import { BiCaretLeft, BiCaretRight, BiCheckCircle, BiCheck, BiCube, BiHide, BiReset, BiShow, BiCamera, BiTrash } from 'react-icons/bi';
import { BsScissors, BsCaretUpFill, BsCaretDownFill } from 'react-icons/bs';
import { FaRegSave, FaLink, FaCheck } from 'react-icons/fa';
import { FaRegObjectGroup, FaForwardStep } from 'react-icons/fa6';
import { IoMdUndo } from 'react-icons/io';
import { LuX, LuChevronDown, LuChevronRight, LuCircleHelp, LuLogOut, LuCreditCard, LuMoon, LuSun, LuMinus, LuZoomOut, LuRotateCcw, LuZoomIn, LuChevronLeft } from 'react-icons/lu';
import { MdOutlineEdit, MdOutlineWarning } from 'react-icons/md';
import { PiGearSixBold, PiCrosshair } from 'react-icons/pi';
import { RiErrorWarningFill } from 'react-icons/ri';
import { RxDragHandleDots2 } from 'react-icons/rx';
import { TbZoomScan, TbChartGridDots, TbTrendingDown, TbTrendingUp } from 'react-icons/tb';
import * as React from 'react';
import React__default, { useRef, useEffect, createContext, useState, useMemo, useCallback, useContext, useLayoutEffect, useImperativeHandle, forwardRef, memo, Fragment as Fragment$1, createElement } from 'react';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { ClientOnly, IconButton, Skeleton, Span, defineSlotRecipe, defineRecipe, defineConfig, createSystem, defaultConfig, ChakraProvider, createSlotRecipeContext, Flex, Box, VStack, Text as Text$2, Button, Link, Dialog, Portal, Circle as Circle$2, usePopoverContext, Popover, Icon, Tag as Tag$1, Tooltip as Tooltip$1, Separator, HStack, Grid, GridItem, Image as Image$3, Spinner, Switch, Spacer, Menu, NumberInput, Drawer, Tabs, Input, useDisclosure, Square, StackSeparator } from '@chakra-ui/react';
import { useTheme, ThemeProvider } from 'next-themes';
import { initReactI18next, useTranslation as useTranslation$1 } from 'react-i18next';
import { useAuth0 } from '@auth0/auth0-react';
import { difference, camelCase, omit, merge, clamp as clamp$1, cloneDeep } from 'lodash';
import { Vector3, Line3, Matrix4, Quaternion, Points, Box3, Plane, EdgesGeometry, BoxGeometry, Matrix3, PerspectiveCamera, Raycaster, Object3D, Vector2, OrthographicCamera, CircleGeometry, Texture, CanvasTexture, LinearMipmapLinearFilter, LinearFilter, PlaneGeometry, Sphere, ShaderMaterial, Color, DoubleSide, BufferGeometry, ShapeUtils, BufferAttribute, MeshBasicMaterial, Cache, NormalBlending, LinearSRGBColorSpace, NoToneMapping, Box3Helper, Mesh, Material, MeshPhongMaterial, Group as Group$2, LineBasicMaterial } from 'three';
import { Html, TransformControls, useContextBridge } from '@react-three/drei';
import { useThree, useFrame, Canvas as Canvas$1 } from '@react-three/fiber';
import { QueryClientContext } from '@tanstack/react-query';
import { ArcballControls as ArcballControls$1 } from 'three/addons/controls/ArcballControls.js';
import { PointCloudOctree, Potree } from '@datalabs-jp/three-loader';
import { FiMove } from 'react-icons/fi';
import { LineMaterial, LineGeometry, Line2, PCDLoader, OBJLoader, MTLLoader } from 'three-stdlib';

var _path$m;
function _extends$p() { return _extends$p = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$p.apply(null, arguments); }
var SvgCubeBack = function SvgCubeBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none"
  }, props), _path$m || (_path$m = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M4.215 0h-.267l-.143.214-.012.018-.139.208H3.64v.022L.088 5.79l-.008.012-.08.12v8.081h11.027l.137-.276 2.787-5.573.053-.105V0H4.215M3.64 2.264l-2.206 3.31H3.64zm0 4.31H1v5.491a.5.5 0 0 1 .793.604l-.213.335h8.637V8.44H4.484l-.253.398a.5.5 0 0 1-.844-.537l.253-.398zm7.577 1.866v2.946L12.69 8.44zm-7.952.985a.5.5 0 0 1 .153.69l-.813 1.277a.5.5 0 1 1-.843-.537l.812-1.277a.5.5 0 0 1 .69-.153",
    clipRule: "evenodd"
  })));
};

var _path$l;
function _extends$o() { return _extends$o = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$o.apply(null, arguments); }
var SvgCubeDown = function SvgCubeDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none"
  }, props), _path$l || (_path$l = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M4.215 0h-.267l-.143.214-.012.018L.088 5.79l-.008.012-.08.12v8.082h11.027l.137-.277 2.787-5.573.053-.105V0H4.215m8.789 7.43h-1.787V6.191l1.787-3.573zm-2.787 0H4.715v-.428a.5.5 0 0 0-.242-.429h5.744zM3.325 8.442 1 11.93V6.573h2.958a.5.5 0 0 0-.243.429v.783l-.328.516a.5.5 0 0 0-.062.141m-1.89-2.869 2.49-3.737a.5.5 0 0 0 .79-.407V1h7.98l-2.287 4.573H4.472a.5.5 0 0 0 .243-.429V3.287a.5.5 0 0 0-1 0v1.857a.5.5 0 0 0 .243.43z",
    clipRule: "evenodd"
  })));
};

var _path$k;
function _extends$n() { return _extends$n = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$n.apply(null, arguments); }
var SvgCubeFront = function SvgCubeFront(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none"
  }, props), _path$k || (_path$k = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M4.215 0h-.267l-.143.214-.012.018L.088 5.79l-.008.012-.08.12v8.082h11.027l.137-.277 2.787-5.573.053-.105V0H4.215m-2.78 5.573 2.49-3.737a.5.5 0 0 0 .79-.407V1h7.98l-2.287 4.573H4.472a.5.5 0 0 0 .243-.429V3.287a.5.5 0 0 0-1 0v1.857a.5.5 0 0 0 .243.43zm9.782.618 1.787-3.573v4.813h-1.068a.5.5 0 0 0 0 1h.759l-1.478 2.955z",
    clipRule: "evenodd"
  })));
};

var _path$j;
function _extends$m() { return _extends$m = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$m.apply(null, arguments); }
var SvgCubeLeft = function SvgCubeLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none"
  }, props), _path$j || (_path$j = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M4.215 0h-.267l-.143.214-.012.018L.088 5.79l-.008.012-.08.12v8.081h11.027l.137-.276 2.787-5.573.053-.105V0H4.215m.535 5.573V1h7.945l-2.287 4.573zm0 1.858v-.858h5.467v1.244a.5.5 0 0 0-.487-.386H7.524a.5.5 0 0 0 0 1H9.73a.5.5 0 0 0 .487-.386v4.959H1.68L4.75 8.5v-.07h.568a.5.5 0 0 0 0-1zm6.467-1.24 1.787-3.573v4.813h-1.068a.5.5 0 0 0 0 1h.759l-1.478 2.955z",
    clipRule: "evenodd"
  })));
};

var _path$i;
function _extends$l() { return _extends$l = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$l.apply(null, arguments); }
var SvgCubeRight = function SvgCubeRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none"
  }, props), _path$i || (_path$i = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M4.215 0h-.267l-.143.214-.012.018L.088 5.79l-.008.012-.08.12v8.081h11.027l.137-.276 2.787-5.573.053-.105V0H4.215m-2.78 5.573 2.49-3.737a.5.5 0 0 0 .79-.407V1h7.98l-2.287 4.573H4.472a.5.5 0 0 0 .243-.429V3.287a.5.5 0 0 0-1 0v1.857a.5.5 0 0 0 .243.43zm-.435 1v5.492a.5.5 0 0 1 .793.604l-.213.335h8.637v-4.96a.5.5 0 0 1-.487.387H7.524a.5.5 0 0 1 0-1H9.73a.5.5 0 0 1 .487.386V6.573H4.473a.5.5 0 0 1 .242.429v.429h.603a.5.5 0 0 1 0 1H4.49l-.26.407a.5.5 0 0 1-.843-.537l.328-.516v-.783a.5.5 0 0 1 .243-.429zm2.265 2.852a.5.5 0 0 1 .153.69l-.813 1.277a.5.5 0 1 1-.843-.537l.812-1.277a.5.5 0 0 1 .69-.153",
    clipRule: "evenodd"
  })));
};

var _path$h;
function _extends$k() { return _extends$k = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$k.apply(null, arguments); }
var SvgCubeUp = function SvgCubeUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none"
  }, props), _path$h || (_path$h = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M4 0h-.052l-.143.214-.012.018L.088 5.79l-.008.012-.08.12v8.081h11.027l.137-.276 2.787-5.573.053-.105V0H4M1 6.573v5.492a.5.5 0 0 1 .793.604l-.213.335h8.637v-4.96a.5.5 0 0 1-.487.387H7.524a.5.5 0 0 1 0-1H9.73a.5.5 0 0 1 .487.386V6.573H4.473a.5.5 0 0 1 .242.429v.429h.603a.5.5 0 0 1 0 1H4.49l-.26.407a.5.5 0 0 1-.843-.537l.328-.516v-.783a.5.5 0 0 1 .243-.429zm10.217-.382 1.787-3.573v4.813h-1.068a.5.5 0 0 0 0 1h.759l-1.478 2.955zM3.265 9.425a.5.5 0 0 1 .153.69l-.813 1.277a.5.5 0 1 1-.843-.537l.812-1.277a.5.5 0 0 1 .69-.153",
    clipRule: "evenodd"
  })));
};

var _path$g;
function _extends$j() { return _extends$j = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$j.apply(null, arguments); }
var SvgToolbarCoverThickness = function SvgToolbarCoverThickness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$g || (_path$g = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.354.646a.5.5 0 0 0-.708 0L5.464 3.828a.5.5 0 1 0 .708.708L9 1.707l2.828 2.829a.5.5 0 1 0 .708-.708zm-.708 16.708a.5.5 0 0 0 .708 0l3.182-3.182a.5.5 0 1 0-.708-.708L9 16.293l-2.828-2.828a.5.5 0 1 0-.708.707zM8.5 1v16h1V1z"
  })));
};

var _path$f;
function _extends$i() { return _extends$i = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$i.apply(null, arguments); }
var SvgToolbarComment = function SvgToolbarComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$i({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path$f || (_path$f = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M13.5 1.5H.5V13L4 10h9.5z"
  })));
};

var _path$e;
function _extends$h() { return _extends$h = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$h.apply(null, arguments); }
var SvgToolbarCylinder = function SvgToolbarCylinder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$h({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path$e || (_path$e = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "m3.88.707 9.36 9.352c.704 1.336-1.76 3.937-3.167 3.164L.713 3.87M3.88.707C4.654 1.762 1.7 4.504.713 3.871M3.88.707C2.825.145.15 3.097.713 3.871"
  })));
};

var _path$d, _path2$6, _path3$3;
function _extends$g() { return _extends$g = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$g.apply(null, arguments); }
var SvgToolbarDepth = function SvgToolbarDepth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$g({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 14"
  }, props), _path$d || (_path$d = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.312 1.646a.5.5 0 0 0-.708 0L6.423 2.828a.5.5 0 1 0 .707.708l.828-.829.828.829a.5.5 0 1 0 .708-.708zm-.708 10.708a.5.5 0 0 0 .708 0l1.182-1.182a.5.5 0 1 0-.708-.708l-.828.829-.828-.828a.5.5 0 1 0-.707.707zM7.458 2v10h1V2z"
  })), _path2$6 || (_path2$6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    d: "M15 .5H1M12 13.5H4"
  })), _path3$3 || (_path3$3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeDasharray: "2 2",
    strokeLinecap: "round",
    d: "m1 2 3 10M15 2l-3 10"
  })));
};

var _path$c;
function _extends$f() { return _extends$f = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$f.apply(null, arguments); }
var SvgToolbarDistance = function SvgToolbarDistance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$f({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 8"
  }, props), _path$c || (_path$c = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.646 3.646a.5.5 0 0 0 0 .708l3.182 3.182a.5.5 0 1 0 .708-.708L1.707 4l2.829-2.828a.5.5 0 1 0-.708-.708zm16.708.708a.5.5 0 0 0 0-.708L14.172.464a.5.5 0 1 0-.708.708L16.293 4l-2.828 2.828a.5.5 0 1 0 .707.708zM1 4.5h16v-1H1z"
  })));
};

var _path$b;
function _extends$e() { return _extends$e = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$e.apply(null, arguments); }
var SvgToolbarMove = function SvgToolbarMove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$e({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 14"
  }, props), _path$b || (_path$b = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M2.538 13.308 1 1l10 6.154c-.897 0-4.462.154-5.385.77-.923.614-2.692 4.102-3.077 5.384Z"
  })));
};

var _path$a, _path2$5;
function _extends$d() { return _extends$d = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$d.apply(null, arguments); }
var SvgToolbarPlane = function SvgToolbarPlane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$d({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path$a || (_path$a = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M5.1 2.8a2.3 2.3 0 1 0-4.6 0 2.3 2.3 0 0 0 4.6 0ZM13.5 2.8a2.3 2.3 0 1 0-4.6 0 2.3 2.3 0 0 0 4.6 0ZM13.5 11.2a2.3 2.3 0 1 0-4.6 0 2.3 2.3 0 0 0 4.6 0Z"
  })), _path2$5 || (_path2$5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.034 2.25a2.3 2.3 0 0 1 .022 1h3.888a2.3 2.3 0 0 1 .022-1zM11.75 5.034a2.3 2.3 0 0 1-1 .022v3.888a2.3 2.3 0 0 1 1 .022zM8.966 11.75a2.3 2.3 0 0 1-.022-1H3.25V5.056a2.3 2.3 0 0 1-1-.022v6.716z"
  })));
};

var _path$9, _circle$1, _circle2$1, _circle3$1;
function _extends$c() { return _extends$c = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$c.apply(null, arguments); }
var SvgToolbarPolyline = function SvgToolbarPolyline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#fff",
    viewBox: "0 0 14 14"
  }, props), _path$9 || (_path$9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.955 4.017 4.057 7.14M4.32 8.592l5.044 1.652"
  })), _circle$1 || (_circle$1 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.608,
    cy: 8.405,
    r: 2
  })), _circle2$1 || (_circle2$1 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.13,
    cy: 11.13,
    r: 2
  })), _circle3$1 || (_circle3$1 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.086,
    cy: 2.608,
    r: 2
  })));
};

var _path$8, _path2$4, _path3$2;
function _extends$b() { return _extends$b = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$b.apply(null, arguments); }
var SvgToolbarVolumeEstimationPolygon = function SvgToolbarVolumeEstimationPolygon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path$8 || (_path$8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M1.071 2.286 8.5.57l7.429 1.715V12.57L13.07 15.43H3.93L1.07 12.57z"
  })), _path2$4 || (_path2$4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M1.071 2.286 3.93 5.714h9.142l2.858-3.428M3.929 5.714v9.143M13.071 5.714v9.143"
  })), _path3$2 || (_path3$2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeDasharray: "2 2",
    strokeLinejoin: "round",
    d: "M1.643 12.571 8.5 10.286l6.857 2.285M8.5 10.286V1.143"
  })));
};

var _path$7, _path2$3;
function _extends$a() { return _extends$a = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$a.apply(null, arguments); }
var SvgVertexAdd = function SvgVertexAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 17 18"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m1 3 10.15 2.45 1.05 5.25-3.5 3.5-5.25-1.05zm0 0 5.31 5.31M8 14.9l4.9-4.9 2.1 2.1-4.9 4.9zm.7-5.6a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.571 2.571V0h.858v2.571H17v.858h-2.571V6h-.858V3.429H11V2.57z"
  })));
};

var _path$6, _g, _defs;
function _extends$9() { return _extends$9 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9.apply(null, arguments); }
var SvgVertexRemove = function SvgVertexRemove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path$6 || (_path$6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m1 1 10.15 2.45L12.2 8.7l-3.5 3.5-5.25-1.05zm0 0 5.31 5.31M8 12.9 12.9 8l2.1 2.1-4.9 4.9zm.7-5.6a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#vertex-remove_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.083.083h5.834v.834h-5.834z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "vertex-remove_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11 0h6v1h-6z"
  })))));
};

var _path$5;
function _extends$8() { return _extends$8 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8.apply(null, arguments); }
var SvgVertexMove = function SvgVertexMove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.672 1.477 5.463 3.686a.444.444 0 1 0 .629.628l1.463-1.463v4.705H2.851l1.463-1.464a.444.444 0 0 0-.628-.628L1.463 7.685a.444.444 0 0 0 0 .628l2.223 2.223a.444.444 0 1 0 .628-.63L2.851 8.445h4.704v4.705l-1.463-1.463a.445.445 0 0 0-.629.628l2.223 2.223a.444.444 0 0 0 .628 0l2.222-2.223a.444.444 0 1 0-.628-.628l-1.464 1.463V8.444h4.705l-1.463 1.464a.445.445 0 0 0 .628.629l2.222-2.223a.444.444 0 0 0 0-.628l-2.222-2.222a.445.445 0 0 0-.628.628l1.463 1.464H8.444V2.85l1.464 1.464a.444.444 0 1 0 .628-.628L8.314 1.464a.443.443 0 0 0-.642.014",
    clipRule: "evenodd"
  })));
};

var _path$4;
function _extends$7() { return _extends$7 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7.apply(null, arguments); }
var SvgVertexConnect = function SvgVertexConnect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.533 1.797A1.417 1.417 0 1 1 9.536 3.8L7.411 5.925a1.417 1.417 0 0 1-2.003 0 .708.708 0 0 0-1.001 1.002 2.833 2.833 0 0 0 4.006 0l2.125-2.125A2.833 2.833 0 0 0 6.532.795L5.469 1.858a.708.708 0 1 0 1.002 1.001zM3.992 5.339a1.417 1.417 0 0 1 2.003 0 .708.708 0 1 0 1.001-1.002 2.833 2.833 0 0 0-4.006 0L.865 6.462a2.833 2.833 0 1 0 4.006 4.006l1.063-1.062a.708.708 0 1 0-1.002-1.002L3.87 9.467a1.417 1.417 0 1 1-2.003-2.003z",
    clipRule: "evenodd"
  })));
};

var _path$3, _path2$2, _path3$1;
function _extends$6() { return _extends$6 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6.apply(null, arguments); }
var SvgToolbarTranslate = function SvgToolbarTranslate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 14 14"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.5 12V2h1v10z",
    clipRule: "evenodd"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 6.5h10v1H2z",
    clipRule: "evenodd"
  })), _path3$1 || (_path3$1 = /*#__PURE__*/React.createElement("path", {
    d: "m7 0 1.732 3H5.268zM14 7l-3 1.732V5.268zM7 14l-1.732-3h3.464zM0 7l3-1.732v3.464z"
  })));
};

var _path$2;
function _extends$5() { return _extends$5 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5.apply(null, arguments); }
var SvgToolbarScale = function SvgToolbarScale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 14 14"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 1.5h11v11h-5V7.02l1.876-1.77.856.93 1.036-3.305-3.38.756.811.882L6.593 6.5H1.5zm0 6v5h5v-5zm-1-1v-6h13v13H.5z",
    clipRule: "evenodd"
  })));
};

var _path$1, _path2$1;
function _extends$4() { return _extends$4 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4.apply(null, arguments); }
var SvgToolbarRotate = function SvgToolbarRotate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 14 14"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.732 6 3.464V0z"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7 12.98q.34-.029.67-.094a.5.5 0 1 0-.194-.981q-.234.046-.476.07zM7 2.024q.242.025.476.07a.5.5 0 0 0 .194-.98A6 6 0 0 0 7 1.02zm2.834-.014a.5.5 0 0 0-.556.83 5 5 0 0 1 1.38 1.381.5.5 0 0 0 .831-.556 6 6 0 0 0-1.655-1.655m2.552 3.819a.5.5 0 1 0-.981.194 5 5 0 0 1 0 1.952.5.5 0 0 0 .98.194 6 6 0 0 0 0-2.34m-.897 4.504a.5.5 0 0 0-.83-.556 5 5 0 0 1-1.381 1.38.5.5 0 0 0 .556.831 6 6 0 0 0 1.655-1.655M7 1.02A6 6 0 1 0 7 12.98v-1.004a5 5 0 1 1 0-9.95z",
    clipRule: "evenodd"
  })));
};

var _circle, _circle2, _circle3;
function _extends$3() { return _extends$3 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3.apply(null, arguments); }
var SvgPcd = function SvgPcd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    stroke: "currentColor"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 6,
    r: 3,
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 14,
    r: 3,
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 14,
    r: 3,
    fill: "currentColor",
    strokeWidth: 1.5
  })));
};

const ToolbarFocusButton = PiCrosshair;
const ToolbarCameraIcon = BiCamera;
const ToolbarMaskRegion = BsScissors;
const ToolbarGridIcon = TbChartGridDots;
const ToolbarCameraCubeUpIcon = SvgCubeUp;
const ToolbarCameraCubeDownIcon = SvgCubeDown;
const ToolbarCameraCubeLeftIcon = SvgCubeLeft;
const ToolbarCameraCubeRightIcon = SvgCubeRight;
const ToolbarCameraCubeFrontIcon = SvgCubeFront;
const ToolbarCameraCubeBackIcon = SvgCubeBack;
const InspectionGroupIcon = FaRegObjectGroup;
// -- General UI
const CaretLeftIcon = BiCaretLeft;
const CaretRightIcon = BiCaretRight;
const ChevronRightIcon = LuChevronRight;
const ChevronDownIcon = LuChevronDown;
// Actions
const SuccessIcon = BiCheck;
const ConfirmIcon = BiCheck;
const CheckCircleIcon = BiCheckCircle;
const SaveIcon = FaRegSave;
const UnsavedIcon = MdOutlineEdit;
const ExpandIcon = LuChevronRight;
const CollapseIcon = LuChevronDown;
const TrashIcon = BiTrash;
const DeleteIcon = LuX;
const OrderGrabIcon = RxDragHandleDots2;
const HideIcon = BiHide;
const ShowIcon = BiShow;
const ResetIcon = BiReset;
const UndoIcon = IoMdUndo;
const FocusItemIcon = TbZoomScan;
const LogoutIcon = LuLogOut;
// Things
const SettingIcon = PiGearSixBold;
const CubeIcon = BiCube;
const PaymentIcon = LuCreditCard;
const HelpOutlineIcon = LuCircleHelp;
const WarningIcon = MdOutlineWarning;
const WarningIconCircle = RiErrorWarningFill;

function ColorModeProvider(props) {
    return jsx(ThemeProvider, { attribute: "class", disableTransitionOnChange: true, ...props });
}
function useColorMode() {
    const { resolvedTheme, setTheme, forcedTheme } = useTheme();
    const colorMode = forcedTheme || resolvedTheme;
    const toggleColorMode = () => {
        setTheme(resolvedTheme === 'dark' ? 'light' : 'dark');
    };
    return {
        colorMode: colorMode,
        setColorMode: setTheme,
        toggleColorMode,
    };
}
function ColorModeIcon() {
    const { colorMode } = useColorMode();
    return colorMode === 'dark' ? jsx(LuMoon, {}) : jsx(LuSun, {});
}
React.forwardRef(function ColorModeButton(props, ref) {
    const { toggleColorMode } = useColorMode();
    return (jsx(ClientOnly, { fallback: jsx(Skeleton, { boxSize: "9" }), children: jsx(IconButton, { onClick: toggleColorMode, variant: "ghost", "aria-label": "Toggle color mode", size: "sm", ref: ref, ...props, css: {
                _icon: {
                    width: '5',
                    height: '5',
                },
            }, children: jsx(ColorModeIcon, {}) }) }));
});
React.forwardRef(function LightMode(props, ref) {
    return (jsx(Span, { color: "fg", display: "contents", className: "chakra-theme light", colorPalette: "gray", colorScheme: "light", ref: ref, ...props }));
});
React.forwardRef(function DarkMode(props, ref) {
    return (jsx(Span, { color: "fg", display: "contents", className: "chakra-theme dark", colorPalette: "gray", colorScheme: "dark", ref: ref, ...props }));
});

var alert = defineSlotRecipe({
    className: 'alert',
    slots: ['root', 'title', 'description', 'indicator'],
    variants: {
        variant: {
            'panel-info': {
                root: {
                    color: '#fff',
                    backgroundColor: 'primary.900',
                    borderRadius: 'md',
                    opacity: 1,
                    flexDirection: 'column',
                    paddingBottom: 2,
                    paddingTop: 2,
                    paddingInlineStart: 3,
                    paddingInlineEnd: 3,
                },
            },
            'panel-warning': {
                root: {
                    color: '#fff',
                    backgroundColor: 'orange.500',
                    borderRadius: 'md',
                    opacity: 1,
                    flexDirection: 'column',
                    paddingBottom: 2,
                    paddingTop: 2,
                    paddingInlineStart: 3,
                    paddingInlineEnd: 3,
                },
            },
        },
    },
});

const INFO_PANEL_PADDING = 2; // * 4px
var button = defineRecipe({
    variants: {
        variant: {
            primary: {
                backgroundColor: 'primary.500',
                color: 'white',
                _hover: {
                    backgroundColor: 'primary.600',
                },
                _active: {
                    backgroundColor: 'primary.700',
                },
                _focus: {
                    backgroundColor: 'primary.600',
                },
            },
            outlinePrimary: {
                borderWidth: '1px',
                borderColor: 'primary.500',
                color: 'primary.500',
                _hover: {
                    backgroundColor: 'gray2.50',
                },
            },
            outlineStatic: {
                borderWidth: '1px',
                borderColor: 'white',
                color: 'white',
                _hover: {
                    backgroundColor: 'white',
                    color: 'primary.500',
                },
            },
            outlineStaticInvert: {
                borderWidth: '1px',
                borderColor: 'gray2.200',
                color: 'inherit',
                _hover: {
                    backgroundColor: 'white',
                    color: 'primary.500',
                    borderColor: 'primary.200',
                },
            },
            toolbar: {
                backgroundColor: 'gray2.600',
                color: 'white',
                _hover: {
                    backgroundColor: 'gray2.700',
                },
            },
            editorGhost: {
                fontWeight: 200,
                color: 'gray2.400',
                backgroundColor: 'gray2.800',
                _hover: {
                    backgroundColor: 'gray2.700',
                    color: 'white',
                },
            },
            ghostLink: {
                fontWeight: 200,
                color: 'white',
                _hover: {
                    color: 'white',
                },
            },
            toolbarIcon: {
                backgroundColor: 'transparent',
                color: 'gray2.400',
                _hover: {
                    backgroundColor: 'gray2.700',
                },
            },
            'panel-icon': {
                backgroundColor: 'transparent',
                color: 'gray2.400',
                _hover: {
                    backgroundColor: 'gray2.700',
                },
                height: 7,
                minWidth: 7,
                fontSize: 'md',
            },
            layer: {
                borderRadius: '0',
                backgroundColor: 'transparent',
                color: 'white',
                fontSize: 'sm',
                justifyContent: 'space-between',
                padding: INFO_PANEL_PADDING,
                _hover: {
                    backgroundColor: 'whiteAlpha.50',
                },
            },
            darkGray: {
                backgroundColor: 'gray2.600',
                color: 'white',
                _hover: {
                    backgroundColor: 'gray2.700',
                    color: 'white',
                },
            },
            panel: {
                color: '#fff',
                backgroundColor: 'gray2.700',
                borderWidth: '1px',
                borderColor: 'transparent',
                width: '100%',
                _hover: {
                    backgroundColor: 'gray2.600',
                    borderColor: 'gray2.700',
                },
            },
            'panel-dark': {
                color: 'gray2.400',
                bgColor: 'gray2.800',
                _hover: {
                    backgroundColor: 'gray2.700',
                    _disabled: {
                        background: 'gray2.700',
                    },
                },
            },
            'panel-dark-outline': {
                color: 'gray2.400',
                bgColor: 'gray2.800',
                borderColor: 'whiteAlpha.500',
                borderWidth: '1px',
                borderStyle: 'solid',
                _hover: {
                    backgroundColor: 'gray2.700',
                    _disabled: {
                        background: 'gray2.700',
                    },
                },
            },
            'panel-dropdown': {
                justifyContent: 'space-between',
                backgroundColor: 'gray2.700',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'rgba(255, 255, 255, 0.08)',
                borderRadius: 'md',
                width: '100%',
                paddingBlock: 0,
                paddingInline: 2,
                color: '#fff',
                fontSize: 'sm',
                height: 8,
            },
        },
    },
});

var checkbox = defineSlotRecipe({
    className: 'checkbox',
    slots: ['root', 'control', 'label'],
    variants: {
        variant: {
            panel: {
                control: {
                    borderColor: 'whiteAlpha.400',
                    backgroundColor: 'blackAlpha.500',
                },
            },
        },
    },
});

var colors = {
    // ChakraV2 gray color palette
    // Mainly used by Hatsuly (3D Editor)
    gray2: {
        50: { value: '#F7FAFC' },
        100: { value: '#EDF2F7' },
        200: { value: '#E2E8F0' },
        300: { value: '#CBD5E0' },
        400: { value: '#A0AEC0' },
        500: { value: '#718096' },
        600: { value: '#4A5568' },
        700: { value: '#2D3748' },
        800: { value: '#1A202C' },
        900: { value: '#171923' },
    },
    // Tailwind blue color palette
    blue: {
        50: { value: '#eef6ff' },
        100: { value: '#d9ecff' },
        200: { value: '#b3d9ff' },
        300: { value: '#80c1ff' },
        400: { value: '#5eb2f9' },
        500: { value: '#2699fb' },
        600: { value: '#2699fb' },
        700: { value: '#2285da' },
        800: { value: '#1a6ab0' },
        900: { value: '#15538a' },
        950: { value: '#0f3d5f' },
    },
    // Tailwind indigo color palette
    indigo: {
        50: { value: '#eef2ff' },
        100: { value: '#e0e7ff' },
        200: { value: '#c7d2fe' },
        300: { value: '#a5b4fc' },
        400: { value: '#818cf8' },
        500: { value: '#6366f1' },
        600: { value: '#4f46e5' },
        700: { value: '#4338ca' },
        800: { value: '#3730a3' },
        900: { value: '#312e81' },
        950: { value: '#1e1b4b' },
    },
    primary: {
        50: { value: '#E5F3FF' },
        100: { value: '#BEE1FF' },
        200: { value: '#90CCFF' },
        300: { value: '#77C0FF' },
        400: { value: '#52B0FF' },
        500: { value: '#2699FB' },
        600: { value: '#248CE4' },
        700: { value: '#186FB9' },
        800: { value: '#11538B' },
        900: { value: '#0E3B62' },
    },
    secondary: {
        50: { value: '#F7FAFC' },
        100: { value: '#EDF2F7' },
        200: { value: '#E2E8F0' },
        300: { value: '#CBD5E0' },
        400: { value: '#A0AEC0' },
        500: { value: '#718096' },
        600: { value: '#4A5568' },
        700: { value: '#2D3748' },
        800: { value: '#1A202C' },
        900: { value: '#171923' },
    },
};

var link = defineRecipe({
    className: 'link',
    variants: {
        variant: {
            button: {
                fontWeight: 'semibold',
                paddingBottom: '4',
                paddingLeft: '8',
                paddingRight: '8',
                paddingTop: '4',
                _hover: {
                    textDecoration: 'none',
                    backgroundColor: 'blackAlpha.100',
                },
            },
            plain: {
                _hover: {
                    textDecoration: 'none',
                },
            },
            underline: {
                textDecoration: 'underline',
                color: 'primary.500',
            },
            neutral: {
                color: 'primary.500',
            },
            toolbar: {
                backgroundColor: 'gray.800',
                color: 'white',
                _hover: {
                    backgroundColor: 'gray.800',
                },
                _active: {
                    backgroundColor: 'gray.800',
                },
                _focus: {
                    backgroundColor: 'gray.800',
                },
            },
        },
    },
});

var menu = defineSlotRecipe({
    className: 'menu',
    slots: ['item', 'content'],
    base: {
        item: {
            paddingBottom: '2.5',
            paddingTop: '2.5',
        },
        content: {
            minW: '40',
            boxShadow: 'md',
            border: '0',
        },
    },
    variants: {
        variant: {
            toolbar: {
                item: {
                    backgroundColor: 'gray.700',
                    color: 'white',
                    _hover: {
                        backgroundColor: 'gray.600',
                    },
                    _active: {
                        backgroundColor: 'gray.600',
                    },
                    _focus: {
                        backgroundColor: 'gray.600',
                    },
                },
                content: {
                    backgroundColor: 'gray.700',
                },
            },
            editorPanel: {
                item: {
                    backgroundColor: 'gray2.700',
                    color: 'white',
                    _active: {
                        backgroundColor: 'rgba(255, 255, 255, 0.08)',
                    },
                    _hover: {
                        backgroundColor: 'rgba(255, 255, 255, 0.08)',
                    },
                    cursor: 'pointer',
                },
                content: {
                    backgroundColor: 'gray2.700',
                },
            },
        },
    },
});

var tabs = defineSlotRecipe({
    className: 'tabs',
    slots: ['root', 'list', 'trigger', 'content', 'indicator'],
    variants: {
        variant: {
            panel: {
                trigger: {
                    backgroundColor: 'gray2.900',
                    opacity: 0.7,
                    _selected: {
                        backgroundColor: 'gray2.800',
                        opacity: 1,
                    },
                    _hover: {
                        backgroundColor: 'gray2.700',
                        opacity: 1,
                    },
                },
                list: {
                    backgroundColor: 'gray2.900',
                },
                content: {
                    backgroundColor: 'gray2.800',
                    paddingTop: 2,
                    paddingBottom: 1,
                    paddingLeft: 4,
                    paddingRight: 2,
                },
            },
        },
    },
});

const config = defineConfig({
    globalCss: {
        button: {
            _focusVisible: {
                outlineColor: 'transparent !important',
            },
        },
    },
    theme: {
        tokens: {
            colors,
        },
        recipes: {
            button,
            link,
        },
        slotRecipes: {
            alert,
            checkbox,
            menu,
            tabs,
        },
        semanticTokens: {
            colors: {
                indigo: {
                    solid: { value: '{colors.indigo.600}' },
                    contrast: { value: 'white' },
                    fg: { value: '{colors.indigo.600}' },
                    muted: { value: '{colors.indigo.100}' },
                    subtle: { value: '{colors.indigo.50}' },
                    emphasized: { value: '{colors.indigo.700}' },
                    focusRing: { value: '{colors.indigo.500}' },
                },
            },
        },
    },
});
var theme = createSystem(defaultConfig, config);

const StylesProvider = (props) => (jsx(ChakraProvider, { value: theme, children: jsx(ColorModeProvider, { forcedTheme: "light", ...props }) }));

const loadingPageRecipe = defineSlotRecipe({
    className: 'loadingPage',
    slots: ['root', 'container', 'image', 'text'],
    base: {
        root: {
            w: '100%',
            display: 'flex',
        },
        container: {
            alignItems: 'center',
        },
        image: {
            w: 160,
        },
        text: {
            fontWeight: 'bold',
            textAlign: 'center',
        },
    },
    variants: {
        colorPalette: {
            white: {
                root: {
                    bg: '#fff',
                },
                text: {
                    color: 'gray.600',
                },
            },
            black: {
                root: {
                    bg: '#000',
                },
                text: {
                    color: 'whiteAlpha.700',
                },
            },
        },
        layout: {
            fullpage: {
                root: {
                    w: '100vw',
                    h: '100vh',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                },
                container: {
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    transform: 'translate(-50%, -50%)',
                },
            },
            contained: {
                root: {
                    position: 'relative',
                    w: '100%',
                    h: '100%',
                },
                container: {
                    position: 'relative',
                    mx: 'auto',
                    my: 'auto',
                },
            },
        },
    },
    defaultVariants: {
        colorPalette: 'white',
        layout: 'fullpage',
    },
});
const { withProvider: withProvider$4, withContext: withContext$4 } = createSlotRecipeContext({
    recipe: loadingPageRecipe,
});
const LoadingPageRoot = withProvider$4('div', 'root');
const LoadingPageContainer = withContext$4('div', 'container');
const LoadingPageImage = withContext$4('img', 'image');
const LoadingPageText = withContext$4('p', 'text');

// This is _built_ URL, not the source path. The source imports are in the .gif files above,
// which will be processed by the bundler to generate the final URLs.
const LoadingAnimationBlack = new URL('./assets/loading-animation-black.gif', import.meta.url).href;
const LoadingAnimationWhite = new URL('./assets/loading-animation.gif', import.meta.url).href;
/**
 * LoadingPage - Full-page or contained loading overlay with an animated GIF.
 *
 * @example
 * // Full-page white overlay (default)
 * <LoadingPage />
 *
 * @example
 * // Contained within a parent element
 * <LoadingPage layout="contained" />
 *
 * @example
 * // Dark background variant with custom text
 * <LoadingPage colorPalette="black" text="Loading data..." />
 */
const LoadingPage = ({ text, imageSrc, colorPalette = 'white', layout = 'fullpage', zIndex = 10, }) => {
    // Use provided imageSrc or default based on colorPalette
    const defaultImage = colorPalette === 'black' ? LoadingAnimationBlack : LoadingAnimationWhite;
    const src = imageSrc ?? defaultImage;
    return (jsx(LoadingPageRoot, { colorPalette: colorPalette, layout: layout, zIndex: zIndex, "data-testid": "loadingPage", children: jsxs(LoadingPageContainer, { children: [jsx(LoadingPageImage, { src: src }), text && jsx(LoadingPageText, { children: text })] }) }));
};

const isString = obj => typeof obj === 'string';
const defer = () => {
  let res;
  let rej;
  const promise = new Promise((resolve, reject) => {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
};
const makeString = object => {
  if (object == null) return '';
  return '' + object;
};
const copy = (a, s, t) => {
  a.forEach(m => {
    if (s[m]) t[m] = s[m];
  });
};
const lastOfPathSeparatorRegExp = /###/g;
const cleanKey = key => key && key.indexOf('###') > -1 ? key.replace(lastOfPathSeparatorRegExp, '.') : key;
const canNotTraverseDeeper = object => !object || isString(object);
const getLastOfPath = (object, path, Empty) => {
  const stack = !isString(path) ? path : path.split('.');
  let stackIndex = 0;
  while (stackIndex < stack.length - 1) {
    if (canNotTraverseDeeper(object)) return {};
    const key = cleanKey(stack[stackIndex]);
    if (!object[key] && Empty) object[key] = new Empty();
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
    ++stackIndex;
  }
  if (canNotTraverseDeeper(object)) return {};
  return {
    obj: object,
    k: cleanKey(stack[stackIndex])
  };
};
const setPath = (object, path, newValue) => {
  const {
    obj,
    k
  } = getLastOfPath(object, path, Object);
  if (obj !== undefined || path.length === 1) {
    obj[k] = newValue;
    return;
  }
  let e = path[path.length - 1];
  let p = path.slice(0, path.length - 1);
  let last = getLastOfPath(object, p, Object);
  while (last.obj === undefined && p.length) {
    e = `${p[p.length - 1]}.${e}`;
    p = p.slice(0, p.length - 1);
    last = getLastOfPath(object, p, Object);
    if (last?.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') {
      last.obj = undefined;
    }
  }
  last.obj[`${last.k}.${e}`] = newValue;
};
const pushPath = (object, path, newValue, concat) => {
  const {
    obj,
    k
  } = getLastOfPath(object, path, Object);
  obj[k] = obj[k] || [];
  obj[k].push(newValue);
};
const getPath = (object, path) => {
  const {
    obj,
    k
  } = getLastOfPath(object, path);
  if (!obj) return undefined;
  if (!Object.prototype.hasOwnProperty.call(obj, k)) return undefined;
  return obj[k];
};
const getPathWithDefaults = (data, defaultData, key) => {
  const value = getPath(data, key);
  if (value !== undefined) {
    return value;
  }
  return getPath(defaultData, key);
};
const deepExtend = (target, source, overwrite) => {
  for (const prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (isString(target[prop]) || target[prop] instanceof String || isString(source[prop]) || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }
  return target;
};
const regexEscape = str => str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
const escape = data => {
  if (isString(data)) {
    return data.replace(/[&<>"'\/]/g, s => _entityMap[s]);
  }
  return data;
};
class RegExpCache {
  constructor(capacity) {
    this.capacity = capacity;
    this.regExpMap = new Map();
    this.regExpQueue = [];
  }
  getRegExp(pattern) {
    const regExpFromCache = this.regExpMap.get(pattern);
    if (regExpFromCache !== undefined) {
      return regExpFromCache;
    }
    const regExpNew = new RegExp(pattern);
    if (this.regExpQueue.length === this.capacity) {
      this.regExpMap.delete(this.regExpQueue.shift());
    }
    this.regExpMap.set(pattern, regExpNew);
    this.regExpQueue.push(pattern);
    return regExpNew;
  }
}
const chars = [' ', ',', '?', '!', ';'];
const looksLikeObjectPathRegExpCache = new RegExpCache(20);
const looksLikeObjectPath = (key, nsSeparator, keySeparator) => {
  nsSeparator = nsSeparator || '';
  keySeparator = keySeparator || '';
  const possibleChars = chars.filter(c => nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
  if (possibleChars.length === 0) return true;
  const r = looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map(c => c === '?' ? '\\?' : c).join('|')})`);
  let matched = !r.test(key);
  if (!matched) {
    const ki = key.indexOf(keySeparator);
    if (ki > 0 && !r.test(key.substring(0, ki))) {
      matched = true;
    }
  }
  return matched;
};
const deepFind = (obj, path, keySeparator = '.') => {
  if (!obj) return undefined;
  if (obj[path]) {
    if (!Object.prototype.hasOwnProperty.call(obj, path)) return undefined;
    return obj[path];
  }
  const tokens = path.split(keySeparator);
  let current = obj;
  for (let i = 0; i < tokens.length;) {
    if (!current || typeof current !== 'object') {
      return undefined;
    }
    let next;
    let nextPath = '';
    for (let j = i; j < tokens.length; ++j) {
      if (j !== i) {
        nextPath += keySeparator;
      }
      nextPath += tokens[j];
      next = current[nextPath];
      if (next !== undefined) {
        if (['string', 'number', 'boolean'].indexOf(typeof next) > -1 && j < tokens.length - 1) {
          continue;
        }
        i += j - i + 1;
        break;
      }
    }
    current = next;
  }
  return current;
};
const getCleanedCode = code => code?.replace(/_/g, '-');

const consoleLogger = {
  type: 'logger',
  log(args) {
    this.output('log', args);
  },
  warn(args) {
    this.output('warn', args);
  },
  error(args) {
    this.output('error', args);
  },
  output(type, args) {
    console?.[type]?.apply?.(console, args);
  }
};
class Logger {
  constructor(concreteLogger, options = {}) {
    this.init(concreteLogger, options);
  }
  init(concreteLogger, options = {}) {
    this.prefix = options.prefix || 'i18next:';
    this.logger = concreteLogger || consoleLogger;
    this.options = options;
    this.debug = options.debug;
  }
  log(...args) {
    return this.forward(args, 'log', '', true);
  }
  warn(...args) {
    return this.forward(args, 'warn', '', true);
  }
  error(...args) {
    return this.forward(args, 'error', '');
  }
  deprecate(...args) {
    return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
  }
  forward(args, lvl, prefix, debugOnly) {
    if (debugOnly && !this.debug) return null;
    if (isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
    return this.logger[lvl](args);
  }
  create(moduleName) {
    return new Logger(this.logger, {
      ...{
        prefix: `${this.prefix}:${moduleName}:`
      },
      ...this.options
    });
  }
  clone(options) {
    options = options || this.options;
    options.prefix = options.prefix || this.prefix;
    return new Logger(this.logger, options);
  }
}
var baseLogger = new Logger();

class EventEmitter {
  constructor() {
    this.observers = {};
  }
  on(events, listener) {
    events.split(' ').forEach(event => {
      if (!this.observers[event]) this.observers[event] = new Map();
      const numListeners = this.observers[event].get(listener) || 0;
      this.observers[event].set(listener, numListeners + 1);
    });
    return this;
  }
  off(event, listener) {
    if (!this.observers[event]) return;
    if (!listener) {
      delete this.observers[event];
      return;
    }
    this.observers[event].delete(listener);
  }
  emit(event, ...args) {
    if (this.observers[event]) {
      const cloned = Array.from(this.observers[event].entries());
      cloned.forEach(([observer, numTimesAdded]) => {
        for (let i = 0; i < numTimesAdded; i++) {
          observer(...args);
        }
      });
    }
    if (this.observers['*']) {
      const cloned = Array.from(this.observers['*'].entries());
      cloned.forEach(([observer, numTimesAdded]) => {
        for (let i = 0; i < numTimesAdded; i++) {
          observer.apply(observer, [event, ...args]);
        }
      });
    }
  }
}

class ResourceStore extends EventEmitter {
  constructor(data, options = {
    ns: ['translation'],
    defaultNS: 'translation'
  }) {
    super();
    this.data = data || {};
    this.options = options;
    if (this.options.keySeparator === undefined) {
      this.options.keySeparator = '.';
    }
    if (this.options.ignoreJSONStructure === undefined) {
      this.options.ignoreJSONStructure = true;
    }
  }
  addNamespaces(ns) {
    if (this.options.ns.indexOf(ns) < 0) {
      this.options.ns.push(ns);
    }
  }
  removeNamespaces(ns) {
    const index = this.options.ns.indexOf(ns);
    if (index > -1) {
      this.options.ns.splice(index, 1);
    }
  }
  getResource(lng, ns, key, options = {}) {
    const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
    const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let path;
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
    } else {
      path = [lng, ns];
      if (key) {
        if (Array.isArray(key)) {
          path.push(...key);
        } else if (isString(key) && keySeparator) {
          path.push(...key.split(keySeparator));
        } else {
          path.push(key);
        }
      }
    }
    const result = getPath(this.data, path);
    if (!result && !ns && !key && lng.indexOf('.') > -1) {
      lng = path[0];
      ns = path[1];
      key = path.slice(2).join('.');
    }
    if (result || !ignoreJSONStructure || !isString(key)) return result;
    return deepFind(this.data?.[lng]?.[ns], key, keySeparator);
  }
  addResource(lng, ns, key, value, options = {
    silent: false
  }) {
    const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
    let path = [lng, ns];
    if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      value = ns;
      ns = path[1];
    }
    this.addNamespaces(ns);
    setPath(this.data, path, value);
    if (!options.silent) this.emit('added', lng, ns, key, value);
  }
  addResources(lng, ns, resources, options = {
    silent: false
  }) {
    for (const m in resources) {
      if (isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
        silent: true
      });
    }
    if (!options.silent) this.emit('added', lng, ns, resources);
  }
  addResourceBundle(lng, ns, resources, deep, overwrite, options = {
    silent: false,
    skipCopy: false
  }) {
    let path = [lng, ns];
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      deep = resources;
      resources = ns;
      ns = path[1];
    }
    this.addNamespaces(ns);
    let pack = getPath(this.data, path) || {};
    if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
    if (deep) {
      deepExtend(pack, resources, overwrite);
    } else {
      pack = {
        ...pack,
        ...resources
      };
    }
    setPath(this.data, path, pack);
    if (!options.silent) this.emit('added', lng, ns, resources);
  }
  removeResourceBundle(lng, ns) {
    if (this.hasResourceBundle(lng, ns)) {
      delete this.data[lng][ns];
    }
    this.removeNamespaces(ns);
    this.emit('removed', lng, ns);
  }
  hasResourceBundle(lng, ns) {
    return this.getResource(lng, ns) !== undefined;
  }
  getResourceBundle(lng, ns) {
    if (!ns) ns = this.options.defaultNS;
    return this.getResource(lng, ns);
  }
  getDataByLanguage(lng) {
    return this.data[lng];
  }
  hasLanguageSomeTranslations(lng) {
    const data = this.getDataByLanguage(lng);
    const n = data && Object.keys(data) || [];
    return !!n.find(v => data[v] && Object.keys(data[v]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}

var postProcessor = {
  processors: {},
  addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle(processors, value, key, options, translator) {
    processors.forEach(processor => {
      value = this.processors[processor]?.process(value, key, options, translator) ?? value;
    });
    return value;
  }
};

const PATH_KEY = Symbol('i18next/PATH_KEY');
function createProxy() {
  const state = [];
  const handler = Object.create(null);
  let proxy;
  handler.get = (target, key) => {
    proxy?.revoke?.();
    if (key === PATH_KEY) return state;
    state.push(key);
    proxy = Proxy.revocable(target, handler);
    return proxy.proxy;
  };
  return Proxy.revocable(Object.create(null), handler).proxy;
}
function keysFromSelector(selector, opts) {
  const {
    [PATH_KEY]: path
  } = selector(createProxy());
  const keySeparator = opts?.keySeparator ?? '.';
  const nsSeparator = opts?.nsSeparator ?? ':';
  if (path.length > 1 && nsSeparator) {
    const ns = opts?.ns;
    const nsArray = Array.isArray(ns) ? ns : null;
    if (nsArray && nsArray.length > 1 && nsArray.slice(1).includes(path[0])) {
      return `${path[0]}${nsSeparator}${path.slice(1).join(keySeparator)}`;
    }
  }
  return path.join(keySeparator);
}

const checkedLoadedFor = {};
const shouldHandleAsObject = res => !isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
class Translator extends EventEmitter {
  constructor(services, options = {}) {
    super();
    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, this);
    this.options = options;
    if (this.options.keySeparator === undefined) {
      this.options.keySeparator = '.';
    }
    this.logger = baseLogger.create('translator');
  }
  changeLanguage(lng) {
    if (lng) this.language = lng;
  }
  exists(key, o = {
    interpolation: {}
  }) {
    const opt = {
      ...o
    };
    if (key == null) return false;
    const resolved = this.resolve(key, opt);
    if (resolved?.res === undefined) return false;
    const isObject = shouldHandleAsObject(resolved.res);
    if (opt.returnObjects === false && isObject) {
      return false;
    }
    return true;
  }
  extractFromKey(key, opt) {
    let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
    if (nsSeparator === undefined) nsSeparator = ':';
    const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
    let namespaces = opt.ns || this.options.defaultNS || [];
    const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
    const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !opt.keySeparator && !this.options.userDefinedNsSeparator && !opt.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
    if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
      const m = key.match(this.interpolator.nestingRegexp);
      if (m && m.length > 0) {
        return {
          key,
          namespaces: isString(namespaces) ? [namespaces] : namespaces
        };
      }
      const parts = key.split(nsSeparator);
      if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
      key = parts.join(keySeparator);
    }
    return {
      key,
      namespaces: isString(namespaces) ? [namespaces] : namespaces
    };
  }
  translate(keys, o, lastKey) {
    let opt = typeof o === 'object' ? {
      ...o
    } : o;
    if (typeof opt !== 'object' && this.options.overloadTranslationOptionHandler) {
      opt = this.options.overloadTranslationOptionHandler(arguments);
    }
    if (typeof opt === 'object') opt = {
      ...opt
    };
    if (!opt) opt = {};
    if (keys == null) return '';
    if (typeof keys === 'function') keys = keysFromSelector(keys, {
      ...this.options,
      ...opt
    });
    if (!Array.isArray(keys)) keys = [String(keys)];
    keys = keys.map(k => typeof k === 'function' ? keysFromSelector(k, {
      ...this.options,
      ...opt
    }) : String(k));
    const returnDetails = opt.returnDetails !== undefined ? opt.returnDetails : this.options.returnDetails;
    const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
    const {
      key,
      namespaces
    } = this.extractFromKey(keys[keys.length - 1], opt);
    const namespace = namespaces[namespaces.length - 1];
    let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
    if (nsSeparator === undefined) nsSeparator = ':';
    const lng = opt.lng || this.language;
    const appendNamespaceToCIMode = opt.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (lng?.toLowerCase() === 'cimode') {
      if (appendNamespaceToCIMode) {
        if (returnDetails) {
          return {
            res: `${namespace}${nsSeparator}${key}`,
            usedKey: key,
            exactUsedKey: key,
            usedLng: lng,
            usedNS: namespace,
            usedParams: this.getUsedParamsDetails(opt)
          };
        }
        return `${namespace}${nsSeparator}${key}`;
      }
      if (returnDetails) {
        return {
          res: key,
          usedKey: key,
          exactUsedKey: key,
          usedLng: lng,
          usedNS: namespace,
          usedParams: this.getUsedParamsDetails(opt)
        };
      }
      return key;
    }
    const resolved = this.resolve(keys, opt);
    let res = resolved?.res;
    const resUsedKey = resolved?.usedKey || key;
    const resExactUsedKey = resolved?.exactUsedKey || key;
    const noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
    const joinArrays = opt.joinArrays !== undefined ? opt.joinArrays : this.options.joinArrays;
    const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
    const needsPluralHandling = opt.count !== undefined && !isString(opt.count);
    const hasDefaultValue = Translator.hasDefaultValue(opt);
    const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, opt) : '';
    const defaultValueSuffixOrdinalFallback = opt.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, {
      ordinal: false
    }) : '';
    const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
    const defaultValue = needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] || opt[`defaultValue${defaultValueSuffix}`] || opt[`defaultValue${defaultValueSuffixOrdinalFallback}`] || opt.defaultValue;
    let resForObjHndl = res;
    if (handleAsObjectInI18nFormat && !res && hasDefaultValue) {
      resForObjHndl = defaultValue;
    }
    const handleAsObject = shouldHandleAsObject(resForObjHndl);
    const resType = Object.prototype.toString.apply(resForObjHndl);
    if (handleAsObjectInI18nFormat && resForObjHndl && handleAsObject && noObject.indexOf(resType) < 0 && !(isString(joinArrays) && Array.isArray(resForObjHndl))) {
      if (!opt.returnObjects && !this.options.returnObjects) {
        if (!this.options.returnedObjectHandler) {
          this.logger.warn('accessing an object - but returnObjects options is not enabled!');
        }
        const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, resForObjHndl, {
          ...opt,
          ns: namespaces
        }) : `key '${key} (${this.language})' returned an object instead of string.`;
        if (returnDetails) {
          resolved.res = r;
          resolved.usedParams = this.getUsedParamsDetails(opt);
          return resolved;
        }
        return r;
      }
      if (keySeparator) {
        const resTypeIsArray = Array.isArray(resForObjHndl);
        const copy = resTypeIsArray ? [] : {};
        const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
        for (const m in resForObjHndl) {
          if (Object.prototype.hasOwnProperty.call(resForObjHndl, m)) {
            const deepKey = `${newKeyToUse}${keySeparator}${m}`;
            if (hasDefaultValue && !res) {
              copy[m] = this.translate(deepKey, {
                ...opt,
                defaultValue: shouldHandleAsObject(defaultValue) ? defaultValue[m] : undefined,
                ...{
                  joinArrays: false,
                  ns: namespaces
                }
              });
            } else {
              copy[m] = this.translate(deepKey, {
                ...opt,
                ...{
                  joinArrays: false,
                  ns: namespaces
                }
              });
            }
            if (copy[m] === deepKey) copy[m] = resForObjHndl[m];
          }
        }
        res = copy;
      }
    } else if (handleAsObjectInI18nFormat && isString(joinArrays) && Array.isArray(res)) {
      res = res.join(joinArrays);
      if (res) res = this.extendTranslation(res, keys, opt, lastKey);
    } else {
      let usedDefault = false;
      let usedKey = false;
      if (!this.isValidLookup(res) && hasDefaultValue) {
        usedDefault = true;
        res = defaultValue;
      }
      if (!this.isValidLookup(res)) {
        usedKey = true;
        res = key;
      }
      const missingKeyNoValueFallbackToKey = opt.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
      const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
      const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
      if (usedKey || usedDefault || updateMissing) {
        this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
        if (keySeparator) {
          const fk = this.resolve(key, {
            ...opt,
            keySeparator: false
          });
          if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
        }
        let lngs = [];
        const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, opt.lng || this.language);
        if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
          for (let i = 0; i < fallbackLngs.length; i++) {
            lngs.push(fallbackLngs[i]);
          }
        } else if (this.options.saveMissingTo === 'all') {
          lngs = this.languageUtils.toResolveHierarchy(opt.lng || this.language);
        } else {
          lngs.push(opt.lng || this.language);
        }
        const send = (l, k, specificDefaultValue) => {
          const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
          if (this.options.missingKeyHandler) {
            this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, opt);
          } else if (this.backendConnector?.saveMissing) {
            this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, opt);
          }
          this.emit('missingKey', l, namespace, k, res);
        };
        if (this.options.saveMissing) {
          if (this.options.saveMissingPlurals && needsPluralHandling) {
            lngs.forEach(language => {
              const suffixes = this.pluralResolver.getSuffixes(language, opt);
              if (needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) {
                suffixes.push(`${this.options.pluralSeparator}zero`);
              }
              suffixes.forEach(suffix => {
                send([language], key + suffix, opt[`defaultValue${suffix}`] || defaultValue);
              });
            });
          } else {
            send(lngs, key, defaultValue);
          }
        }
      }
      res = this.extendTranslation(res, keys, opt, resolved, lastKey);
      if (usedKey && res === key && this.options.appendNamespaceToMissingKey) {
        res = `${namespace}${nsSeparator}${key}`;
      }
      if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
        res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}${nsSeparator}${key}` : key, usedDefault ? res : undefined, opt);
      }
    }
    if (returnDetails) {
      resolved.res = res;
      resolved.usedParams = this.getUsedParamsDetails(opt);
      return resolved;
    }
    return res;
  }
  extendTranslation(res, key, opt, resolved, lastKey) {
    if (this.i18nFormat?.parse) {
      res = this.i18nFormat.parse(res, {
        ...this.options.interpolation.defaultVariables,
        ...opt
      }, opt.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
        resolved
      });
    } else if (!opt.skipInterpolation) {
      if (opt.interpolation) this.interpolator.init({
        ...opt,
        ...{
          interpolation: {
            ...this.options.interpolation,
            ...opt.interpolation
          }
        }
      });
      const skipOnVariables = isString(res) && (opt?.interpolation?.skipOnVariables !== undefined ? opt.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let nestBef;
      if (skipOnVariables) {
        const nb = res.match(this.interpolator.nestingRegexp);
        nestBef = nb && nb.length;
      }
      let data = opt.replace && !isString(opt.replace) ? opt.replace : opt;
      if (this.options.interpolation.defaultVariables) data = {
        ...this.options.interpolation.defaultVariables,
        ...data
      };
      res = this.interpolator.interpolate(res, data, opt.lng || this.language || resolved.usedLng, opt);
      if (skipOnVariables) {
        const na = res.match(this.interpolator.nestingRegexp);
        const nestAft = na && na.length;
        if (nestBef < nestAft) opt.nest = false;
      }
      if (!opt.lng && resolved && resolved.res) opt.lng = this.language || resolved.usedLng;
      if (opt.nest !== false) res = this.interpolator.nest(res, (...args) => {
        if (lastKey?.[0] === args[0] && !opt.context) {
          this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
          return null;
        }
        return this.translate(...args, key);
      }, opt);
      if (opt.interpolation) this.interpolator.reset();
    }
    const postProcess = opt.postProcess || this.options.postProcess;
    const postProcessorNames = isString(postProcess) ? [postProcess] : postProcess;
    if (res != null && postProcessorNames?.length && opt.applyPostProcessor !== false) {
      res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
        i18nResolved: {
          ...resolved,
          usedParams: this.getUsedParamsDetails(opt)
        },
        ...opt
      } : opt, this);
    }
    return res;
  }
  resolve(keys, opt = {}) {
    let found;
    let usedKey;
    let exactUsedKey;
    let usedLng;
    let usedNS;
    if (isString(keys)) keys = [keys];
    if (Array.isArray(keys)) keys = keys.map(k => typeof k === 'function' ? keysFromSelector(k, {
      ...this.options,
      ...opt
    }) : k);
    keys.forEach(k => {
      if (this.isValidLookup(found)) return;
      const extracted = this.extractFromKey(k, opt);
      const key = extracted.key;
      usedKey = key;
      let namespaces = extracted.namespaces;
      if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
      const needsPluralHandling = opt.count !== undefined && !isString(opt.count);
      const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
      const needsContextHandling = opt.context !== undefined && (isString(opt.context) || typeof opt.context === 'number') && opt.context !== '';
      const codes = opt.lngs ? opt.lngs : this.languageUtils.toResolveHierarchy(opt.lng || this.language, opt.fallbackLng);
      namespaces.forEach(ns => {
        if (this.isValidLookup(found)) return;
        usedNS = ns;
        if (!checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(usedNS)) {
          checkedLoadedFor[`${codes[0]}-${ns}`] = true;
          this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        }
        codes.forEach(code => {
          if (this.isValidLookup(found)) return;
          usedLng = code;
          const finalKeys = [key];
          if (this.i18nFormat?.addLookupKeys) {
            this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, opt);
          } else {
            let pluralSuffix;
            if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, opt.count, opt);
            const zeroSuffix = `${this.options.pluralSeparator}zero`;
            const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (needsPluralHandling) {
              if (opt.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) {
                finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
              }
              finalKeys.push(key + pluralSuffix);
              if (needsZeroSuffixLookup) {
                finalKeys.push(key + zeroSuffix);
              }
            }
            if (needsContextHandling) {
              const contextKey = `${key}${this.options.contextSeparator || '_'}${opt.context}`;
              finalKeys.push(contextKey);
              if (needsPluralHandling) {
                if (opt.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) {
                  finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                }
                finalKeys.push(contextKey + pluralSuffix);
                if (needsZeroSuffixLookup) {
                  finalKeys.push(contextKey + zeroSuffix);
                }
              }
            }
          }
          let possibleKey;
          while (possibleKey = finalKeys.pop()) {
            if (!this.isValidLookup(found)) {
              exactUsedKey = possibleKey;
              found = this.getResource(code, ns, possibleKey, opt);
            }
          }
        });
      });
    });
    return {
      res: found,
      usedKey,
      exactUsedKey,
      usedLng,
      usedNS
    };
  }
  isValidLookup(res) {
    return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
  }
  getResource(code, ns, key, options = {}) {
    if (this.i18nFormat?.getResource) return this.i18nFormat.getResource(code, ns, key, options);
    return this.resourceStore.getResource(code, ns, key, options);
  }
  getUsedParamsDetails(options = {}) {
    const optionsKeys = ['defaultValue', 'ordinal', 'context', 'replace', 'lng', 'lngs', 'fallbackLng', 'ns', 'keySeparator', 'nsSeparator', 'returnObjects', 'returnDetails', 'joinArrays', 'postProcess', 'interpolation'];
    const useOptionsReplaceForData = options.replace && !isString(options.replace);
    let data = useOptionsReplaceForData ? options.replace : options;
    if (useOptionsReplaceForData && typeof options.count !== 'undefined') {
      data.count = options.count;
    }
    if (this.options.interpolation.defaultVariables) {
      data = {
        ...this.options.interpolation.defaultVariables,
        ...data
      };
    }
    if (!useOptionsReplaceForData) {
      data = {
        ...data
      };
      for (const key of optionsKeys) {
        delete data[key];
      }
    }
    return data;
  }
  static hasDefaultValue(options) {
    const prefix = 'defaultValue';
    for (const option in options) {
      if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
        return true;
      }
    }
    return false;
  }
}

class LanguageUtil {
  constructor(options) {
    this.options = options;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }
  getScriptPartFromCode(code) {
    code = getCleanedCode(code);
    if (!code || code.indexOf('-') < 0) return null;
    const p = code.split('-');
    if (p.length === 2) return null;
    p.pop();
    if (p[p.length - 1].toLowerCase() === 'x') return null;
    return this.formatLanguageCode(p.join('-'));
  }
  getLanguagePartFromCode(code) {
    code = getCleanedCode(code);
    if (!code || code.indexOf('-') < 0) return code;
    const p = code.split('-');
    return this.formatLanguageCode(p[0]);
  }
  formatLanguageCode(code) {
    if (isString(code) && code.indexOf('-') > -1) {
      let formattedCode;
      try {
        formattedCode = Intl.getCanonicalLocales(code)[0];
      } catch (e) {}
      if (formattedCode && this.options.lowerCaseLng) {
        formattedCode = formattedCode.toLowerCase();
      }
      if (formattedCode) return formattedCode;
      if (this.options.lowerCaseLng) {
        return code.toLowerCase();
      }
      return code;
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
  }
  isSupportedCode(code) {
    if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
      code = this.getLanguagePartFromCode(code);
    }
    return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
  }
  getBestMatchFromCodes(codes) {
    if (!codes) return null;
    let found;
    codes.forEach(code => {
      if (found) return;
      const cleanedLng = this.formatLanguageCode(code);
      if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
    });
    if (!found && this.options.supportedLngs) {
      codes.forEach(code => {
        if (found) return;
        const lngScOnly = this.getScriptPartFromCode(code);
        if (this.isSupportedCode(lngScOnly)) return found = lngScOnly;
        const lngOnly = this.getLanguagePartFromCode(code);
        if (this.isSupportedCode(lngOnly)) return found = lngOnly;
        found = this.options.supportedLngs.find(supportedLng => {
          if (supportedLng === lngOnly) return supportedLng;
          if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
          if (supportedLng.indexOf('-') > 0 && lngOnly.indexOf('-') < 0 && supportedLng.substring(0, supportedLng.indexOf('-')) === lngOnly) return supportedLng;
          if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
        });
      });
    }
    if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
    return found;
  }
  getFallbackCodes(fallbacks, code) {
    if (!fallbacks) return [];
    if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
    if (isString(fallbacks)) fallbacks = [fallbacks];
    if (Array.isArray(fallbacks)) return fallbacks;
    if (!code) return fallbacks.default || [];
    let found = fallbacks[code];
    if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
    if (!found) found = fallbacks[this.formatLanguageCode(code)];
    if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
    if (!found) found = fallbacks.default;
    return found || [];
  }
  toResolveHierarchy(code, fallbackCode) {
    const fallbackCodes = this.getFallbackCodes((fallbackCode === false ? [] : fallbackCode) || this.options.fallbackLng || [], code);
    const codes = [];
    const addCode = c => {
      if (!c) return;
      if (this.isSupportedCode(c)) {
        codes.push(c);
      } else {
        this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
      }
    };
    if (isString(code) && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
      if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
      if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
      if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
    } else if (isString(code)) {
      addCode(this.formatLanguageCode(code));
    }
    fallbackCodes.forEach(fc => {
      if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
    });
    return codes;
  }
}

const suffixesOrder = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
const dummyRule = {
  select: count => count === 1 ? 'one' : 'other',
  resolvedOptions: () => ({
    pluralCategories: ['one', 'other']
  })
};
class PluralResolver {
  constructor(languageUtils, options = {}) {
    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');
    this.pluralRulesCache = {};
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(code, options = {}) {
    const cleanedCode = getCleanedCode(code === 'dev' ? 'en' : code);
    const type = options.ordinal ? 'ordinal' : 'cardinal';
    const cacheKey = JSON.stringify({
      cleanedCode,
      type
    });
    if (cacheKey in this.pluralRulesCache) {
      return this.pluralRulesCache[cacheKey];
    }
    let rule;
    try {
      rule = new Intl.PluralRules(cleanedCode, {
        type
      });
    } catch (err) {
      if (typeof Intl === 'undefined') {
        this.logger.error('No Intl support, please use an Intl polyfill!');
        return dummyRule;
      }
      if (!code.match(/-|_/)) return dummyRule;
      const lngPart = this.languageUtils.getLanguagePartFromCode(code);
      rule = this.getRule(lngPart, options);
    }
    this.pluralRulesCache[cacheKey] = rule;
    return rule;
  }
  needsPlural(code, options = {}) {
    let rule = this.getRule(code, options);
    if (!rule) rule = this.getRule('dev', options);
    return rule?.resolvedOptions().pluralCategories.length > 1;
  }
  getPluralFormsOfKey(code, key, options = {}) {
    return this.getSuffixes(code, options).map(suffix => `${key}${suffix}`);
  }
  getSuffixes(code, options = {}) {
    let rule = this.getRule(code, options);
    if (!rule) rule = this.getRule('dev', options);
    if (!rule) return [];
    return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2) => suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2]).map(pluralCategory => `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
  }
  getSuffix(code, count, options = {}) {
    const rule = this.getRule(code, options);
    if (rule) {
      return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
    }
    this.logger.warn(`no plural rule found for: ${code}`);
    return this.getSuffix('dev', count, options);
  }
}

const deepFindWithDefaults = (data, defaultData, key, keySeparator = '.', ignoreJSONStructure = true) => {
  let path = getPathWithDefaults(data, defaultData, key);
  if (!path && ignoreJSONStructure && isString(key)) {
    path = deepFind(data, key, keySeparator);
    if (path === undefined) path = deepFind(defaultData, key, keySeparator);
  }
  return path;
};
const regexSafe = val => val.replace(/\$/g, '$$$$');
class Interpolator {
  constructor(options = {}) {
    this.logger = baseLogger.create('interpolator');
    this.options = options;
    this.format = options?.interpolation?.format || (value => value);
    this.init(options);
  }
  init(options = {}) {
    if (!options.interpolation) options.interpolation = {
      escapeValue: true
    };
    const {
      escape: escape$1,
      escapeValue,
      useRawValueToEscape,
      prefix,
      prefixEscaped,
      suffix,
      suffixEscaped,
      formatSeparator,
      unescapeSuffix,
      unescapePrefix,
      nestingPrefix,
      nestingPrefixEscaped,
      nestingSuffix,
      nestingSuffixEscaped,
      nestingOptionsSeparator,
      maxReplaces,
      alwaysFormat
    } = options.interpolation;
    this.escape = escape$1 !== undefined ? escape$1 : escape;
    this.escapeValue = escapeValue !== undefined ? escapeValue : true;
    this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
    this.prefix = prefix ? regexEscape(prefix) : prefixEscaped || '{{';
    this.suffix = suffix ? regexEscape(suffix) : suffixEscaped || '}}';
    this.formatSeparator = formatSeparator || ',';
    this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix || '-';
    this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix || '';
    this.nestingPrefix = nestingPrefix ? regexEscape(nestingPrefix) : nestingPrefixEscaped || regexEscape('$t(');
    this.nestingSuffix = nestingSuffix ? regexEscape(nestingSuffix) : nestingSuffixEscaped || regexEscape(')');
    this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
    this.maxReplaces = maxReplaces || 1000;
    this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
    this.resetRegExp();
  }
  reset() {
    if (this.options) this.init(this.options);
  }
  resetRegExp() {
    const getOrResetRegExp = (existingRegExp, pattern) => {
      if (existingRegExp?.source === pattern) {
        existingRegExp.lastIndex = 0;
        return existingRegExp;
      }
      return new RegExp(pattern, 'g');
    };
    this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
    this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
    this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
  }
  interpolate(str, data, lng, options) {
    let match;
    let value;
    let replaces;
    const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
    const handleFormat = key => {
      if (key.indexOf(this.formatSeparator) < 0) {
        const path = deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(path, undefined, lng, {
          ...options,
          ...data,
          interpolationkey: key
        }) : path;
      }
      const p = key.split(this.formatSeparator);
      const k = p.shift().trim();
      const f = p.join(this.formatSeparator).trim();
      return this.format(deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
        ...options,
        ...data,
        interpolationkey: k
      });
    };
    this.resetRegExp();
    const missingInterpolationHandler = options?.missingInterpolationHandler || this.options.missingInterpolationHandler;
    const skipOnVariables = options?.interpolation?.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    const todos = [{
      regex: this.regexpUnescape,
      safeValue: val => regexSafe(val)
    }, {
      regex: this.regexp,
      safeValue: val => this.escapeValue ? regexSafe(this.escape(val)) : regexSafe(val)
    }];
    todos.forEach(todo => {
      replaces = 0;
      while (match = todo.regex.exec(str)) {
        const matchedVar = match[1].trim();
        value = handleFormat(matchedVar);
        if (value === undefined) {
          if (typeof missingInterpolationHandler === 'function') {
            const temp = missingInterpolationHandler(str, match, options);
            value = isString(temp) ? temp : '';
          } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) {
            value = '';
          } else if (skipOnVariables) {
            value = match[0];
            continue;
          } else {
            this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
            value = '';
          }
        } else if (!isString(value) && !this.useRawValueToEscape) {
          value = makeString(value);
        }
        const safeValue = todo.safeValue(value);
        str = str.replace(match[0], safeValue);
        if (skipOnVariables) {
          todo.regex.lastIndex += value.length;
          todo.regex.lastIndex -= match[0].length;
        } else {
          todo.regex.lastIndex = 0;
        }
        replaces++;
        if (replaces >= this.maxReplaces) {
          break;
        }
      }
    });
    return str;
  }
  nest(str, fc, options = {}) {
    let match;
    let value;
    let clonedOptions;
    const handleHasOptions = (key, inheritedOptions) => {
      const sep = this.nestingOptionsSeparator;
      if (key.indexOf(sep) < 0) return key;
      const c = key.split(new RegExp(`${regexEscape(sep)}[ ]*{`));
      let optionsString = `{${c[1]}`;
      key = c[0];
      optionsString = this.interpolate(optionsString, clonedOptions);
      const matchedSingleQuotes = optionsString.match(/'/g);
      const matchedDoubleQuotes = optionsString.match(/"/g);
      if ((matchedSingleQuotes?.length ?? 0) % 2 === 0 && !matchedDoubleQuotes || (matchedDoubleQuotes?.length ?? 0) % 2 !== 0) {
        optionsString = optionsString.replace(/'/g, '"');
      }
      try {
        clonedOptions = JSON.parse(optionsString);
        if (inheritedOptions) clonedOptions = {
          ...inheritedOptions,
          ...clonedOptions
        };
      } catch (e) {
        this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
        return `${key}${sep}${optionsString}`;
      }
      if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
      return key;
    };
    while (match = this.nestingRegexp.exec(str)) {
      let formatters = [];
      clonedOptions = {
        ...options
      };
      clonedOptions = clonedOptions.replace && !isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;
      const keyEndIndex = /{.*}/.test(match[1]) ? match[1].lastIndexOf('}') + 1 : match[1].indexOf(this.formatSeparator);
      if (keyEndIndex !== -1) {
        formatters = match[1].slice(keyEndIndex).split(this.formatSeparator).map(elem => elem.trim()).filter(Boolean);
        match[1] = match[1].slice(0, keyEndIndex);
      }
      value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
      if (value && match[0] === str && !isString(value)) return value;
      if (!isString(value)) value = makeString(value);
      if (!value) {
        this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
        value = '';
      }
      if (formatters.length) {
        value = formatters.reduce((v, f) => this.format(v, f, options.lng, {
          ...options,
          interpolationkey: match[1].trim()
        }), value.trim());
      }
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
    }
    return str;
  }
}

const parseFormatStr = formatStr => {
  let formatName = formatStr.toLowerCase().trim();
  const formatOptions = {};
  if (formatStr.indexOf('(') > -1) {
    const p = formatStr.split('(');
    formatName = p[0].toLowerCase().trim();
    const optStr = p[1].substring(0, p[1].length - 1);
    if (formatName === 'currency' && optStr.indexOf(':') < 0) {
      if (!formatOptions.currency) formatOptions.currency = optStr.trim();
    } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
      if (!formatOptions.range) formatOptions.range = optStr.trim();
    } else {
      const opts = optStr.split(';');
      opts.forEach(opt => {
        if (opt) {
          const [key, ...rest] = opt.split(':');
          const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
          const trimmedKey = key.trim();
          if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
          if (val === 'false') formatOptions[trimmedKey] = false;
          if (val === 'true') formatOptions[trimmedKey] = true;
          if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
        }
      });
    }
  }
  return {
    formatName,
    formatOptions
  };
};
const createCachedFormatter = fn => {
  const cache = {};
  return (v, l, o) => {
    let optForCache = o;
    if (o && o.interpolationkey && o.formatParams && o.formatParams[o.interpolationkey] && o[o.interpolationkey]) {
      optForCache = {
        ...optForCache,
        [o.interpolationkey]: undefined
      };
    }
    const key = l + JSON.stringify(optForCache);
    let frm = cache[key];
    if (!frm) {
      frm = fn(getCleanedCode(l), o);
      cache[key] = frm;
    }
    return frm(v);
  };
};
const createNonCachedFormatter = fn => (v, l, o) => fn(getCleanedCode(l), o)(v);
class Formatter {
  constructor(options = {}) {
    this.logger = baseLogger.create('formatter');
    this.options = options;
    this.init(options);
  }
  init(services, options = {
    interpolation: {}
  }) {
    this.formatSeparator = options.interpolation.formatSeparator || ',';
    const cf = options.cacheInBuiltFormats ? createCachedFormatter : createNonCachedFormatter;
    this.formats = {
      number: cf((lng, opt) => {
        const formatter = new Intl.NumberFormat(lng, {
          ...opt
        });
        return val => formatter.format(val);
      }),
      currency: cf((lng, opt) => {
        const formatter = new Intl.NumberFormat(lng, {
          ...opt,
          style: 'currency'
        });
        return val => formatter.format(val);
      }),
      datetime: cf((lng, opt) => {
        const formatter = new Intl.DateTimeFormat(lng, {
          ...opt
        });
        return val => formatter.format(val);
      }),
      relativetime: cf((lng, opt) => {
        const formatter = new Intl.RelativeTimeFormat(lng, {
          ...opt
        });
        return val => formatter.format(val, opt.range || 'day');
      }),
      list: cf((lng, opt) => {
        const formatter = new Intl.ListFormat(lng, {
          ...opt
        });
        return val => formatter.format(val);
      })
    };
  }
  add(name, fc) {
    this.formats[name.toLowerCase().trim()] = fc;
  }
  addCached(name, fc) {
    this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
  }
  format(value, format, lng, options = {}) {
    const formats = format.split(this.formatSeparator);
    if (formats.length > 1 && formats[0].indexOf('(') > 1 && formats[0].indexOf(')') < 0 && formats.find(f => f.indexOf(')') > -1)) {
      const lastIndex = formats.findIndex(f => f.indexOf(')') > -1);
      formats[0] = [formats[0], ...formats.splice(1, lastIndex)].join(this.formatSeparator);
    }
    const result = formats.reduce((mem, f) => {
      const {
        formatName,
        formatOptions
      } = parseFormatStr(f);
      if (this.formats[formatName]) {
        let formatted = mem;
        try {
          const valOptions = options?.formatParams?.[options.interpolationkey] || {};
          const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
          formatted = this.formats[formatName](mem, l, {
            ...formatOptions,
            ...options,
            ...valOptions
          });
        } catch (error) {
          this.logger.warn(error);
        }
        return formatted;
      } else {
        this.logger.warn(`there was no format function for ${formatName}`);
      }
      return mem;
    }, value);
    return result;
  }
}

const removePending = (q, name) => {
  if (q.pending[name] !== undefined) {
    delete q.pending[name];
    q.pendingCount--;
  }
};
class Connector extends EventEmitter {
  constructor(backend, store, services, options = {}) {
    super();
    this.backend = backend;
    this.store = store;
    this.services = services;
    this.languageUtils = services.languageUtils;
    this.options = options;
    this.logger = baseLogger.create('backendConnector');
    this.waitingReads = [];
    this.maxParallelReads = options.maxParallelReads || 10;
    this.readingCalls = 0;
    this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
    this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
    this.state = {};
    this.queue = [];
    this.backend?.init?.(services, options.backend, options);
  }
  queueLoad(languages, namespaces, options, callback) {
    const toLoad = {};
    const pending = {};
    const toLoadLanguages = {};
    const toLoadNamespaces = {};
    languages.forEach(lng => {
      let hasAllNamespaces = true;
      namespaces.forEach(ns => {
        const name = `${lng}|${ns}`;
        if (!options.reload && this.store.hasResourceBundle(lng, ns)) {
          this.state[name] = 2;
        } else if (this.state[name] < 0) ; else if (this.state[name] === 1) {
          if (pending[name] === undefined) pending[name] = true;
        } else {
          this.state[name] = 1;
          hasAllNamespaces = false;
          if (pending[name] === undefined) pending[name] = true;
          if (toLoad[name] === undefined) toLoad[name] = true;
          if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
        }
      });
      if (!hasAllNamespaces) toLoadLanguages[lng] = true;
    });
    if (Object.keys(toLoad).length || Object.keys(pending).length) {
      this.queue.push({
        pending,
        pendingCount: Object.keys(pending).length,
        loaded: {},
        errors: [],
        callback
      });
    }
    return {
      toLoad: Object.keys(toLoad),
      pending: Object.keys(pending),
      toLoadLanguages: Object.keys(toLoadLanguages),
      toLoadNamespaces: Object.keys(toLoadNamespaces)
    };
  }
  loaded(name, err, data) {
    const s = name.split('|');
    const lng = s[0];
    const ns = s[1];
    if (err) this.emit('failedLoading', lng, ns, err);
    if (!err && data) {
      this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
        skipCopy: true
      });
    }
    this.state[name] = err ? -1 : 2;
    if (err && data) this.state[name] = 0;
    const loaded = {};
    this.queue.forEach(q => {
      pushPath(q.loaded, [lng], ns);
      removePending(q, name);
      if (err) q.errors.push(err);
      if (q.pendingCount === 0 && !q.done) {
        Object.keys(q.loaded).forEach(l => {
          if (!loaded[l]) loaded[l] = {};
          const loadedKeys = q.loaded[l];
          if (loadedKeys.length) {
            loadedKeys.forEach(n => {
              if (loaded[l][n] === undefined) loaded[l][n] = true;
            });
          }
        });
        q.done = true;
        if (q.errors.length) {
          q.callback(q.errors);
        } else {
          q.callback();
        }
      }
    });
    this.emit('loaded', loaded);
    this.queue = this.queue.filter(q => !q.done);
  }
  read(lng, ns, fcName, tried = 0, wait = this.retryTimeout, callback) {
    if (!lng.length) return callback(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng,
        ns,
        fcName,
        tried,
        wait,
        callback
      });
      return;
    }
    this.readingCalls++;
    const resolver = (err, data) => {
      this.readingCalls--;
      if (this.waitingReads.length > 0) {
        const next = this.waitingReads.shift();
        this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
      }
      if (err && data && tried < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
        }, wait);
        return;
      }
      callback(err, data);
    };
    const fc = this.backend[fcName].bind(this.backend);
    if (fc.length === 2) {
      try {
        const r = fc(lng, ns);
        if (r && typeof r.then === 'function') {
          r.then(data => resolver(null, data)).catch(resolver);
        } else {
          resolver(null, r);
        }
      } catch (err) {
        resolver(err);
      }
      return;
    }
    return fc(lng, ns, resolver);
  }
  prepareLoading(languages, namespaces, options = {}, callback) {
    if (!this.backend) {
      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
      return callback && callback();
    }
    if (isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
    if (isString(namespaces)) namespaces = [namespaces];
    const toLoad = this.queueLoad(languages, namespaces, options, callback);
    if (!toLoad.toLoad.length) {
      if (!toLoad.pending.length) callback();
      return null;
    }
    toLoad.toLoad.forEach(name => {
      this.loadOne(name);
    });
  }
  load(languages, namespaces, callback) {
    this.prepareLoading(languages, namespaces, {}, callback);
  }
  reload(languages, namespaces, callback) {
    this.prepareLoading(languages, namespaces, {
      reload: true
    }, callback);
  }
  loadOne(name, prefix = '') {
    const s = name.split('|');
    const lng = s[0];
    const ns = s[1];
    this.read(lng, ns, 'read', undefined, undefined, (err, data) => {
      if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
      if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
      this.loaded(name, err, data);
    });
  }
  saveMissing(languages, namespace, key, fallbackValue, isUpdate, options = {}, clb = () => {}) {
    if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(namespace)) {
      this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
      return;
    }
    if (key === undefined || key === null || key === '') return;
    if (this.backend?.create) {
      const opts = {
        ...options,
        isUpdate
      };
      const fc = this.backend.create.bind(this.backend);
      if (fc.length < 6) {
        try {
          let r;
          if (fc.length === 5) {
            r = fc(languages, namespace, key, fallbackValue, opts);
          } else {
            r = fc(languages, namespace, key, fallbackValue);
          }
          if (r && typeof r.then === 'function') {
            r.then(data => clb(null, data)).catch(clb);
          } else {
            clb(null, r);
          }
        } catch (err) {
          clb(err);
        }
      } else {
        fc(languages, namespace, key, fallbackValue, clb, opts);
      }
    }
    if (!languages || !languages[0]) return;
    this.store.addResource(languages[0], namespace, key, fallbackValue);
  }
}

const get = () => ({
  debug: false,
  initAsync: true,
  ns: ['translation'],
  defaultNS: ['translation'],
  fallbackLng: ['dev'],
  fallbackNS: false,
  supportedLngs: false,
  nonExplicitSupportedLngs: false,
  load: 'all',
  preload: false,
  simplifyPluralSuffix: true,
  keySeparator: '.',
  nsSeparator: ':',
  pluralSeparator: '_',
  contextSeparator: '_',
  partialBundledLanguages: false,
  saveMissing: false,
  updateMissing: false,
  saveMissingTo: 'fallback',
  saveMissingPlurals: true,
  missingKeyHandler: false,
  missingInterpolationHandler: false,
  postProcess: false,
  postProcessPassResolved: false,
  returnNull: false,
  returnEmptyString: true,
  returnObjects: false,
  joinArrays: false,
  returnedObjectHandler: false,
  parseMissingKeyHandler: false,
  appendNamespaceToMissingKey: false,
  appendNamespaceToCIMode: false,
  overloadTranslationOptionHandler: args => {
    let ret = {};
    if (typeof args[1] === 'object') ret = args[1];
    if (isString(args[1])) ret.defaultValue = args[1];
    if (isString(args[2])) ret.tDescription = args[2];
    if (typeof args[2] === 'object' || typeof args[3] === 'object') {
      const options = args[3] || args[2];
      Object.keys(options).forEach(key => {
        ret[key] = options[key];
      });
    }
    return ret;
  },
  interpolation: {
    escapeValue: true,
    format: value => value,
    prefix: '{{',
    suffix: '}}',
    formatSeparator: ',',
    unescapePrefix: '-',
    nestingPrefix: '$t(',
    nestingSuffix: ')',
    nestingOptionsSeparator: ',',
    maxReplaces: 1000,
    skipOnVariables: true
  },
  cacheInBuiltFormats: true
});
const transformOptions = options => {
  if (isString(options.ns)) options.ns = [options.ns];
  if (isString(options.fallbackLng)) options.fallbackLng = [options.fallbackLng];
  if (isString(options.fallbackNS)) options.fallbackNS = [options.fallbackNS];
  if (options.supportedLngs?.indexOf?.('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }
  if (typeof options.initImmediate === 'boolean') options.initAsync = options.initImmediate;
  return options;
};

const noop = () => {};
const bindMemberFunctions = inst => {
  const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
  mems.forEach(mem => {
    if (typeof inst[mem] === 'function') {
      inst[mem] = inst[mem].bind(inst);
    }
  });
};
const SUPPORT_NOTICE_KEY = '__i18next_supportNoticeShown';
const getSupportNoticeShown = () => {
  if (typeof globalThis !== 'undefined' && !!globalThis[SUPPORT_NOTICE_KEY]) return true;
  if (typeof process !== 'undefined' && process.env && process.env.I18NEXT_NO_SUPPORT_NOTICE) return true;
  return false;
};
const setSupportNoticeShown = () => {
  if (typeof globalThis !== 'undefined') globalThis[SUPPORT_NOTICE_KEY] = true;
};
const usesLocize = inst => {
  if (inst?.modules?.backend?.name?.indexOf('Locize') > 0) return true;
  if (inst?.modules?.backend?.constructor?.name?.indexOf('Locize') > 0) return true;
  if (inst?.options?.backend?.backends) {
    if (inst.options.backend.backends.some(b => b?.name?.indexOf('Locize') > 0 || b?.constructor?.name?.indexOf('Locize') > 0)) return true;
  }
  if (inst?.options?.backend?.projectId) return true;
  if (inst?.options?.backend?.backendOptions) {
    if (inst.options.backend.backendOptions.some(b => b?.projectId)) return true;
  }
  return false;
};
class I18n extends EventEmitter {
  constructor(options = {}, callback) {
    super();
    this.options = transformOptions(options);
    this.services = {};
    this.logger = baseLogger;
    this.modules = {
      external: []
    };
    bindMemberFunctions(this);
    if (callback && !this.isInitialized && !options.isClone) {
      if (!this.options.initAsync) {
        this.init(options, callback);
        return this;
      }
      setTimeout(() => {
        this.init(options, callback);
      }, 0);
    }
  }
  init(options = {}, callback) {
    this.isInitializing = true;
    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    if (options.defaultNS == null && options.ns) {
      if (isString(options.ns)) {
        options.defaultNS = options.ns;
      } else if (options.ns.indexOf('translation') < 0) {
        options.defaultNS = options.ns[0];
      }
    }
    const defOpts = get();
    this.options = {
      ...defOpts,
      ...this.options,
      ...transformOptions(options)
    };
    this.options.interpolation = {
      ...defOpts.interpolation,
      ...this.options.interpolation
    };
    if (options.keySeparator !== undefined) {
      this.options.userDefinedKeySeparator = options.keySeparator;
    }
    if (options.nsSeparator !== undefined) {
      this.options.userDefinedNsSeparator = options.nsSeparator;
    }
    if (typeof this.options.overloadTranslationOptionHandler !== 'function') {
      this.options.overloadTranslationOptionHandler = defOpts.overloadTranslationOptionHandler;
    }
    if (this.options.showSupportNotice !== false && !usesLocize(this) && !getSupportNoticeShown()) {
      if (typeof console !== 'undefined' && typeof console.info !== 'undefined') console.info('🌐 i18next is made possible by our own product, Locize — consider powering your project with managed localization (AI, CDN, integrations): https://locize.com 💙');
      setSupportNoticeShown();
    }
    const createClassOnDemand = ClassOrObject => {
      if (!ClassOrObject) return null;
      if (typeof ClassOrObject === 'function') return new ClassOrObject();
      return ClassOrObject;
    };
    if (!this.options.isClone) {
      if (this.modules.logger) {
        baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
      } else {
        baseLogger.init(null, this.options);
      }
      let formatter;
      if (this.modules.formatter) {
        formatter = this.modules.formatter;
      } else {
        formatter = Formatter;
      }
      const lu = new LanguageUtil(this.options);
      this.store = new ResourceStore(this.options.resources, this.options);
      const s = this.services;
      s.logger = baseLogger;
      s.resourceStore = this.store;
      s.languageUtils = lu;
      s.pluralResolver = new PluralResolver(lu, {
        prepend: this.options.pluralSeparator,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      });
      const usingLegacyFormatFunction = this.options.interpolation.format && this.options.interpolation.format !== defOpts.interpolation.format;
      if (usingLegacyFormatFunction) {
        this.logger.deprecate(`init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting`);
      }
      if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
        s.formatter = createClassOnDemand(formatter);
        if (s.formatter.init) s.formatter.init(s, this.options);
        this.options.interpolation.format = s.formatter.format.bind(s.formatter);
      }
      s.interpolator = new Interpolator(this.options);
      s.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      };
      s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
      s.backendConnector.on('*', (event, ...args) => {
        this.emit(event, ...args);
      });
      if (this.modules.languageDetector) {
        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
        if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
      }
      if (this.modules.i18nFormat) {
        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
        if (s.i18nFormat.init) s.i18nFormat.init(this);
      }
      this.translator = new Translator(this.services, this.options);
      this.translator.on('*', (event, ...args) => {
        this.emit(event, ...args);
      });
      this.modules.external.forEach(m => {
        if (m.init) m.init(this);
      });
    }
    this.format = this.options.interpolation.format;
    if (!callback) callback = noop;
    if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
    }
    if (!this.services.languageDetector && !this.options.lng) {
      this.logger.warn('init: no languageDetector is used and no lng is defined');
    }
    const storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
    storeApi.forEach(fcName => {
      this[fcName] = (...args) => this.store[fcName](...args);
    });
    const storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
    storeApiChained.forEach(fcName => {
      this[fcName] = (...args) => {
        this.store[fcName](...args);
        return this;
      };
    });
    const deferred = defer();
    const load = () => {
      const finish = (err, t) => {
        this.isInitializing = false;
        if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
        this.isInitialized = true;
        if (!this.options.isClone) this.logger.log('initialized', this.options);
        this.emit('initialized', this.options);
        deferred.resolve(t);
        callback(err, t);
      };
      if (this.languages && !this.isInitialized) return finish(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, finish);
    };
    if (this.options.resources || !this.options.initAsync) {
      load();
    } else {
      setTimeout(load, 0);
    }
    return deferred;
  }
  loadResources(language, callback = noop) {
    let usedCallback = callback;
    const usedLng = isString(language) ? language : this.language;
    if (typeof language === 'function') usedCallback = language;
    if (!this.options.resources || this.options.partialBundledLanguages) {
      if (usedLng?.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
      const toLoad = [];
      const append = lng => {
        if (!lng) return;
        if (lng === 'cimode') return;
        const lngs = this.services.languageUtils.toResolveHierarchy(lng);
        lngs.forEach(l => {
          if (l === 'cimode') return;
          if (toLoad.indexOf(l) < 0) toLoad.push(l);
        });
      };
      if (!usedLng) {
        const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        fallbacks.forEach(l => append(l));
      } else {
        append(usedLng);
      }
      this.options.preload?.forEach?.(l => append(l));
      this.services.backendConnector.load(toLoad, this.options.ns, e => {
        if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
        usedCallback(e);
      });
    } else {
      usedCallback(null);
    }
  }
  reloadResources(lngs, ns, callback) {
    const deferred = defer();
    if (typeof lngs === 'function') {
      callback = lngs;
      lngs = undefined;
    }
    if (typeof ns === 'function') {
      callback = ns;
      ns = undefined;
    }
    if (!lngs) lngs = this.languages;
    if (!ns) ns = this.options.ns;
    if (!callback) callback = noop;
    this.services.backendConnector.reload(lngs, ns, err => {
      deferred.resolve();
      callback(err);
    });
    return deferred;
  }
  use(module) {
    if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
    if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
    if (module.type === 'backend') {
      this.modules.backend = module;
    }
    if (module.type === 'logger' || module.log && module.warn && module.error) {
      this.modules.logger = module;
    }
    if (module.type === 'languageDetector') {
      this.modules.languageDetector = module;
    }
    if (module.type === 'i18nFormat') {
      this.modules.i18nFormat = module;
    }
    if (module.type === 'postProcessor') {
      postProcessor.addPostProcessor(module);
    }
    if (module.type === 'formatter') {
      this.modules.formatter = module;
    }
    if (module.type === '3rdParty') {
      this.modules.external.push(module);
    }
    return this;
  }
  setResolvedLanguage(l) {
    if (!l || !this.languages) return;
    if (['cimode', 'dev'].indexOf(l) > -1) return;
    for (let li = 0; li < this.languages.length; li++) {
      const lngInLngs = this.languages[li];
      if (['cimode', 'dev'].indexOf(lngInLngs) > -1) continue;
      if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
        this.resolvedLanguage = lngInLngs;
        break;
      }
    }
    if (!this.resolvedLanguage && this.languages.indexOf(l) < 0 && this.store.hasLanguageSomeTranslations(l)) {
      this.resolvedLanguage = l;
      this.languages.unshift(l);
    }
  }
  changeLanguage(lng, callback) {
    this.isLanguageChangingTo = lng;
    const deferred = defer();
    this.emit('languageChanging', lng);
    const setLngProps = l => {
      this.language = l;
      this.languages = this.services.languageUtils.toResolveHierarchy(l);
      this.resolvedLanguage = undefined;
      this.setResolvedLanguage(l);
    };
    const done = (err, l) => {
      if (l) {
        if (this.isLanguageChangingTo === lng) {
          setLngProps(l);
          this.translator.changeLanguage(l);
          this.isLanguageChangingTo = undefined;
          this.emit('languageChanged', l);
          this.logger.log('languageChanged', l);
        }
      } else {
        this.isLanguageChangingTo = undefined;
      }
      deferred.resolve((...args) => this.t(...args));
      if (callback) callback(err, (...args) => this.t(...args));
    };
    const setLng = lngs => {
      if (!lng && !lngs && this.services.languageDetector) lngs = [];
      const fl = isString(lngs) ? lngs : lngs && lngs[0];
      const l = this.store.hasLanguageSomeTranslations(fl) ? fl : this.services.languageUtils.getBestMatchFromCodes(isString(lngs) ? [lngs] : lngs);
      if (l) {
        if (!this.language) {
          setLngProps(l);
        }
        if (!this.translator.language) this.translator.changeLanguage(l);
        this.services.languageDetector?.cacheUserLanguage?.(l);
      }
      this.loadResources(l, err => {
        done(err, l);
      });
    };
    if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
      setLng(this.services.languageDetector.detect());
    } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
      if (this.services.languageDetector.detect.length === 0) {
        this.services.languageDetector.detect().then(setLng);
      } else {
        this.services.languageDetector.detect(setLng);
      }
    } else {
      setLng(lng);
    }
    return deferred;
  }
  getFixedT(lng, ns, keyPrefix) {
    const fixedT = (key, opts, ...rest) => {
      let o;
      if (typeof opts !== 'object') {
        o = this.options.overloadTranslationOptionHandler([key, opts].concat(rest));
      } else {
        o = {
          ...opts
        };
      }
      o.lng = o.lng || fixedT.lng;
      o.lngs = o.lngs || fixedT.lngs;
      o.ns = o.ns || fixedT.ns;
      if (o.keyPrefix !== '') o.keyPrefix = o.keyPrefix || keyPrefix || fixedT.keyPrefix;
      const selectorOpts = {
        ...this.options,
        ...o
      };
      if (typeof o.keyPrefix === 'function') o.keyPrefix = keysFromSelector(o.keyPrefix, selectorOpts);
      const keySeparator = this.options.keySeparator || '.';
      let resultKey;
      if (o.keyPrefix && Array.isArray(key)) {
        resultKey = key.map(k => {
          if (typeof k === 'function') k = keysFromSelector(k, selectorOpts);
          return `${o.keyPrefix}${keySeparator}${k}`;
        });
      } else {
        if (typeof key === 'function') key = keysFromSelector(key, selectorOpts);
        resultKey = o.keyPrefix ? `${o.keyPrefix}${keySeparator}${key}` : key;
      }
      return this.t(resultKey, o);
    };
    if (isString(lng)) {
      fixedT.lng = lng;
    } else {
      fixedT.lngs = lng;
    }
    fixedT.ns = ns;
    fixedT.keyPrefix = keyPrefix;
    return fixedT;
  }
  t(...args) {
    return this.translator?.translate(...args);
  }
  exists(...args) {
    return this.translator?.exists(...args);
  }
  setDefaultNamespace(ns) {
    this.options.defaultNS = ns;
  }
  hasLoadedNamespace(ns, options = {}) {
    if (!this.isInitialized) {
      this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
      return false;
    }
    if (!this.languages || !this.languages.length) {
      this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
      return false;
    }
    const lng = options.lng || this.resolvedLanguage || this.languages[0];
    const fallbackLng = this.options ? this.options.fallbackLng : false;
    const lastLng = this.languages[this.languages.length - 1];
    if (lng.toLowerCase() === 'cimode') return true;
    const loadNotPending = (l, n) => {
      const loadState = this.services.backendConnector.state[`${l}|${n}`];
      return loadState === -1 || loadState === 0 || loadState === 2;
    };
    if (options.precheck) {
      const preResult = options.precheck(this, loadNotPending);
      if (preResult !== undefined) return preResult;
    }
    if (this.hasResourceBundle(lng, ns)) return true;
    if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
  }
  loadNamespaces(ns, callback) {
    const deferred = defer();
    if (!this.options.ns) {
      if (callback) callback();
      return Promise.resolve();
    }
    if (isString(ns)) ns = [ns];
    ns.forEach(n => {
      if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
    });
    this.loadResources(err => {
      deferred.resolve();
      if (callback) callback(err);
    });
    return deferred;
  }
  loadLanguages(lngs, callback) {
    const deferred = defer();
    if (isString(lngs)) lngs = [lngs];
    const preloaded = this.options.preload || [];
    const newLngs = lngs.filter(lng => preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
    if (!newLngs.length) {
      if (callback) callback();
      return Promise.resolve();
    }
    this.options.preload = preloaded.concat(newLngs);
    this.loadResources(err => {
      deferred.resolve();
      if (callback) callback(err);
    });
    return deferred;
  }
  dir(lng) {
    if (!lng) lng = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language);
    if (!lng) return 'rtl';
    try {
      const l = new Intl.Locale(lng);
      if (l && l.getTextInfo) {
        const ti = l.getTextInfo();
        if (ti && ti.direction) return ti.direction;
      }
    } catch (e) {}
    const rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam', 'ckb'];
    const languageUtils = this.services?.languageUtils || new LanguageUtil(get());
    if (lng.toLowerCase().indexOf('-latn') > 1) return 'ltr';
    return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
  }
  static createInstance(options = {}, callback) {
    const instance = new I18n(options, callback);
    instance.createInstance = I18n.createInstance;
    return instance;
  }
  cloneInstance(options = {}, callback = noop) {
    const forkResourceStore = options.forkResourceStore;
    if (forkResourceStore) delete options.forkResourceStore;
    const mergedOptions = {
      ...this.options,
      ...options,
      ...{
        isClone: true
      }
    };
    const clone = new I18n(mergedOptions);
    if (options.debug !== undefined || options.prefix !== undefined) {
      clone.logger = clone.logger.clone(options);
    }
    const membersToCopy = ['store', 'services', 'language'];
    membersToCopy.forEach(m => {
      clone[m] = this[m];
    });
    clone.services = {
      ...this.services
    };
    clone.services.utils = {
      hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
    };
    if (forkResourceStore) {
      const clonedData = Object.keys(this.store.data).reduce((prev, l) => {
        prev[l] = {
          ...this.store.data[l]
        };
        prev[l] = Object.keys(prev[l]).reduce((acc, n) => {
          acc[n] = {
            ...prev[l][n]
          };
          return acc;
        }, prev[l]);
        return prev;
      }, {});
      clone.store = new ResourceStore(clonedData, mergedOptions);
      clone.services.resourceStore = clone.store;
    }
    if (options.interpolation) {
      const defOpts = get();
      const mergedInterpolation = {
        ...defOpts.interpolation,
        ...this.options.interpolation,
        ...options.interpolation
      };
      const mergedForInterpolator = {
        ...mergedOptions,
        interpolation: mergedInterpolation
      };
      clone.services.interpolator = new Interpolator(mergedForInterpolator);
    }
    clone.translator = new Translator(clone.services, mergedOptions);
    clone.translator.on('*', (event, ...args) => {
      clone.emit(event, ...args);
    });
    clone.init(mergedOptions, callback);
    clone.translator.options = mergedOptions;
    clone.translator.backendConnector.services.utils = {
      hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
    };
    return clone;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const instance = I18n.createInstance();

instance.createInstance;
instance.dir;
instance.init;
instance.loadResources;
instance.reloadResources;
instance.use;
instance.changeLanguage;
instance.getFixedT;
instance.t;
instance.exists;
instance.setDefaultNamespace;
instance.hasLoadedNamespace;
instance.loadNamespaces;
instance.loadLanguages;

const {
  slice,
  forEach
} = [];
function defaults(obj) {
  forEach.call(slice.call(arguments, 1), source => {
    if (source) {
      for (const prop in source) {
        if (obj[prop] === undefined) obj[prop] = source[prop];
      }
    }
  });
  return obj;
}
function hasXSS(input) {
  if (typeof input !== 'string') return false;

  // Common XSS attack patterns
  const xssPatterns = [/<\s*script.*?>/i, /<\s*\/\s*script\s*>/i, /<\s*img.*?on\w+\s*=/i, /<\s*\w+\s*on\w+\s*=.*?>/i, /javascript\s*:/i, /vbscript\s*:/i, /expression\s*\(/i, /eval\s*\(/i, /alert\s*\(/i, /document\.cookie/i, /document\.write\s*\(/i, /window\.location/i, /innerHTML/i];
  return xssPatterns.some(pattern => pattern.test(input));
}

// eslint-disable-next-line no-control-regex
const fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
const serializeCookie = function (name, val) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    path: '/'
  };
  const opt = options;
  const value = encodeURIComponent(val);
  let str = `${name}=${value}`;
  if (opt.maxAge > 0) {
    const maxAge = opt.maxAge - 0;
    if (Number.isNaN(maxAge)) throw new Error('maxAge should be a Number');
    str += `; Max-Age=${Math.floor(maxAge)}`;
  }
  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }
    str += `; Domain=${opt.domain}`;
  }
  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }
    str += `; Path=${opt.path}`;
  }
  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }
    str += `; Expires=${opt.expires.toUTCString()}`;
  }
  if (opt.httpOnly) str += '; HttpOnly';
  if (opt.secure) str += '; Secure';
  if (opt.sameSite) {
    const sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }
  if (opt.partitioned) str += '; Partitioned';
  return str;
};
const cookie = {
  create(name, value, minutes, domain) {
    let cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
      path: '/',
      sameSite: 'strict'
    };
    if (minutes) {
      cookieOptions.expires = new Date();
      cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60 * 1000);
    }
    if (domain) cookieOptions.domain = domain;
    document.cookie = serializeCookie(name, value, cookieOptions);
  },
  read(name) {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },
  remove(name, domain) {
    this.create(name, '', -1, domain);
  }
};
var cookie$1 = {
  name: 'cookie',
  // Deconstruct the options object and extract the lookupCookie property
  lookup(_ref) {
    let {
      lookupCookie
    } = _ref;
    if (lookupCookie && typeof document !== 'undefined') {
      return cookie.read(lookupCookie) || undefined;
    }
    return undefined;
  },
  // Deconstruct the options object and extract the lookupCookie, cookieMinutes, cookieDomain, and cookieOptions properties
  cacheUserLanguage(lng, _ref2) {
    let {
      lookupCookie,
      cookieMinutes,
      cookieDomain,
      cookieOptions
    } = _ref2;
    if (lookupCookie && typeof document !== 'undefined') {
      cookie.create(lookupCookie, lng, cookieMinutes, cookieDomain, cookieOptions);
    }
  }
};

var querystring = {
  name: 'querystring',
  // Deconstruct the options object and extract the lookupQuerystring property
  lookup(_ref) {
    let {
      lookupQuerystring
    } = _ref;
    let found;
    if (typeof window !== 'undefined') {
      let {
        search
      } = window.location;
      if (!window.location.search && window.location.hash?.indexOf('?') > -1) {
        search = window.location.hash.substring(window.location.hash.indexOf('?'));
      }
      const query = search.substring(1);
      const params = query.split('&');
      for (let i = 0; i < params.length; i++) {
        const pos = params[i].indexOf('=');
        if (pos > 0) {
          const key = params[i].substring(0, pos);
          if (key === lookupQuerystring) {
            found = params[i].substring(pos + 1);
          }
        }
      }
    }
    return found;
  }
};

var hash = {
  name: 'hash',
  // Deconstruct the options object and extract the lookupHash property and the lookupFromHashIndex property
  lookup(_ref) {
    let {
      lookupHash,
      lookupFromHashIndex
    } = _ref;
    let found;
    if (typeof window !== 'undefined') {
      const {
        hash
      } = window.location;
      if (hash && hash.length > 2) {
        const query = hash.substring(1);
        if (lookupHash) {
          const params = query.split('&');
          for (let i = 0; i < params.length; i++) {
            const pos = params[i].indexOf('=');
            if (pos > 0) {
              const key = params[i].substring(0, pos);
              if (key === lookupHash) {
                found = params[i].substring(pos + 1);
              }
            }
          }
        }
        if (found) return found;
        if (!found && lookupFromHashIndex > -1) {
          const language = hash.match(/\/([a-zA-Z-]*)/g);
          if (!Array.isArray(language)) return undefined;
          const index = typeof lookupFromHashIndex === 'number' ? lookupFromHashIndex : 0;
          return language[index]?.replace('/', '');
        }
      }
    }
    return found;
  }
};

let hasLocalStorageSupport = null;
const localStorageAvailable = () => {
  if (hasLocalStorageSupport !== null) return hasLocalStorageSupport;
  try {
    hasLocalStorageSupport = typeof window !== 'undefined' && window.localStorage !== null;
    if (!hasLocalStorageSupport) {
      return false;
    }
    const testKey = 'i18next.translate.boo';
    window.localStorage.setItem(testKey, 'foo');
    window.localStorage.removeItem(testKey);
  } catch (e) {
    hasLocalStorageSupport = false;
  }
  return hasLocalStorageSupport;
};
var localStorage$1 = {
  name: 'localStorage',
  // Deconstruct the options object and extract the lookupLocalStorage property
  lookup(_ref) {
    let {
      lookupLocalStorage
    } = _ref;
    if (lookupLocalStorage && localStorageAvailable()) {
      return window.localStorage.getItem(lookupLocalStorage) || undefined; // Undefined ensures type consistency with the previous version of this function
    }
    return undefined;
  },
  // Deconstruct the options object and extract the lookupLocalStorage property
  cacheUserLanguage(lng, _ref2) {
    let {
      lookupLocalStorage
    } = _ref2;
    if (lookupLocalStorage && localStorageAvailable()) {
      window.localStorage.setItem(lookupLocalStorage, lng);
    }
  }
};

let hasSessionStorageSupport = null;
const sessionStorageAvailable = () => {
  if (hasSessionStorageSupport !== null) return hasSessionStorageSupport;
  try {
    hasSessionStorageSupport = typeof window !== 'undefined' && window.sessionStorage !== null;
    if (!hasSessionStorageSupport) {
      return false;
    }
    const testKey = 'i18next.translate.boo';
    window.sessionStorage.setItem(testKey, 'foo');
    window.sessionStorage.removeItem(testKey);
  } catch (e) {
    hasSessionStorageSupport = false;
  }
  return hasSessionStorageSupport;
};
var sessionStorage = {
  name: 'sessionStorage',
  lookup(_ref) {
    let {
      lookupSessionStorage
    } = _ref;
    if (lookupSessionStorage && sessionStorageAvailable()) {
      return window.sessionStorage.getItem(lookupSessionStorage) || undefined;
    }
    return undefined;
  },
  cacheUserLanguage(lng, _ref2) {
    let {
      lookupSessionStorage
    } = _ref2;
    if (lookupSessionStorage && sessionStorageAvailable()) {
      window.sessionStorage.setItem(lookupSessionStorage, lng);
    }
  }
};

var navigator$1 = {
  name: 'navigator',
  lookup(options) {
    const found = [];
    if (typeof navigator !== 'undefined') {
      const {
        languages,
        userLanguage,
        language
      } = navigator;
      if (languages) {
        // chrome only; not an array, so can't use .push.apply instead of iterating
        for (let i = 0; i < languages.length; i++) {
          found.push(languages[i]);
        }
      }
      if (userLanguage) {
        found.push(userLanguage);
      }
      if (language) {
        found.push(language);
      }
    }
    return found.length > 0 ? found : undefined;
  }
};

var htmlTag = {
  name: 'htmlTag',
  // Deconstruct the options object and extract the htmlTag property
  lookup(_ref) {
    let {
      htmlTag
    } = _ref;
    let found;
    const internalHtmlTag = htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);
    if (internalHtmlTag && typeof internalHtmlTag.getAttribute === 'function') {
      found = internalHtmlTag.getAttribute('lang');
    }
    return found;
  }
};

var path = {
  name: 'path',
  // Deconstruct the options object and extract the lookupFromPathIndex property
  lookup(_ref) {
    let {
      lookupFromPathIndex
    } = _ref;
    if (typeof window === 'undefined') return undefined;
    const language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
    if (!Array.isArray(language)) return undefined;
    const index = typeof lookupFromPathIndex === 'number' ? lookupFromPathIndex : 0;
    return language[index]?.replace('/', '');
  }
};

var subdomain = {
  name: 'subdomain',
  lookup(_ref) {
    let {
      lookupFromSubdomainIndex
    } = _ref;
    // If given get the subdomain index else 1
    const internalLookupFromSubdomainIndex = typeof lookupFromSubdomainIndex === 'number' ? lookupFromSubdomainIndex + 1 : 1;
    // get all matches if window.location. is existing
    // first item of match is the match itself and the second is the first group match which should be the first subdomain match
    // is the hostname no public domain get the or option of localhost
    const language = typeof window !== 'undefined' && window.location?.hostname?.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);

    // if there is no match (null) return undefined
    if (!language) return undefined;
    // return the given group match
    return language[internalLookupFromSubdomainIndex];
  }
};

// some environments, throws when accessing document.cookie
let canCookies = false;
try {
  // eslint-disable-next-line no-unused-expressions
  document.cookie;
  canCookies = true;
  // eslint-disable-next-line no-empty
} catch (e) {}
const order = ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag'];
if (!canCookies) order.splice(1, 1);
const getDefaults = () => ({
  order,
  lookupQuerystring: 'lng',
  lookupCookie: 'i18next',
  lookupLocalStorage: 'i18nextLng',
  lookupSessionStorage: 'i18nextLng',
  // cache user language
  caches: ['localStorage'],
  excludeCacheFor: ['cimode'],
  // cookieMinutes: 10,
  // cookieDomain: 'myDomain'

  convertDetectedLanguage: l => l
});
class Browser {
  constructor(services) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.type = 'languageDetector';
    this.detectors = {};
    this.init(services, options);
  }
  init() {
    let services = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      languageUtils: {}
    };
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    this.services = services;
    this.options = defaults(options, this.options || {}, getDefaults());
    if (typeof this.options.convertDetectedLanguage === 'string' && this.options.convertDetectedLanguage.indexOf('15897') > -1) {
      this.options.convertDetectedLanguage = l => l.replace('-', '_');
    }

    // backwards compatibility
    if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
    this.i18nOptions = i18nOptions;
    this.addDetector(cookie$1);
    this.addDetector(querystring);
    this.addDetector(localStorage$1);
    this.addDetector(sessionStorage);
    this.addDetector(navigator$1);
    this.addDetector(htmlTag);
    this.addDetector(path);
    this.addDetector(subdomain);
    this.addDetector(hash);
  }
  addDetector(detector) {
    this.detectors[detector.name] = detector;
    return this;
  }
  detect() {
    let detectionOrder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.order;
    let detected = [];
    detectionOrder.forEach(detectorName => {
      if (this.detectors[detectorName]) {
        let lookup = this.detectors[detectorName].lookup(this.options);
        if (lookup && typeof lookup === 'string') lookup = [lookup];
        if (lookup) detected = detected.concat(lookup);
      }
    });
    detected = detected.filter(d => d !== undefined && d !== null && !hasXSS(d)).map(d => this.options.convertDetectedLanguage(d));
    if (this.services && this.services.languageUtils && this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
    return detected.length > 0 ? detected[0] : null; // a little backward compatibility
  }
  cacheUserLanguage(lng) {
    let caches = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options.caches;
    if (!caches) return;
    if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
    caches.forEach(cacheName => {
      if (this.detectors[cacheName]) this.detectors[cacheName].cacheUserLanguage(lng, this.options);
    });
  }
}
Browser.type = 'languageDetector';

var hatsuly$1 = {
	nav: {
		projectList: "Projects",
		projectSettings: "Project Settings",
		login: "Log in",
		register: "Sign up"
	},
	landing: {
		headline: "From inspection to repair,\nthrough to maintenance,\nconnected by 3D:\na new shape for infrastructure management.",
		start: "Get started"
	},
	register: {
		title: "Create a free viewer account",
		description: "Enter your email address and a free account for viewing projects will be created.\nIf you need paid features such as creating projects, sign in with your viewer account and contact us from the inquiry page.",
		email: "Email address",
		name: "Name",
		company: "Company name",
		submit: "Register",
		successTitle: "Your user account was created successfully.",
		successBody: "Check your inbox for a link to set your password."
	},
	adminViewBanner: {
		viewing: "Viewing {{user}}'s dashboard (read-only)",
		back: "Back to your dashboard"
	},
	userMenu: {
		plan: "Subscription Plan",
		userList: "User List"
	},
	stats: {
		storageUsed: "Storage Used",
		projectCount: "Projects",
		projectCountUnit: "projects",
		projectBreakdown: "Created {{owned}} · Invited {{invited}}"
	},
	tabs: {
		owned: "Created",
		invited: "Invited"
	},
	projectList: {
		searchPlaceholder: "Search projects",
		empty: "No matching projects",
		viewersUnit: "",
		create: "New Project",
		toggleAreas: "Toggle inspection areas"
	},
	area: {
		searchPlaceholder: "Search areas",
		empty: "No matching areas",
		create: "New Area"
	},
	menu: {
		projectEdit: "Edit Project",
		reportDetail: "Report Details",
		manageViewers: "Manage Viewers",
		projectDelete: "Delete Project",
		areaEdit: "Edit Area",
		openViewer: "Open Inspection Viewer",
		reportExport: "Export Report",
		alignArea: "Align Area",
		areaDelete: "Delete Area"
	},
	subscription: {
		upgradeTitle: "Upgrade to create new projects",
		upgradeBody: "A paid plan unlocks every feature — creating projects, expanded storage, point-cloud processing and more.",
		viewPlans: "View Paid Plans"
	},
	toast: {
		project: {
			created: "Project created",
			updated: "Project updated",
			deleted: "Project deleted"
		},
		area: {
			created: "Area created",
			updated: "Area updated",
			deleted: "Area deleted"
		},
		viewers: {
			invited: "Viewer invited",
			removed: "Viewer removed"
		}
	},
	columns: {
		name: "Name",
		size: "Size",
		viewers: "Viewers",
		updated: "Updated",
		created: "Created"
	},
	modal: {
		project: {
			create: {
				title: "Create Project",
				nameLabel: "Project Name",
				workTypeLabel: "Work Type",
				typeLabel: "Category",
				fieldHint: "Used as the default when creating areas. Can be changed per area."
			},
			edit: {
				title: "Edit Project"
			},
			duplicateError: "A project with this name already exists, please choose a different name.",
			"delete": {
				title: "Delete Project",
				body: "Delete \"{{name}}\"? This action cannot be undone."
			}
		},
		area: {
			add: {
				title: "Add Area",
				projectLabel: "Project",
				nameLabel: "Area Name",
				dataSection: "Data",
				pointCloud: "Point Cloud",
				pointCloudFormats: ".las / .laz / .ply",
				mesh: "3D Mesh",
				meshFormats: ".zip",
				chooseFile: "Choose a file",
				orDrop: " or drop it here",
				inspectionSection: "Inspection Details",
				optional: "Optional",
				workTypeLabel: "Work Type",
				typeLabel: "Category",
				authorLabel: "Author",
				createdDateLabel: "Created Date",
				witnessLabel: "Witness",
				witnessDateLabel: "Witness Date"
			},
			edit: {
				title: "Edit Area",
				shapesExistError: "Rebars or planes have already been detected on this area. Delete them before replacing the point cloud."
			},
			"delete": {
				title: "Delete Area",
				body: "Delete \"{{name}}\"? This action cannot be undone."
			}
		},
		viewers: {
			title: "Viewers",
			emailColumn: "Email Address",
			invite: "Invite Viewer",
			inviteEmailLabel: "Email address to invite",
			emailPlaceholder: "name@example.com",
			send: "Send",
			empty: "No viewers yet"
		},
		tos: {
			agree: "Agree and Continue"
		}
	},
	footer: {
		copyright: "© 2024 DataLabs Inc.",
		manual: "User Manual",
		terms: "Terms of Service",
		contact: "Contact"
	},
	userList: {
		columns: {
			user: "User",
			hubspot: "HubSpot",
			subscriptionEnd: "Subscription End",
			billing: "Billing / Agency"
		},
		sortNext: "Click to change the order (descending, ascending, unsorted)",
		sortUnsorted: "Unsorted — click to sort by subscription end, newest first",
		searchPlaceholder: "Search by Auth0 email (app login)",
		clearSearch: "Clear search",
		editHubspotId: "Edit HubSpot ID",
		refetch: "Refresh",
		save: "Save changes",
		saved: "Changes saved",
		saveError: "Failed to save changes",
		unsaved: "Unsaved",
		undoChange: "Undo this change",
		hubspotIdPlaceholder: "HubSpot ID",
		noHubspotId: "No ID",
		noHubspotEmail: "No email linked",
		noInfo: "No info",
		legacyPlan: "Legacy plan: {{plan}}",
		prevPage: "Previous",
		nextPage: "Next",
		empty: "No matching users"
	}
};
var maintenance$1 = {
	heading: "Under Maintenance",
	body: "The system is currently undergoing maintenance and is temporarily unavailable. We apologize for the inconvenience—please wait until it is complete.",
	about: "About 3D InfraLoop"
};
var nav$1 = {
	hierarchy: "Contractee → Route → Facility → Timeline",
	administrators: "Administrators",
	routes: "Routes"
};
var dashboard$1 = {
	_single: "Dashboard",
	title: "Infrastructure Dashboard",
	subtitle: "Overview of All Facilities and Inspection Events",
	sections: {
		recentEvents: "Recent Events",
		attentionRequired: "Facilities Requiring Attention",
		allFacilities: "All Facilities"
	},
	returnToDashboard: "Return to Dashboard",
	attentionRequired: {
		emptyState: "There are currently no facilities requiring attention."
	},
	allFacilities: {
		emptyState: "No facilities found."
	},
	recentEvents: {
		emptyState: "No events found."
	}
};
var userAccount$1 = {
	account: {
		title: "Account"
	},
	inspectionSheet: {
		title: "Inspection Sheet Settings"
	},
	editor: {
		title: "3D View Settings"
	},
	plan: {
		title: "Billing Information"
	},
	comingSoon: {
		title: "Coming soon",
		description: "{{label}} will be available soon."
	},
	backToDashboard: "Back to Dashboard"
};
var object$1 = {
	facility: {
		_single: "Facility",
		list: "Facility List",
		add: "Add Facility",
		name: "Facility Name",
		id: "Facility ID",
		year: "Completion Year",
		kilopostStart: "Kilopost Start",
		kilopostEnd: "Kilopost End",
		type: {
			_single: "Facility Type",
			tunnel: "Tunnel",
			bridge: "Bridge",
			culvert: "Culvert",
			shed: "Shed",
			overpass: "Overpass",
			other: "Other"
		},
		latitude: "Latitude",
		longitude: "Longitude",
		coordinates: "Coordinates",
		prefectureCode: "Prefecture Code",
		municipalityCode: "Municipality Code",
		address: "Address",
		coordinateSystem: "Coordinate System",
		totalLength: "Total Length",
		groundwaterCondition: "Groundwater Condition",
		landslideArea: "Landslide Area",
		expansiveGround: "Expansive Ground",
		harmfulWater: "Harmful Groundwater",
		snowArea: "Snow Area",
		saltDamageArea: "Salt Damage Area",
		width: "Width",
		height: "Height",
		totalSpanCount: "Total Spans",
		liningType: "Lining Type",
		lanes: "Lanes",
		constructionMethod: "Construction Method",
		structureType: "Structure Type"
	},
	facilities: "Facilities",
	span: {
		_single: "Span",
		add: "Add Span",
		length: "Length",
		notes: "Notes",
		inspectionDate: "Inspection Date",
		judgmentBasis: "Judgment Basis",
		assessmentNotes: "Assessment Notes"
	},
	event: {
		_single: "Event",
		_plural: "Events",
		count_one: "{{count}} event",
		count_other: "{{count}} events",
		add: "Add Event",
		name: "Event Name",
		year: "Year",
		period: "Period",
		contractor: "Contractor",
		fiscalYear: "Fiscal Year",
		inspectionPeriod: "Inspection Period",
		contractorName: "Contractor Name",
		contractorCode: "Contractor Code",
		inspectionMethod: "Inspection Method",
		inspectionEquipment: "Inspection Equipment",
		weatherSummary: "Weather Summary",
		inspectionTeam: "Inspection Team",
		previousSoundness: "Previous Soundness",
		soundnessRatingBasis: "Soundness Rating Basis",
		team: {
			role: "Role",
			name: "Name",
			qualification: "Qualification",
			qualificationId: "Qualification ID"
		}
	},
	eventType: {
		_single: "Event Type",
		periodic: "Periodic Inspection",
		emergency: "Emergency Inspection",
		followUp: "Follow Up Inspection",
		repair: "Repair Construction"
	},
	inspectionStatus: {
		_single: "Inspection Status",
		draft: "Draft",
		inProgress: "In Progress",
		completed: "Completed",
		submitted: "Submitted"
	},
	defectRecord: {
		_single: "Defect Record",
		add: "Add Defect Record",
		name: "Defect Record Name",
		elementNumber: "Element Number"
	},
	defectPhotos: {
		memo: "Memo"
	},
	construction: {
		type: "Construction Type",
		creator: "Creator",
		created_date: "Created Date",
		observer: "Observer",
		observed_date: "Observed Date"
	},
	inspectionItems: {
		_single: "Inspection Items",
		list: "Inspection Items"
	},
	inspectionArea: {
		_single: "Inspection Area",
		_plural: "Inspection Areas",
		name: "Area Name"
	},
	electronicDelivery: {
		_single: "Electronic Delivery"
	},
	deliverables: {
		_single: "Deliverable",
		_plural: "Deliverables"
	},
	approval: {
		_single: "Approval",
		pending: "Pending",
		approved: "Approved",
		rejected: "Rejected",
		submitted: "Submitted",
		registered: "Registered",
		draft: "Draft",
		revisionRequested: "Revision Requested"
	},
	files: {
		_plural: "Files",
		noPCD: "Missing PCD",
		status: {
			running: "Processing",
			succeeded: "Processed",
			failed: "Error"
		}
	},
	componentType: {
		_single: "Component Type",
		tunnel: {
			crown: "Crown/Arch",
			sidewall: "Sidewall",
			invert: "Invert",
			portal: "Portal",
			ceiling: "Ceiling Board",
			attachments: "Attachments"
		},
		bridge: {
			mainGirder: "Main Girder",
			crossBeam: "Cross Beam",
			stringer: "Stringer",
			deckSlab: "Deck Slab",
			superstructureOther: "Other Superstructure",
			pier: "Pier",
			abutment: "Abutment",
			foundation: "Foundation",
			substructureOther: "Other Substructure",
			bearing: "Bearing",
			connectionOther: "Other Connection",
			expansionJoint: "Expansion Joint",
			failSafe: "Unseating Prevention",
			curb: "Curb",
			guardrail: "Railing / Guardrail",
			drainage: "Drainage Facility",
			pavement: "Road Surface / Pavement",
			staircase: "Staircase",
			signBoard: "Sign Board",
			lighting: "Lighting Facility",
			inspectionGallery: "Inspection Gallery"
		}
	},
	defectType: {
		_single: "Defect Type",
		tunnel: {
			crack: "Crack",
			delamination: "Delamination",
			spalling: "Spalling",
			falloff: "Falloff",
			deformation: "Deformation",
			waterLeakage: "Water Leakage",
			materialDeterioration: "Material Deterioration",
			rebarExposure: "Rebar Exposure",
			cavityVoid: "Cavity/Void",
			efflorescence: "Efflorescence",
			freeLime: "Free Lime",
			rustStaining: "Rust Staining",
			honeycombing: "Honeycombing"
		},
		bridge: {
			corrosionSteel: "Steel Corrosion",
			crackSteel: "Steel Crack",
			boltLooseningFalloff: "Bolt Loosening / Falloff",
			ruptureSteel: "Steel Rupture",
			anticorrosionDeterioration: "Anticorrosion Deterioration",
			crackConcrete: "Concrete Crack",
			spallingRebarExposure: "Spalling / Rebar Exposure",
			leakageEfflorescence: "Leakage / Efflorescence",
			punchingFailure: "Punching Failure",
			reinforcementDamage: "Reinforcement Damage",
			crackDeckSlab: "Deck Slab Crack",
			delamination: "Delamination",
			jointAbnormality: "Joint Abnormality",
			roadSurfaceUnevenness: "Road Surface Unevenness",
			pavementAnomaly: "Pavement Anomaly",
			bearingDysfunction: "Bearing Dysfunction",
			other: "Other",
			anchorageAbnormality: "Anchorage Abnormality",
			materialDeterioration: "Material Deterioration",
			waterLeakagePuddling: "Water Leakage / Puddling",
			abnormalSoundVibration: "Abnormal Sound / Vibration",
			abnormalDeflection: "Abnormal Deflection",
			deformationDefect: "Deformation / Defect",
			sedimentClogging: "Sediment Clogging",
			settlementTilt: "Settlement / Tilt",
			scour: "Scour",
			none: "No Damage"
		}
	},
	assessment: {
		_single: "Assessment",
		_plural: "Assessments"
	},
	severity: {
		_single: "Severity",
		a: "No Defects",
		b: "Minor Defects",
		c: "Caution",
		d: "Emergency",
		e: "Not Inspectable",
		grade: "Severity Grade",
		descriptions: {
			a: "No Defects",
			b: "Defects are present but do not require immediate repair. Monitoring is required.",
			c: "Deterioration has progressed; countermeasures should be planned to prevent functional impairment.",
			d: "Severe defects threatening structural safety or third-party safety.",
			e: "Not Inspectable"
		}
	},
	severityChange: {
		_single: "Severity Change",
		worsened: "Worsened",
		improved: "Improved",
		unchanged: "Unchanged"
	},
	progression: {
		_single: "Progression",
		progressive: "Progressive",
		stable: "Stable",
		unknown: "Unknown"
	},
	countermeasure: {
		_single: "Countermeasure",
		A0: "No Action Required",
		A: "Monitoring Only",
		B: "Planned Maintenance",
		C: "Repair Required (Planned)",
		E1: "Emergency Repair Required",
		E2: "Emergency Measures Required",
		M: "Detailed Investigation Required (Monitoring)",
		S1: "Detailed Investigation Required",
		S2: "Cause Investigation Required",
		description: {
			A0: "Defect is negligible; no action or monitoring required.",
			A: "Monitor during subsequent inspection cycles.",
			B: "Implement planned maintenance while monitoring.",
			C: "Plan repairs before the next inspection.",
			E1: "Structural integrity may be compromised. Emergency repair required.",
			E2: "Immediate traffic restrictions or temporary support work required.",
			M: "Condition unclear. Monitor carefully and plan detailed investigation.",
			S1: "Additional investigation required, such as core sampling or load testing.",
			S2: "Cause analysis required before determining countermeasures."
		}
	},
	cause: {
		_single: "Cause",
		_plural: "Causes",
		aging_deterioration: "Aging Deterioration",
		drying_shrinkage: "Drying Shrinkage",
		thermal_stress: "Thermal Stress",
		structural_stress: "Structural Stress",
		ground_movement: "Ground Movement",
		freeze_thaw: "Freeze-Thaw",
		water_infiltration: "Water Infiltration",
		groundwater_pressure: "Groundwater Pressure",
		chloride_attack: "Chloride Attack",
		carbonation: "Carbonation",
		alkali_silica_reaction: "Alkali-Silica Reaction",
		impact_damage: "Impact Damage",
		fire_damage: "Fire Damage",
		construction_defect: "Construction Defect",
		insufficient_backfill: "Insufficient Backfill",
		joint_degradation: "Joint Degradation",
		water_erosion: "Water Erosion",
		seismic_damage: "Seismic Damage"
	},
	measurements: {
		length: "Length",
		width: "Width",
		depth: "Depth",
		area: "Area",
		volume: "Volume",
		pattern: "Pattern",
		displacement: "Displacement",
		direction: "Direction",
		level: "Level",
		flow_state: "Flow State",
		corrosion_grade: "Corrosion Grade",
		diameter: "Diameter",
		corrosion_area: "Corrosion Area",
		thickness_reduction: "Thickness Reduction",
		crack_length: "Crack Length",
		bolt_count: "Bolt Count",
		deteriorated_area: "Deteriorated Area",
		crack_width: "Crack Width",
		efflorescence_seepage: "Efflorescence / Seepage",
		exposure_area: "Exposure Area",
		section_loss: "Section Loss",
		leakage_state: "Leakage State",
		hole_area: "Hole Area",
		material_type: "Material Type",
		crack_pattern: "Crack Pattern",
		delamination_area: "Delamination Area",
		gap_width: "Gap Width",
		level_difference: "Level Difference",
		anomaly_type: "Anomaly Type",
		dysfunction_state: "Dysfunction State",
		description: "Description",
		damage_state: "Damage State",
		scour_depth: "Scour Depth"
	},
	soundnessRating: {
		_single: "Soundness Rating",
		I: "Sound",
		II: "Preventive Maintenance",
		III: "Early Measure",
		IV: "Emergency Measure",
		descriptions: {
			I: "No significant defects observed. Regular monitoring is recommended.",
			II: "Minor defects present. Preventive maintenance measures are required.",
			III: "Function is possibly impaired; measures are required before the next inspection.",
			IV: "Function is impaired or failure is imminent; immediate closure or repair is required."
		}
	}
};
var modal$1 = {
	facility: {
		namePlaceholder: "Enter facility name",
		typePlaceholder: "Select type...",
		idPlaceholder: "e.g., 38.45123,140.89456",
		add: {
			title: "New Facility",
			submit: "Create Facility",
			successMessage: "Facility created successfully!"
		},
		edit: {
			title: "Edit Facility",
			successMessage: "Successfully updated facility information.",
			basicInfo: "Basic Information",
			location: "Location Information",
			specifications: "Specifications",
			groundConditions: "Ground Conditions"
		},
		"delete": {
			confirmationTitle: "Delete Facility",
			confirmationMessage: "Are you sure you want to delete this facility? This action cannot be undone.",
			successMessage: "Successfully deleted facility."
		}
	},
	span: {
		nameLabel: "Span Name",
		namePlaceholder: "Enter span name",
		lengthPlaceholder: "Enter span length",
		notesPlaceholder: "Enter any additional notes",
		add: {
			title: "Add Span",
			submit: "Add Span",
			successMessage: "Span added successfully!",
			tabs: {
				createNew: "Create New",
				selectExisting: "Select Existing"
			},
			selectExistingDescription: "Import spans from this facility that haven't been added to this inspection yet.",
			noExisting: "All facility spans have already been added to this inspection.",
			importSuccessMessage: "Span(s) imported successfully!"
		},
		edit: {
			title: "Edit Span",
			submit: "Update Span",
			successMessage: "Span updated successfully!"
		},
		"delete": {
			confirmationTitle: "Delete Span",
			confirmationMessage: "Are you sure you want to delete this span? This action cannot be undone.",
			successMessage: "Span deleted successfully!"
		}
	},
	damagePhoto: {
		upload: {
			successMessage: "Photos uploaded successfully"
		},
		updateMemoSuccessMessage: "Memo updated successfully",
		deleteSuccessMessage: "Photo deleted successfully"
	},
	defectRecord: {
		namePlaceholder: "e.g. Member A-1",
		elementNumberPlaceholder: "e.g. Element 001",
		componentTypePlaceholder: "Select component type...",
		defectTypePlaceholder: "Select defect type...",
		add: {
			title: "Add Defect Record",
			selectExistingDescription: "Select from existing defect records...",
			noExisting: "No existing defect records found from previous inspection events for this span.",
			missingInspectionDate: "Missing inspection date",
			successMessage: "Defect record added successfully!",
			tabs: {
				createNew: "Create New",
				selectExisting: "Select Existing"
			}
		},
		edit: {
			title: "Edit Defect Record",
			warningMessage: "Changes to defect record information will affect this defect record across all inspection events",
			successMessage: "Defect record updated successfully!"
		}
	},
	event: {
		add: {
			title: "New Event",
			selectZipFile: "Select Electronic Delivery ZIP File",
			namePlaceholder: "Enter event name",
			eventTypePlaceholder: "Select type",
			contractorPlaceholder: "Enter contractor name",
			periodPlaceholder: "e.g. 2026/01/01 - 2026/03/31",
			electronicDeliveryHelperText: "Import deliverable folder structure from electronic delivery ZIP archive",
			successMessage: "Successfully created event."
		},
		edit: {
			title: "Edit Inspection Event",
			successMessage: "Successfully updated event information.",
			basicInfo: "Basic Information",
			year: "Year",
			contractorInfo: "Contractor Information",
			inspectionDetails: "Inspection Details",
			equipmentPlaceholder: "Enter equipment name",
			addItem: "Add Item",
			weatherSummaryPlaceholder: "e.g., Clear to cloudy, no rain during inspection period",
			addMember: "Add Member",
			team: {
				rolePlaceholder: "Enter role",
				namePlaceholder: "Enter name",
				qualificationPlaceholder: "Enter qualification",
				qualificationIdPlaceholder: "Enter qualification ID"
			},
			soundnessAssessment: "Soundness Assessment",
			soundnessRatingBasisPlaceholder: "Enter the basis for soundness rating determination..."
		},
		"delete": {
			confirmationTitle: "Delete Event",
			confirmationMessage: "Are you sure you want to delete this event? This action cannot be undone.",
			successMessage: "Successfully deleted event."
		}
	},
	inspectionArea: {
		add: {
			title: "Add Inspection Area",
			spanLabel: "Span",
			spanPlaceholder: "Select span...",
			areaNamePlaceholder: "Enter area name",
			areaNameDuplicateError: "An area with this name already exists, please choose a different name.",
			pcdFileLabel: "Point Cloud Data",
			pcdFileHelperText: "Select file (.las, .laz, .ply)",
			pcdFilePlaceholder: "Select PCD file...",
			meshFileLabel: "3D Mesh Data",
			meshFileHelperText: "Select file (.zip)",
			meshFilePlaceholder: "Select 3D mesh file...",
			successMessage: "Inspection area created successfully"
		},
		"delete": {
			confirmationTitle: "Delete Inspection Area",
			confirmationMessage: "Are you sure you want to delete this inspection area? This action cannot be undone.",
			successMessage: "Inspection area deleted successfully"
		}
	},
	spanAssessment: {
		create: {
			successMessage: "Span assessment created successfully!"
		},
		edit: {
			successMessage: "Span assessment updated successfully!"
		}
	},
	comment: {
		create: {
			successMessage: "Comment added successfully!"
		}
	},
	diagram: {
		upload: {
			successMessage: "Diagram uploaded successfully"
		}
	},
	diagramMarker: {
		unlink: {
			confirmationTitle: "Unlink defect record",
			confirmationMessage: "Are you sure you want to unlink this defect record? The defect record itself will not be deleted."
		}
	}
};
var section$1 = {
	overview: {
		title: "Overview",
		soundness: {
			title: "Overall Soundness Rating",
			subtitle: "Per MLIT inspection standards",
			current: "Current",
			previous: "Previous",
			worsened: "Worsened",
			improved: "Improved",
			stable: "Stable",
			judgmentBasis: "Judgment Basis"
		},
		defectBreakdown: {
			title: "Defect Breakdown",
			subtitle: "By severity grade",
			total: "Total"
		},
		actions: {
			title: "Action Required",
			itemCount_one: "{{count}} item",
			itemCount_other: "{{count}} items",
			critical: "Critical",
			criticalDesc: "Severity d or Soundness IV",
			worsened: "Worsened",
			worsenedDesc: "Severity increased since last inspection",
			viewMoreCritical: "View {{count}} more critical defects",
			viewMoreWorsened: "View {{count}} more worsened defects",
			position: "Position {{position}}"
		},
		context: {
			title: "Inspection Context",
			facilitySpecs: "Facility Specifications",
			spec: {
				type: "Type",
				length: "Length",
				method: "Method",
				built: "Built",
				lanes: "Lanes",
				spans: "Spans"
			},
			inspectionInfo: "Inspection Information",
			info: {
				period: "Period",
				method: "Method",
				equipment: "Equipment",
				contractor: "Contractor",
				team: "Team"
			},
			location: "Location",
			locationValue: "宮城県仙台市青葉区",
			mapPlaceholder: "Map (Leaflet integration pending)"
		},
		approval: {
			title: "Approval Status",
			pending: "{{count}} pending",
			actionRequired: "Action required",
			deliverablePackage: "2025 Deliverable Package",
			viewAll: "View All"
		}
	},
	inspectionItem: {
		title: "Defect Records",
		searchPlaceholder: "Search spans...",
		filters: {
			properties: "Properties"
		},
		elementAlreadyLinked: "This element is already linked to another defect record.",
		linkExistingConfirm: {
			title: "Replace existing linked/modelled inspection item?",
			description: "The selected inspection item has already been linked to another defect record ({{otherDamageName}}). \n\n Do you want to replace it with the current one ({{damageName}})?"
		},
		unlinkConfirm: {
			title: "Unlink inspection item?",
			description: "Are you sure you want to unlink the inspection item from defect record ({{damageName}})? This action cannot be undone."
		},
		emptyState: {
			title: "Start Inspection",
			description: "Add spans and record defects to begin documenting this inspection event",
			action: "Create Span",
			hint: "Create your first span to get started",
			noData: "No defect records available.",
			notFound: "No spans match your search"
		},
		detail: {
			viewHistory: "View History",
			historyUnavailable: "History is available once this defect appears in more than one inspection.",
			activity: "Activity",
			activities: "Activities",
			noActivities: "No activities yet",
			personInCharge: "Person in Charge",
			personInChargeLongDescription: "Person in Charge\n\nThe inspector or engineer responsible for this specific defect finding. In the MLIT periodic inspection workflow:\n\n• The field inspector records initial findings and severity grades.\n• A qualified bridge/tunnel inspection engineer reviews and may adjust ratings.\n• The person in charge is recorded in the inspection ledger for traceability and accountability.\n\nMLIT requires that inspection team members hold appropriate qualifications (e.g. Road Maintenance Specialist, PE qualification) and their names/license numbers are recorded in the inspection report.",
			progressionLongDescription: "Progression Assessment\n\nEvaluates whether the defect has worsened over time compared to previous inspection records. MLIT guidelines require progression assessment for all existing defects:\n\n• Progressive — Clear deterioration since the last inspection (e.g., crack width expansion, increased leakage, larger delamination area).\n• Stable — Defect exists but shows no significant change from the previous inspection cycle.\n• Unknown — No previous inspection data available for comparison, or the location was previously uninspectable.\n\nProgression is assessed after severity grading and serves as a key factor in determining individual soundness ratings. Even with the same severity grade, progressive defects may receive a higher soundness rating than stable defects.",
			soundnessRatingLongDescription: "Individual Soundness Rating (I–IV) — MLIT National Standard\n\nA technical assessment of structural safety that comprehensively considers severity grade (a–e), progression, defect location, and member importance. Each defect is individually rated (I–IV), and the most severe rating is reflected at the member and facility level:\n\n• I — Sound: No defects or minor defects that do not affect structural safety.\n• II — Preventive Maintenance: Defects present but no functional impairment. Preventive maintenance is recommended.\n• III — Early Measure: Significant defects. Measures are required before the next inspection.\n• IV — Emergency Measure: Critical defects threatening structural safety or third-party safety. Immediate action required.\n\nIf even one defect is rated III or IV, the entire span or facility is elevated to that rating. This assessment forms the basis for the countermeasure category below.",
			countermeasureLongDescription: "Countermeasure Category — MLIT Bridge/Tunnel Inspection Guidelines\n\nBased on the soundness assessment and progression judgment above, determines the measures to be implemented. The inspector or engineer makes the final determination:\n\n• A0 — No Action Required: Defect is negligible.\n• A — Monitoring Only: Monitor in subsequent inspection cycles.\n• B — Planned Maintenance: Plan regular preventive maintenance.\n• C — Repair Required (Planned): Plan repairs before the next inspection.\n• E1 — Emergency Repair Required: Structural integrity may be compromised.\n• E2 — Emergency Measures Required: Immediate traffic restrictions or temporary support work needed.\n• M — Detailed Investigation Required (Monitoring): Condition unclear; monitor carefully.\n• S1 — Detailed Investigation Required: Additional investigations such as core sampling or load testing needed.\n• S2 — Cause Investigation Required: Root cause analysis needed before determining countermeasures.\n\nThe system automatically suggests a countermeasure category based on severity grade and defect type, but inspectors may modify it based on field judgment.",
			emergencyMeasuresLongDescription: "Emergency Measures Record — MLIT Inspection Guidelines\n\nRecording is required when countermeasure category is E1 or E2. Based on \"Bridge Periodic Inspection Guidelines\" (H31/2019):\n\n・Implementation Date — Date when emergency measures were implemented.\n・Measure Content — Details of measures: traffic restrictions, temporary supports, protective barriers, speed limits, surveillance cameras, etc.\n・Implementer — Organization or person responsible for implementing the measures.\n・Permanent Measure Plan — Permanent repair plan: timing, scope, construction method.\n・Traffic Restrictions — Current ongoing traffic/passage restrictions.\n・Notification Destination — Parties notified: road manager, police, local government, etc.\n\nE1 (structural safety) requires structural measures. E2 (third-party damage) requires traffic restriction measures. Both require immediate recording and notification to road managers.",
			measureImplementationDate: "Implementation Date",
			measureContent: "Measure Content",
			measureContentPlaceholder: "e.g., Speed limit 40km/h, surveillance camera installation",
			implementer: "Implementer",
			implementerPlaceholder: "e.g., NEXCO East Japan",
			permanentMeasurePlan: "Permanent Measure Plan",
			permanentMeasurePlanPlaceholder: "e.g., Weekly monitoring, repair work within 3 months",
			trafficRestrictions: "Traffic Restrictions",
			trafficRestrictionsPlaceholder: "e.g., Heavy vehicle traffic restrictions",
			notificationDestination: "Notification Destination",
			notificationDestinationPlaceholder: "e.g., Police, local government",
			previousInspection: "Previous Inspection",
			previousSeverity: "Previous Severity",
			severityLongDescription: "Severity Grade (a–e) — MLIT Periodic Inspection Guidelines\n\nUsed to evaluate individual defects on the Field Investigation Form (Format 2) during periodic inspections. Each defect is assigned one of the following grades:\n\n• a — No Defects: No defects, or minor defects that do not affect durability or function.\n• b — Minor Defects: Defects present but do not require immediate repair. Monitoring is required.\n• c — Caution: Deterioration has progressed; countermeasures are needed to prevent functional impairment.\n• d — Emergency: Severe defects threatening structural safety or third-party safety.\n• e — Not Inspectable: Condition is not visible (debris, vegetation, etc.), or represents the worst-case state in specific defect definitions (rupture, detachment, etc.).\n\nThis assessment represents field-level \"input data.\" Together with progression assessment, it forms the basis for individual soundness ratings (I–IV) and countermeasure categories.",
			crackPattern: {
				_single: "Crack Pattern",
				longitudinal: "Longitudinal"
			},
			updated: "Updated",
			dimensions: "Dimensions",
			dimensionsLongDescription: "Defect Dimensions\n\nQuantitative measurements of defects recorded during field inspection:\n\n• Length (mm) — Dimension in the longest direction of the defect. For cracks, measured along the crack path.\n• Width (mm) — Maximum dimension perpendicular to length. For cracks, this is the crack opening width (a critical determinant for severity grading).\n• Depth (mm) — How far the defect penetrates into the concrete. Relevant for delamination, voids, and spalling.\n• Area (m²) — Total affected surface area. Relevant for delamination, leakage extent, and spalling.\n\nThese measurements are essential for severity grade (a–e) determination, tracking progression across inspection cycles, and calculating repair quantities for countermeasure planning.",
			causesLongDescription: "Defect Causes — MLIT Tunnel Defect Classification\n\nRoot cause analysis based on MLIT's tunnel defect cause categories. Multiple causes may be identified for a single defect:\n\n• Aging Deterioration — Natural degradation over time due to environmental exposure.\n• Drying Shrinkage — Early-stage cracking due to volume reduction during concrete curing.\n• Thermal Stress — Expansion/contraction cracking from temperature cycles.\n• Structural Stress — Structural cracking from overloading or design inadequacy.\n• Ground Movement — Ground settlement, heave, or lateral displacement.\n• Freeze-Thaw — Water expansion during freeze cycles causing surface scaling and popouts.\n• Water Infiltration — Water ingress through cracks or waterproofing failures.\n• Groundwater Pressure — Hydrostatic pressure from elevated groundwater levels.\n• Chloride Attack — Rebar corrosion from chloride ingress (coastal/de-icing salt environments).\n• Carbonation — CO₂ penetration reducing concrete alkalinity, promoting rebar corrosion.\n• Alkali-Silica Reaction — Chemical reaction between cement alkalis and reactive aggregates (ASR).\n• Impact Damage — Physical damage from vehicle strikes or falling debris.\n• Fire Damage — Thermal effects from tunnel fires.\n• Construction Defect — Original construction quality issues (poor compaction, cold joints, etc.).\n• Insufficient Backfill — Inadequate grouting behind the lining.\n• Joint Degradation — Deterioration of construction or expansion joints.\n• Water Erosion — Soil washout behind the lining from flowing groundwater.\n• Seismic Damage — Cracking or displacement from earthquakes.\n\nAccurate cause identification is essential for selecting effective countermeasures. Treating only symptoms without addressing root causes leads to defect recurrence.",
			causesEmptyValuePlaceholder: "No causes identified",
			notes: "Notes",
			notesPlaceholder: "Enter any additional notes about this defect record...",
			notesEmptyValuePlaceholder: "No notes, edit assessment to add notes...",
			commentPlaceholder: "Add a comment...",
			tabs: {
				photos: "Photos",
				diagram: "Diagram",
				blueprint: "Blueprint",
				"3d": "3D",
				map: "Map"
			},
			defectSummary: "Defect Summary",
			judgmentBasisPlaceholder: "Enter judgment basis for soundness rating...",
			judgmentBasisEmptyValuePlaceholder: "No judgment basis, edit assessment to add...",
			assessmentNotesPlaceholder: "Enter any additional notes about this assessment...",
			assessmentNotesEmptyValuePlaceholder: "No assessment notes, edit assessment to add notes...",
			inspectionArea: {
				emptyMessage: "No inspection areas uploaded yet.",
				uploadButton: "Upload inspection area"
			}
		},
		activities: {
			showMore: "Show {{count}} more",
			showLess: "Show less",
			comment: {
				namePlaceholder: "Your name",
				create: {
					successMessage: "Comment added successfully!"
				},
				update: {
					successMessage: "Comment updated successfully"
				},
				"delete": {
					successMessage: "Comment deleted successfully",
					confirmationTitle: "Delete Comment",
					confirmationMessage: "Are you sure you want to delete this comment? This action cannot be undone."
				}
			}
		},
		imageAlt: {
			modeled: "Modeled Defect",
			naked: "Naked Defect",
			mesh: "3D Mesh"
		},
		photos: {
			noPhotosAvailable: "No photos available"
		},
		"3d": {
			noDiagramsAvailable: "No diagrams available",
			noDiagramsAvailableForDamage: "No diagrams available for this defect record. \n Please upload a diagram through the Span.",
			goToSpan: "Go to Span",
			addMarker: {
				title: "Link to Defect Record",
				noDamages: "No defect records found for this span."
			}
		},
		filterActive: {
			tooltipSpan: "The list is being filtered at the moment. Remove filters to enable re-ordering of spans.",
			tooltipRecord: "The list is being filtered at the moment. Remove filters to enable re-ordering of defect records."
		}
	},
	inspectionItems: {
		"2d": {
			tools: {
				selector: "Select",
				linkToDefectRecord: "Link to Defect Record"
			}
		}
	},
	deliverables: {
		viewReports: "View Reports",
		damagePhotos: {
			focusModeTooltip: "View details in Inspection Items tab",
			noPhotosAvailable: "There are no photos available for this span.",
			lightbox: {
				title: "Photo Details",
				loadingError: "Failed to load photo details. Please try again.",
				previousPhoto: "Previous photo",
				nextPhoto: "Next photo"
			}
		},
		defectPhotos: {
			title: "Defect Photos",
			photoNo: "Photo No.",
			dateTaken: "Date Taken",
			memberName: "Member Name",
			elementNo: "Element No.",
			metadataEmbedded: "Metadata Embedded",
			loadingPhotos: "Loading photos… ({{count}})",
			loadingMorePhotos: "Loading more photos… ({{count}} so far)",
			loadingAllPhotos: "Loading all photos for export…",
			preparingExport: "Preparing photos for export…"
		},
		projectInfo: {
			title: "Project Info"
		}
	},
	files: {
		title: "3D Point Cloud Scan Data",
		searchPlaceholder: "Search files...",
		columns: {
			fileName: "File Name",
			scanDate: "Scan Date",
			uploadedDate: "Uploaded Date",
			fileSize: "File Size",
			pointCount: "Point Count",
			status: "Status"
		},
		add: "Add file",
		emptyState: {
			notFound: "No files match your search"
		}
	},
	facilitySummary: {
		specifications: {
			title: "Specifications"
		},
		location: {
			title: "Location"
		},
		summary: {
			totalEvents: "Total Events"
		},
		eventStats: "Event Statistics",
		eventTimeline: {
			title: "Event Timeline",
			latest: "Latest"
		}
	}
};
var property$1 = {
	id: "ID",
	kilopost: "Kilopost",
	length: "Length",
	period: "Period",
	contractor: "Contractor"
};
var phase$1 = {
	inspection: "Inspection",
	deliverables: "Deliverables",
	approval: "Approval"
};
var status$1 = {
	completed: "Completed",
	done: "Done",
	inprogress: "In Progress",
	review: "Review",
	todo: "To Do",
	archived: "Archived",
	notstarted: "Not Started",
	processed: "Processed",
	processing: "Processing",
	uploaded: "Uploaded"
};
var severity$1 = {
	previousSeverity: "Previous Severity"
};
var approval$1 = {
	pendingReview: "Pending Review",
	packageTitle: "{{year}} {{type}}",
	files: "files",
	submitter: "Submitted by",
	errors: "{{count}} errors",
	warnings: "{{count}} warnings",
	type: {
		deliverablePackage: "Deliverable Package"
	}
};
var ui$1 = {
	expand: "Expand",
	collapse: "Collapse",
	loading: "Loading...",
	uploading: "Uploading...{{progress}}%",
	close: "Close",
	cancel: "Cancel",
	confirm: "Confirm",
	attention: "Attention",
	accept: "OK",
	error: "Error",
	edit: "Edit",
	add: "Add",
	exit: "Exit",
	save: "Save",
	saving: "Saving...",
	sending: "Sending...",
	create: "Create",
	creating: "Creating...",
	"delete": "Delete",
	deleting: "Deleting...",
	unlink: "Unlink",
	unlinking: "Unlinking...",
	"export": "Export",
	pdfExport: "Export as PDF",
	moreDetails: "More details",
	viewMoreDetails: "View more details",
	moreActions: "More actions",
	expandAll: "Expand all",
	collapseAll: "Collapse all",
	readMore: "read more",
	sendComment: "Send",
	selectAll: "Select All",
	deselectAll: "Deselect All",
	clearAllFilters: "Clear All",
	itemsSelected_one: "{{count}} selected",
	itemsSelected_other: "{{count}} selected",
	filters: "Filters",
	language: "Language",
	accountSettings: "Account Settings",
	logout: "Log out",
	noPermission: "You do not have permission to perform this action",
	none: "None",
	focusMode: "Focus Mode",
	exitFocusMode: "Exit Focus Mode",
	dontRemindAgain: "Don't remind again",
	menu: "Menu",
	open: "Open",
	viewDetails: "View details",
	zoomIn: "Zoom in",
	zoomOut: "Zoom out",
	zoomReset: "Reset zoom",
	openInEditor: "Open in Editor"
};
var user$1 = {
	subscription: {
		expiredAlert: {
			title: "No active subscription",
			description: "You are not able to access certain features because your subscription is inactive. To access all features, please upgrade your subscription. If you have any questions, contact support."
		},
		expiringWarning: {
			title: "Subscription expiring",
			description: "Your subscription is about to end and your construction data will be deleted. Renewal is required to keep your data. Please contact support or your account representative."
		}
	}
};
var errors$1 = {
	common: "An error occurred. Please try again.",
	auth0: {
		invalidToken: "Invalid authentication token. Please log in again."
	},
	aws: {
		uploadFailed: "Failed to upload file. Please check your connection and try again.",
		uploadAborted: "File upload was aborted. Please try again.",
		downloadFailed: "Failed to download file. Please check your connection and try again."
	},
	user: {
		notFound: "User not found. Please log in again.",
		fetch: "Failed to load user data. Please refresh the page and try again.",
		register: "Account registration failed. Please check your details and try again."
	},
	facility: {
		fetch: "Failed to load facilities. Please refresh the page and try again.",
		create: "Failed to create facility. Please check your input and try again.",
		"create.40301": "You do not have permission to create a facility. Please contact our support.",
		update: "Failed to update facility. Please check your input and try again.",
		"update.40301": "You do not have permission to update a facility. Please contact our support.",
		"delete": "Failed to delete facility. Please try again.",
		"delete.40301": "You do not have permission to delete a facility. Please contact our support."
	},
	span: {
		fetch: "Failed to load spans. Please refresh the page and try again.",
		create: "Failed to create span. Please check your input and try again.",
		"create.40301": "You do not have permission to create a span. Please contact our support.",
		update: "Failed to update span. Please check your input and try again.",
		"update.40301": "You do not have permission to update a span. Please contact our support.",
		"delete": "Failed to delete span. Please try again.",
		"delete.40301": "You do not have permission to delete a span. Please contact our support."
	},
	event: {
		fetch: "Failed to load events. Please refresh the page and try again.",
		create: "Failed to create event. Please check your input and try again.",
		"create.40301": "You do not have permission to create an event. Please contact our support.",
		"create.40010": "An event with the same name already exists. Please choose a different name.",
		update: "Failed to update event. Please check your input and try again.",
		"update.40301": "You do not have permission to update an event. Please contact our support.",
		"delete": "Failed to delete event. Please try again.",
		"delete.40301": "You do not have permission to delete an event. Please contact our support."
	},
	project: {
		fetch: "Failed to load projects. Please refresh the page and try again.",
		create: "Failed to create project. Please check your input and try again.",
		"create.40301": "You do not have permission to create a project. Please contact our support.",
		update: "Failed to update project. Please check your input and try again.",
		"update.40301": "You do not have permission to update a project. Please contact our support.",
		"delete": "Failed to delete project. Please try again.",
		"delete.40301": "You do not have permission to delete a project. Please contact our support.",
		inviteUser: "Failed to invite user to project. Please check the email address and try again.",
		"inviteUser.40301": "You do not have permission to invite users to this project. Please contact our support.",
		"inviteUser.40402": "The invited viewer does not have an account yet. Please invite them to create an account first.",
		removeUser: "Failed to remove user from project. Please try again.",
		"removeUser.40301": "You do not have permission to remove users from this project. Please contact our support."
	},
	damagePhoto: {
		fetch: "Failed to load damage photos. Please refresh the page and try again.",
		uploadUrl: "Failed to get upload URLs. Please try again.",
		"uploadUrl.40301": "You do not have permission to upload photos. Please contact our support.",
		upload: "Failed to upload photos. Please try again.",
		"upload.40301": "You do not have permission to upload photos. Please contact our support.",
		create: "Failed to create photo records. Please try again.",
		"create.40301": "You do not have permission to create photo records. Please contact our support.",
		update: "Failed to update photo. Please try again.",
		"update.40301": "You do not have permission to update a photo. Please contact our support.",
		"delete": "Failed to delete photo. Please try again.",
		"delete.40301": "You do not have permission to delete a photo. Please contact our support."
	},
	damage: {
		fetch: "Failed to load defect records. Please refresh the page and try again.",
		create: "Failed to create defect record. Please check your input and try again.",
		"create.40301": "You do not have permission to create a defect record. Please contact our support.",
		update: "Failed to update defect record. Please check your input and try again.",
		"update.40301": "You do not have permission to update a defect record. Please contact our support."
	},
	damageAssessment: {
		fetch: "Failed to load damage assessment. Please refresh the page and try again.",
		create: "Failed to create damage assessment. Please check your input and try again.",
		"create.40301": "You do not have permission to create a damage assessment. Please contact our support.",
		update: "Failed to update damage assessment. Please check your input and try again.",
		"update.40301": "You do not have permission to update a damage assessment. Please contact our support."
	},
	spanAssessment: {
		fetch: "Failed to load span assessment. Please refresh the page and try again.",
		create: "Failed to create span assessment. Please check your input and try again.",
		"create.40301": "You do not have permission to create a span assessment. Please contact our support.",
		update: "Failed to update span assessment. Please check your input and try again.",
		"update.40301": "You do not have permission to update a span assessment. Please contact our support.",
		"delete": "Failed to delete span assessment. Please try again.",
		"delete.40301": "You do not have permission to delete a span assessment. Please contact our support."
	},
	assessmentComment: {
		fetch: "Failed to load comments. Please refresh the page and try again.",
		create: "Failed to add comment. Please try again.",
		"create.40301": "You do not have permission to add comments. Please contact our support.",
		update: "Failed to update comment. Please try again.",
		"update.40301": "You do not have permission to update comments. Please contact our support.",
		"delete": "Failed to delete comment. Please try again.",
		"delete.40301": "You do not have permission to delete comments. Please contact our support."
	},
	inspectionArea: {
		fetch: "Failed to load inspection areas. Please refresh the page and try again.",
		create: "Failed to create inspection area. Please check your input and try again.",
		"create.40301": "You do not have permission to create an inspection area. Please contact our support.",
		"create.40011": "An inspection area with the same name already exists. Please use a different name.",
		update: "Failed to update inspection area. Please check your input and try again.",
		"update.40301": "You do not have permission to update an inspection area. Please contact our support.",
		"delete": "Failed to delete inspection area. Please try again.",
		"delete.40301": "You do not have permission to delete an inspection area. Please contact our support."
	},
	jobs: {
		get: "Failed to load background jobs. Please refresh the page and try again.",
		ack: "Failed to acknowledge the job. Please try again."
	},
	maskingRegion: {
		create: "Failed to save the mask region. Please try again.",
		fetch: "Failed to load mask regions. Please refresh the page and try again.",
		"delete": "Failed to delete the mask region. Please try again.",
		"delete.40301": "You do not have permission to delete mask regions. Please contact support."
	},
	serviceStatus: {
		fetch: "Failed to load service status. Please refresh the page and try again."
	},
	tutorialVideoConfig: {
		fetch: "Failed to load tutorial video configuration. Please refresh the page and try again."
	},
	featureFlags: {
		fetch: "Failed to load feature flags. Please refresh the page and try again."
	},
	validation: {
		fieldRequired: "This field is required",
		emergencyMeasuresRequired: "Please fill in all required emergency measures fields"
	},
	diagramDrawing: {
		fetch: "Failed to load diagrams. Please refresh the page and try again.",
		upload: "Failed to upload diagram. Please check your file and try again.",
		"upload.40301": "You do not have permission to upload diagrams. Please contact support.",
		update: "Failed to update diagram. Please check your input and try again.",
		"update.40301": "You do not have permission to update this diagram. Please contact support.",
		"delete": "Failed to delete diagram. Please try again.",
		"delete.40301": "You do not have permission to delete this diagram. Please contact support."
	}
};
var inspectionItem$1 = {
	elementList: {
		title: "Element List",
		noData: "No elements available."
	}
};
var notFound$1 = {
	heading: "The page you are looking for was not found",
	body: "The page you tried to access may have been moved or deleted. \nPlease check the URL and try again from the home page.",
	home: "Return to Home"
};
var errorPage$1 = {
	heading: "An unexpected error occurred",
	body: "Something went wrong on our end and we could not complete your request. Please try reloading the page or come back in a moment. If the problem persists, contact support with the reference number below.",
	referenceNumber: "Reference Number",
	reload: "Reload",
	home: "Return to Home"
};
var enTranslation = {
	hatsuly: hatsuly$1,
	maintenance: maintenance$1,
	nav: nav$1,
	dashboard: dashboard$1,
	userAccount: userAccount$1,
	object: object$1,
	modal: modal$1,
	section: section$1,
	property: property$1,
	phase: phase$1,
	status: status$1,
	severity: severity$1,
	approval: approval$1,
	ui: ui$1,
	user: user$1,
	errors: errors$1,
	inspectionItem: inspectionItem$1,
	"3d": {
	buttons: {
		save: "Save",
		saveAndExit: "Save and finish",
		reset: "Reset all",
		cancel: "Cancel",
		undo: "Undo last point",
		complete: "Complete drawing"
	},
	unsavedGuard: {
		title: "Unsaved work",
		body: "This will discard your unsaved work. Continue?",
		confirm: "Discard and continue"
	},
	linking: {
		linkOrModel: "Link or model inspection items to the selected defect record."
	},
	settings: {
		title: "Settings",
		display: "Display",
		visibility: "Show / hide",
		pointCloud: {
			title: "Point cloud",
			pointSize: "Point size",
			opacity: "Opacity",
			backgroundColor: "Background",
			labelSize: "Label size"
		},
		mesh: {
			title: "3D mesh",
			opacity: "Opacity",
			unavailable: "None of the shown areas has a finished 3D mesh"
		},
		maskRegions: {
			title: "Mask regions",
			showAllPoints: "Show all points",
			region: "Mask region {{index}}",
			empty: "No mask regions",
			deleteConfirmTitle: "Mask region",
			deleteConfirmMessage: "Once deleted, a mask region cannot be restored."
		},
		openDrawer: "3D display settings",
		saveSuccess: "3D display settings saved"
	},
	cameraProfile: {
		saveSuccess: "Camera profile saved",
		saveError: "Failed to save camera profile",
		specifyFront: "Next step",
		enable: "Set front view",
		disable: "Exit front view setup",
		view: {
			front: "Move camera to front (-y) view",
			back: "Move camera to back (+y) view",
			left: "Move camera to left (-x) view",
			right: "Move camera to right (+x) view",
			top: "Move camera to top (+z) view",
			bottom: "Move camera to bottom (-z) view"
		},
		backToFront: "Back to front editing"
	},
	editorTools: {
		move: "Move / Select"
	},
	link: {
		saveLink: "Save link",
		cancelAndExit: "Cancel and exit"
	},
	planeDetection: {
		tool: "Plane Detection — trace a surface to measure its area",
		detectAndLink: "Detect and Link",
		closeTooltip: "Complete this plane",
		startedTitle: "Plane detection started",
		startedBody: "Plane detection is in progress. You can keep using other tools while it runs; we'll notify you when it's done.",
		saveSuccess: "Plane detection completed",
		savedItem: "Saved \"{{itemName}}\"",
		savedAndLinked: "Saved \"{{itemName}}\" and linked it to defect record \"{{damageName}}\"",
		saveError: "Plane detection failed",
		autoLinkNote: "This plane will be auto-linked to Defect Record \"{{damageName}}\"",
		alreadyLinkedWarning: "Defect Record \"{{damageName}}\" already links another item. Saving will overwrite it.",
		detectionInProgress: "Plane detection is in progress for this defect record. Please wait for it to finish.",
		gate: {
			noRecord: "No defect record selected to link to",
			noPermission: "You don't have permission to detect / link areas",
			inProgress: "Plane detection is in progress for this defect record",
			notReady: "The scan isn't ready for detection yet"
		}
	},
	focus: {
		tool: "Focus — click a point to re-centre the camera",
		item: "Focus on item"
	},
	itemCameraProfile: {
		edit: "Set item camera profile",
		disable: "Exit item camera profile setup"
	},
	polyline: {
		tool: "Line",
		save: "Save",
		closeTooltip: "Click here to finish the line",
		saveSuccess: "Line saved",
		savedItem: "Saved \"{{itemName}}\"",
		savedAndLinked: "Saved \"{{itemName}}\" and linked it to defect record \"{{damageName}}\"",
		saveError: "Failed to save the line",
		autoLinkNote: "This length will be auto-linked to defect record \"{{damageName}}\"",
		alreadyLinkedWarning: "Defect record \"{{damageName}}\" already links another item. Saving will overwrite it.",
		width: "Width",
		widthPanelTitle: "Line settings",
		labelSection: "Label display (editing)",
		labelPrimary: "Total length",
		labelEdge: "Each segment",
		vertex: {
			add: "Add vertex",
			move: "Move vertex",
			remove: "Remove vertex",
			removeSplit: "Remove vertex / cut edge",
			connect: "Connect vertices (merge two lines)"
		},
		gate: {
			noRecord: "No defect record selected to link to",
			noPermission: "You don't have permission to save / link lengths",
			notReady: "The scan isn't ready to save yet"
		}
	},
	customMeasurement: {
		tool: "Distance — measure between two points",
		saveError: "Failed to save the distance",
		notReady: "The scan isn't ready to save yet",
		deleteError: "Failed to delete the distance",
		deleteConfirmTitle: "Delete this distance?",
		deleteConfirmMessage: "Deleting it permanently removes this measurement."
	},
	mask: {
		tool: "Mask — set the mask regions",
		saveSuccess: "Saved the mask region",
		transform: {
			translate: "Move",
			scale: "Size",
			rotate: "Rotate"
		}
	},
	elementList: {
		groups: {
			add: "Add an inspection group",
			namePlaceholder: "Group name",
			nameRequired: "Enter a group name",
			nameTaken: "That group name is already in use",
			deleteConfirmTitle: "Delete the inspection group",
			deleteConfirmMessage: "Only the group is deleted. The elements in it move back to unlabeled elements."
		},
		coloringDialog: {
			title: "Change how elements are colored",
			body1: "With the current automatic coloring setting, adding an inspection group switches coloring from the element's type color to its inspection group's color.",
			body2: "In inspection group color mode, elements are colored by their group, or with the unlabeled color when they belong to none.",
			body3: "Switch automatically, or keep coloring by element type? You can change this setting at any time from the display settings.",
			body4: "The inspection group is added either way — only the coloring behaviour differs.",
			keepElementColoring: "Keep element type colors",
			useGroupColoring: "Switch to inspection group colors"
		}
	}
},
	notFound: notFound$1,
	errorPage: errorPage$1
};

var hatsuly = {
	nav: {
		projectList: "工事一覧",
		projectSettings: "工事設定",
		login: "ログイン",
		register: "新規登録"
	},
	landing: {
		headline: "点検から、補修、\n維持管理まで、\n3Dが繋ぐ、\nインフラ管理の新しい形。",
		start: "はじめる"
	},
	register: {
		title: "新規閲覧用アカウント登録",
		description: "ここにメールアドレスを入力していただくと、工事閲覧用の無償アカウントが新規作成されます。\n工事作成などの有償機能をご利用のお客様は閲覧用アカウントでログイン後、問い合わせページよりお問い合わせください。",
		email: "メールアドレス",
		name: "氏名",
		company: "会社名",
		submit: "登録",
		successTitle: "ユーザーアカウント登録に成功しました。",
		successBody: "メールの受信箱を確認し、パスワードを設定するためのリンクを取得してください。"
	},
	adminViewBanner: {
		viewing: "{{user}} のダッシュボードを閲覧中（読み取り専用）",
		back: "自分のダッシュボードに戻る"
	},
	userMenu: {
		plan: "利用プラン",
		userList: "ユーザー一覧"
	},
	stats: {
		storageUsed: "ストレージ使用量",
		projectCount: "工事数",
		projectCountUnit: "件",
		projectBreakdown: "作成 {{owned}} ・ 招待 {{invited}}"
	},
	tabs: {
		owned: "作成した工事",
		invited: "招待された工事"
	},
	projectList: {
		searchPlaceholder: "工事を検索",
		empty: "該当する工事がありません",
		viewersUnit: "名",
		create: "新規工事作成",
		toggleAreas: "検査エリアの表示切り替え"
	},
	area: {
		searchPlaceholder: "エリアを検索",
		empty: "該当するエリアがありません",
		create: "新規エリア作成"
	},
	menu: {
		projectEdit: "工事編集",
		reportDetail: "帳票詳細",
		manageViewers: "閲覧ユーザー管理",
		projectDelete: "工事削除",
		areaEdit: "エリア編集",
		openViewer: "検査ビューアを開く",
		reportExport: "帳票出力",
		alignArea: "位置合わせ",
		areaDelete: "エリア削除"
	},
	subscription: {
		upgradeTitle: "新しい工事を作成するにはアップグレードが必要です",
		upgradeBody: "有償プランで工事の作成・ストレージ拡張・点群処理などすべての機能をご利用いただけます。",
		viewPlans: "有償プランを見る"
	},
	toast: {
		project: {
			created: "工事を作成しました",
			updated: "工事を変更しました",
			deleted: "工事を削除しました"
		},
		area: {
			created: "エリアを作成しました",
			updated: "エリアを変更しました",
			deleted: "エリアを削除しました"
		},
		viewers: {
			invited: "閲覧ユーザーを招待しました",
			removed: "閲覧ユーザーを削除しました"
		}
	},
	columns: {
		name: "名称",
		size: "サイズ",
		viewers: "閲覧ユーザー",
		updated: "更新日",
		created: "作成日"
	},
	modal: {
		project: {
			create: {
				title: "工事を作成",
				nameLabel: "工事名",
				workTypeLabel: "工種名",
				typeLabel: "種別",
				fieldHint: "エリア作成時の初期値として使用されます。エリア毎に変更可能です。"
			},
			edit: {
				title: "工事を編集"
			},
			duplicateError: "同じ工事名が既に存在します。別の名前を選択してください。",
			"delete": {
				title: "工事を削除",
				body: "「{{name}}」を削除しますか？この操作は取り消せません。"
			}
		},
		area: {
			add: {
				title: "エリアを追加",
				projectLabel: "工事",
				nameLabel: "エリア名",
				dataSection: "データ",
				pointCloud: "点群データ",
				pointCloudFormats: ".las / .laz / .ply",
				mesh: "3Dメッシュデータ",
				meshFormats: ".zip",
				chooseFile: "ファイルを選択",
				orDrop: " またはドロップ",
				inspectionSection: "検査情報",
				optional: "任意",
				workTypeLabel: "工種名",
				typeLabel: "種別",
				authorLabel: "作成者",
				createdDateLabel: "作成日",
				witnessLabel: "立会者",
				witnessDateLabel: "立会日"
			},
			edit: {
				title: "エリアを編集",
				shapesExistError: "既に検出された鉄筋または平面があります。まず削除してください。"
			},
			"delete": {
				title: "エリアを削除",
				body: "「{{name}}」を削除しますか？この操作は取り消せません。"
			}
		},
		viewers: {
			title: "閲覧ユーザー一覧",
			emailColumn: "メールアドレス",
			invite: "閲覧ユーザーを招待",
			inviteEmailLabel: "招待するメールアドレス",
			emailPlaceholder: "name@example.com",
			send: "送信",
			empty: "閲覧ユーザーがいません"
		},
		tos: {
			agree: "同意して続ける"
		}
	},
	footer: {
		copyright: "© 2024 DataLabs株式会社",
		manual: "ユーザーマニュアル",
		terms: "利用規約",
		contact: "お問い合わせ"
	},
	userList: {
		columns: {
			user: "ユーザー",
			hubspot: "HubSpot 連携",
			subscriptionEnd: "サブスク終了日",
			billing: "請求 / 代理店"
		},
		sortNext: "クリックで並び順を切り替え（降順 → 昇順 → 並び替えなし）",
		sortUnsorted: "並び替えなし（クリックでサブスク終了日の降順）",
		searchPlaceholder: "Auth0 Email (アプリログイン用) で検索",
		clearSearch: "検索をクリア",
		editHubspotId: "HubSpot ID を編集",
		refetch: "再取得",
		save: "変更を保存",
		saved: "変更を保存しました",
		saveError: "変更の保存に失敗しました",
		unsaved: "未保存",
		undoChange: "この変更を取り消す",
		hubspotIdPlaceholder: "HubSpot ID",
		noHubspotId: "ID 未設定",
		noHubspotEmail: "メール未連携",
		noInfo: "情報なし",
		legacyPlan: "旧プラン: {{plan}}",
		prevPage: "前へ",
		nextPage: "次へ",
		empty: "該当するユーザーがいません"
	}
};
var maintenance = {
	heading: "ただいまメンテナンス中です",
	body: "システムのメンテナンスを実施しているため、現在ご利用いただけません。ご不便をおかけしますが、完了までしばらくお待ちください。",
	about: "3D InfraLoopについて"
};
var nav = {
	hierarchy: "発注者 → 路線 → 施設 → イベント",
	administrators: "発注者",
	routes: "路線"
};
var dashboard = {
	_single: "ダッシュボード",
	title: "インフラダッシュボード",
	subtitle: "全施設・点検イベントの概要",
	sections: {
		recentEvents: "最近のイベント",
		attentionRequired: "対応が必要な施設",
		allFacilities: "すべての施設"
	},
	returnToDashboard: "ダッシュボードに戻る",
	attentionRequired: {
		emptyState: "現在、対応が必要な施設はありません。"
	},
	allFacilities: {
		emptyState: "施設はありません。"
	},
	recentEvents: {
		emptyState: "イベントはありません。"
	}
};
var userAccount = {
	account: {
		title: "アカウント"
	},
	inspectionSheet: {
		title: "帳票詳細"
	},
	editor: {
		title: "3D画面設定"
	},
	plan: {
		title: "請求情報"
	},
	comingSoon: {
		title: "準備中",
		description: "「{{label}}」の設定は近日公開予定です。"
	},
	backToDashboard: "ダッシュボードに戻る"
};
var object = {
	facility: {
		_single: "施設",
		list: "施設一覧",
		add: "施設を追加",
		name: "施設名",
		id: "施設ID",
		year: "竣工年",
		kilopostStart: "起点キロポスト",
		kilopostEnd: "終点キロポスト",
		type: {
			_single: "施設種別",
			tunnel: "トンネル",
			bridge: "橋梁",
			culvert: "カルバート",
			shed: "シェッド",
			overpass: "高架橋",
			other: "その他"
		},
		latitude: "緯度",
		longitude: "経度",
		coordinates: "座標",
		prefectureCode: "都道府県コード",
		municipalityCode: "市区町村コード",
		address: "住所",
		coordinateSystem: "座標系",
		totalLength: "延長 (m)",
		groundwaterCondition: "湧水状況",
		landslideArea: "地すべり地域",
		expansiveGround: "膨張性地盤",
		harmfulWater: "有害な地下水",
		snowArea: "積雪地域",
		saltDamageArea: "塩害地域",
		width: "幅員",
		height: "高さ",
		totalSpanCount: "総径間数",
		liningType: "覆工形式",
		lanes: "車線数",
		constructionMethod: "施工方法",
		structureType: "構造形式"
	},
	facilities: "施設",
	span: {
		_single: "径間",
		add: "径間を追加",
		length: "長さ",
		notes: "メモ",
		inspectionDate: "点検日",
		judgmentBasis: "判定根拠",
		assessmentNotes: "評価メモ"
	},
	event: {
		_single: "イベント",
		_plural: "イベント",
		count_one: "{{count}}件のイベント",
		count_other: "{{count}}件のイベント",
		add: "イベントを追加",
		name: "イベント名",
		year: "年度",
		period: "工期",
		contractor: "施工者",
		fiscalYear: "会計年度",
		inspectionPeriod: "点検期間",
		contractorName: "受注者名",
		contractorCode: "受注者コード",
		inspectionMethod: "点検方法",
		inspectionEquipment: "点検機材",
		weatherSummary: "天候概要",
		inspectionTeam: "点検チーム",
		previousSoundness: "前回健全度",
		soundnessRatingBasis: "健全度評価根拠",
		team: {
			role: "役職",
			name: "氏名",
			qualification: "資格",
			qualificationId: "資格ID"
		}
	},
	eventType: {
		_single: "イベント種別",
		periodic: "定期点検",
		emergency: "緊急点検",
		follow_up: "追跡点検",
		repair: "補修工事"
	},
	inspectionStatus: {
		_single: "点検ステータス",
		draft: "下書き",
		inProgress: "進行中",
		completed: "完了",
		submitted: "提出済み"
	},
	defectRecord: {
		_single: "変状記録",
		add: "変状記録を追加",
		name: "変状記録名",
		elementNumber: "要素番号"
	},
	defectPhotos: {
		memo: "メモ"
	},
	construction: {
		type: "工種名",
		creator: "作成者",
		created_date: "作成日",
		observer: "立会者",
		observed_date: "立会日"
	},
	inspectionItems: {
		_single: "点検項目",
		list: "変状一覧"
	},
	inspectionArea: {
		_single: "検査エリア",
		_plural: "検査エリア",
		name: "エリア名"
	},
	electronicDelivery: {
		_single: "電子納品"
	},
	deliverables: {
		_single: "成果品",
		_plural: "成果品"
	},
	approval: {
		_single: "承認",
		pending: "確認待ち",
		approved: "承認済み",
		rejected: "却下",
		submitted: "提出済み",
		registered: "登録済み",
		draft: "下書き",
		revisionRequested: "修正依頼"
	},
	files: {
		_single: "ファイル",
		noPCD: "点群なし",
		status: {
			running: "変換中",
			succeeded: "変換完了",
			failed: "エラー"
		}
	},
	componentType: {
		_single: "部材種類",
		tunnel: {
			crown: "アーチ部",
			sidewall: "側壁部",
			invert: "インバート",
			portal: "坑門部",
			ceiling: "天井板",
			attachments: "付属物"
		},
		bridge: {
			mainGirder: "主桁",
			crossBeam: "横桁",
			stringer: "縦桁",
			deckSlab: "床版",
			superstructureOther: "その他（上部構造）",
			pier: "橋脚",
			abutment: "橋台",
			foundation: "基礎",
			substructureOther: "その他（下部構造）",
			bearing: "支承部",
			connectionOther: "その他（上下部接続部）",
			expansionJoint: "伸縮装置",
			failSafe: "落橋防止構造",
			curb: "地覆",
			guardrail: "高欄・防護柵",
			drainage: "排水装置",
			pavement: "路面・舗装",
			staircase: "階段部",
			signBoard: "標識板",
			lighting: "照明施設",
			inspectionGallery: "検査路"
		}
	},
	assessment: {
		_single: "評価",
		_plural: "評価"
	},
	defectType: {
		_single: "変状種類",
		tunnel: {
			crack: "ひび割れ",
			delamination: "うき",
			spalling: "はく離",
			falloff: "はく落",
			deformation: "変形",
			waterLeakage: "漏水",
			materialDeterioration: "材質劣化",
			rebarExposure: "鉄筋露出",
			cavityVoid: "空洞",
			efflorescence: "エフロレッセンス",
			freeLime: "遊離石灰",
			rustStaining: "さび汁",
			honeycombing: "豆板"
		},
		bridge: {
			corrosionSteel: "腐食",
			crackSteel: "亀裂",
			boltLooseningFalloff: "ゆるみ・脱落",
			ruptureSteel: "破断",
			anticorrosionDeterioration: "防食機能の劣化",
			crackConcrete: "ひびわれ",
			spallingRebarExposure: "剥離・鉄筋露出",
			leakageEfflorescence: "漏水・遊離石灰",
			punchingFailure: "抜け落ち",
			reinforcementDamage: "補修・補強材の損傷",
			crackDeckSlab: "床版ひびわれ",
			delamination: "うき",
			jointAbnormality: "遊間の異常",
			roadSurfaceUnevenness: "路面の凹凸",
			pavementAnomaly: "舗装の異常",
			bearingDysfunction: "支承部の機能障害",
			other: "その他",
			anchorageAbnormality: "定着部の異常",
			materialDeterioration: "変色・劣化",
			waterLeakagePuddling: "漏水・滞水",
			abnormalSoundVibration: "異常な音・振動",
			abnormalDeflection: "異常なたわみ",
			deformationDefect: "変形・欠損",
			sedimentClogging: "土砂詰まり",
			settlementTilt: "沈下・移動・傾斜",
			scour: "洗掘",
			none: "損傷なし"
		}
	},
	severity: {
		_single: "変状程度",
		a: "損傷なし",
		b: "軽微",
		c: "要注意",
		d: "危険",
		e: "調査不能",
		grade: "変状程度",
		descriptions: {
			a: "損傷なし",
			b: "欠損はあるが、直ちに補修を要しない。経過観察が必要。",
			c: "劣化が進行しており、機能障害を防ぐための対策が必要。",
			d: "構造安全性または第三者への危険を脅かす重大な損傷。",
			e: "調査不能"
		}
	},
	severityChange: {
		_single: "変状程度の変化",
		worsened: "悪化",
		improved: "改善",
		unchanged: "変化なし"
	},
	progression: {
		_single: "進行状況",
		progressive: "進行性",
		stable: "横ばい",
		unknown: "不明"
	},
	countermeasure: {
		_single: "措置区分",
		A0: "措置不要",
		A: "監視のみ",
		B: "計画的補修",
		C: "補修要（計画的）",
		E1: "緊急補修要",
		E2: "緊急措置要",
		M: "詳細調査要（監視）",
		S1: "詳細調査要",
		S2: "原因調査要",
		description: {
			A0: "損傷は無視できるレベルで、措置・監視不要。",
			A: "次回以降の点検サイクルで経過観察。",
			B: "経過観察しながら計画的な維持管理を実施。",
			C: "次回点検までに補修を計画。",
			E1: "構造の健全性が損なわれている可能性。緊急補修が必要。",
			E2: "即座の交通規制や仮設支保工が必要。",
			M: "状態が不明確。注意深く監視し、詳細調査を計画。",
			S1: "コア採取、載荷試験等の追加調査が必要。",
			S2: "対策決定前に原因分析が必要。"
		}
	},
	measurements: {
		length: "長さ",
		width: "幅",
		depth: "深さ",
		area: "面積",
		volume: "体積",
		pattern: "パターン",
		displacement: "変位量",
		direction: "方向",
		level: "レベル",
		flow_state: "流出状態",
		corrosion_grade: "腐食度",
		diameter: "直径",
		corrosion_area: "腐食面積",
		thickness_reduction: "板厚減少",
		crack_length: "き裂長",
		bolt_count: "本数",
		deteriorated_area: "劣化面積",
		crack_width: "ひびわれ幅",
		efflorescence_seepage: "遊離石灰・漏水",
		exposure_area: "露出範囲",
		section_loss: "断面欠損",
		leakage_state: "漏水状態",
		hole_area: "抜け落ち面積",
		material_type: "補強材種別",
		crack_pattern: "ひびわれ形態",
		delamination_area: "うき面積",
		gap_width: "遊間",
		level_difference: "段差",
		anomaly_type: "異常種別",
		dysfunction_state: "機能障害",
		description: "説明",
		damage_state: "損傷状態",
		scour_depth: "洗掘深さ"
	},
	soundnessRating: {
		_single: "健全度",
		I: "健全",
		II: "予防保全段階",
		III: "早期措置段階",
		IV: "緊急措置段階",
		descriptions: {
			I: "重大な損傷は認められず、健全な状態。定期的な経過観察が推奨されます。",
			II: "軽微な損傷あり。予防保全措置が必要。",
			III: "機能に支障が生じる可能性があり、次回点検までに措置が必要。",
			IV: "機能に支障が生じている、または生じる可能性が著しく高く、緊急に措置を講ずべき。"
		}
	}
};
var modal = {
	facility: {
		namePlaceholder: "施設名を入力",
		typePlaceholder: "種別を選択...",
		idPlaceholder: "例: 38.45123,140.89456",
		add: {
			title: "新規施設",
			submit: "施設を作成",
			successMessage: "施設が正常に作成されました。"
		},
		edit: {
			title: "施設情報編集",
			successMessage: "施設が正常に更新されました。",
			basicInfo: "基本情報",
			location: "位置情報",
			specifications: "仕様",
			groundConditions: "地盤条件"
		},
		"delete": {
			confirmationTitle: "施設を削除",
			confirmationMessage: "この施設を削除してもよろしいですか？この操作は元に戻せません。",
			successMessage: "施設が正常に削除されました。"
		}
	},
	span: {
		nameLabel: "径間名",
		namePlaceholder: "径間名を入力",
		lengthPlaceholder: "径間長さを入力",
		notesPlaceholder: "追加情報を入力",
		add: {
			title: "径間を追加",
			submit: "径間を追加",
			successMessage: "径間が正常に追加されました。",
			tabs: {
				createNew: "新規作成",
				selectExisting: "既存を選択"
			},
			selectExistingDescription: "この点検にまだ追加されていない施設の径間をインポートします。",
			noExisting: "施設のすべての径間は既にこの点検に追加されています。",
			importSuccessMessage: "径間が正常にインポートされました。"
		},
		edit: {
			title: "径間編集",
			submit: "径間を更新",
			successMessage: "径間が正常に更新されました。"
		},
		"delete": {
			confirmationTitle: "径間を削除",
			confirmationMessage: "この径間を削除してもよろしいですか？この操作は元に戻せません。",
			successMessage: "径間が正常に削除されました。"
		}
	},
	damagePhoto: {
		upload: {
			successMessage: "写真をアップロードしました"
		},
		updateMemoSuccessMessage: "メモを更新しました",
		deleteSuccessMessage: "写真を削除しました"
	},
	defectRecord: {
		namePlaceholder: "例: 部材A-1",
		elementNumberPlaceholder: "例: 要素001",
		componentTypePlaceholder: "部材種類を選択",
		defectTypePlaceholder: "変状種類を選択",
		add: {
			title: "変状記録を追加",
			selectExistingDescription: "既存の変状記録から選択...",
			noExisting: "この径間の過去の点検イベントに既存の変状記録がありません。",
			missingInspectionDate: "点検日未記録",
			successMessage: "変状記録が正常に追加されました!",
			tabs: {
				createNew: "新規作成",
				selectExisting: "既存を選択"
			}
		},
		edit: {
			title: "変状記録を編集",
			warningMessage: "変状記録の変更は、すべての点検イベントでこの変状記録に影響します",
			successMessage: "変状記録が正常に更新されました!"
		}
	},
	event: {
		add: {
			title: "新規イベント",
			selectZipFile: "電子納品ZIPファイルを選択",
			namePlaceholder: "イベント名を入力",
			eventTypePlaceholder: "種別を選択",
			contractorPlaceholder: "施工者名を入力",
			periodPlaceholder: "例: 2026/01/01 - 2026/03/31",
			electronicDeliveryHelperText: "電子納品ZIPアーカイブから成果品フォルダ構成を取り込みます",
			successMessage: "イベントが正常に作成されました。"
		},
		edit: {
			title: "点検イベント編集",
			successMessage: "イベントが正常に更新されました。",
			basicInfo: "基本情報",
			year: "年度",
			contractorInfo: "受注者情報",
			inspectionDetails: "点検詳細",
			equipmentPlaceholder: "機材名を入力",
			addItem: "項目を追加",
			weatherSummaryPlaceholder: "例: 晴れ～曇り（点検期間中降雨なし）",
			addMember: "メンバーを追加",
			team: {
				rolePlaceholder: "役職を入力",
				namePlaceholder: "氏名を入力",
				qualificationPlaceholder: "資格を入力",
				qualificationIdPlaceholder: "資格IDを入力"
			},
			soundnessAssessment: "健全度評価",
			soundnessRatingBasisPlaceholder: "健全度判定の根拠を入力..."
		},
		"delete": {
			confirmationTitle: "イベントを削除",
			confirmationMessage: "このイベントを削除してもよろしいですか？この操作は元に戻せません。",
			successMessage: "イベントが正常に削除されました。"
		}
	},
	inspectionArea: {
		add: {
			title: "検査エリアを追加",
			spanLabel: "径間",
			spanPlaceholder: "径間を選択...",
			areaNamePlaceholder: "エリア名を入力",
			areaNameDuplicateError: "同じエリア名が既に存在します。別の名前を選択してください。",
			pcdFileLabel: "点群データ",
			pcdFileHelperText: "ファイル選択 (.las, .laz, .ply)",
			pcdFilePlaceholder: "PCDファイルを選択...",
			meshFileLabel: "3Dメッシュデータ",
			meshFileHelperText: "ファイル選択 (.zip)",
			meshFilePlaceholder: "3Dメッシュファイルを選択...",
			successMessage: "エリアを作成しました"
		},
		"delete": {
			confirmationTitle: "点検エリアを削除",
			confirmationMessage: "この点検エリアを削除してもよろしいですか?この操作は元に戻せません。",
			successMessage: "エリアを削除しました"
		}
	},
	spanAssessment: {
		create: {
			successMessage: "径間評価が正常に作成されました!"
		},
		edit: {
			successMessage: "径間評価が正常に更新されました!"
		}
	},
	comment: {
		create: {
			successMessage: "コメントが追加されました!"
		}
	},
	diagram: {
		upload: {
			successMessage: "図面をアップロードしました"
		}
	},
	diagramMarker: {
		unlink: {
			confirmationTitle: "損傷記録のリンクを解除",
			confirmationMessage: "この損傷記録のリンクを解除してもよろしいですか？損傷記録自体は削除されません。"
		}
	}
};
var section = {
	overview: {
		title: "概要",
		soundness: {
			title: "総合健全度",
			subtitle: "国土交通省点検基準",
			current: "現在",
			previous: "前回",
			worsened: "悪化",
			improved: "改善",
			stable: "横ばい",
			judgmentBasis: "判定根拠"
		},
		defectBreakdown: {
			title: "変状程度別件数",
			subtitle: "程度別内訳",
			total: "合計"
		},
		actions: {
			title: "対応が必要な項目",
			itemCount: "{{count}}件",
			critical: "緊急",
			criticalDesc: "変状程度dまたは健全度IV",
			worsened: "悪化",
			worsenedDesc: "前回点検から変状程度が悪化",
			viewMoreCritical: "さらに{{count}}件の緊急変状を表示",
			viewMoreWorsened: "さらに{{count}}件の悪化変状を表示",
			position: "位置{{position}}"
		},
		context: {
			title: "点検概要",
			facilitySpecs: "施設諸元",
			spec: {
				type: "種別",
				length: "延長",
				method: "工法",
				built: "竣工",
				lanes: "車線",
				spans: "径間数"
			},
			inspectionInfo: "点検情報",
			info: {
				period: "点検期間",
				method: "点検方法",
				equipment: "使用機材",
				contractor: "点検業者",
				team: "点検担当者"
			},
			location: "位置情報",
			locationValue: "宮城県仙台市青葉区",
			mapPlaceholder: "地図（Leaflet統合待ち）"
		},
		approval: {
			title: "承認状況",
			pending: "{{count}}件未処理",
			actionRequired: "対応が必要",
			deliverablePackage: "2025年度成果品パッケージ",
			viewAll: "すべて表示"
		}
	},
	inspectionItem: {
		title: "変状記録",
		searchPlaceholder: "径間検索...",
		filters: {
			properties: "属性"
		},
		elementAlreadyLinked: "この要素は他の損傷にリンクされています",
		linkExistingConfirm: {
			title: "既存のリンク済み/モデル化済み点検項目を置き換えますか？",
			description: "選択した点検項目はすでに別の変状記録（{{otherDamageName}}）にリンクされています。\n\n現在の変状記録（{{damageName}}）に置き換えますか？"
		},
		unlinkConfirm: {
			title: "点検項目のリンクを解除しますか？",
			description: "変状記録（{{damageName}}）から点検項目のリンクを解除してもよろしいですか？この操作は元に戻せません。"
		},
		emptyState: {
			title: "点検を開始",
			description: "径間を追加して変状を記録し、この点検イベントの記録を開始します",
			action: "径間を作成",
			hint: "最初の径間を作成して開始",
			noData: "変状記録はありません。",
			notFound: "検索に一致する径間が見つかりません"
		},
		detail: {
			viewHistory: "履歴を表示",
			historyUnavailable: "この不具合が複数の点検に記録されると履歴を表示できます。",
			activity: "アクティビティ",
			activities: "アクティビティ",
			noActivities: "まだアクティビティがありません",
			personInCharge: "担当者",
			personInChargeLongDescription: "担当者\n\nこの特定の損傷記録を担当する点検者または技術者。国土交通省の定期点検ワークフローでは：\n\n・現場点検者が初期所見と変状程度を記録。\n・資格を持つ橋梁/トンネル点検技術者が評価を確認し、必要に応じて修正。\n・担当者は追跡可能性と説明責任のために点検台帳に記録。\n\n国土交通省は、点検チームの構成員が適切な資格（例：道路メンテナンス技術者、技術士等）を保有し、氏名・資格番号を点検報告書に記載することを求めています。",
			progressionLongDescription: "進行性評価（進行性判定）\n\n前回点検記録と比較して、損傷が経時的に悪化しているかを評価します。国土交通省の要領では、すべての既存損傷について進行性の判定が求められます：\n\n・進行性 ― 前回点検から明確に悪化（例：ひび割れ幅の拡大、漏水量の増加、剥離面積の拡大）。\n・横ばい ― 損傷は存在するが、前回点検サイクルから有意な変化なし。\n・不明 ― 比較のための前回点検データがない、または前回は調査不能だった箇所。\n\n進行性は変状程度の後に評価され、個別健全度の重要な判断材料となります。同じ変状程度でも、進行性の損傷は横ばいの損傷より高い健全度が付与される場合があります。",
			soundnessRatingLongDescription: "個別健全度（I〜IV）― 国土交通省 全国統一基準\n\n変状程度（a〜e）、進行性、損傷位置、部材の重要度を総合的に判断した、構造安全性に対する技術的評価です。各損傷を個別に評価（I〜IV）し、最も深刻な評価が部材・施設レベルに反映されます：\n\n・I ― 健全：損傷なし、または構造安全性に影響しない軽微な損傷。\n・II ― 予防保全段階：損傷があるが機能に支障なし。予防保全が推奨される。\n・III ― 早期措置段階：重大な損傷。次回点検前に措置が必要。\n・IV ― 緊急措置段階：構造安全性または第三者被害を脅かす深刻な損傷。即時対応が必要。\n\nIII又はIVと評価された損傷が1つでもあれば、径間・施設全体がその評価に引き上げられます。この評価が下の対策区分の根拠となります。",
			countermeasureLongDescription: "対策区分 ― 国土交通省 橋梁・トンネル点検要領\n\n上記の健全度評価と進行性判定に基づき、実施すべき措置を決定します。点検者または技術者が最終判断として判定します：\n\n・A0 ― 措置不要。損傷は無視できるレベル。\n・A ― 監視のみ。次回以降の点検サイクルで経過観察。\n・B ― 計画的補修。定期的な維持管理を計画。\n・C ― 補修要（計画的）。次回点検までに補修を計画。\n・E1 ― 緊急補修要。構造の健全性が損なわれている可能性。\n・E2 ― 緊急措置要。即座の交通規制や仮設支保工が必要。\n・M ― 詳細調査要（監視）。状態が不明確。注意深く監視。\n・S1 ― 詳細調査要。コア採取、載荷試験等の追加調査が必要。\n・S2 ― 原因調査要。対策決定前に原因分析が必要。\n\nシステムは変状程度と損傷種類に基づき対策区分を自動提案しますが、点検者は現場判断に基づき変更可能です。",
			emergencyMeasuresLongDescription: "応急措置記録 ― 国土交通省 点検要領\n\n対策区分がE1またはE2の場合に記録が必要です。「橋梁定期点検要領」（H31/2019）に基づく：\n\n・応急措置実施日 ― 応急措置を実施した日付。\n・応急措置内容 ― 実施した内容：交通規制、仮設支保工、防護柵、速度制限、監視カメラ設置等。\n・実施者 ― 措置を実施した組織または担当者。\n・恒久対策計画 ― 恒久的な補修計画：時期、範囲、工法。\n・通行制限等 ― 現在継続中の交通・通行制限。\n・通報先 ― 通報した相手：道路管理者、警察、地方自治体等。\n\nE1（構造安全性）は構造的な措置が必要です。E2（第三者被害）は交通規制措置が必要です。いずれも即座の記録と道路管理者への通報が求められます。",
			measureImplementationDate: "措置実施日",
			measureContent: "措置内容",
			measureContentPlaceholder: "例：速度制限40km/h、監視カメラ設置",
			implementer: "実施者",
			implementerPlaceholder: "例：NEXCO東日本",
			permanentMeasurePlan: "恒久対策計画",
			permanentMeasurePlanPlaceholder: "例：週次モニタリング、3ヶ月以内に補修工事",
			trafficRestrictions: "通行制限等",
			trafficRestrictionsPlaceholder: "例：大型車通行制限",
			notificationDestination: "通報先",
			notificationDestinationPlaceholder: "例：警察、地方自治体",
			previousInspection: "前回点検",
			previousSeverity: "前回変状程度",
			severityLongDescription: "変状程度（a〜e）― 国土交通省 定期点検要領\n\n定期点検時に、個々の損傷を現場調査票（様式2）で評価する際に使用します。各損傷に以下のいずれかの等級を付与します：\n\n・a ― 損傷なし：損傷がない。または耐久性・機能に影響しない軽微なもの。\n・b ― 軽微：損傷があるが、直ちに補修を必要としない。経過観察が必要。\n・c ― 要注意：構造機能に支障を及ぼす可能性があり、対策の検討が必要な状態。\n・d ― 危険：構造安全性を脅かす、または第三者被害の恐れがある緊急な状態。\n・e ― 調査不能：視認できない状態（ゴミ、植生等）。または、特定の損傷定義における最悪の状態（破断、脱落等）。\n\nこの評価は現場レベルの「入力データ」です。進行性とあわせて、個別健全度（I〜IV）および対策区分の根拠となります。",
			crackPattern: {
				_single: "ひび割れパターン",
				longitudinal: "縦方向"
			},
			updated: "更新日",
			dimensions: "寸法",
			dimensionsLongDescription: "損傷寸法\n\n現場点検時に記録する損傷の定量的な計測値：\n\n・長さ（mm）― 損傷の最長方向の寸法。ひび割れの場合、ひび割れ経路に沿って測定。\n・幅（mm）― 長さに垂直な方向の最大寸法。ひび割れの場合、ひび割れ開口幅（変状程度判定の重要な決定要因）。\n・深さ（mm）― 損傷がコンクリート内部にどれだけ貫入しているか。剥離、空洞、うきに関連。\n・面積（m²）― 影響を受けた総表面積。剥離、漏水範囲、うきに関連。\n\nこれらの計測値は変状程度（a〜e）の判定、点検サイクル間の進行性追跡、対策計画における補修数量の算出に不可欠です。",
			causesLongDescription: "損傷原因 ― 国土交通省 トンネル損傷分類\n\n国土交通省のトンネル損傷原因カテゴリに基づく原因分析。1つの損傷に対して複数の原因が特定される場合があります：\n\n・経年劣化 ― 環境暴露による経時的な自然劣化。\n・乾燥収縮 ― コンクリート硬化時の体積減少による初期ひび割れ。\n・温度応力 ― 温度サイクルによる膨張・収縮ひび割れ。\n・構造応力 ― 過荷重や設計不足による構造ひび割れ。\n・地盤変動 ― 地盤沈下、隆起、水平変位。\n・凍結融解 ― 凍結サイクルによる水の膨張で表面のスケーリングやポップアウトが発生。\n・浸水 ― ひび割れや防水不良部からの水の浸入。\n・地下水圧 ― 地下水位上昇による静水圧。\n・塩害 ― 塩分浸入による鉄筋腐食（沿岸部/凍結防止剤環境）。\n・中性化 ― CO₂浸透によるコンクリートのアルカリ性低下、鉄筋腐食を促進。\n・アルカリシリカ反応 ― セメントのアルカリと反応性骨材の化学反応（ASR）。\n・衝撃損傷 ― 車両衝突やがれきによる物理的損傷。\n・火災損傷 ― トンネル火災による熱影響。\n・施工不良 ― 元の施工品質の問題（締固め不足、コールドジョイント等）。\n・裏込め不足 ― 覆工背面の不十分なグラウト注入。\n・目地劣化 ― 施工目地や伸縮目地の劣化。\n・水食 ― 流動する地下水による覆工背面の土砂流出。\n・地震損傷 ― 地震によるひび割れや変位。\n\n正確な原因特定は効果的な対策の選定に不可欠です。根本原因に対処せず症状のみを処置すると、損傷が再発します。",
			causesEmptyValuePlaceholder: "要因が特定されていません",
			cause: {
				aging: "経年劣化",
				thermal: "温度応力"
			},
			notes: "メモ",
			notesPlaceholder: "この変状記録に関する追加メモを入力...",
			notesEmptyValuePlaceholder: "メモなし、評価を編集してメモを追加...",
			commentPlaceholder: "コメントを追加...",
			tabs: {
				photos: "写真",
				diagram: "図面",
				blueprint: "設計図",
				"3d": "3D",
				map: "地図"
			},
			defectSummary: "変状集計",
			judgmentBasisPlaceholder: "健全度判定の根拠を入力...",
			judgmentBasisEmptyValuePlaceholder: "判定根拠なし、評価を編集して追加...",
			assessmentNotesPlaceholder: "評価に関する追加メモを入力...",
			assessmentNotesEmptyValuePlaceholder: "評価メモなし、評価を編集してメモを追加...",
			inspectionArea: {
				emptyMessage: "点検エリアがまだアップロードされていません。",
				uploadButton: "点検エリアをアップロード"
			}
		},
		activities: {
			showMore: "さらに{{count}}件を表示",
			showLess: "簡略表示",
			comment: {
				namePlaceholder: "氏名",
				create: {
					successMessage: "コメントが追加されました!"
				},
				update: {
					successMessage: "コメントが更新されました"
				},
				"delete": {
					successMessage: "コメントが削除されました",
					confirmationTitle: "コメントを削除",
					confirmationMessage: "このコメントを削除してもよろしいですか？この操作は元に戻せません。"
				}
			}
		},
		imageAlt: {
			modeled: "モデル化された損傷",
			naked: "損傷写真",
			mesh: "3Dメッシュ"
		},
		photos: {
			noPhotosAvailable: "写真がありません"
		},
		"3d": {
			noDiagramsAvailable: "図面がありません",
			noDiagramsAvailableForDamage: "この変状記録に利用できる図面がありません。\n径間から図面をアップロードしてください。",
			goToSpan: "径間へ移動",
			addMarker: {
				title: "変状記録にリンク",
				noDamages: "この径間に変状記録がありません。"
			}
		},
		filterActive: {
			tooltipSpan: "現在フィルターが適用されています。フィルターを解除してから径間を並べ替えてください。",
			tooltipRecord: "現在フィルターが適用されています。フィルターを解除してから変状記録を並べ替えてください。"
		}
	},
	inspectionItems: {
		"2d": {
			tools: {
				selector: "選択",
				linkToDefectRecord: "変状記録にリンク"
			}
		}
	},
	deliverables: {
		viewReports: "レポートを表示",
		damagePhotos: {
			focusModeTooltip: "変状一覧タブで詳細を表示",
			noPhotosAvailable: "この径間に使用可能な写真はありません。",
			lightbox: {
				title: "写真詳細",
				loadingError: "写真の詳細を読み込めませんでした。再度お試しください。",
				previousPhoto: "前の写真",
				nextPhoto: "次の写真"
			}
		},
		defectPhotos: {
			title: "変状写真",
			photoNo: "写真番号",
			dateTaken: "撮影日",
			memberName: "部材名",
			elementNo: "要素番号",
			metadataEmbedded: "メタデータ埋込済",
			loadingPhotos: "写真を読み込み中… ({{count}}枚)",
			loadingMorePhotos: "写真を読み込み中… (現在{{count}}枚)",
			loadingAllPhotos: "エクスポート用に全ての写真を読み込み中…",
			preparingExport: "エクスポート用の写真を準備中…"
		},
		projectInfo: {
			title: "工事情報"
		}
	},
	files: {
		title: "3D点群スキャンデータ",
		searchPlaceholder: "ファイル検索...",
		columns: {
			fileName: "ファイル名",
			scanDate: "スキャン日",
			uploadedDate: "アップロード日",
			fileSize: "ファイルサイズ",
			pointCount: "ポイント数",
			status: "ステータス"
		},
		add: "ファイルを追加",
		emptyState: {
			notFound: "検索に一致するファイルが見つかりません"
		}
	},
	facilitySummary: {
		specifications: {
			title: "仕様"
		},
		location: {
			title: "位置情報"
		},
		summary: {
			totalEvents: "総イベント数",
			latestSoundness: "最新健全度"
		},
		eventStats: "イベント統計",
		eventTimeline: {
			title: "イベントタイムライン",
			latest: "最新"
		}
	}
};
var property = {
	id: "ID",
	kilopost: "キロポスト",
	length: "延長",
	built: "竣工",
	period: "工期",
	contractor: "受注者"
};
var phase = {
	inspection: "点検",
	deliverables: "成果品",
	approval: "承認"
};
var status = {
	completed: "完了",
	done: "完了",
	inprogress: "進行中",
	review: "レビュー",
	todo: "未着手",
	archived: "アーカイブ",
	notstarted: "未開始",
	processed: "処理済み",
	processing: "処理中",
	uploaded: "アップロード済み"
};
var severity = {
	previousSeverity: "前回変状程度"
};
var approval = {
	pendingReview: "確認待ち",
	packageTitle: "{{year}}年度 {{type}}",
	files: "ファイル",
	submitter: "提出者",
	errors: "{{count}} 件のエラー",
	warnings: "{{count}} 件の警告",
	type: {
		deliverablePackage: "成果品パッケージ"
	}
};
var ui = {
	expand: "拡大",
	collapse: "折りたたむ",
	loading: "読み込み中...",
	uploading: "アップロード中...{{progress}}%",
	close: "閉じる",
	cancel: "キャンセル",
	confirm: "確定",
	attention: "注意",
	accept: "了解",
	error: "エラー",
	edit: "編集",
	add: "追加",
	exit: "終了",
	save: "保存",
	saving: "保存中...",
	sending: "送信中...",
	create: "作成",
	creating: "作成中...",
	"delete": "削除",
	deleting: "削除中...",
	unlink: "リンク解除",
	unlinking: "リンク解除中...",
	"export": "エクスポート",
	pdfExport: "PDFエクスポート",
	moreDetails: "詳細を見る",
	viewMoreDetails: "詳細を見る",
	moreActions: "その他の操作",
	expandAll: "すべて展開",
	collapseAll: "すべて折りたたむ",
	readMore: "もっと見る",
	sendComment: "追加",
	selectAll: "すべて選択",
	deselectAll: "すべて解除",
	clearAllFilters: "すべてクリア",
	itemsSelected_one: "{{count}}件選択中",
	itemsSelected_other: "{{count}}件選択中",
	filters: "フィルター",
	language: "言語",
	accountSettings: "アカウント設定",
	logout: "ログアウト",
	noPermission: "この操作を実行する権限がありません",
	none: "なし",
	focusMode: "フォーカスモード",
	exitFocusMode: "フォーカスモードを解除",
	dontRemindAgain: "今後表示しない",
	menu: "メニュー",
	open: "開く",
	viewDetails: "詳細を見る",
	zoomIn: "ズームイン",
	zoomOut: "ズームアウト",
	zoomReset: "ズームをリセット",
	openInEditor: "エディタで開く"
};
var user = {
	subscription: {
		expiredAlert: {
			title: "有効なサブスクリプションがありません",
			description: "サブスクリプションが無効のため、一部の機能をご利用いただけません。すべての機能をご利用いただくには、サブスクリプションをアップグレードしてください。ご不明な点がある場合は、サポートまでお問い合わせください。"
		},
		expiringWarning: {
			title: "サブスクリプション有効期間",
			description: "まもなくサブスクリプションの有効期間が終了し工事データが削除されます。データを保持するためには更新が必要です。お問合せまたは弊社担当へご連絡ください。"
		}
	}
};
var errors = {
	common: "エラーが発生しました。再度お試しください。",
	auth0: {
		invalidToken: "認証トークンが無効です。再度ログインしてください。"
	},
	aws: {
		uploadFailed: "ファイルのアップロードに失敗しました。接続を確認して再度お試しください。",
		uploadAborted: "ファイルのアップロードが中止されました。再度お試しください。",
		downloadFailed: "ファイルのダウンロードに失敗しました。接続を確認して再度お試しください。"
	},
	user: {
		notFound: "ユーザーが見つかりません。再度ログインしてください。",
		fetch: "ユーザーデータの読み込みに失敗しました。ページを更新して再度お試しください。",
		register: "アカウント登録に失敗しました。入力内容を確認して再度お試しください。"
	},
	facility: {
		fetch: "施設の読み込みに失敗しました。ページを更新して再度お試しください。",
		create: "施設の作成に失敗しました。入力を確認して再度お試しください。",
		"create.40301": "施設を作成する権限がありません。サポートまでお問い合わせください。",
		update: "施設の更新に失敗しました。入力を確認して再度お試しください。",
		"update.40301": "施設を更新する権限がありません。サポートまでお問い合わせください。",
		"delete": "施設の削除に失敗しました。再度お試しください。",
		"delete.40301": "施設を削除する権限がありません。サポートまでお問い合わせください。"
	},
	span: {
		fetch: "径間の読み込みに失敗しました。ページを更新して再度お試しください。",
		create: "径間の作成に失敗しました。入力を確認して再度お試しください。",
		"create.40301": "径間を作成する権限がありません。サポートまでお問い合わせください。",
		update: "径間の更新に失敗しました。入力を確認して再度お試しください。",
		"update.40301": "径間を更新する権限がありません。サポートまでお問い合わせください。",
		"delete": "径間の削除に失敗しました。再度お試しください。",
		"delete.40301": "径間を削除する権限がありません。サポートまでお問い合わせください。"
	},
	event: {
		fetch: "イベントの読み込みに失敗しました。ページを更新して再度お試しください。",
		create: "イベントの作成に失敗しました。入力を確認して再度お試しください。",
		"create.40010": "同じ名前のイベントが既に存在します。別の名前を選択してください。",
		"create.40301": "イベントを作成する権限がありません。サポートまでお問い合わせください。",
		update: "イベントの更新に失敗しました。入力を確認して再度お試しください。",
		"update.40301": "イベントを更新する権限がありません。サポートまでお問い合わせください。",
		"delete": "イベントの削除に失敗しました。再度お試しください。",
		"delete.40301": "イベントを削除する権限がありません。サポートまでお問い合わせください。"
	},
	project: {
		fetch: "プロジェクトの読み込みに失敗しました。ページを更新して再度お試しください。",
		create: "プロジェクトの作成に失敗しました。入力を確認して再度お試しください。",
		"create.40301": "プロジェクトを作成する権限がありません。サポートまでお問い合わせください。",
		update: "プロジェクトの更新に失敗しました。入力を確認して再度お試しください。",
		"update.40301": "プロジェクトを更新する権限がありません。サポートまでお問い合わせください。",
		"delete": "プロジェクトの削除に失敗しました。再度お試しください。",
		"delete.40301": "プロジェクトを削除する権限がありません。サポートまでお問い合わせください。",
		inviteUser: "プロジェクトへのユーザー招待に失敗しました。メールアドレスを確認して再度お試しください。",
		"inviteUser.40301": "このプロジェクトにユーザーを招待する権限がありません。サポートまでお問い合わせください。",
		"inviteUser.40402": "招待された閲覧ユーザーのアカウントが作成されていません。まずアカウント作成の招待を行ってください。",
		removeUser: "プロジェクトからのユーザー削除に失敗しました。再度お試しください。",
		"removeUser.40301": "このプロジェクトからユーザーを削除する権限がありません。サポートまでお問い合わせください。"
	},
	damagePhoto: {
		fetch: "損傷写真の読み込みに失敗しました。ページを更新して再度お試しください。",
		uploadUrl: "アップロードURLの取得に失敗しました。再度お試しください。",
		"uploadUrl.40301": "写真をアップロードする権限がありません。サポートまでお問い合わせください。",
		upload: "写真のアップロードに失敗しました。再度お試しください。",
		"upload.40301": "写真をアップロードする権限がありません。サポートまでお問い合わせください。",
		create: "写真レコードの作成に失敗しました。再度お試しください。",
		"create.40301": "写真レコードを作成する権限がありません。サポートまでお問い合わせください。",
		update: "写真の更新に失敗しました。再度お試しください。",
		"update.40301": "写真を更新する権限がありません。サポートまでお問い合わせください。",
		"delete": "写真の削除に失敗しました。再度お試しください。",
		"delete.40301": "写真を削除する権限がありません。サポートまでお問い合わせください。"
	},
	damage: {
		fetch: "変状記録の読み込みに失敗しました。ページを更新して再度お試しください。",
		create: "変状記録の作成に失敗しました。入力を確認して再度お試しください。",
		"create.40301": "変状記録を作成する権限がありません。サポートまでお問い合わせください。",
		update: "変状記録の更新に失敗しました。入力を確認して再度お試しください。",
		"update.40301": "変状記録を更新する権限がありません。サポートまでお問い合わせください。"
	},
	damageAssessment: {
		fetch: "変状評価の読み込みに失敗しました。ページを更新して再度お試しください。",
		create: "変状評価の作成に失敗しました。入力を確認して再度お試しください。",
		"create.40301": "変状評価を作成する権限がありません。サポートまでお問い合わせください。",
		update: "変状評価の更新に失敗しました。入力を確認して再度お試しください。",
		"update.40301": "変状評価を更新する権限がありません。サポートまでお問い合わせください。"
	},
	spanAssessment: {
		fetch: "径間評価の読み込みに失敗しました。ページを更新して再度お試しください。",
		create: "径間評価の作成に失敗しました。入力を確認して再度お試しください。",
		"create.40301": "径間評価を作成する権限がありません。サポートまでお問い合わせください。",
		update: "径間評価の更新に失敗しました。入力を確認して再度お試しください。",
		"update.40301": "径間評価を更新する権限がありません。サポートまでお問い合わせください。",
		"delete": "径間評価の削除に失敗しました。再度お試しください。",
		"delete.40301": "径間評価を削除する権限がありません。サポートまでお問い合わせください。"
	},
	assessmentComment: {
		fetch: "コメントの読み込みに失敗しました。ページを更新して再度お試しください。",
		create: "コメントの追加に失敗しました。再度お試しください。",
		"create.40301": "コメントを追加する権限がありません。サポートまでお問い合わせください。",
		update: "コメントの更新に失敗しました。再度お試しください。",
		"update.40301": "コメントを更新する権限がありません。サポートまでお問い合わせください。",
		"delete": "コメントの削除に失敗しました。再度お試しください。",
		"delete.40301": "コメントを削除する権限がありません。サポートまでお問い合わせください。"
	},
	inspectionArea: {
		fetch: "検査エリアの読み込みに失敗しました。ページを更新して再度お試しください。",
		create: "検査エリアの作成に失敗しました。入力を確認して再度お試しください。",
		"create.40011": "同じ名前の検査エリアが既に存在します。別の名前を使用してください。",
		"create.40301": "検査エリアを作成する権限がありません。サポートまでお問い合わせください。",
		update: "検査エリアの更新に失敗しました。入力を確認して再度お試しください。",
		"update.40301": "検査エリアを更新する権限がありません。サポートまでお問い合わせください。",
		"delete": "検査エリアの削除に失敗しました。再度お試しください。",
		"delete.40301": "検査エリアを削除する権限がありません。サポートまでお問い合わせください。"
	},
	jobs: {
		get: "ジョブの取得に失敗しました。ページを更新して再度お試しください。",
		ack: "ジョブの確認処理に失敗しました。再度お試しください。"
	},
	maskingRegion: {
		create: "注目領域の保存に失敗しました。再度お試しください。",
		fetch: "注目領域の読み込みに失敗しました。ページを更新して再度お試しください。",
		"delete": "注目領域の削除に失敗しました。再度お試しください。",
		"delete.40301": "注目領域を削除する権限がありません。サポートまでお問い合わせください。"
	},
	serviceStatus: {
		fetch: "サービス状況の読み込みに失敗しました。ページを更新して再度お試しください。"
	},
	tutorialVideoConfig: {
		fetch: "チュートリアル動画設定の読み込みに失敗しました。ページを更新して再度お試しください。"
	},
	featureFlags: {
		fetch: "機能フラグの読み込みに失敗しました。ページを更新して再度お試しください。"
	},
	validation: {
		fieldRequired: "このフィールドは必須です",
		emergencyMeasuresRequired: "応急措置の必須項目をすべて入力してください"
	},
	diagramDrawing: {
		fetch: "図面の読み込みに失敗しました。ページを更新して再度お試しください。",
		upload: "図面のアップロードに失敗しました。ファイルを確認して再度お試しください。",
		"upload.40301": "図面をアップロードする権限がありません。サポートまでお問い合わせください。",
		update: "図面の更新に失敗しました。入力を確認して再度お試しください。",
		"update.40301": "図面を更新する権限がありません。サポートまでお問い合わせください。",
		"delete": "図面の削除に失敗しました。再度お試しください。",
		"delete.40301": "図面を削除する権限がありません。サポートまでお問い合わせください。"
	}
};
var inspectionItem = {
	elementList: {
		title: "要素一覧",
		noData: "データがありません"
	}
};
var notFound = {
	heading: "お探しのページは見つかりませんでした",
	body: "アクセスしようとしたページは、移動または削除された可能性があります。URL をご確認のうえ、ホームからやり直してください。",
	home: "ホームに戻る"
};
var errorPage = {
	heading: "予期しないエラーが発生しました",
	body: "システム側に問題が発生し、処理を完了できませんでした。お手数ですが、ページを再読み込みするか、しばらく時間をおいて再度お試しください。問題が解決しない場合は、下記の参照番号を添えてサポートまでご連絡ください。",
	referenceNumber: "参照番号",
	reload: "再読み込み",
	home: "ホームに戻る"
};
var jaTranslation = {
	hatsuly: hatsuly,
	maintenance: maintenance,
	nav: nav,
	dashboard: dashboard,
	userAccount: userAccount,
	object: object,
	modal: modal,
	section: section,
	property: property,
	phase: phase,
	status: status,
	severity: severity,
	approval: approval,
	ui: ui,
	user: user,
	errors: errors,
	inspectionItem: inspectionItem,
	"3d": {
	buttons: {
		save: "保存",
		saveAndExit: "保存して終了",
		reset: "全てをリセット",
		cancel: "キャンセル",
		undo: "点をひとつ戻す",
		complete: "描画中の要素を完了"
	},
	unsavedGuard: {
		title: "未保存の作業があります",
		body: "このまま進むと、作業内容は破棄されます。よろしいですか？",
		confirm: "破棄して続行"
	},
	linking: {
		linkOrModel: "検査エリアを選択して検査項目をリンクまたはモデル化"
	},
	settings: {
		title: "設定",
		display: "表示設定",
		visibility: "表示・非表示",
		pointCloud: {
			title: "点群",
			pointSize: "点のサイズ",
			opacity: "不透明度",
			backgroundColor: "背景色",
			labelSize: "ラベルサイズ"
		},
		mesh: {
			title: "3Dメッシュ",
			opacity: "不透明度",
			unavailable: "表示中のエリアに完成した3Dメッシュがありません"
		},
		maskRegions: {
			title: "注目領域",
			showAllPoints: "すべての点を表示",
			region: "注目領域 {{index}}",
			empty: "注目領域がありません",
			deleteConfirmTitle: "注目領域",
			deleteConfirmMessage: "一度削除してしまうと、元に戻せません。"
		},
		openDrawer: "3D画面の設定",
		saveSuccess: "3D画面設定が正常に保存されました"
	},
	cameraProfile: {
		saveSuccess: "カメラプロファイルを保存しました",
		saveError: "カメラプロファイルの保存に失敗しました",
		specifyFront: "正面を指定",
		enable: "正面を設定",
		disable: "カメラ正面の設定を終了",
		view: {
			front: "カメラを正面(-y)からの視点に移動",
			back: "カメラを裏(+y)からの視点に移動",
			left: "カメラを左(-x)からの視点に移動",
			right: "カメラを右(+x)からの視点に移動",
			top: "カメラを上(+z)からの視点に移動",
			bottom: "カメラを下(-z)からの視点に移動"
		},
		backToFront: "正面の編集に戻る"
	},
	editorTools: {
		move: "移動 / 選択"
	},
	link: {
		saveLink: "リンクを保存",
		cancelAndExit: "キャンセルして終了"
	},
	planeDetection: {
		tool: "平面検出 — 面をなぞって面積を計測",
		detectAndLink: "計算してリンク",
		closeTooltip: "この平面の作成を完了",
		startedTitle: "平面検出を開始しました",
		startedBody: "平面検出が進行中です。完了をお待ちの間、他のツールを引き続きご利用いただけます。完了次第、通知いたします。",
		saveSuccess: "平面検出が完了しました",
		savedItem: "「{{itemName}}」を保存しました",
		savedAndLinked: "「{{itemName}}」を保存し、欠陥記録「{{damageName}}」にリンクしました",
		saveError: "平面検出に失敗しました",
		autoLinkNote: "この平面は 欠陥記録「{{damageName}}」 に自動でリンクされます",
		alreadyLinkedWarning: "欠陥記録「{{damageName}}」には既に別の項目がリンクされています。保存すると上書きされます。",
		detectionInProgress: "この欠陥記録では平面検出が進行中です。完了までお待ちください。",
		gate: {
			noRecord: "リンク先の欠陥記録が選択されていません",
			noPermission: "面積を計算・リンクする権限がありません",
			inProgress: "この欠陥記録では平面検出が進行中です",
			notReady: "スキャンの処理が完了していないため計算できません"
		}
	},
	focus: {
		tool: "フォーカス — 点をクリックしてカメラを中心に移動",
		item: "アイテムにフォーカス"
	},
	itemCameraProfile: {
		edit: "アイテムのカメラプロファイルを設定",
		disable: "アイテムのカメラプロファイル設定を終了"
	},
	polyline: {
		tool: "延長",
		save: "保存",
		closeTooltip: "ここをクリックして線を終了",
		saveSuccess: "延長の保存が完了しました",
		savedItem: "「{{itemName}}」を保存しました",
		savedAndLinked: "「{{itemName}}」を保存し、欠陥記録「{{damageName}}」にリンクしました",
		saveError: "延長の保存に失敗しました",
		autoLinkNote: "この延長は 欠陥記録「{{damageName}}」 に自動でリンクされます",
		alreadyLinkedWarning: "欠陥記録「{{damageName}}」には既に別の項目がリンクされています。保存すると上書きされます。",
		width: "幅",
		widthPanelTitle: "延長計算の設定",
		labelSection: "ラベル表示（編集中）",
		labelPrimary: "全長",
		labelEdge: "各辺",
		vertex: {
			add: "頂点を追加",
			move: "点を移動",
			remove: "頂点を削除",
			removeSplit: "頂点を削除 / 辺を切断",
			connect: "頂点を接続（2つの延長を結合）"
		},
		gate: {
			noRecord: "リンク先の欠陥記録が選択されていません",
			noPermission: "延長を保存・リンクする権限がありません",
			notReady: "スキャンの処理が完了していないため保存できません"
		}
	},
	customMeasurement: {
		tool: "距離 — 2点間の距離を計測",
		saveError: "距離の保存に失敗しました",
		notReady: "スキャンの処理が完了していないため保存できません",
		deleteError: "距離の削除に失敗しました",
		deleteConfirmTitle: "この距離を削除しますか？",
		deleteConfirmMessage: "削除すると、この距離の計測結果は元に戻せません。"
	},
	mask: {
		tool: "注目領域の設定",
		saveSuccess: "注目領域設定の保存が完了しました",
		transform: {
			translate: "移動",
			scale: "サイズ",
			rotate: "回転"
		}
	},
	elementList: {
		groups: {
			add: "検査グループを追加",
			namePlaceholder: "グループ名",
			nameRequired: "グループ名を入力してください",
			nameTaken: "このグループ名はすでに使用されています",
			deleteConfirmTitle: "検査グループの削除",
			deleteConfirmMessage: "グループのみが削除されます。含まれる要素は未分類要素に戻ります。"
		},
		coloringDialog: {
			title: "要素の色付け動作の変更",
			body1: "現在の自動色付け設定では、検査グループを追加すると色付け動作が要素の種類の色から検査グループの色に切り替わります。",
			body2: "検査グループの色モードでは、要素はグループに基づいて色付けされるか、グループに含まれない場合は未分類用の色が使用されます。",
			body3: "自動切り替えを実行しますか？それとも要素の種類による色のままにしますか？この設定は画面設定からいつでも変更できます。",
			body4: "どちらのオプションでも検査グループを追加できますが、選択に応じて色付け動作が異なります。",
			keepElementColoring: "要素の種類による色のまま",
			useGroupColoring: "検査グループの色に切り替え"
		}
	}
},
	notFound: notFound,
	errorPage: errorPage
};

const resources = {
    en: {
        translation: enTranslation,
    },
    ja: {
        translation: jaTranslation,
    },
};
instance
    .use(Browser)
    .use(initReactI18next)
    .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'ja'],
    load: 'languageOnly',
    interpolation: {
        escapeValue: false,
    },
    returnNull: false,
});
// Keep <html lang> in sync so browsers don't mis-detect and auto-translate the page.
const syncDocumentLang = (lng) => {
    if (typeof document !== 'undefined') {
        document.documentElement.lang = lng;
    }
};
syncDocumentLang(instance.resolvedLanguage ?? instance.language);
instance.on('languageChanged', syncDocumentLang);

const useTranslation = () => {
    const { t, i18n } = useTranslation$1();
    const tStatus = (status) => {
        return t(`status.${status}`);
    };
    return {
        // Use the resolved language (e.g. 'en') rather than the raw detected code
        // (e.g. 'en-US'), so switchers highlight the active language even when it
        // was auto-detected and never explicitly chosen.
        language: i18n.resolvedLanguage ?? i18n.language,
        setLanguage: (lang) => i18n.changeLanguage(lang),
        t,
        tStatus,
    };
};

var _path, _path2, _path3, _path4;
function _extends$2() { return _extends$2 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2.apply(null, arguments); }
var SvgLogoFull = function SvgLogoFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 186,
    height: 32,
    fill: "none",
    viewBox: "0 0 978 168"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2699FB",
    d: "M908.037 157.773v-94.5h21.656V75.04h.672q1.342-3.132 3.803-6.04 2.505-2.909 6.354-4.743 3.893-1.88 9.306-1.88 7.16 0 13.379 3.76 6.264 3.758 10.112 11.588t3.848 19.956q0 11.678-3.714 19.553-3.669 7.875-9.933 11.813-6.22 3.937-13.826 3.937-5.19 0-8.993-1.7t-6.399-4.474q-2.55-2.774-3.937-5.951h-.448v36.914zm21.433-60.137q0 5.549 1.476 9.665 1.522 4.116 4.341 6.399 2.864 2.237 6.845 2.237 4.027 0 6.846-2.237 2.82-2.283 4.251-6.399 1.476-4.116 1.477-9.665 0-5.547-1.477-9.62-1.432-4.071-4.251-6.309-2.774-2.237-6.846-2.237-4.026 0-6.845 2.193t-4.341 6.264q-1.476 4.07-1.476 9.71M862.107 133.298q-10.828 0-18.613-4.43-7.741-4.474-11.947-12.439-4.161-8.01-4.161-18.569 0-10.605 4.161-18.569 4.206-8.01 11.947-12.439 7.785-4.474 18.613-4.474 10.829 0 18.569 4.474 7.786 4.43 11.947 12.44 4.206 7.963 4.206 18.568 0 10.56-4.206 18.569-4.16 7.965-11.947 12.439-7.74 4.43-18.569 4.43m.135-16.511q3.937 0 6.667-2.416t4.161-6.712q1.476-4.296 1.476-9.933 0-5.728-1.476-10.023-1.433-4.295-4.161-6.712-2.73-2.415-6.667-2.416-4.072 0-6.891 2.416-2.774 2.417-4.251 6.712-1.431 4.296-1.431 10.023 0 5.637 1.431 9.933 1.478 4.296 4.251 6.712 2.818 2.416 6.891 2.416M784.096 133.298q-10.829 0-18.614-4.43-7.74-4.474-11.947-12.439-4.161-8.01-4.161-18.569 0-10.605 4.161-18.569 4.207-8.01 11.947-12.439 7.785-4.474 18.614-4.474 10.827 0 18.569 4.474 7.785 4.43 11.946 12.44 4.206 7.963 4.206 18.568 0 10.56-4.206 18.569-4.161 7.965-11.946 12.439-7.742 4.43-18.569 4.43m.134-16.511q3.937 0 6.667-2.416t4.161-6.712q1.477-4.296 1.477-9.933 0-5.728-1.477-10.023-1.432-4.295-4.161-6.712-2.73-2.415-6.667-2.416-4.072 0-6.891 2.416-2.774 2.417-4.25 6.712-1.432 4.296-1.432 10.023 0 5.637 1.432 9.933 1.476 4.296 4.25 6.712 2.82 2.416 6.891 2.416M680.277 132V40.364h22.149v73.649h38.122V132zM625.824 133.163q-6.577 0-11.679-2.192-5.055-2.238-8.009-6.712-2.908-4.52-2.908-11.32 0-5.727 2.013-9.665t5.549-6.398q3.534-2.462 8.143-3.714 4.609-1.298 9.844-1.745 5.86-.537 9.441-1.119 3.579-.626 5.19-1.745 1.656-1.163 1.656-3.266v-.224q0-3.446-2.372-5.324-2.372-1.88-6.398-1.88-4.34 0-6.98 1.88t-3.356 5.19l-20.18-.716q.895-6.264 4.609-11.186 3.759-4.966 10.291-7.786 6.577-2.863 15.795-2.863 6.577 0 12.126 1.566 5.547 1.52 9.664 4.474 4.117 2.91 6.354 7.16 2.282 4.25 2.282 9.709V132h-20.582v-9.575h-.537q-1.834 3.49-4.699 5.906-2.818 2.416-6.666 3.624-3.804 1.209-8.591 1.208m6.756-14.318q3.535 0 6.354-1.432 2.863-1.431 4.564-3.937 1.7-2.55 1.7-5.906v-6.533q-.94.492-2.282.895-1.298.403-2.864.76a51 51 0 0 1-3.221.627q-1.656.269-3.177.492-3.087.492-5.28 1.521-2.148 1.029-3.311 2.685-1.119 1.611-1.119 3.848 0 3.4 2.417 5.19 2.46 1.79 6.219 1.79M556 132V63.273h21.254V75.8h.716Q579.849 69 584.1 65.69q4.25-3.356 9.888-3.356 1.521 0 3.132.224 1.61.18 2.998.581v19.017q-1.566-.537-4.116-.85-2.506-.314-4.475-.314-3.893 0-7.025 1.746-3.087 1.7-4.877 4.787-1.745 3.043-1.745 7.16V132zM545.474 63.273V79.38h-44.207V63.273zM510.484 132V59.783q0-7.965 2.998-13.2 2.998-5.28 8.322-7.875 5.325-2.64 12.305-2.64 4.564 0 8.591.716 4.072.672 6.04 1.208l-3.49 16.019q-1.207-.403-2.953-.672a21 21 0 0 0-3.221-.268q-3.849 0-5.28 1.7t-1.432 4.654V132zM448.435 92.804V132h-21.88V63.273h20.806V75.89h.761q2.281-6.31 7.785-9.889 5.503-3.624 13.11-3.624 7.25 0 12.573 3.266 5.37 3.221 8.323 9.039 2.998 5.771 2.953 13.512V132h-21.88V92.49q.044-5.726-2.908-8.948-2.909-3.222-8.099-3.222-3.445 0-6.085 1.522-2.596 1.475-4.027 4.25-1.387 2.775-1.432 6.712M412.651 40.364V132h-22.149V40.364zM305.264 132h-33.871V40.364h33.826q14.005 0 24.118 5.503 10.156 5.46 15.66 15.75 5.504 10.246 5.504 24.52 0 14.319-5.504 24.609-5.458 10.292-15.616 15.795Q319.225 132 305.264 132m-11.723-18.882h10.873q7.696 0 13.021-2.595 5.369-2.64 8.098-8.546 2.774-5.952 2.774-15.84t-2.774-15.75q-2.774-5.906-8.188-8.501-5.369-2.64-13.244-2.64h-10.56zM222.029 133.253q-10.47 0-18.569-3.58-8.054-3.624-12.708-9.978-4.653-6.353-4.742-14.631h22.282q.135 2.997 1.924 5.324 1.79 2.283 4.877 3.58 3.088 1.298 7.025 1.298t6.936-1.387q3.042-1.433 4.742-3.893 1.701-2.507 1.656-5.727.045-3.222-1.835-5.728-1.878-2.505-5.324-3.893-3.4-1.386-8.054-1.387h-8.904v-15.75h8.904q4.071 0 7.159-1.342 3.132-1.343 4.877-3.758 1.745-2.461 1.7-5.638.045-3.088-1.476-5.414-1.477-2.371-4.161-3.67-2.64-1.296-6.13-1.297-3.67 0-6.667 1.298-2.953 1.297-4.698 3.669-1.745 2.37-1.835 5.503h-21.164q.09-8.188 4.564-14.407 4.475-6.265 12.17-9.8 7.741-3.534 17.63-3.534 9.843 0 17.316 3.445 7.472 3.446 11.633 9.396 4.161 5.906 4.161 13.379.045 7.74-5.056 12.752-5.056 5.012-13.02 6.175v.716q10.649 1.253 16.063 6.89 5.459 5.638 5.414 14.095 0 7.964-4.698 14.139-4.653 6.13-12.976 9.665-8.277 3.49-19.016 3.49M39.45 28.416 76.297 0l51.524 40.595-36.223 31.227 23.733 19.985-39.034 36.223L21.65 78.692l39.346-32.164z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2699FB",
    d: "M32.268 34.037 46.32 46.84 14.78 71.822.417 59.33zM135.628 46.528 106.9 71.822l15.613 13.427 28.729-25.918z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#5EB2F9",
    d: "m122.513 85.25-7.494 45.59 24.356-23.108 11.554-48.401zM115.331 91.807l-39.034 35.91V168l33.101-31.851z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2285DA",
    d: "m21.963 78.38 8.743 46.527L76.298 168v-40.282zM14.78 71.822.73 59.019l12.178 49.026 11.866 10.929z"
  })));
};

const setupCanvas = (canvas) => {
    const dpr = 2;
    const cssW = canvas.clientWidth || 900;
    const cssH = canvas.clientHeight || 450;
    canvas.width = Math.round(cssW * dpr);
    canvas.height = Math.round(cssH * dpr);
    const ctx = canvas.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, cssW, cssH);
    return { ctx, cssW, cssH };
};
const drawGrid = (ctx, cssW, cssH) => {
    ctx.fillStyle = '#F8FAFC';
    ctx.fillRect(0, 0, cssW, cssH);
    const numCols = Math.round(cssW / 28);
    const numRows = Math.round(cssH / 28);
    const gw = cssW / numCols;
    const gh = cssH / numRows;
    ctx.strokeStyle = '#E2E8F0';
    ctx.lineWidth = 1;
    ctx.globalAlpha = 1;
    for (let i = 1; i < numCols; i++) {
        const x = Math.round(i * gw);
        ctx.beginPath();
        ctx.moveTo(x, 0);
        ctx.lineTo(x, cssH);
        ctx.stroke();
    }
    for (let j = 1; j < numRows; j++) {
        const y = Math.round(j * gh);
        ctx.beginPath();
        ctx.moveTo(0, y);
        ctx.lineTo(cssW, y);
        ctx.stroke();
    }
};
const samplePoints = (o, cssW, cssH, step = 3) => {
    const data = o.getImageData(0, 0, cssW, cssH).data;
    const pts = [];
    let minX = 1e9, maxX = -1e9, minY = 1e9, maxY = -1e9;
    for (let y = 0; y < cssH; y += step) {
        for (let x = 0; x < cssW; x += step) {
            if (data[(y * cssW + x) * 4 + 3] > 128) {
                pts.push({ x, y });
                if (x < minX)
                    minX = x;
                if (x > maxX)
                    maxX = x;
                if (y < minY)
                    minY = y;
                if (y > maxY)
                    maxY = y;
            }
        }
    }
    return { pts, minX, maxX, minY, maxY };
};
const makeRng = (seed = 1337) => {
    let s = seed;
    return () => {
        s = (s * 16807) % 2147483647;
        return s / 2147483647;
    };
};
const drawPointCloud = (ctx, pts, rnd) => {
    for (const p of pts) {
        const z = rnd();
        const jx = (rnd() - 0.5) * 2.4;
        const jy = (rnd() - 0.5) * 2.4;
        const r = 0.7 + z * 1.7;
        ctx.globalAlpha = 0.5 + z * 0.5;
        ctx.fillStyle = '#186FB9';
        ctx.beginPath();
        ctx.arc(p.x + jx, p.y + jy, r, 0, 6.2832);
        ctx.fill();
    }
    ctx.globalAlpha = 1;
};
const drawHorizontalRuler = (ctx, { x1, x2, y, scale, color, label }) => {
    const tick = Math.max(3, Math.round(5 * scale));
    const labelFontPx = Math.max(10, Math.round(12 * scale));
    const pad = Math.round(7 * scale);
    const lh = Math.round(18 * scale);
    ctx.lineWidth = Math.max(1, 1.5 * scale);
    ctx.font = `600 ${labelFontPx}px "Noto Sans JP", sans-serif`;
    ctx.strokeStyle = color;
    ctx.globalAlpha = 0.85;
    ctx.beginPath();
    ctx.moveTo(x1, y);
    ctx.lineTo(x2, y);
    ctx.moveTo(x1, y - tick);
    ctx.lineTo(x1, y + tick);
    ctx.moveTo(x2, y - tick);
    ctx.lineTo(x2, y + tick);
    ctx.stroke();
    ctx.globalAlpha = 1;
    const tw = ctx.measureText(label).width;
    const cx = (x1 + x2) / 2;
    ctx.fillStyle = '#fff';
    ctx.fillRect(cx - tw / 2 - pad, y - lh / 2, tw + pad * 2, lh);
    ctx.fillStyle = color;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(label, cx, y);
};
const drawVerticalRuler = (ctx, { x, y1, y2, scale, color, label }) => {
    const tick = Math.max(3, Math.round(5 * scale));
    const pad = Math.round(7 * scale);
    const lh = Math.round(18 * scale);
    ctx.strokeStyle = color;
    ctx.lineWidth = Math.max(1, 1.5 * scale);
    ctx.globalAlpha = 0.85;
    ctx.beginPath();
    ctx.moveTo(x, y1);
    ctx.lineTo(x, y2);
    ctx.moveTo(x - tick, y1);
    ctx.lineTo(x + tick, y1);
    ctx.moveTo(x - tick, y2);
    ctx.lineTo(x + tick, y2);
    ctx.stroke();
    ctx.globalAlpha = 1;
    const lw = ctx.measureText(label).width;
    const cy = (y1 + y2) / 2;
    ctx.fillStyle = '#fff';
    ctx.fillRect(x - lw / 2 - pad, cy - lh / 2, lw + pad * 2, lh);
    ctx.fillStyle = color;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(label, x, cy);
};
const useCanvasDraw = (draw) => {
    const canvasRef = useRef(null);
    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas)
            return;
        const go = () => draw(canvas);
        if (document.fonts?.ready) {
            document.fonts.ready.then(go);
        }
        else {
            go();
        }
        const timer = setTimeout(go, 350);
        const ro = new ResizeObserver(go);
        ro.observe(canvas);
        return () => {
            clearTimeout(timer);
            ro.disconnect();
        };
        // draw is stable (defined at module level), so the empty dep array is correct
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return canvasRef;
};

const draw$2 = (canvas) => {
    const { ctx, cssW, cssH } = setupCanvas(canvas);
    drawGrid(ctx, cssW, cssH);
    const scale = cssH / 450;
    const fontPx = Math.round(285 * scale);
    const off = document.createElement('canvas');
    off.width = cssW;
    off.height = cssH;
    const o = off.getContext('2d');
    o.fillStyle = '#fff';
    o.font = `800 ${fontPx}px "Noto Sans JP", sans-serif`;
    o.textAlign = 'center';
    o.textBaseline = 'middle';
    o.fillText('404', cssW / 2, cssH / 2 + 2);
    const { pts, minX, maxX, minY, maxY } = samplePoints(o, cssW, cssH);
    drawPointCloud(ctx, pts, makeRng());
    const rulerOffset = Math.round(10 + 12 * scale);
    drawHorizontalRuler(ctx, {
        x1: minX,
        x2: maxX,
        y: maxY + rulerOffset * 1.5,
        scale,
        color: '#2699FB',
        label: `W = ${Math.round(maxX - minX)}`,
    });
    drawVerticalRuler(ctx, {
        x: maxX + rulerOffset * 2,
        y1: minY,
        y2: maxY,
        scale,
        color: '#2699FB',
        label: `H = ${Math.round(maxY - minY)}`,
    });
};
const NotFound = ({ homeHref = '/' }) => {
    const { t } = useTranslation();
    const canvasRef = useCanvasDraw(draw$2);
    return (jsxs(Flex, { minH: "100vh", direction: "column", bg: "white", children: [jsx(Flex, { as: "header", align: "center", gap: "9px", px: 10, py: "22px", borderBottom: "1px solid", borderColor: "gray.100", children: jsx(SvgLogoFull, {}) }), jsxs(Flex, { as: "main", flex: 1, direction: "column", align: "center", justify: "center", px: 6, pt: "56px", pb: "64px", children: [jsx(Box, { w: "full", maxW: "960px", border: "1px solid", borderColor: "gray.200", borderRadius: "10px", overflow: "hidden", children: jsx("canvas", { ref: canvasRef, style: { display: 'block', width: '100%', aspectRatio: '32 / 15' } }) }), jsxs(VStack, { mt: 10, gap: 4, textAlign: "center", children: [jsx(Text$2, { fontWeight: "bold", fontSize: "30px", color: "gray.900", letterSpacing: "-0.01em", lineHeight: "1.2", children: t('notFound.heading') }), jsx(Text$2, { maxW: "510px", fontSize: "15px", lineHeight: "1.75", color: "gray.600", whiteSpace: "pre-line", children: t('notFound.body') }), jsx(Button, { mt: 4, asChild: true, colorPalette: "blue", children: jsx(Link, { href: homeHref, children: t('notFound.home') }) })] })] }), jsx(Box, { as: "footer", px: 10, py: 5, borderTop: "1px solid", borderColor: "gray.100", fontSize: "12px", color: "gray.400", children: "\u00A9 2023 - 2026 DataLabs inc." })] }));
};

const draw$1 = (canvas) => {
    const { ctx, cssW, cssH } = setupCanvas(canvas);
    drawGrid(ctx, cssW, cssH);
    const scale = cssH / 450;
    const triH = Math.round(260 * scale);
    const triW = Math.round(triH * 1.155); // equilateral: w = h * 2/√3
    const tcx = cssW / 2;
    const tcy = cssH / 2 + triH / 12;
    // Centroid splits median 2:1; top is 2/3 of height above centroid
    const topPt = { x: tcx, y: tcy - (triH * 2) / 3 };
    const blPt = { x: tcx - triW / 2, y: tcy + triH / 3 };
    const brPt = { x: tcx + triW / 2, y: tcy + triH / 3 };
    const off = document.createElement('canvas');
    off.width = cssW;
    off.height = cssH;
    const o = off.getContext('2d');
    // Thick stroke outline only — no fill — so dots appear on the edges
    const strokeW = Math.max(8, Math.round(22 * scale));
    o.strokeStyle = '#fff';
    o.lineWidth = strokeW;
    o.lineJoin = 'round';
    o.lineCap = 'round';
    o.beginPath();
    o.moveTo(topPt.x, topPt.y);
    o.lineTo(brPt.x, brPt.y);
    o.lineTo(blPt.x, blPt.y);
    o.closePath();
    o.stroke();
    // ! inside the triangle
    const excPx = Math.max(30, Math.round(110 * scale));
    o.fillStyle = '#fff';
    o.font = `900 ${excPx}px "Noto Sans JP", sans-serif`;
    o.textAlign = 'center';
    o.textBaseline = 'middle';
    o.fillText('!', tcx, tcy + Math.round(8 * scale));
    const { pts, minX, maxX, maxY } = samplePoints(o, cssW, cssH);
    drawPointCloud(ctx, pts, makeRng());
    const rulerOffset = Math.round(10 + 12 * scale);
    drawHorizontalRuler(ctx, {
        x1: minX,
        x2: maxX,
        y: maxY + rulerOffset * 1.5,
        scale,
        color: '#E53E3E',
        label: 'STATUS: ERROR',
    });
};
const ErrorPage = ({ homeHref = '/', onReload, errorCode }) => {
    const { t } = useTranslation();
    const canvasRef = useCanvasDraw(draw$1);
    const handleReload = onReload ?? (() => window.location.reload());
    return (jsxs(Flex, { minH: "100vh", direction: "column", bg: "white", children: [jsx(Flex, { as: "header", align: "center", gap: "9px", px: 10, py: "22px", borderBottom: "1px solid", borderColor: "gray.100", children: jsx(SvgLogoFull, {}) }), jsxs(Flex, { as: "main", flex: 1, direction: "column", align: "center", justify: "center", px: 6, pt: "56px", pb: "64px", children: [jsx(Box, { w: "full", maxW: "960px", border: "1px solid", borderColor: "gray.200", borderRadius: "10px", overflow: "hidden", children: jsx("canvas", { ref: canvasRef, style: { display: 'block', width: '100%', aspectRatio: '32 / 15' } }) }), jsxs(VStack, { mt: 10, gap: 4, maxW: "510px", textAlign: "center", children: [jsx(Text$2, { fontWeight: "bold", fontSize: "30px", color: "gray.900", letterSpacing: "-0.01em", lineHeight: "1.2", children: t('errorPage.heading') }), jsx(Text$2, { fontSize: "15px", lineHeight: "1.75", color: "gray.600", children: t('errorPage.body') }), errorCode && (jsxs(Box, { mt: 2, px: 4, py: "10px", border: "1px solid", borderColor: "gray.200", borderRadius: "8px", fontSize: "13px", color: "gray.600", letterSpacing: "0.02em", children: [jsx(Text$2, { as: "span", color: "gray.400", mr: 2, children: t('errorPage.referenceNumber') }), jsx(Text$2, { as: "span", fontWeight: "bold", color: "gray.700", fontFamily: "monospace", children: errorCode })] })), jsxs(Flex, { gap: 3, mt: 4, align: "center", justify: "center", children: [jsx(Button, { onClick: handleReload, colorPalette: "blue", children: t('errorPage.reload') }), jsx(Button, { asChild: true, variant: "ghost", children: jsx(Link, { href: homeHref, children: t('errorPage.home') }) })] })] })] }), jsx(Box, { as: "footer", px: 10, py: 5, borderTop: "1px solid", borderColor: "gray.100", fontSize: "12px", color: "gray.400", children: "\u00A9 2023 - 2026 DataLabs inc." })] }));
};

const draw = (canvas) => {
    const { ctx, cssW, cssH } = setupCanvas(canvas);
    drawGrid(ctx, cssW, cssH);
    const scale = cssH / 450;
    const cx = cssW / 2;
    const cy = cssH / 2 + Math.round(4 * scale);
    // Gear geometry (proportions echo the design's toothed ring + hub)
    const teeth = 9;
    const rOuter = Math.round(144 * scale);
    const rRoot = Math.round(117 * scale);
    const rInner = Math.round(57 * scale);
    const off = document.createElement('canvas');
    off.width = cssW;
    off.height = cssH;
    const o = off.getContext('2d');
    // Thick stroke outline only — no fill — so dots appear on the edges
    o.strokeStyle = '#fff';
    o.lineWidth = Math.max(8, Math.round(22 * scale));
    o.lineJoin = 'round';
    o.lineCap = 'round';
    // Toothed ring
    o.beginPath();
    const segs = teeth * 4;
    for (let i = 0; i <= segs; i++) {
        const ang = (i / segs) * Math.PI * 2 - Math.PI / 2;
        const phase = i % 4;
        const r = phase === 1 || phase === 2 ? rOuter : rRoot;
        const x = cx + Math.cos(ang) * r;
        const y = cy + Math.sin(ang) * r;
        if (i === 0)
            o.moveTo(x, y);
        else
            o.lineTo(x, y);
    }
    o.closePath();
    o.stroke();
    // Inner hub
    o.beginPath();
    o.arc(cx, cy, rInner, 0, Math.PI * 2);
    o.stroke();
    const { pts, minX, maxX, maxY } = samplePoints(o, cssW, cssH);
    drawPointCloud(ctx, pts, makeRng());
    const rulerOffset = Math.round(10 + 12 * scale);
    drawHorizontalRuler(ctx, {
        x1: minX,
        x2: maxX,
        y: maxY + rulerOffset * 1.5,
        scale,
        color: '#CA8A04',
        label: 'STATUS: MAINTENANCE',
    });
};
const ABOUT_URL = 'https://hatsuly.datalabs.jp/';
/**
 * MaintenancePage - Full-page maintenance screen shown when the backend reports
 * `serviceStatus.isDown.enabled`. Store-agnostic: the status is passed in via props.
 */
const MaintenancePage = ({ isDown }) => {
    const { t } = useTranslation();
    const canvasRef = useCanvasDraw(draw);
    const body = isDown.message || isDown.urlText ? (jsxs(VStack, { gap: 1, children: [jsx(Text$2, { children: isDown.message }), isDown.url && isDown.urlText && (jsx(Link, { href: isDown.url, variant: "underline", target: "_blank", children: isDown.urlText }))] })) : (t('maintenance.body'));
    return (jsxs(Flex, { minH: "100vh", direction: "column", bg: "white", children: [jsx(Flex, { as: "header", align: "center", gap: "9px", px: 10, py: "22px", borderBottom: "1px solid", borderColor: "gray.100", children: jsx(SvgLogoFull, {}) }), jsxs(Flex, { as: "main", flex: 1, direction: "column", align: "center", justify: "center", px: 6, pt: "56px", pb: "64px", children: [jsx(Box, { w: "full", maxW: "960px", border: "1px solid", borderColor: "gray.200", borderRadius: "10px", overflow: "hidden", children: jsx("canvas", { ref: canvasRef, style: { display: 'block', width: '100%', aspectRatio: '32 / 15' } }) }), jsxs(VStack, { mt: 10, gap: 4, maxW: "510px", textAlign: "center", children: [jsx(Text$2, { fontWeight: "bold", fontSize: "30px", color: "gray.900", letterSpacing: "-0.01em", lineHeight: "1.2", children: t('maintenance.heading') }), jsx(Text$2, { fontSize: "15px", lineHeight: "1.75", color: "gray.600", whiteSpace: "pre-line", children: body }), jsx(Button, { mt: 4, asChild: true, colorPalette: "blue", children: jsx(Link, { href: ABOUT_URL, target: "_blank", children: t('maintenance.about') }) })] })] }), jsx(Box, { as: "footer", px: 10, py: 5, borderTop: "1px solid", borderColor: "gray.100", fontSize: "12px", color: "gray.400", children: "\u00A9 2023 - 2026 DataLabs inc." })] }));
};

const metaEnv = import.meta.env;
metaEnv?.MODE || 'production';
metaEnv?.REACT_APP_ENV;
metaEnv?.REACT_APP_AUTH0_DOMAIN;
metaEnv?.REACT_APP_AUTH0_CLIENT_ID;
metaEnv?.REACT_APP_AUTH0_AUDIENCE;
const API_GATEWAY_URL = metaEnv?.REACT_APP_API_GATEWAY_URL;
metaEnv?.REACT_APP_MIXPANEL_TOKEN;
metaEnv?.REACT_APP_FORCE_MIXPANEL === 'true';
metaEnv?.REACT_APP_HATSULY_URL;
metaEnv?.REACT_APP_HATSULY_DASHBOARD_URL;
const MARKLY_URL = metaEnv?.REACT_APP_MARKLY_URL;
metaEnv?.REACT_APP_CAPTURE_URL;

var AssessmentType;
(function (AssessmentType) {
    AssessmentType["Damage"] = "damage";
    AssessmentType["Span"] = "span";
})(AssessmentType || (AssessmentType = {}));

/**
 * Type guard to check if an object conforms to the ErrorResponse structure
 *
 * @param body - The object to check
 * @returns True if the object conforms to the ErrorResponse structure, false otherwise
 */
const isErrorBody = (body) => 'status_id' in body && 'status_message' in body;

class GenericError {
    constructor(translationKey, code) {
        this.name = 'GenericError';
        this.translationKey = translationKey;
        this.code = code;
    }
    toJSON() {
        return {
            name: this.name,
            code: this.code,
            translationKey: this.translationKey,
        };
    }
    static fromJSON(json) {
        if (json.name !== 'GenericError') {
            throw new Error(`Invalid error type: expected 'GenericError', got '${json.name}'`);
        }
        return new GenericError(json.translationKey, json.code);
    }
}

/**
 * Wraps an API function with standard success and error handlers.
 *
 * @param apiFunc The API function to wrap.
 * @returns
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function withStandardHandlers(apiFunc, translationKey, unwrapResults = true) {
    return async (...args) => {
        const res = await apiFunc(...args);
        if (!res.ok) {
            const body = (await res.json());
            if (body instanceof Object && isErrorBody(body)) {
                throw new GenericError(translationKey, body.status_id);
            }
            throw new GenericError(translationKey, res.status);
        }
        if (res.status === 204)
            return {}; // Return empty object for 204 No Content
        const result = await res.json();
        if (!(result instanceof Object)) {
            return result;
        }
        return (unwrapResults && 'results' in result ? result.results : result);
    };
}

var PhotoCategory;
(function (PhotoCategory) {
    PhotoCategory["Damage"] = "damage";
    PhotoCategory["General"] = "general";
    PhotoCategory["Blackboard"] = "blackboard";
    PhotoCategory["Overview"] = "overview";
    PhotoCategory["Reference"] = "reference";
    PhotoCategory["Equipment"] = "equipment";
})(PhotoCategory || (PhotoCategory = {}));
var PhotoStatus;
(function (PhotoStatus) {
    PhotoStatus["Uploaded"] = "uploaded";
    PhotoStatus["Processed"] = "processed";
})(PhotoStatus || (PhotoStatus = {}));
var PhotoType;
(function (PhotoType) {
    PhotoType["Main"] = "main";
    PhotoType["Closeup"] = "closeup";
    PhotoType["Measurement"] = "measurement";
    PhotoType["DifferentAngle"] = "different_angle";
    PhotoType["AfterRemoval"] = "after_removal";
    PhotoType["AfterTreatment"] = "after_treatment";
    PhotoType["ThinningArea"] = "thinning_area";
    PhotoType["HealthyArea"] = "healthy_area";
})(PhotoType || (PhotoType = {}));

var FacilityType;
(function (FacilityType) {
    FacilityType["None"] = "none";
    FacilityType["Tunnel"] = "tunnel";
    FacilityType["Bridge"] = "bridge";
    FacilityType["Culvert"] = "culvert";
    FacilityType["Shed"] = "shed";
    FacilityType["Overpass"] = "overpass";
    FacilityType["Other"] = "other";
})(FacilityType || (FacilityType = {}));
[
    FacilityType.Tunnel,
    FacilityType.Bridge,
    FacilityType.Culvert,
    FacilityType.Shed,
    FacilityType.Overpass,
    FacilityType.Other,
];
var FacilityDataSource;
(function (FacilityDataSource) {
    FacilityDataSource["None"] = "none";
    FacilityDataSource["MlitTunnelDb"] = "mlit_tunnel_db";
    FacilityDataSource["MlitBridgeDb"] = "mlit_bridge_db";
    FacilityDataSource["Manual"] = "manual";
})(FacilityDataSource || (FacilityDataSource = {}));
const FacilityCreateRequestBodyKeys = [
    'facility_name',
    'facility_type',
    'external_id',
    'data_source',
    'route_name',
    'route_classification',
    'kilopost_start',
    'kilopost_end',
    'prefecture_code',
    'municipality_code',
    'address',
    'latitude',
    'longitude',
    'coordinate_system',
    'tunnel_specs',
    'bridge_specs',
    'administrator_name',
    'administrator_code',
    'overall_soundness',
];
difference(FacilityCreateRequestBodyKeys, ['facility_type']);

const POTREE_FILES_API_URL = `${API_GATEWAY_URL}/potree-files`;
const DOWN_SAMPLED_FILES_API_URL = `${API_GATEWAY_URL}/down-sampled-files`;
/**
 * Get signed URL for Potree files.
 *
 * @param access_token Auth0 Access token
 * @param project_id Project ID of the inspection area
 * @param inspection_area_id Inspection Area ID of the potree files
 * @returns
 */
const getSignedUrlForPotreeFiles = (accessToken, projectId, inspectionAreaId, blueprintId) => {
    const params = new URLSearchParams({
        project_id: projectId,
        inspection_area_id: inspectionAreaId,
    });
    if (blueprintId) {
        params.append('blueprint_id', blueprintId);
    }
    const fn = () => fetch(`${POTREE_FILES_API_URL}?${params.toString()}`, {
        method: 'GET',
        headers: {
            'X-Authorization': `Bearer ${accessToken}`,
        },
    });
    return withStandardHandlers(fn, 'errors.file.getSignedUrl')();
};
/**
 * Get a signed URL for downloading a down-sampled point cloud file.
 * @param accessToken - The access token for authentication.
 * @param projectId - The project ID.
 * @param inspectionAreaId - The inspection area ID.
 * @returns A signed URL string.
 */
const getSignedUrlForGetDownSampledFile = (accessToken, projectId, inspectionAreaId) => {
    const params = new URLSearchParams({
        project_id: projectId,
        inspection_area_id: inspectionAreaId,
    });
    const fn = () => fetch(`${DOWN_SAMPLED_FILES_API_URL}?${params.toString()}`, {
        method: 'GET',
        headers: {
            'X-Authorization': `Bearer ${accessToken}`,
        },
    });
    return withStandardHandlers(fn, 'errors.file.getSignedUrl')().then((response) => response.url);
};

var PlaneSide;
(function (PlaneSide) {
    PlaneSide["UPPER"] = "upper";
    PlaneSide["LOWER"] = "lower";
})(PlaneSide || (PlaneSide = {}));
var ShapeKeyType;
(function (ShapeKeyType) {
    ShapeKeyType["CYLINDER"] = "cylinders";
    ShapeKeyType["POLYGON"] = "polygons";
})(ShapeKeyType || (ShapeKeyType = {}));
/** Terminal states of a `detect-shapes` job as reported by the job-status endpoint. */
var DetectShapesJobStatus;
(function (DetectShapesJobStatus) {
    DetectShapesJobStatus["SUCCEEDED"] = "SUCCEEDED";
    DetectShapesJobStatus["FAILED"] = "FAILED";
})(DetectShapesJobStatus || (DetectShapesJobStatus = {}));

var InspectionItemType;
(function (InspectionItemType) {
    InspectionItemType["Volume"] = "volume";
    InspectionItemType["PlaneToPlaneDistance"] = "plane_to_plane_distance";
    InspectionItemType["PlaneToCylindersDistance"] = "plane_to_cylinders_distance";
    InspectionItemType["Grid"] = "grid";
    InspectionItemType["PolygonLength1"] = "polygon_length_1";
    InspectionItemType["PolygonLength2"] = "polygon_length_2";
    InspectionItemType["PolygonPerimeter"] = "polygon_perimeter";
    InspectionItemType["PolygonArea"] = "polygon_area";
    InspectionItemType["LengthWithDistanceTool"] = "length_with_distance_tool";
    InspectionItemType["EdgeLength"] = "edge_length";
    InspectionItemType["PolylineLength"] = "polyline_length";
    InspectionItemType["PolylineWidth"] = "polyline_width";
})(InspectionItemType || (InspectionItemType = {}));

const GET_PROJECT_JOBS_API_URL = (projectId) => `${API_GATEWAY_URL}/projects/${projectId}/jobs`;
const GET_INSPECTION_AREA_JOBS_API_URL = (projectId, inspectionAreaId) => `${API_GATEWAY_URL}/projects/${projectId}/inspection-areas/${inspectionAreaId}/jobs`;
const ACK_JOBS_API_URL = (projectId, inspectionAreaId) => `${API_GATEWAY_URL}/projects/${projectId}/inspection-areas/${inspectionAreaId}/jobs:ack`;
/**
 * Get the background jobs of a project (optionally scoped to one inspection area), newest first.
 * The BE auto-fails RUNNING jobs past its server-side timeout, so callers need no timeout logic.
 *
 * @param accessToken Token
 * @param projectId Project ID
 * @param options Optional area scope + pagination
 * @return The page of jobs plus the pagination key for the next page (absent on the last page)
 */
const getJobs = (accessToken, projectId, options = {}) => {
    const { inspectionAreaId, limit, lastEvaluatedKey } = options;
    const baseUrl = inspectionAreaId
        ? GET_INSPECTION_AREA_JOBS_API_URL(projectId, inspectionAreaId)
        : GET_PROJECT_JOBS_API_URL(projectId);
    const params = new URLSearchParams();
    if (limit)
        params.set('limit', String(limit));
    if (lastEvaluatedKey)
        params.set('last_evaluated_key', JSON.stringify(lastEvaluatedKey));
    const query = params.toString();
    const fn = () => fetch(`${baseUrl}${query ? `?${query}` : ''}`, {
        headers: {
            'X-Authorization': `Bearer ${accessToken}`,
        },
    });
    // The caller needs `last_evaluated_key` alongside `results`, so unwrapping is disabled.
    return withStandardHandlers(fn, 'errors.jobs.get', false)();
};
/**
 * Acknowledge finished jobs in batch (`PATCH jobs ack`, max 100 ids), scoped to a project +
 * inspection area. Acked jobs are the ones a client has already surfaced to the user.
 *
 * @param accessToken Token
 * @param projectId Project ID
 * @param inspectionAreaId InspectionArea ID the jobs belong to
 * @param jobIds `job_id`s to mark acknowledged
 * @return Per-job `success` / `not_found` / `failed` outcomes
 */
const ackJobs = (accessToken, projectId, inspectionAreaId, jobIds) => {
    const fn = () => fetch(ACK_JOBS_API_URL(projectId, inspectionAreaId), {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'X-Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ job_ids: jobIds }),
    });
    return withStandardHandlers(fn, 'errors.jobs.ack', false)();
};

var LineStyle;
(function (LineStyle) {
    LineStyle["Solid"] = "solid";
    LineStyle["Dashed"] = "dashed";
})(LineStyle || (LineStyle = {}));

const MILLIMETER_SCALE = 1000;
/**
 * Round a number to a specified decimal place
 * @param {number} num Number to round
 * @param {string} decimalBase The decimal base to round to, e.g., '0.01' rounds to 2 decimal places
 * @return {number} Rounded value
 */
const roundNumber = (num, decimalBase) => {
    //* Count the number of zeros in decimalBase
    const zeroMatch = decimalBase.match(/0/g);
    const zeroCount = zeroMatch ? zeroMatch.length : 0;
    //* Convert decimalBase to an integer to avoid rounding errors
    const intDecimalBase = 10 ** zeroCount;
    return Math.round(num * intDecimalBase) / intDecimalBase;
};
const meterToMillimeter = (value) => value * MILLIMETER_SCALE;
const getPrecision = (step) => String(step).split('.')[1]?.length || 1;

var SeverityGrade;
(function (SeverityGrade) {
    SeverityGrade["A"] = "a";
    SeverityGrade["B"] = "b";
    SeverityGrade["C"] = "c";
    SeverityGrade["D"] = "d";
    SeverityGrade["E"] = "e";
})(SeverityGrade || (SeverityGrade = {}));
const SeverityGradeOptions = Object.freeze(Object.values(SeverityGrade));
var SeverityChange;
(function (SeverityChange) {
    SeverityChange["Unchanged"] = "unchanged";
    SeverityChange["Worsened"] = "worsened";
    SeverityChange["Improved"] = "improved";
})(SeverityChange || (SeverityChange = {}));
Object.freeze(Object.values(SeverityChange));
var CountermeasureCategory;
(function (CountermeasureCategory) {
    CountermeasureCategory["A0"] = "A0";
    CountermeasureCategory["A"] = "A";
    CountermeasureCategory["B"] = "B";
    CountermeasureCategory["C"] = "C";
    CountermeasureCategory["E1"] = "E1";
    CountermeasureCategory["E2"] = "E2";
    CountermeasureCategory["M"] = "M";
    CountermeasureCategory["S1"] = "S1";
    CountermeasureCategory["S2"] = "S2";
})(CountermeasureCategory || (CountermeasureCategory = {}));
Object.freeze(Object.values(CountermeasureCategory));
var SoundnessRating;
(function (SoundnessRating) {
    SoundnessRating["I"] = "I";
    SoundnessRating["II"] = "II";
    SoundnessRating["III"] = "III";
    SoundnessRating["IV"] = "IV";
})(SoundnessRating || (SoundnessRating = {}));
Object.freeze(Object.values(SoundnessRating));
({
    [SeverityGrade.A]: SoundnessRating.I,
    [SeverityGrade.B]: SoundnessRating.II,
    [SeverityGrade.C]: SoundnessRating.III,
    [SeverityGrade.D]: SoundnessRating.IV,
    [SeverityGrade.E]: null,
});
var ProgressionStatus;
(function (ProgressionStatus) {
    ProgressionStatus["Progressive"] = "progressive";
    ProgressionStatus["Stable"] = "stable";
    ProgressionStatus["Unknown"] = "unknown";
})(ProgressionStatus || (ProgressionStatus = {}));
Object.freeze(Object.values(ProgressionStatus));
var DamageCause;
(function (DamageCause) {
    DamageCause["AgingDeterioration"] = "aging_deterioration";
    DamageCause["DryingShrinkage"] = "drying_shrinkage";
    DamageCause["ThermalStress"] = "thermal_stress";
    DamageCause["StructuralStress"] = "structural_stress";
    DamageCause["GroundMovement"] = "ground_movement";
    DamageCause["FreezeThaw"] = "freeze_thaw";
    DamageCause["WaterInfiltration"] = "water_infiltration";
    DamageCause["GroundwaterPressure"] = "groundwater_pressure";
    DamageCause["ChlorideAttack"] = "chloride_attack";
    DamageCause["Carbonation"] = "carbonation";
    DamageCause["AlkaliSilicaReaction"] = "alkali_silica_reaction";
    DamageCause["ImpactDamage"] = "impact_damage";
    DamageCause["FireDamage"] = "fire_damage";
    DamageCause["ConstructionDefect"] = "construction_defect";
    DamageCause["InsufficientBackfill"] = "insufficient_backfill";
    DamageCause["JointDegradation"] = "joint_degradation";
    DamageCause["WaterErosion"] = "water_erosion";
    DamageCause["SeismicDamage"] = "seismic_damage";
})(DamageCause || (DamageCause = {}));
Object.freeze(Object.values(DamageCause));
var AssessmentStatus;
(function (AssessmentStatus) {
    AssessmentStatus["Draft"] = "draft";
    AssessmentStatus["Confirmed"] = "confirmed";
    AssessmentStatus["Reviewed"] = "reviewed";
})(AssessmentStatus || (AssessmentStatus = {}));
Object.freeze(Object.values(AssessmentStatus));

/**
 * Default labels for inspection item types.
 */
({
    [InspectionItemType.Volume]: '体積',
    [InspectionItemType.PolygonArea]: '面積',
    [InspectionItemType.PolylineLength]: '延長',
    [InspectionItemType.LengthWithDistanceTool]: '距離',
});

var ProductType;
(function (ProductType) {
    ProductType["Base"] = "base";
    ProductType["Hatsuly"] = "hatsuly";
    ProductType["Markly"] = "markly";
    ProductType["Admin"] = "admin";
})(ProductType || (ProductType = {}));
var UserType;
(function (UserType) {
    UserType["Admin"] = "admin";
    UserType["PayingUser"] = "paying_user";
    UserType["NonPayingUser"] = "non_paying_user";
    UserType["BetaUser"] = "beta_user";
    UserType["BaseUser"] = "base_user";
})(UserType || (UserType = {}));

var CursorState;
(function (CursorState) {
    CursorState["NONE"] = "none";
    CursorState["DEFAULT"] = "default";
    CursorState["GRAB"] = "grab";
    CursorState["GRABBING"] = "grabbing";
    CursorState["POINTER"] = "pointer";
    CursorState["CROSSHAIR"] = "crosshair";
    CursorState["MOVE"] = "move";
    CursorState["ZOOM_IN"] = "zoom-in";
    CursorState["ZOOM_OUT"] = "zoom-out";
})(CursorState || (CursorState = {}));

/**
 * Damage / inspection vocabulary differs per facility type. The platform supports two facility
 * types — bridge and tunnel — each with its own set of component types and damage types, valid
 * severity grades, and per-damage-type measurement schemas.
 *
 * The frontend works in ids; the `code` carried alongside each id is set automatically on selection
 * (transparent to the user). Labels are not stored here — they live in the i18n locale files,
 * namespaced by facility type (e.g. `object.componentType.bridge.*`, `object.defectType.tunnel.*`).
 */
var DamageCategory;
(function (DamageCategory) {
    DamageCategory["Linear"] = "linear";
    DamageCategory["Surface"] = "surface";
    DamageCategory["Point"] = "point";
    DamageCategory["Volumetric"] = "volumetric";
    DamageCategory["Environmental"] = "environmental";
    DamageCategory["StructuralDamage"] = "structural_damage";
    DamageCategory["Other"] = "other";
})(DamageCategory || (DamageCategory = {}));
// ===== Component types =====
var TunnelComponentType;
(function (TunnelComponentType) {
    TunnelComponentType["Crown"] = "crown";
    TunnelComponentType["Sidewall"] = "sidewall";
    TunnelComponentType["Invert"] = "invert";
    TunnelComponentType["Portal"] = "portal";
    TunnelComponentType["Ceiling"] = "ceiling";
    TunnelComponentType["Attachments"] = "attachments";
})(TunnelComponentType || (TunnelComponentType = {}));
var BridgeComponentType;
(function (BridgeComponentType) {
    BridgeComponentType["MainGirder"] = "main_girder";
    BridgeComponentType["CrossBeam"] = "cross_beam";
    BridgeComponentType["Stringer"] = "stringer";
    BridgeComponentType["DeckSlab"] = "deck_slab";
    BridgeComponentType["SuperstructureOther"] = "superstructure_other";
    BridgeComponentType["Pier"] = "pier";
    BridgeComponentType["Abutment"] = "abutment";
    BridgeComponentType["Foundation"] = "foundation";
    BridgeComponentType["SubstructureOther"] = "substructure_other";
    BridgeComponentType["Bearing"] = "bearing";
    BridgeComponentType["ConnectionOther"] = "connection_other";
    BridgeComponentType["ExpansionJoint"] = "expansion_joint";
    BridgeComponentType["FailSafe"] = "fail_safe";
    BridgeComponentType["Curb"] = "curb";
    BridgeComponentType["Guardrail"] = "guardrail";
    BridgeComponentType["Drainage"] = "drainage";
    BridgeComponentType["Pavement"] = "pavement";
    BridgeComponentType["Staircase"] = "staircase";
    BridgeComponentType["SignBoard"] = "sign_board";
    BridgeComponentType["Lighting"] = "lighting";
    BridgeComponentType["InspectionGallery"] = "inspection_gallery";
})(BridgeComponentType || (BridgeComponentType = {}));
// ===== Damage types =====
var TunnelDamageType;
(function (TunnelDamageType) {
    TunnelDamageType["Crack"] = "crack";
    TunnelDamageType["Delamination"] = "delamination";
    TunnelDamageType["Spalling"] = "spalling";
    TunnelDamageType["Falloff"] = "falloff";
    TunnelDamageType["Deformation"] = "deformation";
    TunnelDamageType["WaterLeakage"] = "water_leakage";
    TunnelDamageType["MaterialDeterioration"] = "material_deterioration";
    TunnelDamageType["RebarExposure"] = "rebar_exposure";
    TunnelDamageType["CavityVoid"] = "cavity_void";
    TunnelDamageType["Efflorescence"] = "efflorescence";
    TunnelDamageType["FreeLime"] = "free_lime";
    TunnelDamageType["RustStaining"] = "rust_staining";
    TunnelDamageType["Honeycombing"] = "honeycombing";
})(TunnelDamageType || (TunnelDamageType = {}));
var BridgeDamageType;
(function (BridgeDamageType) {
    BridgeDamageType["CorrosionSteel"] = "corrosion_steel";
    BridgeDamageType["CrackSteel"] = "crack_steel";
    BridgeDamageType["BoltLooseningFalloff"] = "bolt_loosening_falloff";
    BridgeDamageType["RuptureSteel"] = "rupture_steel";
    BridgeDamageType["AnticorrosionDeterioration"] = "anticorrosion_deterioration";
    BridgeDamageType["CrackConcrete"] = "crack_concrete";
    BridgeDamageType["SpallingRebarExposure"] = "spalling_rebar_exposure";
    BridgeDamageType["LeakageEfflorescence"] = "leakage_efflorescence";
    BridgeDamageType["PunchingFailure"] = "punching_failure";
    BridgeDamageType["ReinforcementDamage"] = "reinforcement_damage";
    BridgeDamageType["CrackDeckSlab"] = "crack_deck_slab";
    BridgeDamageType["Delamination"] = "delamination";
    BridgeDamageType["JointAbnormality"] = "joint_abnormality";
    BridgeDamageType["RoadSurfaceUnevenness"] = "road_surface_unevenness";
    BridgeDamageType["PavementAnomaly"] = "pavement_anomaly";
    BridgeDamageType["BearingDysfunction"] = "bearing_dysfunction";
    BridgeDamageType["Other"] = "other";
    BridgeDamageType["AnchorageAbnormality"] = "anchorage_abnormality";
    BridgeDamageType["MaterialDeterioration"] = "material_deterioration";
    BridgeDamageType["WaterLeakagePuddling"] = "water_leakage_puddling";
    BridgeDamageType["AbnormalSoundVibration"] = "abnormal_sound_vibration";
    BridgeDamageType["AbnormalDeflection"] = "abnormal_deflection";
    BridgeDamageType["DeformationDefect"] = "deformation_defect";
    BridgeDamageType["SedimentClogging"] = "sediment_clogging";
    BridgeDamageType["SettlementTilt"] = "settlement_tilt";
    BridgeDamageType["Scour"] = "scour";
    BridgeDamageType["None"] = "none";
})(BridgeDamageType || (BridgeDamageType = {}));
/** All severity grades — used when a damage type imposes no grade constraint (i.e. tunnel). */
const ALL_SEVERITY_GRADES = [
    SeverityGrade.A,
    SeverityGrade.B,
    SeverityGrade.C,
    SeverityGrade.D,
    SeverityGrade.E,
];
// ===== Tunnel spec =====
[
    { id: TunnelComponentType.Crown, code: '01' },
    { id: TunnelComponentType.Sidewall, code: '02' },
    { id: TunnelComponentType.Invert, code: '03' },
    { id: TunnelComponentType.Portal, code: '04' },
    { id: TunnelComponentType.Ceiling, code: '05' },
    { id: TunnelComponentType.Attachments, code: '06' },
];
[
    {
        id: TunnelDamageType.Crack,
        code: '01',
        category: DamageCategory.Linear,
        validGrades: ALL_SEVERITY_GRADES,
        measurementSchema: [
            { field: 'length', type: 'number', unit: 'mm', required: true },
            { field: 'width', type: 'number', unit: 'mm', required: true },
            { field: 'pattern', type: 'string', unit: null, required: false },
        ],
    },
    {
        id: TunnelDamageType.Delamination,
        code: '02',
        category: DamageCategory.Surface,
        validGrades: ALL_SEVERITY_GRADES,
        measurementSchema: [
            { field: 'area', type: 'number', unit: 'm2', required: true },
            { field: 'depth', type: 'number', unit: 'mm', required: false },
        ],
    },
    {
        id: TunnelDamageType.Spalling,
        code: '03',
        category: DamageCategory.Surface,
        validGrades: ALL_SEVERITY_GRADES,
        measurementSchema: [
            { field: 'area', type: 'number', unit: 'm2', required: true },
            { field: 'depth', type: 'number', unit: 'mm', required: false },
        ],
    },
    {
        id: TunnelDamageType.Falloff,
        code: '04',
        category: DamageCategory.Surface,
        validGrades: ALL_SEVERITY_GRADES,
        measurementSchema: [
            { field: 'area', type: 'number', unit: 'm2', required: true },
            { field: 'depth', type: 'number', unit: 'mm', required: false },
        ],
    },
    {
        id: TunnelDamageType.Deformation,
        code: '05',
        category: DamageCategory.Volumetric,
        validGrades: ALL_SEVERITY_GRADES,
        measurementSchema: [
            { field: 'displacement', type: 'number', unit: 'mm', required: true },
            { field: 'direction', type: 'string', unit: null, required: false },
        ],
    },
    {
        id: TunnelDamageType.WaterLeakage,
        code: '06',
        category: DamageCategory.Environmental,
        validGrades: ALL_SEVERITY_GRADES,
        measurementSchema: [
            { field: 'level', type: 'number', unit: null, required: true, validation: { min: 1, max: 5 } },
            { field: 'flow_state', type: 'string', unit: null, required: false },
        ],
    },
    {
        id: TunnelDamageType.MaterialDeterioration,
        code: '07',
        category: DamageCategory.Surface,
        validGrades: ALL_SEVERITY_GRADES,
        measurementSchema: [{ field: 'area', type: 'number', unit: 'm2', required: false }],
    },
    {
        id: TunnelDamageType.RebarExposure,
        code: '08',
        category: DamageCategory.Point,
        validGrades: ALL_SEVERITY_GRADES,
        measurementSchema: [
            { field: 'length', type: 'number', unit: 'mm', required: false },
            { field: 'corrosion_grade', type: 'string', unit: null, required: false },
        ],
    },
    {
        id: TunnelDamageType.CavityVoid,
        code: '09',
        category: DamageCategory.Volumetric,
        validGrades: ALL_SEVERITY_GRADES,
        measurementSchema: [
            { field: 'depth', type: 'number', unit: 'mm', required: false },
            { field: 'diameter', type: 'number', unit: 'mm', required: false },
        ],
    },
    {
        id: TunnelDamageType.Efflorescence,
        code: '10',
        category: DamageCategory.Environmental,
        validGrades: ALL_SEVERITY_GRADES,
        measurementSchema: [{ field: 'area', type: 'number', unit: 'm2', required: false }],
    },
    {
        id: TunnelDamageType.FreeLime,
        code: '11',
        category: DamageCategory.Environmental,
        validGrades: ALL_SEVERITY_GRADES,
        measurementSchema: [{ field: 'area', type: 'number', unit: 'm2', required: false }],
    },
    {
        id: TunnelDamageType.RustStaining,
        code: '12',
        category: DamageCategory.Environmental,
        validGrades: ALL_SEVERITY_GRADES,
        measurementSchema: [{ field: 'area', type: 'number', unit: 'm2', required: false }],
    },
    {
        id: TunnelDamageType.Honeycombing,
        code: '13',
        category: DamageCategory.Surface,
        validGrades: ALL_SEVERITY_GRADES,
        measurementSchema: [
            { field: 'area', type: 'number', unit: 'm2', required: false },
            { field: 'depth', type: 'number', unit: 'mm', required: false },
        ],
    },
];
// ===== Bridge spec =====
[
    { id: BridgeComponentType.MainGirder, code: 'Mg' },
    { id: BridgeComponentType.CrossBeam, code: 'Cr' },
    { id: BridgeComponentType.Stringer, code: 'St' },
    { id: BridgeComponentType.DeckSlab, code: 'Ds' },
    { id: BridgeComponentType.SuperstructureOther, code: 'Uo' },
    { id: BridgeComponentType.Pier, code: 'Pr' },
    { id: BridgeComponentType.Abutment, code: 'Ab' },
    { id: BridgeComponentType.Foundation, code: 'Fd' },
    { id: BridgeComponentType.SubstructureOther, code: 'Lo' },
    { id: BridgeComponentType.Bearing, code: 'Bg' },
    { id: BridgeComponentType.ConnectionOther, code: 'Co' },
    { id: BridgeComponentType.ExpansionJoint, code: 'Ex' },
    { id: BridgeComponentType.FailSafe, code: 'Fs' },
    { id: BridgeComponentType.Curb, code: 'Cu' },
    { id: BridgeComponentType.Guardrail, code: 'Gr' },
    { id: BridgeComponentType.Drainage, code: 'Dr' },
    { id: BridgeComponentType.Pavement, code: 'Pv' },
    { id: BridgeComponentType.Staircase, code: 'Sc' },
    { id: BridgeComponentType.SignBoard, code: 'Sg' },
    { id: BridgeComponentType.Lighting, code: 'Lt' },
    { id: BridgeComponentType.InspectionGallery, code: 'Ig' },
];
const GRADES_FULL = [SeverityGrade.A, SeverityGrade.B, SeverityGrade.C, SeverityGrade.D, SeverityGrade.E];
const GRADES_AE = [SeverityGrade.A, SeverityGrade.E];
[
    {
        id: BridgeDamageType.CorrosionSteel,
        code: '01',
        category: DamageCategory.Surface,
        validGrades: GRADES_FULL,
        measurementSchema: [
            {
                field: 'corrosion_area',
                type: 'string',
                unit: null,
                required: true,
                validation: { oneOf: ['local', 'spread', 'wide'] },
            },
            {
                field: 'thickness_reduction',
                type: 'string',
                unit: null,
                required: true,
                validation: { oneOf: ['none', 'superficial', 'measurable_loss'] },
            },
        ],
    },
    {
        id: BridgeDamageType.CrackSteel,
        code: '02',
        category: DamageCategory.Linear,
        validGrades: GRADES_AE,
        measurementSchema: [{ field: 'crack_length', type: 'number', unit: 'mm', required: true }],
    },
    {
        id: BridgeDamageType.BoltLooseningFalloff,
        code: '03',
        category: DamageCategory.Point,
        validGrades: GRADES_AE,
        measurementSchema: [{ field: 'bolt_count', type: 'number', unit: null, required: false }],
    },
    {
        id: BridgeDamageType.RuptureSteel,
        code: '04',
        category: DamageCategory.StructuralDamage,
        validGrades: GRADES_AE,
        measurementSchema: [],
    },
    {
        id: BridgeDamageType.AnticorrosionDeterioration,
        code: '05',
        category: DamageCategory.Surface,
        validGrades: GRADES_FULL,
        measurementSchema: [{ field: 'deteriorated_area', type: 'number', unit: 'm2', required: false }],
    },
    {
        id: BridgeDamageType.CrackConcrete,
        code: '06',
        category: DamageCategory.Linear,
        validGrades: GRADES_FULL,
        measurementSchema: [
            { field: 'crack_width', type: 'number', unit: 'mm', required: true },
            {
                field: 'efflorescence_seepage',
                type: 'string',
                unit: null,
                required: true,
                validation: { oneOf: ['none', 'water_seepage', 'efflorescence', 'rust_stain'] },
            },
        ],
    },
    {
        id: BridgeDamageType.SpallingRebarExposure,
        code: '07',
        category: DamageCategory.Surface,
        validGrades: GRADES_FULL,
        measurementSchema: [
            {
                field: 'exposure_area',
                type: 'string',
                unit: null,
                required: true,
                validation: { oneOf: ['limited', 'wide'] },
            },
            {
                field: 'section_loss',
                type: 'string',
                unit: null,
                required: true,
                validation: { oneOf: ['unmeasurable', 'measurable_loss'] },
            },
        ],
    },
    {
        id: BridgeDamageType.LeakageEfflorescence,
        code: '08',
        category: DamageCategory.Environmental,
        validGrades: GRADES_FULL,
        measurementSchema: [
            {
                field: 'leakage_state',
                type: 'string',
                unit: null,
                required: true,
                validation: { oneOf: ['none', 'water_leakage', 'free_lime', 'rust_stain'] },
            },
        ],
    },
    {
        id: BridgeDamageType.PunchingFailure,
        code: '09',
        category: DamageCategory.Volumetric,
        validGrades: GRADES_AE,
        measurementSchema: [{ field: 'hole_area', type: 'number', unit: 'm2', required: false }],
    },
    {
        id: BridgeDamageType.ReinforcementDamage,
        code: '10',
        category: DamageCategory.Surface,
        validGrades: GRADES_AE,
        measurementSchema: [
            {
                field: 'material_type',
                type: 'string',
                unit: null,
                required: true,
                validation: { oneOf: ['steel_plate', 'fibers', 'cementitious', 'paint', 'steel_cover'] },
            },
        ],
    },
    {
        id: BridgeDamageType.CrackDeckSlab,
        code: '11',
        category: DamageCategory.Linear,
        validGrades: GRADES_FULL,
        measurementSchema: [
            {
                field: 'crack_pattern',
                type: 'string',
                unit: null,
                required: true,
                validation: { oneOf: ['one_directional', 'two_directional_lattice'] },
            },
        ],
    },
    {
        id: BridgeDamageType.Delamination,
        code: '12',
        category: DamageCategory.Surface,
        validGrades: GRADES_FULL,
        measurementSchema: [{ field: 'delamination_area', type: 'number', unit: 'm2', required: false }],
    },
    {
        id: BridgeDamageType.JointAbnormality,
        code: '13',
        category: DamageCategory.Point,
        validGrades: GRADES_FULL,
        measurementSchema: [{ field: 'gap_width', type: 'number', unit: 'mm', required: false }],
    },
    {
        id: BridgeDamageType.RoadSurfaceUnevenness,
        code: '14',
        category: DamageCategory.Volumetric,
        validGrades: GRADES_AE,
        measurementSchema: [{ field: 'level_difference', type: 'number', unit: 'mm', required: true }],
    },
    {
        id: BridgeDamageType.PavementAnomaly,
        code: '15',
        category: DamageCategory.Surface,
        validGrades: GRADES_FULL,
        measurementSchema: [
            {
                field: 'anomaly_type',
                type: 'string',
                unit: null,
                required: false,
                validation: { oneOf: ['crack', 'rutting', 'pothole'] },
            },
        ],
    },
    {
        id: BridgeDamageType.BearingDysfunction,
        code: '16',
        category: DamageCategory.StructuralDamage,
        validGrades: GRADES_AE,
        measurementSchema: [
            {
                field: 'dysfunction_state',
                type: 'string',
                unit: null,
                required: true,
                validation: { oneOf: ['functioning', 'severely_obstructed', 'broken', 'uplifted'] },
            },
        ],
    },
    {
        id: BridgeDamageType.Other,
        code: '17',
        category: DamageCategory.Other,
        validGrades: GRADES_FULL,
        measurementSchema: [{ field: 'description', type: 'string', unit: null, required: false }],
    },
    {
        id: BridgeDamageType.AnchorageAbnormality,
        code: '18',
        category: DamageCategory.Point,
        validGrades: GRADES_AE,
        measurementSchema: [
            {
                field: 'damage_state',
                type: 'string',
                unit: null,
                required: true,
                validation: { oneOf: ['none', 'rust_stain', 'spalling', 'exposed_wedges'] },
            },
        ],
    },
    {
        id: BridgeDamageType.MaterialDeterioration,
        code: '19',
        category: DamageCategory.Surface,
        validGrades: GRADES_FULL,
        measurementSchema: [],
    },
    {
        id: BridgeDamageType.WaterLeakagePuddling,
        code: '20',
        category: DamageCategory.Environmental,
        validGrades: GRADES_FULL,
        measurementSchema: [],
    },
    {
        id: BridgeDamageType.AbnormalSoundVibration,
        code: '21',
        category: DamageCategory.Environmental,
        validGrades: GRADES_FULL,
        measurementSchema: [],
    },
    {
        id: BridgeDamageType.AbnormalDeflection,
        code: '22',
        category: DamageCategory.Volumetric,
        validGrades: GRADES_FULL,
        measurementSchema: [],
    },
    {
        id: BridgeDamageType.DeformationDefect,
        code: '23',
        category: DamageCategory.Volumetric,
        validGrades: GRADES_FULL,
        measurementSchema: [],
    },
    {
        id: BridgeDamageType.SedimentClogging,
        code: '24',
        category: DamageCategory.Environmental,
        validGrades: GRADES_FULL,
        measurementSchema: [],
    },
    {
        id: BridgeDamageType.SettlementTilt,
        code: '25',
        category: DamageCategory.Volumetric,
        validGrades: GRADES_AE,
        measurementSchema: [],
    },
    {
        id: BridgeDamageType.Scour,
        code: '26',
        category: DamageCategory.Volumetric,
        validGrades: GRADES_AE,
        measurementSchema: [{ field: 'scour_depth', type: 'number', unit: 'm', required: false }],
    },
    {
        id: BridgeDamageType.None,
        code: '00',
        category: DamageCategory.Other,
        validGrades: [SeverityGrade.A],
        measurementSchema: [],
    },
];
({
    [FacilityType.Tunnel]: {
        },
    [FacilityType.Bridge]: {
        },
});

var EditorColoringType;
(function (EditorColoringType) {
    EditorColoringType["Group"] = "group";
    EditorColoringType["Element"] = "element";
    EditorColoringType["Auto"] = "auto";
})(EditorColoringType || (EditorColoringType = {}));

/**
 * The display configuration an inspection area falls back to when it has none saved.
 *
 * Shared because both 3D hosts need the same fallback: the Editor seeds its settings store from
 * it, and the Platform's 3D view seeds its live display state from it.
 */
({
    general: {
        display_type: EditorColoringType.Auto}});

var EventType;
(function (EventType) {
    EventType["PeriodicInspection"] = "periodic";
    EventType["EmergencyInspection"] = "emergency";
    EventType["RepairConstruction"] = "repair";
    EventType["FollowUpInspection"] = "follow_up";
})(EventType || (EventType = {}));
Object.freeze(Object.values(EventType));
var InspectionStatus;
(function (InspectionStatus) {
    InspectionStatus["Draft"] = "draft";
    InspectionStatus["InProgress"] = "in_progress";
    InspectionStatus["Completed"] = "completed";
    InspectionStatus["Submitted"] = "submitted";
})(InspectionStatus || (InspectionStatus = {}));
Object.freeze(Object.values(InspectionStatus));
({
    [EventType.PeriodicInspection]: { },
    [EventType.FollowUpInspection]: { },
    [EventType.EmergencyInspection]: { },
    [EventType.RepairConstruction]: { },
});

var FileProcessingStatus;
(function (FileProcessingStatus) {
    FileProcessingStatus["Succeeded"] = "SUCCEEDED";
    FileProcessingStatus["Failed"] = "FAILED";
    FileProcessingStatus["Running"] = "RUNNING";
})(FileProcessingStatus || (FileProcessingStatus = {}));

const HELP_CENTER_URL = 'https://datalabs-jp.notion.site/Hatsuly-Help-Center-66c3998d14fa4255b7dce709249315f6';

var ProjectSheetToleranceType;
(function (ProjectSheetToleranceType) {
    ProjectSheetToleranceType["WithinTolerance"] = "within_tolerance";
    ProjectSheetToleranceType["GteDesignedValue"] = "gte_designed_value";
    ProjectSheetToleranceType["LteDesignedValue"] = "lte_designed_value";
    ProjectSheetToleranceType["AsymmetricTolerance"] = "asymmetric_tolerance";
})(ProjectSheetToleranceType || (ProjectSheetToleranceType = {}));
var ProjectSheetItemsOrder;
(function (ProjectSheetItemsOrder) {
    ProjectSheetItemsOrder["Name"] = "by_element_name";
    ProjectSheetItemsOrder["CreatedAt"] = "by_created_at";
    ProjectSheetItemsOrder["CustomOrder"] = "by_display_order_on_3d_gui";
})(ProjectSheetItemsOrder || (ProjectSheetItemsOrder = {}));
/**
 * Which aggregate a かぶり厚 (cover-thickness) row shows / judges / exports.
 */
var CoverThicknessAggregate;
(function (CoverThicknessAggregate) {
    CoverThicknessAggregate["Min"] = "min";
    CoverThicknessAggregate["Max"] = "max";
    CoverThicknessAggregate["Avg"] = "avg";
})(CoverThicknessAggregate || (CoverThicknessAggregate = {}));

Object.freeze({
    default_construction_properties: {
        construction_project_name: '',
        construction_type: '',
        construction_type_detailed: '',
    },
    sheet_models_visibility: {
        volume: true,
        plane: true,
        length_with_distance_tool: true,
        polyline: true,
    },
    sheet_rows_visibility: {
        polygon_length_1: true,
        polygon_length_2: true,
        edge_length: false,
        edge_length_with_value: false,
        polygon_perimeter: true,
        polygon_area: true,
        grid: true,
        volume: true,
        polyline_length: true,
        min_grid_depth: false,
        max_grid_depth: false,
        length_with_distance_tool: true,
        upper_plane_to_cylinders_distance: true,
        lower_plane_to_cylinders_distance: true,
    },
    sheet_rows_tolerance_type: {
        polygon_length_1: ProjectSheetToleranceType.AsymmetricTolerance,
        polygon_length_2: ProjectSheetToleranceType.AsymmetricTolerance,
        edge_length: ProjectSheetToleranceType.AsymmetricTolerance,
        edge_length_with_value: ProjectSheetToleranceType.AsymmetricTolerance,
        polygon_perimeter: ProjectSheetToleranceType.AsymmetricTolerance,
        polygon_area: ProjectSheetToleranceType.AsymmetricTolerance,
        grid: ProjectSheetToleranceType.AsymmetricTolerance,
        volume: ProjectSheetToleranceType.AsymmetricTolerance,
        polyline_length: ProjectSheetToleranceType.AsymmetricTolerance,
        min_grid_depth: ProjectSheetToleranceType.AsymmetricTolerance,
        max_grid_depth: ProjectSheetToleranceType.AsymmetricTolerance,
        length_with_distance_tool: ProjectSheetToleranceType.AsymmetricTolerance,
        upper_plane_to_cylinders_distance: ProjectSheetToleranceType.AsymmetricTolerance,
        lower_plane_to_cylinders_distance: ProjectSheetToleranceType.AsymmetricTolerance,
    },
    sheet_cols_visibility: {
        estimated_value: true,
        designed_value: true,
        tolerance: true,
    },
    sheet_diagram_visibility: {
        plane_diagram: true,
        grid_diagram: true,
        polyline_diagram: true,
    },
    sheet_use_inspection_group_order: true,
    sheet_order_type_of_items: ProjectSheetItemsOrder.CustomOrder,
    cover_thickness_value_type: {
        upper: CoverThicknessAggregate.Min,
        lower: CoverThicknessAggregate.Min,
    },
});

class AbortError extends Error {
    constructor(message, url) {
        super(message || 'The operation was aborted.');
        this.name = 'AbortError';
        this.url = url;
    }
}

var BlueprintDrawingType;
(function (BlueprintDrawingType) {
    BlueprintDrawingType["Polyline"] = "polyline";
    BlueprintDrawingType["Polygon"] = "polygon";
    BlueprintDrawingType["Circle"] = "circle";
    BlueprintDrawingType["TextAnnotation"] = "annotation";
    BlueprintDrawingType["MeasurementLabel"] = "measurement";
})(BlueprintDrawingType || (BlueprintDrawingType = {}));
var BlueprintDrawingStyle;
(function (BlueprintDrawingStyle) {
    BlueprintDrawingStyle["StrokeColor"] = "strokeColor";
    BlueprintDrawingStyle["StrokeWidth"] = "strokeWidth";
    BlueprintDrawingStyle["StrokeStyle"] = "strokeStyle";
    BlueprintDrawingStyle["FillColor"] = "fillColor";
    BlueprintDrawingStyle["TextColor"] = "textColor";
    BlueprintDrawingStyle["TextSize"] = "textSize";
    BlueprintDrawingStyle["TextOffset"] = "textOffset";
})(BlueprintDrawingStyle || (BlueprintDrawingStyle = {}));
var BlueprintPolygonSubtype;
(function (BlueprintPolygonSubtype) {
    BlueprintPolygonSubtype["Polygon"] = "polygon";
    BlueprintPolygonSubtype["Rectangle"] = "rectangle";
})(BlueprintPolygonSubtype || (BlueprintPolygonSubtype = {}));

/**
 * Camera view orientation.
 */
var CameraViewOrientation;
(function (CameraViewOrientation) {
    CameraViewOrientation["FRONT"] = "front";
    CameraViewOrientation["BACK"] = "back";
    CameraViewOrientation["TOP"] = "top";
    CameraViewOrientation["BOTTOM"] = "bottom";
    CameraViewOrientation["LEFT"] = "left";
    CameraViewOrientation["RIGHT"] = "right";
})(CameraViewOrientation || (CameraViewOrientation = {}));

var GridOrderDirection;
(function (GridOrderDirection) {
    /**
     * Top-to-bottom then left-to-right.
     */
    GridOrderDirection["Vertical"] = "vertical";
    /**
     * Left-to-right then top-to-bottom.
     */
    GridOrderDirection["Horizontal"] = "horizontal";
})(GridOrderDirection || (GridOrderDirection = {}));
var GridType;
(function (GridType) {
    /**
     * Grid is generated from the center of the volume.
     */
    GridType["CenterBased"] = "center_based";
    /**
     * Grid is generated from the edge of the volume.
     */
    GridType["EdgeBased"] = "edge_based";
})(GridType || (GridType = {}));

/** Lifecycle states of a background job (`GET jobs` auto-fails RUNNING jobs past the server timeout). */
var JobStatus;
(function (JobStatus) {
    JobStatus["Running"] = "RUNNING";
    JobStatus["Succeeded"] = "SUCCEEDED";
    JobStatus["Failed"] = "FAILED";
})(JobStatus || (JobStatus = {}));
/** First-level job → tool discriminator (`detect_shapes` further splits on the result's `shape_type`). */
var JobKind;
(function (JobKind) {
    JobKind["CrackDetection"] = "crack_detection";
    JobKind["ChalkDetection"] = "chalk_detection";
    JobKind["SavePolylinesWithWidthDetection"] = "save_polylines_with_width_detection";
    JobKind["DetectShapes"] = "detect_shapes";
    JobKind["EvaluateDistancesOnGrid"] = "evaluate_distances_on_grid";
    JobKind["DetectPolygonsVolume"] = "detect_polygons_volume";
    JobKind["ReevaluateVolumeAndGrid"] = "reevaluate_volume_and_grid";
    JobKind["EvaluateDepths"] = "evaluate_depths";
})(JobKind || (JobKind = {}));

var SubscriptionType;
(function (SubscriptionType) {
    SubscriptionType["None"] = "none";
    SubscriptionType["Base"] = "base";
    SubscriptionType["Features"] = "features";
})(SubscriptionType || (SubscriptionType = {}));

/**
 * Generate a camera profile from the live camera + controls. **Pure** — derives a serializable
 * `CameraProfile` (arcball state + orbit target + the six view-orientation positions) from the
 * current camera pose; it performs no I/O. Ported from the Editor's `@/services/Camera`
 * `getCameraProfile` (matrices/target/front) combined with the Editor `useEditor` orientation
 * derivation (back/top/bottom/left/right), and renamed per CODE_STYLE (`get` is for retrieval).
 *
 * @param camera The active camera to capture.
 * @param arcballControls The arcball controls, for the orbit target/gizmo.
 * @returns The full camera profile.
 */
const generateCameraProfile = (camera, arcballControls) => {
    const cameraMatrix = camera.matrix.toArray();
    const gizmoMatrix = arcballControls.gizmos.matrix.toArray();
    const target = arcballControls.gizmos.position.clone();
    // Camera basis (from the current pose) used to place the other orientations around the target.
    const cameraUp = new Vector3().setFromMatrixColumn(camera.matrix, 1);
    const direction = camera.getWorldDirection(new Vector3()).normalize();
    const left = new Vector3().crossVectors(cameraUp, direction).normalize();
    const up = new Vector3().crossVectors(direction, left).normalize();
    const distance = camera.position.distanceTo(target);
    return {
        state: {
            arcballState: {
                cameraFar: camera.far,
                cameraFov: 'fov' in camera ? camera.fov : -1,
                cameraMatrix: { elements: cameraMatrix },
                cameraNear: camera.near,
                cameraUp: {
                    x: cameraMatrix[4],
                    y: cameraMatrix[5],
                    z: cameraMatrix[6],
                },
                cameraZoom: camera.zoom,
                gizmoMatrix: { elements: gizmoMatrix },
            },
        },
        target: target.toArray(),
        positions: {
            [CameraViewOrientation.FRONT]: camera.position.toArray(),
            [CameraViewOrientation.BACK]: new Vector3()
                .copy(target)
                .sub(direction.clone().multiplyScalar(-distance))
                .toArray(),
            [CameraViewOrientation.TOP]: new Vector3().copy(target).add(up.clone().multiplyScalar(distance)).toArray(),
            [CameraViewOrientation.BOTTOM]: new Vector3()
                .copy(target)
                .add(up.clone().negate().multiplyScalar(distance))
                .toArray(),
            [CameraViewOrientation.LEFT]: new Vector3().copy(target).add(left.clone().multiplyScalar(distance)).toArray(),
            [CameraViewOrientation.RIGHT]: new Vector3()
                .copy(target)
                .add(left.clone().negate().multiplyScalar(distance))
                .toArray(),
        },
    };
};

/**
 * Determine if the damage has worsened compared to a previous assessment.
 * @param current The current damage assessment.
 */
const hasDamageWorsened = (current) => {
    // If there is no previous severity, we cannot determine if it has worsened
    if (!current.previous_severity)
        return false;
    const damageASeverityIndex = SeverityGradeOptions.indexOf(current.severity);
    const damageBSeverityIndex = SeverityGradeOptions.indexOf(current.previous_severity);
    return damageASeverityIndex > damageBSeverityIndex;
};
/**
 * Determine if the damage has improved compared to a previous assessment.
 * @param current The current damage assessment.
 */
const hasDamageImproved = (current) => {
    // If there is no previous severity, we cannot determine if it has improved
    if (!current.previous_severity)
        return false;
    const currentSeverityIndex = SeverityGradeOptions.indexOf(current.severity);
    const previousSeverityIndex = SeverityGradeOptions.indexOf(current.previous_severity);
    return currentSeverityIndex < previousSeverityIndex;
};

/** Interval between job-status polls, in ms (matches the Editor's plane-detection poll cadence). */
const POLL_INTERVAL = 2500;
/**
 * Safety backstop on `GET jobs` pagination — far beyond any real project (~100k jobs at the
 * server's default page size). Hitting it aborts the fetch rather than publishing a truncated
 * snapshot: the jobs table sorts by area id (not time), so a RUNNING job could sit past any cut.
 */
const MAX_PAGES = 100;
const JobStatusContext = createContext(null);
/** Read the app-level job-status loop. Throws outside `<JobStatusProvider>`. */
const useJobStatus = () => {
    const context = useContext(JobStatusContext);
    if (!context)
        throw new Error('useJobStatus must be used within a JobStatusProvider');
    return context;
};
/**
 * App-level background-job status loop (app-agnostic — the host app resolves the project id and
 * mounts this where that id lives; auth comes from the host's `Auth0Provider` via `useAuth0`).
 *
 * Lifecycle: one `GET jobs` on mount / project switch; while any job is RUNNING, re-poll on a
 * ~2.5 s interval; when none remain RUNNING, stay idle (no polling). `refreshJobs` re-kicks the
 * loop the moment a tool submits a new job. The server auto-fails RUNNING jobs past its timeout,
 * so the loop needs no timeout logic of its own.
 */
const JobStatusProvider = ({ projectId, children, }) => {
    // Hooks
    const { getAccessTokenSilently } = useAuth0();
    // States
    const [jobs, setJobs] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);
    // Derived state
    const hasRunningJobs = useMemo(() => jobs.some((job) => job.status === JobStatus.Running), [jobs]);
    // Refs — handlers and the latest jobs live in refs so registration/delivery callbacks stay
    // identity-stable and never fire against a stale snapshot.
    const handlersRef = useRef(new Set());
    const jobsRef = useRef([]);
    const fetchInFlightRef = useRef(null);
    // Bumped on project switch so a fetch that resolves late can't publish the old project's jobs.
    const generationRef = useRef(0);
    /**
     * Deliver finished-and-unacknowledged jobs to every registered handler whose matcher claims them,
     * skipping jobs already delivered to that registration.
     * @param currentJobs The jobs snapshot to deliver from.
     */
    const deliver = useCallback((currentJobs) => {
        handlersRef.current.forEach((entry) => {
            currentJobs.forEach((job) => {
                if (job.status === JobStatus.Running || job.ack || entry.notified.has(job.job_id))
                    return;
                if (!entry.matcher(job))
                    return;
                entry.notified.add(job.job_id);
                entry.handler(job);
            });
        });
    }, []);
    /**
     * Fetch every page of the project's jobs. Throws (rather than returning a prefix) if the
     * pagination backstop is hit while pages remain: an incomplete snapshot must never be published
     * as authoritative — callers keep the previous state and retry on the next poll.
     */
    const fetchAllJobs = useCallback(async () => {
        if (!projectId)
            return [];
        const accessToken = await getAccessTokenSilently();
        const all = [];
        let lastEvaluatedKey;
        for (let page = 0; page < MAX_PAGES; page += 1) {
            // Pages are inherently sequential — each request needs the previous page's key.
            // eslint-disable-next-line no-await-in-loop
            const response = await getJobs(accessToken, projectId, { lastEvaluatedKey });
            all.push(...response.results);
            lastEvaluatedKey = response.last_evaluated_key;
            if (!lastEvaluatedKey)
                return all;
        }
        throw new Error(`getJobs pagination exceeded the ${MAX_PAGES}-page safety backstop`);
    }, [projectId, getAccessTokenSilently]);
    /**
     * Fetch → publish → deliver. Concurrent callers share one in-flight fetch; a fetch that outlives
     * a project switch resolves without publishing.
     */
    const refreshJobs = useCallback(async () => {
        if (fetchInFlightRef.current)
            return fetchInFlightRef.current;
        const generation = generationRef.current;
        const fetchPromise = (async () => {
            const fresh = await fetchAllJobs();
            if (generation !== generationRef.current)
                return fresh;
            jobsRef.current = fresh;
            setJobs(fresh);
            setIsLoaded(true);
            deliver(fresh);
            return fresh;
        })();
        fetchInFlightRef.current = fetchPromise;
        // Only clear our own in-flight marker — a project switch may have started a newer fetch.
        const clearOwnMarker = () => {
            if (fetchInFlightRef.current === fetchPromise)
                fetchInFlightRef.current = null;
        };
        fetchPromise.then(clearOwnMarker, clearOwnMarker);
        return fetchPromise;
    }, [fetchAllJobs, deliver]);
    /**
     * Register a completion handler and immediately reconcile it against the jobs the loop already
     * holds (the "handler view remounts after the job finished" path).
     * @param matcher Predicate over `Job` claiming which jobs this handler owns.
     * @param handler Called once per claimed finished-and-unacknowledged job.
     */
    const registerJobHandler = useCallback((matcher, handler) => {
        const entry = { matcher, handler, notified: new Set() };
        handlersRef.current.add(entry);
        jobsRef.current.forEach((job) => {
            if (job.status === JobStatus.Running || job.ack || !matcher(job))
                return;
            entry.notified.add(job.job_id);
            handler(job);
        });
        return () => {
            handlersRef.current.delete(entry);
        };
    }, []);
    /**
     * Acknowledge finished jobs and mirror the flag locally so they stop counting as unacknowledged
     * without waiting for the next fetch.
     * @param inspectionAreaId Area the jobs belong to (the ack endpoint is area-scoped).
     * @param jobIds `job_id`s to acknowledge.
     */
    const ackJobs$1 = useCallback(async (inspectionAreaId, jobIds) => {
        if (!projectId || !jobIds.length)
            return;
        const accessToken = await getAccessTokenSilently();
        const response = await ackJobs(accessToken, projectId, inspectionAreaId, jobIds);
        // Mirror only the ids the server actually acknowledged — a `not_found`/failed id stays
        // unacknowledged locally too, so its completion is re-delivered instead of silently hidden.
        const acked = new Set(response.details.filter((detail) => detail.success).map((detail) => detail.job_id));
        if (!acked.size)
            return;
        jobsRef.current = jobsRef.current.map((job) => (acked.has(job.job_id) ? { ...job, ack: true } : job));
        setJobs(jobsRef.current);
    }, [projectId, getAccessTokenSilently]);
    /**
     * Initial load / project switch: reset the tracked list and fetch once. If nothing is RUNNING the
     * loop then stays idle; a load failure also stays idle (a submit's `refreshJobs` or a reload
     * re-establishes the loop).
     */
    useEffect(() => {
        generationRef.current += 1;
        fetchInFlightRef.current = null;
        jobsRef.current = [];
        setJobs([]);
        setIsLoaded(false);
        if (!projectId)
            return;
        refreshJobs().catch(() => { });
    }, [projectId, refreshJobs]);
    /**
     * Loop until dry: while any tracked job is RUNNING, re-poll on the interval; once none remain,
     * the chain is torn down and the loop idles. A **recursive timeout, not `setInterval`** — the
     * next poll is scheduled only after the current fetch settles, so a slow request never overlaps
     * the next tick. Transient poll failures retry on the next tick.
     */
    useEffect(() => {
        if (!hasRunningJobs)
            return undefined;
        let cancelled = false;
        let timeout;
        const scheduleNextPoll = () => {
            timeout = setTimeout(() => {
                refreshJobs()
                    .catch(() => { })
                    .finally(() => {
                    if (!cancelled)
                        scheduleNextPoll();
                });
            }, POLL_INTERVAL);
        };
        scheduleNextPoll();
        return () => {
            cancelled = true;
            clearTimeout(timeout);
        };
    }, [hasRunningJobs, refreshJobs]);
    const value = useMemo(() => ({ jobs, isLoaded, refreshJobs, registerJobHandler, ackJobs: ackJobs$1 }), [jobs, isLoaded, refreshJobs, registerJobHandler, ackJobs$1]);
    return jsx(JobStatusContext.Provider, { value: value, children: children });
};

const initialState = {
    showModal: () => null,
    showErrorModal: () => null,
    updateModal: () => null,
    hideModal: () => null,
    textConfig: {
        defaultCancelText: 'キャンセル',
        defaultConfirmText: '確定',
        defaultTitle: '注意',
        errorConfirmText: '了解',
        errorTitle: 'エラー',
    },
};
const GlobalModalContext = createContext(initialState);
/**
 * useGlobalModal - Imperative hook for triggering the application-level modal.
 *
 * Must be used inside a `GlobalModalProvider`.
 *
 * @example
 * // Confirmation dialog
 * const { showModal } = useGlobalModal()
 *
 * showModal({
 *   title: 'Delete Event',
 *   body: 'Are you sure you want to delete this event? This action cannot be undone.',
 *   modalType: ModalType.ConfirmationCritical,
 *   onConfirm: () => {
 *     deleteEvent(eventId)
 *     return true // returning true closes the modal
 *   },
 * })
 *
 * @example
 * // Async confirmation (keeps modal open + shows loading while promise resolves)
 * const { showModal } = useGlobalModal()
 *
 * showModal({
 *   title: 'Submit Report',
 *   body: 'Submit the inspection report for review?',
 *   onConfirmPromised: async () => {
 *     await submitReport(reportId)
 *     return true // returning true closes the modal
 *   },
 * })
 *
 * @example
 * // Error modal
 * const { showErrorModal } = useGlobalModal()
 *
 * try {
 *   await saveData()
 * } catch (e) {
 *   showErrorModal('Failed to save. Please try again.')
 * }
 *
 * @example
 * // Loading modal (runs a loader function, closes when it resolves true)
 * const { showModal } = useGlobalModal()
 *
 * showModal({
 *   title: 'Importing...',
 *   body: 'Processing the ZIP archive.',
 *   modalType: ModalType.Loading,
 *   loader: async () => {
 *     await importArchive(file)
 *     return true
 *   },
 *   closeOnLoaded: true,
 * })
 */
const useGlobalModal = () => useContext(GlobalModalContext);

var ModalType;
(function (ModalType) {
    ModalType[ModalType["Alert"] = 0] = "Alert";
    ModalType[ModalType["Error"] = 1] = "Error";
    ModalType[ModalType["Confirmation"] = 2] = "Confirmation";
    ModalType[ModalType["ConfirmationCritical"] = 3] = "ConfirmationCritical";
    ModalType[ModalType["Loading"] = 4] = "Loading";
})(ModalType || (ModalType = {}));
const createDefaultModalProps = (textConfig) => ({
    body: '',
    cancelText: textConfig.defaultCancelText,
    resolveText: '',
    closable: true,
    confirmText: textConfig.defaultConfirmText,
    modalType: ModalType.Confirmation,
    onConfirm: () => true,
    onCancel: () => null,
    onResolve: () => null,
    isConfirmable: true,
    title: textConfig.defaultTitle,
    size: 'sm',
    placement: 'center',
});
const createErrorModalProps = (textConfig) => ({
    ...createDefaultModalProps(textConfig),
    confirmText: textConfig.errorConfirmText,
    modalType: ModalType.Error,
    title: textConfig.errorTitle,
});

const DEFAULT_TEXT_CONFIG = {
    defaultCancelText: 'キャンセル',
    defaultConfirmText: '確定',
    defaultTitle: '注意',
    errorConfirmText: '了解',
    errorTitle: 'エラー',
};
/**
 * GlobalModalProvider - Context provider that enables `useGlobalModal()` throughout the app.
 *
 * Mount once near the root of your application. Manages a single shared modal instance
 * that can be triggered imperatively from any component via the modal context.
 *
 * @example
 * <GlobalModalProvider textConfig={{ defaultCancelText: 'Cancel', defaultConfirmText: 'OK' }}>
 *   <App />
 * </GlobalModalProvider>
 */
const GlobalModalProvider = ({ children, textConfig: customTextConfig }) => {
    const textConfig = useMemo(() => ({ ...DEFAULT_TEXT_CONFIG, ...customTextConfig }), [customTextConfig]);
    const DEFAULT_MODAL_PROPS = useMemo(() => createDefaultModalProps(textConfig), [textConfig]);
    const ERROR_MODAL_PROPS = useMemo(() => createErrorModalProps(textConfig), [textConfig]);
    const [isOpen, setIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [props, setProps] = useState(DEFAULT_MODAL_PROPS);
    const showModal = useCallback((modalProps) => {
        setIsOpen(true);
        setProps({
            ...(modalProps.modalType === ModalType.Error ? ERROR_MODAL_PROPS : DEFAULT_MODAL_PROPS),
            ...modalProps,
        });
    }, [DEFAULT_MODAL_PROPS, ERROR_MODAL_PROPS]);
    const showErrorModal = useCallback((message) => {
        setIsOpen(true);
        setProps({
            ...ERROR_MODAL_PROPS,
            body: message,
        });
    }, [ERROR_MODAL_PROPS]);
    const updateModal = useCallback((modalProps) => {
        // Functional update so this callback stays referentially stable — otherwise the
        // context value changes on every showModal, re-rendering all useGlobalModal consumers.
        setProps((prev) => ({
            ...prev,
            ...modalProps,
        }));
    }, []);
    const hideModal = useCallback(() => {
        setIsOpen(false);
    }, []);
    const contextValue = useMemo(() => ({ showModal, showErrorModal, updateModal, hideModal, textConfig }), [showModal, showErrorModal, updateModal, hideModal, textConfig]);
    const handleModalToggle = () => {
        hideModal();
    };
    const handleModalConfirm = async () => {
        if (props.onConfirmPromised) {
            setIsLoading(true);
            if (await props.onConfirmPromised()) {
                hideModal();
            }
            setIsLoading(false);
        }
        else if (props.onConfirm && props.onConfirm()) {
            hideModal();
        }
    };
    const handleModalCancel = () => {
        if (props.onCancel) {
            props.onCancel();
        }
        hideModal();
    };
    const handleModalResolve = () => {
        if (props.onResolve) {
            props.onResolve();
        }
        hideModal();
    };
    const getColorScheme = (modalType) => {
        switch (modalType) {
            case ModalType.ConfirmationCritical:
                return 'red';
            default:
                return 'blue';
        }
    };
    /**
     * If this is a loader modal, run the loader function and close the modal when it's done.
     */
    useEffect(() => {
        if (isOpen) {
            void (async () => {
                if (props.loader) {
                    const result = await props.loader();
                    if (result && props.closeOnLoaded) {
                        hideModal();
                    }
                }
            })();
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isOpen]);
    const renderComponent = () => {
        if (!isOpen) {
            return null;
        }
        return (jsx(Dialog.Root, { open: true, onOpenChange: (details) => {
                if (!details.open) {
                    handleModalToggle();
                }
            }, closeOnEscape: props.closable, closeOnInteractOutside: props.closable, size: props.size, placement: props.placement, lazyMount: true, unmountOnExit: true, children: jsxs(Portal, { children: [jsx(Dialog.Backdrop, { css: {
                            '--z-index': 1599,
                        } }), jsx(Dialog.Positioner, { css: {
                            '--layer-index': 100,
                        }, children: jsxs(Dialog.Content, { id: "globalModal", children: [jsxs(Dialog.Header, { borderBottom: "1px solid {colors.gray.200}", fontWeight: "semibold", fontSize: "xl", alignItems: "center", children: [props.closable && jsx(Dialog.CloseTrigger, {}), props.leftIcon ? (jsx(Circle$2, { bg: "orange.100", color: "orange.600", size: "2rem", mr: 2, alignSelf: "start", children: props.leftIcon })) : null, props.title] }), jsx(Dialog.Body, { whiteSpace: "pre-wrap", pt: 6, bg: "gray.50", children: props.body }), jsx(Dialog.Footer, { borderTop: "1px solid {colors.gray.200}", pt: 4, children: props.modalType !== ModalType.Loading && (jsxs(Fragment, { children: [props.modalType !== ModalType.Alert && props.modalType !== ModalType.Error && props.closable && (jsx(Button, { variant: "ghost", mr: 3, onClick: handleModalCancel, children: props.cancelText })), props.resolveText && props.onResolve && (jsx(Button, { colorPalette: getColorScheme(props.modalType), mr: 3, onClick: handleModalResolve, children: props.resolveText })), jsx(Button, { colorPalette: getColorScheme(props.modalType), onClick: handleModalConfirm, disabled: !props.isConfirmable || isLoading, loading: isLoading, children: props.confirmText })] })) })] }) })] }) }));
    };
    return (jsxs(GlobalModalContext.Provider, { value: contextValue, children: [renderComponent(), children] }));
};

/**
 * RequiredFieldMark - Renders a red asterisk `*` to indicate a required field.
 *
 * Renders inline as a `<span>` so it can be placed directly inside a label.
 *
 * @example
 * <Field.Label>Name <RequiredFieldMark /></Field.Label>
 */
const RequiredFieldMark = () => (jsx(Text$2, { as: "span", color: "red.500", children: "*" }));

/**
 * DialogCloser - A pre-styled close button for Chakra UI `Dialog` components.
 *
 * Renders as a ghost `IconButton` with an `✕` icon, wired to `Dialog.CloseTrigger`.
 * Place it anywhere inside a `Dialog.Content` to provide a close affordance.
 *
 * @example
 * <Dialog.Header>
 *   <DialogCloser />
 *   Title
 * </Dialog.Header>
 */
const DialogCloser = () => (jsx(Dialog.CloseTrigger, { asChild: true, children: jsx(IconButton, { variant: "ghost", size: "sm", children: jsx(LuX, {}) }) }));

const PopoverCloser = ({ iconProps, ...props }) => {
    const { setOpen } = usePopoverContext();
    return (jsx(Popover.CloseTrigger, { asChild: true, children: jsx(IconButton, { variant: "ghost", size: "sm", onClick: () => setOpen(false), ...props, children: jsx(Icon, { as: LuX, boxSize: 4, ...iconProps }) }) }));
};

/**
 * EventInspectionDateRange - Displays the inspection period of an event as a formatted date range.
 * Note that date format is determined by the user's locale (e.g. "MM/DD/YYYY" in US English, "DD/MM/YYYY" in British English).
 *
 * - Both dates present: `"MM/DD/YYYY - MM/DD/YYYY"`
 * - Only one date present: that date alone
 * - Neither date present: renders nothing
 *
 * Accepts all `Text` props (e.g. `fontSize`, `color`) which are forwarded to the underlying element.
 *
 * @example
 * // Default format
 * <EventInspectionDateRange event={event} />
 *
 * @example
 * // Custom format
 * <EventInspectionDateRange event={event} fontSize="xs" color="gray.500" />
 */
const EventInspectionDateRange = ({ event, default: defaultText, ...props }) => {
    const start = event.inspection_period_start ? new Date(event.inspection_period_start).toLocaleDateString() : null;
    const end = event.inspection_period_end ? new Date(event.inspection_period_end).toLocaleDateString() : null;
    const text = start && end ? `${start} - ${end}` : (start ?? end ?? defaultText);
    if (!text)
        return null;
    return jsx(Text$2, { ...props, children: text });
};

/**
 * FacilityKP - Displays the kilopost range of a facility.
 *
 * Renders a `Text` element in the format `KP {start} - KP {end}`.
 * If only one endpoint is set, renders just that value.
 * Returns `null` if neither `kilopost_start` nor `kilopost_end` is set.
 *
 * Accepts all `Text` props (e.g. `fontSize`, `color`) which are forwarded to the underlying element.
 *
 * @example
 * // Basic usage
 * <FacilityKP facility={facility} />
 *
 * @example
 * // With custom styling
 * <FacilityKP facility={facility} fontSize="xs" color="gray.500" />
 */
const FacilityKP = ({ facility, ...props }) => {
    const kp = [facility.kilopost_start, facility.kilopost_end].filter(Boolean).join(' - KP ');
    return kp ? jsx(Text$2, { ...props, children: `KP ${kp}` }) : null;
};

const RatingBadgeColors = {
    green: {
        borderColor: 'green.300',
        gradientFrom: 'green.50',
        gradientTo: 'green.100',
        color: 'green.800',
    },
    blue: {
        borderColor: 'blue.300',
        gradientFrom: 'blue.50',
        gradientTo: 'blue.100',
        color: 'blue.800',
    },
    yellow: {
        borderColor: 'yellow.300',
        gradientFrom: 'yellow.50',
        gradientTo: 'yellow.100',
        color: 'yellow.900',
    },
    red: {
        borderColor: 'red.300',
        gradientFrom: 'red.50',
        gradientTo: 'red.100',
        color: 'red.900',
    },
    gray: {
        borderColor: 'gray.300',
        gradientFrom: 'gray.50',
        gradientTo: 'gray.100',
        color: 'gray.800',
    },
    purple: {
        borderColor: 'purple.200',
        gradientFrom: 'purple.50',
        gradientTo: 'purple.100',
        color: 'purple.700',
    },
    orange: {
        borderColor: 'orange.200',
        gradientFrom: 'orange.50',
        gradientTo: 'orange.100',
        color: 'orange.700',
    },
};
const ratingBadgeRecipe = defineSlotRecipe({
    className: 'ratingBadge',
    slots: ['root', 'date', 'badge', 'description'],
    base: {
        root: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        date: {
            fontSize: '11px',
            fontWeight: 'medium',
            color: 'gray.500',
            mb: 1,
        },
        badge: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '1em',
            fontWeight: 'black',
            border: '2px solid',
            bgGradient: 'to-br',
        },
        description: {
            mt: 1,
            fontSize: '10px',
            fontWeight: 'semibold',
            lineHeight: 'tight',
            textAlign: 'center',
        },
    },
    variants: {
        colorPalette: {
            green: {
                badge: RatingBadgeColors.green,
                description: {
                    color: 'green.600',
                },
            },
            blue: {
                badge: RatingBadgeColors.blue,
                description: {
                    color: 'blue.600',
                },
            },
            yellow: {
                badge: RatingBadgeColors.yellow,
                description: {
                    color: 'yellow.700',
                },
            },
            red: {
                badge: RatingBadgeColors.red,
                description: {
                    color: 'red.700',
                },
            },
            gray: {
                badge: RatingBadgeColors.gray,
                description: {
                    color: 'gray.600',
                },
            },
            purple: {
                badge: RatingBadgeColors.purple,
                description: {
                    color: 'purple.600',
                },
            },
            orange: {
                badge: RatingBadgeColors.orange,
                description: {
                    color: 'orange.600',
                },
            },
        },
    },
    defaultVariants: {
        colorPalette: 'gray',
    },
});
const { withProvider: withProvider$3, withContext: withContext$3 } = createSlotRecipeContext({
    recipe: ratingBadgeRecipe,
});
const RatingBadgeRoot = withProvider$3('div', 'root');
const RatingBadgeDate = withContext$3('span', 'date');
const RatingBadgeBadge = withContext$3('div', 'badge');
const RatingBadgeDescription = withContext$3('span', 'description');

/**
 * TagBadge - A reusable component for displaying selectable tag badges
 *
 * Displays tags that can be toggled between selected and unselected states.
 * Only visible tags are shown when not in editing mode. In editing mode,
 * all tags are displayed and clickable.
 *
 * @example
 * // Selected tag in editing mode
 * <TagBadge
 *   label="Progressive"
 *   isSelected={true}
 *   isEditing={true}
 *   onClick={() => console.log('clicked')}
 * />
 *
 * @example
 * // Unselected tag in view mode (hidden)
 * <TagBadge
 *   label="Stable"
 *   isSelected={false}
 *   isEditing={false}
 * />
 *
 * @example
 * // Small selected tag
 * <TagBadge
 *   label="Unknown"
 *   isSelected={true}
 *   size="sm"
 * />
 */
const CauseBadge = ({ label, isSelected, isSelectable = false, isEditing = false, onClick, size = 'lg', }) => {
    return (jsx(Tag$1.Root
    // css={{ '&:has(+div)': { mr: 1.5 } }}
    , { 
        // css={{ '&:has(+div)': { mr: 1.5 } }}
        display: isSelected || isEditing ? undefined : 'none', size: size, transition: "all 0.1s", color: isSelected ? 'red.600' : 'gray.500', bgGradient: "to-b", gradientFrom: isSelected ? 'orange.50' : 'gray.50', gradientTo: isSelected ? 'orange.100' : 'gray.100', shadowColor: isSelected ? 'red.200' : undefined, _hover: isSelectable
            ? {
                bg: isSelected ? 'orange.200/60' : 'gray.200/60',
                color: 'red.600',
                shadowColor: 'red.300',
            }
            : undefined, borderRadius: "xl", cursor: isSelectable ? 'pointer' : 'default', onClick: isSelectable
            ? () => {
                if (!isEditing || !onClick)
                    return;
                onClick();
            }
            : undefined, children: jsx(Tag$1.Label, { children: label }) }));
};

/**
 * Size token to chakra size mapping
 */
const sizeTokenMap = {
    xs: 4,
    sm: 7,
    md: 9,
    lg: 12,
    xl: 16,
};
/**
 * Resolve size value to either a chakra number or custom string
 * @param size - The size prop which can be a token, number, or custom string
 */
const resolveSize = (size = 'lg') => {
    // If it's a size token, map it
    if (typeof size === 'string' && size in sizeTokenMap) {
        return sizeTokenMap[size];
    }
    // If it's a number between 0.5 and 96, it's a chakra size
    if (typeof size === 'number' && size >= 0.5 && size <= 96) {
        return size;
    }
    // Otherwise, use it as-is (custom string like "43px")
    return size;
};
/**
 * Resolve size to a number for calculations (e.g., max width, border radius).
 * @param size - The size prop which can be a token, number, or custom string
 */
const resolveSizeInNumber = (size) => {
    if (typeof size === 'number') {
        return size;
    }
    if (typeof size === 'string' && size in sizeTokenMap) {
        return sizeTokenMap[size];
    }
    // For custom string sizes, we can set a default medium size (e.g., 9)
    return 9;
};
/**
 * Calculate max width for the badge based on size to ensure it remains visually balanced
 * @param size - The size prop which can be a token, number, or custom string
 * @returns
 */
const getMaxWidth = (size) => {
    if (typeof size === 'number') {
        return `calc(var(--chakra-sizes-${size}) * 1.5)`; // Scale max width with size
    }
    if (sizeTokenMap[size]) {
        return `${sizeTokenMap[size] * 1.5}rem`;
    }
    // For other string formats (e.g., "2em", "1.5rem"), we can set a reasonable max width
    return `calc(${size} * 1.5)`;
};
/**
 * Calculate border radius based on size to maintain proper proportions
 */
const calculateBorderRadius = (size) => {
    // For custom string sizes, use a default medium radius
    if (typeof size === 'string') {
        return 'md';
    }
    // Scale border radius proportionally with size
    // xs (4) -> 1.5 (0.375rem = 6px)
    // sm (7) -> 2 (0.5rem = 8px)
    // md (9) -> 2.5 (0.625rem = 10px)
    // lg (12) -> 3 (0.75rem = 12px)
    // xl (16) -> 4 (1rem = 16px)
    if (size <= 5)
        return 4;
    if (size <= 8)
        return 6;
    if (size <= 10)
        return 8;
    if (size <= 14)
        return 10;
    return 12;
};
/**
 * Calculate the font size CSS value for a badge of the given size.
 *
 * Uses a dampened scale so larger badges don't get proportionally larger text —
 * the multiplier follows `0.40 + 0.80 / size`, giving roughly:
 * - xs  (4)  → ×0.60
 * - sm  (7)  → ×0.51
 * - md  (9)  → ×0.49
 * - lg  (12) → ×0.47
 * - xl  (16) → ×0.45
 *
 * For custom string sizes (e.g. "43px") the fallback multiplier is 0.49 (≈ md).
 */
const calcFontSize = (size) => {
    const sizeNum = resolveSizeInNumber(size);
    const multiplier = parseFloat((0.4 + 0.8 / sizeNum).toFixed(3));
    const cssSize = typeof size === 'string' && !(size in sizeTokenMap) ? size : `var(--chakra-sizes-${sizeNum})`;
    return `calc(${cssSize} * ${multiplier})`;
};
/**
 * Format ISO date string to YYYY/MM format
 */
const formatDateToYearMonth = (isoDate) => {
    const date = new Date(isoDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    return `${year}/${month}`;
};
/**
 * RatingBadge - A reusable generic rating badge component
 *
 * @example
 * // Simple rating badge
 * <RatingBadge
 *   rating="A"
 *   colorPalette="blue"
 * />
 *
 * @example
 * // Rating with tooltip
 * <RatingBadge
 *   rating="5"
 *   colorPalette="green"
 *   tooltip="Excellent"
 * />
 *
 * @example
 * // Small badge
 * <RatingBadge
 *   rating="B"
 *   size="sm"
 *   colorPalette="yellow"
 * />
 */
const RatingBadge = ({ title, rating, date, tooltip, size = 'lg', opacity = 1, colorPalette = 'gray', forceWidth = false, as, }) => {
    const badgeSize = resolveSize(size);
    const borderRadius = calculateBorderRadius(badgeSize);
    return (jsxs(RatingBadgeRoot, { as: as, colorPalette: colorPalette, title: tooltip || title, w: title || forceWidth ? getMaxWidth(badgeSize) : undefined, children: [date && jsx(RatingBadgeDate, { opacity: opacity, children: formatDateToYearMonth(date) }), jsx(RatingBadgeBadge, { as: as, w: badgeSize, h: badgeSize, borderRadius: borderRadius, opacity: opacity, fontSize: calcFontSize(badgeSize), lineHeight: calcFontSize(badgeSize), children: jsx(Fragment, { children: rating }) }), title && (jsx(RatingBadgeDescription, { as: as, opacity: opacity, children: title }))] }));
};

/**
 * Configuration for each progression status
 */
const ProgressionConfig = {
    progressive: {
        colorPalette: 'red',
        rating: '↑',
    },
    stable: {
        colorPalette: 'green',
        rating: '—',
    },
    unknown: {
        colorPalette: 'gray',
        rating: '?',
    },
    null: {
        colorPalette: 'gray',
        rating: '—',
    },
};
/**
 * ProgressionBadge - A reusable component for displaying progression status badges
 *
 * @example
 * // Progressive status badge
 * <ProgressionBadge status="progressive" />
 *
 * @example
 * // Stable status badge
 * <ProgressionBadge status="stable" />
 *
 * @example
 * // Badge without title
 * <ProgressionBadge
 *   status="unknown"
 *   showTitle={false}
 * />
 *
 * @example
 * // Small badge
 * <ProgressionBadge
 *   status="progressive"
 *   size="sm"
 * />
 */
const ProgressionBadge = ({ status, size = 'lg', opacity = 1, showTitle = false, forceWidth, }) => {
    // Hooks
    const { t } = useTranslation();
    const config = ProgressionConfig[status || 'null'];
    return (jsx(RatingBadge, { rating: config.rating, title: showTitle && status ? t(`object.progression.${status || 'null'}`) : undefined, colorPalette: config.colorPalette, size: size, opacity: opacity, forceWidth: forceWidth }));
};

/**
 * Map countermeasure grades to color palettes
 */
const CountermeasureColorMap = {
    A0: 'gray',
    A: 'green',
    B: 'blue',
    C: 'yellow',
    E1: 'red',
    E2: 'red',
    M: 'orange',
    S1: 'purple',
    S2: 'purple',
    null: 'gray',
};
/**
 * CountermeasureBadge - A specialized badge for displaying countermeasure grades
 *
 * @example
 * // Simple countermeasure badge
 * <CountermeasureBadge grade="B" />
 *
 * @example
 * // With title
 * <CountermeasureBadge grade="E1" showTitle />
 *
 * @example
 * // With full description
 * <CountermeasureBadge grade="C" showDescription />
 *
 * @example
 * // Small badge
 * <CountermeasureBadge grade="A" size="sm" />
 */
const CountermeasureBadge = ({ grade, size = 'lg', date, opacity = 1, showDescription = true, showTitle = false, forceWidth, }) => {
    const { t } = useTranslation();
    const colorPalette = CountermeasureColorMap[grade || 'null'];
    // Get title (short label) if requested
    const title = showTitle && grade ? t(`object.countermeasure.${grade}`) : undefined;
    // Get description (detailed explanation) if requested
    const description = showDescription ? t(`object.countermeasure.description.${grade}`) : undefined;
    return (jsx(RatingBadge, { rating: grade || '—', colorPalette: colorPalette, size: size, date: date, opacity: opacity, title: title, tooltip: description, forceWidth: forceWidth }));
};

const getSeverityChange = (damage) => {
    if (hasDamageWorsened(damage)) {
        return SeverityChange.Worsened;
    }
    else if (hasDamageImproved(damage)) {
        return SeverityChange.Improved;
    }
    else {
        return SeverityChange.Unchanged;
    }
};
/**
 * Configuration for each severity change type
 */
const SeverityChangeColorMap = {
    [SeverityChange.Worsened]: 'red',
    [SeverityChange.Improved]: 'green',
    [SeverityChange.Unchanged]: 'gray',
};
/**
 * Icon mapping for each severity change type
 */
const SeverityChangeIconMap = {
    [SeverityChange.Worsened]: jsx(TbTrendingUp, {}),
    [SeverityChange.Improved]: jsx(TbTrendingDown, {}),
    [SeverityChange.Unchanged]: jsx(LuMinus, {}),
};
/**
 * SeverityChangeBadge - A reusable component for displaying severity change badges
 *
 * @example
 * // Simple severity change badge
 * <SeverityChangeBadge change={SeverityChange.Worsened} />
 *
 * @example
 * // Severity change badge with custom size
 * <SeverityChangeBadge
 *   change={SeverityChange.Improved}
 *   size="sm"
 * />
 *
 * @example
 * // Previous severity change (with reduced opacity)
 * <SeverityChangeBadge
 *   change={SeverityChange.Unchanged}
 *   opacity={0.5}
 * />
 */
const SeverityChangeBadge = ({ change, date, size = 'lg', opacity = 1, showTitle = false, showDescription = true, as, }) => {
    // Hooks
    const { t } = useTranslation();
    const colorPalette = SeverityChangeColorMap[change];
    const icon = SeverityChangeIconMap[change];
    return (jsx(RatingBadge, { as: as, rating: icon, date: date, title: showTitle && change ? t(`object.severityChange.${change}`) : undefined, tooltip: showDescription && change ? t(`object.severityChange.${change}`) : undefined, colorPalette: colorPalette, size: size, opacity: opacity }));
};

/**
 * Configuration for each severity grade level
 */
const SeverityColorMap = {
    a: 'green',
    b: 'blue',
    c: 'yellow',
    d: 'red',
    e: 'gray',
    null: 'gray',
};
/**
 * SeverityBadge - A reusable component for displaying severity grade badges
 *
 * @example
 * // Simple severity badge
 * <SeverityBadge grade="c" />
 *
 * @example
 * // Severity badge with custom size
 * <SeverityBadge
 *   grade="d"
 *   size="sm"
 * />
 *
 * @example
 * // Previous severity grade (with reduced opacity)
 * <SeverityBadge
 *   grade="b"
 *   opacity={0.5}
 * />
 */
const SeverityBadge = ({ grade, date, size = 'lg', opacity = 1, showTitle = false, showDescription = true, forceWidth, as, }) => {
    // Hooks
    const { t } = useTranslation();
    const colorPalette = SeverityColorMap[grade || 'null'];
    return (jsx(RatingBadge, { as: as, rating: grade || '—', date: date, title: showTitle && grade ? t(`object.severity.${grade}`) : undefined, tooltip: showDescription && grade ? t(`object.severity.descriptions.${grade}`) : undefined, colorPalette: colorPalette, size: size, opacity: opacity, forceWidth: forceWidth }));
};

/**
 * Map soundness grades to color palettes
 */
const SoundnessRatingColorMap = {
    I: 'green',
    II: 'blue',
    III: 'yellow',
    IV: 'red',
    null: 'gray',
};
/**
 * SoundnessBadge - A reusable component for displaying soundness grade badges
 *
 * @example
 * // Current grade with description and title
 * <SoundnessBadge
 *   grade="III"
 *   date="2025/06"
 * />
 *
 * @example
 * // Previous grade (with reduced opacity)
 * <SoundnessBadge
 *   grade="II"
 *   date="2019/10"
 *   opacity={0.5}
 * />
 *
 * @example
 * // Badge without description
 * <SoundnessBadge
 *   grade="IV"
 *   showDescription={false}
 * />
 *
 * @example
 * // Small badge
 * <SoundnessBadge
 *   grade="I"
 *   size="sm"
 * />
 *
 * @example
 * // Custom size
 * <SoundnessBadge
 *   grade="III"
 *   size="43px"
 * />
 */
const SoundnessBadge = ({ grade, date, size = 'lg', showDescription = true, showTitle = false, opacity = 1, as, forceWidth, }) => {
    // Hooks
    const { t } = useTranslation();
    return (jsx(RatingBadge, { as: as, rating: grade || '—', title: showTitle && grade ? t(`object.soundnessRating.${grade}`) : undefined, tooltip: showDescription && grade ? t(`object.soundnessRating.descriptions.${grade}`) : undefined, colorPalette: SoundnessRatingColorMap[grade || 'null'], date: date, size: size, opacity: opacity, forceWidth: forceWidth }));
};

const PI_OVER_180 = Math.PI / 180;
function detectBrowser() {
    return (typeof window !== 'undefined' &&
        ({}.toString.call(window) === '[object Window]' ||
            {}.toString.call(window) === '[object global]'));
}
const glob = typeof global !== 'undefined'
    ? global
    : typeof window !== 'undefined'
        ? window
        : typeof WorkerGlobalScope !== 'undefined'
            ? self
            : {};
const Konva$1 = {
    _global: glob,
    version: '10.3.0',
    isBrowser: detectBrowser(),
    isUnminified: /param/.test(function (param) { }.toString()),
    dblClickWindow: 400,
    getAngle(angle) {
        return Konva$1.angleDeg ? angle * PI_OVER_180 : angle;
    },
    enableTrace: false,
    pointerEventsEnabled: true,
    autoDrawEnabled: true,
    hitOnDragEnabled: false,
    capturePointerEventsEnabled: false,
    _mouseListenClick: false,
    _touchListenClick: false,
    _pointerListenClick: false,
    _mouseInDblClickWindow: false,
    _touchInDblClickWindow: false,
    _pointerInDblClickWindow: false,
    _mouseDblClickPointerId: null,
    _touchDblClickPointerId: null,
    _pointerDblClickPointerId: null,
    _renderBackend: 'web',
    legacyTextRendering: false,
    pixelRatio: (typeof window !== 'undefined' && window.devicePixelRatio) || 1,
    dragDistance: 3,
    angleDeg: true,
    showWarnings: true,
    dragButtons: [0, 1],
    isDragging() {
        return Konva$1['DD'].isDragging;
    },
    isTransforming() {
        var _a, _b;
        return (_b = (_a = Konva$1['Transformer']) === null || _a === void 0 ? void 0 : _a.isTransforming()) !== null && _b !== void 0 ? _b : false;
    },
    isDragReady() {
        return !!Konva$1['DD'].node;
    },
    releaseCanvasOnDestroy: true,
    document: glob.document,
    _injectGlobal(Konva) {
        if (typeof glob.Konva !== 'undefined') {
            console.error('Several Konva instances detected. It is not recommended to use multiple Konva instances in the same environment.');
        }
        glob.Konva = Konva;
    },
};
const _registerNode = (NodeClass) => {
    Konva$1[NodeClass.prototype.getClassName()] = NodeClass;
};
Konva$1._injectGlobal(Konva$1);

const NODE_ERROR = `Konva.js unsupported environment.

Looks like you are trying to use Konva.js in Node.js environment. because "document" object is undefined.

To use Konva.js in Node.js environment, you need to use the "canvas-backend" or "skia-backend" module.

bash: npm install canvas
js: import "konva/canvas-backend";

or

bash: npm install skia-canvas
js: import "konva/skia-backend";
`;
const ensureBrowser = () => {
    if (typeof document === 'undefined') {
        throw new Error(NODE_ERROR);
    }
};
class Transform {
    constructor(m = [1, 0, 0, 1, 0, 0]) {
        this.dirty = false;
        this.m = (m && m.slice()) || [1, 0, 0, 1, 0, 0];
    }
    reset() {
        this.m[0] = 1;
        this.m[1] = 0;
        this.m[2] = 0;
        this.m[3] = 1;
        this.m[4] = 0;
        this.m[5] = 0;
    }
    copy() {
        return new Transform(this.m);
    }
    copyInto(tr) {
        tr.m[0] = this.m[0];
        tr.m[1] = this.m[1];
        tr.m[2] = this.m[2];
        tr.m[3] = this.m[3];
        tr.m[4] = this.m[4];
        tr.m[5] = this.m[5];
    }
    point(point) {
        const m = this.m;
        return {
            x: m[0] * point.x + m[2] * point.y + m[4],
            y: m[1] * point.x + m[3] * point.y + m[5],
        };
    }
    translate(x, y) {
        this.m[4] += this.m[0] * x + this.m[2] * y;
        this.m[5] += this.m[1] * x + this.m[3] * y;
        return this;
    }
    scale(sx, sy) {
        this.m[0] *= sx;
        this.m[1] *= sx;
        this.m[2] *= sy;
        this.m[3] *= sy;
        return this;
    }
    rotate(rad) {
        const c = Math.cos(rad);
        const s = Math.sin(rad);
        const m11 = this.m[0] * c + this.m[2] * s;
        const m12 = this.m[1] * c + this.m[3] * s;
        const m21 = this.m[0] * -s + this.m[2] * c;
        const m22 = this.m[1] * -s + this.m[3] * c;
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        return this;
    }
    getTranslation() {
        return {
            x: this.m[4],
            y: this.m[5],
        };
    }
    skew(sx, sy) {
        const m11 = this.m[0] + this.m[2] * sy;
        const m12 = this.m[1] + this.m[3] * sy;
        const m21 = this.m[2] + this.m[0] * sx;
        const m22 = this.m[3] + this.m[1] * sx;
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        return this;
    }
    multiply(matrix) {
        const m11 = this.m[0] * matrix.m[0] + this.m[2] * matrix.m[1];
        const m12 = this.m[1] * matrix.m[0] + this.m[3] * matrix.m[1];
        const m21 = this.m[0] * matrix.m[2] + this.m[2] * matrix.m[3];
        const m22 = this.m[1] * matrix.m[2] + this.m[3] * matrix.m[3];
        const dx = this.m[0] * matrix.m[4] + this.m[2] * matrix.m[5] + this.m[4];
        const dy = this.m[1] * matrix.m[4] + this.m[3] * matrix.m[5] + this.m[5];
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        this.m[4] = dx;
        this.m[5] = dy;
        return this;
    }
    invert() {
        const d = 1 / (this.m[0] * this.m[3] - this.m[1] * this.m[2]);
        const m0 = this.m[3] * d;
        const m1 = -this.m[1] * d;
        const m2 = -this.m[2] * d;
        const m3 = this.m[0] * d;
        const m4 = d * (this.m[2] * this.m[5] - this.m[3] * this.m[4]);
        const m5 = d * (this.m[1] * this.m[4] - this.m[0] * this.m[5]);
        this.m[0] = m0;
        this.m[1] = m1;
        this.m[2] = m2;
        this.m[3] = m3;
        this.m[4] = m4;
        this.m[5] = m5;
        return this;
    }
    getMatrix() {
        return this.m;
    }
    decompose() {
        const a = this.m[0];
        const b = this.m[1];
        const c = this.m[2];
        const d = this.m[3];
        const e = this.m[4];
        const f = this.m[5];
        const delta = a * d - b * c;
        const result = {
            x: e,
            y: f,
            rotation: 0,
            scaleX: 0,
            scaleY: 0,
            skewX: 0,
            skewY: 0,
        };
        if (a != 0 || b != 0) {
            const r = Math.sqrt(a * a + b * b);
            result.rotation = b > 0 ? Math.acos(a / r) : -Math.acos(a / r);
            result.scaleX = r;
            result.scaleY = delta / r;
            result.skewX = (a * c + b * d) / delta;
            result.skewY = 0;
        }
        else if (c != 0 || d != 0) {
            const s = Math.sqrt(c * c + d * d);
            result.rotation =
                Math.PI / 2 - (d > 0 ? Math.acos(-c / s) : -Math.acos(c / s));
            result.scaleX = delta / s;
            result.scaleY = s;
            result.skewX = 0;
            result.skewY = (a * c + b * d) / delta;
        }
        else ;
        result.rotation = Util._getRotation(result.rotation);
        return result;
    }
}
const OBJECT_ARRAY = '[object Array]', OBJECT_NUMBER = '[object Number]', OBJECT_STRING = '[object String]', OBJECT_BOOLEAN = '[object Boolean]', PI_OVER_DEG180 = Math.PI / 180, DEG180_OVER_PI = 180 / Math.PI, HASH = '#', EMPTY_STRING$1 = '', ZERO = '0', KONVA_WARNING = 'Konva warning: ', KONVA_ERROR = 'Konva error: ', RGB_PAREN = 'rgb(', COLORS = {
    aliceblue: [240, 248, 255],
    antiquewhite: [250, 235, 215],
    aqua: [0, 255, 255],
    aquamarine: [127, 255, 212],
    azure: [240, 255, 255],
    beige: [245, 245, 220],
    bisque: [255, 228, 196],
    black: [0, 0, 0],
    blanchedalmond: [255, 235, 205],
    blue: [0, 0, 255],
    blueviolet: [138, 43, 226],
    brown: [165, 42, 42],
    burlywood: [222, 184, 135],
    cadetblue: [95, 158, 160],
    chartreuse: [127, 255, 0],
    chocolate: [210, 105, 30],
    coral: [255, 127, 80],
    cornflowerblue: [100, 149, 237],
    cornsilk: [255, 248, 220],
    crimson: [220, 20, 60],
    cyan: [0, 255, 255],
    darkblue: [0, 0, 139],
    darkcyan: [0, 139, 139],
    darkgoldenrod: [184, 132, 11],
    darkgray: [169, 169, 169],
    darkgreen: [0, 100, 0],
    darkgrey: [169, 169, 169],
    darkkhaki: [189, 183, 107],
    darkmagenta: [139, 0, 139],
    darkolivegreen: [85, 107, 47],
    darkorange: [255, 140, 0],
    darkorchid: [153, 50, 204],
    darkred: [139, 0, 0],
    darksalmon: [233, 150, 122],
    darkseagreen: [143, 188, 143],
    darkslateblue: [72, 61, 139],
    darkslategray: [47, 79, 79],
    darkslategrey: [47, 79, 79],
    darkturquoise: [0, 206, 209],
    darkviolet: [148, 0, 211],
    deeppink: [255, 20, 147],
    deepskyblue: [0, 191, 255],
    dimgray: [105, 105, 105],
    dimgrey: [105, 105, 105],
    dodgerblue: [30, 144, 255],
    firebrick: [178, 34, 34],
    floralwhite: [255, 255, 240],
    forestgreen: [34, 139, 34],
    fuchsia: [255, 0, 255],
    gainsboro: [220, 220, 220],
    ghostwhite: [248, 248, 255],
    gold: [255, 215, 0],
    goldenrod: [218, 165, 32],
    gray: [128, 128, 128],
    green: [0, 128, 0],
    greenyellow: [173, 255, 47],
    grey: [128, 128, 128],
    honeydew: [240, 255, 240],
    hotpink: [255, 105, 180],
    indianred: [205, 92, 92],
    indigo: [75, 0, 130],
    ivory: [255, 255, 240],
    khaki: [240, 230, 140],
    lavender: [230, 230, 250],
    lavenderblush: [255, 240, 245],
    lawngreen: [124, 252, 0],
    lemonchiffon: [255, 250, 205],
    lightblue: [173, 216, 230],
    lightcoral: [240, 128, 128],
    lightcyan: [224, 255, 255],
    lightgoldenrodyellow: [250, 250, 210],
    lightgray: [211, 211, 211],
    lightgreen: [144, 238, 144],
    lightgrey: [211, 211, 211],
    lightpink: [255, 182, 193],
    lightsalmon: [255, 160, 122],
    lightseagreen: [32, 178, 170],
    lightskyblue: [135, 206, 250],
    lightslategray: [119, 136, 153],
    lightslategrey: [119, 136, 153],
    lightsteelblue: [176, 196, 222],
    lightyellow: [255, 255, 224],
    lime: [0, 255, 0],
    limegreen: [50, 205, 50],
    linen: [250, 240, 230],
    magenta: [255, 0, 255],
    maroon: [128, 0, 0],
    mediumaquamarine: [102, 205, 170],
    mediumblue: [0, 0, 205],
    mediumorchid: [186, 85, 211],
    mediumpurple: [147, 112, 219],
    mediumseagreen: [60, 179, 113],
    mediumslateblue: [123, 104, 238],
    mediumspringgreen: [0, 250, 154],
    mediumturquoise: [72, 209, 204],
    mediumvioletred: [199, 21, 133],
    midnightblue: [25, 25, 112],
    mintcream: [245, 255, 250],
    mistyrose: [255, 228, 225],
    moccasin: [255, 228, 181],
    navajowhite: [255, 222, 173],
    navy: [0, 0, 128],
    oldlace: [253, 245, 230],
    olive: [128, 128, 0],
    olivedrab: [107, 142, 35],
    orange: [255, 165, 0],
    orangered: [255, 69, 0],
    orchid: [218, 112, 214],
    palegoldenrod: [238, 232, 170],
    palegreen: [152, 251, 152],
    paleturquoise: [175, 238, 238],
    palevioletred: [219, 112, 147],
    papayawhip: [255, 239, 213],
    peachpuff: [255, 218, 185],
    peru: [205, 133, 63],
    pink: [255, 192, 203],
    plum: [221, 160, 203],
    powderblue: [176, 224, 230],
    purple: [128, 0, 128],
    rebeccapurple: [102, 51, 153],
    red: [255, 0, 0],
    rosybrown: [188, 143, 143],
    royalblue: [65, 105, 225],
    saddlebrown: [139, 69, 19],
    salmon: [250, 128, 114],
    sandybrown: [244, 164, 96],
    seagreen: [46, 139, 87],
    seashell: [255, 245, 238],
    sienna: [160, 82, 45],
    silver: [192, 192, 192],
    skyblue: [135, 206, 235],
    slateblue: [106, 90, 205],
    slategray: [119, 128, 144],
    slategrey: [119, 128, 144],
    snow: [255, 255, 250],
    springgreen: [0, 255, 127],
    steelblue: [70, 130, 180],
    tan: [210, 180, 140],
    teal: [0, 128, 128],
    thistle: [216, 191, 216],
    transparent: [255, 255, 255, 0],
    tomato: [255, 99, 71],
    turquoise: [64, 224, 208],
    violet: [238, 130, 238],
    wheat: [245, 222, 179],
    white: [255, 255, 255],
    whitesmoke: [245, 245, 245],
    yellow: [255, 255, 0],
    yellowgreen: [154, 205, 5],
}, RGB_REGEX = /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/;
let animQueue = [];
let _isCanvasFarblingActive = null;
const req = (typeof requestAnimationFrame !== 'undefined' && requestAnimationFrame) ||
    function (f) {
        setTimeout(f, 16);
    };
const Util = {
    _isElement(obj) {
        return !!(obj && obj.nodeType == 1);
    },
    _isFunction(obj) {
        return !!(obj && obj.constructor && obj.call && obj.apply);
    },
    _isPlainObject(obj) {
        return !!obj && obj.constructor === Object;
    },
    _isArray(obj) {
        return Object.prototype.toString.call(obj) === OBJECT_ARRAY;
    },
    _isNumber(obj) {
        return (Object.prototype.toString.call(obj) === OBJECT_NUMBER &&
            !isNaN(obj) &&
            isFinite(obj));
    },
    _isString(obj) {
        return Object.prototype.toString.call(obj) === OBJECT_STRING;
    },
    _isBoolean(obj) {
        return Object.prototype.toString.call(obj) === OBJECT_BOOLEAN;
    },
    isObject(val) {
        return val instanceof Object;
    },
    isValidSelector(selector) {
        if (typeof selector !== 'string') {
            return false;
        }
        const firstChar = selector[0];
        return (firstChar === '#' ||
            firstChar === '.' ||
            firstChar === firstChar.toUpperCase());
    },
    _sign(number) {
        if (number === 0) {
            return 1;
        }
        if (number > 0) {
            return 1;
        }
        else {
            return -1;
        }
    },
    requestAnimFrame(callback) {
        animQueue.push(callback);
        if (animQueue.length === 1) {
            req(function () {
                const queue = animQueue;
                animQueue = [];
                queue.forEach(function (cb) {
                    cb();
                });
            });
        }
    },
    createCanvasElement() {
        ensureBrowser();
        const canvas = document.createElement('canvas');
        try {
            canvas.style = canvas.style || {};
        }
        catch (e) { }
        return canvas;
    },
    createImageElement() {
        ensureBrowser();
        return document.createElement('img');
    },
    _isInDocument(el) {
        while ((el = el.parentNode)) {
            if (el == document) {
                return true;
            }
        }
        return false;
    },
    _urlToImage(url, callback) {
        const imageObj = Util.createImageElement();
        imageObj.onload = function () {
            callback(imageObj);
        };
        imageObj.src = url;
    },
    _rgbToHex(r, g, b) {
        return ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
    },
    _hexToRgb(hex) {
        hex = hex.replace(HASH, EMPTY_STRING$1);
        const bigint = parseInt(hex, 16);
        return {
            r: (bigint >> 16) & 255,
            g: (bigint >> 8) & 255,
            b: bigint & 255,
        };
    },
    getRandomColor() {
        let randColor = ((Math.random() * 0xffffff) << 0).toString(16);
        while (randColor.length < 6) {
            randColor = ZERO + randColor;
        }
        return HASH + randColor;
    },
    isCanvasFarblingActive() {
        if (_isCanvasFarblingActive !== null) {
            return _isCanvasFarblingActive;
        }
        if (typeof document === 'undefined') {
            _isCanvasFarblingActive = false;
            return false;
        }
        const c = this.createCanvasElement();
        c.width = 10;
        c.height = 10;
        const ctx = c.getContext('2d', {
            willReadFrequently: true,
        });
        ctx.clearRect(0, 0, 10, 10);
        ctx.fillStyle = '#282828';
        ctx.fillRect(0, 0, 10, 10);
        const d = ctx.getImageData(0, 0, 10, 10).data;
        let isFarbling = false;
        for (let i = 0; i < 100; i++) {
            if (d[i * 4] !== 40 ||
                d[i * 4 + 1] !== 40 ||
                d[i * 4 + 2] !== 40 ||
                d[i * 4 + 3] !== 255) {
                isFarbling = true;
                break;
            }
        }
        _isCanvasFarblingActive = isFarbling;
        this.releaseCanvas(c);
        return _isCanvasFarblingActive;
    },
    getHitColor() {
        const color = this.getRandomColor();
        return this.isCanvasFarblingActive()
            ? this.getSnappedHexColor(color)
            : color;
    },
    getHitColorKey(r, g, b) {
        if (this.isCanvasFarblingActive()) {
            r = Math.round(r / 5) * 5;
            g = Math.round(g / 5) * 5;
            b = Math.round(b / 5) * 5;
        }
        return HASH + this._rgbToHex(r, g, b);
    },
    getSnappedHexColor(hex) {
        const rgb = this._hexToRgb(hex);
        return (HASH +
            this._rgbToHex(Math.round(rgb.r / 5) * 5, Math.round(rgb.g / 5) * 5, Math.round(rgb.b / 5) * 5));
    },
    getRGB(color) {
        let rgb;
        if (color in COLORS) {
            rgb = COLORS[color];
            return {
                r: rgb[0],
                g: rgb[1],
                b: rgb[2],
            };
        }
        else if (color[0] === HASH) {
            return this._hexToRgb(color.substring(1));
        }
        else if (color.substr(0, 4) === RGB_PAREN) {
            rgb = RGB_REGEX.exec(color.replace(/ /g, ''));
            return {
                r: parseInt(rgb[1], 10),
                g: parseInt(rgb[2], 10),
                b: parseInt(rgb[3], 10),
            };
        }
        else {
            return {
                r: 0,
                g: 0,
                b: 0,
            };
        }
    },
    colorToRGBA(str) {
        str = str || 'black';
        return (Util._namedColorToRBA(str) ||
            Util._hex3ColorToRGBA(str) ||
            Util._hex4ColorToRGBA(str) ||
            Util._hex6ColorToRGBA(str) ||
            Util._hex8ColorToRGBA(str) ||
            Util._rgbColorToRGBA(str) ||
            Util._rgbaColorToRGBA(str) ||
            Util._hslColorToRGBA(str));
    },
    _namedColorToRBA(str) {
        const c = COLORS[str.toLowerCase()];
        if (!c) {
            return null;
        }
        return {
            r: c[0],
            g: c[1],
            b: c[2],
            a: 1,
        };
    },
    _rgbColorToRGBA(str) {
        if (str.indexOf('rgb(') === 0) {
            str = str.match(/rgb\(([^)]+)\)/)[1];
            const parts = str.split(/ *, */).map(Number);
            return {
                r: parts[0],
                g: parts[1],
                b: parts[2],
                a: 1,
            };
        }
    },
    _rgbaColorToRGBA(str) {
        if (str.indexOf('rgba(') === 0) {
            str = str.match(/rgba\(([^)]+)\)/)[1];
            const parts = str.split(/ *, */).map((n, index) => {
                if (n.slice(-1) === '%') {
                    return index === 3 ? parseInt(n) / 100 : (parseInt(n) / 100) * 255;
                }
                return Number(n);
            });
            return {
                r: parts[0],
                g: parts[1],
                b: parts[2],
                a: parts[3],
            };
        }
    },
    _hex8ColorToRGBA(str) {
        if (str[0] === '#' && str.length === 9) {
            return {
                r: parseInt(str.slice(1, 3), 16),
                g: parseInt(str.slice(3, 5), 16),
                b: parseInt(str.slice(5, 7), 16),
                a: parseInt(str.slice(7, 9), 16) / 0xff,
            };
        }
    },
    _hex6ColorToRGBA(str) {
        if (str[0] === '#' && str.length === 7) {
            return {
                r: parseInt(str.slice(1, 3), 16),
                g: parseInt(str.slice(3, 5), 16),
                b: parseInt(str.slice(5, 7), 16),
                a: 1,
            };
        }
    },
    _hex4ColorToRGBA(str) {
        if (str[0] === '#' && str.length === 5) {
            return {
                r: parseInt(str[1] + str[1], 16),
                g: parseInt(str[2] + str[2], 16),
                b: parseInt(str[3] + str[3], 16),
                a: parseInt(str[4] + str[4], 16) / 0xff,
            };
        }
    },
    _hex3ColorToRGBA(str) {
        if (str[0] === '#' && str.length === 4) {
            return {
                r: parseInt(str[1] + str[1], 16),
                g: parseInt(str[2] + str[2], 16),
                b: parseInt(str[3] + str[3], 16),
                a: 1,
            };
        }
    },
    _hslColorToRGBA(str) {
        if (/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.test(str)) {
            const [_, ...hsl] = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(str);
            const h = Number(hsl[0]) / 360;
            const s = Number(hsl[1]) / 100;
            const l = Number(hsl[2]) / 100;
            let t2;
            let t3;
            let val;
            if (s === 0) {
                val = l * 255;
                return {
                    r: Math.round(val),
                    g: Math.round(val),
                    b: Math.round(val),
                    a: 1,
                };
            }
            if (l < 0.5) {
                t2 = l * (1 + s);
            }
            else {
                t2 = l + s - l * s;
            }
            const t1 = 2 * l - t2;
            const rgb = [0, 0, 0];
            for (let i = 0; i < 3; i++) {
                t3 = h + (1 / 3) * -(i - 1);
                if (t3 < 0) {
                    t3++;
                }
                if (t3 > 1) {
                    t3--;
                }
                if (6 * t3 < 1) {
                    val = t1 + (t2 - t1) * 6 * t3;
                }
                else if (2 * t3 < 1) {
                    val = t2;
                }
                else if (3 * t3 < 2) {
                    val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
                }
                else {
                    val = t1;
                }
                rgb[i] = val * 255;
            }
            return {
                r: Math.round(rgb[0]),
                g: Math.round(rgb[1]),
                b: Math.round(rgb[2]),
                a: 1,
            };
        }
    },
    haveIntersection(r1, r2) {
        return !(r2.x > r1.x + r1.width ||
            r2.x + r2.width < r1.x ||
            r2.y > r1.y + r1.height ||
            r2.y + r2.height < r1.y);
    },
    cloneObject(obj) {
        const retObj = {};
        for (const key in obj) {
            if (this._isPlainObject(obj[key])) {
                retObj[key] = this.cloneObject(obj[key]);
            }
            else if (this._isArray(obj[key])) {
                retObj[key] = this.cloneArray(obj[key]);
            }
            else {
                retObj[key] = obj[key];
            }
        }
        return retObj;
    },
    cloneArray(arr) {
        return arr.slice(0);
    },
    degToRad(deg) {
        return deg * PI_OVER_DEG180;
    },
    radToDeg(rad) {
        return rad * DEG180_OVER_PI;
    },
    _degToRad(deg) {
        Util.warn('Util._degToRad is removed. Please use public Util.degToRad instead.');
        return Util.degToRad(deg);
    },
    _radToDeg(rad) {
        Util.warn('Util._radToDeg is removed. Please use public Util.radToDeg instead.');
        return Util.radToDeg(rad);
    },
    _getRotation(radians) {
        return Konva$1.angleDeg ? Util.radToDeg(radians) : radians;
    },
    _capitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    },
    throw(str) {
        throw new Error(KONVA_ERROR + str);
    },
    error(str) {
        console.error(KONVA_ERROR + str);
    },
    warn(str) {
        if (!Konva$1.showWarnings) {
            return;
        }
        console.warn(KONVA_WARNING + str);
    },
    each(obj, func) {
        for (const key in obj) {
            func(key, obj[key]);
        }
    },
    _inRange(val, left, right) {
        return left <= val && val < right;
    },
    _getProjectionToSegment(x1, y1, x2, y2, x3, y3) {
        let x, y, dist;
        const pd2 = (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
        if (pd2 == 0) {
            x = x1;
            y = y1;
            dist = (x3 - x2) * (x3 - x2) + (y3 - y2) * (y3 - y2);
        }
        else {
            const u = ((x3 - x1) * (x2 - x1) + (y3 - y1) * (y2 - y1)) / pd2;
            if (u < 0) {
                x = x1;
                y = y1;
                dist = (x1 - x3) * (x1 - x3) + (y1 - y3) * (y1 - y3);
            }
            else if (u > 1.0) {
                x = x2;
                y = y2;
                dist = (x2 - x3) * (x2 - x3) + (y2 - y3) * (y2 - y3);
            }
            else {
                x = x1 + u * (x2 - x1);
                y = y1 + u * (y2 - y1);
                dist = (x - x3) * (x - x3) + (y - y3) * (y - y3);
            }
        }
        return [x, y, dist];
    },
    _getProjectionToLine(pt, line, isClosed) {
        const pc = Util.cloneObject(pt);
        let dist = Number.MAX_VALUE;
        line.forEach(function (p1, i) {
            if (!isClosed && i === line.length - 1) {
                return;
            }
            const p2 = line[(i + 1) % line.length];
            const proj = Util._getProjectionToSegment(p1.x, p1.y, p2.x, p2.y, pt.x, pt.y);
            const px = proj[0], py = proj[1], pdist = proj[2];
            if (pdist < dist) {
                pc.x = px;
                pc.y = py;
                dist = pdist;
            }
        });
        return pc;
    },
    _prepareArrayForTween(startArray, endArray, isClosed) {
        const start = [], end = [];
        if (startArray.length > endArray.length) {
            const temp = endArray;
            endArray = startArray;
            startArray = temp;
        }
        for (let n = 0; n < startArray.length; n += 2) {
            start.push({
                x: startArray[n],
                y: startArray[n + 1],
            });
        }
        for (let n = 0; n < endArray.length; n += 2) {
            end.push({
                x: endArray[n],
                y: endArray[n + 1],
            });
        }
        const newStart = [];
        end.forEach(function (point) {
            const pr = Util._getProjectionToLine(point, start, isClosed);
            newStart.push(pr.x);
            newStart.push(pr.y);
        });
        return newStart;
    },
    _prepareToStringify(obj) {
        let desc;
        obj.visitedByCircularReferenceRemoval = true;
        for (const key in obj) {
            if (!(obj.hasOwnProperty(key) && obj[key] && typeof obj[key] == 'object')) {
                continue;
            }
            desc = Object.getOwnPropertyDescriptor(obj, key);
            if (obj[key].visitedByCircularReferenceRemoval ||
                Util._isElement(obj[key])) {
                if (desc.configurable) {
                    delete obj[key];
                }
                else {
                    return null;
                }
            }
            else if (Util._prepareToStringify(obj[key]) === null) {
                if (desc.configurable) {
                    delete obj[key];
                }
                else {
                    return null;
                }
            }
        }
        delete obj.visitedByCircularReferenceRemoval;
        return obj;
    },
    _assign(target, source) {
        for (const key in source) {
            target[key] = source[key];
        }
        return target;
    },
    _getFirstPointerId(evt) {
        if (!evt.touches) {
            return evt.pointerId || 999;
        }
        else {
            return evt.changedTouches[0].identifier;
        }
    },
    releaseCanvas(...canvases) {
        if (!Konva$1.releaseCanvasOnDestroy)
            return;
        canvases.forEach((c) => {
            c.width = 0;
            c.height = 0;
        });
    },
    drawRoundedRectPath(context, width, height, cornerRadius) {
        let xOrigin = width < 0 ? width : 0;
        let yOrigin = height < 0 ? height : 0;
        width = Math.abs(width);
        height = Math.abs(height);
        let topLeft = 0;
        let topRight = 0;
        let bottomLeft = 0;
        let bottomRight = 0;
        if (typeof cornerRadius === 'number') {
            topLeft =
                topRight =
                    bottomLeft =
                        bottomRight =
                            Math.min(cornerRadius, width / 2, height / 2);
        }
        else {
            topLeft = Math.min(cornerRadius[0] || 0, width / 2, height / 2);
            topRight = Math.min(cornerRadius[1] || 0, width / 2, height / 2);
            bottomRight = Math.min(cornerRadius[2] || 0, width / 2, height / 2);
            bottomLeft = Math.min(cornerRadius[3] || 0, width / 2, height / 2);
        }
        context.moveTo(xOrigin + topLeft, yOrigin);
        context.lineTo(xOrigin + width - topRight, yOrigin);
        context.arc(xOrigin + width - topRight, yOrigin + topRight, topRight, (Math.PI * 3) / 2, 0, false);
        context.lineTo(xOrigin + width, yOrigin + height - bottomRight);
        context.arc(xOrigin + width - bottomRight, yOrigin + height - bottomRight, bottomRight, 0, Math.PI / 2, false);
        context.lineTo(xOrigin + bottomLeft, yOrigin + height);
        context.arc(xOrigin + bottomLeft, yOrigin + height - bottomLeft, bottomLeft, Math.PI / 2, Math.PI, false);
        context.lineTo(xOrigin, yOrigin + topLeft);
        context.arc(xOrigin + topLeft, yOrigin + topLeft, topLeft, Math.PI, (Math.PI * 3) / 2, false);
    },
    drawRoundedPolygonPath(context, points, sides, radius, cornerRadius) {
        radius = Math.abs(radius);
        for (let i = 0; i < sides; i++) {
            const prev = points[(i - 1 + sides) % sides];
            const curr = points[i];
            const next = points[(i + 1) % sides];
            const vec1 = { x: curr.x - prev.x, y: curr.y - prev.y };
            const vec2 = { x: next.x - curr.x, y: next.y - curr.y };
            const len1 = Math.hypot(vec1.x, vec1.y);
            const len2 = Math.hypot(vec2.x, vec2.y);
            let currCornerRadius;
            if (typeof cornerRadius === 'number') {
                currCornerRadius = cornerRadius;
            }
            else {
                currCornerRadius = i < cornerRadius.length ? cornerRadius[i] : 0;
            }
            const maxCornerRadius = radius * Math.cos(Math.PI / sides);
            currCornerRadius =
                maxCornerRadius * Math.min(1, (currCornerRadius / radius) * 2);
            const normalVec1 = { x: vec1.x / len1, y: vec1.y / len1 };
            const normalVec2 = { x: vec2.x / len2, y: vec2.y / len2 };
            const p1 = {
                x: curr.x - normalVec1.x * currCornerRadius,
                y: curr.y - normalVec1.y * currCornerRadius,
            };
            const p2 = {
                x: curr.x + normalVec2.x * currCornerRadius,
                y: curr.y + normalVec2.y * currCornerRadius,
            };
            if (i === 0) {
                context.moveTo(p1.x, p1.y);
            }
            else {
                context.lineTo(p1.x, p1.y);
            }
            context.arcTo(curr.x, curr.y, p2.x, p2.y, currCornerRadius);
        }
    },
};

function simplifyArray(arr) {
    const retArr = [], len = arr.length, util = Util;
    for (let n = 0; n < len; n++) {
        let val = arr[n];
        if (util._isNumber(val)) {
            val = Math.round(val * 1000) / 1000;
        }
        else if (!util._isString(val)) {
            val = val + '';
        }
        retArr.push(val);
    }
    return retArr;
}
const COMMA = ',', OPEN_PAREN = '(', CLOSE_PAREN = ')', OPEN_PAREN_BRACKET = '([', CLOSE_BRACKET_PAREN = '])', SEMICOLON = ';', DOUBLE_PAREN = '()', EQUALS = '=', CONTEXT_METHODS = [
    'arc',
    'arcTo',
    'beginPath',
    'bezierCurveTo',
    'clearRect',
    'clip',
    'closePath',
    'createLinearGradient',
    'createPattern',
    'createRadialGradient',
    'drawImage',
    'ellipse',
    'fill',
    'fillText',
    'getImageData',
    'createImageData',
    'lineTo',
    'moveTo',
    'putImageData',
    'quadraticCurveTo',
    'rect',
    'roundRect',
    'restore',
    'rotate',
    'save',
    'scale',
    'setLineDash',
    'setTransform',
    'stroke',
    'strokeText',
    'transform',
    'translate',
];
const CONTEXT_PROPERTIES = [
    'fillStyle',
    'strokeStyle',
    'shadowColor',
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY',
    'letterSpacing',
    'lineCap',
    'lineDashOffset',
    'lineJoin',
    'lineWidth',
    'miterLimit',
    'direction',
    'font',
    'textAlign',
    'textBaseline',
    'globalAlpha',
    'globalCompositeOperation',
    'imageSmoothingEnabled',
    'filter',
];
const traceArrMax = 100;
let _cssFiltersSupported = null;
function isCSSFiltersSupported() {
    if (_cssFiltersSupported !== null) {
        return _cssFiltersSupported;
    }
    try {
        const canvas = Util.createCanvasElement();
        const ctx = canvas.getContext('2d');
        if (!ctx) {
            _cssFiltersSupported = false;
            return false;
        }
        return !!ctx && 'filter' in ctx;
    }
    catch (e) {
        _cssFiltersSupported = false;
        return false;
    }
}
class Context {
    constructor(canvas) {
        this.canvas = canvas;
        if (Konva$1.enableTrace) {
            this.traceArr = [];
            this._enableTrace();
        }
    }
    fillShape(shape) {
        if (shape.fillEnabled()) {
            this._fill(shape);
        }
    }
    _fill(shape) {
    }
    strokeShape(shape) {
        if (shape.hasStroke()) {
            this._stroke(shape);
        }
    }
    _stroke(shape) {
    }
    fillStrokeShape(shape) {
        if (shape.attrs.fillAfterStrokeEnabled) {
            this.strokeShape(shape);
            this.fillShape(shape);
        }
        else {
            this.fillShape(shape);
            this.strokeShape(shape);
        }
    }
    getTrace(relaxed, rounded) {
        let traceArr = this.traceArr, len = traceArr.length, str = '', n, trace, method, args;
        for (n = 0; n < len; n++) {
            trace = traceArr[n];
            method = trace.method;
            if (method) {
                args = trace.args;
                str += method;
                if (relaxed) {
                    str += DOUBLE_PAREN;
                }
                else {
                    if (Util._isArray(args[0])) {
                        str += OPEN_PAREN_BRACKET + args.join(COMMA) + CLOSE_BRACKET_PAREN;
                    }
                    else {
                        if (rounded) {
                            args = args.map((a) => typeof a === 'number' ? Math.floor(a) : a);
                        }
                        str += OPEN_PAREN + args.join(COMMA) + CLOSE_PAREN;
                    }
                }
            }
            else {
                str += trace.property;
                if (!relaxed) {
                    str += EQUALS + trace.val;
                }
            }
            str += SEMICOLON;
        }
        return str;
    }
    clearTrace() {
        this.traceArr = [];
    }
    _trace(str) {
        let traceArr = this.traceArr, len;
        traceArr.push(str);
        len = traceArr.length;
        if (len >= traceArrMax) {
            traceArr.shift();
        }
    }
    reset() {
        const pixelRatio = this.getCanvas().getPixelRatio();
        this.setTransform(1 * pixelRatio, 0, 0, 1 * pixelRatio, 0, 0);
    }
    getCanvas() {
        return this.canvas;
    }
    clear(bounds) {
        const canvas = this.getCanvas();
        if (bounds) {
            this.clearRect(bounds.x || 0, bounds.y || 0, bounds.width || 0, bounds.height || 0);
        }
        else {
            this.clearRect(0, 0, canvas.getWidth() / canvas.pixelRatio, canvas.getHeight() / canvas.pixelRatio);
        }
    }
    _applyLineCap(shape) {
        const lineCap = shape.attrs.lineCap;
        if (lineCap) {
            this.setAttr('lineCap', lineCap);
        }
    }
    _applyOpacity(shape) {
        const absOpacity = shape.getAbsoluteOpacity();
        if (absOpacity !== 1) {
            this.setAttr('globalAlpha', absOpacity);
        }
    }
    _applyLineJoin(shape) {
        const lineJoin = shape.attrs.lineJoin;
        if (lineJoin) {
            this.setAttr('lineJoin', lineJoin);
        }
    }
    _applyMiterLimit(shape) {
        const miterLimit = shape.attrs.miterLimit;
        if (miterLimit != null) {
            this.setAttr('miterLimit', miterLimit);
        }
    }
    setAttr(attr, val) {
        this._context[attr] = val;
    }
    arc(x, y, radius, startAngle, endAngle, counterClockwise) {
        this._context.arc(x, y, radius, startAngle, endAngle, counterClockwise);
    }
    arcTo(x1, y1, x2, y2, radius) {
        this._context.arcTo(x1, y1, x2, y2, radius);
    }
    beginPath() {
        this._context.beginPath();
    }
    bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y) {
        this._context.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
    }
    clearRect(x, y, width, height) {
        this._context.clearRect(x, y, width, height);
    }
    clip(...args) {
        this._context.clip.apply(this._context, args);
    }
    closePath() {
        this._context.closePath();
    }
    createImageData(width, height) {
        const a = arguments;
        if (a.length === 2) {
            return this._context.createImageData(width, height);
        }
        else if (a.length === 1) {
            return this._context.createImageData(width);
        }
    }
    createLinearGradient(x0, y0, x1, y1) {
        return this._context.createLinearGradient(x0, y0, x1, y1);
    }
    createPattern(image, repetition) {
        return this._context.createPattern(image, repetition);
    }
    createRadialGradient(x0, y0, r0, x1, y1, r1) {
        return this._context.createRadialGradient(x0, y0, r0, x1, y1, r1);
    }
    drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight) {
        const a = arguments, _context = this._context;
        if (a.length === 3) {
            _context.drawImage(image, sx, sy);
        }
        else if (a.length === 5) {
            _context.drawImage(image, sx, sy, sWidth, sHeight);
        }
        else if (a.length === 9) {
            _context.drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
        }
    }
    ellipse(x, y, radiusX, radiusY, rotation, startAngle, endAngle, counterclockwise) {
        this._context.ellipse(x, y, radiusX, radiusY, rotation, startAngle, endAngle, counterclockwise);
    }
    isPointInPath(x, y, path, fillRule) {
        if (path) {
            return this._context.isPointInPath(path, x, y, fillRule);
        }
        return this._context.isPointInPath(x, y, fillRule);
    }
    fill(...args) {
        this._context.fill.apply(this._context, args);
    }
    fillRect(x, y, width, height) {
        this._context.fillRect(x, y, width, height);
    }
    strokeRect(x, y, width, height) {
        this._context.strokeRect(x, y, width, height);
    }
    fillText(text, x, y, maxWidth) {
        if (maxWidth) {
            this._context.fillText(text, x, y, maxWidth);
        }
        else {
            this._context.fillText(text, x, y);
        }
    }
    measureText(text) {
        return this._context.measureText(text);
    }
    getImageData(sx, sy, sw, sh) {
        return this._context.getImageData(sx, sy, sw, sh);
    }
    lineTo(x, y) {
        this._context.lineTo(x, y);
    }
    moveTo(x, y) {
        this._context.moveTo(x, y);
    }
    rect(x, y, width, height) {
        this._context.rect(x, y, width, height);
    }
    roundRect(x, y, width, height, radii) {
        this._context.roundRect(x, y, width, height, radii);
    }
    putImageData(imageData, dx, dy) {
        this._context.putImageData(imageData, dx, dy);
    }
    quadraticCurveTo(cpx, cpy, x, y) {
        this._context.quadraticCurveTo(cpx, cpy, x, y);
    }
    restore() {
        this._context.restore();
    }
    rotate(angle) {
        this._context.rotate(angle);
    }
    save() {
        this._context.save();
    }
    scale(x, y) {
        this._context.scale(x, y);
    }
    setLineDash(segments) {
        if (this._context.setLineDash) {
            this._context.setLineDash(segments);
        }
        else if ('mozDash' in this._context) {
            this._context['mozDash'] = segments;
        }
        else if ('webkitLineDash' in this._context) {
            this._context['webkitLineDash'] = segments;
        }
    }
    getLineDash() {
        return this._context.getLineDash();
    }
    setTransform(a, b, c, d, e, f) {
        this._context.setTransform(a, b, c, d, e, f);
    }
    stroke(path2d) {
        if (path2d) {
            this._context.stroke(path2d);
        }
        else {
            this._context.stroke();
        }
    }
    strokeText(text, x, y, maxWidth) {
        this._context.strokeText(text, x, y, maxWidth);
    }
    transform(a, b, c, d, e, f) {
        this._context.transform(a, b, c, d, e, f);
    }
    translate(x, y) {
        this._context.translate(x, y);
    }
    _enableTrace() {
        let that = this, len = CONTEXT_METHODS.length, origSetter = this.setAttr, n, args;
        const func = function (methodName) {
            let origMethod = that[methodName], ret;
            that[methodName] = function () {
                args = simplifyArray(Array.prototype.slice.call(arguments, 0));
                ret = origMethod.apply(that, arguments);
                that._trace({
                    method: methodName,
                    args: args,
                });
                return ret;
            };
        };
        for (n = 0; n < len; n++) {
            func(CONTEXT_METHODS[n]);
        }
        that.setAttr = function () {
            origSetter.apply(that, arguments);
            const prop = arguments[0];
            let val = arguments[1];
            if (prop === 'shadowOffsetX' ||
                prop === 'shadowOffsetY' ||
                prop === 'shadowBlur') {
                val = val / this.canvas.getPixelRatio();
            }
            that._trace({
                property: prop,
                val: val,
            });
        };
    }
    _applyGlobalCompositeOperation(node) {
        const op = node.attrs.globalCompositeOperation;
        const def = !op || op === 'source-over';
        if (!def) {
            this.setAttr('globalCompositeOperation', op);
        }
    }
}
CONTEXT_PROPERTIES.forEach(function (prop) {
    Object.defineProperty(Context.prototype, prop, {
        get() {
            return this._context[prop];
        },
        set(val) {
            this._context[prop] = val;
        },
    });
});
class SceneContext extends Context {
    constructor(canvas, { willReadFrequently = false } = {}) {
        super(canvas);
        this._context = canvas._canvas.getContext('2d', {
            willReadFrequently,
        });
    }
    _fillColor(shape) {
        const fill = shape.fill();
        this.setAttr('fillStyle', fill);
        shape._fillFunc(this);
    }
    _fillPattern(shape) {
        this.setAttr('fillStyle', shape._getFillPattern());
        shape._fillFunc(this);
    }
    _fillLinearGradient(shape) {
        const grd = shape._getLinearGradient();
        if (grd) {
            this.setAttr('fillStyle', grd);
            shape._fillFunc(this);
        }
    }
    _fillRadialGradient(shape) {
        const grd = shape._getRadialGradient();
        if (grd) {
            this.setAttr('fillStyle', grd);
            shape._fillFunc(this);
        }
    }
    _fill(shape) {
        const hasColor = shape.fill(), fillPriority = shape.getFillPriority();
        if (hasColor && fillPriority === 'color') {
            this._fillColor(shape);
            return;
        }
        const hasPattern = shape.getFillPatternImage();
        if (hasPattern && fillPriority === 'pattern') {
            this._fillPattern(shape);
            return;
        }
        const hasLinearGradient = shape.getFillLinearGradientColorStops();
        if (hasLinearGradient && fillPriority === 'linear-gradient') {
            this._fillLinearGradient(shape);
            return;
        }
        const hasRadialGradient = shape.getFillRadialGradientColorStops();
        if (hasRadialGradient && fillPriority === 'radial-gradient') {
            this._fillRadialGradient(shape);
            return;
        }
        if (hasColor) {
            this._fillColor(shape);
        }
        else if (hasPattern) {
            this._fillPattern(shape);
        }
        else if (hasLinearGradient) {
            this._fillLinearGradient(shape);
        }
        else if (hasRadialGradient) {
            this._fillRadialGradient(shape);
        }
    }
    _strokeLinearGradient(shape) {
        const start = shape.getStrokeLinearGradientStartPoint(), end = shape.getStrokeLinearGradientEndPoint(), colorStops = shape.getStrokeLinearGradientColorStops(), grd = this.createLinearGradient(start.x, start.y, end.x, end.y);
        if (colorStops) {
            for (let n = 0; n < colorStops.length; n += 2) {
                grd.addColorStop(colorStops[n], colorStops[n + 1]);
            }
            this.setAttr('strokeStyle', grd);
        }
    }
    _stroke(shape) {
        const dash = shape.dash(), strokeScaleEnabled = shape.getStrokeScaleEnabled();
        if (shape.hasStroke()) {
            if (!strokeScaleEnabled) {
                this.save();
                const pixelRatio = this.getCanvas().getPixelRatio();
                this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
            }
            this._applyLineCap(shape);
            if (dash && shape.dashEnabled()) {
                this.setLineDash(dash);
                this.setAttr('lineDashOffset', shape.dashOffset());
            }
            this.setAttr('lineWidth', shape.strokeWidth());
            if (!shape.getShadowForStrokeEnabled()) {
                this.setAttr('shadowColor', 'rgba(0,0,0,0)');
            }
            const hasLinearGradient = shape.getStrokeLinearGradientColorStops();
            if (hasLinearGradient) {
                this._strokeLinearGradient(shape);
            }
            else {
                this.setAttr('strokeStyle', shape.stroke());
            }
            shape._strokeFunc(this);
            if (!strokeScaleEnabled) {
                this.restore();
            }
        }
    }
    _applyShadow(shape) {
        var _a, _b, _c;
        const color = (_a = shape.getShadowRGBA()) !== null && _a !== void 0 ? _a : 'black', blur = (_b = shape.getShadowBlur()) !== null && _b !== void 0 ? _b : 5, offset = (_c = shape.getShadowOffset()) !== null && _c !== void 0 ? _c : {
            x: 0,
            y: 0,
        }, scale = shape.getAbsoluteScale(), ratio = this.canvas.getPixelRatio(), scaleX = scale.x * ratio, scaleY = scale.y * ratio;
        this.setAttr('shadowColor', color);
        this.setAttr('shadowBlur', blur * Math.min(Math.abs(scaleX), Math.abs(scaleY)));
        this.setAttr('shadowOffsetX', offset.x * scaleX);
        this.setAttr('shadowOffsetY', offset.y * scaleY);
    }
}
class HitContext extends Context {
    constructor(canvas) {
        super(canvas);
        this._context = canvas._canvas.getContext('2d', {
            willReadFrequently: true,
        });
    }
    _fill(shape) {
        this.save();
        this.setAttr('fillStyle', shape.colorKey);
        shape._fillFuncHit(this);
        this.restore();
    }
    strokeShape(shape) {
        if (shape.hasHitStroke()) {
            this._stroke(shape);
        }
    }
    _stroke(shape) {
        if (shape.hasHitStroke()) {
            const strokeScaleEnabled = shape.getStrokeScaleEnabled();
            if (!strokeScaleEnabled) {
                this.save();
                const pixelRatio = this.getCanvas().getPixelRatio();
                this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
            }
            this._applyLineCap(shape);
            const hitStrokeWidth = shape.hitStrokeWidth();
            const strokeWidth = hitStrokeWidth === 'auto' ? shape.strokeWidth() : hitStrokeWidth;
            this.setAttr('lineWidth', strokeWidth);
            this.setAttr('strokeStyle', shape.colorKey);
            shape._strokeFuncHit(this);
            if (!strokeScaleEnabled) {
                this.restore();
            }
        }
    }
}

let _pixelRatio;
function getDevicePixelRatio() {
    if (_pixelRatio) {
        return _pixelRatio;
    }
    const canvas = Util.createCanvasElement();
    const context = canvas.getContext('2d');
    _pixelRatio = (function () {
        const devicePixelRatio = Konva$1._global.devicePixelRatio || 1, backingStoreRatio = context.webkitBackingStorePixelRatio ||
            context.mozBackingStorePixelRatio ||
            context.msBackingStorePixelRatio ||
            context.oBackingStorePixelRatio ||
            context.backingStorePixelRatio ||
            1;
        return devicePixelRatio / backingStoreRatio;
    })();
    Util.releaseCanvas(canvas);
    return _pixelRatio;
}
class Canvas {
    constructor(config) {
        this.pixelRatio = 1;
        this.width = 0;
        this.height = 0;
        this.isCache = false;
        const conf = config || {};
        const pixelRatio = conf.pixelRatio || Konva$1.pixelRatio || getDevicePixelRatio();
        this.pixelRatio = pixelRatio;
        this._canvas = Util.createCanvasElement();
        this._canvas.style.padding = '0';
        this._canvas.style.margin = '0';
        this._canvas.style.border = '0';
        this._canvas.style.background = 'transparent';
        this._canvas.style.position = 'absolute';
        this._canvas.style.top = '0';
        this._canvas.style.left = '0';
    }
    getContext() {
        return this.context;
    }
    getPixelRatio() {
        return this.pixelRatio;
    }
    setPixelRatio(pixelRatio) {
        const previousRatio = this.pixelRatio;
        this.pixelRatio = pixelRatio;
        this.setSize(this.getWidth() / previousRatio, this.getHeight() / previousRatio);
    }
    setWidth(width) {
        this.width = this._canvas.width = width * this.pixelRatio;
        this._canvas.style.width = width + 'px';
        const pixelRatio = this.pixelRatio, _context = this.getContext()._context;
        _context.scale(pixelRatio, pixelRatio);
    }
    setHeight(height) {
        this.height = this._canvas.height = height * this.pixelRatio;
        this._canvas.style.height = height + 'px';
        const pixelRatio = this.pixelRatio, _context = this.getContext()._context;
        _context.scale(pixelRatio, pixelRatio);
    }
    getWidth() {
        return this.width;
    }
    getHeight() {
        return this.height;
    }
    setSize(width, height) {
        this.setWidth(width || 0);
        this.setHeight(height || 0);
    }
    toDataURL(mimeType, quality) {
        try {
            return this._canvas.toDataURL(mimeType, quality);
        }
        catch (e) {
            try {
                return this._canvas.toDataURL();
            }
            catch (err) {
                Util.error('Unable to get data URL. ' +
                    err.message +
                    ' For more info read https://konvajs.org/docs/posts/Tainted_Canvas.html.');
                return '';
            }
        }
    }
}
class SceneCanvas extends Canvas {
    constructor(config = { width: 0, height: 0, willReadFrequently: false }) {
        super(config);
        this.context = new SceneContext(this, {
            willReadFrequently: config.willReadFrequently,
        });
        this.setSize(config.width, config.height);
    }
}
class HitCanvas extends Canvas {
    constructor(config = { width: 0, height: 0 }) {
        super(config);
        this.hitCanvas = true;
        this.context = new HitContext(this);
        this.setSize(config.width, config.height);
    }
}

const DD = {
    get isDragging() {
        let flag = false;
        DD._dragElements.forEach((elem) => {
            if (elem.dragStatus === 'dragging') {
                flag = true;
            }
        });
        return flag;
    },
    justDragged: false,
    get node() {
        let node;
        DD._dragElements.forEach((elem) => {
            node = elem.node;
        });
        return node;
    },
    _dragElements: new Map(),
    _drag(evt) {
        const nodesToFireEvents = [];
        DD._dragElements.forEach((elem, key) => {
            const { node } = elem;
            const stage = node.getStage();
            stage.setPointersPositions(evt);
            if (elem.pointerId === undefined) {
                elem.pointerId = Util._getFirstPointerId(evt);
            }
            const pos = stage._changedPointerPositions.find((pos) => pos.id === elem.pointerId);
            if (!pos) {
                return;
            }
            if (elem.dragStatus !== 'dragging') {
                const dragDistance = node.dragDistance();
                const distance = Math.max(Math.abs(pos.x - elem.startPointerPos.x), Math.abs(pos.y - elem.startPointerPos.y));
                if (distance < dragDistance) {
                    return;
                }
                node.startDrag({ evt });
                if (!node.isDragging()) {
                    return;
                }
            }
            node._setDragPosition(evt, elem);
            nodesToFireEvents.push(node);
        });
        nodesToFireEvents.forEach((node) => {
            if (!node.getStage()) {
                return;
            }
            node.fire('dragmove', {
                type: 'dragmove',
                target: node,
                evt: evt,
            }, true);
        });
    },
    _endDragBefore(evt) {
        const drawNodes = [];
        DD._dragElements.forEach((elem) => {
            const { node } = elem;
            const stage = node.getStage();
            if (evt) {
                stage.setPointersPositions(evt);
            }
            const pos = stage._changedPointerPositions.find((pos) => pos.id === elem.pointerId);
            if (!pos) {
                return;
            }
            if (elem.dragStatus === 'dragging' || elem.dragStatus === 'stopped') {
                DD.justDragged = true;
                Konva$1._mouseListenClick = false;
                Konva$1._touchListenClick = false;
                Konva$1._pointerListenClick = false;
                elem.dragStatus = 'stopped';
            }
            const drawNode = elem.node.getLayer() ||
                (elem.node instanceof Konva$1['Stage'] && elem.node);
            if (drawNode && drawNodes.indexOf(drawNode) === -1) {
                drawNodes.push(drawNode);
            }
        });
        drawNodes.forEach((drawNode) => {
            drawNode.draw();
        });
    },
    _endDragAfter(evt) {
        DD._dragElements.forEach((elem, key) => {
            if (elem.dragStatus === 'stopped') {
                elem.node.fire('dragend', {
                    type: 'dragend',
                    target: elem.node,
                    evt: evt,
                }, true);
            }
            if (elem.dragStatus !== 'dragging') {
                DD._dragElements.delete(key);
            }
        });
    },
};
if (Konva$1.isBrowser) {
    window.addEventListener('mouseup', DD._endDragBefore, true);
    window.addEventListener('touchend', DD._endDragBefore, true);
    window.addEventListener('touchcancel', DD._endDragBefore, true);
    window.addEventListener('mousemove', DD._drag);
    window.addEventListener('touchmove', DD._drag);
    window.addEventListener('mouseup', DD._endDragAfter, false);
    window.addEventListener('touchend', DD._endDragAfter, false);
    window.addEventListener('touchcancel', DD._endDragAfter, false);
}

function _formatValue(val) {
    if (Util._isString(val)) {
        return '"' + val + '"';
    }
    if (Object.prototype.toString.call(val) === '[object Number]') {
        return val;
    }
    if (Util._isBoolean(val)) {
        return val;
    }
    return Object.prototype.toString.call(val);
}
function RGBComponent(val) {
    if (val > 255) {
        return 255;
    }
    else if (val < 0) {
        return 0;
    }
    return Math.round(val);
}
function getNumberValidator() {
    if (Konva$1.isUnminified) {
        return function (val, attr) {
            if (!Util._isNumber(val)) {
                Util.warn(_formatValue(val) +
                    ' is a not valid value for "' +
                    attr +
                    '" attribute. The value should be a number.');
            }
            return val;
        };
    }
}
function getNumberOrArrayOfNumbersValidator(noOfElements) {
    if (Konva$1.isUnminified) {
        return function (val, attr) {
            let isNumber = Util._isNumber(val);
            let isValidArray = Util._isArray(val) && val.length == noOfElements;
            if (!isNumber && !isValidArray) {
                Util.warn(_formatValue(val) +
                    ' is a not valid value for "' +
                    attr +
                    '" attribute. The value should be a number or Array<number>(' +
                    noOfElements +
                    ')');
            }
            return val;
        };
    }
}
function getNumberOrAutoValidator() {
    if (Konva$1.isUnminified) {
        return function (val, attr) {
            const isNumber = Util._isNumber(val);
            const isAuto = val === 'auto';
            if (!(isNumber || isAuto)) {
                Util.warn(_formatValue(val) +
                    ' is a not valid value for "' +
                    attr +
                    '" attribute. The value should be a number or "auto".');
            }
            return val;
        };
    }
}
function getStringValidator() {
    if (Konva$1.isUnminified) {
        return function (val, attr) {
            if (!Util._isString(val)) {
                Util.warn(_formatValue(val) +
                    ' is a not valid value for "' +
                    attr +
                    '" attribute. The value should be a string.');
            }
            return val;
        };
    }
}
function getStringOrGradientValidator() {
    if (Konva$1.isUnminified) {
        return function (val, attr) {
            const isString = Util._isString(val);
            const isGradient = Object.prototype.toString.call(val) === '[object CanvasGradient]' ||
                (val && val['addColorStop']);
            if (!(isString || isGradient)) {
                Util.warn(_formatValue(val) +
                    ' is a not valid value for "' +
                    attr +
                    '" attribute. The value should be a string or a native gradient.');
            }
            return val;
        };
    }
}
function getNumberArrayValidator() {
    if (Konva$1.isUnminified) {
        return function (val, attr) {
            const TypedArray = Int8Array ? Object.getPrototypeOf(Int8Array) : null;
            if (TypedArray && val instanceof TypedArray) {
                return val;
            }
            if (!Util._isArray(val)) {
                Util.warn(_formatValue(val) +
                    ' is a not valid value for "' +
                    attr +
                    '" attribute. The value should be a array of numbers.');
            }
            else {
                val.forEach(function (item) {
                    if (!Util._isNumber(item)) {
                        Util.warn('"' +
                            attr +
                            '" attribute has non numeric element ' +
                            item +
                            '. Make sure that all elements are numbers.');
                    }
                });
            }
            return val;
        };
    }
}
function getBooleanValidator() {
    if (Konva$1.isUnminified) {
        return function (val, attr) {
            const isBool = val === true || val === false;
            if (!isBool) {
                Util.warn(_formatValue(val) +
                    ' is a not valid value for "' +
                    attr +
                    '" attribute. The value should be a boolean.');
            }
            return val;
        };
    }
}
function getComponentValidator(components) {
    if (Konva$1.isUnminified) {
        return function (val, attr) {
            if (val === undefined || val === null) {
                return val;
            }
            if (!Util.isObject(val)) {
                Util.warn(_formatValue(val) +
                    ' is a not valid value for "' +
                    attr +
                    '" attribute. The value should be an object with properties ' +
                    components);
            }
            return val;
        };
    }
}

const GET = 'get';
const SET$1 = 'set';
const Factory = {
    addGetterSetter(constructor, attr, def, validator, after) {
        Factory.addGetter(constructor, attr, def);
        Factory.addSetter(constructor, attr, validator, after);
        Factory.addOverloadedGetterSetter(constructor, attr);
    },
    addGetter(constructor, attr, def) {
        const method = GET + Util._capitalize(attr);
        constructor.prototype[method] =
            constructor.prototype[method] ||
                function () {
                    const val = this.attrs[attr];
                    return val === undefined ? def : val;
                };
    },
    addSetter(constructor, attr, validator, after) {
        const method = SET$1 + Util._capitalize(attr);
        if (!constructor.prototype[method]) {
            Factory.overWriteSetter(constructor, attr, validator, after);
        }
    },
    overWriteSetter(constructor, attr, validator, after) {
        const method = SET$1 + Util._capitalize(attr);
        constructor.prototype[method] = function (val) {
            if (validator && val !== undefined && val !== null) {
                val = validator.call(this, val, attr);
            }
            this._setAttr(attr, val);
            if (after) {
                after.call(this);
            }
            return this;
        };
    },
    addComponentsGetterSetter(constructor, attr, components, validator, after) {
        const len = components.length, capitalize = Util._capitalize, getter = GET + capitalize(attr), setter = SET$1 + capitalize(attr);
        constructor.prototype[getter] = function () {
            const ret = {};
            for (let n = 0; n < len; n++) {
                const component = components[n];
                ret[component] = this.getAttr(attr + capitalize(component));
            }
            return ret;
        };
        const basicValidator = getComponentValidator(components);
        constructor.prototype[setter] = function (val) {
            const oldVal = this.attrs[attr];
            if (validator) {
                val = validator.call(this, val, attr);
            }
            if (basicValidator) {
                basicValidator.call(this, val, attr);
            }
            for (const key in val) {
                if (!val.hasOwnProperty(key)) {
                    continue;
                }
                this._setAttr(attr + capitalize(key), val[key]);
            }
            if (!val) {
                components.forEach((component) => {
                    this._setAttr(attr + capitalize(component), undefined);
                });
            }
            this._fireChangeEvent(attr, oldVal, val);
            if (after) {
                after.call(this);
            }
            return this;
        };
        Factory.addOverloadedGetterSetter(constructor, attr);
    },
    addOverloadedGetterSetter(constructor, attr) {
        const capitalizedAttr = Util._capitalize(attr), setter = SET$1 + capitalizedAttr, getter = GET + capitalizedAttr;
        constructor.prototype[attr] = function () {
            if (arguments.length) {
                this[setter](arguments[0]);
                return this;
            }
            return this[getter]();
        };
    },
    addDeprecatedGetterSetter(constructor, attr, def, validator) {
        Util.error('Adding deprecated ' + attr);
        const method = GET + Util._capitalize(attr);
        const message = attr +
            ' property is deprecated and will be removed soon. Look at Konva change log for more information.';
        constructor.prototype[method] = function () {
            Util.error(message);
            const val = this.attrs[attr];
            return val === undefined ? def : val;
        };
        Factory.addSetter(constructor, attr, validator, function () {
            Util.error(message);
        });
        Factory.addOverloadedGetterSetter(constructor, attr);
    },
    backCompat(constructor, methods) {
        Util.each(methods, function (oldMethodName, newMethodName) {
            const method = constructor.prototype[newMethodName];
            const oldGetter = GET + Util._capitalize(oldMethodName);
            const oldSetter = SET$1 + Util._capitalize(oldMethodName);
            function deprecated() {
                method.apply(this, arguments);
                Util.error('"' +
                    oldMethodName +
                    '" method is deprecated and will be removed soon. Use ""' +
                    newMethodName +
                    '" instead.');
            }
            constructor.prototype[oldMethodName] = deprecated;
            constructor.prototype[oldGetter] = deprecated;
            constructor.prototype[oldSetter] = deprecated;
        });
    },
    afterSetFilter() {
        this._filterUpToDate = false;
    },
};

function parseCSSFilters(cssFilter) {
    const filterRegex = /(\w+)\(([^)]+)\)/g;
    let match;
    while ((match = filterRegex.exec(cssFilter)) !== null) {
        const [, filterName, filterValue] = match;
        switch (filterName) {
            case 'blur': {
                const blurRadius = parseFloat(filterValue.replace('px', ''));
                return function (imageData) {
                    this.blurRadius(blurRadius * 0.5);
                    const KonvaFilters = Konva$1.Filters;
                    if (KonvaFilters && KonvaFilters.Blur) {
                        KonvaFilters.Blur.call(this, imageData);
                    }
                };
            }
            case 'brightness': {
                const brightness = filterValue.includes('%')
                    ? parseFloat(filterValue) / 100
                    : parseFloat(filterValue);
                return function (imageData) {
                    this.brightness(brightness);
                    const KonvaFilters = Konva$1.Filters;
                    if (KonvaFilters && KonvaFilters.Brightness) {
                        KonvaFilters.Brightness.call(this, imageData);
                    }
                };
            }
            case 'contrast': {
                const contrast = parseFloat(filterValue);
                return function (imageData) {
                    const konvaContrast = 100 * (Math.sqrt(contrast) - 1);
                    this.contrast(konvaContrast);
                    const KonvaFilters = Konva$1.Filters;
                    if (KonvaFilters && KonvaFilters.Contrast) {
                        KonvaFilters.Contrast.call(this, imageData);
                    }
                };
            }
            case 'grayscale': {
                return function (imageData) {
                    const KonvaFilters = Konva$1.Filters;
                    if (KonvaFilters && KonvaFilters.Grayscale) {
                        KonvaFilters.Grayscale.call(this, imageData);
                    }
                };
            }
            case 'sepia': {
                return function (imageData) {
                    const KonvaFilters = Konva$1.Filters;
                    if (KonvaFilters && KonvaFilters.Sepia) {
                        KonvaFilters.Sepia.call(this, imageData);
                    }
                };
            }
            case 'invert': {
                return function (imageData) {
                    const KonvaFilters = Konva$1.Filters;
                    if (KonvaFilters && KonvaFilters.Invert) {
                        KonvaFilters.Invert.call(this, imageData);
                    }
                };
            }
            default:
                Util.warn(`CSS filter "${filterName}" is not supported in fallback mode. Consider using function filters for better compatibility.`);
                break;
        }
    }
    return () => { };
}
const ABSOLUTE_OPACITY = 'absoluteOpacity', ALL_LISTENERS = 'allEventListeners', ABSOLUTE_TRANSFORM = 'absoluteTransform', ABSOLUTE_SCALE = 'absoluteScale', CANVAS = 'canvas', CHANGE = 'Change', CHILDREN = 'children', KONVA = 'konva', LISTENING = 'listening', MOUSEENTER$1 = 'mouseenter', MOUSELEAVE$1 = 'mouseleave', POINTERENTER$1 = 'pointerenter', POINTERLEAVE$1 = 'pointerleave', TOUCHENTER = 'touchenter', TOUCHLEAVE = 'touchleave', SET = 'set', SHAPE = 'Shape', SPACE$1 = ' ', STAGE$1 = 'stage', TRANSFORM = 'transform', UPPER_STAGE = 'Stage', VISIBLE = 'visible', TRANSFORM_CHANGE_STR$1 = [
    'xChange.konva',
    'yChange.konva',
    'scaleXChange.konva',
    'scaleYChange.konva',
    'skewXChange.konva',
    'skewYChange.konva',
    'rotationChange.konva',
    'offsetXChange.konva',
    'offsetYChange.konva',
    'transformsEnabledChange.konva',
].join(SPACE$1);
let idCounter$1 = 1;
class Node {
    constructor(config) {
        this._id = idCounter$1++;
        this.eventListeners = {};
        this.attrs = {};
        this.index = 0;
        this._allEventListeners = null;
        this.parent = null;
        this._cache = new Map();
        this._attachedDepsListeners = new Map();
        this._lastPos = null;
        this._batchingTransformChange = false;
        this._needClearTransformCache = false;
        this._filterUpToDate = false;
        this._isUnderCache = false;
        this._dragEventId = null;
        this._shouldFireChangeEvents = false;
        this.setAttrs(config);
        this._shouldFireChangeEvents = true;
    }
    hasChildren() {
        return false;
    }
    _clearCache(attr) {
        if ((attr === TRANSFORM || attr === ABSOLUTE_TRANSFORM) &&
            this._cache.get(attr)) {
            this._cache.get(attr).dirty = true;
        }
        else if (attr) {
            this._cache.delete(attr);
        }
        else {
            this._cache.clear();
        }
    }
    _getCache(attr, privateGetter) {
        let cache = this._cache.get(attr);
        const isTransform = attr === TRANSFORM || attr === ABSOLUTE_TRANSFORM;
        const invalid = cache === undefined || (isTransform && cache.dirty === true);
        if (invalid) {
            cache = privateGetter.call(this);
            this._cache.set(attr, cache);
        }
        return cache;
    }
    _calculate(name, deps, getter) {
        if (!this._attachedDepsListeners.get(name)) {
            const depsString = deps.map((dep) => dep + 'Change.konva').join(SPACE$1);
            this.on(depsString, () => {
                this._clearCache(name);
            });
            this._attachedDepsListeners.set(name, true);
        }
        return this._getCache(name, getter);
    }
    _getCanvasCache() {
        return this._cache.get(CANVAS);
    }
    _clearSelfAndDescendantCache(attr) {
        this._clearCache(attr);
        if (attr === ABSOLUTE_TRANSFORM) {
            this.fire('absoluteTransformChange');
        }
    }
    clearCache() {
        if (this._cache.has(CANVAS)) {
            const { scene, filter, hit } = this._cache.get(CANVAS);
            Util.releaseCanvas(scene._canvas, filter._canvas, hit._canvas);
            this._cache.delete(CANVAS);
        }
        this._clearSelfAndDescendantCache();
        this._requestDraw();
        return this;
    }
    cache(config) {
        const conf = config || {};
        let rect = {};
        if (conf.x === undefined ||
            conf.y === undefined ||
            conf.width === undefined ||
            conf.height === undefined) {
            rect = this.getClientRect({
                skipTransform: true,
                relativeTo: this.getParent() || undefined,
            });
        }
        let width = Math.ceil(conf.width || rect.width), height = Math.ceil(conf.height || rect.height), pixelRatio = conf.pixelRatio, x = conf.x === undefined ? Math.floor(rect.x) : conf.x, y = conf.y === undefined ? Math.floor(rect.y) : conf.y, offset = conf.offset || 0, drawBorder = conf.drawBorder || false, hitCanvasPixelRatio = conf.hitCanvasPixelRatio || 1;
        if (!width || !height) {
            Util.error('Can not cache the node. Width or height of the node equals 0. Caching is skipped.');
            return;
        }
        const extraPaddingX = Math.abs(Math.round(rect.x) - x) > 0.5 ? 1 : 0;
        const extraPaddingY = Math.abs(Math.round(rect.y) - y) > 0.5 ? 1 : 0;
        width += offset * 2 + extraPaddingX;
        height += offset * 2 + extraPaddingY;
        x -= offset;
        y -= offset;
        const cachedSceneCanvas = new SceneCanvas({
            pixelRatio: pixelRatio,
            width: width,
            height: height,
        }), cachedFilterCanvas = new SceneCanvas({
            pixelRatio: pixelRatio,
            width: 0,
            height: 0,
            willReadFrequently: true,
        }), cachedHitCanvas = new HitCanvas({
            pixelRatio: hitCanvasPixelRatio,
            width: width,
            height: height,
        }), sceneContext = cachedSceneCanvas.getContext(), hitContext = cachedHitCanvas.getContext();
        const bufferCanvas = new SceneCanvas({
            width: cachedSceneCanvas.width / cachedSceneCanvas.pixelRatio + Math.abs(x),
            height: cachedSceneCanvas.height / cachedSceneCanvas.pixelRatio + Math.abs(y),
            pixelRatio: cachedSceneCanvas.pixelRatio,
        }), bufferContext = bufferCanvas.getContext();
        cachedHitCanvas.isCache = true;
        cachedSceneCanvas.isCache = true;
        this._cache.delete(CANVAS);
        this._filterUpToDate = false;
        if (conf.imageSmoothingEnabled === false) {
            cachedSceneCanvas.getContext()._context.imageSmoothingEnabled = false;
            cachedFilterCanvas.getContext()._context.imageSmoothingEnabled = false;
        }
        sceneContext.save();
        hitContext.save();
        bufferContext.save();
        sceneContext.translate(-x, -y);
        hitContext.translate(-x, -y);
        bufferContext.translate(-x, -y);
        bufferCanvas.x = x;
        bufferCanvas.y = y;
        this._isUnderCache = true;
        this._clearSelfAndDescendantCache(ABSOLUTE_OPACITY);
        this._clearSelfAndDescendantCache(ABSOLUTE_SCALE);
        this.drawScene(cachedSceneCanvas, this, bufferCanvas);
        this.drawHit(cachedHitCanvas, this);
        this._isUnderCache = false;
        sceneContext.restore();
        hitContext.restore();
        if (drawBorder) {
            sceneContext.save();
            sceneContext.beginPath();
            sceneContext.rect(0, 0, width, height);
            sceneContext.closePath();
            sceneContext.setAttr('strokeStyle', 'red');
            sceneContext.setAttr('lineWidth', 5);
            sceneContext.stroke();
            sceneContext.restore();
        }
        Util.releaseCanvas(bufferCanvas._canvas);
        this._cache.set(CANVAS, {
            scene: cachedSceneCanvas,
            filter: cachedFilterCanvas,
            hit: cachedHitCanvas,
            x: x,
            y: y,
        });
        this._requestDraw();
        return this;
    }
    isCached() {
        return this._cache.has(CANVAS);
    }
    getClientRect(config) {
        throw new Error('abstract "getClientRect" method call');
    }
    _transformedRect(rect, top) {
        const points = [
            { x: rect.x, y: rect.y },
            { x: rect.x + rect.width, y: rect.y },
            { x: rect.x + rect.width, y: rect.y + rect.height },
            { x: rect.x, y: rect.y + rect.height },
        ];
        let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
        const trans = this.getAbsoluteTransform(top);
        points.forEach(function (point) {
            const transformed = trans.point(point);
            if (minX === undefined) {
                minX = maxX = transformed.x;
                minY = maxY = transformed.y;
            }
            minX = Math.min(minX, transformed.x);
            minY = Math.min(minY, transformed.y);
            maxX = Math.max(maxX, transformed.x);
            maxY = Math.max(maxY, transformed.y);
        });
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY,
        };
    }
    _drawCachedSceneCanvas(context) {
        context.save();
        context._applyOpacity(this);
        context._applyGlobalCompositeOperation(this);
        const canvasCache = this._getCanvasCache();
        context.translate(canvasCache.x, canvasCache.y);
        const cacheCanvas = this._getCachedSceneCanvas();
        const ratio = cacheCanvas.pixelRatio;
        context.drawImage(cacheCanvas._canvas, 0, 0, cacheCanvas.width / ratio, cacheCanvas.height / ratio);
        context.restore();
    }
    _drawCachedHitCanvas(context) {
        const canvasCache = this._getCanvasCache(), hitCanvas = canvasCache.hit;
        context.save();
        context.translate(canvasCache.x, canvasCache.y);
        context.drawImage(hitCanvas._canvas, 0, 0, hitCanvas.width / hitCanvas.pixelRatio, hitCanvas.height / hitCanvas.pixelRatio);
        context.restore();
    }
    _getCachedSceneCanvas() {
        let filters = this.filters(), cachedCanvas = this._getCanvasCache(), sceneCanvas = cachedCanvas.scene, filterCanvas = cachedCanvas.filter, filterContext = filterCanvas.getContext(), len, imageData, n, filter;
        if (!filters || filters.length === 0) {
            return sceneCanvas;
        }
        if (this._filterUpToDate) {
            return filterCanvas;
        }
        let useNativeOnly = true;
        for (let i = 0; i < filters.length; i++) {
            typeof filters[i] === 'string' && !isCSSFiltersSupported();
            if (typeof filters[i] !== 'string' || !isCSSFiltersSupported()) {
                useNativeOnly = false;
                break;
            }
        }
        const ratio = sceneCanvas.pixelRatio;
        filterCanvas.setSize(sceneCanvas.width / sceneCanvas.pixelRatio, sceneCanvas.height / sceneCanvas.pixelRatio);
        if (useNativeOnly) {
            const finalFilter = filters.join(' ');
            filterContext.save();
            filterContext.setAttr('filter', finalFilter);
            filterContext.drawImage(sceneCanvas._canvas, 0, 0, sceneCanvas.getWidth() / ratio, sceneCanvas.getHeight() / ratio);
            filterContext.restore();
            this._filterUpToDate = true;
            return filterCanvas;
        }
        try {
            len = filters.length;
            filterContext.clear();
            filterContext.drawImage(sceneCanvas._canvas, 0, 0, sceneCanvas.getWidth() / ratio, sceneCanvas.getHeight() / ratio);
            imageData = filterContext.getImageData(0, 0, filterCanvas.getWidth(), filterCanvas.getHeight());
            for (n = 0; n < len; n++) {
                filter = filters[n];
                if (typeof filter === 'string') {
                    filter = parseCSSFilters(filter);
                }
                filter.call(this, imageData);
                filterContext.putImageData(imageData, 0, 0);
            }
        }
        catch (e) {
            Util.error('Unable to apply filter. ' +
                e.message +
                ' This post my help you https://konvajs.org/docs/posts/Tainted_Canvas.html.');
        }
        this._filterUpToDate = true;
        return filterCanvas;
    }
    on(...args) {
        const evtStr = args[0];
        const selectorOrHandler = args[1];
        args[2];
        if (this._cache) {
            this._cache.delete(ALL_LISTENERS);
        }
        if (args.length === 3) {
            return this._delegate.apply(this, args);
        }
        const events = evtStr.split(SPACE$1);
        for (let n = 0; n < events.length; n++) {
            const event = events[n];
            const parts = event.split('.');
            const baseEvent = parts[0];
            const name = parts[1] || '';
            if (!this.eventListeners[baseEvent]) {
                this.eventListeners[baseEvent] = [];
            }
            this.eventListeners[baseEvent].push({ name, handler: selectorOrHandler });
        }
        return this;
    }
    off(evtStr, callback) {
        let events = (evtStr || '').split(SPACE$1), len = events.length, n, t, event, parts, baseEvent, name;
        this._cache && this._cache.delete(ALL_LISTENERS);
        if (!evtStr) {
            for (t in this.eventListeners) {
                this._off(t);
            }
        }
        for (n = 0; n < len; n++) {
            event = events[n];
            parts = event.split('.');
            baseEvent = parts[0];
            name = parts[1];
            if (baseEvent) {
                if (this.eventListeners[baseEvent]) {
                    this._off(baseEvent, name, callback);
                }
            }
            else {
                for (t in this.eventListeners) {
                    this._off(t, name, callback);
                }
            }
        }
        return this;
    }
    dispatchEvent(evt) {
        const e = {
            target: this,
            type: evt.type,
            evt: evt,
        };
        this.fire(evt.type, e);
        return this;
    }
    addEventListener(type, handler) {
        this.on(type, function (evt) {
            handler.call(this, evt.evt);
        });
        return this;
    }
    removeEventListener(type) {
        this.off(type);
        return this;
    }
    _delegate(event, selector, handler) {
        const stopNode = this;
        this.on(event, function (evt) {
            const targets = evt.target.findAncestors(selector, true, stopNode);
            for (let i = 0; i < targets.length; i++) {
                evt = Util.cloneObject(evt);
                evt.currentTarget = targets[i];
                handler.call(targets[i], evt);
            }
        });
        return this;
    }
    remove() {
        if (this.isDragging()) {
            this.stopDrag();
        }
        DD._dragElements.delete(this._id);
        DD._dragElements.forEach((elem, key) => {
            if (this.isAncestorOf(elem.node)) {
                DD._dragElements.delete(key);
            }
        });
        this._remove();
        return this;
    }
    _clearCaches() {
        this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
        this._clearSelfAndDescendantCache(ABSOLUTE_OPACITY);
        this._clearSelfAndDescendantCache(ABSOLUTE_SCALE);
        this._clearSelfAndDescendantCache(STAGE$1);
        this._clearSelfAndDescendantCache(VISIBLE);
        this._clearSelfAndDescendantCache(LISTENING);
    }
    _remove() {
        this._clearCaches();
        const parent = this.getParent();
        if (parent && parent.children) {
            parent.children.splice(this.index, 1);
            parent._setChildrenIndices();
            this.parent = null;
        }
    }
    destroy() {
        this.remove();
        this.clearCache();
        return this;
    }
    getAttr(attr) {
        const method = 'get' + Util._capitalize(attr);
        if (Util._isFunction(this[method])) {
            return this[method]();
        }
        return this.attrs[attr];
    }
    getAncestors() {
        let parent = this.getParent(), ancestors = [];
        while (parent) {
            ancestors.push(parent);
            parent = parent.getParent();
        }
        return ancestors;
    }
    getAttrs() {
        return this.attrs || {};
    }
    setAttrs(config) {
        this._batchTransformChanges(() => {
            let key, method;
            if (!config) {
                return this;
            }
            for (key in config) {
                if (key === CHILDREN) {
                    continue;
                }
                method = SET + Util._capitalize(key);
                if (Util._isFunction(this[method])) {
                    this[method](config[key]);
                }
                else {
                    this._setAttr(key, config[key]);
                }
            }
        });
        return this;
    }
    isListening() {
        return this._getCache(LISTENING, this._isListening);
    }
    _isListening(relativeTo) {
        const listening = this.listening();
        if (!listening) {
            return false;
        }
        const parent = this.getParent();
        if (parent && parent !== relativeTo && this !== relativeTo) {
            return parent._isListening(relativeTo);
        }
        else {
            return true;
        }
    }
    isVisible() {
        return this._getCache(VISIBLE, this._isVisible);
    }
    _isVisible(relativeTo) {
        const visible = this.visible();
        if (!visible) {
            return false;
        }
        const parent = this.getParent();
        if (parent && parent !== relativeTo && this !== relativeTo) {
            return parent._isVisible(relativeTo);
        }
        else {
            return true;
        }
    }
    shouldDrawHit(top, skipDragCheck = false) {
        if (top) {
            return this._isVisible(top) && this._isListening(top);
        }
        const layer = this.getLayer();
        let layerUnderDrag = false;
        DD._dragElements.forEach((elem) => {
            if (elem.dragStatus !== 'dragging') {
                return;
            }
            else if (elem.node.nodeType === 'Stage') {
                layerUnderDrag = true;
            }
            else if (elem.node.getLayer() === layer) {
                layerUnderDrag = true;
            }
        });
        const dragSkip = !skipDragCheck &&
            !Konva$1.hitOnDragEnabled &&
            (layerUnderDrag || Konva$1.isTransforming());
        return this.isListening() && this.isVisible() && !dragSkip;
    }
    show() {
        this.visible(true);
        return this;
    }
    hide() {
        this.visible(false);
        return this;
    }
    getZIndex() {
        return this.index || 0;
    }
    getAbsoluteZIndex() {
        let depth = this.getDepth(), that = this, index = 0, nodes, len, n, child;
        function addChildren(children) {
            nodes = [];
            len = children.length;
            for (n = 0; n < len; n++) {
                child = children[n];
                index++;
                if (child.nodeType !== SHAPE) {
                    nodes = nodes.concat(child.getChildren().slice());
                }
                if (child._id === that._id) {
                    n = len;
                }
            }
            if (nodes.length > 0 && nodes[0].getDepth() <= depth) {
                addChildren(nodes);
            }
        }
        const stage = this.getStage();
        if (that.nodeType !== UPPER_STAGE && stage) {
            addChildren(stage.getChildren());
        }
        return index;
    }
    getDepth() {
        let depth = 0, parent = this.parent;
        while (parent) {
            depth++;
            parent = parent.parent;
        }
        return depth;
    }
    _batchTransformChanges(func) {
        this._batchingTransformChange = true;
        func();
        this._batchingTransformChange = false;
        if (this._needClearTransformCache) {
            this._clearCache(TRANSFORM);
            this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
        }
        this._needClearTransformCache = false;
    }
    setPosition(pos) {
        this._batchTransformChanges(() => {
            this.x(pos.x);
            this.y(pos.y);
        });
        return this;
    }
    getPosition() {
        return {
            x: this.x(),
            y: this.y(),
        };
    }
    getRelativePointerPosition() {
        const stage = this.getStage();
        if (!stage) {
            return null;
        }
        const pos = stage.getPointerPosition();
        if (!pos) {
            return null;
        }
        const transform = this.getAbsoluteTransform().copy();
        transform.invert();
        return transform.point(pos);
    }
    getAbsolutePosition(top) {
        let haveCachedParent = false;
        let parent = this.parent;
        while (parent) {
            if (parent.isCached()) {
                haveCachedParent = true;
                break;
            }
            parent = parent.parent;
        }
        if (haveCachedParent && !top) {
            top = true;
        }
        const absoluteMatrix = this.getAbsoluteTransform(top).getMatrix(), absoluteTransform = new Transform(), offset = this.offset();
        absoluteTransform.m = absoluteMatrix.slice();
        absoluteTransform.translate(offset.x, offset.y);
        return absoluteTransform.getTranslation();
    }
    setAbsolutePosition(pos) {
        const { x, y, ...origTrans } = this._clearTransform();
        this.attrs.x = x;
        this.attrs.y = y;
        this._clearCache(TRANSFORM);
        const it = this._getAbsoluteTransform().copy();
        it.invert();
        it.translate(pos.x, pos.y);
        pos = {
            x: this.attrs.x + it.getTranslation().x,
            y: this.attrs.y + it.getTranslation().y,
        };
        this._setTransform(origTrans);
        this.setPosition({ x: pos.x, y: pos.y });
        this._clearCache(TRANSFORM);
        this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
        return this;
    }
    _setTransform(trans) {
        let key;
        for (key in trans) {
            this.attrs[key] = trans[key];
        }
    }
    _clearTransform() {
        const trans = {
            x: this.x(),
            y: this.y(),
            rotation: this.rotation(),
            scaleX: this.scaleX(),
            scaleY: this.scaleY(),
            offsetX: this.offsetX(),
            offsetY: this.offsetY(),
            skewX: this.skewX(),
            skewY: this.skewY(),
        };
        this.attrs.x = 0;
        this.attrs.y = 0;
        this.attrs.rotation = 0;
        this.attrs.scaleX = 1;
        this.attrs.scaleY = 1;
        this.attrs.offsetX = 0;
        this.attrs.offsetY = 0;
        this.attrs.skewX = 0;
        this.attrs.skewY = 0;
        return trans;
    }
    move(change) {
        let changeX = change.x, changeY = change.y, x = this.x(), y = this.y();
        if (changeX !== undefined) {
            x += changeX;
        }
        if (changeY !== undefined) {
            y += changeY;
        }
        this.setPosition({ x: x, y: y });
        return this;
    }
    _eachAncestorReverse(func, top) {
        let family = [], parent = this.getParent(), len, n;
        if (top && top._id === this._id) {
            return;
        }
        family.unshift(this);
        while (parent && (!top || parent._id !== top._id)) {
            family.unshift(parent);
            parent = parent.parent;
        }
        len = family.length;
        for (n = 0; n < len; n++) {
            func(family[n]);
        }
    }
    rotate(theta) {
        this.rotation(this.rotation() + theta);
        return this;
    }
    moveToTop() {
        if (!this.parent) {
            Util.warn('Node has no parent. moveToTop function is ignored.');
            return false;
        }
        const index = this.index, len = this.parent.getChildren().length;
        if (index < len - 1) {
            this.parent.children.splice(index, 1);
            this.parent.children.push(this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    moveUp() {
        if (!this.parent) {
            Util.warn('Node has no parent. moveUp function is ignored.');
            return false;
        }
        const index = this.index, len = this.parent.getChildren().length;
        if (index < len - 1) {
            this.parent.children.splice(index, 1);
            this.parent.children.splice(index + 1, 0, this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    moveDown() {
        if (!this.parent) {
            Util.warn('Node has no parent. moveDown function is ignored.');
            return false;
        }
        const index = this.index;
        if (index > 0) {
            this.parent.children.splice(index, 1);
            this.parent.children.splice(index - 1, 0, this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    moveToBottom() {
        if (!this.parent) {
            Util.warn('Node has no parent. moveToBottom function is ignored.');
            return false;
        }
        const index = this.index;
        if (index > 0) {
            this.parent.children.splice(index, 1);
            this.parent.children.unshift(this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    setZIndex(zIndex) {
        if (!this.parent) {
            Util.warn('Node has no parent. zIndex parameter is ignored.');
            return this;
        }
        if (zIndex < 0 || zIndex >= this.parent.children.length) {
            Util.warn('Unexpected value ' +
                zIndex +
                ' for zIndex property. zIndex is just index of a node in children of its parent. Expected value is from 0 to ' +
                (this.parent.children.length - 1) +
                '.');
        }
        const index = this.index;
        this.parent.children.splice(index, 1);
        this.parent.children.splice(zIndex, 0, this);
        this.parent._setChildrenIndices();
        return this;
    }
    getAbsoluteOpacity() {
        return this._getCache(ABSOLUTE_OPACITY, this._getAbsoluteOpacity);
    }
    _getAbsoluteOpacity() {
        let absOpacity = this.opacity();
        const parent = this.getParent();
        if (parent && !parent._isUnderCache) {
            absOpacity *= parent.getAbsoluteOpacity();
        }
        return absOpacity;
    }
    moveTo(newContainer) {
        if (this.getParent() !== newContainer) {
            this._remove();
            newContainer.add(this);
        }
        return this;
    }
    toObject() {
        let attrs = this.getAttrs(), key, val, getter, defaultValue, nonPlainObject;
        const obj = {
            attrs: {},
            className: this.getClassName(),
        };
        for (key in attrs) {
            val = attrs[key];
            nonPlainObject =
                Util.isObject(val) && !Util._isPlainObject(val) && !Util._isArray(val);
            if (nonPlainObject) {
                continue;
            }
            getter = typeof this[key] === 'function' && this[key];
            delete attrs[key];
            defaultValue = getter ? getter.call(this) : null;
            attrs[key] = val;
            if (defaultValue !== val) {
                obj.attrs[key] = val;
            }
        }
        return Util._prepareToStringify(obj);
    }
    toJSON() {
        return JSON.stringify(this.toObject());
    }
    getParent() {
        return this.parent;
    }
    findAncestors(selector, includeSelf, stopNode) {
        const res = [];
        if (includeSelf && this._isMatch(selector)) {
            res.push(this);
        }
        let ancestor = this.parent;
        while (ancestor) {
            if (ancestor === stopNode) {
                return res;
            }
            if (ancestor._isMatch(selector)) {
                res.push(ancestor);
            }
            ancestor = ancestor.parent;
        }
        return res;
    }
    isAncestorOf(node) {
        return false;
    }
    findAncestor(selector, includeSelf, stopNode) {
        return this.findAncestors(selector, includeSelf, stopNode)[0];
    }
    _isMatch(selector) {
        if (!selector) {
            return false;
        }
        if (typeof selector === 'function') {
            return selector(this);
        }
        let selectorArr = selector.replace(/ /g, '').split(','), len = selectorArr.length, n, sel;
        for (n = 0; n < len; n++) {
            sel = selectorArr[n];
            if (!Util.isValidSelector(sel)) {
                Util.warn('Selector "' +
                    sel +
                    '" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".');
                Util.warn('If you have a custom shape with such className, please change it to start with upper letter like "Triangle".');
                Util.warn('Konva is awesome, right?');
            }
            if (sel.charAt(0) === '#') {
                if (this.id() === sel.slice(1)) {
                    return true;
                }
            }
            else if (sel.charAt(0) === '.') {
                if (this.hasName(sel.slice(1))) {
                    return true;
                }
            }
            else if (this.className === sel || this.nodeType === sel) {
                return true;
            }
        }
        return false;
    }
    getLayer() {
        const parent = this.getParent();
        return parent ? parent.getLayer() : null;
    }
    getStage() {
        return this._getCache(STAGE$1, this._getStage);
    }
    _getStage() {
        const parent = this.getParent();
        if (parent) {
            return parent.getStage();
        }
        else {
            return null;
        }
    }
    fire(eventType, evt = {}, bubble) {
        evt.target = evt.target || this;
        if (bubble) {
            this._fireAndBubble(eventType, evt);
        }
        else {
            this._fire(eventType, evt);
        }
        return this;
    }
    getAbsoluteTransform(top) {
        if (top) {
            return this._getAbsoluteTransform(top);
        }
        else {
            return this._getCache(ABSOLUTE_TRANSFORM, this._getAbsoluteTransform);
        }
    }
    _getAbsoluteTransform(top) {
        let at;
        if (top) {
            at = new Transform();
            this._eachAncestorReverse(function (node) {
                const transformsEnabled = node.transformsEnabled();
                if (transformsEnabled === 'all') {
                    at.multiply(node.getTransform());
                }
                else if (transformsEnabled === 'position') {
                    at.translate(node.x() - node.offsetX(), node.y() - node.offsetY());
                }
            }, top);
            return at;
        }
        else {
            at = this._cache.get(ABSOLUTE_TRANSFORM) || new Transform();
            if (this.parent) {
                this.parent.getAbsoluteTransform().copyInto(at);
            }
            else {
                at.reset();
            }
            const transformsEnabled = this.transformsEnabled();
            if (transformsEnabled === 'all') {
                at.multiply(this.getTransform());
            }
            else if (transformsEnabled === 'position') {
                const x = this.attrs.x || 0;
                const y = this.attrs.y || 0;
                const offsetX = this.attrs.offsetX || 0;
                const offsetY = this.attrs.offsetY || 0;
                at.translate(x - offsetX, y - offsetY);
            }
            at.dirty = false;
            return at;
        }
    }
    getAbsoluteScale(top) {
        let parent = this;
        while (parent) {
            if (parent._isUnderCache) {
                top = parent;
            }
            parent = parent.getParent();
        }
        const transform = this.getAbsoluteTransform(top);
        const attrs = transform.decompose();
        return {
            x: attrs.scaleX,
            y: attrs.scaleY,
        };
    }
    getAbsoluteRotation() {
        return this.getAbsoluteTransform().decompose().rotation;
    }
    getTransform() {
        return this._getCache(TRANSFORM, this._getTransform);
    }
    _getTransform() {
        var _a, _b;
        const m = this._cache.get(TRANSFORM) || new Transform();
        m.reset();
        const x = this.x(), y = this.y(), rotation = Konva$1.getAngle(this.rotation()), scaleX = (_a = this.attrs.scaleX) !== null && _a !== void 0 ? _a : 1, scaleY = (_b = this.attrs.scaleY) !== null && _b !== void 0 ? _b : 1, skewX = this.attrs.skewX || 0, skewY = this.attrs.skewY || 0, offsetX = this.attrs.offsetX || 0, offsetY = this.attrs.offsetY || 0;
        if (x !== 0 || y !== 0) {
            m.translate(x, y);
        }
        if (rotation !== 0) {
            m.rotate(rotation);
        }
        if (skewX !== 0 || skewY !== 0) {
            m.skew(skewX, skewY);
        }
        if (scaleX !== 1 || scaleY !== 1) {
            m.scale(scaleX, scaleY);
        }
        if (offsetX !== 0 || offsetY !== 0) {
            m.translate(-1 * offsetX, -1 * offsetY);
        }
        m.dirty = false;
        return m;
    }
    clone(obj) {
        let attrs = Util.cloneObject(this.attrs), key, allListeners, len, n, listener;
        for (key in obj) {
            attrs[key] = obj[key];
        }
        const node = new this.constructor(attrs);
        for (key in this.eventListeners) {
            allListeners = this.eventListeners[key];
            len = allListeners.length;
            for (n = 0; n < len; n++) {
                listener = allListeners[n];
                if (listener.name.indexOf(KONVA) < 0) {
                    if (!node.eventListeners[key]) {
                        node.eventListeners[key] = [];
                    }
                    node.eventListeners[key].push(listener);
                }
            }
        }
        return node;
    }
    _toKonvaCanvas(config) {
        config = config || {};
        const box = this.getClientRect();
        const stage = this.getStage(), x = config.x !== undefined ? config.x : Math.floor(box.x), y = config.y !== undefined ? config.y : Math.floor(box.y), pixelRatio = config.pixelRatio || 1, canvas = new SceneCanvas({
            width: config.width || Math.ceil(box.width) || (stage ? stage.width() : 0),
            height: config.height ||
                Math.ceil(box.height) ||
                (stage ? stage.height() : 0),
            pixelRatio: pixelRatio,
        }), context = canvas.getContext();
        const bufferCanvas = new SceneCanvas({
            width: canvas.width / canvas.pixelRatio + Math.abs(x),
            height: canvas.height / canvas.pixelRatio + Math.abs(y),
            pixelRatio: canvas.pixelRatio,
        });
        if (config.imageSmoothingEnabled === false) {
            context._context.imageSmoothingEnabled = false;
        }
        context.save();
        if (x || y) {
            context.translate(-1 * x, -1 * y);
        }
        this.drawScene(canvas, undefined, bufferCanvas);
        context.restore();
        return canvas;
    }
    toCanvas(config) {
        return this._toKonvaCanvas(config)._canvas;
    }
    toDataURL(config) {
        config = config || {};
        const mimeType = config.mimeType || null, quality = config.quality || null;
        const url = this._toKonvaCanvas(config).toDataURL(mimeType, quality);
        if (config.callback) {
            config.callback(url);
        }
        return url;
    }
    toImage(config) {
        return new Promise((resolve, reject) => {
            try {
                const callback = config === null || config === void 0 ? void 0 : config.callback;
                if (callback)
                    delete config.callback;
                Util._urlToImage(this.toDataURL(config), function (img) {
                    resolve(img);
                    callback === null || callback === void 0 ? void 0 : callback(img);
                });
            }
            catch (err) {
                reject(err);
            }
        });
    }
    toBlob(config) {
        return new Promise((resolve, reject) => {
            try {
                const callback = config === null || config === void 0 ? void 0 : config.callback;
                if (callback)
                    delete config.callback;
                this.toCanvas(config).toBlob((blob) => {
                    resolve(blob);
                    callback === null || callback === void 0 ? void 0 : callback(blob);
                }, config === null || config === void 0 ? void 0 : config.mimeType, config === null || config === void 0 ? void 0 : config.quality);
            }
            catch (err) {
                reject(err);
            }
        });
    }
    setSize(size) {
        this.width(size.width);
        this.height(size.height);
        return this;
    }
    getSize() {
        return {
            width: this.width(),
            height: this.height(),
        };
    }
    getClassName() {
        return this.className || this.nodeType;
    }
    getType() {
        return this.nodeType;
    }
    getDragDistance() {
        if (this.attrs.dragDistance !== undefined) {
            return this.attrs.dragDistance;
        }
        else if (this.parent) {
            return this.parent.getDragDistance();
        }
        else {
            return Konva$1.dragDistance;
        }
    }
    _off(type, name, callback) {
        let evtListeners = this.eventListeners[type], i, evtName, handler;
        for (i = 0; i < evtListeners.length; i++) {
            evtName = evtListeners[i].name;
            handler = evtListeners[i].handler;
            if ((evtName !== 'konva' || name === 'konva') &&
                (!name || evtName === name) &&
                (!callback || callback === handler)) {
                evtListeners.splice(i, 1);
                if (evtListeners.length === 0) {
                    delete this.eventListeners[type];
                    break;
                }
                i--;
            }
        }
    }
    _fireChangeEvent(attr, oldVal, newVal) {
        this._fire(attr + CHANGE, {
            oldVal: oldVal,
            newVal: newVal,
        });
    }
    addName(name) {
        if (!this.hasName(name)) {
            const oldName = this.name();
            const newName = oldName ? oldName + ' ' + name : name;
            this.name(newName);
        }
        return this;
    }
    hasName(name) {
        if (!name) {
            return false;
        }
        const fullName = this.name();
        if (!fullName) {
            return false;
        }
        const names = (fullName || '').split(/\s/g);
        return names.indexOf(name) !== -1;
    }
    removeName(name) {
        const names = (this.name() || '').split(/\s/g);
        const index = names.indexOf(name);
        if (index !== -1) {
            names.splice(index, 1);
            this.name(names.join(' '));
        }
        return this;
    }
    setAttr(attr, val) {
        const func = this[SET + Util._capitalize(attr)];
        if (Util._isFunction(func)) {
            func.call(this, val);
        }
        else {
            this._setAttr(attr, val);
        }
        return this;
    }
    _requestDraw() {
        if (Konva$1.autoDrawEnabled) {
            const drawNode = this.getLayer() || this.getStage();
            drawNode === null || drawNode === void 0 ? void 0 : drawNode.batchDraw();
        }
    }
    _setAttr(key, val) {
        const oldVal = this.attrs[key];
        if (oldVal === val && !Util.isObject(val)) {
            return;
        }
        if (val === undefined || val === null) {
            delete this.attrs[key];
        }
        else {
            this.attrs[key] = val;
        }
        if (this._shouldFireChangeEvents) {
            this._fireChangeEvent(key, oldVal, val);
        }
        this._requestDraw();
    }
    _setComponentAttr(key, component, val) {
        let oldVal;
        if (val !== undefined) {
            oldVal = this.attrs[key];
            if (!oldVal) {
                this.attrs[key] = this.getAttr(key);
            }
            this.attrs[key][component] = val;
            this._fireChangeEvent(key, oldVal, val);
        }
    }
    _fireAndBubble(eventType, evt, compareShape) {
        if (evt && this.nodeType === SHAPE) {
            evt.target = this;
        }
        const nonBubbling = [
            MOUSEENTER$1,
            MOUSELEAVE$1,
            POINTERENTER$1,
            POINTERLEAVE$1,
            TOUCHENTER,
            TOUCHLEAVE,
        ];
        const shouldStop = nonBubbling.indexOf(eventType) !== -1 &&
            ((compareShape &&
                (this === compareShape ||
                    (this.isAncestorOf && this.isAncestorOf(compareShape)))) ||
                (this.nodeType === 'Stage' && !compareShape));
        if (!shouldStop) {
            this._fire(eventType, evt);
            const stopBubble = nonBubbling.indexOf(eventType) !== -1 &&
                compareShape &&
                compareShape.isAncestorOf &&
                compareShape.isAncestorOf(this) &&
                !compareShape.isAncestorOf(this.parent);
            if (((evt && !evt.cancelBubble) || !evt) &&
                this.parent &&
                this.parent.isListening() &&
                !stopBubble) {
                if (compareShape && compareShape.parent) {
                    this._fireAndBubble.call(this.parent, eventType, evt, compareShape);
                }
                else {
                    this._fireAndBubble.call(this.parent, eventType, evt);
                }
            }
        }
    }
    _getProtoListeners(eventType) {
        var _a, _b;
        const { nodeType } = this;
        const allListeners = Node.protoListenerMap.get(nodeType) || {};
        let events = allListeners === null || allListeners === void 0 ? void 0 : allListeners[eventType];
        if (events === undefined) {
            events = [];
            let obj = Object.getPrototypeOf(this);
            while (obj) {
                const hierarchyEvents = (_b = (_a = obj.eventListeners) === null || _a === void 0 ? void 0 : _a[eventType]) !== null && _b !== void 0 ? _b : [];
                events.push(...hierarchyEvents);
                obj = Object.getPrototypeOf(obj);
            }
            allListeners[eventType] = events;
            Node.protoListenerMap.set(nodeType, allListeners);
        }
        return events;
    }
    _fire(eventType, evt) {
        evt = evt || {};
        evt.currentTarget = this;
        evt.type = eventType;
        const topListeners = this._getProtoListeners(eventType);
        if (topListeners) {
            const list = topListeners.slice();
            for (let i = 0; i < list.length; i++) {
                list[i].handler.call(this, evt);
            }
        }
        const selfListeners = this.eventListeners[eventType];
        if (selfListeners) {
            const list = selfListeners.slice();
            const origLen = list.length;
            for (let i = 0; i < list.length; i++) {
                list[i].handler.call(this, evt);
            }
            const liveListeners = this.eventListeners[eventType];
            if (liveListeners) {
                for (let i = origLen; i < liveListeners.length; i++) {
                    liveListeners[i].handler.call(this, evt);
                }
            }
        }
    }
    draw() {
        this.drawScene();
        this.drawHit();
        return this;
    }
    _createDragElement(evt) {
        const pointerId = evt ? evt.pointerId : undefined;
        const stage = this.getStage();
        const ap = this.getAbsolutePosition();
        if (!stage) {
            return;
        }
        const pos = stage._getPointerById(pointerId) ||
            stage._changedPointerPositions[0] ||
            ap;
        DD._dragElements.set(this._id, {
            node: this,
            startPointerPos: pos,
            offset: {
                x: pos.x - ap.x,
                y: pos.y - ap.y,
            },
            dragStatus: 'ready',
            pointerId,
            startEvent: evt,
        });
    }
    startDrag(evt, bubbleEvent = true) {
        if (!DD._dragElements.has(this._id)) {
            this._createDragElement(evt);
        }
        const elem = DD._dragElements.get(this._id);
        elem.dragStatus = 'dragging';
        this.fire('dragstart', {
            type: 'dragstart',
            target: this,
            evt: (elem.startEvent && elem.startEvent.evt) || (evt && evt.evt),
        }, bubbleEvent);
    }
    _setDragPosition(evt, elem) {
        const pos = this.getStage()._getPointerById(elem.pointerId);
        if (!pos) {
            return;
        }
        let newNodePos = {
            x: pos.x - elem.offset.x,
            y: pos.y - elem.offset.y,
        };
        const dbf = this.dragBoundFunc();
        if (dbf !== undefined) {
            const bounded = dbf.call(this, newNodePos, evt);
            if (!bounded) {
                Util.warn('dragBoundFunc did not return any value. That is unexpected behavior. You must return new absolute position from dragBoundFunc.');
            }
            else {
                newNodePos = bounded;
            }
        }
        if (!this._lastPos ||
            this._lastPos.x !== newNodePos.x ||
            this._lastPos.y !== newNodePos.y) {
            this.setAbsolutePosition(newNodePos);
            this._requestDraw();
        }
        this._lastPos = newNodePos;
    }
    stopDrag(evt) {
        const elem = DD._dragElements.get(this._id);
        if (elem) {
            elem.dragStatus = 'stopped';
        }
        DD._endDragBefore(evt);
        DD._endDragAfter(evt);
    }
    setDraggable(draggable) {
        this._setAttr('draggable', draggable);
        this._dragChange();
    }
    isDragging() {
        const elem = DD._dragElements.get(this._id);
        return elem ? elem.dragStatus === 'dragging' : false;
    }
    _listenDrag() {
        this._dragCleanup();
        this.on('mousedown.konva touchstart.konva', function (evt) {
            const shouldCheckButton = evt.evt['button'] !== undefined;
            const canDrag = !shouldCheckButton || Konva$1.dragButtons.indexOf(evt.evt['button']) >= 0;
            if (!canDrag) {
                return;
            }
            if (this.isDragging()) {
                return;
            }
            let hasDraggingChild = false;
            DD._dragElements.forEach((elem) => {
                if (this.isAncestorOf(elem.node)) {
                    hasDraggingChild = true;
                }
            });
            if (!hasDraggingChild) {
                this._createDragElement(evt);
            }
        });
    }
    _dragChange() {
        if (this.attrs.draggable) {
            this._listenDrag();
        }
        else {
            this._dragCleanup();
            const stage = this.getStage();
            if (!stage) {
                return;
            }
            const dragElement = DD._dragElements.get(this._id);
            const isDragging = dragElement && dragElement.dragStatus === 'dragging';
            const isReady = dragElement && dragElement.dragStatus === 'ready';
            if (isDragging) {
                this.stopDrag();
            }
            else if (isReady) {
                DD._dragElements.delete(this._id);
            }
        }
    }
    _dragCleanup() {
        this.off('mousedown.konva');
        this.off('touchstart.konva');
    }
    isClientRectOnScreen(margin = { x: 0, y: 0 }) {
        const stage = this.getStage();
        if (!stage) {
            return false;
        }
        const screenRect = {
            x: -margin.x,
            y: -margin.y,
            width: stage.width() + 2 * margin.x,
            height: stage.height() + 2 * margin.y,
        };
        return Util.haveIntersection(screenRect, this.getClientRect());
    }
    static create(data, container) {
        if (Util._isString(data)) {
            data = JSON.parse(data);
        }
        return this._createNode(data, container);
    }
    static _createNode(obj, container) {
        let className = Node.prototype.getClassName.call(obj), children = obj.children, no, len, n;
        if (container) {
            obj.attrs.container = container;
        }
        if (!Konva$1[className]) {
            Util.warn('Can not find a node with class name "' +
                className +
                '". Fallback to "Shape".');
            className = 'Shape';
        }
        const Class = Konva$1[className];
        no = new Class(obj.attrs);
        if (children) {
            len = children.length;
            for (n = 0; n < len; n++) {
                no.add(Node._createNode(children[n]));
            }
        }
        return no;
    }
}
Node.protoListenerMap = new Map();
Node.prototype.nodeType = 'Node';
Node.prototype._attrsAffectingSize = [];
Node.prototype.eventListeners = {};
Node.prototype.on(TRANSFORM_CHANGE_STR$1, function () {
    if (this._batchingTransformChange) {
        this._needClearTransformCache = true;
        return;
    }
    this._clearCache(TRANSFORM);
    this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
});
Node.prototype.on('visibleChange.konva', function () {
    this._clearSelfAndDescendantCache(VISIBLE);
});
Node.prototype.on('listeningChange.konva', function () {
    this._clearSelfAndDescendantCache(LISTENING);
});
Node.prototype.on('opacityChange.konva', function () {
    this._clearSelfAndDescendantCache(ABSOLUTE_OPACITY);
});
const addGetterSetter = Factory.addGetterSetter;
addGetterSetter(Node, 'zIndex');
addGetterSetter(Node, 'absolutePosition');
addGetterSetter(Node, 'position');
addGetterSetter(Node, 'x', 0, getNumberValidator());
addGetterSetter(Node, 'y', 0, getNumberValidator());
addGetterSetter(Node, 'globalCompositeOperation', 'source-over', getStringValidator());
addGetterSetter(Node, 'opacity', 1, getNumberValidator());
addGetterSetter(Node, 'name', '', getStringValidator());
addGetterSetter(Node, 'id', '', getStringValidator());
addGetterSetter(Node, 'rotation', 0, getNumberValidator());
Factory.addComponentsGetterSetter(Node, 'scale', ['x', 'y']);
addGetterSetter(Node, 'scaleX', 1, getNumberValidator());
addGetterSetter(Node, 'scaleY', 1, getNumberValidator());
Factory.addComponentsGetterSetter(Node, 'skew', ['x', 'y']);
addGetterSetter(Node, 'skewX', 0, getNumberValidator());
addGetterSetter(Node, 'skewY', 0, getNumberValidator());
Factory.addComponentsGetterSetter(Node, 'offset', ['x', 'y']);
addGetterSetter(Node, 'offsetX', 0, getNumberValidator());
addGetterSetter(Node, 'offsetY', 0, getNumberValidator());
addGetterSetter(Node, 'dragDistance', undefined, getNumberValidator());
addGetterSetter(Node, 'width', 0, getNumberValidator());
addGetterSetter(Node, 'height', 0, getNumberValidator());
addGetterSetter(Node, 'listening', true, getBooleanValidator());
addGetterSetter(Node, 'preventDefault', true, getBooleanValidator());
addGetterSetter(Node, 'filters', undefined, function (val) {
    this._filterUpToDate = false;
    return val;
});
addGetterSetter(Node, 'visible', true, getBooleanValidator());
addGetterSetter(Node, 'transformsEnabled', 'all', getStringValidator());
addGetterSetter(Node, 'size');
addGetterSetter(Node, 'dragBoundFunc');
addGetterSetter(Node, 'draggable', false, getBooleanValidator());
Factory.backCompat(Node, {
    rotateDeg: 'rotate',
    setRotationDeg: 'setRotation',
    getRotationDeg: 'getRotation',
});

class Container extends Node {
    constructor() {
        super(...arguments);
        this.children = [];
    }
    getChildren(filterFunc) {
        const children = this.children || [];
        if (filterFunc) {
            return children.filter(filterFunc);
        }
        return children;
    }
    hasChildren() {
        return this.getChildren().length > 0;
    }
    removeChildren() {
        this.getChildren().forEach((child) => {
            child.parent = null;
            child.index = 0;
            child.remove();
        });
        this.children = [];
        this._requestDraw();
        return this;
    }
    destroyChildren() {
        this.getChildren().forEach((child) => {
            child.parent = null;
            child.index = 0;
            child.destroy();
        });
        this.children = [];
        this._requestDraw();
        return this;
    }
    add(...children) {
        if (children.length === 0) {
            return this;
        }
        if (children.length > 1) {
            for (let i = 0; i < children.length; i++) {
                this.add(children[i]);
            }
            return this;
        }
        const child = children[0];
        if (child.getParent()) {
            child.moveTo(this);
            return this;
        }
        this._validateAdd(child);
        child.index = this.getChildren().length;
        child.parent = this;
        child._clearCaches();
        this.getChildren().push(child);
        this._fire('add', {
            child: child,
        });
        this._requestDraw();
        return this;
    }
    destroy() {
        if (this.hasChildren()) {
            this.destroyChildren();
        }
        super.destroy();
        return this;
    }
    find(selector) {
        return this._generalFind(selector, false);
    }
    findOne(selector) {
        const result = this._generalFind(selector, true);
        return result.length > 0 ? result[0] : undefined;
    }
    _generalFind(selector, findOne) {
        const retArr = [];
        this._descendants((node) => {
            const valid = node._isMatch(selector);
            if (valid) {
                retArr.push(node);
            }
            if (valid && findOne) {
                return true;
            }
            return false;
        });
        return retArr;
    }
    _descendants(fn) {
        let shouldStop = false;
        const children = this.getChildren();
        for (const child of children) {
            shouldStop = fn(child);
            if (shouldStop) {
                return true;
            }
            if (!child.hasChildren()) {
                continue;
            }
            shouldStop = child._descendants(fn);
            if (shouldStop) {
                return true;
            }
        }
        return false;
    }
    toObject() {
        const obj = Node.prototype.toObject.call(this);
        obj.children = [];
        this.getChildren().forEach((child) => {
            obj.children.push(child.toObject());
        });
        return obj;
    }
    isAncestorOf(node) {
        let parent = node.getParent();
        while (parent) {
            if (parent._id === this._id) {
                return true;
            }
            parent = parent.getParent();
        }
        return false;
    }
    clone(obj) {
        const node = Node.prototype.clone.call(this, obj);
        this.getChildren().forEach(function (no) {
            node.add(no.clone());
        });
        return node;
    }
    getAllIntersections(pos) {
        const arr = [];
        this.find('Shape').forEach((shape) => {
            if (shape.isVisible() && shape.intersects(pos)) {
                arr.push(shape);
            }
        });
        return arr;
    }
    _clearSelfAndDescendantCache(attr) {
        var _a;
        super._clearSelfAndDescendantCache(attr);
        if (this.isCached()) {
            return;
        }
        (_a = this.children) === null || _a === void 0 ? void 0 : _a.forEach(function (node) {
            node._clearSelfAndDescendantCache(attr);
        });
    }
    _setChildrenIndices() {
        var _a;
        (_a = this.children) === null || _a === void 0 ? void 0 : _a.forEach(function (child, n) {
            child.index = n;
        });
        this._requestDraw();
    }
    drawScene(can, top, bufferCanvas) {
        const layer = this.getLayer(), canvas = can || (layer && layer.getCanvas()), context = canvas && canvas.getContext(), cachedCanvas = this._getCanvasCache(), cachedSceneCanvas = cachedCanvas && cachedCanvas.scene;
        const caching = canvas && canvas.isCache;
        if (!this.isVisible() && !caching) {
            return this;
        }
        if (cachedSceneCanvas) {
            context.save();
            const m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedSceneCanvas(context);
            context.restore();
        }
        else {
            this._drawChildren('drawScene', canvas, top, bufferCanvas);
        }
        return this;
    }
    drawHit(can, top) {
        if (!this.shouldDrawHit(top)) {
            return this;
        }
        const layer = this.getLayer(), canvas = can || (layer && layer.hitCanvas), context = canvas && canvas.getContext(), cachedCanvas = this._getCanvasCache(), cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
        if (cachedHitCanvas) {
            context.save();
            const m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedHitCanvas(context);
            context.restore();
        }
        else {
            this._drawChildren('drawHit', canvas, top);
        }
        return this;
    }
    _drawChildren(drawMethod, canvas, top, bufferCanvas) {
        var _a;
        const context = canvas && canvas.getContext(), clipWidth = this.clipWidth(), clipHeight = this.clipHeight(), clipFunc = this.clipFunc(), hasClip = (typeof clipWidth === 'number' && typeof clipHeight === 'number') ||
            clipFunc;
        const selfCache = top === this;
        if (hasClip) {
            context.save();
            const transform = this.getAbsoluteTransform(top);
            let m = transform.getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            context.beginPath();
            let clipArgs;
            if (clipFunc) {
                clipArgs = clipFunc.call(this, context, this);
            }
            else {
                const clipX = this.clipX();
                const clipY = this.clipY();
                context.rect(clipX || 0, clipY || 0, clipWidth, clipHeight);
            }
            context.clip.apply(context, clipArgs);
            m = transform.copy().invert().getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
        }
        const hasComposition = !selfCache &&
            this.globalCompositeOperation() !== 'source-over' &&
            drawMethod === 'drawScene';
        if (hasComposition) {
            context.save();
            context._applyGlobalCompositeOperation(this);
        }
        (_a = this.children) === null || _a === void 0 ? void 0 : _a.forEach(function (child) {
            child[drawMethod](canvas, top, bufferCanvas);
        });
        if (hasComposition) {
            context.restore();
        }
        if (hasClip) {
            context.restore();
        }
    }
    getClientRect(config = {}) {
        var _a;
        const skipTransform = config.skipTransform;
        const relativeTo = config.relativeTo;
        let minX, minY, maxX, maxY;
        let selfRect = {
            x: Infinity,
            y: Infinity,
            width: 0,
            height: 0,
        };
        const that = this;
        (_a = this.children) === null || _a === void 0 ? void 0 : _a.forEach(function (child) {
            if (!child.visible()) {
                return;
            }
            const rect = child.getClientRect({
                relativeTo: that,
                skipShadow: config.skipShadow,
                skipStroke: config.skipStroke,
            });
            if (rect.width === 0 && rect.height === 0) {
                return;
            }
            if (minX === undefined) {
                minX = rect.x;
                minY = rect.y;
                maxX = rect.x + rect.width;
                maxY = rect.y + rect.height;
            }
            else {
                minX = Math.min(minX, rect.x);
                minY = Math.min(minY, rect.y);
                maxX = Math.max(maxX, rect.x + rect.width);
                maxY = Math.max(maxY, rect.y + rect.height);
            }
        });
        const shapes = this.find('Shape');
        let hasVisible = false;
        for (let i = 0; i < shapes.length; i++) {
            const shape = shapes[i];
            if (shape._isVisible(this)) {
                hasVisible = true;
                break;
            }
        }
        if (hasVisible && minX !== undefined) {
            selfRect = {
                x: minX,
                y: minY,
                width: maxX - minX,
                height: maxY - minY,
            };
        }
        else {
            selfRect = {
                x: 0,
                y: 0,
                width: 0,
                height: 0,
            };
        }
        if (!skipTransform) {
            return this._transformedRect(selfRect, relativeTo);
        }
        return selfRect;
    }
}
Factory.addComponentsGetterSetter(Container, 'clip', [
    'x',
    'y',
    'width',
    'height',
]);
Factory.addGetterSetter(Container, 'clipX', undefined, getNumberValidator());
Factory.addGetterSetter(Container, 'clipY', undefined, getNumberValidator());
Factory.addGetterSetter(Container, 'clipWidth', undefined, getNumberValidator());
Factory.addGetterSetter(Container, 'clipHeight', undefined, getNumberValidator());
Factory.addGetterSetter(Container, 'clipFunc');

const Captures = new Map();
const SUPPORT_POINTER_EVENTS = Konva$1._global['PointerEvent'] !== undefined;
function getCapturedShape(pointerId) {
    return Captures.get(pointerId);
}
function createEvent(evt) {
    return {
        evt,
        pointerId: evt.pointerId,
    };
}
function hasPointerCapture(pointerId, shape) {
    return Captures.get(pointerId) === shape;
}
function setPointerCapture(pointerId, shape) {
    releaseCapture(pointerId);
    const stage = shape.getStage();
    if (!stage)
        return;
    Captures.set(pointerId, shape);
    if (SUPPORT_POINTER_EVENTS) {
        shape._fire('gotpointercapture', createEvent(new PointerEvent('gotpointercapture')));
    }
}
function releaseCapture(pointerId, target) {
    const shape = Captures.get(pointerId);
    if (!shape)
        return;
    const stage = shape.getStage();
    if (stage && stage.content) ;
    Captures.delete(pointerId);
    if (SUPPORT_POINTER_EVENTS) {
        shape._fire('lostpointercapture', createEvent(new PointerEvent('lostpointercapture')));
    }
}

const STAGE = 'Stage', STRING = 'string', PX = 'px', MOUSEOUT = 'mouseout', MOUSELEAVE = 'mouseleave', MOUSEOVER = 'mouseover', MOUSEENTER = 'mouseenter', MOUSEMOVE = 'mousemove', MOUSEDOWN = 'mousedown', MOUSEUP = 'mouseup', POINTERMOVE = 'pointermove', POINTERDOWN = 'pointerdown', POINTERUP = 'pointerup', POINTERCANCEL = 'pointercancel', LOSTPOINTERCAPTURE = 'lostpointercapture', POINTEROUT = 'pointerout', POINTERLEAVE = 'pointerleave', POINTEROVER = 'pointerover', POINTERENTER = 'pointerenter', CONTEXTMENU = 'contextmenu', TOUCHSTART = 'touchstart', TOUCHEND = 'touchend', TOUCHMOVE = 'touchmove', TOUCHCANCEL = 'touchcancel', WHEEL = 'wheel', MAX_LAYERS_NUMBER = 5, EVENTS = [
    [MOUSEENTER, '_pointerenter'],
    [MOUSEDOWN, '_pointerdown'],
    [MOUSEMOVE, '_pointermove'],
    [MOUSEUP, '_pointerup'],
    [MOUSELEAVE, '_pointerleave'],
    [TOUCHSTART, '_pointerdown'],
    [TOUCHMOVE, '_pointermove'],
    [TOUCHEND, '_pointerup'],
    [TOUCHCANCEL, '_pointercancel'],
    [MOUSEOVER, '_pointerover'],
    [WHEEL, '_wheel'],
    [CONTEXTMENU, '_contextmenu'],
    [POINTERDOWN, '_pointerdown'],
    [POINTERMOVE, '_pointermove'],
    [POINTERUP, '_pointerup'],
    [POINTERCANCEL, '_pointercancel'],
    [POINTERLEAVE, '_pointerleave'],
    [LOSTPOINTERCAPTURE, '_lostpointercapture'],
];
const EVENTS_MAP = {
    mouse: {
        [POINTEROUT]: MOUSEOUT,
        [POINTERLEAVE]: MOUSELEAVE,
        [POINTEROVER]: MOUSEOVER,
        [POINTERENTER]: MOUSEENTER,
        [POINTERMOVE]: MOUSEMOVE,
        [POINTERDOWN]: MOUSEDOWN,
        [POINTERUP]: MOUSEUP,
        [POINTERCANCEL]: 'mousecancel',
        pointerclick: 'click',
        pointerdblclick: 'dblclick',
    },
    touch: {
        [POINTEROUT]: 'touchout',
        [POINTERLEAVE]: 'touchleave',
        [POINTEROVER]: 'touchover',
        [POINTERENTER]: 'touchenter',
        [POINTERMOVE]: TOUCHMOVE,
        [POINTERDOWN]: TOUCHSTART,
        [POINTERUP]: TOUCHEND,
        [POINTERCANCEL]: TOUCHCANCEL,
        pointerclick: 'tap',
        pointerdblclick: 'dbltap',
    },
    pointer: {
        [POINTEROUT]: POINTEROUT,
        [POINTERLEAVE]: POINTERLEAVE,
        [POINTEROVER]: POINTEROVER,
        [POINTERENTER]: POINTERENTER,
        [POINTERMOVE]: POINTERMOVE,
        [POINTERDOWN]: POINTERDOWN,
        [POINTERUP]: POINTERUP,
        [POINTERCANCEL]: POINTERCANCEL,
        pointerclick: 'pointerclick',
        pointerdblclick: 'pointerdblclick',
    },
};
const getEventType = (type) => {
    if (type.indexOf('pointer') >= 0) {
        return 'pointer';
    }
    if (type.indexOf('touch') >= 0) {
        return 'touch';
    }
    return 'mouse';
};
const getEventsMap = (eventType) => {
    const type = getEventType(eventType);
    if (type === 'pointer') {
        return Konva$1.pointerEventsEnabled && EVENTS_MAP.pointer;
    }
    if (type === 'touch') {
        return EVENTS_MAP.touch;
    }
    if (type === 'mouse') {
        return EVENTS_MAP.mouse;
    }
};
function checkNoClip(attrs = {}) {
    if (attrs.clipFunc || attrs.clipWidth || attrs.clipHeight) {
        Util.warn('Stage does not support clipping. Please use clip for Layers or Groups.');
    }
    return attrs;
}
const NO_POINTERS_MESSAGE = `Pointer position is missing and not registered by the stage. Looks like it is outside of the stage container. You can set it manually from event: stage.setPointersPositions(event);`;
const stages = [];
let Stage$1 = class Stage extends Container {
    constructor(config) {
        super(checkNoClip(config));
        this._pointerPositions = [];
        this._changedPointerPositions = [];
        this._buildDOM();
        this._bindContentEvents();
        stages.push(this);
        this.on('widthChange.konva heightChange.konva', this._resizeDOM);
        this.on('visibleChange.konva', this._checkVisibility);
        this.on('clipWidthChange.konva clipHeightChange.konva clipFuncChange.konva', () => {
            checkNoClip(this.attrs);
        });
        this._checkVisibility();
    }
    _validateAdd(child) {
        const isLayer = child.getType() === 'Layer';
        const isFastLayer = child.getType() === 'FastLayer';
        const valid = isLayer || isFastLayer;
        if (!valid) {
            Util.throw('You may only add layers to the stage.');
        }
    }
    _checkVisibility() {
        if (!this.content) {
            return;
        }
        const style = this.visible() ? '' : 'none';
        this.content.style.display = style;
    }
    setContainer(container) {
        if (typeof container === STRING) {
            let id;
            if (container.charAt(0) === '.') {
                const className = container.slice(1);
                container = document.getElementsByClassName(className)[0];
            }
            else {
                if (container.charAt(0) !== '#') {
                    id = container;
                }
                else {
                    id = container.slice(1);
                }
                container = document.getElementById(id);
            }
            if (!container) {
                throw 'Can not find container in document with id ' + id;
            }
        }
        this._setAttr('container', container);
        if (this.content) {
            if (this.content.parentElement) {
                this.content.parentElement.removeChild(this.content);
            }
            container.appendChild(this.content);
        }
        return this;
    }
    shouldDrawHit() {
        return true;
    }
    clear() {
        const layers = this.children, len = layers.length;
        for (let n = 0; n < len; n++) {
            layers[n].clear();
        }
        return this;
    }
    clone(obj) {
        if (!obj) {
            obj = {};
        }
        obj.container =
            typeof document !== 'undefined' && document.createElement('div');
        return Container.prototype.clone.call(this, obj);
    }
    destroy() {
        super.destroy();
        const content = this.content;
        if (content && Util._isInDocument(content)) {
            this.container().removeChild(content);
        }
        const index = stages.indexOf(this);
        if (index > -1) {
            stages.splice(index, 1);
        }
        Util.releaseCanvas(this.bufferCanvas._canvas, this.bufferHitCanvas._canvas);
        return this;
    }
    getPointerPosition() {
        const pos = this._pointerPositions[0] || this._changedPointerPositions[0];
        if (!pos) {
            Util.warn(NO_POINTERS_MESSAGE);
            return null;
        }
        return {
            x: pos.x,
            y: pos.y,
        };
    }
    _getPointerById(id) {
        return this._pointerPositions.find((p) => p.id === id);
    }
    getPointersPositions() {
        return this._pointerPositions;
    }
    getStage() {
        return this;
    }
    getContent() {
        return this.content;
    }
    _toKonvaCanvas(config) {
        config = { ...config };
        config.x = config.x || 0;
        config.y = config.y || 0;
        config.width = config.width || this.width();
        config.height = config.height || this.height();
        const canvas = new SceneCanvas({
            width: config.width,
            height: config.height,
            pixelRatio: config.pixelRatio || 1,
        });
        const _context = canvas.getContext()._context;
        const layers = this.children;
        if (config.x || config.y) {
            _context.translate(-1 * config.x, -1 * config.y);
        }
        layers.forEach(function (layer) {
            if (!layer.isVisible()) {
                return;
            }
            const layerCanvas = layer._toKonvaCanvas(config);
            _context.drawImage(layerCanvas._canvas, config.x, config.y, layerCanvas.getWidth() / layerCanvas.getPixelRatio(), layerCanvas.getHeight() / layerCanvas.getPixelRatio());
        });
        return canvas;
    }
    getIntersection(pos) {
        if (!pos) {
            return null;
        }
        const layers = this.children, len = layers.length, end = len - 1;
        for (let n = end; n >= 0; n--) {
            const shape = layers[n].getIntersection(pos);
            if (shape) {
                return shape;
            }
        }
        return null;
    }
    _resizeDOM() {
        const width = this.width();
        const height = this.height();
        if (this.content) {
            this.content.style.width = width + PX;
            this.content.style.height = height + PX;
        }
        this.bufferCanvas.setSize(width, height);
        this.bufferHitCanvas.setSize(width, height);
        this.children.forEach((layer) => {
            layer.setSize({ width, height });
            layer.draw();
        });
    }
    add(layer, ...rest) {
        if (arguments.length > 1) {
            for (let i = 0; i < arguments.length; i++) {
                this.add(arguments[i]);
            }
            return this;
        }
        super.add(layer);
        const length = this.children.length;
        if (length > MAX_LAYERS_NUMBER) {
            Util.warn('The stage has ' +
                length +
                ' layers. Recommended maximum number of layers is 3-5. Adding more layers into the stage may drop the performance. Rethink your tree structure, you can use Konva.Group.');
        }
        layer.setSize({ width: this.width(), height: this.height() });
        layer.draw();
        if (Konva$1.isBrowser) {
            this.content.appendChild(layer.canvas._canvas);
        }
        return this;
    }
    getParent() {
        return null;
    }
    getLayer() {
        return null;
    }
    hasPointerCapture(pointerId) {
        return hasPointerCapture(pointerId, this);
    }
    setPointerCapture(pointerId) {
        setPointerCapture(pointerId, this);
    }
    releaseCapture(pointerId) {
        releaseCapture(pointerId);
    }
    getLayers() {
        return this.children;
    }
    _bindContentEvents() {
        if (!Konva$1.isBrowser) {
            return;
        }
        EVENTS.forEach(([event, methodName]) => {
            this.content.addEventListener(event, (evt) => {
                this[methodName](evt);
            }, { passive: false });
        });
    }
    _pointerenter(evt) {
        this.setPointersPositions(evt);
        const events = getEventsMap(evt.type);
        if (events) {
            this._fire(events.pointerenter, {
                evt: evt,
                target: this,
                currentTarget: this,
            });
        }
    }
    _pointerover(evt) {
        this.setPointersPositions(evt);
        const events = getEventsMap(evt.type);
        if (events) {
            this._fire(events.pointerover, {
                evt: evt,
                target: this,
                currentTarget: this,
            });
        }
    }
    _getTargetShape(evenType) {
        let shape = this[evenType + 'targetShape'];
        if (shape && !shape.getStage()) {
            shape = null;
        }
        return shape;
    }
    _pointerleave(evt) {
        const events = getEventsMap(evt.type);
        const eventType = getEventType(evt.type);
        if (!events) {
            return;
        }
        this.setPointersPositions(evt);
        const targetShape = this._getTargetShape(eventType);
        const eventsEnabled = !(Konva$1.isDragging() || Konva$1.isTransforming()) || Konva$1.hitOnDragEnabled;
        if (targetShape && eventsEnabled) {
            targetShape._fireAndBubble(events.pointerout, { evt: evt });
            targetShape._fireAndBubble(events.pointerleave, { evt: evt });
            this._fire(events.pointerleave, {
                evt: evt,
                target: this,
                currentTarget: this,
            });
            this[eventType + 'targetShape'] = null;
        }
        else if (eventsEnabled) {
            this._fire(events.pointerleave, {
                evt: evt,
                target: this,
                currentTarget: this,
            });
            this._fire(events.pointerout, {
                evt: evt,
                target: this,
                currentTarget: this,
            });
        }
        this.pointerPos = null;
        this._pointerPositions = [];
    }
    _pointerdown(evt) {
        const events = getEventsMap(evt.type);
        const eventType = getEventType(evt.type);
        if (!events) {
            return;
        }
        this.setPointersPositions(evt);
        let triggeredOnShape = false;
        this._changedPointerPositions.forEach((pos) => {
            const shape = this.getIntersection(pos);
            DD.justDragged = false;
            Konva$1['_' + eventType + 'ListenClick'] = true;
            if (!shape || !shape.isListening()) {
                this[eventType + 'ClickStartShape'] = undefined;
                return;
            }
            if (Konva$1.capturePointerEventsEnabled) {
                shape.setPointerCapture(pos.id);
            }
            this[eventType + 'ClickStartShape'] = shape;
            shape._fireAndBubble(events.pointerdown, {
                evt: evt,
                pointerId: pos.id,
            });
            triggeredOnShape = true;
            const isTouch = evt.type.indexOf('touch') >= 0;
            if (shape.preventDefault() && evt.cancelable && isTouch) {
                evt.preventDefault();
            }
        });
        if (!triggeredOnShape) {
            this._fire(events.pointerdown, {
                evt: evt,
                target: this,
                currentTarget: this,
                pointerId: this._pointerPositions[0].id,
            });
        }
    }
    _pointermove(evt) {
        const events = getEventsMap(evt.type);
        const eventType = getEventType(evt.type);
        if (!events) {
            return;
        }
        const isTouchPointer = evt.type.indexOf('touch') >= 0 ||
            evt.pointerType === 'touch';
        if (Konva$1.isDragging() &&
            DD.node.preventDefault() &&
            evt.cancelable &&
            isTouchPointer) {
            evt.preventDefault();
        }
        this.setPointersPositions(evt);
        const eventsEnabled = !(Konva$1.isDragging() || Konva$1.isTransforming()) || Konva$1.hitOnDragEnabled;
        if (!eventsEnabled) {
            return;
        }
        const processedShapesIds = {};
        let triggeredOnShape = false;
        const targetShape = this._getTargetShape(eventType);
        this._changedPointerPositions.forEach((pos) => {
            const shape = (getCapturedShape(pos.id) ||
                this.getIntersection(pos));
            const pointerId = pos.id;
            const event = { evt: evt, pointerId };
            const differentTarget = targetShape !== shape;
            if (differentTarget && targetShape) {
                targetShape._fireAndBubble(events.pointerout, { ...event }, shape);
                targetShape._fireAndBubble(events.pointerleave, { ...event }, shape);
            }
            if (shape) {
                if (processedShapesIds[shape._id]) {
                    return;
                }
                processedShapesIds[shape._id] = true;
            }
            if (shape && shape.isListening()) {
                triggeredOnShape = true;
                if (differentTarget) {
                    shape._fireAndBubble(events.pointerover, { ...event }, targetShape);
                    shape._fireAndBubble(events.pointerenter, { ...event }, targetShape);
                    this[eventType + 'targetShape'] = shape;
                }
                shape._fireAndBubble(events.pointermove, { ...event });
            }
            else {
                if (targetShape) {
                    this._fire(events.pointerover, {
                        evt: evt,
                        target: this,
                        currentTarget: this,
                        pointerId,
                    });
                    this[eventType + 'targetShape'] = null;
                }
            }
        });
        if (!triggeredOnShape) {
            this._fire(events.pointermove, {
                evt: evt,
                target: this,
                currentTarget: this,
                pointerId: this._changedPointerPositions[0].id,
            });
        }
    }
    _pointerup(evt) {
        const events = getEventsMap(evt.type);
        const eventType = getEventType(evt.type);
        if (!events) {
            return;
        }
        this.setPointersPositions(evt);
        const clickStartShape = this[eventType + 'ClickStartShape'];
        const clickEndShape = this[eventType + 'ClickEndShape'];
        const processedShapesIds = {};
        let skipPointerUpTrigger = false;
        this._changedPointerPositions.forEach((pos) => {
            const shape = (getCapturedShape(pos.id) ||
                this.getIntersection(pos));
            if (shape) {
                shape.releaseCapture(pos.id);
                if (processedShapesIds[shape._id]) {
                    return;
                }
                processedShapesIds[shape._id] = true;
            }
            const pointerId = pos.id;
            const event = { evt: evt, pointerId };
            let fireDblClick = false;
            if (Konva$1['_' + eventType + 'InDblClickWindow']) {
                fireDblClick = true;
                clearTimeout(this[eventType + 'DblTimeout']);
            }
            else if (!DD.justDragged) {
                Konva$1['_' + eventType + 'InDblClickWindow'] = true;
                clearTimeout(this[eventType + 'DblTimeout']);
            }
            this[eventType + 'DblTimeout'] = setTimeout(function () {
                Konva$1['_' + eventType + 'InDblClickWindow'] = false;
            }, Konva$1.dblClickWindow);
            if (shape && shape.isListening()) {
                skipPointerUpTrigger = true;
                this[eventType + 'ClickEndShape'] = shape;
                shape._fireAndBubble(events.pointerup, { ...event });
                if (Konva$1['_' + eventType + 'ListenClick'] &&
                    clickStartShape &&
                    clickStartShape === shape) {
                    shape._fireAndBubble(events.pointerclick, { ...event });
                    if (fireDblClick && clickEndShape && clickEndShape === shape) {
                        shape._fireAndBubble(events.pointerdblclick, { ...event });
                    }
                }
            }
            else {
                this[eventType + 'ClickEndShape'] = null;
                if (!skipPointerUpTrigger) {
                    this._fire(events.pointerup, {
                        evt: evt,
                        target: this,
                        currentTarget: this,
                        pointerId: this._changedPointerPositions[0].id,
                    });
                    skipPointerUpTrigger = true;
                }
                if (Konva$1['_' + eventType + 'ListenClick']) {
                    this._fire(events.pointerclick, {
                        evt: evt,
                        target: this,
                        currentTarget: this,
                        pointerId,
                    });
                }
                if (fireDblClick) {
                    this._fire(events.pointerdblclick, {
                        evt: evt,
                        target: this,
                        currentTarget: this,
                        pointerId,
                    });
                }
            }
        });
        if (!skipPointerUpTrigger) {
            this._fire(events.pointerup, {
                evt: evt,
                target: this,
                currentTarget: this,
                pointerId: this._changedPointerPositions[0].id,
            });
        }
        Konva$1['_' + eventType + 'ListenClick'] = false;
        if (evt.cancelable && eventType !== 'touch' && eventType !== 'pointer') {
            evt.preventDefault();
        }
    }
    _contextmenu(evt) {
        this.setPointersPositions(evt);
        const shape = this.getIntersection(this.getPointerPosition());
        if (shape && shape.isListening()) {
            shape._fireAndBubble(CONTEXTMENU, { evt: evt });
        }
        else {
            this._fire(CONTEXTMENU, {
                evt: evt,
                target: this,
                currentTarget: this,
            });
        }
    }
    _wheel(evt) {
        this.setPointersPositions(evt);
        const shape = this.getIntersection(this.getPointerPosition());
        if (shape && shape.isListening()) {
            shape._fireAndBubble(WHEEL, { evt: evt });
        }
        else {
            this._fire(WHEEL, {
                evt: evt,
                target: this,
                currentTarget: this,
            });
        }
    }
    _pointercancel(evt) {
        this.setPointersPositions(evt);
        const shape = getCapturedShape(evt.pointerId) ||
            this.getIntersection(this.getPointerPosition());
        if (shape) {
            shape._fireAndBubble(POINTERUP, createEvent(evt));
        }
        releaseCapture(evt.pointerId);
    }
    _lostpointercapture(evt) {
        releaseCapture(evt.pointerId);
    }
    setPointersPositions(evt) {
        const contentPosition = this._getContentPosition();
        let x = null, y = null;
        evt = evt ? evt : window.event;
        if (evt.touches !== undefined) {
            this._pointerPositions = [];
            this._changedPointerPositions = [];
            Array.prototype.forEach.call(evt.touches, (touch) => {
                this._pointerPositions.push({
                    id: touch.identifier,
                    x: (touch.clientX - contentPosition.left) / contentPosition.scaleX,
                    y: (touch.clientY - contentPosition.top) / contentPosition.scaleY,
                });
            });
            Array.prototype.forEach.call(evt.changedTouches || evt.touches, (touch) => {
                this._changedPointerPositions.push({
                    id: touch.identifier,
                    x: (touch.clientX - contentPosition.left) / contentPosition.scaleX,
                    y: (touch.clientY - contentPosition.top) / contentPosition.scaleY,
                });
            });
        }
        else {
            x = (evt.clientX - contentPosition.left) / contentPosition.scaleX;
            y = (evt.clientY - contentPosition.top) / contentPosition.scaleY;
            this.pointerPos = {
                x: x,
                y: y,
            };
            this._pointerPositions = [{ x, y, id: Util._getFirstPointerId(evt) }];
            this._changedPointerPositions = [
                { x, y, id: Util._getFirstPointerId(evt) },
            ];
        }
    }
    _setPointerPosition(evt) {
        Util.warn('Method _setPointerPosition is deprecated. Use "stage.setPointersPositions(event)" instead.');
        this.setPointersPositions(evt);
    }
    _getContentPosition() {
        if (!this.content || !this.content.getBoundingClientRect) {
            return {
                top: 0,
                left: 0,
                scaleX: 1,
                scaleY: 1,
            };
        }
        const rect = this.content.getBoundingClientRect();
        return {
            top: rect.top,
            left: rect.left,
            scaleX: rect.width / this.content.clientWidth || 1,
            scaleY: rect.height / this.content.clientHeight || 1,
        };
    }
    _buildDOM() {
        this.bufferCanvas = new SceneCanvas({
            width: this.width(),
            height: this.height(),
        });
        this.bufferHitCanvas = new HitCanvas({
            pixelRatio: 1,
            width: this.width(),
            height: this.height(),
        });
        if (!Konva$1.isBrowser) {
            return;
        }
        const container = this.container();
        if (!container) {
            throw 'Stage has no container. A container is required.';
        }
        container.innerHTML = '';
        this.content = document.createElement('div');
        this.content.style.position = 'relative';
        this.content.style.userSelect = 'none';
        this.content.className = 'konvajs-content';
        this.content.setAttribute('role', 'presentation');
        container.appendChild(this.content);
        this._resizeDOM();
    }
    cache() {
        Util.warn('Cache function is not allowed for stage. You may use cache only for layers, groups and shapes.');
        return this;
    }
    clearCache() {
        return this;
    }
    batchDraw() {
        this.getChildren().forEach(function (layer) {
            layer.batchDraw();
        });
        return this;
    }
};
Stage$1.prototype.nodeType = STAGE;
_registerNode(Stage$1);
Factory.addGetterSetter(Stage$1, 'container');
if (Konva$1.isBrowser) {
    document.addEventListener('visibilitychange', () => {
        stages.forEach((stage) => {
            stage.batchDraw();
        });
    });
}

const HAS_SHADOW = 'hasShadow';
const SHADOW_RGBA = 'shadowRGBA';
const patternImage = 'patternImage';
const linearGradient = 'linearGradient';
const radialGradient = 'radialGradient';
let dummyContext$1;
function getDummyContext$1() {
    if (dummyContext$1) {
        return dummyContext$1;
    }
    dummyContext$1 = Util.createCanvasElement().getContext('2d');
    return dummyContext$1;
}
const shapes = {};
function _fillFunc$2(context) {
    const fillRule = this.attrs.fillRule;
    if (fillRule) {
        context.fill(fillRule);
    }
    else {
        context.fill();
    }
}
function _strokeFunc$2(context) {
    context.stroke();
}
function _fillFuncHit(context) {
    const fillRule = this.attrs.fillRule;
    if (fillRule) {
        context.fill(fillRule);
    }
    else {
        context.fill();
    }
}
function _strokeFuncHit(context) {
    context.stroke();
}
function _clearHasShadowCache() {
    this._clearCache(HAS_SHADOW);
}
function _clearGetShadowRGBACache() {
    this._clearCache(SHADOW_RGBA);
}
function _clearFillPatternCache() {
    this._clearCache(patternImage);
}
function _clearLinearGradientCache() {
    this._clearCache(linearGradient);
}
function _clearRadialGradientCache() {
    this._clearCache(radialGradient);
}
class Shape extends Node {
    constructor(config) {
        super(config);
        let key;
        let attempts = 0;
        while (true) {
            key = Util.getHitColor();
            if (key && !(key in shapes)) {
                break;
            }
            attempts++;
            if (attempts >= 10000) {
                Util.warn('Failed to find a unique color key for a shape. Konva may work incorrectly. Most likely your browser is using canvas farbling. Consider disabling it.');
                key = Util.getRandomColor();
                break;
            }
        }
        this.colorKey = key;
        shapes[key] = this;
    }
    getContext() {
        Util.warn('shape.getContext() method is deprecated. Please do not use it.');
        return this.getLayer().getContext();
    }
    getCanvas() {
        Util.warn('shape.getCanvas() method is deprecated. Please do not use it.');
        return this.getLayer().getCanvas();
    }
    getSceneFunc() {
        return this.attrs.sceneFunc || this['_sceneFunc'];
    }
    getHitFunc() {
        return this.attrs.hitFunc || this['_hitFunc'];
    }
    hasShadow() {
        return this._getCache(HAS_SHADOW, this._hasShadow);
    }
    _hasShadow() {
        return (this.shadowEnabled() &&
            this.shadowOpacity() !== 0 &&
            !!(this.shadowColor() ||
                this.shadowBlur() ||
                this.shadowOffsetX() ||
                this.shadowOffsetY()));
    }
    _getFillPattern() {
        return this._getCache(patternImage, this.__getFillPattern);
    }
    __getFillPattern() {
        if (this.fillPatternImage()) {
            const ctx = getDummyContext$1();
            const pattern = ctx.createPattern(this.fillPatternImage(), this.fillPatternRepeat() || 'repeat');
            if (pattern && pattern.setTransform) {
                const tr = new Transform();
                tr.translate(this.fillPatternX(), this.fillPatternY());
                tr.rotate(Konva$1.getAngle(this.fillPatternRotation()));
                tr.scale(this.fillPatternScaleX(), this.fillPatternScaleY());
                tr.translate(-1 * this.fillPatternOffsetX(), -1 * this.fillPatternOffsetY());
                const m = tr.getMatrix();
                const matrix = typeof DOMMatrix === 'undefined'
                    ? {
                        a: m[0],
                        b: m[1],
                        c: m[2],
                        d: m[3],
                        e: m[4],
                        f: m[5],
                    }
                    : new DOMMatrix(m);
                pattern.setTransform(matrix);
            }
            return pattern;
        }
    }
    _getLinearGradient() {
        return this._getCache(linearGradient, this.__getLinearGradient);
    }
    __getLinearGradient() {
        const colorStops = this.fillLinearGradientColorStops();
        if (colorStops) {
            const ctx = getDummyContext$1();
            const start = this.fillLinearGradientStartPoint();
            const end = this.fillLinearGradientEndPoint();
            const grd = ctx.createLinearGradient(start.x, start.y, end.x, end.y);
            for (let n = 0; n < colorStops.length; n += 2) {
                grd.addColorStop(colorStops[n], colorStops[n + 1]);
            }
            return grd;
        }
    }
    _getRadialGradient() {
        return this._getCache(radialGradient, this.__getRadialGradient);
    }
    __getRadialGradient() {
        const colorStops = this.fillRadialGradientColorStops();
        if (colorStops) {
            const ctx = getDummyContext$1();
            const start = this.fillRadialGradientStartPoint();
            const end = this.fillRadialGradientEndPoint();
            const grd = ctx.createRadialGradient(start.x, start.y, this.fillRadialGradientStartRadius(), end.x, end.y, this.fillRadialGradientEndRadius());
            for (let n = 0; n < colorStops.length; n += 2) {
                grd.addColorStop(colorStops[n], colorStops[n + 1]);
            }
            return grd;
        }
    }
    getShadowRGBA() {
        return this._getCache(SHADOW_RGBA, this._getShadowRGBA);
    }
    _getShadowRGBA() {
        if (!this.hasShadow()) {
            return;
        }
        const rgba = Util.colorToRGBA(this.shadowColor());
        if (rgba) {
            return ('rgba(' +
                rgba.r +
                ',' +
                rgba.g +
                ',' +
                rgba.b +
                ',' +
                rgba.a * (this.shadowOpacity() || 1) +
                ')');
        }
    }
    hasFill() {
        return this._calculate('hasFill', [
            'fillEnabled',
            'fill',
            'fillPatternImage',
            'fillLinearGradientColorStops',
            'fillRadialGradientColorStops',
        ], () => {
            return (this.fillEnabled() &&
                !!(this.fill() ||
                    this.fillPatternImage() ||
                    this.fillLinearGradientColorStops() ||
                    this.fillRadialGradientColorStops()));
        });
    }
    hasStroke() {
        return this._calculate('hasStroke', [
            'strokeEnabled',
            'strokeWidth',
            'stroke',
            'strokeLinearGradientColorStops',
        ], () => {
            return (this.strokeEnabled() &&
                this.strokeWidth() &&
                !!(this.stroke() || this.strokeLinearGradientColorStops()));
        });
    }
    hasHitStroke() {
        const width = this.hitStrokeWidth();
        if (width === 'auto') {
            return this.hasStroke();
        }
        return this.strokeEnabled() && !!width;
    }
    intersects(point) {
        const stage = this.getStage();
        if (!stage) {
            return false;
        }
        const bufferHitCanvas = stage.bufferHitCanvas;
        bufferHitCanvas.getContext().clear();
        this.drawHit(bufferHitCanvas, undefined, true);
        const p = bufferHitCanvas.context.getImageData(Math.round(point.x), Math.round(point.y), 1, 1).data;
        return p[3] > 0;
    }
    destroy() {
        Node.prototype.destroy.call(this);
        delete shapes[this.colorKey];
        delete this.colorKey;
        return this;
    }
    _useBufferCanvas(forceFill) {
        var _a;
        const perfectDrawEnabled = (_a = this.attrs.perfectDrawEnabled) !== null && _a !== void 0 ? _a : true;
        if (!perfectDrawEnabled) {
            return false;
        }
        const hasFill = forceFill || this.hasFill();
        const hasStroke = this.hasStroke();
        const isTransparent = this.getAbsoluteOpacity() !== 1;
        if (hasFill && hasStroke && isTransparent) {
            return true;
        }
        const hasShadow = this.hasShadow();
        const strokeForShadow = this.shadowForStrokeEnabled();
        if (hasFill && hasStroke && hasShadow && strokeForShadow) {
            return true;
        }
        return false;
    }
    setStrokeHitEnabled(val) {
        Util.warn('strokeHitEnabled property is deprecated. Please use hitStrokeWidth instead.');
        if (val) {
            this.hitStrokeWidth('auto');
        }
        else {
            this.hitStrokeWidth(0);
        }
    }
    getStrokeHitEnabled() {
        if (this.hitStrokeWidth() === 0) {
            return false;
        }
        else {
            return true;
        }
    }
    getSelfRect() {
        const size = this.size();
        return {
            x: this._centroid ? -size.width / 2 : 0,
            y: this._centroid ? -size.height / 2 : 0,
            width: size.width,
            height: size.height,
        };
    }
    getClientRect(config = {}) {
        let hasCachedParent = false;
        let parent = this.getParent();
        while (parent) {
            if (parent.isCached()) {
                hasCachedParent = true;
                break;
            }
            parent = parent.getParent();
        }
        const skipTransform = config.skipTransform;
        const relativeTo = config.relativeTo || (hasCachedParent && this.getStage()) || undefined;
        const fillRect = this.getSelfRect();
        const applyStroke = !config.skipStroke && this.hasStroke();
        const strokeWidth = (applyStroke && this.strokeWidth()) || 0;
        const fillAndStrokeWidth = fillRect.width + strokeWidth;
        const fillAndStrokeHeight = fillRect.height + strokeWidth;
        const applyShadow = !config.skipShadow && this.hasShadow();
        const shadowOffsetX = applyShadow ? this.shadowOffsetX() : 0;
        const shadowOffsetY = applyShadow ? this.shadowOffsetY() : 0;
        const preWidth = fillAndStrokeWidth + Math.abs(shadowOffsetX);
        const preHeight = fillAndStrokeHeight + Math.abs(shadowOffsetY);
        const blurRadius = (applyShadow && this.shadowBlur()) || 0;
        const width = preWidth + blurRadius * 2;
        const height = preHeight + blurRadius * 2;
        const rect = {
            width: width,
            height: height,
            x: -(strokeWidth / 2 + blurRadius) +
                Math.min(shadowOffsetX, 0) +
                fillRect.x,
            y: -(strokeWidth / 2 + blurRadius) +
                Math.min(shadowOffsetY, 0) +
                fillRect.y,
        };
        if (!skipTransform) {
            return this._transformedRect(rect, relativeTo);
        }
        return rect;
    }
    drawScene(can, top, bufferCanvas) {
        const layer = this.getLayer();
        const canvas = can || layer.getCanvas(), context = canvas.getContext(), cachedCanvas = this._getCanvasCache(), drawFunc = this.getSceneFunc(), hasShadow = this.hasShadow();
        let stage;
        const cachingSelf = top === this;
        if (!this.isVisible() && !cachingSelf) {
            return this;
        }
        if (cachedCanvas) {
            context.save();
            const m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedSceneCanvas(context);
            context.restore();
            return this;
        }
        if (!drawFunc) {
            return this;
        }
        context.save();
        if (this._useBufferCanvas() && true) {
            stage = this.getStage();
            const bc = bufferCanvas || stage.bufferCanvas;
            const bufferContext = bc.getContext();
            if (bufferCanvas) {
                bufferContext.save();
                bufferContext.setTransform(1, 0, 0, 1, 0, 0);
                bufferContext.clearRect(0, 0, bc.width, bc.height);
                bufferContext.restore();
            }
            else {
                bufferContext.clear();
            }
            bufferContext.save();
            bufferContext._applyLineJoin(this);
            bufferContext._applyMiterLimit(this);
            const o = this.getAbsoluteTransform(top).getMatrix();
            bufferContext.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
            drawFunc.call(this, bufferContext, this);
            bufferContext.restore();
            const ratio = bc.pixelRatio;
            if (hasShadow) {
                context._applyShadow(this);
            }
            if (!cachingSelf) {
                context._applyOpacity(this);
                context._applyGlobalCompositeOperation(this);
            }
            context.drawImage(bc._canvas, bc.x || 0, bc.y || 0, bc.width / ratio, bc.height / ratio);
        }
        else {
            context._applyLineJoin(this);
            context._applyMiterLimit(this);
            if (!cachingSelf) {
                const o = this.getAbsoluteTransform(top).getMatrix();
                context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
                context._applyOpacity(this);
                context._applyGlobalCompositeOperation(this);
            }
            if (hasShadow) {
                context._applyShadow(this);
            }
            drawFunc.call(this, context, this);
        }
        context.restore();
        return this;
    }
    drawHit(can, top, skipDragCheck = false) {
        if (!this.shouldDrawHit(top, skipDragCheck)) {
            return this;
        }
        const layer = this.getLayer(), canvas = can || layer.hitCanvas, context = canvas && canvas.getContext(), drawFunc = this.hitFunc() || this.sceneFunc(), cachedCanvas = this._getCanvasCache(), cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
        if (!this.colorKey) {
            Util.warn('Looks like your canvas has a destroyed shape in it. Do not reuse shape after you destroyed it. If you want to reuse shape you should call remove() instead of destroy()');
        }
        if (cachedHitCanvas) {
            context.save();
            const m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedHitCanvas(context);
            context.restore();
            return this;
        }
        if (!drawFunc) {
            return this;
        }
        context.save();
        context._applyLineJoin(this);
        context._applyMiterLimit(this);
        const selfCache = this === top;
        if (!selfCache) {
            const o = this.getAbsoluteTransform(top).getMatrix();
            context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
        }
        drawFunc.call(this, context, this);
        context.restore();
        return this;
    }
    drawHitFromCache(alphaThreshold = 0) {
        const cachedCanvas = this._getCanvasCache(), sceneCanvas = this._getCachedSceneCanvas(), hitCanvas = cachedCanvas.hit, hitContext = hitCanvas.getContext(), hitWidth = hitCanvas.getWidth(), hitHeight = hitCanvas.getHeight();
        hitContext.clear();
        hitContext.drawImage(sceneCanvas._canvas, 0, 0, hitWidth, hitHeight);
        try {
            const hitImageData = hitContext.getImageData(0, 0, hitWidth, hitHeight);
            const hitData = hitImageData.data;
            const len = hitData.length;
            const rgbColorKey = Util._hexToRgb(this.colorKey);
            for (let i = 0; i < len; i += 4) {
                const alpha = hitData[i + 3];
                if (alpha > alphaThreshold) {
                    hitData[i] = rgbColorKey.r;
                    hitData[i + 1] = rgbColorKey.g;
                    hitData[i + 2] = rgbColorKey.b;
                    hitData[i + 3] = 255;
                }
                else {
                    hitData[i + 3] = 0;
                }
            }
            hitContext.putImageData(hitImageData, 0, 0);
        }
        catch (e) {
            Util.error('Unable to draw hit graph from cached scene canvas. ' + e.message);
        }
        return this;
    }
    hasPointerCapture(pointerId) {
        return hasPointerCapture(pointerId, this);
    }
    setPointerCapture(pointerId) {
        setPointerCapture(pointerId, this);
    }
    releaseCapture(pointerId) {
        releaseCapture(pointerId);
    }
}
Shape.prototype._fillFunc = _fillFunc$2;
Shape.prototype._strokeFunc = _strokeFunc$2;
Shape.prototype._fillFuncHit = _fillFuncHit;
Shape.prototype._strokeFuncHit = _strokeFuncHit;
Shape.prototype._centroid = false;
Shape.prototype.nodeType = 'Shape';
_registerNode(Shape);
Shape.prototype.eventListeners = {};
Shape.prototype.on('shadowColorChange.konva shadowBlurChange.konva shadowOffsetChange.konva shadowOpacityChange.konva shadowEnabledChange.konva', _clearHasShadowCache);
Shape.prototype.on('shadowColorChange.konva shadowOpacityChange.konva shadowEnabledChange.konva', _clearGetShadowRGBACache);
Shape.prototype.on('fillPriorityChange.konva fillPatternImageChange.konva fillPatternRepeatChange.konva fillPatternScaleXChange.konva fillPatternScaleYChange.konva fillPatternOffsetXChange.konva fillPatternOffsetYChange.konva fillPatternXChange.konva fillPatternYChange.konva fillPatternRotationChange.konva', _clearFillPatternCache);
Shape.prototype.on('fillPriorityChange.konva fillLinearGradientColorStopsChange.konva fillLinearGradientStartPointXChange.konva fillLinearGradientStartPointYChange.konva fillLinearGradientEndPointXChange.konva fillLinearGradientEndPointYChange.konva', _clearLinearGradientCache);
Shape.prototype.on('fillPriorityChange.konva fillRadialGradientColorStopsChange.konva fillRadialGradientStartPointXChange.konva fillRadialGradientStartPointYChange.konva fillRadialGradientEndPointXChange.konva fillRadialGradientEndPointYChange.konva fillRadialGradientStartRadiusChange.konva fillRadialGradientEndRadiusChange.konva', _clearRadialGradientCache);
Factory.addGetterSetter(Shape, 'stroke', undefined, getStringOrGradientValidator());
Factory.addGetterSetter(Shape, 'strokeWidth', 2, getNumberValidator());
Factory.addGetterSetter(Shape, 'fillAfterStrokeEnabled', false);
Factory.addGetterSetter(Shape, 'hitStrokeWidth', 'auto', getNumberOrAutoValidator());
Factory.addGetterSetter(Shape, 'strokeHitEnabled', true, getBooleanValidator());
Factory.addGetterSetter(Shape, 'perfectDrawEnabled', true, getBooleanValidator());
Factory.addGetterSetter(Shape, 'shadowForStrokeEnabled', true, getBooleanValidator());
Factory.addGetterSetter(Shape, 'lineJoin');
Factory.addGetterSetter(Shape, 'lineCap');
Factory.addGetterSetter(Shape, 'miterLimit');
Factory.addGetterSetter(Shape, 'sceneFunc');
Factory.addGetterSetter(Shape, 'hitFunc');
Factory.addGetterSetter(Shape, 'dash');
Factory.addGetterSetter(Shape, 'dashOffset', 0, getNumberValidator());
Factory.addGetterSetter(Shape, 'shadowColor', undefined, getStringValidator());
Factory.addGetterSetter(Shape, 'shadowBlur', 0, getNumberValidator());
Factory.addGetterSetter(Shape, 'shadowOpacity', 1, getNumberValidator());
Factory.addComponentsGetterSetter(Shape, 'shadowOffset', ['x', 'y']);
Factory.addGetterSetter(Shape, 'shadowOffsetX', 0, getNumberValidator());
Factory.addGetterSetter(Shape, 'shadowOffsetY', 0, getNumberValidator());
Factory.addGetterSetter(Shape, 'fillPatternImage');
Factory.addGetterSetter(Shape, 'fill', undefined, getStringOrGradientValidator());
Factory.addGetterSetter(Shape, 'fillPatternX', 0, getNumberValidator());
Factory.addGetterSetter(Shape, 'fillPatternY', 0, getNumberValidator());
Factory.addGetterSetter(Shape, 'fillLinearGradientColorStops');
Factory.addGetterSetter(Shape, 'strokeLinearGradientColorStops');
Factory.addGetterSetter(Shape, 'fillRadialGradientStartRadius', 0);
Factory.addGetterSetter(Shape, 'fillRadialGradientEndRadius', 0);
Factory.addGetterSetter(Shape, 'fillRadialGradientColorStops');
Factory.addGetterSetter(Shape, 'fillPatternRepeat', 'repeat');
Factory.addGetterSetter(Shape, 'fillEnabled', true);
Factory.addGetterSetter(Shape, 'strokeEnabled', true);
Factory.addGetterSetter(Shape, 'shadowEnabled', true);
Factory.addGetterSetter(Shape, 'dashEnabled', true);
Factory.addGetterSetter(Shape, 'strokeScaleEnabled', true);
Factory.addGetterSetter(Shape, 'fillPriority', 'color');
Factory.addComponentsGetterSetter(Shape, 'fillPatternOffset', ['x', 'y']);
Factory.addGetterSetter(Shape, 'fillPatternOffsetX', 0, getNumberValidator());
Factory.addGetterSetter(Shape, 'fillPatternOffsetY', 0, getNumberValidator());
Factory.addComponentsGetterSetter(Shape, 'fillPatternScale', ['x', 'y']);
Factory.addGetterSetter(Shape, 'fillPatternScaleX', 1, getNumberValidator());
Factory.addGetterSetter(Shape, 'fillPatternScaleY', 1, getNumberValidator());
Factory.addComponentsGetterSetter(Shape, 'fillLinearGradientStartPoint', [
    'x',
    'y',
]);
Factory.addComponentsGetterSetter(Shape, 'strokeLinearGradientStartPoint', [
    'x',
    'y',
]);
Factory.addGetterSetter(Shape, 'fillLinearGradientStartPointX', 0);
Factory.addGetterSetter(Shape, 'strokeLinearGradientStartPointX', 0);
Factory.addGetterSetter(Shape, 'fillLinearGradientStartPointY', 0);
Factory.addGetterSetter(Shape, 'strokeLinearGradientStartPointY', 0);
Factory.addComponentsGetterSetter(Shape, 'fillLinearGradientEndPoint', [
    'x',
    'y',
]);
Factory.addComponentsGetterSetter(Shape, 'strokeLinearGradientEndPoint', [
    'x',
    'y',
]);
Factory.addGetterSetter(Shape, 'fillLinearGradientEndPointX', 0);
Factory.addGetterSetter(Shape, 'strokeLinearGradientEndPointX', 0);
Factory.addGetterSetter(Shape, 'fillLinearGradientEndPointY', 0);
Factory.addGetterSetter(Shape, 'strokeLinearGradientEndPointY', 0);
Factory.addComponentsGetterSetter(Shape, 'fillRadialGradientStartPoint', [
    'x',
    'y',
]);
Factory.addGetterSetter(Shape, 'fillRadialGradientStartPointX', 0);
Factory.addGetterSetter(Shape, 'fillRadialGradientStartPointY', 0);
Factory.addComponentsGetterSetter(Shape, 'fillRadialGradientEndPoint', [
    'x',
    'y',
]);
Factory.addGetterSetter(Shape, 'fillRadialGradientEndPointX', 0);
Factory.addGetterSetter(Shape, 'fillRadialGradientEndPointY', 0);
Factory.addGetterSetter(Shape, 'fillPatternRotation', 0);
Factory.addGetterSetter(Shape, 'fillRule', undefined, getStringValidator());
Factory.backCompat(Shape, {
    dashArray: 'dash',
    getDashArray: 'getDash',
    setDashArray: 'getDash',
    drawFunc: 'sceneFunc',
    getDrawFunc: 'getSceneFunc',
    setDrawFunc: 'setSceneFunc',
    drawHitFunc: 'hitFunc',
    getDrawHitFunc: 'getHitFunc',
    setDrawHitFunc: 'setHitFunc',
});

const BEFORE_DRAW = 'beforeDraw', DRAW = 'draw', INTERSECTION_OFFSETS = [
    { x: 0, y: 0 },
    { x: -1, y: -1 },
    { x: 1, y: -1 },
    { x: 1, y: 1 },
    { x: -1, y: 1 },
], INTERSECTION_OFFSETS_LEN = INTERSECTION_OFFSETS.length;
let Layer$1 = class Layer extends Container {
    constructor(config) {
        super(config);
        this.canvas = new SceneCanvas();
        this.hitCanvas = new HitCanvas({
            pixelRatio: 1,
        });
        this._waitingForDraw = false;
        this.on('visibleChange.konva', this._checkVisibility);
        this._checkVisibility();
        this.on('imageSmoothingEnabledChange.konva', this._setSmoothEnabled);
        this._setSmoothEnabled();
    }
    createPNGStream() {
        const c = this.canvas._canvas;
        return c.createPNGStream();
    }
    getCanvas() {
        return this.canvas;
    }
    getNativeCanvasElement() {
        return this.canvas._canvas;
    }
    getHitCanvas() {
        return this.hitCanvas;
    }
    getContext() {
        return this.getCanvas().getContext();
    }
    clear(bounds) {
        this.getContext().clear(bounds);
        this.getHitCanvas().getContext().clear(bounds);
        return this;
    }
    setZIndex(index) {
        super.setZIndex(index);
        const stage = this.getStage();
        if (stage && stage.content) {
            stage.content.removeChild(this.getNativeCanvasElement());
            if (index < stage.children.length - 1) {
                stage.content.insertBefore(this.getNativeCanvasElement(), stage.children[index + 1].getCanvas()._canvas);
            }
            else {
                stage.content.appendChild(this.getNativeCanvasElement());
            }
        }
        return this;
    }
    moveToTop() {
        Node.prototype.moveToTop.call(this);
        const stage = this.getStage();
        if (stage && stage.content) {
            stage.content.removeChild(this.getNativeCanvasElement());
            stage.content.appendChild(this.getNativeCanvasElement());
        }
        return true;
    }
    moveUp() {
        const moved = Node.prototype.moveUp.call(this);
        if (!moved) {
            return false;
        }
        const stage = this.getStage();
        if (!stage || !stage.content) {
            return false;
        }
        stage.content.removeChild(this.getNativeCanvasElement());
        if (this.index < stage.children.length - 1) {
            stage.content.insertBefore(this.getNativeCanvasElement(), stage.children[this.index + 1].getCanvas()._canvas);
        }
        else {
            stage.content.appendChild(this.getNativeCanvasElement());
        }
        return true;
    }
    moveDown() {
        if (Node.prototype.moveDown.call(this)) {
            const stage = this.getStage();
            if (stage) {
                const children = stage.children;
                if (stage.content) {
                    stage.content.removeChild(this.getNativeCanvasElement());
                    stage.content.insertBefore(this.getNativeCanvasElement(), children[this.index + 1].getCanvas()._canvas);
                }
            }
            return true;
        }
        return false;
    }
    moveToBottom() {
        if (Node.prototype.moveToBottom.call(this)) {
            const stage = this.getStage();
            if (stage) {
                const children = stage.children;
                if (stage.content) {
                    stage.content.removeChild(this.getNativeCanvasElement());
                    stage.content.insertBefore(this.getNativeCanvasElement(), children[1].getCanvas()._canvas);
                }
            }
            return true;
        }
        return false;
    }
    getLayer() {
        return this;
    }
    remove() {
        const _canvas = this.getNativeCanvasElement();
        Node.prototype.remove.call(this);
        if (_canvas && _canvas.parentNode && Util._isInDocument(_canvas)) {
            _canvas.parentNode.removeChild(_canvas);
        }
        return this;
    }
    getStage() {
        return this.parent;
    }
    setSize({ width, height }) {
        this.canvas.setSize(width, height);
        this.hitCanvas.setSize(width, height);
        this._setSmoothEnabled();
        return this;
    }
    _validateAdd(child) {
        const type = child.getType();
        if (type !== 'Group' && type !== 'Shape') {
            Util.throw('You may only add groups and shapes to a layer.');
        }
    }
    _toKonvaCanvas(config) {
        config = { ...config };
        config.width = config.width || this.getWidth();
        config.height = config.height || this.getHeight();
        config.x = config.x !== undefined ? config.x : this.x();
        config.y = config.y !== undefined ? config.y : this.y();
        return Node.prototype._toKonvaCanvas.call(this, config);
    }
    _checkVisibility() {
        const visible = this.visible();
        if (visible) {
            this.canvas._canvas.style.display = 'block';
        }
        else {
            this.canvas._canvas.style.display = 'none';
        }
    }
    _setSmoothEnabled() {
        this.getContext()._context.imageSmoothingEnabled =
            this.imageSmoothingEnabled();
    }
    getWidth() {
        if (this.parent) {
            return this.parent.width();
        }
    }
    setWidth() {
        Util.warn('Can not change width of layer. Use "stage.width(value)" function instead.');
    }
    getHeight() {
        if (this.parent) {
            return this.parent.height();
        }
    }
    setHeight() {
        Util.warn('Can not change height of layer. Use "stage.height(value)" function instead.');
    }
    batchDraw() {
        if (!this._waitingForDraw) {
            this._waitingForDraw = true;
            Util.requestAnimFrame(() => {
                this.draw();
                this._waitingForDraw = false;
            });
        }
        return this;
    }
    getIntersection(pos) {
        if (!this.isListening() || !this.isVisible()) {
            return null;
        }
        let spiralSearchDistance = 1;
        let continueSearch = false;
        while (true) {
            for (let i = 0; i < INTERSECTION_OFFSETS_LEN; i++) {
                const intersectionOffset = INTERSECTION_OFFSETS[i];
                const obj = this._getIntersection({
                    x: pos.x + intersectionOffset.x * spiralSearchDistance,
                    y: pos.y + intersectionOffset.y * spiralSearchDistance,
                });
                const shape = obj.shape;
                if (shape) {
                    return shape;
                }
                continueSearch = !!obj.antialiased;
                if (!obj.antialiased) {
                    break;
                }
            }
            if (continueSearch) {
                spiralSearchDistance += 1;
            }
            else {
                return null;
            }
        }
    }
    _getIntersection(pos) {
        const ratio = this.hitCanvas.pixelRatio;
        const p = this.hitCanvas.context.getImageData(Math.round(pos.x * ratio), Math.round(pos.y * ratio), 1, 1).data;
        const p3 = p[3];
        if (p3 === 255) {
            const colorKey = Util.getHitColorKey(p[0], p[1], p[2]);
            const shape = shapes[colorKey];
            if (shape) {
                return {
                    shape: shape,
                };
            }
            return {
                antialiased: true,
            };
        }
        else if (p3 > 0) {
            return {
                antialiased: true,
            };
        }
        return {};
    }
    drawScene(can, top, bufferCanvas) {
        const layer = this.getLayer(), canvas = can || (layer && layer.getCanvas());
        this._fire(BEFORE_DRAW, {
            node: this,
        });
        if (this.clearBeforeDraw()) {
            canvas.getContext().clear();
        }
        Container.prototype.drawScene.call(this, canvas, top, bufferCanvas);
        this._fire(DRAW, {
            node: this,
        });
        return this;
    }
    drawHit(can, top) {
        const layer = this.getLayer(), canvas = can || (layer && layer.hitCanvas);
        if (layer && layer.clearBeforeDraw()) {
            layer.getHitCanvas().getContext().clear();
        }
        Container.prototype.drawHit.call(this, canvas, top);
        return this;
    }
    enableHitGraph() {
        this.hitGraphEnabled(true);
        return this;
    }
    disableHitGraph() {
        this.hitGraphEnabled(false);
        return this;
    }
    setHitGraphEnabled(val) {
        Util.warn('hitGraphEnabled method is deprecated. Please use layer.listening() instead.');
        this.listening(val);
    }
    getHitGraphEnabled(val) {
        Util.warn('hitGraphEnabled method is deprecated. Please use layer.listening() instead.');
        return this.listening();
    }
    toggleHitCanvas() {
        if (!this.parent || !this.parent['content']) {
            return;
        }
        const parent = this.parent;
        const added = !!this.hitCanvas._canvas.parentNode;
        if (added) {
            parent.content.removeChild(this.hitCanvas._canvas);
        }
        else {
            parent.content.appendChild(this.hitCanvas._canvas);
        }
    }
    destroy() {
        Util.releaseCanvas(this.getNativeCanvasElement(), this.getHitCanvas()._canvas);
        return super.destroy();
    }
};
Layer$1.prototype.nodeType = 'Layer';
_registerNode(Layer$1);
Factory.addGetterSetter(Layer$1, 'imageSmoothingEnabled', true);
Factory.addGetterSetter(Layer$1, 'clearBeforeDraw', true);
Factory.addGetterSetter(Layer$1, 'hitGraphEnabled', true, getBooleanValidator());

class FastLayer extends Layer$1 {
    constructor(attrs) {
        super(attrs);
        this.listening(false);
        Util.warn('Konva.Fast layer is deprecated. Please use "new Konva.Layer({ listening: false })" instead.');
    }
}
FastLayer.prototype.nodeType = 'FastLayer';
_registerNode(FastLayer);

let Group$1 = class Group extends Container {
    _validateAdd(child) {
        const type = child.getType();
        if (type !== 'Group' && type !== 'Shape') {
            Util.throw('You may only add groups and shapes to groups.');
        }
    }
};
Group$1.prototype.nodeType = 'Group';
_registerNode(Group$1);

const now = (function () {
    if (glob.performance && glob.performance.now) {
        return function () {
            return glob.performance.now();
        };
    }
    return function () {
        return new Date().getTime();
    };
})();
class Animation {
    constructor(func, layers) {
        this.id = Animation.animIdCounter++;
        this.frame = {
            time: 0,
            timeDiff: 0,
            lastTime: now(),
            frameRate: 0,
        };
        this.func = func;
        this.setLayers(layers);
    }
    setLayers(layers) {
        let lays = [];
        if (layers) {
            lays = Array.isArray(layers) ? layers : [layers];
        }
        this.layers = lays;
        return this;
    }
    getLayers() {
        return this.layers;
    }
    addLayer(layer) {
        const layers = this.layers;
        const len = layers.length;
        for (let n = 0; n < len; n++) {
            if (layers[n]._id === layer._id) {
                return false;
            }
        }
        this.layers.push(layer);
        return true;
    }
    isRunning() {
        const a = Animation;
        const animations = a.animations;
        const len = animations.length;
        for (let n = 0; n < len; n++) {
            if (animations[n].id === this.id) {
                return true;
            }
        }
        return false;
    }
    start() {
        this.stop();
        this.frame.timeDiff = 0;
        this.frame.lastTime = now();
        Animation._addAnimation(this);
        return this;
    }
    stop() {
        Animation._removeAnimation(this);
        return this;
    }
    _updateFrameObject(time) {
        this.frame.timeDiff = time - this.frame.lastTime;
        this.frame.lastTime = time;
        this.frame.time += this.frame.timeDiff;
        this.frame.frameRate = 1000 / this.frame.timeDiff;
    }
    static _addAnimation(anim) {
        this.animations.push(anim);
        this._handleAnimation();
    }
    static _removeAnimation(anim) {
        const id = anim.id;
        const animations = this.animations;
        const len = animations.length;
        for (let n = 0; n < len; n++) {
            if (animations[n].id === id) {
                this.animations.splice(n, 1);
                break;
            }
        }
    }
    static _runFrames() {
        const layerHash = {};
        const animations = this.animations;
        for (let n = 0; n < animations.length; n++) {
            const anim = animations[n];
            const layers = anim.layers;
            const func = anim.func;
            anim._updateFrameObject(now());
            const layersLen = layers.length;
            let needRedraw;
            if (func) {
                needRedraw = func.call(anim, anim.frame) !== false;
            }
            else {
                needRedraw = true;
            }
            if (!needRedraw) {
                continue;
            }
            for (let i = 0; i < layersLen; i++) {
                const layer = layers[i];
                if (layer._id !== undefined) {
                    layerHash[layer._id] = layer;
                }
            }
        }
        for (const key in layerHash) {
            if (!layerHash.hasOwnProperty(key)) {
                continue;
            }
            layerHash[key].batchDraw();
        }
    }
    static _animationLoop() {
        const Anim = Animation;
        if (Anim.animations.length) {
            Anim._runFrames();
            Util.requestAnimFrame(Anim._animationLoop);
        }
        else {
            Anim.animRunning = false;
        }
    }
    static _handleAnimation() {
        if (!this.animRunning) {
            this.animRunning = true;
            Util.requestAnimFrame(this._animationLoop);
        }
    }
}
Animation.animations = [];
Animation.animIdCounter = 0;
Animation.animRunning = false;

const blacklist = {
    node: 1,
    duration: 1,
    easing: 1,
    onFinish: 1,
    yoyo: 1,
}, PAUSED = 1, PLAYING = 2, REVERSING = 3, colorAttrs = ['fill', 'stroke', 'shadowColor'];
let idCounter = 0;
class TweenEngine {
    constructor(prop, propFunc, func, begin, finish, duration, yoyo) {
        this.prop = prop;
        this.propFunc = propFunc;
        this.begin = begin;
        this._pos = begin;
        this.duration = duration;
        this._change = 0;
        this.prevPos = 0;
        this.yoyo = yoyo;
        this._time = 0;
        this._position = 0;
        this._startTime = 0;
        this._finish = 0;
        this.func = func;
        this._change = finish - this.begin;
        this.pause();
    }
    fire(str) {
        const handler = this[str];
        if (handler) {
            handler();
        }
    }
    setTime(t) {
        if (t > this.duration) {
            if (this.yoyo) {
                this._time = this.duration;
                this.reverse();
            }
            else {
                this.finish();
            }
        }
        else if (t < 0) {
            if (this.yoyo) {
                this._time = 0;
                this.play();
            }
            else {
                this.reset();
            }
        }
        else {
            this._time = t;
            this.update();
        }
    }
    getTime() {
        return this._time;
    }
    setPosition(p) {
        this.prevPos = this._pos;
        this.propFunc(p);
        this._pos = p;
    }
    getPosition(t) {
        if (t === undefined) {
            t = this._time;
        }
        return this.func(t, this.begin, this._change, this.duration);
    }
    play() {
        this.state = PLAYING;
        this._startTime = this.getTimer() - this._time;
        this.onEnterFrame();
        this.fire('onPlay');
    }
    reverse() {
        this.state = REVERSING;
        this._time = this.duration - this._time;
        this._startTime = this.getTimer() - this._time;
        this.onEnterFrame();
        this.fire('onReverse');
    }
    seek(t) {
        this.pause();
        this._time = t;
        this.update();
        this.fire('onSeek');
    }
    reset() {
        this.pause();
        this._time = 0;
        this.update();
        this.fire('onReset');
    }
    finish() {
        this.pause();
        this._time = this.duration;
        this.update();
        this.fire('onFinish');
    }
    update() {
        this.setPosition(this.getPosition(this._time));
        this.fire('onUpdate');
    }
    onEnterFrame() {
        const t = this.getTimer() - this._startTime;
        if (this.state === PLAYING) {
            this.setTime(t);
        }
        else if (this.state === REVERSING) {
            this.setTime(this.duration - t);
        }
    }
    pause() {
        this.state = PAUSED;
        this.fire('onPause');
    }
    getTimer() {
        return new Date().getTime();
    }
}
class Tween {
    constructor(config) {
        const that = this, node = config.node, nodeId = node._id, easing = config.easing || Easings.Linear, yoyo = !!config.yoyo;
        let duration, key;
        if (typeof config.duration === 'undefined') {
            duration = 0.3;
        }
        else if (config.duration === 0) {
            duration = 0.001;
        }
        else {
            duration = config.duration;
        }
        this.node = node;
        this._id = idCounter++;
        const layers = node.getLayer() ||
            (node instanceof Konva$1['Stage'] ? node.getLayers() : null);
        if (!layers) {
            Util.error('Tween constructor have `node` that is not in a layer. Please add node into layer first.');
        }
        this.anim = new Animation(function () {
            that.tween.onEnterFrame();
        }, layers);
        this.tween = new TweenEngine(key, function (i) {
            that._tweenFunc(i);
        }, easing, 0, 1, duration * 1000, yoyo);
        this._addListeners();
        if (!Tween.attrs[nodeId]) {
            Tween.attrs[nodeId] = {};
        }
        if (!Tween.attrs[nodeId][this._id]) {
            Tween.attrs[nodeId][this._id] = {};
        }
        if (!Tween.tweens[nodeId]) {
            Tween.tweens[nodeId] = {};
        }
        for (key in config) {
            if (blacklist[key] === undefined) {
                this._addAttr(key, config[key]);
            }
        }
        this.reset();
        this.onFinish = config.onFinish;
        this.onReset = config.onReset;
        this.onUpdate = config.onUpdate;
    }
    _addAttr(key, end) {
        const node = this.node, nodeId = node._id;
        let diff, len, trueEnd, trueStart, endRGBA;
        const tweenId = Tween.tweens[nodeId][key];
        if (tweenId) {
            delete Tween.attrs[nodeId][tweenId][key];
        }
        let start = node.getAttr(key);
        if (Util._isArray(end)) {
            diff = [];
            len = Math.max(end.length, start.length);
            if (key === 'points' && end.length !== start.length) {
                if (end.length > start.length) {
                    trueStart = start;
                    start = Util._prepareArrayForTween(start, end, node.closed());
                }
                else {
                    trueEnd = end;
                    end = Util._prepareArrayForTween(end, start, node.closed());
                }
            }
            if (key.indexOf('fill') === 0) {
                for (let n = 0; n < len; n++) {
                    if (n % 2 === 0) {
                        diff.push(end[n] - start[n]);
                    }
                    else {
                        const startRGBA = Util.colorToRGBA(start[n]);
                        endRGBA = Util.colorToRGBA(end[n]);
                        start[n] = startRGBA;
                        diff.push({
                            r: endRGBA.r - startRGBA.r,
                            g: endRGBA.g - startRGBA.g,
                            b: endRGBA.b - startRGBA.b,
                            a: endRGBA.a - startRGBA.a,
                        });
                    }
                }
            }
            else {
                for (let n = 0; n < len; n++) {
                    diff.push(end[n] - start[n]);
                }
            }
        }
        else if (colorAttrs.indexOf(key) !== -1) {
            start = Util.colorToRGBA(start);
            endRGBA = Util.colorToRGBA(end);
            diff = {
                r: endRGBA.r - start.r,
                g: endRGBA.g - start.g,
                b: endRGBA.b - start.b,
                a: endRGBA.a - start.a,
            };
        }
        else {
            diff = end - start;
        }
        Tween.attrs[nodeId][this._id][key] = {
            start: start,
            diff: diff,
            end: end,
            trueEnd: trueEnd,
            trueStart: trueStart,
        };
        Tween.tweens[nodeId][key] = this._id;
    }
    _tweenFunc(i) {
        const node = this.node, attrs = Tween.attrs[node._id][this._id];
        let key, attr, start, diff, newVal, n, len, end;
        for (key in attrs) {
            attr = attrs[key];
            start = attr.start;
            diff = attr.diff;
            end = attr.end;
            if (Util._isArray(start)) {
                newVal = [];
                len = Math.max(start.length, end.length);
                if (key.indexOf('fill') === 0) {
                    for (n = 0; n < len; n++) {
                        if (n % 2 === 0) {
                            newVal.push((start[n] || 0) + diff[n] * i);
                        }
                        else {
                            newVal.push('rgba(' +
                                Math.round(start[n].r + diff[n].r * i) +
                                ',' +
                                Math.round(start[n].g + diff[n].g * i) +
                                ',' +
                                Math.round(start[n].b + diff[n].b * i) +
                                ',' +
                                (start[n].a + diff[n].a * i) +
                                ')');
                        }
                    }
                }
                else {
                    for (n = 0; n < len; n++) {
                        newVal.push((start[n] || 0) + diff[n] * i);
                    }
                }
            }
            else if (colorAttrs.indexOf(key) !== -1) {
                newVal =
                    'rgba(' +
                        Math.round(start.r + diff.r * i) +
                        ',' +
                        Math.round(start.g + diff.g * i) +
                        ',' +
                        Math.round(start.b + diff.b * i) +
                        ',' +
                        (start.a + diff.a * i) +
                        ')';
            }
            else {
                newVal = start + diff * i;
            }
            node.setAttr(key, newVal);
        }
    }
    _addListeners() {
        this.tween.onPlay = () => {
            this.anim.start();
        };
        this.tween.onReverse = () => {
            this.anim.start();
        };
        this.tween.onPause = () => {
            this.anim.stop();
        };
        this.tween.onFinish = () => {
            const node = this.node;
            const attrs = Tween.attrs[node._id][this._id];
            if (attrs.points && attrs.points.trueEnd) {
                node.setAttr('points', attrs.points.trueEnd);
            }
            if (this.onFinish) {
                this.onFinish.call(this);
            }
        };
        this.tween.onReset = () => {
            const node = this.node;
            const attrs = Tween.attrs[node._id][this._id];
            if (attrs.points && attrs.points.trueStart) {
                node.points(attrs.points.trueStart);
            }
            if (this.onReset) {
                this.onReset();
            }
        };
        this.tween.onUpdate = () => {
            if (this.onUpdate) {
                this.onUpdate.call(this);
            }
        };
    }
    play() {
        this.tween.play();
        return this;
    }
    reverse() {
        this.tween.reverse();
        return this;
    }
    reset() {
        this.tween.reset();
        return this;
    }
    seek(t) {
        this.tween.seek(t * 1000);
        return this;
    }
    pause() {
        this.tween.pause();
        return this;
    }
    finish() {
        this.tween.finish();
        return this;
    }
    destroy() {
        const nodeId = this.node._id, thisId = this._id, attrs = Tween.tweens[nodeId];
        this.pause();
        if (this.anim) {
            this.anim.stop();
        }
        for (const key in attrs) {
            delete Tween.tweens[nodeId][key];
        }
        delete Tween.attrs[nodeId][thisId];
        if (Tween.tweens[nodeId]) {
            if (Object.keys(Tween.tweens[nodeId]).length === 0) {
                delete Tween.tweens[nodeId];
            }
            if (Object.keys(Tween.attrs[nodeId]).length === 0) {
                delete Tween.attrs[nodeId];
            }
        }
    }
}
Tween.attrs = {};
Tween.tweens = {};
Node.prototype.to = function (params) {
    const onFinish = params.onFinish;
    params.node = this;
    params.onFinish = function () {
        this.destroy();
        if (onFinish) {
            onFinish();
        }
    };
    const tween = new Tween(params);
    tween.play();
};
const Easings = {
    BackEaseIn(t, b, c, d) {
        const s = 1.70158;
        return c * (t /= d) * t * ((s + 1) * t - s) + b;
    },
    BackEaseOut(t, b, c, d) {
        const s = 1.70158;
        return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
    },
    BackEaseInOut(t, b, c, d) {
        let s = 1.70158;
        if ((t /= d / 2) < 1) {
            return (c / 2) * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
        }
        return (c / 2) * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
    },
    ElasticEaseIn(t, b, c, d, a, p) {
        let s = 0;
        if (t === 0) {
            return b;
        }
        if ((t /= d) === 1) {
            return b + c;
        }
        if (!p) {
            p = d * 0.3;
        }
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        }
        else {
            s = (p / (2 * Math.PI)) * Math.asin(c / a);
        }
        return (-(a *
            Math.pow(2, 10 * (t -= 1)) *
            Math.sin(((t * d - s) * (2 * Math.PI)) / p)) + b);
    },
    ElasticEaseOut(t, b, c, d, a, p) {
        let s = 0;
        if (t === 0) {
            return b;
        }
        if ((t /= d) === 1) {
            return b + c;
        }
        if (!p) {
            p = d * 0.3;
        }
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        }
        else {
            s = (p / (2 * Math.PI)) * Math.asin(c / a);
        }
        return (a * Math.pow(2, -10 * t) * Math.sin(((t * d - s) * (2 * Math.PI)) / p) +
            c +
            b);
    },
    ElasticEaseInOut(t, b, c, d, a, p) {
        let s = 0;
        if (t === 0) {
            return b;
        }
        if ((t /= d / 2) === 2) {
            return b + c;
        }
        if (!p) {
            p = d * (0.3 * 1.5);
        }
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        }
        else {
            s = (p / (2 * Math.PI)) * Math.asin(c / a);
        }
        if (t < 1) {
            return (-0.5 *
                (a *
                    Math.pow(2, 10 * (t -= 1)) *
                    Math.sin(((t * d - s) * (2 * Math.PI)) / p)) +
                b);
        }
        return (a *
            Math.pow(2, -10 * (t -= 1)) *
            Math.sin(((t * d - s) * (2 * Math.PI)) / p) *
            0.5 +
            c +
            b);
    },
    BounceEaseOut(t, b, c, d) {
        if ((t /= d) < 1 / 2.75) {
            return c * (7.5625 * t * t) + b;
        }
        else if (t < 2 / 2.75) {
            return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
        }
        else if (t < 2.5 / 2.75) {
            return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
        }
        else {
            return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
        }
    },
    BounceEaseIn(t, b, c, d) {
        return c - Easings.BounceEaseOut(d - t, 0, c, d) + b;
    },
    BounceEaseInOut(t, b, c, d) {
        if (t < d / 2) {
            return Easings.BounceEaseIn(t * 2, 0, c, d) * 0.5 + b;
        }
        else {
            return Easings.BounceEaseOut(t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b;
        }
    },
    EaseIn(t, b, c, d) {
        return c * (t /= d) * t + b;
    },
    EaseOut(t, b, c, d) {
        return -c * (t /= d) * (t - 2) + b;
    },
    EaseInOut(t, b, c, d) {
        if ((t /= d / 2) < 1) {
            return (c / 2) * t * t + b;
        }
        return (-c / 2) * (--t * (t - 2) - 1) + b;
    },
    StrongEaseIn(t, b, c, d) {
        return c * (t /= d) * t * t * t * t + b;
    },
    StrongEaseOut(t, b, c, d) {
        return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
    },
    StrongEaseInOut(t, b, c, d) {
        if ((t /= d / 2) < 1) {
            return (c / 2) * t * t * t * t * t + b;
        }
        return (c / 2) * ((t -= 2) * t * t * t * t + 2) + b;
    },
    Linear(t, b, c, d) {
        return (c * t) / d + b;
    },
};

const Konva = Util._assign(Konva$1, {
    Util,
    Transform,
    Node,
    Container,
    Stage: Stage$1,
    stages,
    Layer: Layer$1,
    FastLayer,
    Group: Group$1,
    DD,
    Shape,
    shapes,
    Animation,
    Tween,
    Easings,
    Context,
    Canvas,
});

class Arc extends Shape {
    _sceneFunc(context) {
        const angle = Konva$1.getAngle(this.angle()), clockwise = this.clockwise();
        context.beginPath();
        context.arc(0, 0, this.outerRadius(), 0, angle, clockwise);
        context.arc(0, 0, this.innerRadius(), angle, 0, !clockwise);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.outerRadius() * 2;
    }
    getHeight() {
        return this.outerRadius() * 2;
    }
    setWidth(width) {
        this.outerRadius(width / 2);
    }
    setHeight(height) {
        this.outerRadius(height / 2);
    }
    getSelfRect() {
        const innerRadius = this.innerRadius();
        const outerRadius = this.outerRadius();
        const clockwise = this.clockwise();
        const angle = Konva$1.getAngle(clockwise ? 360 - this.angle() : this.angle());
        const boundLeftRatio = Math.cos(Math.min(angle, Math.PI));
        const boundRightRatio = 1;
        const boundTopRatio = Math.sin(Math.min(Math.max(Math.PI, angle), (3 * Math.PI) / 2));
        const boundBottomRatio = Math.sin(Math.min(angle, Math.PI / 2));
        const boundLeft = boundLeftRatio * (boundLeftRatio > 0 ? innerRadius : outerRadius);
        const boundRight = boundRightRatio * (outerRadius );
        const boundTop = boundTopRatio * (boundTopRatio > 0 ? innerRadius : outerRadius);
        const boundBottom = boundBottomRatio * (boundBottomRatio > 0 ? outerRadius : innerRadius);
        return {
            x: boundLeft,
            y: clockwise ? -1 * boundBottom : boundTop,
            width: boundRight - boundLeft,
            height: boundBottom - boundTop,
        };
    }
}
Arc.prototype._centroid = true;
Arc.prototype.className = 'Arc';
Arc.prototype._attrsAffectingSize = [
    'innerRadius',
    'outerRadius',
    'angle',
    'clockwise',
];
_registerNode(Arc);
Factory.addGetterSetter(Arc, 'innerRadius', 0, getNumberValidator());
Factory.addGetterSetter(Arc, 'outerRadius', 0, getNumberValidator());
Factory.addGetterSetter(Arc, 'angle', 0, getNumberValidator());
Factory.addGetterSetter(Arc, 'clockwise', false, getBooleanValidator());

function getControlPoints(x0, y0, x1, y1, x2, y2, t) {
    const d01 = Math.sqrt(Math.pow(x1 - x0, 2) + Math.pow(y1 - y0, 2)), d12 = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2)), fa = (t * d01) / (d01 + d12), fb = (t * d12) / (d01 + d12), p1x = x1 - fa * (x2 - x0), p1y = y1 - fa * (y2 - y0), p2x = x1 + fb * (x2 - x0), p2y = y1 + fb * (y2 - y0);
    return [p1x, p1y, p2x, p2y];
}
function expandPoints(p, tension) {
    const len = p.length, allPoints = [];
    for (let n = 2; n < len - 2; n += 2) {
        const cp = getControlPoints(p[n - 2], p[n - 1], p[n], p[n + 1], p[n + 2], p[n + 3], tension);
        if (isNaN(cp[0])) {
            continue;
        }
        allPoints.push(cp[0]);
        allPoints.push(cp[1]);
        allPoints.push(p[n]);
        allPoints.push(p[n + 1]);
        allPoints.push(cp[2]);
        allPoints.push(cp[3]);
    }
    return allPoints;
}
function getBezierExtremaPoints(points) {
    const axisPoints = [
        [points[0], points[2], points[4], points[6]],
        [points[1], points[3], points[5], points[7]],
    ];
    const extremaTs = [];
    for (const axis of axisPoints) {
        const a = -3 * axis[0] + 9 * axis[1] - 9 * axis[2] + 3 * axis[3];
        if (a !== 0) {
            const b = 6 * axis[0] - 12 * axis[1] + 6 * axis[2];
            const c = -3 * axis[0] + 3 * axis[1];
            const discriminant = b * b - 4 * a * c;
            if (discriminant >= 0) {
                const d = Math.sqrt(discriminant);
                extremaTs.push((-b + d) / (2 * a));
                extremaTs.push((-b - d) / (2 * a));
            }
        }
    }
    return extremaTs
        .filter((t) => t > 0 && t < 1)
        .flatMap((t) => axisPoints.map((axis) => {
        const mt = 1 - t;
        return (mt * mt * mt * axis[0] +
            3 * mt * mt * t * axis[1] +
            3 * mt * t * t * axis[2] +
            t * t * t * axis[3]);
    }));
}
let Line$1 = class Line extends Shape {
    constructor(config) {
        super(config);
        this.on('pointsChange.konva tensionChange.konva closedChange.konva bezierChange.konva', function () {
            this._clearCache('tensionPoints');
        });
    }
    _sceneFunc(context) {
        const points = this.points(), length = points.length, tension = this.tension(), closed = this.closed(), bezier = this.bezier();
        if (!length) {
            return;
        }
        let n = 0;
        context.beginPath();
        context.moveTo(points[0], points[1]);
        if (tension !== 0 && length > 4) {
            const tp = this.getTensionPoints();
            const len = tp.length;
            n = closed ? 0 : 4;
            if (!closed) {
                context.quadraticCurveTo(tp[0], tp[1], tp[2], tp[3]);
            }
            while (n < len - 2) {
                context.bezierCurveTo(tp[n++], tp[n++], tp[n++], tp[n++], tp[n++], tp[n++]);
            }
            if (!closed) {
                context.quadraticCurveTo(tp[len - 2], tp[len - 1], points[length - 2], points[length - 1]);
            }
        }
        else if (bezier) {
            n = 2;
            while (n < length) {
                context.bezierCurveTo(points[n++], points[n++], points[n++], points[n++], points[n++], points[n++]);
            }
        }
        else {
            for (n = 2; n < length; n += 2) {
                context.lineTo(points[n], points[n + 1]);
            }
        }
        if (closed) {
            context.closePath();
            context.fillStrokeShape(this);
        }
        else {
            context.strokeShape(this);
        }
    }
    getTensionPoints() {
        return this._getCache('tensionPoints', this._getTensionPoints);
    }
    _getTensionPoints() {
        if (this.closed()) {
            return this._getTensionPointsClosed();
        }
        else {
            return expandPoints(this.points(), this.tension());
        }
    }
    _getTensionPointsClosed() {
        const p = this.points(), len = p.length, tension = this.tension(), firstControlPoints = getControlPoints(p[len - 2], p[len - 1], p[0], p[1], p[2], p[3], tension), lastControlPoints = getControlPoints(p[len - 4], p[len - 3], p[len - 2], p[len - 1], p[0], p[1], tension), middle = expandPoints(p, tension), tp = [firstControlPoints[2], firstControlPoints[3]]
            .concat(middle)
            .concat([
            lastControlPoints[0],
            lastControlPoints[1],
            p[len - 2],
            p[len - 1],
            lastControlPoints[2],
            lastControlPoints[3],
            firstControlPoints[0],
            firstControlPoints[1],
            p[0],
            p[1],
        ]);
        return tp;
    }
    getWidth() {
        return this.getSelfRect().width;
    }
    getHeight() {
        return this.getSelfRect().height;
    }
    getSelfRect() {
        let points = this.points();
        if (points.length < 4) {
            return {
                x: points[0] || 0,
                y: points[1] || 0,
                width: 0,
                height: 0,
            };
        }
        if (this.tension() !== 0) {
            points = [
                points[0],
                points[1],
                ...this._getTensionPoints(),
                points[points.length - 2],
                points[points.length - 1],
            ];
        }
        else if (this.bezier()) {
            points = [
                points[0],
                points[1],
                ...getBezierExtremaPoints(this.points()),
                points[points.length - 2],
                points[points.length - 1],
            ];
        }
        else {
            points = this.points();
        }
        let minX = points[0];
        let maxX = points[0];
        let minY = points[1];
        let maxY = points[1];
        let x, y;
        for (let i = 0; i < points.length / 2; i++) {
            x = points[i * 2];
            y = points[i * 2 + 1];
            minX = Math.min(minX, x);
            maxX = Math.max(maxX, x);
            minY = Math.min(minY, y);
            maxY = Math.max(maxY, y);
        }
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY,
        };
    }
};
Line$1.prototype.className = 'Line';
Line$1.prototype._attrsAffectingSize = ['points', 'bezier', 'tension'];
_registerNode(Line$1);
Factory.addGetterSetter(Line$1, 'closed', false);
Factory.addGetterSetter(Line$1, 'bezier', false);
Factory.addGetterSetter(Line$1, 'tension', 0, getNumberValidator());
Factory.addGetterSetter(Line$1, 'points', [], getNumberArrayValidator());

const tValues = [
    [],
    [],
    [
        -0.5773502691896257,
        0.5773502691896257645091487805019574556476,
    ],
    [
        0, -0.7745966692414834,
        0.7745966692414833770358530799564799221665,
    ],
    [
        -0.33998104358485626,
        0.3399810435848562648026657591032446872005,
        -0.8611363115940526,
        0.8611363115940525752239464888928095050957,
    ],
    [
        0, -0.5384693101056831,
        0.5384693101056830910363144207002088049672,
        -0.906179845938664,
        0.9061798459386639927976268782993929651256,
    ],
    [
        0.6612093864662645136613995950199053470064,
        -0.6612093864662645,
        -0.2386191860831969,
        0.2386191860831969086305017216807119354186,
        -0.932469514203152,
        0.9324695142031520278123015544939946091347,
    ],
    [
        0, 0.4058451513773971669066064120769614633473,
        -0.4058451513773972,
        -0.7415311855993945,
        0.7415311855993944398638647732807884070741,
        -0.9491079123427585,
        0.9491079123427585245261896840478512624007,
    ],
    [
        -0.1834346424956498,
        0.1834346424956498049394761423601839806667,
        -0.525532409916329,
        0.5255324099163289858177390491892463490419,
        -0.7966664774136267,
        0.7966664774136267395915539364758304368371,
        -0.9602898564975363,
        0.9602898564975362316835608685694729904282,
    ],
    [
        0, -0.8360311073266358,
        0.8360311073266357942994297880697348765441,
        -0.9681602395076261,
        0.9681602395076260898355762029036728700494,
        -0.3242534234038089,
        0.3242534234038089290385380146433366085719,
        -0.6133714327005904,
        0.6133714327005903973087020393414741847857,
    ],
    [
        -0.14887433898163122,
        0.1488743389816312108848260011297199846175,
        -0.4333953941292472,
        0.4333953941292471907992659431657841622,
        -0.6794095682990244,
        0.6794095682990244062343273651148735757692,
        -0.8650633666889845,
        0.8650633666889845107320966884234930485275,
        -0.9739065285171717,
        0.9739065285171717200779640120844520534282,
    ],
    [
        0, -0.26954315595234496,
        0.2695431559523449723315319854008615246796,
        -0.5190961292068118,
        0.5190961292068118159257256694586095544802,
        -0.7301520055740494,
        0.7301520055740493240934162520311534580496,
        -0.8870625997680953,
        0.8870625997680952990751577693039272666316,
        -0.978228658146057,
        0.9782286581460569928039380011228573907714,
    ],
    [
        -0.1252334085114689,
        0.1252334085114689154724413694638531299833,
        -0.3678314989981802,
        0.3678314989981801937526915366437175612563,
        -0.5873179542866175,
        0.587317954286617447296702418940534280369,
        -0.7699026741943047,
        0.7699026741943046870368938332128180759849,
        -0.9041172563704749,
        0.9041172563704748566784658661190961925375,
        -0.9815606342467192,
        0.9815606342467192506905490901492808229601,
    ],
    [
        0, -0.2304583159551348,
        0.2304583159551347940655281210979888352115,
        -0.44849275103644687,
        0.4484927510364468528779128521276398678019,
        -0.6423493394403402,
        0.6423493394403402206439846069955156500716,
        -0.8015780907333099,
        0.8015780907333099127942064895828598903056,
        -0.9175983992229779,
        0.9175983992229779652065478365007195123904,
        -0.9841830547185881,
        0.9841830547185881494728294488071096110649,
    ],
    [
        -0.10805494870734367,
        0.1080549487073436620662446502198347476119,
        -0.31911236892788974,
        0.3191123689278897604356718241684754668342,
        -0.5152486363581541,
        0.5152486363581540919652907185511886623088,
        -0.6872929048116855,
        0.6872929048116854701480198030193341375384,
        -0.827201315069765,
        0.8272013150697649931897947426503949610397,
        -0.9284348836635735,
        0.928434883663573517336391139377874264477,
        -0.9862838086968123,
        0.986283808696812338841597266704052801676,
    ],
    [
        0, -0.20119409399743451,
        0.2011940939974345223006283033945962078128,
        -0.3941513470775634,
        0.3941513470775633698972073709810454683627,
        -0.5709721726085388,
        0.5709721726085388475372267372539106412383,
        -0.7244177313601701,
        0.7244177313601700474161860546139380096308,
        -0.8482065834104272,
        0.8482065834104272162006483207742168513662,
        -0.937273392400706,
        0.9372733924007059043077589477102094712439,
        -0.9879925180204854,
        0.9879925180204854284895657185866125811469,
    ],
    [
        -0.09501250983763744,
        0.0950125098376374401853193354249580631303,
        -0.2816035507792589,
        0.281603550779258913230460501460496106486,
        -0.45801677765722737,
        0.45801677765722738634241944298357757354,
        -0.6178762444026438,
        0.6178762444026437484466717640487910189918,
        -0.755404408355003,
        0.7554044083550030338951011948474422683538,
        -0.8656312023878318,
        0.8656312023878317438804678977123931323873,
        -0.9445750230732326,
        0.9445750230732325760779884155346083450911,
        -0.9894009349916499,
        0.9894009349916499325961541734503326274262,
    ],
    [
        0, -0.17848418149584785,
        0.1784841814958478558506774936540655574754,
        -0.3512317634538763,
        0.3512317634538763152971855170953460050405,
        -0.5126905370864769,
        0.5126905370864769678862465686295518745829,
        -0.6576711592166907,
        0.6576711592166907658503022166430023351478,
        -0.7815140038968014,
        0.7815140038968014069252300555204760502239,
        -0.8802391537269859,
        0.8802391537269859021229556944881556926234,
        -0.9506755217687678,
        0.9506755217687677612227169578958030214433,
        -0.9905754753144174,
        0.9905754753144173356754340199406652765077,
    ],
    [
        -0.0847750130417353,
        0.0847750130417353012422618529357838117333,
        -0.2518862256915055,
        0.2518862256915055095889728548779112301628,
        -0.41175116146284263,
        0.4117511614628426460359317938330516370789,
        -0.5597708310739475,
        0.5597708310739475346078715485253291369276,
        -0.6916870430603532,
        0.6916870430603532078748910812888483894522,
        -0.8037049589725231,
        0.8037049589725231156824174550145907971032,
        -0.8926024664975557,
        0.8926024664975557392060605911271455154078,
        -0.9558239495713977,
        0.9558239495713977551811958929297763099728,
        -0.9915651684209309,
        0.9915651684209309467300160047061507702525,
    ],
    [
        0, -0.16035864564022537,
        0.1603586456402253758680961157407435495048,
        -0.31656409996362983,
        0.3165640999636298319901173288498449178922,
        -0.46457074137596094,
        0.4645707413759609457172671481041023679762,
        -0.600545304661681,
        0.6005453046616810234696381649462392798683,
        -0.7209661773352294,
        0.7209661773352293786170958608237816296571,
        -0.8227146565371428,
        0.8227146565371428249789224867127139017745,
        -0.9031559036148179,
        0.9031559036148179016426609285323124878093,
        -0.96020815213483,
        0.960208152134830030852778840687651526615,
        -0.9924068438435844,
        0.9924068438435844031890176702532604935893,
    ],
    [
        -0.07652652113349734,
        0.0765265211334973337546404093988382110047,
        -0.22778585114164507,
        0.227785851141645078080496195368574624743,
        -0.37370608871541955,
        0.3737060887154195606725481770249272373957,
        -0.5108670019508271,
        0.5108670019508270980043640509552509984254,
        -0.636053680726515,
        0.6360536807265150254528366962262859367433,
        -0.7463319064601508,
        0.7463319064601507926143050703556415903107,
        -0.8391169718222188,
        0.8391169718222188233945290617015206853296,
        -0.912234428251326,
        0.9122344282513259058677524412032981130491,
        -0.9639719272779138,
        0.963971927277913791267666131197277221912,
        -0.9931285991850949,
        0.9931285991850949247861223884713202782226,
    ],
    [
        0, -0.1455618541608951,
        0.1455618541608950909370309823386863301163,
        -0.2880213168024011,
        0.288021316802401096600792516064600319909,
        -0.4243421202074388,
        0.4243421202074387835736688885437880520964,
        -0.5516188358872198,
        0.551618835887219807059018796724313286622,
        -0.6671388041974123,
        0.667138804197412319305966669990339162597,
        -0.7684399634756779,
        0.7684399634756779086158778513062280348209,
        -0.8533633645833173,
        0.8533633645833172836472506385875676702761,
        -0.9200993341504008,
        0.9200993341504008287901871337149688941591,
        -0.9672268385663063,
        0.9672268385663062943166222149076951614246,
        -0.9937521706203895,
        0.9937521706203895002602420359379409291933,
    ],
    [
        -0.06973927331972223,
        0.0697392733197222212138417961186280818222,
        -0.20786042668822127,
        0.2078604266882212854788465339195457342156,
        -0.34193582089208424,
        0.3419358208920842251581474204273796195591,
        -0.469355837986757,
        0.4693558379867570264063307109664063460953,
        -0.5876404035069116,
        0.5876404035069115929588769276386473488776,
        -0.6944872631866827,
        0.6944872631866827800506898357622567712673,
        -0.7878168059792081,
        0.7878168059792081620042779554083515213881,
        -0.8658125777203002,
        0.8658125777203001365364256370193787290847,
        -0.926956772187174,
        0.9269567721871740005206929392590531966353,
        -0.9700604978354287,
        0.9700604978354287271239509867652687108059,
        -0.9942945854823992,
        0.994294585482399292073031421161298980393,
    ],
    [
        0, -0.1332568242984661,
        0.1332568242984661109317426822417661370104,
        -0.26413568097034495,
        0.264135680970344930533869538283309602979,
        -0.3903010380302908,
        0.390301038030290831421488872880605458578,
        -0.5095014778460075,
        0.5095014778460075496897930478668464305448,
        -0.6196098757636461,
        0.6196098757636461563850973116495956533871,
        -0.7186613631319502,
        0.7186613631319501944616244837486188483299,
        -0.8048884016188399,
        0.8048884016188398921511184069967785579414,
        -0.8767523582704416,
        0.8767523582704416673781568859341456716389,
        -0.9329710868260161,
        0.9329710868260161023491969890384229782357,
        -0.9725424712181152,
        0.9725424712181152319560240768207773751816,
        -0.9947693349975522,
        0.9947693349975521235239257154455743605736,
    ],
    [
        -0.06405689286260563,
        0.0640568928626056260850430826247450385909,
        -0.1911188674736163,
        0.1911188674736163091586398207570696318404,
        -0.3150426796961634,
        0.3150426796961633743867932913198102407864,
        -0.4337935076260451,
        0.4337935076260451384870842319133497124524,
        -0.5454214713888396,
        0.5454214713888395356583756172183723700107,
        -0.6480936519369755,
        0.6480936519369755692524957869107476266696,
        -0.7401241915785544,
        0.7401241915785543642438281030999784255232,
        -0.820001985973903,
        0.8200019859739029219539498726697452080761,
        -0.8864155270044011,
        0.8864155270044010342131543419821967550873,
        -0.9382745520027328,
        0.9382745520027327585236490017087214496548,
        -0.9747285559713095,
        0.9747285559713094981983919930081690617411,
        -0.9951872199970213,
        0.9951872199970213601799974097007368118745,
    ],
];
const cValues = [
    [],
    [],
    [1.0, 1.0],
    [
        0.8888888888888888888888888888888888888888,
        0.5555555555555555555555555555555555555555,
        0.5555555555555555555555555555555555555555,
    ],
    [
        0.6521451548625461426269360507780005927646,
        0.6521451548625461426269360507780005927646,
        0.3478548451374538573730639492219994072353,
        0.3478548451374538573730639492219994072353,
    ],
    [
        0.5688888888888888888888888888888888888888,
        0.4786286704993664680412915148356381929122,
        0.4786286704993664680412915148356381929122,
        0.2369268850561890875142640407199173626432,
        0.2369268850561890875142640407199173626432,
    ],
    [
        0.3607615730481386075698335138377161116615,
        0.3607615730481386075698335138377161116615,
        0.4679139345726910473898703439895509948116,
        0.4679139345726910473898703439895509948116,
        0.1713244923791703450402961421727328935268,
        0.1713244923791703450402961421727328935268,
    ],
    [
        0.4179591836734693877551020408163265306122,
        0.3818300505051189449503697754889751338783,
        0.3818300505051189449503697754889751338783,
        0.2797053914892766679014677714237795824869,
        0.2797053914892766679014677714237795824869,
        0.1294849661688696932706114326790820183285,
        0.1294849661688696932706114326790820183285,
    ],
    [
        0.3626837833783619829651504492771956121941,
        0.3626837833783619829651504492771956121941,
        0.3137066458778872873379622019866013132603,
        0.3137066458778872873379622019866013132603,
        0.2223810344533744705443559944262408844301,
        0.2223810344533744705443559944262408844301,
        0.1012285362903762591525313543099621901153,
        0.1012285362903762591525313543099621901153,
    ],
    [
        0.3302393550012597631645250692869740488788,
        0.1806481606948574040584720312429128095143,
        0.1806481606948574040584720312429128095143,
        0.0812743883615744119718921581105236506756,
        0.0812743883615744119718921581105236506756,
        0.3123470770400028400686304065844436655987,
        0.3123470770400028400686304065844436655987,
        0.2606106964029354623187428694186328497718,
        0.2606106964029354623187428694186328497718,
    ],
    [
        0.295524224714752870173892994651338329421,
        0.295524224714752870173892994651338329421,
        0.2692667193099963550912269215694693528597,
        0.2692667193099963550912269215694693528597,
        0.2190863625159820439955349342281631924587,
        0.2190863625159820439955349342281631924587,
        0.1494513491505805931457763396576973324025,
        0.1494513491505805931457763396576973324025,
        0.0666713443086881375935688098933317928578,
        0.0666713443086881375935688098933317928578,
    ],
    [
        0.272925086777900630714483528336342189156,
        0.2628045445102466621806888698905091953727,
        0.2628045445102466621806888698905091953727,
        0.2331937645919904799185237048431751394317,
        0.2331937645919904799185237048431751394317,
        0.1862902109277342514260976414316558916912,
        0.1862902109277342514260976414316558916912,
        0.1255803694649046246346942992239401001976,
        0.1255803694649046246346942992239401001976,
        0.0556685671161736664827537204425485787285,
        0.0556685671161736664827537204425485787285,
    ],
    [
        0.2491470458134027850005624360429512108304,
        0.2491470458134027850005624360429512108304,
        0.2334925365383548087608498989248780562594,
        0.2334925365383548087608498989248780562594,
        0.2031674267230659217490644558097983765065,
        0.2031674267230659217490644558097983765065,
        0.160078328543346226334652529543359071872,
        0.160078328543346226334652529543359071872,
        0.1069393259953184309602547181939962242145,
        0.1069393259953184309602547181939962242145,
        0.047175336386511827194615961485017060317,
        0.047175336386511827194615961485017060317,
    ],
    [
        0.2325515532308739101945895152688359481566,
        0.2262831802628972384120901860397766184347,
        0.2262831802628972384120901860397766184347,
        0.2078160475368885023125232193060527633865,
        0.2078160475368885023125232193060527633865,
        0.1781459807619457382800466919960979955128,
        0.1781459807619457382800466919960979955128,
        0.1388735102197872384636017768688714676218,
        0.1388735102197872384636017768688714676218,
        0.0921214998377284479144217759537971209236,
        0.0921214998377284479144217759537971209236,
        0.0404840047653158795200215922009860600419,
        0.0404840047653158795200215922009860600419,
    ],
    [
        0.2152638534631577901958764433162600352749,
        0.2152638534631577901958764433162600352749,
        0.2051984637212956039659240656612180557103,
        0.2051984637212956039659240656612180557103,
        0.1855383974779378137417165901251570362489,
        0.1855383974779378137417165901251570362489,
        0.1572031671581935345696019386238421566056,
        0.1572031671581935345696019386238421566056,
        0.1215185706879031846894148090724766259566,
        0.1215185706879031846894148090724766259566,
        0.0801580871597602098056332770628543095836,
        0.0801580871597602098056332770628543095836,
        0.0351194603317518630318328761381917806197,
        0.0351194603317518630318328761381917806197,
    ],
    [
        0.2025782419255612728806201999675193148386,
        0.1984314853271115764561183264438393248186,
        0.1984314853271115764561183264438393248186,
        0.1861610000155622110268005618664228245062,
        0.1861610000155622110268005618664228245062,
        0.1662692058169939335532008604812088111309,
        0.1662692058169939335532008604812088111309,
        0.1395706779261543144478047945110283225208,
        0.1395706779261543144478047945110283225208,
        0.1071592204671719350118695466858693034155,
        0.1071592204671719350118695466858693034155,
        0.0703660474881081247092674164506673384667,
        0.0703660474881081247092674164506673384667,
        0.0307532419961172683546283935772044177217,
        0.0307532419961172683546283935772044177217,
    ],
    [
        0.1894506104550684962853967232082831051469,
        0.1894506104550684962853967232082831051469,
        0.1826034150449235888667636679692199393835,
        0.1826034150449235888667636679692199393835,
        0.1691565193950025381893120790303599622116,
        0.1691565193950025381893120790303599622116,
        0.1495959888165767320815017305474785489704,
        0.1495959888165767320815017305474785489704,
        0.1246289712555338720524762821920164201448,
        0.1246289712555338720524762821920164201448,
        0.0951585116824927848099251076022462263552,
        0.0951585116824927848099251076022462263552,
        0.0622535239386478928628438369943776942749,
        0.0622535239386478928628438369943776942749,
        0.0271524594117540948517805724560181035122,
        0.0271524594117540948517805724560181035122,
    ],
    [
        0.1794464703562065254582656442618856214487,
        0.1765627053669926463252709901131972391509,
        0.1765627053669926463252709901131972391509,
        0.1680041021564500445099706637883231550211,
        0.1680041021564500445099706637883231550211,
        0.1540457610768102880814315948019586119404,
        0.1540457610768102880814315948019586119404,
        0.1351363684685254732863199817023501973721,
        0.1351363684685254732863199817023501973721,
        0.1118838471934039710947883856263559267358,
        0.1118838471934039710947883856263559267358,
        0.0850361483171791808835353701910620738504,
        0.0850361483171791808835353701910620738504,
        0.0554595293739872011294401653582446605128,
        0.0554595293739872011294401653582446605128,
        0.0241483028685479319601100262875653246916,
        0.0241483028685479319601100262875653246916,
    ],
    [
        0.1691423829631435918406564701349866103341,
        0.1691423829631435918406564701349866103341,
        0.1642764837458327229860537764659275904123,
        0.1642764837458327229860537764659275904123,
        0.1546846751262652449254180038363747721932,
        0.1546846751262652449254180038363747721932,
        0.1406429146706506512047313037519472280955,
        0.1406429146706506512047313037519472280955,
        0.1225552067114784601845191268002015552281,
        0.1225552067114784601845191268002015552281,
        0.1009420441062871655628139849248346070628,
        0.1009420441062871655628139849248346070628,
        0.0764257302548890565291296776166365256053,
        0.0764257302548890565291296776166365256053,
        0.0497145488949697964533349462026386416808,
        0.0497145488949697964533349462026386416808,
        0.0216160135264833103133427102664524693876,
        0.0216160135264833103133427102664524693876,
    ],
    [
        0.1610544498487836959791636253209167350399,
        0.1589688433939543476499564394650472016787,
        0.1589688433939543476499564394650472016787,
        0.152766042065859666778855400897662998461,
        0.152766042065859666778855400897662998461,
        0.1426067021736066117757461094419029724756,
        0.1426067021736066117757461094419029724756,
        0.1287539625393362276755157848568771170558,
        0.1287539625393362276755157848568771170558,
        0.1115666455473339947160239016817659974813,
        0.1115666455473339947160239016817659974813,
        0.0914900216224499994644620941238396526609,
        0.0914900216224499994644620941238396526609,
        0.0690445427376412265807082580060130449618,
        0.0690445427376412265807082580060130449618,
        0.0448142267656996003328381574019942119517,
        0.0448142267656996003328381574019942119517,
        0.0194617882297264770363120414644384357529,
        0.0194617882297264770363120414644384357529,
    ],
    [
        0.1527533871307258506980843319550975934919,
        0.1527533871307258506980843319550975934919,
        0.1491729864726037467878287370019694366926,
        0.1491729864726037467878287370019694366926,
        0.1420961093183820513292983250671649330345,
        0.1420961093183820513292983250671649330345,
        0.1316886384491766268984944997481631349161,
        0.1316886384491766268984944997481631349161,
        0.118194531961518417312377377711382287005,
        0.118194531961518417312377377711382287005,
        0.1019301198172404350367501354803498761666,
        0.1019301198172404350367501354803498761666,
        0.0832767415767047487247581432220462061001,
        0.0832767415767047487247581432220462061001,
        0.0626720483341090635695065351870416063516,
        0.0626720483341090635695065351870416063516,
        0.040601429800386941331039952274932109879,
        0.040601429800386941331039952274932109879,
        0.0176140071391521183118619623518528163621,
        0.0176140071391521183118619623518528163621,
    ],
    [
        0.1460811336496904271919851476833711882448,
        0.1445244039899700590638271665537525436099,
        0.1445244039899700590638271665537525436099,
        0.1398873947910731547221334238675831108927,
        0.1398873947910731547221334238675831108927,
        0.132268938633337461781052574496775604329,
        0.132268938633337461781052574496775604329,
        0.1218314160537285341953671771257335983563,
        0.1218314160537285341953671771257335983563,
        0.1087972991671483776634745780701056420336,
        0.1087972991671483776634745780701056420336,
        0.0934444234560338615532897411139320884835,
        0.0934444234560338615532897411139320884835,
        0.0761001136283793020170516533001831792261,
        0.0761001136283793020170516533001831792261,
        0.0571344254268572082836358264724479574912,
        0.0571344254268572082836358264724479574912,
        0.0369537897708524937999506682993296661889,
        0.0369537897708524937999506682993296661889,
        0.0160172282577743333242246168584710152658,
        0.0160172282577743333242246168584710152658,
    ],
    [
        0.1392518728556319933754102483418099578739,
        0.1392518728556319933754102483418099578739,
        0.1365414983460151713525738312315173965863,
        0.1365414983460151713525738312315173965863,
        0.1311735047870623707329649925303074458757,
        0.1311735047870623707329649925303074458757,
        0.1232523768105124242855609861548144719594,
        0.1232523768105124242855609861548144719594,
        0.1129322960805392183934006074217843191142,
        0.1129322960805392183934006074217843191142,
        0.1004141444428809649320788378305362823508,
        0.1004141444428809649320788378305362823508,
        0.0859416062170677274144436813727028661891,
        0.0859416062170677274144436813727028661891,
        0.0697964684245204880949614189302176573987,
        0.0697964684245204880949614189302176573987,
        0.0522933351526832859403120512732112561121,
        0.0522933351526832859403120512732112561121,
        0.0337749015848141547933022468659129013491,
        0.0337749015848141547933022468659129013491,
        0.0146279952982722006849910980471854451902,
        0.0146279952982722006849910980471854451902,
    ],
    [
        0.1336545721861061753514571105458443385831,
        0.132462039404696617371642464703316925805,
        0.132462039404696617371642464703316925805,
        0.1289057221880821499785953393997936532597,
        0.1289057221880821499785953393997936532597,
        0.1230490843067295304675784006720096548158,
        0.1230490843067295304675784006720096548158,
        0.1149966402224113649416435129339613014914,
        0.1149966402224113649416435129339613014914,
        0.1048920914645414100740861850147438548584,
        0.1048920914645414100740861850147438548584,
        0.0929157660600351474770186173697646486034,
        0.0929157660600351474770186173697646486034,
        0.0792814117767189549228925247420432269137,
        0.0792814117767189549228925247420432269137,
        0.0642324214085258521271696151589109980391,
        0.0642324214085258521271696151589109980391,
        0.0480376717310846685716410716320339965612,
        0.0480376717310846685716410716320339965612,
        0.0309880058569794443106942196418845053837,
        0.0309880058569794443106942196418845053837,
        0.0134118594871417720813094934586150649766,
        0.0134118594871417720813094934586150649766,
    ],
    [
        0.1279381953467521569740561652246953718517,
        0.1279381953467521569740561652246953718517,
        0.1258374563468282961213753825111836887264,
        0.1258374563468282961213753825111836887264,
        0.121670472927803391204463153476262425607,
        0.121670472927803391204463153476262425607,
        0.1155056680537256013533444839067835598622,
        0.1155056680537256013533444839067835598622,
        0.1074442701159656347825773424466062227946,
        0.1074442701159656347825773424466062227946,
        0.0976186521041138882698806644642471544279,
        0.0976186521041138882698806644642471544279,
        0.086190161531953275917185202983742667185,
        0.086190161531953275917185202983742667185,
        0.0733464814110803057340336152531165181193,
        0.0733464814110803057340336152531165181193,
        0.0592985849154367807463677585001085845412,
        0.0592985849154367807463677585001085845412,
        0.0442774388174198061686027482113382288593,
        0.0442774388174198061686027482113382288593,
        0.0285313886289336631813078159518782864491,
        0.0285313886289336631813078159518782864491,
        0.0123412297999871995468056670700372915759,
        0.0123412297999871995468056670700372915759,
    ],
];
const binomialCoefficients = [[1], [1, 1], [1, 2, 1], [1, 3, 3, 1]];
const getCubicArcLength = (xs, ys, t) => {
    let sum;
    let correctedT;
    const n = 20;
    const z = t / 2;
    sum = 0;
    for (let i = 0; i < n; i++) {
        correctedT = z * tValues[n][i] + z;
        sum += cValues[n][i] * BFunc(xs, ys, correctedT);
    }
    return z * sum;
};
const getQuadraticArcLength = (xs, ys, t) => {
    if (t === undefined) {
        t = 1;
    }
    const ax = xs[0] - 2 * xs[1] + xs[2];
    const ay = ys[0] - 2 * ys[1] + ys[2];
    const bx = 2 * xs[1] - 2 * xs[0];
    const by = 2 * ys[1] - 2 * ys[0];
    const A = 4 * (ax * ax + ay * ay);
    const B = 4 * (ax * bx + ay * by);
    const C = bx * bx + by * by;
    if (A === 0) {
        return (t * Math.sqrt(Math.pow(xs[2] - xs[0], 2) + Math.pow(ys[2] - ys[0], 2)));
    }
    const b = B / (2 * A);
    const c = C / A;
    const u = t + b;
    const k = c - b * b;
    const uuk = u * u + k > 0 ? Math.sqrt(u * u + k) : 0;
    const bbk = b * b + k > 0 ? Math.sqrt(b * b + k) : 0;
    const term = b + Math.sqrt(b * b + k) !== 0
        ? k * Math.log(Math.abs((u + uuk) / (b + bbk)))
        : 0;
    return (Math.sqrt(A) / 2) * (u * uuk - b * bbk + term);
};
function BFunc(xs, ys, t) {
    const xbase = getDerivative(1, t, xs);
    const ybase = getDerivative(1, t, ys);
    const combined = xbase * xbase + ybase * ybase;
    return Math.sqrt(combined);
}
const getDerivative = (derivative, t, vs) => {
    const n = vs.length - 1;
    let _vs;
    let value;
    if (n === 0) {
        return 0;
    }
    if (derivative === 0) {
        value = 0;
        for (let k = 0; k <= n; k++) {
            value +=
                binomialCoefficients[n][k] *
                    Math.pow(1 - t, n - k) *
                    Math.pow(t, k) *
                    vs[k];
        }
        return value;
    }
    else {
        _vs = new Array(n);
        for (let k = 0; k < n; k++) {
            _vs[k] = n * (vs[k + 1] - vs[k]);
        }
        return getDerivative(derivative - 1, t, _vs);
    }
};
const t2length = (length, totalLength, func) => {
    let error = 1;
    let t = length / totalLength;
    let step = (length - func(t)) / totalLength;
    let numIterations = 0;
    while (error > 0.001) {
        const increasedTLength = func(t + step);
        const increasedTError = Math.abs(length - increasedTLength) / totalLength;
        if (increasedTError < error) {
            error = increasedTError;
            t += step;
        }
        else {
            const decreasedTLength = func(t - step);
            const decreasedTError = Math.abs(length - decreasedTLength) / totalLength;
            if (decreasedTError < error) {
                error = decreasedTError;
                t -= step;
            }
            else {
                step /= 2;
            }
        }
        numIterations++;
        if (numIterations > 500) {
            break;
        }
    }
    return t;
};

class Path extends Shape {
    constructor(config) {
        super(config);
        this.dataArray = [];
        this.pathLength = 0;
        this._readDataAttribute();
        this.on('dataChange.konva', function () {
            this._readDataAttribute();
        });
    }
    _readDataAttribute() {
        this.dataArray = Path.parsePathData(this.data());
        this.pathLength = Path.getPathLength(this.dataArray);
    }
    _sceneFunc(context) {
        const ca = this.dataArray;
        context.beginPath();
        let isClosed = false;
        for (let n = 0; n < ca.length; n++) {
            const c = ca[n].command;
            const p = ca[n].points;
            switch (c) {
                case 'L':
                    context.lineTo(p[0], p[1]);
                    break;
                case 'M':
                    context.moveTo(p[0], p[1]);
                    break;
                case 'C':
                    context.bezierCurveTo(p[0], p[1], p[2], p[3], p[4], p[5]);
                    break;
                case 'Q':
                    context.quadraticCurveTo(p[0], p[1], p[2], p[3]);
                    break;
                case 'A':
                    const cx = p[0], cy = p[1], rx = p[2], ry = p[3], theta = p[4], dTheta = p[5], psi = p[6], fs = p[7];
                    const r = rx > ry ? rx : ry;
                    const scaleX = rx > ry ? 1 : rx / ry;
                    const scaleY = rx > ry ? ry / rx : 1;
                    context.translate(cx, cy);
                    context.rotate(psi);
                    context.scale(scaleX, scaleY);
                    context.arc(0, 0, r, theta, theta + dTheta, 1 - fs);
                    context.scale(1 / scaleX, 1 / scaleY);
                    context.rotate(-psi);
                    context.translate(-cx, -cy);
                    break;
                case 'z':
                    isClosed = true;
                    context.closePath();
                    break;
            }
        }
        if (!isClosed && !this.hasFill()) {
            context.strokeShape(this);
        }
        else {
            context.fillStrokeShape(this);
        }
    }
    getSelfRect() {
        let points = [];
        this.dataArray.forEach(function (data) {
            if (data.command === 'A') {
                const start = data.points[4];
                const dTheta = data.points[5];
                const end = data.points[4] + dTheta;
                let inc = Math.PI / 180.0;
                if (Math.abs(start - end) < inc) {
                    inc = Math.abs(start - end);
                }
                if (dTheta < 0) {
                    for (let t = start - inc; t > end; t -= inc) {
                        const point = Path.getPointOnEllipticalArc(data.points[0], data.points[1], data.points[2], data.points[3], t, 0);
                        points.push(point.x, point.y);
                    }
                }
                else {
                    for (let t = start + inc; t < end; t += inc) {
                        const point = Path.getPointOnEllipticalArc(data.points[0], data.points[1], data.points[2], data.points[3], t, 0);
                        points.push(point.x, point.y);
                    }
                }
            }
            else if (data.command === 'C') {
                for (let t = 0.0; t <= 1; t += 0.01) {
                    const point = Path.getPointOnCubicBezier(t, data.start.x, data.start.y, data.points[0], data.points[1], data.points[2], data.points[3], data.points[4], data.points[5]);
                    points.push(point.x, point.y);
                }
            }
            else {
                points = points.concat(data.points);
            }
        });
        let minX = points[0];
        let maxX = points[0];
        let minY = points[1];
        let maxY = points[1];
        let x, y;
        for (let i = 0; i < points.length / 2; i++) {
            x = points[i * 2];
            y = points[i * 2 + 1];
            if (!isNaN(x)) {
                minX = Math.min(minX, x);
                maxX = Math.max(maxX, x);
            }
            if (!isNaN(y)) {
                minY = Math.min(minY, y);
                maxY = Math.max(maxY, y);
            }
        }
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY,
        };
    }
    getLength() {
        return this.pathLength;
    }
    getPointAtLength(length) {
        return Path.getPointAtLengthOfDataArray(length, this.dataArray);
    }
    static getLineLength(x1, y1, x2, y2) {
        return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    }
    static getPathLength(dataArray) {
        let pathLength = 0;
        for (let i = 0; i < dataArray.length; ++i) {
            pathLength += dataArray[i].pathLength;
        }
        return pathLength;
    }
    static getPointAtLengthOfDataArray(length, dataArray) {
        let points, i = 0, ii = dataArray.length;
        if (!ii) {
            return null;
        }
        while (i < ii && length > dataArray[i].pathLength) {
            length -= dataArray[i].pathLength;
            ++i;
        }
        if (i === ii) {
            points = dataArray[i - 1].points.slice(-2);
            return {
                x: points[0],
                y: points[1],
            };
        }
        if (length < 0.01) {
            const cmd = dataArray[i].command;
            if (cmd === 'M') {
                points = dataArray[i].points.slice(0, 2);
                return {
                    x: points[0],
                    y: points[1],
                };
            }
            else {
                return {
                    x: dataArray[i].start.x,
                    y: dataArray[i].start.y,
                };
            }
        }
        const cp = dataArray[i];
        const p = cp.points;
        switch (cp.command) {
            case 'L':
                return Path.getPointOnLine(length, cp.start.x, cp.start.y, p[0], p[1]);
            case 'C':
                return Path.getPointOnCubicBezier(t2length(length, Path.getPathLength(dataArray), (i) => {
                    return getCubicArcLength([cp.start.x, p[0], p[2], p[4]], [cp.start.y, p[1], p[3], p[5]], i);
                }), cp.start.x, cp.start.y, p[0], p[1], p[2], p[3], p[4], p[5]);
            case 'Q':
                return Path.getPointOnQuadraticBezier(t2length(length, Path.getPathLength(dataArray), (i) => {
                    return getQuadraticArcLength([cp.start.x, p[0], p[2]], [cp.start.y, p[1], p[3]], i);
                }), cp.start.x, cp.start.y, p[0], p[1], p[2], p[3]);
            case 'A':
                const cx = p[0], cy = p[1], rx = p[2], ry = p[3], dTheta = p[5], psi = p[6];
                let theta = p[4];
                theta += (dTheta * length) / cp.pathLength;
                return Path.getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi);
        }
        return null;
    }
    static getPointOnLine(dist, P1x, P1y, P2x, P2y, fromX, fromY) {
        fromX = fromX !== null && fromX !== void 0 ? fromX : P1x;
        fromY = fromY !== null && fromY !== void 0 ? fromY : P1y;
        const len = this.getLineLength(P1x, P1y, P2x, P2y);
        if (len < 1e-10) {
            return { x: P1x, y: P1y };
        }
        if (P2x === P1x) {
            return { x: fromX, y: fromY + (P2y > P1y ? dist : -dist) };
        }
        const m = (P2y - P1y) / (P2x - P1x);
        const run = Math.sqrt((dist * dist) / (1 + m * m)) * (P2x < P1x ? -1 : 1);
        const rise = m * run;
        if (Math.abs(fromY - P1y - m * (fromX - P1x)) < 1e-10) {
            return { x: fromX + run, y: fromY + rise };
        }
        const u = ((fromX - P1x) * (P2x - P1x) + (fromY - P1y) * (P2y - P1y)) / (len * len);
        const ix = P1x + u * (P2x - P1x);
        const iy = P1y + u * (P2y - P1y);
        const pRise = this.getLineLength(fromX, fromY, ix, iy);
        const pRun = Math.sqrt(dist * dist - pRise * pRise);
        const adjustedRun = Math.sqrt((pRun * pRun) / (1 + m * m)) * (P2x < P1x ? -1 : 1);
        const adjustedRise = m * adjustedRun;
        return { x: ix + adjustedRun, y: iy + adjustedRise };
    }
    static getPointOnCubicBezier(pct, P1x, P1y, P2x, P2y, P3x, P3y, P4x, P4y) {
        function CB1(t) {
            return t * t * t;
        }
        function CB2(t) {
            return 3 * t * t * (1 - t);
        }
        function CB3(t) {
            return 3 * t * (1 - t) * (1 - t);
        }
        function CB4(t) {
            return (1 - t) * (1 - t) * (1 - t);
        }
        const x = P4x * CB1(pct) + P3x * CB2(pct) + P2x * CB3(pct) + P1x * CB4(pct);
        const y = P4y * CB1(pct) + P3y * CB2(pct) + P2y * CB3(pct) + P1y * CB4(pct);
        return { x, y };
    }
    static getPointOnQuadraticBezier(pct, P1x, P1y, P2x, P2y, P3x, P3y) {
        function QB1(t) {
            return t * t;
        }
        function QB2(t) {
            return 2 * t * (1 - t);
        }
        function QB3(t) {
            return (1 - t) * (1 - t);
        }
        const x = P3x * QB1(pct) + P2x * QB2(pct) + P1x * QB3(pct);
        const y = P3y * QB1(pct) + P2y * QB2(pct) + P1y * QB3(pct);
        return { x, y };
    }
    static getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi) {
        const cosPsi = Math.cos(psi), sinPsi = Math.sin(psi);
        const pt = {
            x: rx * Math.cos(theta),
            y: ry * Math.sin(theta),
        };
        return {
            x: cx + (pt.x * cosPsi - pt.y * sinPsi),
            y: cy + (pt.x * sinPsi + pt.y * cosPsi),
        };
    }
    static parsePathData(data) {
        if (!data) {
            return [];
        }
        let cs = data;
        const cc = [
            'm',
            'M',
            'l',
            'L',
            'v',
            'V',
            'h',
            'H',
            'z',
            'Z',
            'c',
            'C',
            'q',
            'Q',
            't',
            'T',
            's',
            'S',
            'a',
            'A',
        ];
        cs = cs.replace(new RegExp(' ', 'g'), ',');
        for (let n = 0; n < cc.length; n++) {
            cs = cs.replace(new RegExp(cc[n], 'g'), '|' + cc[n]);
        }
        const arr = cs.split('|');
        const ca = [];
        const coords = [];
        let cpx = 0;
        let cpy = 0;
        const re = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:e[-+]?\d+)?)/gi;
        let match;
        for (let n = 1; n < arr.length; n++) {
            let str = arr[n];
            let c = str.charAt(0);
            str = str.slice(1);
            coords.length = 0;
            while ((match = re.exec(str))) {
                coords.push(match[0]);
            }
            let p = [];
            let arcParamIndex = c === 'A' || c === 'a' ? 0 : -1;
            for (let j = 0, jlen = coords.length; j < jlen; j++) {
                const token = coords[j];
                if (token === '00') {
                    p.push(0, 0);
                    if (arcParamIndex >= 0) {
                        arcParamIndex += 2;
                        if (arcParamIndex >= 7)
                            arcParamIndex -= 7;
                    }
                    continue;
                }
                if (arcParamIndex >= 0) {
                    if (arcParamIndex === 3) {
                        if (/^[01]{2}\d+(?:\.\d+)?$/.test(token)) {
                            p.push(parseInt(token[0], 10));
                            p.push(parseInt(token[1], 10));
                            p.push(parseFloat(token.slice(2)));
                            arcParamIndex += 3;
                            if (arcParamIndex >= 7)
                                arcParamIndex -= 7;
                            continue;
                        }
                        if (token === '11' || token === '10' || token === '01') {
                            p.push(parseInt(token[0], 10));
                            p.push(parseInt(token[1], 10));
                            arcParamIndex += 2;
                            if (arcParamIndex >= 7)
                                arcParamIndex -= 7;
                            continue;
                        }
                        if (token === '0' || token === '1') {
                            p.push(parseInt(token, 10));
                            arcParamIndex += 1;
                            if (arcParamIndex >= 7)
                                arcParamIndex -= 7;
                            continue;
                        }
                    }
                    else if (arcParamIndex === 4) {
                        if (/^[01]\d+(?:\.\d+)?$/.test(token)) {
                            p.push(parseInt(token[0], 10));
                            p.push(parseFloat(token.slice(1)));
                            arcParamIndex += 2;
                            if (arcParamIndex >= 7)
                                arcParamIndex -= 7;
                            continue;
                        }
                        if (token === '0' || token === '1') {
                            p.push(parseInt(token, 10));
                            arcParamIndex += 1;
                            if (arcParamIndex >= 7)
                                arcParamIndex -= 7;
                            continue;
                        }
                    }
                    const parsedArc = parseFloat(token);
                    if (!isNaN(parsedArc)) {
                        p.push(parsedArc);
                    }
                    else {
                        p.push(0);
                    }
                    arcParamIndex += 1;
                    if (arcParamIndex >= 7)
                        arcParamIndex -= 7;
                }
                else {
                    const parsed = parseFloat(token);
                    if (!isNaN(parsed)) {
                        p.push(parsed);
                    }
                    else {
                        p.push(0);
                    }
                }
            }
            while (p.length > 0) {
                if (isNaN(p[0])) {
                    break;
                }
                let cmd = '';
                let points = [];
                const startX = cpx, startY = cpy;
                let prevCmd, ctlPtx, ctlPty;
                let rx, ry, psi, fa, fs, x1, y1;
                switch (c) {
                    case 'l':
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'L':
                        cpx = p.shift();
                        cpy = p.shift();
                        points.push(cpx, cpy);
                        break;
                    case 'm':
                        const dx = p.shift();
                        const dy = p.shift();
                        cpx += dx;
                        cpy += dy;
                        cmd = 'M';
                        if (ca.length > 2 && ca[ca.length - 1].command === 'z') {
                            for (let idx = ca.length - 2; idx >= 0; idx--) {
                                if (ca[idx].command === 'M') {
                                    cpx = ca[idx].points[0] + dx;
                                    cpy = ca[idx].points[1] + dy;
                                    break;
                                }
                            }
                        }
                        points.push(cpx, cpy);
                        c = 'l';
                        break;
                    case 'M':
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = 'M';
                        points.push(cpx, cpy);
                        c = 'L';
                        break;
                    case 'h':
                        cpx += p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'H':
                        cpx = p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'v':
                        cpy += p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'V':
                        cpy = p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'C':
                        points.push(p.shift(), p.shift(), p.shift(), p.shift());
                        cpx = p.shift();
                        cpy = p.shift();
                        points.push(cpx, cpy);
                        break;
                    case 'c':
                        points.push(cpx + p.shift(), cpy + p.shift(), cpx + p.shift(), cpy + p.shift());
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'C';
                        points.push(cpx, cpy);
                        break;
                    case 'S':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === 'C') {
                            ctlPtx = cpx + (cpx - prevCmd.points[2]);
                            ctlPty = cpy + (cpy - prevCmd.points[3]);
                        }
                        points.push(ctlPtx, ctlPty, p.shift(), p.shift());
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = 'C';
                        points.push(cpx, cpy);
                        break;
                    case 's':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === 'C') {
                            ctlPtx = cpx + (cpx - prevCmd.points[2]);
                            ctlPty = cpy + (cpy - prevCmd.points[3]);
                        }
                        points.push(ctlPtx, ctlPty, cpx + p.shift(), cpy + p.shift());
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'C';
                        points.push(cpx, cpy);
                        break;
                    case 'Q':
                        points.push(p.shift(), p.shift());
                        cpx = p.shift();
                        cpy = p.shift();
                        points.push(cpx, cpy);
                        break;
                    case 'q':
                        points.push(cpx + p.shift(), cpy + p.shift());
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'Q';
                        points.push(cpx, cpy);
                        break;
                    case 'T':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === 'Q') {
                            ctlPtx = cpx + (cpx - prevCmd.points[0]);
                            ctlPty = cpy + (cpy - prevCmd.points[1]);
                        }
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = 'Q';
                        points.push(ctlPtx, ctlPty, cpx, cpy);
                        break;
                    case 't':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === 'Q') {
                            ctlPtx = cpx + (cpx - prevCmd.points[0]);
                            ctlPty = cpy + (cpy - prevCmd.points[1]);
                        }
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'Q';
                        points.push(ctlPtx, ctlPty, cpx, cpy);
                        break;
                    case 'A':
                        rx = p.shift();
                        ry = p.shift();
                        psi = p.shift();
                        fa = p.shift();
                        fs = p.shift();
                        x1 = cpx;
                        y1 = cpy;
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = 'A';
                        points = this.convertEndpointToCenterParameterization(x1, y1, cpx, cpy, fa, fs, rx, ry, psi);
                        break;
                    case 'a':
                        rx = p.shift();
                        ry = p.shift();
                        psi = p.shift();
                        fa = p.shift();
                        fs = p.shift();
                        x1 = cpx;
                        y1 = cpy;
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'A';
                        points = this.convertEndpointToCenterParameterization(x1, y1, cpx, cpy, fa, fs, rx, ry, psi);
                        break;
                }
                ca.push({
                    command: cmd || c,
                    points: points,
                    start: {
                        x: startX,
                        y: startY,
                    },
                    pathLength: this.calcLength(startX, startY, cmd || c, points),
                });
            }
            if (c === 'z' || c === 'Z') {
                ca.push({
                    command: 'z',
                    points: [],
                    start: undefined,
                    pathLength: 0,
                });
            }
        }
        return ca;
    }
    static calcLength(x, y, cmd, points) {
        let len, p1, p2, t;
        const path = Path;
        switch (cmd) {
            case 'L':
                return path.getLineLength(x, y, points[0], points[1]);
            case 'C':
                return getCubicArcLength([x, points[0], points[2], points[4]], [y, points[1], points[3], points[5]], 1);
            case 'Q':
                return getQuadraticArcLength([x, points[0], points[2]], [y, points[1], points[3]], 1);
            case 'A':
                len = 0.0;
                const start = points[4];
                const dTheta = points[5];
                const end = points[4] + dTheta;
                let inc = Math.PI / 180.0;
                if (Math.abs(start - end) < inc) {
                    inc = Math.abs(start - end);
                }
                p1 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], start, 0);
                if (dTheta < 0) {
                    for (t = start - inc; t > end; t -= inc) {
                        p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
                        len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                        p1 = p2;
                    }
                }
                else {
                    for (t = start + inc; t < end; t += inc) {
                        p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
                        len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                        p1 = p2;
                    }
                }
                p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], end, 0);
                len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                return len;
        }
        return 0;
    }
    static convertEndpointToCenterParameterization(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg) {
        const psi = psiDeg * (Math.PI / 180.0);
        const xp = (Math.cos(psi) * (x1 - x2)) / 2.0 + (Math.sin(psi) * (y1 - y2)) / 2.0;
        const yp = (-1 * Math.sin(psi) * (x1 - x2)) / 2.0 +
            (Math.cos(psi) * (y1 - y2)) / 2.0;
        const lambda = (xp * xp) / (rx * rx) + (yp * yp) / (ry * ry);
        if (lambda > 1) {
            rx *= Math.sqrt(lambda);
            ry *= Math.sqrt(lambda);
        }
        let f = Math.sqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) /
            (rx * rx * (yp * yp) + ry * ry * (xp * xp)));
        if (fa === fs) {
            f *= -1;
        }
        if (isNaN(f)) {
            f = 0;
        }
        const cxp = (f * rx * yp) / ry;
        const cyp = (f * -ry * xp) / rx;
        const cx = (x1 + x2) / 2.0 + Math.cos(psi) * cxp - Math.sin(psi) * cyp;
        const cy = (y1 + y2) / 2.0 + Math.sin(psi) * cxp + Math.cos(psi) * cyp;
        const vMag = function (v) {
            return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
        };
        const vRatio = function (u, v) {
            return (u[0] * v[0] + u[1] * v[1]) / (vMag(u) * vMag(v));
        };
        const vAngle = function (u, v) {
            return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos(vRatio(u, v));
        };
        const theta = vAngle([1, 0], [(xp - cxp) / rx, (yp - cyp) / ry]);
        const u = [(xp - cxp) / rx, (yp - cyp) / ry];
        const v = [(-1 * xp - cxp) / rx, (-1 * yp - cyp) / ry];
        let dTheta = vAngle(u, v);
        if (vRatio(u, v) <= -1) {
            dTheta = Math.PI;
        }
        if (vRatio(u, v) >= 1) {
            dTheta = 0;
        }
        if (fs === 0 && dTheta > 0) {
            dTheta = dTheta - 2 * Math.PI;
        }
        if (fs === 1 && dTheta < 0) {
            dTheta = dTheta + 2 * Math.PI;
        }
        return [cx, cy, rx, ry, theta, dTheta, psi, fs];
    }
}
Path.prototype.className = 'Path';
Path.prototype._attrsAffectingSize = ['data'];
_registerNode(Path);
Factory.addGetterSetter(Path, 'data');

let Arrow$1 = class Arrow extends Line$1 {
    _sceneFunc(ctx) {
        super._sceneFunc(ctx);
        const PI2 = Math.PI * 2;
        const points = this.points();
        let tp = points;
        const fromTension = this.tension() !== 0 && points.length > 4;
        if (fromTension) {
            tp = this.getTensionPoints();
        }
        const length = this.pointerLength();
        const n = points.length;
        let dx, dy;
        if (fromTension) {
            const lp = [
                tp[tp.length - 4],
                tp[tp.length - 3],
                tp[tp.length - 2],
                tp[tp.length - 1],
                points[n - 2],
                points[n - 1],
            ];
            const lastLength = Path.calcLength(tp[tp.length - 4], tp[tp.length - 3], 'C', lp);
            const previous = Path.getPointOnQuadraticBezier(Math.min(1, 1 - length / lastLength), lp[0], lp[1], lp[2], lp[3], lp[4], lp[5]);
            dx = points[n - 2] - previous.x;
            dy = points[n - 1] - previous.y;
        }
        else {
            dx = points[n - 2] - points[n - 4];
            dy = points[n - 1] - points[n - 3];
        }
        const radians = (Math.atan2(dy, dx) + PI2) % PI2;
        const width = this.pointerWidth();
        if (this.pointerAtEnding()) {
            ctx.save();
            ctx.beginPath();
            ctx.translate(points[n - 2], points[n - 1]);
            ctx.rotate(radians);
            ctx.moveTo(0, 0);
            ctx.lineTo(-length, width / 2);
            ctx.lineTo(-length, -width / 2);
            ctx.closePath();
            ctx.restore();
            this.__fillStroke(ctx);
        }
        if (this.pointerAtBeginning()) {
            ctx.save();
            ctx.beginPath();
            ctx.translate(points[0], points[1]);
            if (fromTension) {
                dx = (tp[0] + tp[2]) / 2 - points[0];
                dy = (tp[1] + tp[3]) / 2 - points[1];
            }
            else {
                dx = points[2] - points[0];
                dy = points[3] - points[1];
            }
            ctx.rotate((Math.atan2(-dy, -dx) + PI2) % PI2);
            ctx.moveTo(0, 0);
            ctx.lineTo(-length, width / 2);
            ctx.lineTo(-length, -width / 2);
            ctx.closePath();
            ctx.restore();
            this.__fillStroke(ctx);
        }
    }
    __fillStroke(ctx) {
        const isDashEnabled = this.dashEnabled();
        if (isDashEnabled) {
            this.attrs.dashEnabled = false;
            ctx.setLineDash([]);
        }
        ctx.fillStrokeShape(this);
        if (isDashEnabled) {
            this.attrs.dashEnabled = true;
        }
    }
    getSelfRect() {
        const lineRect = super.getSelfRect();
        const offset = this.pointerWidth() / 2;
        return {
            x: lineRect.x,
            y: lineRect.y - offset,
            width: lineRect.width,
            height: lineRect.height + offset * 2,
        };
    }
};
Arrow$1.prototype.className = 'Arrow';
_registerNode(Arrow$1);
Factory.addGetterSetter(Arrow$1, 'pointerLength', 10, getNumberValidator());
Factory.addGetterSetter(Arrow$1, 'pointerWidth', 10, getNumberValidator());
Factory.addGetterSetter(Arrow$1, 'pointerAtBeginning', false);
Factory.addGetterSetter(Arrow$1, 'pointerAtEnding', true);

let Circle$1 = class Circle extends Shape {
    _sceneFunc(context) {
        context.beginPath();
        context.arc(0, 0, this.attrs.radius || 0, 0, Math.PI * 2, false);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.radius() * 2;
    }
    getHeight() {
        return this.radius() * 2;
    }
    setWidth(width) {
        if (this.radius() !== width / 2) {
            this.radius(width / 2);
        }
    }
    setHeight(height) {
        if (this.radius() !== height / 2) {
            this.radius(height / 2);
        }
    }
};
Circle$1.prototype._centroid = true;
Circle$1.prototype.className = 'Circle';
Circle$1.prototype._attrsAffectingSize = ['radius'];
_registerNode(Circle$1);
Factory.addGetterSetter(Circle$1, 'radius', 0, getNumberValidator());

class Ellipse extends Shape {
    _sceneFunc(context) {
        const rx = this.radiusX(), ry = this.radiusY();
        context.beginPath();
        context.save();
        if (rx !== ry) {
            context.scale(1, ry / rx);
        }
        context.arc(0, 0, rx, 0, Math.PI * 2, false);
        context.restore();
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.radiusX() * 2;
    }
    getHeight() {
        return this.radiusY() * 2;
    }
    setWidth(width) {
        this.radiusX(width / 2);
    }
    setHeight(height) {
        this.radiusY(height / 2);
    }
}
Ellipse.prototype.className = 'Ellipse';
Ellipse.prototype._centroid = true;
Ellipse.prototype._attrsAffectingSize = ['radiusX', 'radiusY'];
_registerNode(Ellipse);
Factory.addComponentsGetterSetter(Ellipse, 'radius', ['x', 'y']);
Factory.addGetterSetter(Ellipse, 'radiusX', 0, getNumberValidator());
Factory.addGetterSetter(Ellipse, 'radiusY', 0, getNumberValidator());

let Image$2 = class Image extends Shape {
    constructor(attrs) {
        super(attrs);
        this._loadListener = () => {
            this._requestDraw();
        };
        this.on('imageChange.konva', (props) => {
            this._removeImageLoad(props.oldVal);
            this._setImageLoad();
        });
        this._setImageLoad();
    }
    _setImageLoad() {
        const image = this.image();
        if (image && image.complete) {
            return;
        }
        if (image && image.readyState === 4) {
            return;
        }
        if (image && image['addEventListener']) {
            image['addEventListener']('load', this._loadListener);
        }
    }
    _removeImageLoad(image) {
        if (image && image['removeEventListener']) {
            image['removeEventListener']('load', this._loadListener);
        }
    }
    destroy() {
        this._removeImageLoad(this.image());
        super.destroy();
        return this;
    }
    _useBufferCanvas() {
        const hasCornerRadius = !!this.cornerRadius();
        const hasShadow = this.hasShadow();
        if (hasCornerRadius && hasShadow) {
            return true;
        }
        return super._useBufferCanvas(true);
    }
    _sceneFunc(context) {
        const width = this.getWidth();
        const height = this.getHeight();
        const cornerRadius = this.cornerRadius();
        const image = this.attrs.image;
        let params;
        if (image) {
            const cropWidth = this.attrs.cropWidth;
            const cropHeight = this.attrs.cropHeight;
            if (cropWidth && cropHeight) {
                params = [
                    image,
                    this.cropX(),
                    this.cropY(),
                    cropWidth,
                    cropHeight,
                    0,
                    0,
                    width,
                    height,
                ];
            }
            else {
                params = [image, 0, 0, width, height];
            }
        }
        if (this.hasFill() || this.hasStroke() || cornerRadius) {
            context.beginPath();
            cornerRadius
                ? Util.drawRoundedRectPath(context, width, height, cornerRadius)
                : context.rect(0, 0, width, height);
            context.closePath();
            context.fillStrokeShape(this);
        }
        if (image) {
            if (cornerRadius) {
                context.clip();
            }
            context.drawImage.apply(context, params);
        }
    }
    _hitFunc(context) {
        const width = this.width(), height = this.height(), cornerRadius = this.cornerRadius();
        context.beginPath();
        if (!cornerRadius) {
            context.rect(0, 0, width, height);
        }
        else {
            Util.drawRoundedRectPath(context, width, height, cornerRadius);
        }
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        var _a, _b, _c;
        return (_c = (_a = this.attrs.width) !== null && _a !== void 0 ? _a : (_b = this.image()) === null || _b === void 0 ? void 0 : _b.width) !== null && _c !== void 0 ? _c : 0;
    }
    getHeight() {
        var _a, _b, _c;
        return (_c = (_a = this.attrs.height) !== null && _a !== void 0 ? _a : (_b = this.image()) === null || _b === void 0 ? void 0 : _b.height) !== null && _c !== void 0 ? _c : 0;
    }
    static fromURL(url, callback, onError = null) {
        const img = Util.createImageElement();
        img.onload = function () {
            const image = new Image({
                image: img,
            });
            callback(image);
        };
        img.onerror = onError;
        img.crossOrigin = 'Anonymous';
        img.src = url;
    }
};
Image$2.prototype.className = 'Image';
Image$2.prototype._attrsAffectingSize = ['image'];
_registerNode(Image$2);
Factory.addGetterSetter(Image$2, 'cornerRadius', 0, getNumberOrArrayOfNumbersValidator(4));
Factory.addGetterSetter(Image$2, 'image');
Factory.addComponentsGetterSetter(Image$2, 'crop', ['x', 'y', 'width', 'height']);
Factory.addGetterSetter(Image$2, 'cropX', 0, getNumberValidator());
Factory.addGetterSetter(Image$2, 'cropY', 0, getNumberValidator());
Factory.addGetterSetter(Image$2, 'cropWidth', 0, getNumberValidator());
Factory.addGetterSetter(Image$2, 'cropHeight', 0, getNumberValidator());

const ATTR_CHANGE_LIST$2 = [
    'fontFamily',
    'fontSize',
    'fontStyle',
    'padding',
    'lineHeight',
    'text',
    'width',
    'height',
    'pointerDirection',
    'pointerWidth',
    'pointerHeight',
], CHANGE_KONVA$1 = 'Change.konva', NONE$1 = 'none', UP = 'up', RIGHT$1 = 'right', DOWN = 'down', LEFT$1 = 'left', attrChangeListLen$1 = ATTR_CHANGE_LIST$2.length;
let Label$1 = class Label extends Group$1 {
    constructor(config) {
        super(config);
        this.on('add.konva', function (evt) {
            this._addListeners(evt.child);
            this._sync();
        });
    }
    getText() {
        return this.find('Text')[0];
    }
    getTag() {
        return this.find('Tag')[0];
    }
    _addListeners(text) {
        let that = this, n;
        const func = function () {
            that._sync();
        };
        for (n = 0; n < attrChangeListLen$1; n++) {
            text.on(ATTR_CHANGE_LIST$2[n] + CHANGE_KONVA$1, func);
        }
    }
    getWidth() {
        return this.getText().width();
    }
    getHeight() {
        return this.getText().height();
    }
    _sync() {
        let text = this.getText(), tag = this.getTag(), width, height, pointerDirection, pointerWidth, x, y, pointerHeight;
        if (text && tag) {
            width = text.width();
            height = text.height();
            pointerDirection = tag.pointerDirection();
            pointerWidth = tag.pointerWidth();
            pointerHeight = tag.pointerHeight();
            x = 0;
            y = 0;
            switch (pointerDirection) {
                case UP:
                    x = width / 2;
                    y = -1 * pointerHeight;
                    break;
                case RIGHT$1:
                    x = width + pointerWidth;
                    y = height / 2;
                    break;
                case DOWN:
                    x = width / 2;
                    y = height + pointerHeight;
                    break;
                case LEFT$1:
                    x = -1 * pointerWidth;
                    y = height / 2;
                    break;
            }
            tag.setAttrs({
                x: -1 * x,
                y: -1 * y,
                width: width,
                height: height,
            });
            text.setAttrs({
                x: -1 * x,
                y: -1 * y,
            });
        }
    }
};
Label$1.prototype.className = 'Label';
_registerNode(Label$1);
class Tag extends Shape {
    _sceneFunc(context) {
        const width = this.width(), height = this.height(), pointerDirection = this.pointerDirection(), pointerWidth = this.pointerWidth(), pointerHeight = this.pointerHeight(), cornerRadius = this.cornerRadius();
        let topLeft = 0;
        let topRight = 0;
        let bottomLeft = 0;
        let bottomRight = 0;
        if (typeof cornerRadius === 'number') {
            topLeft =
                topRight =
                    bottomLeft =
                        bottomRight =
                            Math.min(cornerRadius, width / 2, height / 2);
        }
        else {
            topLeft = Math.min(cornerRadius[0] || 0, width / 2, height / 2);
            topRight = Math.min(cornerRadius[1] || 0, width / 2, height / 2);
            bottomRight = Math.min(cornerRadius[2] || 0, width / 2, height / 2);
            bottomLeft = Math.min(cornerRadius[3] || 0, width / 2, height / 2);
        }
        context.beginPath();
        context.moveTo(topLeft, 0);
        if (pointerDirection === UP) {
            context.lineTo((width - pointerWidth) / 2, 0);
            context.lineTo(width / 2, -1 * pointerHeight);
            context.lineTo((width + pointerWidth) / 2, 0);
        }
        context.lineTo(width - topRight, 0);
        context.arc(width - topRight, topRight, topRight, (Math.PI * 3) / 2, 0, false);
        if (pointerDirection === RIGHT$1) {
            context.lineTo(width, (height - pointerHeight) / 2);
            context.lineTo(width + pointerWidth, height / 2);
            context.lineTo(width, (height + pointerHeight) / 2);
        }
        context.lineTo(width, height - bottomRight);
        context.arc(width - bottomRight, height - bottomRight, bottomRight, 0, Math.PI / 2, false);
        if (pointerDirection === DOWN) {
            context.lineTo((width + pointerWidth) / 2, height);
            context.lineTo(width / 2, height + pointerHeight);
            context.lineTo((width - pointerWidth) / 2, height);
        }
        context.lineTo(bottomLeft, height);
        context.arc(bottomLeft, height - bottomLeft, bottomLeft, Math.PI / 2, Math.PI, false);
        if (pointerDirection === LEFT$1) {
            context.lineTo(0, (height + pointerHeight) / 2);
            context.lineTo(-1 * pointerWidth, height / 2);
            context.lineTo(0, (height - pointerHeight) / 2);
        }
        context.lineTo(0, topLeft);
        context.arc(topLeft, topLeft, topLeft, Math.PI, (Math.PI * 3) / 2, false);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getSelfRect() {
        let x = 0, y = 0, pointerWidth = this.pointerWidth(), pointerHeight = this.pointerHeight(), direction = this.pointerDirection(), width = this.width(), height = this.height();
        if (direction === UP) {
            y -= pointerHeight;
            height += pointerHeight;
        }
        else if (direction === DOWN) {
            height += pointerHeight;
        }
        else if (direction === LEFT$1) {
            x -= pointerWidth * 1.5;
            width += pointerWidth;
        }
        else if (direction === RIGHT$1) {
            width += pointerWidth * 1.5;
        }
        return {
            x: x,
            y: y,
            width: width,
            height: height,
        };
    }
}
Tag.prototype.className = 'Tag';
_registerNode(Tag);
Factory.addGetterSetter(Tag, 'pointerDirection', NONE$1);
Factory.addGetterSetter(Tag, 'pointerWidth', 0, getNumberValidator());
Factory.addGetterSetter(Tag, 'pointerHeight', 0, getNumberValidator());
Factory.addGetterSetter(Tag, 'cornerRadius', 0, getNumberOrArrayOfNumbersValidator(4));

let Rect$1 = class Rect extends Shape {
    _sceneFunc(context) {
        const cornerRadius = this.cornerRadius(), width = this.width(), height = this.height();
        context.beginPath();
        if (!cornerRadius) {
            context.rect(0, 0, width, height);
        }
        else {
            Util.drawRoundedRectPath(context, width, height, cornerRadius);
        }
        context.closePath();
        context.fillStrokeShape(this);
    }
};
Rect$1.prototype.className = 'Rect';
_registerNode(Rect$1);
Factory.addGetterSetter(Rect$1, 'cornerRadius', 0, getNumberOrArrayOfNumbersValidator(4));

class RegularPolygon extends Shape {
    _sceneFunc(context) {
        const points = this._getPoints(), radius = this.radius(), sides = this.sides(), cornerRadius = this.cornerRadius();
        context.beginPath();
        if (!cornerRadius) {
            context.moveTo(points[0].x, points[0].y);
            for (let n = 1; n < points.length; n++) {
                context.lineTo(points[n].x, points[n].y);
            }
        }
        else {
            Util.drawRoundedPolygonPath(context, points, sides, radius, cornerRadius);
        }
        context.closePath();
        context.fillStrokeShape(this);
    }
    _getPoints() {
        const sides = this.attrs.sides;
        const radius = this.attrs.radius || 0;
        const points = [];
        for (let n = 0; n < sides; n++) {
            points.push({
                x: radius * Math.sin((n * 2 * Math.PI) / sides),
                y: -1 * radius * Math.cos((n * 2 * Math.PI) / sides),
            });
        }
        return points;
    }
    getSelfRect() {
        const points = this._getPoints();
        let minX = points[0].x;
        let maxX = points[0].x;
        let minY = points[0].y;
        let maxY = points[0].y;
        points.forEach((point) => {
            minX = Math.min(minX, point.x);
            maxX = Math.max(maxX, point.x);
            minY = Math.min(minY, point.y);
            maxY = Math.max(maxY, point.y);
        });
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY,
        };
    }
    getWidth() {
        return this.radius() * 2;
    }
    getHeight() {
        return this.radius() * 2;
    }
    setWidth(width) {
        this.radius(width / 2);
    }
    setHeight(height) {
        this.radius(height / 2);
    }
}
RegularPolygon.prototype.className = 'RegularPolygon';
RegularPolygon.prototype._centroid = true;
RegularPolygon.prototype._attrsAffectingSize = ['radius'];
_registerNode(RegularPolygon);
Factory.addGetterSetter(RegularPolygon, 'radius', 0, getNumberValidator());
Factory.addGetterSetter(RegularPolygon, 'sides', 0, getNumberValidator());
Factory.addGetterSetter(RegularPolygon, 'cornerRadius', 0, getNumberOrArrayOfNumbersValidator(4));

const PIx2 = Math.PI * 2;
class Ring extends Shape {
    _sceneFunc(context) {
        context.beginPath();
        context.arc(0, 0, this.innerRadius(), 0, PIx2, false);
        context.moveTo(this.outerRadius(), 0);
        context.arc(0, 0, this.outerRadius(), PIx2, 0, true);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.outerRadius() * 2;
    }
    getHeight() {
        return this.outerRadius() * 2;
    }
    setWidth(width) {
        this.outerRadius(width / 2);
    }
    setHeight(height) {
        this.outerRadius(height / 2);
    }
}
Ring.prototype.className = 'Ring';
Ring.prototype._centroid = true;
Ring.prototype._attrsAffectingSize = ['innerRadius', 'outerRadius'];
_registerNode(Ring);
Factory.addGetterSetter(Ring, 'innerRadius', 0, getNumberValidator());
Factory.addGetterSetter(Ring, 'outerRadius', 0, getNumberValidator());

class Sprite extends Shape {
    constructor(config) {
        super(config);
        this._updated = true;
        this.anim = new Animation(() => {
            const updated = this._updated;
            this._updated = false;
            return updated;
        });
        this.on('animationChange.konva', function () {
            this.frameIndex(0);
        });
        this.on('frameIndexChange.konva', function () {
            this._updated = true;
        });
        this.on('frameRateChange.konva', function () {
            if (!this.anim.isRunning()) {
                return;
            }
            clearInterval(this.interval);
            this._setInterval();
        });
    }
    _sceneFunc(context) {
        const anim = this.animation(), index = this.frameIndex(), ix4 = index * 4, set = this.animations()[anim], offsets = this.frameOffsets(), x = set[ix4 + 0], y = set[ix4 + 1], width = set[ix4 + 2], height = set[ix4 + 3], image = this.image();
        if (this.hasFill() || this.hasStroke()) {
            context.beginPath();
            context.rect(0, 0, width, height);
            context.closePath();
            context.fillStrokeShape(this);
        }
        if (image) {
            if (offsets) {
                const offset = offsets[anim], ix2 = index * 2;
                context.drawImage(image, x, y, width, height, offset[ix2 + 0], offset[ix2 + 1], width, height);
            }
            else {
                context.drawImage(image, x, y, width, height, 0, 0, width, height);
            }
        }
    }
    _hitFunc(context) {
        const anim = this.animation(), index = this.frameIndex(), ix4 = index * 4, set = this.animations()[anim], offsets = this.frameOffsets(), width = set[ix4 + 2], height = set[ix4 + 3];
        context.beginPath();
        if (offsets) {
            const offset = offsets[anim];
            const ix2 = index * 2;
            context.rect(offset[ix2 + 0], offset[ix2 + 1], width, height);
        }
        else {
            context.rect(0, 0, width, height);
        }
        context.closePath();
        context.fillShape(this);
    }
    _useBufferCanvas() {
        return super._useBufferCanvas(true);
    }
    _setInterval() {
        const that = this;
        this.interval = setInterval(function () {
            that._updateIndex();
        }, 1000 / this.frameRate());
    }
    start() {
        if (this.isRunning()) {
            return;
        }
        const layer = this.getLayer();
        this.anim.setLayers(layer);
        this._setInterval();
        this.anim.start();
    }
    stop() {
        this.anim.stop();
        clearInterval(this.interval);
    }
    isRunning() {
        return this.anim.isRunning();
    }
    _updateIndex() {
        const index = this.frameIndex(), animation = this.animation(), animations = this.animations(), anim = animations[animation], len = anim.length / 4;
        if (index < len - 1) {
            this.frameIndex(index + 1);
        }
        else {
            this.frameIndex(0);
        }
    }
}
Sprite.prototype.className = 'Sprite';
_registerNode(Sprite);
Factory.addGetterSetter(Sprite, 'animation');
Factory.addGetterSetter(Sprite, 'animations');
Factory.addGetterSetter(Sprite, 'frameOffsets');
Factory.addGetterSetter(Sprite, 'image');
Factory.addGetterSetter(Sprite, 'frameIndex', 0, getNumberValidator());
Factory.addGetterSetter(Sprite, 'frameRate', 17, getNumberValidator());
Factory.backCompat(Sprite, {
    index: 'frameIndex',
    getIndex: 'getFrameIndex',
    setIndex: 'setFrameIndex',
});

class Star extends Shape {
    _sceneFunc(context) {
        const innerRadius = this.innerRadius(), outerRadius = this.outerRadius(), numPoints = this.numPoints();
        context.beginPath();
        context.moveTo(0, 0 - outerRadius);
        for (let n = 1; n < numPoints * 2; n++) {
            const radius = n % 2 === 0 ? outerRadius : innerRadius;
            const x = radius * Math.sin((n * Math.PI) / numPoints);
            const y = -1 * radius * Math.cos((n * Math.PI) / numPoints);
            context.lineTo(x, y);
        }
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.outerRadius() * 2;
    }
    getHeight() {
        return this.outerRadius() * 2;
    }
    setWidth(width) {
        this.outerRadius(width / 2);
    }
    setHeight(height) {
        this.outerRadius(height / 2);
    }
}
Star.prototype.className = 'Star';
Star.prototype._centroid = true;
Star.prototype._attrsAffectingSize = ['innerRadius', 'outerRadius'];
_registerNode(Star);
Factory.addGetterSetter(Star, 'numPoints', 5, getNumberValidator());
Factory.addGetterSetter(Star, 'innerRadius', 0, getNumberValidator());
Factory.addGetterSetter(Star, 'outerRadius', 0, getNumberValidator());

function stringToArray(string) {
    return [...string].reduce((acc, char, index, array) => {
        if (/\p{Emoji}/u.test(char)) {
            const nextChar = array[index + 1];
            if (nextChar && /\p{Emoji_Modifier}|\u200D/u.test(nextChar)) {
                acc.push(char + nextChar);
                array[index + 1] = '';
            }
            else {
                acc.push(char);
            }
        }
        else if (/\p{Regional_Indicator}{2}/u.test(char + (array[index + 1] || ''))) {
            acc.push(char + array[index + 1]);
        }
        else if (index > 0 && /\p{Mn}|\p{Me}|\p{Mc}/u.test(char)) {
            acc[acc.length - 1] += char;
        }
        else if (char) {
            acc.push(char);
        }
        return acc;
    }, []);
}
const AUTO = 'auto', CENTER = 'center', INHERIT = 'inherit', JUSTIFY = 'justify', CHANGE_KONVA = 'Change.konva', CONTEXT_2D = '2d', DASH = '-', LEFT = 'left', TEXT = 'text', TEXT_UPPER = 'Text', TOP = 'top', BOTTOM = 'bottom', MIDDLE = 'middle', NORMAL$1 = 'normal', PX_SPACE = 'px ', SPACE = ' ', RIGHT = 'right', RTL = 'rtl', WORD = 'word', CHAR = 'char', NONE = 'none', ELLIPSIS = '…', ATTR_CHANGE_LIST$1 = [
    'direction',
    'fontFamily',
    'fontSize',
    'fontStyle',
    'fontVariant',
    'padding',
    'align',
    'verticalAlign',
    'lineHeight',
    'text',
    'width',
    'height',
    'wrap',
    'ellipsis',
    'letterSpacing',
], attrChangeListLen = ATTR_CHANGE_LIST$1.length;
let _shadowOpacityBuggy = null;
function hasShadowOpacityBug() {
    if (_shadowOpacityBuggy !== null) {
        return _shadowOpacityBuggy;
    }
    _shadowOpacityBuggy = false;
    try {
        const c = document.createElement('canvas');
        c.width = 10;
        c.height = 10;
        const ctx = c.getContext(CONTEXT_2D);
        if (ctx) {
            ctx.globalAlpha = 0;
            ctx.shadowColor = 'black';
            ctx.shadowBlur = 5;
            ctx.shadowOffsetX = 5;
            ctx.shadowOffsetY = 5;
            ctx.fillStyle = 'black';
            ctx.font = '10px Arial';
            ctx.fillText('X', 0, 10);
            const data = ctx.getImageData(0, 0, 10, 10).data;
            for (let i = 3; i < data.length; i += 4) {
                if (data[i] > 0) {
                    _shadowOpacityBuggy = true;
                    break;
                }
            }
        }
    }
    catch (e) {
    }
    return _shadowOpacityBuggy;
}
function normalizeFontFamily(fontFamily) {
    return fontFamily
        .split(',')
        .map((family) => {
        family = family.trim();
        const hasSpace = family.indexOf(' ') >= 0;
        const hasQuotes = family.indexOf('"') >= 0 || family.indexOf("'") >= 0;
        if (hasSpace && !hasQuotes) {
            family = `"${family}"`;
        }
        return family;
    })
        .join(', ');
}
let dummyContext;
function getDummyContext() {
    if (dummyContext) {
        return dummyContext;
    }
    dummyContext = Util.createCanvasElement().getContext(CONTEXT_2D);
    return dummyContext;
}
function _fillFunc$1(context) {
    context.fillText(this._partialText, this._partialTextX, this._partialTextY);
}
function _strokeFunc$1(context) {
    context.setAttr('miterLimit', 2);
    context.strokeText(this._partialText, this._partialTextX, this._partialTextY);
}
function checkDefaultFill(config) {
    config = config || {};
    if (!config.fillLinearGradientColorStops &&
        !config.fillRadialGradientColorStops &&
        !config.fillPatternImage) {
        config.fill = config.fill || 'black';
    }
    return config;
}
let Text$1 = class Text extends Shape {
    constructor(config) {
        super(checkDefaultFill(config));
        this._partialTextX = 0;
        this._partialTextY = 0;
        for (let n = 0; n < attrChangeListLen; n++) {
            this.on(ATTR_CHANGE_LIST$1[n] + CHANGE_KONVA, this._setTextData);
        }
        this._setTextData();
    }
    _sceneFunc(context) {
        var _a, _b;
        const textArr = this.textArr, textArrLen = textArr.length;
        if (!this.text()) {
            return;
        }
        let padding = this.padding(), fontSize = this.fontSize(), lineHeightPx = this.lineHeight() * fontSize, verticalAlign = this.verticalAlign(), direction = this.direction(), alignY = 0, align = this.align(), totalWidth = this.getWidth(), letterSpacing = this.letterSpacing(), charRenderFunc = this.charRenderFunc(), fill = this.fill(), textDecoration = this.textDecoration(), underlineOffset = this.underlineOffset(), shouldUnderline = textDecoration.indexOf('underline') !== -1, shouldLineThrough = textDecoration.indexOf('line-through') !== -1, n;
        direction = direction === INHERIT ? context.direction : direction;
        let translateY = lineHeightPx / 2;
        let baseline = MIDDLE;
        if (!Konva$1.legacyTextRendering) {
            const metrics = this.measureSize('M');
            baseline = 'alphabetic';
            const ascent = (_a = metrics.fontBoundingBoxAscent) !== null && _a !== void 0 ? _a : metrics.actualBoundingBoxAscent;
            const descent = (_b = metrics.fontBoundingBoxDescent) !== null && _b !== void 0 ? _b : metrics.actualBoundingBoxDescent;
            translateY = (ascent - descent) / 2 + lineHeightPx / 2;
        }
        if (direction === RTL) {
            context.setAttr('direction', direction);
        }
        context.setAttr('font', this._getContextFont());
        context.setAttr('textBaseline', baseline);
        context.setAttr('textAlign', LEFT);
        if (verticalAlign === MIDDLE) {
            alignY = (this.getHeight() - textArrLen * lineHeightPx - padding * 2) / 2;
        }
        else if (verticalAlign === BOTTOM) {
            alignY = this.getHeight() - textArrLen * lineHeightPx - padding * 2;
        }
        context.translate(padding, alignY + padding);
        for (n = 0; n < textArrLen; n++) {
            let lineTranslateX = 0;
            let lineTranslateY = 0;
            const obj = textArr[n], text = obj.text, width = obj.width, lastLine = obj.lastInParagraph;
            context.save();
            if (align === RIGHT) {
                lineTranslateX += totalWidth - width - padding * 2;
            }
            else if (align === CENTER) {
                lineTranslateX += (totalWidth - width - padding * 2) / 2;
            }
            if (shouldUnderline) {
                context.save();
                context.beginPath();
                const yOffset = underlineOffset !== null && underlineOffset !== void 0 ? underlineOffset : (!Konva$1.legacyTextRendering
                    ? Math.round(fontSize / 4)
                    : Math.round(fontSize / 2));
                const x = lineTranslateX;
                const y = translateY + lineTranslateY + yOffset;
                context.moveTo(x, y);
                const lineWidth = align === JUSTIFY && !lastLine ? totalWidth - padding * 2 : width;
                context.lineTo(x + Math.round(lineWidth), y);
                context.lineWidth = fontSize / 15;
                const gradient = this._getLinearGradient();
                context.strokeStyle = gradient || fill;
                context.stroke();
                context.restore();
            }
            const lineThroughStartX = lineTranslateX;
            if (direction !== RTL &&
                (letterSpacing !== 0 || align === JUSTIFY || charRenderFunc)) {
                const spacesNumber = text.split(' ').length - 1;
                const array = stringToArray(text);
                for (let li = 0; li < array.length; li++) {
                    const letter = array[li];
                    if (letter === ' ' && !lastLine && align === JUSTIFY) {
                        lineTranslateX += (totalWidth - padding * 2 - width) / spacesNumber;
                    }
                    this._partialTextX = lineTranslateX;
                    this._partialTextY = translateY + lineTranslateY;
                    this._partialText = letter;
                    if (charRenderFunc) {
                        context.save();
                        const previousLines = textArr.slice(0, n);
                        const previousGraphemes = previousLines.reduce((acc, line) => acc + stringToArray(line.text).length, 0);
                        const charIndex = li + previousGraphemes;
                        charRenderFunc({
                            char: letter,
                            index: charIndex,
                            x: lineTranslateX,
                            y: translateY + lineTranslateY,
                            lineIndex: n,
                            column: li,
                            isLastInLine: lastLine,
                            width: this.measureSize(letter).width,
                            context,
                        });
                    }
                    context.fillStrokeShape(this);
                    if (charRenderFunc) {
                        context.restore();
                    }
                    lineTranslateX += this.measureSize(letter).width + letterSpacing;
                }
            }
            else {
                if (letterSpacing !== 0) {
                    context.setAttr('letterSpacing', `${letterSpacing}px`);
                }
                this._partialTextX = lineTranslateX;
                this._partialTextY = translateY + lineTranslateY;
                this._partialText = text;
                context.fillStrokeShape(this);
            }
            if (shouldLineThrough) {
                context.save();
                context.beginPath();
                const yOffset = !Konva$1.legacyTextRendering
                    ? -Math.round(fontSize / 4)
                    : 0;
                const x = lineThroughStartX;
                context.moveTo(x, translateY + lineTranslateY + yOffset);
                const lineWidth = align === JUSTIFY && !lastLine ? totalWidth - padding * 2 : width;
                context.lineTo(x + Math.round(lineWidth), translateY + lineTranslateY + yOffset);
                context.lineWidth = fontSize / 15;
                const gradient = this._getLinearGradient();
                context.strokeStyle = gradient || fill;
                context.stroke();
                context.restore();
            }
            context.restore();
            if (textArrLen > 1) {
                translateY += lineHeightPx;
            }
        }
    }
    _hitFunc(context) {
        const width = this.getWidth(), height = this.getHeight();
        context.beginPath();
        context.rect(0, 0, width, height);
        context.closePath();
        context.fillStrokeShape(this);
    }
    setText(text) {
        const str = Util._isString(text)
            ? text
            : text === null || text === undefined
                ? ''
                : text + '';
        this._setAttr(TEXT, str);
        return this;
    }
    getWidth() {
        const isAuto = this.attrs.width === AUTO || this.attrs.width === undefined;
        return isAuto ? this.getTextWidth() + this.padding() * 2 : this.attrs.width;
    }
    getHeight() {
        const isAuto = this.attrs.height === AUTO || this.attrs.height === undefined;
        return isAuto
            ? this.fontSize() * this.textArr.length * this.lineHeight() +
                this.padding() * 2
            : this.attrs.height;
    }
    getTextWidth() {
        return this.textWidth;
    }
    getTextHeight() {
        Util.warn('text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height.');
        return this.textHeight;
    }
    measureSize(text) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        let _context = getDummyContext(), fontSize = this.fontSize(), metrics;
        _context.save();
        _context.font = this._getContextFont();
        metrics = _context.measureText(text);
        _context.restore();
        const scaleFactor = fontSize / 100;
        return {
            actualBoundingBoxAscent: (_a = metrics.actualBoundingBoxAscent) !== null && _a !== void 0 ? _a : 71.58203125 * scaleFactor,
            actualBoundingBoxDescent: (_b = metrics.actualBoundingBoxDescent) !== null && _b !== void 0 ? _b : 0,
            actualBoundingBoxLeft: (_c = metrics.actualBoundingBoxLeft) !== null && _c !== void 0 ? _c : -7.421875 * scaleFactor,
            actualBoundingBoxRight: (_d = metrics.actualBoundingBoxRight) !== null && _d !== void 0 ? _d : 75.732421875 * scaleFactor,
            alphabeticBaseline: (_e = metrics.alphabeticBaseline) !== null && _e !== void 0 ? _e : 0,
            emHeightAscent: (_f = metrics.emHeightAscent) !== null && _f !== void 0 ? _f : 100 * scaleFactor,
            emHeightDescent: (_g = metrics.emHeightDescent) !== null && _g !== void 0 ? _g : -20 * scaleFactor,
            fontBoundingBoxAscent: (_h = metrics.fontBoundingBoxAscent) !== null && _h !== void 0 ? _h : 91 * scaleFactor,
            fontBoundingBoxDescent: (_j = metrics.fontBoundingBoxDescent) !== null && _j !== void 0 ? _j : 21 * scaleFactor,
            hangingBaseline: (_k = metrics.hangingBaseline) !== null && _k !== void 0 ? _k : 72.80000305175781 * scaleFactor,
            ideographicBaseline: (_l = metrics.ideographicBaseline) !== null && _l !== void 0 ? _l : -21 * scaleFactor,
            width: metrics.width,
            height: fontSize,
        };
    }
    _getContextFont() {
        return (this.fontStyle() +
            SPACE +
            this.fontVariant() +
            SPACE +
            (this.fontSize() + PX_SPACE) +
            normalizeFontFamily(this.fontFamily()));
    }
    _addTextLine(line) {
        const align = this.align();
        if (align === JUSTIFY) {
            line = line.trim();
        }
        const width = this._getTextWidth(line);
        return this.textArr.push({
            text: line,
            width: width,
            lastInParagraph: false,
        });
    }
    _getTextWidth(text) {
        const letterSpacing = this.letterSpacing();
        const length = text.length;
        return getDummyContext().measureText(text).width + letterSpacing * length;
    }
    _setTextData() {
        let lines = this.text().split('\n'), fontSize = +this.fontSize(), textWidth = 0, lineHeightPx = this.lineHeight() * fontSize, width = this.attrs.width, height = this.attrs.height, fixedWidth = width !== AUTO && width !== undefined, fixedHeight = height !== AUTO && height !== undefined, padding = this.padding(), maxWidth = width - padding * 2, maxHeightPx = height - padding * 2, currentHeightPx = 0, wrap = this.wrap(), shouldWrap = wrap !== NONE, wrapAtWord = wrap !== CHAR && shouldWrap, shouldAddEllipsis = this.ellipsis();
        this.textArr = [];
        getDummyContext().font = this._getContextFont();
        const additionalWidth = shouldAddEllipsis
            ? this._getTextWidth(ELLIPSIS)
            : 0;
        for (let i = 0, max = lines.length; i < max; ++i) {
            let line = lines[i];
            let lineWidth = this._getTextWidth(line);
            if (fixedWidth && lineWidth > maxWidth) {
                while (line.length > 0) {
                    let low = 0, high = stringToArray(line).length, match = '', matchWidth = 0;
                    while (low < high) {
                        const mid = (low + high) >>> 1, lineArray = stringToArray(line), substr = lineArray.slice(0, mid + 1).join(''), substrWidth = this._getTextWidth(substr);
                        const shouldConsiderEllipsis = shouldAddEllipsis &&
                            fixedHeight &&
                            currentHeightPx + lineHeightPx > maxHeightPx;
                        const effectiveWidth = shouldConsiderEllipsis
                            ? substrWidth + additionalWidth
                            : substrWidth;
                        if (effectiveWidth <= maxWidth) {
                            low = mid + 1;
                            match = substr;
                            matchWidth = substrWidth;
                        }
                        else {
                            high = mid;
                        }
                    }
                    if (match) {
                        if (wrapAtWord) {
                            const lineArray = stringToArray(line);
                            const matchArray = stringToArray(match);
                            const nextChar = lineArray[matchArray.length];
                            const nextIsSpaceOrDash = nextChar === SPACE || nextChar === DASH;
                            let wrapIndex;
                            if (nextIsSpaceOrDash && matchWidth <= maxWidth) {
                                wrapIndex = matchArray.length;
                            }
                            else {
                                const lastSpaceIndex = matchArray.lastIndexOf(SPACE);
                                const lastDashIndex = matchArray.lastIndexOf(DASH);
                                wrapIndex = Math.max(lastSpaceIndex, lastDashIndex) + 1;
                            }
                            if (wrapIndex > 0) {
                                low = wrapIndex;
                                match = lineArray.slice(0, low).join('');
                                matchWidth = this._getTextWidth(match);
                            }
                        }
                        match = match.trimRight();
                        this._addTextLine(match);
                        textWidth = Math.max(textWidth, matchWidth);
                        currentHeightPx += lineHeightPx;
                        const shouldHandleEllipsis = this._shouldHandleEllipsis(currentHeightPx);
                        if (shouldHandleEllipsis) {
                            this._tryToAddEllipsisToLastLine();
                            break;
                        }
                        const lineArray = stringToArray(line);
                        line = lineArray.slice(low).join('').trimLeft();
                        if (line.length > 0) {
                            lineWidth = this._getTextWidth(line);
                            if (lineWidth <= maxWidth) {
                                this._addTextLine(line);
                                currentHeightPx += lineHeightPx;
                                textWidth = Math.max(textWidth, lineWidth);
                                break;
                            }
                        }
                    }
                    else {
                        break;
                    }
                }
            }
            else {
                this._addTextLine(line);
                currentHeightPx += lineHeightPx;
                textWidth = Math.max(textWidth, lineWidth);
                if (this._shouldHandleEllipsis(currentHeightPx) && i < max - 1) {
                    this._tryToAddEllipsisToLastLine();
                }
            }
            if (this.textArr[this.textArr.length - 1]) {
                this.textArr[this.textArr.length - 1].lastInParagraph = true;
            }
            if (fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx) {
                break;
            }
        }
        this.textHeight = fontSize;
        this.textWidth = textWidth;
    }
    _shouldHandleEllipsis(currentHeightPx) {
        const fontSize = +this.fontSize(), lineHeightPx = this.lineHeight() * fontSize, height = this.attrs.height, fixedHeight = height !== AUTO && height !== undefined, padding = this.padding(), maxHeightPx = height - padding * 2, wrap = this.wrap(), shouldWrap = wrap !== NONE;
        return (!shouldWrap ||
            (fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx));
    }
    _tryToAddEllipsisToLastLine() {
        const width = this.attrs.width, fixedWidth = width !== AUTO && width !== undefined, padding = this.padding(), maxWidth = width - padding * 2, shouldAddEllipsis = this.ellipsis();
        const lastLine = this.textArr[this.textArr.length - 1];
        if (!lastLine || !shouldAddEllipsis) {
            return;
        }
        if (fixedWidth) {
            const haveSpace = this._getTextWidth(lastLine.text + ELLIPSIS) < maxWidth;
            if (!haveSpace) {
                lastLine.text = lastLine.text.slice(0, lastLine.text.length - 3);
            }
        }
        this.textArr.splice(this.textArr.length - 1, 1);
        this._addTextLine(lastLine.text + ELLIPSIS);
    }
    getStrokeScaleEnabled() {
        return true;
    }
    _useBufferCanvas() {
        const hasLine = this.textDecoration().indexOf('underline') !== -1 ||
            this.textDecoration().indexOf('line-through') !== -1;
        const hasShadow = this.hasShadow();
        if (hasLine && hasShadow) {
            return true;
        }
        if (hasShadow && this.getAbsoluteOpacity() !== 1 && hasShadowOpacityBug()) {
            return true;
        }
        return super._useBufferCanvas();
    }
};
Text$1.prototype._fillFunc = _fillFunc$1;
Text$1.prototype._strokeFunc = _strokeFunc$1;
Text$1.prototype.className = TEXT_UPPER;
Text$1.prototype._attrsAffectingSize = [
    'text',
    'fontSize',
    'padding',
    'wrap',
    'lineHeight',
    'letterSpacing',
];
_registerNode(Text$1);
Factory.overWriteSetter(Text$1, 'width', getNumberOrAutoValidator());
Factory.overWriteSetter(Text$1, 'height', getNumberOrAutoValidator());
Factory.addGetterSetter(Text$1, 'direction', INHERIT);
Factory.addGetterSetter(Text$1, 'fontFamily', 'Arial');
Factory.addGetterSetter(Text$1, 'fontSize', 12, getNumberValidator());
Factory.addGetterSetter(Text$1, 'fontStyle', NORMAL$1);
Factory.addGetterSetter(Text$1, 'fontVariant', NORMAL$1);
Factory.addGetterSetter(Text$1, 'padding', 0, getNumberValidator());
Factory.addGetterSetter(Text$1, 'align', LEFT);
Factory.addGetterSetter(Text$1, 'verticalAlign', TOP);
Factory.addGetterSetter(Text$1, 'lineHeight', 1, getNumberValidator());
Factory.addGetterSetter(Text$1, 'wrap', WORD);
Factory.addGetterSetter(Text$1, 'ellipsis', false, getBooleanValidator());
Factory.addGetterSetter(Text$1, 'letterSpacing', 0, getNumberValidator());
Factory.addGetterSetter(Text$1, 'text', '', getStringValidator());
Factory.addGetterSetter(Text$1, 'textDecoration', '');
Factory.addGetterSetter(Text$1, 'underlineOffset', undefined, getNumberValidator());
Factory.addGetterSetter(Text$1, 'charRenderFunc', undefined);

const EMPTY_STRING = '', NORMAL = 'normal';
function _fillFunc(context) {
    context.fillText(this.partialText, 0, 0);
}
function _strokeFunc(context) {
    context.strokeText(this.partialText, 0, 0);
}
class TextPath extends Shape {
    constructor(config) {
        super(config);
        this.dummyCanvas = Util.createCanvasElement();
        this.dataArray = [];
        this._readDataAttribute();
        this.on('dataChange.konva', function () {
            this._readDataAttribute();
            this._setTextData();
        });
        this.on('textChange.konva alignChange.konva letterSpacingChange.konva kerningFuncChange.konva fontSizeChange.konva fontFamilyChange.konva directionChange.konva', this._setTextData);
        this._setTextData();
    }
    _getTextPathLength() {
        return Path.getPathLength(this.dataArray);
    }
    _getPointAtLength(length) {
        if (!this.attrs.data) {
            return null;
        }
        const totalLength = this.pathLength;
        if (length > totalLength) {
            return null;
        }
        return Path.getPointAtLengthOfDataArray(length, this.dataArray);
    }
    _readDataAttribute() {
        this.dataArray = Path.parsePathData(this.attrs.data);
        this.pathLength = this._getTextPathLength();
    }
    _sceneFunc(context) {
        context.setAttr('font', this._getContextFont());
        context.setAttr('textBaseline', this.textBaseline());
        context.setAttr('textAlign', 'left');
        context.save();
        const textDecoration = this.textDecoration();
        const fill = this.fill();
        const fontSize = this.fontSize();
        const glyphInfo = this.glyphInfo;
        const hasUnderline = textDecoration.indexOf('underline') !== -1;
        const hasLineThrough = textDecoration.indexOf('line-through') !== -1;
        if (hasUnderline) {
            context.beginPath();
        }
        for (let i = 0; i < glyphInfo.length; i++) {
            context.save();
            const p0 = glyphInfo[i].p0;
            context.translate(p0.x, p0.y);
            context.rotate(glyphInfo[i].rotation);
            this.partialText = glyphInfo[i].text;
            context.fillStrokeShape(this);
            if (hasUnderline) {
                if (i === 0) {
                    context.moveTo(0, fontSize / 2 + 1);
                }
                context.lineTo(glyphInfo[i].width, fontSize / 2 + 1);
            }
            context.restore();
        }
        if (hasUnderline) {
            context.strokeStyle = fill;
            context.lineWidth = fontSize / 20;
            context.stroke();
        }
        if (hasLineThrough) {
            context.beginPath();
            for (let i = 0; i < glyphInfo.length; i++) {
                context.save();
                const p0 = glyphInfo[i].p0;
                context.translate(p0.x, p0.y);
                context.rotate(glyphInfo[i].rotation);
                if (i === 0) {
                    context.moveTo(0, 0);
                }
                context.lineTo(glyphInfo[i].width, 0);
                context.restore();
            }
            context.strokeStyle = fill;
            context.lineWidth = fontSize / 20;
            context.stroke();
        }
        context.restore();
    }
    _hitFunc(context) {
        context.beginPath();
        const glyphInfo = this.glyphInfo;
        if (glyphInfo.length >= 1) {
            const p0 = glyphInfo[0].p0;
            context.moveTo(p0.x, p0.y);
        }
        for (let i = 0; i < glyphInfo.length; i++) {
            const p1 = glyphInfo[i].p1;
            context.lineTo(p1.x, p1.y);
        }
        context.setAttr('lineWidth', this.fontSize());
        context.setAttr('strokeStyle', this.colorKey);
        context.stroke();
    }
    getTextWidth() {
        return this.textWidth;
    }
    getTextHeight() {
        Util.warn('text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height.');
        return this.textHeight;
    }
    setText(text) {
        return Text$1.prototype.setText.call(this, text);
    }
    _getContextFont() {
        return Text$1.prototype._getContextFont.call(this);
    }
    _getTextSize(text) {
        const dummyCanvas = this.dummyCanvas;
        const _context = dummyCanvas.getContext('2d');
        _context.save();
        _context.font = this._getContextFont();
        const metrics = _context.measureText(text);
        _context.restore();
        return {
            width: metrics.width,
            height: parseInt(`${this.fontSize()}`, 10),
        };
    }
    _setTextData() {
        const charArr = stringToArray(this.text());
        if (this.direction() === 'rtl') {
            charArr.reverse();
        }
        const chars = [];
        let width = 0;
        for (let i = 0; i < charArr.length; i++) {
            chars.push({
                char: charArr[i],
                width: this._getTextSize(charArr[i]).width,
            });
            width += chars[i].width;
        }
        const { width: fullTextWidth, height } = this._getTextSize(this.attrs.text);
        this.textWidth = width;
        this.textHeight = height;
        this.glyphInfo = [];
        if (!this.attrs.data) {
            return null;
        }
        const letterSpacing = this.letterSpacing();
        const align = this.align();
        const kerningFunc = this.kerningFunc();
        const kerningAdjustment = Math.max(0, width - fullTextWidth);
        const textWidth = Math.max(this.textWidth + ((this.attrs.text || '').length - 1) * letterSpacing, 0);
        let offset = 0;
        if (align === 'center') {
            offset = Math.max(0, this.pathLength / 2 - textWidth / 2);
        }
        if (align === 'right') {
            offset = Math.max(0, this.pathLength - textWidth);
        }
        let offsetToGlyph = offset;
        for (let i = 0; i < chars.length; i++) {
            const charStartPoint = this._getPointAtLength(offsetToGlyph);
            if (!charStartPoint)
                return;
            const char = chars[i].char;
            let glyphWidth = chars[i].width + letterSpacing;
            if (char === ' ' && align === 'justify') {
                const numberOfSpaces = this.text().split(' ').length - 1;
                glyphWidth += (this.pathLength - textWidth) / numberOfSpaces;
            }
            const charEndLength = offsetToGlyph + glyphWidth;
            const charEndPoint = this._getPointAtLength(charEndLength > this.pathLength &&
                charEndLength - this.pathLength <= kerningAdjustment
                ? this.pathLength
                : charEndLength);
            if (!charEndPoint) {
                return;
            }
            const width = Path.getLineLength(charStartPoint.x, charStartPoint.y, charEndPoint.x, charEndPoint.y);
            let kern = 0;
            if (kerningFunc) {
                try {
                    kern = kerningFunc(chars[i - 1].char, char) * this.fontSize();
                }
                catch (e) {
                    kern = 0;
                }
            }
            charStartPoint.x += kern;
            charEndPoint.x += kern;
            this.textWidth += kern;
            const midpoint = Path.getPointOnLine(kern + width / 2.0, charStartPoint.x, charStartPoint.y, charEndPoint.x, charEndPoint.y);
            const rotation = Math.atan2(charEndPoint.y - charStartPoint.y, charEndPoint.x - charStartPoint.x);
            this.glyphInfo.push({
                transposeX: midpoint.x,
                transposeY: midpoint.y,
                text: charArr[i],
                rotation: rotation,
                p0: charStartPoint,
                p1: charEndPoint,
                width: width,
            });
            offsetToGlyph += glyphWidth;
        }
    }
    getSelfRect() {
        if (!this.glyphInfo.length) {
            return {
                x: 0,
                y: 0,
                width: 0,
                height: 0,
            };
        }
        const points = [];
        this.glyphInfo.forEach(function (info) {
            points.push(info.p0.x);
            points.push(info.p0.y);
            points.push(info.p1.x);
            points.push(info.p1.y);
        });
        let minX = points[0] || 0;
        let maxX = points[0] || 0;
        let minY = points[1] || 0;
        let maxY = points[1] || 0;
        let x, y;
        for (let i = 0; i < points.length / 2; i++) {
            x = points[i * 2];
            y = points[i * 2 + 1];
            minX = Math.min(minX, x);
            maxX = Math.max(maxX, x);
            minY = Math.min(minY, y);
            maxY = Math.max(maxY, y);
        }
        const fontSize = this.fontSize();
        return {
            x: minX - fontSize / 2,
            y: minY - fontSize / 2,
            width: maxX - minX + fontSize,
            height: maxY - minY + fontSize,
        };
    }
    destroy() {
        Util.releaseCanvas(this.dummyCanvas);
        return super.destroy();
    }
}
TextPath.prototype._fillFunc = _fillFunc;
TextPath.prototype._strokeFunc = _strokeFunc;
TextPath.prototype._fillFuncHit = _fillFunc;
TextPath.prototype._strokeFuncHit = _strokeFunc;
TextPath.prototype.className = 'TextPath';
TextPath.prototype._attrsAffectingSize = ['text', 'fontSize', 'data'];
_registerNode(TextPath);
Factory.addGetterSetter(TextPath, 'data');
Factory.addGetterSetter(TextPath, 'fontFamily', 'Arial');
Factory.addGetterSetter(TextPath, 'fontSize', 12, getNumberValidator());
Factory.addGetterSetter(TextPath, 'fontStyle', NORMAL);
Factory.addGetterSetter(TextPath, 'align', 'left');
Factory.addGetterSetter(TextPath, 'letterSpacing', 0, getNumberValidator());
Factory.addGetterSetter(TextPath, 'textBaseline', 'middle');
Factory.addGetterSetter(TextPath, 'fontVariant', NORMAL);
Factory.addGetterSetter(TextPath, 'text', EMPTY_STRING);
Factory.addGetterSetter(TextPath, 'textDecoration', '');
Factory.addGetterSetter(TextPath, 'kerningFunc', undefined);
Factory.addGetterSetter(TextPath, 'direction', 'inherit');

const EVENTS_NAME = 'tr-konva';
const ATTR_CHANGE_LIST = [
    'resizeEnabledChange',
    'rotateAnchorOffsetChange',
    'rotateAnchorAngleChange',
    'rotateEnabledChange',
    'enabledAnchorsChange',
    'anchorSizeChange',
    'borderEnabledChange',
    'borderStrokeChange',
    'borderStrokeWidthChange',
    'borderDashChange',
    'anchorStrokeChange',
    'anchorStrokeWidthChange',
    'anchorFillChange',
    'anchorCornerRadiusChange',
    'ignoreStrokeChange',
    'anchorStyleFuncChange',
]
    .map((e) => e + `.${EVENTS_NAME}`)
    .join(' ');
const NODES_RECT = 'nodesRect';
const TRANSFORM_CHANGE_STR = [
    'widthChange',
    'heightChange',
    'scaleXChange',
    'scaleYChange',
    'skewXChange',
    'skewYChange',
    'rotationChange',
    'offsetXChange',
    'offsetYChange',
    'transformsEnabledChange',
    'strokeWidthChange',
    'draggableChange',
];
const ANGLES = {
    'top-left': -45,
    'top-center': 0,
    'top-right': 45,
    'middle-right': -90,
    'middle-left': 90,
    'bottom-left': -135,
    'bottom-center': 180,
    'bottom-right': 135,
};
const TOUCH_DEVICE = 'ontouchstart' in Konva$1._global;
function getCursor(anchorName, rad, rotateCursor) {
    if (anchorName === 'rotater') {
        return rotateCursor;
    }
    rad += Util.degToRad(ANGLES[anchorName] || 0);
    const angle = ((Util.radToDeg(rad) % 360) + 360) % 360;
    if (Util._inRange(angle, 315 + 22.5, 360) || Util._inRange(angle, 0, 22.5)) {
        return 'ns-resize';
    }
    else if (Util._inRange(angle, 45 - 22.5, 45 + 22.5)) {
        return 'nesw-resize';
    }
    else if (Util._inRange(angle, 90 - 22.5, 90 + 22.5)) {
        return 'ew-resize';
    }
    else if (Util._inRange(angle, 135 - 22.5, 135 + 22.5)) {
        return 'nwse-resize';
    }
    else if (Util._inRange(angle, 180 - 22.5, 180 + 22.5)) {
        return 'ns-resize';
    }
    else if (Util._inRange(angle, 225 - 22.5, 225 + 22.5)) {
        return 'nesw-resize';
    }
    else if (Util._inRange(angle, 270 - 22.5, 270 + 22.5)) {
        return 'ew-resize';
    }
    else if (Util._inRange(angle, 315 - 22.5, 315 + 22.5)) {
        return 'nwse-resize';
    }
    else {
        Util.error('Transformer has unknown angle for cursor detection: ' + angle);
        return 'pointer';
    }
}
const ANCHORS_NAMES = [
    'top-left',
    'top-center',
    'top-right',
    'middle-right',
    'middle-left',
    'bottom-left',
    'bottom-center',
    'bottom-right',
];
function getCenter(shape) {
    return {
        x: shape.x +
            (shape.width / 2) * Math.cos(shape.rotation) +
            (shape.height / 2) * Math.sin(-shape.rotation),
        y: shape.y +
            (shape.height / 2) * Math.cos(shape.rotation) +
            (shape.width / 2) * Math.sin(shape.rotation),
    };
}
function rotateAroundPoint(shape, angleRad, point) {
    const x = point.x +
        (shape.x - point.x) * Math.cos(angleRad) -
        (shape.y - point.y) * Math.sin(angleRad);
    const y = point.y +
        (shape.x - point.x) * Math.sin(angleRad) +
        (shape.y - point.y) * Math.cos(angleRad);
    return {
        ...shape,
        rotation: shape.rotation + angleRad,
        x,
        y,
    };
}
function rotateAroundCenter(shape, deltaRad) {
    const center = getCenter(shape);
    return rotateAroundPoint(shape, deltaRad, center);
}
function getSnap(snaps, newRotationRad, tol) {
    let snapped = newRotationRad;
    for (let i = 0; i < snaps.length; i++) {
        const angle = Konva$1.getAngle(snaps[i]);
        const absDiff = Math.abs(angle - newRotationRad) % (Math.PI * 2);
        const dif = Math.min(absDiff, Math.PI * 2 - absDiff);
        if (dif < tol) {
            snapped = angle;
        }
    }
    return snapped;
}
let activeTransformersCount = 0;
class Transformer extends Group$1 {
    constructor(config) {
        super(config);
        this._movingAnchorName = null;
        this._transforming = false;
        this._elementsCreated = false;
        this._createElements();
        this._handleMouseMove = this._handleMouseMove.bind(this);
        this._handleMouseUp = this._handleMouseUp.bind(this);
        this.update = this.update.bind(this);
        this.on(ATTR_CHANGE_LIST, this.update);
        if (this.getNode()) {
            this.update();
        }
    }
    attachTo(node) {
        this.setNode(node);
        return this;
    }
    setNode(node) {
        Util.warn('tr.setNode(shape), tr.node(shape) and tr.attachTo(shape) methods are deprecated. Please use tr.nodes(nodesArray) instead.');
        return this.setNodes([node]);
    }
    getNode() {
        return this._nodes && this._nodes[0];
    }
    _getEventNamespace() {
        return EVENTS_NAME + this._id;
    }
    setNodes(nodes = []) {
        if (this._nodes && this._nodes.length) {
            this.detach();
        }
        const filteredNodes = nodes.filter((node) => {
            if (node.isAncestorOf(this)) {
                Util.error('Konva.Transformer cannot be an a child of the node you are trying to attach');
                return false;
            }
            return true;
        });
        this._nodes = nodes = filteredNodes;
        if (nodes.length === 1 && this.useSingleNodeRotation()) {
            this.rotation(nodes[0].getAbsoluteRotation());
        }
        else {
            this.rotation(0);
        }
        this._nodes.forEach((node) => {
            const onChange = () => {
                if (this.nodes().length === 1 && this.useSingleNodeRotation()) {
                    this.rotation(this.nodes()[0].getAbsoluteRotation());
                }
                this._resetTransformCache();
                if (!this._transforming && !this.isDragging()) {
                    this.update();
                }
            };
            if (node._attrsAffectingSize.length) {
                const additionalEvents = node._attrsAffectingSize
                    .map((prop) => prop + 'Change.' + this._getEventNamespace())
                    .join(' ');
                node.on(additionalEvents, onChange);
            }
            node.on(TRANSFORM_CHANGE_STR.map((e) => e + `.${this._getEventNamespace()}`).join(' '), onChange);
            node.on(`absoluteTransformChange.${this._getEventNamespace()}`, onChange);
            this._proxyDrag(node);
        });
        this._resetTransformCache();
        const elementsCreated = !!this.findOne('.top-left');
        if (elementsCreated) {
            this.update();
        }
        return this;
    }
    _proxyDrag(node) {
        let lastPos;
        node.on(`dragstart.${this._getEventNamespace()}`, (e) => {
            lastPos = node.getAbsolutePosition();
            if (!this.isDragging() && node !== this.findOne('.back')) {
                this.startDrag(e, false);
            }
        });
        node.on(`dragmove.${this._getEventNamespace()}`, (e) => {
            if (!lastPos) {
                return;
            }
            const abs = node.getAbsolutePosition();
            const dx = abs.x - lastPos.x;
            const dy = abs.y - lastPos.y;
            this.nodes().forEach((otherNode) => {
                if (otherNode === node) {
                    return;
                }
                if (otherNode.isDragging()) {
                    return;
                }
                const otherAbs = otherNode.getAbsolutePosition();
                otherNode.setAbsolutePosition({
                    x: otherAbs.x + dx,
                    y: otherAbs.y + dy,
                });
                otherNode.startDrag(e);
            });
            lastPos = null;
        });
    }
    getNodes() {
        return this._nodes || [];
    }
    getActiveAnchor() {
        return this._movingAnchorName;
    }
    detach() {
        if (this._nodes) {
            this._nodes.forEach((node) => {
                node.off('.' + this._getEventNamespace());
            });
        }
        this._nodes = [];
        this._resetTransformCache();
    }
    _resetTransformCache() {
        this._clearCache(NODES_RECT);
        this._clearCache('transform');
        this._clearSelfAndDescendantCache('absoluteTransform');
    }
    _getNodeRect() {
        return this._getCache(NODES_RECT, this.__getNodeRect);
    }
    __getNodeShape(node, rot = this.rotation(), relative) {
        const rect = node.getClientRect({
            skipTransform: true,
            skipShadow: true,
            skipStroke: this.ignoreStroke(),
        });
        const absScale = node.getAbsoluteScale(relative);
        const absPos = node.getAbsolutePosition(relative);
        const dx = rect.x * absScale.x - node.offsetX() * absScale.x;
        const dy = rect.y * absScale.y - node.offsetY() * absScale.y;
        const rotation = (Konva$1.getAngle(node.getAbsoluteRotation()) + Math.PI * 2) %
            (Math.PI * 2);
        const box = {
            x: absPos.x + dx * Math.cos(rotation) + dy * Math.sin(-rotation),
            y: absPos.y + dy * Math.cos(rotation) + dx * Math.sin(rotation),
            width: rect.width * absScale.x,
            height: rect.height * absScale.y,
            rotation: rotation,
        };
        return rotateAroundPoint(box, -Konva$1.getAngle(rot), {
            x: 0,
            y: 0,
        });
    }
    __getNodeRect() {
        const node = this.getNode();
        if (!node) {
            return {
                x: -1e8,
                y: -1e8,
                width: 0,
                height: 0,
                rotation: 0,
            };
        }
        const totalPoints = [];
        this.nodes().map((node) => {
            const box = node.getClientRect({
                skipTransform: true,
                skipShadow: true,
                skipStroke: this.ignoreStroke(),
            });
            const points = [
                { x: box.x, y: box.y },
                { x: box.x + box.width, y: box.y },
                { x: box.x + box.width, y: box.y + box.height },
                { x: box.x, y: box.y + box.height },
            ];
            const trans = node.getAbsoluteTransform();
            points.forEach(function (point) {
                const transformed = trans.point(point);
                totalPoints.push(transformed);
            });
        });
        const tr = new Transform();
        tr.rotate(-Konva$1.getAngle(this.rotation()));
        let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
        totalPoints.forEach(function (point) {
            const transformed = tr.point(point);
            if (minX === undefined) {
                minX = maxX = transformed.x;
                minY = maxY = transformed.y;
            }
            minX = Math.min(minX, transformed.x);
            minY = Math.min(minY, transformed.y);
            maxX = Math.max(maxX, transformed.x);
            maxY = Math.max(maxY, transformed.y);
        });
        tr.invert();
        const p = tr.point({ x: minX, y: minY });
        return {
            x: p.x,
            y: p.y,
            width: maxX - minX,
            height: maxY - minY,
            rotation: Konva$1.getAngle(this.rotation()),
        };
    }
    getX() {
        return this._getNodeRect().x;
    }
    getY() {
        return this._getNodeRect().y;
    }
    getWidth() {
        return this._getNodeRect().width;
    }
    getHeight() {
        return this._getNodeRect().height;
    }
    _createElements() {
        this._createBack();
        ANCHORS_NAMES.forEach((name) => {
            this._createAnchor(name);
        });
        this._createAnchor('rotater');
        this._elementsCreated = true;
    }
    _createAnchor(name) {
        const anchor = new Rect$1({
            stroke: 'rgb(0, 161, 255)',
            fill: 'white',
            strokeWidth: 1,
            name: name + ' _anchor',
            dragDistance: 0,
            draggable: true,
            hitStrokeWidth: TOUCH_DEVICE ? 10 : 'auto',
        });
        const self = this;
        anchor.on('mousedown touchstart', function (e) {
            self._handleMouseDown(e);
        });
        anchor.on('dragstart', (e) => {
            anchor.stopDrag();
            e.cancelBubble = true;
        });
        anchor.on('dragend', (e) => {
            e.cancelBubble = true;
        });
        anchor.on('mouseenter', () => {
            const rad = Konva$1.getAngle(this.rotation());
            const rotateCursor = this.rotateAnchorCursor();
            const cursor = getCursor(name, rad, rotateCursor);
            anchor.getStage().content &&
                (anchor.getStage().content.style.cursor = cursor);
            this._cursorChange = true;
        });
        anchor.on('mouseout', () => {
            anchor.getStage().content &&
                (anchor.getStage().content.style.cursor = '');
            this._cursorChange = false;
        });
        this.add(anchor);
    }
    _createBack() {
        const back = new Shape({
            name: 'back',
            width: 0,
            height: 0,
            sceneFunc(ctx, shape) {
                const tr = shape.getParent();
                const padding = tr.padding();
                const width = shape.width();
                const height = shape.height();
                ctx.beginPath();
                ctx.rect(-padding, -padding, width + padding * 2, height + padding * 2);
                if (tr.rotateEnabled() && tr.rotateLineVisible()) {
                    const rotateAnchorAngle = tr.rotateAnchorAngle();
                    const rotateAnchorOffset = tr.rotateAnchorOffset();
                    const rad = Util.degToRad(rotateAnchorAngle);
                    const dirX = Math.sin(rad);
                    const dirY = -Math.cos(rad);
                    const cx = width / 2;
                    const cy = height / 2;
                    let t = Infinity;
                    if (dirY < 0) {
                        t = Math.min(t, -cy / dirY);
                    }
                    else if (dirY > 0) {
                        t = Math.min(t, (height - cy) / dirY);
                    }
                    if (dirX < 0) {
                        t = Math.min(t, -cx / dirX);
                    }
                    else if (dirX > 0) {
                        t = Math.min(t, (width - cx) / dirX);
                    }
                    const edgeX = cx + dirX * t;
                    const edgeY = cy + dirY * t;
                    const sign = Util._sign(height);
                    const endX = edgeX + dirX * rotateAnchorOffset * sign;
                    const endY = edgeY + dirY * rotateAnchorOffset * sign;
                    ctx.moveTo(edgeX, edgeY);
                    ctx.lineTo(endX, endY);
                }
                ctx.fillStrokeShape(shape);
            },
            hitFunc: (ctx, shape) => {
                if (!this.shouldOverdrawWholeArea()) {
                    return;
                }
                const padding = this.padding();
                ctx.beginPath();
                ctx.rect(-padding, -padding, shape.width() + padding * 2, shape.height() + padding * 2);
                ctx.fillStrokeShape(shape);
            },
        });
        this.add(back);
        this._proxyDrag(back);
        back.on('dragstart', (e) => {
            e.cancelBubble = true;
        });
        back.on('dragmove', (e) => {
            e.cancelBubble = true;
        });
        back.on('dragend', (e) => {
            e.cancelBubble = true;
        });
        this.on('dragmove', (e) => {
            this.update();
        });
    }
    _handleMouseDown(e) {
        if (this._transforming) {
            return;
        }
        this._movingAnchorName = e.target.name().split(' ')[0];
        const attrs = this._getNodeRect();
        const width = attrs.width;
        const height = attrs.height;
        const hypotenuse = Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2));
        this.sin = Math.abs(height / hypotenuse);
        this.cos = Math.abs(width / hypotenuse);
        if (typeof window !== 'undefined') {
            window.addEventListener('mousemove', this._handleMouseMove);
            window.addEventListener('touchmove', this._handleMouseMove);
            window.addEventListener('mouseup', this._handleMouseUp, true);
            window.addEventListener('touchend', this._handleMouseUp, true);
        }
        this._transforming = true;
        const ap = e.target.getAbsolutePosition();
        const pos = e.target.getStage().getPointerPosition();
        this._anchorDragOffset = {
            x: pos.x - ap.x,
            y: pos.y - ap.y,
        };
        activeTransformersCount++;
        this._fire('transformstart', { evt: e.evt, target: this.getNode() });
        this._nodes.forEach((target) => {
            target._fire('transformstart', { evt: e.evt, target });
        });
    }
    _handleMouseMove(e) {
        let x, y, newHypotenuse;
        const anchorNode = this.findOne('.' + this._movingAnchorName);
        const stage = anchorNode.getStage();
        stage.setPointersPositions(e);
        const pp = stage.getPointerPosition();
        let newNodePos = {
            x: pp.x - this._anchorDragOffset.x,
            y: pp.y - this._anchorDragOffset.y,
        };
        const oldAbs = anchorNode.getAbsolutePosition();
        if (this.anchorDragBoundFunc()) {
            newNodePos = this.anchorDragBoundFunc()(oldAbs, newNodePos, e);
        }
        anchorNode.setAbsolutePosition(newNodePos);
        const newAbs = anchorNode.getAbsolutePosition();
        if (oldAbs.x === newAbs.x && oldAbs.y === newAbs.y) {
            return;
        }
        if (this._movingAnchorName === 'rotater') {
            const attrs = this._getNodeRect();
            x = anchorNode.x() - attrs.width / 2;
            y = -anchorNode.y() + attrs.height / 2;
            const rotateAnchorAngleRad = Konva$1.getAngle(this.rotateAnchorAngle());
            let delta = Math.atan2(-y, x) + Math.PI / 2 - rotateAnchorAngleRad;
            if (attrs.height < 0) {
                delta -= Math.PI;
            }
            const oldRotation = Konva$1.getAngle(this.rotation());
            const newRotation = oldRotation + delta;
            const tol = Konva$1.getAngle(this.rotationSnapTolerance());
            const snappedRot = getSnap(this.rotationSnaps(), newRotation, tol);
            const diff = snappedRot - attrs.rotation;
            const shape = rotateAroundCenter(attrs, diff);
            this._fitNodesInto(shape, e);
            return;
        }
        const shiftBehavior = this.shiftBehavior();
        let keepProportion;
        if (shiftBehavior === 'inverted') {
            keepProportion = this.keepRatio() && !e.shiftKey;
        }
        else if (shiftBehavior === 'none') {
            keepProportion = this.keepRatio();
        }
        else {
            keepProportion = this.keepRatio() || e.shiftKey;
        }
        let centeredScaling = this.centeredScaling() || e.altKey;
        if (this._movingAnchorName === 'top-left') {
            if (keepProportion) {
                const comparePoint = centeredScaling
                    ? {
                        x: this.width() / 2,
                        y: this.height() / 2,
                    }
                    : {
                        x: this.findOne('.bottom-right').x(),
                        y: this.findOne('.bottom-right').y(),
                    };
                newHypotenuse = Math.sqrt(Math.pow(comparePoint.x - anchorNode.x(), 2) +
                    Math.pow(comparePoint.y - anchorNode.y(), 2));
                const reverseX = this.findOne('.top-left').x() > comparePoint.x ? -1 : 1;
                const reverseY = this.findOne('.top-left').y() > comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                this.findOne('.top-left').x(comparePoint.x - x);
                this.findOne('.top-left').y(comparePoint.y - y);
            }
        }
        else if (this._movingAnchorName === 'top-center') {
            this.findOne('.top-left').y(anchorNode.y());
        }
        else if (this._movingAnchorName === 'top-right') {
            if (keepProportion) {
                const comparePoint = centeredScaling
                    ? {
                        x: this.width() / 2,
                        y: this.height() / 2,
                    }
                    : {
                        x: this.findOne('.bottom-left').x(),
                        y: this.findOne('.bottom-left').y(),
                    };
                newHypotenuse = Math.sqrt(Math.pow(anchorNode.x() - comparePoint.x, 2) +
                    Math.pow(comparePoint.y - anchorNode.y(), 2));
                const reverseX = this.findOne('.top-right').x() < comparePoint.x ? -1 : 1;
                const reverseY = this.findOne('.top-right').y() > comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                this.findOne('.top-right').x(comparePoint.x + x);
                this.findOne('.top-right').y(comparePoint.y - y);
            }
            var pos = anchorNode.position();
            this.findOne('.top-left').y(pos.y);
            this.findOne('.bottom-right').x(pos.x);
        }
        else if (this._movingAnchorName === 'middle-left') {
            this.findOne('.top-left').x(anchorNode.x());
        }
        else if (this._movingAnchorName === 'middle-right') {
            this.findOne('.bottom-right').x(anchorNode.x());
        }
        else if (this._movingAnchorName === 'bottom-left') {
            if (keepProportion) {
                const comparePoint = centeredScaling
                    ? {
                        x: this.width() / 2,
                        y: this.height() / 2,
                    }
                    : {
                        x: this.findOne('.top-right').x(),
                        y: this.findOne('.top-right').y(),
                    };
                newHypotenuse = Math.sqrt(Math.pow(comparePoint.x - anchorNode.x(), 2) +
                    Math.pow(anchorNode.y() - comparePoint.y, 2));
                const reverseX = comparePoint.x < anchorNode.x() ? -1 : 1;
                const reverseY = anchorNode.y() < comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                anchorNode.x(comparePoint.x - x);
                anchorNode.y(comparePoint.y + y);
            }
            pos = anchorNode.position();
            this.findOne('.top-left').x(pos.x);
            this.findOne('.bottom-right').y(pos.y);
        }
        else if (this._movingAnchorName === 'bottom-center') {
            this.findOne('.bottom-right').y(anchorNode.y());
        }
        else if (this._movingAnchorName === 'bottom-right') {
            if (keepProportion) {
                const comparePoint = centeredScaling
                    ? {
                        x: this.width() / 2,
                        y: this.height() / 2,
                    }
                    : {
                        x: this.findOne('.top-left').x(),
                        y: this.findOne('.top-left').y(),
                    };
                newHypotenuse = Math.sqrt(Math.pow(anchorNode.x() - comparePoint.x, 2) +
                    Math.pow(anchorNode.y() - comparePoint.y, 2));
                const reverseX = this.findOne('.bottom-right').x() < comparePoint.x ? -1 : 1;
                const reverseY = this.findOne('.bottom-right').y() < comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                this.findOne('.bottom-right').x(comparePoint.x + x);
                this.findOne('.bottom-right').y(comparePoint.y + y);
            }
        }
        else {
            console.error(new Error('Wrong position argument of selection resizer: ' +
                this._movingAnchorName));
        }
        centeredScaling = this.centeredScaling() || e.altKey;
        if (centeredScaling) {
            const topLeft = this.findOne('.top-left');
            const bottomRight = this.findOne('.bottom-right');
            const topOffsetX = topLeft.x();
            const topOffsetY = topLeft.y();
            const bottomOffsetX = this.getWidth() - bottomRight.x();
            const bottomOffsetY = this.getHeight() - bottomRight.y();
            bottomRight.move({
                x: -topOffsetX,
                y: -topOffsetY,
            });
            topLeft.move({
                x: bottomOffsetX,
                y: bottomOffsetY,
            });
        }
        const absPos = this.findOne('.top-left').getAbsolutePosition();
        x = absPos.x;
        y = absPos.y;
        const width = this.findOne('.bottom-right').x() - this.findOne('.top-left').x();
        const height = this.findOne('.bottom-right').y() - this.findOne('.top-left').y();
        this._fitNodesInto({
            x: x,
            y: y,
            width: width,
            height: height,
            rotation: Konva$1.getAngle(this.rotation()),
        }, e);
    }
    _handleMouseUp(e) {
        this._removeEvents(e);
    }
    getAbsoluteTransform() {
        return this.getTransform();
    }
    _removeEvents(e) {
        var _a;
        if (this._transforming) {
            this._transforming = false;
            if (typeof window !== 'undefined') {
                window.removeEventListener('mousemove', this._handleMouseMove);
                window.removeEventListener('touchmove', this._handleMouseMove);
                window.removeEventListener('mouseup', this._handleMouseUp, true);
                window.removeEventListener('touchend', this._handleMouseUp, true);
            }
            const node = this.getNode();
            activeTransformersCount--;
            this._fire('transformend', { evt: e, target: node });
            (_a = this.getLayer()) === null || _a === void 0 ? void 0 : _a.batchDraw();
            if (node) {
                this._nodes.forEach((target) => {
                    var _a;
                    target._fire('transformend', { evt: e, target });
                    (_a = target.getLayer()) === null || _a === void 0 ? void 0 : _a.batchDraw();
                });
            }
            this._movingAnchorName = null;
        }
    }
    _fitNodesInto(newAttrs, evt) {
        const oldAttrs = this._getNodeRect();
        const minSize = 1;
        if (Util._inRange(newAttrs.width, -this.padding() * 2 - minSize, minSize)) {
            this.update();
            return;
        }
        if (Util._inRange(newAttrs.height, -this.padding() * 2 - minSize, minSize)) {
            this.update();
            return;
        }
        const t = new Transform();
        t.rotate(Konva$1.getAngle(this.rotation()));
        if (this._movingAnchorName &&
            newAttrs.width < 0 &&
            this._movingAnchorName.indexOf('left') >= 0) {
            const offset = t.point({
                x: -this.padding() * 2,
                y: 0,
            });
            newAttrs.x += offset.x;
            newAttrs.y += offset.y;
            newAttrs.width += this.padding() * 2;
            this._movingAnchorName = this._movingAnchorName.replace('left', 'right');
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
        }
        else if (this._movingAnchorName &&
            newAttrs.width < 0 &&
            this._movingAnchorName.indexOf('right') >= 0) {
            const offset = t.point({
                x: this.padding() * 2,
                y: 0,
            });
            this._movingAnchorName = this._movingAnchorName.replace('right', 'left');
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            newAttrs.width += this.padding() * 2;
        }
        if (this._movingAnchorName &&
            newAttrs.height < 0 &&
            this._movingAnchorName.indexOf('top') >= 0) {
            const offset = t.point({
                x: 0,
                y: -this.padding() * 2,
            });
            newAttrs.x += offset.x;
            newAttrs.y += offset.y;
            this._movingAnchorName = this._movingAnchorName.replace('top', 'bottom');
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            newAttrs.height += this.padding() * 2;
        }
        else if (this._movingAnchorName &&
            newAttrs.height < 0 &&
            this._movingAnchorName.indexOf('bottom') >= 0) {
            const offset = t.point({
                x: 0,
                y: this.padding() * 2,
            });
            this._movingAnchorName = this._movingAnchorName.replace('bottom', 'top');
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            newAttrs.height += this.padding() * 2;
        }
        if (this.boundBoxFunc()) {
            const bounded = this.boundBoxFunc()(oldAttrs, newAttrs);
            if (bounded) {
                newAttrs = bounded;
            }
            else {
                Util.warn('boundBoxFunc returned falsy. You should return new bound rect from it!');
            }
        }
        const baseSize = 10000000;
        const oldTr = new Transform();
        oldTr.translate(oldAttrs.x, oldAttrs.y);
        oldTr.rotate(oldAttrs.rotation);
        oldTr.scale(oldAttrs.width / baseSize, oldAttrs.height / baseSize);
        const newTr = new Transform();
        const newScaleX = newAttrs.width / baseSize;
        const newScaleY = newAttrs.height / baseSize;
        if (this.flipEnabled() === false) {
            newTr.translate(newAttrs.x, newAttrs.y);
            newTr.rotate(newAttrs.rotation);
            newTr.translate(newAttrs.width < 0 ? newAttrs.width : 0, newAttrs.height < 0 ? newAttrs.height : 0);
            newTr.scale(Math.abs(newScaleX), Math.abs(newScaleY));
        }
        else {
            newTr.translate(newAttrs.x, newAttrs.y);
            newTr.rotate(newAttrs.rotation);
            newTr.scale(newScaleX, newScaleY);
        }
        const delta = newTr.multiply(oldTr.invert());
        this._nodes.forEach((node) => {
            var _a;
            if (!node.getStage()) {
                return;
            }
            const parentTransform = node.getParent().getAbsoluteTransform();
            const localTransform = node.getTransform().copy();
            localTransform.translate(node.offsetX(), node.offsetY());
            const newLocalTransform = new Transform();
            newLocalTransform
                .multiply(parentTransform.copy().invert())
                .multiply(delta)
                .multiply(parentTransform)
                .multiply(localTransform);
            const attrs = newLocalTransform.decompose();
            node.setAttrs(attrs);
            (_a = node.getLayer()) === null || _a === void 0 ? void 0 : _a.batchDraw();
        });
        this.rotation(Util._getRotation(newAttrs.rotation));
        this._nodes.forEach((node) => {
            this._fire('transform', { evt: evt, target: node });
            node._fire('transform', { evt: evt, target: node });
        });
        this._resetTransformCache();
        this.update();
        this.getLayer().batchDraw();
    }
    forceUpdate() {
        this._resetTransformCache();
        this.update();
    }
    _batchChangeChild(selector, attrs) {
        const anchor = this.findOne(selector);
        anchor.setAttrs(attrs);
    }
    update() {
        var _a;
        const attrs = this._getNodeRect();
        this.rotation(Util._getRotation(attrs.rotation));
        const width = attrs.width;
        const height = attrs.height;
        const enabledAnchors = this.enabledAnchors();
        const resizeEnabled = this.resizeEnabled();
        const padding = this.padding();
        const anchorSize = this.anchorSize();
        const anchors = this.find('._anchor');
        anchors.forEach((node) => {
            node.setAttrs({
                width: anchorSize,
                height: anchorSize,
                offsetX: anchorSize / 2,
                offsetY: anchorSize / 2,
                stroke: this.anchorStroke(),
                strokeWidth: this.anchorStrokeWidth(),
                fill: this.anchorFill(),
                cornerRadius: this.anchorCornerRadius(),
            });
        });
        this._batchChangeChild('.top-left', {
            x: 0,
            y: 0,
            offsetX: anchorSize / 2 + padding,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf('top-left') >= 0,
        });
        this._batchChangeChild('.top-center', {
            x: width / 2,
            y: 0,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf('top-center') >= 0,
        });
        this._batchChangeChild('.top-right', {
            x: width,
            y: 0,
            offsetX: anchorSize / 2 - padding,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf('top-right') >= 0,
        });
        this._batchChangeChild('.middle-left', {
            x: 0,
            y: height / 2,
            offsetX: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf('middle-left') >= 0,
        });
        this._batchChangeChild('.middle-right', {
            x: width,
            y: height / 2,
            offsetX: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf('middle-right') >= 0,
        });
        this._batchChangeChild('.bottom-left', {
            x: 0,
            y: height,
            offsetX: anchorSize / 2 + padding,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf('bottom-left') >= 0,
        });
        this._batchChangeChild('.bottom-center', {
            x: width / 2,
            y: height,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf('bottom-center') >= 0,
        });
        this._batchChangeChild('.bottom-right', {
            x: width,
            y: height,
            offsetX: anchorSize / 2 - padding,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf('bottom-right') >= 0,
        });
        const rotateAnchorAngle = this.rotateAnchorAngle();
        const rotateAnchorOffset = this.rotateAnchorOffset();
        const rad = Util.degToRad(rotateAnchorAngle);
        const dirX = Math.sin(rad);
        const dirY = -Math.cos(rad);
        const cx = width / 2;
        const cy = height / 2;
        let t = Infinity;
        if (dirY < 0) {
            t = Math.min(t, -cy / dirY);
        }
        else if (dirY > 0) {
            t = Math.min(t, (height - cy) / dirY);
        }
        if (dirX < 0) {
            t = Math.min(t, -cx / dirX);
        }
        else if (dirX > 0) {
            t = Math.min(t, (width - cx) / dirX);
        }
        const edgeX = cx + dirX * t;
        const edgeY = cy + dirY * t;
        const sign = Util._sign(height);
        this._batchChangeChild('.rotater', {
            x: edgeX + dirX * rotateAnchorOffset * sign,
            y: edgeY + dirY * rotateAnchorOffset * sign - padding * dirY,
            visible: this.rotateEnabled(),
        });
        this._batchChangeChild('.back', {
            width: width,
            height: height,
            visible: this.borderEnabled(),
            stroke: this.borderStroke(),
            strokeWidth: this.borderStrokeWidth(),
            dash: this.borderDash(),
            draggable: this.nodes().some((node) => node.draggable()),
            x: 0,
            y: 0,
        });
        const styleFunc = this.anchorStyleFunc();
        if (styleFunc) {
            anchors.forEach((node) => {
                styleFunc(node);
            });
        }
        (_a = this.getLayer()) === null || _a === void 0 ? void 0 : _a.batchDraw();
    }
    isTransforming() {
        return this._transforming;
    }
    stopTransform() {
        if (this._transforming) {
            this._removeEvents();
            const anchorNode = this.findOne('.' + this._movingAnchorName);
            if (anchorNode) {
                anchorNode.stopDrag();
            }
        }
    }
    destroy() {
        if (this.getStage() && this._cursorChange) {
            this.getStage().content && (this.getStage().content.style.cursor = '');
        }
        Group$1.prototype.destroy.call(this);
        this.detach();
        this._removeEvents();
        return this;
    }
    add(...children) {
        if (this._elementsCreated) {
            Util.error('You cannot add external nodes to the Transformer. Use tr.nodes([node]) instead.');
            return this;
        }
        return super.add(...children);
    }
    toObject() {
        return Node.prototype.toObject.call(this);
    }
    clone(obj) {
        const node = Node.prototype.clone.call(this, obj);
        return node;
    }
    getClientRect() {
        if (this.nodes().length > 0) {
            return super.getClientRect();
        }
        else {
            return { x: 0, y: 0, width: 0, height: 0 };
        }
    }
}
Transformer.isTransforming = () => {
    return activeTransformersCount > 0;
};
function validateAnchors(val) {
    if (!(val instanceof Array)) {
        Util.warn('enabledAnchors value should be an array');
    }
    if (val instanceof Array) {
        val.forEach(function (name) {
            if (ANCHORS_NAMES.indexOf(name) === -1) {
                Util.warn('Unknown anchor name: ' +
                    name +
                    '. Available names are: ' +
                    ANCHORS_NAMES.join(', '));
            }
        });
    }
    return val || [];
}
Transformer.prototype.className = 'Transformer';
_registerNode(Transformer);
Factory.addGetterSetter(Transformer, 'enabledAnchors', ANCHORS_NAMES, validateAnchors);
Factory.addGetterSetter(Transformer, 'flipEnabled', true, getBooleanValidator());
Factory.addGetterSetter(Transformer, 'resizeEnabled', true);
Factory.addGetterSetter(Transformer, 'anchorSize', 10, getNumberValidator());
Factory.addGetterSetter(Transformer, 'rotateEnabled', true);
Factory.addGetterSetter(Transformer, 'rotateLineVisible', true);
Factory.addGetterSetter(Transformer, 'rotationSnaps', []);
Factory.addGetterSetter(Transformer, 'rotateAnchorOffset', 50, getNumberValidator());
Factory.addGetterSetter(Transformer, 'rotateAnchorAngle', 0, getNumberValidator());
Factory.addGetterSetter(Transformer, 'rotateAnchorCursor', 'crosshair');
Factory.addGetterSetter(Transformer, 'rotationSnapTolerance', 5, getNumberValidator());
Factory.addGetterSetter(Transformer, 'borderEnabled', true);
Factory.addGetterSetter(Transformer, 'anchorStroke', 'rgb(0, 161, 255)');
Factory.addGetterSetter(Transformer, 'anchorStrokeWidth', 1, getNumberValidator());
Factory.addGetterSetter(Transformer, 'anchorFill', 'white');
Factory.addGetterSetter(Transformer, 'anchorCornerRadius', 0, getNumberValidator());
Factory.addGetterSetter(Transformer, 'borderStroke', 'rgb(0, 161, 255)');
Factory.addGetterSetter(Transformer, 'borderStrokeWidth', 1, getNumberValidator());
Factory.addGetterSetter(Transformer, 'borderDash');
Factory.addGetterSetter(Transformer, 'keepRatio', true);
Factory.addGetterSetter(Transformer, 'shiftBehavior', 'default');
Factory.addGetterSetter(Transformer, 'centeredScaling', false);
Factory.addGetterSetter(Transformer, 'ignoreStroke', false);
Factory.addGetterSetter(Transformer, 'padding', 0, getNumberValidator());
Factory.addGetterSetter(Transformer, 'nodes');
Factory.addGetterSetter(Transformer, 'node');
Factory.addGetterSetter(Transformer, 'boundBoxFunc');
Factory.addGetterSetter(Transformer, 'anchorDragBoundFunc');
Factory.addGetterSetter(Transformer, 'anchorStyleFunc');
Factory.addGetterSetter(Transformer, 'shouldOverdrawWholeArea', false);
Factory.addGetterSetter(Transformer, 'useSingleNodeRotation', true);
Factory.backCompat(Transformer, {
    lineEnabled: 'borderEnabled',
    rotateHandlerOffset: 'rotateAnchorOffset',
    enabledHandlers: 'enabledAnchors',
});

class Wedge extends Shape {
    _sceneFunc(context) {
        context.beginPath();
        context.arc(0, 0, this.radius(), 0, Konva$1.getAngle(this.angle()), this.clockwise());
        context.lineTo(0, 0);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.radius() * 2;
    }
    getHeight() {
        return this.radius() * 2;
    }
    setWidth(width) {
        this.radius(width / 2);
    }
    setHeight(height) {
        this.radius(height / 2);
    }
}
Wedge.prototype.className = 'Wedge';
Wedge.prototype._centroid = true;
Wedge.prototype._attrsAffectingSize = ['radius'];
_registerNode(Wedge);
Factory.addGetterSetter(Wedge, 'radius', 0, getNumberValidator());
Factory.addGetterSetter(Wedge, 'angle', 0, getNumberValidator());
Factory.addGetterSetter(Wedge, 'clockwise', false);
Factory.backCompat(Wedge, {
    angleDeg: 'angle',
    getAngleDeg: 'getAngle',
    setAngleDeg: 'setAngle',
});

function BlurStack() {
    this.r = 0;
    this.g = 0;
    this.b = 0;
    this.a = 0;
    this.next = null;
}
const mul_table = [
    512, 512, 456, 512, 328, 456, 335, 512, 405, 328, 271, 456, 388, 335, 292,
    512, 454, 405, 364, 328, 298, 271, 496, 456, 420, 388, 360, 335, 312, 292,
    273, 512, 482, 454, 428, 405, 383, 364, 345, 328, 312, 298, 284, 271, 259,
    496, 475, 456, 437, 420, 404, 388, 374, 360, 347, 335, 323, 312, 302, 292,
    282, 273, 265, 512, 497, 482, 468, 454, 441, 428, 417, 405, 394, 383, 373,
    364, 354, 345, 337, 328, 320, 312, 305, 298, 291, 284, 278, 271, 265, 259,
    507, 496, 485, 475, 465, 456, 446, 437, 428, 420, 412, 404, 396, 388, 381,
    374, 367, 360, 354, 347, 341, 335, 329, 323, 318, 312, 307, 302, 297, 292,
    287, 282, 278, 273, 269, 265, 261, 512, 505, 497, 489, 482, 475, 468, 461,
    454, 447, 441, 435, 428, 422, 417, 411, 405, 399, 394, 389, 383, 378, 373,
    368, 364, 359, 354, 350, 345, 341, 337, 332, 328, 324, 320, 316, 312, 309,
    305, 301, 298, 294, 291, 287, 284, 281, 278, 274, 271, 268, 265, 262, 259,
    257, 507, 501, 496, 491, 485, 480, 475, 470, 465, 460, 456, 451, 446, 442,
    437, 433, 428, 424, 420, 416, 412, 408, 404, 400, 396, 392, 388, 385, 381,
    377, 374, 370, 367, 363, 360, 357, 354, 350, 347, 344, 341, 338, 335, 332,
    329, 326, 323, 320, 318, 315, 312, 310, 307, 304, 302, 299, 297, 294, 292,
    289, 287, 285, 282, 280, 278, 275, 273, 271, 269, 267, 265, 263, 261, 259,
];
const shg_table = [
    9, 11, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 16, 17, 17, 17, 17, 17,
    17, 17, 18, 18, 18, 18, 18, 18, 18, 18, 18, 19, 19, 19, 19, 19, 19, 19, 19,
    19, 19, 19, 19, 19, 19, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20,
    20, 20, 20, 20, 20, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21,
    21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 22, 22, 22, 22, 22, 22,
    22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22,
    22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 23, 23, 23, 23, 23, 23, 23,
    23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23,
    23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23,
    23, 23, 23, 23, 23, 23, 23, 23, 23, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
    24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
    24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
    24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
    24, 24, 24, 24, 24, 24, 24,
];
function filterGaussBlurRGBA(imageData, radius) {
    const pixels = imageData.data, width = imageData.width, height = imageData.height;
    let p, yi, yw, r_sum, g_sum, b_sum, a_sum, r_out_sum, g_out_sum, b_out_sum, a_out_sum, r_in_sum, g_in_sum, b_in_sum, a_in_sum, pr, pg, pb, pa, rbs;
    const div = radius + radius + 1, widthMinus1 = width - 1, heightMinus1 = height - 1, radiusPlus1 = radius + 1, sumFactor = (radiusPlus1 * (radiusPlus1 + 1)) / 2, stackStart = new BlurStack(), mul_sum = mul_table[radius], shg_sum = shg_table[radius];
    let stackEnd = null, stack = stackStart, stackIn = null, stackOut = null;
    for (let i = 1; i < div; i++) {
        stack = stack.next = new BlurStack();
        if (i === radiusPlus1) {
            stackEnd = stack;
        }
    }
    stack.next = stackStart;
    yw = yi = 0;
    for (let y = 0; y < height; y++) {
        r_in_sum =
            g_in_sum =
                b_in_sum =
                    a_in_sum =
                        r_sum =
                            g_sum =
                                b_sum =
                                    a_sum =
                                        0;
        r_out_sum = radiusPlus1 * (pr = pixels[yi]);
        g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
        b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
        a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);
        r_sum += sumFactor * pr;
        g_sum += sumFactor * pg;
        b_sum += sumFactor * pb;
        a_sum += sumFactor * pa;
        stack = stackStart;
        for (let i = 0; i < radiusPlus1; i++) {
            stack.r = pr;
            stack.g = pg;
            stack.b = pb;
            stack.a = pa;
            stack = stack.next;
        }
        for (let i = 1; i < radiusPlus1; i++) {
            p = yi + ((widthMinus1 < i ? widthMinus1 : i) << 2);
            r_sum += (stack.r = pr = pixels[p]) * (rbs = radiusPlus1 - i);
            g_sum += (stack.g = pg = pixels[p + 1]) * rbs;
            b_sum += (stack.b = pb = pixels[p + 2]) * rbs;
            a_sum += (stack.a = pa = pixels[p + 3]) * rbs;
            r_in_sum += pr;
            g_in_sum += pg;
            b_in_sum += pb;
            a_in_sum += pa;
            stack = stack.next;
        }
        stackIn = stackStart;
        stackOut = stackEnd;
        for (let x = 0; x < width; x++) {
            pixels[yi + 3] = pa = (a_sum * mul_sum) >> shg_sum;
            if (pa !== 0) {
                pa = 255 / pa;
                pixels[yi] = ((r_sum * mul_sum) >> shg_sum) * pa;
                pixels[yi + 1] = ((g_sum * mul_sum) >> shg_sum) * pa;
                pixels[yi + 2] = ((b_sum * mul_sum) >> shg_sum) * pa;
            }
            else {
                pixels[yi] = pixels[yi + 1] = pixels[yi + 2] = 0;
            }
            r_sum -= r_out_sum;
            g_sum -= g_out_sum;
            b_sum -= b_out_sum;
            a_sum -= a_out_sum;
            r_out_sum -= stackIn.r;
            g_out_sum -= stackIn.g;
            b_out_sum -= stackIn.b;
            a_out_sum -= stackIn.a;
            p = (yw + ((p = x + radius + 1) < widthMinus1 ? p : widthMinus1)) << 2;
            r_in_sum += stackIn.r = pixels[p];
            g_in_sum += stackIn.g = pixels[p + 1];
            b_in_sum += stackIn.b = pixels[p + 2];
            a_in_sum += stackIn.a = pixels[p + 3];
            r_sum += r_in_sum;
            g_sum += g_in_sum;
            b_sum += b_in_sum;
            a_sum += a_in_sum;
            stackIn = stackIn.next;
            r_out_sum += pr = stackOut.r;
            g_out_sum += pg = stackOut.g;
            b_out_sum += pb = stackOut.b;
            a_out_sum += pa = stackOut.a;
            r_in_sum -= pr;
            g_in_sum -= pg;
            b_in_sum -= pb;
            a_in_sum -= pa;
            stackOut = stackOut.next;
            yi += 4;
        }
        yw += width;
    }
    for (let x = 0; x < width; x++) {
        g_in_sum =
            b_in_sum =
                a_in_sum =
                    r_in_sum =
                        g_sum =
                            b_sum =
                                a_sum =
                                    r_sum =
                                        0;
        yi = x << 2;
        r_out_sum = radiusPlus1 * (pr = pixels[yi]);
        g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
        b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
        a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);
        r_sum += sumFactor * pr;
        g_sum += sumFactor * pg;
        b_sum += sumFactor * pb;
        a_sum += sumFactor * pa;
        stack = stackStart;
        for (let i = 0; i < radiusPlus1; i++) {
            stack.r = pr;
            stack.g = pg;
            stack.b = pb;
            stack.a = pa;
            stack = stack.next;
        }
        let yp = width;
        for (let i = 1; i <= radius; i++) {
            yi = (yp + x) << 2;
            r_sum += (stack.r = pr = pixels[yi]) * (rbs = radiusPlus1 - i);
            g_sum += (stack.g = pg = pixels[yi + 1]) * rbs;
            b_sum += (stack.b = pb = pixels[yi + 2]) * rbs;
            a_sum += (stack.a = pa = pixels[yi + 3]) * rbs;
            r_in_sum += pr;
            g_in_sum += pg;
            b_in_sum += pb;
            a_in_sum += pa;
            stack = stack.next;
            if (i < heightMinus1) {
                yp += width;
            }
        }
        yi = x;
        stackIn = stackStart;
        stackOut = stackEnd;
        for (let y = 0; y < height; y++) {
            p = yi << 2;
            pixels[p + 3] = pa = (a_sum * mul_sum) >> shg_sum;
            if (pa > 0) {
                pa = 255 / pa;
                pixels[p] = ((r_sum * mul_sum) >> shg_sum) * pa;
                pixels[p + 1] = ((g_sum * mul_sum) >> shg_sum) * pa;
                pixels[p + 2] = ((b_sum * mul_sum) >> shg_sum) * pa;
            }
            else {
                pixels[p] = pixels[p + 1] = pixels[p + 2] = 0;
            }
            r_sum -= r_out_sum;
            g_sum -= g_out_sum;
            b_sum -= b_out_sum;
            a_sum -= a_out_sum;
            r_out_sum -= stackIn.r;
            g_out_sum -= stackIn.g;
            b_out_sum -= stackIn.b;
            a_out_sum -= stackIn.a;
            p =
                (x +
                    ((p = y + radiusPlus1) < heightMinus1 ? p : heightMinus1) * width) <<
                    2;
            r_sum += r_in_sum += stackIn.r = pixels[p];
            g_sum += g_in_sum += stackIn.g = pixels[p + 1];
            b_sum += b_in_sum += stackIn.b = pixels[p + 2];
            a_sum += a_in_sum += stackIn.a = pixels[p + 3];
            stackIn = stackIn.next;
            r_out_sum += pr = stackOut.r;
            g_out_sum += pg = stackOut.g;
            b_out_sum += pb = stackOut.b;
            a_out_sum += pa = stackOut.a;
            r_in_sum -= pr;
            g_in_sum -= pg;
            b_in_sum -= pb;
            a_in_sum -= pa;
            stackOut = stackOut.next;
            yi += width;
        }
    }
}
const Blur = function Blur(imageData) {
    const radius = Math.round(this.blurRadius());
    if (radius > 0) {
        filterGaussBlurRGBA(imageData, radius);
    }
};
Factory.addGetterSetter(Node, 'blurRadius', 0, getNumberValidator(), Factory.afterSetFilter);

const Brighten = function (imageData) {
    const brightness = this.brightness() * 255, data = imageData.data, len = data.length;
    for (let i = 0; i < len; i += 4) {
        data[i] += brightness;
        data[i + 1] += brightness;
        data[i + 2] += brightness;
    }
};
Factory.addGetterSetter(Node, 'brightness', 0, getNumberValidator(), Factory.afterSetFilter);

const Brightness = function (imageData) {
    const brightness = this.brightness(), data = imageData.data, len = data.length;
    for (let i = 0; i < len; i += 4) {
        data[i] = Math.min(255, data[i] * brightness);
        data[i + 1] = Math.min(255, data[i + 1] * brightness);
        data[i + 2] = Math.min(255, data[i + 2] * brightness);
    }
};

const Contrast = function (imageData) {
    const adjust = Math.pow((this.contrast() + 100) / 100, 2);
    const data = imageData.data, nPixels = data.length;
    let red = 150, green = 150, blue = 150;
    for (let i = 0; i < nPixels; i += 4) {
        red = data[i];
        green = data[i + 1];
        blue = data[i + 2];
        red /= 255;
        red -= 0.5;
        red *= adjust;
        red += 0.5;
        red *= 255;
        green /= 255;
        green -= 0.5;
        green *= adjust;
        green += 0.5;
        green *= 255;
        blue /= 255;
        blue -= 0.5;
        blue *= adjust;
        blue += 0.5;
        blue *= 255;
        red = red < 0 ? 0 : red > 255 ? 255 : red;
        green = green < 0 ? 0 : green > 255 ? 255 : green;
        blue = blue < 0 ? 0 : blue > 255 ? 255 : blue;
        data[i] = red;
        data[i + 1] = green;
        data[i + 2] = blue;
    }
};
Factory.addGetterSetter(Node, 'contrast', 0, getNumberValidator(), Factory.afterSetFilter);

const Emboss = function (imageData) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const data = imageData.data;
    const w = imageData.width;
    const h = imageData.height;
    const strength01 = Math.min(1, Math.max(0, (_b = (_a = this.embossStrength) === null || _a === void 0 ? void 0 : _a.call(this)) !== null && _b !== void 0 ? _b : 0.5));
    const whiteLevel01 = Math.min(1, Math.max(0, (_d = (_c = this.embossWhiteLevel) === null || _c === void 0 ? void 0 : _c.call(this)) !== null && _d !== void 0 ? _d : 0.5));
    const directionMap = {
        'top-left': 315,
        top: 270,
        'top-right': 225,
        right: 180,
        'bottom-right': 135,
        bottom: 90,
        'bottom-left': 45,
        left: 0,
    };
    const directionDeg = (_g = directionMap[(_f = (_e = this.embossDirection) === null || _e === void 0 ? void 0 : _e.call(this)) !== null && _f !== void 0 ? _f : 'top-left']) !== null && _g !== void 0 ? _g : 315;
    const blend = !!((_j = (_h = this.embossBlend) === null || _h === void 0 ? void 0 : _h.call(this)) !== null && _j !== void 0 ? _j : false);
    const strength = strength01 * 10;
    const bias = whiteLevel01 * 255;
    const dirRad = (directionDeg * Math.PI) / 180;
    const cx = Math.cos(dirRad);
    const cy = Math.sin(dirRad);
    const SCALE = (128 / 1020) * strength;
    const src = new Uint8ClampedArray(data);
    const lum = new Float32Array(w * h);
    for (let p = 0, i = 0; i < data.length; i += 4, p++) {
        lum[p] = 0.2126 * src[i] + 0.7152 * src[i + 1] + 0.0722 * src[i + 2];
    }
    const Gx = [-1, 0, 1, -2, 0, 2, -1, 0, 1];
    const Gy = [-1, -2, -1, 0, 0, 0, 1, 2, 1];
    const OFF = [-w - 1, -w, -w + 1, -1, 0, 1, w - 1, w, w + 1];
    const clamp8 = (v) => (v < 0 ? 0 : v > 255 ? 255 : v);
    for (let y = 1; y < h - 1; y++) {
        for (let x = 1; x < w - 1; x++) {
            const p = y * w + x;
            let sx = 0, sy = 0;
            sx += lum[p + OFF[0]] * Gx[0];
            sy += lum[p + OFF[0]] * Gy[0];
            sx += lum[p + OFF[1]] * Gx[1];
            sy += lum[p + OFF[1]] * Gy[1];
            sx += lum[p + OFF[2]] * Gx[2];
            sy += lum[p + OFF[2]] * Gy[2];
            sx += lum[p + OFF[3]] * Gx[3];
            sy += lum[p + OFF[3]] * Gy[3];
            sx += lum[p + OFF[5]] * Gx[5];
            sy += lum[p + OFF[5]] * Gy[5];
            sx += lum[p + OFF[6]] * Gx[6];
            sy += lum[p + OFF[6]] * Gy[6];
            sx += lum[p + OFF[7]] * Gx[7];
            sy += lum[p + OFF[7]] * Gy[7];
            sx += lum[p + OFF[8]] * Gx[8];
            sy += lum[p + OFF[8]] * Gy[8];
            const r = cx * sx + cy * sy;
            const outGray = clamp8(bias + r * SCALE);
            const o = p * 4;
            if (blend) {
                const delta = outGray - bias;
                data[o] = clamp8(src[o] + delta);
                data[o + 1] = clamp8(src[o + 1] + delta);
                data[o + 2] = clamp8(src[o + 2] + delta);
                data[o + 3] = src[o + 3];
            }
            else {
                data[o] = data[o + 1] = data[o + 2] = outGray;
                data[o + 3] = src[o + 3];
            }
        }
    }
    for (let x = 0; x < w; x++) {
        let oTop = x * 4, oBot = ((h - 1) * w + x) * 4;
        data[oTop] = src[oTop];
        data[oTop + 1] = src[oTop + 1];
        data[oTop + 2] = src[oTop + 2];
        data[oTop + 3] = src[oTop + 3];
        data[oBot] = src[oBot];
        data[oBot + 1] = src[oBot + 1];
        data[oBot + 2] = src[oBot + 2];
        data[oBot + 3] = src[oBot + 3];
    }
    for (let y = 1; y < h - 1; y++) {
        let oL = y * w * 4, oR = (y * w + (w - 1)) * 4;
        data[oL] = src[oL];
        data[oL + 1] = src[oL + 1];
        data[oL + 2] = src[oL + 2];
        data[oL + 3] = src[oL + 3];
        data[oR] = src[oR];
        data[oR + 1] = src[oR + 1];
        data[oR + 2] = src[oR + 2];
        data[oR + 3] = src[oR + 3];
    }
    return imageData;
};
Factory.addGetterSetter(Node, 'embossStrength', 0.5, getNumberValidator(), Factory.afterSetFilter);
Factory.addGetterSetter(Node, 'embossWhiteLevel', 0.5, getNumberValidator(), Factory.afterSetFilter);
Factory.addGetterSetter(Node, 'embossDirection', 'top-left', undefined, Factory.afterSetFilter);
Factory.addGetterSetter(Node, 'embossBlend', false, undefined, Factory.afterSetFilter);

function remap(fromValue, fromMin, fromMax, toMin, toMax) {
    const fromRange = fromMax - fromMin, toRange = toMax - toMin;
    if (fromRange === 0) {
        return toMin + toRange / 2;
    }
    if (toRange === 0) {
        return toMin;
    }
    let toValue = (fromValue - fromMin) / fromRange;
    toValue = toRange * toValue + toMin;
    return toValue;
}
const Enhance = function (imageData) {
    const data = imageData.data, nSubPixels = data.length;
    let rMin = data[0], rMax = rMin, r, gMin = data[1], gMax = gMin, g, bMin = data[2], bMax = bMin, b;
    const enhanceAmount = this.enhance();
    if (enhanceAmount === 0) {
        return;
    }
    for (let i = 0; i < nSubPixels; i += 4) {
        r = data[i + 0];
        if (r < rMin) {
            rMin = r;
        }
        else if (r > rMax) {
            rMax = r;
        }
        g = data[i + 1];
        if (g < gMin) {
            gMin = g;
        }
        else if (g > gMax) {
            gMax = g;
        }
        b = data[i + 2];
        if (b < bMin) {
            bMin = b;
        }
        else if (b > bMax) {
            bMax = b;
        }
    }
    if (rMax === rMin) {
        rMax = 255;
        rMin = 0;
    }
    if (gMax === gMin) {
        gMax = 255;
        gMin = 0;
    }
    if (bMax === bMin) {
        bMax = 255;
        bMin = 0;
    }
    let rGoalMax, rGoalMin, gGoalMax, gGoalMin, bGoalMax, bGoalMin;
    if (enhanceAmount > 0) {
        rGoalMax = rMax + enhanceAmount * (255 - rMax);
        rGoalMin = rMin - enhanceAmount * (rMin - 0);
        gGoalMax = gMax + enhanceAmount * (255 - gMax);
        gGoalMin = gMin - enhanceAmount * (gMin - 0);
        bGoalMax = bMax + enhanceAmount * (255 - bMax);
        bGoalMin = bMin - enhanceAmount * (bMin - 0);
    }
    else {
        const rMid = (rMax + rMin) * 0.5;
        rGoalMax = rMax + enhanceAmount * (rMax - rMid);
        rGoalMin = rMin + enhanceAmount * (rMin - rMid);
        const gMid = (gMax + gMin) * 0.5;
        gGoalMax = gMax + enhanceAmount * (gMax - gMid);
        gGoalMin = gMin + enhanceAmount * (gMin - gMid);
        const bMid = (bMax + bMin) * 0.5;
        bGoalMax = bMax + enhanceAmount * (bMax - bMid);
        bGoalMin = bMin + enhanceAmount * (bMin - bMid);
    }
    for (let i = 0; i < nSubPixels; i += 4) {
        data[i + 0] = remap(data[i + 0], rMin, rMax, rGoalMin, rGoalMax);
        data[i + 1] = remap(data[i + 1], gMin, gMax, gGoalMin, gGoalMax);
        data[i + 2] = remap(data[i + 2], bMin, bMax, bGoalMin, bGoalMax);
    }
};
Factory.addGetterSetter(Node, 'enhance', 0, getNumberValidator(), Factory.afterSetFilter);

const Grayscale = function (imageData) {
    const data = imageData.data, len = data.length;
    for (let i = 0; i < len; i += 4) {
        const brightness = 0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2];
        data[i] = brightness;
        data[i + 1] = brightness;
        data[i + 2] = brightness;
    }
};

Factory.addGetterSetter(Node, 'hue', 0, getNumberValidator(), Factory.afterSetFilter);
Factory.addGetterSetter(Node, 'saturation', 0, getNumberValidator(), Factory.afterSetFilter);
Factory.addGetterSetter(Node, 'luminance', 0, getNumberValidator(), Factory.afterSetFilter);
const HSL = function (imageData) {
    const data = imageData.data, nPixels = data.length, v = 1, s = Math.pow(2, this.saturation()), h = Math.abs(this.hue() + 360) % 360, l = this.luminance() * 127;
    const vsu = v * s * Math.cos((h * Math.PI) / 180), vsw = v * s * Math.sin((h * Math.PI) / 180);
    const rr = 0.299 * v + 0.701 * vsu + 0.167 * vsw, rg = 0.587 * v - 0.587 * vsu + 0.33 * vsw, rb = 0.114 * v - 0.114 * vsu - 0.497 * vsw;
    const gr = 0.299 * v - 0.299 * vsu - 0.328 * vsw, gg = 0.587 * v + 0.413 * vsu + 0.035 * vsw, gb = 0.114 * v - 0.114 * vsu + 0.293 * vsw;
    const br = 0.299 * v - 0.3 * vsu + 1.25 * vsw, bg = 0.587 * v - 0.586 * vsu - 1.05 * vsw, bb = 0.114 * v + 0.886 * vsu - 0.2 * vsw;
    let r, g, b, a;
    for (let i = 0; i < nPixels; i += 4) {
        r = data[i + 0];
        g = data[i + 1];
        b = data[i + 2];
        a = data[i + 3];
        data[i + 0] = rr * r + rg * g + rb * b + l;
        data[i + 1] = gr * r + gg * g + gb * b + l;
        data[i + 2] = br * r + bg * g + bb * b + l;
        data[i + 3] = a;
    }
};

const HSV = function (imageData) {
    const data = imageData.data, nPixels = data.length, v = Math.pow(2, this.value()), s = Math.pow(2, this.saturation()), h = Math.abs(this.hue() + 360) % 360;
    const vsu = v * s * Math.cos((h * Math.PI) / 180), vsw = v * s * Math.sin((h * Math.PI) / 180);
    const rr = 0.299 * v + 0.701 * vsu + 0.167 * vsw, rg = 0.587 * v - 0.587 * vsu + 0.33 * vsw, rb = 0.114 * v - 0.114 * vsu - 0.497 * vsw;
    const gr = 0.299 * v - 0.299 * vsu - 0.328 * vsw, gg = 0.587 * v + 0.413 * vsu + 0.035 * vsw, gb = 0.114 * v - 0.114 * vsu + 0.293 * vsw;
    const br = 0.299 * v - 0.3 * vsu + 1.25 * vsw, bg = 0.587 * v - 0.586 * vsu - 1.05 * vsw, bb = 0.114 * v + 0.886 * vsu - 0.2 * vsw;
    for (let i = 0; i < nPixels; i += 4) {
        const r = data[i + 0];
        const g = data[i + 1];
        const b = data[i + 2];
        const a = data[i + 3];
        data[i + 0] = rr * r + rg * g + rb * b;
        data[i + 1] = gr * r + gg * g + gb * b;
        data[i + 2] = br * r + bg * g + bb * b;
        data[i + 3] = a;
    }
};
Factory.addGetterSetter(Node, 'hue', 0, getNumberValidator(), Factory.afterSetFilter);
Factory.addGetterSetter(Node, 'saturation', 0, getNumberValidator(), Factory.afterSetFilter);
Factory.addGetterSetter(Node, 'value', 0, getNumberValidator(), Factory.afterSetFilter);

const Invert = function (imageData) {
    const data = imageData.data, len = data.length;
    for (let i = 0; i < len; i += 4) {
        data[i] = 255 - data[i];
        data[i + 1] = 255 - data[i + 1];
        data[i + 2] = 255 - data[i + 2];
    }
};

const ToPolar = function (src, dst, opt) {
    const srcPixels = src.data, dstPixels = dst.data, xSize = src.width, ySize = src.height, xMid = opt.polarCenterX || xSize / 2, yMid = opt.polarCenterY || ySize / 2;
    let rMax = Math.sqrt(xMid * xMid + yMid * yMid);
    let x = xSize - xMid;
    let y = ySize - yMid;
    const rad = Math.sqrt(x * x + y * y);
    rMax = rad > rMax ? rad : rMax;
    const rSize = ySize, tSize = xSize;
    const conversion = ((360 / tSize) * Math.PI) / 180;
    for (let theta = 0; theta < tSize; theta += 1) {
        const sin = Math.sin(theta * conversion);
        const cos = Math.cos(theta * conversion);
        for (let radius = 0; radius < rSize; radius += 1) {
            x = Math.floor(xMid + ((rMax * radius) / rSize) * cos);
            y = Math.floor(yMid + ((rMax * radius) / rSize) * sin);
            let i = (y * xSize + x) * 4;
            const r = srcPixels[i + 0];
            const g = srcPixels[i + 1];
            const b = srcPixels[i + 2];
            const a = srcPixels[i + 3];
            i = (theta + radius * xSize) * 4;
            dstPixels[i + 0] = r;
            dstPixels[i + 1] = g;
            dstPixels[i + 2] = b;
            dstPixels[i + 3] = a;
        }
    }
};
const FromPolar = function (src, dst, opt) {
    const srcPixels = src.data, dstPixels = dst.data, xSize = src.width, ySize = src.height, xMid = opt.polarCenterX || xSize / 2, yMid = opt.polarCenterY || ySize / 2;
    let rMax = Math.sqrt(xMid * xMid + yMid * yMid);
    let x = xSize - xMid;
    let y = ySize - yMid;
    const rad = Math.sqrt(x * x + y * y);
    rMax = rad > rMax ? rad : rMax;
    const rSize = ySize, tSize = xSize, phaseShift = 0;
    let x1, y1;
    for (x = 0; x < xSize; x += 1) {
        for (y = 0; y < ySize; y += 1) {
            const dx = x - xMid;
            const dy = y - yMid;
            const radius = (Math.sqrt(dx * dx + dy * dy) * rSize) / rMax;
            let theta = ((Math.atan2(dy, dx) * 180) / Math.PI + 360 + phaseShift) % 360;
            theta = (theta * tSize) / 360;
            x1 = Math.floor(theta);
            y1 = Math.floor(radius);
            let i = (y1 * xSize + x1) * 4;
            const r = srcPixels[i + 0];
            const g = srcPixels[i + 1];
            const b = srcPixels[i + 2];
            const a = srcPixels[i + 3];
            i = (y * xSize + x) * 4;
            dstPixels[i + 0] = r;
            dstPixels[i + 1] = g;
            dstPixels[i + 2] = b;
            dstPixels[i + 3] = a;
        }
    }
};
const Kaleidoscope = function (imageData) {
    const xSize = imageData.width, ySize = imageData.height;
    let x, y, xoff, i, r, g, b, a, srcPos, dstPos;
    let power = Math.round(this.kaleidoscopePower());
    const angle = Math.round(this.kaleidoscopeAngle());
    const offset = Math.floor((xSize * (angle % 360)) / 360);
    if (power < 1) {
        return;
    }
    const tempCanvas = Util.createCanvasElement();
    tempCanvas.width = xSize;
    tempCanvas.height = ySize;
    const scratchData = tempCanvas
        .getContext('2d')
        .getImageData(0, 0, xSize, ySize);
    Util.releaseCanvas(tempCanvas);
    ToPolar(imageData, scratchData, {
        polarCenterX: xSize / 2,
        polarCenterY: ySize / 2,
    });
    let minSectionSize = xSize / Math.pow(2, power);
    while (minSectionSize <= 8) {
        minSectionSize = minSectionSize * 2;
        power -= 1;
    }
    minSectionSize = Math.ceil(minSectionSize);
    let sectionSize = minSectionSize;
    let xStart = 0, xEnd = sectionSize, xDelta = 1;
    if (offset + minSectionSize > xSize) {
        xStart = sectionSize;
        xEnd = 0;
        xDelta = -1;
    }
    for (y = 0; y < ySize; y += 1) {
        for (x = xStart; x !== xEnd; x += xDelta) {
            xoff = Math.round(x + offset) % xSize;
            srcPos = (xSize * y + xoff) * 4;
            r = scratchData.data[srcPos + 0];
            g = scratchData.data[srcPos + 1];
            b = scratchData.data[srcPos + 2];
            a = scratchData.data[srcPos + 3];
            dstPos = (xSize * y + x) * 4;
            scratchData.data[dstPos + 0] = r;
            scratchData.data[dstPos + 1] = g;
            scratchData.data[dstPos + 2] = b;
            scratchData.data[dstPos + 3] = a;
        }
    }
    for (y = 0; y < ySize; y += 1) {
        sectionSize = Math.floor(minSectionSize);
        for (i = 0; i < power; i += 1) {
            for (x = 0; x < sectionSize + 1; x += 1) {
                srcPos = (xSize * y + x) * 4;
                r = scratchData.data[srcPos + 0];
                g = scratchData.data[srcPos + 1];
                b = scratchData.data[srcPos + 2];
                a = scratchData.data[srcPos + 3];
                dstPos = (xSize * y + sectionSize * 2 - x - 1) * 4;
                scratchData.data[dstPos + 0] = r;
                scratchData.data[dstPos + 1] = g;
                scratchData.data[dstPos + 2] = b;
                scratchData.data[dstPos + 3] = a;
            }
            sectionSize *= 2;
        }
    }
    FromPolar(scratchData, imageData, { });
};
Factory.addGetterSetter(Node, 'kaleidoscopePower', 2, getNumberValidator(), Factory.afterSetFilter);
Factory.addGetterSetter(Node, 'kaleidoscopeAngle', 0, getNumberValidator(), Factory.afterSetFilter);

function pixelAt(idata, x, y) {
    let idx = (y * idata.width + x) * 4;
    const d = [];
    d.push(idata.data[idx++], idata.data[idx++], idata.data[idx++], idata.data[idx++]);
    return d;
}
function rgbDistance(p1, p2) {
    return Math.sqrt(Math.pow(p1[0] - p2[0], 2) +
        Math.pow(p1[1] - p2[1], 2) +
        Math.pow(p1[2] - p2[2], 2));
}
function rgbMean(pTab) {
    const m = [0, 0, 0];
    for (let i = 0; i < pTab.length; i++) {
        m[0] += pTab[i][0];
        m[1] += pTab[i][1];
        m[2] += pTab[i][2];
    }
    m[0] /= pTab.length;
    m[1] /= pTab.length;
    m[2] /= pTab.length;
    return m;
}
function backgroundMask(idata, threshold) {
    const rgbv_no = pixelAt(idata, 0, 0);
    const rgbv_ne = pixelAt(idata, idata.width - 1, 0);
    const rgbv_so = pixelAt(idata, 0, idata.height - 1);
    const rgbv_se = pixelAt(idata, idata.width - 1, idata.height - 1);
    const thres = threshold || 10;
    if (rgbDistance(rgbv_no, rgbv_ne) < thres &&
        rgbDistance(rgbv_ne, rgbv_se) < thres &&
        rgbDistance(rgbv_se, rgbv_so) < thres &&
        rgbDistance(rgbv_so, rgbv_no) < thres) {
        const mean = rgbMean([rgbv_ne, rgbv_no, rgbv_se, rgbv_so]);
        const mask = [];
        for (let i = 0; i < idata.width * idata.height; i++) {
            const d = rgbDistance(mean, [
                idata.data[i * 4],
                idata.data[i * 4 + 1],
                idata.data[i * 4 + 2],
            ]);
            mask[i] = d < thres ? 0 : 255;
        }
        return mask;
    }
}
function applyMask(idata, mask) {
    for (let i = 0; i < idata.width * idata.height; i++) {
        idata.data[4 * i + 3] = mask[i];
    }
}
function erodeMask(mask, sw, sh) {
    const weights = [1, 1, 1, 1, 0, 1, 1, 1, 1];
    const side = Math.round(Math.sqrt(weights.length));
    const halfSide = Math.floor(side / 2);
    const maskResult = [];
    for (let y = 0; y < sh; y++) {
        for (let x = 0; x < sw; x++) {
            const so = y * sw + x;
            let a = 0;
            for (let cy = 0; cy < side; cy++) {
                for (let cx = 0; cx < side; cx++) {
                    const scy = y + cy - halfSide;
                    const scx = x + cx - halfSide;
                    if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                        const srcOff = scy * sw + scx;
                        const wt = weights[cy * side + cx];
                        a += mask[srcOff] * wt;
                    }
                }
            }
            maskResult[so] = a === 255 * 8 ? 255 : 0;
        }
    }
    return maskResult;
}
function dilateMask(mask, sw, sh) {
    const weights = [1, 1, 1, 1, 1, 1, 1, 1, 1];
    const side = Math.round(Math.sqrt(weights.length));
    const halfSide = Math.floor(side / 2);
    const maskResult = [];
    for (let y = 0; y < sh; y++) {
        for (let x = 0; x < sw; x++) {
            const so = y * sw + x;
            let a = 0;
            for (let cy = 0; cy < side; cy++) {
                for (let cx = 0; cx < side; cx++) {
                    const scy = y + cy - halfSide;
                    const scx = x + cx - halfSide;
                    if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                        const srcOff = scy * sw + scx;
                        const wt = weights[cy * side + cx];
                        a += mask[srcOff] * wt;
                    }
                }
            }
            maskResult[so] = a >= 255 * 4 ? 255 : 0;
        }
    }
    return maskResult;
}
function smoothEdgeMask(mask, sw, sh) {
    const weights = [
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
    ];
    const side = Math.round(Math.sqrt(weights.length));
    const halfSide = Math.floor(side / 2);
    const maskResult = [];
    for (let y = 0; y < sh; y++) {
        for (let x = 0; x < sw; x++) {
            const so = y * sw + x;
            let a = 0;
            for (let cy = 0; cy < side; cy++) {
                for (let cx = 0; cx < side; cx++) {
                    const scy = y + cy - halfSide;
                    const scx = x + cx - halfSide;
                    if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                        const srcOff = scy * sw + scx;
                        const wt = weights[cy * side + cx];
                        a += mask[srcOff] * wt;
                    }
                }
            }
            maskResult[so] = a;
        }
    }
    return maskResult;
}
const Mask = function (imageData) {
    const threshold = this.threshold();
    let mask = backgroundMask(imageData, threshold);
    if (mask) {
        mask = erodeMask(mask, imageData.width, imageData.height);
        mask = dilateMask(mask, imageData.width, imageData.height);
        mask = smoothEdgeMask(mask, imageData.width, imageData.height);
        applyMask(imageData, mask);
    }
    return imageData;
};
Factory.addGetterSetter(Node, 'threshold', 0, getNumberValidator(), Factory.afterSetFilter);

const Noise = function (imageData) {
    const amount = this.noise() * 255, data = imageData.data, nPixels = data.length, half = amount / 2;
    for (let i = 0; i < nPixels; i += 4) {
        data[i + 0] += half - 2 * half * Math.random();
        data[i + 1] += half - 2 * half * Math.random();
        data[i + 2] += half - 2 * half * Math.random();
    }
};
Factory.addGetterSetter(Node, 'noise', 0.2, getNumberValidator(), Factory.afterSetFilter);

const Pixelate = function (imageData) {
    let pixelSize = Math.ceil(this.pixelSize()), width = imageData.width, height = imageData.height, nBinsX = Math.ceil(width / pixelSize), nBinsY = Math.ceil(height / pixelSize), data = imageData.data;
    if (pixelSize <= 0) {
        Util.error('pixelSize value can not be <= 0');
        return;
    }
    for (let xBin = 0; xBin < nBinsX; xBin += 1) {
        for (let yBin = 0; yBin < nBinsY; yBin += 1) {
            let red = 0;
            let green = 0;
            let blue = 0;
            let alpha = 0;
            const xBinStart = xBin * pixelSize;
            const xBinEnd = xBinStart + pixelSize;
            const yBinStart = yBin * pixelSize;
            const yBinEnd = yBinStart + pixelSize;
            let pixelsInBin = 0;
            for (let x = xBinStart; x < xBinEnd; x += 1) {
                if (x >= width) {
                    continue;
                }
                for (let y = yBinStart; y < yBinEnd; y += 1) {
                    if (y >= height) {
                        continue;
                    }
                    const i = (width * y + x) * 4;
                    red += data[i + 0];
                    green += data[i + 1];
                    blue += data[i + 2];
                    alpha += data[i + 3];
                    pixelsInBin += 1;
                }
            }
            red = red / pixelsInBin;
            green = green / pixelsInBin;
            blue = blue / pixelsInBin;
            alpha = alpha / pixelsInBin;
            for (let x = xBinStart; x < xBinEnd; x += 1) {
                if (x >= width) {
                    continue;
                }
                for (let y = yBinStart; y < yBinEnd; y += 1) {
                    if (y >= height) {
                        continue;
                    }
                    const i = (width * y + x) * 4;
                    data[i + 0] = red;
                    data[i + 1] = green;
                    data[i + 2] = blue;
                    data[i + 3] = alpha;
                }
            }
        }
    }
};
Factory.addGetterSetter(Node, 'pixelSize', 8, getNumberValidator(), Factory.afterSetFilter);

const Posterize = function (imageData) {
    const levels = Math.round(this.levels() * 254) + 1, data = imageData.data, len = data.length, scale = 255 / levels;
    for (let i = 0; i < len; i += 1) {
        data[i] = Math.floor(data[i] / scale) * scale;
    }
};
Factory.addGetterSetter(Node, 'levels', 0.5, getNumberValidator(), Factory.afterSetFilter);

const RGB = function (imageData) {
    const data = imageData.data, nPixels = data.length, red = this.red(), green = this.green(), blue = this.blue();
    for (let i = 0; i < nPixels; i += 4) {
        const brightness = (0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2]) / 255;
        data[i] = brightness * red;
        data[i + 1] = brightness * green;
        data[i + 2] = brightness * blue;
        data[i + 3] = data[i + 3];
    }
};
Factory.addGetterSetter(Node, 'red', 0, function (val) {
    this._filterUpToDate = false;
    if (val > 255) {
        return 255;
    }
    else if (val < 0) {
        return 0;
    }
    else {
        return Math.round(val);
    }
});
Factory.addGetterSetter(Node, 'green', 0, function (val) {
    this._filterUpToDate = false;
    if (val > 255) {
        return 255;
    }
    else if (val < 0) {
        return 0;
    }
    else {
        return Math.round(val);
    }
});
Factory.addGetterSetter(Node, 'blue', 0, RGBComponent, Factory.afterSetFilter);

const RGBA = function (imageData) {
    const data = imageData.data, nPixels = data.length, red = this.red(), green = this.green(), blue = this.blue(), alpha = this.alpha();
    for (let i = 0; i < nPixels; i += 4) {
        const ia = 1 - alpha;
        data[i] = red * alpha + data[i] * ia;
        data[i + 1] = green * alpha + data[i + 1] * ia;
        data[i + 2] = blue * alpha + data[i + 2] * ia;
    }
};
Factory.addGetterSetter(Node, 'red', 0, function (val) {
    this._filterUpToDate = false;
    if (val > 255) {
        return 255;
    }
    else if (val < 0) {
        return 0;
    }
    else {
        return Math.round(val);
    }
});
Factory.addGetterSetter(Node, 'green', 0, function (val) {
    this._filterUpToDate = false;
    if (val > 255) {
        return 255;
    }
    else if (val < 0) {
        return 0;
    }
    else {
        return Math.round(val);
    }
});
Factory.addGetterSetter(Node, 'blue', 0, RGBComponent, Factory.afterSetFilter);
Factory.addGetterSetter(Node, 'alpha', 1, function (val) {
    this._filterUpToDate = false;
    if (val > 1) {
        return 1;
    }
    else if (val < 0) {
        return 0;
    }
    else {
        return val;
    }
});

const Sepia = function (imageData) {
    const data = imageData.data, nPixels = data.length;
    for (let i = 0; i < nPixels; i += 4) {
        const r = data[i + 0];
        const g = data[i + 1];
        const b = data[i + 2];
        data[i + 0] = Math.min(255, r * 0.393 + g * 0.769 + b * 0.189);
        data[i + 1] = Math.min(255, r * 0.349 + g * 0.686 + b * 0.168);
        data[i + 2] = Math.min(255, r * 0.272 + g * 0.534 + b * 0.131);
    }
};

const Solarize = function (imageData) {
    const threshold = 128;
    const d = imageData.data;
    for (let i = 0; i < d.length; i += 4) {
        const r = d[i], g = d[i + 1], b = d[i + 2];
        const L = 0.2126 * r + 0.7152 * g + 0.0722 * b;
        if (L >= threshold) {
            d[i] = 255 - r;
            d[i + 1] = 255 - g;
            d[i + 2] = 255 - b;
        }
    }
    return imageData;
};

const Threshold = function (imageData) {
    const level = this.threshold() * 255, data = imageData.data, len = data.length;
    for (let i = 0; i < len; i += 1) {
        data[i] = data[i] < level ? 0 : 255;
    }
};
Factory.addGetterSetter(Node, 'threshold', 0.5, getNumberValidator(), Factory.afterSetFilter);

Konva.Util._assign(Konva, {
    Arc,
    Arrow: Arrow$1,
    Circle: Circle$1,
    Ellipse,
    Image: Image$2,
    Label: Label$1,
    Tag,
    Line: Line$1,
    Path,
    Rect: Rect$1,
    RegularPolygon,
    Ring,
    Sprite,
    Star,
    Text: Text$1,
    TextPath,
    Transformer,
    Wedge,
    Filters: {
        Blur,
        Brightness,
        Brighten,
        Contrast,
        Emboss,
        Enhance,
        Grayscale,
        HSL,
        HSV,
        Invert,
        Kaleidoscope,
        Mask,
        Noise,
        Pixelate,
        Posterize,
        RGB,
        RGBA,
        Sepia,
        Solarize,
        Threshold,
    },
});

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var reactReconciler = {exports: {}};

var reactReconciler_production = {exports: {}};

var scheduler = {exports: {}};

var scheduler_production = {};

/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredScheduler_production;

function requireScheduler_production () {
	if (hasRequiredScheduler_production) return scheduler_production;
	hasRequiredScheduler_production = 1;
	(function (exports$1) {
		function push(heap, node) {
		  var index = heap.length;
		  heap.push(node);
		  a: for (; 0 < index; ) {
		    var parentIndex = (index - 1) >>> 1,
		      parent = heap[parentIndex];
		    if (0 < compare(parent, node))
		      (heap[parentIndex] = node), (heap[index] = parent), (index = parentIndex);
		    else break a;
		  }
		}
		function peek(heap) {
		  return 0 === heap.length ? null : heap[0];
		}
		function pop(heap) {
		  if (0 === heap.length) return null;
		  var first = heap[0],
		    last = heap.pop();
		  if (last !== first) {
		    heap[0] = last;
		    a: for (
		      var index = 0, length = heap.length, halfLength = length >>> 1;
		      index < halfLength;

		    ) {
		      var leftIndex = 2 * (index + 1) - 1,
		        left = heap[leftIndex],
		        rightIndex = leftIndex + 1,
		        right = heap[rightIndex];
		      if (0 > compare(left, last))
		        rightIndex < length && 0 > compare(right, left)
		          ? ((heap[index] = right),
		            (heap[rightIndex] = last),
		            (index = rightIndex))
		          : ((heap[index] = left),
		            (heap[leftIndex] = last),
		            (index = leftIndex));
		      else if (rightIndex < length && 0 > compare(right, last))
		        (heap[index] = right), (heap[rightIndex] = last), (index = rightIndex);
		      else break a;
		    }
		  }
		  return first;
		}
		function compare(a, b) {
		  var diff = a.sortIndex - b.sortIndex;
		  return 0 !== diff ? diff : a.id - b.id;
		}
		exports$1.unstable_now = void 0;
		if ("object" === typeof performance && "function" === typeof performance.now) {
		  var localPerformance = performance;
		  exports$1.unstable_now = function () {
		    return localPerformance.now();
		  };
		} else {
		  var localDate = Date,
		    initialTime = localDate.now();
		  exports$1.unstable_now = function () {
		    return localDate.now() - initialTime;
		  };
		}
		var taskQueue = [],
		  timerQueue = [],
		  taskIdCounter = 1,
		  currentTask = null,
		  currentPriorityLevel = 3,
		  isPerformingWork = false,
		  isHostCallbackScheduled = false,
		  isHostTimeoutScheduled = false,
		  needsPaint = false,
		  localSetTimeout = "function" === typeof setTimeout ? setTimeout : null,
		  localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null,
		  localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
		function advanceTimers(currentTime) {
		  for (var timer = peek(timerQueue); null !== timer; ) {
		    if (null === timer.callback) pop(timerQueue);
		    else if (timer.startTime <= currentTime)
		      pop(timerQueue),
		        (timer.sortIndex = timer.expirationTime),
		        push(taskQueue, timer);
		    else break;
		    timer = peek(timerQueue);
		  }
		}
		function handleTimeout(currentTime) {
		  isHostTimeoutScheduled = false;
		  advanceTimers(currentTime);
		  if (!isHostCallbackScheduled)
		    if (null !== peek(taskQueue))
		      (isHostCallbackScheduled = true),
		        isMessageLoopRunning ||
		          ((isMessageLoopRunning = true), schedulePerformWorkUntilDeadline());
		    else {
		      var firstTimer = peek(timerQueue);
		      null !== firstTimer &&
		        requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
		    }
		}
		var isMessageLoopRunning = false,
		  taskTimeoutID = -1,
		  frameInterval = 5,
		  startTime = -1;
		function shouldYieldToHost() {
		  return needsPaint
		    ? true
		    : exports$1.unstable_now() - startTime < frameInterval
		      ? false
		      : true;
		}
		function performWorkUntilDeadline() {
		  needsPaint = false;
		  if (isMessageLoopRunning) {
		    var currentTime = exports$1.unstable_now();
		    startTime = currentTime;
		    var hasMoreWork = true;
		    try {
		      a: {
		        isHostCallbackScheduled = !1;
		        isHostTimeoutScheduled &&
		          ((isHostTimeoutScheduled = !1),
		          localClearTimeout(taskTimeoutID),
		          (taskTimeoutID = -1));
		        isPerformingWork = !0;
		        var previousPriorityLevel = currentPriorityLevel;
		        try {
		          b: {
		            advanceTimers(currentTime);
		            for (
		              currentTask = peek(taskQueue);
		              null !== currentTask &&
		              !(
		                currentTask.expirationTime > currentTime && shouldYieldToHost()
		              );

		            ) {
		              var callback = currentTask.callback;
		              if ("function" === typeof callback) {
		                currentTask.callback = null;
		                currentPriorityLevel = currentTask.priorityLevel;
		                var continuationCallback = callback(
		                  currentTask.expirationTime <= currentTime
		                );
		                currentTime = exports$1.unstable_now();
		                if ("function" === typeof continuationCallback) {
		                  currentTask.callback = continuationCallback;
		                  advanceTimers(currentTime);
		                  hasMoreWork = !0;
		                  break b;
		                }
		                currentTask === peek(taskQueue) && pop(taskQueue);
		                advanceTimers(currentTime);
		              } else pop(taskQueue);
		              currentTask = peek(taskQueue);
		            }
		            if (null !== currentTask) hasMoreWork = !0;
		            else {
		              var firstTimer = peek(timerQueue);
		              null !== firstTimer &&
		                requestHostTimeout(
		                  handleTimeout,
		                  firstTimer.startTime - currentTime
		                );
		              hasMoreWork = !1;
		            }
		          }
		          break a;
		        } finally {
		          (currentTask = null),
		            (currentPriorityLevel = previousPriorityLevel),
		            (isPerformingWork = !1);
		        }
		        hasMoreWork = void 0;
		      }
		    } finally {
		      hasMoreWork
		        ? schedulePerformWorkUntilDeadline()
		        : (isMessageLoopRunning = false);
		    }
		  }
		}
		var schedulePerformWorkUntilDeadline;
		if ("function" === typeof localSetImmediate)
		  schedulePerformWorkUntilDeadline = function () {
		    localSetImmediate(performWorkUntilDeadline);
		  };
		else if ("undefined" !== typeof MessageChannel) {
		  var channel = new MessageChannel(),
		    port = channel.port2;
		  channel.port1.onmessage = performWorkUntilDeadline;
		  schedulePerformWorkUntilDeadline = function () {
		    port.postMessage(null);
		  };
		} else
		  schedulePerformWorkUntilDeadline = function () {
		    localSetTimeout(performWorkUntilDeadline, 0);
		  };
		function requestHostTimeout(callback, ms) {
		  taskTimeoutID = localSetTimeout(function () {
		    callback(exports$1.unstable_now());
		  }, ms);
		}
		exports$1.unstable_IdlePriority = 5;
		exports$1.unstable_ImmediatePriority = 1;
		exports$1.unstable_LowPriority = 4;
		exports$1.unstable_NormalPriority = 3;
		exports$1.unstable_Profiling = null;
		exports$1.unstable_UserBlockingPriority = 2;
		exports$1.unstable_cancelCallback = function (task) {
		  task.callback = null;
		};
		exports$1.unstable_forceFrameRate = function (fps) {
		  0 > fps || 125 < fps
		    ? console.error(
		        "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
		      )
		    : (frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5);
		};
		exports$1.unstable_getCurrentPriorityLevel = function () {
		  return currentPriorityLevel;
		};
		exports$1.unstable_next = function (eventHandler) {
		  switch (currentPriorityLevel) {
		    case 1:
		    case 2:
		    case 3:
		      var priorityLevel = 3;
		      break;
		    default:
		      priorityLevel = currentPriorityLevel;
		  }
		  var previousPriorityLevel = currentPriorityLevel;
		  currentPriorityLevel = priorityLevel;
		  try {
		    return eventHandler();
		  } finally {
		    currentPriorityLevel = previousPriorityLevel;
		  }
		};
		exports$1.unstable_requestPaint = function () {
		  needsPaint = true;
		};
		exports$1.unstable_runWithPriority = function (priorityLevel, eventHandler) {
		  switch (priorityLevel) {
		    case 1:
		    case 2:
		    case 3:
		    case 4:
		    case 5:
		      break;
		    default:
		      priorityLevel = 3;
		  }
		  var previousPriorityLevel = currentPriorityLevel;
		  currentPriorityLevel = priorityLevel;
		  try {
		    return eventHandler();
		  } finally {
		    currentPriorityLevel = previousPriorityLevel;
		  }
		};
		exports$1.unstable_scheduleCallback = function (
		  priorityLevel,
		  callback,
		  options
		) {
		  var currentTime = exports$1.unstable_now();
		  "object" === typeof options && null !== options
		    ? ((options = options.delay),
		      (options =
		        "number" === typeof options && 0 < options
		          ? currentTime + options
		          : currentTime))
		    : (options = currentTime);
		  switch (priorityLevel) {
		    case 1:
		      var timeout = -1;
		      break;
		    case 2:
		      timeout = 250;
		      break;
		    case 5:
		      timeout = 1073741823;
		      break;
		    case 4:
		      timeout = 1e4;
		      break;
		    default:
		      timeout = 5e3;
		  }
		  timeout = options + timeout;
		  priorityLevel = {
		    id: taskIdCounter++,
		    callback: callback,
		    priorityLevel: priorityLevel,
		    startTime: options,
		    expirationTime: timeout,
		    sortIndex: -1
		  };
		  options > currentTime
		    ? ((priorityLevel.sortIndex = options),
		      push(timerQueue, priorityLevel),
		      null === peek(taskQueue) &&
		        priorityLevel === peek(timerQueue) &&
		        (isHostTimeoutScheduled
		          ? (localClearTimeout(taskTimeoutID), (taskTimeoutID = -1))
		          : (isHostTimeoutScheduled = true),
		        requestHostTimeout(handleTimeout, options - currentTime)))
		    : ((priorityLevel.sortIndex = timeout),
		      push(taskQueue, priorityLevel),
		      isHostCallbackScheduled ||
		        isPerformingWork ||
		        ((isHostCallbackScheduled = true),
		        isMessageLoopRunning ||
		          ((isMessageLoopRunning = true), schedulePerformWorkUntilDeadline())));
		  return priorityLevel;
		};
		exports$1.unstable_shouldYield = shouldYieldToHost;
		exports$1.unstable_wrapCallback = function (callback) {
		  var parentPriorityLevel = currentPriorityLevel;
		  return function () {
		    var previousPriorityLevel = currentPriorityLevel;
		    currentPriorityLevel = parentPriorityLevel;
		    try {
		      return callback.apply(this, arguments);
		    } finally {
		      currentPriorityLevel = previousPriorityLevel;
		    }
		  };
		}; 
	} (scheduler_production));
	return scheduler_production;
}

var scheduler_development = {};

/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredScheduler_development;

function requireScheduler_development () {
	if (hasRequiredScheduler_development) return scheduler_development;
	hasRequiredScheduler_development = 1;
	(function (exports$1) {
		"production" !== process.env.NODE_ENV &&
		  (function () {
		    function performWorkUntilDeadline() {
		      needsPaint = false;
		      if (isMessageLoopRunning) {
		        var currentTime = exports$1.unstable_now();
		        startTime = currentTime;
		        var hasMoreWork = true;
		        try {
		          a: {
		            isHostCallbackScheduled = !1;
		            isHostTimeoutScheduled &&
		              ((isHostTimeoutScheduled = !1),
		              localClearTimeout(taskTimeoutID),
		              (taskTimeoutID = -1));
		            isPerformingWork = !0;
		            var previousPriorityLevel = currentPriorityLevel;
		            try {
		              b: {
		                advanceTimers(currentTime);
		                for (
		                  currentTask = peek(taskQueue);
		                  null !== currentTask &&
		                  !(
		                    currentTask.expirationTime > currentTime &&
		                    shouldYieldToHost()
		                  );

		                ) {
		                  var callback = currentTask.callback;
		                  if ("function" === typeof callback) {
		                    currentTask.callback = null;
		                    currentPriorityLevel = currentTask.priorityLevel;
		                    var continuationCallback = callback(
		                      currentTask.expirationTime <= currentTime
		                    );
		                    currentTime = exports$1.unstable_now();
		                    if ("function" === typeof continuationCallback) {
		                      currentTask.callback = continuationCallback;
		                      advanceTimers(currentTime);
		                      hasMoreWork = !0;
		                      break b;
		                    }
		                    currentTask === peek(taskQueue) && pop(taskQueue);
		                    advanceTimers(currentTime);
		                  } else pop(taskQueue);
		                  currentTask = peek(taskQueue);
		                }
		                if (null !== currentTask) hasMoreWork = !0;
		                else {
		                  var firstTimer = peek(timerQueue);
		                  null !== firstTimer &&
		                    requestHostTimeout(
		                      handleTimeout,
		                      firstTimer.startTime - currentTime
		                    );
		                  hasMoreWork = !1;
		                }
		              }
		              break a;
		            } finally {
		              (currentTask = null),
		                (currentPriorityLevel = previousPriorityLevel),
		                (isPerformingWork = !1);
		            }
		            hasMoreWork = void 0;
		          }
		        } finally {
		          hasMoreWork
		            ? schedulePerformWorkUntilDeadline()
		            : (isMessageLoopRunning = false);
		        }
		      }
		    }
		    function push(heap, node) {
		      var index = heap.length;
		      heap.push(node);
		      a: for (; 0 < index; ) {
		        var parentIndex = (index - 1) >>> 1,
		          parent = heap[parentIndex];
		        if (0 < compare(parent, node))
		          (heap[parentIndex] = node),
		            (heap[index] = parent),
		            (index = parentIndex);
		        else break a;
		      }
		    }
		    function peek(heap) {
		      return 0 === heap.length ? null : heap[0];
		    }
		    function pop(heap) {
		      if (0 === heap.length) return null;
		      var first = heap[0],
		        last = heap.pop();
		      if (last !== first) {
		        heap[0] = last;
		        a: for (
		          var index = 0, length = heap.length, halfLength = length >>> 1;
		          index < halfLength;

		        ) {
		          var leftIndex = 2 * (index + 1) - 1,
		            left = heap[leftIndex],
		            rightIndex = leftIndex + 1,
		            right = heap[rightIndex];
		          if (0 > compare(left, last))
		            rightIndex < length && 0 > compare(right, left)
		              ? ((heap[index] = right),
		                (heap[rightIndex] = last),
		                (index = rightIndex))
		              : ((heap[index] = left),
		                (heap[leftIndex] = last),
		                (index = leftIndex));
		          else if (rightIndex < length && 0 > compare(right, last))
		            (heap[index] = right),
		              (heap[rightIndex] = last),
		              (index = rightIndex);
		          else break a;
		        }
		      }
		      return first;
		    }
		    function compare(a, b) {
		      var diff = a.sortIndex - b.sortIndex;
		      return 0 !== diff ? diff : a.id - b.id;
		    }
		    function advanceTimers(currentTime) {
		      for (var timer = peek(timerQueue); null !== timer; ) {
		        if (null === timer.callback) pop(timerQueue);
		        else if (timer.startTime <= currentTime)
		          pop(timerQueue),
		            (timer.sortIndex = timer.expirationTime),
		            push(taskQueue, timer);
		        else break;
		        timer = peek(timerQueue);
		      }
		    }
		    function handleTimeout(currentTime) {
		      isHostTimeoutScheduled = false;
		      advanceTimers(currentTime);
		      if (!isHostCallbackScheduled)
		        if (null !== peek(taskQueue))
		          (isHostCallbackScheduled = true),
		            isMessageLoopRunning ||
		              ((isMessageLoopRunning = true), schedulePerformWorkUntilDeadline());
		        else {
		          var firstTimer = peek(timerQueue);
		          null !== firstTimer &&
		            requestHostTimeout(
		              handleTimeout,
		              firstTimer.startTime - currentTime
		            );
		        }
		    }
		    function shouldYieldToHost() {
		      return needsPaint
		        ? true
		        : exports$1.unstable_now() - startTime < frameInterval
		          ? false
		          : true;
		    }
		    function requestHostTimeout(callback, ms) {
		      taskTimeoutID = localSetTimeout(function () {
		        callback(exports$1.unstable_now());
		      }, ms);
		    }
		    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ &&
		      "function" ===
		        typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart &&
		      __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
		    exports$1.unstable_now = void 0;
		    if (
		      "object" === typeof performance &&
		      "function" === typeof performance.now
		    ) {
		      var localPerformance = performance;
		      exports$1.unstable_now = function () {
		        return localPerformance.now();
		      };
		    } else {
		      var localDate = Date,
		        initialTime = localDate.now();
		      exports$1.unstable_now = function () {
		        return localDate.now() - initialTime;
		      };
		    }
		    var taskQueue = [],
		      timerQueue = [],
		      taskIdCounter = 1,
		      currentTask = null,
		      currentPriorityLevel = 3,
		      isPerformingWork = false,
		      isHostCallbackScheduled = false,
		      isHostTimeoutScheduled = false,
		      needsPaint = false,
		      localSetTimeout = "function" === typeof setTimeout ? setTimeout : null,
		      localClearTimeout =
		        "function" === typeof clearTimeout ? clearTimeout : null,
		      localSetImmediate =
		        "undefined" !== typeof setImmediate ? setImmediate : null,
		      isMessageLoopRunning = false,
		      taskTimeoutID = -1,
		      frameInterval = 5,
		      startTime = -1;
		    if ("function" === typeof localSetImmediate)
		      var schedulePerformWorkUntilDeadline = function () {
		        localSetImmediate(performWorkUntilDeadline);
		      };
		    else if ("undefined" !== typeof MessageChannel) {
		      var channel = new MessageChannel(),
		        port = channel.port2;
		      channel.port1.onmessage = performWorkUntilDeadline;
		      schedulePerformWorkUntilDeadline = function () {
		        port.postMessage(null);
		      };
		    } else
		      schedulePerformWorkUntilDeadline = function () {
		        localSetTimeout(performWorkUntilDeadline, 0);
		      };
		    exports$1.unstable_IdlePriority = 5;
		    exports$1.unstable_ImmediatePriority = 1;
		    exports$1.unstable_LowPriority = 4;
		    exports$1.unstable_NormalPriority = 3;
		    exports$1.unstable_Profiling = null;
		    exports$1.unstable_UserBlockingPriority = 2;
		    exports$1.unstable_cancelCallback = function (task) {
		      task.callback = null;
		    };
		    exports$1.unstable_forceFrameRate = function (fps) {
		      0 > fps || 125 < fps
		        ? console.error(
		            "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
		          )
		        : (frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5);
		    };
		    exports$1.unstable_getCurrentPriorityLevel = function () {
		      return currentPriorityLevel;
		    };
		    exports$1.unstable_next = function (eventHandler) {
		      switch (currentPriorityLevel) {
		        case 1:
		        case 2:
		        case 3:
		          var priorityLevel = 3;
		          break;
		        default:
		          priorityLevel = currentPriorityLevel;
		      }
		      var previousPriorityLevel = currentPriorityLevel;
		      currentPriorityLevel = priorityLevel;
		      try {
		        return eventHandler();
		      } finally {
		        currentPriorityLevel = previousPriorityLevel;
		      }
		    };
		    exports$1.unstable_requestPaint = function () {
		      needsPaint = true;
		    };
		    exports$1.unstable_runWithPriority = function (priorityLevel, eventHandler) {
		      switch (priorityLevel) {
		        case 1:
		        case 2:
		        case 3:
		        case 4:
		        case 5:
		          break;
		        default:
		          priorityLevel = 3;
		      }
		      var previousPriorityLevel = currentPriorityLevel;
		      currentPriorityLevel = priorityLevel;
		      try {
		        return eventHandler();
		      } finally {
		        currentPriorityLevel = previousPriorityLevel;
		      }
		    };
		    exports$1.unstable_scheduleCallback = function (
		      priorityLevel,
		      callback,
		      options
		    ) {
		      var currentTime = exports$1.unstable_now();
		      "object" === typeof options && null !== options
		        ? ((options = options.delay),
		          (options =
		            "number" === typeof options && 0 < options
		              ? currentTime + options
		              : currentTime))
		        : (options = currentTime);
		      switch (priorityLevel) {
		        case 1:
		          var timeout = -1;
		          break;
		        case 2:
		          timeout = 250;
		          break;
		        case 5:
		          timeout = 1073741823;
		          break;
		        case 4:
		          timeout = 1e4;
		          break;
		        default:
		          timeout = 5e3;
		      }
		      timeout = options + timeout;
		      priorityLevel = {
		        id: taskIdCounter++,
		        callback: callback,
		        priorityLevel: priorityLevel,
		        startTime: options,
		        expirationTime: timeout,
		        sortIndex: -1
		      };
		      options > currentTime
		        ? ((priorityLevel.sortIndex = options),
		          push(timerQueue, priorityLevel),
		          null === peek(taskQueue) &&
		            priorityLevel === peek(timerQueue) &&
		            (isHostTimeoutScheduled
		              ? (localClearTimeout(taskTimeoutID), (taskTimeoutID = -1))
		              : (isHostTimeoutScheduled = true),
		            requestHostTimeout(handleTimeout, options - currentTime)))
		        : ((priorityLevel.sortIndex = timeout),
		          push(taskQueue, priorityLevel),
		          isHostCallbackScheduled ||
		            isPerformingWork ||
		            ((isHostCallbackScheduled = true),
		            isMessageLoopRunning ||
		              ((isMessageLoopRunning = true),
		              schedulePerformWorkUntilDeadline())));
		      return priorityLevel;
		    };
		    exports$1.unstable_shouldYield = shouldYieldToHost;
		    exports$1.unstable_wrapCallback = function (callback) {
		      var parentPriorityLevel = currentPriorityLevel;
		      return function () {
		        var previousPriorityLevel = currentPriorityLevel;
		        currentPriorityLevel = parentPriorityLevel;
		        try {
		          return callback.apply(this, arguments);
		        } finally {
		          currentPriorityLevel = previousPriorityLevel;
		        }
		      };
		    };
		    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ &&
		      "function" ===
		        typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop &&
		      __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
		  })(); 
	} (scheduler_development));
	return scheduler_development;
}

var hasRequiredScheduler;

function requireScheduler () {
	if (hasRequiredScheduler) return scheduler.exports;
	hasRequiredScheduler = 1;

	if (process.env.NODE_ENV === 'production') {
	  scheduler.exports = requireScheduler_production();
	} else {
	  scheduler.exports = requireScheduler_development();
	}
	return scheduler.exports;
}

/**
 * @license React
 * react-reconciler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactReconciler_production;

function requireReactReconciler_production () {
	if (hasRequiredReactReconciler_production) return reactReconciler_production.exports;
	hasRequiredReactReconciler_production = 1;
	(function (module) {
		module.exports = function ($$$config) {
		  function createFiber(tag, pendingProps, key, mode) {
		    return new FiberNode(tag, pendingProps, key, mode);
		  }
		  function noop() {}
		  function formatProdErrorMessage(code) {
		    var url = "https://react.dev/errors/" + code;
		    if (1 < arguments.length) {
		      url += "?args[]=" + encodeURIComponent(arguments[1]);
		      for (var i = 2; i < arguments.length; i++)
		        url += "&args[]=" + encodeURIComponent(arguments[i]);
		    }
		    return (
		      "Minified React error #" +
		      code +
		      "; visit " +
		      url +
		      " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
		    );
		  }
		  function getNearestMountedFiber(fiber) {
		    var node = fiber,
		      nearestMounted = fiber;
		    if (fiber.alternate) for (; node.return; ) node = node.return;
		    else {
		      fiber = node;
		      do
		        (node = fiber),
		          0 !== (node.flags & 4098) && (nearestMounted = node.return),
		          (fiber = node.return);
		      while (fiber);
		    }
		    return 3 === node.tag ? nearestMounted : null;
		  }
		  function assertIsMounted(fiber) {
		    if (getNearestMountedFiber(fiber) !== fiber)
		      throw Error(formatProdErrorMessage(188));
		  }
		  function findCurrentFiberUsingSlowPath(fiber) {
		    var alternate = fiber.alternate;
		    if (!alternate) {
		      alternate = getNearestMountedFiber(fiber);
		      if (null === alternate) throw Error(formatProdErrorMessage(188));
		      return alternate !== fiber ? null : fiber;
		    }
		    for (var a = fiber, b = alternate; ; ) {
		      var parentA = a.return;
		      if (null === parentA) break;
		      var parentB = parentA.alternate;
		      if (null === parentB) {
		        b = parentA.return;
		        if (null !== b) {
		          a = b;
		          continue;
		        }
		        break;
		      }
		      if (parentA.child === parentB.child) {
		        for (parentB = parentA.child; parentB; ) {
		          if (parentB === a) return assertIsMounted(parentA), fiber;
		          if (parentB === b) return assertIsMounted(parentA), alternate;
		          parentB = parentB.sibling;
		        }
		        throw Error(formatProdErrorMessage(188));
		      }
		      if (a.return !== b.return) (a = parentA), (b = parentB);
		      else {
		        for (var didFindChild = false, child$0 = parentA.child; child$0; ) {
		          if (child$0 === a) {
		            didFindChild = true;
		            a = parentA;
		            b = parentB;
		            break;
		          }
		          if (child$0 === b) {
		            didFindChild = true;
		            b = parentA;
		            a = parentB;
		            break;
		          }
		          child$0 = child$0.sibling;
		        }
		        if (!didFindChild) {
		          for (child$0 = parentB.child; child$0; ) {
		            if (child$0 === a) {
		              didFindChild = true;
		              a = parentB;
		              b = parentA;
		              break;
		            }
		            if (child$0 === b) {
		              didFindChild = true;
		              b = parentB;
		              a = parentA;
		              break;
		            }
		            child$0 = child$0.sibling;
		          }
		          if (!didFindChild) throw Error(formatProdErrorMessage(189));
		        }
		      }
		      if (a.alternate !== b) throw Error(formatProdErrorMessage(190));
		    }
		    if (3 !== a.tag) throw Error(formatProdErrorMessage(188));
		    return a.stateNode.current === a ? fiber : alternate;
		  }
		  function findCurrentHostFiberImpl(node) {
		    var tag = node.tag;
		    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
		    for (node = node.child; null !== node; ) {
		      tag = findCurrentHostFiberImpl(node);
		      if (null !== tag) return tag;
		      node = node.sibling;
		    }
		    return null;
		  }
		  function findCurrentHostFiberWithNoPortalsImpl(node) {
		    var tag = node.tag;
		    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
		    for (node = node.child; null !== node; ) {
		      if (
		        4 !== node.tag &&
		        ((tag = findCurrentHostFiberWithNoPortalsImpl(node)), null !== tag)
		      )
		        return tag;
		      node = node.sibling;
		    }
		    return null;
		  }
		  function getIteratorFn(maybeIterable) {
		    if (null === maybeIterable || "object" !== typeof maybeIterable)
		      return null;
		    maybeIterable =
		      (MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL]) ||
		      maybeIterable["@@iterator"];
		    return "function" === typeof maybeIterable ? maybeIterable : null;
		  }
		  function getComponentNameFromType(type) {
		    if (null == type) return null;
		    if ("function" === typeof type)
		      return type.$$typeof === REACT_CLIENT_REFERENCE
		        ? null
		        : type.displayName || type.name || null;
		    if ("string" === typeof type) return type;
		    switch (type) {
		      case REACT_FRAGMENT_TYPE:
		        return "Fragment";
		      case REACT_PROFILER_TYPE:
		        return "Profiler";
		      case REACT_STRICT_MODE_TYPE:
		        return "StrictMode";
		      case REACT_SUSPENSE_TYPE:
		        return "Suspense";
		      case REACT_SUSPENSE_LIST_TYPE:
		        return "SuspenseList";
		      case REACT_ACTIVITY_TYPE:
		        return "Activity";
		    }
		    if ("object" === typeof type)
		      switch (type.$$typeof) {
		        case REACT_PORTAL_TYPE:
		          return "Portal";
		        case REACT_CONTEXT_TYPE:
		          return type.displayName || "Context";
		        case REACT_CONSUMER_TYPE:
		          return (type._context.displayName || "Context") + ".Consumer";
		        case REACT_FORWARD_REF_TYPE:
		          var innerType = type.render;
		          type = type.displayName;
		          type ||
		            ((type = innerType.displayName || innerType.name || ""),
		            (type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef"));
		          return type;
		        case REACT_MEMO_TYPE:
		          return (
		            (innerType = type.displayName || null),
		            null !== innerType
		              ? innerType
		              : getComponentNameFromType(type.type) || "Memo"
		          );
		        case REACT_LAZY_TYPE:
		          innerType = type._payload;
		          type = type._init;
		          try {
		            return getComponentNameFromType(type(innerType));
		          } catch (x) {}
		      }
		    return null;
		  }
		  function createCursor(defaultValue) {
		    return { current: defaultValue };
		  }
		  function pop(cursor) {
		    0 > index$jscomp$0 ||
		      ((cursor.current = valueStack[index$jscomp$0]),
		      (valueStack[index$jscomp$0] = null),
		      index$jscomp$0--);
		  }
		  function push(cursor, value) {
		    index$jscomp$0++;
		    valueStack[index$jscomp$0] = cursor.current;
		    cursor.current = value;
		  }
		  function clz32Fallback(x) {
		    x >>>= 0;
		    return 0 === x ? 32 : (31 - ((log$1(x) / LN2) | 0)) | 0;
		  }
		  function getHighestPriorityLanes(lanes) {
		    var pendingSyncLanes = lanes & 42;
		    if (0 !== pendingSyncLanes) return pendingSyncLanes;
		    switch (lanes & -lanes) {
		      case 1:
		        return 1;
		      case 2:
		        return 2;
		      case 4:
		        return 4;
		      case 8:
		        return 8;
		      case 16:
		        return 16;
		      case 32:
		        return 32;
		      case 64:
		        return 64;
		      case 128:
		        return 128;
		      case 256:
		      case 512:
		      case 1024:
		      case 2048:
		      case 4096:
		      case 8192:
		      case 16384:
		      case 32768:
		      case 65536:
		      case 131072:
		        return lanes & 261888;
		      case 262144:
		      case 524288:
		      case 1048576:
		      case 2097152:
		        return lanes & 3932160;
		      case 4194304:
		      case 8388608:
		      case 16777216:
		      case 33554432:
		        return lanes & 62914560;
		      case 67108864:
		        return 67108864;
		      case 134217728:
		        return 134217728;
		      case 268435456:
		        return 268435456;
		      case 536870912:
		        return 536870912;
		      case 1073741824:
		        return 0;
		      default:
		        return lanes;
		    }
		  }
		  function getNextLanes(root, wipLanes, rootHasPendingCommit) {
		    var pendingLanes = root.pendingLanes;
		    if (0 === pendingLanes) return 0;
		    var nextLanes = 0,
		      suspendedLanes = root.suspendedLanes,
		      pingedLanes = root.pingedLanes;
		    root = root.warmLanes;
		    var nonIdlePendingLanes = pendingLanes & 134217727;
		    0 !== nonIdlePendingLanes
		      ? ((pendingLanes = nonIdlePendingLanes & ~suspendedLanes),
		        0 !== pendingLanes
		          ? (nextLanes = getHighestPriorityLanes(pendingLanes))
		          : ((pingedLanes &= nonIdlePendingLanes),
		            0 !== pingedLanes
		              ? (nextLanes = getHighestPriorityLanes(pingedLanes))
		              : rootHasPendingCommit ||
		                ((rootHasPendingCommit = nonIdlePendingLanes & ~root),
		                0 !== rootHasPendingCommit &&
		                  (nextLanes = getHighestPriorityLanes(rootHasPendingCommit)))))
		      : ((nonIdlePendingLanes = pendingLanes & ~suspendedLanes),
		        0 !== nonIdlePendingLanes
		          ? (nextLanes = getHighestPriorityLanes(nonIdlePendingLanes))
		          : 0 !== pingedLanes
		            ? (nextLanes = getHighestPriorityLanes(pingedLanes))
		            : rootHasPendingCommit ||
		              ((rootHasPendingCommit = pendingLanes & ~root),
		              0 !== rootHasPendingCommit &&
		                (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))));
		    return 0 === nextLanes
		      ? 0
		      : 0 !== wipLanes &&
		          wipLanes !== nextLanes &&
		          0 === (wipLanes & suspendedLanes) &&
		          ((suspendedLanes = nextLanes & -nextLanes),
		          (rootHasPendingCommit = wipLanes & -wipLanes),
		          suspendedLanes >= rootHasPendingCommit ||
		            (32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)))
		        ? wipLanes
		        : nextLanes;
		  }
		  function checkIfRootIsPrerendering(root, renderLanes) {
		    return (
		      0 ===
		      (root.pendingLanes &
		        ~(root.suspendedLanes & ~root.pingedLanes) &
		        renderLanes)
		    );
		  }
		  function computeExpirationTime(lane, currentTime) {
		    switch (lane) {
		      case 1:
		      case 2:
		      case 4:
		      case 8:
		      case 64:
		        return currentTime + 250;
		      case 16:
		      case 32:
		      case 128:
		      case 256:
		      case 512:
		      case 1024:
		      case 2048:
		      case 4096:
		      case 8192:
		      case 16384:
		      case 32768:
		      case 65536:
		      case 131072:
		      case 262144:
		      case 524288:
		      case 1048576:
		      case 2097152:
		        return currentTime + 5e3;
		      case 4194304:
		      case 8388608:
		      case 16777216:
		      case 33554432:
		        return -1;
		      case 67108864:
		      case 134217728:
		      case 268435456:
		      case 536870912:
		      case 1073741824:
		        return -1;
		      default:
		        return -1;
		    }
		  }
		  function claimNextRetryLane() {
		    var lane = nextRetryLane;
		    nextRetryLane <<= 1;
		    0 === (nextRetryLane & 62914560) && (nextRetryLane = 4194304);
		    return lane;
		  }
		  function createLaneMap(initial) {
		    for (var laneMap = [], i = 0; 31 > i; i++) laneMap.push(initial);
		    return laneMap;
		  }
		  function markRootUpdated$1(root, updateLane) {
		    root.pendingLanes |= updateLane;
		    268435456 !== updateLane &&
		      ((root.suspendedLanes = 0), (root.pingedLanes = 0), (root.warmLanes = 0));
		  }
		  function markRootFinished(
		    root,
		    finishedLanes,
		    remainingLanes,
		    spawnedLane,
		    updatedLanes,
		    suspendedRetryLanes
		  ) {
		    var previouslyPendingLanes = root.pendingLanes;
		    root.pendingLanes = remainingLanes;
		    root.suspendedLanes = 0;
		    root.pingedLanes = 0;
		    root.warmLanes = 0;
		    root.expiredLanes &= remainingLanes;
		    root.entangledLanes &= remainingLanes;
		    root.errorRecoveryDisabledLanes &= remainingLanes;
		    root.shellSuspendCounter = 0;
		    var entanglements = root.entanglements,
		      expirationTimes = root.expirationTimes,
		      hiddenUpdates = root.hiddenUpdates;
		    for (
		      remainingLanes = previouslyPendingLanes & ~remainingLanes;
		      0 < remainingLanes;

		    ) {
		      var index$5 = 31 - clz32(remainingLanes),
		        lane = 1 << index$5;
		      entanglements[index$5] = 0;
		      expirationTimes[index$5] = -1;
		      var hiddenUpdatesForLane = hiddenUpdates[index$5];
		      if (null !== hiddenUpdatesForLane)
		        for (
		          hiddenUpdates[index$5] = null, index$5 = 0;
		          index$5 < hiddenUpdatesForLane.length;
		          index$5++
		        ) {
		          var update = hiddenUpdatesForLane[index$5];
		          null !== update && (update.lane &= -536870913);
		        }
		      remainingLanes &= ~lane;
		    }
		    0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, 0);
		    0 !== suspendedRetryLanes &&
		      0 === updatedLanes &&
		      0 !== root.tag &&
		      (root.suspendedLanes |=
		        suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
		  }
		  function markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
		    root.pendingLanes |= spawnedLane;
		    root.suspendedLanes &= ~spawnedLane;
		    var spawnedLaneIndex = 31 - clz32(spawnedLane);
		    root.entangledLanes |= spawnedLane;
		    root.entanglements[spawnedLaneIndex] =
		      root.entanglements[spawnedLaneIndex] |
		      1073741824 |
		      (entangledLanes & 261930);
		  }
		  function markRootEntangled(root, entangledLanes) {
		    var rootEntangledLanes = (root.entangledLanes |= entangledLanes);
		    for (root = root.entanglements; rootEntangledLanes; ) {
		      var index$6 = 31 - clz32(rootEntangledLanes),
		        lane = 1 << index$6;
		      (lane & entangledLanes) | (root[index$6] & entangledLanes) &&
		        (root[index$6] |= entangledLanes);
		      rootEntangledLanes &= ~lane;
		    }
		  }
		  function getBumpedLaneForHydration(root, renderLanes) {
		    var renderLane = renderLanes & -renderLanes;
		    renderLane =
		      0 !== (renderLane & 42) ? 1 : getBumpedLaneForHydrationByLane(renderLane);
		    return 0 !== (renderLane & (root.suspendedLanes | renderLanes))
		      ? 0
		      : renderLane;
		  }
		  function getBumpedLaneForHydrationByLane(lane) {
		    switch (lane) {
		      case 2:
		        lane = 1;
		        break;
		      case 8:
		        lane = 4;
		        break;
		      case 32:
		        lane = 16;
		        break;
		      case 256:
		      case 512:
		      case 1024:
		      case 2048:
		      case 4096:
		      case 8192:
		      case 16384:
		      case 32768:
		      case 65536:
		      case 131072:
		      case 262144:
		      case 524288:
		      case 1048576:
		      case 2097152:
		      case 4194304:
		      case 8388608:
		      case 16777216:
		      case 33554432:
		        lane = 128;
		        break;
		      case 268435456:
		        lane = 134217728;
		        break;
		      default:
		        lane = 0;
		    }
		    return lane;
		  }
		  function lanesToEventPriority(lanes) {
		    lanes &= -lanes;
		    return 2 < lanes
		      ? 8 < lanes
		        ? 0 !== (lanes & 134217727)
		          ? 32
		          : 268435456
		        : 8
		      : 2;
		  }
		  function setIsStrictModeForDevtools(newIsStrictMode) {
		    "function" === typeof log && unstable_setDisableYieldValue(newIsStrictMode);
		    if (injectedHook && "function" === typeof injectedHook.setStrictMode)
		      try {
		        injectedHook.setStrictMode(rendererID, newIsStrictMode);
		      } catch (err) {}
		  }
		  function is(x, y) {
		    return (x === y && (0 !== x || 1 / x === 1 / y)) || (x !== x && y !== y);
		  }
		  function describeBuiltInComponentFrame(name) {
		    if (void 0 === prefix)
		      try {
		        throw Error();
		      } catch (x) {
		        var match = x.stack.trim().match(/\n( *(at )?)/);
		        prefix = (match && match[1]) || "";
		        suffix =
		          -1 < x.stack.indexOf("\n    at")
		            ? " (<anonymous>)"
		            : -1 < x.stack.indexOf("@")
		              ? "@unknown:0:0"
		              : "";
		      }
		    return "\n" + prefix + name + suffix;
		  }
		  function describeNativeComponentFrame(fn, construct) {
		    if (!fn || reentry) return "";
		    reentry = true;
		    var previousPrepareStackTrace = Error.prepareStackTrace;
		    Error.prepareStackTrace = void 0;
		    try {
		      var RunInRootFrame = {
		        DetermineComponentFrameRoot: function () {
		          try {
		            if (construct) {
		              var Fake = function () {
		                throw Error();
		              };
		              Object.defineProperty(Fake.prototype, "props", {
		                set: function () {
		                  throw Error();
		                }
		              });
		              if ("object" === typeof Reflect && Reflect.construct) {
		                try {
		                  Reflect.construct(Fake, []);
		                } catch (x) {
		                  var control = x;
		                }
		                Reflect.construct(fn, [], Fake);
		              } else {
		                try {
		                  Fake.call();
		                } catch (x$8) {
		                  control = x$8;
		                }
		                fn.call(Fake.prototype);
		              }
		            } else {
		              try {
		                throw Error();
		              } catch (x$9) {
		                control = x$9;
		              }
		              (Fake = fn()) &&
		                "function" === typeof Fake.catch &&
		                Fake.catch(function () {});
		            }
		          } catch (sample) {
		            if (sample && control && "string" === typeof sample.stack)
		              return [sample.stack, control.stack];
		          }
		          return [null, null];
		        }
		      };
		      RunInRootFrame.DetermineComponentFrameRoot.displayName =
		        "DetermineComponentFrameRoot";
		      var namePropDescriptor = Object.getOwnPropertyDescriptor(
		        RunInRootFrame.DetermineComponentFrameRoot,
		        "name"
		      );
		      namePropDescriptor &&
		        namePropDescriptor.configurable &&
		        Object.defineProperty(
		          RunInRootFrame.DetermineComponentFrameRoot,
		          "name",
		          { value: "DetermineComponentFrameRoot" }
		        );
		      var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(),
		        sampleStack = _RunInRootFrame$Deter[0],
		        controlStack = _RunInRootFrame$Deter[1];
		      if (sampleStack && controlStack) {
		        var sampleLines = sampleStack.split("\n"),
		          controlLines = controlStack.split("\n");
		        for (
		          namePropDescriptor = RunInRootFrame = 0;
		          RunInRootFrame < sampleLines.length &&
		          !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");

		        )
		          RunInRootFrame++;
		        for (
		          ;
		          namePropDescriptor < controlLines.length &&
		          !controlLines[namePropDescriptor].includes(
		            "DetermineComponentFrameRoot"
		          );

		        )
		          namePropDescriptor++;
		        if (
		          RunInRootFrame === sampleLines.length ||
		          namePropDescriptor === controlLines.length
		        )
		          for (
		            RunInRootFrame = sampleLines.length - 1,
		              namePropDescriptor = controlLines.length - 1;
		            1 <= RunInRootFrame &&
		            0 <= namePropDescriptor &&
		            sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];

		          )
		            namePropDescriptor--;
		        for (
		          ;
		          1 <= RunInRootFrame && 0 <= namePropDescriptor;
		          RunInRootFrame--, namePropDescriptor--
		        )
		          if (
		            sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]
		          ) {
		            if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
		              do
		                if (
		                  (RunInRootFrame--,
		                  namePropDescriptor--,
		                  0 > namePropDescriptor ||
		                    sampleLines[RunInRootFrame] !==
		                      controlLines[namePropDescriptor])
		                ) {
		                  var frame =
		                    "\n" +
		                    sampleLines[RunInRootFrame].replace(" at new ", " at ");
		                  fn.displayName &&
		                    frame.includes("<anonymous>") &&
		                    (frame = frame.replace("<anonymous>", fn.displayName));
		                  return frame;
		                }
		              while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
		            }
		            break;
		          }
		      }
		    } finally {
		      (reentry = false), (Error.prepareStackTrace = previousPrepareStackTrace);
		    }
		    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "")
		      ? describeBuiltInComponentFrame(previousPrepareStackTrace)
		      : "";
		  }
		  function describeFiber(fiber, childFiber) {
		    switch (fiber.tag) {
		      case 26:
		      case 27:
		      case 5:
		        return describeBuiltInComponentFrame(fiber.type);
		      case 16:
		        return describeBuiltInComponentFrame("Lazy");
		      case 13:
		        return fiber.child !== childFiber && null !== childFiber
		          ? describeBuiltInComponentFrame("Suspense Fallback")
		          : describeBuiltInComponentFrame("Suspense");
		      case 19:
		        return describeBuiltInComponentFrame("SuspenseList");
		      case 0:
		      case 15:
		        return describeNativeComponentFrame(fiber.type, false);
		      case 11:
		        return describeNativeComponentFrame(fiber.type.render, false);
		      case 1:
		        return describeNativeComponentFrame(fiber.type, true);
		      case 31:
		        return describeBuiltInComponentFrame("Activity");
		      default:
		        return "";
		    }
		  }
		  function getStackByFiberInDevAndProd(workInProgress) {
		    try {
		      var info = "",
		        previous = null;
		      do
		        (info += describeFiber(workInProgress, previous)),
		          (previous = workInProgress),
		          (workInProgress = workInProgress.return);
		      while (workInProgress);
		      return info;
		    } catch (x) {
		      return "\nError generating stack: " + x.message + "\n" + x.stack;
		    }
		  }
		  function createCapturedValueAtFiber(value, source) {
		    if ("object" === typeof value && null !== value) {
		      var existing = CapturedStacks.get(value);
		      if (void 0 !== existing) return existing;
		      source = {
		        value: value,
		        source: source,
		        stack: getStackByFiberInDevAndProd(source)
		      };
		      CapturedStacks.set(value, source);
		      return source;
		    }
		    return {
		      value: value,
		      source: source,
		      stack: getStackByFiberInDevAndProd(source)
		    };
		  }
		  function pushTreeFork(workInProgress, totalChildren) {
		    forkStack[forkStackIndex++] = treeForkCount;
		    forkStack[forkStackIndex++] = treeForkProvider;
		    treeForkProvider = workInProgress;
		    treeForkCount = totalChildren;
		  }
		  function pushTreeId(workInProgress, totalChildren, index) {
		    idStack[idStackIndex++] = treeContextId;
		    idStack[idStackIndex++] = treeContextOverflow;
		    idStack[idStackIndex++] = treeContextProvider;
		    treeContextProvider = workInProgress;
		    var baseIdWithLeadingBit = treeContextId;
		    workInProgress = treeContextOverflow;
		    var baseLength = 32 - clz32(baseIdWithLeadingBit) - 1;
		    baseIdWithLeadingBit &= ~(1 << baseLength);
		    index += 1;
		    var length = 32 - clz32(totalChildren) + baseLength;
		    if (30 < length) {
		      var numberOfOverflowBits = baseLength - (baseLength % 5);
		      length = (
		        baseIdWithLeadingBit &
		        ((1 << numberOfOverflowBits) - 1)
		      ).toString(32);
		      baseIdWithLeadingBit >>= numberOfOverflowBits;
		      baseLength -= numberOfOverflowBits;
		      treeContextId =
		        (1 << (32 - clz32(totalChildren) + baseLength)) |
		        (index << baseLength) |
		        baseIdWithLeadingBit;
		      treeContextOverflow = length + workInProgress;
		    } else
		      (treeContextId =
		        (1 << length) | (index << baseLength) | baseIdWithLeadingBit),
		        (treeContextOverflow = workInProgress);
		  }
		  function pushMaterializedTreeId(workInProgress) {
		    null !== workInProgress.return &&
		      (pushTreeFork(workInProgress, 1), pushTreeId(workInProgress, 1, 0));
		  }
		  function popTreeContext(workInProgress) {
		    for (; workInProgress === treeForkProvider; )
		      (treeForkProvider = forkStack[--forkStackIndex]),
		        (forkStack[forkStackIndex] = null),
		        (treeForkCount = forkStack[--forkStackIndex]),
		        (forkStack[forkStackIndex] = null);
		    for (; workInProgress === treeContextProvider; )
		      (treeContextProvider = idStack[--idStackIndex]),
		        (idStack[idStackIndex] = null),
		        (treeContextOverflow = idStack[--idStackIndex]),
		        (idStack[idStackIndex] = null),
		        (treeContextId = idStack[--idStackIndex]),
		        (idStack[idStackIndex] = null);
		  }
		  function restoreSuspendedTreeContext(workInProgress, suspendedContext) {
		    idStack[idStackIndex++] = treeContextId;
		    idStack[idStackIndex++] = treeContextOverflow;
		    idStack[idStackIndex++] = treeContextProvider;
		    treeContextId = suspendedContext.id;
		    treeContextOverflow = suspendedContext.overflow;
		    treeContextProvider = workInProgress;
		  }
		  function pushHostContainer(fiber, nextRootInstance) {
		    push(rootInstanceStackCursor, nextRootInstance);
		    push(contextFiberStackCursor, fiber);
		    push(contextStackCursor, null);
		    fiber = getRootHostContext(nextRootInstance);
		    pop(contextStackCursor);
		    push(contextStackCursor, fiber);
		  }
		  function popHostContainer() {
		    pop(contextStackCursor);
		    pop(contextFiberStackCursor);
		    pop(rootInstanceStackCursor);
		  }
		  function pushHostContext(fiber) {
		    null !== fiber.memoizedState && push(hostTransitionProviderCursor, fiber);
		    var context = contextStackCursor.current,
		      nextContext = getChildHostContext(context, fiber.type);
		    context !== nextContext &&
		      (push(contextFiberStackCursor, fiber),
		      push(contextStackCursor, nextContext));
		  }
		  function popHostContext(fiber) {
		    contextFiberStackCursor.current === fiber &&
		      (pop(contextStackCursor), pop(contextFiberStackCursor));
		    hostTransitionProviderCursor.current === fiber &&
		      (pop(hostTransitionProviderCursor),
		      isPrimaryRenderer
		        ? (HostTransitionContext._currentValue = NotPendingTransition)
		        : (HostTransitionContext._currentValue2 = NotPendingTransition));
		  }
		  function throwOnHydrationMismatch(fiber) {
		    var error = Error(
		      formatProdErrorMessage(
		        418,
		        1 < arguments.length && void 0 !== arguments[1] && arguments[1]
		          ? "text"
		          : "HTML",
		        ""
		      )
		    );
		    queueHydrationError(createCapturedValueAtFiber(error, fiber));
		    throw HydrationMismatchException;
		  }
		  function prepareToHydrateHostInstance(fiber, hostContext) {
		    if (!supportsHydration) throw Error(formatProdErrorMessage(175));
		    hydrateInstance(
		      fiber.stateNode,
		      fiber.type,
		      fiber.memoizedProps,
		      hostContext,
		      fiber
		    ) || throwOnHydrationMismatch(fiber, true);
		  }
		  function popToNextHostParent(fiber) {
		    for (hydrationParentFiber = fiber.return; hydrationParentFiber; )
		      switch (hydrationParentFiber.tag) {
		        case 5:
		        case 31:
		        case 13:
		          rootOrSingletonContext = false;
		          return;
		        case 27:
		        case 3:
		          rootOrSingletonContext = true;
		          return;
		        default:
		          hydrationParentFiber = hydrationParentFiber.return;
		      }
		  }
		  function popHydrationState(fiber) {
		    if (!supportsHydration || fiber !== hydrationParentFiber) return false;
		    if (!isHydrating) return popToNextHostParent(fiber), (isHydrating = true), false;
		    var tag = fiber.tag;
		    supportsSingletons
		      ? 3 !== tag &&
		        27 !== tag &&
		        (5 !== tag ||
		          (shouldDeleteUnhydratedTailInstances(fiber.type) &&
		            !shouldSetTextContent(fiber.type, fiber.memoizedProps))) &&
		        nextHydratableInstance &&
		        throwOnHydrationMismatch(fiber)
		      : 3 !== tag &&
		        (5 !== tag ||
		          (shouldDeleteUnhydratedTailInstances(fiber.type) &&
		            !shouldSetTextContent(fiber.type, fiber.memoizedProps))) &&
		        nextHydratableInstance &&
		        throwOnHydrationMismatch(fiber);
		    popToNextHostParent(fiber);
		    if (13 === tag) {
		      if (!supportsHydration) throw Error(formatProdErrorMessage(316));
		      fiber = fiber.memoizedState;
		      fiber = null !== fiber ? fiber.dehydrated : null;
		      if (!fiber) throw Error(formatProdErrorMessage(317));
		      nextHydratableInstance =
		        getNextHydratableInstanceAfterSuspenseInstance(fiber);
		    } else if (31 === tag) {
		      fiber = fiber.memoizedState;
		      fiber = null !== fiber ? fiber.dehydrated : null;
		      if (!fiber) throw Error(formatProdErrorMessage(317));
		      nextHydratableInstance =
		        getNextHydratableInstanceAfterActivityInstance(fiber);
		    } else
		      nextHydratableInstance =
		        supportsSingletons && 27 === tag
		          ? getNextHydratableSiblingAfterSingleton(
		              fiber.type,
		              nextHydratableInstance
		            )
		          : hydrationParentFiber
		            ? getNextHydratableSibling(fiber.stateNode)
		            : null;
		    return true;
		  }
		  function resetHydrationState() {
		    supportsHydration &&
		      ((nextHydratableInstance = hydrationParentFiber = null),
		      (isHydrating = false));
		  }
		  function upgradeHydrationErrorsToRecoverable() {
		    var queuedErrors = hydrationErrors;
		    null !== queuedErrors &&
		      (null === workInProgressRootRecoverableErrors
		        ? (workInProgressRootRecoverableErrors = queuedErrors)
		        : workInProgressRootRecoverableErrors.push.apply(
		            workInProgressRootRecoverableErrors,
		            queuedErrors
		          ),
		      (hydrationErrors = null));
		    return queuedErrors;
		  }
		  function queueHydrationError(error) {
		    null === hydrationErrors
		      ? (hydrationErrors = [error])
		      : hydrationErrors.push(error);
		  }
		  function pushProvider(providerFiber, context, nextValue) {
		    isPrimaryRenderer
		      ? (push(valueCursor, context._currentValue),
		        (context._currentValue = nextValue))
		      : (push(valueCursor, context._currentValue2),
		        (context._currentValue2 = nextValue));
		  }
		  function popProvider(context) {
		    var currentValue = valueCursor.current;
		    isPrimaryRenderer
		      ? (context._currentValue = currentValue)
		      : (context._currentValue2 = currentValue);
		    pop(valueCursor);
		  }
		  function scheduleContextWorkOnParentPath(
		    parent,
		    renderLanes,
		    propagationRoot
		  ) {
		    for (; null !== parent; ) {
		      var alternate = parent.alternate;
		      (parent.childLanes & renderLanes) !== renderLanes
		        ? ((parent.childLanes |= renderLanes),
		          null !== alternate && (alternate.childLanes |= renderLanes))
		        : null !== alternate &&
		          (alternate.childLanes & renderLanes) !== renderLanes &&
		          (alternate.childLanes |= renderLanes);
		      if (parent === propagationRoot) break;
		      parent = parent.return;
		    }
		  }
		  function propagateContextChanges(
		    workInProgress,
		    contexts,
		    renderLanes,
		    forcePropagateEntireTree
		  ) {
		    var fiber = workInProgress.child;
		    null !== fiber && (fiber.return = workInProgress);
		    for (; null !== fiber; ) {
		      var list = fiber.dependencies;
		      if (null !== list) {
		        var nextFiber = fiber.child;
		        list = list.firstContext;
		        a: for (; null !== list; ) {
		          var dependency = list;
		          list = fiber;
		          for (var i = 0; i < contexts.length; i++)
		            if (dependency.context === contexts[i]) {
		              list.lanes |= renderLanes;
		              dependency = list.alternate;
		              null !== dependency && (dependency.lanes |= renderLanes);
		              scheduleContextWorkOnParentPath(
		                list.return,
		                renderLanes,
		                workInProgress
		              );
		              forcePropagateEntireTree || (nextFiber = null);
		              break a;
		            }
		          list = dependency.next;
		        }
		      } else if (18 === fiber.tag) {
		        nextFiber = fiber.return;
		        if (null === nextFiber) throw Error(formatProdErrorMessage(341));
		        nextFiber.lanes |= renderLanes;
		        list = nextFiber.alternate;
		        null !== list && (list.lanes |= renderLanes);
		        scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
		        nextFiber = null;
		      } else nextFiber = fiber.child;
		      if (null !== nextFiber) nextFiber.return = fiber;
		      else
		        for (nextFiber = fiber; null !== nextFiber; ) {
		          if (nextFiber === workInProgress) {
		            nextFiber = null;
		            break;
		          }
		          fiber = nextFiber.sibling;
		          if (null !== fiber) {
		            fiber.return = nextFiber.return;
		            nextFiber = fiber;
		            break;
		          }
		          nextFiber = nextFiber.return;
		        }
		      fiber = nextFiber;
		    }
		  }
		  function propagateParentContextChanges(
		    current,
		    workInProgress,
		    renderLanes,
		    forcePropagateEntireTree
		  ) {
		    current = null;
		    for (
		      var parent = workInProgress, isInsidePropagationBailout = false;
		      null !== parent;

		    ) {
		      if (!isInsidePropagationBailout)
		        if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = true;
		        else if (0 !== (parent.flags & 262144)) break;
		      if (10 === parent.tag) {
		        var currentParent = parent.alternate;
		        if (null === currentParent) throw Error(formatProdErrorMessage(387));
		        currentParent = currentParent.memoizedProps;
		        if (null !== currentParent) {
		          var context = parent.type;
		          objectIs(parent.pendingProps.value, currentParent.value) ||
		            (null !== current ? current.push(context) : (current = [context]));
		        }
		      } else if (parent === hostTransitionProviderCursor.current) {
		        currentParent = parent.alternate;
		        if (null === currentParent) throw Error(formatProdErrorMessage(387));
		        currentParent.memoizedState.memoizedState !==
		          parent.memoizedState.memoizedState &&
		          (null !== current
		            ? current.push(HostTransitionContext)
		            : (current = [HostTransitionContext]));
		      }
		      parent = parent.return;
		    }
		    null !== current &&
		      propagateContextChanges(
		        workInProgress,
		        current,
		        renderLanes,
		        forcePropagateEntireTree
		      );
		    workInProgress.flags |= 262144;
		  }
		  function checkIfContextChanged(currentDependencies) {
		    for (
		      currentDependencies = currentDependencies.firstContext;
		      null !== currentDependencies;

		    ) {
		      var context = currentDependencies.context;
		      if (
		        !objectIs(
		          isPrimaryRenderer ? context._currentValue : context._currentValue2,
		          currentDependencies.memoizedValue
		        )
		      )
		        return true;
		      currentDependencies = currentDependencies.next;
		    }
		    return false;
		  }
		  function prepareToReadContext(workInProgress) {
		    currentlyRenderingFiber$1 = workInProgress;
		    lastContextDependency = null;
		    workInProgress = workInProgress.dependencies;
		    null !== workInProgress && (workInProgress.firstContext = null);
		  }
		  function readContext(context) {
		    return readContextForConsumer(currentlyRenderingFiber$1, context);
		  }
		  function readContextDuringReconciliation(consumer, context) {
		    null === currentlyRenderingFiber$1 && prepareToReadContext(consumer);
		    return readContextForConsumer(consumer, context);
		  }
		  function readContextForConsumer(consumer, context) {
		    var value = isPrimaryRenderer
		      ? context._currentValue
		      : context._currentValue2;
		    context = { context: context, memoizedValue: value, next: null };
		    if (null === lastContextDependency) {
		      if (null === consumer) throw Error(formatProdErrorMessage(308));
		      lastContextDependency = context;
		      consumer.dependencies = { lanes: 0, firstContext: context };
		      consumer.flags |= 524288;
		    } else lastContextDependency = lastContextDependency.next = context;
		    return value;
		  }
		  function createCache() {
		    return {
		      controller: new AbortControllerLocal(),
		      data: new Map(),
		      refCount: 0
		    };
		  }
		  function releaseCache(cache) {
		    cache.refCount--;
		    0 === cache.refCount &&
		      scheduleCallback$2(NormalPriority, function () {
		        cache.controller.abort();
		      });
		  }
		  function noop$1() {}
		  function ensureRootIsScheduled(root) {
		    root !== lastScheduledRoot &&
		      null === root.next &&
		      (null === lastScheduledRoot
		        ? (firstScheduledRoot = lastScheduledRoot = root)
		        : (lastScheduledRoot = lastScheduledRoot.next = root));
		    mightHavePendingSyncWork = true;
		    didScheduleMicrotask ||
		      ((didScheduleMicrotask = true), scheduleImmediateRootScheduleTask());
		  }
		  function flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
		    if (!isFlushingWork && mightHavePendingSyncWork) {
		      isFlushingWork = true;
		      do {
		        var didPerformSomeWork = false;
		        for (var root = firstScheduledRoot; null !== root; ) {
		          if (0 !== syncTransitionLanes) {
		              var pendingLanes = root.pendingLanes;
		              if (0 === pendingLanes) var JSCompiler_inline_result = 0;
		              else {
		                var suspendedLanes = root.suspendedLanes,
		                  pingedLanes = root.pingedLanes;
		                JSCompiler_inline_result =
		                  (1 << (31 - clz32(42 | syncTransitionLanes) + 1)) - 1;
		                JSCompiler_inline_result &=
		                  pendingLanes & ~(suspendedLanes & ~pingedLanes);
		                JSCompiler_inline_result =
		                  JSCompiler_inline_result & 201326741
		                    ? (JSCompiler_inline_result & 201326741) | 1
		                    : JSCompiler_inline_result
		                      ? JSCompiler_inline_result | 2
		                      : 0;
		              }
		              0 !== JSCompiler_inline_result &&
		                ((didPerformSomeWork = true),
		                performSyncWorkOnRoot(root, JSCompiler_inline_result));
		            } else
		              (JSCompiler_inline_result = workInProgressRootRenderLanes),
		                (JSCompiler_inline_result = getNextLanes(
		                  root,
		                  root === workInProgressRoot ? JSCompiler_inline_result : 0,
		                  null !== root.cancelPendingCommit ||
		                    root.timeoutHandle !== noTimeout
		                )),
		                0 === (JSCompiler_inline_result & 3) ||
		                  checkIfRootIsPrerendering(root, JSCompiler_inline_result) ||
		                  ((didPerformSomeWork = true),
		                  performSyncWorkOnRoot(root, JSCompiler_inline_result));
		          root = root.next;
		        }
		      } while (didPerformSomeWork);
		      isFlushingWork = false;
		    }
		  }
		  function processRootScheduleInImmediateTask() {
		    processRootScheduleInMicrotask();
		  }
		  function processRootScheduleInMicrotask() {
		    mightHavePendingSyncWork = didScheduleMicrotask = false;
		    var syncTransitionLanes = 0;
		    0 !== currentEventTransitionLane &&
		      shouldAttemptEagerTransition() &&
		      (syncTransitionLanes = currentEventTransitionLane);
		    for (
		      var currentTime = now(), prev = null, root = firstScheduledRoot;
		      null !== root;

		    ) {
		      var next = root.next,
		        nextLanes = scheduleTaskForRootDuringMicrotask(root, currentTime);
		      if (0 === nextLanes)
		        (root.next = null),
		          null === prev ? (firstScheduledRoot = next) : (prev.next = next),
		          null === next && (lastScheduledRoot = prev);
		      else if (
		        ((prev = root), 0 !== syncTransitionLanes || 0 !== (nextLanes & 3))
		      )
		        mightHavePendingSyncWork = true;
		      root = next;
		    }
		    (0 !== pendingEffectsStatus && 5 !== pendingEffectsStatus) ||
		      flushSyncWorkAcrossRoots_impl(syncTransitionLanes);
		    0 !== currentEventTransitionLane && (currentEventTransitionLane = 0);
		  }
		  function scheduleTaskForRootDuringMicrotask(root, currentTime) {
		    for (
		      var suspendedLanes = root.suspendedLanes,
		        pingedLanes = root.pingedLanes,
		        expirationTimes = root.expirationTimes,
		        lanes = root.pendingLanes & -62914561;
		      0 < lanes;

		    ) {
		      var index$3 = 31 - clz32(lanes),
		        lane = 1 << index$3,
		        expirationTime = expirationTimes[index$3];
		      if (-1 === expirationTime) {
		        if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes))
		          expirationTimes[index$3] = computeExpirationTime(lane, currentTime);
		      } else expirationTime <= currentTime && (root.expiredLanes |= lane);
		      lanes &= ~lane;
		    }
		    currentTime = workInProgressRoot;
		    suspendedLanes = workInProgressRootRenderLanes;
		    suspendedLanes = getNextLanes(
		      root,
		      root === currentTime ? suspendedLanes : 0,
		      null !== root.cancelPendingCommit || root.timeoutHandle !== noTimeout
		    );
		    pingedLanes = root.callbackNode;
		    if (
		      0 === suspendedLanes ||
		      (root === currentTime &&
		        (2 === workInProgressSuspendedReason ||
		          9 === workInProgressSuspendedReason)) ||
		      null !== root.cancelPendingCommit
		    )
		      return (
		        null !== pingedLanes &&
		          null !== pingedLanes &&
		          cancelCallback$1(pingedLanes),
		        (root.callbackNode = null),
		        (root.callbackPriority = 0)
		      );
		    if (
		      0 === (suspendedLanes & 3) ||
		      checkIfRootIsPrerendering(root, suspendedLanes)
		    ) {
		      currentTime = suspendedLanes & -suspendedLanes;
		      if (currentTime === root.callbackPriority) return currentTime;
		      null !== pingedLanes && cancelCallback$1(pingedLanes);
		      switch (lanesToEventPriority(suspendedLanes)) {
		        case 2:
		        case 8:
		          suspendedLanes = UserBlockingPriority;
		          break;
		        case 32:
		          suspendedLanes = NormalPriority$1;
		          break;
		        case 268435456:
		          suspendedLanes = IdlePriority;
		          break;
		        default:
		          suspendedLanes = NormalPriority$1;
		      }
		      pingedLanes = performWorkOnRootViaSchedulerTask.bind(null, root);
		      suspendedLanes = scheduleCallback$3(suspendedLanes, pingedLanes);
		      root.callbackPriority = currentTime;
		      root.callbackNode = suspendedLanes;
		      return currentTime;
		    }
		    null !== pingedLanes &&
		      null !== pingedLanes &&
		      cancelCallback$1(pingedLanes);
		    root.callbackPriority = 2;
		    root.callbackNode = null;
		    return 2;
		  }
		  function performWorkOnRootViaSchedulerTask(root, didTimeout) {
		    if (0 !== pendingEffectsStatus && 5 !== pendingEffectsStatus)
		      return (root.callbackNode = null), (root.callbackPriority = 0), null;
		    var originalCallbackNode = root.callbackNode;
		    if (flushPendingEffects() && root.callbackNode !== originalCallbackNode)
		      return null;
		    var workInProgressRootRenderLanes$jscomp$0 = workInProgressRootRenderLanes;
		    workInProgressRootRenderLanes$jscomp$0 = getNextLanes(
		      root,
		      root === workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0,
		      null !== root.cancelPendingCommit || root.timeoutHandle !== noTimeout
		    );
		    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
		    performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
		    scheduleTaskForRootDuringMicrotask(root, now());
		    return null != root.callbackNode &&
		      root.callbackNode === originalCallbackNode
		      ? performWorkOnRootViaSchedulerTask.bind(null, root)
		      : null;
		  }
		  function performSyncWorkOnRoot(root, lanes) {
		    if (flushPendingEffects()) return null;
		    performWorkOnRoot(root, lanes, true);
		  }
		  function scheduleImmediateRootScheduleTask() {
		    supportsMicrotasks
		      ? scheduleMicrotask(function () {
		          0 !== (executionContext & 6)
		            ? scheduleCallback$3(
		                ImmediatePriority,
		                processRootScheduleInImmediateTask
		              )
		            : processRootScheduleInMicrotask();
		        })
		      : scheduleCallback$3(
		          ImmediatePriority,
		          processRootScheduleInImmediateTask
		        );
		  }
		  function requestTransitionLane() {
		    if (0 === currentEventTransitionLane) {
		      var actionScopeLane = currentEntangledLane;
		      0 === actionScopeLane &&
		        ((actionScopeLane = nextTransitionUpdateLane),
		        (nextTransitionUpdateLane <<= 1),
		        0 === (nextTransitionUpdateLane & 261888) &&
		          (nextTransitionUpdateLane = 256));
		      currentEventTransitionLane = actionScopeLane;
		    }
		    return currentEventTransitionLane;
		  }
		  function entangleAsyncAction(transition, thenable) {
		    if (null === currentEntangledListeners) {
		      var entangledListeners = (currentEntangledListeners = []);
		      currentEntangledPendingCount = 0;
		      currentEntangledLane = requestTransitionLane();
		      currentEntangledActionThenable = {
		        status: "pending",
		        value: void 0,
		        then: function (resolve) {
		          entangledListeners.push(resolve);
		        }
		      };
		    }
		    currentEntangledPendingCount++;
		    thenable.then(pingEngtangledActionScope, pingEngtangledActionScope);
		    return thenable;
		  }
		  function pingEngtangledActionScope() {
		    if (
		      0 === --currentEntangledPendingCount &&
		      null !== currentEntangledListeners
		    ) {
		      null !== currentEntangledActionThenable &&
		        (currentEntangledActionThenable.status = "fulfilled");
		      var listeners = currentEntangledListeners;
		      currentEntangledListeners = null;
		      currentEntangledLane = 0;
		      currentEntangledActionThenable = null;
		      for (var i = 0; i < listeners.length; i++) (0, listeners[i])();
		    }
		  }
		  function chainThenableValue(thenable, result) {
		    var listeners = [],
		      thenableWithOverride = {
		        status: "pending",
		        value: null,
		        reason: null,
		        then: function (resolve) {
		          listeners.push(resolve);
		        }
		      };
		    thenable.then(
		      function () {
		        thenableWithOverride.status = "fulfilled";
		        thenableWithOverride.value = result;
		        for (var i = 0; i < listeners.length; i++) (0, listeners[i])(result);
		      },
		      function (error) {
		        thenableWithOverride.status = "rejected";
		        thenableWithOverride.reason = error;
		        for (error = 0; error < listeners.length; error++)
		          (0, listeners[error])(void 0);
		      }
		    );
		    return thenableWithOverride;
		  }
		  function peekCacheFromPool() {
		    var cacheResumedFromPreviousRender = resumedCache.current;
		    return null !== cacheResumedFromPreviousRender
		      ? cacheResumedFromPreviousRender
		      : workInProgressRoot.pooledCache;
		  }
		  function pushTransition(offscreenWorkInProgress, prevCachePool) {
		    null === prevCachePool
		      ? push(resumedCache, resumedCache.current)
		      : push(resumedCache, prevCachePool.pool);
		  }
		  function getSuspendedCache() {
		    var cacheFromPool = peekCacheFromPool();
		    return null === cacheFromPool
		      ? null
		      : {
		          parent: isPrimaryRenderer
		            ? CacheContext._currentValue
		            : CacheContext._currentValue2,
		          pool: cacheFromPool
		        };
		  }
		  function shallowEqual(objA, objB) {
		    if (objectIs(objA, objB)) return true;
		    if (
		      "object" !== typeof objA ||
		      null === objA ||
		      "object" !== typeof objB ||
		      null === objB
		    )
		      return false;
		    var keysA = Object.keys(objA),
		      keysB = Object.keys(objB);
		    if (keysA.length !== keysB.length) return false;
		    for (keysB = 0; keysB < keysA.length; keysB++) {
		      var currentKey = keysA[keysB];
		      if (
		        !hasOwnProperty.call(objB, currentKey) ||
		        !objectIs(objA[currentKey], objB[currentKey])
		      )
		        return false;
		    }
		    return true;
		  }
		  function isThenableResolved(thenable) {
		    thenable = thenable.status;
		    return "fulfilled" === thenable || "rejected" === thenable;
		  }
		  function trackUsedThenable(thenableState, thenable, index) {
		    index = thenableState[index];
		    void 0 === index
		      ? thenableState.push(thenable)
		      : index !== thenable &&
		        (thenable.then(noop$1, noop$1), (thenable = index));
		    switch (thenable.status) {
		      case "fulfilled":
		        return thenable.value;
		      case "rejected":
		        throw (
		          ((thenableState = thenable.reason),
		          checkIfUseWrappedInAsyncCatch(thenableState),
		          thenableState)
		        );
		      default:
		        if ("string" === typeof thenable.status) thenable.then(noop$1, noop$1);
		        else {
		          thenableState = workInProgressRoot;
		          if (null !== thenableState && 100 < thenableState.shellSuspendCounter)
		            throw Error(formatProdErrorMessage(482));
		          thenableState = thenable;
		          thenableState.status = "pending";
		          thenableState.then(
		            function (fulfilledValue) {
		              if ("pending" === thenable.status) {
		                var fulfilledThenable = thenable;
		                fulfilledThenable.status = "fulfilled";
		                fulfilledThenable.value = fulfilledValue;
		              }
		            },
		            function (error) {
		              if ("pending" === thenable.status) {
		                var rejectedThenable = thenable;
		                rejectedThenable.status = "rejected";
		                rejectedThenable.reason = error;
		              }
		            }
		          );
		        }
		        switch (thenable.status) {
		          case "fulfilled":
		            return thenable.value;
		          case "rejected":
		            throw (
		              ((thenableState = thenable.reason),
		              checkIfUseWrappedInAsyncCatch(thenableState),
		              thenableState)
		            );
		        }
		        suspendedThenable = thenable;
		        throw SuspenseException;
		    }
		  }
		  function resolveLazy(lazyType) {
		    try {
		      var init = lazyType._init;
		      return init(lazyType._payload);
		    } catch (x) {
		      if (null !== x && "object" === typeof x && "function" === typeof x.then)
		        throw ((suspendedThenable = x), SuspenseException);
		      throw x;
		    }
		  }
		  function getSuspendedThenable() {
		    if (null === suspendedThenable) throw Error(formatProdErrorMessage(459));
		    var thenable = suspendedThenable;
		    suspendedThenable = null;
		    return thenable;
		  }
		  function checkIfUseWrappedInAsyncCatch(rejectedReason) {
		    if (
		      rejectedReason === SuspenseException ||
		      rejectedReason === SuspenseActionException
		    )
		      throw Error(formatProdErrorMessage(483));
		  }
		  function unwrapThenable(thenable) {
		    var index = thenableIndexCounter$1;
		    thenableIndexCounter$1 += 1;
		    null === thenableState$1 && (thenableState$1 = []);
		    return trackUsedThenable(thenableState$1, thenable, index);
		  }
		  function coerceRef(workInProgress, element) {
		    element = element.props.ref;
		    workInProgress.ref = void 0 !== element ? element : null;
		  }
		  function throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
		    if (newChild.$$typeof === REACT_LEGACY_ELEMENT_TYPE)
		      throw Error(formatProdErrorMessage(525));
		    returnFiber = Object.prototype.toString.call(newChild);
		    throw Error(
		      formatProdErrorMessage(
		        31,
		        "[object Object]" === returnFiber
		          ? "object with keys {" + Object.keys(newChild).join(", ") + "}"
		          : returnFiber
		      )
		    );
		  }
		  function createChildReconciler(shouldTrackSideEffects) {
		    function deleteChild(returnFiber, childToDelete) {
		      if (shouldTrackSideEffects) {
		        var deletions = returnFiber.deletions;
		        null === deletions
		          ? ((returnFiber.deletions = [childToDelete]),
		            (returnFiber.flags |= 16))
		          : deletions.push(childToDelete);
		      }
		    }
		    function deleteRemainingChildren(returnFiber, currentFirstChild) {
		      if (!shouldTrackSideEffects) return null;
		      for (; null !== currentFirstChild; )
		        deleteChild(returnFiber, currentFirstChild),
		          (currentFirstChild = currentFirstChild.sibling);
		      return null;
		    }
		    function mapRemainingChildren(currentFirstChild) {
		      for (var existingChildren = new Map(); null !== currentFirstChild; )
		        null !== currentFirstChild.key
		          ? existingChildren.set(currentFirstChild.key, currentFirstChild)
		          : existingChildren.set(currentFirstChild.index, currentFirstChild),
		          (currentFirstChild = currentFirstChild.sibling);
		      return existingChildren;
		    }
		    function useFiber(fiber, pendingProps) {
		      fiber = createWorkInProgress(fiber, pendingProps);
		      fiber.index = 0;
		      fiber.sibling = null;
		      return fiber;
		    }
		    function placeChild(newFiber, lastPlacedIndex, newIndex) {
		      newFiber.index = newIndex;
		      if (!shouldTrackSideEffects)
		        return (newFiber.flags |= 1048576), lastPlacedIndex;
		      newIndex = newFiber.alternate;
		      if (null !== newIndex)
		        return (
		          (newIndex = newIndex.index),
		          newIndex < lastPlacedIndex
		            ? ((newFiber.flags |= 67108866), lastPlacedIndex)
		            : newIndex
		        );
		      newFiber.flags |= 67108866;
		      return lastPlacedIndex;
		    }
		    function placeSingleChild(newFiber) {
		      shouldTrackSideEffects &&
		        null === newFiber.alternate &&
		        (newFiber.flags |= 67108866);
		      return newFiber;
		    }
		    function updateTextNode(returnFiber, current, textContent, lanes) {
		      if (null === current || 6 !== current.tag)
		        return (
		          (current = createFiberFromText(textContent, returnFiber.mode, lanes)),
		          (current.return = returnFiber),
		          current
		        );
		      current = useFiber(current, textContent);
		      current.return = returnFiber;
		      return current;
		    }
		    function updateElement(returnFiber, current, element, lanes) {
		      var elementType = element.type;
		      if (elementType === REACT_FRAGMENT_TYPE)
		        return updateFragment(
		          returnFiber,
		          current,
		          element.props.children,
		          lanes,
		          element.key
		        );
		      if (
		        null !== current &&
		        (current.elementType === elementType ||
		          ("object" === typeof elementType &&
		            null !== elementType &&
		            elementType.$$typeof === REACT_LAZY_TYPE &&
		            resolveLazy(elementType) === current.type))
		      )
		        return (
		          (current = useFiber(current, element.props)),
		          coerceRef(current, element),
		          (current.return = returnFiber),
		          current
		        );
		      current = createFiberFromTypeAndProps(
		        element.type,
		        element.key,
		        element.props,
		        null,
		        returnFiber.mode,
		        lanes
		      );
		      coerceRef(current, element);
		      current.return = returnFiber;
		      return current;
		    }
		    function updatePortal(returnFiber, current, portal, lanes) {
		      if (
		        null === current ||
		        4 !== current.tag ||
		        current.stateNode.containerInfo !== portal.containerInfo ||
		        current.stateNode.implementation !== portal.implementation
		      )
		        return (
		          (current = createFiberFromPortal(portal, returnFiber.mode, lanes)),
		          (current.return = returnFiber),
		          current
		        );
		      current = useFiber(current, portal.children || []);
		      current.return = returnFiber;
		      return current;
		    }
		    function updateFragment(returnFiber, current, fragment, lanes, key) {
		      if (null === current || 7 !== current.tag)
		        return (
		          (current = createFiberFromFragment(
		            fragment,
		            returnFiber.mode,
		            lanes,
		            key
		          )),
		          (current.return = returnFiber),
		          current
		        );
		      current = useFiber(current, fragment);
		      current.return = returnFiber;
		      return current;
		    }
		    function createChild(returnFiber, newChild, lanes) {
		      if (
		        ("string" === typeof newChild && "" !== newChild) ||
		        "number" === typeof newChild ||
		        "bigint" === typeof newChild
		      )
		        return (
		          (newChild = createFiberFromText(
		            "" + newChild,
		            returnFiber.mode,
		            lanes
		          )),
		          (newChild.return = returnFiber),
		          newChild
		        );
		      if ("object" === typeof newChild && null !== newChild) {
		        switch (newChild.$$typeof) {
		          case REACT_ELEMENT_TYPE:
		            return (
		              (lanes = createFiberFromTypeAndProps(
		                newChild.type,
		                newChild.key,
		                newChild.props,
		                null,
		                returnFiber.mode,
		                lanes
		              )),
		              coerceRef(lanes, newChild),
		              (lanes.return = returnFiber),
		              lanes
		            );
		          case REACT_PORTAL_TYPE:
		            return (
		              (newChild = createFiberFromPortal(
		                newChild,
		                returnFiber.mode,
		                lanes
		              )),
		              (newChild.return = returnFiber),
		              newChild
		            );
		          case REACT_LAZY_TYPE:
		            return (
		              (newChild = resolveLazy(newChild)),
		              createChild(returnFiber, newChild, lanes)
		            );
		        }
		        if (isArrayImpl(newChild) || getIteratorFn(newChild))
		          return (
		            (newChild = createFiberFromFragment(
		              newChild,
		              returnFiber.mode,
		              lanes,
		              null
		            )),
		            (newChild.return = returnFiber),
		            newChild
		          );
		        if ("function" === typeof newChild.then)
		          return createChild(returnFiber, unwrapThenable(newChild), lanes);
		        if (newChild.$$typeof === REACT_CONTEXT_TYPE)
		          return createChild(
		            returnFiber,
		            readContextDuringReconciliation(returnFiber, newChild),
		            lanes
		          );
		        throwOnInvalidObjectTypeImpl(returnFiber, newChild);
		      }
		      return null;
		    }
		    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
		      var key = null !== oldFiber ? oldFiber.key : null;
		      if (
		        ("string" === typeof newChild && "" !== newChild) ||
		        "number" === typeof newChild ||
		        "bigint" === typeof newChild
		      )
		        return null !== key
		          ? null
		          : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
		      if ("object" === typeof newChild && null !== newChild) {
		        switch (newChild.$$typeof) {
		          case REACT_ELEMENT_TYPE:
		            return newChild.key === key
		              ? updateElement(returnFiber, oldFiber, newChild, lanes)
		              : null;
		          case REACT_PORTAL_TYPE:
		            return newChild.key === key
		              ? updatePortal(returnFiber, oldFiber, newChild, lanes)
		              : null;
		          case REACT_LAZY_TYPE:
		            return (
		              (newChild = resolveLazy(newChild)),
		              updateSlot(returnFiber, oldFiber, newChild, lanes)
		            );
		        }
		        if (isArrayImpl(newChild) || getIteratorFn(newChild))
		          return null !== key
		            ? null
		            : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
		        if ("function" === typeof newChild.then)
		          return updateSlot(
		            returnFiber,
		            oldFiber,
		            unwrapThenable(newChild),
		            lanes
		          );
		        if (newChild.$$typeof === REACT_CONTEXT_TYPE)
		          return updateSlot(
		            returnFiber,
		            oldFiber,
		            readContextDuringReconciliation(returnFiber, newChild),
		            lanes
		          );
		        throwOnInvalidObjectTypeImpl(returnFiber, newChild);
		      }
		      return null;
		    }
		    function updateFromMap(
		      existingChildren,
		      returnFiber,
		      newIdx,
		      newChild,
		      lanes
		    ) {
		      if (
		        ("string" === typeof newChild && "" !== newChild) ||
		        "number" === typeof newChild ||
		        "bigint" === typeof newChild
		      )
		        return (
		          (existingChildren = existingChildren.get(newIdx) || null),
		          updateTextNode(returnFiber, existingChildren, "" + newChild, lanes)
		        );
		      if ("object" === typeof newChild && null !== newChild) {
		        switch (newChild.$$typeof) {
		          case REACT_ELEMENT_TYPE:
		            return (
		              (existingChildren =
		                existingChildren.get(
		                  null === newChild.key ? newIdx : newChild.key
		                ) || null),
		              updateElement(returnFiber, existingChildren, newChild, lanes)
		            );
		          case REACT_PORTAL_TYPE:
		            return (
		              (existingChildren =
		                existingChildren.get(
		                  null === newChild.key ? newIdx : newChild.key
		                ) || null),
		              updatePortal(returnFiber, existingChildren, newChild, lanes)
		            );
		          case REACT_LAZY_TYPE:
		            return (
		              (newChild = resolveLazy(newChild)),
		              updateFromMap(
		                existingChildren,
		                returnFiber,
		                newIdx,
		                newChild,
		                lanes
		              )
		            );
		        }
		        if (isArrayImpl(newChild) || getIteratorFn(newChild))
		          return (
		            (existingChildren = existingChildren.get(newIdx) || null),
		            updateFragment(returnFiber, existingChildren, newChild, lanes, null)
		          );
		        if ("function" === typeof newChild.then)
		          return updateFromMap(
		            existingChildren,
		            returnFiber,
		            newIdx,
		            unwrapThenable(newChild),
		            lanes
		          );
		        if (newChild.$$typeof === REACT_CONTEXT_TYPE)
		          return updateFromMap(
		            existingChildren,
		            returnFiber,
		            newIdx,
		            readContextDuringReconciliation(returnFiber, newChild),
		            lanes
		          );
		        throwOnInvalidObjectTypeImpl(returnFiber, newChild);
		      }
		      return null;
		    }
		    function reconcileChildrenArray(
		      returnFiber,
		      currentFirstChild,
		      newChildren,
		      lanes
		    ) {
		      for (
		        var resultingFirstChild = null,
		          previousNewFiber = null,
		          oldFiber = currentFirstChild,
		          newIdx = (currentFirstChild = 0),
		          nextOldFiber = null;
		        null !== oldFiber && newIdx < newChildren.length;
		        newIdx++
		      ) {
		        oldFiber.index > newIdx
		          ? ((nextOldFiber = oldFiber), (oldFiber = null))
		          : (nextOldFiber = oldFiber.sibling);
		        var newFiber = updateSlot(
		          returnFiber,
		          oldFiber,
		          newChildren[newIdx],
		          lanes
		        );
		        if (null === newFiber) {
		          null === oldFiber && (oldFiber = nextOldFiber);
		          break;
		        }
		        shouldTrackSideEffects &&
		          oldFiber &&
		          null === newFiber.alternate &&
		          deleteChild(returnFiber, oldFiber);
		        currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
		        null === previousNewFiber
		          ? (resultingFirstChild = newFiber)
		          : (previousNewFiber.sibling = newFiber);
		        previousNewFiber = newFiber;
		        oldFiber = nextOldFiber;
		      }
		      if (newIdx === newChildren.length)
		        return (
		          deleteRemainingChildren(returnFiber, oldFiber),
		          isHydrating && pushTreeFork(returnFiber, newIdx),
		          resultingFirstChild
		        );
		      if (null === oldFiber) {
		        for (; newIdx < newChildren.length; newIdx++)
		          (oldFiber = createChild(returnFiber, newChildren[newIdx], lanes)),
		            null !== oldFiber &&
		              ((currentFirstChild = placeChild(
		                oldFiber,
		                currentFirstChild,
		                newIdx
		              )),
		              null === previousNewFiber
		                ? (resultingFirstChild = oldFiber)
		                : (previousNewFiber.sibling = oldFiber),
		              (previousNewFiber = oldFiber));
		        isHydrating && pushTreeFork(returnFiber, newIdx);
		        return resultingFirstChild;
		      }
		      for (
		        oldFiber = mapRemainingChildren(oldFiber);
		        newIdx < newChildren.length;
		        newIdx++
		      )
		        (nextOldFiber = updateFromMap(
		          oldFiber,
		          returnFiber,
		          newIdx,
		          newChildren[newIdx],
		          lanes
		        )),
		          null !== nextOldFiber &&
		            (shouldTrackSideEffects &&
		              null !== nextOldFiber.alternate &&
		              oldFiber.delete(
		                null === nextOldFiber.key ? newIdx : nextOldFiber.key
		              ),
		            (currentFirstChild = placeChild(
		              nextOldFiber,
		              currentFirstChild,
		              newIdx
		            )),
		            null === previousNewFiber
		              ? (resultingFirstChild = nextOldFiber)
		              : (previousNewFiber.sibling = nextOldFiber),
		            (previousNewFiber = nextOldFiber));
		      shouldTrackSideEffects &&
		        oldFiber.forEach(function (child) {
		          return deleteChild(returnFiber, child);
		        });
		      isHydrating && pushTreeFork(returnFiber, newIdx);
		      return resultingFirstChild;
		    }
		    function reconcileChildrenIterator(
		      returnFiber,
		      currentFirstChild,
		      newChildren,
		      lanes
		    ) {
		      if (null == newChildren) throw Error(formatProdErrorMessage(151));
		      for (
		        var resultingFirstChild = null,
		          previousNewFiber = null,
		          oldFiber = currentFirstChild,
		          newIdx = (currentFirstChild = 0),
		          nextOldFiber = null,
		          step = newChildren.next();
		        null !== oldFiber && !step.done;
		        newIdx++, step = newChildren.next()
		      ) {
		        oldFiber.index > newIdx
		          ? ((nextOldFiber = oldFiber), (oldFiber = null))
		          : (nextOldFiber = oldFiber.sibling);
		        var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
		        if (null === newFiber) {
		          null === oldFiber && (oldFiber = nextOldFiber);
		          break;
		        }
		        shouldTrackSideEffects &&
		          oldFiber &&
		          null === newFiber.alternate &&
		          deleteChild(returnFiber, oldFiber);
		        currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
		        null === previousNewFiber
		          ? (resultingFirstChild = newFiber)
		          : (previousNewFiber.sibling = newFiber);
		        previousNewFiber = newFiber;
		        oldFiber = nextOldFiber;
		      }
		      if (step.done)
		        return (
		          deleteRemainingChildren(returnFiber, oldFiber),
		          isHydrating && pushTreeFork(returnFiber, newIdx),
		          resultingFirstChild
		        );
		      if (null === oldFiber) {
		        for (; !step.done; newIdx++, step = newChildren.next())
		          (step = createChild(returnFiber, step.value, lanes)),
		            null !== step &&
		              ((currentFirstChild = placeChild(
		                step,
		                currentFirstChild,
		                newIdx
		              )),
		              null === previousNewFiber
		                ? (resultingFirstChild = step)
		                : (previousNewFiber.sibling = step),
		              (previousNewFiber = step));
		        isHydrating && pushTreeFork(returnFiber, newIdx);
		        return resultingFirstChild;
		      }
		      for (
		        oldFiber = mapRemainingChildren(oldFiber);
		        !step.done;
		        newIdx++, step = newChildren.next()
		      )
		        (step = updateFromMap(
		          oldFiber,
		          returnFiber,
		          newIdx,
		          step.value,
		          lanes
		        )),
		          null !== step &&
		            (shouldTrackSideEffects &&
		              null !== step.alternate &&
		              oldFiber.delete(null === step.key ? newIdx : step.key),
		            (currentFirstChild = placeChild(step, currentFirstChild, newIdx)),
		            null === previousNewFiber
		              ? (resultingFirstChild = step)
		              : (previousNewFiber.sibling = step),
		            (previousNewFiber = step));
		      shouldTrackSideEffects &&
		        oldFiber.forEach(function (child) {
		          return deleteChild(returnFiber, child);
		        });
		      isHydrating && pushTreeFork(returnFiber, newIdx);
		      return resultingFirstChild;
		    }
		    function reconcileChildFibersImpl(
		      returnFiber,
		      currentFirstChild,
		      newChild,
		      lanes
		    ) {
		      "object" === typeof newChild &&
		        null !== newChild &&
		        newChild.type === REACT_FRAGMENT_TYPE &&
		        null === newChild.key &&
		        (newChild = newChild.props.children);
		      if ("object" === typeof newChild && null !== newChild) {
		        switch (newChild.$$typeof) {
		          case REACT_ELEMENT_TYPE:
		            a: {
		              for (var key = newChild.key; null !== currentFirstChild; ) {
		                if (currentFirstChild.key === key) {
		                  key = newChild.type;
		                  if (key === REACT_FRAGMENT_TYPE) {
		                    if (7 === currentFirstChild.tag) {
		                      deleteRemainingChildren(
		                        returnFiber,
		                        currentFirstChild.sibling
		                      );
		                      lanes = useFiber(
		                        currentFirstChild,
		                        newChild.props.children
		                      );
		                      lanes.return = returnFiber;
		                      returnFiber = lanes;
		                      break a;
		                    }
		                  } else if (
		                    currentFirstChild.elementType === key ||
		                    ("object" === typeof key &&
		                      null !== key &&
		                      key.$$typeof === REACT_LAZY_TYPE &&
		                      resolveLazy(key) === currentFirstChild.type)
		                  ) {
		                    deleteRemainingChildren(
		                      returnFiber,
		                      currentFirstChild.sibling
		                    );
		                    lanes = useFiber(currentFirstChild, newChild.props);
		                    coerceRef(lanes, newChild);
		                    lanes.return = returnFiber;
		                    returnFiber = lanes;
		                    break a;
		                  }
		                  deleteRemainingChildren(returnFiber, currentFirstChild);
		                  break;
		                } else deleteChild(returnFiber, currentFirstChild);
		                currentFirstChild = currentFirstChild.sibling;
		              }
		              newChild.type === REACT_FRAGMENT_TYPE
		                ? ((lanes = createFiberFromFragment(
		                    newChild.props.children,
		                    returnFiber.mode,
		                    lanes,
		                    newChild.key
		                  )),
		                  (lanes.return = returnFiber),
		                  (returnFiber = lanes))
		                : ((lanes = createFiberFromTypeAndProps(
		                    newChild.type,
		                    newChild.key,
		                    newChild.props,
		                    null,
		                    returnFiber.mode,
		                    lanes
		                  )),
		                  coerceRef(lanes, newChild),
		                  (lanes.return = returnFiber),
		                  (returnFiber = lanes));
		            }
		            return placeSingleChild(returnFiber);
		          case REACT_PORTAL_TYPE:
		            a: {
		              for (key = newChild.key; null !== currentFirstChild; ) {
		                if (currentFirstChild.key === key)
		                  if (
		                    4 === currentFirstChild.tag &&
		                    currentFirstChild.stateNode.containerInfo ===
		                      newChild.containerInfo &&
		                    currentFirstChild.stateNode.implementation ===
		                      newChild.implementation
		                  ) {
		                    deleteRemainingChildren(
		                      returnFiber,
		                      currentFirstChild.sibling
		                    );
		                    lanes = useFiber(
		                      currentFirstChild,
		                      newChild.children || []
		                    );
		                    lanes.return = returnFiber;
		                    returnFiber = lanes;
		                    break a;
		                  } else {
		                    deleteRemainingChildren(returnFiber, currentFirstChild);
		                    break;
		                  }
		                else deleteChild(returnFiber, currentFirstChild);
		                currentFirstChild = currentFirstChild.sibling;
		              }
		              lanes = createFiberFromPortal(newChild, returnFiber.mode, lanes);
		              lanes.return = returnFiber;
		              returnFiber = lanes;
		            }
		            return placeSingleChild(returnFiber);
		          case REACT_LAZY_TYPE:
		            return (
		              (newChild = resolveLazy(newChild)),
		              reconcileChildFibersImpl(
		                returnFiber,
		                currentFirstChild,
		                newChild,
		                lanes
		              )
		            );
		        }
		        if (isArrayImpl(newChild))
		          return reconcileChildrenArray(
		            returnFiber,
		            currentFirstChild,
		            newChild,
		            lanes
		          );
		        if (getIteratorFn(newChild)) {
		          key = getIteratorFn(newChild);
		          if ("function" !== typeof key)
		            throw Error(formatProdErrorMessage(150));
		          newChild = key.call(newChild);
		          return reconcileChildrenIterator(
		            returnFiber,
		            currentFirstChild,
		            newChild,
		            lanes
		          );
		        }
		        if ("function" === typeof newChild.then)
		          return reconcileChildFibersImpl(
		            returnFiber,
		            currentFirstChild,
		            unwrapThenable(newChild),
		            lanes
		          );
		        if (newChild.$$typeof === REACT_CONTEXT_TYPE)
		          return reconcileChildFibersImpl(
		            returnFiber,
		            currentFirstChild,
		            readContextDuringReconciliation(returnFiber, newChild),
		            lanes
		          );
		        throwOnInvalidObjectTypeImpl(returnFiber, newChild);
		      }
		      return ("string" === typeof newChild && "" !== newChild) ||
		        "number" === typeof newChild ||
		        "bigint" === typeof newChild
		        ? ((newChild = "" + newChild),
		          null !== currentFirstChild && 6 === currentFirstChild.tag
		            ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling),
		              (lanes = useFiber(currentFirstChild, newChild)),
		              (lanes.return = returnFiber),
		              (returnFiber = lanes))
		            : (deleteRemainingChildren(returnFiber, currentFirstChild),
		              (lanes = createFiberFromText(newChild, returnFiber.mode, lanes)),
		              (lanes.return = returnFiber),
		              (returnFiber = lanes)),
		          placeSingleChild(returnFiber))
		        : deleteRemainingChildren(returnFiber, currentFirstChild);
		    }
		    return function (returnFiber, currentFirstChild, newChild, lanes) {
		      try {
		        thenableIndexCounter$1 = 0;
		        var firstChildFiber = reconcileChildFibersImpl(
		          returnFiber,
		          currentFirstChild,
		          newChild,
		          lanes
		        );
		        thenableState$1 = null;
		        return firstChildFiber;
		      } catch (x) {
		        if (x === SuspenseException || x === SuspenseActionException) throw x;
		        var fiber = createFiber(29, x, null, returnFiber.mode);
		        fiber.lanes = lanes;
		        fiber.return = returnFiber;
		        return fiber;
		      } finally {
		      }
		    };
		  }
		  function finishQueueingConcurrentUpdates() {
		    for (
		      var endIndex = concurrentQueuesIndex,
		        i = (concurrentlyUpdatedLanes = concurrentQueuesIndex = 0);
		      i < endIndex;

		    ) {
		      var fiber = concurrentQueues[i];
		      concurrentQueues[i++] = null;
		      var queue = concurrentQueues[i];
		      concurrentQueues[i++] = null;
		      var update = concurrentQueues[i];
		      concurrentQueues[i++] = null;
		      var lane = concurrentQueues[i];
		      concurrentQueues[i++] = null;
		      if (null !== queue && null !== update) {
		        var pending = queue.pending;
		        null === pending
		          ? (update.next = update)
		          : ((update.next = pending.next), (pending.next = update));
		        queue.pending = update;
		      }
		      0 !== lane && markUpdateLaneFromFiberToRoot(fiber, update, lane);
		    }
		  }
		  function enqueueUpdate$1(fiber, queue, update, lane) {
		    concurrentQueues[concurrentQueuesIndex++] = fiber;
		    concurrentQueues[concurrentQueuesIndex++] = queue;
		    concurrentQueues[concurrentQueuesIndex++] = update;
		    concurrentQueues[concurrentQueuesIndex++] = lane;
		    concurrentlyUpdatedLanes |= lane;
		    fiber.lanes |= lane;
		    fiber = fiber.alternate;
		    null !== fiber && (fiber.lanes |= lane);
		  }
		  function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
		    enqueueUpdate$1(fiber, queue, update, lane);
		    return getRootForUpdatedFiber(fiber);
		  }
		  function enqueueConcurrentRenderForLane(fiber, lane) {
		    enqueueUpdate$1(fiber, null, null, lane);
		    return getRootForUpdatedFiber(fiber);
		  }
		  function markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
		    sourceFiber.lanes |= lane;
		    var alternate = sourceFiber.alternate;
		    null !== alternate && (alternate.lanes |= lane);
		    for (var isHidden = false, parent = sourceFiber.return; null !== parent; )
		      (parent.childLanes |= lane),
		        (alternate = parent.alternate),
		        null !== alternate && (alternate.childLanes |= lane),
		        22 === parent.tag &&
		          ((sourceFiber = parent.stateNode),
		          null === sourceFiber ||
		            sourceFiber._visibility & 1 ||
		            (isHidden = true)),
		        (sourceFiber = parent),
		        (parent = parent.return);
		    return 3 === sourceFiber.tag
		      ? ((parent = sourceFiber.stateNode),
		        isHidden &&
		          null !== update &&
		          ((isHidden = 31 - clz32(lane)),
		          (sourceFiber = parent.hiddenUpdates),
		          (alternate = sourceFiber[isHidden]),
		          null === alternate
		            ? (sourceFiber[isHidden] = [update])
		            : alternate.push(update),
		          (update.lane = lane | 536870912)),
		        parent)
		      : null;
		  }
		  function getRootForUpdatedFiber(sourceFiber) {
		    if (50 < nestedUpdateCount)
		      throw (
		        ((nestedUpdateCount = 0),
		        (rootWithNestedUpdates = null),
		        Error(formatProdErrorMessage(185)))
		      );
		    for (var parent = sourceFiber.return; null !== parent; )
		      (sourceFiber = parent), (parent = sourceFiber.return);
		    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
		  }
		  function initializeUpdateQueue(fiber) {
		    fiber.updateQueue = {
		      baseState: fiber.memoizedState,
		      firstBaseUpdate: null,
		      lastBaseUpdate: null,
		      shared: { pending: null, lanes: 0, hiddenCallbacks: null },
		      callbacks: null
		    };
		  }
		  function cloneUpdateQueue(current, workInProgress) {
		    current = current.updateQueue;
		    workInProgress.updateQueue === current &&
		      (workInProgress.updateQueue = {
		        baseState: current.baseState,
		        firstBaseUpdate: current.firstBaseUpdate,
		        lastBaseUpdate: current.lastBaseUpdate,
		        shared: current.shared,
		        callbacks: null
		      });
		  }
		  function createUpdate(lane) {
		    return { lane: lane, tag: 0, payload: null, callback: null, next: null };
		  }
		  function enqueueUpdate(fiber, update, lane) {
		    var updateQueue = fiber.updateQueue;
		    if (null === updateQueue) return null;
		    updateQueue = updateQueue.shared;
		    if (0 !== (executionContext & 2)) {
		      var pending = updateQueue.pending;
		      null === pending
		        ? (update.next = update)
		        : ((update.next = pending.next), (pending.next = update));
		      updateQueue.pending = update;
		      update = getRootForUpdatedFiber(fiber);
		      markUpdateLaneFromFiberToRoot(fiber, null, lane);
		      return update;
		    }
		    enqueueUpdate$1(fiber, updateQueue, update, lane);
		    return getRootForUpdatedFiber(fiber);
		  }
		  function entangleTransitions(root, fiber, lane) {
		    fiber = fiber.updateQueue;
		    if (null !== fiber && ((fiber = fiber.shared), 0 !== (lane & 4194048))) {
		      var queueLanes = fiber.lanes;
		      queueLanes &= root.pendingLanes;
		      lane |= queueLanes;
		      fiber.lanes = lane;
		      markRootEntangled(root, lane);
		    }
		  }
		  function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
		    var queue = workInProgress.updateQueue,
		      current = workInProgress.alternate;
		    if (
		      null !== current &&
		      ((current = current.updateQueue), queue === current)
		    ) {
		      var newFirst = null,
		        newLast = null;
		      queue = queue.firstBaseUpdate;
		      if (null !== queue) {
		        do {
		          var clone = {
		            lane: queue.lane,
		            tag: queue.tag,
		            payload: queue.payload,
		            callback: null,
		            next: null
		          };
		          null === newLast
		            ? (newFirst = newLast = clone)
		            : (newLast = newLast.next = clone);
		          queue = queue.next;
		        } while (null !== queue);
		        null === newLast
		          ? (newFirst = newLast = capturedUpdate)
		          : (newLast = newLast.next = capturedUpdate);
		      } else newFirst = newLast = capturedUpdate;
		      queue = {
		        baseState: current.baseState,
		        firstBaseUpdate: newFirst,
		        lastBaseUpdate: newLast,
		        shared: current.shared,
		        callbacks: current.callbacks
		      };
		      workInProgress.updateQueue = queue;
		      return;
		    }
		    workInProgress = queue.lastBaseUpdate;
		    null === workInProgress
		      ? (queue.firstBaseUpdate = capturedUpdate)
		      : (workInProgress.next = capturedUpdate);
		    queue.lastBaseUpdate = capturedUpdate;
		  }
		  function suspendIfUpdateReadFromEntangledAsyncAction() {
		    if (didReadFromEntangledAsyncAction) {
		      var entangledActionThenable = currentEntangledActionThenable;
		      if (null !== entangledActionThenable) throw entangledActionThenable;
		    }
		  }
		  function processUpdateQueue(
		    workInProgress$jscomp$0,
		    props,
		    instance$jscomp$0,
		    renderLanes
		  ) {
		    didReadFromEntangledAsyncAction = false;
		    var queue = workInProgress$jscomp$0.updateQueue;
		    hasForceUpdate = false;
		    var firstBaseUpdate = queue.firstBaseUpdate,
		      lastBaseUpdate = queue.lastBaseUpdate,
		      pendingQueue = queue.shared.pending;
		    if (null !== pendingQueue) {
		      queue.shared.pending = null;
		      var lastPendingUpdate = pendingQueue,
		        firstPendingUpdate = lastPendingUpdate.next;
		      lastPendingUpdate.next = null;
		      null === lastBaseUpdate
		        ? (firstBaseUpdate = firstPendingUpdate)
		        : (lastBaseUpdate.next = firstPendingUpdate);
		      lastBaseUpdate = lastPendingUpdate;
		      var current = workInProgress$jscomp$0.alternate;
		      null !== current &&
		        ((current = current.updateQueue),
		        (pendingQueue = current.lastBaseUpdate),
		        pendingQueue !== lastBaseUpdate &&
		          (null === pendingQueue
		            ? (current.firstBaseUpdate = firstPendingUpdate)
		            : (pendingQueue.next = firstPendingUpdate),
		          (current.lastBaseUpdate = lastPendingUpdate)));
		    }
		    if (null !== firstBaseUpdate) {
		      var newState = queue.baseState;
		      lastBaseUpdate = 0;
		      current = firstPendingUpdate = lastPendingUpdate = null;
		      pendingQueue = firstBaseUpdate;
		      do {
		        var updateLane = pendingQueue.lane & -536870913,
		          isHiddenUpdate = updateLane !== pendingQueue.lane;
		        if (
		          isHiddenUpdate
		            ? (workInProgressRootRenderLanes & updateLane) === updateLane
		            : (renderLanes & updateLane) === updateLane
		        ) {
		          0 !== updateLane &&
		            updateLane === currentEntangledLane &&
		            (didReadFromEntangledAsyncAction = true);
		          null !== current &&
		            (current = current.next =
		              {
		                lane: 0,
		                tag: pendingQueue.tag,
		                payload: pendingQueue.payload,
		                callback: null,
		                next: null
		              });
		          a: {
		            var workInProgress = workInProgress$jscomp$0,
		              update = pendingQueue;
		            updateLane = props;
		            var instance = instance$jscomp$0;
		            switch (update.tag) {
		              case 1:
		                workInProgress = update.payload;
		                if ("function" === typeof workInProgress) {
		                  newState = workInProgress.call(
		                    instance,
		                    newState,
		                    updateLane
		                  );
		                  break a;
		                }
		                newState = workInProgress;
		                break a;
		              case 3:
		                workInProgress.flags = (workInProgress.flags & -65537) | 128;
		              case 0:
		                workInProgress = update.payload;
		                updateLane =
		                  "function" === typeof workInProgress
		                    ? workInProgress.call(instance, newState, updateLane)
		                    : workInProgress;
		                if (null === updateLane || void 0 === updateLane) break a;
		                newState = assign({}, newState, updateLane);
		                break a;
		              case 2:
		                hasForceUpdate = true;
		            }
		          }
		          updateLane = pendingQueue.callback;
		          null !== updateLane &&
		            ((workInProgress$jscomp$0.flags |= 64),
		            isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192),
		            (isHiddenUpdate = queue.callbacks),
		            null === isHiddenUpdate
		              ? (queue.callbacks = [updateLane])
		              : isHiddenUpdate.push(updateLane));
		        } else
		          (isHiddenUpdate = {
		            lane: updateLane,
		            tag: pendingQueue.tag,
		            payload: pendingQueue.payload,
		            callback: pendingQueue.callback,
		            next: null
		          }),
		            null === current
		              ? ((firstPendingUpdate = current = isHiddenUpdate),
		                (lastPendingUpdate = newState))
		              : (current = current.next = isHiddenUpdate),
		            (lastBaseUpdate |= updateLane);
		        pendingQueue = pendingQueue.next;
		        if (null === pendingQueue)
		          if (((pendingQueue = queue.shared.pending), null === pendingQueue))
		            break;
		          else
		            (isHiddenUpdate = pendingQueue),
		              (pendingQueue = isHiddenUpdate.next),
		              (isHiddenUpdate.next = null),
		              (queue.lastBaseUpdate = isHiddenUpdate),
		              (queue.shared.pending = null);
		      } while (1);
		      null === current && (lastPendingUpdate = newState);
		      queue.baseState = lastPendingUpdate;
		      queue.firstBaseUpdate = firstPendingUpdate;
		      queue.lastBaseUpdate = current;
		      null === firstBaseUpdate && (queue.shared.lanes = 0);
		      workInProgressRootSkippedLanes |= lastBaseUpdate;
		      workInProgress$jscomp$0.lanes = lastBaseUpdate;
		      workInProgress$jscomp$0.memoizedState = newState;
		    }
		  }
		  function callCallback(callback, context) {
		    if ("function" !== typeof callback)
		      throw Error(formatProdErrorMessage(191, callback));
		    callback.call(context);
		  }
		  function commitCallbacks(updateQueue, context) {
		    var callbacks = updateQueue.callbacks;
		    if (null !== callbacks)
		      for (
		        updateQueue.callbacks = null, updateQueue = 0;
		        updateQueue < callbacks.length;
		        updateQueue++
		      )
		        callCallback(callbacks[updateQueue], context);
		  }
		  function pushHiddenContext(fiber, context) {
		    fiber = entangledRenderLanes;
		    push(prevEntangledRenderLanesCursor, fiber);
		    push(currentTreeHiddenStackCursor, context);
		    entangledRenderLanes = fiber | context.baseLanes;
		  }
		  function reuseHiddenContextOnStack() {
		    push(prevEntangledRenderLanesCursor, entangledRenderLanes);
		    push(currentTreeHiddenStackCursor, currentTreeHiddenStackCursor.current);
		  }
		  function popHiddenContext() {
		    entangledRenderLanes = prevEntangledRenderLanesCursor.current;
		    pop(currentTreeHiddenStackCursor);
		    pop(prevEntangledRenderLanesCursor);
		  }
		  function pushPrimaryTreeSuspenseHandler(handler) {
		    var current = handler.alternate;
		    push(suspenseStackCursor, suspenseStackCursor.current & 1);
		    push(suspenseHandlerStackCursor, handler);
		    null === shellBoundary &&
		      (null === current || null !== currentTreeHiddenStackCursor.current
		        ? (shellBoundary = handler)
		        : null !== current.memoizedState && (shellBoundary = handler));
		  }
		  function pushDehydratedActivitySuspenseHandler(fiber) {
		    push(suspenseStackCursor, suspenseStackCursor.current);
		    push(suspenseHandlerStackCursor, fiber);
		    null === shellBoundary && (shellBoundary = fiber);
		  }
		  function pushOffscreenSuspenseHandler(fiber) {
		    22 === fiber.tag
		      ? (push(suspenseStackCursor, suspenseStackCursor.current),
		        push(suspenseHandlerStackCursor, fiber),
		        null === shellBoundary && (shellBoundary = fiber))
		      : reuseSuspenseHandlerOnStack();
		  }
		  function reuseSuspenseHandlerOnStack() {
		    push(suspenseStackCursor, suspenseStackCursor.current);
		    push(suspenseHandlerStackCursor, suspenseHandlerStackCursor.current);
		  }
		  function popSuspenseHandler(fiber) {
		    pop(suspenseHandlerStackCursor);
		    shellBoundary === fiber && (shellBoundary = null);
		    pop(suspenseStackCursor);
		  }
		  function findFirstSuspended(row) {
		    for (var node = row; null !== node; ) {
		      if (13 === node.tag) {
		        var state = node.memoizedState;
		        if (
		          null !== state &&
		          ((state = state.dehydrated),
		          null === state ||
		            isSuspenseInstancePending(state) ||
		            isSuspenseInstanceFallback(state))
		        )
		          return node;
		      } else if (
		        19 === node.tag &&
		        ("forwards" === node.memoizedProps.revealOrder ||
		          "backwards" === node.memoizedProps.revealOrder ||
		          "unstable_legacy-backwards" === node.memoizedProps.revealOrder ||
		          "together" === node.memoizedProps.revealOrder)
		      ) {
		        if (0 !== (node.flags & 128)) return node;
		      } else if (null !== node.child) {
		        node.child.return = node;
		        node = node.child;
		        continue;
		      }
		      if (node === row) break;
		      for (; null === node.sibling; ) {
		        if (null === node.return || node.return === row) return null;
		        node = node.return;
		      }
		      node.sibling.return = node.return;
		      node = node.sibling;
		    }
		    return null;
		  }
		  function throwInvalidHookError() {
		    throw Error(formatProdErrorMessage(321));
		  }
		  function areHookInputsEqual(nextDeps, prevDeps) {
		    if (null === prevDeps) return false;
		    for (var i = 0; i < prevDeps.length && i < nextDeps.length; i++)
		      if (!objectIs(nextDeps[i], prevDeps[i])) return false;
		    return true;
		  }
		  function renderWithHooks(
		    current,
		    workInProgress,
		    Component,
		    props,
		    secondArg,
		    nextRenderLanes
		  ) {
		    renderLanes = nextRenderLanes;
		    currentlyRenderingFiber = workInProgress;
		    workInProgress.memoizedState = null;
		    workInProgress.updateQueue = null;
		    workInProgress.lanes = 0;
		    ReactSharedInternals.H =
		      null === current || null === current.memoizedState
		        ? HooksDispatcherOnMount
		        : HooksDispatcherOnUpdate;
		    shouldDoubleInvokeUserFnsInHooksDEV = false;
		    nextRenderLanes = Component(props, secondArg);
		    shouldDoubleInvokeUserFnsInHooksDEV = false;
		    didScheduleRenderPhaseUpdateDuringThisPass &&
		      (nextRenderLanes = renderWithHooksAgain(
		        workInProgress,
		        Component,
		        props,
		        secondArg
		      ));
		    finishRenderingHooks(current);
		    return nextRenderLanes;
		  }
		  function finishRenderingHooks(current) {
		    ReactSharedInternals.H = ContextOnlyDispatcher;
		    var didRenderTooFewHooks =
		      null !== currentHook && null !== currentHook.next;
		    renderLanes = 0;
		    workInProgressHook = currentHook = currentlyRenderingFiber = null;
		    didScheduleRenderPhaseUpdate = false;
		    thenableIndexCounter = 0;
		    thenableState = null;
		    if (didRenderTooFewHooks) throw Error(formatProdErrorMessage(300));
		    null === current ||
		      didReceiveUpdate ||
		      ((current = current.dependencies),
		      null !== current &&
		        checkIfContextChanged(current) &&
		        (didReceiveUpdate = true));
		  }
		  function renderWithHooksAgain(workInProgress, Component, props, secondArg) {
		    currentlyRenderingFiber = workInProgress;
		    var numberOfReRenders = 0;
		    do {
		      didScheduleRenderPhaseUpdateDuringThisPass && (thenableState = null);
		      thenableIndexCounter = 0;
		      didScheduleRenderPhaseUpdateDuringThisPass = false;
		      if (25 <= numberOfReRenders) throw Error(formatProdErrorMessage(301));
		      numberOfReRenders += 1;
		      workInProgressHook = currentHook = null;
		      if (null != workInProgress.updateQueue) {
		        var children = workInProgress.updateQueue;
		        children.lastEffect = null;
		        children.events = null;
		        children.stores = null;
		        null != children.memoCache && (children.memoCache.index = 0);
		      }
		      ReactSharedInternals.H = HooksDispatcherOnRerender;
		      children = Component(props, secondArg);
		    } while (didScheduleRenderPhaseUpdateDuringThisPass);
		    return children;
		  }
		  function TransitionAwareHostComponent() {
		    var dispatcher = ReactSharedInternals.H,
		      maybeThenable = dispatcher.useState()[0];
		    maybeThenable =
		      "function" === typeof maybeThenable.then
		        ? useThenable(maybeThenable)
		        : maybeThenable;
		    dispatcher = dispatcher.useState()[0];
		    (null !== currentHook ? currentHook.memoizedState : null) !== dispatcher &&
		      (currentlyRenderingFiber.flags |= 1024);
		    return maybeThenable;
		  }
		  function checkDidRenderIdHook() {
		    var didRenderIdHook = 0 !== localIdCounter;
		    localIdCounter = 0;
		    return didRenderIdHook;
		  }
		  function bailoutHooks(current, workInProgress, lanes) {
		    workInProgress.updateQueue = current.updateQueue;
		    workInProgress.flags &= -2053;
		    current.lanes &= ~lanes;
		  }
		  function resetHooksOnUnwind(workInProgress) {
		    if (didScheduleRenderPhaseUpdate) {
		      for (
		        workInProgress = workInProgress.memoizedState;
		        null !== workInProgress;

		      ) {
		        var queue = workInProgress.queue;
		        null !== queue && (queue.pending = null);
		        workInProgress = workInProgress.next;
		      }
		      didScheduleRenderPhaseUpdate = false;
		    }
		    renderLanes = 0;
		    workInProgressHook = currentHook = currentlyRenderingFiber = null;
		    didScheduleRenderPhaseUpdateDuringThisPass = false;
		    thenableIndexCounter = localIdCounter = 0;
		    thenableState = null;
		  }
		  function mountWorkInProgressHook() {
		    var hook = {
		      memoizedState: null,
		      baseState: null,
		      baseQueue: null,
		      queue: null,
		      next: null
		    };
		    null === workInProgressHook
		      ? (currentlyRenderingFiber.memoizedState = workInProgressHook = hook)
		      : (workInProgressHook = workInProgressHook.next = hook);
		    return workInProgressHook;
		  }
		  function updateWorkInProgressHook() {
		    if (null === currentHook) {
		      var nextCurrentHook = currentlyRenderingFiber.alternate;
		      nextCurrentHook =
		        null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
		    } else nextCurrentHook = currentHook.next;
		    var nextWorkInProgressHook =
		      null === workInProgressHook
		        ? currentlyRenderingFiber.memoizedState
		        : workInProgressHook.next;
		    if (null !== nextWorkInProgressHook)
		      (workInProgressHook = nextWorkInProgressHook),
		        (currentHook = nextCurrentHook);
		    else {
		      if (null === nextCurrentHook) {
		        if (null === currentlyRenderingFiber.alternate)
		          throw Error(formatProdErrorMessage(467));
		        throw Error(formatProdErrorMessage(310));
		      }
		      currentHook = nextCurrentHook;
		      nextCurrentHook = {
		        memoizedState: currentHook.memoizedState,
		        baseState: currentHook.baseState,
		        baseQueue: currentHook.baseQueue,
		        queue: currentHook.queue,
		        next: null
		      };
		      null === workInProgressHook
		        ? (currentlyRenderingFiber.memoizedState = workInProgressHook =
		            nextCurrentHook)
		        : (workInProgressHook = workInProgressHook.next = nextCurrentHook);
		    }
		    return workInProgressHook;
		  }
		  function createFunctionComponentUpdateQueue() {
		    return { lastEffect: null, events: null, stores: null, memoCache: null };
		  }
		  function useThenable(thenable) {
		    var index = thenableIndexCounter;
		    thenableIndexCounter += 1;
		    null === thenableState && (thenableState = []);
		    thenable = trackUsedThenable(thenableState, thenable, index);
		    index = currentlyRenderingFiber;
		    null ===
		      (null === workInProgressHook
		        ? index.memoizedState
		        : workInProgressHook.next) &&
		      ((index = index.alternate),
		      (ReactSharedInternals.H =
		        null === index || null === index.memoizedState
		          ? HooksDispatcherOnMount
		          : HooksDispatcherOnUpdate));
		    return thenable;
		  }
		  function use(usable) {
		    if (null !== usable && "object" === typeof usable) {
		      if ("function" === typeof usable.then) return useThenable(usable);
		      if (usable.$$typeof === REACT_CONTEXT_TYPE) return readContext(usable);
		    }
		    throw Error(formatProdErrorMessage(438, String(usable)));
		  }
		  function useMemoCache(size) {
		    var memoCache = null,
		      updateQueue = currentlyRenderingFiber.updateQueue;
		    null !== updateQueue && (memoCache = updateQueue.memoCache);
		    if (null == memoCache) {
		      var current = currentlyRenderingFiber.alternate;
		      null !== current &&
		        ((current = current.updateQueue),
		        null !== current &&
		          ((current = current.memoCache),
		          null != current &&
		            (memoCache = {
		              data: current.data.map(function (array) {
		                return array.slice();
		              }),
		              index: 0
		            })));
		    }
		    null == memoCache && (memoCache = { data: [], index: 0 });
		    null === updateQueue &&
		      ((updateQueue = createFunctionComponentUpdateQueue()),
		      (currentlyRenderingFiber.updateQueue = updateQueue));
		    updateQueue.memoCache = memoCache;
		    updateQueue = memoCache.data[memoCache.index];
		    if (void 0 === updateQueue)
		      for (
		        updateQueue = memoCache.data[memoCache.index] = Array(size),
		          current = 0;
		        current < size;
		        current++
		      )
		        updateQueue[current] = REACT_MEMO_CACHE_SENTINEL;
		    memoCache.index++;
		    return updateQueue;
		  }
		  function basicStateReducer(state, action) {
		    return "function" === typeof action ? action(state) : action;
		  }
		  function updateReducer(reducer) {
		    var hook = updateWorkInProgressHook();
		    return updateReducerImpl(hook, currentHook, reducer);
		  }
		  function updateReducerImpl(hook, current, reducer) {
		    var queue = hook.queue;
		    if (null === queue) throw Error(formatProdErrorMessage(311));
		    queue.lastRenderedReducer = reducer;
		    var baseQueue = hook.baseQueue,
		      pendingQueue = queue.pending;
		    if (null !== pendingQueue) {
		      if (null !== baseQueue) {
		        var baseFirst = baseQueue.next;
		        baseQueue.next = pendingQueue.next;
		        pendingQueue.next = baseFirst;
		      }
		      current.baseQueue = baseQueue = pendingQueue;
		      queue.pending = null;
		    }
		    pendingQueue = hook.baseState;
		    if (null === baseQueue) hook.memoizedState = pendingQueue;
		    else {
		      current = baseQueue.next;
		      var newBaseQueueFirst = (baseFirst = null),
		        newBaseQueueLast = null,
		        update = current,
		        didReadFromEntangledAsyncAction$51 = false;
		      do {
		        var updateLane = update.lane & -536870913;
		        if (
		          updateLane !== update.lane
		            ? (workInProgressRootRenderLanes & updateLane) === updateLane
		            : (renderLanes & updateLane) === updateLane
		        ) {
		          var revertLane = update.revertLane;
		          if (0 === revertLane)
		            null !== newBaseQueueLast &&
		              (newBaseQueueLast = newBaseQueueLast.next =
		                {
		                  lane: 0,
		                  revertLane: 0,
		                  gesture: null,
		                  action: update.action,
		                  hasEagerState: update.hasEagerState,
		                  eagerState: update.eagerState,
		                  next: null
		                }),
		              updateLane === currentEntangledLane &&
		                (didReadFromEntangledAsyncAction$51 = true);
		          else if ((renderLanes & revertLane) === revertLane) {
		            update = update.next;
		            revertLane === currentEntangledLane &&
		              (didReadFromEntangledAsyncAction$51 = true);
		            continue;
		          } else
		            (updateLane = {
		              lane: 0,
		              revertLane: update.revertLane,
		              gesture: null,
		              action: update.action,
		              hasEagerState: update.hasEagerState,
		              eagerState: update.eagerState,
		              next: null
		            }),
		              null === newBaseQueueLast
		                ? ((newBaseQueueFirst = newBaseQueueLast = updateLane),
		                  (baseFirst = pendingQueue))
		                : (newBaseQueueLast = newBaseQueueLast.next = updateLane),
		              (currentlyRenderingFiber.lanes |= revertLane),
		              (workInProgressRootSkippedLanes |= revertLane);
		          updateLane = update.action;
		          shouldDoubleInvokeUserFnsInHooksDEV &&
		            reducer(pendingQueue, updateLane);
		          pendingQueue = update.hasEagerState
		            ? update.eagerState
		            : reducer(pendingQueue, updateLane);
		        } else
		          (revertLane = {
		            lane: updateLane,
		            revertLane: update.revertLane,
		            gesture: update.gesture,
		            action: update.action,
		            hasEagerState: update.hasEagerState,
		            eagerState: update.eagerState,
		            next: null
		          }),
		            null === newBaseQueueLast
		              ? ((newBaseQueueFirst = newBaseQueueLast = revertLane),
		                (baseFirst = pendingQueue))
		              : (newBaseQueueLast = newBaseQueueLast.next = revertLane),
		            (currentlyRenderingFiber.lanes |= updateLane),
		            (workInProgressRootSkippedLanes |= updateLane);
		        update = update.next;
		      } while (null !== update && update !== current);
		      null === newBaseQueueLast
		        ? (baseFirst = pendingQueue)
		        : (newBaseQueueLast.next = newBaseQueueFirst);
		      if (
		        !objectIs(pendingQueue, hook.memoizedState) &&
		        ((didReceiveUpdate = true),
		        didReadFromEntangledAsyncAction$51 &&
		          ((reducer = currentEntangledActionThenable), null !== reducer))
		      )
		        throw reducer;
		      hook.memoizedState = pendingQueue;
		      hook.baseState = baseFirst;
		      hook.baseQueue = newBaseQueueLast;
		      queue.lastRenderedState = pendingQueue;
		    }
		    null === baseQueue && (queue.lanes = 0);
		    return [hook.memoizedState, queue.dispatch];
		  }
		  function rerenderReducer(reducer) {
		    var hook = updateWorkInProgressHook(),
		      queue = hook.queue;
		    if (null === queue) throw Error(formatProdErrorMessage(311));
		    queue.lastRenderedReducer = reducer;
		    var dispatch = queue.dispatch,
		      lastRenderPhaseUpdate = queue.pending,
		      newState = hook.memoizedState;
		    if (null !== lastRenderPhaseUpdate) {
		      queue.pending = null;
		      var update = (lastRenderPhaseUpdate = lastRenderPhaseUpdate.next);
		      do (newState = reducer(newState, update.action)), (update = update.next);
		      while (update !== lastRenderPhaseUpdate);
		      objectIs(newState, hook.memoizedState) || (didReceiveUpdate = true);
		      hook.memoizedState = newState;
		      null === hook.baseQueue && (hook.baseState = newState);
		      queue.lastRenderedState = newState;
		    }
		    return [newState, dispatch];
		  }
		  function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
		    var fiber = currentlyRenderingFiber,
		      hook = updateWorkInProgressHook(),
		      isHydrating$jscomp$0 = isHydrating;
		    if (isHydrating$jscomp$0) {
		      if (void 0 === getServerSnapshot)
		        throw Error(formatProdErrorMessage(407));
		      getServerSnapshot = getServerSnapshot();
		    } else getServerSnapshot = getSnapshot();
		    var snapshotChanged = !objectIs(
		      (currentHook || hook).memoizedState,
		      getServerSnapshot
		    );
		    snapshotChanged &&
		      ((hook.memoizedState = getServerSnapshot), (didReceiveUpdate = true));
		    hook = hook.queue;
		    updateEffect(subscribeToStore.bind(null, fiber, hook, subscribe), [
		      subscribe
		    ]);
		    if (
		      hook.getSnapshot !== getSnapshot ||
		      snapshotChanged ||
		      (null !== workInProgressHook && workInProgressHook.memoizedState.tag & 1)
		    ) {
		      fiber.flags |= 2048;
		      pushSimpleEffect(
		        9,
		        { destroy: void 0 },
		        updateStoreInstance.bind(
		          null,
		          fiber,
		          hook,
		          getServerSnapshot,
		          getSnapshot
		        ),
		        null
		      );
		      if (null === workInProgressRoot) throw Error(formatProdErrorMessage(349));
		      isHydrating$jscomp$0 ||
		        0 !== (renderLanes & 127) ||
		        pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
		    }
		    return getServerSnapshot;
		  }
		  function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
		    fiber.flags |= 16384;
		    fiber = { getSnapshot: getSnapshot, value: renderedSnapshot };
		    getSnapshot = currentlyRenderingFiber.updateQueue;
		    null === getSnapshot
		      ? ((getSnapshot = createFunctionComponentUpdateQueue()),
		        (currentlyRenderingFiber.updateQueue = getSnapshot),
		        (getSnapshot.stores = [fiber]))
		      : ((renderedSnapshot = getSnapshot.stores),
		        null === renderedSnapshot
		          ? (getSnapshot.stores = [fiber])
		          : renderedSnapshot.push(fiber));
		  }
		  function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
		    inst.value = nextSnapshot;
		    inst.getSnapshot = getSnapshot;
		    checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
		  }
		  function subscribeToStore(fiber, inst, subscribe) {
		    return subscribe(function () {
		      checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
		    });
		  }
		  function checkIfSnapshotChanged(inst) {
		    var latestGetSnapshot = inst.getSnapshot;
		    inst = inst.value;
		    try {
		      var nextValue = latestGetSnapshot();
		      return !objectIs(inst, nextValue);
		    } catch (error) {
		      return true;
		    }
		  }
		  function forceStoreRerender(fiber) {
		    var root = enqueueConcurrentRenderForLane(fiber, 2);
		    null !== root && scheduleUpdateOnFiber(root, fiber, 2);
		  }
		  function mountStateImpl(initialState) {
		    var hook = mountWorkInProgressHook();
		    if ("function" === typeof initialState) {
		      var initialStateInitializer = initialState;
		      initialState = initialStateInitializer();
		      if (shouldDoubleInvokeUserFnsInHooksDEV) {
		        setIsStrictModeForDevtools(true);
		        try {
		          initialStateInitializer();
		        } finally {
		          setIsStrictModeForDevtools(false);
		        }
		      }
		    }
		    hook.memoizedState = hook.baseState = initialState;
		    hook.queue = {
		      pending: null,
		      lanes: 0,
		      dispatch: null,
		      lastRenderedReducer: basicStateReducer,
		      lastRenderedState: initialState
		    };
		    return hook;
		  }
		  function updateOptimisticImpl(hook, current, passthrough, reducer) {
		    hook.baseState = passthrough;
		    return updateReducerImpl(
		      hook,
		      currentHook,
		      "function" === typeof reducer ? reducer : basicStateReducer
		    );
		  }
		  function dispatchActionState(
		    fiber,
		    actionQueue,
		    setPendingState,
		    setState,
		    payload
		  ) {
		    if (isRenderPhaseUpdate(fiber)) throw Error(formatProdErrorMessage(485));
		    fiber = actionQueue.action;
		    if (null !== fiber) {
		      var actionNode = {
		        payload: payload,
		        action: fiber,
		        next: null,
		        isTransition: true,
		        status: "pending",
		        value: null,
		        reason: null,
		        listeners: [],
		        then: function (listener) {
		          actionNode.listeners.push(listener);
		        }
		      };
		      null !== ReactSharedInternals.T
		        ? setPendingState(true)
		        : (actionNode.isTransition = false);
		      setState(actionNode);
		      setPendingState = actionQueue.pending;
		      null === setPendingState
		        ? ((actionNode.next = actionQueue.pending = actionNode),
		          runActionStateAction(actionQueue, actionNode))
		        : ((actionNode.next = setPendingState.next),
		          (actionQueue.pending = setPendingState.next = actionNode));
		    }
		  }
		  function runActionStateAction(actionQueue, node) {
		    var action = node.action,
		      payload = node.payload,
		      prevState = actionQueue.state;
		    if (node.isTransition) {
		      var prevTransition = ReactSharedInternals.T,
		        currentTransition = {};
		      ReactSharedInternals.T = currentTransition;
		      try {
		        var returnValue = action(prevState, payload),
		          onStartTransitionFinish = ReactSharedInternals.S;
		        null !== onStartTransitionFinish &&
		          onStartTransitionFinish(currentTransition, returnValue);
		        handleActionReturnValue(actionQueue, node, returnValue);
		      } catch (error) {
		        onActionError(actionQueue, node, error);
		      } finally {
		        null !== prevTransition &&
		          null !== currentTransition.types &&
		          (prevTransition.types = currentTransition.types),
		          (ReactSharedInternals.T = prevTransition);
		      }
		    } else
		      try {
		        (prevTransition = action(prevState, payload)),
		          handleActionReturnValue(actionQueue, node, prevTransition);
		      } catch (error$55) {
		        onActionError(actionQueue, node, error$55);
		      }
		  }
		  function handleActionReturnValue(actionQueue, node, returnValue) {
		    null !== returnValue &&
		    "object" === typeof returnValue &&
		    "function" === typeof returnValue.then
		      ? returnValue.then(
		          function (nextState) {
		            onActionSuccess(actionQueue, node, nextState);
		          },
		          function (error) {
		            return onActionError(actionQueue, node, error);
		          }
		        )
		      : onActionSuccess(actionQueue, node, returnValue);
		  }
		  function onActionSuccess(actionQueue, actionNode, nextState) {
		    actionNode.status = "fulfilled";
		    actionNode.value = nextState;
		    notifyActionListeners(actionNode);
		    actionQueue.state = nextState;
		    actionNode = actionQueue.pending;
		    null !== actionNode &&
		      ((nextState = actionNode.next),
		      nextState === actionNode
		        ? (actionQueue.pending = null)
		        : ((nextState = nextState.next),
		          (actionNode.next = nextState),
		          runActionStateAction(actionQueue, nextState)));
		  }
		  function onActionError(actionQueue, actionNode, error) {
		    var last = actionQueue.pending;
		    actionQueue.pending = null;
		    if (null !== last) {
		      last = last.next;
		      do
		        (actionNode.status = "rejected"),
		          (actionNode.reason = error),
		          notifyActionListeners(actionNode),
		          (actionNode = actionNode.next);
		      while (actionNode !== last);
		    }
		    actionQueue.action = null;
		  }
		  function notifyActionListeners(actionNode) {
		    actionNode = actionNode.listeners;
		    for (var i = 0; i < actionNode.length; i++) (0, actionNode[i])();
		  }
		  function actionStateReducer(oldState, newState) {
		    return newState;
		  }
		  function mountActionState(action, initialStateProp) {
		    if (isHydrating) {
		      var ssrFormState = workInProgressRoot.formState;
		      if (null !== ssrFormState) {
		        a: {
		          var JSCompiler_inline_result = currentlyRenderingFiber;
		          if (isHydrating) {
		            if (nextHydratableInstance) {
		              var markerInstance = canHydrateFormStateMarker(
		                nextHydratableInstance,
		                rootOrSingletonContext
		              );
		              if (markerInstance) {
		                nextHydratableInstance =
		                  getNextHydratableSibling(markerInstance);
		                JSCompiler_inline_result =
		                  isFormStateMarkerMatching(markerInstance);
		                break a;
		              }
		            }
		            throwOnHydrationMismatch(JSCompiler_inline_result);
		          }
		          JSCompiler_inline_result = false;
		        }
		        JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
		      }
		    }
		    ssrFormState = mountWorkInProgressHook();
		    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
		    JSCompiler_inline_result = {
		      pending: null,
		      lanes: 0,
		      dispatch: null,
		      lastRenderedReducer: actionStateReducer,
		      lastRenderedState: initialStateProp
		    };
		    ssrFormState.queue = JSCompiler_inline_result;
		    ssrFormState = dispatchSetState.bind(
		      null,
		      currentlyRenderingFiber,
		      JSCompiler_inline_result
		    );
		    JSCompiler_inline_result.dispatch = ssrFormState;
		    JSCompiler_inline_result = mountStateImpl(false);
		    var setPendingState = dispatchOptimisticSetState.bind(
		      null,
		      currentlyRenderingFiber,
		      false,
		      JSCompiler_inline_result.queue
		    );
		    JSCompiler_inline_result = mountWorkInProgressHook();
		    markerInstance = {
		      state: initialStateProp,
		      dispatch: null,
		      action: action,
		      pending: null
		    };
		    JSCompiler_inline_result.queue = markerInstance;
		    ssrFormState = dispatchActionState.bind(
		      null,
		      currentlyRenderingFiber,
		      markerInstance,
		      setPendingState,
		      ssrFormState
		    );
		    markerInstance.dispatch = ssrFormState;
		    JSCompiler_inline_result.memoizedState = action;
		    return [initialStateProp, ssrFormState, false];
		  }
		  function updateActionState(action) {
		    var stateHook = updateWorkInProgressHook();
		    return updateActionStateImpl(stateHook, currentHook, action);
		  }
		  function updateActionStateImpl(stateHook, currentStateHook, action) {
		    currentStateHook = updateReducerImpl(
		      stateHook,
		      currentStateHook,
		      actionStateReducer
		    )[0];
		    stateHook = updateReducer(basicStateReducer)[0];
		    if (
		      "object" === typeof currentStateHook &&
		      null !== currentStateHook &&
		      "function" === typeof currentStateHook.then
		    )
		      try {
		        var state = useThenable(currentStateHook);
		      } catch (x) {
		        if (x === SuspenseException) throw SuspenseActionException;
		        throw x;
		      }
		    else state = currentStateHook;
		    currentStateHook = updateWorkInProgressHook();
		    var actionQueue = currentStateHook.queue,
		      dispatch = actionQueue.dispatch;
		    action !== currentStateHook.memoizedState &&
		      ((currentlyRenderingFiber.flags |= 2048),
		      pushSimpleEffect(
		        9,
		        { destroy: void 0 },
		        actionStateActionEffect.bind(null, actionQueue, action),
		        null
		      ));
		    return [state, dispatch, stateHook];
		  }
		  function actionStateActionEffect(actionQueue, action) {
		    actionQueue.action = action;
		  }
		  function rerenderActionState(action) {
		    var stateHook = updateWorkInProgressHook(),
		      currentStateHook = currentHook;
		    if (null !== currentStateHook)
		      return updateActionStateImpl(stateHook, currentStateHook, action);
		    updateWorkInProgressHook();
		    stateHook = stateHook.memoizedState;
		    currentStateHook = updateWorkInProgressHook();
		    var dispatch = currentStateHook.queue.dispatch;
		    currentStateHook.memoizedState = action;
		    return [stateHook, dispatch, false];
		  }
		  function pushSimpleEffect(tag, inst, create, deps) {
		    tag = { tag: tag, create: create, deps: deps, inst: inst, next: null };
		    inst = currentlyRenderingFiber.updateQueue;
		    null === inst &&
		      ((inst = createFunctionComponentUpdateQueue()),
		      (currentlyRenderingFiber.updateQueue = inst));
		    create = inst.lastEffect;
		    null === create
		      ? (inst.lastEffect = tag.next = tag)
		      : ((deps = create.next),
		        (create.next = tag),
		        (tag.next = deps),
		        (inst.lastEffect = tag));
		    return tag;
		  }
		  function updateRef() {
		    return updateWorkInProgressHook().memoizedState;
		  }
		  function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
		    var hook = mountWorkInProgressHook();
		    currentlyRenderingFiber.flags |= fiberFlags;
		    hook.memoizedState = pushSimpleEffect(
		      1 | hookFlags,
		      { destroy: void 0 },
		      create,
		      void 0 === deps ? null : deps
		    );
		  }
		  function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
		    var hook = updateWorkInProgressHook();
		    deps = void 0 === deps ? null : deps;
		    var inst = hook.memoizedState.inst;
		    null !== currentHook &&
		    null !== deps &&
		    areHookInputsEqual(deps, currentHook.memoizedState.deps)
		      ? (hook.memoizedState = pushSimpleEffect(hookFlags, inst, create, deps))
		      : ((currentlyRenderingFiber.flags |= fiberFlags),
		        (hook.memoizedState = pushSimpleEffect(
		          1 | hookFlags,
		          inst,
		          create,
		          deps
		        )));
		  }
		  function mountEffect(create, deps) {
		    mountEffectImpl(8390656, 8, create, deps);
		  }
		  function updateEffect(create, deps) {
		    updateEffectImpl(2048, 8, create, deps);
		  }
		  function useEffectEventImpl(payload) {
		    currentlyRenderingFiber.flags |= 4;
		    var componentUpdateQueue = currentlyRenderingFiber.updateQueue;
		    if (null === componentUpdateQueue)
		      (componentUpdateQueue = createFunctionComponentUpdateQueue()),
		        (currentlyRenderingFiber.updateQueue = componentUpdateQueue),
		        (componentUpdateQueue.events = [payload]);
		    else {
		      var events = componentUpdateQueue.events;
		      null === events
		        ? (componentUpdateQueue.events = [payload])
		        : events.push(payload);
		    }
		  }
		  function updateEvent(callback) {
		    var ref = updateWorkInProgressHook().memoizedState;
		    useEffectEventImpl({ ref: ref, nextImpl: callback });
		    return function () {
		      if (0 !== (executionContext & 2))
		        throw Error(formatProdErrorMessage(440));
		      return ref.impl.apply(void 0, arguments);
		    };
		  }
		  function updateInsertionEffect(create, deps) {
		    return updateEffectImpl(4, 2, create, deps);
		  }
		  function updateLayoutEffect(create, deps) {
		    return updateEffectImpl(4, 4, create, deps);
		  }
		  function imperativeHandleEffect(create, ref) {
		    if ("function" === typeof ref) {
		      create = create();
		      var refCleanup = ref(create);
		      return function () {
		        "function" === typeof refCleanup ? refCleanup() : ref(null);
		      };
		    }
		    if (null !== ref && void 0 !== ref)
		      return (
		        (create = create()),
		        (ref.current = create),
		        function () {
		          ref.current = null;
		        }
		      );
		  }
		  function updateImperativeHandle(ref, create, deps) {
		    deps = null !== deps && void 0 !== deps ? deps.concat([ref]) : null;
		    updateEffectImpl(
		      4,
		      4,
		      imperativeHandleEffect.bind(null, create, ref),
		      deps
		    );
		  }
		  function mountDebugValue() {}
		  function updateCallback(callback, deps) {
		    var hook = updateWorkInProgressHook();
		    deps = void 0 === deps ? null : deps;
		    var prevState = hook.memoizedState;
		    if (null !== deps && areHookInputsEqual(deps, prevState[1]))
		      return prevState[0];
		    hook.memoizedState = [callback, deps];
		    return callback;
		  }
		  function updateMemo(nextCreate, deps) {
		    var hook = updateWorkInProgressHook();
		    deps = void 0 === deps ? null : deps;
		    var prevState = hook.memoizedState;
		    if (null !== deps && areHookInputsEqual(deps, prevState[1]))
		      return prevState[0];
		    prevState = nextCreate();
		    if (shouldDoubleInvokeUserFnsInHooksDEV) {
		      setIsStrictModeForDevtools(true);
		      try {
		        nextCreate();
		      } finally {
		        setIsStrictModeForDevtools(false);
		      }
		    }
		    hook.memoizedState = [prevState, deps];
		    return prevState;
		  }
		  function mountDeferredValueImpl(hook, value, initialValue) {
		    if (
		      void 0 === initialValue ||
		      (0 !== (renderLanes & 1073741824) &&
		        0 === (workInProgressRootRenderLanes & 261930))
		    )
		      return (hook.memoizedState = value);
		    hook.memoizedState = initialValue;
		    hook = requestDeferredLane();
		    currentlyRenderingFiber.lanes |= hook;
		    workInProgressRootSkippedLanes |= hook;
		    return initialValue;
		  }
		  function updateDeferredValueImpl(hook, prevValue, value, initialValue) {
		    if (objectIs(value, prevValue)) return value;
		    if (null !== currentTreeHiddenStackCursor.current)
		      return (
		        (hook = mountDeferredValueImpl(hook, value, initialValue)),
		        objectIs(hook, prevValue) || (didReceiveUpdate = true),
		        hook
		      );
		    if (
		      0 === (renderLanes & 42) ||
		      (0 !== (renderLanes & 1073741824) &&
		        0 === (workInProgressRootRenderLanes & 261930))
		    )
		      return (didReceiveUpdate = true), (hook.memoizedState = value);
		    hook = requestDeferredLane();
		    currentlyRenderingFiber.lanes |= hook;
		    workInProgressRootSkippedLanes |= hook;
		    return prevValue;
		  }
		  function startTransition(
		    fiber,
		    queue,
		    pendingState,
		    finishedState,
		    callback
		  ) {
		    var previousPriority = getCurrentUpdatePriority();
		    setCurrentUpdatePriority(
		      0 !== previousPriority && 8 > previousPriority ? previousPriority : 8
		    );
		    var prevTransition = ReactSharedInternals.T,
		      currentTransition = {};
		    ReactSharedInternals.T = currentTransition;
		    dispatchOptimisticSetState(fiber, false, queue, pendingState);
		    try {
		      var returnValue = callback(),
		        onStartTransitionFinish = ReactSharedInternals.S;
		      null !== onStartTransitionFinish &&
		        onStartTransitionFinish(currentTransition, returnValue);
		      if (
		        null !== returnValue &&
		        "object" === typeof returnValue &&
		        "function" === typeof returnValue.then
		      ) {
		        var thenableForFinishedState = chainThenableValue(
		          returnValue,
		          finishedState
		        );
		        dispatchSetStateInternal(
		          fiber,
		          queue,
		          thenableForFinishedState,
		          requestUpdateLane(fiber)
		        );
		      } else
		        dispatchSetStateInternal(
		          fiber,
		          queue,
		          finishedState,
		          requestUpdateLane(fiber)
		        );
		    } catch (error) {
		      dispatchSetStateInternal(
		        fiber,
		        queue,
		        { then: function () {}, status: "rejected", reason: error },
		        requestUpdateLane()
		      );
		    } finally {
		      setCurrentUpdatePriority(previousPriority),
		        null !== prevTransition &&
		          null !== currentTransition.types &&
		          (prevTransition.types = currentTransition.types),
		        (ReactSharedInternals.T = prevTransition);
		    }
		  }
		  function ensureFormComponentIsStateful(formFiber) {
		    var existingStateHook = formFiber.memoizedState;
		    if (null !== existingStateHook) return existingStateHook;
		    existingStateHook = {
		      memoizedState: NotPendingTransition,
		      baseState: NotPendingTransition,
		      baseQueue: null,
		      queue: {
		        pending: null,
		        lanes: 0,
		        dispatch: null,
		        lastRenderedReducer: basicStateReducer,
		        lastRenderedState: NotPendingTransition
		      },
		      next: null
		    };
		    var initialResetState = {};
		    existingStateHook.next = {
		      memoizedState: initialResetState,
		      baseState: initialResetState,
		      baseQueue: null,
		      queue: {
		        pending: null,
		        lanes: 0,
		        dispatch: null,
		        lastRenderedReducer: basicStateReducer,
		        lastRenderedState: initialResetState
		      },
		      next: null
		    };
		    formFiber.memoizedState = existingStateHook;
		    formFiber = formFiber.alternate;
		    null !== formFiber && (formFiber.memoizedState = existingStateHook);
		    return existingStateHook;
		  }
		  function useHostTransitionStatus() {
		    return readContext(HostTransitionContext);
		  }
		  function updateId() {
		    return updateWorkInProgressHook().memoizedState;
		  }
		  function updateRefresh() {
		    return updateWorkInProgressHook().memoizedState;
		  }
		  function refreshCache(fiber) {
		    for (var provider = fiber.return; null !== provider; ) {
		      switch (provider.tag) {
		        case 24:
		        case 3:
		          var lane = requestUpdateLane();
		          fiber = createUpdate(lane);
		          var root = enqueueUpdate(provider, fiber, lane);
		          null !== root &&
		            (scheduleUpdateOnFiber(root, provider, lane),
		            entangleTransitions(root, provider, lane));
		          provider = { cache: createCache() };
		          fiber.payload = provider;
		          return;
		      }
		      provider = provider.return;
		    }
		  }
		  function dispatchReducerAction(fiber, queue, action) {
		    var lane = requestUpdateLane();
		    action = {
		      lane: lane,
		      revertLane: 0,
		      gesture: null,
		      action: action,
		      hasEagerState: false,
		      eagerState: null,
		      next: null
		    };
		    isRenderPhaseUpdate(fiber)
		      ? enqueueRenderPhaseUpdate(queue, action)
		      : ((action = enqueueConcurrentHookUpdate(fiber, queue, action, lane)),
		        null !== action &&
		          (scheduleUpdateOnFiber(action, fiber, lane),
		          entangleTransitionUpdate(action, queue, lane)));
		  }
		  function dispatchSetState(fiber, queue, action) {
		    var lane = requestUpdateLane();
		    dispatchSetStateInternal(fiber, queue, action, lane);
		  }
		  function dispatchSetStateInternal(fiber, queue, action, lane) {
		    var update = {
		      lane: lane,
		      revertLane: 0,
		      gesture: null,
		      action: action,
		      hasEagerState: false,
		      eagerState: null,
		      next: null
		    };
		    if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
		    else {
		      var alternate = fiber.alternate;
		      if (
		        0 === fiber.lanes &&
		        (null === alternate || 0 === alternate.lanes) &&
		        ((alternate = queue.lastRenderedReducer), null !== alternate)
		      )
		        try {
		          var currentState = queue.lastRenderedState,
		            eagerState = alternate(currentState, action);
		          update.hasEagerState = !0;
		          update.eagerState = eagerState;
		          if (objectIs(eagerState, currentState))
		            return (
		              enqueueUpdate$1(fiber, queue, update, 0),
		              null === workInProgressRoot && finishQueueingConcurrentUpdates(),
		              !1
		            );
		        } catch (error) {
		        } finally {
		        }
		      action = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
		      if (null !== action)
		        return (
		          scheduleUpdateOnFiber(action, fiber, lane),
		          entangleTransitionUpdate(action, queue, lane),
		          true
		        );
		    }
		    return false;
		  }
		  function dispatchOptimisticSetState(
		    fiber,
		    throwIfDuringRender,
		    queue,
		    action
		  ) {
		    action = {
		      lane: 2,
		      revertLane: requestTransitionLane(),
		      gesture: null,
		      action: action,
		      hasEagerState: false,
		      eagerState: null,
		      next: null
		    };
		    if (isRenderPhaseUpdate(fiber)) {
		      if (throwIfDuringRender) throw Error(formatProdErrorMessage(479));
		    } else
		      (throwIfDuringRender = enqueueConcurrentHookUpdate(
		        fiber,
		        queue,
		        action,
		        2
		      )),
		        null !== throwIfDuringRender &&
		          scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
		  }
		  function isRenderPhaseUpdate(fiber) {
		    var alternate = fiber.alternate;
		    return (
		      fiber === currentlyRenderingFiber ||
		      (null !== alternate && alternate === currentlyRenderingFiber)
		    );
		  }
		  function enqueueRenderPhaseUpdate(queue, update) {
		    didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate =
		      true;
		    var pending = queue.pending;
		    null === pending
		      ? (update.next = update)
		      : ((update.next = pending.next), (pending.next = update));
		    queue.pending = update;
		  }
		  function entangleTransitionUpdate(root, queue, lane) {
		    if (0 !== (lane & 4194048)) {
		      var queueLanes = queue.lanes;
		      queueLanes &= root.pendingLanes;
		      lane |= queueLanes;
		      queue.lanes = lane;
		      markRootEntangled(root, lane);
		    }
		  }
		  function applyDerivedStateFromProps(
		    workInProgress,
		    ctor,
		    getDerivedStateFromProps,
		    nextProps
		  ) {
		    ctor = workInProgress.memoizedState;
		    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
		    getDerivedStateFromProps =
		      null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps
		        ? ctor
		        : assign({}, ctor, getDerivedStateFromProps);
		    workInProgress.memoizedState = getDerivedStateFromProps;
		    0 === workInProgress.lanes &&
		      (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
		  }
		  function checkShouldComponentUpdate(
		    workInProgress,
		    ctor,
		    oldProps,
		    newProps,
		    oldState,
		    newState,
		    nextContext
		  ) {
		    workInProgress = workInProgress.stateNode;
		    return "function" === typeof workInProgress.shouldComponentUpdate
		      ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext)
		      : ctor.prototype && ctor.prototype.isPureReactComponent
		        ? !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState)
		        : true;
		  }
		  function callComponentWillReceiveProps(
		    workInProgress,
		    instance,
		    newProps,
		    nextContext
		  ) {
		    workInProgress = instance.state;
		    "function" === typeof instance.componentWillReceiveProps &&
		      instance.componentWillReceiveProps(newProps, nextContext);
		    "function" === typeof instance.UNSAFE_componentWillReceiveProps &&
		      instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
		    instance.state !== workInProgress &&
		      classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
		  }
		  function resolveClassComponentProps(Component, baseProps) {
		    var newProps = baseProps;
		    if ("ref" in baseProps) {
		      newProps = {};
		      for (var propName in baseProps)
		        "ref" !== propName && (newProps[propName] = baseProps[propName]);
		    }
		    if ((Component = Component.defaultProps)) {
		      newProps === baseProps && (newProps = assign({}, newProps));
		      for (var propName$57 in Component)
		        void 0 === newProps[propName$57] &&
		          (newProps[propName$57] = Component[propName$57]);
		    }
		    return newProps;
		  }
		  function logUncaughtError(root, errorInfo) {
		    try {
		      var onUncaughtError = root.onUncaughtError;
		      onUncaughtError(errorInfo.value, { componentStack: errorInfo.stack });
		    } catch (e) {
		      setTimeout(function () {
		        throw e;
		      });
		    }
		  }
		  function logCaughtError(root, boundary, errorInfo) {
		    try {
		      var onCaughtError = root.onCaughtError;
		      onCaughtError(errorInfo.value, {
		        componentStack: errorInfo.stack,
		        errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
		      });
		    } catch (e) {
		      setTimeout(function () {
		        throw e;
		      });
		    }
		  }
		  function createRootErrorUpdate(root, errorInfo, lane) {
		    lane = createUpdate(lane);
		    lane.tag = 3;
		    lane.payload = { element: null };
		    lane.callback = function () {
		      logUncaughtError(root, errorInfo);
		    };
		    return lane;
		  }
		  function createClassErrorUpdate(lane) {
		    lane = createUpdate(lane);
		    lane.tag = 3;
		    return lane;
		  }
		  function initializeClassErrorUpdate(update, root, fiber, errorInfo) {
		    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
		    if ("function" === typeof getDerivedStateFromError) {
		      var error = errorInfo.value;
		      update.payload = function () {
		        return getDerivedStateFromError(error);
		      };
		      update.callback = function () {
		        logCaughtError(root, fiber, errorInfo);
		      };
		    }
		    var inst = fiber.stateNode;
		    null !== inst &&
		      "function" === typeof inst.componentDidCatch &&
		      (update.callback = function () {
		        logCaughtError(root, fiber, errorInfo);
		        "function" !== typeof getDerivedStateFromError &&
		          (null === legacyErrorBoundariesThatAlreadyFailed
		            ? (legacyErrorBoundariesThatAlreadyFailed = new Set([this]))
		            : legacyErrorBoundariesThatAlreadyFailed.add(this));
		        var stack = errorInfo.stack;
		        this.componentDidCatch(errorInfo.value, {
		          componentStack: null !== stack ? stack : ""
		        });
		      });
		  }
		  function throwException(
		    root,
		    returnFiber,
		    sourceFiber,
		    value,
		    rootRenderLanes
		  ) {
		    sourceFiber.flags |= 32768;
		    if (
		      null !== value &&
		      "object" === typeof value &&
		      "function" === typeof value.then
		    ) {
		      returnFiber = sourceFiber.alternate;
		      null !== returnFiber &&
		        propagateParentContextChanges(
		          returnFiber,
		          sourceFiber,
		          rootRenderLanes,
		          true
		        );
		      sourceFiber = suspenseHandlerStackCursor.current;
		      if (null !== sourceFiber) {
		        switch (sourceFiber.tag) {
		          case 31:
		          case 13:
		            return (
		              null === shellBoundary
		                ? renderDidSuspendDelayIfPossible()
		                : null === sourceFiber.alternate &&
		                  0 === workInProgressRootExitStatus &&
		                  (workInProgressRootExitStatus = 3),
		              (sourceFiber.flags &= -257),
		              (sourceFiber.flags |= 65536),
		              (sourceFiber.lanes = rootRenderLanes),
		              value === noopSuspenseyCommitThenable
		                ? (sourceFiber.flags |= 16384)
		                : ((returnFiber = sourceFiber.updateQueue),
		                  null === returnFiber
		                    ? (sourceFiber.updateQueue = new Set([value]))
		                    : returnFiber.add(value),
		                  attachPingListener(root, value, rootRenderLanes)),
		              false
		            );
		          case 22:
		            return (
		              (sourceFiber.flags |= 65536),
		              value === noopSuspenseyCommitThenable
		                ? (sourceFiber.flags |= 16384)
		                : ((returnFiber = sourceFiber.updateQueue),
		                  null === returnFiber
		                    ? ((returnFiber = {
		                        transitions: null,
		                        markerInstances: null,
		                        retryQueue: new Set([value])
		                      }),
		                      (sourceFiber.updateQueue = returnFiber))
		                    : ((sourceFiber = returnFiber.retryQueue),
		                      null === sourceFiber
		                        ? (returnFiber.retryQueue = new Set([value]))
		                        : sourceFiber.add(value)),
		                  attachPingListener(root, value, rootRenderLanes)),
		              false
		            );
		        }
		        throw Error(formatProdErrorMessage(435, sourceFiber.tag));
		      }
		      attachPingListener(root, value, rootRenderLanes);
		      renderDidSuspendDelayIfPossible();
		      return false;
		    }
		    if (isHydrating)
		      return (
		        (returnFiber = suspenseHandlerStackCursor.current),
		        null !== returnFiber
		          ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256),
		            (returnFiber.flags |= 65536),
		            (returnFiber.lanes = rootRenderLanes),
		            value !== HydrationMismatchException &&
		              ((root = Error(formatProdErrorMessage(422), { cause: value })),
		              queueHydrationError(
		                createCapturedValueAtFiber(root, sourceFiber)
		              )))
		          : (value !== HydrationMismatchException &&
		              ((returnFiber = Error(formatProdErrorMessage(423), {
		                cause: value
		              })),
		              queueHydrationError(
		                createCapturedValueAtFiber(returnFiber, sourceFiber)
		              )),
		            (root = root.current.alternate),
		            (root.flags |= 65536),
		            (rootRenderLanes &= -rootRenderLanes),
		            (root.lanes |= rootRenderLanes),
		            (value = createCapturedValueAtFiber(value, sourceFiber)),
		            (rootRenderLanes = createRootErrorUpdate(
		              root.stateNode,
		              value,
		              rootRenderLanes
		            )),
		            enqueueCapturedUpdate(root, rootRenderLanes),
		            4 !== workInProgressRootExitStatus &&
		              (workInProgressRootExitStatus = 2)),
		        false
		      );
		    var wrapperError = Error(formatProdErrorMessage(520), { cause: value });
		    wrapperError = createCapturedValueAtFiber(wrapperError, sourceFiber);
		    null === workInProgressRootConcurrentErrors
		      ? (workInProgressRootConcurrentErrors = [wrapperError])
		      : workInProgressRootConcurrentErrors.push(wrapperError);
		    4 !== workInProgressRootExitStatus && (workInProgressRootExitStatus = 2);
		    if (null === returnFiber) return true;
		    value = createCapturedValueAtFiber(value, sourceFiber);
		    sourceFiber = returnFiber;
		    do {
		      switch (sourceFiber.tag) {
		        case 3:
		          return (
		            (sourceFiber.flags |= 65536),
		            (root = rootRenderLanes & -rootRenderLanes),
		            (sourceFiber.lanes |= root),
		            (root = createRootErrorUpdate(sourceFiber.stateNode, value, root)),
		            enqueueCapturedUpdate(sourceFiber, root),
		            false
		          );
		        case 1:
		          if (
		            ((returnFiber = sourceFiber.type),
		            (wrapperError = sourceFiber.stateNode),
		            0 === (sourceFiber.flags & 128) &&
		              ("function" === typeof returnFiber.getDerivedStateFromError ||
		                (null !== wrapperError &&
		                  "function" === typeof wrapperError.componentDidCatch &&
		                  (null === legacyErrorBoundariesThatAlreadyFailed ||
		                    !legacyErrorBoundariesThatAlreadyFailed.has(
		                      wrapperError
		                    )))))
		          )
		            return (
		              (sourceFiber.flags |= 65536),
		              (rootRenderLanes &= -rootRenderLanes),
		              (sourceFiber.lanes |= rootRenderLanes),
		              (rootRenderLanes = createClassErrorUpdate(rootRenderLanes)),
		              initializeClassErrorUpdate(
		                rootRenderLanes,
		                root,
		                sourceFiber,
		                value
		              ),
		              enqueueCapturedUpdate(sourceFiber, rootRenderLanes),
		              false
		            );
		      }
		      sourceFiber = sourceFiber.return;
		    } while (null !== sourceFiber);
		    return false;
		  }
		  function reconcileChildren(
		    current,
		    workInProgress,
		    nextChildren,
		    renderLanes
		  ) {
		    workInProgress.child =
		      null === current
		        ? mountChildFibers(workInProgress, null, nextChildren, renderLanes)
		        : reconcileChildFibers(
		            workInProgress,
		            current.child,
		            nextChildren,
		            renderLanes
		          );
		  }
		  function updateForwardRef(
		    current,
		    workInProgress,
		    Component,
		    nextProps,
		    renderLanes
		  ) {
		    Component = Component.render;
		    var ref = workInProgress.ref;
		    if ("ref" in nextProps) {
		      var propsWithoutRef = {};
		      for (var key in nextProps)
		        "ref" !== key && (propsWithoutRef[key] = nextProps[key]);
		    } else propsWithoutRef = nextProps;
		    prepareToReadContext(workInProgress);
		    nextProps = renderWithHooks(
		      current,
		      workInProgress,
		      Component,
		      propsWithoutRef,
		      ref,
		      renderLanes
		    );
		    key = checkDidRenderIdHook();
		    if (null !== current && !didReceiveUpdate)
		      return (
		        bailoutHooks(current, workInProgress, renderLanes),
		        bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes)
		      );
		    isHydrating && key && pushMaterializedTreeId(workInProgress);
		    workInProgress.flags |= 1;
		    reconcileChildren(current, workInProgress, nextProps, renderLanes);
		    return workInProgress.child;
		  }
		  function updateMemoComponent(
		    current,
		    workInProgress,
		    Component,
		    nextProps,
		    renderLanes
		  ) {
		    if (null === current) {
		      var type = Component.type;
		      if (
		        "function" === typeof type &&
		        !shouldConstruct(type) &&
		        void 0 === type.defaultProps &&
		        null === Component.compare
		      )
		        return (
		          (workInProgress.tag = 15),
		          (workInProgress.type = type),
		          updateSimpleMemoComponent(
		            current,
		            workInProgress,
		            type,
		            nextProps,
		            renderLanes
		          )
		        );
		      current = createFiberFromTypeAndProps(
		        Component.type,
		        null,
		        nextProps,
		        workInProgress,
		        workInProgress.mode,
		        renderLanes
		      );
		      current.ref = workInProgress.ref;
		      current.return = workInProgress;
		      return (workInProgress.child = current);
		    }
		    type = current.child;
		    if (!checkScheduledUpdateOrContext(current, renderLanes)) {
		      var prevProps = type.memoizedProps;
		      Component = Component.compare;
		      Component = null !== Component ? Component : shallowEqual;
		      if (Component(prevProps, nextProps) && current.ref === workInProgress.ref)
		        return bailoutOnAlreadyFinishedWork(
		          current,
		          workInProgress,
		          renderLanes
		        );
		    }
		    workInProgress.flags |= 1;
		    current = createWorkInProgress(type, nextProps);
		    current.ref = workInProgress.ref;
		    current.return = workInProgress;
		    return (workInProgress.child = current);
		  }
		  function updateSimpleMemoComponent(
		    current,
		    workInProgress,
		    Component,
		    nextProps,
		    renderLanes
		  ) {
		    if (null !== current) {
		      var prevProps = current.memoizedProps;
		      if (
		        shallowEqual(prevProps, nextProps) &&
		        current.ref === workInProgress.ref
		      )
		        if (
		          ((didReceiveUpdate = false),
		          (workInProgress.pendingProps = nextProps = prevProps),
		          checkScheduledUpdateOrContext(current, renderLanes))
		        )
		          0 !== (current.flags & 131072) && (didReceiveUpdate = true);
		        else
		          return (
		            (workInProgress.lanes = current.lanes),
		            bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes)
		          );
		    }
		    return updateFunctionComponent(
		      current,
		      workInProgress,
		      Component,
		      nextProps,
		      renderLanes
		    );
		  }
		  function updateOffscreenComponent(
		    current,
		    workInProgress,
		    renderLanes,
		    nextProps
		  ) {
		    var nextChildren = nextProps.children,
		      prevState = null !== current ? current.memoizedState : null;
		    null === current &&
		      null === workInProgress.stateNode &&
		      (workInProgress.stateNode = {
		        _visibility: 1,
		        _pendingMarkers: null,
		        _retryCache: null,
		        _transitions: null
		      });
		    if ("hidden" === nextProps.mode) {
		      if (0 !== (workInProgress.flags & 128)) {
		        prevState =
		          null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
		        if (null !== current) {
		          nextProps = workInProgress.child = current.child;
		          for (nextChildren = 0; null !== nextProps; )
		            (nextChildren =
		              nextChildren | nextProps.lanes | nextProps.childLanes),
		              (nextProps = nextProps.sibling);
		          nextProps = nextChildren & ~prevState;
		        } else (nextProps = 0), (workInProgress.child = null);
		        return deferHiddenOffscreenComponent(
		          current,
		          workInProgress,
		          prevState,
		          renderLanes,
		          nextProps
		        );
		      }
		      if (0 !== (renderLanes & 536870912))
		        (workInProgress.memoizedState = { baseLanes: 0, cachePool: null }),
		          null !== current &&
		            pushTransition(
		              workInProgress,
		              null !== prevState ? prevState.cachePool : null
		            ),
		          null !== prevState
		            ? pushHiddenContext(workInProgress, prevState)
		            : reuseHiddenContextOnStack(),
		          pushOffscreenSuspenseHandler(workInProgress);
		      else
		        return (
		          (nextProps = workInProgress.lanes = 536870912),
		          deferHiddenOffscreenComponent(
		            current,
		            workInProgress,
		            null !== prevState
		              ? prevState.baseLanes | renderLanes
		              : renderLanes,
		            renderLanes,
		            nextProps
		          )
		        );
		    } else
		      null !== prevState
		        ? (pushTransition(workInProgress, prevState.cachePool),
		          pushHiddenContext(workInProgress, prevState),
		          reuseSuspenseHandlerOnStack(),
		          (workInProgress.memoizedState = null))
		        : (null !== current && pushTransition(workInProgress, null),
		          reuseHiddenContextOnStack(),
		          reuseSuspenseHandlerOnStack());
		    reconcileChildren(current, workInProgress, nextChildren, renderLanes);
		    return workInProgress.child;
		  }
		  function bailoutOffscreenComponent(current, workInProgress) {
		    (null !== current && 22 === current.tag) ||
		      null !== workInProgress.stateNode ||
		      (workInProgress.stateNode = {
		        _visibility: 1,
		        _pendingMarkers: null,
		        _retryCache: null,
		        _transitions: null
		      });
		    return workInProgress.sibling;
		  }
		  function deferHiddenOffscreenComponent(
		    current,
		    workInProgress,
		    nextBaseLanes,
		    renderLanes,
		    remainingChildLanes
		  ) {
		    var JSCompiler_inline_result = peekCacheFromPool();
		    JSCompiler_inline_result =
		      null === JSCompiler_inline_result
		        ? null
		        : {
		            parent: isPrimaryRenderer
		              ? CacheContext._currentValue
		              : CacheContext._currentValue2,
		            pool: JSCompiler_inline_result
		          };
		    workInProgress.memoizedState = {
		      baseLanes: nextBaseLanes,
		      cachePool: JSCompiler_inline_result
		    };
		    null !== current && pushTransition(workInProgress, null);
		    reuseHiddenContextOnStack();
		    pushOffscreenSuspenseHandler(workInProgress);
		    null !== current &&
		      propagateParentContextChanges(current, workInProgress, renderLanes, true);
		    workInProgress.childLanes = remainingChildLanes;
		    return null;
		  }
		  function mountActivityChildren(workInProgress, nextProps) {
		    nextProps = mountWorkInProgressOffscreenFiber(
		      { mode: nextProps.mode, children: nextProps.children },
		      workInProgress.mode
		    );
		    nextProps.ref = workInProgress.ref;
		    workInProgress.child = nextProps;
		    nextProps.return = workInProgress;
		    return nextProps;
		  }
		  function retryActivityComponentWithoutHydrating(
		    current,
		    workInProgress,
		    renderLanes
		  ) {
		    reconcileChildFibers(workInProgress, current.child, null, renderLanes);
		    current = mountActivityChildren(
		      workInProgress,
		      workInProgress.pendingProps
		    );
		    current.flags |= 2;
		    popSuspenseHandler(workInProgress);
		    workInProgress.memoizedState = null;
		    return current;
		  }
		  function updateActivityComponent(current, workInProgress, renderLanes) {
		    var nextProps = workInProgress.pendingProps,
		      didSuspend = 0 !== (workInProgress.flags & 128);
		    workInProgress.flags &= -129;
		    if (null === current) {
		      if (isHydrating) {
		        if ("hidden" === nextProps.mode)
		          return (
		            (current = mountActivityChildren(workInProgress, nextProps)),
		            (workInProgress.lanes = 536870912),
		            bailoutOffscreenComponent(null, current)
		          );
		        pushDehydratedActivitySuspenseHandler(workInProgress);
		        (current = nextHydratableInstance)
		          ? ((current = canHydrateActivityInstance(
		              current,
		              rootOrSingletonContext
		            )),
		            null !== current &&
		              ((workInProgress.memoizedState = {
		                dehydrated: current,
		                treeContext:
		                  null !== treeContextProvider
		                    ? { id: treeContextId, overflow: treeContextOverflow }
		                    : null,
		                retryLane: 536870912,
		                hydrationErrors: null
		              }),
		              (renderLanes = createFiberFromDehydratedFragment(current)),
		              (renderLanes.return = workInProgress),
		              (workInProgress.child = renderLanes),
		              (hydrationParentFiber = workInProgress),
		              (nextHydratableInstance = null)))
		          : (current = null);
		        if (null === current) throw throwOnHydrationMismatch(workInProgress);
		        workInProgress.lanes = 536870912;
		        return null;
		      }
		      return mountActivityChildren(workInProgress, nextProps);
		    }
		    var prevState = current.memoizedState;
		    if (null !== prevState) {
		      var dehydrated = prevState.dehydrated;
		      pushDehydratedActivitySuspenseHandler(workInProgress);
		      if (didSuspend)
		        if (workInProgress.flags & 256)
		          (workInProgress.flags &= -257),
		            (workInProgress = retryActivityComponentWithoutHydrating(
		              current,
		              workInProgress,
		              renderLanes
		            ));
		        else if (null !== workInProgress.memoizedState)
		          (workInProgress.child = current.child),
		            (workInProgress.flags |= 128),
		            (workInProgress = null);
		        else throw Error(formatProdErrorMessage(558));
		      else if (
		        (didReceiveUpdate ||
		          propagateParentContextChanges(
		            current,
		            workInProgress,
		            renderLanes,
		            false
		          ),
		        (didSuspend = 0 !== (renderLanes & current.childLanes)),
		        didReceiveUpdate || didSuspend)
		      ) {
		        nextProps = workInProgressRoot;
		        if (
		          null !== nextProps &&
		          ((dehydrated = getBumpedLaneForHydration(nextProps, renderLanes)),
		          0 !== dehydrated && dehydrated !== prevState.retryLane)
		        )
		          throw (
		            ((prevState.retryLane = dehydrated),
		            enqueueConcurrentRenderForLane(current, dehydrated),
		            scheduleUpdateOnFiber(nextProps, current, dehydrated),
		            SelectiveHydrationException)
		          );
		        renderDidSuspendDelayIfPossible();
		        workInProgress = retryActivityComponentWithoutHydrating(
		          current,
		          workInProgress,
		          renderLanes
		        );
		      } else
		        (current = prevState.treeContext),
		          supportsHydration &&
		            ((nextHydratableInstance =
		              getFirstHydratableChildWithinActivityInstance(dehydrated)),
		            (hydrationParentFiber = workInProgress),
		            (isHydrating = true),
		            (hydrationErrors = null),
		            (rootOrSingletonContext = false),
		            null !== current &&
		              restoreSuspendedTreeContext(workInProgress, current)),
		          (workInProgress = mountActivityChildren(workInProgress, nextProps)),
		          (workInProgress.flags |= 4096);
		      return workInProgress;
		    }
		    current = createWorkInProgress(current.child, {
		      mode: nextProps.mode,
		      children: nextProps.children
		    });
		    current.ref = workInProgress.ref;
		    workInProgress.child = current;
		    current.return = workInProgress;
		    return current;
		  }
		  function markRef(current, workInProgress) {
		    var ref = workInProgress.ref;
		    if (null === ref)
		      null !== current &&
		        null !== current.ref &&
		        (workInProgress.flags |= 4194816);
		    else {
		      if ("function" !== typeof ref && "object" !== typeof ref)
		        throw Error(formatProdErrorMessage(284));
		      if (null === current || current.ref !== ref)
		        workInProgress.flags |= 4194816;
		    }
		  }
		  function updateFunctionComponent(
		    current,
		    workInProgress,
		    Component,
		    nextProps,
		    renderLanes
		  ) {
		    prepareToReadContext(workInProgress);
		    Component = renderWithHooks(
		      current,
		      workInProgress,
		      Component,
		      nextProps,
		      void 0,
		      renderLanes
		    );
		    nextProps = checkDidRenderIdHook();
		    if (null !== current && !didReceiveUpdate)
		      return (
		        bailoutHooks(current, workInProgress, renderLanes),
		        bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes)
		      );
		    isHydrating && nextProps && pushMaterializedTreeId(workInProgress);
		    workInProgress.flags |= 1;
		    reconcileChildren(current, workInProgress, Component, renderLanes);
		    return workInProgress.child;
		  }
		  function replayFunctionComponent(
		    current,
		    workInProgress,
		    nextProps,
		    Component,
		    secondArg,
		    renderLanes
		  ) {
		    prepareToReadContext(workInProgress);
		    workInProgress.updateQueue = null;
		    nextProps = renderWithHooksAgain(
		      workInProgress,
		      Component,
		      nextProps,
		      secondArg
		    );
		    finishRenderingHooks(current);
		    Component = checkDidRenderIdHook();
		    if (null !== current && !didReceiveUpdate)
		      return (
		        bailoutHooks(current, workInProgress, renderLanes),
		        bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes)
		      );
		    isHydrating && Component && pushMaterializedTreeId(workInProgress);
		    workInProgress.flags |= 1;
		    reconcileChildren(current, workInProgress, nextProps, renderLanes);
		    return workInProgress.child;
		  }
		  function updateClassComponent(
		    current,
		    workInProgress,
		    Component,
		    nextProps,
		    renderLanes
		  ) {
		    prepareToReadContext(workInProgress);
		    if (null === workInProgress.stateNode) {
		      var context = emptyContextObject,
		        contextType = Component.contextType;
		      "object" === typeof contextType &&
		        null !== contextType &&
		        (context = readContext(contextType));
		      context = new Component(nextProps, context);
		      workInProgress.memoizedState =
		        null !== context.state && void 0 !== context.state
		          ? context.state
		          : null;
		      context.updater = classComponentUpdater;
		      workInProgress.stateNode = context;
		      context._reactInternals = workInProgress;
		      context = workInProgress.stateNode;
		      context.props = nextProps;
		      context.state = workInProgress.memoizedState;
		      context.refs = {};
		      initializeUpdateQueue(workInProgress);
		      contextType = Component.contextType;
		      context.context =
		        "object" === typeof contextType && null !== contextType
		          ? readContext(contextType)
		          : emptyContextObject;
		      context.state = workInProgress.memoizedState;
		      contextType = Component.getDerivedStateFromProps;
		      "function" === typeof contextType &&
		        (applyDerivedStateFromProps(
		          workInProgress,
		          Component,
		          contextType,
		          nextProps
		        ),
		        (context.state = workInProgress.memoizedState));
		      "function" === typeof Component.getDerivedStateFromProps ||
		        "function" === typeof context.getSnapshotBeforeUpdate ||
		        ("function" !== typeof context.UNSAFE_componentWillMount &&
		          "function" !== typeof context.componentWillMount) ||
		        ((contextType = context.state),
		        "function" === typeof context.componentWillMount &&
		          context.componentWillMount(),
		        "function" === typeof context.UNSAFE_componentWillMount &&
		          context.UNSAFE_componentWillMount(),
		        contextType !== context.state &&
		          classComponentUpdater.enqueueReplaceState(
		            context,
		            context.state,
		            null
		          ),
		        processUpdateQueue(workInProgress, nextProps, context, renderLanes),
		        suspendIfUpdateReadFromEntangledAsyncAction(),
		        (context.state = workInProgress.memoizedState));
		      "function" === typeof context.componentDidMount &&
		        (workInProgress.flags |= 4194308);
		      nextProps = true;
		    } else if (null === current) {
		      context = workInProgress.stateNode;
		      var unresolvedOldProps = workInProgress.memoizedProps,
		        oldProps = resolveClassComponentProps(Component, unresolvedOldProps);
		      context.props = oldProps;
		      var oldContext = context.context,
		        contextType$jscomp$0 = Component.contextType;
		      contextType = emptyContextObject;
		      "object" === typeof contextType$jscomp$0 &&
		        null !== contextType$jscomp$0 &&
		        (contextType = readContext(contextType$jscomp$0));
		      var getDerivedStateFromProps = Component.getDerivedStateFromProps;
		      contextType$jscomp$0 =
		        "function" === typeof getDerivedStateFromProps ||
		        "function" === typeof context.getSnapshotBeforeUpdate;
		      unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
		      contextType$jscomp$0 ||
		        ("function" !== typeof context.UNSAFE_componentWillReceiveProps &&
		          "function" !== typeof context.componentWillReceiveProps) ||
		        ((unresolvedOldProps || oldContext !== contextType) &&
		          callComponentWillReceiveProps(
		            workInProgress,
		            context,
		            nextProps,
		            contextType
		          ));
		      hasForceUpdate = false;
		      var oldState = workInProgress.memoizedState;
		      context.state = oldState;
		      processUpdateQueue(workInProgress, nextProps, context, renderLanes);
		      suspendIfUpdateReadFromEntangledAsyncAction();
		      oldContext = workInProgress.memoizedState;
		      unresolvedOldProps || oldState !== oldContext || hasForceUpdate
		        ? ("function" === typeof getDerivedStateFromProps &&
		            (applyDerivedStateFromProps(
		              workInProgress,
		              Component,
		              getDerivedStateFromProps,
		              nextProps
		            ),
		            (oldContext = workInProgress.memoizedState)),
		          (oldProps =
		            hasForceUpdate ||
		            checkShouldComponentUpdate(
		              workInProgress,
		              Component,
		              oldProps,
		              nextProps,
		              oldState,
		              oldContext,
		              contextType
		            ))
		            ? (contextType$jscomp$0 ||
		                ("function" !== typeof context.UNSAFE_componentWillMount &&
		                  "function" !== typeof context.componentWillMount) ||
		                ("function" === typeof context.componentWillMount &&
		                  context.componentWillMount(),
		                "function" === typeof context.UNSAFE_componentWillMount &&
		                  context.UNSAFE_componentWillMount()),
		              "function" === typeof context.componentDidMount &&
		                (workInProgress.flags |= 4194308))
		            : ("function" === typeof context.componentDidMount &&
		                (workInProgress.flags |= 4194308),
		              (workInProgress.memoizedProps = nextProps),
		              (workInProgress.memoizedState = oldContext)),
		          (context.props = nextProps),
		          (context.state = oldContext),
		          (context.context = contextType),
		          (nextProps = oldProps))
		        : ("function" === typeof context.componentDidMount &&
		            (workInProgress.flags |= 4194308),
		          (nextProps = false));
		    } else {
		      context = workInProgress.stateNode;
		      cloneUpdateQueue(current, workInProgress);
		      contextType = workInProgress.memoizedProps;
		      contextType$jscomp$0 = resolveClassComponentProps(Component, contextType);
		      context.props = contextType$jscomp$0;
		      getDerivedStateFromProps = workInProgress.pendingProps;
		      oldState = context.context;
		      oldContext = Component.contextType;
		      oldProps = emptyContextObject;
		      "object" === typeof oldContext &&
		        null !== oldContext &&
		        (oldProps = readContext(oldContext));
		      unresolvedOldProps = Component.getDerivedStateFromProps;
		      (oldContext =
		        "function" === typeof unresolvedOldProps ||
		        "function" === typeof context.getSnapshotBeforeUpdate) ||
		        ("function" !== typeof context.UNSAFE_componentWillReceiveProps &&
		          "function" !== typeof context.componentWillReceiveProps) ||
		        ((contextType !== getDerivedStateFromProps || oldState !== oldProps) &&
		          callComponentWillReceiveProps(
		            workInProgress,
		            context,
		            nextProps,
		            oldProps
		          ));
		      hasForceUpdate = false;
		      oldState = workInProgress.memoizedState;
		      context.state = oldState;
		      processUpdateQueue(workInProgress, nextProps, context, renderLanes);
		      suspendIfUpdateReadFromEntangledAsyncAction();
		      var newState = workInProgress.memoizedState;
		      contextType !== getDerivedStateFromProps ||
		      oldState !== newState ||
		      hasForceUpdate ||
		      (null !== current &&
		        null !== current.dependencies &&
		        checkIfContextChanged(current.dependencies))
		        ? ("function" === typeof unresolvedOldProps &&
		            (applyDerivedStateFromProps(
		              workInProgress,
		              Component,
		              unresolvedOldProps,
		              nextProps
		            ),
		            (newState = workInProgress.memoizedState)),
		          (contextType$jscomp$0 =
		            hasForceUpdate ||
		            checkShouldComponentUpdate(
		              workInProgress,
		              Component,
		              contextType$jscomp$0,
		              nextProps,
		              oldState,
		              newState,
		              oldProps
		            ) ||
		            (null !== current &&
		              null !== current.dependencies &&
		              checkIfContextChanged(current.dependencies)))
		            ? (oldContext ||
		                ("function" !== typeof context.UNSAFE_componentWillUpdate &&
		                  "function" !== typeof context.componentWillUpdate) ||
		                ("function" === typeof context.componentWillUpdate &&
		                  context.componentWillUpdate(nextProps, newState, oldProps),
		                "function" === typeof context.UNSAFE_componentWillUpdate &&
		                  context.UNSAFE_componentWillUpdate(
		                    nextProps,
		                    newState,
		                    oldProps
		                  )),
		              "function" === typeof context.componentDidUpdate &&
		                (workInProgress.flags |= 4),
		              "function" === typeof context.getSnapshotBeforeUpdate &&
		                (workInProgress.flags |= 1024))
		            : ("function" !== typeof context.componentDidUpdate ||
		                (contextType === current.memoizedProps &&
		                  oldState === current.memoizedState) ||
		                (workInProgress.flags |= 4),
		              "function" !== typeof context.getSnapshotBeforeUpdate ||
		                (contextType === current.memoizedProps &&
		                  oldState === current.memoizedState) ||
		                (workInProgress.flags |= 1024),
		              (workInProgress.memoizedProps = nextProps),
		              (workInProgress.memoizedState = newState)),
		          (context.props = nextProps),
		          (context.state = newState),
		          (context.context = oldProps),
		          (nextProps = contextType$jscomp$0))
		        : ("function" !== typeof context.componentDidUpdate ||
		            (contextType === current.memoizedProps &&
		              oldState === current.memoizedState) ||
		            (workInProgress.flags |= 4),
		          "function" !== typeof context.getSnapshotBeforeUpdate ||
		            (contextType === current.memoizedProps &&
		              oldState === current.memoizedState) ||
		            (workInProgress.flags |= 1024),
		          (nextProps = false));
		    }
		    context = nextProps;
		    markRef(current, workInProgress);
		    nextProps = 0 !== (workInProgress.flags & 128);
		    context || nextProps
		      ? ((context = workInProgress.stateNode),
		        (Component =
		          nextProps && "function" !== typeof Component.getDerivedStateFromError
		            ? null
		            : context.render()),
		        (workInProgress.flags |= 1),
		        null !== current && nextProps
		          ? ((workInProgress.child = reconcileChildFibers(
		              workInProgress,
		              current.child,
		              null,
		              renderLanes
		            )),
		            (workInProgress.child = reconcileChildFibers(
		              workInProgress,
		              null,
		              Component,
		              renderLanes
		            )))
		          : reconcileChildren(current, workInProgress, Component, renderLanes),
		        (workInProgress.memoizedState = context.state),
		        (current = workInProgress.child))
		      : (current = bailoutOnAlreadyFinishedWork(
		          current,
		          workInProgress,
		          renderLanes
		        ));
		    return current;
		  }
		  function mountHostRootWithoutHydrating(
		    current,
		    workInProgress,
		    nextChildren,
		    renderLanes
		  ) {
		    resetHydrationState();
		    workInProgress.flags |= 256;
		    reconcileChildren(current, workInProgress, nextChildren, renderLanes);
		    return workInProgress.child;
		  }
		  function mountSuspenseOffscreenState(renderLanes) {
		    return { baseLanes: renderLanes, cachePool: getSuspendedCache() };
		  }
		  function getRemainingWorkInPrimaryTree(
		    current,
		    primaryTreeDidDefer,
		    renderLanes
		  ) {
		    current = null !== current ? current.childLanes & ~renderLanes : 0;
		    primaryTreeDidDefer && (current |= workInProgressDeferredLane);
		    return current;
		  }
		  function updateSuspenseComponent(current, workInProgress, renderLanes) {
		    var nextProps = workInProgress.pendingProps,
		      showFallback = false,
		      didSuspend = 0 !== (workInProgress.flags & 128),
		      JSCompiler_temp;
		    (JSCompiler_temp = didSuspend) ||
		      (JSCompiler_temp =
		        null !== current && null === current.memoizedState
		          ? false
		          : 0 !== (suspenseStackCursor.current & 2));
		    JSCompiler_temp && ((showFallback = true), (workInProgress.flags &= -129));
		    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
		    workInProgress.flags &= -33;
		    if (null === current) {
		      if (isHydrating) {
		        showFallback
		          ? pushPrimaryTreeSuspenseHandler(workInProgress)
		          : reuseSuspenseHandlerOnStack();
		        (current = nextHydratableInstance)
		          ? ((current = canHydrateSuspenseInstance(
		              current,
		              rootOrSingletonContext
		            )),
		            null !== current &&
		              ((workInProgress.memoizedState = {
		                dehydrated: current,
		                treeContext:
		                  null !== treeContextProvider
		                    ? { id: treeContextId, overflow: treeContextOverflow }
		                    : null,
		                retryLane: 536870912,
		                hydrationErrors: null
		              }),
		              (renderLanes = createFiberFromDehydratedFragment(current)),
		              (renderLanes.return = workInProgress),
		              (workInProgress.child = renderLanes),
		              (hydrationParentFiber = workInProgress),
		              (nextHydratableInstance = null)))
		          : (current = null);
		        if (null === current) throw throwOnHydrationMismatch(workInProgress);
		        isSuspenseInstanceFallback(current)
		          ? (workInProgress.lanes = 32)
		          : (workInProgress.lanes = 536870912);
		        return null;
		      }
		      var nextPrimaryChildren = nextProps.children;
		      nextProps = nextProps.fallback;
		      if (showFallback)
		        return (
		          reuseSuspenseHandlerOnStack(),
		          (showFallback = workInProgress.mode),
		          (nextPrimaryChildren = mountWorkInProgressOffscreenFiber(
		            { mode: "hidden", children: nextPrimaryChildren },
		            showFallback
		          )),
		          (nextProps = createFiberFromFragment(
		            nextProps,
		            showFallback,
		            renderLanes,
		            null
		          )),
		          (nextPrimaryChildren.return = workInProgress),
		          (nextProps.return = workInProgress),
		          (nextPrimaryChildren.sibling = nextProps),
		          (workInProgress.child = nextPrimaryChildren),
		          (nextProps = workInProgress.child),
		          (nextProps.memoizedState = mountSuspenseOffscreenState(renderLanes)),
		          (nextProps.childLanes = getRemainingWorkInPrimaryTree(
		            current,
		            JSCompiler_temp,
		            renderLanes
		          )),
		          (workInProgress.memoizedState = SUSPENDED_MARKER),
		          bailoutOffscreenComponent(null, nextProps)
		        );
		      pushPrimaryTreeSuspenseHandler(workInProgress);
		      return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
		    }
		    var prevState = current.memoizedState;
		    if (
		      null !== prevState &&
		      ((nextPrimaryChildren = prevState.dehydrated),
		      null !== nextPrimaryChildren)
		    ) {
		      if (didSuspend)
		        workInProgress.flags & 256
		          ? (pushPrimaryTreeSuspenseHandler(workInProgress),
		            (workInProgress.flags &= -257),
		            (workInProgress = retrySuspenseComponentWithoutHydrating(
		              current,
		              workInProgress,
		              renderLanes
		            )))
		          : null !== workInProgress.memoizedState
		            ? (reuseSuspenseHandlerOnStack(),
		              (workInProgress.child = current.child),
		              (workInProgress.flags |= 128),
		              (workInProgress = null))
		            : (reuseSuspenseHandlerOnStack(),
		              (nextPrimaryChildren = nextProps.fallback),
		              (showFallback = workInProgress.mode),
		              (nextProps = mountWorkInProgressOffscreenFiber(
		                { mode: "visible", children: nextProps.children },
		                showFallback
		              )),
		              (nextPrimaryChildren = createFiberFromFragment(
		                nextPrimaryChildren,
		                showFallback,
		                renderLanes,
		                null
		              )),
		              (nextPrimaryChildren.flags |= 2),
		              (nextProps.return = workInProgress),
		              (nextPrimaryChildren.return = workInProgress),
		              (nextProps.sibling = nextPrimaryChildren),
		              (workInProgress.child = nextProps),
		              reconcileChildFibers(
		                workInProgress,
		                current.child,
		                null,
		                renderLanes
		              ),
		              (nextProps = workInProgress.child),
		              (nextProps.memoizedState =
		                mountSuspenseOffscreenState(renderLanes)),
		              (nextProps.childLanes = getRemainingWorkInPrimaryTree(
		                current,
		                JSCompiler_temp,
		                renderLanes
		              )),
		              (workInProgress.memoizedState = SUSPENDED_MARKER),
		              (workInProgress = bailoutOffscreenComponent(null, nextProps)));
		      else if (
		        (pushPrimaryTreeSuspenseHandler(workInProgress),
		        isSuspenseInstanceFallback(nextPrimaryChildren))
		      )
		        (JSCompiler_temp =
		          getSuspenseInstanceFallbackErrorDetails(nextPrimaryChildren).digest),
		          (nextProps = Error(formatProdErrorMessage(419))),
		          (nextProps.stack = ""),
		          (nextProps.digest = JSCompiler_temp),
		          queueHydrationError({ value: nextProps, source: null, stack: null }),
		          (workInProgress = retrySuspenseComponentWithoutHydrating(
		            current,
		            workInProgress,
		            renderLanes
		          ));
		      else if (
		        (didReceiveUpdate ||
		          propagateParentContextChanges(
		            current,
		            workInProgress,
		            renderLanes,
		            false
		          ),
		        (JSCompiler_temp = 0 !== (renderLanes & current.childLanes)),
		        didReceiveUpdate || JSCompiler_temp)
		      ) {
		        JSCompiler_temp = workInProgressRoot;
		        if (
		          null !== JSCompiler_temp &&
		          ((nextProps = getBumpedLaneForHydration(
		            JSCompiler_temp,
		            renderLanes
		          )),
		          0 !== nextProps && nextProps !== prevState.retryLane)
		        )
		          throw (
		            ((prevState.retryLane = nextProps),
		            enqueueConcurrentRenderForLane(current, nextProps),
		            scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps),
		            SelectiveHydrationException)
		          );
		        isSuspenseInstancePending(nextPrimaryChildren) ||
		          renderDidSuspendDelayIfPossible();
		        workInProgress = retrySuspenseComponentWithoutHydrating(
		          current,
		          workInProgress,
		          renderLanes
		        );
		      } else
		        isSuspenseInstancePending(nextPrimaryChildren)
		          ? ((workInProgress.flags |= 192),
		            (workInProgress.child = current.child),
		            (workInProgress = null))
		          : ((current = prevState.treeContext),
		            supportsHydration &&
		              ((nextHydratableInstance =
		                getFirstHydratableChildWithinSuspenseInstance(
		                  nextPrimaryChildren
		                )),
		              (hydrationParentFiber = workInProgress),
		              (isHydrating = true),
		              (hydrationErrors = null),
		              (rootOrSingletonContext = false),
		              null !== current &&
		                restoreSuspendedTreeContext(workInProgress, current)),
		            (workInProgress = mountSuspensePrimaryChildren(
		              workInProgress,
		              nextProps.children
		            )),
		            (workInProgress.flags |= 4096));
		      return workInProgress;
		    }
		    if (showFallback)
		      return (
		        reuseSuspenseHandlerOnStack(),
		        (nextPrimaryChildren = nextProps.fallback),
		        (showFallback = workInProgress.mode),
		        (prevState = current.child),
		        (didSuspend = prevState.sibling),
		        (nextProps = createWorkInProgress(prevState, {
		          mode: "hidden",
		          children: nextProps.children
		        })),
		        (nextProps.subtreeFlags = prevState.subtreeFlags & 65011712),
		        null !== didSuspend
		          ? (nextPrimaryChildren = createWorkInProgress(
		              didSuspend,
		              nextPrimaryChildren
		            ))
		          : ((nextPrimaryChildren = createFiberFromFragment(
		              nextPrimaryChildren,
		              showFallback,
		              renderLanes,
		              null
		            )),
		            (nextPrimaryChildren.flags |= 2)),
		        (nextPrimaryChildren.return = workInProgress),
		        (nextProps.return = workInProgress),
		        (nextProps.sibling = nextPrimaryChildren),
		        (workInProgress.child = nextProps),
		        bailoutOffscreenComponent(null, nextProps),
		        (nextProps = workInProgress.child),
		        (nextPrimaryChildren = current.child.memoizedState),
		        null === nextPrimaryChildren
		          ? (nextPrimaryChildren = mountSuspenseOffscreenState(renderLanes))
		          : ((showFallback = nextPrimaryChildren.cachePool),
		            null !== showFallback
		              ? ((prevState = isPrimaryRenderer
		                  ? CacheContext._currentValue
		                  : CacheContext._currentValue2),
		                (showFallback =
		                  showFallback.parent !== prevState
		                    ? { parent: prevState, pool: prevState }
		                    : showFallback))
		              : (showFallback = getSuspendedCache()),
		            (nextPrimaryChildren = {
		              baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
		              cachePool: showFallback
		            })),
		        (nextProps.memoizedState = nextPrimaryChildren),
		        (nextProps.childLanes = getRemainingWorkInPrimaryTree(
		          current,
		          JSCompiler_temp,
		          renderLanes
		        )),
		        (workInProgress.memoizedState = SUSPENDED_MARKER),
		        bailoutOffscreenComponent(current.child, nextProps)
		      );
		    pushPrimaryTreeSuspenseHandler(workInProgress);
		    renderLanes = current.child;
		    current = renderLanes.sibling;
		    renderLanes = createWorkInProgress(renderLanes, {
		      mode: "visible",
		      children: nextProps.children
		    });
		    renderLanes.return = workInProgress;
		    renderLanes.sibling = null;
		    null !== current &&
		      ((JSCompiler_temp = workInProgress.deletions),
		      null === JSCompiler_temp
		        ? ((workInProgress.deletions = [current]), (workInProgress.flags |= 16))
		        : JSCompiler_temp.push(current));
		    workInProgress.child = renderLanes;
		    workInProgress.memoizedState = null;
		    return renderLanes;
		  }
		  function mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
		    primaryChildren = mountWorkInProgressOffscreenFiber(
		      { mode: "visible", children: primaryChildren },
		      workInProgress.mode
		    );
		    primaryChildren.return = workInProgress;
		    return (workInProgress.child = primaryChildren);
		  }
		  function mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
		    offscreenProps = createFiber(22, offscreenProps, null, mode);
		    offscreenProps.lanes = 0;
		    return offscreenProps;
		  }
		  function retrySuspenseComponentWithoutHydrating(
		    current,
		    workInProgress,
		    renderLanes
		  ) {
		    reconcileChildFibers(workInProgress, current.child, null, renderLanes);
		    current = mountSuspensePrimaryChildren(
		      workInProgress,
		      workInProgress.pendingProps.children
		    );
		    current.flags |= 2;
		    workInProgress.memoizedState = null;
		    return current;
		  }
		  function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
		    fiber.lanes |= renderLanes;
		    var alternate = fiber.alternate;
		    null !== alternate && (alternate.lanes |= renderLanes);
		    scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
		  }
		  function initSuspenseListRenderState(
		    workInProgress,
		    isBackwards,
		    tail,
		    lastContentRow,
		    tailMode,
		    treeForkCount
		  ) {
		    var renderState = workInProgress.memoizedState;
		    null === renderState
		      ? (workInProgress.memoizedState = {
		          isBackwards: isBackwards,
		          rendering: null,
		          renderingStartTime: 0,
		          last: lastContentRow,
		          tail: tail,
		          tailMode: tailMode,
		          treeForkCount: treeForkCount
		        })
		      : ((renderState.isBackwards = isBackwards),
		        (renderState.rendering = null),
		        (renderState.renderingStartTime = 0),
		        (renderState.last = lastContentRow),
		        (renderState.tail = tail),
		        (renderState.tailMode = tailMode),
		        (renderState.treeForkCount = treeForkCount));
		  }
		  function updateSuspenseListComponent(current, workInProgress, renderLanes) {
		    var nextProps = workInProgress.pendingProps,
		      revealOrder = nextProps.revealOrder,
		      tailMode = nextProps.tail;
		    nextProps = nextProps.children;
		    var suspenseContext = suspenseStackCursor.current,
		      shouldForceFallback = 0 !== (suspenseContext & 2);
		    shouldForceFallback
		      ? ((suspenseContext = (suspenseContext & 1) | 2),
		        (workInProgress.flags |= 128))
		      : (suspenseContext &= 1);
		    push(suspenseStackCursor, suspenseContext);
		    reconcileChildren(current, workInProgress, nextProps, renderLanes);
		    nextProps = isHydrating ? treeForkCount : 0;
		    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128))
		      a: for (current = workInProgress.child; null !== current; ) {
		        if (13 === current.tag)
		          null !== current.memoizedState &&
		            scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
		        else if (19 === current.tag)
		          scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
		        else if (null !== current.child) {
		          current.child.return = current;
		          current = current.child;
		          continue;
		        }
		        if (current === workInProgress) break a;
		        for (; null === current.sibling; ) {
		          if (null === current.return || current.return === workInProgress)
		            break a;
		          current = current.return;
		        }
		        current.sibling.return = current.return;
		        current = current.sibling;
		      }
		    switch (revealOrder) {
		      case "forwards":
		        renderLanes = workInProgress.child;
		        for (revealOrder = null; null !== renderLanes; )
		          (current = renderLanes.alternate),
		            null !== current &&
		              null === findFirstSuspended(current) &&
		              (revealOrder = renderLanes),
		            (renderLanes = renderLanes.sibling);
		        renderLanes = revealOrder;
		        null === renderLanes
		          ? ((revealOrder = workInProgress.child),
		            (workInProgress.child = null))
		          : ((revealOrder = renderLanes.sibling), (renderLanes.sibling = null));
		        initSuspenseListRenderState(
		          workInProgress,
		          false,
		          revealOrder,
		          renderLanes,
		          tailMode,
		          nextProps
		        );
		        break;
		      case "backwards":
		      case "unstable_legacy-backwards":
		        renderLanes = null;
		        revealOrder = workInProgress.child;
		        for (workInProgress.child = null; null !== revealOrder; ) {
		          current = revealOrder.alternate;
		          if (null !== current && null === findFirstSuspended(current)) {
		            workInProgress.child = revealOrder;
		            break;
		          }
		          current = revealOrder.sibling;
		          revealOrder.sibling = renderLanes;
		          renderLanes = revealOrder;
		          revealOrder = current;
		        }
		        initSuspenseListRenderState(
		          workInProgress,
		          true,
		          renderLanes,
		          null,
		          tailMode,
		          nextProps
		        );
		        break;
		      case "together":
		        initSuspenseListRenderState(
		          workInProgress,
		          false,
		          null,
		          null,
		          void 0,
		          nextProps
		        );
		        break;
		      default:
		        workInProgress.memoizedState = null;
		    }
		    return workInProgress.child;
		  }
		  function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
		    null !== current && (workInProgress.dependencies = current.dependencies);
		    workInProgressRootSkippedLanes |= workInProgress.lanes;
		    if (0 === (renderLanes & workInProgress.childLanes))
		      if (null !== current) {
		        if (
		          (propagateParentContextChanges(
		            current,
		            workInProgress,
		            renderLanes,
		            false
		          ),
		          0 === (renderLanes & workInProgress.childLanes))
		        )
		          return null;
		      } else return null;
		    if (null !== current && workInProgress.child !== current.child)
		      throw Error(formatProdErrorMessage(153));
		    if (null !== workInProgress.child) {
		      current = workInProgress.child;
		      renderLanes = createWorkInProgress(current, current.pendingProps);
		      workInProgress.child = renderLanes;
		      for (renderLanes.return = workInProgress; null !== current.sibling; )
		        (current = current.sibling),
		          (renderLanes = renderLanes.sibling =
		            createWorkInProgress(current, current.pendingProps)),
		          (renderLanes.return = workInProgress);
		      renderLanes.sibling = null;
		    }
		    return workInProgress.child;
		  }
		  function checkScheduledUpdateOrContext(current, renderLanes) {
		    if (0 !== (current.lanes & renderLanes)) return true;
		    current = current.dependencies;
		    return null !== current && checkIfContextChanged(current) ? true : false;
		  }
		  function attemptEarlyBailoutIfNoScheduledUpdate(
		    current,
		    workInProgress,
		    renderLanes
		  ) {
		    switch (workInProgress.tag) {
		      case 3:
		        pushHostContainer(
		          workInProgress,
		          workInProgress.stateNode.containerInfo
		        );
		        pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
		        resetHydrationState();
		        break;
		      case 27:
		      case 5:
		        pushHostContext(workInProgress);
		        break;
		      case 4:
		        pushHostContainer(
		          workInProgress,
		          workInProgress.stateNode.containerInfo
		        );
		        break;
		      case 10:
		        pushProvider(
		          workInProgress,
		          workInProgress.type,
		          workInProgress.memoizedProps.value
		        );
		        break;
		      case 31:
		        if (null !== workInProgress.memoizedState)
		          return (
		            (workInProgress.flags |= 128),
		            pushDehydratedActivitySuspenseHandler(workInProgress),
		            null
		          );
		        break;
		      case 13:
		        var state$82 = workInProgress.memoizedState;
		        if (null !== state$82) {
		          if (null !== state$82.dehydrated)
		            return (
		              pushPrimaryTreeSuspenseHandler(workInProgress),
		              (workInProgress.flags |= 128),
		              null
		            );
		          if (0 !== (renderLanes & workInProgress.child.childLanes))
		            return updateSuspenseComponent(
		              current,
		              workInProgress,
		              renderLanes
		            );
		          pushPrimaryTreeSuspenseHandler(workInProgress);
		          current = bailoutOnAlreadyFinishedWork(
		            current,
		            workInProgress,
		            renderLanes
		          );
		          return null !== current ? current.sibling : null;
		        }
		        pushPrimaryTreeSuspenseHandler(workInProgress);
		        break;
		      case 19:
		        var didSuspendBefore = 0 !== (current.flags & 128);
		        state$82 = 0 !== (renderLanes & workInProgress.childLanes);
		        state$82 ||
		          (propagateParentContextChanges(
		            current,
		            workInProgress,
		            renderLanes,
		            false
		          ),
		          (state$82 = 0 !== (renderLanes & workInProgress.childLanes)));
		        if (didSuspendBefore) {
		          if (state$82)
		            return updateSuspenseListComponent(
		              current,
		              workInProgress,
		              renderLanes
		            );
		          workInProgress.flags |= 128;
		        }
		        didSuspendBefore = workInProgress.memoizedState;
		        null !== didSuspendBefore &&
		          ((didSuspendBefore.rendering = null),
		          (didSuspendBefore.tail = null),
		          (didSuspendBefore.lastEffect = null));
		        push(suspenseStackCursor, suspenseStackCursor.current);
		        if (state$82) break;
		        else return null;
		      case 22:
		        return (
		          (workInProgress.lanes = 0),
		          updateOffscreenComponent(
		            current,
		            workInProgress,
		            renderLanes,
		            workInProgress.pendingProps
		          )
		        );
		      case 24:
		        pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
		    }
		    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
		  }
		  function beginWork(current, workInProgress, renderLanes) {
		    if (null !== current)
		      if (current.memoizedProps !== workInProgress.pendingProps)
		        didReceiveUpdate = true;
		      else {
		        if (
		          !checkScheduledUpdateOrContext(current, renderLanes) &&
		          0 === (workInProgress.flags & 128)
		        )
		          return (
		            (didReceiveUpdate = false),
		            attemptEarlyBailoutIfNoScheduledUpdate(
		              current,
		              workInProgress,
		              renderLanes
		            )
		          );
		        didReceiveUpdate = 0 !== (current.flags & 131072) ? true : false;
		      }
		    else
		      (didReceiveUpdate = false),
		        isHydrating &&
		          0 !== (workInProgress.flags & 1048576) &&
		          pushTreeId(workInProgress, treeForkCount, workInProgress.index);
		    workInProgress.lanes = 0;
		    switch (workInProgress.tag) {
		      case 16:
		        a: {
		          var props = workInProgress.pendingProps;
		          current = resolveLazy(workInProgress.elementType);
		          workInProgress.type = current;
		          if ("function" === typeof current)
		            shouldConstruct(current)
		              ? ((props = resolveClassComponentProps(current, props)),
		                (workInProgress.tag = 1),
		                (workInProgress = updateClassComponent(
		                  null,
		                  workInProgress,
		                  current,
		                  props,
		                  renderLanes
		                )))
		              : ((workInProgress.tag = 0),
		                (workInProgress = updateFunctionComponent(
		                  null,
		                  workInProgress,
		                  current,
		                  props,
		                  renderLanes
		                )));
		          else {
		            if (void 0 !== current && null !== current) {
		              var $$typeof = current.$$typeof;
		              if ($$typeof === REACT_FORWARD_REF_TYPE) {
		                workInProgress.tag = 11;
		                workInProgress = updateForwardRef(
		                  null,
		                  workInProgress,
		                  current,
		                  props,
		                  renderLanes
		                );
		                break a;
		              } else if ($$typeof === REACT_MEMO_TYPE) {
		                workInProgress.tag = 14;
		                workInProgress = updateMemoComponent(
		                  null,
		                  workInProgress,
		                  current,
		                  props,
		                  renderLanes
		                );
		                break a;
		              }
		            }
		            workInProgress = getComponentNameFromType(current) || current;
		            throw Error(formatProdErrorMessage(306, workInProgress, ""));
		          }
		        }
		        return workInProgress;
		      case 0:
		        return updateFunctionComponent(
		          current,
		          workInProgress,
		          workInProgress.type,
		          workInProgress.pendingProps,
		          renderLanes
		        );
		      case 1:
		        return (
		          (props = workInProgress.type),
		          ($$typeof = resolveClassComponentProps(
		            props,
		            workInProgress.pendingProps
		          )),
		          updateClassComponent(
		            current,
		            workInProgress,
		            props,
		            $$typeof,
		            renderLanes
		          )
		        );
		      case 3:
		        a: {
		          pushHostContainer(
		            workInProgress,
		            workInProgress.stateNode.containerInfo
		          );
		          if (null === current) throw Error(formatProdErrorMessage(387));
		          var nextProps = workInProgress.pendingProps;
		          $$typeof = workInProgress.memoizedState;
		          props = $$typeof.element;
		          cloneUpdateQueue(current, workInProgress);
		          processUpdateQueue(workInProgress, nextProps, null, renderLanes);
		          var nextState = workInProgress.memoizedState;
		          nextProps = nextState.cache;
		          pushProvider(workInProgress, CacheContext, nextProps);
		          nextProps !== $$typeof.cache &&
		            propagateContextChanges(
		              workInProgress,
		              [CacheContext],
		              renderLanes,
		              true
		            );
		          suspendIfUpdateReadFromEntangledAsyncAction();
		          nextProps = nextState.element;
		          if (supportsHydration && $$typeof.isDehydrated)
		            if (
		              (($$typeof = {
		                element: nextProps,
		                isDehydrated: false,
		                cache: nextState.cache
		              }),
		              (workInProgress.updateQueue.baseState = $$typeof),
		              (workInProgress.memoizedState = $$typeof),
		              workInProgress.flags & 256)
		            ) {
		              workInProgress = mountHostRootWithoutHydrating(
		                current,
		                workInProgress,
		                nextProps,
		                renderLanes
		              );
		              break a;
		            } else if (nextProps !== props) {
		              props = createCapturedValueAtFiber(
		                Error(formatProdErrorMessage(424)),
		                workInProgress
		              );
		              queueHydrationError(props);
		              workInProgress = mountHostRootWithoutHydrating(
		                current,
		                workInProgress,
		                nextProps,
		                renderLanes
		              );
		              break a;
		            } else
		              for (
		                supportsHydration &&
		                  ((nextHydratableInstance =
		                    getFirstHydratableChildWithinContainer(
		                      workInProgress.stateNode.containerInfo
		                    )),
		                  (hydrationParentFiber = workInProgress),
		                  (isHydrating = true),
		                  (hydrationErrors = null),
		                  (rootOrSingletonContext = true)),
		                  renderLanes = mountChildFibers(
		                    workInProgress,
		                    null,
		                    nextProps,
		                    renderLanes
		                  ),
		                  workInProgress.child = renderLanes;
		                renderLanes;

		              )
		                (renderLanes.flags = (renderLanes.flags & -3) | 4096),
		                  (renderLanes = renderLanes.sibling);
		          else {
		            resetHydrationState();
		            if (nextProps === props) {
		              workInProgress = bailoutOnAlreadyFinishedWork(
		                current,
		                workInProgress,
		                renderLanes
		              );
		              break a;
		            }
		            reconcileChildren(current, workInProgress, nextProps, renderLanes);
		          }
		          workInProgress = workInProgress.child;
		        }
		        return workInProgress;
		      case 26:
		        if (supportsResources)
		          return (
		            markRef(current, workInProgress),
		            null === current
		              ? (renderLanes = getResource(
		                  workInProgress.type,
		                  null,
		                  workInProgress.pendingProps,
		                  null
		                ))
		                ? (workInProgress.memoizedState = renderLanes)
		                : isHydrating ||
		                  (workInProgress.stateNode = createHoistableInstance(
		                    workInProgress.type,
		                    workInProgress.pendingProps,
		                    rootInstanceStackCursor.current,
		                    workInProgress
		                  ))
		              : (workInProgress.memoizedState = getResource(
		                  workInProgress.type,
		                  current.memoizedProps,
		                  workInProgress.pendingProps,
		                  current.memoizedState
		                )),
		            null
		          );
		      case 27:
		        if (supportsSingletons)
		          return (
		            pushHostContext(workInProgress),
		            null === current &&
		              supportsSingletons &&
		              isHydrating &&
		              ((props = workInProgress.stateNode =
		                resolveSingletonInstance(
		                  workInProgress.type,
		                  workInProgress.pendingProps,
		                  rootInstanceStackCursor.current,
		                  contextStackCursor.current,
		                  false
		                )),
		              (hydrationParentFiber = workInProgress),
		              (rootOrSingletonContext = true),
		              (nextHydratableInstance = getFirstHydratableChildWithinSingleton(
		                workInProgress.type,
		                props,
		                nextHydratableInstance
		              ))),
		            reconcileChildren(
		              current,
		              workInProgress,
		              workInProgress.pendingProps.children,
		              renderLanes
		            ),
		            markRef(current, workInProgress),
		            null === current && (workInProgress.flags |= 4194304),
		            workInProgress.child
		          );
		      case 5:
		        if (null === current && isHydrating) {
		          validateHydratableInstance(
		            workInProgress.type,
		            workInProgress.pendingProps,
		            contextStackCursor.current
		          );
		          if (($$typeof = props = nextHydratableInstance))
		            (props = canHydrateInstance(
		              props,
		              workInProgress.type,
		              workInProgress.pendingProps,
		              rootOrSingletonContext
		            )),
		              null !== props
		                ? ((workInProgress.stateNode = props),
		                  (hydrationParentFiber = workInProgress),
		                  (nextHydratableInstance = getFirstHydratableChild(props)),
		                  (rootOrSingletonContext = false),
		                  ($$typeof = true))
		                : ($$typeof = false);
		          $$typeof || throwOnHydrationMismatch(workInProgress);
		        }
		        pushHostContext(workInProgress);
		        $$typeof = workInProgress.type;
		        nextProps = workInProgress.pendingProps;
		        nextState = null !== current ? current.memoizedProps : null;
		        props = nextProps.children;
		        shouldSetTextContent($$typeof, nextProps)
		          ? (props = null)
		          : null !== nextState &&
		            shouldSetTextContent($$typeof, nextState) &&
		            (workInProgress.flags |= 32);
		        null !== workInProgress.memoizedState &&
		          (($$typeof = renderWithHooks(
		            current,
		            workInProgress,
		            TransitionAwareHostComponent,
		            null,
		            null,
		            renderLanes
		          )),
		          isPrimaryRenderer
		            ? (HostTransitionContext._currentValue = $$typeof)
		            : (HostTransitionContext._currentValue2 = $$typeof));
		        markRef(current, workInProgress);
		        reconcileChildren(current, workInProgress, props, renderLanes);
		        return workInProgress.child;
		      case 6:
		        if (null === current && isHydrating) {
		          validateHydratableTextInstance(
		            workInProgress.pendingProps,
		            contextStackCursor.current
		          );
		          if ((current = renderLanes = nextHydratableInstance))
		            (renderLanes = canHydrateTextInstance(
		              renderLanes,
		              workInProgress.pendingProps,
		              rootOrSingletonContext
		            )),
		              null !== renderLanes
		                ? ((workInProgress.stateNode = renderLanes),
		                  (hydrationParentFiber = workInProgress),
		                  (nextHydratableInstance = null),
		                  (current = true))
		                : (current = false);
		          current || throwOnHydrationMismatch(workInProgress);
		        }
		        return null;
		      case 13:
		        return updateSuspenseComponent(current, workInProgress, renderLanes);
		      case 4:
		        return (
		          pushHostContainer(
		            workInProgress,
		            workInProgress.stateNode.containerInfo
		          ),
		          (props = workInProgress.pendingProps),
		          null === current
		            ? (workInProgress.child = reconcileChildFibers(
		                workInProgress,
		                null,
		                props,
		                renderLanes
		              ))
		            : reconcileChildren(current, workInProgress, props, renderLanes),
		          workInProgress.child
		        );
		      case 11:
		        return updateForwardRef(
		          current,
		          workInProgress,
		          workInProgress.type,
		          workInProgress.pendingProps,
		          renderLanes
		        );
		      case 7:
		        return (
		          reconcileChildren(
		            current,
		            workInProgress,
		            workInProgress.pendingProps,
		            renderLanes
		          ),
		          workInProgress.child
		        );
		      case 8:
		        return (
		          reconcileChildren(
		            current,
		            workInProgress,
		            workInProgress.pendingProps.children,
		            renderLanes
		          ),
		          workInProgress.child
		        );
		      case 12:
		        return (
		          reconcileChildren(
		            current,
		            workInProgress,
		            workInProgress.pendingProps.children,
		            renderLanes
		          ),
		          workInProgress.child
		        );
		      case 10:
		        return (
		          (props = workInProgress.pendingProps),
		          pushProvider(workInProgress, workInProgress.type, props.value),
		          reconcileChildren(
		            current,
		            workInProgress,
		            props.children,
		            renderLanes
		          ),
		          workInProgress.child
		        );
		      case 9:
		        return (
		          ($$typeof = workInProgress.type._context),
		          (props = workInProgress.pendingProps.children),
		          prepareToReadContext(workInProgress),
		          ($$typeof = readContext($$typeof)),
		          (props = props($$typeof)),
		          (workInProgress.flags |= 1),
		          reconcileChildren(current, workInProgress, props, renderLanes),
		          workInProgress.child
		        );
		      case 14:
		        return updateMemoComponent(
		          current,
		          workInProgress,
		          workInProgress.type,
		          workInProgress.pendingProps,
		          renderLanes
		        );
		      case 15:
		        return updateSimpleMemoComponent(
		          current,
		          workInProgress,
		          workInProgress.type,
		          workInProgress.pendingProps,
		          renderLanes
		        );
		      case 19:
		        return updateSuspenseListComponent(
		          current,
		          workInProgress,
		          renderLanes
		        );
		      case 31:
		        return updateActivityComponent(current, workInProgress, renderLanes);
		      case 22:
		        return updateOffscreenComponent(
		          current,
		          workInProgress,
		          renderLanes,
		          workInProgress.pendingProps
		        );
		      case 24:
		        return (
		          prepareToReadContext(workInProgress),
		          (props = readContext(CacheContext)),
		          null === current
		            ? (($$typeof = peekCacheFromPool()),
		              null === $$typeof &&
		                (($$typeof = workInProgressRoot),
		                (nextProps = createCache()),
		                ($$typeof.pooledCache = nextProps),
		                nextProps.refCount++,
		                null !== nextProps &&
		                  ($$typeof.pooledCacheLanes |= renderLanes),
		                ($$typeof = nextProps)),
		              (workInProgress.memoizedState = {
		                parent: props,
		                cache: $$typeof
		              }),
		              initializeUpdateQueue(workInProgress),
		              pushProvider(workInProgress, CacheContext, $$typeof))
		            : (0 !== (current.lanes & renderLanes) &&
		                (cloneUpdateQueue(current, workInProgress),
		                processUpdateQueue(workInProgress, null, null, renderLanes),
		                suspendIfUpdateReadFromEntangledAsyncAction()),
		              ($$typeof = current.memoizedState),
		              (nextProps = workInProgress.memoizedState),
		              $$typeof.parent !== props
		                ? (($$typeof = { parent: props, cache: props }),
		                  (workInProgress.memoizedState = $$typeof),
		                  0 === workInProgress.lanes &&
		                    (workInProgress.memoizedState =
		                      workInProgress.updateQueue.baseState =
		                        $$typeof),
		                  pushProvider(workInProgress, CacheContext, props))
		                : ((props = nextProps.cache),
		                  pushProvider(workInProgress, CacheContext, props),
		                  props !== $$typeof.cache &&
		                    propagateContextChanges(
		                      workInProgress,
		                      [CacheContext],
		                      renderLanes,
		                      true
		                    ))),
		          reconcileChildren(
		            current,
		            workInProgress,
		            workInProgress.pendingProps.children,
		            renderLanes
		          ),
		          workInProgress.child
		        );
		      case 29:
		        throw workInProgress.pendingProps;
		    }
		    throw Error(formatProdErrorMessage(156, workInProgress.tag));
		  }
		  function markUpdate(workInProgress) {
		    workInProgress.flags |= 4;
		  }
		  function markCloned(workInProgress) {
		    supportsPersistence && (workInProgress.flags |= 8);
		  }
		  function doesRequireClone(current, completedWork) {
		    if (null !== current && current.child === completedWork.child) return false;
		    if (0 !== (completedWork.flags & 16)) return true;
		    for (current = completedWork.child; null !== current; ) {
		      if (0 !== (current.flags & 8218) || 0 !== (current.subtreeFlags & 8218))
		        return true;
		      current = current.sibling;
		    }
		    return false;
		  }
		  function appendAllChildren(
		    parent,
		    workInProgress,
		    needsVisibilityToggle,
		    isHidden
		  ) {
		    if (supportsMutation)
		      for (
		        needsVisibilityToggle = workInProgress.child;
		        null !== needsVisibilityToggle;

		      ) {
		        if (5 === needsVisibilityToggle.tag || 6 === needsVisibilityToggle.tag)
		          appendInitialChild(parent, needsVisibilityToggle.stateNode);
		        else if (
		          !(
		            4 === needsVisibilityToggle.tag ||
		            (supportsSingletons && 27 === needsVisibilityToggle.tag)
		          ) &&
		          null !== needsVisibilityToggle.child
		        ) {
		          needsVisibilityToggle.child.return = needsVisibilityToggle;
		          needsVisibilityToggle = needsVisibilityToggle.child;
		          continue;
		        }
		        if (needsVisibilityToggle === workInProgress) break;
		        for (; null === needsVisibilityToggle.sibling; ) {
		          if (
		            null === needsVisibilityToggle.return ||
		            needsVisibilityToggle.return === workInProgress
		          )
		            return;
		          needsVisibilityToggle = needsVisibilityToggle.return;
		        }
		        needsVisibilityToggle.sibling.return = needsVisibilityToggle.return;
		        needsVisibilityToggle = needsVisibilityToggle.sibling;
		      }
		    else if (supportsPersistence)
		      for (var node$85 = workInProgress.child; null !== node$85; ) {
		        if (5 === node$85.tag) {
		          var instance = node$85.stateNode;
		          needsVisibilityToggle &&
		            isHidden &&
		            (instance = cloneHiddenInstance(
		              instance,
		              node$85.type,
		              node$85.memoizedProps
		            ));
		          appendInitialChild(parent, instance);
		        } else if (6 === node$85.tag)
		          (instance = node$85.stateNode),
		            needsVisibilityToggle &&
		              isHidden &&
		              (instance = cloneHiddenTextInstance(
		                instance,
		                node$85.memoizedProps
		              )),
		            appendInitialChild(parent, instance);
		        else if (4 !== node$85.tag)
		          if (22 === node$85.tag && null !== node$85.memoizedState)
		            (instance = node$85.child),
		              null !== instance && (instance.return = node$85),
		              appendAllChildren(parent, node$85, true, true);
		          else if (null !== node$85.child) {
		            node$85.child.return = node$85;
		            node$85 = node$85.child;
		            continue;
		          }
		        if (node$85 === workInProgress) break;
		        for (; null === node$85.sibling; ) {
		          if (null === node$85.return || node$85.return === workInProgress)
		            return;
		          node$85 = node$85.return;
		        }
		        node$85.sibling.return = node$85.return;
		        node$85 = node$85.sibling;
		      }
		  }
		  function appendAllChildrenToContainer(
		    containerChildSet,
		    workInProgress,
		    needsVisibilityToggle,
		    isHidden
		  ) {
		    var hasOffscreenComponentChild = false;
		    if (supportsPersistence)
		      for (var node = workInProgress.child; null !== node; ) {
		        if (5 === node.tag) {
		          var instance = node.stateNode;
		          needsVisibilityToggle &&
		            isHidden &&
		            (instance = cloneHiddenInstance(
		              instance,
		              node.type,
		              node.memoizedProps
		            ));
		          appendChildToContainerChildSet(containerChildSet, instance);
		        } else if (6 === node.tag)
		          (instance = node.stateNode),
		            needsVisibilityToggle &&
		              isHidden &&
		              (instance = cloneHiddenTextInstance(
		                instance,
		                node.memoizedProps
		              )),
		            appendChildToContainerChildSet(containerChildSet, instance);
		        else if (4 !== node.tag)
		          if (22 === node.tag && null !== node.memoizedState)
		            (hasOffscreenComponentChild = node.child),
		              null !== hasOffscreenComponentChild &&
		                (hasOffscreenComponentChild.return = node),
		              appendAllChildrenToContainer(containerChildSet, node, true, true),
		              (hasOffscreenComponentChild = true);
		          else if (null !== node.child) {
		            node.child.return = node;
		            node = node.child;
		            continue;
		          }
		        if (node === workInProgress) break;
		        for (; null === node.sibling; ) {
		          if (null === node.return || node.return === workInProgress)
		            return hasOffscreenComponentChild;
		          node = node.return;
		        }
		        node.sibling.return = node.return;
		        node = node.sibling;
		      }
		    return hasOffscreenComponentChild;
		  }
		  function updateHostContainer(current, workInProgress) {
		    if (supportsPersistence && doesRequireClone(current, workInProgress)) {
		      current = workInProgress.stateNode;
		      var container = current.containerInfo,
		        newChildSet = createContainerChildSet();
		      appendAllChildrenToContainer(newChildSet, workInProgress, false, false);
		      current.pendingChildren = newChildSet;
		      markUpdate(workInProgress);
		      finalizeContainerChildren(container, newChildSet);
		    }
		  }
		  function updateHostComponent(current, workInProgress, type, newProps) {
		    if (supportsMutation)
		      current.memoizedProps !== newProps && markUpdate(workInProgress);
		    else if (supportsPersistence) {
		      var currentInstance = current.stateNode,
		        oldProps$88 = current.memoizedProps;
		      if (
		        (current = doesRequireClone(current, workInProgress)) ||
		        oldProps$88 !== newProps
		      ) {
		        var currentHostContext = contextStackCursor.current;
		        oldProps$88 = cloneInstance(
		          currentInstance,
		          type,
		          oldProps$88,
		          newProps,
		          !current,
		          null
		        );
		        oldProps$88 === currentInstance
		          ? (workInProgress.stateNode = currentInstance)
		          : (markCloned(workInProgress),
		            finalizeInitialChildren(
		              oldProps$88,
		              type,
		              newProps,
		              currentHostContext
		            ) && markUpdate(workInProgress),
		            (workInProgress.stateNode = oldProps$88),
		            current && appendAllChildren(oldProps$88, workInProgress, false, false));
		      } else workInProgress.stateNode = currentInstance;
		    }
		  }
		  function preloadInstanceAndSuspendIfNeeded(
		    workInProgress,
		    type,
		    oldProps,
		    newProps,
		    renderLanes
		  ) {
		    if (
		      0 !== (workInProgress.mode & 32) &&
		      (null === oldProps
		        ? maySuspendCommit(type, newProps)
		        : maySuspendCommitOnUpdate(type, oldProps, newProps))
		    ) {
		      if (
		        ((workInProgress.flags |= 16777216),
		        (renderLanes & 335544128) === renderLanes ||
		          maySuspendCommitInSyncRender(type, newProps))
		      )
		        if (preloadInstance(workInProgress.stateNode, type, newProps))
		          workInProgress.flags |= 8192;
		        else if (shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
		        else
		          throw (
		            ((suspendedThenable = noopSuspenseyCommitThenable),
		            SuspenseyCommitException)
		          );
		    } else workInProgress.flags &= -16777217;
		  }
		  function preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
		    if (mayResourceSuspendCommit(resource)) {
		      if (((workInProgress.flags |= 16777216), !preloadResource(resource)))
		        if (shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
		        else
		          throw (
		            ((suspendedThenable = noopSuspenseyCommitThenable),
		            SuspenseyCommitException)
		          );
		    } else workInProgress.flags &= -16777217;
		  }
		  function scheduleRetryEffect(workInProgress, retryQueue) {
		    null !== retryQueue && (workInProgress.flags |= 4);
		    workInProgress.flags & 16384 &&
		      ((retryQueue =
		        22 !== workInProgress.tag ? claimNextRetryLane() : 536870912),
		      (workInProgress.lanes |= retryQueue),
		      (workInProgressSuspendedRetryLanes |= retryQueue));
		  }
		  function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
		    if (!isHydrating)
		      switch (renderState.tailMode) {
		        case "hidden":
		          hasRenderedATailFallback = renderState.tail;
		          for (var lastTailNode = null; null !== hasRenderedATailFallback; )
		            null !== hasRenderedATailFallback.alternate &&
		              (lastTailNode = hasRenderedATailFallback),
		              (hasRenderedATailFallback = hasRenderedATailFallback.sibling);
		          null === lastTailNode
		            ? (renderState.tail = null)
		            : (lastTailNode.sibling = null);
		          break;
		        case "collapsed":
		          lastTailNode = renderState.tail;
		          for (var lastTailNode$90 = null; null !== lastTailNode; )
		            null !== lastTailNode.alternate && (lastTailNode$90 = lastTailNode),
		              (lastTailNode = lastTailNode.sibling);
		          null === lastTailNode$90
		            ? hasRenderedATailFallback || null === renderState.tail
		              ? (renderState.tail = null)
		              : (renderState.tail.sibling = null)
		            : (lastTailNode$90.sibling = null);
		      }
		  }
		  function bubbleProperties(completedWork) {
		    var didBailout =
		        null !== completedWork.alternate &&
		        completedWork.alternate.child === completedWork.child,
		      newChildLanes = 0,
		      subtreeFlags = 0;
		    if (didBailout)
		      for (var child$91 = completedWork.child; null !== child$91; )
		        (newChildLanes |= child$91.lanes | child$91.childLanes),
		          (subtreeFlags |= child$91.subtreeFlags & 65011712),
		          (subtreeFlags |= child$91.flags & 65011712),
		          (child$91.return = completedWork),
		          (child$91 = child$91.sibling);
		    else
		      for (child$91 = completedWork.child; null !== child$91; )
		        (newChildLanes |= child$91.lanes | child$91.childLanes),
		          (subtreeFlags |= child$91.subtreeFlags),
		          (subtreeFlags |= child$91.flags),
		          (child$91.return = completedWork),
		          (child$91 = child$91.sibling);
		    completedWork.subtreeFlags |= subtreeFlags;
		    completedWork.childLanes = newChildLanes;
		    return didBailout;
		  }
		  function completeWork(current, workInProgress, renderLanes) {
		    var newProps = workInProgress.pendingProps;
		    popTreeContext(workInProgress);
		    switch (workInProgress.tag) {
		      case 16:
		      case 15:
		      case 0:
		      case 11:
		      case 7:
		      case 8:
		      case 12:
		      case 9:
		      case 14:
		        return bubbleProperties(workInProgress), null;
		      case 1:
		        return bubbleProperties(workInProgress), null;
		      case 3:
		        renderLanes = workInProgress.stateNode;
		        newProps = null;
		        null !== current && (newProps = current.memoizedState.cache);
		        workInProgress.memoizedState.cache !== newProps &&
		          (workInProgress.flags |= 2048);
		        popProvider(CacheContext);
		        popHostContainer();
		        renderLanes.pendingContext &&
		          ((renderLanes.context = renderLanes.pendingContext),
		          (renderLanes.pendingContext = null));
		        if (null === current || null === current.child)
		          popHydrationState(workInProgress)
		            ? markUpdate(workInProgress)
		            : null === current ||
		              (current.memoizedState.isDehydrated &&
		                0 === (workInProgress.flags & 256)) ||
		              ((workInProgress.flags |= 1024),
		              upgradeHydrationErrorsToRecoverable());
		        updateHostContainer(current, workInProgress);
		        bubbleProperties(workInProgress);
		        return null;
		      case 26:
		        if (supportsResources) {
		          var type = workInProgress.type,
		            nextResource = workInProgress.memoizedState;
		          null === current
		            ? (markUpdate(workInProgress),
		              null !== nextResource
		                ? (bubbleProperties(workInProgress),
		                  preloadResourceAndSuspendIfNeeded(
		                    workInProgress,
		                    nextResource
		                  ))
		                : (bubbleProperties(workInProgress),
		                  preloadInstanceAndSuspendIfNeeded(
		                    workInProgress,
		                    type,
		                    null,
		                    newProps,
		                    renderLanes
		                  )))
		            : nextResource
		              ? nextResource !== current.memoizedState
		                ? (markUpdate(workInProgress),
		                  bubbleProperties(workInProgress),
		                  preloadResourceAndSuspendIfNeeded(
		                    workInProgress,
		                    nextResource
		                  ))
		                : (bubbleProperties(workInProgress),
		                  (workInProgress.flags &= -16777217))
		              : ((nextResource = current.memoizedProps),
		                supportsMutation
		                  ? nextResource !== newProps && markUpdate(workInProgress)
		                  : updateHostComponent(
		                      current,
		                      workInProgress,
		                      type,
		                      newProps
		                    ),
		                bubbleProperties(workInProgress),
		                preloadInstanceAndSuspendIfNeeded(
		                  workInProgress,
		                  type,
		                  nextResource,
		                  newProps,
		                  renderLanes
		                ));
		          return null;
		        }
		      case 27:
		        if (supportsSingletons) {
		          popHostContext(workInProgress);
		          renderLanes = rootInstanceStackCursor.current;
		          type = workInProgress.type;
		          if (null !== current && null != workInProgress.stateNode)
		            supportsMutation
		              ? current.memoizedProps !== newProps && markUpdate(workInProgress)
		              : updateHostComponent(current, workInProgress, type, newProps);
		          else {
		            if (!newProps) {
		              if (null === workInProgress.stateNode)
		                throw Error(formatProdErrorMessage(166));
		              bubbleProperties(workInProgress);
		              return null;
		            }
		            current = contextStackCursor.current;
		            popHydrationState(workInProgress)
		              ? prepareToHydrateHostInstance(workInProgress, current)
		              : ((current = resolveSingletonInstance(
		                  type,
		                  newProps,
		                  renderLanes,
		                  current,
		                  true
		                )),
		                (workInProgress.stateNode = current),
		                markUpdate(workInProgress));
		          }
		          bubbleProperties(workInProgress);
		          return null;
		        }
		      case 5:
		        popHostContext(workInProgress);
		        type = workInProgress.type;
		        if (null !== current && null != workInProgress.stateNode)
		          updateHostComponent(current, workInProgress, type, newProps);
		        else {
		          if (!newProps) {
		            if (null === workInProgress.stateNode)
		              throw Error(formatProdErrorMessage(166));
		            bubbleProperties(workInProgress);
		            return null;
		          }
		          nextResource = contextStackCursor.current;
		          if (popHydrationState(workInProgress))
		            prepareToHydrateHostInstance(workInProgress, nextResource),
		              finalizeHydratedChildren(
		                workInProgress.stateNode,
		                type,
		                newProps,
		                nextResource
		              ) && (workInProgress.flags |= 64);
		          else {
		            var instance$101 = createInstance(
		              type,
		              newProps,
		              rootInstanceStackCursor.current,
		              nextResource,
		              workInProgress
		            );
		            markCloned(workInProgress);
		            appendAllChildren(instance$101, workInProgress, false, false);
		            workInProgress.stateNode = instance$101;
		            finalizeInitialChildren(
		              instance$101,
		              type,
		              newProps,
		              nextResource
		            ) && markUpdate(workInProgress);
		          }
		        }
		        bubbleProperties(workInProgress);
		        preloadInstanceAndSuspendIfNeeded(
		          workInProgress,
		          workInProgress.type,
		          null === current ? null : current.memoizedProps,
		          workInProgress.pendingProps,
		          renderLanes
		        );
		        return null;
		      case 6:
		        if (current && null != workInProgress.stateNode)
		          (renderLanes = current.memoizedProps),
		            supportsMutation
		              ? renderLanes !== newProps && markUpdate(workInProgress)
		              : supportsPersistence &&
		                (renderLanes !== newProps
		                  ? ((current = rootInstanceStackCursor.current),
		                    (renderLanes = contextStackCursor.current),
		                    markCloned(workInProgress),
		                    (workInProgress.stateNode = createTextInstance(
		                      newProps,
		                      current,
		                      renderLanes,
		                      workInProgress
		                    )))
		                  : (workInProgress.stateNode = current.stateNode));
		        else {
		          if ("string" !== typeof newProps && null === workInProgress.stateNode)
		            throw Error(formatProdErrorMessage(166));
		          current = rootInstanceStackCursor.current;
		          renderLanes = contextStackCursor.current;
		          if (popHydrationState(workInProgress)) {
		            if (!supportsHydration) throw Error(formatProdErrorMessage(176));
		            current = workInProgress.stateNode;
		            renderLanes = workInProgress.memoizedProps;
		            newProps = null;
		            type = hydrationParentFiber;
		            if (null !== type)
		              switch (type.tag) {
		                case 27:
		                case 5:
		                  newProps = type.memoizedProps;
		              }
		            hydrateTextInstance(
		              current,
		              renderLanes,
		              workInProgress,
		              newProps
		            ) || throwOnHydrationMismatch(workInProgress, true);
		          } else
		            markCloned(workInProgress),
		              (workInProgress.stateNode = createTextInstance(
		                newProps,
		                current,
		                renderLanes,
		                workInProgress
		              ));
		        }
		        bubbleProperties(workInProgress);
		        return null;
		      case 31:
		        renderLanes = workInProgress.memoizedState;
		        if (null === current || null !== current.memoizedState) {
		          newProps = popHydrationState(workInProgress);
		          if (null !== renderLanes) {
		            if (null === current) {
		              if (!newProps) throw Error(formatProdErrorMessage(318));
		              if (!supportsHydration) throw Error(formatProdErrorMessage(556));
		              current = workInProgress.memoizedState;
		              current = null !== current ? current.dehydrated : null;
		              if (!current) throw Error(formatProdErrorMessage(557));
		              hydrateActivityInstance(current, workInProgress);
		            } else
		              resetHydrationState(),
		                0 === (workInProgress.flags & 128) &&
		                  (workInProgress.memoizedState = null),
		                (workInProgress.flags |= 4);
		            bubbleProperties(workInProgress);
		            current = false;
		          } else
		            (renderLanes = upgradeHydrationErrorsToRecoverable()),
		              null !== current &&
		                null !== current.memoizedState &&
		                (current.memoizedState.hydrationErrors = renderLanes),
		              (current = true);
		          if (!current) {
		            if (workInProgress.flags & 256)
		              return popSuspenseHandler(workInProgress), workInProgress;
		            popSuspenseHandler(workInProgress);
		            return null;
		          }
		          if (0 !== (workInProgress.flags & 128))
		            throw Error(formatProdErrorMessage(558));
		        }
		        bubbleProperties(workInProgress);
		        return null;
		      case 13:
		        newProps = workInProgress.memoizedState;
		        if (
		          null === current ||
		          (null !== current.memoizedState &&
		            null !== current.memoizedState.dehydrated)
		        ) {
		          type = popHydrationState(workInProgress);
		          if (null !== newProps && null !== newProps.dehydrated) {
		            if (null === current) {
		              if (!type) throw Error(formatProdErrorMessage(318));
		              if (!supportsHydration) throw Error(formatProdErrorMessage(344));
		              type = workInProgress.memoizedState;
		              type = null !== type ? type.dehydrated : null;
		              if (!type) throw Error(formatProdErrorMessage(317));
		              hydrateSuspenseInstance(type, workInProgress);
		            } else
		              resetHydrationState(),
		                0 === (workInProgress.flags & 128) &&
		                  (workInProgress.memoizedState = null),
		                (workInProgress.flags |= 4);
		            bubbleProperties(workInProgress);
		            type = false;
		          } else
		            (type = upgradeHydrationErrorsToRecoverable()),
		              null !== current &&
		                null !== current.memoizedState &&
		                (current.memoizedState.hydrationErrors = type),
		              (type = true);
		          if (!type) {
		            if (workInProgress.flags & 256)
		              return popSuspenseHandler(workInProgress), workInProgress;
		            popSuspenseHandler(workInProgress);
		            return null;
		          }
		        }
		        popSuspenseHandler(workInProgress);
		        if (0 !== (workInProgress.flags & 128))
		          return (workInProgress.lanes = renderLanes), workInProgress;
		        renderLanes = null !== newProps;
		        current = null !== current && null !== current.memoizedState;
		        renderLanes &&
		          ((newProps = workInProgress.child),
		          (type = null),
		          null !== newProps.alternate &&
		            null !== newProps.alternate.memoizedState &&
		            null !== newProps.alternate.memoizedState.cachePool &&
		            (type = newProps.alternate.memoizedState.cachePool.pool),
		          (nextResource = null),
		          null !== newProps.memoizedState &&
		            null !== newProps.memoizedState.cachePool &&
		            (nextResource = newProps.memoizedState.cachePool.pool),
		          nextResource !== type && (newProps.flags |= 2048));
		        renderLanes !== current &&
		          renderLanes &&
		          (workInProgress.child.flags |= 8192);
		        scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
		        bubbleProperties(workInProgress);
		        return null;
		      case 4:
		        return (
		          popHostContainer(),
		          updateHostContainer(current, workInProgress),
		          null === current &&
		            preparePortalMount(workInProgress.stateNode.containerInfo),
		          bubbleProperties(workInProgress),
		          null
		        );
		      case 10:
		        return (
		          popProvider(workInProgress.type),
		          bubbleProperties(workInProgress),
		          null
		        );
		      case 19:
		        pop(suspenseStackCursor);
		        newProps = workInProgress.memoizedState;
		        if (null === newProps) return bubbleProperties(workInProgress), null;
		        type = 0 !== (workInProgress.flags & 128);
		        nextResource = newProps.rendering;
		        if (null === nextResource)
		          if (type) cutOffTailIfNeeded(newProps, false);
		          else {
		            if (
		              0 !== workInProgressRootExitStatus ||
		              (null !== current && 0 !== (current.flags & 128))
		            )
		              for (current = workInProgress.child; null !== current; ) {
		                nextResource = findFirstSuspended(current);
		                if (null !== nextResource) {
		                  workInProgress.flags |= 128;
		                  cutOffTailIfNeeded(newProps, false);
		                  current = nextResource.updateQueue;
		                  workInProgress.updateQueue = current;
		                  scheduleRetryEffect(workInProgress, current);
		                  workInProgress.subtreeFlags = 0;
		                  current = renderLanes;
		                  for (
		                    renderLanes = workInProgress.child;
		                    null !== renderLanes;

		                  )
		                    resetWorkInProgress(renderLanes, current),
		                      (renderLanes = renderLanes.sibling);
		                  push(
		                    suspenseStackCursor,
		                    (suspenseStackCursor.current & 1) | 2
		                  );
		                  isHydrating &&
		                    pushTreeFork(workInProgress, newProps.treeForkCount);
		                  return workInProgress.child;
		                }
		                current = current.sibling;
		              }
		            null !== newProps.tail &&
		              now() > workInProgressRootRenderTargetTime &&
		              ((workInProgress.flags |= 128),
		              (type = true),
		              cutOffTailIfNeeded(newProps, false),
		              (workInProgress.lanes = 4194304));
		          }
		        else {
		          if (!type)
		            if (
		              ((current = findFirstSuspended(nextResource)), null !== current)
		            ) {
		              if (
		                ((workInProgress.flags |= 128),
		                (type = true),
		                (current = current.updateQueue),
		                (workInProgress.updateQueue = current),
		                scheduleRetryEffect(workInProgress, current),
		                cutOffTailIfNeeded(newProps, true),
		                null === newProps.tail &&
		                  "hidden" === newProps.tailMode &&
		                  !nextResource.alternate &&
		                  !isHydrating)
		              )
		                return bubbleProperties(workInProgress), null;
		            } else
		              2 * now() - newProps.renderingStartTime >
		                workInProgressRootRenderTargetTime &&
		                536870912 !== renderLanes &&
		                ((workInProgress.flags |= 128),
		                (type = true),
		                cutOffTailIfNeeded(newProps, false),
		                (workInProgress.lanes = 4194304));
		          newProps.isBackwards
		            ? ((nextResource.sibling = workInProgress.child),
		              (workInProgress.child = nextResource))
		            : ((current = newProps.last),
		              null !== current
		                ? (current.sibling = nextResource)
		                : (workInProgress.child = nextResource),
		              (newProps.last = nextResource));
		        }
		        if (null !== newProps.tail)
		          return (
		            (current = newProps.tail),
		            (newProps.rendering = current),
		            (newProps.tail = current.sibling),
		            (newProps.renderingStartTime = now()),
		            (current.sibling = null),
		            (renderLanes = suspenseStackCursor.current),
		            push(
		              suspenseStackCursor,
		              type ? (renderLanes & 1) | 2 : renderLanes & 1
		            ),
		            isHydrating && pushTreeFork(workInProgress, newProps.treeForkCount),
		            current
		          );
		        bubbleProperties(workInProgress);
		        return null;
		      case 22:
		      case 23:
		        return (
		          popSuspenseHandler(workInProgress),
		          popHiddenContext(),
		          (newProps = null !== workInProgress.memoizedState),
		          null !== current
		            ? (null !== current.memoizedState) !== newProps &&
		              (workInProgress.flags |= 8192)
		            : newProps && (workInProgress.flags |= 8192),
		          newProps
		            ? 0 !== (renderLanes & 536870912) &&
		              0 === (workInProgress.flags & 128) &&
		              (bubbleProperties(workInProgress),
		              workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192))
		            : bubbleProperties(workInProgress),
		          (renderLanes = workInProgress.updateQueue),
		          null !== renderLanes &&
		            scheduleRetryEffect(workInProgress, renderLanes.retryQueue),
		          (renderLanes = null),
		          null !== current &&
		            null !== current.memoizedState &&
		            null !== current.memoizedState.cachePool &&
		            (renderLanes = current.memoizedState.cachePool.pool),
		          (newProps = null),
		          null !== workInProgress.memoizedState &&
		            null !== workInProgress.memoizedState.cachePool &&
		            (newProps = workInProgress.memoizedState.cachePool.pool),
		          newProps !== renderLanes && (workInProgress.flags |= 2048),
		          null !== current && pop(resumedCache),
		          null
		        );
		      case 24:
		        return (
		          (renderLanes = null),
		          null !== current && (renderLanes = current.memoizedState.cache),
		          workInProgress.memoizedState.cache !== renderLanes &&
		            (workInProgress.flags |= 2048),
		          popProvider(CacheContext),
		          bubbleProperties(workInProgress),
		          null
		        );
		      case 25:
		        return null;
		      case 30:
		        return null;
		    }
		    throw Error(formatProdErrorMessage(156, workInProgress.tag));
		  }
		  function unwindWork(current, workInProgress) {
		    popTreeContext(workInProgress);
		    switch (workInProgress.tag) {
		      case 1:
		        return (
		          (current = workInProgress.flags),
		          current & 65536
		            ? ((workInProgress.flags = (current & -65537) | 128),
		              workInProgress)
		            : null
		        );
		      case 3:
		        return (
		          popProvider(CacheContext),
		          popHostContainer(),
		          (current = workInProgress.flags),
		          0 !== (current & 65536) && 0 === (current & 128)
		            ? ((workInProgress.flags = (current & -65537) | 128),
		              workInProgress)
		            : null
		        );
		      case 26:
		      case 27:
		      case 5:
		        return popHostContext(workInProgress), null;
		      case 31:
		        if (null !== workInProgress.memoizedState) {
		          popSuspenseHandler(workInProgress);
		          if (null === workInProgress.alternate)
		            throw Error(formatProdErrorMessage(340));
		          resetHydrationState();
		        }
		        current = workInProgress.flags;
		        return current & 65536
		          ? ((workInProgress.flags = (current & -65537) | 128), workInProgress)
		          : null;
		      case 13:
		        popSuspenseHandler(workInProgress);
		        current = workInProgress.memoizedState;
		        if (null !== current && null !== current.dehydrated) {
		          if (null === workInProgress.alternate)
		            throw Error(formatProdErrorMessage(340));
		          resetHydrationState();
		        }
		        current = workInProgress.flags;
		        return current & 65536
		          ? ((workInProgress.flags = (current & -65537) | 128), workInProgress)
		          : null;
		      case 19:
		        return pop(suspenseStackCursor), null;
		      case 4:
		        return popHostContainer(), null;
		      case 10:
		        return popProvider(workInProgress.type), null;
		      case 22:
		      case 23:
		        return (
		          popSuspenseHandler(workInProgress),
		          popHiddenContext(),
		          null !== current && pop(resumedCache),
		          (current = workInProgress.flags),
		          current & 65536
		            ? ((workInProgress.flags = (current & -65537) | 128),
		              workInProgress)
		            : null
		        );
		      case 24:
		        return popProvider(CacheContext), null;
		      case 25:
		        return null;
		      default:
		        return null;
		    }
		  }
		  function unwindInterruptedWork(current, interruptedWork) {
		    popTreeContext(interruptedWork);
		    switch (interruptedWork.tag) {
		      case 3:
		        popProvider(CacheContext);
		        popHostContainer();
		        break;
		      case 26:
		      case 27:
		      case 5:
		        popHostContext(interruptedWork);
		        break;
		      case 4:
		        popHostContainer();
		        break;
		      case 31:
		        null !== interruptedWork.memoizedState &&
		          popSuspenseHandler(interruptedWork);
		        break;
		      case 13:
		        popSuspenseHandler(interruptedWork);
		        break;
		      case 19:
		        pop(suspenseStackCursor);
		        break;
		      case 10:
		        popProvider(interruptedWork.type);
		        break;
		      case 22:
		      case 23:
		        popSuspenseHandler(interruptedWork);
		        popHiddenContext();
		        null !== current && pop(resumedCache);
		        break;
		      case 24:
		        popProvider(CacheContext);
		    }
		  }
		  function commitHookEffectListMount(flags, finishedWork) {
		    try {
		      var updateQueue = finishedWork.updateQueue,
		        lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
		      if (null !== lastEffect) {
		        var firstEffect = lastEffect.next;
		        updateQueue = firstEffect;
		        do {
		          if ((updateQueue.tag & flags) === flags) {
		            lastEffect = void 0;
		            var create = updateQueue.create,
		              inst = updateQueue.inst;
		            lastEffect = create();
		            inst.destroy = lastEffect;
		          }
		          updateQueue = updateQueue.next;
		        } while (updateQueue !== firstEffect);
		      }
		    } catch (error) {
		      captureCommitPhaseError(finishedWork, finishedWork.return, error);
		    }
		  }
		  function commitHookEffectListUnmount(
		    flags,
		    finishedWork,
		    nearestMountedAncestor$jscomp$0
		  ) {
		    try {
		      var updateQueue = finishedWork.updateQueue,
		        lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
		      if (null !== lastEffect) {
		        var firstEffect = lastEffect.next;
		        updateQueue = firstEffect;
		        do {
		          if ((updateQueue.tag & flags) === flags) {
		            var inst = updateQueue.inst,
		              destroy = inst.destroy;
		            if (void 0 !== destroy) {
		              inst.destroy = void 0;
		              lastEffect = finishedWork;
		              var nearestMountedAncestor = nearestMountedAncestor$jscomp$0,
		                destroy_ = destroy;
		              try {
		                destroy_();
		              } catch (error) {
		                captureCommitPhaseError(
		                  lastEffect,
		                  nearestMountedAncestor,
		                  error
		                );
		              }
		            }
		          }
		          updateQueue = updateQueue.next;
		        } while (updateQueue !== firstEffect);
		      }
		    } catch (error) {
		      captureCommitPhaseError(finishedWork, finishedWork.return, error);
		    }
		  }
		  function commitClassCallbacks(finishedWork) {
		    var updateQueue = finishedWork.updateQueue;
		    if (null !== updateQueue) {
		      var instance = finishedWork.stateNode;
		      try {
		        commitCallbacks(updateQueue, instance);
		      } catch (error) {
		        captureCommitPhaseError(finishedWork, finishedWork.return, error);
		      }
		    }
		  }
		  function safelyCallComponentWillUnmount(
		    current,
		    nearestMountedAncestor,
		    instance
		  ) {
		    instance.props = resolveClassComponentProps(
		      current.type,
		      current.memoizedProps
		    );
		    instance.state = current.memoizedState;
		    try {
		      instance.componentWillUnmount();
		    } catch (error) {
		      captureCommitPhaseError(current, nearestMountedAncestor, error);
		    }
		  }
		  function safelyAttachRef(current, nearestMountedAncestor) {
		    try {
		      var ref = current.ref;
		      if (null !== ref) {
		        switch (current.tag) {
		          case 26:
		          case 27:
		          case 5:
		            var instanceToUse = getPublicInstance(current.stateNode);
		            break;
		          case 30:
		            instanceToUse = current.stateNode;
		            break;
		          default:
		            instanceToUse = current.stateNode;
		        }
		        "function" === typeof ref
		          ? (current.refCleanup = ref(instanceToUse))
		          : (ref.current = instanceToUse);
		      }
		    } catch (error) {
		      captureCommitPhaseError(current, nearestMountedAncestor, error);
		    }
		  }
		  function safelyDetachRef(current, nearestMountedAncestor) {
		    var ref = current.ref,
		      refCleanup = current.refCleanup;
		    if (null !== ref)
		      if ("function" === typeof refCleanup)
		        try {
		          refCleanup();
		        } catch (error) {
		          captureCommitPhaseError(current, nearestMountedAncestor, error);
		        } finally {
		          (current.refCleanup = null),
		            (current = current.alternate),
		            null != current && (current.refCleanup = null);
		        }
		      else if ("function" === typeof ref)
		        try {
		          ref(null);
		        } catch (error$124) {
		          captureCommitPhaseError(current, nearestMountedAncestor, error$124);
		        }
		      else ref.current = null;
		  }
		  function commitHostMount(finishedWork) {
		    var type = finishedWork.type,
		      props = finishedWork.memoizedProps,
		      instance = finishedWork.stateNode;
		    try {
		      commitMount(instance, type, props, finishedWork);
		    } catch (error) {
		      captureCommitPhaseError(finishedWork, finishedWork.return, error);
		    }
		  }
		  function commitHostUpdate(finishedWork, newProps, oldProps) {
		    try {
		      commitUpdate(
		        finishedWork.stateNode,
		        finishedWork.type,
		        oldProps,
		        newProps,
		        finishedWork
		      );
		    } catch (error) {
		      captureCommitPhaseError(finishedWork, finishedWork.return, error);
		    }
		  }
		  function isHostParent(fiber) {
		    return (
		      5 === fiber.tag ||
		      3 === fiber.tag ||
		      (supportsResources ? 26 === fiber.tag : false) ||
		      (supportsSingletons
		        ? 27 === fiber.tag && isSingletonScope(fiber.type)
		        : false) ||
		      4 === fiber.tag
		    );
		  }
		  function getHostSibling(fiber) {
		    a: for (;;) {
		      for (; null === fiber.sibling; ) {
		        if (null === fiber.return || isHostParent(fiber.return)) return null;
		        fiber = fiber.return;
		      }
		      fiber.sibling.return = fiber.return;
		      for (
		        fiber = fiber.sibling;
		        5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;

		      ) {
		        if (
		          supportsSingletons &&
		          27 === fiber.tag &&
		          isSingletonScope(fiber.type)
		        )
		          continue a;
		        if (fiber.flags & 2) continue a;
		        if (null === fiber.child || 4 === fiber.tag) continue a;
		        else (fiber.child.return = fiber), (fiber = fiber.child);
		      }
		      if (!(fiber.flags & 2)) return fiber.stateNode;
		    }
		  }
		  function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
		    var tag = node.tag;
		    if (5 === tag || 6 === tag)
		      (node = node.stateNode),
		        before
		          ? insertInContainerBefore(parent, node, before)
		          : appendChildToContainer(parent, node);
		    else if (
		      4 !== tag &&
		      (supportsSingletons &&
		        27 === tag &&
		        isSingletonScope(node.type) &&
		        ((parent = node.stateNode), (before = null)),
		      (node = node.child),
		      null !== node)
		    )
		      for (
		        insertOrAppendPlacementNodeIntoContainer(node, before, parent),
		          node = node.sibling;
		        null !== node;

		      )
		        insertOrAppendPlacementNodeIntoContainer(node, before, parent),
		          (node = node.sibling);
		  }
		  function insertOrAppendPlacementNode(node, before, parent) {
		    var tag = node.tag;
		    if (5 === tag || 6 === tag)
		      (node = node.stateNode),
		        before ? insertBefore(parent, node, before) : appendChild(parent, node);
		    else if (
		      4 !== tag &&
		      (supportsSingletons &&
		        27 === tag &&
		        isSingletonScope(node.type) &&
		        (parent = node.stateNode),
		      (node = node.child),
		      null !== node)
		    )
		      for (
		        insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
		        null !== node;

		      )
		        insertOrAppendPlacementNode(node, before, parent),
		          (node = node.sibling);
		  }
		  function commitHostPortalContainerChildren(
		    portal,
		    finishedWork,
		    pendingChildren
		  ) {
		    portal = portal.containerInfo;
		    try {
		      replaceContainerChildren(portal, pendingChildren);
		    } catch (error) {
		      captureCommitPhaseError(finishedWork, finishedWork.return, error);
		    }
		  }
		  function commitHostSingletonAcquisition(finishedWork) {
		    var singleton = finishedWork.stateNode,
		      props = finishedWork.memoizedProps;
		    try {
		      acquireSingletonInstance(
		        finishedWork.type,
		        props,
		        singleton,
		        finishedWork
		      );
		    } catch (error) {
		      captureCommitPhaseError(finishedWork, finishedWork.return, error);
		    }
		  }
		  function commitBeforeMutationEffects(root, firstChild) {
		    prepareForCommit(root.containerInfo);
		    for (nextEffect = firstChild; null !== nextEffect; )
		      if (
		        ((root = nextEffect),
		        (firstChild = root.child),
		        0 !== (root.subtreeFlags & 1028) && null !== firstChild)
		      )
		        (firstChild.return = root), (nextEffect = firstChild);
		      else
		        for (; null !== nextEffect; ) {
		          root = nextEffect;
		          var current = root.alternate;
		          firstChild = root.flags;
		          switch (root.tag) {
		            case 0:
		              if (
		                0 !== (firstChild & 4) &&
		                ((firstChild = root.updateQueue),
		                (firstChild = null !== firstChild ? firstChild.events : null),
		                null !== firstChild)
		              )
		                for (var ii = 0; ii < firstChild.length; ii++) {
		                  var _eventPayloads$ii = firstChild[ii];
		                  _eventPayloads$ii.ref.impl = _eventPayloads$ii.nextImpl;
		                }
		              break;
		            case 11:
		            case 15:
		              break;
		            case 1:
		              if (0 !== (firstChild & 1024) && null !== current) {
		                firstChild = void 0;
		                ii = root;
		                _eventPayloads$ii = current.memoizedProps;
		                current = current.memoizedState;
		                var instance = ii.stateNode;
		                try {
		                  var resolvedPrevProps = resolveClassComponentProps(
		                    ii.type,
		                    _eventPayloads$ii
		                  );
		                  firstChild = instance.getSnapshotBeforeUpdate(
		                    resolvedPrevProps,
		                    current
		                  );
		                  instance.__reactInternalSnapshotBeforeUpdate = firstChild;
		                } catch (error) {
		                  captureCommitPhaseError(ii, ii.return, error);
		                }
		              }
		              break;
		            case 3:
		              0 !== (firstChild & 1024) &&
		                supportsMutation &&
		                clearContainer(root.stateNode.containerInfo);
		              break;
		            case 5:
		            case 26:
		            case 27:
		            case 6:
		            case 4:
		            case 17:
		              break;
		            default:
		              if (0 !== (firstChild & 1024))
		                throw Error(formatProdErrorMessage(163));
		          }
		          firstChild = root.sibling;
		          if (null !== firstChild) {
		            firstChild.return = root.return;
		            nextEffect = firstChild;
		            break;
		          }
		          nextEffect = root.return;
		        }
		  }
		  function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
		    var flags = finishedWork.flags;
		    switch (finishedWork.tag) {
		      case 0:
		      case 11:
		      case 15:
		        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
		        flags & 4 && commitHookEffectListMount(5, finishedWork);
		        break;
		      case 1:
		        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
		        if (flags & 4)
		          if (((finishedRoot = finishedWork.stateNode), null === current))
		            try {
		              finishedRoot.componentDidMount();
		            } catch (error) {
		              captureCommitPhaseError(finishedWork, finishedWork.return, error);
		            }
		          else {
		            var prevProps = resolveClassComponentProps(
		              finishedWork.type,
		              current.memoizedProps
		            );
		            current = current.memoizedState;
		            try {
		              finishedRoot.componentDidUpdate(
		                prevProps,
		                current,
		                finishedRoot.__reactInternalSnapshotBeforeUpdate
		              );
		            } catch (error$123) {
		              captureCommitPhaseError(
		                finishedWork,
		                finishedWork.return,
		                error$123
		              );
		            }
		          }
		        flags & 64 && commitClassCallbacks(finishedWork);
		        flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
		        break;
		      case 3:
		        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
		        if (
		          flags & 64 &&
		          ((flags = finishedWork.updateQueue), null !== flags)
		        ) {
		          finishedRoot = null;
		          if (null !== finishedWork.child)
		            switch (finishedWork.child.tag) {
		              case 27:
		              case 5:
		                finishedRoot = getPublicInstance(finishedWork.child.stateNode);
		                break;
		              case 1:
		                finishedRoot = finishedWork.child.stateNode;
		            }
		          try {
		            commitCallbacks(flags, finishedRoot);
		          } catch (error) {
		            captureCommitPhaseError(finishedWork, finishedWork.return, error);
		          }
		        }
		        break;
		      case 27:
		        supportsSingletons &&
		          null === current &&
		          flags & 4 &&
		          commitHostSingletonAcquisition(finishedWork);
		      case 26:
		      case 5:
		        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
		        if (null === current)
		          if (flags & 4) commitHostMount(finishedWork);
		          else if (flags & 64) {
		            finishedRoot = finishedWork.type;
		            current = finishedWork.memoizedProps;
		            prevProps = finishedWork.stateNode;
		            try {
		              commitHydratedInstance(
		                prevProps,
		                finishedRoot,
		                current,
		                finishedWork
		              );
		            } catch (error) {
		              captureCommitPhaseError(finishedWork, finishedWork.return, error);
		            }
		          }
		        flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
		        break;
		      case 12:
		        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
		        break;
		      case 31:
		        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
		        flags & 4 &&
		          commitActivityHydrationCallbacks(finishedRoot, finishedWork);
		        break;
		      case 13:
		        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
		        flags & 4 &&
		          commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
		        flags & 64 &&
		          ((flags = finishedWork.memoizedState),
		          null !== flags &&
		            ((flags = flags.dehydrated),
		            null !== flags &&
		              ((finishedWork = retryDehydratedSuspenseBoundary.bind(
		                null,
		                finishedWork
		              )),
		              registerSuspenseInstanceRetry(flags, finishedWork))));
		        break;
		      case 22:
		        flags = null !== finishedWork.memoizedState || offscreenSubtreeIsHidden;
		        if (!flags) {
		          current =
		            (null !== current && null !== current.memoizedState) ||
		            offscreenSubtreeWasHidden;
		          prevProps = offscreenSubtreeIsHidden;
		          var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
		          offscreenSubtreeIsHidden = flags;
		          (offscreenSubtreeWasHidden = current) &&
		          !prevOffscreenSubtreeWasHidden
		            ? recursivelyTraverseReappearLayoutEffects(
		                finishedRoot,
		                finishedWork,
		                0 !== (finishedWork.subtreeFlags & 8772)
		              )
		            : recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
		          offscreenSubtreeIsHidden = prevProps;
		          offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
		        }
		        break;
		      case 30:
		        break;
		      default:
		        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
		    }
		  }
		  function detachFiberAfterEffects(fiber) {
		    var alternate = fiber.alternate;
		    null !== alternate &&
		      ((fiber.alternate = null), detachFiberAfterEffects(alternate));
		    fiber.child = null;
		    fiber.deletions = null;
		    fiber.sibling = null;
		    5 === fiber.tag &&
		      ((alternate = fiber.stateNode),
		      null !== alternate && detachDeletedInstance(alternate));
		    fiber.stateNode = null;
		    fiber.return = null;
		    fiber.dependencies = null;
		    fiber.memoizedProps = null;
		    fiber.memoizedState = null;
		    fiber.pendingProps = null;
		    fiber.stateNode = null;
		    fiber.updateQueue = null;
		  }
		  function recursivelyTraverseDeletionEffects(
		    finishedRoot,
		    nearestMountedAncestor,
		    parent
		  ) {
		    for (parent = parent.child; null !== parent; )
		      commitDeletionEffectsOnFiber(
		        finishedRoot,
		        nearestMountedAncestor,
		        parent
		      ),
		        (parent = parent.sibling);
		  }
		  function commitDeletionEffectsOnFiber(
		    finishedRoot,
		    nearestMountedAncestor,
		    deletedFiber
		  ) {
		    if (injectedHook && "function" === typeof injectedHook.onCommitFiberUnmount)
		      try {
		        injectedHook.onCommitFiberUnmount(rendererID, deletedFiber);
		      } catch (err) {}
		    switch (deletedFiber.tag) {
		      case 26:
		        if (supportsResources) {
		          offscreenSubtreeWasHidden ||
		            safelyDetachRef(deletedFiber, nearestMountedAncestor);
		          recursivelyTraverseDeletionEffects(
		            finishedRoot,
		            nearestMountedAncestor,
		            deletedFiber
		          );
		          deletedFiber.memoizedState
		            ? releaseResource(deletedFiber.memoizedState)
		            : deletedFiber.stateNode &&
		              unmountHoistable(deletedFiber.stateNode);
		          break;
		        }
		      case 27:
		        if (supportsSingletons) {
		          offscreenSubtreeWasHidden ||
		            safelyDetachRef(deletedFiber, nearestMountedAncestor);
		          var prevHostParent = hostParent,
		            prevHostParentIsContainer = hostParentIsContainer;
		          isSingletonScope(deletedFiber.type) &&
		            ((hostParent = deletedFiber.stateNode),
		            (hostParentIsContainer = false));
		          recursivelyTraverseDeletionEffects(
		            finishedRoot,
		            nearestMountedAncestor,
		            deletedFiber
		          );
		          releaseSingletonInstance(deletedFiber.stateNode);
		          hostParent = prevHostParent;
		          hostParentIsContainer = prevHostParentIsContainer;
		          break;
		        }
		      case 5:
		        offscreenSubtreeWasHidden ||
		          safelyDetachRef(deletedFiber, nearestMountedAncestor);
		      case 6:
		        if (supportsMutation) {
		          if (
		            ((prevHostParent = hostParent),
		            (prevHostParentIsContainer = hostParentIsContainer),
		            (hostParent = null),
		            recursivelyTraverseDeletionEffects(
		              finishedRoot,
		              nearestMountedAncestor,
		              deletedFiber
		            ),
		            (hostParent = prevHostParent),
		            (hostParentIsContainer = prevHostParentIsContainer),
		            null !== hostParent)
		          )
		            if (hostParentIsContainer)
		              try {
		                removeChildFromContainer(hostParent, deletedFiber.stateNode);
		              } catch (error) {
		                captureCommitPhaseError(
		                  deletedFiber,
		                  nearestMountedAncestor,
		                  error
		                );
		              }
		            else
		              try {
		                removeChild(hostParent, deletedFiber.stateNode);
		              } catch (error) {
		                captureCommitPhaseError(
		                  deletedFiber,
		                  nearestMountedAncestor,
		                  error
		                );
		              }
		        } else
		          recursivelyTraverseDeletionEffects(
		            finishedRoot,
		            nearestMountedAncestor,
		            deletedFiber
		          );
		        break;
		      case 18:
		        supportsMutation &&
		          null !== hostParent &&
		          (hostParentIsContainer
		            ? clearSuspenseBoundaryFromContainer(
		                hostParent,
		                deletedFiber.stateNode
		              )
		            : clearSuspenseBoundary(hostParent, deletedFiber.stateNode));
		        break;
		      case 4:
		        supportsMutation
		          ? ((prevHostParent = hostParent),
		            (prevHostParentIsContainer = hostParentIsContainer),
		            (hostParent = deletedFiber.stateNode.containerInfo),
		            (hostParentIsContainer = true),
		            recursivelyTraverseDeletionEffects(
		              finishedRoot,
		              nearestMountedAncestor,
		              deletedFiber
		            ),
		            (hostParent = prevHostParent),
		            (hostParentIsContainer = prevHostParentIsContainer))
		          : (supportsPersistence &&
		              commitHostPortalContainerChildren(
		                deletedFiber.stateNode,
		                deletedFiber,
		                createContainerChildSet()
		              ),
		            recursivelyTraverseDeletionEffects(
		              finishedRoot,
		              nearestMountedAncestor,
		              deletedFiber
		            ));
		        break;
		      case 0:
		      case 11:
		      case 14:
		      case 15:
		        commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
		        offscreenSubtreeWasHidden ||
		          commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
		        recursivelyTraverseDeletionEffects(
		          finishedRoot,
		          nearestMountedAncestor,
		          deletedFiber
		        );
		        break;
		      case 1:
		        offscreenSubtreeWasHidden ||
		          (safelyDetachRef(deletedFiber, nearestMountedAncestor),
		          (prevHostParent = deletedFiber.stateNode),
		          "function" === typeof prevHostParent.componentWillUnmount &&
		            safelyCallComponentWillUnmount(
		              deletedFiber,
		              nearestMountedAncestor,
		              prevHostParent
		            ));
		        recursivelyTraverseDeletionEffects(
		          finishedRoot,
		          nearestMountedAncestor,
		          deletedFiber
		        );
		        break;
		      case 21:
		        recursivelyTraverseDeletionEffects(
		          finishedRoot,
		          nearestMountedAncestor,
		          deletedFiber
		        );
		        break;
		      case 22:
		        offscreenSubtreeWasHidden =
		          (prevHostParent = offscreenSubtreeWasHidden) ||
		          null !== deletedFiber.memoizedState;
		        recursivelyTraverseDeletionEffects(
		          finishedRoot,
		          nearestMountedAncestor,
		          deletedFiber
		        );
		        offscreenSubtreeWasHidden = prevHostParent;
		        break;
		      default:
		        recursivelyTraverseDeletionEffects(
		          finishedRoot,
		          nearestMountedAncestor,
		          deletedFiber
		        );
		    }
		  }
		  function commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
		    if (
		      supportsHydration &&
		      null === finishedWork.memoizedState &&
		      ((finishedRoot = finishedWork.alternate),
		      null !== finishedRoot &&
		        ((finishedRoot = finishedRoot.memoizedState), null !== finishedRoot))
		    ) {
		      finishedRoot = finishedRoot.dehydrated;
		      try {
		        commitHydratedActivityInstance(finishedRoot);
		      } catch (error) {
		        captureCommitPhaseError(finishedWork, finishedWork.return, error);
		      }
		    }
		  }
		  function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
		    if (
		      supportsHydration &&
		      null === finishedWork.memoizedState &&
		      ((finishedRoot = finishedWork.alternate),
		      null !== finishedRoot &&
		        ((finishedRoot = finishedRoot.memoizedState),
		        null !== finishedRoot &&
		          ((finishedRoot = finishedRoot.dehydrated), null !== finishedRoot)))
		    )
		      try {
		        commitHydratedSuspenseInstance(finishedRoot);
		      } catch (error) {
		        captureCommitPhaseError(finishedWork, finishedWork.return, error);
		      }
		  }
		  function getRetryCache(finishedWork) {
		    switch (finishedWork.tag) {
		      case 31:
		      case 13:
		      case 19:
		        var retryCache = finishedWork.stateNode;
		        null === retryCache &&
		          (retryCache = finishedWork.stateNode = new PossiblyWeakSet());
		        return retryCache;
		      case 22:
		        return (
		          (finishedWork = finishedWork.stateNode),
		          (retryCache = finishedWork._retryCache),
		          null === retryCache &&
		            (retryCache = finishedWork._retryCache = new PossiblyWeakSet()),
		          retryCache
		        );
		      default:
		        throw Error(formatProdErrorMessage(435, finishedWork.tag));
		    }
		  }
		  function attachSuspenseRetryListeners(finishedWork, wakeables) {
		    var retryCache = getRetryCache(finishedWork);
		    wakeables.forEach(function (wakeable) {
		      if (!retryCache.has(wakeable)) {
		        retryCache.add(wakeable);
		        var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
		        wakeable.then(retry, retry);
		      }
		    });
		  }
		  function recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
		    var deletions = parentFiber.deletions;
		    if (null !== deletions)
		      for (var i = 0; i < deletions.length; i++) {
		        var childToDelete = deletions[i],
		          root = root$jscomp$0,
		          returnFiber = parentFiber;
		        if (supportsMutation) {
		          var parent = returnFiber;
		          a: for (; null !== parent; ) {
		            switch (parent.tag) {
		              case 27:
		                if (supportsSingletons) {
		                  if (isSingletonScope(parent.type)) {
		                    hostParent = parent.stateNode;
		                    hostParentIsContainer = false;
		                    break a;
		                  }
		                  break;
		                }
		              case 5:
		                hostParent = parent.stateNode;
		                hostParentIsContainer = false;
		                break a;
		              case 3:
		              case 4:
		                hostParent = parent.stateNode.containerInfo;
		                hostParentIsContainer = true;
		                break a;
		            }
		            parent = parent.return;
		          }
		          if (null === hostParent) throw Error(formatProdErrorMessage(160));
		          commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
		          hostParent = null;
		          hostParentIsContainer = false;
		        } else commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
		        root = childToDelete.alternate;
		        null !== root && (root.return = null);
		        childToDelete.return = null;
		      }
		    if (parentFiber.subtreeFlags & 13886)
		      for (parentFiber = parentFiber.child; null !== parentFiber; )
		        commitMutationEffectsOnFiber(parentFiber, root$jscomp$0),
		          (parentFiber = parentFiber.sibling);
		  }
		  function commitMutationEffectsOnFiber(finishedWork, root) {
		    var current = finishedWork.alternate,
		      flags = finishedWork.flags;
		    switch (finishedWork.tag) {
		      case 0:
		      case 11:
		      case 14:
		      case 15:
		        recursivelyTraverseMutationEffects(root, finishedWork);
		        commitReconciliationEffects(finishedWork);
		        flags & 4 &&
		          (commitHookEffectListUnmount(3, finishedWork, finishedWork.return),
		          commitHookEffectListMount(3, finishedWork),
		          commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
		        break;
		      case 1:
		        recursivelyTraverseMutationEffects(root, finishedWork);
		        commitReconciliationEffects(finishedWork);
		        flags & 512 &&
		          (offscreenSubtreeWasHidden ||
		            null === current ||
		            safelyDetachRef(current, current.return));
		        flags & 64 &&
		          offscreenSubtreeIsHidden &&
		          ((finishedWork = finishedWork.updateQueue),
		          null !== finishedWork &&
		            ((flags = finishedWork.callbacks),
		            null !== flags &&
		              ((current = finishedWork.shared.hiddenCallbacks),
		              (finishedWork.shared.hiddenCallbacks =
		                null === current ? flags : current.concat(flags)))));
		        break;
		      case 26:
		        if (supportsResources) {
		          var hoistableRoot = currentHoistableRoot;
		          recursivelyTraverseMutationEffects(root, finishedWork);
		          commitReconciliationEffects(finishedWork);
		          flags & 512 &&
		            (offscreenSubtreeWasHidden ||
		              null === current ||
		              safelyDetachRef(current, current.return));
		          if (flags & 4) {
		            flags = null !== current ? current.memoizedState : null;
		            var newResource = finishedWork.memoizedState;
		            null === current
		              ? null === newResource
		                ? null === finishedWork.stateNode
		                  ? (finishedWork.stateNode = hydrateHoistable(
		                      hoistableRoot,
		                      finishedWork.type,
		                      finishedWork.memoizedProps,
		                      finishedWork
		                    ))
		                  : mountHoistable(
		                      hoistableRoot,
		                      finishedWork.type,
		                      finishedWork.stateNode
		                    )
		                : (finishedWork.stateNode = acquireResource(
		                    hoistableRoot,
		                    newResource,
		                    finishedWork.memoizedProps
		                  ))
		              : flags !== newResource
		                ? (null === flags
		                    ? null !== current.stateNode &&
		                      unmountHoistable(current.stateNode)
		                    : releaseResource(flags),
		                  null === newResource
		                    ? mountHoistable(
		                        hoistableRoot,
		                        finishedWork.type,
		                        finishedWork.stateNode
		                      )
		                    : acquireResource(
		                        hoistableRoot,
		                        newResource,
		                        finishedWork.memoizedProps
		                      ))
		                : null === newResource &&
		                  null !== finishedWork.stateNode &&
		                  commitHostUpdate(
		                    finishedWork,
		                    finishedWork.memoizedProps,
		                    current.memoizedProps
		                  );
		          }
		          break;
		        }
		      case 27:
		        if (supportsSingletons) {
		          recursivelyTraverseMutationEffects(root, finishedWork);
		          commitReconciliationEffects(finishedWork);
		          flags & 512 &&
		            (offscreenSubtreeWasHidden ||
		              null === current ||
		              safelyDetachRef(current, current.return));
		          null !== current &&
		            flags & 4 &&
		            commitHostUpdate(
		              finishedWork,
		              finishedWork.memoizedProps,
		              current.memoizedProps
		            );
		          break;
		        }
		      case 5:
		        recursivelyTraverseMutationEffects(root, finishedWork);
		        commitReconciliationEffects(finishedWork);
		        flags & 512 &&
		          (offscreenSubtreeWasHidden ||
		            null === current ||
		            safelyDetachRef(current, current.return));
		        if (supportsMutation) {
		          if (finishedWork.flags & 32) {
		            hoistableRoot = finishedWork.stateNode;
		            try {
		              resetTextContent(hoistableRoot);
		            } catch (error) {
		              captureCommitPhaseError(finishedWork, finishedWork.return, error);
		            }
		          }
		          flags & 4 &&
		            null != finishedWork.stateNode &&
		            ((hoistableRoot = finishedWork.memoizedProps),
		            commitHostUpdate(
		              finishedWork,
		              hoistableRoot,
		              null !== current ? current.memoizedProps : hoistableRoot
		            ));
		          flags & 1024 && (needsFormReset = true);
		        } else
		          supportsPersistence &&
		            null !== finishedWork.alternate &&
		            (finishedWork.alternate.stateNode = finishedWork.stateNode);
		        break;
		      case 6:
		        recursivelyTraverseMutationEffects(root, finishedWork);
		        commitReconciliationEffects(finishedWork);
		        if (flags & 4 && supportsMutation) {
		          if (null === finishedWork.stateNode)
		            throw Error(formatProdErrorMessage(162));
		          flags = finishedWork.memoizedProps;
		          current = null !== current ? current.memoizedProps : flags;
		          hoistableRoot = finishedWork.stateNode;
		          try {
		            commitTextUpdate(hoistableRoot, current, flags);
		          } catch (error) {
		            captureCommitPhaseError(finishedWork, finishedWork.return, error);
		          }
		        }
		        break;
		      case 3:
		        supportsResources
		          ? (prepareToCommitHoistables(),
		            (hoistableRoot = currentHoistableRoot),
		            (currentHoistableRoot = getHoistableRoot(root.containerInfo)),
		            recursivelyTraverseMutationEffects(root, finishedWork),
		            (currentHoistableRoot = hoistableRoot))
		          : recursivelyTraverseMutationEffects(root, finishedWork);
		        commitReconciliationEffects(finishedWork);
		        if (flags & 4) {
		          if (
		            supportsMutation &&
		            supportsHydration &&
		            null !== current &&
		            current.memoizedState.isDehydrated
		          )
		            try {
		              commitHydratedContainer(root.containerInfo);
		            } catch (error) {
		              captureCommitPhaseError(finishedWork, finishedWork.return, error);
		            }
		          if (supportsPersistence) {
		            flags = root.containerInfo;
		            current = root.pendingChildren;
		            try {
		              replaceContainerChildren(flags, current);
		            } catch (error) {
		              captureCommitPhaseError(finishedWork, finishedWork.return, error);
		            }
		          }
		        }
		        needsFormReset &&
		          ((needsFormReset = false), recursivelyResetForms(finishedWork));
		        break;
		      case 4:
		        supportsResources
		          ? ((current = currentHoistableRoot),
		            (currentHoistableRoot = getHoistableRoot(
		              finishedWork.stateNode.containerInfo
		            )),
		            recursivelyTraverseMutationEffects(root, finishedWork),
		            commitReconciliationEffects(finishedWork),
		            (currentHoistableRoot = current))
		          : (recursivelyTraverseMutationEffects(root, finishedWork),
		            commitReconciliationEffects(finishedWork));
		        flags & 4 &&
		          supportsPersistence &&
		          commitHostPortalContainerChildren(
		            finishedWork.stateNode,
		            finishedWork,
		            finishedWork.stateNode.pendingChildren
		          );
		        break;
		      case 12:
		        recursivelyTraverseMutationEffects(root, finishedWork);
		        commitReconciliationEffects(finishedWork);
		        break;
		      case 31:
		        recursivelyTraverseMutationEffects(root, finishedWork);
		        commitReconciliationEffects(finishedWork);
		        flags & 4 &&
		          ((flags = finishedWork.updateQueue),
		          null !== flags &&
		            ((finishedWork.updateQueue = null),
		            attachSuspenseRetryListeners(finishedWork, flags)));
		        break;
		      case 13:
		        recursivelyTraverseMutationEffects(root, finishedWork);
		        commitReconciliationEffects(finishedWork);
		        finishedWork.child.flags & 8192 &&
		          (null !== finishedWork.memoizedState) !==
		            (null !== current && null !== current.memoizedState) &&
		          (globalMostRecentFallbackTime = now());
		        flags & 4 &&
		          ((flags = finishedWork.updateQueue),
		          null !== flags &&
		            ((finishedWork.updateQueue = null),
		            attachSuspenseRetryListeners(finishedWork, flags)));
		        break;
		      case 22:
		        hoistableRoot = null !== finishedWork.memoizedState;
		        var wasHidden = null !== current && null !== current.memoizedState,
		          prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden,
		          prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
		        offscreenSubtreeIsHidden =
		          prevOffscreenSubtreeIsHidden || hoistableRoot;
		        offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
		        recursivelyTraverseMutationEffects(root, finishedWork);
		        offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
		        offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
		        commitReconciliationEffects(finishedWork);
		        if (
		          flags & 8192 &&
		          ((root = finishedWork.stateNode),
		          (root._visibility = hoistableRoot
		            ? root._visibility & -2
		            : root._visibility | 1),
		          hoistableRoot &&
		            (null === current ||
		              wasHidden ||
		              offscreenSubtreeIsHidden ||
		              offscreenSubtreeWasHidden ||
		              recursivelyTraverseDisappearLayoutEffects(finishedWork)),
		          supportsMutation)
		        )
		          a: if (((current = null), supportsMutation))
		            for (root = finishedWork; ; ) {
		              if (5 === root.tag || (supportsResources && 26 === root.tag)) {
		                if (null === current) {
		                  wasHidden = current = root;
		                  try {
		                    (newResource = wasHidden.stateNode),
		                      hoistableRoot
		                        ? hideInstance(newResource)
		                        : unhideInstance(
		                            wasHidden.stateNode,
		                            wasHidden.memoizedProps
		                          );
		                  } catch (error) {
		                    captureCommitPhaseError(wasHidden, wasHidden.return, error);
		                  }
		                }
		              } else if (6 === root.tag) {
		                if (null === current) {
		                  wasHidden = root;
		                  try {
		                    var instance = wasHidden.stateNode;
		                    hoistableRoot
		                      ? hideTextInstance(instance)
		                      : unhideTextInstance(instance, wasHidden.memoizedProps);
		                  } catch (error) {
		                    captureCommitPhaseError(wasHidden, wasHidden.return, error);
		                  }
		                }
		              } else if (18 === root.tag) {
		                if (null === current) {
		                  wasHidden = root;
		                  try {
		                    var instance$jscomp$0 = wasHidden.stateNode;
		                    hoistableRoot
		                      ? hideDehydratedBoundary(instance$jscomp$0)
		                      : unhideDehydratedBoundary(wasHidden.stateNode);
		                  } catch (error) {
		                    captureCommitPhaseError(wasHidden, wasHidden.return, error);
		                  }
		                }
		              } else if (
		                ((22 !== root.tag && 23 !== root.tag) ||
		                  null === root.memoizedState ||
		                  root === finishedWork) &&
		                null !== root.child
		              ) {
		                root.child.return = root;
		                root = root.child;
		                continue;
		              }
		              if (root === finishedWork) break a;
		              for (; null === root.sibling; ) {
		                if (null === root.return || root.return === finishedWork)
		                  break a;
		                current === root && (current = null);
		                root = root.return;
		              }
		              current === root && (current = null);
		              root.sibling.return = root.return;
		              root = root.sibling;
		            }
		        flags & 4 &&
		          ((flags = finishedWork.updateQueue),
		          null !== flags &&
		            ((current = flags.retryQueue),
		            null !== current &&
		              ((flags.retryQueue = null),
		              attachSuspenseRetryListeners(finishedWork, current))));
		        break;
		      case 19:
		        recursivelyTraverseMutationEffects(root, finishedWork);
		        commitReconciliationEffects(finishedWork);
		        flags & 4 &&
		          ((flags = finishedWork.updateQueue),
		          null !== flags &&
		            ((finishedWork.updateQueue = null),
		            attachSuspenseRetryListeners(finishedWork, flags)));
		        break;
		      case 30:
		        break;
		      case 21:
		        break;
		      default:
		        recursivelyTraverseMutationEffects(root, finishedWork),
		          commitReconciliationEffects(finishedWork);
		    }
		  }
		  function commitReconciliationEffects(finishedWork) {
		    var flags = finishedWork.flags;
		    if (flags & 2) {
		      try {
		        for (
		          var hostParentFiber, parentFiber = finishedWork.return;
		          null !== parentFiber;

		        ) {
		          if (isHostParent(parentFiber)) {
		            hostParentFiber = parentFiber;
		            break;
		          }
		          parentFiber = parentFiber.return;
		        }
		        if (supportsMutation) {
		          if (null == hostParentFiber) throw Error(formatProdErrorMessage(160));
		          switch (hostParentFiber.tag) {
		            case 27:
		              if (supportsSingletons) {
		                var parent = hostParentFiber.stateNode,
		                  before = getHostSibling(finishedWork);
		                insertOrAppendPlacementNode(finishedWork, before, parent);
		                break;
		              }
		            case 5:
		              var parent$125 = hostParentFiber.stateNode;
		              hostParentFiber.flags & 32 &&
		                (resetTextContent(parent$125), (hostParentFiber.flags &= -33));
		              var before$126 = getHostSibling(finishedWork);
		              insertOrAppendPlacementNode(finishedWork, before$126, parent$125);
		              break;
		            case 3:
		            case 4:
		              var parent$127 = hostParentFiber.stateNode.containerInfo,
		                before$128 = getHostSibling(finishedWork);
		              insertOrAppendPlacementNodeIntoContainer(
		                finishedWork,
		                before$128,
		                parent$127
		              );
		              break;
		            default:
		              throw Error(formatProdErrorMessage(161));
		          }
		        }
		      } catch (error) {
		        captureCommitPhaseError(finishedWork, finishedWork.return, error);
		      }
		      finishedWork.flags &= -3;
		    }
		    flags & 4096 && (finishedWork.flags &= -4097);
		  }
		  function recursivelyResetForms(parentFiber) {
		    if (parentFiber.subtreeFlags & 1024)
		      for (parentFiber = parentFiber.child; null !== parentFiber; ) {
		        var fiber = parentFiber;
		        recursivelyResetForms(fiber);
		        5 === fiber.tag &&
		          fiber.flags & 1024 &&
		          resetFormInstance(fiber.stateNode);
		        parentFiber = parentFiber.sibling;
		      }
		  }
		  function recursivelyTraverseLayoutEffects(root, parentFiber) {
		    if (parentFiber.subtreeFlags & 8772)
		      for (parentFiber = parentFiber.child; null !== parentFiber; )
		        commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber),
		          (parentFiber = parentFiber.sibling);
		  }
		  function recursivelyTraverseDisappearLayoutEffects(parentFiber) {
		    for (parentFiber = parentFiber.child; null !== parentFiber; ) {
		      var finishedWork = parentFiber;
		      switch (finishedWork.tag) {
		        case 0:
		        case 11:
		        case 14:
		        case 15:
		          commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
		          recursivelyTraverseDisappearLayoutEffects(finishedWork);
		          break;
		        case 1:
		          safelyDetachRef(finishedWork, finishedWork.return);
		          var instance = finishedWork.stateNode;
		          "function" === typeof instance.componentWillUnmount &&
		            safelyCallComponentWillUnmount(
		              finishedWork,
		              finishedWork.return,
		              instance
		            );
		          recursivelyTraverseDisappearLayoutEffects(finishedWork);
		          break;
		        case 27:
		          supportsSingletons &&
		            releaseSingletonInstance(finishedWork.stateNode);
		        case 26:
		        case 5:
		          safelyDetachRef(finishedWork, finishedWork.return);
		          recursivelyTraverseDisappearLayoutEffects(finishedWork);
		          break;
		        case 22:
		          null === finishedWork.memoizedState &&
		            recursivelyTraverseDisappearLayoutEffects(finishedWork);
		          break;
		        case 30:
		          recursivelyTraverseDisappearLayoutEffects(finishedWork);
		          break;
		        default:
		          recursivelyTraverseDisappearLayoutEffects(finishedWork);
		      }
		      parentFiber = parentFiber.sibling;
		    }
		  }
		  function recursivelyTraverseReappearLayoutEffects(
		    finishedRoot$jscomp$0,
		    parentFiber,
		    includeWorkInProgressEffects
		  ) {
		    includeWorkInProgressEffects =
		      includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
		    for (parentFiber = parentFiber.child; null !== parentFiber; ) {
		      var current = parentFiber.alternate,
		        finishedRoot = finishedRoot$jscomp$0,
		        finishedWork = parentFiber,
		        flags = finishedWork.flags;
		      switch (finishedWork.tag) {
		        case 0:
		        case 11:
		        case 15:
		          recursivelyTraverseReappearLayoutEffects(
		            finishedRoot,
		            finishedWork,
		            includeWorkInProgressEffects
		          );
		          commitHookEffectListMount(4, finishedWork);
		          break;
		        case 1:
		          recursivelyTraverseReappearLayoutEffects(
		            finishedRoot,
		            finishedWork,
		            includeWorkInProgressEffects
		          );
		          current = finishedWork;
		          finishedRoot = current.stateNode;
		          if ("function" === typeof finishedRoot.componentDidMount)
		            try {
		              finishedRoot.componentDidMount();
		            } catch (error) {
		              captureCommitPhaseError(current, current.return, error);
		            }
		          current = finishedWork;
		          finishedRoot = current.updateQueue;
		          if (null !== finishedRoot) {
		            var instance = current.stateNode;
		            try {
		              var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
		              if (null !== hiddenCallbacks)
		                for (
		                  finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0;
		                  finishedRoot < hiddenCallbacks.length;
		                  finishedRoot++
		                )
		                  callCallback(hiddenCallbacks[finishedRoot], instance);
		            } catch (error) {
		              captureCommitPhaseError(current, current.return, error);
		            }
		          }
		          includeWorkInProgressEffects &&
		            flags & 64 &&
		            commitClassCallbacks(finishedWork);
		          safelyAttachRef(finishedWork, finishedWork.return);
		          break;
		        case 27:
		          supportsSingletons && commitHostSingletonAcquisition(finishedWork);
		        case 26:
		        case 5:
		          recursivelyTraverseReappearLayoutEffects(
		            finishedRoot,
		            finishedWork,
		            includeWorkInProgressEffects
		          );
		          includeWorkInProgressEffects &&
		            null === current &&
		            flags & 4 &&
		            commitHostMount(finishedWork);
		          safelyAttachRef(finishedWork, finishedWork.return);
		          break;
		        case 12:
		          recursivelyTraverseReappearLayoutEffects(
		            finishedRoot,
		            finishedWork,
		            includeWorkInProgressEffects
		          );
		          break;
		        case 31:
		          recursivelyTraverseReappearLayoutEffects(
		            finishedRoot,
		            finishedWork,
		            includeWorkInProgressEffects
		          );
		          includeWorkInProgressEffects &&
		            flags & 4 &&
		            commitActivityHydrationCallbacks(finishedRoot, finishedWork);
		          break;
		        case 13:
		          recursivelyTraverseReappearLayoutEffects(
		            finishedRoot,
		            finishedWork,
		            includeWorkInProgressEffects
		          );
		          includeWorkInProgressEffects &&
		            flags & 4 &&
		            commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
		          break;
		        case 22:
		          null === finishedWork.memoizedState &&
		            recursivelyTraverseReappearLayoutEffects(
		              finishedRoot,
		              finishedWork,
		              includeWorkInProgressEffects
		            );
		          safelyAttachRef(finishedWork, finishedWork.return);
		          break;
		        case 30:
		          break;
		        default:
		          recursivelyTraverseReappearLayoutEffects(
		            finishedRoot,
		            finishedWork,
		            includeWorkInProgressEffects
		          );
		      }
		      parentFiber = parentFiber.sibling;
		    }
		  }
		  function commitOffscreenPassiveMountEffects(current, finishedWork) {
		    var previousCache = null;
		    null !== current &&
		      null !== current.memoizedState &&
		      null !== current.memoizedState.cachePool &&
		      (previousCache = current.memoizedState.cachePool.pool);
		    current = null;
		    null !== finishedWork.memoizedState &&
		      null !== finishedWork.memoizedState.cachePool &&
		      (current = finishedWork.memoizedState.cachePool.pool);
		    current !== previousCache &&
		      (null != current && current.refCount++,
		      null != previousCache && releaseCache(previousCache));
		  }
		  function commitCachePassiveMountEffect(current, finishedWork) {
		    current = null;
		    null !== finishedWork.alternate &&
		      (current = finishedWork.alternate.memoizedState.cache);
		    finishedWork = finishedWork.memoizedState.cache;
		    finishedWork !== current &&
		      (finishedWork.refCount++, null != current && releaseCache(current));
		  }
		  function recursivelyTraversePassiveMountEffects(
		    root,
		    parentFiber,
		    committedLanes,
		    committedTransitions
		  ) {
		    if (parentFiber.subtreeFlags & 10256)
		      for (parentFiber = parentFiber.child; null !== parentFiber; )
		        commitPassiveMountOnFiber(
		          root,
		          parentFiber,
		          committedLanes,
		          committedTransitions
		        ),
		          (parentFiber = parentFiber.sibling);
		  }
		  function commitPassiveMountOnFiber(
		    finishedRoot,
		    finishedWork,
		    committedLanes,
		    committedTransitions
		  ) {
		    var flags = finishedWork.flags;
		    switch (finishedWork.tag) {
		      case 0:
		      case 11:
		      case 15:
		        recursivelyTraversePassiveMountEffects(
		          finishedRoot,
		          finishedWork,
		          committedLanes,
		          committedTransitions
		        );
		        flags & 2048 && commitHookEffectListMount(9, finishedWork);
		        break;
		      case 1:
		        recursivelyTraversePassiveMountEffects(
		          finishedRoot,
		          finishedWork,
		          committedLanes,
		          committedTransitions
		        );
		        break;
		      case 3:
		        recursivelyTraversePassiveMountEffects(
		          finishedRoot,
		          finishedWork,
		          committedLanes,
		          committedTransitions
		        );
		        flags & 2048 &&
		          ((finishedRoot = null),
		          null !== finishedWork.alternate &&
		            (finishedRoot = finishedWork.alternate.memoizedState.cache),
		          (finishedWork = finishedWork.memoizedState.cache),
		          finishedWork !== finishedRoot &&
		            (finishedWork.refCount++,
		            null != finishedRoot && releaseCache(finishedRoot)));
		        break;
		      case 12:
		        if (flags & 2048) {
		          recursivelyTraversePassiveMountEffects(
		            finishedRoot,
		            finishedWork,
		            committedLanes,
		            committedTransitions
		          );
		          finishedRoot = finishedWork.stateNode;
		          try {
		            var _finishedWork$memoize2 = finishedWork.memoizedProps,
		              id = _finishedWork$memoize2.id,
		              onPostCommit = _finishedWork$memoize2.onPostCommit;
		            "function" === typeof onPostCommit &&
		              onPostCommit(
		                id,
		                null === finishedWork.alternate ? "mount" : "update",
		                finishedRoot.passiveEffectDuration,
		                -0
		              );
		          } catch (error) {
		            captureCommitPhaseError(finishedWork, finishedWork.return, error);
		          }
		        } else
		          recursivelyTraversePassiveMountEffects(
		            finishedRoot,
		            finishedWork,
		            committedLanes,
		            committedTransitions
		          );
		        break;
		      case 31:
		        recursivelyTraversePassiveMountEffects(
		          finishedRoot,
		          finishedWork,
		          committedLanes,
		          committedTransitions
		        );
		        break;
		      case 13:
		        recursivelyTraversePassiveMountEffects(
		          finishedRoot,
		          finishedWork,
		          committedLanes,
		          committedTransitions
		        );
		        break;
		      case 23:
		        break;
		      case 22:
		        _finishedWork$memoize2 = finishedWork.stateNode;
		        id = finishedWork.alternate;
		        null !== finishedWork.memoizedState
		          ? _finishedWork$memoize2._visibility & 2
		            ? recursivelyTraversePassiveMountEffects(
		                finishedRoot,
		                finishedWork,
		                committedLanes,
		                committedTransitions
		              )
		            : recursivelyTraverseAtomicPassiveEffects(
		                finishedRoot,
		                finishedWork
		              )
		          : _finishedWork$memoize2._visibility & 2
		            ? recursivelyTraversePassiveMountEffects(
		                finishedRoot,
		                finishedWork,
		                committedLanes,
		                committedTransitions
		              )
		            : ((_finishedWork$memoize2._visibility |= 2),
		              recursivelyTraverseReconnectPassiveEffects(
		                finishedRoot,
		                finishedWork,
		                committedLanes,
		                committedTransitions,
		                0 !== (finishedWork.subtreeFlags & 10256) || false
		              ));
		        flags & 2048 && commitOffscreenPassiveMountEffects(id, finishedWork);
		        break;
		      case 24:
		        recursivelyTraversePassiveMountEffects(
		          finishedRoot,
		          finishedWork,
		          committedLanes,
		          committedTransitions
		        );
		        flags & 2048 &&
		          commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
		        break;
		      default:
		        recursivelyTraversePassiveMountEffects(
		          finishedRoot,
		          finishedWork,
		          committedLanes,
		          committedTransitions
		        );
		    }
		  }
		  function recursivelyTraverseReconnectPassiveEffects(
		    finishedRoot$jscomp$0,
		    parentFiber,
		    committedLanes$jscomp$0,
		    committedTransitions$jscomp$0,
		    includeWorkInProgressEffects
		  ) {
		    includeWorkInProgressEffects =
		      includeWorkInProgressEffects &&
		      (0 !== (parentFiber.subtreeFlags & 10256) || false);
		    for (parentFiber = parentFiber.child; null !== parentFiber; ) {
		      var finishedRoot = finishedRoot$jscomp$0,
		        finishedWork = parentFiber,
		        committedLanes = committedLanes$jscomp$0,
		        committedTransitions = committedTransitions$jscomp$0,
		        flags = finishedWork.flags;
		      switch (finishedWork.tag) {
		        case 0:
		        case 11:
		        case 15:
		          recursivelyTraverseReconnectPassiveEffects(
		            finishedRoot,
		            finishedWork,
		            committedLanes,
		            committedTransitions,
		            includeWorkInProgressEffects
		          );
		          commitHookEffectListMount(8, finishedWork);
		          break;
		        case 23:
		          break;
		        case 22:
		          var instance = finishedWork.stateNode;
		          null !== finishedWork.memoizedState
		            ? instance._visibility & 2
		              ? recursivelyTraverseReconnectPassiveEffects(
		                  finishedRoot,
		                  finishedWork,
		                  committedLanes,
		                  committedTransitions,
		                  includeWorkInProgressEffects
		                )
		              : recursivelyTraverseAtomicPassiveEffects(
		                  finishedRoot,
		                  finishedWork
		                )
		            : ((instance._visibility |= 2),
		              recursivelyTraverseReconnectPassiveEffects(
		                finishedRoot,
		                finishedWork,
		                committedLanes,
		                committedTransitions,
		                includeWorkInProgressEffects
		              ));
		          includeWorkInProgressEffects &&
		            flags & 2048 &&
		            commitOffscreenPassiveMountEffects(
		              finishedWork.alternate,
		              finishedWork
		            );
		          break;
		        case 24:
		          recursivelyTraverseReconnectPassiveEffects(
		            finishedRoot,
		            finishedWork,
		            committedLanes,
		            committedTransitions,
		            includeWorkInProgressEffects
		          );
		          includeWorkInProgressEffects &&
		            flags & 2048 &&
		            commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
		          break;
		        default:
		          recursivelyTraverseReconnectPassiveEffects(
		            finishedRoot,
		            finishedWork,
		            committedLanes,
		            committedTransitions,
		            includeWorkInProgressEffects
		          );
		      }
		      parentFiber = parentFiber.sibling;
		    }
		  }
		  function recursivelyTraverseAtomicPassiveEffects(
		    finishedRoot$jscomp$0,
		    parentFiber
		  ) {
		    if (parentFiber.subtreeFlags & 10256)
		      for (parentFiber = parentFiber.child; null !== parentFiber; ) {
		        var finishedRoot = finishedRoot$jscomp$0,
		          finishedWork = parentFiber,
		          flags = finishedWork.flags;
		        switch (finishedWork.tag) {
		          case 22:
		            recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
		            flags & 2048 &&
		              commitOffscreenPassiveMountEffects(
		                finishedWork.alternate,
		                finishedWork
		              );
		            break;
		          case 24:
		            recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
		            flags & 2048 &&
		              commitCachePassiveMountEffect(
		                finishedWork.alternate,
		                finishedWork
		              );
		            break;
		          default:
		            recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
		        }
		        parentFiber = parentFiber.sibling;
		      }
		  }
		  function recursivelyAccumulateSuspenseyCommit(
		    parentFiber,
		    committedLanes,
		    suspendedState
		  ) {
		    if (parentFiber.subtreeFlags & suspenseyCommitFlag)
		      for (parentFiber = parentFiber.child; null !== parentFiber; )
		        accumulateSuspenseyCommitOnFiber(
		          parentFiber,
		          committedLanes,
		          suspendedState
		        ),
		          (parentFiber = parentFiber.sibling);
		  }
		  function accumulateSuspenseyCommitOnFiber(
		    fiber,
		    committedLanes,
		    suspendedState
		  ) {
		    switch (fiber.tag) {
		      case 26:
		        recursivelyAccumulateSuspenseyCommit(
		          fiber,
		          committedLanes,
		          suspendedState
		        );
		        if (fiber.flags & suspenseyCommitFlag)
		          if (null !== fiber.memoizedState)
		            suspendResource(
		              suspendedState,
		              currentHoistableRoot,
		              fiber.memoizedState,
		              fiber.memoizedProps
		            );
		          else {
		            var instance = fiber.stateNode,
		              type = fiber.type;
		            fiber = fiber.memoizedProps;
		            ((committedLanes & 335544128) === committedLanes ||
		              maySuspendCommitInSyncRender(type, fiber)) &&
		              suspendInstance(suspendedState, instance, type, fiber);
		          }
		        break;
		      case 5:
		        recursivelyAccumulateSuspenseyCommit(
		          fiber,
		          committedLanes,
		          suspendedState
		        );
		        fiber.flags & suspenseyCommitFlag &&
		          ((instance = fiber.stateNode),
		          (type = fiber.type),
		          (fiber = fiber.memoizedProps),
		          ((committedLanes & 335544128) === committedLanes ||
		            maySuspendCommitInSyncRender(type, fiber)) &&
		            suspendInstance(suspendedState, instance, type, fiber));
		        break;
		      case 3:
		      case 4:
		        supportsResources
		          ? ((instance = currentHoistableRoot),
		            (currentHoistableRoot = getHoistableRoot(
		              fiber.stateNode.containerInfo
		            )),
		            recursivelyAccumulateSuspenseyCommit(
		              fiber,
		              committedLanes,
		              suspendedState
		            ),
		            (currentHoistableRoot = instance))
		          : recursivelyAccumulateSuspenseyCommit(
		              fiber,
		              committedLanes,
		              suspendedState
		            );
		        break;
		      case 22:
		        null === fiber.memoizedState &&
		          ((instance = fiber.alternate),
		          null !== instance && null !== instance.memoizedState
		            ? ((instance = suspenseyCommitFlag),
		              (suspenseyCommitFlag = 16777216),
		              recursivelyAccumulateSuspenseyCommit(
		                fiber,
		                committedLanes,
		                suspendedState
		              ),
		              (suspenseyCommitFlag = instance))
		            : recursivelyAccumulateSuspenseyCommit(
		                fiber,
		                committedLanes,
		                suspendedState
		              ));
		        break;
		      default:
		        recursivelyAccumulateSuspenseyCommit(
		          fiber,
		          committedLanes,
		          suspendedState
		        );
		    }
		  }
		  function detachAlternateSiblings(parentFiber) {
		    var previousFiber = parentFiber.alternate;
		    if (
		      null !== previousFiber &&
		      ((parentFiber = previousFiber.child), null !== parentFiber)
		    ) {
		      previousFiber.child = null;
		      do
		        (previousFiber = parentFiber.sibling),
		          (parentFiber.sibling = null),
		          (parentFiber = previousFiber);
		      while (null !== parentFiber);
		    }
		  }
		  function recursivelyTraversePassiveUnmountEffects(parentFiber) {
		    var deletions = parentFiber.deletions;
		    if (0 !== (parentFiber.flags & 16)) {
		      if (null !== deletions)
		        for (var i = 0; i < deletions.length; i++) {
		          var childToDelete = deletions[i];
		          nextEffect = childToDelete;
		          commitPassiveUnmountEffectsInsideOfDeletedTree_begin(
		            childToDelete,
		            parentFiber
		          );
		        }
		      detachAlternateSiblings(parentFiber);
		    }
		    if (parentFiber.subtreeFlags & 10256)
		      for (parentFiber = parentFiber.child; null !== parentFiber; )
		        commitPassiveUnmountOnFiber(parentFiber),
		          (parentFiber = parentFiber.sibling);
		  }
		  function commitPassiveUnmountOnFiber(finishedWork) {
		    switch (finishedWork.tag) {
		      case 0:
		      case 11:
		      case 15:
		        recursivelyTraversePassiveUnmountEffects(finishedWork);
		        finishedWork.flags & 2048 &&
		          commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
		        break;
		      case 3:
		        recursivelyTraversePassiveUnmountEffects(finishedWork);
		        break;
		      case 12:
		        recursivelyTraversePassiveUnmountEffects(finishedWork);
		        break;
		      case 22:
		        var instance = finishedWork.stateNode;
		        null !== finishedWork.memoizedState &&
		        instance._visibility & 2 &&
		        (null === finishedWork.return || 13 !== finishedWork.return.tag)
		          ? ((instance._visibility &= -3),
		            recursivelyTraverseDisconnectPassiveEffects(finishedWork))
		          : recursivelyTraversePassiveUnmountEffects(finishedWork);
		        break;
		      default:
		        recursivelyTraversePassiveUnmountEffects(finishedWork);
		    }
		  }
		  function recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
		    var deletions = parentFiber.deletions;
		    if (0 !== (parentFiber.flags & 16)) {
		      if (null !== deletions)
		        for (var i = 0; i < deletions.length; i++) {
		          var childToDelete = deletions[i];
		          nextEffect = childToDelete;
		          commitPassiveUnmountEffectsInsideOfDeletedTree_begin(
		            childToDelete,
		            parentFiber
		          );
		        }
		      detachAlternateSiblings(parentFiber);
		    }
		    for (parentFiber = parentFiber.child; null !== parentFiber; ) {
		      deletions = parentFiber;
		      switch (deletions.tag) {
		        case 0:
		        case 11:
		        case 15:
		          commitHookEffectListUnmount(8, deletions, deletions.return);
		          recursivelyTraverseDisconnectPassiveEffects(deletions);
		          break;
		        case 22:
		          i = deletions.stateNode;
		          i._visibility & 2 &&
		            ((i._visibility &= -3),
		            recursivelyTraverseDisconnectPassiveEffects(deletions));
		          break;
		        default:
		          recursivelyTraverseDisconnectPassiveEffects(deletions);
		      }
		      parentFiber = parentFiber.sibling;
		    }
		  }
		  function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(
		    deletedSubtreeRoot,
		    nearestMountedAncestor
		  ) {
		    for (; null !== nextEffect; ) {
		      var fiber = nextEffect;
		      switch (fiber.tag) {
		        case 0:
		        case 11:
		        case 15:
		          commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
		          break;
		        case 23:
		        case 22:
		          if (
		            null !== fiber.memoizedState &&
		            null !== fiber.memoizedState.cachePool
		          ) {
		            var cache = fiber.memoizedState.cachePool.pool;
		            null != cache && cache.refCount++;
		          }
		          break;
		        case 24:
		          releaseCache(fiber.memoizedState.cache);
		      }
		      cache = fiber.child;
		      if (null !== cache) (cache.return = fiber), (nextEffect = cache);
		      else
		        a: for (fiber = deletedSubtreeRoot; null !== nextEffect; ) {
		          cache = nextEffect;
		          var sibling = cache.sibling,
		            returnFiber = cache.return;
		          detachFiberAfterEffects(cache);
		          if (cache === fiber) {
		            nextEffect = null;
		            break a;
		          }
		          if (null !== sibling) {
		            sibling.return = returnFiber;
		            nextEffect = sibling;
		            break a;
		          }
		          nextEffect = returnFiber;
		        }
		    }
		  }
		  function findFiberRootForHostRoot(hostRoot) {
		    var maybeFiber = getInstanceFromNode(hostRoot);
		    if (null != maybeFiber) {
		      if ("string" !== typeof maybeFiber.memoizedProps["data-testname"])
		        throw Error(formatProdErrorMessage(364));
		      return maybeFiber;
		    }
		    hostRoot = findFiberRoot(hostRoot);
		    if (null === hostRoot) throw Error(formatProdErrorMessage(362));
		    return hostRoot.stateNode.current;
		  }
		  function matchSelector(fiber$jscomp$0, selector) {
		    var tag = fiber$jscomp$0.tag;
		    switch (selector.$$typeof) {
		      case COMPONENT_TYPE:
		        if (fiber$jscomp$0.type === selector.value) return true;
		        break;
		      case HAS_PSEUDO_CLASS_TYPE:
		        a: {
		          selector = selector.value;
		          fiber$jscomp$0 = [fiber$jscomp$0, 0];
		          for (tag = 0; tag < fiber$jscomp$0.length; ) {
		            var fiber = fiber$jscomp$0[tag++],
		              tag$jscomp$0 = fiber.tag,
		              selectorIndex = fiber$jscomp$0[tag++],
		              selector$jscomp$0 = selector[selectorIndex];
		            if (
		              (5 !== tag$jscomp$0 &&
		                26 !== tag$jscomp$0 &&
		                27 !== tag$jscomp$0) ||
		              !isHiddenSubtree(fiber)
		            ) {
		              for (
		                ;
		                null != selector$jscomp$0 &&
		                matchSelector(fiber, selector$jscomp$0);

		              )
		                selectorIndex++, (selector$jscomp$0 = selector[selectorIndex]);
		              if (selectorIndex === selector.length) {
		                selector = true;
		                break a;
		              } else
		                for (fiber = fiber.child; null !== fiber; )
		                  fiber$jscomp$0.push(fiber, selectorIndex),
		                    (fiber = fiber.sibling);
		            }
		          }
		          selector = false;
		        }
		        return selector;
		      case ROLE_TYPE:
		        if (
		          (5 === tag || 26 === tag || 27 === tag) &&
		          matchAccessibilityRole(fiber$jscomp$0.stateNode, selector.value)
		        )
		          return true;
		        break;
		      case TEXT_TYPE:
		        if (5 === tag || 6 === tag || 26 === tag || 27 === tag)
		          if (
		            ((fiber$jscomp$0 = getTextContent(fiber$jscomp$0)),
		            null !== fiber$jscomp$0 &&
		              0 <= fiber$jscomp$0.indexOf(selector.value))
		          )
		            return true;
		        break;
		      case TEST_NAME_TYPE:
		        if (5 === tag || 26 === tag || 27 === tag)
		          if (
		            ((fiber$jscomp$0 = fiber$jscomp$0.memoizedProps["data-testname"]),
		            "string" === typeof fiber$jscomp$0 &&
		              fiber$jscomp$0.toLowerCase() === selector.value.toLowerCase())
		          )
		            return true;
		        break;
		      default:
		        throw Error(formatProdErrorMessage(365));
		    }
		    return false;
		  }
		  function selectorToString(selector) {
		    switch (selector.$$typeof) {
		      case COMPONENT_TYPE:
		        return (
		          "<" + (getComponentNameFromType(selector.value) || "Unknown") + ">"
		        );
		      case HAS_PSEUDO_CLASS_TYPE:
		        return ":has(" + (selectorToString(selector) || "") + ")";
		      case ROLE_TYPE:
		        return '[role="' + selector.value + '"]';
		      case TEXT_TYPE:
		        return '"' + selector.value + '"';
		      case TEST_NAME_TYPE:
		        return '[data-testname="' + selector.value + '"]';
		      default:
		        throw Error(formatProdErrorMessage(365));
		    }
		  }
		  function findPaths(root, selectors) {
		    var matchingFibers = [];
		    root = [root, 0];
		    for (var index = 0; index < root.length; ) {
		      var fiber = root[index++],
		        tag = fiber.tag,
		        selectorIndex = root[index++],
		        selector = selectors[selectorIndex];
		      if ((5 !== tag && 26 !== tag && 27 !== tag) || !isHiddenSubtree(fiber)) {
		        for (; null != selector && matchSelector(fiber, selector); )
		          selectorIndex++, (selector = selectors[selectorIndex]);
		        if (selectorIndex === selectors.length) matchingFibers.push(fiber);
		        else
		          for (fiber = fiber.child; null !== fiber; )
		            root.push(fiber, selectorIndex), (fiber = fiber.sibling);
		      }
		    }
		    return matchingFibers;
		  }
		  function findAllNodes(hostRoot, selectors) {
		    if (!supportsTestSelectors) throw Error(formatProdErrorMessage(363));
		    hostRoot = findFiberRootForHostRoot(hostRoot);
		    hostRoot = findPaths(hostRoot, selectors);
		    selectors = [];
		    hostRoot = Array.from(hostRoot);
		    for (var index = 0; index < hostRoot.length; ) {
		      var node = hostRoot[index++],
		        tag = node.tag;
		      if (5 === tag || 26 === tag || 27 === tag)
		        isHiddenSubtree(node) || selectors.push(node.stateNode);
		      else
		        for (node = node.child; null !== node; )
		          hostRoot.push(node), (node = node.sibling);
		    }
		    return selectors;
		  }
		  function requestUpdateLane() {
		    return 0 !== (executionContext & 2) && 0 !== workInProgressRootRenderLanes
		      ? workInProgressRootRenderLanes & -workInProgressRootRenderLanes
		      : null !== ReactSharedInternals.T
		        ? requestTransitionLane()
		        : resolveUpdatePriority();
		  }
		  function requestDeferredLane() {
		    if (0 === workInProgressDeferredLane)
		      if (0 === (workInProgressRootRenderLanes & 536870912) || isHydrating) {
		        var lane = nextTransitionDeferredLane;
		        nextTransitionDeferredLane <<= 1;
		        0 === (nextTransitionDeferredLane & 3932160) &&
		          (nextTransitionDeferredLane = 262144);
		        workInProgressDeferredLane = lane;
		      } else workInProgressDeferredLane = 536870912;
		    lane = suspenseHandlerStackCursor.current;
		    null !== lane && (lane.flags |= 32);
		    return workInProgressDeferredLane;
		  }
		  function scheduleUpdateOnFiber(root, fiber, lane) {
		    if (
		      (root === workInProgressRoot &&
		        (2 === workInProgressSuspendedReason ||
		          9 === workInProgressSuspendedReason)) ||
		      null !== root.cancelPendingCommit
		    )
		      prepareFreshStack(root, 0),
		        markRootSuspended(
		          root,
		          workInProgressRootRenderLanes,
		          workInProgressDeferredLane,
		          false
		        );
		    markRootUpdated$1(root, lane);
		    if (0 === (executionContext & 2) || root !== workInProgressRoot)
		      root === workInProgressRoot &&
		        (0 === (executionContext & 2) &&
		          (workInProgressRootInterleavedUpdatedLanes |= lane),
		        4 === workInProgressRootExitStatus &&
		          markRootSuspended(
		            root,
		            workInProgressRootRenderLanes,
		            workInProgressDeferredLane,
		            false
		          )),
		        ensureRootIsScheduled(root);
		  }
		  function performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
		    if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(327));
		    var shouldTimeSlice =
		        (!forceSync &&
		          0 === (lanes & 127) &&
		          0 === (lanes & root$jscomp$0.expiredLanes)) ||
		        checkIfRootIsPrerendering(root$jscomp$0, lanes),
		      exitStatus = shouldTimeSlice
		        ? renderRootConcurrent(root$jscomp$0, lanes)
		        : renderRootSync(root$jscomp$0, lanes, true),
		      renderWasConcurrent = shouldTimeSlice;
		    do {
		      if (0 === exitStatus) {
		        workInProgressRootIsPrerendering &&
		          !shouldTimeSlice &&
		          markRootSuspended(root$jscomp$0, lanes, 0, false);
		        break;
		      } else {
		        forceSync = root$jscomp$0.current.alternate;
		        if (
		          renderWasConcurrent &&
		          !isRenderConsistentWithExternalStores(forceSync)
		        ) {
		          exitStatus = renderRootSync(root$jscomp$0, lanes, false);
		          renderWasConcurrent = false;
		          continue;
		        }
		        if (2 === exitStatus) {
		          renderWasConcurrent = lanes;
		          if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent)
		            var JSCompiler_inline_result = 0;
		          else
		            (JSCompiler_inline_result =
		              root$jscomp$0.pendingLanes & -536870913),
		              (JSCompiler_inline_result =
		                0 !== JSCompiler_inline_result
		                  ? JSCompiler_inline_result
		                  : JSCompiler_inline_result & 536870912
		                    ? 536870912
		                    : 0);
		          if (0 !== JSCompiler_inline_result) {
		            lanes = JSCompiler_inline_result;
		            a: {
		              var root = root$jscomp$0;
		              exitStatus = workInProgressRootConcurrentErrors;
		              var wasRootDehydrated =
		                supportsHydration && root.current.memoizedState.isDehydrated;
		              wasRootDehydrated &&
		                (prepareFreshStack(root, JSCompiler_inline_result).flags |=
		                  256);
		              JSCompiler_inline_result = renderRootSync(
		                root,
		                JSCompiler_inline_result,
		                false
		              );
		              if (2 !== JSCompiler_inline_result) {
		                if (
		                  workInProgressRootDidAttachPingListener &&
		                  !wasRootDehydrated
		                ) {
		                  root.errorRecoveryDisabledLanes |= renderWasConcurrent;
		                  workInProgressRootInterleavedUpdatedLanes |=
		                    renderWasConcurrent;
		                  exitStatus = 4;
		                  break a;
		                }
		                renderWasConcurrent = workInProgressRootRecoverableErrors;
		                workInProgressRootRecoverableErrors = exitStatus;
		                null !== renderWasConcurrent &&
		                  (null === workInProgressRootRecoverableErrors
		                    ? (workInProgressRootRecoverableErrors =
		                        renderWasConcurrent)
		                    : workInProgressRootRecoverableErrors.push.apply(
		                        workInProgressRootRecoverableErrors,
		                        renderWasConcurrent
		                      ));
		              }
		              exitStatus = JSCompiler_inline_result;
		            }
		            renderWasConcurrent = false;
		            if (2 !== exitStatus) continue;
		          }
		        }
		        if (1 === exitStatus) {
		          prepareFreshStack(root$jscomp$0, 0);
		          markRootSuspended(root$jscomp$0, lanes, 0, true);
		          break;
		        }
		        a: {
		          shouldTimeSlice = root$jscomp$0;
		          renderWasConcurrent = exitStatus;
		          switch (renderWasConcurrent) {
		            case 0:
		            case 1:
		              throw Error(formatProdErrorMessage(345));
		            case 4:
		              if ((lanes & 4194048) !== lanes) break;
		            case 6:
		              markRootSuspended(
		                shouldTimeSlice,
		                lanes,
		                workInProgressDeferredLane,
		                !workInProgressRootDidSkipSuspendedSiblings
		              );
		              break a;
		            case 2:
		              workInProgressRootRecoverableErrors = null;
		              break;
		            case 3:
		            case 5:
		              break;
		            default:
		              throw Error(formatProdErrorMessage(329));
		          }
		          if (
		            (lanes & 62914560) === lanes &&
		            ((exitStatus = globalMostRecentFallbackTime + 300 - now()),
		            10 < exitStatus)
		          ) {
		            markRootSuspended(
		              shouldTimeSlice,
		              lanes,
		              workInProgressDeferredLane,
		              !workInProgressRootDidSkipSuspendedSiblings
		            );
		            if (0 !== getNextLanes(shouldTimeSlice, 0, true)) break a;
		            pendingEffectsLanes = lanes;
		            shouldTimeSlice.timeoutHandle = scheduleTimeout(
		              commitRootWhenReady.bind(
		                null,
		                shouldTimeSlice,
		                forceSync,
		                workInProgressRootRecoverableErrors,
		                workInProgressTransitions,
		                workInProgressRootDidIncludeRecursiveRenderUpdate,
		                lanes,
		                workInProgressDeferredLane,
		                workInProgressRootInterleavedUpdatedLanes,
		                workInProgressSuspendedRetryLanes,
		                workInProgressRootDidSkipSuspendedSiblings,
		                renderWasConcurrent,
		                "Throttled",
		                -0,
		                0
		              ),
		              exitStatus
		            );
		            break a;
		          }
		          commitRootWhenReady(
		            shouldTimeSlice,
		            forceSync,
		            workInProgressRootRecoverableErrors,
		            workInProgressTransitions,
		            workInProgressRootDidIncludeRecursiveRenderUpdate,
		            lanes,
		            workInProgressDeferredLane,
		            workInProgressRootInterleavedUpdatedLanes,
		            workInProgressSuspendedRetryLanes,
		            workInProgressRootDidSkipSuspendedSiblings,
		            renderWasConcurrent,
		            null,
		            -0,
		            0
		          );
		        }
		      }
		      break;
		    } while (1);
		    ensureRootIsScheduled(root$jscomp$0);
		  }
		  function commitRootWhenReady(
		    root,
		    finishedWork,
		    recoverableErrors,
		    transitions,
		    didIncludeRenderPhaseUpdate,
		    lanes,
		    spawnedLane,
		    updatedLanes,
		    suspendedRetryLanes,
		    didSkipSuspendedSiblings,
		    exitStatus,
		    suspendedCommitReason,
		    completedRenderStartTime,
		    completedRenderEndTime
		  ) {
		    root.timeoutHandle = noTimeout;
		    suspendedCommitReason = finishedWork.subtreeFlags;
		    if (
		      suspendedCommitReason & 8192 ||
		      16785408 === (suspendedCommitReason & 16785408)
		    ) {
		      suspendedCommitReason = startSuspendingCommit();
		      accumulateSuspenseyCommitOnFiber(
		        finishedWork,
		        lanes,
		        suspendedCommitReason
		      );
		      var timeoutOffset =
		        (lanes & 62914560) === lanes
		          ? globalMostRecentFallbackTime - now()
		          : (lanes & 4194048) === lanes
		            ? globalMostRecentTransitionTime - now()
		            : 0;
		      timeoutOffset = waitForCommitToBeReady(
		        suspendedCommitReason,
		        timeoutOffset
		      );
		      if (null !== timeoutOffset) {
		        pendingEffectsLanes = lanes;
		        root.cancelPendingCommit = timeoutOffset(
		          commitRoot.bind(
		            null,
		            root,
		            finishedWork,
		            lanes,
		            recoverableErrors,
		            transitions,
		            didIncludeRenderPhaseUpdate,
		            spawnedLane,
		            updatedLanes,
		            suspendedRetryLanes,
		            exitStatus,
		            suspendedCommitReason,
		            null,
		            completedRenderStartTime,
		            completedRenderEndTime
		          )
		        );
		        markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
		        return;
		      }
		    }
		    commitRoot(
		      root,
		      finishedWork,
		      lanes,
		      recoverableErrors,
		      transitions,
		      didIncludeRenderPhaseUpdate,
		      spawnedLane,
		      updatedLanes,
		      suspendedRetryLanes
		    );
		  }
		  function isRenderConsistentWithExternalStores(finishedWork) {
		    for (var node = finishedWork; ; ) {
		      var tag = node.tag;
		      if (
		        (0 === tag || 11 === tag || 15 === tag) &&
		        node.flags & 16384 &&
		        ((tag = node.updateQueue),
		        null !== tag && ((tag = tag.stores), null !== tag))
		      )
		        for (var i = 0; i < tag.length; i++) {
		          var check = tag[i],
		            getSnapshot = check.getSnapshot;
		          check = check.value;
		          try {
		            if (!objectIs(getSnapshot(), check)) return !1;
		          } catch (error) {
		            return false;
		          }
		        }
		      tag = node.child;
		      if (node.subtreeFlags & 16384 && null !== tag)
		        (tag.return = node), (node = tag);
		      else {
		        if (node === finishedWork) break;
		        for (; null === node.sibling; ) {
		          if (null === node.return || node.return === finishedWork) return true;
		          node = node.return;
		        }
		        node.sibling.return = node.return;
		        node = node.sibling;
		      }
		    }
		    return true;
		  }
		  function markRootSuspended(
		    root,
		    suspendedLanes,
		    spawnedLane,
		    didAttemptEntireTree
		  ) {
		    suspendedLanes &= ~workInProgressRootPingedLanes;
		    suspendedLanes &= ~workInProgressRootInterleavedUpdatedLanes;
		    root.suspendedLanes |= suspendedLanes;
		    root.pingedLanes &= ~suspendedLanes;
		    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
		    didAttemptEntireTree = root.expirationTimes;
		    for (var lanes = suspendedLanes; 0 < lanes; ) {
		      var index$4 = 31 - clz32(lanes),
		        lane = 1 << index$4;
		      didAttemptEntireTree[index$4] = -1;
		      lanes &= ~lane;
		    }
		    0 !== spawnedLane &&
		      markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
		  }
		  function flushSyncWork() {
		    return 0 === (executionContext & 6)
		      ? (flushSyncWorkAcrossRoots_impl(0), false)
		      : true;
		  }
		  function resetWorkInProgressStack() {
		    if (null !== workInProgress) {
		      if (0 === workInProgressSuspendedReason)
		        var interruptedWork = workInProgress.return;
		      else
		        (interruptedWork = workInProgress),
		          (lastContextDependency = currentlyRenderingFiber$1 = null),
		          resetHooksOnUnwind(interruptedWork),
		          (thenableState$1 = null),
		          (thenableIndexCounter$1 = 0),
		          (interruptedWork = workInProgress);
		      for (; null !== interruptedWork; )
		        unwindInterruptedWork(interruptedWork.alternate, interruptedWork),
		          (interruptedWork = interruptedWork.return);
		      workInProgress = null;
		    }
		  }
		  function prepareFreshStack(root, lanes) {
		    var timeoutHandle = root.timeoutHandle;
		    timeoutHandle !== noTimeout &&
		      ((root.timeoutHandle = noTimeout), cancelTimeout(timeoutHandle));
		    timeoutHandle = root.cancelPendingCommit;
		    null !== timeoutHandle &&
		      ((root.cancelPendingCommit = null), timeoutHandle());
		    pendingEffectsLanes = 0;
		    resetWorkInProgressStack();
		    workInProgressRoot = root;
		    workInProgress = timeoutHandle = createWorkInProgress(root.current, null);
		    workInProgressRootRenderLanes = lanes;
		    workInProgressSuspendedReason = 0;
		    workInProgressThrownValue = null;
		    workInProgressRootDidSkipSuspendedSiblings = false;
		    workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
		    workInProgressRootDidAttachPingListener = false;
		    workInProgressSuspendedRetryLanes =
		      workInProgressDeferredLane =
		      workInProgressRootPingedLanes =
		      workInProgressRootInterleavedUpdatedLanes =
		      workInProgressRootSkippedLanes =
		      workInProgressRootExitStatus =
		        0;
		    workInProgressRootRecoverableErrors = workInProgressRootConcurrentErrors =
		      null;
		    workInProgressRootDidIncludeRecursiveRenderUpdate = false;
		    0 !== (lanes & 8) && (lanes |= lanes & 32);
		    var allEntangledLanes = root.entangledLanes;
		    if (0 !== allEntangledLanes)
		      for (
		        root = root.entanglements, allEntangledLanes &= lanes;
		        0 < allEntangledLanes;

		      ) {
		        var index$2 = 31 - clz32(allEntangledLanes),
		          lane = 1 << index$2;
		        lanes |= root[index$2];
		        allEntangledLanes &= ~lane;
		      }
		    entangledRenderLanes = lanes;
		    finishQueueingConcurrentUpdates();
		    return timeoutHandle;
		  }
		  function handleThrow(root, thrownValue) {
		    currentlyRenderingFiber = null;
		    ReactSharedInternals.H = ContextOnlyDispatcher;
		    thrownValue === SuspenseException || thrownValue === SuspenseActionException
		      ? ((thrownValue = getSuspendedThenable()),
		        (workInProgressSuspendedReason = 3))
		      : thrownValue === SuspenseyCommitException
		        ? ((thrownValue = getSuspendedThenable()),
		          (workInProgressSuspendedReason = 4))
		        : (workInProgressSuspendedReason =
		            thrownValue === SelectiveHydrationException
		              ? 8
		              : null !== thrownValue &&
		                  "object" === typeof thrownValue &&
		                  "function" === typeof thrownValue.then
		                ? 6
		                : 1);
		    workInProgressThrownValue = thrownValue;
		    null === workInProgress &&
		      ((workInProgressRootExitStatus = 1),
		      logUncaughtError(
		        root,
		        createCapturedValueAtFiber(thrownValue, root.current)
		      ));
		  }
		  function shouldRemainOnPreviousScreen() {
		    var handler = suspenseHandlerStackCursor.current;
		    return null === handler
		      ? true
		      : (workInProgressRootRenderLanes & 4194048) ===
		          workInProgressRootRenderLanes
		        ? null === shellBoundary
		          ? true
		          : false
		        : (workInProgressRootRenderLanes & 62914560) ===
		              workInProgressRootRenderLanes ||
		            0 !== (workInProgressRootRenderLanes & 536870912)
		          ? handler === shellBoundary
		          : false;
		  }
		  function pushDispatcher() {
		    var prevDispatcher = ReactSharedInternals.H;
		    ReactSharedInternals.H = ContextOnlyDispatcher;
		    return null === prevDispatcher ? ContextOnlyDispatcher : prevDispatcher;
		  }
		  function pushAsyncDispatcher() {
		    var prevAsyncDispatcher = ReactSharedInternals.A;
		    ReactSharedInternals.A = DefaultAsyncDispatcher;
		    return prevAsyncDispatcher;
		  }
		  function renderDidSuspendDelayIfPossible() {
		    workInProgressRootExitStatus = 4;
		    workInProgressRootDidSkipSuspendedSiblings ||
		      ((workInProgressRootRenderLanes & 4194048) !==
		        workInProgressRootRenderLanes &&
		        null !== suspenseHandlerStackCursor.current) ||
		      (workInProgressRootIsPrerendering = true);
		    (0 === (workInProgressRootSkippedLanes & 134217727) &&
		      0 === (workInProgressRootInterleavedUpdatedLanes & 134217727)) ||
		      null === workInProgressRoot ||
		      markRootSuspended(
		        workInProgressRoot,
		        workInProgressRootRenderLanes,
		        workInProgressDeferredLane,
		        false
		      );
		  }
		  function renderRootSync(root, lanes, shouldYieldForPrerendering) {
		    var prevExecutionContext = executionContext;
		    executionContext |= 2;
		    var prevDispatcher = pushDispatcher(),
		      prevAsyncDispatcher = pushAsyncDispatcher();
		    if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes)
		      (workInProgressTransitions = null), prepareFreshStack(root, lanes);
		    lanes = false;
		    var exitStatus = workInProgressRootExitStatus;
		    a: do
		      try {
		        if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
		          var unitOfWork = workInProgress,
		            thrownValue = workInProgressThrownValue;
		          switch (workInProgressSuspendedReason) {
		            case 8:
		              resetWorkInProgressStack();
		              exitStatus = 6;
		              break a;
		            case 3:
		            case 2:
		            case 9:
		            case 6:
		              null === suspenseHandlerStackCursor.current && (lanes = !0);
		              var reason = workInProgressSuspendedReason;
		              workInProgressSuspendedReason = 0;
		              workInProgressThrownValue = null;
		              throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
		              if (
		                shouldYieldForPrerendering &&
		                workInProgressRootIsPrerendering
		              ) {
		                exitStatus = 0;
		                break a;
		              }
		              break;
		            default:
		              (reason = workInProgressSuspendedReason),
		                (workInProgressSuspendedReason = 0),
		                (workInProgressThrownValue = null),
		                throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
		          }
		        }
		        workLoopSync();
		        exitStatus = workInProgressRootExitStatus;
		        break;
		      } catch (thrownValue$152) {
		        handleThrow(root, thrownValue$152);
		      }
		    while (1);
		    lanes && root.shellSuspendCounter++;
		    lastContextDependency = currentlyRenderingFiber$1 = null;
		    executionContext = prevExecutionContext;
		    ReactSharedInternals.H = prevDispatcher;
		    ReactSharedInternals.A = prevAsyncDispatcher;
		    null === workInProgress &&
		      ((workInProgressRoot = null),
		      (workInProgressRootRenderLanes = 0),
		      finishQueueingConcurrentUpdates());
		    return exitStatus;
		  }
		  function workLoopSync() {
		    for (; null !== workInProgress; ) performUnitOfWork(workInProgress);
		  }
		  function renderRootConcurrent(root, lanes) {
		    var prevExecutionContext = executionContext;
		    executionContext |= 2;
		    var prevDispatcher = pushDispatcher(),
		      prevAsyncDispatcher = pushAsyncDispatcher();
		    workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes
		      ? ((workInProgressTransitions = null),
		        (workInProgressRootRenderTargetTime = now() + 500),
		        prepareFreshStack(root, lanes))
		      : (workInProgressRootIsPrerendering = checkIfRootIsPrerendering(
		          root,
		          lanes
		        ));
		    a: do
		      try {
		        if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
		          lanes = workInProgress;
		          var thrownValue = workInProgressThrownValue;
		          b: switch (workInProgressSuspendedReason) {
		            case 1:
		              workInProgressSuspendedReason = 0;
		              workInProgressThrownValue = null;
		              throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
		              break;
		            case 2:
		            case 9:
		              if (isThenableResolved(thrownValue)) {
		                workInProgressSuspendedReason = 0;
		                workInProgressThrownValue = null;
		                replaySuspendedUnitOfWork(lanes);
		                break;
		              }
		              lanes = function () {
		                (2 !== workInProgressSuspendedReason &&
		                  9 !== workInProgressSuspendedReason) ||
		                  workInProgressRoot !== root ||
		                  (workInProgressSuspendedReason = 7);
		                ensureRootIsScheduled(root);
		              };
		              thrownValue.then(lanes, lanes);
		              break a;
		            case 3:
		              workInProgressSuspendedReason = 7;
		              break a;
		            case 4:
		              workInProgressSuspendedReason = 5;
		              break a;
		            case 7:
		              isThenableResolved(thrownValue)
		                ? ((workInProgressSuspendedReason = 0),
		                  (workInProgressThrownValue = null),
		                  replaySuspendedUnitOfWork(lanes))
		                : ((workInProgressSuspendedReason = 0),
		                  (workInProgressThrownValue = null),
		                  throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
		              break;
		            case 5:
		              var resource = null;
		              switch (workInProgress.tag) {
		                case 26:
		                  resource = workInProgress.memoizedState;
		                case 5:
		                case 27:
		                  var hostFiber = workInProgress,
		                    type = hostFiber.type,
		                    props = hostFiber.pendingProps;
		                  if (
		                    resource
		                      ? preloadResource(resource)
		                      : preloadInstance(hostFiber.stateNode, type, props)
		                  ) {
		                    workInProgressSuspendedReason = 0;
		                    workInProgressThrownValue = null;
		                    var sibling = hostFiber.sibling;
		                    if (null !== sibling) workInProgress = sibling;
		                    else {
		                      var returnFiber = hostFiber.return;
		                      null !== returnFiber
		                        ? ((workInProgress = returnFiber),
		                          completeUnitOfWork(returnFiber))
		                        : (workInProgress = null);
		                    }
		                    break b;
		                  }
		              }
		              workInProgressSuspendedReason = 0;
		              workInProgressThrownValue = null;
		              throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
		              break;
		            case 6:
		              workInProgressSuspendedReason = 0;
		              workInProgressThrownValue = null;
		              throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
		              break;
		            case 8:
		              resetWorkInProgressStack();
		              workInProgressRootExitStatus = 6;
		              break a;
		            default:
		              throw Error(formatProdErrorMessage(462));
		          }
		        }
		        workLoopConcurrentByScheduler();
		        break;
		      } catch (thrownValue$154) {
		        handleThrow(root, thrownValue$154);
		      }
		    while (1);
		    lastContextDependency = currentlyRenderingFiber$1 = null;
		    ReactSharedInternals.H = prevDispatcher;
		    ReactSharedInternals.A = prevAsyncDispatcher;
		    executionContext = prevExecutionContext;
		    if (null !== workInProgress) return 0;
		    workInProgressRoot = null;
		    workInProgressRootRenderLanes = 0;
		    finishQueueingConcurrentUpdates();
		    return workInProgressRootExitStatus;
		  }
		  function workLoopConcurrentByScheduler() {
		    for (; null !== workInProgress && !shouldYield(); )
		      performUnitOfWork(workInProgress);
		  }
		  function performUnitOfWork(unitOfWork) {
		    var next = beginWork(
		      unitOfWork.alternate,
		      unitOfWork,
		      entangledRenderLanes
		    );
		    unitOfWork.memoizedProps = unitOfWork.pendingProps;
		    null === next ? completeUnitOfWork(unitOfWork) : (workInProgress = next);
		  }
		  function replaySuspendedUnitOfWork(unitOfWork) {
		    var next = unitOfWork;
		    var current = next.alternate;
		    switch (next.tag) {
		      case 15:
		      case 0:
		        next = replayFunctionComponent(
		          current,
		          next,
		          next.pendingProps,
		          next.type,
		          void 0,
		          workInProgressRootRenderLanes
		        );
		        break;
		      case 11:
		        next = replayFunctionComponent(
		          current,
		          next,
		          next.pendingProps,
		          next.type.render,
		          next.ref,
		          workInProgressRootRenderLanes
		        );
		        break;
		      case 5:
		        resetHooksOnUnwind(next);
		      default:
		        unwindInterruptedWork(current, next),
		          (next = workInProgress =
		            resetWorkInProgress(next, entangledRenderLanes)),
		          (next = beginWork(current, next, entangledRenderLanes));
		    }
		    unitOfWork.memoizedProps = unitOfWork.pendingProps;
		    null === next ? completeUnitOfWork(unitOfWork) : (workInProgress = next);
		  }
		  function throwAndUnwindWorkLoop(
		    root,
		    unitOfWork,
		    thrownValue,
		    suspendedReason
		  ) {
		    lastContextDependency = currentlyRenderingFiber$1 = null;
		    resetHooksOnUnwind(unitOfWork);
		    thenableState$1 = null;
		    thenableIndexCounter$1 = 0;
		    var returnFiber = unitOfWork.return;
		    try {
		      if (
		        throwException(
		          root,
		          returnFiber,
		          unitOfWork,
		          thrownValue,
		          workInProgressRootRenderLanes
		        )
		      ) {
		        workInProgressRootExitStatus = 1;
		        logUncaughtError(
		          root,
		          createCapturedValueAtFiber(thrownValue, root.current)
		        );
		        workInProgress = null;
		        return;
		      }
		    } catch (error) {
		      if (null !== returnFiber) throw ((workInProgress = returnFiber), error);
		      workInProgressRootExitStatus = 1;
		      logUncaughtError(
		        root,
		        createCapturedValueAtFiber(thrownValue, root.current)
		      );
		      workInProgress = null;
		      return;
		    }
		    if (unitOfWork.flags & 32768) {
		      if (isHydrating || 1 === suspendedReason) root = true;
		      else if (
		        workInProgressRootIsPrerendering ||
		        0 !== (workInProgressRootRenderLanes & 536870912)
		      )
		        root = false;
		      else if (
		        ((workInProgressRootDidSkipSuspendedSiblings = root = true),
		        2 === suspendedReason ||
		          9 === suspendedReason ||
		          3 === suspendedReason ||
		          6 === suspendedReason)
		      )
		        (suspendedReason = suspenseHandlerStackCursor.current),
		          null !== suspendedReason &&
		            13 === suspendedReason.tag &&
		            (suspendedReason.flags |= 16384);
		      unwindUnitOfWork(unitOfWork, root);
		    } else completeUnitOfWork(unitOfWork);
		  }
		  function completeUnitOfWork(unitOfWork) {
		    var completedWork = unitOfWork;
		    do {
		      if (0 !== (completedWork.flags & 32768)) {
		        unwindUnitOfWork(
		          completedWork,
		          workInProgressRootDidSkipSuspendedSiblings
		        );
		        return;
		      }
		      unitOfWork = completedWork.return;
		      var next = completeWork(
		        completedWork.alternate,
		        completedWork,
		        entangledRenderLanes
		      );
		      if (null !== next) {
		        workInProgress = next;
		        return;
		      }
		      completedWork = completedWork.sibling;
		      if (null !== completedWork) {
		        workInProgress = completedWork;
		        return;
		      }
		      workInProgress = completedWork = unitOfWork;
		    } while (null !== completedWork);
		    0 === workInProgressRootExitStatus && (workInProgressRootExitStatus = 5);
		  }
		  function unwindUnitOfWork(unitOfWork, skipSiblings) {
		    do {
		      var next = unwindWork(unitOfWork.alternate, unitOfWork);
		      if (null !== next) {
		        next.flags &= 32767;
		        workInProgress = next;
		        return;
		      }
		      next = unitOfWork.return;
		      null !== next &&
		        ((next.flags |= 32768),
		        (next.subtreeFlags = 0),
		        (next.deletions = null));
		      if (
		        !skipSiblings &&
		        ((unitOfWork = unitOfWork.sibling), null !== unitOfWork)
		      ) {
		        workInProgress = unitOfWork;
		        return;
		      }
		      workInProgress = unitOfWork = next;
		    } while (null !== unitOfWork);
		    workInProgressRootExitStatus = 6;
		    workInProgress = null;
		  }
		  function commitRoot(
		    root,
		    finishedWork,
		    lanes,
		    recoverableErrors,
		    transitions,
		    didIncludeRenderPhaseUpdate,
		    spawnedLane,
		    updatedLanes,
		    suspendedRetryLanes
		  ) {
		    root.cancelPendingCommit = null;
		    do flushPendingEffects();
		    while (0 !== pendingEffectsStatus);
		    if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(327));
		    if (null !== finishedWork) {
		      if (finishedWork === root.current)
		        throw Error(formatProdErrorMessage(177));
		      didIncludeRenderPhaseUpdate =
		        finishedWork.lanes | finishedWork.childLanes;
		      didIncludeRenderPhaseUpdate |= concurrentlyUpdatedLanes;
		      markRootFinished(
		        root,
		        lanes,
		        didIncludeRenderPhaseUpdate,
		        spawnedLane,
		        updatedLanes,
		        suspendedRetryLanes
		      );
		      root === workInProgressRoot &&
		        ((workInProgress = workInProgressRoot = null),
		        (workInProgressRootRenderLanes = 0));
		      pendingFinishedWork = finishedWork;
		      pendingEffectsRoot = root;
		      pendingEffectsLanes = lanes;
		      pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
		      pendingPassiveTransitions = transitions;
		      pendingRecoverableErrors = recoverableErrors;
		      0 !== (finishedWork.subtreeFlags & 10256) ||
		      0 !== (finishedWork.flags & 10256)
		        ? ((root.callbackNode = null),
		          (root.callbackPriority = 0),
		          scheduleCallback(NormalPriority$1, function () {
		            flushPassiveEffects();
		            return null;
		          }))
		        : ((root.callbackNode = null), (root.callbackPriority = 0));
		      recoverableErrors = 0 !== (finishedWork.flags & 13878);
		      if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
		        recoverableErrors = ReactSharedInternals.T;
		        ReactSharedInternals.T = null;
		        transitions = getCurrentUpdatePriority();
		        setCurrentUpdatePriority(2);
		        spawnedLane = executionContext;
		        executionContext |= 4;
		        try {
		          commitBeforeMutationEffects(root, finishedWork, lanes);
		        } finally {
		          (executionContext = spawnedLane),
		            setCurrentUpdatePriority(transitions),
		            (ReactSharedInternals.T = recoverableErrors);
		        }
		      }
		      pendingEffectsStatus = 1;
		      flushMutationEffects();
		      flushLayoutEffects();
		      flushSpawnedWork();
		    }
		  }
		  function flushMutationEffects() {
		    if (1 === pendingEffectsStatus) {
		      pendingEffectsStatus = 0;
		      var root = pendingEffectsRoot,
		        finishedWork = pendingFinishedWork,
		        rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
		      if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
		        rootMutationHasEffect = ReactSharedInternals.T;
		        ReactSharedInternals.T = null;
		        var previousPriority = getCurrentUpdatePriority();
		        setCurrentUpdatePriority(2);
		        var prevExecutionContext = executionContext;
		        executionContext |= 4;
		        try {
		          commitMutationEffectsOnFiber(finishedWork, root),
		            resetAfterCommit(root.containerInfo);
		        } finally {
		          (executionContext = prevExecutionContext),
		            setCurrentUpdatePriority(previousPriority),
		            (ReactSharedInternals.T = rootMutationHasEffect);
		        }
		      }
		      root.current = finishedWork;
		      pendingEffectsStatus = 2;
		    }
		  }
		  function flushLayoutEffects() {
		    if (2 === pendingEffectsStatus) {
		      pendingEffectsStatus = 0;
		      var root = pendingEffectsRoot,
		        finishedWork = pendingFinishedWork,
		        rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
		      if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
		        rootHasLayoutEffect = ReactSharedInternals.T;
		        ReactSharedInternals.T = null;
		        var previousPriority = getCurrentUpdatePriority();
		        setCurrentUpdatePriority(2);
		        var prevExecutionContext = executionContext;
		        executionContext |= 4;
		        try {
		          commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
		        } finally {
		          (executionContext = prevExecutionContext),
		            setCurrentUpdatePriority(previousPriority),
		            (ReactSharedInternals.T = rootHasLayoutEffect);
		        }
		      }
		      pendingEffectsStatus = 3;
		    }
		  }
		  function flushSpawnedWork() {
		    if (4 === pendingEffectsStatus || 3 === pendingEffectsStatus) {
		      pendingEffectsStatus = 0;
		      requestPaint();
		      var root = pendingEffectsRoot,
		        finishedWork = pendingFinishedWork,
		        lanes = pendingEffectsLanes,
		        recoverableErrors = pendingRecoverableErrors;
		      0 !== (finishedWork.subtreeFlags & 10256) ||
		      0 !== (finishedWork.flags & 10256)
		        ? (pendingEffectsStatus = 5)
		        : ((pendingEffectsStatus = 0),
		          (pendingFinishedWork = pendingEffectsRoot = null),
		          releaseRootPooledCache(root, root.pendingLanes));
		      var remainingLanes = root.pendingLanes;
		      0 === remainingLanes && (legacyErrorBoundariesThatAlreadyFailed = null);
		      lanesToEventPriority(lanes);
		      finishedWork = finishedWork.stateNode;
		      if (injectedHook && "function" === typeof injectedHook.onCommitFiberRoot)
		        try {
		          injectedHook.onCommitFiberRoot(
		            rendererID,
		            finishedWork,
		            void 0,
		            128 === (finishedWork.current.flags & 128)
		          );
		        } catch (err) {}
		      if (null !== recoverableErrors) {
		        finishedWork = ReactSharedInternals.T;
		        remainingLanes = getCurrentUpdatePriority();
		        setCurrentUpdatePriority(2);
		        ReactSharedInternals.T = null;
		        try {
		          for (
		            var onRecoverableError = root.onRecoverableError, i = 0;
		            i < recoverableErrors.length;
		            i++
		          ) {
		            var recoverableError = recoverableErrors[i];
		            onRecoverableError(recoverableError.value, {
		              componentStack: recoverableError.stack
		            });
		          }
		        } finally {
		          (ReactSharedInternals.T = finishedWork),
		            setCurrentUpdatePriority(remainingLanes);
		        }
		      }
		      0 !== (pendingEffectsLanes & 3) && flushPendingEffects();
		      ensureRootIsScheduled(root);
		      remainingLanes = root.pendingLanes;
		      0 !== (lanes & 261930) && 0 !== (remainingLanes & 42)
		        ? root === rootWithNestedUpdates
		          ? nestedUpdateCount++
		          : ((nestedUpdateCount = 0), (rootWithNestedUpdates = root))
		        : (nestedUpdateCount = 0);
		      supportsHydration && flushHydrationEvents();
		      flushSyncWorkAcrossRoots_impl(0);
		    }
		  }
		  function releaseRootPooledCache(root, remainingLanes) {
		    0 === (root.pooledCacheLanes &= remainingLanes) &&
		      ((remainingLanes = root.pooledCache),
		      null != remainingLanes &&
		        ((root.pooledCache = null), releaseCache(remainingLanes)));
		  }
		  function flushPendingEffects() {
		    flushMutationEffects();
		    flushLayoutEffects();
		    flushSpawnedWork();
		    return flushPassiveEffects();
		  }
		  function flushPassiveEffects() {
		    if (5 !== pendingEffectsStatus) return false;
		    var root = pendingEffectsRoot,
		      remainingLanes = pendingEffectsRemainingLanes;
		    pendingEffectsRemainingLanes = 0;
		    var renderPriority = lanesToEventPriority(pendingEffectsLanes),
		      priority = 32 > renderPriority ? 32 : renderPriority;
		    renderPriority = ReactSharedInternals.T;
		    var previousPriority = getCurrentUpdatePriority();
		    try {
		      setCurrentUpdatePriority(priority);
		      ReactSharedInternals.T = null;
		      priority = pendingPassiveTransitions;
		      pendingPassiveTransitions = null;
		      var root$jscomp$0 = pendingEffectsRoot,
		        lanes = pendingEffectsLanes;
		      pendingEffectsStatus = 0;
		      pendingFinishedWork = pendingEffectsRoot = null;
		      pendingEffectsLanes = 0;
		      if (0 !== (executionContext & 6))
		        throw Error(formatProdErrorMessage(331));
		      var prevExecutionContext = executionContext;
		      executionContext |= 4;
		      commitPassiveUnmountOnFiber(root$jscomp$0.current);
		      commitPassiveMountOnFiber(
		        root$jscomp$0,
		        root$jscomp$0.current,
		        lanes,
		        priority
		      );
		      executionContext = prevExecutionContext;
		      flushSyncWorkAcrossRoots_impl(0, !1);
		      if (
		        injectedHook &&
		        "function" === typeof injectedHook.onPostCommitFiberRoot
		      )
		        try {
		          injectedHook.onPostCommitFiberRoot(rendererID, root$jscomp$0);
		        } catch (err) {}
		      return !0;
		    } finally {
		      setCurrentUpdatePriority(previousPriority),
		        (ReactSharedInternals.T = renderPriority),
		        releaseRootPooledCache(root, remainingLanes);
		    }
		  }
		  function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
		    sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
		    sourceFiber = createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
		    rootFiber = enqueueUpdate(rootFiber, sourceFiber, 2);
		    null !== rootFiber &&
		      (markRootUpdated$1(rootFiber, 2), ensureRootIsScheduled(rootFiber));
		  }
		  function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
		    if (3 === sourceFiber.tag)
		      captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
		    else
		      for (; null !== nearestMountedAncestor; ) {
		        if (3 === nearestMountedAncestor.tag) {
		          captureCommitPhaseErrorOnRoot(
		            nearestMountedAncestor,
		            sourceFiber,
		            error
		          );
		          break;
		        } else if (1 === nearestMountedAncestor.tag) {
		          var instance = nearestMountedAncestor.stateNode;
		          if (
		            "function" ===
		              typeof nearestMountedAncestor.type.getDerivedStateFromError ||
		            ("function" === typeof instance.componentDidCatch &&
		              (null === legacyErrorBoundariesThatAlreadyFailed ||
		                !legacyErrorBoundariesThatAlreadyFailed.has(instance)))
		          ) {
		            sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
		            error = createClassErrorUpdate(2);
		            instance = enqueueUpdate(nearestMountedAncestor, error, 2);
		            null !== instance &&
		              (initializeClassErrorUpdate(
		                error,
		                instance,
		                nearestMountedAncestor,
		                sourceFiber
		              ),
		              markRootUpdated$1(instance, 2),
		              ensureRootIsScheduled(instance));
		            break;
		          }
		        }
		        nearestMountedAncestor = nearestMountedAncestor.return;
		      }
		  }
		  function attachPingListener(root, wakeable, lanes) {
		    var pingCache = root.pingCache;
		    if (null === pingCache) {
		      pingCache = root.pingCache = new PossiblyWeakMap();
		      var threadIDs = new Set();
		      pingCache.set(wakeable, threadIDs);
		    } else
		      (threadIDs = pingCache.get(wakeable)),
		        void 0 === threadIDs &&
		          ((threadIDs = new Set()), pingCache.set(wakeable, threadIDs));
		    threadIDs.has(lanes) ||
		      ((workInProgressRootDidAttachPingListener = true),
		      threadIDs.add(lanes),
		      (root = pingSuspendedRoot.bind(null, root, wakeable, lanes)),
		      wakeable.then(root, root));
		  }
		  function pingSuspendedRoot(root, wakeable, pingedLanes) {
		    var pingCache = root.pingCache;
		    null !== pingCache && pingCache.delete(wakeable);
		    root.pingedLanes |= root.suspendedLanes & pingedLanes;
		    root.warmLanes &= ~pingedLanes;
		    workInProgressRoot === root &&
		      (workInProgressRootRenderLanes & pingedLanes) === pingedLanes &&
		      (4 === workInProgressRootExitStatus ||
		      (3 === workInProgressRootExitStatus &&
		        (workInProgressRootRenderLanes & 62914560) ===
		          workInProgressRootRenderLanes &&
		        300 > now() - globalMostRecentFallbackTime)
		        ? 0 === (executionContext & 2) && prepareFreshStack(root, 0)
		        : (workInProgressRootPingedLanes |= pingedLanes),
		      workInProgressSuspendedRetryLanes === workInProgressRootRenderLanes &&
		        (workInProgressSuspendedRetryLanes = 0));
		    ensureRootIsScheduled(root);
		  }
		  function retryTimedOutBoundary(boundaryFiber, retryLane) {
		    0 === retryLane && (retryLane = claimNextRetryLane());
		    boundaryFiber = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
		    null !== boundaryFiber &&
		      (markRootUpdated$1(boundaryFiber, retryLane),
		      ensureRootIsScheduled(boundaryFiber));
		  }
		  function retryDehydratedSuspenseBoundary(boundaryFiber) {
		    var suspenseState = boundaryFiber.memoizedState,
		      retryLane = 0;
		    null !== suspenseState && (retryLane = suspenseState.retryLane);
		    retryTimedOutBoundary(boundaryFiber, retryLane);
		  }
		  function resolveRetryWakeable(boundaryFiber, wakeable) {
		    var retryLane = 0;
		    switch (boundaryFiber.tag) {
		      case 31:
		      case 13:
		        var retryCache = boundaryFiber.stateNode;
		        var suspenseState = boundaryFiber.memoizedState;
		        null !== suspenseState && (retryLane = suspenseState.retryLane);
		        break;
		      case 19:
		        retryCache = boundaryFiber.stateNode;
		        break;
		      case 22:
		        retryCache = boundaryFiber.stateNode._retryCache;
		        break;
		      default:
		        throw Error(formatProdErrorMessage(314));
		    }
		    null !== retryCache && retryCache.delete(wakeable);
		    retryTimedOutBoundary(boundaryFiber, retryLane);
		  }
		  function scheduleCallback(priorityLevel, callback) {
		    return scheduleCallback$3(priorityLevel, callback);
		  }
		  function FiberNode(tag, pendingProps, key, mode) {
		    this.tag = tag;
		    this.key = key;
		    this.sibling =
		      this.child =
		      this.return =
		      this.stateNode =
		      this.type =
		      this.elementType =
		        null;
		    this.index = 0;
		    this.refCleanup = this.ref = null;
		    this.pendingProps = pendingProps;
		    this.dependencies =
		      this.memoizedState =
		      this.updateQueue =
		      this.memoizedProps =
		        null;
		    this.mode = mode;
		    this.subtreeFlags = this.flags = 0;
		    this.deletions = null;
		    this.childLanes = this.lanes = 0;
		    this.alternate = null;
		  }
		  function shouldConstruct(Component) {
		    Component = Component.prototype;
		    return !(!Component || !Component.isReactComponent);
		  }
		  function createWorkInProgress(current, pendingProps) {
		    var workInProgress = current.alternate;
		    null === workInProgress
		      ? ((workInProgress = createFiber(
		          current.tag,
		          pendingProps,
		          current.key,
		          current.mode
		        )),
		        (workInProgress.elementType = current.elementType),
		        (workInProgress.type = current.type),
		        (workInProgress.stateNode = current.stateNode),
		        (workInProgress.alternate = current),
		        (current.alternate = workInProgress))
		      : ((workInProgress.pendingProps = pendingProps),
		        (workInProgress.type = current.type),
		        (workInProgress.flags = 0),
		        (workInProgress.subtreeFlags = 0),
		        (workInProgress.deletions = null));
		    workInProgress.flags = current.flags & 65011712;
		    workInProgress.childLanes = current.childLanes;
		    workInProgress.lanes = current.lanes;
		    workInProgress.child = current.child;
		    workInProgress.memoizedProps = current.memoizedProps;
		    workInProgress.memoizedState = current.memoizedState;
		    workInProgress.updateQueue = current.updateQueue;
		    pendingProps = current.dependencies;
		    workInProgress.dependencies =
		      null === pendingProps
		        ? null
		        : {
		            lanes: pendingProps.lanes,
		            firstContext: pendingProps.firstContext
		          };
		    workInProgress.sibling = current.sibling;
		    workInProgress.index = current.index;
		    workInProgress.ref = current.ref;
		    workInProgress.refCleanup = current.refCleanup;
		    return workInProgress;
		  }
		  function resetWorkInProgress(workInProgress, renderLanes) {
		    workInProgress.flags &= 65011714;
		    var current = workInProgress.alternate;
		    null === current
		      ? ((workInProgress.childLanes = 0),
		        (workInProgress.lanes = renderLanes),
		        (workInProgress.child = null),
		        (workInProgress.subtreeFlags = 0),
		        (workInProgress.memoizedProps = null),
		        (workInProgress.memoizedState = null),
		        (workInProgress.updateQueue = null),
		        (workInProgress.dependencies = null),
		        (workInProgress.stateNode = null))
		      : ((workInProgress.childLanes = current.childLanes),
		        (workInProgress.lanes = current.lanes),
		        (workInProgress.child = current.child),
		        (workInProgress.subtreeFlags = 0),
		        (workInProgress.deletions = null),
		        (workInProgress.memoizedProps = current.memoizedProps),
		        (workInProgress.memoizedState = current.memoizedState),
		        (workInProgress.updateQueue = current.updateQueue),
		        (workInProgress.type = current.type),
		        (renderLanes = current.dependencies),
		        (workInProgress.dependencies =
		          null === renderLanes
		            ? null
		            : {
		                lanes: renderLanes.lanes,
		                firstContext: renderLanes.firstContext
		              }));
		    return workInProgress;
		  }
		  function createFiberFromTypeAndProps(
		    type,
		    key,
		    pendingProps,
		    owner,
		    mode,
		    lanes
		  ) {
		    var fiberTag = 0;
		    owner = type;
		    if ("function" === typeof type) shouldConstruct(type) && (fiberTag = 1);
		    else if ("string" === typeof type)
		      fiberTag =
		        supportsResources && supportsSingletons
		          ? isHostHoistableType(type, pendingProps, contextStackCursor.current)
		            ? 26
		            : isHostSingletonType(type)
		              ? 27
		              : 5
		          : supportsResources
		            ? isHostHoistableType(
		                type,
		                pendingProps,
		                contextStackCursor.current
		              )
		              ? 26
		              : 5
		            : supportsSingletons
		              ? isHostSingletonType(type)
		                ? 27
		                : 5
		              : 5;
		    else
		      a: switch (type) {
		        case REACT_ACTIVITY_TYPE:
		          return (
		            (type = createFiber(31, pendingProps, key, mode)),
		            (type.elementType = REACT_ACTIVITY_TYPE),
		            (type.lanes = lanes),
		            type
		          );
		        case REACT_FRAGMENT_TYPE:
		          return createFiberFromFragment(
		            pendingProps.children,
		            mode,
		            lanes,
		            key
		          );
		        case REACT_STRICT_MODE_TYPE:
		          fiberTag = 8;
		          mode |= 24;
		          break;
		        case REACT_PROFILER_TYPE:
		          return (
		            (type = createFiber(12, pendingProps, key, mode | 2)),
		            (type.elementType = REACT_PROFILER_TYPE),
		            (type.lanes = lanes),
		            type
		          );
		        case REACT_SUSPENSE_TYPE:
		          return (
		            (type = createFiber(13, pendingProps, key, mode)),
		            (type.elementType = REACT_SUSPENSE_TYPE),
		            (type.lanes = lanes),
		            type
		          );
		        case REACT_SUSPENSE_LIST_TYPE:
		          return (
		            (type = createFiber(19, pendingProps, key, mode)),
		            (type.elementType = REACT_SUSPENSE_LIST_TYPE),
		            (type.lanes = lanes),
		            type
		          );
		        default:
		          if ("object" === typeof type && null !== type)
		            switch (type.$$typeof) {
		              case REACT_CONTEXT_TYPE:
		                fiberTag = 10;
		                break a;
		              case REACT_CONSUMER_TYPE:
		                fiberTag = 9;
		                break a;
		              case REACT_FORWARD_REF_TYPE:
		                fiberTag = 11;
		                break a;
		              case REACT_MEMO_TYPE:
		                fiberTag = 14;
		                break a;
		              case REACT_LAZY_TYPE:
		                fiberTag = 16;
		                owner = null;
		                break a;
		            }
		          fiberTag = 29;
		          pendingProps = Error(
		            formatProdErrorMessage(
		              130,
		              null === type ? "null" : typeof type,
		              ""
		            )
		          );
		          owner = null;
		      }
		    key = createFiber(fiberTag, pendingProps, key, mode);
		    key.elementType = type;
		    key.type = owner;
		    key.lanes = lanes;
		    return key;
		  }
		  function createFiberFromFragment(elements, mode, lanes, key) {
		    elements = createFiber(7, elements, key, mode);
		    elements.lanes = lanes;
		    return elements;
		  }
		  function createFiberFromText(content, mode, lanes) {
		    content = createFiber(6, content, null, mode);
		    content.lanes = lanes;
		    return content;
		  }
		  function createFiberFromDehydratedFragment(dehydratedNode) {
		    var fiber = createFiber(18, null, null, 0);
		    fiber.stateNode = dehydratedNode;
		    return fiber;
		  }
		  function createFiberFromPortal(portal, mode, lanes) {
		    mode = createFiber(
		      4,
		      null !== portal.children ? portal.children : [],
		      portal.key,
		      mode
		    );
		    mode.lanes = lanes;
		    mode.stateNode = {
		      containerInfo: portal.containerInfo,
		      pendingChildren: null,
		      implementation: portal.implementation
		    };
		    return mode;
		  }
		  function FiberRootNode(
		    containerInfo,
		    tag,
		    hydrate,
		    identifierPrefix,
		    onUncaughtError,
		    onCaughtError,
		    onRecoverableError,
		    onDefaultTransitionIndicator,
		    formState
		  ) {
		    this.tag = 1;
		    this.containerInfo = containerInfo;
		    this.pingCache = this.current = this.pendingChildren = null;
		    this.timeoutHandle = noTimeout;
		    this.callbackNode =
		      this.next =
		      this.pendingContext =
		      this.context =
		      this.cancelPendingCommit =
		        null;
		    this.callbackPriority = 0;
		    this.expirationTimes = createLaneMap(-1);
		    this.entangledLanes =
		      this.shellSuspendCounter =
		      this.errorRecoveryDisabledLanes =
		      this.expiredLanes =
		      this.warmLanes =
		      this.pingedLanes =
		      this.suspendedLanes =
		      this.pendingLanes =
		        0;
		    this.entanglements = createLaneMap(0);
		    this.hiddenUpdates = createLaneMap(null);
		    this.identifierPrefix = identifierPrefix;
		    this.onUncaughtError = onUncaughtError;
		    this.onCaughtError = onCaughtError;
		    this.onRecoverableError = onRecoverableError;
		    this.pooledCache = null;
		    this.pooledCacheLanes = 0;
		    this.formState = formState;
		    this.incompleteTransitions = new Map();
		  }
		  function createFiberRoot(
		    containerInfo,
		    tag,
		    hydrate,
		    initialChildren,
		    hydrationCallbacks,
		    isStrictMode,
		    identifierPrefix,
		    formState,
		    onUncaughtError,
		    onCaughtError,
		    onRecoverableError,
		    onDefaultTransitionIndicator
		  ) {
		    containerInfo = new FiberRootNode(
		      containerInfo,
		      tag,
		      hydrate,
		      identifierPrefix,
		      onUncaughtError,
		      onCaughtError,
		      onRecoverableError,
		      onDefaultTransitionIndicator,
		      formState
		    );
		    tag = 1;
		    true === isStrictMode && (tag |= 24);
		    isStrictMode = createFiber(3, null, null, tag);
		    containerInfo.current = isStrictMode;
		    isStrictMode.stateNode = containerInfo;
		    tag = createCache();
		    tag.refCount++;
		    containerInfo.pooledCache = tag;
		    tag.refCount++;
		    isStrictMode.memoizedState = {
		      element: initialChildren,
		      isDehydrated: hydrate,
		      cache: tag
		    };
		    initializeUpdateQueue(isStrictMode);
		    return containerInfo;
		  }
		  function getContextForSubtree(parentComponent) {
		    if (!parentComponent) return emptyContextObject;
		    parentComponent = emptyContextObject;
		    return parentComponent;
		  }
		  function findHostInstance(component) {
		    var fiber = component._reactInternals;
		    if (void 0 === fiber) {
		      if ("function" === typeof component.render)
		        throw Error(formatProdErrorMessage(188));
		      component = Object.keys(component).join(",");
		      throw Error(formatProdErrorMessage(268, component));
		    }
		    component = findCurrentFiberUsingSlowPath(fiber);
		    component = null !== component ? findCurrentHostFiberImpl(component) : null;
		    return null === component ? null : getPublicInstance(component.stateNode);
		  }
		  function updateContainerImpl(
		    rootFiber,
		    lane,
		    element,
		    container,
		    parentComponent,
		    callback
		  ) {
		    parentComponent = getContextForSubtree(parentComponent);
		    null === container.context
		      ? (container.context = parentComponent)
		      : (container.pendingContext = parentComponent);
		    container = createUpdate(lane);
		    container.payload = { element: element };
		    callback = void 0 === callback ? null : callback;
		    null !== callback && (container.callback = callback);
		    element = enqueueUpdate(rootFiber, container, lane);
		    null !== element &&
		      (scheduleUpdateOnFiber(element, rootFiber, lane),
		      entangleTransitions(element, rootFiber, lane));
		  }
		  function markRetryLaneImpl(fiber, retryLane) {
		    fiber = fiber.memoizedState;
		    if (null !== fiber && null !== fiber.dehydrated) {
		      var a = fiber.retryLane;
		      fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
		    }
		  }
		  function markRetryLaneIfNotHydrated(fiber, retryLane) {
		    markRetryLaneImpl(fiber, retryLane);
		    (fiber = fiber.alternate) && markRetryLaneImpl(fiber, retryLane);
		  }
		  var exports$1 = {};
		  var React = React__default,
		    Scheduler = requireScheduler(),
		    assign = Object.assign,
		    REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"),
		    REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"),
		    REACT_PORTAL_TYPE = Symbol.for("react.portal"),
		    REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"),
		    REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"),
		    REACT_PROFILER_TYPE = Symbol.for("react.profiler"),
		    REACT_CONSUMER_TYPE = Symbol.for("react.consumer"),
		    REACT_CONTEXT_TYPE = Symbol.for("react.context"),
		    REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"),
		    REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"),
		    REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"),
		    REACT_MEMO_TYPE = Symbol.for("react.memo"),
		    REACT_LAZY_TYPE = Symbol.for("react.lazy");
		  var REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
		  var REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
		  var MAYBE_ITERATOR_SYMBOL = Symbol.iterator,
		    REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference"),
		    isArrayImpl = Array.isArray,
		    ReactSharedInternals =
		      React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
		    rendererVersion = $$$config.rendererVersion,
		    rendererPackageName = $$$config.rendererPackageName,
		    extraDevToolsConfig = $$$config.extraDevToolsConfig,
		    getPublicInstance = $$$config.getPublicInstance,
		    getRootHostContext = $$$config.getRootHostContext,
		    getChildHostContext = $$$config.getChildHostContext,
		    prepareForCommit = $$$config.prepareForCommit,
		    resetAfterCommit = $$$config.resetAfterCommit,
		    createInstance = $$$config.createInstance;
		  $$$config.cloneMutableInstance;
		  var appendInitialChild = $$$config.appendInitialChild,
		    finalizeInitialChildren = $$$config.finalizeInitialChildren,
		    shouldSetTextContent = $$$config.shouldSetTextContent,
		    createTextInstance = $$$config.createTextInstance;
		  $$$config.cloneMutableTextInstance;
		  var scheduleTimeout = $$$config.scheduleTimeout,
		    cancelTimeout = $$$config.cancelTimeout,
		    noTimeout = $$$config.noTimeout,
		    isPrimaryRenderer = $$$config.isPrimaryRenderer;
		  $$$config.warnsIfNotActing;
		  var supportsMutation = $$$config.supportsMutation,
		    supportsPersistence = $$$config.supportsPersistence,
		    supportsHydration = $$$config.supportsHydration,
		    getInstanceFromNode = $$$config.getInstanceFromNode;
		  $$$config.beforeActiveInstanceBlur;
		  var preparePortalMount = $$$config.preparePortalMount;
		  $$$config.prepareScopeUpdate;
		  $$$config.getInstanceFromScope;
		  var setCurrentUpdatePriority = $$$config.setCurrentUpdatePriority,
		    getCurrentUpdatePriority = $$$config.getCurrentUpdatePriority,
		    resolveUpdatePriority = $$$config.resolveUpdatePriority;
		  $$$config.trackSchedulerEvent;
		  $$$config.resolveEventType;
		  $$$config.resolveEventTimeStamp;
		  var shouldAttemptEagerTransition = $$$config.shouldAttemptEagerTransition,
		    detachDeletedInstance = $$$config.detachDeletedInstance;
		  $$$config.requestPostPaintCallback;
		  var maySuspendCommit = $$$config.maySuspendCommit,
		    maySuspendCommitOnUpdate = $$$config.maySuspendCommitOnUpdate,
		    maySuspendCommitInSyncRender = $$$config.maySuspendCommitInSyncRender,
		    preloadInstance = $$$config.preloadInstance,
		    startSuspendingCommit = $$$config.startSuspendingCommit,
		    suspendInstance = $$$config.suspendInstance;
		  $$$config.suspendOnActiveViewTransition;
		  var waitForCommitToBeReady = $$$config.waitForCommitToBeReady;
		  $$$config.getSuspendedCommitReason;
		  var NotPendingTransition = $$$config.NotPendingTransition,
		    HostTransitionContext = $$$config.HostTransitionContext,
		    resetFormInstance = $$$config.resetFormInstance;
		  $$$config.bindToConsole;
		  var supportsMicrotasks = $$$config.supportsMicrotasks,
		    scheduleMicrotask = $$$config.scheduleMicrotask,
		    supportsTestSelectors = $$$config.supportsTestSelectors,
		    findFiberRoot = $$$config.findFiberRoot,
		    getBoundingRect = $$$config.getBoundingRect,
		    getTextContent = $$$config.getTextContent,
		    isHiddenSubtree = $$$config.isHiddenSubtree,
		    matchAccessibilityRole = $$$config.matchAccessibilityRole,
		    setFocusIfFocusable = $$$config.setFocusIfFocusable,
		    setupIntersectionObserver = $$$config.setupIntersectionObserver,
		    appendChild = $$$config.appendChild,
		    appendChildToContainer = $$$config.appendChildToContainer,
		    commitTextUpdate = $$$config.commitTextUpdate,
		    commitMount = $$$config.commitMount,
		    commitUpdate = $$$config.commitUpdate,
		    insertBefore = $$$config.insertBefore,
		    insertInContainerBefore = $$$config.insertInContainerBefore,
		    removeChild = $$$config.removeChild,
		    removeChildFromContainer = $$$config.removeChildFromContainer,
		    resetTextContent = $$$config.resetTextContent,
		    hideInstance = $$$config.hideInstance,
		    hideTextInstance = $$$config.hideTextInstance,
		    unhideInstance = $$$config.unhideInstance,
		    unhideTextInstance = $$$config.unhideTextInstance;
		  $$$config.cancelViewTransitionName;
		  $$$config.cancelRootViewTransitionName;
		  $$$config.restoreRootViewTransitionName;
		  $$$config.cloneRootViewTransitionContainer;
		  $$$config.removeRootViewTransitionClone;
		  $$$config.measureClonedInstance;
		  $$$config.hasInstanceChanged;
		  $$$config.hasInstanceAffectedParent;
		  $$$config.startViewTransition;
		  $$$config.startGestureTransition;
		  $$$config.stopViewTransition;
		  $$$config.getCurrentGestureOffset;
		  $$$config.createViewTransitionInstance;
		  var clearContainer = $$$config.clearContainer;
		  $$$config.createFragmentInstance;
		  $$$config.updateFragmentInstanceFiber;
		  $$$config.commitNewChildToFragmentInstance;
		  $$$config.deleteChildFromFragmentInstance;
		  var cloneInstance = $$$config.cloneInstance,
		    createContainerChildSet = $$$config.createContainerChildSet,
		    appendChildToContainerChildSet = $$$config.appendChildToContainerChildSet,
		    finalizeContainerChildren = $$$config.finalizeContainerChildren,
		    replaceContainerChildren = $$$config.replaceContainerChildren,
		    cloneHiddenInstance = $$$config.cloneHiddenInstance,
		    cloneHiddenTextInstance = $$$config.cloneHiddenTextInstance,
		    isSuspenseInstancePending = $$$config.isSuspenseInstancePending,
		    isSuspenseInstanceFallback = $$$config.isSuspenseInstanceFallback,
		    getSuspenseInstanceFallbackErrorDetails =
		      $$$config.getSuspenseInstanceFallbackErrorDetails,
		    registerSuspenseInstanceRetry = $$$config.registerSuspenseInstanceRetry,
		    canHydrateFormStateMarker = $$$config.canHydrateFormStateMarker,
		    isFormStateMarkerMatching = $$$config.isFormStateMarkerMatching,
		    getNextHydratableSibling = $$$config.getNextHydratableSibling,
		    getNextHydratableSiblingAfterSingleton =
		      $$$config.getNextHydratableSiblingAfterSingleton,
		    getFirstHydratableChild = $$$config.getFirstHydratableChild,
		    getFirstHydratableChildWithinContainer =
		      $$$config.getFirstHydratableChildWithinContainer,
		    getFirstHydratableChildWithinActivityInstance =
		      $$$config.getFirstHydratableChildWithinActivityInstance,
		    getFirstHydratableChildWithinSuspenseInstance =
		      $$$config.getFirstHydratableChildWithinSuspenseInstance,
		    getFirstHydratableChildWithinSingleton =
		      $$$config.getFirstHydratableChildWithinSingleton,
		    canHydrateInstance = $$$config.canHydrateInstance,
		    canHydrateTextInstance = $$$config.canHydrateTextInstance,
		    canHydrateActivityInstance = $$$config.canHydrateActivityInstance,
		    canHydrateSuspenseInstance = $$$config.canHydrateSuspenseInstance,
		    hydrateInstance = $$$config.hydrateInstance,
		    hydrateTextInstance = $$$config.hydrateTextInstance,
		    hydrateActivityInstance = $$$config.hydrateActivityInstance,
		    hydrateSuspenseInstance = $$$config.hydrateSuspenseInstance,
		    getNextHydratableInstanceAfterActivityInstance =
		      $$$config.getNextHydratableInstanceAfterActivityInstance,
		    getNextHydratableInstanceAfterSuspenseInstance =
		      $$$config.getNextHydratableInstanceAfterSuspenseInstance,
		    commitHydratedInstance = $$$config.commitHydratedInstance,
		    commitHydratedContainer = $$$config.commitHydratedContainer,
		    commitHydratedActivityInstance = $$$config.commitHydratedActivityInstance,
		    commitHydratedSuspenseInstance = $$$config.commitHydratedSuspenseInstance,
		    finalizeHydratedChildren = $$$config.finalizeHydratedChildren,
		    flushHydrationEvents = $$$config.flushHydrationEvents;
		  $$$config.clearActivityBoundary;
		  var clearSuspenseBoundary = $$$config.clearSuspenseBoundary;
		  $$$config.clearActivityBoundaryFromContainer;
		  var clearSuspenseBoundaryFromContainer =
		      $$$config.clearSuspenseBoundaryFromContainer,
		    hideDehydratedBoundary = $$$config.hideDehydratedBoundary,
		    unhideDehydratedBoundary = $$$config.unhideDehydratedBoundary,
		    shouldDeleteUnhydratedTailInstances =
		      $$$config.shouldDeleteUnhydratedTailInstances;
		  $$$config.diffHydratedPropsForDevWarnings;
		  $$$config.diffHydratedTextForDevWarnings;
		  $$$config.describeHydratableInstanceForDevWarnings;
		  var validateHydratableInstance = $$$config.validateHydratableInstance,
		    validateHydratableTextInstance = $$$config.validateHydratableTextInstance,
		    supportsResources = $$$config.supportsResources,
		    isHostHoistableType = $$$config.isHostHoistableType,
		    getHoistableRoot = $$$config.getHoistableRoot,
		    getResource = $$$config.getResource,
		    acquireResource = $$$config.acquireResource,
		    releaseResource = $$$config.releaseResource,
		    hydrateHoistable = $$$config.hydrateHoistable,
		    mountHoistable = $$$config.mountHoistable,
		    unmountHoistable = $$$config.unmountHoistable,
		    createHoistableInstance = $$$config.createHoistableInstance,
		    prepareToCommitHoistables = $$$config.prepareToCommitHoistables,
		    mayResourceSuspendCommit = $$$config.mayResourceSuspendCommit,
		    preloadResource = $$$config.preloadResource,
		    suspendResource = $$$config.suspendResource,
		    supportsSingletons = $$$config.supportsSingletons,
		    resolveSingletonInstance = $$$config.resolveSingletonInstance,
		    acquireSingletonInstance = $$$config.acquireSingletonInstance,
		    releaseSingletonInstance = $$$config.releaseSingletonInstance,
		    isHostSingletonType = $$$config.isHostSingletonType,
		    isSingletonScope = $$$config.isSingletonScope,
		    valueStack = [],
		    index$jscomp$0 = -1,
		    emptyContextObject = {},
		    clz32 = Math.clz32 ? Math.clz32 : clz32Fallback,
		    log$1 = Math.log,
		    LN2 = Math.LN2,
		    nextTransitionUpdateLane = 256,
		    nextTransitionDeferredLane = 262144,
		    nextRetryLane = 4194304,
		    scheduleCallback$3 = Scheduler.unstable_scheduleCallback,
		    cancelCallback$1 = Scheduler.unstable_cancelCallback,
		    shouldYield = Scheduler.unstable_shouldYield,
		    requestPaint = Scheduler.unstable_requestPaint,
		    now = Scheduler.unstable_now,
		    ImmediatePriority = Scheduler.unstable_ImmediatePriority,
		    UserBlockingPriority = Scheduler.unstable_UserBlockingPriority,
		    NormalPriority$1 = Scheduler.unstable_NormalPriority,
		    IdlePriority = Scheduler.unstable_IdlePriority,
		    log = Scheduler.log,
		    unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue,
		    rendererID = null,
		    injectedHook = null,
		    objectIs = "function" === typeof Object.is ? Object.is : is,
		    reportGlobalError =
		      "function" === typeof reportError
		        ? reportError
		        : function (error) {
		            if (
		              "object" === typeof window &&
		              "function" === typeof window.ErrorEvent
		            ) {
		              var event = new window.ErrorEvent("error", {
		                bubbles: true,
		                cancelable: true,
		                message:
		                  "object" === typeof error &&
		                  null !== error &&
		                  "string" === typeof error.message
		                    ? String(error.message)
		                    : String(error),
		                error: error
		              });
		              if (!window.dispatchEvent(event)) return;
		            } else if (
		              "object" === typeof process &&
		              "function" === typeof process.emit
		            ) {
		              process.emit("uncaughtException", error);
		              return;
		            }
		            console.error(error);
		          },
		    hasOwnProperty = Object.prototype.hasOwnProperty,
		    prefix,
		    suffix,
		    reentry = false,
		    CapturedStacks = new WeakMap(),
		    forkStack = [],
		    forkStackIndex = 0,
		    treeForkProvider = null,
		    treeForkCount = 0,
		    idStack = [],
		    idStackIndex = 0,
		    treeContextProvider = null,
		    treeContextId = 1,
		    treeContextOverflow = "",
		    contextStackCursor = createCursor(null),
		    contextFiberStackCursor = createCursor(null),
		    rootInstanceStackCursor = createCursor(null),
		    hostTransitionProviderCursor = createCursor(null),
		    hydrationParentFiber = null,
		    nextHydratableInstance = null,
		    isHydrating = false,
		    hydrationErrors = null,
		    rootOrSingletonContext = false,
		    HydrationMismatchException = Error(formatProdErrorMessage(519)),
		    valueCursor = createCursor(null),
		    currentlyRenderingFiber$1 = null,
		    lastContextDependency = null,
		    AbortControllerLocal =
		      "undefined" !== typeof AbortController
		        ? AbortController
		        : function () {
		            var listeners = [],
		              signal = (this.signal = {
		                aborted: false,
		                addEventListener: function (type, listener) {
		                  listeners.push(listener);
		                }
		              });
		            this.abort = function () {
		              signal.aborted = true;
		              listeners.forEach(function (listener) {
		                return listener();
		              });
		            };
		          },
		    scheduleCallback$2 = Scheduler.unstable_scheduleCallback,
		    NormalPriority = Scheduler.unstable_NormalPriority,
		    CacheContext = {
		      $$typeof: REACT_CONTEXT_TYPE,
		      Consumer: null,
		      Provider: null,
		      _currentValue: null,
		      _currentValue2: null,
		      _threadCount: 0
		    },
		    firstScheduledRoot = null,
		    lastScheduledRoot = null,
		    didScheduleMicrotask = false,
		    mightHavePendingSyncWork = false,
		    isFlushingWork = false,
		    currentEventTransitionLane = 0,
		    currentEntangledListeners = null,
		    currentEntangledPendingCount = 0,
		    currentEntangledLane = 0,
		    currentEntangledActionThenable = null,
		    prevOnStartTransitionFinish = ReactSharedInternals.S;
		  ReactSharedInternals.S = function (transition, returnValue) {
		    globalMostRecentTransitionTime = now();
		    "object" === typeof returnValue &&
		      null !== returnValue &&
		      "function" === typeof returnValue.then &&
		      entangleAsyncAction(transition, returnValue);
		    null !== prevOnStartTransitionFinish &&
		      prevOnStartTransitionFinish(transition, returnValue);
		  };
		  var resumedCache = createCursor(null),
		    SuspenseException = Error(formatProdErrorMessage(460)),
		    SuspenseyCommitException = Error(formatProdErrorMessage(474)),
		    SuspenseActionException = Error(formatProdErrorMessage(542)),
		    noopSuspenseyCommitThenable = { then: function () {} },
		    suspendedThenable = null,
		    thenableState$1 = null,
		    thenableIndexCounter$1 = 0,
		    reconcileChildFibers = createChildReconciler(true),
		    mountChildFibers = createChildReconciler(false),
		    concurrentQueues = [],
		    concurrentQueuesIndex = 0,
		    concurrentlyUpdatedLanes = 0,
		    hasForceUpdate = false,
		    didReadFromEntangledAsyncAction = false,
		    currentTreeHiddenStackCursor = createCursor(null),
		    prevEntangledRenderLanesCursor = createCursor(0),
		    suspenseHandlerStackCursor = createCursor(null),
		    shellBoundary = null,
		    suspenseStackCursor = createCursor(0),
		    renderLanes = 0,
		    currentlyRenderingFiber = null,
		    currentHook = null,
		    workInProgressHook = null,
		    didScheduleRenderPhaseUpdate = false,
		    didScheduleRenderPhaseUpdateDuringThisPass = false,
		    shouldDoubleInvokeUserFnsInHooksDEV = false,
		    localIdCounter = 0,
		    thenableIndexCounter = 0,
		    thenableState = null,
		    globalClientIdCounter = 0,
		    ContextOnlyDispatcher = {
		      readContext: readContext,
		      use: use,
		      useCallback: throwInvalidHookError,
		      useContext: throwInvalidHookError,
		      useEffect: throwInvalidHookError,
		      useImperativeHandle: throwInvalidHookError,
		      useLayoutEffect: throwInvalidHookError,
		      useInsertionEffect: throwInvalidHookError,
		      useMemo: throwInvalidHookError,
		      useReducer: throwInvalidHookError,
		      useRef: throwInvalidHookError,
		      useState: throwInvalidHookError,
		      useDebugValue: throwInvalidHookError,
		      useDeferredValue: throwInvalidHookError,
		      useTransition: throwInvalidHookError,
		      useSyncExternalStore: throwInvalidHookError,
		      useId: throwInvalidHookError,
		      useHostTransitionStatus: throwInvalidHookError,
		      useFormState: throwInvalidHookError,
		      useActionState: throwInvalidHookError,
		      useOptimistic: throwInvalidHookError,
		      useMemoCache: throwInvalidHookError,
		      useCacheRefresh: throwInvalidHookError
		    };
		  ContextOnlyDispatcher.useEffectEvent = throwInvalidHookError;
		  var HooksDispatcherOnMount = {
		      readContext: readContext,
		      use: use,
		      useCallback: function (callback, deps) {
		        mountWorkInProgressHook().memoizedState = [
		          callback,
		          void 0 === deps ? null : deps
		        ];
		        return callback;
		      },
		      useContext: readContext,
		      useEffect: mountEffect,
		      useImperativeHandle: function (ref, create, deps) {
		        deps = null !== deps && void 0 !== deps ? deps.concat([ref]) : null;
		        mountEffectImpl(
		          4194308,
		          4,
		          imperativeHandleEffect.bind(null, create, ref),
		          deps
		        );
		      },
		      useLayoutEffect: function (create, deps) {
		        return mountEffectImpl(4194308, 4, create, deps);
		      },
		      useInsertionEffect: function (create, deps) {
		        mountEffectImpl(4, 2, create, deps);
		      },
		      useMemo: function (nextCreate, deps) {
		        var hook = mountWorkInProgressHook();
		        deps = void 0 === deps ? null : deps;
		        var nextValue = nextCreate();
		        if (shouldDoubleInvokeUserFnsInHooksDEV) {
		          setIsStrictModeForDevtools(true);
		          try {
		            nextCreate();
		          } finally {
		            setIsStrictModeForDevtools(false);
		          }
		        }
		        hook.memoizedState = [nextValue, deps];
		        return nextValue;
		      },
		      useReducer: function (reducer, initialArg, init) {
		        var hook = mountWorkInProgressHook();
		        if (void 0 !== init) {
		          var initialState = init(initialArg);
		          if (shouldDoubleInvokeUserFnsInHooksDEV) {
		            setIsStrictModeForDevtools(true);
		            try {
		              init(initialArg);
		            } finally {
		              setIsStrictModeForDevtools(false);
		            }
		          }
		        } else initialState = initialArg;
		        hook.memoizedState = hook.baseState = initialState;
		        reducer = {
		          pending: null,
		          lanes: 0,
		          dispatch: null,
		          lastRenderedReducer: reducer,
		          lastRenderedState: initialState
		        };
		        hook.queue = reducer;
		        reducer = reducer.dispatch = dispatchReducerAction.bind(
		          null,
		          currentlyRenderingFiber,
		          reducer
		        );
		        return [hook.memoizedState, reducer];
		      },
		      useRef: function (initialValue) {
		        var hook = mountWorkInProgressHook();
		        initialValue = { current: initialValue };
		        return (hook.memoizedState = initialValue);
		      },
		      useState: function (initialState) {
		        initialState = mountStateImpl(initialState);
		        var queue = initialState.queue,
		          dispatch = dispatchSetState.bind(
		            null,
		            currentlyRenderingFiber,
		            queue
		          );
		        queue.dispatch = dispatch;
		        return [initialState.memoizedState, dispatch];
		      },
		      useDebugValue: mountDebugValue,
		      useDeferredValue: function (value, initialValue) {
		        var hook = mountWorkInProgressHook();
		        return mountDeferredValueImpl(hook, value, initialValue);
		      },
		      useTransition: function () {
		        var stateHook = mountStateImpl(false);
		        stateHook = startTransition.bind(
		          null,
		          currentlyRenderingFiber,
		          stateHook.queue,
		          true,
		          false
		        );
		        mountWorkInProgressHook().memoizedState = stateHook;
		        return [false, stateHook];
		      },
		      useSyncExternalStore: function (
		        subscribe,
		        getSnapshot,
		        getServerSnapshot
		      ) {
		        var fiber = currentlyRenderingFiber,
		          hook = mountWorkInProgressHook();
		        if (isHydrating) {
		          if (void 0 === getServerSnapshot)
		            throw Error(formatProdErrorMessage(407));
		          getServerSnapshot = getServerSnapshot();
		        } else {
		          getServerSnapshot = getSnapshot();
		          if (null === workInProgressRoot)
		            throw Error(formatProdErrorMessage(349));
		          0 !== (workInProgressRootRenderLanes & 127) ||
		            pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
		        }
		        hook.memoizedState = getServerSnapshot;
		        var inst = { value: getServerSnapshot, getSnapshot: getSnapshot };
		        hook.queue = inst;
		        mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
		          subscribe
		        ]);
		        fiber.flags |= 2048;
		        pushSimpleEffect(
		          9,
		          { destroy: void 0 },
		          updateStoreInstance.bind(
		            null,
		            fiber,
		            inst,
		            getServerSnapshot,
		            getSnapshot
		          ),
		          null
		        );
		        return getServerSnapshot;
		      },
		      useId: function () {
		        var hook = mountWorkInProgressHook(),
		          identifierPrefix = workInProgressRoot.identifierPrefix;
		        if (isHydrating) {
		          var JSCompiler_inline_result = treeContextOverflow;
		          var idWithLeadingBit = treeContextId;
		          JSCompiler_inline_result =
		            (
		              idWithLeadingBit & ~(1 << (32 - clz32(idWithLeadingBit) - 1))
		            ).toString(32) + JSCompiler_inline_result;
		          identifierPrefix =
		            "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
		          JSCompiler_inline_result = localIdCounter++;
		          0 < JSCompiler_inline_result &&
		            (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
		          identifierPrefix += "_";
		        } else
		          (JSCompiler_inline_result = globalClientIdCounter++),
		            (identifierPrefix =
		              "_" +
		              identifierPrefix +
		              "r_" +
		              JSCompiler_inline_result.toString(32) +
		              "_");
		        return (hook.memoizedState = identifierPrefix);
		      },
		      useHostTransitionStatus: useHostTransitionStatus,
		      useFormState: mountActionState,
		      useActionState: mountActionState,
		      useOptimistic: function (passthrough) {
		        var hook = mountWorkInProgressHook();
		        hook.memoizedState = hook.baseState = passthrough;
		        var queue = {
		          pending: null,
		          lanes: 0,
		          dispatch: null,
		          lastRenderedReducer: null,
		          lastRenderedState: null
		        };
		        hook.queue = queue;
		        hook = dispatchOptimisticSetState.bind(
		          null,
		          currentlyRenderingFiber,
		          true,
		          queue
		        );
		        queue.dispatch = hook;
		        return [passthrough, hook];
		      },
		      useMemoCache: useMemoCache,
		      useCacheRefresh: function () {
		        return (mountWorkInProgressHook().memoizedState = refreshCache.bind(
		          null,
		          currentlyRenderingFiber
		        ));
		      },
		      useEffectEvent: function (callback) {
		        var hook = mountWorkInProgressHook(),
		          ref = { impl: callback };
		        hook.memoizedState = ref;
		        return function () {
		          if (0 !== (executionContext & 2))
		            throw Error(formatProdErrorMessage(440));
		          return ref.impl.apply(void 0, arguments);
		        };
		      }
		    },
		    HooksDispatcherOnUpdate = {
		      readContext: readContext,
		      use: use,
		      useCallback: updateCallback,
		      useContext: readContext,
		      useEffect: updateEffect,
		      useImperativeHandle: updateImperativeHandle,
		      useInsertionEffect: updateInsertionEffect,
		      useLayoutEffect: updateLayoutEffect,
		      useMemo: updateMemo,
		      useReducer: updateReducer,
		      useRef: updateRef,
		      useState: function () {
		        return updateReducer(basicStateReducer);
		      },
		      useDebugValue: mountDebugValue,
		      useDeferredValue: function (value, initialValue) {
		        var hook = updateWorkInProgressHook();
		        return updateDeferredValueImpl(
		          hook,
		          currentHook.memoizedState,
		          value,
		          initialValue
		        );
		      },
		      useTransition: function () {
		        var booleanOrThenable = updateReducer(basicStateReducer)[0],
		          start = updateWorkInProgressHook().memoizedState;
		        return [
		          "boolean" === typeof booleanOrThenable
		            ? booleanOrThenable
		            : useThenable(booleanOrThenable),
		          start
		        ];
		      },
		      useSyncExternalStore: updateSyncExternalStore,
		      useId: updateId,
		      useHostTransitionStatus: useHostTransitionStatus,
		      useFormState: updateActionState,
		      useActionState: updateActionState,
		      useOptimistic: function (passthrough, reducer) {
		        var hook = updateWorkInProgressHook();
		        return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
		      },
		      useMemoCache: useMemoCache,
		      useCacheRefresh: updateRefresh
		    };
		  HooksDispatcherOnUpdate.useEffectEvent = updateEvent;
		  var HooksDispatcherOnRerender = {
		    readContext: readContext,
		    use: use,
		    useCallback: updateCallback,
		    useContext: readContext,
		    useEffect: updateEffect,
		    useImperativeHandle: updateImperativeHandle,
		    useInsertionEffect: updateInsertionEffect,
		    useLayoutEffect: updateLayoutEffect,
		    useMemo: updateMemo,
		    useReducer: rerenderReducer,
		    useRef: updateRef,
		    useState: function () {
		      return rerenderReducer(basicStateReducer);
		    },
		    useDebugValue: mountDebugValue,
		    useDeferredValue: function (value, initialValue) {
		      var hook = updateWorkInProgressHook();
		      return null === currentHook
		        ? mountDeferredValueImpl(hook, value, initialValue)
		        : updateDeferredValueImpl(
		            hook,
		            currentHook.memoizedState,
		            value,
		            initialValue
		          );
		    },
		    useTransition: function () {
		      var booleanOrThenable = rerenderReducer(basicStateReducer)[0],
		        start = updateWorkInProgressHook().memoizedState;
		      return [
		        "boolean" === typeof booleanOrThenable
		          ? booleanOrThenable
		          : useThenable(booleanOrThenable),
		        start
		      ];
		    },
		    useSyncExternalStore: updateSyncExternalStore,
		    useId: updateId,
		    useHostTransitionStatus: useHostTransitionStatus,
		    useFormState: rerenderActionState,
		    useActionState: rerenderActionState,
		    useOptimistic: function (passthrough, reducer) {
		      var hook = updateWorkInProgressHook();
		      if (null !== currentHook)
		        return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
		      hook.baseState = passthrough;
		      return [passthrough, hook.queue.dispatch];
		    },
		    useMemoCache: useMemoCache,
		    useCacheRefresh: updateRefresh
		  };
		  HooksDispatcherOnRerender.useEffectEvent = updateEvent;
		  var classComponentUpdater = {
		      enqueueSetState: function (inst, payload, callback) {
		        inst = inst._reactInternals;
		        var lane = requestUpdateLane(),
		          update = createUpdate(lane);
		        update.payload = payload;
		        void 0 !== callback &&
		          null !== callback &&
		          (update.callback = callback);
		        payload = enqueueUpdate(inst, update, lane);
		        null !== payload &&
		          (scheduleUpdateOnFiber(payload, inst, lane),
		          entangleTransitions(payload, inst, lane));
		      },
		      enqueueReplaceState: function (inst, payload, callback) {
		        inst = inst._reactInternals;
		        var lane = requestUpdateLane(),
		          update = createUpdate(lane);
		        update.tag = 1;
		        update.payload = payload;
		        void 0 !== callback &&
		          null !== callback &&
		          (update.callback = callback);
		        payload = enqueueUpdate(inst, update, lane);
		        null !== payload &&
		          (scheduleUpdateOnFiber(payload, inst, lane),
		          entangleTransitions(payload, inst, lane));
		      },
		      enqueueForceUpdate: function (inst, callback) {
		        inst = inst._reactInternals;
		        var lane = requestUpdateLane(),
		          update = createUpdate(lane);
		        update.tag = 2;
		        void 0 !== callback &&
		          null !== callback &&
		          (update.callback = callback);
		        callback = enqueueUpdate(inst, update, lane);
		        null !== callback &&
		          (scheduleUpdateOnFiber(callback, inst, lane),
		          entangleTransitions(callback, inst, lane));
		      }
		    },
		    SelectiveHydrationException = Error(formatProdErrorMessage(461)),
		    didReceiveUpdate = false,
		    SUSPENDED_MARKER = {
		      dehydrated: null,
		      treeContext: null,
		      retryLane: 0,
		      hydrationErrors: null
		    },
		    offscreenSubtreeIsHidden = false,
		    offscreenSubtreeWasHidden = false,
		    needsFormReset = false,
		    PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set,
		    nextEffect = null,
		    hostParent = null,
		    hostParentIsContainer = false,
		    currentHoistableRoot = null,
		    suspenseyCommitFlag = 8192,
		    DefaultAsyncDispatcher = {
		      getCacheForType: function (resourceType) {
		        var cache = readContext(CacheContext),
		          cacheForType = cache.data.get(resourceType);
		        void 0 === cacheForType &&
		          ((cacheForType = resourceType()),
		          cache.data.set(resourceType, cacheForType));
		        return cacheForType;
		      },
		      cacheSignal: function () {
		        return readContext(CacheContext).controller.signal;
		      }
		    },
		    COMPONENT_TYPE = 0,
		    HAS_PSEUDO_CLASS_TYPE = 1,
		    ROLE_TYPE = 2,
		    TEST_NAME_TYPE = 3,
		    TEXT_TYPE = 4;
		  if ("function" === typeof Symbol && Symbol.for) {
		    var symbolFor = Symbol.for;
		    COMPONENT_TYPE = symbolFor("selector.component");
		    HAS_PSEUDO_CLASS_TYPE = symbolFor("selector.has_pseudo_class");
		    ROLE_TYPE = symbolFor("selector.role");
		    TEST_NAME_TYPE = symbolFor("selector.test_id");
		    TEXT_TYPE = symbolFor("selector.text");
		  }
		  var PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map,
		    executionContext = 0,
		    workInProgressRoot = null,
		    workInProgress = null,
		    workInProgressRootRenderLanes = 0,
		    workInProgressSuspendedReason = 0,
		    workInProgressThrownValue = null,
		    workInProgressRootDidSkipSuspendedSiblings = false,
		    workInProgressRootIsPrerendering = false,
		    workInProgressRootDidAttachPingListener = false,
		    entangledRenderLanes = 0,
		    workInProgressRootExitStatus = 0,
		    workInProgressRootSkippedLanes = 0,
		    workInProgressRootInterleavedUpdatedLanes = 0,
		    workInProgressRootPingedLanes = 0,
		    workInProgressDeferredLane = 0,
		    workInProgressSuspendedRetryLanes = 0,
		    workInProgressRootConcurrentErrors = null,
		    workInProgressRootRecoverableErrors = null,
		    workInProgressRootDidIncludeRecursiveRenderUpdate = false,
		    globalMostRecentFallbackTime = 0,
		    globalMostRecentTransitionTime = 0,
		    workInProgressRootRenderTargetTime = Infinity,
		    workInProgressTransitions = null,
		    legacyErrorBoundariesThatAlreadyFailed = null,
		    pendingEffectsStatus = 0,
		    pendingEffectsRoot = null,
		    pendingFinishedWork = null,
		    pendingEffectsLanes = 0,
		    pendingEffectsRemainingLanes = 0,
		    pendingPassiveTransitions = null,
		    pendingRecoverableErrors = null,
		    nestedUpdateCount = 0,
		    rootWithNestedUpdates = null;
		  exports$1.attemptContinuousHydration = function (fiber) {
		    if (13 === fiber.tag || 31 === fiber.tag) {
		      var root = enqueueConcurrentRenderForLane(fiber, 67108864);
		      null !== root && scheduleUpdateOnFiber(root, fiber, 67108864);
		      markRetryLaneIfNotHydrated(fiber, 67108864);
		    }
		  };
		  exports$1.attemptHydrationAtCurrentPriority = function (fiber) {
		    if (13 === fiber.tag || 31 === fiber.tag) {
		      var lane = requestUpdateLane();
		      lane = getBumpedLaneForHydrationByLane(lane);
		      var root = enqueueConcurrentRenderForLane(fiber, lane);
		      null !== root && scheduleUpdateOnFiber(root, fiber, lane);
		      markRetryLaneIfNotHydrated(fiber, lane);
		    }
		  };
		  exports$1.attemptSynchronousHydration = function (fiber) {
		    switch (fiber.tag) {
		      case 3:
		        fiber = fiber.stateNode;
		        if (fiber.current.memoizedState.isDehydrated) {
		          var lanes = getHighestPriorityLanes(fiber.pendingLanes);
		          if (0 !== lanes) {
		            fiber.pendingLanes |= 2;
		            for (fiber.entangledLanes |= 2; lanes; ) {
		              var lane = 1 << (31 - clz32(lanes));
		              fiber.entanglements[1] |= lane;
		              lanes &= ~lane;
		            }
		            ensureRootIsScheduled(fiber);
		            0 === (executionContext & 6) &&
		              ((workInProgressRootRenderTargetTime = now() + 500),
		              flushSyncWorkAcrossRoots_impl(0));
		          }
		        }
		        break;
		      case 31:
		      case 13:
		        (lanes = enqueueConcurrentRenderForLane(fiber, 2)),
		          null !== lanes && scheduleUpdateOnFiber(lanes, fiber, 2),
		          flushSyncWork(),
		          markRetryLaneIfNotHydrated(fiber, 2);
		    }
		  };
		  exports$1.batchedUpdates = function (fn, a) {
		    return fn(a);
		  };
		  exports$1.createComponentSelector = function (component) {
		    return { $$typeof: COMPONENT_TYPE, value: component };
		  };
		  exports$1.createContainer = function (
		    containerInfo,
		    tag,
		    hydrationCallbacks,
		    isStrictMode,
		    concurrentUpdatesByDefaultOverride,
		    identifierPrefix,
		    onUncaughtError,
		    onCaughtError,
		    onRecoverableError,
		    onDefaultTransitionIndicator
		  ) {
		    return createFiberRoot(
		      containerInfo,
		      tag,
		      false,
		      null,
		      hydrationCallbacks,
		      isStrictMode,
		      identifierPrefix,
		      null,
		      onUncaughtError,
		      onCaughtError,
		      onRecoverableError,
		      onDefaultTransitionIndicator
		    );
		  };
		  exports$1.createHasPseudoClassSelector = function (selectors) {
		    return { $$typeof: HAS_PSEUDO_CLASS_TYPE, value: selectors };
		  };
		  exports$1.createHydrationContainer = function (
		    initialChildren,
		    callback,
		    containerInfo,
		    tag,
		    hydrationCallbacks,
		    isStrictMode,
		    concurrentUpdatesByDefaultOverride,
		    identifierPrefix,
		    onUncaughtError,
		    onCaughtError,
		    onRecoverableError,
		    onDefaultTransitionIndicator,
		    transitionCallbacks,
		    formState
		  ) {
		    initialChildren = createFiberRoot(
		      containerInfo,
		      tag,
		      true,
		      initialChildren,
		      hydrationCallbacks,
		      isStrictMode,
		      identifierPrefix,
		      formState,
		      onUncaughtError,
		      onCaughtError,
		      onRecoverableError,
		      onDefaultTransitionIndicator
		    );
		    initialChildren.context = getContextForSubtree(null);
		    containerInfo = initialChildren.current;
		    tag = requestUpdateLane();
		    tag = getBumpedLaneForHydrationByLane(tag);
		    hydrationCallbacks = createUpdate(tag);
		    hydrationCallbacks.callback =
		      void 0 !== callback && null !== callback ? callback : null;
		    enqueueUpdate(containerInfo, hydrationCallbacks, tag);
		    callback = tag;
		    initialChildren.current.lanes = callback;
		    markRootUpdated$1(initialChildren, callback);
		    ensureRootIsScheduled(initialChildren);
		    return initialChildren;
		  };
		  exports$1.createPortal = function (children, containerInfo, implementation) {
		    var key =
		      3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
		    return {
		      $$typeof: REACT_PORTAL_TYPE,
		      key: null == key ? null : "" + key,
		      children: children,
		      containerInfo: containerInfo,
		      implementation: implementation
		    };
		  };
		  exports$1.createRoleSelector = function (role) {
		    return { $$typeof: ROLE_TYPE, value: role };
		  };
		  exports$1.createTestNameSelector = function (id) {
		    return { $$typeof: TEST_NAME_TYPE, value: id };
		  };
		  exports$1.createTextSelector = function (text) {
		    return { $$typeof: TEXT_TYPE, value: text };
		  };
		  exports$1.defaultOnCaughtError = function (error) {
		    console.error(error);
		  };
		  exports$1.defaultOnRecoverableError = function (error) {
		    reportGlobalError(error);
		  };
		  exports$1.defaultOnUncaughtError = function (error) {
		    reportGlobalError(error);
		  };
		  exports$1.deferredUpdates = function (fn) {
		    var prevTransition = ReactSharedInternals.T,
		      previousPriority = getCurrentUpdatePriority();
		    try {
		      return (
		        setCurrentUpdatePriority(32), (ReactSharedInternals.T = null), fn()
		      );
		    } finally {
		      setCurrentUpdatePriority(previousPriority),
		        (ReactSharedInternals.T = prevTransition);
		    }
		  };
		  exports$1.discreteUpdates = function (fn, a, b, c, d) {
		    var prevTransition = ReactSharedInternals.T,
		      previousPriority = getCurrentUpdatePriority();
		    try {
		      return (
		        setCurrentUpdatePriority(2),
		        (ReactSharedInternals.T = null),
		        fn(a, b, c, d)
		      );
		    } finally {
		      setCurrentUpdatePriority(previousPriority),
		        (ReactSharedInternals.T = prevTransition),
		        0 === executionContext &&
		          (workInProgressRootRenderTargetTime = now() + 500);
		    }
		  };
		  exports$1.findAllNodes = findAllNodes;
		  exports$1.findBoundingRects = function (hostRoot, selectors) {
		    if (!supportsTestSelectors) throw Error(formatProdErrorMessage(363));
		    selectors = findAllNodes(hostRoot, selectors);
		    hostRoot = [];
		    for (var i = 0; i < selectors.length; i++)
		      hostRoot.push(getBoundingRect(selectors[i]));
		    for (selectors = hostRoot.length - 1; 0 < selectors; selectors--) {
		      i = hostRoot[selectors];
		      for (
		        var targetLeft = i.x,
		          targetRight = targetLeft + i.width,
		          targetTop = i.y,
		          targetBottom = targetTop + i.height,
		          j = selectors - 1;
		        0 <= j;
		        j--
		      )
		        if (selectors !== j) {
		          var otherRect = hostRoot[j],
		            otherLeft = otherRect.x,
		            otherRight = otherLeft + otherRect.width,
		            otherTop = otherRect.y,
		            otherBottom = otherTop + otherRect.height;
		          if (
		            targetLeft >= otherLeft &&
		            targetTop >= otherTop &&
		            targetRight <= otherRight &&
		            targetBottom <= otherBottom
		          ) {
		            hostRoot.splice(selectors, 1);
		            break;
		          } else if (
		            !(
		              targetLeft !== otherLeft ||
		              i.width !== otherRect.width ||
		              otherBottom < targetTop ||
		              otherTop > targetBottom
		            )
		          ) {
		            otherTop > targetTop &&
		              ((otherRect.height += otherTop - targetTop),
		              (otherRect.y = targetTop));
		            otherBottom < targetBottom &&
		              (otherRect.height = targetBottom - otherTop);
		            hostRoot.splice(selectors, 1);
		            break;
		          } else if (
		            !(
		              targetTop !== otherTop ||
		              i.height !== otherRect.height ||
		              otherRight < targetLeft ||
		              otherLeft > targetRight
		            )
		          ) {
		            otherLeft > targetLeft &&
		              ((otherRect.width += otherLeft - targetLeft),
		              (otherRect.x = targetLeft));
		            otherRight < targetRight &&
		              (otherRect.width = targetRight - otherLeft);
		            hostRoot.splice(selectors, 1);
		            break;
		          }
		        }
		    }
		    return hostRoot;
		  };
		  exports$1.findHostInstance = findHostInstance;
		  exports$1.findHostInstanceWithNoPortals = function (fiber) {
		    fiber = findCurrentFiberUsingSlowPath(fiber);
		    fiber =
		      null !== fiber ? findCurrentHostFiberWithNoPortalsImpl(fiber) : null;
		    return null === fiber ? null : getPublicInstance(fiber.stateNode);
		  };
		  exports$1.findHostInstanceWithWarning = function (component) {
		    return findHostInstance(component);
		  };
		  exports$1.flushPassiveEffects = flushPendingEffects;
		  exports$1.flushSyncFromReconciler = function (fn) {
		    var prevExecutionContext = executionContext;
		    executionContext |= 1;
		    var prevTransition = ReactSharedInternals.T,
		      previousPriority = getCurrentUpdatePriority();
		    try {
		      if ((setCurrentUpdatePriority(2), (ReactSharedInternals.T = null), fn))
		        return fn();
		    } finally {
		      setCurrentUpdatePriority(previousPriority),
		        (ReactSharedInternals.T = prevTransition),
		        (executionContext = prevExecutionContext),
		        0 === (executionContext & 6) && flushSyncWorkAcrossRoots_impl(0);
		    }
		  };
		  exports$1.flushSyncWork = flushSyncWork;
		  exports$1.focusWithin = function (hostRoot, selectors) {
		    if (!supportsTestSelectors) throw Error(formatProdErrorMessage(363));
		    hostRoot = findFiberRootForHostRoot(hostRoot);
		    selectors = findPaths(hostRoot, selectors);
		    selectors = Array.from(selectors);
		    for (hostRoot = 0; hostRoot < selectors.length; ) {
		      var fiber = selectors[hostRoot++],
		        tag = fiber.tag;
		      if (!isHiddenSubtree(fiber)) {
		        if (
		          (5 === tag || 26 === tag || 27 === tag) &&
		          setFocusIfFocusable(fiber.stateNode)
		        )
		          return true;
		        for (fiber = fiber.child; null !== fiber; )
		          selectors.push(fiber), (fiber = fiber.sibling);
		      }
		    }
		    return false;
		  };
		  exports$1.getFindAllNodesFailureDescription = function (hostRoot, selectors) {
		    if (!supportsTestSelectors) throw Error(formatProdErrorMessage(363));
		    var maxSelectorIndex = 0,
		      matchedNames = [];
		    hostRoot = [findFiberRootForHostRoot(hostRoot), 0];
		    for (var index = 0; index < hostRoot.length; ) {
		      var fiber = hostRoot[index++],
		        tag = fiber.tag,
		        selectorIndex = hostRoot[index++],
		        selector = selectors[selectorIndex];
		      if ((5 !== tag && 26 !== tag && 27 !== tag) || !isHiddenSubtree(fiber))
		        if (
		          (matchSelector(fiber, selector) &&
		            (matchedNames.push(selectorToString(selector)),
		            selectorIndex++,
		            selectorIndex > maxSelectorIndex &&
		              (maxSelectorIndex = selectorIndex)),
		          selectorIndex < selectors.length)
		        )
		          for (fiber = fiber.child; null !== fiber; )
		            hostRoot.push(fiber, selectorIndex), (fiber = fiber.sibling);
		    }
		    if (maxSelectorIndex < selectors.length) {
		      for (
		        hostRoot = [];
		        maxSelectorIndex < selectors.length;
		        maxSelectorIndex++
		      )
		        hostRoot.push(selectorToString(selectors[maxSelectorIndex]));
		      return (
		        "findAllNodes was able to match part of the selector:\n  " +
		        (matchedNames.join(" > ") +
		          "\n\nNo matching component was found for:\n  ") +
		        hostRoot.join(" > ")
		      );
		    }
		    return null;
		  };
		  exports$1.getPublicRootInstance = function (container) {
		    container = container.current;
		    if (!container.child) return null;
		    switch (container.child.tag) {
		      case 27:
		      case 5:
		        return getPublicInstance(container.child.stateNode);
		      default:
		        return container.child.stateNode;
		    }
		  };
		  exports$1.injectIntoDevTools = function () {
		    var internals = {
		      bundleType: 0,
		      version: rendererVersion,
		      rendererPackageName: rendererPackageName,
		      currentDispatcherRef: ReactSharedInternals,
		      reconcilerVersion: "19.2.0"
		    };
		    null !== extraDevToolsConfig &&
		      (internals.rendererConfig = extraDevToolsConfig);
		    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) internals = false;
		    else {
		      var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
		      if (hook.isDisabled || !hook.supportsFiber) internals = true;
		      else {
		        try {
		          (rendererID = hook.inject(internals)), (injectedHook = hook);
		        } catch (err) {}
		        internals = hook.checkDCE ? true : false;
		      }
		    }
		    return internals;
		  };
		  exports$1.isAlreadyRendering = function () {
		    return 0 !== (executionContext & 6);
		  };
		  exports$1.observeVisibleRects = function (
		    hostRoot,
		    selectors,
		    callback,
		    options
		  ) {
		    if (!supportsTestSelectors) throw Error(formatProdErrorMessage(363));
		    hostRoot = findAllNodes(hostRoot, selectors);
		    var disconnect = setupIntersectionObserver(
		      hostRoot,
		      callback,
		      options
		    ).disconnect;
		    return {
		      disconnect: function () {
		        disconnect();
		      }
		    };
		  };
		  exports$1.shouldError = function () {
		    return null;
		  };
		  exports$1.shouldSuspend = function () {
		    return false;
		  };
		  exports$1.startHostTransition = function (
		    formFiber,
		    pendingState,
		    action,
		    formData
		  ) {
		    if (5 !== formFiber.tag) throw Error(formatProdErrorMessage(476));
		    var queue = ensureFormComponentIsStateful(formFiber).queue;
		    startTransition(
		      formFiber,
		      queue,
		      pendingState,
		      NotPendingTransition,
		      null === action
		        ? noop
		        : function () {
		            var stateHook = ensureFormComponentIsStateful(formFiber);
		            null === stateHook.next &&
		              (stateHook = formFiber.alternate.memoizedState);
		            dispatchSetStateInternal(
		              formFiber,
		              stateHook.next.queue,
		              {},
		              requestUpdateLane()
		            );
		            return action(formData);
		          }
		    );
		  };
		  exports$1.updateContainer = function (
		    element,
		    container,
		    parentComponent,
		    callback
		  ) {
		    var current = container.current,
		      lane = requestUpdateLane();
		    updateContainerImpl(
		      current,
		      lane,
		      element,
		      container,
		      parentComponent,
		      callback
		    );
		    return lane;
		  };
		  exports$1.updateContainerSync = function (
		    element,
		    container,
		    parentComponent,
		    callback
		  ) {
		    updateContainerImpl(
		      container.current,
		      2,
		      element,
		      container,
		      parentComponent,
		      callback
		    );
		    return 2;
		  };
		  return exports$1;
		};
		module.exports.default = module.exports;
		Object.defineProperty(module.exports, "__esModule", { value: true }); 
	} (reactReconciler_production));
	return reactReconciler_production.exports;
}

var reactReconciler_development = {exports: {}};

/**
 * @license React
 * react-reconciler.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactReconciler_development;

function requireReactReconciler_development () {
	if (hasRequiredReactReconciler_development) return reactReconciler_development.exports;
	hasRequiredReactReconciler_development = 1;
	(function (module) {
		"production" !== process.env.NODE_ENV &&
		  ((module.exports = function ($$$config) {
		    function findHook(fiber, id) {
		      for (fiber = fiber.memoizedState; null !== fiber && 0 < id; )
		        (fiber = fiber.next), id--;
		      return fiber;
		    }
		    function copyWithSetImpl(obj, path, index, value) {
		      if (index >= path.length) return value;
		      var key = path[index],
		        updated = isArrayImpl(obj) ? obj.slice() : assign({}, obj);
		      updated[key] = copyWithSetImpl(obj[key], path, index + 1, value);
		      return updated;
		    }
		    function copyWithRename(obj, oldPath, newPath) {
		      if (oldPath.length !== newPath.length)
		        console.warn("copyWithRename() expects paths of the same length");
		      else {
		        for (var i = 0; i < newPath.length - 1; i++)
		          if (oldPath[i] !== newPath[i]) {
		            console.warn(
		              "copyWithRename() expects paths to be the same except for the deepest key"
		            );
		            return;
		          }
		        return copyWithRenameImpl(obj, oldPath, newPath, 0);
		      }
		    }
		    function copyWithRenameImpl(obj, oldPath, newPath, index) {
		      var oldKey = oldPath[index],
		        updated = isArrayImpl(obj) ? obj.slice() : assign({}, obj);
		      index + 1 === oldPath.length
		        ? ((updated[newPath[index]] = updated[oldKey]),
		          isArrayImpl(updated)
		            ? updated.splice(oldKey, 1)
		            : delete updated[oldKey])
		        : (updated[oldKey] = copyWithRenameImpl(
		            obj[oldKey],
		            oldPath,
		            newPath,
		            index + 1
		          ));
		      return updated;
		    }
		    function copyWithDeleteImpl(obj, path, index) {
		      var key = path[index],
		        updated = isArrayImpl(obj) ? obj.slice() : assign({}, obj);
		      if (index + 1 === path.length)
		        return (
		          isArrayImpl(updated) ? updated.splice(key, 1) : delete updated[key],
		          updated
		        );
		      updated[key] = copyWithDeleteImpl(obj[key], path, index + 1);
		      return updated;
		    }
		    function shouldSuspendImpl() {
		      return false;
		    }
		    function shouldErrorImpl() {
		      return null;
		    }
		    function createFiber(tag, pendingProps, key, mode) {
		      return new FiberNode(tag, pendingProps, key, mode);
		    }
		    function scheduleRoot(root, element) {
		      root.context === emptyContextObject &&
		        (updateContainerSync(element, root, null, null), flushSyncWork());
		    }
		    function scheduleRefresh(root, update) {
		      if (null !== resolveFamily) {
		        var staleFamilies = update.staleFamilies;
		        update = update.updatedFamilies;
		        flushPendingEffects();
		        scheduleFibersWithFamiliesRecursively(
		          root.current,
		          update,
		          staleFamilies
		        );
		        flushSyncWork();
		      }
		    }
		    function setRefreshHandler(handler) {
		      resolveFamily = handler;
		    }
		    function warnInvalidHookAccess() {
		      console.error(
		        "Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://react.dev/link/rules-of-hooks"
		      );
		    }
		    function warnInvalidContextAccess() {
		      console.error(
		        "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
		      );
		    }
		    function noop() {}
		    function warnForMissingKey() {}
		    function setToSortedString(set) {
		      var array = [];
		      set.forEach(function (value) {
		        array.push(value);
		      });
		      return array.sort().join(", ");
		    }
		    function getNearestMountedFiber(fiber) {
		      var node = fiber,
		        nearestMounted = fiber;
		      if (fiber.alternate) for (; node.return; ) node = node.return;
		      else {
		        fiber = node;
		        do
		          (node = fiber),
		            0 !== (node.flags & 4098) && (nearestMounted = node.return),
		            (fiber = node.return);
		        while (fiber);
		      }
		      return 3 === node.tag ? nearestMounted : null;
		    }
		    function assertIsMounted(fiber) {
		      if (getNearestMountedFiber(fiber) !== fiber)
		        throw Error("Unable to find node on an unmounted component.");
		    }
		    function findCurrentFiberUsingSlowPath(fiber) {
		      var alternate = fiber.alternate;
		      if (!alternate) {
		        alternate = getNearestMountedFiber(fiber);
		        if (null === alternate)
		          throw Error("Unable to find node on an unmounted component.");
		        return alternate !== fiber ? null : fiber;
		      }
		      for (var a = fiber, b = alternate; ; ) {
		        var parentA = a.return;
		        if (null === parentA) break;
		        var parentB = parentA.alternate;
		        if (null === parentB) {
		          b = parentA.return;
		          if (null !== b) {
		            a = b;
		            continue;
		          }
		          break;
		        }
		        if (parentA.child === parentB.child) {
		          for (parentB = parentA.child; parentB; ) {
		            if (parentB === a) return assertIsMounted(parentA), fiber;
		            if (parentB === b) return assertIsMounted(parentA), alternate;
		            parentB = parentB.sibling;
		          }
		          throw Error("Unable to find node on an unmounted component.");
		        }
		        if (a.return !== b.return) (a = parentA), (b = parentB);
		        else {
		          for (var didFindChild = false, _child = parentA.child; _child; ) {
		            if (_child === a) {
		              didFindChild = true;
		              a = parentA;
		              b = parentB;
		              break;
		            }
		            if (_child === b) {
		              didFindChild = true;
		              b = parentA;
		              a = parentB;
		              break;
		            }
		            _child = _child.sibling;
		          }
		          if (!didFindChild) {
		            for (_child = parentB.child; _child; ) {
		              if (_child === a) {
		                didFindChild = true;
		                a = parentB;
		                b = parentA;
		                break;
		              }
		              if (_child === b) {
		                didFindChild = true;
		                b = parentB;
		                a = parentA;
		                break;
		              }
		              _child = _child.sibling;
		            }
		            if (!didFindChild)
		              throw Error(
		                "Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue."
		              );
		          }
		        }
		        if (a.alternate !== b)
		          throw Error(
		            "Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue."
		          );
		      }
		      if (3 !== a.tag)
		        throw Error("Unable to find node on an unmounted component.");
		      return a.stateNode.current === a ? fiber : alternate;
		    }
		    function findCurrentHostFiber(parent) {
		      parent = findCurrentFiberUsingSlowPath(parent);
		      return null !== parent ? findCurrentHostFiberImpl(parent) : null;
		    }
		    function findCurrentHostFiberImpl(node) {
		      var tag = node.tag;
		      if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
		      for (node = node.child; null !== node; ) {
		        tag = findCurrentHostFiberImpl(node);
		        if (null !== tag) return tag;
		        node = node.sibling;
		      }
		      return null;
		    }
		    function findCurrentHostFiberWithNoPortalsImpl(node) {
		      var tag = node.tag;
		      if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
		      for (node = node.child; null !== node; ) {
		        if (
		          4 !== node.tag &&
		          ((tag = findCurrentHostFiberWithNoPortalsImpl(node)), null !== tag)
		        )
		          return tag;
		        node = node.sibling;
		      }
		      return null;
		    }
		    function getIteratorFn(maybeIterable) {
		      if (null === maybeIterable || "object" !== typeof maybeIterable)
		        return null;
		      maybeIterable =
		        (MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL]) ||
		        maybeIterable["@@iterator"];
		      return "function" === typeof maybeIterable ? maybeIterable : null;
		    }
		    function getComponentNameFromType(type) {
		      if (null == type) return null;
		      if ("function" === typeof type)
		        return type.$$typeof === REACT_CLIENT_REFERENCE
		          ? null
		          : type.displayName || type.name || null;
		      if ("string" === typeof type) return type;
		      switch (type) {
		        case REACT_FRAGMENT_TYPE:
		          return "Fragment";
		        case REACT_PROFILER_TYPE:
		          return "Profiler";
		        case REACT_STRICT_MODE_TYPE:
		          return "StrictMode";
		        case REACT_SUSPENSE_TYPE:
		          return "Suspense";
		        case REACT_SUSPENSE_LIST_TYPE:
		          return "SuspenseList";
		        case REACT_ACTIVITY_TYPE:
		          return "Activity";
		      }
		      if ("object" === typeof type)
		        switch (
		          ("number" === typeof type.tag &&
		            console.error(
		              "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
		            ),
		          type.$$typeof)
		        ) {
		          case REACT_PORTAL_TYPE:
		            return "Portal";
		          case REACT_CONTEXT_TYPE:
		            return type.displayName || "Context";
		          case REACT_CONSUMER_TYPE:
		            return (type._context.displayName || "Context") + ".Consumer";
		          case REACT_FORWARD_REF_TYPE:
		            var innerType = type.render;
		            type = type.displayName;
		            type ||
		              ((type = innerType.displayName || innerType.name || ""),
		              (type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef"));
		            return type;
		          case REACT_MEMO_TYPE:
		            return (
		              (innerType = type.displayName || null),
		              null !== innerType
		                ? innerType
		                : getComponentNameFromType(type.type) || "Memo"
		            );
		          case REACT_LAZY_TYPE:
		            innerType = type._payload;
		            type = type._init;
		            try {
		              return getComponentNameFromType(type(innerType));
		            } catch (x) {}
		        }
		      return null;
		    }
		    function getComponentNameFromFiber(fiber) {
		      var type = fiber.type;
		      switch (fiber.tag) {
		        case 31:
		          return "Activity";
		        case 24:
		          return "Cache";
		        case 9:
		          return (type._context.displayName || "Context") + ".Consumer";
		        case 10:
		          return type.displayName || "Context";
		        case 18:
		          return "DehydratedFragment";
		        case 11:
		          return (
		            (fiber = type.render),
		            (fiber = fiber.displayName || fiber.name || ""),
		            type.displayName ||
		              ("" !== fiber ? "ForwardRef(" + fiber + ")" : "ForwardRef")
		          );
		        case 7:
		          return "Fragment";
		        case 26:
		        case 27:
		        case 5:
		          return type;
		        case 4:
		          return "Portal";
		        case 3:
		          return "Root";
		        case 6:
		          return "Text";
		        case 16:
		          return getComponentNameFromType(type);
		        case 8:
		          return type === REACT_STRICT_MODE_TYPE ? "StrictMode" : "Mode";
		        case 22:
		          return "Offscreen";
		        case 12:
		          return "Profiler";
		        case 21:
		          return "Scope";
		        case 13:
		          return "Suspense";
		        case 19:
		          return "SuspenseList";
		        case 25:
		          return "TracingMarker";
		        case 1:
		        case 0:
		        case 14:
		        case 15:
		          if ("function" === typeof type)
		            return type.displayName || type.name || null;
		          if ("string" === typeof type) return type;
		          break;
		        case 29:
		          type = fiber._debugInfo;
		          if (null != type)
		            for (var i = type.length - 1; 0 <= i; i--)
		              if ("string" === typeof type[i].name) return type[i].name;
		          if (null !== fiber.return)
		            return getComponentNameFromFiber(fiber.return);
		      }
		      return null;
		    }
		    function createCursor(defaultValue) {
		      return { current: defaultValue };
		    }
		    function pop(cursor, fiber) {
		      0 > index$jscomp$0
		        ? console.error("Unexpected pop.")
		        : (fiber !== fiberStack[index$jscomp$0] &&
		            console.error("Unexpected Fiber popped."),
		          (cursor.current = valueStack[index$jscomp$0]),
		          (valueStack[index$jscomp$0] = null),
		          (fiberStack[index$jscomp$0] = null),
		          index$jscomp$0--);
		    }
		    function push(cursor, value, fiber) {
		      index$jscomp$0++;
		      valueStack[index$jscomp$0] = cursor.current;
		      fiberStack[index$jscomp$0] = fiber;
		      cursor.current = value;
		    }
		    function clz32Fallback(x) {
		      x >>>= 0;
		      return 0 === x ? 32 : (31 - ((log$1(x) / LN2) | 0)) | 0;
		    }
		    function getHighestPriorityLanes(lanes) {
		      var pendingSyncLanes = lanes & 42;
		      if (0 !== pendingSyncLanes) return pendingSyncLanes;
		      switch (lanes & -lanes) {
		        case 1:
		          return 1;
		        case 2:
		          return 2;
		        case 4:
		          return 4;
		        case 8:
		          return 8;
		        case 16:
		          return 16;
		        case 32:
		          return 32;
		        case 64:
		          return 64;
		        case 128:
		          return 128;
		        case 256:
		        case 512:
		        case 1024:
		        case 2048:
		        case 4096:
		        case 8192:
		        case 16384:
		        case 32768:
		        case 65536:
		        case 131072:
		          return lanes & 261888;
		        case 262144:
		        case 524288:
		        case 1048576:
		        case 2097152:
		          return lanes & 3932160;
		        case 4194304:
		        case 8388608:
		        case 16777216:
		        case 33554432:
		          return lanes & 62914560;
		        case 67108864:
		          return 67108864;
		        case 134217728:
		          return 134217728;
		        case 268435456:
		          return 268435456;
		        case 536870912:
		          return 536870912;
		        case 1073741824:
		          return 0;
		        default:
		          return (
		            console.error(
		              "Should have found matching lanes. This is a bug in React."
		            ),
		            lanes
		          );
		      }
		    }
		    function getNextLanes(root, wipLanes, rootHasPendingCommit) {
		      var pendingLanes = root.pendingLanes;
		      if (0 === pendingLanes) return 0;
		      var nextLanes = 0,
		        suspendedLanes = root.suspendedLanes,
		        pingedLanes = root.pingedLanes;
		      root = root.warmLanes;
		      var nonIdlePendingLanes = pendingLanes & 134217727;
		      0 !== nonIdlePendingLanes
		        ? ((pendingLanes = nonIdlePendingLanes & ~suspendedLanes),
		          0 !== pendingLanes
		            ? (nextLanes = getHighestPriorityLanes(pendingLanes))
		            : ((pingedLanes &= nonIdlePendingLanes),
		              0 !== pingedLanes
		                ? (nextLanes = getHighestPriorityLanes(pingedLanes))
		                : rootHasPendingCommit ||
		                  ((rootHasPendingCommit = nonIdlePendingLanes & ~root),
		                  0 !== rootHasPendingCommit &&
		                    (nextLanes =
		                      getHighestPriorityLanes(rootHasPendingCommit)))))
		        : ((nonIdlePendingLanes = pendingLanes & ~suspendedLanes),
		          0 !== nonIdlePendingLanes
		            ? (nextLanes = getHighestPriorityLanes(nonIdlePendingLanes))
		            : 0 !== pingedLanes
		              ? (nextLanes = getHighestPriorityLanes(pingedLanes))
		              : rootHasPendingCommit ||
		                ((rootHasPendingCommit = pendingLanes & ~root),
		                0 !== rootHasPendingCommit &&
		                  (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))));
		      return 0 === nextLanes
		        ? 0
		        : 0 !== wipLanes &&
		            wipLanes !== nextLanes &&
		            0 === (wipLanes & suspendedLanes) &&
		            ((suspendedLanes = nextLanes & -nextLanes),
		            (rootHasPendingCommit = wipLanes & -wipLanes),
		            suspendedLanes >= rootHasPendingCommit ||
		              (32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)))
		          ? wipLanes
		          : nextLanes;
		    }
		    function checkIfRootIsPrerendering(root, renderLanes) {
		      return (
		        0 ===
		        (root.pendingLanes &
		          ~(root.suspendedLanes & ~root.pingedLanes) &
		          renderLanes)
		      );
		    }
		    function computeExpirationTime(lane, currentTime) {
		      switch (lane) {
		        case 1:
		        case 2:
		        case 4:
		        case 8:
		        case 64:
		          return currentTime + 250;
		        case 16:
		        case 32:
		        case 128:
		        case 256:
		        case 512:
		        case 1024:
		        case 2048:
		        case 4096:
		        case 8192:
		        case 16384:
		        case 32768:
		        case 65536:
		        case 131072:
		        case 262144:
		        case 524288:
		        case 1048576:
		        case 2097152:
		          return currentTime + 5e3;
		        case 4194304:
		        case 8388608:
		        case 16777216:
		        case 33554432:
		          return -1;
		        case 67108864:
		        case 134217728:
		        case 268435456:
		        case 536870912:
		        case 1073741824:
		          return -1;
		        default:
		          return (
		            console.error(
		              "Should have found matching lanes. This is a bug in React."
		            ),
		            -1
		          );
		      }
		    }
		    function claimNextRetryLane() {
		      var lane = nextRetryLane;
		      nextRetryLane <<= 1;
		      0 === (nextRetryLane & 62914560) && (nextRetryLane = 4194304);
		      return lane;
		    }
		    function createLaneMap(initial) {
		      for (var laneMap = [], i = 0; 31 > i; i++) laneMap.push(initial);
		      return laneMap;
		    }
		    function markRootUpdated$1(root, updateLane) {
		      root.pendingLanes |= updateLane;
		      268435456 !== updateLane &&
		        ((root.suspendedLanes = 0),
		        (root.pingedLanes = 0),
		        (root.warmLanes = 0));
		    }
		    function markRootFinished(
		      root,
		      finishedLanes,
		      remainingLanes,
		      spawnedLane,
		      updatedLanes,
		      suspendedRetryLanes
		    ) {
		      var previouslyPendingLanes = root.pendingLanes;
		      root.pendingLanes = remainingLanes;
		      root.suspendedLanes = 0;
		      root.pingedLanes = 0;
		      root.warmLanes = 0;
		      root.expiredLanes &= remainingLanes;
		      root.entangledLanes &= remainingLanes;
		      root.errorRecoveryDisabledLanes &= remainingLanes;
		      root.shellSuspendCounter = 0;
		      var entanglements = root.entanglements,
		        expirationTimes = root.expirationTimes,
		        hiddenUpdates = root.hiddenUpdates;
		      for (
		        remainingLanes = previouslyPendingLanes & ~remainingLanes;
		        0 < remainingLanes;

		      ) {
		        var index = 31 - clz32(remainingLanes),
		          lane = 1 << index;
		        entanglements[index] = 0;
		        expirationTimes[index] = -1;
		        var hiddenUpdatesForLane = hiddenUpdates[index];
		        if (null !== hiddenUpdatesForLane)
		          for (
		            hiddenUpdates[index] = null, index = 0;
		            index < hiddenUpdatesForLane.length;
		            index++
		          ) {
		            var update = hiddenUpdatesForLane[index];
		            null !== update && (update.lane &= -536870913);
		          }
		        remainingLanes &= ~lane;
		      }
		      0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, 0);
		      0 !== suspendedRetryLanes &&
		        0 === updatedLanes &&
		        0 !== root.tag &&
		        (root.suspendedLanes |=
		          suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
		    }
		    function markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
		      root.pendingLanes |= spawnedLane;
		      root.suspendedLanes &= ~spawnedLane;
		      var spawnedLaneIndex = 31 - clz32(spawnedLane);
		      root.entangledLanes |= spawnedLane;
		      root.entanglements[spawnedLaneIndex] =
		        root.entanglements[spawnedLaneIndex] |
		        1073741824 |
		        (entangledLanes & 261930);
		    }
		    function markRootEntangled(root, entangledLanes) {
		      var rootEntangledLanes = (root.entangledLanes |= entangledLanes);
		      for (root = root.entanglements; rootEntangledLanes; ) {
		        var index = 31 - clz32(rootEntangledLanes),
		          lane = 1 << index;
		        (lane & entangledLanes) | (root[index] & entangledLanes) &&
		          (root[index] |= entangledLanes);
		        rootEntangledLanes &= ~lane;
		      }
		    }
		    function getBumpedLaneForHydration(root, renderLanes) {
		      var renderLane = renderLanes & -renderLanes;
		      renderLane =
		        0 !== (renderLane & 42)
		          ? 1
		          : getBumpedLaneForHydrationByLane(renderLane);
		      return 0 !== (renderLane & (root.suspendedLanes | renderLanes))
		        ? 0
		        : renderLane;
		    }
		    function getBumpedLaneForHydrationByLane(lane) {
		      switch (lane) {
		        case 2:
		          lane = 1;
		          break;
		        case 8:
		          lane = 4;
		          break;
		        case 32:
		          lane = 16;
		          break;
		        case 256:
		        case 512:
		        case 1024:
		        case 2048:
		        case 4096:
		        case 8192:
		        case 16384:
		        case 32768:
		        case 65536:
		        case 131072:
		        case 262144:
		        case 524288:
		        case 1048576:
		        case 2097152:
		        case 4194304:
		        case 8388608:
		        case 16777216:
		        case 33554432:
		          lane = 128;
		          break;
		        case 268435456:
		          lane = 134217728;
		          break;
		        default:
		          lane = 0;
		      }
		      return lane;
		    }
		    function addFiberToLanesMap(root, fiber, lanes) {
		      if (isDevToolsPresent)
		        for (root = root.pendingUpdatersLaneMap; 0 < lanes; ) {
		          var index = 31 - clz32(lanes),
		            lane = 1 << index;
		          root[index].add(fiber);
		          lanes &= ~lane;
		        }
		    }
		    function movePendingFibersToMemoized(root, lanes) {
		      if (isDevToolsPresent)
		        for (
		          var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap,
		            memoizedUpdaters = root.memoizedUpdaters;
		          0 < lanes;

		        ) {
		          var index = 31 - clz32(lanes);
		          root = 1 << index;
		          index = pendingUpdatersLaneMap[index];
		          0 < index.size &&
		            (index.forEach(function (fiber) {
		              var alternate = fiber.alternate;
		              (null !== alternate && memoizedUpdaters.has(alternate)) ||
		                memoizedUpdaters.add(fiber);
		            }),
		            index.clear());
		          lanes &= ~root;
		        }
		    }
		    function lanesToEventPriority(lanes) {
		      lanes &= -lanes;
		      return 2 < lanes
		        ? 8 < lanes
		          ? 0 !== (lanes & 134217727)
		            ? 32
		            : 268435456
		          : 8
		        : 2;
		    }
		    function injectInternals(internals) {
		      if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return false;
		      var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
		      if (hook.isDisabled) return true;
		      if (!hook.supportsFiber)
		        return (
		          console.error(
		            "The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://react.dev/link/react-devtools"
		          ),
		          true
		        );
		      try {
		        (rendererID = hook.inject(internals)), (injectedHook = hook);
		      } catch (err) {
		        console.error("React instrumentation encountered an error: %o.", err);
		      }
		      return hook.checkDCE ? true : false;
		    }
		    function setIsStrictModeForDevtools(newIsStrictMode) {
		      "function" === typeof log &&
		        unstable_setDisableYieldValue(newIsStrictMode);
		      if (injectedHook && "function" === typeof injectedHook.setStrictMode)
		        try {
		          injectedHook.setStrictMode(rendererID, newIsStrictMode);
		        } catch (err) {
		          hasLoggedError ||
		            ((hasLoggedError = true),
		            console.error(
		              "React instrumentation encountered an error: %o",
		              err
		            ));
		        }
		    }
		    function is(x, y) {
		      return (x === y && (0 !== x || 1 / x === 1 / y)) || (x !== x && y !== y);
		    }
		    function getArrayKind(array) {
		      for (var kind = 0, i = 0; i < array.length; i++) {
		        var value = array[i];
		        if ("object" === typeof value && null !== value)
		          if (
		            isArrayImpl(value) &&
		            2 === value.length &&
		            "string" === typeof value[0]
		          ) {
		            if (0 !== kind && 3 !== kind) return 1;
		            kind = 3;
		          } else return 1;
		        else {
		          if (
		            "function" === typeof value ||
		            ("string" === typeof value && 50 < value.length) ||
		            (0 !== kind && 2 !== kind)
		          )
		            return 1;
		          kind = 2;
		        }
		      }
		      return kind;
		    }
		    function addObjectToProperties(object, properties, indent, prefix) {
		      for (var key in object)
		        hasOwnProperty.call(object, key) &&
		          "_" !== key[0] &&
		          addValueToProperties(key, object[key], properties, indent, prefix);
		    }
		    function addValueToProperties(
		      propertyName,
		      value,
		      properties,
		      indent,
		      prefix
		    ) {
		      switch (typeof value) {
		        case "object":
		          if (null === value) {
		            value = "null";
		            break;
		          } else {
		            if (value.$$typeof === REACT_ELEMENT_TYPE) {
		              var typeName = getComponentNameFromType(value.type) || "\u2026",
		                key = value.key;
		              value = value.props;
		              var propsKeys = Object.keys(value),
		                propsLength = propsKeys.length;
		              if (null == key && 0 === propsLength) {
		                value = "<" + typeName + " />";
		                break;
		              }
		              if (
		                3 > indent ||
		                (1 === propsLength &&
		                  "children" === propsKeys[0] &&
		                  null == key)
		              ) {
		                value = "<" + typeName + " \u2026 />";
		                break;
		              }
		              properties.push([
		                prefix + "\u00a0\u00a0".repeat(indent) + propertyName,
		                "<" + typeName
		              ]);
		              null !== key &&
		                addValueToProperties(
		                  "key",
		                  key,
		                  properties,
		                  indent + 1,
		                  prefix
		                );
		              propertyName = false;
		              for (var propKey in value)
		                "children" === propKey
		                  ? null != value.children &&
		                    (!isArrayImpl(value.children) ||
		                      0 < value.children.length) &&
		                    (propertyName = true)
		                  : hasOwnProperty.call(value, propKey) &&
		                    "_" !== propKey[0] &&
		                    addValueToProperties(
		                      propKey,
		                      value[propKey],
		                      properties,
		                      indent + 1,
		                      prefix
		                    );
		              properties.push([
		                "",
		                propertyName ? ">\u2026</" + typeName + ">" : "/>"
		              ]);
		              return;
		            }
		            typeName = Object.prototype.toString.call(value);
		            typeName = typeName.slice(8, typeName.length - 1);
		            if ("Array" === typeName)
		              if (
		                ((propKey = getArrayKind(value)),
		                2 === propKey || 0 === propKey)
		              ) {
		                value = JSON.stringify(value);
		                break;
		              } else if (3 === propKey) {
		                properties.push([
		                  prefix + "\u00a0\u00a0".repeat(indent) + propertyName,
		                  ""
		                ]);
		                for (
		                  propertyName = 0;
		                  propertyName < value.length;
		                  propertyName++
		                )
		                  (typeName = value[propertyName]),
		                    addValueToProperties(
		                      typeName[0],
		                      typeName[1],
		                      properties,
		                      indent + 1,
		                      prefix
		                    );
		                return;
		              }
		            if ("Promise" === typeName) {
		              if ("fulfilled" === value.status) {
		                if (
		                  ((typeName = properties.length),
		                  addValueToProperties(
		                    propertyName,
		                    value.value,
		                    properties,
		                    indent,
		                    prefix
		                  ),
		                  properties.length > typeName)
		                ) {
		                  properties = properties[typeName];
		                  properties[1] =
		                    "Promise<" + (properties[1] || "Object") + ">";
		                  return;
		                }
		              } else if (
		                "rejected" === value.status &&
		                ((typeName = properties.length),
		                addValueToProperties(
		                  propertyName,
		                  value.reason,
		                  properties,
		                  indent,
		                  prefix
		                ),
		                properties.length > typeName)
		              ) {
		                properties = properties[typeName];
		                properties[1] = "Rejected Promise<" + properties[1] + ">";
		                return;
		              }
		              properties.push([
		                "\u00a0\u00a0".repeat(indent) + propertyName,
		                "Promise"
		              ]);
		              return;
		            }
		            "Object" === typeName &&
		              (propKey = Object.getPrototypeOf(value)) &&
		              "function" === typeof propKey.constructor &&
		              (typeName = propKey.constructor.name);
		            properties.push([
		              prefix + "\u00a0\u00a0".repeat(indent) + propertyName,
		              "Object" === typeName ? (3 > indent ? "" : "\u2026") : typeName
		            ]);
		            3 > indent &&
		              addObjectToProperties(value, properties, indent + 1, prefix);
		            return;
		          }
		        case "function":
		          value = "" === value.name ? "() => {}" : value.name + "() {}";
		          break;
		        case "string":
		          value =
		            "This object has been omitted by React in the console log to avoid sending too much data from the server. Try logging smaller or more specific objects." ===
		            value
		              ? "\u2026"
		              : JSON.stringify(value);
		          break;
		        case "undefined":
		          value = "undefined";
		          break;
		        case "boolean":
		          value = value ? "true" : "false";
		          break;
		        default:
		          value = String(value);
		      }
		      properties.push([
		        prefix + "\u00a0\u00a0".repeat(indent) + propertyName,
		        value
		      ]);
		    }
		    function addObjectDiffToProperties(prev, next, properties, indent) {
		      var isDeeplyEqual = true;
		      for (key in prev)
		        key in next ||
		          (properties.push([
		            "\u2013\u00a0" + "\u00a0\u00a0".repeat(indent) + key,
		            "\u2026"
		          ]),
		          (isDeeplyEqual = false));
		      for (var _key in next)
		        if (_key in prev) {
		          var key = prev[_key];
		          var nextValue = next[_key];
		          if (key !== nextValue) {
		            if (0 === indent && "children" === _key)
		              (isDeeplyEqual = "\u00a0\u00a0".repeat(indent) + _key),
		                properties.push(
		                  ["\u2013\u00a0" + isDeeplyEqual, "\u2026"],
		                  ["+\u00a0" + isDeeplyEqual, "\u2026"]
		                );
		            else {
		              if (!(3 <= indent))
		                if (
		                  "object" === typeof key &&
		                  "object" === typeof nextValue &&
		                  null !== key &&
		                  null !== nextValue &&
		                  key.$$typeof === nextValue.$$typeof
		                )
		                  if (nextValue.$$typeof === REACT_ELEMENT_TYPE) {
		                    if (
		                      key.type === nextValue.type &&
		                      key.key === nextValue.key
		                    ) {
		                      key =
		                        getComponentNameFromType(nextValue.type) || "\u2026";
		                      isDeeplyEqual = "\u00a0\u00a0".repeat(indent) + _key;
		                      key = "<" + key + " \u2026 />";
		                      properties.push(
		                        ["\u2013\u00a0" + isDeeplyEqual, key],
		                        ["+\u00a0" + isDeeplyEqual, key]
		                      );
		                      isDeeplyEqual = false;
		                      continue;
		                    }
		                  } else {
		                    var prevKind = Object.prototype.toString.call(key),
		                      nextKind = Object.prototype.toString.call(nextValue);
		                    if (
		                      prevKind === nextKind &&
		                      ("[object Object]" === nextKind ||
		                        "[object Array]" === nextKind)
		                    ) {
		                      prevKind = [
		                        "\u2007\u00a0" + "\u00a0\u00a0".repeat(indent) + _key,
		                        "[object Array]" === nextKind ? "Array" : ""
		                      ];
		                      properties.push(prevKind);
		                      nextKind = properties.length;
		                      addObjectDiffToProperties(
		                        key,
		                        nextValue,
		                        properties,
		                        indent + 1
		                      )
		                        ? nextKind === properties.length &&
		                          (prevKind[1] =
		                            "Referentially unequal but deeply equal objects. Consider memoization.")
		                        : (isDeeplyEqual = false);
		                      continue;
		                    }
		                  }
		                else if (
		                  "function" === typeof key &&
		                  "function" === typeof nextValue &&
		                  key.name === nextValue.name &&
		                  key.length === nextValue.length &&
		                  ((prevKind = Function.prototype.toString.call(key)),
		                  (nextKind = Function.prototype.toString.call(nextValue)),
		                  prevKind === nextKind)
		                ) {
		                  key =
		                    "" === nextValue.name
		                      ? "() => {}"
		                      : nextValue.name + "() {}";
		                  properties.push([
		                    "\u2007\u00a0" + "\u00a0\u00a0".repeat(indent) + _key,
		                    key +
		                      " Referentially unequal function closure. Consider memoization."
		                  ]);
		                  continue;
		                }
		              addValueToProperties(
		                _key,
		                key,
		                properties,
		                indent,
		                "\u2013\u00a0"
		              );
		              addValueToProperties(
		                _key,
		                nextValue,
		                properties,
		                indent,
		                "+\u00a0"
		              );
		            }
		            isDeeplyEqual = false;
		          }
		        } else
		          properties.push([
		            "+\u00a0" + "\u00a0\u00a0".repeat(indent) + _key,
		            "\u2026"
		          ]),
		            (isDeeplyEqual = false);
		      return isDeeplyEqual;
		    }
		    function setCurrentTrackFromLanes(lanes) {
		      currentTrack =
		        lanes & 63
		          ? "Blocking"
		          : lanes & 64
		            ? "Gesture"
		            : lanes & 4194176
		              ? "Transition"
		              : lanes & 62914560
		                ? "Suspense"
		                : lanes & 2080374784
		                  ? "Idle"
		                  : "Other";
		    }
		    function logComponentTrigger(fiber, startTime, endTime, trigger) {
		      supportsUserTiming &&
		        ((reusableComponentOptions.start = startTime),
		        (reusableComponentOptions.end = endTime),
		        (reusableComponentDevToolDetails.color = "warning"),
		        (reusableComponentDevToolDetails.tooltipText = trigger),
		        (reusableComponentDevToolDetails.properties = null),
		        (fiber = fiber._debugTask)
		          ? fiber.run(
		              performance.measure.bind(
		                performance,
		                trigger,
		                reusableComponentOptions
		              )
		            )
		          : performance.measure(trigger, reusableComponentOptions));
		    }
		    function logComponentReappeared(fiber, startTime, endTime) {
		      logComponentTrigger(fiber, startTime, endTime, "Reconnect");
		    }
		    function logComponentRender(
		      fiber,
		      startTime,
		      endTime,
		      wasHydrated,
		      committedLanes
		    ) {
		      var name = getComponentNameFromFiber(fiber);
		      if (null !== name && supportsUserTiming) {
		        var alternate = fiber.alternate,
		          selfTime = fiber.actualDuration;
		        if (null === alternate || alternate.child !== fiber.child)
		          for (var child = fiber.child; null !== child; child = child.sibling)
		            selfTime -= child.actualDuration;
		        wasHydrated =
		          0.5 > selfTime
		            ? wasHydrated
		              ? "tertiary-light"
		              : "primary-light"
		            : 10 > selfTime
		              ? wasHydrated
		                ? "tertiary"
		                : "primary"
		              : 100 > selfTime
		                ? wasHydrated
		                  ? "tertiary-dark"
		                  : "primary-dark"
		                : "error";
		        var props = fiber.memoizedProps;
		        selfTime = fiber._debugTask;
		        null !== props &&
		        null !== alternate &&
		        alternate.memoizedProps !== props
		          ? ((child = [resuableChangedPropsEntry]),
		            (props = addObjectDiffToProperties(
		              alternate.memoizedProps,
		              props,
		              child,
		              0
		            )),
		            1 < child.length &&
		              (props &&
		              !alreadyWarnedForDeepEquality &&
		              0 === (alternate.lanes & committedLanes) &&
		              100 < fiber.actualDuration
		                ? ((alreadyWarnedForDeepEquality = true),
		                  (child[0] = reusableDeeplyEqualPropsEntry),
		                  (reusableComponentDevToolDetails.color = "warning"),
		                  (reusableComponentDevToolDetails.tooltipText =
		                    "This component received deeply equal props. It might benefit from useMemo or the React Compiler in its owner."))
		                : ((reusableComponentDevToolDetails.color = wasHydrated),
		                  (reusableComponentDevToolDetails.tooltipText = name)),
		              (reusableComponentDevToolDetails.properties = child),
		              (reusableComponentOptions.start = startTime),
		              (reusableComponentOptions.end = endTime),
		              null != selfTime
		                ? selfTime.run(
		                    performance.measure.bind(
		                      performance,
		                      "\u200b" + name,
		                      reusableComponentOptions
		                    )
		                  )
		                : performance.measure(
		                    "\u200b" + name,
		                    reusableComponentOptions
		                  )))
		          : null != selfTime
		            ? selfTime.run(
		                console.timeStamp.bind(
		                  console,
		                  name,
		                  startTime,
		                  endTime,
		                  "Components \u269b",
		                  void 0,
		                  wasHydrated
		                )
		              )
		            : console.timeStamp(
		                name,
		                startTime,
		                endTime,
		                "Components \u269b",
		                void 0,
		                wasHydrated
		              );
		      }
		    }
		    function logComponentErrored(fiber, startTime, endTime, errors) {
		      if (supportsUserTiming) {
		        var name = getComponentNameFromFiber(fiber);
		        if (null !== name) {
		          for (
		            var debugTask = null, properties = [], i = 0;
		            i < errors.length;
		            i++
		          ) {
		            var capturedValue = errors[i];
		            null == debugTask &&
		              null !== capturedValue.source &&
		              (debugTask = capturedValue.source._debugTask);
		            capturedValue = capturedValue.value;
		            properties.push([
		              "Error",
		              "object" === typeof capturedValue &&
		              null !== capturedValue &&
		              "string" === typeof capturedValue.message
		                ? String(capturedValue.message)
		                : String(capturedValue)
		            ]);
		          }
		          null !== fiber.key &&
		            addValueToProperties("key", fiber.key, properties, 0, "");
		          null !== fiber.memoizedProps &&
		            addObjectToProperties(fiber.memoizedProps, properties, 0, "");
		          null == debugTask && (debugTask = fiber._debugTask);
		          fiber = {
		            start: startTime,
		            end: endTime,
		            detail: {
		              devtools: {
		                color: "error",
		                track: "Components \u269b",
		                tooltipText:
		                  13 === fiber.tag
		                    ? "Hydration failed"
		                    : "Error boundary caught an error",
		                properties: properties
		              }
		            }
		          };
		          debugTask
		            ? debugTask.run(
		                performance.measure.bind(performance, "\u200b" + name, fiber)
		              )
		            : performance.measure("\u200b" + name, fiber);
		        }
		      }
		    }
		    function logComponentEffect(fiber, startTime, endTime, selfTime, errors) {
		      if (null !== errors) {
		        if (supportsUserTiming) {
		          var name = getComponentNameFromFiber(fiber);
		          if (null !== name) {
		            selfTime = [];
		            for (var i = 0; i < errors.length; i++) {
		              var error = errors[i].value;
		              selfTime.push([
		                "Error",
		                "object" === typeof error &&
		                null !== error &&
		                "string" === typeof error.message
		                  ? String(error.message)
		                  : String(error)
		              ]);
		            }
		            null !== fiber.key &&
		              addValueToProperties("key", fiber.key, selfTime, 0, "");
		            null !== fiber.memoizedProps &&
		              addObjectToProperties(fiber.memoizedProps, selfTime, 0, "");
		            startTime = {
		              start: startTime,
		              end: endTime,
		              detail: {
		                devtools: {
		                  color: "error",
		                  track: "Components \u269b",
		                  tooltipText: "A lifecycle or effect errored",
		                  properties: selfTime
		                }
		              }
		            };
		            (fiber = fiber._debugTask)
		              ? fiber.run(
		                  performance.measure.bind(
		                    performance,
		                    "\u200b" + name,
		                    startTime
		                  )
		                )
		              : performance.measure("\u200b" + name, startTime);
		          }
		        }
		      } else
		        (name = getComponentNameFromFiber(fiber)),
		          null !== name &&
		            supportsUserTiming &&
		            ((errors =
		              1 > selfTime
		                ? "secondary-light"
		                : 100 > selfTime
		                  ? "secondary"
		                  : 500 > selfTime
		                    ? "secondary-dark"
		                    : "error"),
		            (fiber = fiber._debugTask)
		              ? fiber.run(
		                  console.timeStamp.bind(
		                    console,
		                    name,
		                    startTime,
		                    endTime,
		                    "Components \u269b",
		                    void 0,
		                    errors
		                  )
		                )
		              : console.timeStamp(
		                  name,
		                  startTime,
		                  endTime,
		                  "Components \u269b",
		                  void 0,
		                  errors
		                ));
		    }
		    function logRenderPhase(startTime, endTime, lanes, debugTask) {
		      if (supportsUserTiming && !(endTime <= startTime)) {
		        var color =
		          (lanes & 738197653) === lanes ? "tertiary-dark" : "primary-dark";
		        lanes =
		          (lanes & 536870912) === lanes
		            ? "Prepared"
		            : (lanes & 201326741) === lanes
		              ? "Hydrated"
		              : "Render";
		        debugTask
		          ? debugTask.run(
		              console.timeStamp.bind(
		                console,
		                lanes,
		                startTime,
		                endTime,
		                currentTrack,
		                "Scheduler \u269b",
		                color
		              )
		            )
		          : console.timeStamp(
		              lanes,
		              startTime,
		              endTime,
		              currentTrack,
		              "Scheduler \u269b",
		              color
		            );
		      }
		    }
		    function logSuspendedRenderPhase(startTime, endTime, lanes, debugTask) {
		      !supportsUserTiming ||
		        endTime <= startTime ||
		        ((lanes =
		          (lanes & 738197653) === lanes ? "tertiary-dark" : "primary-dark"),
		        debugTask
		          ? debugTask.run(
		              console.timeStamp.bind(
		                console,
		                "Prewarm",
		                startTime,
		                endTime,
		                currentTrack,
		                "Scheduler \u269b",
		                lanes
		              )
		            )
		          : console.timeStamp(
		              "Prewarm",
		              startTime,
		              endTime,
		              currentTrack,
		              "Scheduler \u269b",
		              lanes
		            ));
		    }
		    function logSuspendedWithDelayPhase(startTime, endTime, lanes, debugTask) {
		      !supportsUserTiming ||
		        endTime <= startTime ||
		        ((lanes =
		          (lanes & 738197653) === lanes ? "tertiary-dark" : "primary-dark"),
		        debugTask
		          ? debugTask.run(
		              console.timeStamp.bind(
		                console,
		                "Suspended",
		                startTime,
		                endTime,
		                currentTrack,
		                "Scheduler \u269b",
		                lanes
		              )
		            )
		          : console.timeStamp(
		              "Suspended",
		              startTime,
		              endTime,
		              currentTrack,
		              "Scheduler \u269b",
		              lanes
		            ));
		    }
		    function logRecoveredRenderPhase(
		      startTime,
		      endTime,
		      lanes,
		      recoverableErrors,
		      hydrationFailed,
		      debugTask
		    ) {
		      if (supportsUserTiming && !(endTime <= startTime)) {
		        lanes = [];
		        for (var i = 0; i < recoverableErrors.length; i++) {
		          var error = recoverableErrors[i].value;
		          lanes.push([
		            "Recoverable Error",
		            "object" === typeof error &&
		            null !== error &&
		            "string" === typeof error.message
		              ? String(error.message)
		              : String(error)
		          ]);
		        }
		        startTime = {
		          start: startTime,
		          end: endTime,
		          detail: {
		            devtools: {
		              color: "primary-dark",
		              track: currentTrack,
		              trackGroup: "Scheduler \u269b",
		              tooltipText: hydrationFailed
		                ? "Hydration Failed"
		                : "Recovered after Error",
		              properties: lanes
		            }
		          }
		        };
		        debugTask
		          ? debugTask.run(
		              performance.measure.bind(performance, "Recovered", startTime)
		            )
		          : performance.measure("Recovered", startTime);
		      }
		    }
		    function logErroredRenderPhase(startTime, endTime, lanes, debugTask) {
		      !supportsUserTiming ||
		        endTime <= startTime ||
		        (debugTask
		          ? debugTask.run(
		              console.timeStamp.bind(
		                console,
		                "Errored",
		                startTime,
		                endTime,
		                currentTrack,
		                "Scheduler \u269b",
		                "error"
		              )
		            )
		          : console.timeStamp(
		              "Errored",
		              startTime,
		              endTime,
		              currentTrack,
		              "Scheduler \u269b",
		              "error"
		            ));
		    }
		    function logSuspendedCommitPhase(startTime, endTime, reason, debugTask) {
		      !supportsUserTiming ||
		        endTime <= startTime ||
		        (debugTask
		          ? debugTask.run(
		              console.timeStamp.bind(
		                console,
		                reason,
		                startTime,
		                endTime,
		                currentTrack,
		                "Scheduler \u269b",
		                "secondary-light"
		              )
		            )
		          : console.timeStamp(
		              reason,
		              startTime,
		              endTime,
		              currentTrack,
		              "Scheduler \u269b",
		              "secondary-light"
		            ));
		    }
		    function logCommitErrored(startTime, endTime, errors, passive, debugTask) {
		      if (supportsUserTiming && !(endTime <= startTime)) {
		        for (var properties = [], i = 0; i < errors.length; i++) {
		          var error = errors[i].value;
		          properties.push([
		            "Error",
		            "object" === typeof error &&
		            null !== error &&
		            "string" === typeof error.message
		              ? String(error.message)
		              : String(error)
		          ]);
		        }
		        startTime = {
		          start: startTime,
		          end: endTime,
		          detail: {
		            devtools: {
		              color: "error",
		              track: currentTrack,
		              trackGroup: "Scheduler \u269b",
		              tooltipText: passive
		                ? "Remaining Effects Errored"
		                : "Commit Errored",
		              properties: properties
		            }
		          }
		        };
		        debugTask
		          ? debugTask.run(
		              performance.measure.bind(performance, "Errored", startTime)
		            )
		          : performance.measure("Errored", startTime);
		      }
		    }
		    function disabledLog() {}
		    function disableLogs() {
		      if (0 === disabledDepth) {
		        prevLog = console.log;
		        prevInfo = console.info;
		        prevWarn = console.warn;
		        prevError = console.error;
		        prevGroup = console.group;
		        prevGroupCollapsed = console.groupCollapsed;
		        prevGroupEnd = console.groupEnd;
		        var props = {
		          configurable: true,
		          enumerable: true,
		          value: disabledLog,
		          writable: true
		        };
		        Object.defineProperties(console, {
		          info: props,
		          log: props,
		          warn: props,
		          error: props,
		          group: props,
		          groupCollapsed: props,
		          groupEnd: props
		        });
		      }
		      disabledDepth++;
		    }
		    function reenableLogs() {
		      disabledDepth--;
		      if (0 === disabledDepth) {
		        var props = { configurable: true, enumerable: true, writable: true };
		        Object.defineProperties(console, {
		          log: assign({}, props, { value: prevLog }),
		          info: assign({}, props, { value: prevInfo }),
		          warn: assign({}, props, { value: prevWarn }),
		          error: assign({}, props, { value: prevError }),
		          group: assign({}, props, { value: prevGroup }),
		          groupCollapsed: assign({}, props, { value: prevGroupCollapsed }),
		          groupEnd: assign({}, props, { value: prevGroupEnd })
		        });
		      }
		      0 > disabledDepth &&
		        console.error(
		          "disabledDepth fell below zero. This is a bug in React. Please file an issue."
		        );
		    }
		    function formatOwnerStack(error) {
		      var prevPrepareStackTrace = Error.prepareStackTrace;
		      Error.prepareStackTrace = void 0;
		      error = error.stack;
		      Error.prepareStackTrace = prevPrepareStackTrace;
		      error.startsWith("Error: react-stack-top-frame\n") &&
		        (error = error.slice(29));
		      prevPrepareStackTrace = error.indexOf("\n");
		      -1 !== prevPrepareStackTrace &&
		        (error = error.slice(prevPrepareStackTrace + 1));
		      prevPrepareStackTrace = error.indexOf("react_stack_bottom_frame");
		      -1 !== prevPrepareStackTrace &&
		        (prevPrepareStackTrace = error.lastIndexOf(
		          "\n",
		          prevPrepareStackTrace
		        ));
		      if (-1 !== prevPrepareStackTrace)
		        error = error.slice(0, prevPrepareStackTrace);
		      else return "";
		      return error;
		    }
		    function describeBuiltInComponentFrame(name) {
		      if (void 0 === prefix)
		        try {
		          throw Error();
		        } catch (x) {
		          var match = x.stack.trim().match(/\n( *(at )?)/);
		          prefix = (match && match[1]) || "";
		          suffix =
		            -1 < x.stack.indexOf("\n    at")
		              ? " (<anonymous>)"
		              : -1 < x.stack.indexOf("@")
		                ? "@unknown:0:0"
		                : "";
		        }
		      return "\n" + prefix + name + suffix;
		    }
		    function describeNativeComponentFrame(fn, construct) {
		      if (!fn || reentry) return "";
		      var frame = componentFrameCache.get(fn);
		      if (void 0 !== frame) return frame;
		      reentry = true;
		      frame = Error.prepareStackTrace;
		      Error.prepareStackTrace = void 0;
		      var previousDispatcher = null;
		      previousDispatcher = ReactSharedInternals.H;
		      ReactSharedInternals.H = null;
		      disableLogs();
		      try {
		        var RunInRootFrame = {
		          DetermineComponentFrameRoot: function () {
		            try {
		              if (construct) {
		                var Fake = function () {
		                  throw Error();
		                };
		                Object.defineProperty(Fake.prototype, "props", {
		                  set: function () {
		                    throw Error();
		                  }
		                });
		                if ("object" === typeof Reflect && Reflect.construct) {
		                  try {
		                    Reflect.construct(Fake, []);
		                  } catch (x) {
		                    var control = x;
		                  }
		                  Reflect.construct(fn, [], Fake);
		                } else {
		                  try {
		                    Fake.call();
		                  } catch (x$0) {
		                    control = x$0;
		                  }
		                  fn.call(Fake.prototype);
		                }
		              } else {
		                try {
		                  throw Error();
		                } catch (x$1) {
		                  control = x$1;
		                }
		                (Fake = fn()) &&
		                  "function" === typeof Fake.catch &&
		                  Fake.catch(function () {});
		              }
		            } catch (sample) {
		              if (sample && control && "string" === typeof sample.stack)
		                return [sample.stack, control.stack];
		            }
		            return [null, null];
		          }
		        };
		        RunInRootFrame.DetermineComponentFrameRoot.displayName =
		          "DetermineComponentFrameRoot";
		        var namePropDescriptor = Object.getOwnPropertyDescriptor(
		          RunInRootFrame.DetermineComponentFrameRoot,
		          "name"
		        );
		        namePropDescriptor &&
		          namePropDescriptor.configurable &&
		          Object.defineProperty(
		            RunInRootFrame.DetermineComponentFrameRoot,
		            "name",
		            { value: "DetermineComponentFrameRoot" }
		          );
		        var _RunInRootFrame$Deter =
		            RunInRootFrame.DetermineComponentFrameRoot(),
		          sampleStack = _RunInRootFrame$Deter[0],
		          controlStack = _RunInRootFrame$Deter[1];
		        if (sampleStack && controlStack) {
		          var sampleLines = sampleStack.split("\n"),
		            controlLines = controlStack.split("\n");
		          for (
		            _RunInRootFrame$Deter = namePropDescriptor = 0;
		            namePropDescriptor < sampleLines.length &&
		            !sampleLines[namePropDescriptor].includes(
		              "DetermineComponentFrameRoot"
		            );

		          )
		            namePropDescriptor++;
		          for (
		            ;
		            _RunInRootFrame$Deter < controlLines.length &&
		            !controlLines[_RunInRootFrame$Deter].includes(
		              "DetermineComponentFrameRoot"
		            );

		          )
		            _RunInRootFrame$Deter++;
		          if (
		            namePropDescriptor === sampleLines.length ||
		            _RunInRootFrame$Deter === controlLines.length
		          )
		            for (
		              namePropDescriptor = sampleLines.length - 1,
		                _RunInRootFrame$Deter = controlLines.length - 1;
		              1 <= namePropDescriptor &&
		              0 <= _RunInRootFrame$Deter &&
		              sampleLines[namePropDescriptor] !==
		                controlLines[_RunInRootFrame$Deter];

		            )
		              _RunInRootFrame$Deter--;
		          for (
		            ;
		            1 <= namePropDescriptor && 0 <= _RunInRootFrame$Deter;
		            namePropDescriptor--, _RunInRootFrame$Deter--
		          )
		            if (
		              sampleLines[namePropDescriptor] !==
		              controlLines[_RunInRootFrame$Deter]
		            ) {
		              if (1 !== namePropDescriptor || 1 !== _RunInRootFrame$Deter) {
		                do
		                  if (
		                    (namePropDescriptor--,
		                    _RunInRootFrame$Deter--,
		                    0 > _RunInRootFrame$Deter ||
		                      sampleLines[namePropDescriptor] !==
		                        controlLines[_RunInRootFrame$Deter])
		                  ) {
		                    var _frame =
		                      "\n" +
		                      sampleLines[namePropDescriptor].replace(
		                        " at new ",
		                        " at "
		                      );
		                    fn.displayName &&
		                      _frame.includes("<anonymous>") &&
		                      (_frame = _frame.replace("<anonymous>", fn.displayName));
		                    "function" === typeof fn &&
		                      componentFrameCache.set(fn, _frame);
		                    return _frame;
		                  }
		                while (1 <= namePropDescriptor && 0 <= _RunInRootFrame$Deter);
		              }
		              break;
		            }
		        }
		      } finally {
		        (reentry = false),
		          (ReactSharedInternals.H = previousDispatcher),
		          reenableLogs(),
		          (Error.prepareStackTrace = frame);
		      }
		      sampleLines = (sampleLines = fn ? fn.displayName || fn.name : "")
		        ? describeBuiltInComponentFrame(sampleLines)
		        : "";
		      "function" === typeof fn && componentFrameCache.set(fn, sampleLines);
		      return sampleLines;
		    }
		    function describeFiber(fiber, childFiber) {
		      switch (fiber.tag) {
		        case 26:
		        case 27:
		        case 5:
		          return describeBuiltInComponentFrame(fiber.type);
		        case 16:
		          return describeBuiltInComponentFrame("Lazy");
		        case 13:
		          return fiber.child !== childFiber && null !== childFiber
		            ? describeBuiltInComponentFrame("Suspense Fallback")
		            : describeBuiltInComponentFrame("Suspense");
		        case 19:
		          return describeBuiltInComponentFrame("SuspenseList");
		        case 0:
		        case 15:
		          return describeNativeComponentFrame(fiber.type, false);
		        case 11:
		          return describeNativeComponentFrame(fiber.type.render, false);
		        case 1:
		          return describeNativeComponentFrame(fiber.type, true);
		        case 31:
		          return describeBuiltInComponentFrame("Activity");
		        default:
		          return "";
		      }
		    }
		    function getStackByFiberInDevAndProd(workInProgress) {
		      try {
		        var info = "",
		          previous = null;
		        do {
		          info += describeFiber(workInProgress, previous);
		          var debugInfo = workInProgress._debugInfo;
		          if (debugInfo)
		            for (var i = debugInfo.length - 1; 0 <= i; i--) {
		              var entry = debugInfo[i];
		              if ("string" === typeof entry.name) {
		                var JSCompiler_temp_const = info;
		                a: {
		                  var name = entry.name,
		                    env = entry.env,
		                    location = entry.debugLocation;
		                  if (null != location) {
		                    var childStack = formatOwnerStack(location),
		                      idx = childStack.lastIndexOf("\n"),
		                      lastLine =
		                        -1 === idx ? childStack : childStack.slice(idx + 1);
		                    if (-1 !== lastLine.indexOf(name)) {
		                      var JSCompiler_inline_result = "\n" + lastLine;
		                      break a;
		                    }
		                  }
		                  JSCompiler_inline_result = describeBuiltInComponentFrame(
		                    name + (env ? " [" + env + "]" : "")
		                  );
		                }
		                info = JSCompiler_temp_const + JSCompiler_inline_result;
		              }
		            }
		          previous = workInProgress;
		          workInProgress = workInProgress.return;
		        } while (workInProgress);
		        return info;
		      } catch (x) {
		        return "\nError generating stack: " + x.message + "\n" + x.stack;
		      }
		    }
		    function describeFunctionComponentFrameWithoutLineNumber(fn) {
		      return (fn = fn ? fn.displayName || fn.name : "")
		        ? describeBuiltInComponentFrame(fn)
		        : "";
		    }
		    function createCapturedValueAtFiber(value, source) {
		      if ("object" === typeof value && null !== value) {
		        var existing = CapturedStacks.get(value);
		        if (void 0 !== existing) return existing;
		        source = {
		          value: value,
		          source: source,
		          stack: getStackByFiberInDevAndProd(source)
		        };
		        CapturedStacks.set(value, source);
		        return source;
		      }
		      return {
		        value: value,
		        source: source,
		        stack: getStackByFiberInDevAndProd(source)
		      };
		    }
		    function pushTreeFork(workInProgress, totalChildren) {
		      warnIfNotHydrating();
		      forkStack[forkStackIndex++] = treeForkCount;
		      forkStack[forkStackIndex++] = treeForkProvider;
		      treeForkProvider = workInProgress;
		      treeForkCount = totalChildren;
		    }
		    function pushTreeId(workInProgress, totalChildren, index) {
		      warnIfNotHydrating();
		      idStack[idStackIndex++] = treeContextId;
		      idStack[idStackIndex++] = treeContextOverflow;
		      idStack[idStackIndex++] = treeContextProvider;
		      treeContextProvider = workInProgress;
		      var baseIdWithLeadingBit = treeContextId;
		      workInProgress = treeContextOverflow;
		      var baseLength = 32 - clz32(baseIdWithLeadingBit) - 1;
		      baseIdWithLeadingBit &= ~(1 << baseLength);
		      index += 1;
		      var length = 32 - clz32(totalChildren) + baseLength;
		      if (30 < length) {
		        var numberOfOverflowBits = baseLength - (baseLength % 5);
		        length = (
		          baseIdWithLeadingBit &
		          ((1 << numberOfOverflowBits) - 1)
		        ).toString(32);
		        baseIdWithLeadingBit >>= numberOfOverflowBits;
		        baseLength -= numberOfOverflowBits;
		        treeContextId =
		          (1 << (32 - clz32(totalChildren) + baseLength)) |
		          (index << baseLength) |
		          baseIdWithLeadingBit;
		        treeContextOverflow = length + workInProgress;
		      } else
		        (treeContextId =
		          (1 << length) | (index << baseLength) | baseIdWithLeadingBit),
		          (treeContextOverflow = workInProgress);
		    }
		    function pushMaterializedTreeId(workInProgress) {
		      warnIfNotHydrating();
		      null !== workInProgress.return &&
		        (pushTreeFork(workInProgress, 1), pushTreeId(workInProgress, 1, 0));
		    }
		    function popTreeContext(workInProgress) {
		      for (; workInProgress === treeForkProvider; )
		        (treeForkProvider = forkStack[--forkStackIndex]),
		          (forkStack[forkStackIndex] = null),
		          (treeForkCount = forkStack[--forkStackIndex]),
		          (forkStack[forkStackIndex] = null);
		      for (; workInProgress === treeContextProvider; )
		        (treeContextProvider = idStack[--idStackIndex]),
		          (idStack[idStackIndex] = null),
		          (treeContextOverflow = idStack[--idStackIndex]),
		          (idStack[idStackIndex] = null),
		          (treeContextId = idStack[--idStackIndex]),
		          (idStack[idStackIndex] = null);
		    }
		    function getSuspendedTreeContext() {
		      warnIfNotHydrating();
		      return null !== treeContextProvider
		        ? { id: treeContextId, overflow: treeContextOverflow }
		        : null;
		    }
		    function restoreSuspendedTreeContext(workInProgress, suspendedContext) {
		      warnIfNotHydrating();
		      idStack[idStackIndex++] = treeContextId;
		      idStack[idStackIndex++] = treeContextOverflow;
		      idStack[idStackIndex++] = treeContextProvider;
		      treeContextId = suspendedContext.id;
		      treeContextOverflow = suspendedContext.overflow;
		      treeContextProvider = workInProgress;
		    }
		    function warnIfNotHydrating() {
		      isHydrating ||
		        console.error(
		          "Expected to be hydrating. This is a bug in React. Please file an issue."
		        );
		    }
		    function requiredContext(c) {
		      null === c &&
		        console.error(
		          "Expected host context to exist. This error is likely caused by a bug in React. Please file an issue."
		        );
		      return c;
		    }
		    function pushHostContainer(fiber, nextRootInstance) {
		      push(rootInstanceStackCursor, nextRootInstance, fiber);
		      push(contextFiberStackCursor, fiber, fiber);
		      push(contextStackCursor, null, fiber);
		      nextRootInstance = getRootHostContext(nextRootInstance);
		      pop(contextStackCursor, fiber);
		      push(contextStackCursor, nextRootInstance, fiber);
		    }
		    function popHostContainer(fiber) {
		      pop(contextStackCursor, fiber);
		      pop(contextFiberStackCursor, fiber);
		      pop(rootInstanceStackCursor, fiber);
		    }
		    function getHostContext() {
		      return requiredContext(contextStackCursor.current);
		    }
		    function pushHostContext(fiber) {
		      null !== fiber.memoizedState &&
		        push(hostTransitionProviderCursor, fiber, fiber);
		      var context = requiredContext(contextStackCursor.current),
		        nextContext = getChildHostContext(context, fiber.type);
		      context !== nextContext &&
		        (push(contextFiberStackCursor, fiber, fiber),
		        push(contextStackCursor, nextContext, fiber));
		    }
		    function popHostContext(fiber) {
		      contextFiberStackCursor.current === fiber &&
		        (pop(contextStackCursor, fiber), pop(contextFiberStackCursor, fiber));
		      hostTransitionProviderCursor.current === fiber &&
		        (pop(hostTransitionProviderCursor, fiber),
		        isPrimaryRenderer
		          ? (HostTransitionContext._currentValue = NotPendingTransition)
		          : (HostTransitionContext._currentValue2 = NotPendingTransition));
		    }
		    function findNotableNode(node, indent) {
		      return void 0 === node.serverProps &&
		        0 === node.serverTail.length &&
		        1 === node.children.length &&
		        3 < node.distanceFromLeaf &&
		        node.distanceFromLeaf > 15 - indent
		        ? findNotableNode(node.children[0], indent)
		        : node;
		    }
		    function indentation(indent) {
		      return "  " + "  ".repeat(indent);
		    }
		    function added(indent) {
		      return "+ " + "  ".repeat(indent);
		    }
		    function removed(indent) {
		      return "- " + "  ".repeat(indent);
		    }
		    function describeFiberType(fiber) {
		      switch (fiber.tag) {
		        case 26:
		        case 27:
		        case 5:
		          return fiber.type;
		        case 16:
		          return "Lazy";
		        case 31:
		          return "Activity";
		        case 13:
		          return "Suspense";
		        case 19:
		          return "SuspenseList";
		        case 0:
		        case 15:
		          return (fiber = fiber.type), fiber.displayName || fiber.name || null;
		        case 11:
		          return (
		            (fiber = fiber.type.render), fiber.displayName || fiber.name || null
		          );
		        case 1:
		          return (fiber = fiber.type), fiber.displayName || fiber.name || null;
		        default:
		          return null;
		      }
		    }
		    function describeTextNode(content, maxLength) {
		      return needsEscaping.test(content)
		        ? ((content = JSON.stringify(content)),
		          content.length > maxLength - 2
		            ? 8 > maxLength
		              ? '{"..."}'
		              : "{" + content.slice(0, maxLength - 7) + '..."}'
		            : "{" + content + "}")
		        : content.length > maxLength
		          ? 5 > maxLength
		            ? '{"..."}'
		            : content.slice(0, maxLength - 3) + "..."
		          : content;
		    }
		    function describeTextDiff(clientText, serverProps, indent) {
		      var maxLength = 120 - 2 * indent;
		      if (null === serverProps)
		        return added(indent) + describeTextNode(clientText, maxLength) + "\n";
		      if ("string" === typeof serverProps) {
		        for (
		          var firstDiff = 0;
		          firstDiff < serverProps.length &&
		          firstDiff < clientText.length &&
		          serverProps.charCodeAt(firstDiff) ===
		            clientText.charCodeAt(firstDiff);
		          firstDiff++
		        );
		        firstDiff > maxLength - 8 &&
		          10 < firstDiff &&
		          ((clientText = "..." + clientText.slice(firstDiff - 8)),
		          (serverProps = "..." + serverProps.slice(firstDiff - 8)));
		        return (
		          added(indent) +
		          describeTextNode(clientText, maxLength) +
		          "\n" +
		          removed(indent) +
		          describeTextNode(serverProps, maxLength) +
		          "\n"
		        );
		      }
		      return (
		        indentation(indent) + describeTextNode(clientText, maxLength) + "\n"
		      );
		    }
		    function objectName(object) {
		      return Object.prototype.toString
		        .call(object)
		        .replace(/^\[object (.*)\]$/, function (m, p0) {
		          return p0;
		        });
		    }
		    function describeValue(value, maxLength) {
		      switch (typeof value) {
		        case "string":
		          return (
		            (value = JSON.stringify(value)),
		            value.length > maxLength
		              ? 5 > maxLength
		                ? '"..."'
		                : value.slice(0, maxLength - 4) + '..."'
		              : value
		          );
		        case "object":
		          if (null === value) return "null";
		          if (isArrayImpl(value)) return "[...]";
		          if (value.$$typeof === REACT_ELEMENT_TYPE)
		            return (maxLength = getComponentNameFromType(value.type))
		              ? "<" + maxLength + ">"
		              : "<...>";
		          var name = objectName(value);
		          if ("Object" === name) {
		            name = "";
		            maxLength -= 2;
		            for (var propName in value)
		              if (value.hasOwnProperty(propName)) {
		                var jsonPropName = JSON.stringify(propName);
		                jsonPropName !== '"' + propName + '"' &&
		                  (propName = jsonPropName);
		                maxLength -= propName.length - 2;
		                jsonPropName = describeValue(
		                  value[propName],
		                  15 > maxLength ? maxLength : 15
		                );
		                maxLength -= jsonPropName.length;
		                if (0 > maxLength) {
		                  name += "" === name ? "..." : ", ...";
		                  break;
		                }
		                name +=
		                  ("" === name ? "" : ",") + propName + ":" + jsonPropName;
		              }
		            return "{" + name + "}";
		          }
		          return name;
		        case "function":
		          return (maxLength = value.displayName || value.name)
		            ? "function " + maxLength
		            : "function";
		        default:
		          return String(value);
		      }
		    }
		    function describePropValue(value, maxLength) {
		      return "string" !== typeof value || needsEscaping.test(value)
		        ? "{" + describeValue(value, maxLength - 2) + "}"
		        : value.length > maxLength - 2
		          ? 5 > maxLength
		            ? '"..."'
		            : '"' + value.slice(0, maxLength - 5) + '..."'
		          : '"' + value + '"';
		    }
		    function describeExpandedElement(type, props, rowPrefix) {
		      var remainingRowLength = 120 - rowPrefix.length - type.length,
		        properties = [],
		        propName;
		      for (propName in props)
		        if (props.hasOwnProperty(propName) && "children" !== propName) {
		          var propValue = describePropValue(
		            props[propName],
		            120 - rowPrefix.length - propName.length - 1
		          );
		          remainingRowLength -= propName.length + propValue.length + 2;
		          properties.push(propName + "=" + propValue);
		        }
		      return 0 === properties.length
		        ? rowPrefix + "<" + type + ">\n"
		        : 0 < remainingRowLength
		          ? rowPrefix + "<" + type + " " + properties.join(" ") + ">\n"
		          : rowPrefix +
		            "<" +
		            type +
		            "\n" +
		            rowPrefix +
		            "  " +
		            properties.join("\n" + rowPrefix + "  ") +
		            "\n" +
		            rowPrefix +
		            ">\n";
		    }
		    function describePropertiesDiff(clientObject, serverObject, indent) {
		      var properties = "",
		        remainingServerProperties = assign({}, serverObject),
		        propName;
		      for (propName in clientObject)
		        if (clientObject.hasOwnProperty(propName)) {
		          delete remainingServerProperties[propName];
		          var maxLength = 120 - 2 * indent - propName.length - 2,
		            clientPropValue = describeValue(clientObject[propName], maxLength);
		          serverObject.hasOwnProperty(propName)
		            ? ((maxLength = describeValue(serverObject[propName], maxLength)),
		              (properties +=
		                added(indent) + propName + ": " + clientPropValue + "\n"),
		              (properties +=
		                removed(indent) + propName + ": " + maxLength + "\n"))
		            : (properties +=
		                added(indent) + propName + ": " + clientPropValue + "\n");
		        }
		      for (var _propName in remainingServerProperties)
		        remainingServerProperties.hasOwnProperty(_propName) &&
		          ((clientObject = describeValue(
		            remainingServerProperties[_propName],
		            120 - 2 * indent - _propName.length - 2
		          )),
		          (properties +=
		            removed(indent) + _propName + ": " + clientObject + "\n"));
		      return properties;
		    }
		    function describeElementDiff(type, clientProps, serverProps, indent) {
		      var content = "",
		        serverPropNames = new Map();
		      for (propName$jscomp$0 in serverProps)
		        serverProps.hasOwnProperty(propName$jscomp$0) &&
		          serverPropNames.set(
		            propName$jscomp$0.toLowerCase(),
		            propName$jscomp$0
		          );
		      if (1 === serverPropNames.size && serverPropNames.has("children"))
		        content += describeExpandedElement(
		          type,
		          clientProps,
		          indentation(indent)
		        );
		      else {
		        for (var _propName2 in clientProps)
		          if (
		            clientProps.hasOwnProperty(_propName2) &&
		            "children" !== _propName2
		          ) {
		            var maxLength$jscomp$0 =
		                120 - 2 * (indent + 1) - _propName2.length - 1,
		              serverPropName = serverPropNames.get(_propName2.toLowerCase());
		            if (void 0 !== serverPropName) {
		              serverPropNames.delete(_propName2.toLowerCase());
		              var propName$jscomp$0 = clientProps[_propName2];
		              serverPropName = serverProps[serverPropName];
		              var clientPropValue = describePropValue(
		                propName$jscomp$0,
		                maxLength$jscomp$0
		              );
		              maxLength$jscomp$0 = describePropValue(
		                serverPropName,
		                maxLength$jscomp$0
		              );
		              "object" === typeof propName$jscomp$0 &&
		              null !== propName$jscomp$0 &&
		              "object" === typeof serverPropName &&
		              null !== serverPropName &&
		              "Object" === objectName(propName$jscomp$0) &&
		              "Object" === objectName(serverPropName) &&
		              (2 < Object.keys(propName$jscomp$0).length ||
		                2 < Object.keys(serverPropName).length ||
		                -1 < clientPropValue.indexOf("...") ||
		                -1 < maxLength$jscomp$0.indexOf("..."))
		                ? (content +=
		                    indentation(indent + 1) +
		                    _propName2 +
		                    "={{\n" +
		                    describePropertiesDiff(
		                      propName$jscomp$0,
		                      serverPropName,
		                      indent + 2
		                    ) +
		                    indentation(indent + 1) +
		                    "}}\n")
		                : ((content +=
		                    added(indent + 1) +
		                    _propName2 +
		                    "=" +
		                    clientPropValue +
		                    "\n"),
		                  (content +=
		                    removed(indent + 1) +
		                    _propName2 +
		                    "=" +
		                    maxLength$jscomp$0 +
		                    "\n"));
		            } else
		              content +=
		                indentation(indent + 1) +
		                _propName2 +
		                "=" +
		                describePropValue(clientProps[_propName2], maxLength$jscomp$0) +
		                "\n";
		          }
		        serverPropNames.forEach(function (propName) {
		          if ("children" !== propName) {
		            var maxLength = 120 - 2 * (indent + 1) - propName.length - 1;
		            content +=
		              removed(indent + 1) +
		              propName +
		              "=" +
		              describePropValue(serverProps[propName], maxLength) +
		              "\n";
		          }
		        });
		        content =
		          "" === content
		            ? indentation(indent) + "<" + type + ">\n"
		            : indentation(indent) +
		              "<" +
		              type +
		              "\n" +
		              content +
		              indentation(indent) +
		              ">\n";
		      }
		      type = serverProps.children;
		      clientProps = clientProps.children;
		      if (
		        "string" === typeof type ||
		        "number" === typeof type ||
		        "bigint" === typeof type
		      ) {
		        serverPropNames = "";
		        if (
		          "string" === typeof clientProps ||
		          "number" === typeof clientProps ||
		          "bigint" === typeof clientProps
		        )
		          serverPropNames = "" + clientProps;
		        content += describeTextDiff(serverPropNames, "" + type, indent + 1);
		      } else if (
		        "string" === typeof clientProps ||
		        "number" === typeof clientProps ||
		        "bigint" === typeof clientProps
		      )
		        content =
		          null == type
		            ? content + describeTextDiff("" + clientProps, null, indent + 1)
		            : content + describeTextDiff("" + clientProps, void 0, indent + 1);
		      return content;
		    }
		    function describeSiblingFiber(fiber, indent) {
		      var type = describeFiberType(fiber);
		      if (null === type) {
		        type = "";
		        for (fiber = fiber.child; fiber; )
		          (type += describeSiblingFiber(fiber, indent)),
		            (fiber = fiber.sibling);
		        return type;
		      }
		      return indentation(indent) + "<" + type + ">\n";
		    }
		    function describeNode(node, indent) {
		      var skipToNode = findNotableNode(node, indent);
		      if (
		        skipToNode !== node &&
		        (1 !== node.children.length || node.children[0] !== skipToNode)
		      )
		        return (
		          indentation(indent) + "...\n" + describeNode(skipToNode, indent + 1)
		        );
		      skipToNode = "";
		      var debugInfo = node.fiber._debugInfo;
		      if (debugInfo)
		        for (var i = 0; i < debugInfo.length; i++) {
		          var serverComponentName = debugInfo[i].name;
		          "string" === typeof serverComponentName &&
		            ((skipToNode +=
		              indentation(indent) + "<" + serverComponentName + ">\n"),
		            indent++);
		        }
		      debugInfo = "";
		      i = node.fiber.pendingProps;
		      if (6 === node.fiber.tag)
		        (debugInfo = describeTextDiff(i, node.serverProps, indent)), indent++;
		      else if (
		        ((serverComponentName = describeFiberType(node.fiber)),
		        null !== serverComponentName)
		      )
		        if (void 0 === node.serverProps) {
		          debugInfo = indent;
		          var maxLength = 120 - 2 * debugInfo - serverComponentName.length - 2,
		            content = "";
		          for (propName in i)
		            if (i.hasOwnProperty(propName) && "children" !== propName) {
		              var propValue = describePropValue(i[propName], 15);
		              maxLength -= propName.length + propValue.length + 2;
		              if (0 > maxLength) {
		                content += " ...";
		                break;
		              }
		              content += " " + propName + "=" + propValue;
		            }
		          debugInfo =
		            indentation(debugInfo) +
		            "<" +
		            serverComponentName +
		            content +
		            ">\n";
		          indent++;
		        } else
		          null === node.serverProps
		            ? ((debugInfo = describeExpandedElement(
		                serverComponentName,
		                i,
		                added(indent)
		              )),
		              indent++)
		            : "string" === typeof node.serverProps
		              ? console.error(
		                  "Should not have matched a non HostText fiber to a Text node. This is a bug in React."
		                )
		              : ((debugInfo = describeElementDiff(
		                  serverComponentName,
		                  i,
		                  node.serverProps,
		                  indent
		                )),
		                indent++);
		      var propName = "";
		      i = node.fiber.child;
		      for (
		        serverComponentName = 0;
		        i && serverComponentName < node.children.length;

		      )
		        (maxLength = node.children[serverComponentName]),
		          maxLength.fiber === i
		            ? ((propName += describeNode(maxLength, indent)),
		              serverComponentName++)
		            : (propName += describeSiblingFiber(i, indent)),
		          (i = i.sibling);
		      i &&
		        0 < node.children.length &&
		        (propName += indentation(indent) + "...\n");
		      i = node.serverTail;
		      null === node.serverProps && indent--;
		      for (node = 0; node < i.length; node++)
		        (serverComponentName = i[node]),
		          (propName =
		            "string" === typeof serverComponentName
		              ? propName +
		                (removed(indent) +
		                  describeTextNode(serverComponentName, 120 - 2 * indent) +
		                  "\n")
		              : propName +
		                describeExpandedElement(
		                  serverComponentName.type,
		                  serverComponentName.props,
		                  removed(indent)
		                ));
		      return skipToNode + debugInfo + propName;
		    }
		    function describeDiff(rootNode) {
		      try {
		        return "\n\n" + describeNode(rootNode, 0);
		      } catch (x) {
		        return "";
		      }
		    }
		    function getCurrentFiberStackInDev() {
		      if (null === current) return "";
		      var workInProgress = current;
		      try {
		        var info = "";
		        6 === workInProgress.tag && (workInProgress = workInProgress.return);
		        switch (workInProgress.tag) {
		          case 26:
		          case 27:
		          case 5:
		            info += describeBuiltInComponentFrame(workInProgress.type);
		            break;
		          case 13:
		            info += describeBuiltInComponentFrame("Suspense");
		            break;
		          case 19:
		            info += describeBuiltInComponentFrame("SuspenseList");
		            break;
		          case 31:
		            info += describeBuiltInComponentFrame("Activity");
		            break;
		          case 30:
		          case 0:
		          case 15:
		          case 1:
		            workInProgress._debugOwner ||
		              "" !== info ||
		              (info += describeFunctionComponentFrameWithoutLineNumber(
		                workInProgress.type
		              ));
		            break;
		          case 11:
		            workInProgress._debugOwner ||
		              "" !== info ||
		              (info += describeFunctionComponentFrameWithoutLineNumber(
		                workInProgress.type.render
		              ));
		        }
		        for (; workInProgress; )
		          if ("number" === typeof workInProgress.tag) {
		            var fiber = workInProgress;
		            workInProgress = fiber._debugOwner;
		            var debugStack = fiber._debugStack;
		            if (workInProgress && debugStack) {
		              var formattedStack = formatOwnerStack(debugStack);
		              "" !== formattedStack && (info += "\n" + formattedStack);
		            }
		          } else if (null != workInProgress.debugStack) {
		            var ownerStack = workInProgress.debugStack;
		            (workInProgress = workInProgress.owner) &&
		              ownerStack &&
		              (info += "\n" + formatOwnerStack(ownerStack));
		          } else break;
		        var JSCompiler_inline_result = info;
		      } catch (x) {
		        JSCompiler_inline_result =
		          "\nError generating stack: " + x.message + "\n" + x.stack;
		      }
		      return JSCompiler_inline_result;
		    }
		    function runWithFiberInDEV(fiber, callback, arg0, arg1, arg2, arg3, arg4) {
		      var previousFiber = current;
		      setCurrentFiber(fiber);
		      try {
		        return null !== fiber && fiber._debugTask
		          ? fiber._debugTask.run(
		              callback.bind(null, arg0, arg1, arg2, arg3, arg4)
		            )
		          : callback(arg0, arg1, arg2, arg3, arg4);
		      } finally {
		        setCurrentFiber(previousFiber);
		      }
		      throw Error(
		        "runWithFiberInDEV should never be called in production. This is a bug in React."
		      );
		    }
		    function setCurrentFiber(fiber) {
		      ReactSharedInternals.getCurrentStack =
		        null === fiber ? null : getCurrentFiberStackInDev;
		      isRendering = false;
		      current = fiber;
		    }
		    function buildHydrationDiffNode(fiber, distanceFromLeaf) {
		      if (null === fiber.return) {
		        if (null === hydrationDiffRootDEV)
		          hydrationDiffRootDEV = {
		            fiber: fiber,
		            children: [],
		            serverProps: void 0,
		            serverTail: [],
		            distanceFromLeaf: distanceFromLeaf
		          };
		        else {
		          if (hydrationDiffRootDEV.fiber !== fiber)
		            throw Error(
		              "Saw multiple hydration diff roots in a pass. This is a bug in React."
		            );
		          hydrationDiffRootDEV.distanceFromLeaf > distanceFromLeaf &&
		            (hydrationDiffRootDEV.distanceFromLeaf = distanceFromLeaf);
		        }
		        return hydrationDiffRootDEV;
		      }
		      var siblings = buildHydrationDiffNode(
		        fiber.return,
		        distanceFromLeaf + 1
		      ).children;
		      if (0 < siblings.length && siblings[siblings.length - 1].fiber === fiber)
		        return (
		          (siblings = siblings[siblings.length - 1]),
		          siblings.distanceFromLeaf > distanceFromLeaf &&
		            (siblings.distanceFromLeaf = distanceFromLeaf),
		          siblings
		        );
		      distanceFromLeaf = {
		        fiber: fiber,
		        children: [],
		        serverProps: void 0,
		        serverTail: [],
		        distanceFromLeaf: distanceFromLeaf
		      };
		      siblings.push(distanceFromLeaf);
		      return distanceFromLeaf;
		    }
		    function warnIfHydrating() {
		      isHydrating &&
		        console.error(
		          "We should not be hydrating here. This is a bug in React. Please file a bug."
		        );
		    }
		    function warnNonHydratedInstance(fiber, rejectedCandidate) {
		      didSuspendOrErrorDEV ||
		        ((fiber = buildHydrationDiffNode(fiber, 0)),
		        (fiber.serverProps = null),
		        null !== rejectedCandidate &&
		          ((rejectedCandidate =
		            describeHydratableInstanceForDevWarnings(rejectedCandidate)),
		          fiber.serverTail.push(rejectedCandidate)));
		    }
		    function throwOnHydrationMismatch(fiber) {
		      var fromText =
		          1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : false,
		        diff = "",
		        diffRoot = hydrationDiffRootDEV;
		      null !== diffRoot &&
		        ((hydrationDiffRootDEV = null), (diff = describeDiff(diffRoot)));
		      queueHydrationError(
		        createCapturedValueAtFiber(
		          Error(
		            "Hydration failed because the server rendered " +
		              (fromText ? "text" : "HTML") +
		              " didn't match the client. As a result this tree will be regenerated on the client. This can happen if a SSR-ed Client Component used:\n\n- A server/client branch `if (typeof window !== 'undefined')`.\n- Variable input such as `Date.now()` or `Math.random()` which changes each time it's called.\n- Date formatting in a user's locale which doesn't match the server.\n- External changing data without sending a snapshot of it along with the HTML.\n- Invalid HTML tag nesting.\n\nIt can also happen if the client has a browser extension installed which messes with the HTML before React loaded.\n\nhttps://react.dev/link/hydration-mismatch" +
		              diff
		          ),
		          fiber
		        )
		      );
		      throw HydrationMismatchException;
		    }
		    function prepareToHydrateHostInstance(fiber, hostContext) {
		      if (!supportsHydration)
		        throw Error(
		          "Expected prepareToHydrateHostInstance() to never be called. This error is likely caused by a bug in React. Please file an issue."
		        );
		      hydrateInstance(
		        fiber.stateNode,
		        fiber.type,
		        fiber.memoizedProps,
		        hostContext,
		        fiber
		      ) || throwOnHydrationMismatch(fiber, true);
		    }
		    function popToNextHostParent(fiber) {
		      for (hydrationParentFiber = fiber.return; hydrationParentFiber; )
		        switch (hydrationParentFiber.tag) {
		          case 5:
		          case 31:
		          case 13:
		            rootOrSingletonContext = false;
		            return;
		          case 27:
		          case 3:
		            rootOrSingletonContext = true;
		            return;
		          default:
		            hydrationParentFiber = hydrationParentFiber.return;
		        }
		    }
		    function popHydrationState(fiber) {
		      if (!supportsHydration || fiber !== hydrationParentFiber) return false;
		      if (!isHydrating)
		        return popToNextHostParent(fiber), (isHydrating = true), false;
		      var tag = fiber.tag;
		      supportsSingletons
		        ? 3 !== tag &&
		          27 !== tag &&
		          (5 !== tag ||
		            (shouldDeleteUnhydratedTailInstances(fiber.type) &&
		              !shouldSetTextContent(fiber.type, fiber.memoizedProps))) &&
		          nextHydratableInstance &&
		          (warnIfUnhydratedTailNodes(fiber), throwOnHydrationMismatch(fiber))
		        : 3 !== tag &&
		          (5 !== tag ||
		            (shouldDeleteUnhydratedTailInstances(fiber.type) &&
		              !shouldSetTextContent(fiber.type, fiber.memoizedProps))) &&
		          nextHydratableInstance &&
		          (warnIfUnhydratedTailNodes(fiber), throwOnHydrationMismatch(fiber));
		      popToNextHostParent(fiber);
		      if (13 === tag) {
		        if (!supportsHydration)
		          throw Error(
		            "Expected skipPastDehydratedSuspenseInstance() to never be called. This error is likely caused by a bug in React. Please file an issue."
		          );
		        fiber = fiber.memoizedState;
		        fiber = null !== fiber ? fiber.dehydrated : null;
		        if (!fiber)
		          throw Error(
		            "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue."
		          );
		        nextHydratableInstance =
		          getNextHydratableInstanceAfterSuspenseInstance(fiber);
		      } else if (31 === tag) {
		        fiber = fiber.memoizedState;
		        fiber = null !== fiber ? fiber.dehydrated : null;
		        if (!fiber)
		          throw Error(
		            "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue."
		          );
		        nextHydratableInstance =
		          getNextHydratableInstanceAfterActivityInstance(fiber);
		      } else
		        nextHydratableInstance =
		          supportsSingletons && 27 === tag
		            ? getNextHydratableSiblingAfterSingleton(
		                fiber.type,
		                nextHydratableInstance
		              )
		            : hydrationParentFiber
		              ? getNextHydratableSibling(fiber.stateNode)
		              : null;
		      return true;
		    }
		    function warnIfUnhydratedTailNodes(fiber) {
		      for (var nextInstance = nextHydratableInstance; nextInstance; ) {
		        var diffNode = buildHydrationDiffNode(fiber, 0),
		          description = describeHydratableInstanceForDevWarnings(nextInstance);
		        diffNode.serverTail.push(description);
		        nextInstance =
		          "Suspense" === description.type
		            ? getNextHydratableInstanceAfterSuspenseInstance(nextInstance)
		            : getNextHydratableSibling(nextInstance);
		      }
		    }
		    function resetHydrationState() {
		      supportsHydration &&
		        ((nextHydratableInstance = hydrationParentFiber = null),
		        (didSuspendOrErrorDEV = isHydrating = false));
		    }
		    function upgradeHydrationErrorsToRecoverable() {
		      var queuedErrors = hydrationErrors;
		      null !== queuedErrors &&
		        (null === workInProgressRootRecoverableErrors
		          ? (workInProgressRootRecoverableErrors = queuedErrors)
		          : workInProgressRootRecoverableErrors.push.apply(
		              workInProgressRootRecoverableErrors,
		              queuedErrors
		            ),
		        (hydrationErrors = null));
		      return queuedErrors;
		    }
		    function queueHydrationError(error) {
		      null === hydrationErrors
		        ? (hydrationErrors = [error])
		        : hydrationErrors.push(error);
		    }
		    function emitPendingHydrationWarnings() {
		      var diffRoot = hydrationDiffRootDEV;
		      if (null !== diffRoot) {
		        hydrationDiffRootDEV = null;
		        for (var diff = describeDiff(diffRoot); 0 < diffRoot.children.length; )
		          diffRoot = diffRoot.children[0];
		        runWithFiberInDEV(diffRoot.fiber, function () {
		          console.error(
		            "A tree hydrated but some attributes of the server rendered HTML didn't match the client properties. This won't be patched up. This can happen if a SSR-ed Client Component used:\n\n- A server/client branch `if (typeof window !== 'undefined')`.\n- Variable input such as `Date.now()` or `Math.random()` which changes each time it's called.\n- Date formatting in a user's locale which doesn't match the server.\n- External changing data without sending a snapshot of it along with the HTML.\n- Invalid HTML tag nesting.\n\nIt can also happen if the client has a browser extension installed which messes with the HTML before React loaded.\n\n%s%s",
		            "https://react.dev/link/hydration-mismatch",
		            diff
		          );
		        });
		      }
		    }
		    function resetContextDependencies() {
		      lastContextDependency = currentlyRenderingFiber$1 = null;
		      isDisallowedContextReadInDEV = false;
		    }
		    function pushProvider(providerFiber, context, nextValue) {
		      isPrimaryRenderer
		        ? (push(valueCursor, context._currentValue, providerFiber),
		          (context._currentValue = nextValue),
		          push(rendererCursorDEV, context._currentRenderer, providerFiber),
		          void 0 !== context._currentRenderer &&
		            null !== context._currentRenderer &&
		            context._currentRenderer !== rendererSigil &&
		            console.error(
		              "Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."
		            ),
		          (context._currentRenderer = rendererSigil))
		        : (push(valueCursor, context._currentValue2, providerFiber),
		          (context._currentValue2 = nextValue),
		          push(renderer2CursorDEV, context._currentRenderer2, providerFiber),
		          void 0 !== context._currentRenderer2 &&
		            null !== context._currentRenderer2 &&
		            context._currentRenderer2 !== rendererSigil &&
		            console.error(
		              "Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."
		            ),
		          (context._currentRenderer2 = rendererSigil));
		    }
		    function popProvider(context, providerFiber) {
		      var currentValue = valueCursor.current;
		      isPrimaryRenderer
		        ? ((context._currentValue = currentValue),
		          (currentValue = rendererCursorDEV.current),
		          pop(rendererCursorDEV, providerFiber),
		          (context._currentRenderer = currentValue))
		        : ((context._currentValue2 = currentValue),
		          (currentValue = renderer2CursorDEV.current),
		          pop(renderer2CursorDEV, providerFiber),
		          (context._currentRenderer2 = currentValue));
		      pop(valueCursor, providerFiber);
		    }
		    function scheduleContextWorkOnParentPath(
		      parent,
		      renderLanes,
		      propagationRoot
		    ) {
		      for (; null !== parent; ) {
		        var alternate = parent.alternate;
		        (parent.childLanes & renderLanes) !== renderLanes
		          ? ((parent.childLanes |= renderLanes),
		            null !== alternate && (alternate.childLanes |= renderLanes))
		          : null !== alternate &&
		            (alternate.childLanes & renderLanes) !== renderLanes &&
		            (alternate.childLanes |= renderLanes);
		        if (parent === propagationRoot) break;
		        parent = parent.return;
		      }
		      parent !== propagationRoot &&
		        console.error(
		          "Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue."
		        );
		    }
		    function propagateContextChanges(
		      workInProgress,
		      contexts,
		      renderLanes,
		      forcePropagateEntireTree
		    ) {
		      var fiber = workInProgress.child;
		      null !== fiber && (fiber.return = workInProgress);
		      for (; null !== fiber; ) {
		        var list = fiber.dependencies;
		        if (null !== list) {
		          var nextFiber = fiber.child;
		          list = list.firstContext;
		          a: for (; null !== list; ) {
		            var dependency = list;
		            list = fiber;
		            for (var i = 0; i < contexts.length; i++)
		              if (dependency.context === contexts[i]) {
		                list.lanes |= renderLanes;
		                dependency = list.alternate;
		                null !== dependency && (dependency.lanes |= renderLanes);
		                scheduleContextWorkOnParentPath(
		                  list.return,
		                  renderLanes,
		                  workInProgress
		                );
		                forcePropagateEntireTree || (nextFiber = null);
		                break a;
		              }
		            list = dependency.next;
		          }
		        } else if (18 === fiber.tag) {
		          nextFiber = fiber.return;
		          if (null === nextFiber)
		            throw Error(
		              "We just came from a parent so we must have had a parent. This is a bug in React."
		            );
		          nextFiber.lanes |= renderLanes;
		          list = nextFiber.alternate;
		          null !== list && (list.lanes |= renderLanes);
		          scheduleContextWorkOnParentPath(
		            nextFiber,
		            renderLanes,
		            workInProgress
		          );
		          nextFiber = null;
		        } else nextFiber = fiber.child;
		        if (null !== nextFiber) nextFiber.return = fiber;
		        else
		          for (nextFiber = fiber; null !== nextFiber; ) {
		            if (nextFiber === workInProgress) {
		              nextFiber = null;
		              break;
		            }
		            fiber = nextFiber.sibling;
		            if (null !== fiber) {
		              fiber.return = nextFiber.return;
		              nextFiber = fiber;
		              break;
		            }
		            nextFiber = nextFiber.return;
		          }
		        fiber = nextFiber;
		      }
		    }
		    function propagateParentContextChanges(
		      current,
		      workInProgress,
		      renderLanes,
		      forcePropagateEntireTree
		    ) {
		      current = null;
		      for (
		        var parent = workInProgress, isInsidePropagationBailout = false;
		        null !== parent;

		      ) {
		        if (!isInsidePropagationBailout)
		          if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = true;
		          else if (0 !== (parent.flags & 262144)) break;
		        if (10 === parent.tag) {
		          var currentParent = parent.alternate;
		          if (null === currentParent)
		            throw Error("Should have a current fiber. This is a bug in React.");
		          currentParent = currentParent.memoizedProps;
		          if (null !== currentParent) {
		            var context = parent.type;
		            objectIs(parent.pendingProps.value, currentParent.value) ||
		              (null !== current
		                ? current.push(context)
		                : (current = [context]));
		          }
		        } else if (parent === hostTransitionProviderCursor.current) {
		          currentParent = parent.alternate;
		          if (null === currentParent)
		            throw Error("Should have a current fiber. This is a bug in React.");
		          currentParent.memoizedState.memoizedState !==
		            parent.memoizedState.memoizedState &&
		            (null !== current
		              ? current.push(HostTransitionContext)
		              : (current = [HostTransitionContext]));
		        }
		        parent = parent.return;
		      }
		      null !== current &&
		        propagateContextChanges(
		          workInProgress,
		          current,
		          renderLanes,
		          forcePropagateEntireTree
		        );
		      workInProgress.flags |= 262144;
		    }
		    function checkIfContextChanged(currentDependencies) {
		      for (
		        currentDependencies = currentDependencies.firstContext;
		        null !== currentDependencies;

		      ) {
		        var context = currentDependencies.context;
		        if (
		          !objectIs(
		            isPrimaryRenderer ? context._currentValue : context._currentValue2,
		            currentDependencies.memoizedValue
		          )
		        )
		          return true;
		        currentDependencies = currentDependencies.next;
		      }
		      return false;
		    }
		    function prepareToReadContext(workInProgress) {
		      currentlyRenderingFiber$1 = workInProgress;
		      lastContextDependency = null;
		      workInProgress = workInProgress.dependencies;
		      null !== workInProgress && (workInProgress.firstContext = null);
		    }
		    function readContext(context) {
		      isDisallowedContextReadInDEV &&
		        console.error(
		          "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
		        );
		      return readContextForConsumer(currentlyRenderingFiber$1, context);
		    }
		    function readContextDuringReconciliation(consumer, context) {
		      null === currentlyRenderingFiber$1 && prepareToReadContext(consumer);
		      return readContextForConsumer(consumer, context);
		    }
		    function readContextForConsumer(consumer, context) {
		      var value = isPrimaryRenderer
		        ? context._currentValue
		        : context._currentValue2;
		      context = { context: context, memoizedValue: value, next: null };
		      if (null === lastContextDependency) {
		        if (null === consumer)
		          throw Error(
		            "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
		          );
		        lastContextDependency = context;
		        consumer.dependencies = {
		          lanes: 0,
		          firstContext: context,
		          _debugThenableState: null
		        };
		        consumer.flags |= 524288;
		      } else lastContextDependency = lastContextDependency.next = context;
		      return value;
		    }
		    function createCache() {
		      return {
		        controller: new AbortControllerLocal(),
		        data: new Map(),
		        refCount: 0
		      };
		    }
		    function retainCache(cache) {
		      cache.controller.signal.aborted &&
		        console.warn(
		          "A cache instance was retained after it was already freed. This likely indicates a bug in React."
		        );
		      cache.refCount++;
		    }
		    function releaseCache(cache) {
		      cache.refCount--;
		      0 > cache.refCount &&
		        console.warn(
		          "A cache instance was released after it was already freed. This likely indicates a bug in React."
		        );
		      0 === cache.refCount &&
		        scheduleCallback$2(NormalPriority, function () {
		          cache.controller.abort();
		        });
		    }
		    function startUpdateTimerByLane(lane, method, fiber) {
		      if (0 !== (lane & 127))
		        0 > blockingUpdateTime &&
		          ((blockingUpdateTime = now()),
		          (blockingUpdateTask = createTask(method)),
		          (blockingUpdateMethodName = method),
		          null != fiber &&
		            (blockingUpdateComponentName = getComponentNameFromFiber(fiber)),
		          isAlreadyRendering() &&
		            ((componentEffectSpawnedUpdate = true), (blockingUpdateType = 1)),
		          (lane = resolveEventTimeStamp()),
		          (method = resolveEventType()),
		          lane !== blockingEventRepeatTime || method !== blockingEventType
		            ? (blockingEventRepeatTime = -1.1)
		            : null !== method && (blockingUpdateType = 1),
		          (blockingEventTime = lane),
		          (blockingEventType = method));
		      else if (
		        0 !== (lane & 4194048) &&
		        0 > transitionUpdateTime &&
		        ((transitionUpdateTime = now()),
		        (transitionUpdateTask = createTask(method)),
		        (transitionUpdateMethodName = method),
		        null != fiber &&
		          (transitionUpdateComponentName = getComponentNameFromFiber(fiber)),
		        0 > transitionStartTime)
		      ) {
		        lane = resolveEventTimeStamp();
		        method = resolveEventType();
		        if (
		          lane !== transitionEventRepeatTime ||
		          method !== transitionEventType
		        )
		          transitionEventRepeatTime = -1.1;
		        transitionEventTime = lane;
		        transitionEventType = method;
		      }
		    }
		    function startHostActionTimer(fiber) {
		      if (0 > blockingUpdateTime) {
		        blockingUpdateTime = now();
		        blockingUpdateTask = null != fiber._debugTask ? fiber._debugTask : null;
		        isAlreadyRendering() && (blockingUpdateType = 1);
		        var newEventTime = resolveEventTimeStamp(),
		          newEventType = resolveEventType();
		        newEventTime !== blockingEventRepeatTime ||
		        newEventType !== blockingEventType
		          ? (blockingEventRepeatTime = -1.1)
		          : null !== newEventType && (blockingUpdateType = 1);
		        blockingEventTime = newEventTime;
		        blockingEventType = newEventType;
		      }
		      if (
		        0 > transitionUpdateTime &&
		        ((transitionUpdateTime = now()),
		        (transitionUpdateTask =
		          null != fiber._debugTask ? fiber._debugTask : null),
		        0 > transitionStartTime)
		      ) {
		        fiber = resolveEventTimeStamp();
		        newEventTime = resolveEventType();
		        if (
		          fiber !== transitionEventRepeatTime ||
		          newEventTime !== transitionEventType
		        )
		          transitionEventRepeatTime = -1.1;
		        transitionEventTime = fiber;
		        transitionEventType = newEventTime;
		      }
		    }
		    function pushNestedEffectDurations() {
		      var prevEffectDuration = profilerEffectDuration;
		      profilerEffectDuration = 0;
		      return prevEffectDuration;
		    }
		    function popNestedEffectDurations(prevEffectDuration) {
		      var elapsedTime = profilerEffectDuration;
		      profilerEffectDuration = prevEffectDuration;
		      return elapsedTime;
		    }
		    function bubbleNestedEffectDurations(prevEffectDuration) {
		      var elapsedTime = profilerEffectDuration;
		      profilerEffectDuration += prevEffectDuration;
		      return elapsedTime;
		    }
		    function resetComponentEffectTimers() {
		      componentEffectEndTime = componentEffectStartTime = -1.1;
		    }
		    function pushComponentEffectStart() {
		      var prevEffectStart = componentEffectStartTime;
		      componentEffectStartTime = -1.1;
		      return prevEffectStart;
		    }
		    function popComponentEffectStart(prevEffectStart) {
		      0 <= prevEffectStart && (componentEffectStartTime = prevEffectStart);
		    }
		    function pushComponentEffectDuration() {
		      var prevEffectDuration = componentEffectDuration;
		      componentEffectDuration = -0;
		      return prevEffectDuration;
		    }
		    function popComponentEffectDuration(prevEffectDuration) {
		      0 <= prevEffectDuration && (componentEffectDuration = prevEffectDuration);
		    }
		    function pushComponentEffectErrors() {
		      var prevErrors = componentEffectErrors;
		      componentEffectErrors = null;
		      return prevErrors;
		    }
		    function pushComponentEffectDidSpawnUpdate() {
		      var prev = componentEffectSpawnedUpdate;
		      componentEffectSpawnedUpdate = false;
		      return prev;
		    }
		    function startProfilerTimer(fiber) {
		      profilerStartTime = now();
		      0 > fiber.actualStartTime && (fiber.actualStartTime = profilerStartTime);
		    }
		    function stopProfilerTimerIfRunningAndRecordDuration(fiber) {
		      if (0 <= profilerStartTime) {
		        var elapsedTime = now() - profilerStartTime;
		        fiber.actualDuration += elapsedTime;
		        fiber.selfBaseDuration = elapsedTime;
		        profilerStartTime = -1;
		      }
		    }
		    function stopProfilerTimerIfRunningAndRecordIncompleteDuration(fiber) {
		      if (0 <= profilerStartTime) {
		        var elapsedTime = now() - profilerStartTime;
		        fiber.actualDuration += elapsedTime;
		        profilerStartTime = -1;
		      }
		    }
		    function recordEffectDuration() {
		      if (0 <= profilerStartTime) {
		        var endTime = now(),
		          elapsedTime = endTime - profilerStartTime;
		        profilerStartTime = -1;
		        profilerEffectDuration += elapsedTime;
		        componentEffectDuration += elapsedTime;
		        componentEffectEndTime = endTime;
		      }
		    }
		    function recordEffectError(errorInfo) {
		      null === componentEffectErrors && (componentEffectErrors = []);
		      componentEffectErrors.push(errorInfo);
		      null === commitErrors && (commitErrors = []);
		      commitErrors.push(errorInfo);
		    }
		    function startEffectTimer() {
		      profilerStartTime = now();
		      0 > componentEffectStartTime &&
		        (componentEffectStartTime = profilerStartTime);
		    }
		    function transferActualDuration(fiber) {
		      for (var child = fiber.child; child; )
		        (fiber.actualDuration += child.actualDuration), (child = child.sibling);
		    }
		    function noop$1() {}
		    function ensureRootIsScheduled(root) {
		      root !== lastScheduledRoot &&
		        null === root.next &&
		        (null === lastScheduledRoot
		          ? (firstScheduledRoot = lastScheduledRoot = root)
		          : (lastScheduledRoot = lastScheduledRoot.next = root));
		      mightHavePendingSyncWork = true;
		      null !== ReactSharedInternals.actQueue
		        ? didScheduleMicrotask_act ||
		          ((didScheduleMicrotask_act = true), scheduleImmediateRootScheduleTask())
		        : didScheduleMicrotask ||
		          ((didScheduleMicrotask = true), scheduleImmediateRootScheduleTask());
		    }
		    function flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
		      if (!isFlushingWork && mightHavePendingSyncWork) {
		        isFlushingWork = true;
		        do {
		          var didPerformSomeWork = false;
		          for (var root = firstScheduledRoot; null !== root; ) {
		            if (0 !== syncTransitionLanes) {
		                var pendingLanes = root.pendingLanes;
		                if (0 === pendingLanes) var nextLanes = 0;
		                else {
		                  var suspendedLanes = root.suspendedLanes,
		                    pingedLanes = root.pingedLanes;
		                  nextLanes =
		                    (1 << (31 - clz32(42 | syncTransitionLanes) + 1)) - 1;
		                  nextLanes &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
		                  nextLanes =
		                    nextLanes & 201326741
		                      ? (nextLanes & 201326741) | 1
		                      : nextLanes
		                        ? nextLanes | 2
		                        : 0;
		                }
		                0 !== nextLanes &&
		                  ((didPerformSomeWork = true),
		                  performSyncWorkOnRoot(root, nextLanes));
		              } else
		                (nextLanes = workInProgressRootRenderLanes),
		                  (nextLanes = getNextLanes(
		                    root,
		                    root === workInProgressRoot ? nextLanes : 0,
		                    null !== root.cancelPendingCommit ||
		                      root.timeoutHandle !== noTimeout
		                  )),
		                  0 === (nextLanes & 3) ||
		                    checkIfRootIsPrerendering(root, nextLanes) ||
		                    ((didPerformSomeWork = true),
		                    performSyncWorkOnRoot(root, nextLanes));
		            root = root.next;
		          }
		        } while (didPerformSomeWork);
		        isFlushingWork = false;
		      }
		    }
		    function processRootScheduleInImmediateTask() {
		      trackSchedulerEvent();
		      processRootScheduleInMicrotask();
		    }
		    function processRootScheduleInMicrotask() {
		      mightHavePendingSyncWork =
		        didScheduleMicrotask_act =
		        didScheduleMicrotask =
		          false;
		      var syncTransitionLanes = 0;
		      0 !== currentEventTransitionLane &&
		        shouldAttemptEagerTransition() &&
		        (syncTransitionLanes = currentEventTransitionLane);
		      for (
		        var currentTime = now$1(), prev = null, root = firstScheduledRoot;
		        null !== root;

		      ) {
		        var next = root.next,
		          nextLanes = scheduleTaskForRootDuringMicrotask(root, currentTime);
		        if (0 === nextLanes)
		          (root.next = null),
		            null === prev ? (firstScheduledRoot = next) : (prev.next = next),
		            null === next && (lastScheduledRoot = prev);
		        else if (
		          ((prev = root), 0 !== syncTransitionLanes || 0 !== (nextLanes & 3))
		        )
		          mightHavePendingSyncWork = true;
		        root = next;
		      }
		      (pendingEffectsStatus !== NO_PENDING_EFFECTS &&
		        pendingEffectsStatus !== PENDING_PASSIVE_PHASE) ||
		        flushSyncWorkAcrossRoots_impl(syncTransitionLanes);
		      0 !== currentEventTransitionLane && (currentEventTransitionLane = 0);
		    }
		    function scheduleTaskForRootDuringMicrotask(root, currentTime) {
		      for (
		        var suspendedLanes = root.suspendedLanes,
		          pingedLanes = root.pingedLanes,
		          expirationTimes = root.expirationTimes,
		          lanes = root.pendingLanes & -62914561;
		        0 < lanes;

		      ) {
		        var index = 31 - clz32(lanes),
		          lane = 1 << index,
		          expirationTime = expirationTimes[index];
		        if (-1 === expirationTime) {
		          if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes))
		            expirationTimes[index] = computeExpirationTime(lane, currentTime);
		        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
		        lanes &= ~lane;
		      }
		      currentTime = workInProgressRoot;
		      suspendedLanes = workInProgressRootRenderLanes;
		      suspendedLanes = getNextLanes(
		        root,
		        root === currentTime ? suspendedLanes : 0,
		        null !== root.cancelPendingCommit || root.timeoutHandle !== noTimeout
		      );
		      pingedLanes = root.callbackNode;
		      if (
		        0 === suspendedLanes ||
		        (root === currentTime &&
		          (workInProgressSuspendedReason === SuspendedOnData ||
		            workInProgressSuspendedReason === SuspendedOnAction)) ||
		        null !== root.cancelPendingCommit
		      )
		        return (
		          null !== pingedLanes && cancelCallback(pingedLanes),
		          (root.callbackNode = null),
		          (root.callbackPriority = 0)
		        );
		      if (
		        0 === (suspendedLanes & 3) ||
		        checkIfRootIsPrerendering(root, suspendedLanes)
		      ) {
		        currentTime = suspendedLanes & -suspendedLanes;
		        if (
		          currentTime !== root.callbackPriority ||
		          (null !== ReactSharedInternals.actQueue &&
		            pingedLanes !== fakeActCallbackNode$1)
		        )
		          cancelCallback(pingedLanes);
		        else return currentTime;
		        switch (lanesToEventPriority(suspendedLanes)) {
		          case 2:
		          case 8:
		            suspendedLanes = UserBlockingPriority;
		            break;
		          case 32:
		            suspendedLanes = NormalPriority$1;
		            break;
		          case 268435456:
		            suspendedLanes = IdlePriority;
		            break;
		          default:
		            suspendedLanes = NormalPriority$1;
		        }
		        pingedLanes = performWorkOnRootViaSchedulerTask.bind(null, root);
		        null !== ReactSharedInternals.actQueue
		          ? (ReactSharedInternals.actQueue.push(pingedLanes),
		            (suspendedLanes = fakeActCallbackNode$1))
		          : (suspendedLanes = scheduleCallback$3(suspendedLanes, pingedLanes));
		        root.callbackPriority = currentTime;
		        root.callbackNode = suspendedLanes;
		        return currentTime;
		      }
		      null !== pingedLanes && cancelCallback(pingedLanes);
		      root.callbackPriority = 2;
		      root.callbackNode = null;
		      return 2;
		    }
		    function performWorkOnRootViaSchedulerTask(root, didTimeout) {
		      nestedUpdateScheduled = currentUpdateIsNested = false;
		      trackSchedulerEvent();
		      if (
		        pendingEffectsStatus !== NO_PENDING_EFFECTS &&
		        pendingEffectsStatus !== PENDING_PASSIVE_PHASE
		      )
		        return (root.callbackNode = null), (root.callbackPriority = 0), null;
		      var originalCallbackNode = root.callbackNode;
		      pendingDelayedCommitReason === IMMEDIATE_COMMIT &&
		        (pendingDelayedCommitReason = DELAYED_PASSIVE_COMMIT);
		      if (flushPendingEffects() && root.callbackNode !== originalCallbackNode)
		        return null;
		      var workInProgressRootRenderLanes$jscomp$0 =
		        workInProgressRootRenderLanes;
		      workInProgressRootRenderLanes$jscomp$0 = getNextLanes(
		        root,
		        root === workInProgressRoot
		          ? workInProgressRootRenderLanes$jscomp$0
		          : 0,
		        null !== root.cancelPendingCommit || root.timeoutHandle !== noTimeout
		      );
		      if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
		      performWorkOnRoot(
		        root,
		        workInProgressRootRenderLanes$jscomp$0,
		        didTimeout
		      );
		      scheduleTaskForRootDuringMicrotask(root, now$1());
		      return null != root.callbackNode &&
		        root.callbackNode === originalCallbackNode
		        ? performWorkOnRootViaSchedulerTask.bind(null, root)
		        : null;
		    }
		    function performSyncWorkOnRoot(root, lanes) {
		      if (flushPendingEffects()) return null;
		      currentUpdateIsNested = nestedUpdateScheduled;
		      nestedUpdateScheduled = false;
		      performWorkOnRoot(root, lanes, true);
		    }
		    function cancelCallback(callbackNode) {
		      callbackNode !== fakeActCallbackNode$1 &&
		        null !== callbackNode &&
		        cancelCallback$1(callbackNode);
		    }
		    function scheduleImmediateRootScheduleTask() {
		      null !== ReactSharedInternals.actQueue &&
		        ReactSharedInternals.actQueue.push(function () {
		          processRootScheduleInMicrotask();
		          return null;
		        });
		      supportsMicrotasks
		        ? scheduleMicrotask(function () {
		            (executionContext & (RenderContext | CommitContext)) !== NoContext
		              ? scheduleCallback$3(
		                  ImmediatePriority,
		                  processRootScheduleInImmediateTask
		                )
		              : processRootScheduleInMicrotask();
		          })
		        : scheduleCallback$3(
		            ImmediatePriority,
		            processRootScheduleInImmediateTask
		          );
		    }
		    function requestTransitionLane() {
		      if (0 === currentEventTransitionLane) {
		        var actionScopeLane = currentEntangledLane;
		        0 === actionScopeLane &&
		          ((actionScopeLane = nextTransitionUpdateLane),
		          (nextTransitionUpdateLane <<= 1),
		          0 === (nextTransitionUpdateLane & 261888) &&
		            (nextTransitionUpdateLane = 256));
		        currentEventTransitionLane = actionScopeLane;
		      }
		      return currentEventTransitionLane;
		    }
		    function entangleAsyncAction(transition, thenable) {
		      if (null === currentEntangledListeners) {
		        var entangledListeners = (currentEntangledListeners = []);
		        currentEntangledPendingCount = 0;
		        currentEntangledLane = requestTransitionLane();
		        currentEntangledActionThenable = {
		          status: "pending",
		          value: void 0,
		          then: function (resolve) {
		            entangledListeners.push(resolve);
		          }
		        };
		      }
		      currentEntangledPendingCount++;
		      thenable.then(pingEngtangledActionScope, pingEngtangledActionScope);
		      return thenable;
		    }
		    function pingEngtangledActionScope() {
		      if (
		        0 === --currentEntangledPendingCount &&
		        (-1 < transitionUpdateTime || (transitionStartTime = -1.1),
		        null !== currentEntangledListeners)
		      ) {
		        null !== currentEntangledActionThenable &&
		          (currentEntangledActionThenable.status = "fulfilled");
		        var listeners = currentEntangledListeners;
		        currentEntangledListeners = null;
		        currentEntangledLane = 0;
		        currentEntangledActionThenable = null;
		        for (var i = 0; i < listeners.length; i++) (0, listeners[i])();
		      }
		    }
		    function chainThenableValue(thenable, result) {
		      var listeners = [],
		        thenableWithOverride = {
		          status: "pending",
		          value: null,
		          reason: null,
		          then: function (resolve) {
		            listeners.push(resolve);
		          }
		        };
		      thenable.then(
		        function () {
		          thenableWithOverride.status = "fulfilled";
		          thenableWithOverride.value = result;
		          for (var i = 0; i < listeners.length; i++) (0, listeners[i])(result);
		        },
		        function (error) {
		          thenableWithOverride.status = "rejected";
		          thenableWithOverride.reason = error;
		          for (error = 0; error < listeners.length; error++)
		            (0, listeners[error])(void 0);
		        }
		      );
		      return thenableWithOverride;
		    }
		    function peekCacheFromPool() {
		      var cacheResumedFromPreviousRender = resumedCache.current;
		      return null !== cacheResumedFromPreviousRender
		        ? cacheResumedFromPreviousRender
		        : workInProgressRoot.pooledCache;
		    }
		    function pushTransition(offscreenWorkInProgress, prevCachePool) {
		      null === prevCachePool
		        ? push(resumedCache, resumedCache.current, offscreenWorkInProgress)
		        : push(resumedCache, prevCachePool.pool, offscreenWorkInProgress);
		    }
		    function getSuspendedCache() {
		      var cacheFromPool = peekCacheFromPool();
		      return null === cacheFromPool
		        ? null
		        : {
		            parent: isPrimaryRenderer
		              ? CacheContext._currentValue
		              : CacheContext._currentValue2,
		            pool: cacheFromPool
		          };
		    }
		    function shallowEqual(objA, objB) {
		      if (objectIs(objA, objB)) return true;
		      if (
		        "object" !== typeof objA ||
		        null === objA ||
		        "object" !== typeof objB ||
		        null === objB
		      )
		        return false;
		      var keysA = Object.keys(objA),
		        keysB = Object.keys(objB);
		      if (keysA.length !== keysB.length) return false;
		      for (keysB = 0; keysB < keysA.length; keysB++) {
		        var currentKey = keysA[keysB];
		        if (
		          !hasOwnProperty.call(objB, currentKey) ||
		          !objectIs(objA[currentKey], objB[currentKey])
		        )
		          return false;
		      }
		      return true;
		    }
		    function createThenableState() {
		      return { didWarnAboutUncachedPromise: false, thenables: [] };
		    }
		    function isThenableResolved(thenable) {
		      thenable = thenable.status;
		      return "fulfilled" === thenable || "rejected" === thenable;
		    }
		    function trackUsedThenable(thenableState, thenable, index) {
		      null !== ReactSharedInternals.actQueue &&
		        (ReactSharedInternals.didUsePromise = true);
		      var trackedThenables = thenableState.thenables;
		      index = trackedThenables[index];
		      void 0 === index
		        ? trackedThenables.push(thenable)
		        : index !== thenable &&
		          (thenableState.didWarnAboutUncachedPromise ||
		            ((thenableState.didWarnAboutUncachedPromise = true),
		            console.error(
		              "A component was suspended by an uncached promise. Creating promises inside a Client Component or hook is not yet supported, except via a Suspense-compatible library or framework."
		            )),
		          thenable.then(noop$1, noop$1),
		          (thenable = index));
		      if (void 0 === thenable._debugInfo) {
		        thenableState = performance.now();
		        trackedThenables = thenable.displayName;
		        var ioInfo = {
		          name:
		            "string" === typeof trackedThenables ? trackedThenables : "Promise",
		          start: thenableState,
		          end: thenableState,
		          value: thenable
		        };
		        thenable._debugInfo = [{ awaited: ioInfo }];
		        "fulfilled" !== thenable.status &&
		          "rejected" !== thenable.status &&
		          ((thenableState = function () {
		            ioInfo.end = performance.now();
		          }),
		          thenable.then(thenableState, thenableState));
		      }
		      switch (thenable.status) {
		        case "fulfilled":
		          return thenable.value;
		        case "rejected":
		          throw (
		            ((thenableState = thenable.reason),
		            checkIfUseWrappedInAsyncCatch(thenableState),
		            thenableState)
		          );
		        default:
		          if ("string" === typeof thenable.status)
		            thenable.then(noop$1, noop$1);
		          else {
		            thenableState = workInProgressRoot;
		            if (
		              null !== thenableState &&
		              100 < thenableState.shellSuspendCounter
		            )
		              throw Error(
		                "An unknown Component is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server."
		              );
		            thenableState = thenable;
		            thenableState.status = "pending";
		            thenableState.then(
		              function (fulfilledValue) {
		                if ("pending" === thenable.status) {
		                  var fulfilledThenable = thenable;
		                  fulfilledThenable.status = "fulfilled";
		                  fulfilledThenable.value = fulfilledValue;
		                }
		              },
		              function (error) {
		                if ("pending" === thenable.status) {
		                  var rejectedThenable = thenable;
		                  rejectedThenable.status = "rejected";
		                  rejectedThenable.reason = error;
		                }
		              }
		            );
		          }
		          switch (thenable.status) {
		            case "fulfilled":
		              return thenable.value;
		            case "rejected":
		              throw (
		                ((thenableState = thenable.reason),
		                checkIfUseWrappedInAsyncCatch(thenableState),
		                thenableState)
		              );
		          }
		          suspendedThenable = thenable;
		          needsToResetSuspendedThenableDEV = true;
		          throw SuspenseException;
		      }
		    }
		    function resolveLazy(lazyType) {
		      try {
		        return callLazyInitInDEV(lazyType);
		      } catch (x) {
		        if (null !== x && "object" === typeof x && "function" === typeof x.then)
		          throw (
		            ((suspendedThenable = x),
		            (needsToResetSuspendedThenableDEV = true),
		            SuspenseException)
		          );
		        throw x;
		      }
		    }
		    function getSuspendedThenable() {
		      if (null === suspendedThenable)
		        throw Error(
		          "Expected a suspended thenable. This is a bug in React. Please file an issue."
		        );
		      var thenable = suspendedThenable;
		      suspendedThenable = null;
		      needsToResetSuspendedThenableDEV = false;
		      return thenable;
		    }
		    function checkIfUseWrappedInAsyncCatch(rejectedReason) {
		      if (
		        rejectedReason === SuspenseException ||
		        rejectedReason === SuspenseActionException
		      )
		        throw Error(
		          "Hooks are not supported inside an async component. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server."
		        );
		    }
		    function pushDebugInfo(debugInfo) {
		      var previousDebugInfo = currentDebugInfo;
		      null != debugInfo &&
		        (currentDebugInfo =
		          null === previousDebugInfo
		            ? debugInfo
		            : previousDebugInfo.concat(debugInfo));
		      return previousDebugInfo;
		    }
		    function getCurrentDebugTask() {
		      var debugInfo = currentDebugInfo;
		      if (null != debugInfo)
		        for (var i = debugInfo.length - 1; 0 <= i; i--)
		          if (null != debugInfo[i].name) {
		            var debugTask = debugInfo[i].debugTask;
		            if (null != debugTask) return debugTask;
		          }
		      return null;
		    }
		    function validateFragmentProps(element, fiber, returnFiber) {
		      for (var keys = Object.keys(element.props), i = 0; i < keys.length; i++) {
		        var key = keys[i];
		        if ("children" !== key && "key" !== key) {
		          null === fiber &&
		            ((fiber = createFiberFromElement(element, returnFiber.mode, 0)),
		            (fiber._debugInfo = currentDebugInfo),
		            (fiber.return = returnFiber));
		          runWithFiberInDEV(
		            fiber,
		            function (erroredKey) {
		              console.error(
		                "Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.",
		                erroredKey
		              );
		            },
		            key
		          );
		          break;
		        }
		      }
		    }
		    function unwrapThenable(thenable) {
		      var index = thenableIndexCounter$1;
		      thenableIndexCounter$1 += 1;
		      null === thenableState$1 && (thenableState$1 = createThenableState());
		      return trackUsedThenable(thenableState$1, thenable, index);
		    }
		    function coerceRef(workInProgress, element) {
		      element = element.props.ref;
		      workInProgress.ref = void 0 !== element ? element : null;
		    }
		    function throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
		      if (newChild.$$typeof === REACT_LEGACY_ELEMENT_TYPE)
		        throw Error(
		          'A React Element from an older version of React was rendered. This is not supported. It can happen if:\n- Multiple copies of the "react" package is used.\n- A library pre-bundled an old copy of "react" or "react/jsx-runtime".\n- A compiler tries to "inline" JSX instead of using the runtime.'
		        );
		      returnFiber = Object.prototype.toString.call(newChild);
		      throw Error(
		        "Objects are not valid as a React child (found: " +
		          ("[object Object]" === returnFiber
		            ? "object with keys {" + Object.keys(newChild).join(", ") + "}"
		            : returnFiber) +
		          "). If you meant to render a collection of children, use an array instead."
		      );
		    }
		    function throwOnInvalidObjectType(returnFiber, newChild) {
		      var debugTask = getCurrentDebugTask();
		      null !== debugTask
		        ? debugTask.run(
		            throwOnInvalidObjectTypeImpl.bind(null, returnFiber, newChild)
		          )
		        : throwOnInvalidObjectTypeImpl(returnFiber, newChild);
		    }
		    function warnOnFunctionTypeImpl(returnFiber, invalidChild) {
		      var parentName = getComponentNameFromFiber(returnFiber) || "Component";
		      ownerHasFunctionTypeWarning[parentName] ||
		        ((ownerHasFunctionTypeWarning[parentName] = true),
		        (invalidChild =
		          invalidChild.displayName || invalidChild.name || "Component"),
		        3 === returnFiber.tag
		          ? console.error(
		              "Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.\n  root.render(%s)",
		              invalidChild,
		              invalidChild,
		              invalidChild
		            )
		          : console.error(
		              "Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.\n  <%s>{%s}</%s>",
		              invalidChild,
		              invalidChild,
		              parentName,
		              invalidChild,
		              parentName
		            ));
		    }
		    function warnOnFunctionType(returnFiber, invalidChild) {
		      var debugTask = getCurrentDebugTask();
		      null !== debugTask
		        ? debugTask.run(
		            warnOnFunctionTypeImpl.bind(null, returnFiber, invalidChild)
		          )
		        : warnOnFunctionTypeImpl(returnFiber, invalidChild);
		    }
		    function warnOnSymbolTypeImpl(returnFiber, invalidChild) {
		      var parentName = getComponentNameFromFiber(returnFiber) || "Component";
		      ownerHasSymbolTypeWarning[parentName] ||
		        ((ownerHasSymbolTypeWarning[parentName] = true),
		        (invalidChild = String(invalidChild)),
		        3 === returnFiber.tag
		          ? console.error(
		              "Symbols are not valid as a React child.\n  root.render(%s)",
		              invalidChild
		            )
		          : console.error(
		              "Symbols are not valid as a React child.\n  <%s>%s</%s>",
		              parentName,
		              invalidChild,
		              parentName
		            ));
		    }
		    function warnOnSymbolType(returnFiber, invalidChild) {
		      var debugTask = getCurrentDebugTask();
		      null !== debugTask
		        ? debugTask.run(
		            warnOnSymbolTypeImpl.bind(null, returnFiber, invalidChild)
		          )
		        : warnOnSymbolTypeImpl(returnFiber, invalidChild);
		    }
		    function createChildReconciler(shouldTrackSideEffects) {
		      function deleteChild(returnFiber, childToDelete) {
		        if (shouldTrackSideEffects) {
		          var deletions = returnFiber.deletions;
		          null === deletions
		            ? ((returnFiber.deletions = [childToDelete]),
		              (returnFiber.flags |= 16))
		            : deletions.push(childToDelete);
		        }
		      }
		      function deleteRemainingChildren(returnFiber, currentFirstChild) {
		        if (!shouldTrackSideEffects) return null;
		        for (; null !== currentFirstChild; )
		          deleteChild(returnFiber, currentFirstChild),
		            (currentFirstChild = currentFirstChild.sibling);
		        return null;
		      }
		      function mapRemainingChildren(currentFirstChild) {
		        for (var existingChildren = new Map(); null !== currentFirstChild; )
		          null !== currentFirstChild.key
		            ? existingChildren.set(currentFirstChild.key, currentFirstChild)
		            : existingChildren.set(currentFirstChild.index, currentFirstChild),
		            (currentFirstChild = currentFirstChild.sibling);
		        return existingChildren;
		      }
		      function useFiber(fiber, pendingProps) {
		        fiber = createWorkInProgress(fiber, pendingProps);
		        fiber.index = 0;
		        fiber.sibling = null;
		        return fiber;
		      }
		      function placeChild(newFiber, lastPlacedIndex, newIndex) {
		        newFiber.index = newIndex;
		        if (!shouldTrackSideEffects)
		          return (newFiber.flags |= 1048576), lastPlacedIndex;
		        newIndex = newFiber.alternate;
		        if (null !== newIndex)
		          return (
		            (newIndex = newIndex.index),
		            newIndex < lastPlacedIndex
		              ? ((newFiber.flags |= 67108866), lastPlacedIndex)
		              : newIndex
		          );
		        newFiber.flags |= 67108866;
		        return lastPlacedIndex;
		      }
		      function placeSingleChild(newFiber) {
		        shouldTrackSideEffects &&
		          null === newFiber.alternate &&
		          (newFiber.flags |= 67108866);
		        return newFiber;
		      }
		      function updateTextNode(returnFiber, current, textContent, lanes) {
		        if (null === current || 6 !== current.tag)
		          return (
		            (current = createFiberFromText(
		              textContent,
		              returnFiber.mode,
		              lanes
		            )),
		            (current.return = returnFiber),
		            (current._debugOwner = returnFiber),
		            (current._debugTask = returnFiber._debugTask),
		            (current._debugInfo = currentDebugInfo),
		            current
		          );
		        current = useFiber(current, textContent);
		        current.return = returnFiber;
		        current._debugInfo = currentDebugInfo;
		        return current;
		      }
		      function updateElement(returnFiber, current, element, lanes) {
		        var elementType = element.type;
		        if (elementType === REACT_FRAGMENT_TYPE)
		          return (
		            (current = updateFragment(
		              returnFiber,
		              current,
		              element.props.children,
		              lanes,
		              element.key
		            )),
		            validateFragmentProps(element, current, returnFiber),
		            current
		          );
		        if (
		          null !== current &&
		          (current.elementType === elementType ||
		            isCompatibleFamilyForHotReloading(current, element) ||
		            ("object" === typeof elementType &&
		              null !== elementType &&
		              elementType.$$typeof === REACT_LAZY_TYPE &&
		              resolveLazy(elementType) === current.type))
		        )
		          return (
		            (current = useFiber(current, element.props)),
		            coerceRef(current, element),
		            (current.return = returnFiber),
		            (current._debugOwner = element._owner),
		            (current._debugInfo = currentDebugInfo),
		            current
		          );
		        current = createFiberFromElement(element, returnFiber.mode, lanes);
		        coerceRef(current, element);
		        current.return = returnFiber;
		        current._debugInfo = currentDebugInfo;
		        return current;
		      }
		      function updatePortal(returnFiber, current, portal, lanes) {
		        if (
		          null === current ||
		          4 !== current.tag ||
		          current.stateNode.containerInfo !== portal.containerInfo ||
		          current.stateNode.implementation !== portal.implementation
		        )
		          return (
		            (current = createFiberFromPortal(portal, returnFiber.mode, lanes)),
		            (current.return = returnFiber),
		            (current._debugInfo = currentDebugInfo),
		            current
		          );
		        current = useFiber(current, portal.children || []);
		        current.return = returnFiber;
		        current._debugInfo = currentDebugInfo;
		        return current;
		      }
		      function updateFragment(returnFiber, current, fragment, lanes, key) {
		        if (null === current || 7 !== current.tag)
		          return (
		            (current = createFiberFromFragment(
		              fragment,
		              returnFiber.mode,
		              lanes,
		              key
		            )),
		            (current.return = returnFiber),
		            (current._debugOwner = returnFiber),
		            (current._debugTask = returnFiber._debugTask),
		            (current._debugInfo = currentDebugInfo),
		            current
		          );
		        current = useFiber(current, fragment);
		        current.return = returnFiber;
		        current._debugInfo = currentDebugInfo;
		        return current;
		      }
		      function createChild(returnFiber, newChild, lanes) {
		        if (
		          ("string" === typeof newChild && "" !== newChild) ||
		          "number" === typeof newChild ||
		          "bigint" === typeof newChild
		        )
		          return (
		            (newChild = createFiberFromText(
		              "" + newChild,
		              returnFiber.mode,
		              lanes
		            )),
		            (newChild.return = returnFiber),
		            (newChild._debugOwner = returnFiber),
		            (newChild._debugTask = returnFiber._debugTask),
		            (newChild._debugInfo = currentDebugInfo),
		            newChild
		          );
		        if ("object" === typeof newChild && null !== newChild) {
		          switch (newChild.$$typeof) {
		            case REACT_ELEMENT_TYPE:
		              return (
		                (lanes = createFiberFromElement(
		                  newChild,
		                  returnFiber.mode,
		                  lanes
		                )),
		                coerceRef(lanes, newChild),
		                (lanes.return = returnFiber),
		                (returnFiber = pushDebugInfo(newChild._debugInfo)),
		                (lanes._debugInfo = currentDebugInfo),
		                (currentDebugInfo = returnFiber),
		                lanes
		              );
		            case REACT_PORTAL_TYPE:
		              return (
		                (newChild = createFiberFromPortal(
		                  newChild,
		                  returnFiber.mode,
		                  lanes
		                )),
		                (newChild.return = returnFiber),
		                (newChild._debugInfo = currentDebugInfo),
		                newChild
		              );
		            case REACT_LAZY_TYPE:
		              var _prevDebugInfo = pushDebugInfo(newChild._debugInfo);
		              newChild = resolveLazy(newChild);
		              returnFiber = createChild(returnFiber, newChild, lanes);
		              currentDebugInfo = _prevDebugInfo;
		              return returnFiber;
		          }
		          if (isArrayImpl(newChild) || getIteratorFn(newChild))
		            return (
		              (lanes = createFiberFromFragment(
		                newChild,
		                returnFiber.mode,
		                lanes,
		                null
		              )),
		              (lanes.return = returnFiber),
		              (lanes._debugOwner = returnFiber),
		              (lanes._debugTask = returnFiber._debugTask),
		              (returnFiber = pushDebugInfo(newChild._debugInfo)),
		              (lanes._debugInfo = currentDebugInfo),
		              (currentDebugInfo = returnFiber),
		              lanes
		            );
		          if ("function" === typeof newChild.then)
		            return (
		              (_prevDebugInfo = pushDebugInfo(newChild._debugInfo)),
		              (returnFiber = createChild(
		                returnFiber,
		                unwrapThenable(newChild),
		                lanes
		              )),
		              (currentDebugInfo = _prevDebugInfo),
		              returnFiber
		            );
		          if (newChild.$$typeof === REACT_CONTEXT_TYPE)
		            return createChild(
		              returnFiber,
		              readContextDuringReconciliation(returnFiber, newChild),
		              lanes
		            );
		          throwOnInvalidObjectType(returnFiber, newChild);
		        }
		        "function" === typeof newChild &&
		          warnOnFunctionType(returnFiber, newChild);
		        "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
		        return null;
		      }
		      function updateSlot(returnFiber, oldFiber, newChild, lanes) {
		        var key = null !== oldFiber ? oldFiber.key : null;
		        if (
		          ("string" === typeof newChild && "" !== newChild) ||
		          "number" === typeof newChild ||
		          "bigint" === typeof newChild
		        )
		          return null !== key
		            ? null
		            : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
		        if ("object" === typeof newChild && null !== newChild) {
		          switch (newChild.$$typeof) {
		            case REACT_ELEMENT_TYPE:
		              return newChild.key === key
		                ? ((key = pushDebugInfo(newChild._debugInfo)),
		                  (returnFiber = updateElement(
		                    returnFiber,
		                    oldFiber,
		                    newChild,
		                    lanes
		                  )),
		                  (currentDebugInfo = key),
		                  returnFiber)
		                : null;
		            case REACT_PORTAL_TYPE:
		              return newChild.key === key
		                ? updatePortal(returnFiber, oldFiber, newChild, lanes)
		                : null;
		            case REACT_LAZY_TYPE:
		              return (
		                (key = pushDebugInfo(newChild._debugInfo)),
		                (newChild = resolveLazy(newChild)),
		                (returnFiber = updateSlot(
		                  returnFiber,
		                  oldFiber,
		                  newChild,
		                  lanes
		                )),
		                (currentDebugInfo = key),
		                returnFiber
		              );
		          }
		          if (isArrayImpl(newChild) || getIteratorFn(newChild)) {
		            if (null !== key) return null;
		            key = pushDebugInfo(newChild._debugInfo);
		            returnFiber = updateFragment(
		              returnFiber,
		              oldFiber,
		              newChild,
		              lanes,
		              null
		            );
		            currentDebugInfo = key;
		            return returnFiber;
		          }
		          if ("function" === typeof newChild.then)
		            return (
		              (key = pushDebugInfo(newChild._debugInfo)),
		              (returnFiber = updateSlot(
		                returnFiber,
		                oldFiber,
		                unwrapThenable(newChild),
		                lanes
		              )),
		              (currentDebugInfo = key),
		              returnFiber
		            );
		          if (newChild.$$typeof === REACT_CONTEXT_TYPE)
		            return updateSlot(
		              returnFiber,
		              oldFiber,
		              readContextDuringReconciliation(returnFiber, newChild),
		              lanes
		            );
		          throwOnInvalidObjectType(returnFiber, newChild);
		        }
		        "function" === typeof newChild &&
		          warnOnFunctionType(returnFiber, newChild);
		        "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
		        return null;
		      }
		      function updateFromMap(
		        existingChildren,
		        returnFiber,
		        newIdx,
		        newChild,
		        lanes
		      ) {
		        if (
		          ("string" === typeof newChild && "" !== newChild) ||
		          "number" === typeof newChild ||
		          "bigint" === typeof newChild
		        )
		          return (
		            (existingChildren = existingChildren.get(newIdx) || null),
		            updateTextNode(returnFiber, existingChildren, "" + newChild, lanes)
		          );
		        if ("object" === typeof newChild && null !== newChild) {
		          switch (newChild.$$typeof) {
		            case REACT_ELEMENT_TYPE:
		              return (
		                (newIdx =
		                  existingChildren.get(
		                    null === newChild.key ? newIdx : newChild.key
		                  ) || null),
		                (existingChildren = pushDebugInfo(newChild._debugInfo)),
		                (returnFiber = updateElement(
		                  returnFiber,
		                  newIdx,
		                  newChild,
		                  lanes
		                )),
		                (currentDebugInfo = existingChildren),
		                returnFiber
		              );
		            case REACT_PORTAL_TYPE:
		              return (
		                (existingChildren =
		                  existingChildren.get(
		                    null === newChild.key ? newIdx : newChild.key
		                  ) || null),
		                updatePortal(returnFiber, existingChildren, newChild, lanes)
		              );
		            case REACT_LAZY_TYPE:
		              var _prevDebugInfo7 = pushDebugInfo(newChild._debugInfo);
		              newChild = resolveLazy(newChild);
		              returnFiber = updateFromMap(
		                existingChildren,
		                returnFiber,
		                newIdx,
		                newChild,
		                lanes
		              );
		              currentDebugInfo = _prevDebugInfo7;
		              return returnFiber;
		          }
		          if (isArrayImpl(newChild) || getIteratorFn(newChild))
		            return (
		              (newIdx = existingChildren.get(newIdx) || null),
		              (existingChildren = pushDebugInfo(newChild._debugInfo)),
		              (returnFiber = updateFragment(
		                returnFiber,
		                newIdx,
		                newChild,
		                lanes,
		                null
		              )),
		              (currentDebugInfo = existingChildren),
		              returnFiber
		            );
		          if ("function" === typeof newChild.then)
		            return (
		              (_prevDebugInfo7 = pushDebugInfo(newChild._debugInfo)),
		              (returnFiber = updateFromMap(
		                existingChildren,
		                returnFiber,
		                newIdx,
		                unwrapThenable(newChild),
		                lanes
		              )),
		              (currentDebugInfo = _prevDebugInfo7),
		              returnFiber
		            );
		          if (newChild.$$typeof === REACT_CONTEXT_TYPE)
		            return updateFromMap(
		              existingChildren,
		              returnFiber,
		              newIdx,
		              readContextDuringReconciliation(returnFiber, newChild),
		              lanes
		            );
		          throwOnInvalidObjectType(returnFiber, newChild);
		        }
		        "function" === typeof newChild &&
		          warnOnFunctionType(returnFiber, newChild);
		        "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
		        return null;
		      }
		      function warnOnInvalidKey(returnFiber, workInProgress, child, knownKeys) {
		        if ("object" !== typeof child || null === child) return knownKeys;
		        switch (child.$$typeof) {
		          case REACT_ELEMENT_TYPE:
		          case REACT_PORTAL_TYPE:
		            warnForMissingKey(returnFiber, workInProgress, child);
		            var key = child.key;
		            if ("string" !== typeof key) break;
		            if (null === knownKeys) {
		              knownKeys = new Set();
		              knownKeys.add(key);
		              break;
		            }
		            if (!knownKeys.has(key)) {
		              knownKeys.add(key);
		              break;
		            }
		            runWithFiberInDEV(workInProgress, function () {
		              console.error(
		                "Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted \u2014 the behavior is unsupported and could change in a future version.",
		                key
		              );
		            });
		            break;
		          case REACT_LAZY_TYPE:
		            (child = resolveLazy(child)),
		              warnOnInvalidKey(returnFiber, workInProgress, child, knownKeys);
		        }
		        return knownKeys;
		      }
		      function reconcileChildrenArray(
		        returnFiber,
		        currentFirstChild,
		        newChildren,
		        lanes
		      ) {
		        for (
		          var knownKeys = null,
		            resultingFirstChild = null,
		            previousNewFiber = null,
		            oldFiber = currentFirstChild,
		            newIdx = (currentFirstChild = 0),
		            nextOldFiber = null;
		          null !== oldFiber && newIdx < newChildren.length;
		          newIdx++
		        ) {
		          oldFiber.index > newIdx
		            ? ((nextOldFiber = oldFiber), (oldFiber = null))
		            : (nextOldFiber = oldFiber.sibling);
		          var newFiber = updateSlot(
		            returnFiber,
		            oldFiber,
		            newChildren[newIdx],
		            lanes
		          );
		          if (null === newFiber) {
		            null === oldFiber && (oldFiber = nextOldFiber);
		            break;
		          }
		          knownKeys = warnOnInvalidKey(
		            returnFiber,
		            newFiber,
		            newChildren[newIdx],
		            knownKeys
		          );
		          shouldTrackSideEffects &&
		            oldFiber &&
		            null === newFiber.alternate &&
		            deleteChild(returnFiber, oldFiber);
		          currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
		          null === previousNewFiber
		            ? (resultingFirstChild = newFiber)
		            : (previousNewFiber.sibling = newFiber);
		          previousNewFiber = newFiber;
		          oldFiber = nextOldFiber;
		        }
		        if (newIdx === newChildren.length)
		          return (
		            deleteRemainingChildren(returnFiber, oldFiber),
		            isHydrating && pushTreeFork(returnFiber, newIdx),
		            resultingFirstChild
		          );
		        if (null === oldFiber) {
		          for (; newIdx < newChildren.length; newIdx++)
		            (oldFiber = createChild(returnFiber, newChildren[newIdx], lanes)),
		              null !== oldFiber &&
		                ((knownKeys = warnOnInvalidKey(
		                  returnFiber,
		                  oldFiber,
		                  newChildren[newIdx],
		                  knownKeys
		                )),
		                (currentFirstChild = placeChild(
		                  oldFiber,
		                  currentFirstChild,
		                  newIdx
		                )),
		                null === previousNewFiber
		                  ? (resultingFirstChild = oldFiber)
		                  : (previousNewFiber.sibling = oldFiber),
		                (previousNewFiber = oldFiber));
		          isHydrating && pushTreeFork(returnFiber, newIdx);
		          return resultingFirstChild;
		        }
		        for (
		          oldFiber = mapRemainingChildren(oldFiber);
		          newIdx < newChildren.length;
		          newIdx++
		        )
		          (nextOldFiber = updateFromMap(
		            oldFiber,
		            returnFiber,
		            newIdx,
		            newChildren[newIdx],
		            lanes
		          )),
		            null !== nextOldFiber &&
		              ((knownKeys = warnOnInvalidKey(
		                returnFiber,
		                nextOldFiber,
		                newChildren[newIdx],
		                knownKeys
		              )),
		              shouldTrackSideEffects &&
		                null !== nextOldFiber.alternate &&
		                oldFiber.delete(
		                  null === nextOldFiber.key ? newIdx : nextOldFiber.key
		                ),
		              (currentFirstChild = placeChild(
		                nextOldFiber,
		                currentFirstChild,
		                newIdx
		              )),
		              null === previousNewFiber
		                ? (resultingFirstChild = nextOldFiber)
		                : (previousNewFiber.sibling = nextOldFiber),
		              (previousNewFiber = nextOldFiber));
		        shouldTrackSideEffects &&
		          oldFiber.forEach(function (child) {
		            return deleteChild(returnFiber, child);
		          });
		        isHydrating && pushTreeFork(returnFiber, newIdx);
		        return resultingFirstChild;
		      }
		      function reconcileChildrenIterator(
		        returnFiber,
		        currentFirstChild,
		        newChildren,
		        lanes
		      ) {
		        if (null == newChildren)
		          throw Error("An iterable object provided no iterator.");
		        for (
		          var resultingFirstChild = null,
		            previousNewFiber = null,
		            oldFiber = currentFirstChild,
		            newIdx = (currentFirstChild = 0),
		            nextOldFiber = null,
		            knownKeys = null,
		            step = newChildren.next();
		          null !== oldFiber && !step.done;
		          newIdx++, step = newChildren.next()
		        ) {
		          oldFiber.index > newIdx
		            ? ((nextOldFiber = oldFiber), (oldFiber = null))
		            : (nextOldFiber = oldFiber.sibling);
		          var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
		          if (null === newFiber) {
		            null === oldFiber && (oldFiber = nextOldFiber);
		            break;
		          }
		          knownKeys = warnOnInvalidKey(
		            returnFiber,
		            newFiber,
		            step.value,
		            knownKeys
		          );
		          shouldTrackSideEffects &&
		            oldFiber &&
		            null === newFiber.alternate &&
		            deleteChild(returnFiber, oldFiber);
		          currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
		          null === previousNewFiber
		            ? (resultingFirstChild = newFiber)
		            : (previousNewFiber.sibling = newFiber);
		          previousNewFiber = newFiber;
		          oldFiber = nextOldFiber;
		        }
		        if (step.done)
		          return (
		            deleteRemainingChildren(returnFiber, oldFiber),
		            isHydrating && pushTreeFork(returnFiber, newIdx),
		            resultingFirstChild
		          );
		        if (null === oldFiber) {
		          for (; !step.done; newIdx++, step = newChildren.next())
		            (oldFiber = createChild(returnFiber, step.value, lanes)),
		              null !== oldFiber &&
		                ((knownKeys = warnOnInvalidKey(
		                  returnFiber,
		                  oldFiber,
		                  step.value,
		                  knownKeys
		                )),
		                (currentFirstChild = placeChild(
		                  oldFiber,
		                  currentFirstChild,
		                  newIdx
		                )),
		                null === previousNewFiber
		                  ? (resultingFirstChild = oldFiber)
		                  : (previousNewFiber.sibling = oldFiber),
		                (previousNewFiber = oldFiber));
		          isHydrating && pushTreeFork(returnFiber, newIdx);
		          return resultingFirstChild;
		        }
		        for (
		          oldFiber = mapRemainingChildren(oldFiber);
		          !step.done;
		          newIdx++, step = newChildren.next()
		        )
		          (nextOldFiber = updateFromMap(
		            oldFiber,
		            returnFiber,
		            newIdx,
		            step.value,
		            lanes
		          )),
		            null !== nextOldFiber &&
		              ((knownKeys = warnOnInvalidKey(
		                returnFiber,
		                nextOldFiber,
		                step.value,
		                knownKeys
		              )),
		              shouldTrackSideEffects &&
		                null !== nextOldFiber.alternate &&
		                oldFiber.delete(
		                  null === nextOldFiber.key ? newIdx : nextOldFiber.key
		                ),
		              (currentFirstChild = placeChild(
		                nextOldFiber,
		                currentFirstChild,
		                newIdx
		              )),
		              null === previousNewFiber
		                ? (resultingFirstChild = nextOldFiber)
		                : (previousNewFiber.sibling = nextOldFiber),
		              (previousNewFiber = nextOldFiber));
		        shouldTrackSideEffects &&
		          oldFiber.forEach(function (child) {
		            return deleteChild(returnFiber, child);
		          });
		        isHydrating && pushTreeFork(returnFiber, newIdx);
		        return resultingFirstChild;
		      }
		      function reconcileChildFibersImpl(
		        returnFiber,
		        currentFirstChild,
		        newChild,
		        lanes
		      ) {
		        "object" === typeof newChild &&
		          null !== newChild &&
		          newChild.type === REACT_FRAGMENT_TYPE &&
		          null === newChild.key &&
		          (validateFragmentProps(newChild, null, returnFiber),
		          (newChild = newChild.props.children));
		        if ("object" === typeof newChild && null !== newChild) {
		          switch (newChild.$$typeof) {
		            case REACT_ELEMENT_TYPE:
		              var prevDebugInfo = pushDebugInfo(newChild._debugInfo);
		              a: {
		                for (var key = newChild.key; null !== currentFirstChild; ) {
		                  if (currentFirstChild.key === key) {
		                    key = newChild.type;
		                    if (key === REACT_FRAGMENT_TYPE) {
		                      if (7 === currentFirstChild.tag) {
		                        deleteRemainingChildren(
		                          returnFiber,
		                          currentFirstChild.sibling
		                        );
		                        lanes = useFiber(
		                          currentFirstChild,
		                          newChild.props.children
		                        );
		                        lanes.return = returnFiber;
		                        lanes._debugOwner = newChild._owner;
		                        lanes._debugInfo = currentDebugInfo;
		                        validateFragmentProps(newChild, lanes, returnFiber);
		                        returnFiber = lanes;
		                        break a;
		                      }
		                    } else if (
		                      currentFirstChild.elementType === key ||
		                      isCompatibleFamilyForHotReloading(
		                        currentFirstChild,
		                        newChild
		                      ) ||
		                      ("object" === typeof key &&
		                        null !== key &&
		                        key.$$typeof === REACT_LAZY_TYPE &&
		                        resolveLazy(key) === currentFirstChild.type)
		                    ) {
		                      deleteRemainingChildren(
		                        returnFiber,
		                        currentFirstChild.sibling
		                      );
		                      lanes = useFiber(currentFirstChild, newChild.props);
		                      coerceRef(lanes, newChild);
		                      lanes.return = returnFiber;
		                      lanes._debugOwner = newChild._owner;
		                      lanes._debugInfo = currentDebugInfo;
		                      returnFiber = lanes;
		                      break a;
		                    }
		                    deleteRemainingChildren(returnFiber, currentFirstChild);
		                    break;
		                  } else deleteChild(returnFiber, currentFirstChild);
		                  currentFirstChild = currentFirstChild.sibling;
		                }
		                newChild.type === REACT_FRAGMENT_TYPE
		                  ? ((lanes = createFiberFromFragment(
		                      newChild.props.children,
		                      returnFiber.mode,
		                      lanes,
		                      newChild.key
		                    )),
		                    (lanes.return = returnFiber),
		                    (lanes._debugOwner = returnFiber),
		                    (lanes._debugTask = returnFiber._debugTask),
		                    (lanes._debugInfo = currentDebugInfo),
		                    validateFragmentProps(newChild, lanes, returnFiber),
		                    (returnFiber = lanes))
		                  : ((lanes = createFiberFromElement(
		                      newChild,
		                      returnFiber.mode,
		                      lanes
		                    )),
		                    coerceRef(lanes, newChild),
		                    (lanes.return = returnFiber),
		                    (lanes._debugInfo = currentDebugInfo),
		                    (returnFiber = lanes));
		              }
		              returnFiber = placeSingleChild(returnFiber);
		              currentDebugInfo = prevDebugInfo;
		              return returnFiber;
		            case REACT_PORTAL_TYPE:
		              a: {
		                prevDebugInfo = newChild;
		                for (
		                  newChild = prevDebugInfo.key;
		                  null !== currentFirstChild;

		                ) {
		                  if (currentFirstChild.key === newChild)
		                    if (
		                      4 === currentFirstChild.tag &&
		                      currentFirstChild.stateNode.containerInfo ===
		                        prevDebugInfo.containerInfo &&
		                      currentFirstChild.stateNode.implementation ===
		                        prevDebugInfo.implementation
		                    ) {
		                      deleteRemainingChildren(
		                        returnFiber,
		                        currentFirstChild.sibling
		                      );
		                      lanes = useFiber(
		                        currentFirstChild,
		                        prevDebugInfo.children || []
		                      );
		                      lanes.return = returnFiber;
		                      returnFiber = lanes;
		                      break a;
		                    } else {
		                      deleteRemainingChildren(returnFiber, currentFirstChild);
		                      break;
		                    }
		                  else deleteChild(returnFiber, currentFirstChild);
		                  currentFirstChild = currentFirstChild.sibling;
		                }
		                lanes = createFiberFromPortal(
		                  prevDebugInfo,
		                  returnFiber.mode,
		                  lanes
		                );
		                lanes.return = returnFiber;
		                returnFiber = lanes;
		              }
		              return placeSingleChild(returnFiber);
		            case REACT_LAZY_TYPE:
		              return (
		                (prevDebugInfo = pushDebugInfo(newChild._debugInfo)),
		                (newChild = resolveLazy(newChild)),
		                (returnFiber = reconcileChildFibersImpl(
		                  returnFiber,
		                  currentFirstChild,
		                  newChild,
		                  lanes
		                )),
		                (currentDebugInfo = prevDebugInfo),
		                returnFiber
		              );
		          }
		          if (isArrayImpl(newChild))
		            return (
		              (prevDebugInfo = pushDebugInfo(newChild._debugInfo)),
		              (returnFiber = reconcileChildrenArray(
		                returnFiber,
		                currentFirstChild,
		                newChild,
		                lanes
		              )),
		              (currentDebugInfo = prevDebugInfo),
		              returnFiber
		            );
		          if (getIteratorFn(newChild)) {
		            prevDebugInfo = pushDebugInfo(newChild._debugInfo);
		            key = getIteratorFn(newChild);
		            if ("function" !== typeof key)
		              throw Error(
		                "An object is not an iterable. This error is likely caused by a bug in React. Please file an issue."
		              );
		            var newChildren = key.call(newChild);
		            if (newChildren === newChild) {
		              if (
		                0 !== returnFiber.tag ||
		                "[object GeneratorFunction]" !==
		                  Object.prototype.toString.call(returnFiber.type) ||
		                "[object Generator]" !==
		                  Object.prototype.toString.call(newChildren)
		              )
		                didWarnAboutGenerators ||
		                  console.error(
		                    "Using Iterators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. You can also use an Iterable that can iterate multiple times over the same items."
		                  ),
		                  (didWarnAboutGenerators = true);
		            } else
		              newChild.entries !== key ||
		                didWarnAboutMaps ||
		                (console.error(
		                  "Using Maps as children is not supported. Use an array of keyed ReactElements instead."
		                ),
		                (didWarnAboutMaps = true));
		            returnFiber = reconcileChildrenIterator(
		              returnFiber,
		              currentFirstChild,
		              newChildren,
		              lanes
		            );
		            currentDebugInfo = prevDebugInfo;
		            return returnFiber;
		          }
		          if ("function" === typeof newChild.then)
		            return (
		              (prevDebugInfo = pushDebugInfo(newChild._debugInfo)),
		              (returnFiber = reconcileChildFibersImpl(
		                returnFiber,
		                currentFirstChild,
		                unwrapThenable(newChild),
		                lanes
		              )),
		              (currentDebugInfo = prevDebugInfo),
		              returnFiber
		            );
		          if (newChild.$$typeof === REACT_CONTEXT_TYPE)
		            return reconcileChildFibersImpl(
		              returnFiber,
		              currentFirstChild,
		              readContextDuringReconciliation(returnFiber, newChild),
		              lanes
		            );
		          throwOnInvalidObjectType(returnFiber, newChild);
		        }
		        if (
		          ("string" === typeof newChild && "" !== newChild) ||
		          "number" === typeof newChild ||
		          "bigint" === typeof newChild
		        )
		          return (
		            (prevDebugInfo = "" + newChild),
		            null !== currentFirstChild && 6 === currentFirstChild.tag
		              ? (deleteRemainingChildren(
		                  returnFiber,
		                  currentFirstChild.sibling
		                ),
		                (lanes = useFiber(currentFirstChild, prevDebugInfo)),
		                (lanes.return = returnFiber),
		                (returnFiber = lanes))
		              : (deleteRemainingChildren(returnFiber, currentFirstChild),
		                (lanes = createFiberFromText(
		                  prevDebugInfo,
		                  returnFiber.mode,
		                  lanes
		                )),
		                (lanes.return = returnFiber),
		                (lanes._debugOwner = returnFiber),
		                (lanes._debugTask = returnFiber._debugTask),
		                (lanes._debugInfo = currentDebugInfo),
		                (returnFiber = lanes)),
		            placeSingleChild(returnFiber)
		          );
		        "function" === typeof newChild &&
		          warnOnFunctionType(returnFiber, newChild);
		        "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
		        return deleteRemainingChildren(returnFiber, currentFirstChild);
		      }
		      return function (returnFiber, currentFirstChild, newChild, lanes) {
		        var prevDebugInfo = currentDebugInfo;
		        currentDebugInfo = null;
		        try {
		          thenableIndexCounter$1 = 0;
		          var firstChildFiber = reconcileChildFibersImpl(
		            returnFiber,
		            currentFirstChild,
		            newChild,
		            lanes
		          );
		          thenableState$1 = null;
		          return firstChildFiber;
		        } catch (x) {
		          if (x === SuspenseException || x === SuspenseActionException) throw x;
		          var fiber = createFiber(29, x, null, returnFiber.mode);
		          fiber.lanes = lanes;
		          fiber.return = returnFiber;
		          var debugInfo = (fiber._debugInfo = currentDebugInfo);
		          fiber._debugOwner = returnFiber._debugOwner;
		          fiber._debugTask = returnFiber._debugTask;
		          if (null != debugInfo)
		            for (var i = debugInfo.length - 1; 0 <= i; i--)
		              if ("string" === typeof debugInfo[i].stack) {
		                fiber._debugOwner = debugInfo[i];
		                fiber._debugTask = debugInfo[i].debugTask;
		                break;
		              }
		          return fiber;
		        } finally {
		          currentDebugInfo = prevDebugInfo;
		        }
		      };
		    }
		    function validateSuspenseListNestedChild(childSlot, index) {
		      var isAnArray = isArrayImpl(childSlot);
		      childSlot = !isAnArray && "function" === typeof getIteratorFn(childSlot);
		      return isAnArray || childSlot
		        ? ((isAnArray = isAnArray ? "array" : "iterable"),
		          console.error(
		            "A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>",
		            isAnArray,
		            index,
		            isAnArray
		          ),
		          false)
		        : true;
		    }
		    function finishQueueingConcurrentUpdates() {
		      for (
		        var endIndex = concurrentQueuesIndex,
		          i = (concurrentlyUpdatedLanes = concurrentQueuesIndex = 0);
		        i < endIndex;

		      ) {
		        var fiber = concurrentQueues[i];
		        concurrentQueues[i++] = null;
		        var queue = concurrentQueues[i];
		        concurrentQueues[i++] = null;
		        var update = concurrentQueues[i];
		        concurrentQueues[i++] = null;
		        var lane = concurrentQueues[i];
		        concurrentQueues[i++] = null;
		        if (null !== queue && null !== update) {
		          var pending = queue.pending;
		          null === pending
		            ? (update.next = update)
		            : ((update.next = pending.next), (pending.next = update));
		          queue.pending = update;
		        }
		        0 !== lane && markUpdateLaneFromFiberToRoot(fiber, update, lane);
		      }
		    }
		    function enqueueUpdate$1(fiber, queue, update, lane) {
		      concurrentQueues[concurrentQueuesIndex++] = fiber;
		      concurrentQueues[concurrentQueuesIndex++] = queue;
		      concurrentQueues[concurrentQueuesIndex++] = update;
		      concurrentQueues[concurrentQueuesIndex++] = lane;
		      concurrentlyUpdatedLanes |= lane;
		      fiber.lanes |= lane;
		      fiber = fiber.alternate;
		      null !== fiber && (fiber.lanes |= lane);
		    }
		    function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
		      enqueueUpdate$1(fiber, queue, update, lane);
		      return getRootForUpdatedFiber(fiber);
		    }
		    function enqueueConcurrentRenderForLane(fiber, lane) {
		      enqueueUpdate$1(fiber, null, null, lane);
		      return getRootForUpdatedFiber(fiber);
		    }
		    function markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
		      sourceFiber.lanes |= lane;
		      var alternate = sourceFiber.alternate;
		      null !== alternate && (alternate.lanes |= lane);
		      for (var isHidden = false, parent = sourceFiber.return; null !== parent; )
		        (parent.childLanes |= lane),
		          (alternate = parent.alternate),
		          null !== alternate && (alternate.childLanes |= lane),
		          22 === parent.tag &&
		            ((sourceFiber = parent.stateNode),
		            null === sourceFiber ||
		              sourceFiber._visibility & OffscreenVisible ||
		              (isHidden = true)),
		          (sourceFiber = parent),
		          (parent = parent.return);
		      return 3 === sourceFiber.tag
		        ? ((parent = sourceFiber.stateNode),
		          isHidden &&
		            null !== update &&
		            ((isHidden = 31 - clz32(lane)),
		            (sourceFiber = parent.hiddenUpdates),
		            (alternate = sourceFiber[isHidden]),
		            null === alternate
		              ? (sourceFiber[isHidden] = [update])
		              : alternate.push(update),
		            (update.lane = lane | 536870912)),
		          parent)
		        : null;
		    }
		    function getRootForUpdatedFiber(sourceFiber) {
		      if (nestedUpdateCount > NESTED_UPDATE_LIMIT)
		        throw (
		          ((nestedPassiveUpdateCount = nestedUpdateCount = 0),
		          (rootWithPassiveNestedUpdates = rootWithNestedUpdates = null),
		          Error(
		            "Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops."
		          ))
		        );
		      nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT &&
		        ((nestedPassiveUpdateCount = 0),
		        (rootWithPassiveNestedUpdates = null),
		        console.error(
		          "Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."
		        ));
		      null === sourceFiber.alternate &&
		        0 !== (sourceFiber.flags & 4098) &&
		        warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
		      for (var node = sourceFiber, parent = node.return; null !== parent; )
		        null === node.alternate &&
		          0 !== (node.flags & 4098) &&
		          warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber),
		          (node = parent),
		          (parent = node.return);
		      return 3 === node.tag ? node.stateNode : null;
		    }
		    function initializeUpdateQueue(fiber) {
		      fiber.updateQueue = {
		        baseState: fiber.memoizedState,
		        firstBaseUpdate: null,
		        lastBaseUpdate: null,
		        shared: { pending: null, lanes: 0, hiddenCallbacks: null },
		        callbacks: null
		      };
		    }
		    function cloneUpdateQueue(current, workInProgress) {
		      current = current.updateQueue;
		      workInProgress.updateQueue === current &&
		        (workInProgress.updateQueue = {
		          baseState: current.baseState,
		          firstBaseUpdate: current.firstBaseUpdate,
		          lastBaseUpdate: current.lastBaseUpdate,
		          shared: current.shared,
		          callbacks: null
		        });
		    }
		    function createUpdate(lane) {
		      return {
		        lane: lane,
		        tag: UpdateState,
		        payload: null,
		        callback: null,
		        next: null
		      };
		    }
		    function enqueueUpdate(fiber, update, lane) {
		      var updateQueue = fiber.updateQueue;
		      if (null === updateQueue) return null;
		      updateQueue = updateQueue.shared;
		      if (
		        currentlyProcessingQueue === updateQueue &&
		        !didWarnUpdateInsideUpdate
		      ) {
		        var componentName = getComponentNameFromFiber(fiber);
		        console.error(
		          "An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.\n\nPlease update the following component: %s",
		          componentName
		        );
		        didWarnUpdateInsideUpdate = true;
		      }
		      if ((executionContext & RenderContext) !== NoContext)
		        return (
		          (componentName = updateQueue.pending),
		          null === componentName
		            ? (update.next = update)
		            : ((update.next = componentName.next),
		              (componentName.next = update)),
		          (updateQueue.pending = update),
		          (update = getRootForUpdatedFiber(fiber)),
		          markUpdateLaneFromFiberToRoot(fiber, null, lane),
		          update
		        );
		      enqueueUpdate$1(fiber, updateQueue, update, lane);
		      return getRootForUpdatedFiber(fiber);
		    }
		    function entangleTransitions(root, fiber, lane) {
		      fiber = fiber.updateQueue;
		      if (null !== fiber && ((fiber = fiber.shared), 0 !== (lane & 4194048))) {
		        var queueLanes = fiber.lanes;
		        queueLanes &= root.pendingLanes;
		        lane |= queueLanes;
		        fiber.lanes = lane;
		        markRootEntangled(root, lane);
		      }
		    }
		    function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
		      var queue = workInProgress.updateQueue,
		        current = workInProgress.alternate;
		      if (
		        null !== current &&
		        ((current = current.updateQueue), queue === current)
		      ) {
		        var newFirst = null,
		          newLast = null;
		        queue = queue.firstBaseUpdate;
		        if (null !== queue) {
		          do {
		            var clone = {
		              lane: queue.lane,
		              tag: queue.tag,
		              payload: queue.payload,
		              callback: null,
		              next: null
		            };
		            null === newLast
		              ? (newFirst = newLast = clone)
		              : (newLast = newLast.next = clone);
		            queue = queue.next;
		          } while (null !== queue);
		          null === newLast
		            ? (newFirst = newLast = capturedUpdate)
		            : (newLast = newLast.next = capturedUpdate);
		        } else newFirst = newLast = capturedUpdate;
		        queue = {
		          baseState: current.baseState,
		          firstBaseUpdate: newFirst,
		          lastBaseUpdate: newLast,
		          shared: current.shared,
		          callbacks: current.callbacks
		        };
		        workInProgress.updateQueue = queue;
		        return;
		      }
		      workInProgress = queue.lastBaseUpdate;
		      null === workInProgress
		        ? (queue.firstBaseUpdate = capturedUpdate)
		        : (workInProgress.next = capturedUpdate);
		      queue.lastBaseUpdate = capturedUpdate;
		    }
		    function suspendIfUpdateReadFromEntangledAsyncAction() {
		      if (didReadFromEntangledAsyncAction) {
		        var entangledActionThenable = currentEntangledActionThenable;
		        if (null !== entangledActionThenable) throw entangledActionThenable;
		      }
		    }
		    function processUpdateQueue(
		      workInProgress,
		      props,
		      instance$jscomp$0,
		      renderLanes
		    ) {
		      didReadFromEntangledAsyncAction = false;
		      var queue = workInProgress.updateQueue;
		      hasForceUpdate = false;
		      currentlyProcessingQueue = queue.shared;
		      var firstBaseUpdate = queue.firstBaseUpdate,
		        lastBaseUpdate = queue.lastBaseUpdate,
		        pendingQueue = queue.shared.pending;
		      if (null !== pendingQueue) {
		        queue.shared.pending = null;
		        var lastPendingUpdate = pendingQueue,
		          firstPendingUpdate = lastPendingUpdate.next;
		        lastPendingUpdate.next = null;
		        null === lastBaseUpdate
		          ? (firstBaseUpdate = firstPendingUpdate)
		          : (lastBaseUpdate.next = firstPendingUpdate);
		        lastBaseUpdate = lastPendingUpdate;
		        var current = workInProgress.alternate;
		        null !== current &&
		          ((current = current.updateQueue),
		          (pendingQueue = current.lastBaseUpdate),
		          pendingQueue !== lastBaseUpdate &&
		            (null === pendingQueue
		              ? (current.firstBaseUpdate = firstPendingUpdate)
		              : (pendingQueue.next = firstPendingUpdate),
		            (current.lastBaseUpdate = lastPendingUpdate)));
		      }
		      if (null !== firstBaseUpdate) {
		        var newState = queue.baseState;
		        lastBaseUpdate = 0;
		        current = firstPendingUpdate = lastPendingUpdate = null;
		        pendingQueue = firstBaseUpdate;
		        do {
		          var updateLane = pendingQueue.lane & -536870913,
		            isHiddenUpdate = updateLane !== pendingQueue.lane;
		          if (
		            isHiddenUpdate
		              ? (workInProgressRootRenderLanes & updateLane) === updateLane
		              : (renderLanes & updateLane) === updateLane
		          ) {
		            0 !== updateLane &&
		              updateLane === currentEntangledLane &&
		              (didReadFromEntangledAsyncAction = true);
		            null !== current &&
		              (current = current.next =
		                {
		                  lane: 0,
		                  tag: pendingQueue.tag,
		                  payload: pendingQueue.payload,
		                  callback: null,
		                  next: null
		                });
		            a: {
		              updateLane = workInProgress;
		              var partialState = pendingQueue;
		              var nextProps = props,
		                instance = instance$jscomp$0;
		              switch (partialState.tag) {
		                case ReplaceState:
		                  partialState = partialState.payload;
		                  if ("function" === typeof partialState) {
		                    isDisallowedContextReadInDEV = true;
		                    var nextState = partialState.call(
		                      instance,
		                      newState,
		                      nextProps
		                    );
		                    if (updateLane.mode & 8) {
		                      setIsStrictModeForDevtools(true);
		                      try {
		                        partialState.call(instance, newState, nextProps);
		                      } finally {
		                        setIsStrictModeForDevtools(false);
		                      }
		                    }
		                    isDisallowedContextReadInDEV = false;
		                    newState = nextState;
		                    break a;
		                  }
		                  newState = partialState;
		                  break a;
		                case CaptureUpdate:
		                  updateLane.flags = (updateLane.flags & -65537) | 128;
		                case UpdateState:
		                  nextState = partialState.payload;
		                  if ("function" === typeof nextState) {
		                    isDisallowedContextReadInDEV = true;
		                    partialState = nextState.call(
		                      instance,
		                      newState,
		                      nextProps
		                    );
		                    if (updateLane.mode & 8) {
		                      setIsStrictModeForDevtools(true);
		                      try {
		                        nextState.call(instance, newState, nextProps);
		                      } finally {
		                        setIsStrictModeForDevtools(false);
		                      }
		                    }
		                    isDisallowedContextReadInDEV = false;
		                  } else partialState = nextState;
		                  if (null === partialState || void 0 === partialState) break a;
		                  newState = assign({}, newState, partialState);
		                  break a;
		                case ForceUpdate:
		                  hasForceUpdate = true;
		              }
		            }
		            updateLane = pendingQueue.callback;
		            null !== updateLane &&
		              ((workInProgress.flags |= 64),
		              isHiddenUpdate && (workInProgress.flags |= 8192),
		              (isHiddenUpdate = queue.callbacks),
		              null === isHiddenUpdate
		                ? (queue.callbacks = [updateLane])
		                : isHiddenUpdate.push(updateLane));
		          } else
		            (isHiddenUpdate = {
		              lane: updateLane,
		              tag: pendingQueue.tag,
		              payload: pendingQueue.payload,
		              callback: pendingQueue.callback,
		              next: null
		            }),
		              null === current
		                ? ((firstPendingUpdate = current = isHiddenUpdate),
		                  (lastPendingUpdate = newState))
		                : (current = current.next = isHiddenUpdate),
		              (lastBaseUpdate |= updateLane);
		          pendingQueue = pendingQueue.next;
		          if (null === pendingQueue)
		            if (((pendingQueue = queue.shared.pending), null === pendingQueue))
		              break;
		            else
		              (isHiddenUpdate = pendingQueue),
		                (pendingQueue = isHiddenUpdate.next),
		                (isHiddenUpdate.next = null),
		                (queue.lastBaseUpdate = isHiddenUpdate),
		                (queue.shared.pending = null);
		        } while (1);
		        null === current && (lastPendingUpdate = newState);
		        queue.baseState = lastPendingUpdate;
		        queue.firstBaseUpdate = firstPendingUpdate;
		        queue.lastBaseUpdate = current;
		        null === firstBaseUpdate && (queue.shared.lanes = 0);
		        workInProgressRootSkippedLanes |= lastBaseUpdate;
		        workInProgress.lanes = lastBaseUpdate;
		        workInProgress.memoizedState = newState;
		      }
		      currentlyProcessingQueue = null;
		    }
		    function callCallback(callback, context) {
		      if ("function" !== typeof callback)
		        throw Error(
		          "Invalid argument passed as callback. Expected a function. Instead received: " +
		            callback
		        );
		      callback.call(context);
		    }
		    function commitHiddenCallbacks(updateQueue, context) {
		      var hiddenCallbacks = updateQueue.shared.hiddenCallbacks;
		      if (null !== hiddenCallbacks)
		        for (
		          updateQueue.shared.hiddenCallbacks = null, updateQueue = 0;
		          updateQueue < hiddenCallbacks.length;
		          updateQueue++
		        )
		          callCallback(hiddenCallbacks[updateQueue], context);
		    }
		    function commitCallbacks(updateQueue, context) {
		      var callbacks = updateQueue.callbacks;
		      if (null !== callbacks)
		        for (
		          updateQueue.callbacks = null, updateQueue = 0;
		          updateQueue < callbacks.length;
		          updateQueue++
		        )
		          callCallback(callbacks[updateQueue], context);
		    }
		    function pushHiddenContext(fiber, context) {
		      var prevEntangledRenderLanes = entangledRenderLanes;
		      push(prevEntangledRenderLanesCursor, prevEntangledRenderLanes, fiber);
		      push(currentTreeHiddenStackCursor, context, fiber);
		      entangledRenderLanes = prevEntangledRenderLanes | context.baseLanes;
		    }
		    function reuseHiddenContextOnStack(fiber) {
		      push(prevEntangledRenderLanesCursor, entangledRenderLanes, fiber);
		      push(
		        currentTreeHiddenStackCursor,
		        currentTreeHiddenStackCursor.current,
		        fiber
		      );
		    }
		    function popHiddenContext(fiber) {
		      entangledRenderLanes = prevEntangledRenderLanesCursor.current;
		      pop(currentTreeHiddenStackCursor, fiber);
		      pop(prevEntangledRenderLanesCursor, fiber);
		    }
		    function pushPrimaryTreeSuspenseHandler(handler) {
		      var current = handler.alternate;
		      push(
		        suspenseStackCursor,
		        suspenseStackCursor.current & SubtreeSuspenseContextMask,
		        handler
		      );
		      push(suspenseHandlerStackCursor, handler, handler);
		      null === shellBoundary &&
		        (null === current || null !== currentTreeHiddenStackCursor.current
		          ? (shellBoundary = handler)
		          : null !== current.memoizedState && (shellBoundary = handler));
		    }
		    function pushDehydratedActivitySuspenseHandler(fiber) {
		      push(suspenseStackCursor, suspenseStackCursor.current, fiber);
		      push(suspenseHandlerStackCursor, fiber, fiber);
		      null === shellBoundary && (shellBoundary = fiber);
		    }
		    function pushOffscreenSuspenseHandler(fiber) {
		      22 === fiber.tag
		        ? (push(suspenseStackCursor, suspenseStackCursor.current, fiber),
		          push(suspenseHandlerStackCursor, fiber, fiber),
		          null === shellBoundary && (shellBoundary = fiber))
		        : reuseSuspenseHandlerOnStack(fiber);
		    }
		    function reuseSuspenseHandlerOnStack(fiber) {
		      push(suspenseStackCursor, suspenseStackCursor.current, fiber);
		      push(
		        suspenseHandlerStackCursor,
		        suspenseHandlerStackCursor.current,
		        fiber
		      );
		    }
		    function popSuspenseHandler(fiber) {
		      pop(suspenseHandlerStackCursor, fiber);
		      shellBoundary === fiber && (shellBoundary = null);
		      pop(suspenseStackCursor, fiber);
		    }
		    function findFirstSuspended(row) {
		      for (var node = row; null !== node; ) {
		        if (13 === node.tag) {
		          var state = node.memoizedState;
		          if (
		            null !== state &&
		            ((state = state.dehydrated),
		            null === state ||
		              isSuspenseInstancePending(state) ||
		              isSuspenseInstanceFallback(state))
		          )
		            return node;
		        } else if (
		          19 === node.tag &&
		          ("forwards" === node.memoizedProps.revealOrder ||
		            "backwards" === node.memoizedProps.revealOrder ||
		            "unstable_legacy-backwards" === node.memoizedProps.revealOrder ||
		            "together" === node.memoizedProps.revealOrder)
		        ) {
		          if (0 !== (node.flags & 128)) return node;
		        } else if (null !== node.child) {
		          node.child.return = node;
		          node = node.child;
		          continue;
		        }
		        if (node === row) break;
		        for (; null === node.sibling; ) {
		          if (null === node.return || node.return === row) return null;
		          node = node.return;
		        }
		        node.sibling.return = node.return;
		        node = node.sibling;
		      }
		      return null;
		    }
		    function mountHookTypesDev() {
		      var hookName = currentHookNameInDev;
		      null === hookTypesDev
		        ? (hookTypesDev = [hookName])
		        : hookTypesDev.push(hookName);
		    }
		    function updateHookTypesDev() {
		      var hookName = currentHookNameInDev;
		      if (
		        null !== hookTypesDev &&
		        (hookTypesUpdateIndexDev++,
		        hookTypesDev[hookTypesUpdateIndexDev] !== hookName)
		      ) {
		        var componentName = getComponentNameFromFiber(currentlyRenderingFiber);
		        if (
		          !didWarnAboutMismatchedHooksForComponent.has(componentName) &&
		          (didWarnAboutMismatchedHooksForComponent.add(componentName),
		          null !== hookTypesDev)
		        ) {
		          for (var table = "", i = 0; i <= hookTypesUpdateIndexDev; i++) {
		            var oldHookName = hookTypesDev[i],
		              newHookName =
		                i === hookTypesUpdateIndexDev ? hookName : oldHookName;
		            for (
		              oldHookName = i + 1 + ". " + oldHookName;
		              30 > oldHookName.length;

		            )
		              oldHookName += " ";
		            oldHookName += newHookName + "\n";
		            table += oldHookName;
		          }
		          console.error(
		            "React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://react.dev/link/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n",
		            componentName,
		            table
		          );
		        }
		      }
		    }
		    function checkDepsAreArrayDev(deps) {
		      void 0 === deps ||
		        null === deps ||
		        isArrayImpl(deps) ||
		        console.error(
		          "%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.",
		          currentHookNameInDev,
		          typeof deps
		        );
		    }
		    function warnOnUseFormStateInDev() {
		      var componentName = getComponentNameFromFiber(currentlyRenderingFiber);
		      didWarnAboutUseFormState.has(componentName) ||
		        (didWarnAboutUseFormState.add(componentName),
		        console.error(
		          "ReactDOM.useFormState has been renamed to React.useActionState. Please update %s to use React.useActionState.",
		          componentName
		        ));
		    }
		    function throwInvalidHookError() {
		      throw Error(
		        "Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem."
		      );
		    }
		    function areHookInputsEqual(nextDeps, prevDeps) {
		      if (ignorePreviousDependencies) return false;
		      if (null === prevDeps)
		        return (
		          console.error(
		            "%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.",
		            currentHookNameInDev
		          ),
		          false
		        );
		      nextDeps.length !== prevDeps.length &&
		        console.error(
		          "The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s",
		          currentHookNameInDev,
		          "[" + prevDeps.join(", ") + "]",
		          "[" + nextDeps.join(", ") + "]"
		        );
		      for (var i = 0; i < prevDeps.length && i < nextDeps.length; i++)
		        if (!objectIs(nextDeps[i], prevDeps[i])) return false;
		      return true;
		    }
		    function renderWithHooks(
		      current,
		      workInProgress,
		      Component,
		      props,
		      secondArg,
		      nextRenderLanes
		    ) {
		      renderLanes = nextRenderLanes;
		      currentlyRenderingFiber = workInProgress;
		      hookTypesDev = null !== current ? current._debugHookTypes : null;
		      hookTypesUpdateIndexDev = -1;
		      ignorePreviousDependencies =
		        null !== current && current.type !== workInProgress.type;
		      if (
		        "[object AsyncFunction]" ===
		          Object.prototype.toString.call(Component) ||
		        "[object AsyncGeneratorFunction]" ===
		          Object.prototype.toString.call(Component)
		      )
		        (nextRenderLanes = getComponentNameFromFiber(currentlyRenderingFiber)),
		          didWarnAboutAsyncClientComponent.has(nextRenderLanes) ||
		            (didWarnAboutAsyncClientComponent.add(nextRenderLanes),
		            console.error(
		              "%s is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.",
		              null === nextRenderLanes
		                ? "An unknown Component"
		                : "<" + nextRenderLanes + ">"
		            ));
		      workInProgress.memoizedState = null;
		      workInProgress.updateQueue = null;
		      workInProgress.lanes = 0;
		      ReactSharedInternals.H =
		        null !== current && null !== current.memoizedState
		          ? HooksDispatcherOnUpdateInDEV
		          : null !== hookTypesDev
		            ? HooksDispatcherOnMountWithHookTypesInDEV
		            : HooksDispatcherOnMountInDEV;
		      shouldDoubleInvokeUserFnsInHooksDEV = nextRenderLanes =
		        (workInProgress.mode & 8) !== NoMode;
		      var children = callComponentInDEV(Component, props, secondArg);
		      shouldDoubleInvokeUserFnsInHooksDEV = false;
		      didScheduleRenderPhaseUpdateDuringThisPass &&
		        (children = renderWithHooksAgain(
		          workInProgress,
		          Component,
		          props,
		          secondArg
		        ));
		      if (nextRenderLanes) {
		        setIsStrictModeForDevtools(true);
		        try {
		          children = renderWithHooksAgain(
		            workInProgress,
		            Component,
		            props,
		            secondArg
		          );
		        } finally {
		          setIsStrictModeForDevtools(false);
		        }
		      }
		      finishRenderingHooks(current, workInProgress);
		      return children;
		    }
		    function finishRenderingHooks(current, workInProgress) {
		      workInProgress._debugHookTypes = hookTypesDev;
		      null === workInProgress.dependencies
		        ? null !== thenableState &&
		          (workInProgress.dependencies = {
		            lanes: 0,
		            firstContext: null,
		            _debugThenableState: thenableState
		          })
		        : (workInProgress.dependencies._debugThenableState = thenableState);
		      ReactSharedInternals.H = ContextOnlyDispatcher;
		      var didRenderTooFewHooks =
		        null !== currentHook && null !== currentHook.next;
		      renderLanes = 0;
		      hookTypesDev =
		        currentHookNameInDev =
		        workInProgressHook =
		        currentHook =
		        currentlyRenderingFiber =
		          null;
		      hookTypesUpdateIndexDev = -1;
		      null !== current &&
		        (current.flags & 65011712) !== (workInProgress.flags & 65011712) &&
		        console.error(
		          "Internal React error: Expected static flag was missing. Please notify the React team."
		        );
		      didScheduleRenderPhaseUpdate = false;
		      thenableIndexCounter = 0;
		      thenableState = null;
		      if (didRenderTooFewHooks)
		        throw Error(
		          "Rendered fewer hooks than expected. This may be caused by an accidental early return statement."
		        );
		      null === current ||
		        didReceiveUpdate ||
		        ((current = current.dependencies),
		        null !== current &&
		          checkIfContextChanged(current) &&
		          (didReceiveUpdate = true));
		      needsToResetSuspendedThenableDEV
		        ? ((needsToResetSuspendedThenableDEV = false), (current = true))
		        : (current = false);
		      current &&
		        ((workInProgress =
		          getComponentNameFromFiber(workInProgress) || "Unknown"),
		        didWarnAboutUseWrappedInTryCatch.has(workInProgress) ||
		          didWarnAboutAsyncClientComponent.has(workInProgress) ||
		          (didWarnAboutUseWrappedInTryCatch.add(workInProgress),
		          console.error(
		            "`use` was called from inside a try/catch block. This is not allowed and can lead to unexpected behavior. To handle errors triggered by `use`, wrap your component in a error boundary."
		          )));
		    }
		    function renderWithHooksAgain(workInProgress, Component, props, secondArg) {
		      currentlyRenderingFiber = workInProgress;
		      var numberOfReRenders = 0;
		      do {
		        didScheduleRenderPhaseUpdateDuringThisPass && (thenableState = null);
		        thenableIndexCounter = 0;
		        didScheduleRenderPhaseUpdateDuringThisPass = false;
		        if (numberOfReRenders >= RE_RENDER_LIMIT)
		          throw Error(
		            "Too many re-renders. React limits the number of renders to prevent an infinite loop."
		          );
		        numberOfReRenders += 1;
		        ignorePreviousDependencies = false;
		        workInProgressHook = currentHook = null;
		        if (null != workInProgress.updateQueue) {
		          var children = workInProgress.updateQueue;
		          children.lastEffect = null;
		          children.events = null;
		          children.stores = null;
		          null != children.memoCache && (children.memoCache.index = 0);
		        }
		        hookTypesUpdateIndexDev = -1;
		        ReactSharedInternals.H = HooksDispatcherOnRerenderInDEV;
		        children = callComponentInDEV(Component, props, secondArg);
		      } while (didScheduleRenderPhaseUpdateDuringThisPass);
		      return children;
		    }
		    function TransitionAwareHostComponent() {
		      var dispatcher = ReactSharedInternals.H,
		        maybeThenable = dispatcher.useState()[0];
		      maybeThenable =
		        "function" === typeof maybeThenable.then
		          ? useThenable(maybeThenable)
		          : maybeThenable;
		      dispatcher = dispatcher.useState()[0];
		      (null !== currentHook ? currentHook.memoizedState : null) !==
		        dispatcher && (currentlyRenderingFiber.flags |= 1024);
		      return maybeThenable;
		    }
		    function checkDidRenderIdHook() {
		      var didRenderIdHook = 0 !== localIdCounter;
		      localIdCounter = 0;
		      return didRenderIdHook;
		    }
		    function bailoutHooks(current, workInProgress, lanes) {
		      workInProgress.updateQueue = current.updateQueue;
		      workInProgress.flags =
		        (workInProgress.mode & 16) !== NoMode
		          ? workInProgress.flags & -402655237
		          : workInProgress.flags & -2053;
		      current.lanes &= ~lanes;
		    }
		    function resetHooksOnUnwind(workInProgress) {
		      if (didScheduleRenderPhaseUpdate) {
		        for (
		          workInProgress = workInProgress.memoizedState;
		          null !== workInProgress;

		        ) {
		          var queue = workInProgress.queue;
		          null !== queue && (queue.pending = null);
		          workInProgress = workInProgress.next;
		        }
		        didScheduleRenderPhaseUpdate = false;
		      }
		      renderLanes = 0;
		      hookTypesDev =
		        workInProgressHook =
		        currentHook =
		        currentlyRenderingFiber =
		          null;
		      hookTypesUpdateIndexDev = -1;
		      currentHookNameInDev = null;
		      didScheduleRenderPhaseUpdateDuringThisPass = false;
		      thenableIndexCounter = localIdCounter = 0;
		      thenableState = null;
		    }
		    function mountWorkInProgressHook() {
		      var hook = {
		        memoizedState: null,
		        baseState: null,
		        baseQueue: null,
		        queue: null,
		        next: null
		      };
		      null === workInProgressHook
		        ? (currentlyRenderingFiber.memoizedState = workInProgressHook = hook)
		        : (workInProgressHook = workInProgressHook.next = hook);
		      return workInProgressHook;
		    }
		    function updateWorkInProgressHook() {
		      if (null === currentHook) {
		        var nextCurrentHook = currentlyRenderingFiber.alternate;
		        nextCurrentHook =
		          null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
		      } else nextCurrentHook = currentHook.next;
		      var nextWorkInProgressHook =
		        null === workInProgressHook
		          ? currentlyRenderingFiber.memoizedState
		          : workInProgressHook.next;
		      if (null !== nextWorkInProgressHook)
		        (workInProgressHook = nextWorkInProgressHook),
		          (currentHook = nextCurrentHook);
		      else {
		        if (null === nextCurrentHook) {
		          if (null === currentlyRenderingFiber.alternate)
		            throw Error(
		              "Update hook called on initial render. This is likely a bug in React. Please file an issue."
		            );
		          throw Error("Rendered more hooks than during the previous render.");
		        }
		        currentHook = nextCurrentHook;
		        nextCurrentHook = {
		          memoizedState: currentHook.memoizedState,
		          baseState: currentHook.baseState,
		          baseQueue: currentHook.baseQueue,
		          queue: currentHook.queue,
		          next: null
		        };
		        null === workInProgressHook
		          ? (currentlyRenderingFiber.memoizedState = workInProgressHook =
		              nextCurrentHook)
		          : (workInProgressHook = workInProgressHook.next = nextCurrentHook);
		      }
		      return workInProgressHook;
		    }
		    function createFunctionComponentUpdateQueue() {
		      return { lastEffect: null, events: null, stores: null, memoCache: null };
		    }
		    function useThenable(thenable) {
		      var index = thenableIndexCounter;
		      thenableIndexCounter += 1;
		      null === thenableState && (thenableState = createThenableState());
		      thenable = trackUsedThenable(thenableState, thenable, index);
		      index = currentlyRenderingFiber;
		      null ===
		        (null === workInProgressHook
		          ? index.memoizedState
		          : workInProgressHook.next) &&
		        ((index = index.alternate),
		        (ReactSharedInternals.H =
		          null !== index && null !== index.memoizedState
		            ? HooksDispatcherOnUpdateInDEV
		            : HooksDispatcherOnMountInDEV));
		      return thenable;
		    }
		    function use(usable) {
		      if (null !== usable && "object" === typeof usable) {
		        if ("function" === typeof usable.then) return useThenable(usable);
		        if (usable.$$typeof === REACT_CONTEXT_TYPE) return readContext(usable);
		      }
		      throw Error("An unsupported type was passed to use(): " + String(usable));
		    }
		    function useMemoCache(size) {
		      var memoCache = null,
		        updateQueue = currentlyRenderingFiber.updateQueue;
		      null !== updateQueue && (memoCache = updateQueue.memoCache);
		      if (null == memoCache) {
		        var current = currentlyRenderingFiber.alternate;
		        null !== current &&
		          ((current = current.updateQueue),
		          null !== current &&
		            ((current = current.memoCache),
		            null != current &&
		              (memoCache = {
		                data: current.data.map(function (array) {
		                  return array.slice();
		                }),
		                index: 0
		              })));
		      }
		      null == memoCache && (memoCache = { data: [], index: 0 });
		      null === updateQueue &&
		        ((updateQueue = createFunctionComponentUpdateQueue()),
		        (currentlyRenderingFiber.updateQueue = updateQueue));
		      updateQueue.memoCache = memoCache;
		      updateQueue = memoCache.data[memoCache.index];
		      if (void 0 === updateQueue || ignorePreviousDependencies)
		        for (
		          updateQueue = memoCache.data[memoCache.index] = Array(size),
		            current = 0;
		          current < size;
		          current++
		        )
		          updateQueue[current] = REACT_MEMO_CACHE_SENTINEL;
		      else
		        updateQueue.length !== size &&
		          console.error(
		            "Expected a constant size argument for each invocation of useMemoCache. The previous cache was allocated with size %s but size %s was requested.",
		            updateQueue.length,
		            size
		          );
		      memoCache.index++;
		      return updateQueue;
		    }
		    function basicStateReducer(state, action) {
		      return "function" === typeof action ? action(state) : action;
		    }
		    function mountReducer(reducer, initialArg, init) {
		      var hook = mountWorkInProgressHook();
		      if (void 0 !== init) {
		        var initialState = init(initialArg);
		        if (shouldDoubleInvokeUserFnsInHooksDEV) {
		          setIsStrictModeForDevtools(true);
		          try {
		            init(initialArg);
		          } finally {
		            setIsStrictModeForDevtools(false);
		          }
		        }
		      } else initialState = initialArg;
		      hook.memoizedState = hook.baseState = initialState;
		      reducer = {
		        pending: null,
		        lanes: 0,
		        dispatch: null,
		        lastRenderedReducer: reducer,
		        lastRenderedState: initialState
		      };
		      hook.queue = reducer;
		      reducer = reducer.dispatch = dispatchReducerAction.bind(
		        null,
		        currentlyRenderingFiber,
		        reducer
		      );
		      return [hook.memoizedState, reducer];
		    }
		    function updateReducer(reducer) {
		      var hook = updateWorkInProgressHook();
		      return updateReducerImpl(hook, currentHook, reducer);
		    }
		    function updateReducerImpl(hook, current, reducer) {
		      var queue = hook.queue;
		      if (null === queue)
		        throw Error(
		          "Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)"
		        );
		      queue.lastRenderedReducer = reducer;
		      var baseQueue = hook.baseQueue,
		        pendingQueue = queue.pending;
		      if (null !== pendingQueue) {
		        if (null !== baseQueue) {
		          var baseFirst = baseQueue.next;
		          baseQueue.next = pendingQueue.next;
		          pendingQueue.next = baseFirst;
		        }
		        current.baseQueue !== baseQueue &&
		          console.error(
		            "Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."
		          );
		        current.baseQueue = baseQueue = pendingQueue;
		        queue.pending = null;
		      }
		      pendingQueue = hook.baseState;
		      if (null === baseQueue) hook.memoizedState = pendingQueue;
		      else {
		        current = baseQueue.next;
		        var newBaseQueueFirst = (baseFirst = null),
		          newBaseQueueLast = null,
		          update = current,
		          didReadFromEntangledAsyncAction = false;
		        do {
		          var updateLane = update.lane & -536870913;
		          if (
		            updateLane !== update.lane
		              ? (workInProgressRootRenderLanes & updateLane) === updateLane
		              : (renderLanes & updateLane) === updateLane
		          ) {
		            var revertLane = update.revertLane;
		            if (0 === revertLane)
		              null !== newBaseQueueLast &&
		                (newBaseQueueLast = newBaseQueueLast.next =
		                  {
		                    lane: 0,
		                    revertLane: 0,
		                    gesture: null,
		                    action: update.action,
		                    hasEagerState: update.hasEagerState,
		                    eagerState: update.eagerState,
		                    next: null
		                  }),
		                updateLane === currentEntangledLane &&
		                  (didReadFromEntangledAsyncAction = true);
		            else if ((renderLanes & revertLane) === revertLane) {
		              update = update.next;
		              revertLane === currentEntangledLane &&
		                (didReadFromEntangledAsyncAction = true);
		              continue;
		            } else
		              (updateLane = {
		                lane: 0,
		                revertLane: update.revertLane,
		                gesture: null,
		                action: update.action,
		                hasEagerState: update.hasEagerState,
		                eagerState: update.eagerState,
		                next: null
		              }),
		                null === newBaseQueueLast
		                  ? ((newBaseQueueFirst = newBaseQueueLast = updateLane),
		                    (baseFirst = pendingQueue))
		                  : (newBaseQueueLast = newBaseQueueLast.next = updateLane),
		                (currentlyRenderingFiber.lanes |= revertLane),
		                (workInProgressRootSkippedLanes |= revertLane);
		            updateLane = update.action;
		            shouldDoubleInvokeUserFnsInHooksDEV &&
		              reducer(pendingQueue, updateLane);
		            pendingQueue = update.hasEagerState
		              ? update.eagerState
		              : reducer(pendingQueue, updateLane);
		          } else
		            (revertLane = {
		              lane: updateLane,
		              revertLane: update.revertLane,
		              gesture: update.gesture,
		              action: update.action,
		              hasEagerState: update.hasEagerState,
		              eagerState: update.eagerState,
		              next: null
		            }),
		              null === newBaseQueueLast
		                ? ((newBaseQueueFirst = newBaseQueueLast = revertLane),
		                  (baseFirst = pendingQueue))
		                : (newBaseQueueLast = newBaseQueueLast.next = revertLane),
		              (currentlyRenderingFiber.lanes |= updateLane),
		              (workInProgressRootSkippedLanes |= updateLane);
		          update = update.next;
		        } while (null !== update && update !== current);
		        null === newBaseQueueLast
		          ? (baseFirst = pendingQueue)
		          : (newBaseQueueLast.next = newBaseQueueFirst);
		        if (
		          !objectIs(pendingQueue, hook.memoizedState) &&
		          ((didReceiveUpdate = true),
		          didReadFromEntangledAsyncAction &&
		            ((reducer = currentEntangledActionThenable), null !== reducer))
		        )
		          throw reducer;
		        hook.memoizedState = pendingQueue;
		        hook.baseState = baseFirst;
		        hook.baseQueue = newBaseQueueLast;
		        queue.lastRenderedState = pendingQueue;
		      }
		      null === baseQueue && (queue.lanes = 0);
		      return [hook.memoizedState, queue.dispatch];
		    }
		    function rerenderReducer(reducer) {
		      var hook = updateWorkInProgressHook(),
		        queue = hook.queue;
		      if (null === queue)
		        throw Error(
		          "Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)"
		        );
		      queue.lastRenderedReducer = reducer;
		      var dispatch = queue.dispatch,
		        lastRenderPhaseUpdate = queue.pending,
		        newState = hook.memoizedState;
		      if (null !== lastRenderPhaseUpdate) {
		        queue.pending = null;
		        var update = (lastRenderPhaseUpdate = lastRenderPhaseUpdate.next);
		        do
		          (newState = reducer(newState, update.action)), (update = update.next);
		        while (update !== lastRenderPhaseUpdate);
		        objectIs(newState, hook.memoizedState) || (didReceiveUpdate = true);
		        hook.memoizedState = newState;
		        null === hook.baseQueue && (hook.baseState = newState);
		        queue.lastRenderedState = newState;
		      }
		      return [newState, dispatch];
		    }
		    function mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
		      var fiber = currentlyRenderingFiber,
		        hook = mountWorkInProgressHook();
		      if (isHydrating) {
		        if (void 0 === getServerSnapshot)
		          throw Error(
		            "Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering."
		          );
		        var nextSnapshot = getServerSnapshot();
		        didWarnUncachedGetSnapshot ||
		          nextSnapshot === getServerSnapshot() ||
		          (console.error(
		            "The result of getServerSnapshot should be cached to avoid an infinite loop"
		          ),
		          (didWarnUncachedGetSnapshot = true));
		      } else {
		        nextSnapshot = getSnapshot();
		        didWarnUncachedGetSnapshot ||
		          ((getServerSnapshot = getSnapshot()),
		          objectIs(nextSnapshot, getServerSnapshot) ||
		            (console.error(
		              "The result of getSnapshot should be cached to avoid an infinite loop"
		            ),
		            (didWarnUncachedGetSnapshot = true)));
		        if (null === workInProgressRoot)
		          throw Error(
		            "Expected a work-in-progress root. This is a bug in React. Please file an issue."
		          );
		        0 !== (workInProgressRootRenderLanes & 127) ||
		          pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
		      }
		      hook.memoizedState = nextSnapshot;
		      getServerSnapshot = { value: nextSnapshot, getSnapshot: getSnapshot };
		      hook.queue = getServerSnapshot;
		      mountEffect(
		        subscribeToStore.bind(null, fiber, getServerSnapshot, subscribe),
		        [subscribe]
		      );
		      fiber.flags |= 2048;
		      pushSimpleEffect(
		        HasEffect | Passive,
		        { destroy: void 0 },
		        updateStoreInstance.bind(
		          null,
		          fiber,
		          getServerSnapshot,
		          nextSnapshot,
		          getSnapshot
		        ),
		        null
		      );
		      return nextSnapshot;
		    }
		    function updateSyncExternalStore(
		      subscribe,
		      getSnapshot,
		      getServerSnapshot
		    ) {
		      var fiber = currentlyRenderingFiber,
		        hook = updateWorkInProgressHook(),
		        isHydrating$jscomp$0 = isHydrating;
		      if (isHydrating$jscomp$0) {
		        if (void 0 === getServerSnapshot)
		          throw Error(
		            "Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering."
		          );
		        getServerSnapshot = getServerSnapshot();
		      } else if (
		        ((getServerSnapshot = getSnapshot()), !didWarnUncachedGetSnapshot)
		      ) {
		        var cachedSnapshot = getSnapshot();
		        objectIs(getServerSnapshot, cachedSnapshot) ||
		          (console.error(
		            "The result of getSnapshot should be cached to avoid an infinite loop"
		          ),
		          (didWarnUncachedGetSnapshot = true));
		      }
		      if (
		        (cachedSnapshot = !objectIs(
		          (currentHook || hook).memoizedState,
		          getServerSnapshot
		        ))
		      )
		        (hook.memoizedState = getServerSnapshot), (didReceiveUpdate = true);
		      hook = hook.queue;
		      var create = subscribeToStore.bind(null, fiber, hook, subscribe);
		      updateEffectImpl(2048, Passive, create, [subscribe]);
		      if (
		        hook.getSnapshot !== getSnapshot ||
		        cachedSnapshot ||
		        (null !== workInProgressHook &&
		          workInProgressHook.memoizedState.tag & HasEffect)
		      ) {
		        fiber.flags |= 2048;
		        pushSimpleEffect(
		          HasEffect | Passive,
		          { destroy: void 0 },
		          updateStoreInstance.bind(
		            null,
		            fiber,
		            hook,
		            getServerSnapshot,
		            getSnapshot
		          ),
		          null
		        );
		        if (null === workInProgressRoot)
		          throw Error(
		            "Expected a work-in-progress root. This is a bug in React. Please file an issue."
		          );
		        isHydrating$jscomp$0 ||
		          0 !== (renderLanes & 127) ||
		          pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
		      }
		      return getServerSnapshot;
		    }
		    function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
		      fiber.flags |= 16384;
		      fiber = { getSnapshot: getSnapshot, value: renderedSnapshot };
		      getSnapshot = currentlyRenderingFiber.updateQueue;
		      null === getSnapshot
		        ? ((getSnapshot = createFunctionComponentUpdateQueue()),
		          (currentlyRenderingFiber.updateQueue = getSnapshot),
		          (getSnapshot.stores = [fiber]))
		        : ((renderedSnapshot = getSnapshot.stores),
		          null === renderedSnapshot
		            ? (getSnapshot.stores = [fiber])
		            : renderedSnapshot.push(fiber));
		    }
		    function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
		      inst.value = nextSnapshot;
		      inst.getSnapshot = getSnapshot;
		      checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
		    }
		    function subscribeToStore(fiber, inst, subscribe) {
		      return subscribe(function () {
		        checkIfSnapshotChanged(inst) &&
		          (startUpdateTimerByLane(2, "updateSyncExternalStore()", fiber),
		          forceStoreRerender(fiber));
		      });
		    }
		    function checkIfSnapshotChanged(inst) {
		      var latestGetSnapshot = inst.getSnapshot;
		      inst = inst.value;
		      try {
		        var nextValue = latestGetSnapshot();
		        return !objectIs(inst, nextValue);
		      } catch (error) {
		        return true;
		      }
		    }
		    function forceStoreRerender(fiber) {
		      var root = enqueueConcurrentRenderForLane(fiber, 2);
		      null !== root && scheduleUpdateOnFiber(root, fiber, 2);
		    }
		    function mountStateImpl(initialState) {
		      var hook = mountWorkInProgressHook();
		      if ("function" === typeof initialState) {
		        var initialStateInitializer = initialState;
		        initialState = initialStateInitializer();
		        if (shouldDoubleInvokeUserFnsInHooksDEV) {
		          setIsStrictModeForDevtools(true);
		          try {
		            initialStateInitializer();
		          } finally {
		            setIsStrictModeForDevtools(false);
		          }
		        }
		      }
		      hook.memoizedState = hook.baseState = initialState;
		      hook.queue = {
		        pending: null,
		        lanes: 0,
		        dispatch: null,
		        lastRenderedReducer: basicStateReducer,
		        lastRenderedState: initialState
		      };
		      return hook;
		    }
		    function mountState(initialState) {
		      initialState = mountStateImpl(initialState);
		      var queue = initialState.queue,
		        dispatch = dispatchSetState.bind(null, currentlyRenderingFiber, queue);
		      queue.dispatch = dispatch;
		      return [initialState.memoizedState, dispatch];
		    }
		    function mountOptimistic(passthrough) {
		      var hook = mountWorkInProgressHook();
		      hook.memoizedState = hook.baseState = passthrough;
		      var queue = {
		        pending: null,
		        lanes: 0,
		        dispatch: null,
		        lastRenderedReducer: null,
		        lastRenderedState: null
		      };
		      hook.queue = queue;
		      hook = dispatchOptimisticSetState.bind(
		        null,
		        currentlyRenderingFiber,
		        true,
		        queue
		      );
		      queue.dispatch = hook;
		      return [passthrough, hook];
		    }
		    function updateOptimistic(passthrough, reducer) {
		      var hook = updateWorkInProgressHook();
		      return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
		    }
		    function updateOptimisticImpl(hook, current, passthrough, reducer) {
		      hook.baseState = passthrough;
		      return updateReducerImpl(
		        hook,
		        currentHook,
		        "function" === typeof reducer ? reducer : basicStateReducer
		      );
		    }
		    function rerenderOptimistic(passthrough, reducer) {
		      var hook = updateWorkInProgressHook();
		      if (null !== currentHook)
		        return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
		      hook.baseState = passthrough;
		      return [passthrough, hook.queue.dispatch];
		    }
		    function dispatchActionState(
		      fiber,
		      actionQueue,
		      setPendingState,
		      setState,
		      payload
		    ) {
		      if (isRenderPhaseUpdate(fiber))
		        throw Error("Cannot update form state while rendering.");
		      fiber = actionQueue.action;
		      if (null !== fiber) {
		        var actionNode = {
		          payload: payload,
		          action: fiber,
		          next: null,
		          isTransition: true,
		          status: "pending",
		          value: null,
		          reason: null,
		          listeners: [],
		          then: function (listener) {
		            actionNode.listeners.push(listener);
		          }
		        };
		        null !== ReactSharedInternals.T
		          ? setPendingState(true)
		          : (actionNode.isTransition = false);
		        setState(actionNode);
		        setPendingState = actionQueue.pending;
		        null === setPendingState
		          ? ((actionNode.next = actionQueue.pending = actionNode),
		            runActionStateAction(actionQueue, actionNode))
		          : ((actionNode.next = setPendingState.next),
		            (actionQueue.pending = setPendingState.next = actionNode));
		      }
		    }
		    function runActionStateAction(actionQueue, node) {
		      var action = node.action,
		        payload = node.payload,
		        prevState = actionQueue.state;
		      if (node.isTransition) {
		        var prevTransition = ReactSharedInternals.T,
		          currentTransition = {};
		        currentTransition._updatedFibers = new Set();
		        ReactSharedInternals.T = currentTransition;
		        try {
		          var returnValue = action(prevState, payload),
		            onStartTransitionFinish = ReactSharedInternals.S;
		          null !== onStartTransitionFinish &&
		            onStartTransitionFinish(currentTransition, returnValue);
		          handleActionReturnValue(actionQueue, node, returnValue);
		        } catch (error) {
		          onActionError(actionQueue, node, error);
		        } finally {
		          null !== prevTransition &&
		            null !== currentTransition.types &&
		            (null !== prevTransition.types &&
		              prevTransition.types !== currentTransition.types &&
		              console.error(
		                "We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."
		              ),
		            (prevTransition.types = currentTransition.types)),
		            (ReactSharedInternals.T = prevTransition),
		            null === prevTransition &&
		              currentTransition._updatedFibers &&
		              ((actionQueue = currentTransition._updatedFibers.size),
		              currentTransition._updatedFibers.clear(),
		              10 < actionQueue &&
		                console.warn(
		                  "Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."
		                ));
		        }
		      } else
		        try {
		          (currentTransition = action(prevState, payload)),
		            handleActionReturnValue(actionQueue, node, currentTransition);
		        } catch (error$2) {
		          onActionError(actionQueue, node, error$2);
		        }
		    }
		    function handleActionReturnValue(actionQueue, node, returnValue) {
		      null !== returnValue &&
		      "object" === typeof returnValue &&
		      "function" === typeof returnValue.then
		        ? (ReactSharedInternals.asyncTransitions++,
		          returnValue.then(releaseAsyncTransition, releaseAsyncTransition),
		          returnValue.then(
		            function (nextState) {
		              onActionSuccess(actionQueue, node, nextState);
		            },
		            function (error) {
		              return onActionError(actionQueue, node, error);
		            }
		          ),
		          node.isTransition ||
		            console.error(
		              "An async function with useActionState was called outside of a transition. This is likely not what you intended (for example, isPending will not update correctly). Either call the returned function inside startTransition, or pass it to an `action` or `formAction` prop."
		            ))
		        : onActionSuccess(actionQueue, node, returnValue);
		    }
		    function onActionSuccess(actionQueue, actionNode, nextState) {
		      actionNode.status = "fulfilled";
		      actionNode.value = nextState;
		      notifyActionListeners(actionNode);
		      actionQueue.state = nextState;
		      actionNode = actionQueue.pending;
		      null !== actionNode &&
		        ((nextState = actionNode.next),
		        nextState === actionNode
		          ? (actionQueue.pending = null)
		          : ((nextState = nextState.next),
		            (actionNode.next = nextState),
		            runActionStateAction(actionQueue, nextState)));
		    }
		    function onActionError(actionQueue, actionNode, error) {
		      var last = actionQueue.pending;
		      actionQueue.pending = null;
		      if (null !== last) {
		        last = last.next;
		        do
		          (actionNode.status = "rejected"),
		            (actionNode.reason = error),
		            notifyActionListeners(actionNode),
		            (actionNode = actionNode.next);
		        while (actionNode !== last);
		      }
		      actionQueue.action = null;
		    }
		    function notifyActionListeners(actionNode) {
		      actionNode = actionNode.listeners;
		      for (var i = 0; i < actionNode.length; i++) (0, actionNode[i])();
		    }
		    function actionStateReducer(oldState, newState) {
		      return newState;
		    }
		    function mountActionState(action, initialStateProp) {
		      if (isHydrating) {
		        var ssrFormState = workInProgressRoot.formState;
		        if (null !== ssrFormState) {
		          a: {
		            var isMatching = currentlyRenderingFiber;
		            if (isHydrating) {
		              if (nextHydratableInstance) {
		                var markerInstance = canHydrateFormStateMarker(
		                  nextHydratableInstance,
		                  rootOrSingletonContext
		                );
		                if (markerInstance) {
		                  nextHydratableInstance =
		                    getNextHydratableSibling(markerInstance);
		                  isMatching = isFormStateMarkerMatching(markerInstance);
		                  break a;
		                }
		              }
		              throwOnHydrationMismatch(isMatching);
		            }
		            isMatching = false;
		          }
		          isMatching && (initialStateProp = ssrFormState[0]);
		        }
		      }
		      ssrFormState = mountWorkInProgressHook();
		      ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
		      isMatching = {
		        pending: null,
		        lanes: 0,
		        dispatch: null,
		        lastRenderedReducer: actionStateReducer,
		        lastRenderedState: initialStateProp
		      };
		      ssrFormState.queue = isMatching;
		      ssrFormState = dispatchSetState.bind(
		        null,
		        currentlyRenderingFiber,
		        isMatching
		      );
		      isMatching.dispatch = ssrFormState;
		      isMatching = mountStateImpl(false);
		      var setPendingState = dispatchOptimisticSetState.bind(
		        null,
		        currentlyRenderingFiber,
		        false,
		        isMatching.queue
		      );
		      isMatching = mountWorkInProgressHook();
		      markerInstance = {
		        state: initialStateProp,
		        dispatch: null,
		        action: action,
		        pending: null
		      };
		      isMatching.queue = markerInstance;
		      ssrFormState = dispatchActionState.bind(
		        null,
		        currentlyRenderingFiber,
		        markerInstance,
		        setPendingState,
		        ssrFormState
		      );
		      markerInstance.dispatch = ssrFormState;
		      isMatching.memoizedState = action;
		      return [initialStateProp, ssrFormState, false];
		    }
		    function updateActionState(action) {
		      var stateHook = updateWorkInProgressHook();
		      return updateActionStateImpl(stateHook, currentHook, action);
		    }
		    function updateActionStateImpl(stateHook, currentStateHook, action) {
		      currentStateHook = updateReducerImpl(
		        stateHook,
		        currentStateHook,
		        actionStateReducer
		      )[0];
		      stateHook = updateReducer(basicStateReducer)[0];
		      if (
		        "object" === typeof currentStateHook &&
		        null !== currentStateHook &&
		        "function" === typeof currentStateHook.then
		      )
		        try {
		          var state = useThenable(currentStateHook);
		        } catch (x) {
		          if (x === SuspenseException) throw SuspenseActionException;
		          throw x;
		        }
		      else state = currentStateHook;
		      currentStateHook = updateWorkInProgressHook();
		      var actionQueue = currentStateHook.queue,
		        dispatch = actionQueue.dispatch;
		      action !== currentStateHook.memoizedState &&
		        ((currentlyRenderingFiber.flags |= 2048),
		        pushSimpleEffect(
		          HasEffect | Passive,
		          { destroy: void 0 },
		          actionStateActionEffect.bind(null, actionQueue, action),
		          null
		        ));
		      return [state, dispatch, stateHook];
		    }
		    function actionStateActionEffect(actionQueue, action) {
		      actionQueue.action = action;
		    }
		    function rerenderActionState(action) {
		      var stateHook = updateWorkInProgressHook(),
		        currentStateHook = currentHook;
		      if (null !== currentStateHook)
		        return updateActionStateImpl(stateHook, currentStateHook, action);
		      updateWorkInProgressHook();
		      stateHook = stateHook.memoizedState;
		      currentStateHook = updateWorkInProgressHook();
		      var dispatch = currentStateHook.queue.dispatch;
		      currentStateHook.memoizedState = action;
		      return [stateHook, dispatch, false];
		    }
		    function pushSimpleEffect(tag, inst, create, deps) {
		      tag = { tag: tag, create: create, deps: deps, inst: inst, next: null };
		      inst = currentlyRenderingFiber.updateQueue;
		      null === inst &&
		        ((inst = createFunctionComponentUpdateQueue()),
		        (currentlyRenderingFiber.updateQueue = inst));
		      create = inst.lastEffect;
		      null === create
		        ? (inst.lastEffect = tag.next = tag)
		        : ((deps = create.next),
		          (create.next = tag),
		          (tag.next = deps),
		          (inst.lastEffect = tag));
		      return tag;
		    }
		    function mountRef(initialValue) {
		      var hook = mountWorkInProgressHook();
		      initialValue = { current: initialValue };
		      return (hook.memoizedState = initialValue);
		    }
		    function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
		      var hook = mountWorkInProgressHook();
		      currentlyRenderingFiber.flags |= fiberFlags;
		      hook.memoizedState = pushSimpleEffect(
		        HasEffect | hookFlags,
		        { destroy: void 0 },
		        create,
		        void 0 === deps ? null : deps
		      );
		    }
		    function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
		      var hook = updateWorkInProgressHook();
		      deps = void 0 === deps ? null : deps;
		      var inst = hook.memoizedState.inst;
		      null !== currentHook &&
		      null !== deps &&
		      areHookInputsEqual(deps, currentHook.memoizedState.deps)
		        ? (hook.memoizedState = pushSimpleEffect(hookFlags, inst, create, deps))
		        : ((currentlyRenderingFiber.flags |= fiberFlags),
		          (hook.memoizedState = pushSimpleEffect(
		            HasEffect | hookFlags,
		            inst,
		            create,
		            deps
		          )));
		    }
		    function mountEffect(create, deps) {
		      (currentlyRenderingFiber.mode & 16) !== NoMode
		        ? mountEffectImpl(276826112, Passive, create, deps)
		        : mountEffectImpl(8390656, Passive, create, deps);
		    }
		    function useEffectEventImpl(payload) {
		      currentlyRenderingFiber.flags |= 4;
		      var componentUpdateQueue = currentlyRenderingFiber.updateQueue;
		      if (null === componentUpdateQueue)
		        (componentUpdateQueue = createFunctionComponentUpdateQueue()),
		          (currentlyRenderingFiber.updateQueue = componentUpdateQueue),
		          (componentUpdateQueue.events = [payload]);
		      else {
		        var events = componentUpdateQueue.events;
		        null === events
		          ? (componentUpdateQueue.events = [payload])
		          : events.push(payload);
		      }
		    }
		    function mountEvent(callback) {
		      var hook = mountWorkInProgressHook(),
		        ref = { impl: callback };
		      hook.memoizedState = ref;
		      return function () {
		        if ((executionContext & RenderContext) !== NoContext)
		          throw Error(
		            "A function wrapped in useEffectEvent can't be called during rendering."
		          );
		        return ref.impl.apply(void 0, arguments);
		      };
		    }
		    function updateEvent(callback) {
		      var ref = updateWorkInProgressHook().memoizedState;
		      useEffectEventImpl({ ref: ref, nextImpl: callback });
		      return function () {
		        if ((executionContext & RenderContext) !== NoContext)
		          throw Error(
		            "A function wrapped in useEffectEvent can't be called during rendering."
		          );
		        return ref.impl.apply(void 0, arguments);
		      };
		    }
		    function mountLayoutEffect(create, deps) {
		      var fiberFlags = 4194308;
		      (currentlyRenderingFiber.mode & 16) !== NoMode &&
		        (fiberFlags |= 134217728);
		      return mountEffectImpl(fiberFlags, Layout, create, deps);
		    }
		    function imperativeHandleEffect(create, ref) {
		      if ("function" === typeof ref) {
		        create = create();
		        var refCleanup = ref(create);
		        return function () {
		          "function" === typeof refCleanup ? refCleanup() : ref(null);
		        };
		      }
		      if (null !== ref && void 0 !== ref)
		        return (
		          ref.hasOwnProperty("current") ||
		            console.error(
		              "Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.",
		              "an object with keys {" + Object.keys(ref).join(", ") + "}"
		            ),
		          (create = create()),
		          (ref.current = create),
		          function () {
		            ref.current = null;
		          }
		        );
		    }
		    function mountImperativeHandle(ref, create, deps) {
		      "function" !== typeof create &&
		        console.error(
		          "Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.",
		          null !== create ? typeof create : "null"
		        );
		      deps = null !== deps && void 0 !== deps ? deps.concat([ref]) : null;
		      var fiberFlags = 4194308;
		      (currentlyRenderingFiber.mode & 16) !== NoMode &&
		        (fiberFlags |= 134217728);
		      mountEffectImpl(
		        fiberFlags,
		        Layout,
		        imperativeHandleEffect.bind(null, create, ref),
		        deps
		      );
		    }
		    function updateImperativeHandle(ref, create, deps) {
		      "function" !== typeof create &&
		        console.error(
		          "Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.",
		          null !== create ? typeof create : "null"
		        );
		      deps = null !== deps && void 0 !== deps ? deps.concat([ref]) : null;
		      updateEffectImpl(
		        4,
		        Layout,
		        imperativeHandleEffect.bind(null, create, ref),
		        deps
		      );
		    }
		    function mountCallback(callback, deps) {
		      mountWorkInProgressHook().memoizedState = [
		        callback,
		        void 0 === deps ? null : deps
		      ];
		      return callback;
		    }
		    function updateCallback(callback, deps) {
		      var hook = updateWorkInProgressHook();
		      deps = void 0 === deps ? null : deps;
		      var prevState = hook.memoizedState;
		      if (null !== deps && areHookInputsEqual(deps, prevState[1]))
		        return prevState[0];
		      hook.memoizedState = [callback, deps];
		      return callback;
		    }
		    function mountMemo(nextCreate, deps) {
		      var hook = mountWorkInProgressHook();
		      deps = void 0 === deps ? null : deps;
		      var nextValue = nextCreate();
		      if (shouldDoubleInvokeUserFnsInHooksDEV) {
		        setIsStrictModeForDevtools(true);
		        try {
		          nextCreate();
		        } finally {
		          setIsStrictModeForDevtools(false);
		        }
		      }
		      hook.memoizedState = [nextValue, deps];
		      return nextValue;
		    }
		    function updateMemo(nextCreate, deps) {
		      var hook = updateWorkInProgressHook();
		      deps = void 0 === deps ? null : deps;
		      var prevState = hook.memoizedState;
		      if (null !== deps && areHookInputsEqual(deps, prevState[1]))
		        return prevState[0];
		      prevState = nextCreate();
		      if (shouldDoubleInvokeUserFnsInHooksDEV) {
		        setIsStrictModeForDevtools(true);
		        try {
		          nextCreate();
		        } finally {
		          setIsStrictModeForDevtools(false);
		        }
		      }
		      hook.memoizedState = [prevState, deps];
		      return prevState;
		    }
		    function mountDeferredValue(value, initialValue) {
		      var hook = mountWorkInProgressHook();
		      return mountDeferredValueImpl(hook, value, initialValue);
		    }
		    function updateDeferredValue(value, initialValue) {
		      var hook = updateWorkInProgressHook();
		      return updateDeferredValueImpl(
		        hook,
		        currentHook.memoizedState,
		        value,
		        initialValue
		      );
		    }
		    function rerenderDeferredValue(value, initialValue) {
		      var hook = updateWorkInProgressHook();
		      return null === currentHook
		        ? mountDeferredValueImpl(hook, value, initialValue)
		        : updateDeferredValueImpl(
		            hook,
		            currentHook.memoizedState,
		            value,
		            initialValue
		          );
		    }
		    function mountDeferredValueImpl(hook, value, initialValue) {
		      if (
		        void 0 === initialValue ||
		        (0 !== (renderLanes & 1073741824) &&
		          0 === (workInProgressRootRenderLanes & 261930))
		      )
		        return (hook.memoizedState = value);
		      hook.memoizedState = initialValue;
		      hook = requestDeferredLane();
		      currentlyRenderingFiber.lanes |= hook;
		      workInProgressRootSkippedLanes |= hook;
		      return initialValue;
		    }
		    function updateDeferredValueImpl(hook, prevValue, value, initialValue) {
		      if (objectIs(value, prevValue)) return value;
		      if (null !== currentTreeHiddenStackCursor.current)
		        return (
		          (hook = mountDeferredValueImpl(hook, value, initialValue)),
		          objectIs(hook, prevValue) || (didReceiveUpdate = true),
		          hook
		        );
		      if (
		        0 === (renderLanes & 42) ||
		        (0 !== (renderLanes & 1073741824) &&
		          0 === (workInProgressRootRenderLanes & 261930))
		      )
		        return (didReceiveUpdate = true), (hook.memoizedState = value);
		      hook = requestDeferredLane();
		      currentlyRenderingFiber.lanes |= hook;
		      workInProgressRootSkippedLanes |= hook;
		      return prevValue;
		    }
		    function releaseAsyncTransition() {
		      ReactSharedInternals.asyncTransitions--;
		    }
		    function startTransition(
		      fiber,
		      queue,
		      pendingState,
		      finishedState,
		      callback
		    ) {
		      var previousPriority = getCurrentUpdatePriority();
		      setCurrentUpdatePriority(
		        0 !== previousPriority && 8 > previousPriority ? previousPriority : 8
		      );
		      var prevTransition = ReactSharedInternals.T,
		        currentTransition = {};
		      currentTransition._updatedFibers = new Set();
		      ReactSharedInternals.T = currentTransition;
		      dispatchOptimisticSetState(fiber, false, queue, pendingState);
		      try {
		        var returnValue = callback(),
		          onStartTransitionFinish = ReactSharedInternals.S;
		        null !== onStartTransitionFinish &&
		          onStartTransitionFinish(currentTransition, returnValue);
		        if (
		          null !== returnValue &&
		          "object" === typeof returnValue &&
		          "function" === typeof returnValue.then
		        ) {
		          ReactSharedInternals.asyncTransitions++;
		          returnValue.then(releaseAsyncTransition, releaseAsyncTransition);
		          var thenableForFinishedState = chainThenableValue(
		            returnValue,
		            finishedState
		          );
		          dispatchSetStateInternal(
		            fiber,
		            queue,
		            thenableForFinishedState,
		            requestUpdateLane(fiber)
		          );
		        } else
		          dispatchSetStateInternal(
		            fiber,
		            queue,
		            finishedState,
		            requestUpdateLane(fiber)
		          );
		      } catch (error) {
		        dispatchSetStateInternal(
		          fiber,
		          queue,
		          { then: function () {}, status: "rejected", reason: error },
		          requestUpdateLane(fiber)
		        );
		      } finally {
		        setCurrentUpdatePriority(previousPriority),
		          null !== prevTransition &&
		            null !== currentTransition.types &&
		            (null !== prevTransition.types &&
		              prevTransition.types !== currentTransition.types &&
		              console.error(
		                "We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."
		              ),
		            (prevTransition.types = currentTransition.types)),
		          (ReactSharedInternals.T = prevTransition),
		          null === prevTransition &&
		            currentTransition._updatedFibers &&
		            ((fiber = currentTransition._updatedFibers.size),
		            currentTransition._updatedFibers.clear(),
		            10 < fiber &&
		              console.warn(
		                "Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."
		              ));
		      }
		    }
		    function ensureFormComponentIsStateful(formFiber) {
		      var existingStateHook = formFiber.memoizedState;
		      if (null !== existingStateHook) return existingStateHook;
		      existingStateHook = {
		        memoizedState: NotPendingTransition,
		        baseState: NotPendingTransition,
		        baseQueue: null,
		        queue: {
		          pending: null,
		          lanes: 0,
		          dispatch: null,
		          lastRenderedReducer: basicStateReducer,
		          lastRenderedState: NotPendingTransition
		        },
		        next: null
		      };
		      var initialResetState = {};
		      existingStateHook.next = {
		        memoizedState: initialResetState,
		        baseState: initialResetState,
		        baseQueue: null,
		        queue: {
		          pending: null,
		          lanes: 0,
		          dispatch: null,
		          lastRenderedReducer: basicStateReducer,
		          lastRenderedState: initialResetState
		        },
		        next: null
		      };
		      formFiber.memoizedState = existingStateHook;
		      formFiber = formFiber.alternate;
		      null !== formFiber && (formFiber.memoizedState = existingStateHook);
		      return existingStateHook;
		    }
		    function mountTransition() {
		      var stateHook = mountStateImpl(false);
		      stateHook = startTransition.bind(
		        null,
		        currentlyRenderingFiber,
		        stateHook.queue,
		        true,
		        false
		      );
		      mountWorkInProgressHook().memoizedState = stateHook;
		      return [false, stateHook];
		    }
		    function updateTransition() {
		      var booleanOrThenable = updateReducer(basicStateReducer)[0],
		        start = updateWorkInProgressHook().memoizedState;
		      return [
		        "boolean" === typeof booleanOrThenable
		          ? booleanOrThenable
		          : useThenable(booleanOrThenable),
		        start
		      ];
		    }
		    function rerenderTransition() {
		      var booleanOrThenable = rerenderReducer(basicStateReducer)[0],
		        start = updateWorkInProgressHook().memoizedState;
		      return [
		        "boolean" === typeof booleanOrThenable
		          ? booleanOrThenable
		          : useThenable(booleanOrThenable),
		        start
		      ];
		    }
		    function useHostTransitionStatus() {
		      return readContext(HostTransitionContext);
		    }
		    function mountId() {
		      var hook = mountWorkInProgressHook(),
		        identifierPrefix = workInProgressRoot.identifierPrefix;
		      if (isHydrating) {
		        var treeId = treeContextOverflow;
		        var idWithLeadingBit = treeContextId;
		        treeId =
		          (
		            idWithLeadingBit & ~(1 << (32 - clz32(idWithLeadingBit) - 1))
		          ).toString(32) + treeId;
		        identifierPrefix = "_" + identifierPrefix + "R_" + treeId;
		        treeId = localIdCounter++;
		        0 < treeId && (identifierPrefix += "H" + treeId.toString(32));
		        identifierPrefix += "_";
		      } else
		        (treeId = globalClientIdCounter++),
		          (identifierPrefix =
		            "_" + identifierPrefix + "r_" + treeId.toString(32) + "_");
		      return (hook.memoizedState = identifierPrefix);
		    }
		    function mountRefresh() {
		      return (mountWorkInProgressHook().memoizedState = refreshCache.bind(
		        null,
		        currentlyRenderingFiber
		      ));
		    }
		    function refreshCache(fiber, seedKey) {
		      for (var provider = fiber.return; null !== provider; ) {
		        switch (provider.tag) {
		          case 24:
		          case 3:
		            var lane = requestUpdateLane(provider),
		              refreshUpdate = createUpdate(lane),
		              root = enqueueUpdate(provider, refreshUpdate, lane);
		            null !== root &&
		              (startUpdateTimerByLane(lane, "refresh()", fiber),
		              scheduleUpdateOnFiber(root, provider, lane),
		              entangleTransitions(root, provider, lane));
		            fiber = createCache();
		            null !== seedKey &&
		              void 0 !== seedKey &&
		              null !== root &&
		              console.error(
		                "The seed argument is not enabled outside experimental channels."
		              );
		            refreshUpdate.payload = { cache: fiber };
		            return;
		        }
		        provider = provider.return;
		      }
		    }
		    function dispatchReducerAction(fiber, queue, action) {
		      var args = arguments;
		      "function" === typeof args[3] &&
		        console.error(
		          "State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect()."
		        );
		      args = requestUpdateLane(fiber);
		      var update = {
		        lane: args,
		        revertLane: 0,
		        gesture: null,
		        action: action,
		        hasEagerState: false,
		        eagerState: null,
		        next: null
		      };
		      isRenderPhaseUpdate(fiber)
		        ? enqueueRenderPhaseUpdate(queue, update)
		        : ((update = enqueueConcurrentHookUpdate(fiber, queue, update, args)),
		          null !== update &&
		            (startUpdateTimerByLane(args, "dispatch()", fiber),
		            scheduleUpdateOnFiber(update, fiber, args),
		            entangleTransitionUpdate(update, queue, args)));
		    }
		    function dispatchSetState(fiber, queue, action) {
		      var args = arguments;
		      "function" === typeof args[3] &&
		        console.error(
		          "State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect()."
		        );
		      args = requestUpdateLane(fiber);
		      dispatchSetStateInternal(fiber, queue, action, args) &&
		        startUpdateTimerByLane(args, "setState()", fiber);
		    }
		    function dispatchSetStateInternal(fiber, queue, action, lane) {
		      var update = {
		        lane: lane,
		        revertLane: 0,
		        gesture: null,
		        action: action,
		        hasEagerState: false,
		        eagerState: null,
		        next: null
		      };
		      if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
		      else {
		        var alternate = fiber.alternate;
		        if (
		          0 === fiber.lanes &&
		          (null === alternate || 0 === alternate.lanes) &&
		          ((alternate = queue.lastRenderedReducer), null !== alternate)
		        ) {
		          var prevDispatcher = ReactSharedInternals.H;
		          ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
		          try {
		            var currentState = queue.lastRenderedState,
		              eagerState = alternate(currentState, action);
		            update.hasEagerState = !0;
		            update.eagerState = eagerState;
		            if (objectIs(eagerState, currentState))
		              return (
		                enqueueUpdate$1(fiber, queue, update, 0),
		                null === workInProgressRoot &&
		                  finishQueueingConcurrentUpdates(),
		                !1
		              );
		          } catch (error) {
		          } finally {
		            ReactSharedInternals.H = prevDispatcher;
		          }
		        }
		        action = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
		        if (null !== action)
		          return (
		            scheduleUpdateOnFiber(action, fiber, lane),
		            entangleTransitionUpdate(action, queue, lane),
		            true
		          );
		      }
		      return false;
		    }
		    function dispatchOptimisticSetState(
		      fiber,
		      throwIfDuringRender,
		      queue,
		      action
		    ) {
		      null === ReactSharedInternals.T &&
		        0 === currentEntangledLane &&
		        console.error(
		          "An optimistic state update occurred outside a transition or action. To fix, move the update to an action, or wrap with startTransition."
		        );
		      action = {
		        lane: 2,
		        revertLane: requestTransitionLane(),
		        gesture: null,
		        action: action,
		        hasEagerState: false,
		        eagerState: null,
		        next: null
		      };
		      if (isRenderPhaseUpdate(fiber)) {
		        if (throwIfDuringRender)
		          throw Error("Cannot update optimistic state while rendering.");
		        console.error("Cannot call startTransition while rendering.");
		      } else
		        (throwIfDuringRender = enqueueConcurrentHookUpdate(
		          fiber,
		          queue,
		          action,
		          2
		        )),
		          null !== throwIfDuringRender &&
		            (startUpdateTimerByLane(2, "setOptimistic()", fiber),
		            scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2));
		    }
		    function isRenderPhaseUpdate(fiber) {
		      var alternate = fiber.alternate;
		      return (
		        fiber === currentlyRenderingFiber ||
		        (null !== alternate && alternate === currentlyRenderingFiber)
		      );
		    }
		    function enqueueRenderPhaseUpdate(queue, update) {
		      didScheduleRenderPhaseUpdateDuringThisPass =
		        didScheduleRenderPhaseUpdate = true;
		      var pending = queue.pending;
		      null === pending
		        ? (update.next = update)
		        : ((update.next = pending.next), (pending.next = update));
		      queue.pending = update;
		    }
		    function entangleTransitionUpdate(root, queue, lane) {
		      if (0 !== (lane & 4194048)) {
		        var queueLanes = queue.lanes;
		        queueLanes &= root.pendingLanes;
		        lane |= queueLanes;
		        queue.lanes = lane;
		        markRootEntangled(root, lane);
		      }
		    }
		    function warnOnInvalidCallback(callback) {
		      if (null !== callback && "function" !== typeof callback) {
		        var key = String(callback);
		        didWarnOnInvalidCallback.has(key) ||
		          (didWarnOnInvalidCallback.add(key),
		          console.error(
		            "Expected the last optional `callback` argument to be a function. Instead received: %s.",
		            callback
		          ));
		      }
		    }
		    function applyDerivedStateFromProps(
		      workInProgress,
		      ctor,
		      getDerivedStateFromProps,
		      nextProps
		    ) {
		      var prevState = workInProgress.memoizedState,
		        partialState = getDerivedStateFromProps(nextProps, prevState);
		      if (workInProgress.mode & 8) {
		        setIsStrictModeForDevtools(true);
		        try {
		          partialState = getDerivedStateFromProps(nextProps, prevState);
		        } finally {
		          setIsStrictModeForDevtools(false);
		        }
		      }
		      void 0 === partialState &&
		        ((ctor = getComponentNameFromType(ctor) || "Component"),
		        didWarnAboutUndefinedDerivedState.has(ctor) ||
		          (didWarnAboutUndefinedDerivedState.add(ctor),
		          console.error(
		            "%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.",
		            ctor
		          )));
		      prevState =
		        null === partialState || void 0 === partialState
		          ? prevState
		          : assign({}, prevState, partialState);
		      workInProgress.memoizedState = prevState;
		      0 === workInProgress.lanes &&
		        (workInProgress.updateQueue.baseState = prevState);
		    }
		    function checkShouldComponentUpdate(
		      workInProgress,
		      ctor,
		      oldProps,
		      newProps,
		      oldState,
		      newState,
		      nextContext
		    ) {
		      var instance = workInProgress.stateNode;
		      if ("function" === typeof instance.shouldComponentUpdate) {
		        oldProps = instance.shouldComponentUpdate(
		          newProps,
		          newState,
		          nextContext
		        );
		        if (workInProgress.mode & 8) {
		          setIsStrictModeForDevtools(true);
		          try {
		            oldProps = instance.shouldComponentUpdate(
		              newProps,
		              newState,
		              nextContext
		            );
		          } finally {
		            setIsStrictModeForDevtools(false);
		          }
		        }
		        void 0 === oldProps &&
		          console.error(
		            "%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.",
		            getComponentNameFromType(ctor) || "Component"
		          );
		        return oldProps;
		      }
		      return ctor.prototype && ctor.prototype.isPureReactComponent
		        ? !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState)
		        : true;
		    }
		    function callComponentWillReceiveProps(
		      workInProgress,
		      instance,
		      newProps,
		      nextContext
		    ) {
		      var oldState = instance.state;
		      "function" === typeof instance.componentWillReceiveProps &&
		        instance.componentWillReceiveProps(newProps, nextContext);
		      "function" === typeof instance.UNSAFE_componentWillReceiveProps &&
		        instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
		      instance.state !== oldState &&
		        ((workInProgress =
		          getComponentNameFromFiber(workInProgress) || "Component"),
		        didWarnAboutStateAssignmentForComponent.has(workInProgress) ||
		          (didWarnAboutStateAssignmentForComponent.add(workInProgress),
		          console.error(
		            "%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",
		            workInProgress
		          )),
		        classComponentUpdater.enqueueReplaceState(
		          instance,
		          instance.state,
		          null
		        ));
		    }
		    function resolveClassComponentProps(Component, baseProps) {
		      var newProps = baseProps;
		      if ("ref" in baseProps) {
		        newProps = {};
		        for (var propName in baseProps)
		          "ref" !== propName && (newProps[propName] = baseProps[propName]);
		      }
		      if ((Component = Component.defaultProps)) {
		        newProps === baseProps && (newProps = assign({}, newProps));
		        for (var _propName in Component)
		          void 0 === newProps[_propName] &&
		            (newProps[_propName] = Component[_propName]);
		      }
		      return newProps;
		    }
		    function logUncaughtError(root, errorInfo) {
		      try {
		        componentName = errorInfo.source
		          ? getComponentNameFromFiber(errorInfo.source)
		          : null;
		        errorBoundaryName = null;
		        var error = errorInfo.value;
		        if (null !== ReactSharedInternals.actQueue)
		          ReactSharedInternals.thrownErrors.push(error);
		        else {
		          var onUncaughtError = root.onUncaughtError;
		          onUncaughtError(error, { componentStack: errorInfo.stack });
		        }
		      } catch (e) {
		        setTimeout(function () {
		          throw e;
		        });
		      }
		    }
		    function logCaughtError(root, boundary, errorInfo) {
		      try {
		        componentName = errorInfo.source
		          ? getComponentNameFromFiber(errorInfo.source)
		          : null;
		        errorBoundaryName = getComponentNameFromFiber(boundary);
		        var onCaughtError = root.onCaughtError;
		        onCaughtError(errorInfo.value, {
		          componentStack: errorInfo.stack,
		          errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
		        });
		      } catch (e) {
		        setTimeout(function () {
		          throw e;
		        });
		      }
		    }
		    function createRootErrorUpdate(root, errorInfo, lane) {
		      lane = createUpdate(lane);
		      lane.tag = CaptureUpdate;
		      lane.payload = { element: null };
		      lane.callback = function () {
		        runWithFiberInDEV(errorInfo.source, logUncaughtError, root, errorInfo);
		      };
		      return lane;
		    }
		    function createClassErrorUpdate(lane) {
		      lane = createUpdate(lane);
		      lane.tag = CaptureUpdate;
		      return lane;
		    }
		    function initializeClassErrorUpdate(update, root, fiber, errorInfo) {
		      var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
		      if ("function" === typeof getDerivedStateFromError) {
		        var error = errorInfo.value;
		        update.payload = function () {
		          return getDerivedStateFromError(error);
		        };
		        update.callback = function () {
		          markFailedErrorBoundaryForHotReloading(fiber);
		          runWithFiberInDEV(
		            errorInfo.source,
		            logCaughtError,
		            root,
		            fiber,
		            errorInfo
		          );
		        };
		      }
		      var inst = fiber.stateNode;
		      null !== inst &&
		        "function" === typeof inst.componentDidCatch &&
		        (update.callback = function () {
		          markFailedErrorBoundaryForHotReloading(fiber);
		          runWithFiberInDEV(
		            errorInfo.source,
		            logCaughtError,
		            root,
		            fiber,
		            errorInfo
		          );
		          "function" !== typeof getDerivedStateFromError &&
		            (null === legacyErrorBoundariesThatAlreadyFailed
		              ? (legacyErrorBoundariesThatAlreadyFailed = new Set([this]))
		              : legacyErrorBoundariesThatAlreadyFailed.add(this));
		          callComponentDidCatchInDEV(this, errorInfo);
		          "function" === typeof getDerivedStateFromError ||
		            (0 === (fiber.lanes & 2) &&
		              console.error(
		                "%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.",
		                getComponentNameFromFiber(fiber) || "Unknown"
		              ));
		        });
		    }
		    function throwException(
		      root,
		      returnFiber,
		      sourceFiber,
		      value,
		      rootRenderLanes
		    ) {
		      sourceFiber.flags |= 32768;
		      isDevToolsPresent && restorePendingUpdaters(root, rootRenderLanes);
		      if (
		        null !== value &&
		        "object" === typeof value &&
		        "function" === typeof value.then
		      ) {
		        returnFiber = sourceFiber.alternate;
		        null !== returnFiber &&
		          propagateParentContextChanges(
		            returnFiber,
		            sourceFiber,
		            rootRenderLanes,
		            true
		          );
		        isHydrating && (didSuspendOrErrorDEV = true);
		        sourceFiber = suspenseHandlerStackCursor.current;
		        if (null !== sourceFiber) {
		          switch (sourceFiber.tag) {
		            case 31:
		            case 13:
		              return (
		                null === shellBoundary
		                  ? renderDidSuspendDelayIfPossible()
		                  : null === sourceFiber.alternate &&
		                    workInProgressRootExitStatus === RootInProgress &&
		                    (workInProgressRootExitStatus = RootSuspended),
		                (sourceFiber.flags &= -257),
		                (sourceFiber.flags |= 65536),
		                (sourceFiber.lanes = rootRenderLanes),
		                value === noopSuspenseyCommitThenable
		                  ? (sourceFiber.flags |= 16384)
		                  : ((returnFiber = sourceFiber.updateQueue),
		                    null === returnFiber
		                      ? (sourceFiber.updateQueue = new Set([value]))
		                      : returnFiber.add(value),
		                    attachPingListener(root, value, rootRenderLanes)),
		                false
		              );
		            case 22:
		              return (
		                (sourceFiber.flags |= 65536),
		                value === noopSuspenseyCommitThenable
		                  ? (sourceFiber.flags |= 16384)
		                  : ((returnFiber = sourceFiber.updateQueue),
		                    null === returnFiber
		                      ? ((returnFiber = {
		                          transitions: null,
		                          markerInstances: null,
		                          retryQueue: new Set([value])
		                        }),
		                        (sourceFiber.updateQueue = returnFiber))
		                      : ((sourceFiber = returnFiber.retryQueue),
		                        null === sourceFiber
		                          ? (returnFiber.retryQueue = new Set([value]))
		                          : sourceFiber.add(value)),
		                    attachPingListener(root, value, rootRenderLanes)),
		                false
		              );
		          }
		          throw Error(
		            "Unexpected Suspense handler tag (" +
		              sourceFiber.tag +
		              "). This is a bug in React."
		          );
		        }
		        attachPingListener(root, value, rootRenderLanes);
		        renderDidSuspendDelayIfPossible();
		        return false;
		      }
		      if (isHydrating)
		        return (
		          (didSuspendOrErrorDEV = true),
		          (returnFiber = suspenseHandlerStackCursor.current),
		          null !== returnFiber
		            ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256),
		              (returnFiber.flags |= 65536),
		              (returnFiber.lanes = rootRenderLanes),
		              value !== HydrationMismatchException &&
		                queueHydrationError(
		                  createCapturedValueAtFiber(
		                    Error(
		                      "There was an error while hydrating but React was able to recover by instead client rendering from the nearest Suspense boundary.",
		                      { cause: value }
		                    ),
		                    sourceFiber
		                  )
		                ))
		            : (value !== HydrationMismatchException &&
		                queueHydrationError(
		                  createCapturedValueAtFiber(
		                    Error(
		                      "There was an error while hydrating but React was able to recover by instead client rendering the entire root.",
		                      { cause: value }
		                    ),
		                    sourceFiber
		                  )
		                ),
		              (root = root.current.alternate),
		              (root.flags |= 65536),
		              (rootRenderLanes &= -rootRenderLanes),
		              (root.lanes |= rootRenderLanes),
		              (value = createCapturedValueAtFiber(value, sourceFiber)),
		              (rootRenderLanes = createRootErrorUpdate(
		                root.stateNode,
		                value,
		                rootRenderLanes
		              )),
		              enqueueCapturedUpdate(root, rootRenderLanes),
		              workInProgressRootExitStatus !== RootSuspendedWithDelay &&
		                (workInProgressRootExitStatus = RootErrored)),
		          false
		        );
		      var error = createCapturedValueAtFiber(
		        Error(
		          "There was an error during concurrent rendering but React was able to recover by instead synchronously rendering the entire root.",
		          { cause: value }
		        ),
		        sourceFiber
		      );
		      null === workInProgressRootConcurrentErrors
		        ? (workInProgressRootConcurrentErrors = [error])
		        : workInProgressRootConcurrentErrors.push(error);
		      workInProgressRootExitStatus !== RootSuspendedWithDelay &&
		        (workInProgressRootExitStatus = RootErrored);
		      if (null === returnFiber) return true;
		      value = createCapturedValueAtFiber(value, sourceFiber);
		      sourceFiber = returnFiber;
		      do {
		        switch (sourceFiber.tag) {
		          case 3:
		            return (
		              (sourceFiber.flags |= 65536),
		              (root = rootRenderLanes & -rootRenderLanes),
		              (sourceFiber.lanes |= root),
		              (root = createRootErrorUpdate(
		                sourceFiber.stateNode,
		                value,
		                root
		              )),
		              enqueueCapturedUpdate(sourceFiber, root),
		              false
		            );
		          case 1:
		            if (
		              ((returnFiber = sourceFiber.type),
		              (error = sourceFiber.stateNode),
		              0 === (sourceFiber.flags & 128) &&
		                ("function" === typeof returnFiber.getDerivedStateFromError ||
		                  (null !== error &&
		                    "function" === typeof error.componentDidCatch &&
		                    (null === legacyErrorBoundariesThatAlreadyFailed ||
		                      !legacyErrorBoundariesThatAlreadyFailed.has(error)))))
		            )
		              return (
		                (sourceFiber.flags |= 65536),
		                (rootRenderLanes &= -rootRenderLanes),
		                (sourceFiber.lanes |= rootRenderLanes),
		                (rootRenderLanes = createClassErrorUpdate(rootRenderLanes)),
		                initializeClassErrorUpdate(
		                  rootRenderLanes,
		                  root,
		                  sourceFiber,
		                  value
		                ),
		                enqueueCapturedUpdate(sourceFiber, rootRenderLanes),
		                false
		              );
		        }
		        sourceFiber = sourceFiber.return;
		      } while (null !== sourceFiber);
		      return false;
		    }
		    function reconcileChildren(
		      current,
		      workInProgress,
		      nextChildren,
		      renderLanes
		    ) {
		      workInProgress.child =
		        null === current
		          ? mountChildFibers(workInProgress, null, nextChildren, renderLanes)
		          : reconcileChildFibers(
		              workInProgress,
		              current.child,
		              nextChildren,
		              renderLanes
		            );
		    }
		    function updateForwardRef(
		      current,
		      workInProgress,
		      Component,
		      nextProps,
		      renderLanes
		    ) {
		      Component = Component.render;
		      var ref = workInProgress.ref;
		      if ("ref" in nextProps) {
		        var propsWithoutRef = {};
		        for (var key in nextProps)
		          "ref" !== key && (propsWithoutRef[key] = nextProps[key]);
		      } else propsWithoutRef = nextProps;
		      prepareToReadContext(workInProgress);
		      nextProps = renderWithHooks(
		        current,
		        workInProgress,
		        Component,
		        propsWithoutRef,
		        ref,
		        renderLanes
		      );
		      key = checkDidRenderIdHook();
		      if (null !== current && !didReceiveUpdate)
		        return (
		          bailoutHooks(current, workInProgress, renderLanes),
		          bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes)
		        );
		      isHydrating && key && pushMaterializedTreeId(workInProgress);
		      workInProgress.flags |= 1;
		      reconcileChildren(current, workInProgress, nextProps, renderLanes);
		      return workInProgress.child;
		    }
		    function updateMemoComponent(
		      current,
		      workInProgress,
		      Component,
		      nextProps,
		      renderLanes
		    ) {
		      if (null === current) {
		        var type = Component.type;
		        if (
		          "function" === typeof type &&
		          !shouldConstruct(type) &&
		          void 0 === type.defaultProps &&
		          null === Component.compare
		        )
		          return (
		            (Component = resolveFunctionForHotReloading(type)),
		            (workInProgress.tag = 15),
		            (workInProgress.type = Component),
		            validateFunctionComponentInDev(workInProgress, type),
		            updateSimpleMemoComponent(
		              current,
		              workInProgress,
		              Component,
		              nextProps,
		              renderLanes
		            )
		          );
		        current = createFiberFromTypeAndProps(
		          Component.type,
		          null,
		          nextProps,
		          workInProgress,
		          workInProgress.mode,
		          renderLanes
		        );
		        current.ref = workInProgress.ref;
		        current.return = workInProgress;
		        return (workInProgress.child = current);
		      }
		      type = current.child;
		      if (!checkScheduledUpdateOrContext(current, renderLanes)) {
		        var prevProps = type.memoizedProps;
		        Component = Component.compare;
		        Component = null !== Component ? Component : shallowEqual;
		        if (
		          Component(prevProps, nextProps) &&
		          current.ref === workInProgress.ref
		        )
		          return bailoutOnAlreadyFinishedWork(
		            current,
		            workInProgress,
		            renderLanes
		          );
		      }
		      workInProgress.flags |= 1;
		      current = createWorkInProgress(type, nextProps);
		      current.ref = workInProgress.ref;
		      current.return = workInProgress;
		      return (workInProgress.child = current);
		    }
		    function updateSimpleMemoComponent(
		      current,
		      workInProgress,
		      Component,
		      nextProps,
		      renderLanes
		    ) {
		      if (null !== current) {
		        var prevProps = current.memoizedProps;
		        if (
		          shallowEqual(prevProps, nextProps) &&
		          current.ref === workInProgress.ref &&
		          workInProgress.type === current.type
		        )
		          if (
		            ((didReceiveUpdate = false),
		            (workInProgress.pendingProps = nextProps = prevProps),
		            checkScheduledUpdateOrContext(current, renderLanes))
		          )
		            0 !== (current.flags & 131072) && (didReceiveUpdate = true);
		          else
		            return (
		              (workInProgress.lanes = current.lanes),
		              bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes)
		            );
		      }
		      return updateFunctionComponent(
		        current,
		        workInProgress,
		        Component,
		        nextProps,
		        renderLanes
		      );
		    }
		    function updateOffscreenComponent(
		      current,
		      workInProgress,
		      renderLanes,
		      nextProps
		    ) {
		      var nextChildren = nextProps.children,
		        prevState = null !== current ? current.memoizedState : null;
		      null === current &&
		        null === workInProgress.stateNode &&
		        (workInProgress.stateNode = {
		          _visibility: OffscreenVisible,
		          _pendingMarkers: null,
		          _retryCache: null,
		          _transitions: null
		        });
		      if ("hidden" === nextProps.mode) {
		        if (0 !== (workInProgress.flags & 128)) {
		          prevState =
		            null !== prevState
		              ? prevState.baseLanes | renderLanes
		              : renderLanes;
		          if (null !== current) {
		            nextProps = workInProgress.child = current.child;
		            for (nextChildren = 0; null !== nextProps; )
		              (nextChildren =
		                nextChildren | nextProps.lanes | nextProps.childLanes),
		                (nextProps = nextProps.sibling);
		            nextProps = nextChildren & ~prevState;
		          } else (nextProps = 0), (workInProgress.child = null);
		          return deferHiddenOffscreenComponent(
		            current,
		            workInProgress,
		            prevState,
		            renderLanes,
		            nextProps
		          );
		        }
		        if (0 !== (renderLanes & 536870912))
		          (workInProgress.memoizedState = { baseLanes: 0, cachePool: null }),
		            null !== current &&
		              pushTransition(
		                workInProgress,
		                null !== prevState ? prevState.cachePool : null
		              ),
		            null !== prevState
		              ? pushHiddenContext(workInProgress, prevState)
		              : reuseHiddenContextOnStack(workInProgress),
		            pushOffscreenSuspenseHandler(workInProgress);
		        else
		          return (
		            (nextProps = workInProgress.lanes = 536870912),
		            deferHiddenOffscreenComponent(
		              current,
		              workInProgress,
		              null !== prevState
		                ? prevState.baseLanes | renderLanes
		                : renderLanes,
		              renderLanes,
		              nextProps
		            )
		          );
		      } else
		        null !== prevState
		          ? (pushTransition(workInProgress, prevState.cachePool),
		            pushHiddenContext(workInProgress, prevState),
		            reuseSuspenseHandlerOnStack(workInProgress),
		            (workInProgress.memoizedState = null))
		          : (null !== current && pushTransition(workInProgress, null),
		            reuseHiddenContextOnStack(workInProgress),
		            reuseSuspenseHandlerOnStack(workInProgress));
		      reconcileChildren(current, workInProgress, nextChildren, renderLanes);
		      return workInProgress.child;
		    }
		    function bailoutOffscreenComponent(current, workInProgress) {
		      (null !== current && 22 === current.tag) ||
		        null !== workInProgress.stateNode ||
		        (workInProgress.stateNode = {
		          _visibility: OffscreenVisible,
		          _pendingMarkers: null,
		          _retryCache: null,
		          _transitions: null
		        });
		      return workInProgress.sibling;
		    }
		    function deferHiddenOffscreenComponent(
		      current,
		      workInProgress,
		      nextBaseLanes,
		      renderLanes,
		      remainingChildLanes
		    ) {
		      var JSCompiler_inline_result = peekCacheFromPool();
		      JSCompiler_inline_result =
		        null === JSCompiler_inline_result
		          ? null
		          : {
		              parent: isPrimaryRenderer
		                ? CacheContext._currentValue
		                : CacheContext._currentValue2,
		              pool: JSCompiler_inline_result
		            };
		      workInProgress.memoizedState = {
		        baseLanes: nextBaseLanes,
		        cachePool: JSCompiler_inline_result
		      };
		      null !== current && pushTransition(workInProgress, null);
		      reuseHiddenContextOnStack(workInProgress);
		      pushOffscreenSuspenseHandler(workInProgress);
		      null !== current &&
		        propagateParentContextChanges(current, workInProgress, renderLanes, true);
		      workInProgress.childLanes = remainingChildLanes;
		      return null;
		    }
		    function mountActivityChildren(workInProgress, nextProps) {
		      var hiddenProp = nextProps.hidden;
		      void 0 !== hiddenProp &&
		        console.error(
		          '<Activity> doesn\'t accept a hidden prop. Use mode="hidden" instead.\n- <Activity %s>\n+ <Activity %s>',
		          true === hiddenProp
		            ? "hidden"
		            : false === hiddenProp
		              ? "hidden={false}"
		              : "hidden={...}",
		          hiddenProp ? 'mode="hidden"' : 'mode="visible"'
		        );
		      nextProps = mountWorkInProgressOffscreenFiber(
		        { mode: nextProps.mode, children: nextProps.children },
		        workInProgress.mode
		      );
		      nextProps.ref = workInProgress.ref;
		      workInProgress.child = nextProps;
		      nextProps.return = workInProgress;
		      return nextProps;
		    }
		    function retryActivityComponentWithoutHydrating(
		      current,
		      workInProgress,
		      renderLanes
		    ) {
		      reconcileChildFibers(workInProgress, current.child, null, renderLanes);
		      current = mountActivityChildren(
		        workInProgress,
		        workInProgress.pendingProps
		      );
		      current.flags |= 2;
		      popSuspenseHandler(workInProgress);
		      workInProgress.memoizedState = null;
		      return current;
		    }
		    function updateActivityComponent(current, workInProgress, renderLanes) {
		      var nextProps = workInProgress.pendingProps,
		        didSuspend = 0 !== (workInProgress.flags & 128);
		      workInProgress.flags &= -129;
		      if (null === current) {
		        if (isHydrating) {
		          if ("hidden" === nextProps.mode)
		            return (
		              (current = mountActivityChildren(workInProgress, nextProps)),
		              (workInProgress.lanes = 536870912),
		              bailoutOffscreenComponent(null, current)
		            );
		          pushDehydratedActivitySuspenseHandler(workInProgress);
		          (current = nextHydratableInstance)
		            ? ((renderLanes = canHydrateActivityInstance(
		                current,
		                rootOrSingletonContext
		              )),
		              null !== renderLanes &&
		                ((nextProps = {
		                  dehydrated: renderLanes,
		                  treeContext: getSuspendedTreeContext(),
		                  retryLane: 536870912,
		                  hydrationErrors: null
		                }),
		                (workInProgress.memoizedState = nextProps),
		                (nextProps = createFiberFromDehydratedFragment(renderLanes)),
		                (nextProps.return = workInProgress),
		                (workInProgress.child = nextProps),
		                (hydrationParentFiber = workInProgress),
		                (nextHydratableInstance = null)))
		            : (renderLanes = null);
		          if (null === renderLanes)
		            throw (
		              (warnNonHydratedInstance(workInProgress, current),
		              throwOnHydrationMismatch(workInProgress))
		            );
		          workInProgress.lanes = 536870912;
		          return null;
		        }
		        return mountActivityChildren(workInProgress, nextProps);
		      }
		      var prevState = current.memoizedState;
		      if (null !== prevState) {
		        var activityInstance = prevState.dehydrated;
		        pushDehydratedActivitySuspenseHandler(workInProgress);
		        if (didSuspend)
		          if (workInProgress.flags & 256)
		            (workInProgress.flags &= -257),
		              (workInProgress = retryActivityComponentWithoutHydrating(
		                current,
		                workInProgress,
		                renderLanes
		              ));
		          else if (null !== workInProgress.memoizedState)
		            (workInProgress.child = current.child),
		              (workInProgress.flags |= 128),
		              (workInProgress = null);
		          else
		            throw Error(
		              "Client rendering an Activity suspended it again. This is a bug in React."
		            );
		        else if (
		          (warnIfHydrating(),
		          0 !== (renderLanes & 536870912) &&
		            markRenderDerivedCause(workInProgress),
		          didReceiveUpdate ||
		            propagateParentContextChanges(
		              current,
		              workInProgress,
		              renderLanes,
		              false
		            ),
		          (didSuspend = 0 !== (renderLanes & current.childLanes)),
		          didReceiveUpdate || didSuspend)
		        ) {
		          nextProps = workInProgressRoot;
		          if (
		            null !== nextProps &&
		            ((activityInstance = getBumpedLaneForHydration(
		              nextProps,
		              renderLanes
		            )),
		            0 !== activityInstance && activityInstance !== prevState.retryLane)
		          )
		            throw (
		              ((prevState.retryLane = activityInstance),
		              enqueueConcurrentRenderForLane(current, activityInstance),
		              scheduleUpdateOnFiber(nextProps, current, activityInstance),
		              SelectiveHydrationException)
		            );
		          renderDidSuspendDelayIfPossible();
		          workInProgress = retryActivityComponentWithoutHydrating(
		            current,
		            workInProgress,
		            renderLanes
		          );
		        } else
		          (current = prevState.treeContext),
		            supportsHydration &&
		              ((nextHydratableInstance =
		                getFirstHydratableChildWithinActivityInstance(
		                  activityInstance
		                )),
		              (hydrationParentFiber = workInProgress),
		              (isHydrating = true),
		              (hydrationErrors = null),
		              (didSuspendOrErrorDEV = false),
		              (hydrationDiffRootDEV = null),
		              (rootOrSingletonContext = false),
		              null !== current &&
		                restoreSuspendedTreeContext(workInProgress, current)),
		            (workInProgress = mountActivityChildren(workInProgress, nextProps)),
		            (workInProgress.flags |= 4096);
		        return workInProgress;
		      }
		      prevState = current.child;
		      nextProps = { mode: nextProps.mode, children: nextProps.children };
		      0 !== (renderLanes & 536870912) &&
		        0 !== (renderLanes & current.lanes) &&
		        markRenderDerivedCause(workInProgress);
		      current = createWorkInProgress(prevState, nextProps);
		      current.ref = workInProgress.ref;
		      workInProgress.child = current;
		      current.return = workInProgress;
		      return current;
		    }
		    function markRef(current, workInProgress) {
		      var ref = workInProgress.ref;
		      if (null === ref)
		        null !== current &&
		          null !== current.ref &&
		          (workInProgress.flags |= 4194816);
		      else {
		        if ("function" !== typeof ref && "object" !== typeof ref)
		          throw Error(
		            "Expected ref to be a function, an object returned by React.createRef(), or undefined/null."
		          );
		        if (null === current || current.ref !== ref)
		          workInProgress.flags |= 4194816;
		      }
		    }
		    function updateFunctionComponent(
		      current,
		      workInProgress,
		      Component,
		      nextProps,
		      renderLanes
		    ) {
		      if (
		        Component.prototype &&
		        "function" === typeof Component.prototype.render
		      ) {
		        var componentName = getComponentNameFromType(Component) || "Unknown";
		        didWarnAboutBadClass[componentName] ||
		          (console.error(
		            "The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.",
		            componentName,
		            componentName
		          ),
		          (didWarnAboutBadClass[componentName] = true));
		      }
		      workInProgress.mode & 8 &&
		        ReactStrictModeWarnings.recordLegacyContextWarning(
		          workInProgress,
		          null
		        );
		      null === current &&
		        (validateFunctionComponentInDev(workInProgress, workInProgress.type),
		        Component.contextTypes &&
		          ((componentName = getComponentNameFromType(Component) || "Unknown"),
		          didWarnAboutContextTypes[componentName] ||
		            ((didWarnAboutContextTypes[componentName] = true),
		            console.error(
		              "%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with React.useContext() instead. (https://react.dev/link/legacy-context)",
		              componentName
		            ))));
		      prepareToReadContext(workInProgress);
		      Component = renderWithHooks(
		        current,
		        workInProgress,
		        Component,
		        nextProps,
		        void 0,
		        renderLanes
		      );
		      nextProps = checkDidRenderIdHook();
		      if (null !== current && !didReceiveUpdate)
		        return (
		          bailoutHooks(current, workInProgress, renderLanes),
		          bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes)
		        );
		      isHydrating && nextProps && pushMaterializedTreeId(workInProgress);
		      workInProgress.flags |= 1;
		      reconcileChildren(current, workInProgress, Component, renderLanes);
		      return workInProgress.child;
		    }
		    function replayFunctionComponent(
		      current,
		      workInProgress,
		      nextProps,
		      Component,
		      secondArg,
		      renderLanes
		    ) {
		      prepareToReadContext(workInProgress);
		      hookTypesUpdateIndexDev = -1;
		      ignorePreviousDependencies =
		        null !== current && current.type !== workInProgress.type;
		      workInProgress.updateQueue = null;
		      nextProps = renderWithHooksAgain(
		        workInProgress,
		        Component,
		        nextProps,
		        secondArg
		      );
		      finishRenderingHooks(current, workInProgress);
		      Component = checkDidRenderIdHook();
		      if (null !== current && !didReceiveUpdate)
		        return (
		          bailoutHooks(current, workInProgress, renderLanes),
		          bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes)
		        );
		      isHydrating && Component && pushMaterializedTreeId(workInProgress);
		      workInProgress.flags |= 1;
		      reconcileChildren(current, workInProgress, nextProps, renderLanes);
		      return workInProgress.child;
		    }
		    function updateClassComponent(
		      current,
		      workInProgress,
		      Component,
		      nextProps,
		      renderLanes
		    ) {
		      switch (shouldErrorImpl(workInProgress)) {
		        case false:
		          var _instance = workInProgress.stateNode,
		            state = new workInProgress.type(
		              workInProgress.memoizedProps,
		              _instance.context
		            ).state;
		          _instance.updater.enqueueSetState(_instance, state, null);
		          break;
		        case true:
		          workInProgress.flags |= 128;
		          workInProgress.flags |= 65536;
		          _instance = Error("Simulated error coming from DevTools");
		          var lane = renderLanes & -renderLanes;
		          workInProgress.lanes |= lane;
		          state = workInProgressRoot;
		          if (null === state)
		            throw Error(
		              "Expected a work-in-progress root. This is a bug in React. Please file an issue."
		            );
		          lane = createClassErrorUpdate(lane);
		          initializeClassErrorUpdate(
		            lane,
		            state,
		            workInProgress,
		            createCapturedValueAtFiber(_instance, workInProgress)
		          );
		          enqueueCapturedUpdate(workInProgress, lane);
		      }
		      prepareToReadContext(workInProgress);
		      if (null === workInProgress.stateNode) {
		        state = emptyContextObject;
		        _instance = Component.contextType;
		        "contextType" in Component &&
		          null !== _instance &&
		          (void 0 === _instance || _instance.$$typeof !== REACT_CONTEXT_TYPE) &&
		          !didWarnAboutInvalidateContextType.has(Component) &&
		          (didWarnAboutInvalidateContextType.add(Component),
		          (lane =
		            void 0 === _instance
		              ? " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file."
		              : "object" !== typeof _instance
		                ? " However, it is set to a " + typeof _instance + "."
		                : _instance.$$typeof === REACT_CONSUMER_TYPE
		                  ? " Did you accidentally pass the Context.Consumer instead?"
		                  : " However, it is set to an object with keys {" +
		                    Object.keys(_instance).join(", ") +
		                    "}."),
		          console.error(
		            "%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s",
		            getComponentNameFromType(Component) || "Component",
		            lane
		          ));
		        "object" === typeof _instance &&
		          null !== _instance &&
		          (state = readContext(_instance));
		        _instance = new Component(nextProps, state);
		        if (workInProgress.mode & 8) {
		          setIsStrictModeForDevtools(true);
		          try {
		            _instance = new Component(nextProps, state);
		          } finally {
		            setIsStrictModeForDevtools(false);
		          }
		        }
		        state = workInProgress.memoizedState =
		          null !== _instance.state && void 0 !== _instance.state
		            ? _instance.state
		            : null;
		        _instance.updater = classComponentUpdater;
		        workInProgress.stateNode = _instance;
		        _instance._reactInternals = workInProgress;
		        _instance._reactInternalInstance = fakeInternalInstance;
		        "function" === typeof Component.getDerivedStateFromProps &&
		          null === state &&
		          ((state = getComponentNameFromType(Component) || "Component"),
		          didWarnAboutUninitializedState.has(state) ||
		            (didWarnAboutUninitializedState.add(state),
		            console.error(
		              "`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.",
		              state,
		              null === _instance.state ? "null" : "undefined",
		              state
		            )));
		        if (
		          "function" === typeof Component.getDerivedStateFromProps ||
		          "function" === typeof _instance.getSnapshotBeforeUpdate
		        ) {
		          var foundWillUpdateName = (lane = state = null);
		          "function" === typeof _instance.componentWillMount &&
		          true !== _instance.componentWillMount.__suppressDeprecationWarning
		            ? (state = "componentWillMount")
		            : "function" === typeof _instance.UNSAFE_componentWillMount &&
		              (state = "UNSAFE_componentWillMount");
		          "function" === typeof _instance.componentWillReceiveProps &&
		          true !==
		            _instance.componentWillReceiveProps.__suppressDeprecationWarning
		            ? (lane = "componentWillReceiveProps")
		            : "function" ===
		                typeof _instance.UNSAFE_componentWillReceiveProps &&
		              (lane = "UNSAFE_componentWillReceiveProps");
		          "function" === typeof _instance.componentWillUpdate &&
		          true !== _instance.componentWillUpdate.__suppressDeprecationWarning
		            ? (foundWillUpdateName = "componentWillUpdate")
		            : "function" === typeof _instance.UNSAFE_componentWillUpdate &&
		              (foundWillUpdateName = "UNSAFE_componentWillUpdate");
		          if (null !== state || null !== lane || null !== foundWillUpdateName) {
		            _instance = getComponentNameFromType(Component) || "Component";
		            var newApiName =
		              "function" === typeof Component.getDerivedStateFromProps
		                ? "getDerivedStateFromProps()"
		                : "getSnapshotBeforeUpdate()";
		            didWarnAboutLegacyLifecyclesAndDerivedState.has(_instance) ||
		              (didWarnAboutLegacyLifecyclesAndDerivedState.add(_instance),
		              console.error(
		                "Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://react.dev/link/unsafe-component-lifecycles",
		                _instance,
		                newApiName,
		                null !== state ? "\n  " + state : "",
		                null !== lane ? "\n  " + lane : "",
		                null !== foundWillUpdateName ? "\n  " + foundWillUpdateName : ""
		              ));
		          }
		        }
		        _instance = workInProgress.stateNode;
		        state = getComponentNameFromType(Component) || "Component";
		        _instance.render ||
		          (Component.prototype &&
		          "function" === typeof Component.prototype.render
		            ? console.error(
		                "No `render` method found on the %s instance: did you accidentally return an object from the constructor?",
		                state
		              )
		            : console.error(
		                "No `render` method found on the %s instance: you may have forgotten to define `render`.",
		                state
		              ));
		        !_instance.getInitialState ||
		          _instance.getInitialState.isReactClassApproved ||
		          _instance.state ||
		          console.error(
		            "getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?",
		            state
		          );
		        _instance.getDefaultProps &&
		          !_instance.getDefaultProps.isReactClassApproved &&
		          console.error(
		            "getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.",
		            state
		          );
		        _instance.contextType &&
		          console.error(
		            "contextType was defined as an instance property on %s. Use a static property to define contextType instead.",
		            state
		          );
		        Component.childContextTypes &&
		          !didWarnAboutChildContextTypes.has(Component) &&
		          (didWarnAboutChildContextTypes.add(Component),
		          console.error(
		            "%s uses the legacy childContextTypes API which was removed in React 19. Use React.createContext() instead. (https://react.dev/link/legacy-context)",
		            state
		          ));
		        Component.contextTypes &&
		          !didWarnAboutContextTypes$1.has(Component) &&
		          (didWarnAboutContextTypes$1.add(Component),
		          console.error(
		            "%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with static contextType instead. (https://react.dev/link/legacy-context)",
		            state
		          ));
		        "function" === typeof _instance.componentShouldUpdate &&
		          console.error(
		            "%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.",
		            state
		          );
		        Component.prototype &&
		          Component.prototype.isPureReactComponent &&
		          "undefined" !== typeof _instance.shouldComponentUpdate &&
		          console.error(
		            "%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.",
		            getComponentNameFromType(Component) || "A pure component"
		          );
		        "function" === typeof _instance.componentDidUnmount &&
		          console.error(
		            "%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?",
		            state
		          );
		        "function" === typeof _instance.componentDidReceiveProps &&
		          console.error(
		            "%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().",
		            state
		          );
		        "function" === typeof _instance.componentWillRecieveProps &&
		          console.error(
		            "%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?",
		            state
		          );
		        "function" === typeof _instance.UNSAFE_componentWillRecieveProps &&
		          console.error(
		            "%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?",
		            state
		          );
		        lane = _instance.props !== nextProps;
		        void 0 !== _instance.props &&
		          lane &&
		          console.error(
		            "When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.",
		            state
		          );
		        _instance.defaultProps &&
		          console.error(
		            "Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.",
		            state,
		            state
		          );
		        "function" !== typeof _instance.getSnapshotBeforeUpdate ||
		          "function" === typeof _instance.componentDidUpdate ||
		          didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(Component) ||
		          (didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(Component),
		          console.error(
		            "%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.",
		            getComponentNameFromType(Component)
		          ));
		        "function" === typeof _instance.getDerivedStateFromProps &&
		          console.error(
		            "%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.",
		            state
		          );
		        "function" === typeof _instance.getDerivedStateFromError &&
		          console.error(
		            "%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.",
		            state
		          );
		        "function" === typeof Component.getSnapshotBeforeUpdate &&
		          console.error(
		            "%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.",
		            state
		          );
		        (lane = _instance.state) &&
		          ("object" !== typeof lane || isArrayImpl(lane)) &&
		          console.error("%s.state: must be set to an object or null", state);
		        "function" === typeof _instance.getChildContext &&
		          "object" !== typeof Component.childContextTypes &&
		          console.error(
		            "%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().",
		            state
		          );
		        _instance = workInProgress.stateNode;
		        _instance.props = nextProps;
		        _instance.state = workInProgress.memoizedState;
		        _instance.refs = {};
		        initializeUpdateQueue(workInProgress);
		        state = Component.contextType;
		        _instance.context =
		          "object" === typeof state && null !== state
		            ? readContext(state)
		            : emptyContextObject;
		        _instance.state === nextProps &&
		          ((state = getComponentNameFromType(Component) || "Component"),
		          didWarnAboutDirectlyAssigningPropsToState.has(state) ||
		            (didWarnAboutDirectlyAssigningPropsToState.add(state),
		            console.error(
		              "%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.",
		              state
		            )));
		        workInProgress.mode & 8 &&
		          ReactStrictModeWarnings.recordLegacyContextWarning(
		            workInProgress,
		            _instance
		          );
		        ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(
		          workInProgress,
		          _instance
		        );
		        _instance.state = workInProgress.memoizedState;
		        state = Component.getDerivedStateFromProps;
		        "function" === typeof state &&
		          (applyDerivedStateFromProps(
		            workInProgress,
		            Component,
		            state,
		            nextProps
		          ),
		          (_instance.state = workInProgress.memoizedState));
		        "function" === typeof Component.getDerivedStateFromProps ||
		          "function" === typeof _instance.getSnapshotBeforeUpdate ||
		          ("function" !== typeof _instance.UNSAFE_componentWillMount &&
		            "function" !== typeof _instance.componentWillMount) ||
		          ((state = _instance.state),
		          "function" === typeof _instance.componentWillMount &&
		            _instance.componentWillMount(),
		          "function" === typeof _instance.UNSAFE_componentWillMount &&
		            _instance.UNSAFE_componentWillMount(),
		          state !== _instance.state &&
		            (console.error(
		              "%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",
		              getComponentNameFromFiber(workInProgress) || "Component"
		            ),
		            classComponentUpdater.enqueueReplaceState(
		              _instance,
		              _instance.state,
		              null
		            )),
		          processUpdateQueue(workInProgress, nextProps, _instance, renderLanes),
		          suspendIfUpdateReadFromEntangledAsyncAction(),
		          (_instance.state = workInProgress.memoizedState));
		        "function" === typeof _instance.componentDidMount &&
		          (workInProgress.flags |= 4194308);
		        (workInProgress.mode & 16) !== NoMode &&
		          (workInProgress.flags |= 134217728);
		        _instance = true;
		      } else if (null === current) {
		        _instance = workInProgress.stateNode;
		        var unresolvedOldProps = workInProgress.memoizedProps;
		        lane = resolveClassComponentProps(Component, unresolvedOldProps);
		        _instance.props = lane;
		        var oldContext = _instance.context;
		        foundWillUpdateName = Component.contextType;
		        state = emptyContextObject;
		        "object" === typeof foundWillUpdateName &&
		          null !== foundWillUpdateName &&
		          (state = readContext(foundWillUpdateName));
		        newApiName = Component.getDerivedStateFromProps;
		        foundWillUpdateName =
		          "function" === typeof newApiName ||
		          "function" === typeof _instance.getSnapshotBeforeUpdate;
		        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
		        foundWillUpdateName ||
		          ("function" !== typeof _instance.UNSAFE_componentWillReceiveProps &&
		            "function" !== typeof _instance.componentWillReceiveProps) ||
		          ((unresolvedOldProps || oldContext !== state) &&
		            callComponentWillReceiveProps(
		              workInProgress,
		              _instance,
		              nextProps,
		              state
		            ));
		        hasForceUpdate = false;
		        var oldState = workInProgress.memoizedState;
		        _instance.state = oldState;
		        processUpdateQueue(workInProgress, nextProps, _instance, renderLanes);
		        suspendIfUpdateReadFromEntangledAsyncAction();
		        oldContext = workInProgress.memoizedState;
		        unresolvedOldProps || oldState !== oldContext || hasForceUpdate
		          ? ("function" === typeof newApiName &&
		              (applyDerivedStateFromProps(
		                workInProgress,
		                Component,
		                newApiName,
		                nextProps
		              ),
		              (oldContext = workInProgress.memoizedState)),
		            (lane =
		              hasForceUpdate ||
		              checkShouldComponentUpdate(
		                workInProgress,
		                Component,
		                lane,
		                nextProps,
		                oldState,
		                oldContext,
		                state
		              ))
		              ? (foundWillUpdateName ||
		                  ("function" !== typeof _instance.UNSAFE_componentWillMount &&
		                    "function" !== typeof _instance.componentWillMount) ||
		                  ("function" === typeof _instance.componentWillMount &&
		                    _instance.componentWillMount(),
		                  "function" === typeof _instance.UNSAFE_componentWillMount &&
		                    _instance.UNSAFE_componentWillMount()),
		                "function" === typeof _instance.componentDidMount &&
		                  (workInProgress.flags |= 4194308),
		                (workInProgress.mode & 16) !== NoMode &&
		                  (workInProgress.flags |= 134217728))
		              : ("function" === typeof _instance.componentDidMount &&
		                  (workInProgress.flags |= 4194308),
		                (workInProgress.mode & 16) !== NoMode &&
		                  (workInProgress.flags |= 134217728),
		                (workInProgress.memoizedProps = nextProps),
		                (workInProgress.memoizedState = oldContext)),
		            (_instance.props = nextProps),
		            (_instance.state = oldContext),
		            (_instance.context = state),
		            (_instance = lane))
		          : ("function" === typeof _instance.componentDidMount &&
		              (workInProgress.flags |= 4194308),
		            (workInProgress.mode & 16) !== NoMode &&
		              (workInProgress.flags |= 134217728),
		            (_instance = false));
		      } else {
		        _instance = workInProgress.stateNode;
		        cloneUpdateQueue(current, workInProgress);
		        state = workInProgress.memoizedProps;
		        foundWillUpdateName = resolveClassComponentProps(Component, state);
		        _instance.props = foundWillUpdateName;
		        newApiName = workInProgress.pendingProps;
		        oldState = _instance.context;
		        oldContext = Component.contextType;
		        lane = emptyContextObject;
		        "object" === typeof oldContext &&
		          null !== oldContext &&
		          (lane = readContext(oldContext));
		        unresolvedOldProps = Component.getDerivedStateFromProps;
		        (oldContext =
		          "function" === typeof unresolvedOldProps ||
		          "function" === typeof _instance.getSnapshotBeforeUpdate) ||
		          ("function" !== typeof _instance.UNSAFE_componentWillReceiveProps &&
		            "function" !== typeof _instance.componentWillReceiveProps) ||
		          ((state !== newApiName || oldState !== lane) &&
		            callComponentWillReceiveProps(
		              workInProgress,
		              _instance,
		              nextProps,
		              lane
		            ));
		        hasForceUpdate = false;
		        oldState = workInProgress.memoizedState;
		        _instance.state = oldState;
		        processUpdateQueue(workInProgress, nextProps, _instance, renderLanes);
		        suspendIfUpdateReadFromEntangledAsyncAction();
		        var newState = workInProgress.memoizedState;
		        state !== newApiName ||
		        oldState !== newState ||
		        hasForceUpdate ||
		        (null !== current &&
		          null !== current.dependencies &&
		          checkIfContextChanged(current.dependencies))
		          ? ("function" === typeof unresolvedOldProps &&
		              (applyDerivedStateFromProps(
		                workInProgress,
		                Component,
		                unresolvedOldProps,
		                nextProps
		              ),
		              (newState = workInProgress.memoizedState)),
		            (foundWillUpdateName =
		              hasForceUpdate ||
		              checkShouldComponentUpdate(
		                workInProgress,
		                Component,
		                foundWillUpdateName,
		                nextProps,
		                oldState,
		                newState,
		                lane
		              ) ||
		              (null !== current &&
		                null !== current.dependencies &&
		                checkIfContextChanged(current.dependencies)))
		              ? (oldContext ||
		                  ("function" !== typeof _instance.UNSAFE_componentWillUpdate &&
		                    "function" !== typeof _instance.componentWillUpdate) ||
		                  ("function" === typeof _instance.componentWillUpdate &&
		                    _instance.componentWillUpdate(nextProps, newState, lane),
		                  "function" === typeof _instance.UNSAFE_componentWillUpdate &&
		                    _instance.UNSAFE_componentWillUpdate(
		                      nextProps,
		                      newState,
		                      lane
		                    )),
		                "function" === typeof _instance.componentDidUpdate &&
		                  (workInProgress.flags |= 4),
		                "function" === typeof _instance.getSnapshotBeforeUpdate &&
		                  (workInProgress.flags |= 1024))
		              : ("function" !== typeof _instance.componentDidUpdate ||
		                  (state === current.memoizedProps &&
		                    oldState === current.memoizedState) ||
		                  (workInProgress.flags |= 4),
		                "function" !== typeof _instance.getSnapshotBeforeUpdate ||
		                  (state === current.memoizedProps &&
		                    oldState === current.memoizedState) ||
		                  (workInProgress.flags |= 1024),
		                (workInProgress.memoizedProps = nextProps),
		                (workInProgress.memoizedState = newState)),
		            (_instance.props = nextProps),
		            (_instance.state = newState),
		            (_instance.context = lane),
		            (_instance = foundWillUpdateName))
		          : ("function" !== typeof _instance.componentDidUpdate ||
		              (state === current.memoizedProps &&
		                oldState === current.memoizedState) ||
		              (workInProgress.flags |= 4),
		            "function" !== typeof _instance.getSnapshotBeforeUpdate ||
		              (state === current.memoizedProps &&
		                oldState === current.memoizedState) ||
		              (workInProgress.flags |= 1024),
		            (_instance = false));
		      }
		      lane = _instance;
		      markRef(current, workInProgress);
		      state = 0 !== (workInProgress.flags & 128);
		      if (lane || state) {
		        lane = workInProgress.stateNode;
		        setCurrentFiber(workInProgress);
		        if (state && "function" !== typeof Component.getDerivedStateFromError)
		          (Component = null), (profilerStartTime = -1);
		        else if (
		          ((Component = callRenderInDEV(lane)), workInProgress.mode & 8)
		        ) {
		          setIsStrictModeForDevtools(true);
		          try {
		            callRenderInDEV(lane);
		          } finally {
		            setIsStrictModeForDevtools(false);
		          }
		        }
		        workInProgress.flags |= 1;
		        null !== current && state
		          ? ((workInProgress.child = reconcileChildFibers(
		              workInProgress,
		              current.child,
		              null,
		              renderLanes
		            )),
		            (workInProgress.child = reconcileChildFibers(
		              workInProgress,
		              null,
		              Component,
		              renderLanes
		            )))
		          : reconcileChildren(current, workInProgress, Component, renderLanes);
		        workInProgress.memoizedState = lane.state;
		        current = workInProgress.child;
		      } else
		        current = bailoutOnAlreadyFinishedWork(
		          current,
		          workInProgress,
		          renderLanes
		        );
		      renderLanes = workInProgress.stateNode;
		      _instance &&
		        renderLanes.props !== nextProps &&
		        (didWarnAboutReassigningProps ||
		          console.error(
		            "It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.",
		            getComponentNameFromFiber(workInProgress) || "a component"
		          ),
		        (didWarnAboutReassigningProps = true));
		      return current;
		    }
		    function mountHostRootWithoutHydrating(
		      current,
		      workInProgress,
		      nextChildren,
		      renderLanes
		    ) {
		      resetHydrationState();
		      workInProgress.flags |= 256;
		      reconcileChildren(current, workInProgress, nextChildren, renderLanes);
		      return workInProgress.child;
		    }
		    function validateFunctionComponentInDev(workInProgress, Component) {
		      Component &&
		        Component.childContextTypes &&
		        console.error(
		          "childContextTypes cannot be defined on a function component.\n  %s.childContextTypes = ...",
		          Component.displayName || Component.name || "Component"
		        );
		      "function" === typeof Component.getDerivedStateFromProps &&
		        ((workInProgress = getComponentNameFromType(Component) || "Unknown"),
		        didWarnAboutGetDerivedStateOnFunctionComponent[workInProgress] ||
		          (console.error(
		            "%s: Function components do not support getDerivedStateFromProps.",
		            workInProgress
		          ),
		          (didWarnAboutGetDerivedStateOnFunctionComponent[workInProgress] =
		            true)));
		      "object" === typeof Component.contextType &&
		        null !== Component.contextType &&
		        ((Component = getComponentNameFromType(Component) || "Unknown"),
		        didWarnAboutContextTypeOnFunctionComponent[Component] ||
		          (console.error(
		            "%s: Function components do not support contextType.",
		            Component
		          ),
		          (didWarnAboutContextTypeOnFunctionComponent[Component] = true)));
		    }
		    function mountSuspenseOffscreenState(renderLanes) {
		      return { baseLanes: renderLanes, cachePool: getSuspendedCache() };
		    }
		    function getRemainingWorkInPrimaryTree(
		      current,
		      primaryTreeDidDefer,
		      renderLanes
		    ) {
		      current = null !== current ? current.childLanes & ~renderLanes : 0;
		      primaryTreeDidDefer && (current |= workInProgressDeferredLane);
		      return current;
		    }
		    function updateSuspenseComponent(current, workInProgress, renderLanes) {
		      var nextProps = workInProgress.pendingProps;
		      shouldSuspendImpl(workInProgress) && (workInProgress.flags |= 128);
		      var showFallback = false,
		        didSuspend = 0 !== (workInProgress.flags & 128),
		        JSCompiler_temp;
		      (JSCompiler_temp = didSuspend) ||
		        (JSCompiler_temp =
		          null !== current && null === current.memoizedState
		            ? false
		            : 0 !== (suspenseStackCursor.current & ForceSuspenseFallback));
		      JSCompiler_temp && ((showFallback = true), (workInProgress.flags &= -129));
		      JSCompiler_temp = 0 !== (workInProgress.flags & 32);
		      workInProgress.flags &= -33;
		      if (null === current) {
		        if (isHydrating) {
		          showFallback
		            ? pushPrimaryTreeSuspenseHandler(workInProgress)
		            : reuseSuspenseHandlerOnStack(workInProgress);
		          (current = nextHydratableInstance)
		            ? ((renderLanes = canHydrateSuspenseInstance(
		                current,
		                rootOrSingletonContext
		              )),
		              null !== renderLanes &&
		                ((JSCompiler_temp = {
		                  dehydrated: renderLanes,
		                  treeContext: getSuspendedTreeContext(),
		                  retryLane: 536870912,
		                  hydrationErrors: null
		                }),
		                (workInProgress.memoizedState = JSCompiler_temp),
		                (JSCompiler_temp =
		                  createFiberFromDehydratedFragment(renderLanes)),
		                (JSCompiler_temp.return = workInProgress),
		                (workInProgress.child = JSCompiler_temp),
		                (hydrationParentFiber = workInProgress),
		                (nextHydratableInstance = null)))
		            : (renderLanes = null);
		          if (null === renderLanes)
		            throw (
		              (warnNonHydratedInstance(workInProgress, current),
		              throwOnHydrationMismatch(workInProgress))
		            );
		          isSuspenseInstanceFallback(renderLanes)
		            ? (workInProgress.lanes = 32)
		            : (workInProgress.lanes = 536870912);
		          return null;
		        }
		        var nextPrimaryChildren = nextProps.children;
		        nextProps = nextProps.fallback;
		        if (showFallback)
		          return (
		            reuseSuspenseHandlerOnStack(workInProgress),
		            (showFallback = workInProgress.mode),
		            (nextPrimaryChildren = mountWorkInProgressOffscreenFiber(
		              { mode: "hidden", children: nextPrimaryChildren },
		              showFallback
		            )),
		            (nextProps = createFiberFromFragment(
		              nextProps,
		              showFallback,
		              renderLanes,
		              null
		            )),
		            (nextPrimaryChildren.return = workInProgress),
		            (nextProps.return = workInProgress),
		            (nextPrimaryChildren.sibling = nextProps),
		            (workInProgress.child = nextPrimaryChildren),
		            (nextProps = workInProgress.child),
		            (nextProps.memoizedState =
		              mountSuspenseOffscreenState(renderLanes)),
		            (nextProps.childLanes = getRemainingWorkInPrimaryTree(
		              current,
		              JSCompiler_temp,
		              renderLanes
		            )),
		            (workInProgress.memoizedState = SUSPENDED_MARKER),
		            bailoutOffscreenComponent(null, nextProps)
		          );
		        pushPrimaryTreeSuspenseHandler(workInProgress);
		        return mountSuspensePrimaryChildren(
		          workInProgress,
		          nextPrimaryChildren
		        );
		      }
		      var prevState = current.memoizedState;
		      if (
		        null !== prevState &&
		        ((nextPrimaryChildren = prevState.dehydrated),
		        null !== nextPrimaryChildren)
		      ) {
		        if (didSuspend)
		          workInProgress.flags & 256
		            ? (pushPrimaryTreeSuspenseHandler(workInProgress),
		              (workInProgress.flags &= -257),
		              (workInProgress = retrySuspenseComponentWithoutHydrating(
		                current,
		                workInProgress,
		                renderLanes
		              )))
		            : null !== workInProgress.memoizedState
		              ? (reuseSuspenseHandlerOnStack(workInProgress),
		                (workInProgress.child = current.child),
		                (workInProgress.flags |= 128),
		                (workInProgress = null))
		              : (reuseSuspenseHandlerOnStack(workInProgress),
		                (nextPrimaryChildren = nextProps.fallback),
		                (showFallback = workInProgress.mode),
		                (nextProps = mountWorkInProgressOffscreenFiber(
		                  { mode: "visible", children: nextProps.children },
		                  showFallback
		                )),
		                (nextPrimaryChildren = createFiberFromFragment(
		                  nextPrimaryChildren,
		                  showFallback,
		                  renderLanes,
		                  null
		                )),
		                (nextPrimaryChildren.flags |= 2),
		                (nextProps.return = workInProgress),
		                (nextPrimaryChildren.return = workInProgress),
		                (nextProps.sibling = nextPrimaryChildren),
		                (workInProgress.child = nextProps),
		                reconcileChildFibers(
		                  workInProgress,
		                  current.child,
		                  null,
		                  renderLanes
		                ),
		                (nextProps = workInProgress.child),
		                (nextProps.memoizedState =
		                  mountSuspenseOffscreenState(renderLanes)),
		                (nextProps.childLanes = getRemainingWorkInPrimaryTree(
		                  current,
		                  JSCompiler_temp,
		                  renderLanes
		                )),
		                (workInProgress.memoizedState = SUSPENDED_MARKER),
		                (workInProgress = bailoutOffscreenComponent(null, nextProps)));
		        else if (
		          (pushPrimaryTreeSuspenseHandler(workInProgress),
		          warnIfHydrating(),
		          0 !== (renderLanes & 536870912) &&
		            markRenderDerivedCause(workInProgress),
		          isSuspenseInstanceFallback(nextPrimaryChildren))
		        )
		          (showFallback =
		            getSuspenseInstanceFallbackErrorDetails(nextPrimaryChildren)),
		            (JSCompiler_temp = showFallback.digest),
		            (nextPrimaryChildren = showFallback.message),
		            (nextProps = showFallback.stack),
		            (showFallback = showFallback.componentStack),
		            (nextPrimaryChildren = nextPrimaryChildren
		              ? Error(nextPrimaryChildren)
		              : Error(
		                  "The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering."
		                )),
		            (nextPrimaryChildren.stack = nextProps || ""),
		            (nextPrimaryChildren.digest = JSCompiler_temp),
		            (JSCompiler_temp = void 0 === showFallback ? null : showFallback),
		            (nextProps = {
		              value: nextPrimaryChildren,
		              source: null,
		              stack: JSCompiler_temp
		            }),
		            "string" === typeof JSCompiler_temp &&
		              CapturedStacks.set(nextPrimaryChildren, nextProps),
		            queueHydrationError(nextProps),
		            (workInProgress = retrySuspenseComponentWithoutHydrating(
		              current,
		              workInProgress,
		              renderLanes
		            ));
		        else if (
		          (didReceiveUpdate ||
		            propagateParentContextChanges(
		              current,
		              workInProgress,
		              renderLanes,
		              false
		            ),
		          (JSCompiler_temp = 0 !== (renderLanes & current.childLanes)),
		          didReceiveUpdate || JSCompiler_temp)
		        ) {
		          JSCompiler_temp = workInProgressRoot;
		          if (
		            null !== JSCompiler_temp &&
		            ((nextProps = getBumpedLaneForHydration(
		              JSCompiler_temp,
		              renderLanes
		            )),
		            0 !== nextProps && nextProps !== prevState.retryLane)
		          )
		            throw (
		              ((prevState.retryLane = nextProps),
		              enqueueConcurrentRenderForLane(current, nextProps),
		              scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps),
		              SelectiveHydrationException)
		            );
		          isSuspenseInstancePending(nextPrimaryChildren) ||
		            renderDidSuspendDelayIfPossible();
		          workInProgress = retrySuspenseComponentWithoutHydrating(
		            current,
		            workInProgress,
		            renderLanes
		          );
		        } else
		          isSuspenseInstancePending(nextPrimaryChildren)
		            ? ((workInProgress.flags |= 192),
		              (workInProgress.child = current.child),
		              (workInProgress = null))
		            : ((current = prevState.treeContext),
		              supportsHydration &&
		                ((nextHydratableInstance =
		                  getFirstHydratableChildWithinSuspenseInstance(
		                    nextPrimaryChildren
		                  )),
		                (hydrationParentFiber = workInProgress),
		                (isHydrating = true),
		                (hydrationErrors = null),
		                (didSuspendOrErrorDEV = false),
		                (hydrationDiffRootDEV = null),
		                (rootOrSingletonContext = false),
		                null !== current &&
		                  restoreSuspendedTreeContext(workInProgress, current)),
		              (workInProgress = mountSuspensePrimaryChildren(
		                workInProgress,
		                nextProps.children
		              )),
		              (workInProgress.flags |= 4096));
		        return workInProgress;
		      }
		      if (showFallback)
		        return (
		          reuseSuspenseHandlerOnStack(workInProgress),
		          (nextPrimaryChildren = nextProps.fallback),
		          (showFallback = workInProgress.mode),
		          (prevState = current.child),
		          (didSuspend = prevState.sibling),
		          (nextProps = createWorkInProgress(prevState, {
		            mode: "hidden",
		            children: nextProps.children
		          })),
		          (nextProps.subtreeFlags = prevState.subtreeFlags & 65011712),
		          null !== didSuspend
		            ? (nextPrimaryChildren = createWorkInProgress(
		                didSuspend,
		                nextPrimaryChildren
		              ))
		            : ((nextPrimaryChildren = createFiberFromFragment(
		                nextPrimaryChildren,
		                showFallback,
		                renderLanes,
		                null
		              )),
		              (nextPrimaryChildren.flags |= 2)),
		          (nextPrimaryChildren.return = workInProgress),
		          (nextProps.return = workInProgress),
		          (nextProps.sibling = nextPrimaryChildren),
		          (workInProgress.child = nextProps),
		          bailoutOffscreenComponent(null, nextProps),
		          (nextProps = workInProgress.child),
		          (nextPrimaryChildren = current.child.memoizedState),
		          null === nextPrimaryChildren
		            ? (nextPrimaryChildren = mountSuspenseOffscreenState(renderLanes))
		            : ((showFallback = nextPrimaryChildren.cachePool),
		              null !== showFallback
		                ? ((prevState = isPrimaryRenderer
		                    ? CacheContext._currentValue
		                    : CacheContext._currentValue2),
		                  (showFallback =
		                    showFallback.parent !== prevState
		                      ? { parent: prevState, pool: prevState }
		                      : showFallback))
		                : (showFallback = getSuspendedCache()),
		              (nextPrimaryChildren = {
		                baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
		                cachePool: showFallback
		              })),
		          (nextProps.memoizedState = nextPrimaryChildren),
		          (nextProps.childLanes = getRemainingWorkInPrimaryTree(
		            current,
		            JSCompiler_temp,
		            renderLanes
		          )),
		          (workInProgress.memoizedState = SUSPENDED_MARKER),
		          bailoutOffscreenComponent(current.child, nextProps)
		        );
		      null !== prevState &&
		        (renderLanes & 62914560) === renderLanes &&
		        0 !== (renderLanes & current.lanes) &&
		        markRenderDerivedCause(workInProgress);
		      pushPrimaryTreeSuspenseHandler(workInProgress);
		      renderLanes = current.child;
		      current = renderLanes.sibling;
		      renderLanes = createWorkInProgress(renderLanes, {
		        mode: "visible",
		        children: nextProps.children
		      });
		      renderLanes.return = workInProgress;
		      renderLanes.sibling = null;
		      null !== current &&
		        ((JSCompiler_temp = workInProgress.deletions),
		        null === JSCompiler_temp
		          ? ((workInProgress.deletions = [current]),
		            (workInProgress.flags |= 16))
		          : JSCompiler_temp.push(current));
		      workInProgress.child = renderLanes;
		      workInProgress.memoizedState = null;
		      return renderLanes;
		    }
		    function mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
		      primaryChildren = mountWorkInProgressOffscreenFiber(
		        { mode: "visible", children: primaryChildren },
		        workInProgress.mode
		      );
		      primaryChildren.return = workInProgress;
		      return (workInProgress.child = primaryChildren);
		    }
		    function mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
		      offscreenProps = createFiber(22, offscreenProps, null, mode);
		      offscreenProps.lanes = 0;
		      return offscreenProps;
		    }
		    function retrySuspenseComponentWithoutHydrating(
		      current,
		      workInProgress,
		      renderLanes
		    ) {
		      reconcileChildFibers(workInProgress, current.child, null, renderLanes);
		      current = mountSuspensePrimaryChildren(
		        workInProgress,
		        workInProgress.pendingProps.children
		      );
		      current.flags |= 2;
		      workInProgress.memoizedState = null;
		      return current;
		    }
		    function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
		      fiber.lanes |= renderLanes;
		      var alternate = fiber.alternate;
		      null !== alternate && (alternate.lanes |= renderLanes);
		      scheduleContextWorkOnParentPath(
		        fiber.return,
		        renderLanes,
		        propagationRoot
		      );
		    }
		    function initSuspenseListRenderState(
		      workInProgress,
		      isBackwards,
		      tail,
		      lastContentRow,
		      tailMode,
		      treeForkCount
		    ) {
		      var renderState = workInProgress.memoizedState;
		      null === renderState
		        ? (workInProgress.memoizedState = {
		            isBackwards: isBackwards,
		            rendering: null,
		            renderingStartTime: 0,
		            last: lastContentRow,
		            tail: tail,
		            tailMode: tailMode,
		            treeForkCount: treeForkCount
		          })
		        : ((renderState.isBackwards = isBackwards),
		          (renderState.rendering = null),
		          (renderState.renderingStartTime = 0),
		          (renderState.last = lastContentRow),
		          (renderState.tail = tail),
		          (renderState.tailMode = tailMode),
		          (renderState.treeForkCount = treeForkCount));
		    }
		    function updateSuspenseListComponent(current, workInProgress, renderLanes) {
		      var nextProps = workInProgress.pendingProps,
		        revealOrder = nextProps.revealOrder,
		        tailMode = nextProps.tail,
		        newChildren = nextProps.children,
		        suspenseContext = suspenseStackCursor.current;
		      (nextProps = 0 !== (suspenseContext & ForceSuspenseFallback))
		        ? ((suspenseContext =
		            (suspenseContext & SubtreeSuspenseContextMask) |
		            ForceSuspenseFallback),
		          (workInProgress.flags |= 128))
		        : (suspenseContext &= SubtreeSuspenseContextMask);
		      push(suspenseStackCursor, suspenseContext, workInProgress);
		      suspenseContext = null == revealOrder ? "null" : revealOrder;
		      if (
		        "forwards" !== revealOrder &&
		        "unstable_legacy-backwards" !== revealOrder &&
		        "together" !== revealOrder &&
		        "independent" !== revealOrder &&
		        !didWarnAboutRevealOrder[suspenseContext]
		      )
		        if (
		          ((didWarnAboutRevealOrder[suspenseContext] = true), null == revealOrder)
		        )
		          console.error(
		            'The default for the <SuspenseList revealOrder="..."> prop is changing. To be future compatible you must explictly specify either "independent" (the current default), "together", "forwards" or "legacy_unstable-backwards".'
		          );
		        else if ("backwards" === revealOrder)
		          console.error(
		            'The rendering order of <SuspenseList revealOrder="backwards"> is changing. To be future compatible you must specify revealOrder="legacy_unstable-backwards" instead.'
		          );
		        else if ("string" === typeof revealOrder)
		          switch (revealOrder.toLowerCase()) {
		            case "together":
		            case "forwards":
		            case "backwards":
		            case "independent":
		              console.error(
		                '"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.',
		                revealOrder,
		                revealOrder.toLowerCase()
		              );
		              break;
		            case "forward":
		            case "backward":
		              console.error(
		                '"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.',
		                revealOrder,
		                revealOrder.toLowerCase()
		              );
		              break;
		            default:
		              console.error(
		                '"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "independent", "together", "forwards" or "backwards"?',
		                revealOrder
		              );
		          }
		        else
		          console.error(
		            '%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "independent", "together", "forwards" or "backwards"?',
		            revealOrder
		          );
		      suspenseContext = null == tailMode ? "null" : tailMode;
		      if (!didWarnAboutTailOptions[suspenseContext])
		        if (null == tailMode) {
		          if (
		            "forwards" === revealOrder ||
		            "backwards" === revealOrder ||
		            "unstable_legacy-backwards" === revealOrder
		          )
		            (didWarnAboutTailOptions[suspenseContext] = true),
		              console.error(
		                'The default for the <SuspenseList tail="..."> prop is changing. To be future compatible you must explictly specify either "visible" (the current default), "collapsed" or "hidden".'
		              );
		        } else
		          "visible" !== tailMode &&
		          "collapsed" !== tailMode &&
		          "hidden" !== tailMode
		            ? ((didWarnAboutTailOptions[suspenseContext] = true),
		              console.error(
		                '"%s" is not a supported value for tail on <SuspenseList />. Did you mean "visible", "collapsed" or "hidden"?',
		                tailMode
		              ))
		            : "forwards" !== revealOrder &&
		              "backwards" !== revealOrder &&
		              "unstable_legacy-backwards" !== revealOrder &&
		              ((didWarnAboutTailOptions[suspenseContext] = true),
		              console.error(
		                '<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?',
		                tailMode
		              ));
		      a: if (
		        ("forwards" === revealOrder ||
		          "backwards" === revealOrder ||
		          "unstable_legacy-backwards" === revealOrder) &&
		        void 0 !== newChildren &&
		        null !== newChildren &&
		        false !== newChildren
		      )
		        if (isArrayImpl(newChildren))
		          for (
		            suspenseContext = 0;
		            suspenseContext < newChildren.length;
		            suspenseContext++
		          ) {
		            if (
		              !validateSuspenseListNestedChild(
		                newChildren[suspenseContext],
		                suspenseContext
		              )
		            )
		              break a;
		          }
		        else if (
		          ((suspenseContext = getIteratorFn(newChildren)),
		          "function" === typeof suspenseContext)
		        ) {
		          if ((suspenseContext = suspenseContext.call(newChildren)))
		            for (
		              var step = suspenseContext.next(), _i = 0;
		              !step.done;
		              step = suspenseContext.next()
		            ) {
		              if (!validateSuspenseListNestedChild(step.value, _i)) break a;
		              _i++;
		            }
		        } else
		          console.error(
		            'A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?',
		            revealOrder
		          );
		      reconcileChildren(current, workInProgress, newChildren, renderLanes);
		      isHydrating
		        ? (warnIfNotHydrating(), (newChildren = treeForkCount))
		        : (newChildren = 0);
		      if (!nextProps && null !== current && 0 !== (current.flags & 128))
		        a: for (current = workInProgress.child; null !== current; ) {
		          if (13 === current.tag)
		            null !== current.memoizedState &&
		              scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
		          else if (19 === current.tag)
		            scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
		          else if (null !== current.child) {
		            current.child.return = current;
		            current = current.child;
		            continue;
		          }
		          if (current === workInProgress) break a;
		          for (; null === current.sibling; ) {
		            if (null === current.return || current.return === workInProgress)
		              break a;
		            current = current.return;
		          }
		          current.sibling.return = current.return;
		          current = current.sibling;
		        }
		      switch (revealOrder) {
		        case "forwards":
		          renderLanes = workInProgress.child;
		          for (revealOrder = null; null !== renderLanes; )
		            (current = renderLanes.alternate),
		              null !== current &&
		                null === findFirstSuspended(current) &&
		                (revealOrder = renderLanes),
		              (renderLanes = renderLanes.sibling);
		          renderLanes = revealOrder;
		          null === renderLanes
		            ? ((revealOrder = workInProgress.child),
		              (workInProgress.child = null))
		            : ((revealOrder = renderLanes.sibling),
		              (renderLanes.sibling = null));
		          initSuspenseListRenderState(
		            workInProgress,
		            false,
		            revealOrder,
		            renderLanes,
		            tailMode,
		            newChildren
		          );
		          break;
		        case "backwards":
		        case "unstable_legacy-backwards":
		          renderLanes = null;
		          revealOrder = workInProgress.child;
		          for (workInProgress.child = null; null !== revealOrder; ) {
		            current = revealOrder.alternate;
		            if (null !== current && null === findFirstSuspended(current)) {
		              workInProgress.child = revealOrder;
		              break;
		            }
		            current = revealOrder.sibling;
		            revealOrder.sibling = renderLanes;
		            renderLanes = revealOrder;
		            revealOrder = current;
		          }
		          initSuspenseListRenderState(
		            workInProgress,
		            true,
		            renderLanes,
		            null,
		            tailMode,
		            newChildren
		          );
		          break;
		        case "together":
		          initSuspenseListRenderState(
		            workInProgress,
		            false,
		            null,
		            null,
		            void 0,
		            newChildren
		          );
		          break;
		        default:
		          workInProgress.memoizedState = null;
		      }
		      return workInProgress.child;
		    }
		    function bailoutOnAlreadyFinishedWork(
		      current,
		      workInProgress,
		      renderLanes
		    ) {
		      null !== current && (workInProgress.dependencies = current.dependencies);
		      profilerStartTime = -1;
		      workInProgressRootSkippedLanes |= workInProgress.lanes;
		      if (0 === (renderLanes & workInProgress.childLanes))
		        if (null !== current) {
		          if (
		            (propagateParentContextChanges(
		              current,
		              workInProgress,
		              renderLanes,
		              false
		            ),
		            0 === (renderLanes & workInProgress.childLanes))
		          )
		            return null;
		        } else return null;
		      if (null !== current && workInProgress.child !== current.child)
		        throw Error("Resuming work not yet implemented.");
		      if (null !== workInProgress.child) {
		        current = workInProgress.child;
		        renderLanes = createWorkInProgress(current, current.pendingProps);
		        workInProgress.child = renderLanes;
		        for (renderLanes.return = workInProgress; null !== current.sibling; )
		          (current = current.sibling),
		            (renderLanes = renderLanes.sibling =
		              createWorkInProgress(current, current.pendingProps)),
		            (renderLanes.return = workInProgress);
		        renderLanes.sibling = null;
		      }
		      return workInProgress.child;
		    }
		    function checkScheduledUpdateOrContext(current, renderLanes) {
		      if (0 !== (current.lanes & renderLanes)) return true;
		      current = current.dependencies;
		      return null !== current && checkIfContextChanged(current) ? true : false;
		    }
		    function attemptEarlyBailoutIfNoScheduledUpdate(
		      current,
		      workInProgress,
		      renderLanes
		    ) {
		      switch (workInProgress.tag) {
		        case 3:
		          pushHostContainer(
		            workInProgress,
		            workInProgress.stateNode.containerInfo
		          );
		          pushProvider(
		            workInProgress,
		            CacheContext,
		            current.memoizedState.cache
		          );
		          resetHydrationState();
		          break;
		        case 27:
		        case 5:
		          pushHostContext(workInProgress);
		          break;
		        case 4:
		          pushHostContainer(
		            workInProgress,
		            workInProgress.stateNode.containerInfo
		          );
		          break;
		        case 10:
		          pushProvider(
		            workInProgress,
		            workInProgress.type,
		            workInProgress.memoizedProps.value
		          );
		          break;
		        case 12:
		          0 !== (renderLanes & workInProgress.childLanes) &&
		            (workInProgress.flags |= 4);
		          workInProgress.flags |= 2048;
		          var stateNode = workInProgress.stateNode;
		          stateNode.effectDuration = -0;
		          stateNode.passiveEffectDuration = -0;
		          break;
		        case 31:
		          if (null !== workInProgress.memoizedState)
		            return (
		              (workInProgress.flags |= 128),
		              pushDehydratedActivitySuspenseHandler(workInProgress),
		              null
		            );
		          break;
		        case 13:
		          stateNode = workInProgress.memoizedState;
		          if (null !== stateNode) {
		            if (null !== stateNode.dehydrated)
		              return (
		                pushPrimaryTreeSuspenseHandler(workInProgress),
		                (workInProgress.flags |= 128),
		                null
		              );
		            if (0 !== (renderLanes & workInProgress.child.childLanes))
		              return updateSuspenseComponent(
		                current,
		                workInProgress,
		                renderLanes
		              );
		            pushPrimaryTreeSuspenseHandler(workInProgress);
		            current = bailoutOnAlreadyFinishedWork(
		              current,
		              workInProgress,
		              renderLanes
		            );
		            return null !== current ? current.sibling : null;
		          }
		          pushPrimaryTreeSuspenseHandler(workInProgress);
		          break;
		        case 19:
		          var didSuspendBefore = 0 !== (current.flags & 128);
		          stateNode = 0 !== (renderLanes & workInProgress.childLanes);
		          stateNode ||
		            (propagateParentContextChanges(
		              current,
		              workInProgress,
		              renderLanes,
		              false
		            ),
		            (stateNode = 0 !== (renderLanes & workInProgress.childLanes)));
		          if (didSuspendBefore) {
		            if (stateNode)
		              return updateSuspenseListComponent(
		                current,
		                workInProgress,
		                renderLanes
		              );
		            workInProgress.flags |= 128;
		          }
		          didSuspendBefore = workInProgress.memoizedState;
		          null !== didSuspendBefore &&
		            ((didSuspendBefore.rendering = null),
		            (didSuspendBefore.tail = null),
		            (didSuspendBefore.lastEffect = null));
		          push(
		            suspenseStackCursor,
		            suspenseStackCursor.current,
		            workInProgress
		          );
		          if (stateNode) break;
		          else return null;
		        case 22:
		          return (
		            (workInProgress.lanes = 0),
		            updateOffscreenComponent(
		              current,
		              workInProgress,
		              renderLanes,
		              workInProgress.pendingProps
		            )
		          );
		        case 24:
		          pushProvider(
		            workInProgress,
		            CacheContext,
		            current.memoizedState.cache
		          );
		      }
		      return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
		    }
		    function beginWork(current, workInProgress, renderLanes) {
		      if (workInProgress._debugNeedsRemount && null !== current) {
		        renderLanes = createFiberFromTypeAndProps(
		          workInProgress.type,
		          workInProgress.key,
		          workInProgress.pendingProps,
		          workInProgress._debugOwner || null,
		          workInProgress.mode,
		          workInProgress.lanes
		        );
		        renderLanes._debugStack = workInProgress._debugStack;
		        renderLanes._debugTask = workInProgress._debugTask;
		        var returnFiber = workInProgress.return;
		        if (null === returnFiber) throw Error("Cannot swap the root fiber.");
		        current.alternate = null;
		        workInProgress.alternate = null;
		        renderLanes.index = workInProgress.index;
		        renderLanes.sibling = workInProgress.sibling;
		        renderLanes.return = workInProgress.return;
		        renderLanes.ref = workInProgress.ref;
		        renderLanes._debugInfo = workInProgress._debugInfo;
		        if (workInProgress === returnFiber.child)
		          returnFiber.child = renderLanes;
		        else {
		          var prevSibling = returnFiber.child;
		          if (null === prevSibling)
		            throw Error("Expected parent to have a child.");
		          for (; prevSibling.sibling !== workInProgress; )
		            if (((prevSibling = prevSibling.sibling), null === prevSibling))
		              throw Error("Expected to find the previous sibling.");
		          prevSibling.sibling = renderLanes;
		        }
		        workInProgress = returnFiber.deletions;
		        null === workInProgress
		          ? ((returnFiber.deletions = [current]), (returnFiber.flags |= 16))
		          : workInProgress.push(current);
		        renderLanes.flags |= 2;
		        return renderLanes;
		      }
		      if (null !== current)
		        if (
		          current.memoizedProps !== workInProgress.pendingProps ||
		          workInProgress.type !== current.type
		        )
		          didReceiveUpdate = true;
		        else {
		          if (
		            !checkScheduledUpdateOrContext(current, renderLanes) &&
		            0 === (workInProgress.flags & 128)
		          )
		            return (
		              (didReceiveUpdate = false),
		              attemptEarlyBailoutIfNoScheduledUpdate(
		                current,
		                workInProgress,
		                renderLanes
		              )
		            );
		          didReceiveUpdate = 0 !== (current.flags & 131072) ? true : false;
		        }
		      else {
		        didReceiveUpdate = false;
		        if ((returnFiber = isHydrating))
		          warnIfNotHydrating(),
		            (returnFiber = 0 !== (workInProgress.flags & 1048576));
		        returnFiber &&
		          ((returnFiber = workInProgress.index),
		          warnIfNotHydrating(),
		          pushTreeId(workInProgress, treeForkCount, returnFiber));
		      }
		      workInProgress.lanes = 0;
		      switch (workInProgress.tag) {
		        case 16:
		          a: if (
		            ((returnFiber = workInProgress.pendingProps),
		            (current = resolveLazy(workInProgress.elementType)),
		            (workInProgress.type = current),
		            "function" === typeof current)
		          )
		            shouldConstruct(current)
		              ? ((returnFiber = resolveClassComponentProps(
		                  current,
		                  returnFiber
		                )),
		                (workInProgress.tag = 1),
		                (workInProgress.type = current =
		                  resolveFunctionForHotReloading(current)),
		                (workInProgress = updateClassComponent(
		                  null,
		                  workInProgress,
		                  current,
		                  returnFiber,
		                  renderLanes
		                )))
		              : ((workInProgress.tag = 0),
		                validateFunctionComponentInDev(workInProgress, current),
		                (workInProgress.type = current =
		                  resolveFunctionForHotReloading(current)),
		                (workInProgress = updateFunctionComponent(
		                  null,
		                  workInProgress,
		                  current,
		                  returnFiber,
		                  renderLanes
		                )));
		          else {
		            if (void 0 !== current && null !== current)
		              if (
		                ((prevSibling = current.$$typeof),
		                prevSibling === REACT_FORWARD_REF_TYPE)
		              ) {
		                workInProgress.tag = 11;
		                workInProgress.type = current =
		                  resolveForwardRefForHotReloading(current);
		                workInProgress = updateForwardRef(
		                  null,
		                  workInProgress,
		                  current,
		                  returnFiber,
		                  renderLanes
		                );
		                break a;
		              } else if (prevSibling === REACT_MEMO_TYPE) {
		                workInProgress.tag = 14;
		                workInProgress = updateMemoComponent(
		                  null,
		                  workInProgress,
		                  current,
		                  returnFiber,
		                  renderLanes
		                );
		                break a;
		              }
		            workInProgress = "";
		            null !== current &&
		              "object" === typeof current &&
		              current.$$typeof === REACT_LAZY_TYPE &&
		              (workInProgress =
		                " Did you wrap a component in React.lazy() more than once?");
		            current = getComponentNameFromType(current) || current;
		            throw Error(
		              "Element type is invalid. Received a promise that resolves to: " +
		                current +
		                ". Lazy element type must resolve to a class or function." +
		                workInProgress
		            );
		          }
		          return workInProgress;
		        case 0:
		          return updateFunctionComponent(
		            current,
		            workInProgress,
		            workInProgress.type,
		            workInProgress.pendingProps,
		            renderLanes
		          );
		        case 1:
		          return (
		            (returnFiber = workInProgress.type),
		            (prevSibling = resolveClassComponentProps(
		              returnFiber,
		              workInProgress.pendingProps
		            )),
		            updateClassComponent(
		              current,
		              workInProgress,
		              returnFiber,
		              prevSibling,
		              renderLanes
		            )
		          );
		        case 3:
		          a: {
		            pushHostContainer(
		              workInProgress,
		              workInProgress.stateNode.containerInfo
		            );
		            if (null === current)
		              throw Error(
		                "Should have a current fiber. This is a bug in React."
		              );
		            var nextProps = workInProgress.pendingProps;
		            prevSibling = workInProgress.memoizedState;
		            returnFiber = prevSibling.element;
		            cloneUpdateQueue(current, workInProgress);
		            processUpdateQueue(workInProgress, nextProps, null, renderLanes);
		            var nextState = workInProgress.memoizedState;
		            nextProps = nextState.cache;
		            pushProvider(workInProgress, CacheContext, nextProps);
		            nextProps !== prevSibling.cache &&
		              propagateContextChanges(
		                workInProgress,
		                [CacheContext],
		                renderLanes,
		                true
		              );
		            suspendIfUpdateReadFromEntangledAsyncAction();
		            nextProps = nextState.element;
		            if (supportsHydration && prevSibling.isDehydrated)
		              if (
		                ((prevSibling = {
		                  element: nextProps,
		                  isDehydrated: false,
		                  cache: nextState.cache
		                }),
		                (workInProgress.updateQueue.baseState = prevSibling),
		                (workInProgress.memoizedState = prevSibling),
		                workInProgress.flags & 256)
		              ) {
		                workInProgress = mountHostRootWithoutHydrating(
		                  current,
		                  workInProgress,
		                  nextProps,
		                  renderLanes
		                );
		                break a;
		              } else if (nextProps !== returnFiber) {
		                returnFiber = createCapturedValueAtFiber(
		                  Error(
		                    "This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."
		                  ),
		                  workInProgress
		                );
		                queueHydrationError(returnFiber);
		                workInProgress = mountHostRootWithoutHydrating(
		                  current,
		                  workInProgress,
		                  nextProps,
		                  renderLanes
		                );
		                break a;
		              } else
		                for (
		                  supportsHydration &&
		                    ((nextHydratableInstance =
		                      getFirstHydratableChildWithinContainer(
		                        workInProgress.stateNode.containerInfo
		                      )),
		                    (hydrationParentFiber = workInProgress),
		                    (isHydrating = true),
		                    (hydrationErrors = null),
		                    (didSuspendOrErrorDEV = false),
		                    (hydrationDiffRootDEV = null),
		                    (rootOrSingletonContext = true)),
		                    current = mountChildFibers(
		                      workInProgress,
		                      null,
		                      nextProps,
		                      renderLanes
		                    ),
		                    workInProgress.child = current;
		                  current;

		                )
		                  (current.flags = (current.flags & -3) | 4096),
		                    (current = current.sibling);
		            else {
		              resetHydrationState();
		              if (nextProps === returnFiber) {
		                workInProgress = bailoutOnAlreadyFinishedWork(
		                  current,
		                  workInProgress,
		                  renderLanes
		                );
		                break a;
		              }
		              reconcileChildren(
		                current,
		                workInProgress,
		                nextProps,
		                renderLanes
		              );
		            }
		            workInProgress = workInProgress.child;
		          }
		          return workInProgress;
		        case 26:
		          if (supportsResources)
		            return (
		              markRef(current, workInProgress),
		              null === current
		                ? (current = getResource(
		                    workInProgress.type,
		                    null,
		                    workInProgress.pendingProps,
		                    null
		                  ))
		                  ? (workInProgress.memoizedState = current)
		                  : isHydrating ||
		                    (workInProgress.stateNode = createHoistableInstance(
		                      workInProgress.type,
		                      workInProgress.pendingProps,
		                      requiredContext(rootInstanceStackCursor.current),
		                      workInProgress
		                    ))
		                : (workInProgress.memoizedState = getResource(
		                    workInProgress.type,
		                    current.memoizedProps,
		                    workInProgress.pendingProps,
		                    current.memoizedState
		                  )),
		              null
		            );
		        case 27:
		          if (supportsSingletons)
		            return (
		              pushHostContext(workInProgress),
		              null === current &&
		                supportsSingletons &&
		                isHydrating &&
		                ((prevSibling = requiredContext(
		                  rootInstanceStackCursor.current
		                )),
		                (returnFiber = getHostContext()),
		                (prevSibling = workInProgress.stateNode =
		                  resolveSingletonInstance(
		                    workInProgress.type,
		                    workInProgress.pendingProps,
		                    prevSibling,
		                    returnFiber,
		                    false
		                  )),
		                didSuspendOrErrorDEV ||
		                  ((returnFiber = diffHydratedPropsForDevWarnings(
		                    prevSibling,
		                    workInProgress.type,
		                    workInProgress.pendingProps,
		                    returnFiber
		                  )),
		                  null !== returnFiber &&
		                    (buildHydrationDiffNode(workInProgress, 0).serverProps =
		                      returnFiber)),
		                (hydrationParentFiber = workInProgress),
		                (rootOrSingletonContext = true),
		                (nextHydratableInstance =
		                  getFirstHydratableChildWithinSingleton(
		                    workInProgress.type,
		                    prevSibling,
		                    nextHydratableInstance
		                  ))),
		              reconcileChildren(
		                current,
		                workInProgress,
		                workInProgress.pendingProps.children,
		                renderLanes
		              ),
		              markRef(current, workInProgress),
		              null === current && (workInProgress.flags |= 4194304),
		              workInProgress.child
		            );
		        case 5:
		          return (
		            null === current &&
		              isHydrating &&
		              ((nextProps = getHostContext()),
		              (returnFiber = validateHydratableInstance(
		                workInProgress.type,
		                workInProgress.pendingProps,
		                nextProps
		              )),
		              (prevSibling = nextHydratableInstance),
		              (nextState = !prevSibling) ||
		                ((nextState = canHydrateInstance(
		                  prevSibling,
		                  workInProgress.type,
		                  workInProgress.pendingProps,
		                  rootOrSingletonContext
		                )),
		                null !== nextState
		                  ? ((workInProgress.stateNode = nextState),
		                    didSuspendOrErrorDEV ||
		                      ((nextProps = diffHydratedPropsForDevWarnings(
		                        nextState,
		                        workInProgress.type,
		                        workInProgress.pendingProps,
		                        nextProps
		                      )),
		                      null !== nextProps &&
		                        (buildHydrationDiffNode(workInProgress, 0).serverProps =
		                          nextProps)),
		                    (hydrationParentFiber = workInProgress),
		                    (nextHydratableInstance =
		                      getFirstHydratableChild(nextState)),
		                    (rootOrSingletonContext = false),
		                    (nextProps = true))
		                  : (nextProps = false),
		                (nextState = !nextProps)),
		              nextState &&
		                (returnFiber &&
		                  warnNonHydratedInstance(workInProgress, prevSibling),
		                throwOnHydrationMismatch(workInProgress))),
		            pushHostContext(workInProgress),
		            (prevSibling = workInProgress.type),
		            (nextProps = workInProgress.pendingProps),
		            (nextState = null !== current ? current.memoizedProps : null),
		            (returnFiber = nextProps.children),
		            shouldSetTextContent(prevSibling, nextProps)
		              ? (returnFiber = null)
		              : null !== nextState &&
		                shouldSetTextContent(prevSibling, nextState) &&
		                (workInProgress.flags |= 32),
		            null !== workInProgress.memoizedState &&
		              ((prevSibling = renderWithHooks(
		                current,
		                workInProgress,
		                TransitionAwareHostComponent,
		                null,
		                null,
		                renderLanes
		              )),
		              isPrimaryRenderer
		                ? (HostTransitionContext._currentValue = prevSibling)
		                : (HostTransitionContext._currentValue2 = prevSibling)),
		            markRef(current, workInProgress),
		            reconcileChildren(
		              current,
		              workInProgress,
		              returnFiber,
		              renderLanes
		            ),
		            workInProgress.child
		          );
		        case 6:
		          return (
		            null === current &&
		              isHydrating &&
		              ((current = workInProgress.pendingProps),
		              (renderLanes = getHostContext()),
		              (current = validateHydratableTextInstance(current, renderLanes)),
		              (renderLanes = nextHydratableInstance),
		              (returnFiber = !renderLanes) ||
		                ((returnFiber = canHydrateTextInstance(
		                  renderLanes,
		                  workInProgress.pendingProps,
		                  rootOrSingletonContext
		                )),
		                null !== returnFiber
		                  ? ((workInProgress.stateNode = returnFiber),
		                    (hydrationParentFiber = workInProgress),
		                    (nextHydratableInstance = null),
		                    (returnFiber = true))
		                  : (returnFiber = false),
		                (returnFiber = !returnFiber)),
		              returnFiber &&
		                (current &&
		                  warnNonHydratedInstance(workInProgress, renderLanes),
		                throwOnHydrationMismatch(workInProgress))),
		            null
		          );
		        case 13:
		          return updateSuspenseComponent(current, workInProgress, renderLanes);
		        case 4:
		          return (
		            pushHostContainer(
		              workInProgress,
		              workInProgress.stateNode.containerInfo
		            ),
		            (returnFiber = workInProgress.pendingProps),
		            null === current
		              ? (workInProgress.child = reconcileChildFibers(
		                  workInProgress,
		                  null,
		                  returnFiber,
		                  renderLanes
		                ))
		              : reconcileChildren(
		                  current,
		                  workInProgress,
		                  returnFiber,
		                  renderLanes
		                ),
		            workInProgress.child
		          );
		        case 11:
		          return updateForwardRef(
		            current,
		            workInProgress,
		            workInProgress.type,
		            workInProgress.pendingProps,
		            renderLanes
		          );
		        case 7:
		          return (
		            reconcileChildren(
		              current,
		              workInProgress,
		              workInProgress.pendingProps,
		              renderLanes
		            ),
		            workInProgress.child
		          );
		        case 8:
		          return (
		            reconcileChildren(
		              current,
		              workInProgress,
		              workInProgress.pendingProps.children,
		              renderLanes
		            ),
		            workInProgress.child
		          );
		        case 12:
		          return (
		            (workInProgress.flags |= 4),
		            (workInProgress.flags |= 2048),
		            (returnFiber = workInProgress.stateNode),
		            (returnFiber.effectDuration = -0),
		            (returnFiber.passiveEffectDuration = -0),
		            reconcileChildren(
		              current,
		              workInProgress,
		              workInProgress.pendingProps.children,
		              renderLanes
		            ),
		            workInProgress.child
		          );
		        case 10:
		          return (
		            (returnFiber = workInProgress.type),
		            (prevSibling = workInProgress.pendingProps),
		            (nextProps = prevSibling.value),
		            "value" in prevSibling ||
		              hasWarnedAboutUsingNoValuePropOnContextProvider ||
		              ((hasWarnedAboutUsingNoValuePropOnContextProvider = true),
		              console.error(
		                "The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"
		              )),
		            pushProvider(workInProgress, returnFiber, nextProps),
		            reconcileChildren(
		              current,
		              workInProgress,
		              prevSibling.children,
		              renderLanes
		            ),
		            workInProgress.child
		          );
		        case 9:
		          return (
		            (prevSibling = workInProgress.type._context),
		            (returnFiber = workInProgress.pendingProps.children),
		            "function" !== typeof returnFiber &&
		              console.error(
		                "A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."
		              ),
		            prepareToReadContext(workInProgress),
		            (prevSibling = readContext(prevSibling)),
		            (returnFiber = callComponentInDEV(
		              returnFiber,
		              prevSibling,
		              void 0
		            )),
		            (workInProgress.flags |= 1),
		            reconcileChildren(
		              current,
		              workInProgress,
		              returnFiber,
		              renderLanes
		            ),
		            workInProgress.child
		          );
		        case 14:
		          return updateMemoComponent(
		            current,
		            workInProgress,
		            workInProgress.type,
		            workInProgress.pendingProps,
		            renderLanes
		          );
		        case 15:
		          return updateSimpleMemoComponent(
		            current,
		            workInProgress,
		            workInProgress.type,
		            workInProgress.pendingProps,
		            renderLanes
		          );
		        case 19:
		          return updateSuspenseListComponent(
		            current,
		            workInProgress,
		            renderLanes
		          );
		        case 31:
		          return updateActivityComponent(current, workInProgress, renderLanes);
		        case 22:
		          return updateOffscreenComponent(
		            current,
		            workInProgress,
		            renderLanes,
		            workInProgress.pendingProps
		          );
		        case 24:
		          return (
		            prepareToReadContext(workInProgress),
		            (returnFiber = readContext(CacheContext)),
		            null === current
		              ? ((prevSibling = peekCacheFromPool()),
		                null === prevSibling &&
		                  ((prevSibling = workInProgressRoot),
		                  (nextProps = createCache()),
		                  (prevSibling.pooledCache = nextProps),
		                  retainCache(nextProps),
		                  null !== nextProps &&
		                    (prevSibling.pooledCacheLanes |= renderLanes),
		                  (prevSibling = nextProps)),
		                (workInProgress.memoizedState = {
		                  parent: returnFiber,
		                  cache: prevSibling
		                }),
		                initializeUpdateQueue(workInProgress),
		                pushProvider(workInProgress, CacheContext, prevSibling))
		              : (0 !== (current.lanes & renderLanes) &&
		                  (cloneUpdateQueue(current, workInProgress),
		                  processUpdateQueue(workInProgress, null, null, renderLanes),
		                  suspendIfUpdateReadFromEntangledAsyncAction()),
		                (prevSibling = current.memoizedState),
		                (nextProps = workInProgress.memoizedState),
		                prevSibling.parent !== returnFiber
		                  ? ((prevSibling = {
		                      parent: returnFiber,
		                      cache: returnFiber
		                    }),
		                    (workInProgress.memoizedState = prevSibling),
		                    0 === workInProgress.lanes &&
		                      (workInProgress.memoizedState =
		                        workInProgress.updateQueue.baseState =
		                          prevSibling),
		                    pushProvider(workInProgress, CacheContext, returnFiber))
		                  : ((returnFiber = nextProps.cache),
		                    pushProvider(workInProgress, CacheContext, returnFiber),
		                    returnFiber !== prevSibling.cache &&
		                      propagateContextChanges(
		                        workInProgress,
		                        [CacheContext],
		                        renderLanes,
		                        true
		                      ))),
		            reconcileChildren(
		              current,
		              workInProgress,
		              workInProgress.pendingProps.children,
		              renderLanes
		            ),
		            workInProgress.child
		          );
		        case 29:
		          throw workInProgress.pendingProps;
		      }
		      throw Error(
		        "Unknown unit of work tag (" +
		          workInProgress.tag +
		          "). This error is likely caused by a bug in React. Please file an issue."
		      );
		    }
		    function markUpdate(workInProgress) {
		      workInProgress.flags |= 4;
		    }
		    function markCloned(workInProgress) {
		      supportsPersistence && (workInProgress.flags |= 8);
		    }
		    function doesRequireClone(current, completedWork) {
		      if (null !== current && current.child === completedWork.child) return false;
		      if (0 !== (completedWork.flags & 16)) return true;
		      for (current = completedWork.child; null !== current; ) {
		        if (0 !== (current.flags & 8218) || 0 !== (current.subtreeFlags & 8218))
		          return true;
		        current = current.sibling;
		      }
		      return false;
		    }
		    function appendAllChildren(
		      parent,
		      workInProgress,
		      needsVisibilityToggle,
		      isHidden
		    ) {
		      if (supportsMutation)
		        for (
		          needsVisibilityToggle = workInProgress.child;
		          null !== needsVisibilityToggle;

		        ) {
		          if (
		            5 === needsVisibilityToggle.tag ||
		            6 === needsVisibilityToggle.tag
		          )
		            appendInitialChild(parent, needsVisibilityToggle.stateNode);
		          else if (
		            !(
		              4 === needsVisibilityToggle.tag ||
		              (supportsSingletons && 27 === needsVisibilityToggle.tag)
		            ) &&
		            null !== needsVisibilityToggle.child
		          ) {
		            needsVisibilityToggle.child.return = needsVisibilityToggle;
		            needsVisibilityToggle = needsVisibilityToggle.child;
		            continue;
		          }
		          if (needsVisibilityToggle === workInProgress) break;
		          for (; null === needsVisibilityToggle.sibling; ) {
		            if (
		              null === needsVisibilityToggle.return ||
		              needsVisibilityToggle.return === workInProgress
		            )
		              return;
		            needsVisibilityToggle = needsVisibilityToggle.return;
		          }
		          needsVisibilityToggle.sibling.return = needsVisibilityToggle.return;
		          needsVisibilityToggle = needsVisibilityToggle.sibling;
		        }
		      else if (supportsPersistence)
		        for (var _node = workInProgress.child; null !== _node; ) {
		          if (5 === _node.tag) {
		            var instance = _node.stateNode;
		            needsVisibilityToggle &&
		              isHidden &&
		              (instance = cloneHiddenInstance(
		                instance,
		                _node.type,
		                _node.memoizedProps
		              ));
		            appendInitialChild(parent, instance);
		          } else if (6 === _node.tag)
		            (instance = _node.stateNode),
		              needsVisibilityToggle &&
		                isHidden &&
		                (instance = cloneHiddenTextInstance(
		                  instance,
		                  _node.memoizedProps
		                )),
		              appendInitialChild(parent, instance);
		          else if (4 !== _node.tag)
		            if (22 === _node.tag && null !== _node.memoizedState)
		              (instance = _node.child),
		                null !== instance && (instance.return = _node),
		                appendAllChildren(parent, _node, true, true);
		            else if (null !== _node.child) {
		              _node.child.return = _node;
		              _node = _node.child;
		              continue;
		            }
		          if (_node === workInProgress) break;
		          for (; null === _node.sibling; ) {
		            if (null === _node.return || _node.return === workInProgress)
		              return;
		            _node = _node.return;
		          }
		          _node.sibling.return = _node.return;
		          _node = _node.sibling;
		        }
		    }
		    function appendAllChildrenToContainer(
		      containerChildSet,
		      workInProgress,
		      needsVisibilityToggle,
		      isHidden
		    ) {
		      var hasOffscreenComponentChild = false;
		      if (supportsPersistence)
		        for (var node = workInProgress.child; null !== node; ) {
		          if (5 === node.tag) {
		            var instance = node.stateNode;
		            needsVisibilityToggle &&
		              isHidden &&
		              (instance = cloneHiddenInstance(
		                instance,
		                node.type,
		                node.memoizedProps
		              ));
		            appendChildToContainerChildSet(containerChildSet, instance);
		          } else if (6 === node.tag)
		            (instance = node.stateNode),
		              needsVisibilityToggle &&
		                isHidden &&
		                (instance = cloneHiddenTextInstance(
		                  instance,
		                  node.memoizedProps
		                )),
		              appendChildToContainerChildSet(containerChildSet, instance);
		          else if (4 !== node.tag)
		            if (22 === node.tag && null !== node.memoizedState)
		              (hasOffscreenComponentChild = node.child),
		                null !== hasOffscreenComponentChild &&
		                  (hasOffscreenComponentChild.return = node),
		                appendAllChildrenToContainer(containerChildSet, node, true, true),
		                (hasOffscreenComponentChild = true);
		            else if (null !== node.child) {
		              node.child.return = node;
		              node = node.child;
		              continue;
		            }
		          if (node === workInProgress) break;
		          for (; null === node.sibling; ) {
		            if (null === node.return || node.return === workInProgress)
		              return hasOffscreenComponentChild;
		            node = node.return;
		          }
		          node.sibling.return = node.return;
		          node = node.sibling;
		        }
		      return hasOffscreenComponentChild;
		    }
		    function updateHostContainer(current, workInProgress) {
		      if (supportsPersistence && doesRequireClone(current, workInProgress)) {
		        current = workInProgress.stateNode;
		        var container = current.containerInfo,
		          newChildSet = createContainerChildSet();
		        appendAllChildrenToContainer(newChildSet, workInProgress, false, false);
		        current.pendingChildren = newChildSet;
		        markUpdate(workInProgress);
		        finalizeContainerChildren(container, newChildSet);
		      }
		    }
		    function updateHostComponent(current, workInProgress, type, newProps) {
		      if (supportsMutation)
		        current.memoizedProps !== newProps && markUpdate(workInProgress);
		      else if (supportsPersistence) {
		        var currentInstance = current.stateNode,
		          _oldProps = current.memoizedProps;
		        if (
		          (current = doesRequireClone(current, workInProgress)) ||
		          _oldProps !== newProps
		        ) {
		          var currentHostContext = getHostContext();
		          _oldProps = cloneInstance(
		            currentInstance,
		            type,
		            _oldProps,
		            newProps,
		            !current,
		            null
		          );
		          _oldProps === currentInstance
		            ? (workInProgress.stateNode = currentInstance)
		            : (markCloned(workInProgress),
		              finalizeInitialChildren(
		                _oldProps,
		                type,
		                newProps,
		                currentHostContext
		              ) && markUpdate(workInProgress),
		              (workInProgress.stateNode = _oldProps),
		              current && appendAllChildren(_oldProps, workInProgress, false, false));
		        } else workInProgress.stateNode = currentInstance;
		      }
		    }
		    function preloadInstanceAndSuspendIfNeeded(
		      workInProgress,
		      type,
		      oldProps,
		      newProps,
		      renderLanes
		    ) {
		      if (
		        (workInProgress.mode & 32) !== NoMode &&
		        (null === oldProps
		          ? maySuspendCommit(type, newProps)
		          : maySuspendCommitOnUpdate(type, oldProps, newProps))
		      ) {
		        if (
		          ((workInProgress.flags |= 16777216),
		          (renderLanes & 335544128) === renderLanes ||
		            maySuspendCommitInSyncRender(type, newProps))
		        )
		          if (preloadInstance(workInProgress.stateNode, type, newProps))
		            workInProgress.flags |= 8192;
		          else if (shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
		          else
		            throw (
		              ((suspendedThenable = noopSuspenseyCommitThenable),
		              SuspenseyCommitException)
		            );
		      } else workInProgress.flags &= -16777217;
		    }
		    function preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
		      if (mayResourceSuspendCommit(resource)) {
		        if (((workInProgress.flags |= 16777216), !preloadResource(resource)))
		          if (shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
		          else
		            throw (
		              ((suspendedThenable = noopSuspenseyCommitThenable),
		              SuspenseyCommitException)
		            );
		      } else workInProgress.flags &= -16777217;
		    }
		    function scheduleRetryEffect(workInProgress, retryQueue) {
		      null !== retryQueue && (workInProgress.flags |= 4);
		      workInProgress.flags & 16384 &&
		        ((retryQueue =
		          22 !== workInProgress.tag ? claimNextRetryLane() : 536870912),
		        (workInProgress.lanes |= retryQueue),
		        (workInProgressSuspendedRetryLanes |= retryQueue));
		    }
		    function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
		      if (!isHydrating)
		        switch (renderState.tailMode) {
		          case "hidden":
		            hasRenderedATailFallback = renderState.tail;
		            for (var lastTailNode = null; null !== hasRenderedATailFallback; )
		              null !== hasRenderedATailFallback.alternate &&
		                (lastTailNode = hasRenderedATailFallback),
		                (hasRenderedATailFallback = hasRenderedATailFallback.sibling);
		            null === lastTailNode
		              ? (renderState.tail = null)
		              : (lastTailNode.sibling = null);
		            break;
		          case "collapsed":
		            lastTailNode = renderState.tail;
		            for (var _lastTailNode = null; null !== lastTailNode; )
		              null !== lastTailNode.alternate && (_lastTailNode = lastTailNode),
		                (lastTailNode = lastTailNode.sibling);
		            null === _lastTailNode
		              ? hasRenderedATailFallback || null === renderState.tail
		                ? (renderState.tail = null)
		                : (renderState.tail.sibling = null)
		              : (_lastTailNode.sibling = null);
		        }
		    }
		    function bubbleProperties(completedWork) {
		      var didBailout =
		          null !== completedWork.alternate &&
		          completedWork.alternate.child === completedWork.child,
		        newChildLanes = 0,
		        subtreeFlags = 0;
		      if (didBailout)
		        if ((completedWork.mode & 2) !== NoMode) {
		          for (
		            var _treeBaseDuration = completedWork.selfBaseDuration,
		              _child2 = completedWork.child;
		            null !== _child2;

		          )
		            (newChildLanes |= _child2.lanes | _child2.childLanes),
		              (subtreeFlags |= _child2.subtreeFlags & 65011712),
		              (subtreeFlags |= _child2.flags & 65011712),
		              (_treeBaseDuration += _child2.treeBaseDuration),
		              (_child2 = _child2.sibling);
		          completedWork.treeBaseDuration = _treeBaseDuration;
		        } else
		          for (
		            _treeBaseDuration = completedWork.child;
		            null !== _treeBaseDuration;

		          )
		            (newChildLanes |=
		              _treeBaseDuration.lanes | _treeBaseDuration.childLanes),
		              (subtreeFlags |= _treeBaseDuration.subtreeFlags & 65011712),
		              (subtreeFlags |= _treeBaseDuration.flags & 65011712),
		              (_treeBaseDuration.return = completedWork),
		              (_treeBaseDuration = _treeBaseDuration.sibling);
		      else if ((completedWork.mode & 2) !== NoMode) {
		        _treeBaseDuration = completedWork.actualDuration;
		        _child2 = completedWork.selfBaseDuration;
		        for (var child = completedWork.child; null !== child; )
		          (newChildLanes |= child.lanes | child.childLanes),
		            (subtreeFlags |= child.subtreeFlags),
		            (subtreeFlags |= child.flags),
		            (_treeBaseDuration += child.actualDuration),
		            (_child2 += child.treeBaseDuration),
		            (child = child.sibling);
		        completedWork.actualDuration = _treeBaseDuration;
		        completedWork.treeBaseDuration = _child2;
		      } else
		        for (
		          _treeBaseDuration = completedWork.child;
		          null !== _treeBaseDuration;

		        )
		          (newChildLanes |=
		            _treeBaseDuration.lanes | _treeBaseDuration.childLanes),
		            (subtreeFlags |= _treeBaseDuration.subtreeFlags),
		            (subtreeFlags |= _treeBaseDuration.flags),
		            (_treeBaseDuration.return = completedWork),
		            (_treeBaseDuration = _treeBaseDuration.sibling);
		      completedWork.subtreeFlags |= subtreeFlags;
		      completedWork.childLanes = newChildLanes;
		      return didBailout;
		    }
		    function completeWork(current, workInProgress, renderLanes) {
		      var newProps = workInProgress.pendingProps;
		      popTreeContext(workInProgress);
		      switch (workInProgress.tag) {
		        case 16:
		        case 15:
		        case 0:
		        case 11:
		        case 7:
		        case 8:
		        case 12:
		        case 9:
		        case 14:
		          return bubbleProperties(workInProgress), null;
		        case 1:
		          return bubbleProperties(workInProgress), null;
		        case 3:
		          renderLanes = workInProgress.stateNode;
		          newProps = null;
		          null !== current && (newProps = current.memoizedState.cache);
		          workInProgress.memoizedState.cache !== newProps &&
		            (workInProgress.flags |= 2048);
		          popProvider(CacheContext, workInProgress);
		          popHostContainer(workInProgress);
		          renderLanes.pendingContext &&
		            ((renderLanes.context = renderLanes.pendingContext),
		            (renderLanes.pendingContext = null));
		          if (null === current || null === current.child)
		            popHydrationState(workInProgress)
		              ? (emitPendingHydrationWarnings(), markUpdate(workInProgress))
		              : null === current ||
		                (current.memoizedState.isDehydrated &&
		                  0 === (workInProgress.flags & 256)) ||
		                ((workInProgress.flags |= 1024),
		                upgradeHydrationErrorsToRecoverable());
		          updateHostContainer(current, workInProgress);
		          bubbleProperties(workInProgress);
		          return null;
		        case 26:
		          if (supportsResources) {
		            var type = workInProgress.type,
		              nextResource = workInProgress.memoizedState;
		            null === current
		              ? (markUpdate(workInProgress),
		                null !== nextResource
		                  ? (bubbleProperties(workInProgress),
		                    preloadResourceAndSuspendIfNeeded(
		                      workInProgress,
		                      nextResource
		                    ))
		                  : (bubbleProperties(workInProgress),
		                    preloadInstanceAndSuspendIfNeeded(
		                      workInProgress,
		                      type,
		                      null,
		                      newProps,
		                      renderLanes
		                    )))
		              : nextResource
		                ? nextResource !== current.memoizedState
		                  ? (markUpdate(workInProgress),
		                    bubbleProperties(workInProgress),
		                    preloadResourceAndSuspendIfNeeded(
		                      workInProgress,
		                      nextResource
		                    ))
		                  : (bubbleProperties(workInProgress),
		                    (workInProgress.flags &= -16777217))
		                : ((nextResource = current.memoizedProps),
		                  supportsMutation
		                    ? nextResource !== newProps && markUpdate(workInProgress)
		                    : updateHostComponent(
		                        current,
		                        workInProgress,
		                        type,
		                        newProps
		                      ),
		                  bubbleProperties(workInProgress),
		                  preloadInstanceAndSuspendIfNeeded(
		                    workInProgress,
		                    type,
		                    nextResource,
		                    newProps,
		                    renderLanes
		                  ));
		            return null;
		          }
		        case 27:
		          if (supportsSingletons) {
		            popHostContext(workInProgress);
		            renderLanes = requiredContext(rootInstanceStackCursor.current);
		            type = workInProgress.type;
		            if (null !== current && null != workInProgress.stateNode)
		              supportsMutation
		                ? current.memoizedProps !== newProps &&
		                  markUpdate(workInProgress)
		                : updateHostComponent(current, workInProgress, type, newProps);
		            else {
		              if (!newProps) {
		                if (null === workInProgress.stateNode)
		                  throw Error(
		                    "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
		                  );
		                bubbleProperties(workInProgress);
		                return null;
		              }
		              current = getHostContext();
		              popHydrationState(workInProgress)
		                ? prepareToHydrateHostInstance(workInProgress, current)
		                : ((current = resolveSingletonInstance(
		                    type,
		                    newProps,
		                    renderLanes,
		                    current,
		                    true
		                  )),
		                  (workInProgress.stateNode = current),
		                  markUpdate(workInProgress));
		            }
		            bubbleProperties(workInProgress);
		            return null;
		          }
		        case 5:
		          popHostContext(workInProgress);
		          type = workInProgress.type;
		          if (null !== current && null != workInProgress.stateNode)
		            updateHostComponent(current, workInProgress, type, newProps);
		          else {
		            if (!newProps) {
		              if (null === workInProgress.stateNode)
		                throw Error(
		                  "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
		                );
		              bubbleProperties(workInProgress);
		              return null;
		            }
		            nextResource = getHostContext();
		            if (popHydrationState(workInProgress))
		              prepareToHydrateHostInstance(workInProgress, nextResource),
		                finalizeHydratedChildren(
		                  workInProgress.stateNode,
		                  type,
		                  newProps,
		                  nextResource
		                ) && (workInProgress.flags |= 64);
		            else {
		              var _rootContainerInstance = requiredContext(
		                rootInstanceStackCursor.current
		              );
		              _rootContainerInstance = createInstance(
		                type,
		                newProps,
		                _rootContainerInstance,
		                nextResource,
		                workInProgress
		              );
		              markCloned(workInProgress);
		              appendAllChildren(_rootContainerInstance, workInProgress, false, false);
		              workInProgress.stateNode = _rootContainerInstance;
		              finalizeInitialChildren(
		                _rootContainerInstance,
		                type,
		                newProps,
		                nextResource
		              ) && markUpdate(workInProgress);
		            }
		          }
		          bubbleProperties(workInProgress);
		          preloadInstanceAndSuspendIfNeeded(
		            workInProgress,
		            workInProgress.type,
		            null === current ? null : current.memoizedProps,
		            workInProgress.pendingProps,
		            renderLanes
		          );
		          return null;
		        case 6:
		          if (current && null != workInProgress.stateNode)
		            (renderLanes = current.memoizedProps),
		              supportsMutation
		                ? renderLanes !== newProps && markUpdate(workInProgress)
		                : supportsPersistence &&
		                  (renderLanes !== newProps
		                    ? ((current = requiredContext(
		                        rootInstanceStackCursor.current
		                      )),
		                      (renderLanes = getHostContext()),
		                      markCloned(workInProgress),
		                      (workInProgress.stateNode = createTextInstance(
		                        newProps,
		                        current,
		                        renderLanes,
		                        workInProgress
		                      )))
		                    : (workInProgress.stateNode = current.stateNode));
		          else {
		            if (
		              "string" !== typeof newProps &&
		              null === workInProgress.stateNode
		            )
		              throw Error(
		                "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
		              );
		            current = requiredContext(rootInstanceStackCursor.current);
		            renderLanes = getHostContext();
		            if (popHydrationState(workInProgress)) {
		              if (!supportsHydration)
		                throw Error(
		                  "Expected prepareToHydrateHostTextInstance() to never be called. This error is likely caused by a bug in React. Please file an issue."
		                );
		              current = workInProgress.stateNode;
		              renderLanes = workInProgress.memoizedProps;
		              type = !didSuspendOrErrorDEV;
		              newProps = null;
		              nextResource = hydrationParentFiber;
		              if (null !== nextResource)
		                switch (nextResource.tag) {
		                  case 3:
		                    type &&
		                      ((type = diffHydratedTextForDevWarnings(
		                        current,
		                        renderLanes,
		                        newProps
		                      )),
		                      null !== type &&
		                        (buildHydrationDiffNode(workInProgress, 0).serverProps =
		                          type));
		                    break;
		                  case 27:
		                  case 5:
		                    (newProps = nextResource.memoizedProps),
		                      type &&
		                        ((type = diffHydratedTextForDevWarnings(
		                          current,
		                          renderLanes,
		                          newProps
		                        )),
		                        null !== type &&
		                          (buildHydrationDiffNode(
		                            workInProgress,
		                            0
		                          ).serverProps = type));
		                }
		              hydrateTextInstance(
		                current,
		                renderLanes,
		                workInProgress,
		                newProps
		              ) || throwOnHydrationMismatch(workInProgress, true);
		            } else
		              markCloned(workInProgress),
		                (workInProgress.stateNode = createTextInstance(
		                  newProps,
		                  current,
		                  renderLanes,
		                  workInProgress
		                ));
		          }
		          bubbleProperties(workInProgress);
		          return null;
		        case 31:
		          renderLanes = workInProgress.memoizedState;
		          if (null === current || null !== current.memoizedState) {
		            newProps = popHydrationState(workInProgress);
		            if (null !== renderLanes) {
		              if (null === current) {
		                if (!newProps)
		                  throw Error(
		                    "A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React."
		                  );
		                if (!supportsHydration)
		                  throw Error(
		                    "Expected prepareToHydrateHostActivityInstance() to never be called. This error is likely caused by a bug in React. Please file an issue."
		                  );
		                current = workInProgress.memoizedState;
		                current = null !== current ? current.dehydrated : null;
		                if (!current)
		                  throw Error(
		                    "Expected to have a hydrated activity instance. This error is likely caused by a bug in React. Please file an issue."
		                  );
		                hydrateActivityInstance(current, workInProgress);
		                bubbleProperties(workInProgress);
		                (workInProgress.mode & 2) !== NoMode &&
		                  null !== renderLanes &&
		                  ((current = workInProgress.child),
		                  null !== current &&
		                    (workInProgress.treeBaseDuration -=
		                      current.treeBaseDuration));
		              } else
		                emitPendingHydrationWarnings(),
		                  resetHydrationState(),
		                  0 === (workInProgress.flags & 128) &&
		                    (renderLanes = workInProgress.memoizedState = null),
		                  (workInProgress.flags |= 4),
		                  bubbleProperties(workInProgress),
		                  (workInProgress.mode & 2) !== NoMode &&
		                    null !== renderLanes &&
		                    ((current = workInProgress.child),
		                    null !== current &&
		                      (workInProgress.treeBaseDuration -=
		                        current.treeBaseDuration));
		              current = false;
		            } else
		              (renderLanes = upgradeHydrationErrorsToRecoverable()),
		                null !== current &&
		                  null !== current.memoizedState &&
		                  (current.memoizedState.hydrationErrors = renderLanes),
		                (current = true);
		            if (!current) {
		              if (workInProgress.flags & 256)
		                return popSuspenseHandler(workInProgress), workInProgress;
		              popSuspenseHandler(workInProgress);
		              return null;
		            }
		            if (0 !== (workInProgress.flags & 128))
		              throw Error(
		                "Client rendering an Activity suspended it again. This is a bug in React."
		              );
		          }
		          bubbleProperties(workInProgress);
		          return null;
		        case 13:
		          newProps = workInProgress.memoizedState;
		          if (
		            null === current ||
		            (null !== current.memoizedState &&
		              null !== current.memoizedState.dehydrated)
		          ) {
		            type = newProps;
		            nextResource = popHydrationState(workInProgress);
		            if (null !== type && null !== type.dehydrated) {
		              if (null === current) {
		                if (!nextResource)
		                  throw Error(
		                    "A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React."
		                  );
		                if (!supportsHydration)
		                  throw Error(
		                    "Expected prepareToHydrateHostSuspenseInstance() to never be called. This error is likely caused by a bug in React. Please file an issue."
		                  );
		                nextResource = workInProgress.memoizedState;
		                nextResource =
		                  null !== nextResource ? nextResource.dehydrated : null;
		                if (!nextResource)
		                  throw Error(
		                    "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue."
		                  );
		                hydrateSuspenseInstance(nextResource, workInProgress);
		                bubbleProperties(workInProgress);
		                (workInProgress.mode & 2) !== NoMode &&
		                  null !== type &&
		                  ((type = workInProgress.child),
		                  null !== type &&
		                    (workInProgress.treeBaseDuration -= type.treeBaseDuration));
		              } else
		                emitPendingHydrationWarnings(),
		                  resetHydrationState(),
		                  0 === (workInProgress.flags & 128) &&
		                    (type = workInProgress.memoizedState = null),
		                  (workInProgress.flags |= 4),
		                  bubbleProperties(workInProgress),
		                  (workInProgress.mode & 2) !== NoMode &&
		                    null !== type &&
		                    ((type = workInProgress.child),
		                    null !== type &&
		                      (workInProgress.treeBaseDuration -=
		                        type.treeBaseDuration));
		              type = false;
		            } else
		              (type = upgradeHydrationErrorsToRecoverable()),
		                null !== current &&
		                  null !== current.memoizedState &&
		                  (current.memoizedState.hydrationErrors = type),
		                (type = true);
		            if (!type) {
		              if (workInProgress.flags & 256)
		                return popSuspenseHandler(workInProgress), workInProgress;
		              popSuspenseHandler(workInProgress);
		              return null;
		            }
		          }
		          popSuspenseHandler(workInProgress);
		          if (0 !== (workInProgress.flags & 128))
		            return (
		              (workInProgress.lanes = renderLanes),
		              (workInProgress.mode & 2) !== NoMode &&
		                transferActualDuration(workInProgress),
		              workInProgress
		            );
		          renderLanes = null !== newProps;
		          current = null !== current && null !== current.memoizedState;
		          renderLanes &&
		            ((newProps = workInProgress.child),
		            (type = null),
		            null !== newProps.alternate &&
		              null !== newProps.alternate.memoizedState &&
		              null !== newProps.alternate.memoizedState.cachePool &&
		              (type = newProps.alternate.memoizedState.cachePool.pool),
		            (nextResource = null),
		            null !== newProps.memoizedState &&
		              null !== newProps.memoizedState.cachePool &&
		              (nextResource = newProps.memoizedState.cachePool.pool),
		            nextResource !== type && (newProps.flags |= 2048));
		          renderLanes !== current &&
		            renderLanes &&
		            (workInProgress.child.flags |= 8192);
		          scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
		          bubbleProperties(workInProgress);
		          (workInProgress.mode & 2) !== NoMode &&
		            renderLanes &&
		            ((current = workInProgress.child),
		            null !== current &&
		              (workInProgress.treeBaseDuration -= current.treeBaseDuration));
		          return null;
		        case 4:
		          return (
		            popHostContainer(workInProgress),
		            updateHostContainer(current, workInProgress),
		            null === current &&
		              preparePortalMount(workInProgress.stateNode.containerInfo),
		            bubbleProperties(workInProgress),
		            null
		          );
		        case 10:
		          return (
		            popProvider(workInProgress.type, workInProgress),
		            bubbleProperties(workInProgress),
		            null
		          );
		        case 19:
		          pop(suspenseStackCursor, workInProgress);
		          newProps = workInProgress.memoizedState;
		          if (null === newProps) return bubbleProperties(workInProgress), null;
		          type = 0 !== (workInProgress.flags & 128);
		          nextResource = newProps.rendering;
		          if (null === nextResource)
		            if (type) cutOffTailIfNeeded(newProps, false);
		            else {
		              if (
		                workInProgressRootExitStatus !== RootInProgress ||
		                (null !== current && 0 !== (current.flags & 128))
		              )
		                for (current = workInProgress.child; null !== current; ) {
		                  nextResource = findFirstSuspended(current);
		                  if (null !== nextResource) {
		                    workInProgress.flags |= 128;
		                    cutOffTailIfNeeded(newProps, false);
		                    current = nextResource.updateQueue;
		                    workInProgress.updateQueue = current;
		                    scheduleRetryEffect(workInProgress, current);
		                    workInProgress.subtreeFlags = 0;
		                    current = renderLanes;
		                    for (
		                      renderLanes = workInProgress.child;
		                      null !== renderLanes;

		                    )
		                      resetWorkInProgress(renderLanes, current),
		                        (renderLanes = renderLanes.sibling);
		                    push(
		                      suspenseStackCursor,
		                      (suspenseStackCursor.current &
		                        SubtreeSuspenseContextMask) |
		                        ForceSuspenseFallback,
		                      workInProgress
		                    );
		                    isHydrating &&
		                      pushTreeFork(workInProgress, newProps.treeForkCount);
		                    return workInProgress.child;
		                  }
		                  current = current.sibling;
		                }
		              null !== newProps.tail &&
		                now$1() > workInProgressRootRenderTargetTime &&
		                ((workInProgress.flags |= 128),
		                (type = true),
		                cutOffTailIfNeeded(newProps, false),
		                (workInProgress.lanes = 4194304));
		            }
		          else {
		            if (!type)
		              if (
		                ((current = findFirstSuspended(nextResource)), null !== current)
		              ) {
		                if (
		                  ((workInProgress.flags |= 128),
		                  (type = true),
		                  (current = current.updateQueue),
		                  (workInProgress.updateQueue = current),
		                  scheduleRetryEffect(workInProgress, current),
		                  cutOffTailIfNeeded(newProps, true),
		                  null === newProps.tail &&
		                    "hidden" === newProps.tailMode &&
		                    !nextResource.alternate &&
		                    !isHydrating)
		                )
		                  return bubbleProperties(workInProgress), null;
		              } else
		                2 * now$1() - newProps.renderingStartTime >
		                  workInProgressRootRenderTargetTime &&
		                  536870912 !== renderLanes &&
		                  ((workInProgress.flags |= 128),
		                  (type = true),
		                  cutOffTailIfNeeded(newProps, false),
		                  (workInProgress.lanes = 4194304));
		            newProps.isBackwards
		              ? ((nextResource.sibling = workInProgress.child),
		                (workInProgress.child = nextResource))
		              : ((current = newProps.last),
		                null !== current
		                  ? (current.sibling = nextResource)
		                  : (workInProgress.child = nextResource),
		                (newProps.last = nextResource));
		          }
		          if (null !== newProps.tail)
		            return (
		              (current = newProps.tail),
		              (newProps.rendering = current),
		              (newProps.tail = current.sibling),
		              (newProps.renderingStartTime = now$1()),
		              (current.sibling = null),
		              (renderLanes = suspenseStackCursor.current),
		              (renderLanes = type
		                ? (renderLanes & SubtreeSuspenseContextMask) |
		                  ForceSuspenseFallback
		                : renderLanes & SubtreeSuspenseContextMask),
		              push(suspenseStackCursor, renderLanes, workInProgress),
		              isHydrating &&
		                pushTreeFork(workInProgress, newProps.treeForkCount),
		              current
		            );
		          bubbleProperties(workInProgress);
		          return null;
		        case 22:
		        case 23:
		          return (
		            popSuspenseHandler(workInProgress),
		            popHiddenContext(workInProgress),
		            (newProps = null !== workInProgress.memoizedState),
		            null !== current
		              ? (null !== current.memoizedState) !== newProps &&
		                (workInProgress.flags |= 8192)
		              : newProps && (workInProgress.flags |= 8192),
		            newProps
		              ? 0 !== (renderLanes & 536870912) &&
		                0 === (workInProgress.flags & 128) &&
		                (bubbleProperties(workInProgress),
		                workInProgress.subtreeFlags & 6 &&
		                  (workInProgress.flags |= 8192))
		              : bubbleProperties(workInProgress),
		            (renderLanes = workInProgress.updateQueue),
		            null !== renderLanes &&
		              scheduleRetryEffect(workInProgress, renderLanes.retryQueue),
		            (renderLanes = null),
		            null !== current &&
		              null !== current.memoizedState &&
		              null !== current.memoizedState.cachePool &&
		              (renderLanes = current.memoizedState.cachePool.pool),
		            (newProps = null),
		            null !== workInProgress.memoizedState &&
		              null !== workInProgress.memoizedState.cachePool &&
		              (newProps = workInProgress.memoizedState.cachePool.pool),
		            newProps !== renderLanes && (workInProgress.flags |= 2048),
		            null !== current && pop(resumedCache, workInProgress),
		            null
		          );
		        case 24:
		          return (
		            (renderLanes = null),
		            null !== current && (renderLanes = current.memoizedState.cache),
		            workInProgress.memoizedState.cache !== renderLanes &&
		              (workInProgress.flags |= 2048),
		            popProvider(CacheContext, workInProgress),
		            bubbleProperties(workInProgress),
		            null
		          );
		        case 25:
		          return null;
		        case 30:
		          return null;
		      }
		      throw Error(
		        "Unknown unit of work tag (" +
		          workInProgress.tag +
		          "). This error is likely caused by a bug in React. Please file an issue."
		      );
		    }
		    function unwindWork(current, workInProgress) {
		      popTreeContext(workInProgress);
		      switch (workInProgress.tag) {
		        case 1:
		          return (
		            (current = workInProgress.flags),
		            current & 65536
		              ? ((workInProgress.flags = (current & -65537) | 128),
		                (workInProgress.mode & 2) !== NoMode &&
		                  transferActualDuration(workInProgress),
		                workInProgress)
		              : null
		          );
		        case 3:
		          return (
		            popProvider(CacheContext, workInProgress),
		            popHostContainer(workInProgress),
		            (current = workInProgress.flags),
		            0 !== (current & 65536) && 0 === (current & 128)
		              ? ((workInProgress.flags = (current & -65537) | 128),
		                workInProgress)
		              : null
		          );
		        case 26:
		        case 27:
		        case 5:
		          return popHostContext(workInProgress), null;
		        case 31:
		          if (null !== workInProgress.memoizedState) {
		            popSuspenseHandler(workInProgress);
		            if (null === workInProgress.alternate)
		              throw Error(
		                "Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue."
		              );
		            resetHydrationState();
		          }
		          current = workInProgress.flags;
		          return current & 65536
		            ? ((workInProgress.flags = (current & -65537) | 128),
		              (workInProgress.mode & 2) !== NoMode &&
		                transferActualDuration(workInProgress),
		              workInProgress)
		            : null;
		        case 13:
		          popSuspenseHandler(workInProgress);
		          current = workInProgress.memoizedState;
		          if (null !== current && null !== current.dehydrated) {
		            if (null === workInProgress.alternate)
		              throw Error(
		                "Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue."
		              );
		            resetHydrationState();
		          }
		          current = workInProgress.flags;
		          return current & 65536
		            ? ((workInProgress.flags = (current & -65537) | 128),
		              (workInProgress.mode & 2) !== NoMode &&
		                transferActualDuration(workInProgress),
		              workInProgress)
		            : null;
		        case 19:
		          return pop(suspenseStackCursor, workInProgress), null;
		        case 4:
		          return popHostContainer(workInProgress), null;
		        case 10:
		          return popProvider(workInProgress.type, workInProgress), null;
		        case 22:
		        case 23:
		          return (
		            popSuspenseHandler(workInProgress),
		            popHiddenContext(workInProgress),
		            null !== current && pop(resumedCache, workInProgress),
		            (current = workInProgress.flags),
		            current & 65536
		              ? ((workInProgress.flags = (current & -65537) | 128),
		                (workInProgress.mode & 2) !== NoMode &&
		                  transferActualDuration(workInProgress),
		                workInProgress)
		              : null
		          );
		        case 24:
		          return popProvider(CacheContext, workInProgress), null;
		        case 25:
		          return null;
		        default:
		          return null;
		      }
		    }
		    function unwindInterruptedWork(current, interruptedWork) {
		      popTreeContext(interruptedWork);
		      switch (interruptedWork.tag) {
		        case 3:
		          popProvider(CacheContext, interruptedWork);
		          popHostContainer(interruptedWork);
		          break;
		        case 26:
		        case 27:
		        case 5:
		          popHostContext(interruptedWork);
		          break;
		        case 4:
		          popHostContainer(interruptedWork);
		          break;
		        case 31:
		          null !== interruptedWork.memoizedState &&
		            popSuspenseHandler(interruptedWork);
		          break;
		        case 13:
		          popSuspenseHandler(interruptedWork);
		          break;
		        case 19:
		          pop(suspenseStackCursor, interruptedWork);
		          break;
		        case 10:
		          popProvider(interruptedWork.type, interruptedWork);
		          break;
		        case 22:
		        case 23:
		          popSuspenseHandler(interruptedWork);
		          popHiddenContext(interruptedWork);
		          null !== current && pop(resumedCache, interruptedWork);
		          break;
		        case 24:
		          popProvider(CacheContext, interruptedWork);
		      }
		    }
		    function shouldProfile(current) {
		      return (current.mode & 2) !== NoMode;
		    }
		    function commitHookLayoutEffects(finishedWork, hookFlags) {
		      shouldProfile(finishedWork)
		        ? (startEffectTimer(),
		          commitHookEffectListMount(hookFlags, finishedWork),
		          recordEffectDuration())
		        : commitHookEffectListMount(hookFlags, finishedWork);
		    }
		    function commitHookLayoutUnmountEffects(
		      finishedWork,
		      nearestMountedAncestor,
		      hookFlags
		    ) {
		      shouldProfile(finishedWork)
		        ? (startEffectTimer(),
		          commitHookEffectListUnmount(
		            hookFlags,
		            finishedWork,
		            nearestMountedAncestor
		          ),
		          recordEffectDuration())
		        : commitHookEffectListUnmount(
		            hookFlags,
		            finishedWork,
		            nearestMountedAncestor
		          );
		    }
		    function commitHookEffectListMount(flags, finishedWork) {
		      try {
		        var updateQueue = finishedWork.updateQueue,
		          lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
		        if (null !== lastEffect) {
		          var firstEffect = lastEffect.next;
		          updateQueue = firstEffect;
		          do {
		            if (
		              (updateQueue.tag & flags) === flags &&
		              ((lastEffect = void 0),
		              (flags & Insertion) !== NoFlags &&
		                (isRunningInsertionEffect = !0),
		              (lastEffect = runWithFiberInDEV(
		                finishedWork,
		                callCreateInDEV,
		                updateQueue
		              )),
		              (flags & Insertion) !== NoFlags &&
		                (isRunningInsertionEffect = !1),
		              void 0 !== lastEffect && "function" !== typeof lastEffect)
		            ) {
		              var hookName = void 0;
		              hookName =
		                0 !== (updateQueue.tag & Layout)
		                  ? "useLayoutEffect"
		                  : 0 !== (updateQueue.tag & Insertion)
		                    ? "useInsertionEffect"
		                    : "useEffect";
		              var addendum = void 0;
		              addendum =
		                null === lastEffect
		                  ? " You returned null. If your effect does not require clean up, return undefined (or nothing)."
		                  : "function" === typeof lastEffect.then
		                    ? "\n\nIt looks like you wrote " +
		                      hookName +
		                      "(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:\n\n" +
		                      hookName +
		                      "(() => {\n  async function fetchData() {\n    // You can await here\n    const response = await MyAPI.getData(someId);\n    // ...\n  }\n  fetchData();\n}, [someId]); // Or [] if effect doesn't need props or state\n\nLearn more about data fetching with Hooks: https://react.dev/link/hooks-data-fetching"
		                    : " You returned: " + lastEffect;
		              runWithFiberInDEV(
		                finishedWork,
		                function (n, a) {
		                  console.error(
		                    "%s must not return anything besides a function, which is used for clean-up.%s",
		                    n,
		                    a
		                  );
		                },
		                hookName,
		                addendum
		              );
		            }
		            updateQueue = updateQueue.next;
		          } while (updateQueue !== firstEffect);
		        }
		      } catch (error) {
		        captureCommitPhaseError(finishedWork, finishedWork.return, error);
		      }
		    }
		    function commitHookEffectListUnmount(
		      flags,
		      finishedWork,
		      nearestMountedAncestor
		    ) {
		      try {
		        var updateQueue = finishedWork.updateQueue,
		          lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
		        if (null !== lastEffect) {
		          var firstEffect = lastEffect.next;
		          updateQueue = firstEffect;
		          do {
		            if ((updateQueue.tag & flags) === flags) {
		              var inst = updateQueue.inst,
		                destroy = inst.destroy;
		              void 0 !== destroy &&
		                ((inst.destroy = void 0),
		                (flags & Insertion) !== NoFlags &&
		                  (isRunningInsertionEffect = !0),
		                (lastEffect = finishedWork),
		                runWithFiberInDEV(
		                  lastEffect,
		                  callDestroyInDEV,
		                  lastEffect,
		                  nearestMountedAncestor,
		                  destroy
		                ),
		                (flags & Insertion) !== NoFlags &&
		                  (isRunningInsertionEffect = !1));
		            }
		            updateQueue = updateQueue.next;
		          } while (updateQueue !== firstEffect);
		        }
		      } catch (error) {
		        captureCommitPhaseError(finishedWork, finishedWork.return, error);
		      }
		    }
		    function commitHookPassiveMountEffects(finishedWork, hookFlags) {
		      shouldProfile(finishedWork)
		        ? (startEffectTimer(),
		          commitHookEffectListMount(hookFlags, finishedWork),
		          recordEffectDuration())
		        : commitHookEffectListMount(hookFlags, finishedWork);
		    }
		    function commitHookPassiveUnmountEffects(
		      finishedWork,
		      nearestMountedAncestor,
		      hookFlags
		    ) {
		      shouldProfile(finishedWork)
		        ? (startEffectTimer(),
		          commitHookEffectListUnmount(
		            hookFlags,
		            finishedWork,
		            nearestMountedAncestor
		          ),
		          recordEffectDuration())
		        : commitHookEffectListUnmount(
		            hookFlags,
		            finishedWork,
		            nearestMountedAncestor
		          );
		    }
		    function commitClassCallbacks(finishedWork) {
		      var updateQueue = finishedWork.updateQueue;
		      if (null !== updateQueue) {
		        var instance = finishedWork.stateNode;
		        finishedWork.type.defaultProps ||
		          "ref" in finishedWork.memoizedProps ||
		          didWarnAboutReassigningProps ||
		          (instance.props !== finishedWork.memoizedProps &&
		            console.error(
		              "Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
		              getComponentNameFromFiber(finishedWork) || "instance"
		            ),
		          instance.state !== finishedWork.memoizedState &&
		            console.error(
		              "Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
		              getComponentNameFromFiber(finishedWork) || "instance"
		            ));
		        try {
		          runWithFiberInDEV(
		            finishedWork,
		            commitCallbacks,
		            updateQueue,
		            instance
		          );
		        } catch (error) {
		          captureCommitPhaseError(finishedWork, finishedWork.return, error);
		        }
		      }
		    }
		    function callGetSnapshotBeforeUpdates(instance, prevProps, prevState) {
		      return instance.getSnapshotBeforeUpdate(prevProps, prevState);
		    }
		    function commitClassSnapshot(finishedWork, current) {
		      var prevProps = current.memoizedProps,
		        prevState = current.memoizedState;
		      current = finishedWork.stateNode;
		      finishedWork.type.defaultProps ||
		        "ref" in finishedWork.memoizedProps ||
		        didWarnAboutReassigningProps ||
		        (current.props !== finishedWork.memoizedProps &&
		          console.error(
		            "Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
		            getComponentNameFromFiber(finishedWork) || "instance"
		          ),
		        current.state !== finishedWork.memoizedState &&
		          console.error(
		            "Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
		            getComponentNameFromFiber(finishedWork) || "instance"
		          ));
		      try {
		        var resolvedPrevProps = resolveClassComponentProps(
		          finishedWork.type,
		          prevProps
		        );
		        var snapshot = runWithFiberInDEV(
		          finishedWork,
		          callGetSnapshotBeforeUpdates,
		          current,
		          resolvedPrevProps,
		          prevState
		        );
		        prevProps = didWarnAboutUndefinedSnapshotBeforeUpdate;
		        void 0 !== snapshot ||
		          prevProps.has(finishedWork.type) ||
		          (prevProps.add(finishedWork.type),
		          runWithFiberInDEV(finishedWork, function () {
		            console.error(
		              "%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.",
		              getComponentNameFromFiber(finishedWork)
		            );
		          }));
		        current.__reactInternalSnapshotBeforeUpdate = snapshot;
		      } catch (error) {
		        captureCommitPhaseError(finishedWork, finishedWork.return, error);
		      }
		    }
		    function safelyCallComponentWillUnmount(
		      current,
		      nearestMountedAncestor,
		      instance
		    ) {
		      instance.props = resolveClassComponentProps(
		        current.type,
		        current.memoizedProps
		      );
		      instance.state = current.memoizedState;
		      shouldProfile(current)
		        ? (startEffectTimer(),
		          runWithFiberInDEV(
		            current,
		            callComponentWillUnmountInDEV,
		            current,
		            nearestMountedAncestor,
		            instance
		          ),
		          recordEffectDuration())
		        : runWithFiberInDEV(
		            current,
		            callComponentWillUnmountInDEV,
		            current,
		            nearestMountedAncestor,
		            instance
		          );
		    }
		    function commitAttachRef(finishedWork) {
		      var ref = finishedWork.ref;
		      if (null !== ref) {
		        switch (finishedWork.tag) {
		          case 26:
		          case 27:
		          case 5:
		            var instanceToUse = getPublicInstance(finishedWork.stateNode);
		            break;
		          case 30:
		            instanceToUse = finishedWork.stateNode;
		            break;
		          default:
		            instanceToUse = finishedWork.stateNode;
		        }
		        if ("function" === typeof ref)
		          if (shouldProfile(finishedWork))
		            try {
		              startEffectTimer(),
		                (finishedWork.refCleanup = ref(instanceToUse));
		            } finally {
		              recordEffectDuration();
		            }
		          else finishedWork.refCleanup = ref(instanceToUse);
		        else
		          "string" === typeof ref
		            ? console.error("String refs are no longer supported.")
		            : ref.hasOwnProperty("current") ||
		              console.error(
		                "Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().",
		                getComponentNameFromFiber(finishedWork)
		              ),
		            (ref.current = instanceToUse);
		      }
		    }
		    function safelyAttachRef(current, nearestMountedAncestor) {
		      try {
		        runWithFiberInDEV(current, commitAttachRef, current);
		      } catch (error) {
		        captureCommitPhaseError(current, nearestMountedAncestor, error);
		      }
		    }
		    function safelyDetachRef(current, nearestMountedAncestor) {
		      var ref = current.ref,
		        refCleanup = current.refCleanup;
		      if (null !== ref)
		        if ("function" === typeof refCleanup)
		          try {
		            if (shouldProfile(current))
		              try {
		                startEffectTimer(), runWithFiberInDEV(current, refCleanup);
		              } finally {
		                recordEffectDuration(current);
		              }
		            else runWithFiberInDEV(current, refCleanup);
		          } catch (error) {
		            captureCommitPhaseError(current, nearestMountedAncestor, error);
		          } finally {
		            (current.refCleanup = null),
		              (current = current.alternate),
		              null != current && (current.refCleanup = null);
		          }
		        else if ("function" === typeof ref)
		          try {
		            if (shouldProfile(current))
		              try {
		                startEffectTimer(), runWithFiberInDEV(current, ref, null);
		              } finally {
		                recordEffectDuration(current);
		              }
		            else runWithFiberInDEV(current, ref, null);
		          } catch (error$3) {
		            captureCommitPhaseError(current, nearestMountedAncestor, error$3);
		          }
		        else ref.current = null;
		    }
		    function commitProfiler(
		      finishedWork,
		      current,
		      commitStartTime,
		      effectDuration
		    ) {
		      var _finishedWork$memoize = finishedWork.memoizedProps,
		        id = _finishedWork$memoize.id,
		        onCommit = _finishedWork$memoize.onCommit;
		      _finishedWork$memoize = _finishedWork$memoize.onRender;
		      current = null === current ? "mount" : "update";
		      currentUpdateIsNested && (current = "nested-update");
		      "function" === typeof _finishedWork$memoize &&
		        _finishedWork$memoize(
		          id,
		          current,
		          finishedWork.actualDuration,
		          finishedWork.treeBaseDuration,
		          finishedWork.actualStartTime,
		          commitStartTime
		        );
		      "function" === typeof onCommit &&
		        onCommit(id, current, effectDuration, commitStartTime);
		    }
		    function commitProfilerPostCommitImpl(
		      finishedWork,
		      current,
		      commitStartTime,
		      passiveEffectDuration
		    ) {
		      var _finishedWork$memoize2 = finishedWork.memoizedProps;
		      finishedWork = _finishedWork$memoize2.id;
		      _finishedWork$memoize2 = _finishedWork$memoize2.onPostCommit;
		      current = null === current ? "mount" : "update";
		      currentUpdateIsNested && (current = "nested-update");
		      "function" === typeof _finishedWork$memoize2 &&
		        _finishedWork$memoize2(
		          finishedWork,
		          current,
		          passiveEffectDuration,
		          commitStartTime
		        );
		    }
		    function commitHostMount(finishedWork) {
		      var type = finishedWork.type,
		        props = finishedWork.memoizedProps,
		        instance = finishedWork.stateNode;
		      try {
		        runWithFiberInDEV(
		          finishedWork,
		          commitMount,
		          instance,
		          type,
		          props,
		          finishedWork
		        );
		      } catch (error) {
		        captureCommitPhaseError(finishedWork, finishedWork.return, error);
		      }
		    }
		    function commitHostUpdate(finishedWork, newProps, oldProps) {
		      try {
		        runWithFiberInDEV(
		          finishedWork,
		          commitUpdate,
		          finishedWork.stateNode,
		          finishedWork.type,
		          oldProps,
		          newProps,
		          finishedWork
		        );
		      } catch (error) {
		        captureCommitPhaseError(finishedWork, finishedWork.return, error);
		      }
		    }
		    function isHostParent(fiber) {
		      return (
		        5 === fiber.tag ||
		        3 === fiber.tag ||
		        (supportsResources ? 26 === fiber.tag : false) ||
		        (supportsSingletons
		          ? 27 === fiber.tag && isSingletonScope(fiber.type)
		          : false) ||
		        4 === fiber.tag
		      );
		    }
		    function getHostSibling(fiber) {
		      a: for (;;) {
		        for (; null === fiber.sibling; ) {
		          if (null === fiber.return || isHostParent(fiber.return)) return null;
		          fiber = fiber.return;
		        }
		        fiber.sibling.return = fiber.return;
		        for (
		          fiber = fiber.sibling;
		          5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;

		        ) {
		          if (
		            supportsSingletons &&
		            27 === fiber.tag &&
		            isSingletonScope(fiber.type)
		          )
		            continue a;
		          if (fiber.flags & 2) continue a;
		          if (null === fiber.child || 4 === fiber.tag) continue a;
		          else (fiber.child.return = fiber), (fiber = fiber.child);
		        }
		        if (!(fiber.flags & 2)) return fiber.stateNode;
		      }
		    }
		    function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
		      var tag = node.tag;
		      if (5 === tag || 6 === tag)
		        (node = node.stateNode),
		          before
		            ? insertInContainerBefore(parent, node, before)
		            : appendChildToContainer(parent, node);
		      else if (
		        4 !== tag &&
		        (supportsSingletons &&
		          27 === tag &&
		          isSingletonScope(node.type) &&
		          ((parent = node.stateNode), (before = null)),
		        (node = node.child),
		        null !== node)
		      )
		        for (
		          insertOrAppendPlacementNodeIntoContainer(node, before, parent),
		            node = node.sibling;
		          null !== node;

		        )
		          insertOrAppendPlacementNodeIntoContainer(node, before, parent),
		            (node = node.sibling);
		    }
		    function insertOrAppendPlacementNode(node, before, parent) {
		      var tag = node.tag;
		      if (5 === tag || 6 === tag)
		        (node = node.stateNode),
		          before
		            ? insertBefore(parent, node, before)
		            : appendChild(parent, node);
		      else if (
		        4 !== tag &&
		        (supportsSingletons &&
		          27 === tag &&
		          isSingletonScope(node.type) &&
		          (parent = node.stateNode),
		        (node = node.child),
		        null !== node)
		      )
		        for (
		          insertOrAppendPlacementNode(node, before, parent),
		            node = node.sibling;
		          null !== node;

		        )
		          insertOrAppendPlacementNode(node, before, parent),
		            (node = node.sibling);
		    }
		    function commitPlacement(finishedWork) {
		      for (
		        var hostParentFiber, parentFiber = finishedWork.return;
		        null !== parentFiber;

		      ) {
		        if (isHostParent(parentFiber)) {
		          hostParentFiber = parentFiber;
		          break;
		        }
		        parentFiber = parentFiber.return;
		      }
		      if (supportsMutation) {
		        if (null == hostParentFiber)
		          throw Error(
		            "Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue."
		          );
		        switch (hostParentFiber.tag) {
		          case 27:
		            if (supportsSingletons) {
		              hostParentFiber = hostParentFiber.stateNode;
		              parentFiber = getHostSibling(finishedWork);
		              insertOrAppendPlacementNode(
		                finishedWork,
		                parentFiber,
		                hostParentFiber
		              );
		              break;
		            }
		          case 5:
		            parentFiber = hostParentFiber.stateNode;
		            hostParentFiber.flags & 32 &&
		              (resetTextContent(parentFiber), (hostParentFiber.flags &= -33));
		            hostParentFiber = getHostSibling(finishedWork);
		            insertOrAppendPlacementNode(
		              finishedWork,
		              hostParentFiber,
		              parentFiber
		            );
		            break;
		          case 3:
		          case 4:
		            hostParentFiber = hostParentFiber.stateNode.containerInfo;
		            parentFiber = getHostSibling(finishedWork);
		            insertOrAppendPlacementNodeIntoContainer(
		              finishedWork,
		              parentFiber,
		              hostParentFiber
		            );
		            break;
		          default:
		            throw Error(
		              "Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue."
		            );
		        }
		      }
		    }
		    function commitHostPortalContainerChildren(
		      portal,
		      finishedWork,
		      pendingChildren
		    ) {
		      portal = portal.containerInfo;
		      try {
		        runWithFiberInDEV(
		          finishedWork,
		          replaceContainerChildren,
		          portal,
		          pendingChildren
		        );
		      } catch (error) {
		        captureCommitPhaseError(finishedWork, finishedWork.return, error);
		      }
		    }
		    function commitHostSingletonAcquisition(finishedWork) {
		      var singleton = finishedWork.stateNode,
		        props = finishedWork.memoizedProps;
		      try {
		        runWithFiberInDEV(
		          finishedWork,
		          acquireSingletonInstance,
		          finishedWork.type,
		          props,
		          singleton,
		          finishedWork
		        );
		      } catch (error) {
		        captureCommitPhaseError(finishedWork, finishedWork.return, error);
		      }
		    }
		    function isHydratingParent(current, finishedWork) {
		      return 31 === finishedWork.tag
		        ? ((finishedWork = finishedWork.memoizedState),
		          null !== current.memoizedState && null === finishedWork)
		        : 13 === finishedWork.tag
		          ? ((current = current.memoizedState),
		            (finishedWork = finishedWork.memoizedState),
		            null !== current &&
		              null !== current.dehydrated &&
		              (null === finishedWork || null === finishedWork.dehydrated))
		          : 3 === finishedWork.tag
		            ? current.memoizedState.isDehydrated &&
		              0 === (finishedWork.flags & 256)
		            : false;
		    }
		    function commitBeforeMutationEffects(root, firstChild) {
		      prepareForCommit(root.containerInfo);
		      for (nextEffect = firstChild; null !== nextEffect; )
		        if (
		          ((root = nextEffect),
		          (firstChild = root.child),
		          0 !== (root.subtreeFlags & 1028) && null !== firstChild)
		        )
		          (firstChild.return = root), (nextEffect = firstChild);
		        else
		          for (; null !== nextEffect; ) {
		            firstChild = root = nextEffect;
		            var current = firstChild.alternate,
		              flags = firstChild.flags;
		            switch (firstChild.tag) {
		              case 0:
		                if (
		                  0 !== (flags & 4) &&
		                  ((firstChild = firstChild.updateQueue),
		                  (firstChild = null !== firstChild ? firstChild.events : null),
		                  null !== firstChild)
		                )
		                  for (current = 0; current < firstChild.length; current++)
		                    (flags = firstChild[current]),
		                      (flags.ref.impl = flags.nextImpl);
		                break;
		              case 11:
		              case 15:
		                break;
		              case 1:
		                0 !== (flags & 1024) &&
		                  null !== current &&
		                  commitClassSnapshot(firstChild, current);
		                break;
		              case 3:
		                0 !== (flags & 1024) &&
		                  supportsMutation &&
		                  clearContainer(firstChild.stateNode.containerInfo);
		                break;
		              case 5:
		              case 26:
		              case 27:
		              case 6:
		              case 4:
		              case 17:
		                break;
		              default:
		                if (0 !== (flags & 1024))
		                  throw Error(
		                    "This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue."
		                  );
		            }
		            firstChild = root.sibling;
		            if (null !== firstChild) {
		              firstChild.return = root.return;
		              nextEffect = firstChild;
		              break;
		            }
		            nextEffect = root.return;
		          }
		    }
		    function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
		      var prevEffectStart = pushComponentEffectStart(),
		        prevEffectDuration = pushComponentEffectDuration(),
		        prevEffectErrors = pushComponentEffectErrors(),
		        prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(),
		        flags = finishedWork.flags;
		      switch (finishedWork.tag) {
		        case 0:
		        case 11:
		        case 15:
		          recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
		          flags & 4 &&
		            commitHookLayoutEffects(finishedWork, Layout | HasEffect);
		          break;
		        case 1:
		          recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
		          if (flags & 4)
		            if (((finishedRoot = finishedWork.stateNode), null === current))
		              finishedWork.type.defaultProps ||
		                "ref" in finishedWork.memoizedProps ||
		                didWarnAboutReassigningProps ||
		                (finishedRoot.props !== finishedWork.memoizedProps &&
		                  console.error(
		                    "Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
		                    getComponentNameFromFiber(finishedWork) || "instance"
		                  ),
		                finishedRoot.state !== finishedWork.memoizedState &&
		                  console.error(
		                    "Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
		                    getComponentNameFromFiber(finishedWork) || "instance"
		                  )),
		                shouldProfile(finishedWork)
		                  ? (startEffectTimer(),
		                    runWithFiberInDEV(
		                      finishedWork,
		                      callComponentDidMountInDEV,
		                      finishedWork,
		                      finishedRoot
		                    ),
		                    recordEffectDuration())
		                  : runWithFiberInDEV(
		                      finishedWork,
		                      callComponentDidMountInDEV,
		                      finishedWork,
		                      finishedRoot
		                    );
		            else {
		              var prevProps = resolveClassComponentProps(
		                finishedWork.type,
		                current.memoizedProps
		              );
		              current = current.memoizedState;
		              finishedWork.type.defaultProps ||
		                "ref" in finishedWork.memoizedProps ||
		                didWarnAboutReassigningProps ||
		                (finishedRoot.props !== finishedWork.memoizedProps &&
		                  console.error(
		                    "Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
		                    getComponentNameFromFiber(finishedWork) || "instance"
		                  ),
		                finishedRoot.state !== finishedWork.memoizedState &&
		                  console.error(
		                    "Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
		                    getComponentNameFromFiber(finishedWork) || "instance"
		                  ));
		              shouldProfile(finishedWork)
		                ? (startEffectTimer(),
		                  runWithFiberInDEV(
		                    finishedWork,
		                    callComponentDidUpdateInDEV,
		                    finishedWork,
		                    finishedRoot,
		                    prevProps,
		                    current,
		                    finishedRoot.__reactInternalSnapshotBeforeUpdate
		                  ),
		                  recordEffectDuration())
		                : runWithFiberInDEV(
		                    finishedWork,
		                    callComponentDidUpdateInDEV,
		                    finishedWork,
		                    finishedRoot,
		                    prevProps,
		                    current,
		                    finishedRoot.__reactInternalSnapshotBeforeUpdate
		                  );
		            }
		          flags & 64 && commitClassCallbacks(finishedWork);
		          flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
		          break;
		        case 3:
		          current = pushNestedEffectDurations();
		          recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
		          if (
		            flags & 64 &&
		            ((flags = finishedWork.updateQueue), null !== flags)
		          ) {
		            prevProps = null;
		            if (null !== finishedWork.child)
		              switch (finishedWork.child.tag) {
		                case 27:
		                case 5:
		                  prevProps = getPublicInstance(finishedWork.child.stateNode);
		                  break;
		                case 1:
		                  prevProps = finishedWork.child.stateNode;
		              }
		            try {
		              runWithFiberInDEV(
		                finishedWork,
		                commitCallbacks,
		                flags,
		                prevProps
		              );
		            } catch (error) {
		              captureCommitPhaseError(finishedWork, finishedWork.return, error);
		            }
		          }
		          finishedRoot.effectDuration += popNestedEffectDurations(current);
		          break;
		        case 27:
		          supportsSingletons &&
		            null === current &&
		            flags & 4 &&
		            commitHostSingletonAcquisition(finishedWork);
		        case 26:
		        case 5:
		          recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
		          if (null === current)
		            if (flags & 4) commitHostMount(finishedWork);
		            else if (flags & 64) {
		              finishedRoot = finishedWork.type;
		              current = finishedWork.memoizedProps;
		              prevProps = finishedWork.stateNode;
		              try {
		                runWithFiberInDEV(
		                  finishedWork,
		                  commitHydratedInstance,
		                  prevProps,
		                  finishedRoot,
		                  current,
		                  finishedWork
		                );
		              } catch (error) {
		                captureCommitPhaseError(
		                  finishedWork,
		                  finishedWork.return,
		                  error
		                );
		              }
		            }
		          flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
		          break;
		        case 12:
		          if (flags & 4) {
		            flags = pushNestedEffectDurations();
		            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
		            finishedRoot = finishedWork.stateNode;
		            finishedRoot.effectDuration += bubbleNestedEffectDurations(flags);
		            try {
		              runWithFiberInDEV(
		                finishedWork,
		                commitProfiler,
		                finishedWork,
		                current,
		                commitStartTime,
		                finishedRoot.effectDuration
		              );
		            } catch (error) {
		              captureCommitPhaseError(finishedWork, finishedWork.return, error);
		            }
		          } else recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
		          break;
		        case 31:
		          recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
		          flags & 4 &&
		            commitActivityHydrationCallbacks(finishedRoot, finishedWork);
		          break;
		        case 13:
		          recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
		          flags & 4 &&
		            commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
		          flags & 64 &&
		            ((finishedRoot = finishedWork.memoizedState),
		            null !== finishedRoot &&
		              ((finishedRoot = finishedRoot.dehydrated),
		              null !== finishedRoot &&
		                ((flags = retryDehydratedSuspenseBoundary.bind(
		                  null,
		                  finishedWork
		                )),
		                registerSuspenseInstanceRetry(finishedRoot, flags))));
		          break;
		        case 22:
		          flags =
		            null !== finishedWork.memoizedState || offscreenSubtreeIsHidden;
		          if (!flags) {
		            current =
		              (null !== current && null !== current.memoizedState) ||
		              offscreenSubtreeWasHidden;
		            prevProps = offscreenSubtreeIsHidden;
		            var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
		            offscreenSubtreeIsHidden = flags;
		            (offscreenSubtreeWasHidden = current) &&
		            !prevOffscreenSubtreeWasHidden
		              ? (recursivelyTraverseReappearLayoutEffects(
		                  finishedRoot,
		                  finishedWork,
		                  0 !== (finishedWork.subtreeFlags & 8772)
		                ),
		                (finishedWork.mode & 2) !== NoMode &&
		                  0 <= componentEffectStartTime &&
		                  0 <= componentEffectEndTime &&
		                  0.05 < componentEffectEndTime - componentEffectStartTime &&
		                  logComponentReappeared(
		                    finishedWork,
		                    componentEffectStartTime,
		                    componentEffectEndTime
		                  ))
		              : recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
		            offscreenSubtreeIsHidden = prevProps;
		            offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
		          }
		          break;
		        case 30:
		          break;
		        default:
		          recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
		      }
		      (finishedWork.mode & 2) !== NoMode &&
		        0 <= componentEffectStartTime &&
		        0 <= componentEffectEndTime &&
		        ((componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) &&
		          logComponentEffect(
		            finishedWork,
		            componentEffectStartTime,
		            componentEffectEndTime,
		            componentEffectDuration,
		            componentEffectErrors
		          ),
		        null === finishedWork.alternate &&
		          null !== finishedWork.return &&
		          null !== finishedWork.return.alternate &&
		          0.05 < componentEffectEndTime - componentEffectStartTime &&
		          (isHydratingParent(
		            finishedWork.return.alternate,
		            finishedWork.return
		          ) ||
		            logComponentTrigger(
		              finishedWork,
		              componentEffectStartTime,
		              componentEffectEndTime,
		              "Mount"
		            )));
		      popComponentEffectStart(prevEffectStart);
		      popComponentEffectDuration(prevEffectDuration);
		      componentEffectErrors = prevEffectErrors;
		      componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
		    }
		    function detachFiberAfterEffects(fiber) {
		      var alternate = fiber.alternate;
		      null !== alternate &&
		        ((fiber.alternate = null), detachFiberAfterEffects(alternate));
		      fiber.child = null;
		      fiber.deletions = null;
		      fiber.sibling = null;
		      5 === fiber.tag &&
		        ((alternate = fiber.stateNode),
		        null !== alternate && detachDeletedInstance(alternate));
		      fiber.stateNode = null;
		      fiber._debugOwner = null;
		      fiber.return = null;
		      fiber.dependencies = null;
		      fiber.memoizedProps = null;
		      fiber.memoizedState = null;
		      fiber.pendingProps = null;
		      fiber.stateNode = null;
		      fiber.updateQueue = null;
		    }
		    function recursivelyTraverseDeletionEffects(
		      finishedRoot,
		      nearestMountedAncestor,
		      parent
		    ) {
		      for (parent = parent.child; null !== parent; )
		        commitDeletionEffectsOnFiber(
		          finishedRoot,
		          nearestMountedAncestor,
		          parent
		        ),
		          (parent = parent.sibling);
		    }
		    function commitDeletionEffectsOnFiber(
		      finishedRoot,
		      nearestMountedAncestor,
		      deletedFiber
		    ) {
		      if (
		        injectedHook &&
		        "function" === typeof injectedHook.onCommitFiberUnmount
		      )
		        try {
		          injectedHook.onCommitFiberUnmount(rendererID, deletedFiber);
		        } catch (err) {
		          hasLoggedError ||
		            ((hasLoggedError = true),
		            console.error(
		              "React instrumentation encountered an error: %o",
		              err
		            ));
		        }
		      var prevEffectStart = pushComponentEffectStart(),
		        prevEffectDuration = pushComponentEffectDuration(),
		        prevEffectErrors = pushComponentEffectErrors(),
		        prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
		      switch (deletedFiber.tag) {
		        case 26:
		          if (supportsResources) {
		            offscreenSubtreeWasHidden ||
		              safelyDetachRef(deletedFiber, nearestMountedAncestor);
		            recursivelyTraverseDeletionEffects(
		              finishedRoot,
		              nearestMountedAncestor,
		              deletedFiber
		            );
		            deletedFiber.memoizedState
		              ? releaseResource(deletedFiber.memoizedState)
		              : deletedFiber.stateNode &&
		                unmountHoistable(deletedFiber.stateNode);
		            break;
		          }
		        case 27:
		          if (supportsSingletons) {
		            offscreenSubtreeWasHidden ||
		              safelyDetachRef(deletedFiber, nearestMountedAncestor);
		            var prevHostParent = hostParent,
		              prevHostParentIsContainer = hostParentIsContainer;
		            isSingletonScope(deletedFiber.type) &&
		              ((hostParent = deletedFiber.stateNode),
		              (hostParentIsContainer = false));
		            recursivelyTraverseDeletionEffects(
		              finishedRoot,
		              nearestMountedAncestor,
		              deletedFiber
		            );
		            runWithFiberInDEV(
		              deletedFiber,
		              releaseSingletonInstance,
		              deletedFiber.stateNode
		            );
		            hostParent = prevHostParent;
		            hostParentIsContainer = prevHostParentIsContainer;
		            break;
		          }
		        case 5:
		          offscreenSubtreeWasHidden ||
		            safelyDetachRef(deletedFiber, nearestMountedAncestor);
		        case 6:
		          if (supportsMutation) {
		            if (
		              ((prevHostParent = hostParent),
		              (prevHostParentIsContainer = hostParentIsContainer),
		              (hostParent = null),
		              recursivelyTraverseDeletionEffects(
		                finishedRoot,
		                nearestMountedAncestor,
		                deletedFiber
		              ),
		              (hostParent = prevHostParent),
		              (hostParentIsContainer = prevHostParentIsContainer),
		              null !== hostParent)
		            )
		              if (hostParentIsContainer)
		                try {
		                  runWithFiberInDEV(
		                    deletedFiber,
		                    removeChildFromContainer,
		                    hostParent,
		                    deletedFiber.stateNode
		                  );
		                } catch (error) {
		                  captureCommitPhaseError(
		                    deletedFiber,
		                    nearestMountedAncestor,
		                    error
		                  );
		                }
		              else
		                try {
		                  runWithFiberInDEV(
		                    deletedFiber,
		                    removeChild,
		                    hostParent,
		                    deletedFiber.stateNode
		                  );
		                } catch (error) {
		                  captureCommitPhaseError(
		                    deletedFiber,
		                    nearestMountedAncestor,
		                    error
		                  );
		                }
		          } else
		            recursivelyTraverseDeletionEffects(
		              finishedRoot,
		              nearestMountedAncestor,
		              deletedFiber
		            );
		          break;
		        case 18:
		          supportsMutation &&
		            null !== hostParent &&
		            (hostParentIsContainer
		              ? clearSuspenseBoundaryFromContainer(
		                  hostParent,
		                  deletedFiber.stateNode
		                )
		              : clearSuspenseBoundary(hostParent, deletedFiber.stateNode));
		          break;
		        case 4:
		          supportsMutation
		            ? ((prevHostParent = hostParent),
		              (prevHostParentIsContainer = hostParentIsContainer),
		              (hostParent = deletedFiber.stateNode.containerInfo),
		              (hostParentIsContainer = true),
		              recursivelyTraverseDeletionEffects(
		                finishedRoot,
		                nearestMountedAncestor,
		                deletedFiber
		              ),
		              (hostParent = prevHostParent),
		              (hostParentIsContainer = prevHostParentIsContainer))
		            : (supportsPersistence &&
		                commitHostPortalContainerChildren(
		                  deletedFiber.stateNode,
		                  deletedFiber,
		                  createContainerChildSet()
		                ),
		              recursivelyTraverseDeletionEffects(
		                finishedRoot,
		                nearestMountedAncestor,
		                deletedFiber
		              ));
		          break;
		        case 0:
		        case 11:
		        case 14:
		        case 15:
		          commitHookEffectListUnmount(
		            Insertion,
		            deletedFiber,
		            nearestMountedAncestor
		          );
		          offscreenSubtreeWasHidden ||
		            commitHookLayoutUnmountEffects(
		              deletedFiber,
		              nearestMountedAncestor,
		              Layout
		            );
		          recursivelyTraverseDeletionEffects(
		            finishedRoot,
		            nearestMountedAncestor,
		            deletedFiber
		          );
		          break;
		        case 1:
		          offscreenSubtreeWasHidden ||
		            (safelyDetachRef(deletedFiber, nearestMountedAncestor),
		            (prevHostParent = deletedFiber.stateNode),
		            "function" === typeof prevHostParent.componentWillUnmount &&
		              safelyCallComponentWillUnmount(
		                deletedFiber,
		                nearestMountedAncestor,
		                prevHostParent
		              ));
		          recursivelyTraverseDeletionEffects(
		            finishedRoot,
		            nearestMountedAncestor,
		            deletedFiber
		          );
		          break;
		        case 21:
		          recursivelyTraverseDeletionEffects(
		            finishedRoot,
		            nearestMountedAncestor,
		            deletedFiber
		          );
		          break;
		        case 22:
		          offscreenSubtreeWasHidden =
		            (prevHostParent = offscreenSubtreeWasHidden) ||
		            null !== deletedFiber.memoizedState;
		          recursivelyTraverseDeletionEffects(
		            finishedRoot,
		            nearestMountedAncestor,
		            deletedFiber
		          );
		          offscreenSubtreeWasHidden = prevHostParent;
		          break;
		        default:
		          recursivelyTraverseDeletionEffects(
		            finishedRoot,
		            nearestMountedAncestor,
		            deletedFiber
		          );
		      }
		      (deletedFiber.mode & 2) !== NoMode &&
		        0 <= componentEffectStartTime &&
		        0 <= componentEffectEndTime &&
		        (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) &&
		        logComponentEffect(
		          deletedFiber,
		          componentEffectStartTime,
		          componentEffectEndTime,
		          componentEffectDuration,
		          componentEffectErrors
		        );
		      popComponentEffectStart(prevEffectStart);
		      popComponentEffectDuration(prevEffectDuration);
		      componentEffectErrors = prevEffectErrors;
		      componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
		    }
		    function commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
		      if (
		        supportsHydration &&
		        null === finishedWork.memoizedState &&
		        ((finishedRoot = finishedWork.alternate),
		        null !== finishedRoot &&
		          ((finishedRoot = finishedRoot.memoizedState), null !== finishedRoot))
		      ) {
		        finishedRoot = finishedRoot.dehydrated;
		        try {
		          runWithFiberInDEV(
		            finishedWork,
		            commitHydratedActivityInstance,
		            finishedRoot
		          );
		        } catch (error) {
		          captureCommitPhaseError(finishedWork, finishedWork.return, error);
		        }
		      }
		    }
		    function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
		      if (
		        supportsHydration &&
		        null === finishedWork.memoizedState &&
		        ((finishedRoot = finishedWork.alternate),
		        null !== finishedRoot &&
		          ((finishedRoot = finishedRoot.memoizedState),
		          null !== finishedRoot &&
		            ((finishedRoot = finishedRoot.dehydrated), null !== finishedRoot)))
		      )
		        try {
		          runWithFiberInDEV(
		            finishedWork,
		            commitHydratedSuspenseInstance,
		            finishedRoot
		          );
		        } catch (error) {
		          captureCommitPhaseError(finishedWork, finishedWork.return, error);
		        }
		    }
		    function getRetryCache(finishedWork) {
		      switch (finishedWork.tag) {
		        case 31:
		        case 13:
		        case 19:
		          var retryCache = finishedWork.stateNode;
		          null === retryCache &&
		            (retryCache = finishedWork.stateNode = new PossiblyWeakSet());
		          return retryCache;
		        case 22:
		          return (
		            (finishedWork = finishedWork.stateNode),
		            (retryCache = finishedWork._retryCache),
		            null === retryCache &&
		              (retryCache = finishedWork._retryCache = new PossiblyWeakSet()),
		            retryCache
		          );
		        default:
		          throw Error(
		            "Unexpected Suspense handler tag (" +
		              finishedWork.tag +
		              "). This is a bug in React."
		          );
		      }
		    }
		    function attachSuspenseRetryListeners(finishedWork, wakeables) {
		      var retryCache = getRetryCache(finishedWork);
		      wakeables.forEach(function (wakeable) {
		        if (!retryCache.has(wakeable)) {
		          retryCache.add(wakeable);
		          if (isDevToolsPresent)
		            if (null !== inProgressLanes && null !== inProgressRoot)
		              restorePendingUpdaters(inProgressRoot, inProgressLanes);
		            else
		              throw Error(
		                "Expected finished root and lanes to be set. This is a bug in React."
		              );
		          var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
		          wakeable.then(retry, retry);
		        }
		      });
		    }
		    function recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
		      var deletions = parentFiber.deletions;
		      if (null !== deletions)
		        for (var i = 0; i < deletions.length; i++) {
		          var root = root$jscomp$0,
		            returnFiber = parentFiber,
		            deletedFiber = deletions[i],
		            prevEffectStart = pushComponentEffectStart();
		          if (supportsMutation) {
		            var parent = returnFiber;
		            a: for (; null !== parent; ) {
		              switch (parent.tag) {
		                case 27:
		                  if (supportsSingletons) {
		                    if (isSingletonScope(parent.type)) {
		                      hostParent = parent.stateNode;
		                      hostParentIsContainer = false;
		                      break a;
		                    }
		                    break;
		                  }
		                case 5:
		                  hostParent = parent.stateNode;
		                  hostParentIsContainer = false;
		                  break a;
		                case 3:
		                case 4:
		                  hostParent = parent.stateNode.containerInfo;
		                  hostParentIsContainer = true;
		                  break a;
		              }
		              parent = parent.return;
		            }
		            if (null === hostParent)
		              throw Error(
		                "Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue."
		              );
		            commitDeletionEffectsOnFiber(root, returnFiber, deletedFiber);
		            hostParent = null;
		            hostParentIsContainer = false;
		          } else commitDeletionEffectsOnFiber(root, returnFiber, deletedFiber);
		          (deletedFiber.mode & 2) !== NoMode &&
		            0 <= componentEffectStartTime &&
		            0 <= componentEffectEndTime &&
		            0.05 < componentEffectEndTime - componentEffectStartTime &&
		            logComponentTrigger(
		              deletedFiber,
		              componentEffectStartTime,
		              componentEffectEndTime,
		              "Unmount"
		            );
		          popComponentEffectStart(prevEffectStart);
		          root = deletedFiber;
		          returnFiber = root.alternate;
		          null !== returnFiber && (returnFiber.return = null);
		          root.return = null;
		        }
		      if (parentFiber.subtreeFlags & 13886)
		        for (parentFiber = parentFiber.child; null !== parentFiber; )
		          commitMutationEffectsOnFiber(parentFiber, root$jscomp$0),
		            (parentFiber = parentFiber.sibling);
		    }
		    function commitMutationEffectsOnFiber(finishedWork, root) {
		      var prevEffectStart = pushComponentEffectStart(),
		        prevEffectDuration = pushComponentEffectDuration(),
		        prevEffectErrors = pushComponentEffectErrors(),
		        prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(),
		        current = finishedWork.alternate,
		        flags = finishedWork.flags;
		      switch (finishedWork.tag) {
		        case 0:
		        case 11:
		        case 14:
		        case 15:
		          recursivelyTraverseMutationEffects(root, finishedWork);
		          commitReconciliationEffects(finishedWork);
		          flags & 4 &&
		            (commitHookEffectListUnmount(
		              Insertion | HasEffect,
		              finishedWork,
		              finishedWork.return
		            ),
		            commitHookEffectListMount(Insertion | HasEffect, finishedWork),
		            commitHookLayoutUnmountEffects(
		              finishedWork,
		              finishedWork.return,
		              Layout | HasEffect
		            ));
		          break;
		        case 1:
		          recursivelyTraverseMutationEffects(root, finishedWork);
		          commitReconciliationEffects(finishedWork);
		          flags & 512 &&
		            (offscreenSubtreeWasHidden ||
		              null === current ||
		              safelyDetachRef(current, current.return));
		          flags & 64 &&
		            offscreenSubtreeIsHidden &&
		            ((flags = finishedWork.updateQueue),
		            null !== flags &&
		              ((current = flags.callbacks),
		              null !== current &&
		                ((root = flags.shared.hiddenCallbacks),
		                (flags.shared.hiddenCallbacks =
		                  null === root ? current : root.concat(current)))));
		          break;
		        case 26:
		          if (supportsResources) {
		            var hoistableRoot = currentHoistableRoot;
		            recursivelyTraverseMutationEffects(root, finishedWork);
		            commitReconciliationEffects(finishedWork);
		            flags & 512 &&
		              (offscreenSubtreeWasHidden ||
		                null === current ||
		                safelyDetachRef(current, current.return));
		            flags & 4 &&
		              ((flags = null !== current ? current.memoizedState : null),
		              (root = finishedWork.memoizedState),
		              null === current
		                ? null === root
		                  ? null === finishedWork.stateNode
		                    ? (finishedWork.stateNode = hydrateHoistable(
		                        hoistableRoot,
		                        finishedWork.type,
		                        finishedWork.memoizedProps,
		                        finishedWork
		                      ))
		                    : mountHoistable(
		                        hoistableRoot,
		                        finishedWork.type,
		                        finishedWork.stateNode
		                      )
		                  : (finishedWork.stateNode = acquireResource(
		                      hoistableRoot,
		                      root,
		                      finishedWork.memoizedProps
		                    ))
		                : flags !== root
		                  ? (null === flags
		                      ? null !== current.stateNode &&
		                        unmountHoistable(current.stateNode)
		                      : releaseResource(flags),
		                    null === root
		                      ? mountHoistable(
		                          hoistableRoot,
		                          finishedWork.type,
		                          finishedWork.stateNode
		                        )
		                      : acquireResource(
		                          hoistableRoot,
		                          root,
		                          finishedWork.memoizedProps
		                        ))
		                  : null === root &&
		                    null !== finishedWork.stateNode &&
		                    commitHostUpdate(
		                      finishedWork,
		                      finishedWork.memoizedProps,
		                      current.memoizedProps
		                    ));
		            break;
		          }
		        case 27:
		          if (supportsSingletons) {
		            recursivelyTraverseMutationEffects(root, finishedWork);
		            commitReconciliationEffects(finishedWork);
		            flags & 512 &&
		              (offscreenSubtreeWasHidden ||
		                null === current ||
		                safelyDetachRef(current, current.return));
		            null !== current &&
		              flags & 4 &&
		              commitHostUpdate(
		                finishedWork,
		                finishedWork.memoizedProps,
		                current.memoizedProps
		              );
		            break;
		          }
		        case 5:
		          recursivelyTraverseMutationEffects(root, finishedWork);
		          commitReconciliationEffects(finishedWork);
		          flags & 512 &&
		            (offscreenSubtreeWasHidden ||
		              null === current ||
		              safelyDetachRef(current, current.return));
		          if (supportsMutation) {
		            if (finishedWork.flags & 32) {
		              root = finishedWork.stateNode;
		              try {
		                runWithFiberInDEV(finishedWork, resetTextContent, root);
		              } catch (error) {
		                captureCommitPhaseError(
		                  finishedWork,
		                  finishedWork.return,
		                  error
		                );
		              }
		            }
		            flags & 4 &&
		              null != finishedWork.stateNode &&
		              ((root = finishedWork.memoizedProps),
		              commitHostUpdate(
		                finishedWork,
		                root,
		                null !== current ? current.memoizedProps : root
		              ));
		            flags & 1024 &&
		              ((needsFormReset = true),
		              "form" !== finishedWork.type &&
		                console.error(
		                  "Unexpected host component type. Expected a form. This is a bug in React."
		                ));
		          } else
		            supportsPersistence &&
		              null !== finishedWork.alternate &&
		              (finishedWork.alternate.stateNode = finishedWork.stateNode);
		          break;
		        case 6:
		          recursivelyTraverseMutationEffects(root, finishedWork);
		          commitReconciliationEffects(finishedWork);
		          if (flags & 4 && supportsMutation) {
		            if (null === finishedWork.stateNode)
		              throw Error(
		                "This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue."
		              );
		            flags = finishedWork.memoizedProps;
		            current = null !== current ? current.memoizedProps : flags;
		            root = finishedWork.stateNode;
		            try {
		              runWithFiberInDEV(
		                finishedWork,
		                commitTextUpdate,
		                root,
		                current,
		                flags
		              );
		            } catch (error) {
		              captureCommitPhaseError(finishedWork, finishedWork.return, error);
		            }
		          }
		          break;
		        case 3:
		          hoistableRoot = pushNestedEffectDurations();
		          if (supportsResources) {
		            prepareToCommitHoistables();
		            var previousHoistableRoot = currentHoistableRoot;
		            currentHoistableRoot = getHoistableRoot(root.containerInfo);
		            recursivelyTraverseMutationEffects(root, finishedWork);
		            currentHoistableRoot = previousHoistableRoot;
		          } else recursivelyTraverseMutationEffects(root, finishedWork);
		          commitReconciliationEffects(finishedWork);
		          if (flags & 4) {
		            if (
		              supportsMutation &&
		              supportsHydration &&
		              null !== current &&
		              current.memoizedState.isDehydrated
		            )
		              try {
		                runWithFiberInDEV(
		                  finishedWork,
		                  commitHydratedContainer,
		                  root.containerInfo
		                );
		              } catch (error) {
		                captureCommitPhaseError(
		                  finishedWork,
		                  finishedWork.return,
		                  error
		                );
		              }
		            if (supportsPersistence) {
		              flags = root.containerInfo;
		              current = root.pendingChildren;
		              try {
		                runWithFiberInDEV(
		                  finishedWork,
		                  replaceContainerChildren,
		                  flags,
		                  current
		                );
		              } catch (error) {
		                captureCommitPhaseError(
		                  finishedWork,
		                  finishedWork.return,
		                  error
		                );
		              }
		            }
		          }
		          needsFormReset &&
		            ((needsFormReset = false), recursivelyResetForms(finishedWork));
		          root.effectDuration += popNestedEffectDurations(hoistableRoot);
		          break;
		        case 4:
		          supportsResources
		            ? ((current = currentHoistableRoot),
		              (currentHoistableRoot = getHoistableRoot(
		                finishedWork.stateNode.containerInfo
		              )),
		              recursivelyTraverseMutationEffects(root, finishedWork),
		              commitReconciliationEffects(finishedWork),
		              (currentHoistableRoot = current))
		            : (recursivelyTraverseMutationEffects(root, finishedWork),
		              commitReconciliationEffects(finishedWork));
		          flags & 4 &&
		            supportsPersistence &&
		            commitHostPortalContainerChildren(
		              finishedWork.stateNode,
		              finishedWork,
		              finishedWork.stateNode.pendingChildren
		            );
		          break;
		        case 12:
		          flags = pushNestedEffectDurations();
		          recursivelyTraverseMutationEffects(root, finishedWork);
		          commitReconciliationEffects(finishedWork);
		          finishedWork.stateNode.effectDuration +=
		            bubbleNestedEffectDurations(flags);
		          break;
		        case 31:
		          recursivelyTraverseMutationEffects(root, finishedWork);
		          commitReconciliationEffects(finishedWork);
		          flags & 4 &&
		            ((flags = finishedWork.updateQueue),
		            null !== flags &&
		              ((finishedWork.updateQueue = null),
		              attachSuspenseRetryListeners(finishedWork, flags)));
		          break;
		        case 13:
		          recursivelyTraverseMutationEffects(root, finishedWork);
		          commitReconciliationEffects(finishedWork);
		          finishedWork.child.flags & 8192 &&
		            (null !== finishedWork.memoizedState) !==
		              (null !== current && null !== current.memoizedState) &&
		            (globalMostRecentFallbackTime = now$1());
		          flags & 4 &&
		            ((flags = finishedWork.updateQueue),
		            null !== flags &&
		              ((finishedWork.updateQueue = null),
		              attachSuspenseRetryListeners(finishedWork, flags)));
		          break;
		        case 22:
		          hoistableRoot = null !== finishedWork.memoizedState;
		          var wasHidden = null !== current && null !== current.memoizedState,
		            prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden,
		            prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
		          offscreenSubtreeIsHidden =
		            prevOffscreenSubtreeIsHidden || hoistableRoot;
		          offscreenSubtreeWasHidden =
		            prevOffscreenSubtreeWasHidden || wasHidden;
		          recursivelyTraverseMutationEffects(root, finishedWork);
		          offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
		          offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
		          wasHidden &&
		            !hoistableRoot &&
		            !prevOffscreenSubtreeIsHidden &&
		            !prevOffscreenSubtreeWasHidden &&
		            (finishedWork.mode & 2) !== NoMode &&
		            0 <= componentEffectStartTime &&
		            0 <= componentEffectEndTime &&
		            0.05 < componentEffectEndTime - componentEffectStartTime &&
		            logComponentReappeared(
		              finishedWork,
		              componentEffectStartTime,
		              componentEffectEndTime
		            );
		          commitReconciliationEffects(finishedWork);
		          if (
		            flags & 8192 &&
		            ((root = finishedWork.stateNode),
		            (root._visibility = hoistableRoot
		              ? root._visibility & ~OffscreenVisible
		              : root._visibility | OffscreenVisible),
		            !hoistableRoot ||
		              null === current ||
		              wasHidden ||
		              offscreenSubtreeIsHidden ||
		              offscreenSubtreeWasHidden ||
		              (recursivelyTraverseDisappearLayoutEffects(finishedWork),
		              (finishedWork.mode & 2) !== NoMode &&
		                0 <= componentEffectStartTime &&
		                0 <= componentEffectEndTime &&
		                0.05 < componentEffectEndTime - componentEffectStartTime &&
		                logComponentTrigger(
		                  finishedWork,
		                  componentEffectStartTime,
		                  componentEffectEndTime,
		                  "Disconnect"
		                )),
		            supportsMutation)
		          )
		            a: if (((current = null), supportsMutation))
		              for (root = finishedWork; ; ) {
		                if (5 === root.tag || (supportsResources && 26 === root.tag)) {
		                  if (null === current) {
		                    wasHidden = current = root;
		                    try {
		                      (previousHoistableRoot = wasHidden.stateNode),
		                        hoistableRoot
		                          ? runWithFiberInDEV(
		                              wasHidden,
		                              hideInstance,
		                              previousHoistableRoot
		                            )
		                          : runWithFiberInDEV(
		                              wasHidden,
		                              unhideInstance,
		                              wasHidden.stateNode,
		                              wasHidden.memoizedProps
		                            );
		                    } catch (error) {
		                      captureCommitPhaseError(
		                        wasHidden,
		                        wasHidden.return,
		                        error
		                      );
		                    }
		                  }
		                } else if (6 === root.tag) {
		                  if (null === current) {
		                    wasHidden = root;
		                    try {
		                      var instance = wasHidden.stateNode;
		                      hoistableRoot
		                        ? runWithFiberInDEV(
		                            wasHidden,
		                            hideTextInstance,
		                            instance
		                          )
		                        : runWithFiberInDEV(
		                            wasHidden,
		                            unhideTextInstance,
		                            instance,
		                            wasHidden.memoizedProps
		                          );
		                    } catch (error) {
		                      captureCommitPhaseError(
		                        wasHidden,
		                        wasHidden.return,
		                        error
		                      );
		                    }
		                  }
		                } else if (18 === root.tag) {
		                  if (null === current) {
		                    wasHidden = root;
		                    try {
		                      var instance$jscomp$0 = wasHidden.stateNode;
		                      hoistableRoot
		                        ? runWithFiberInDEV(
		                            wasHidden,
		                            hideDehydratedBoundary,
		                            instance$jscomp$0
		                          )
		                        : runWithFiberInDEV(
		                            wasHidden,
		                            unhideDehydratedBoundary,
		                            wasHidden.stateNode
		                          );
		                    } catch (error) {
		                      captureCommitPhaseError(
		                        wasHidden,
		                        wasHidden.return,
		                        error
		                      );
		                    }
		                  }
		                } else if (
		                  ((22 !== root.tag && 23 !== root.tag) ||
		                    null === root.memoizedState ||
		                    root === finishedWork) &&
		                  null !== root.child
		                ) {
		                  root.child.return = root;
		                  root = root.child;
		                  continue;
		                }
		                if (root === finishedWork) break a;
		                for (; null === root.sibling; ) {
		                  if (null === root.return || root.return === finishedWork)
		                    break a;
		                  current === root && (current = null);
		                  root = root.return;
		                }
		                current === root && (current = null);
		                root.sibling.return = root.return;
		                root = root.sibling;
		              }
		          flags & 4 &&
		            ((flags = finishedWork.updateQueue),
		            null !== flags &&
		              ((current = flags.retryQueue),
		              null !== current &&
		                ((flags.retryQueue = null),
		                attachSuspenseRetryListeners(finishedWork, current))));
		          break;
		        case 19:
		          recursivelyTraverseMutationEffects(root, finishedWork);
		          commitReconciliationEffects(finishedWork);
		          flags & 4 &&
		            ((flags = finishedWork.updateQueue),
		            null !== flags &&
		              ((finishedWork.updateQueue = null),
		              attachSuspenseRetryListeners(finishedWork, flags)));
		          break;
		        case 30:
		          break;
		        case 21:
		          break;
		        default:
		          recursivelyTraverseMutationEffects(root, finishedWork),
		            commitReconciliationEffects(finishedWork);
		      }
		      (finishedWork.mode & 2) !== NoMode &&
		        0 <= componentEffectStartTime &&
		        0 <= componentEffectEndTime &&
		        ((componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) &&
		          logComponentEffect(
		            finishedWork,
		            componentEffectStartTime,
		            componentEffectEndTime,
		            componentEffectDuration,
		            componentEffectErrors
		          ),
		        null === finishedWork.alternate &&
		          null !== finishedWork.return &&
		          null !== finishedWork.return.alternate &&
		          0.05 < componentEffectEndTime - componentEffectStartTime &&
		          (isHydratingParent(
		            finishedWork.return.alternate,
		            finishedWork.return
		          ) ||
		            logComponentTrigger(
		              finishedWork,
		              componentEffectStartTime,
		              componentEffectEndTime,
		              "Mount"
		            )));
		      popComponentEffectStart(prevEffectStart);
		      popComponentEffectDuration(prevEffectDuration);
		      componentEffectErrors = prevEffectErrors;
		      componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
		    }
		    function commitReconciliationEffects(finishedWork) {
		      var flags = finishedWork.flags;
		      if (flags & 2) {
		        try {
		          runWithFiberInDEV(finishedWork, commitPlacement, finishedWork);
		        } catch (error) {
		          captureCommitPhaseError(finishedWork, finishedWork.return, error);
		        }
		        finishedWork.flags &= -3;
		      }
		      flags & 4096 && (finishedWork.flags &= -4097);
		    }
		    function recursivelyResetForms(parentFiber) {
		      if (parentFiber.subtreeFlags & 1024)
		        for (parentFiber = parentFiber.child; null !== parentFiber; ) {
		          var fiber = parentFiber;
		          recursivelyResetForms(fiber);
		          5 === fiber.tag &&
		            fiber.flags & 1024 &&
		            resetFormInstance(fiber.stateNode);
		          parentFiber = parentFiber.sibling;
		        }
		    }
		    function recursivelyTraverseLayoutEffects(root, parentFiber) {
		      if (parentFiber.subtreeFlags & 8772)
		        for (parentFiber = parentFiber.child; null !== parentFiber; )
		          commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber),
		            (parentFiber = parentFiber.sibling);
		    }
		    function disappearLayoutEffects(finishedWork) {
		      var prevEffectStart = pushComponentEffectStart(),
		        prevEffectDuration = pushComponentEffectDuration(),
		        prevEffectErrors = pushComponentEffectErrors(),
		        prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
		      switch (finishedWork.tag) {
		        case 0:
		        case 11:
		        case 14:
		        case 15:
		          commitHookLayoutUnmountEffects(
		            finishedWork,
		            finishedWork.return,
		            Layout
		          );
		          recursivelyTraverseDisappearLayoutEffects(finishedWork);
		          break;
		        case 1:
		          safelyDetachRef(finishedWork, finishedWork.return);
		          var instance = finishedWork.stateNode;
		          "function" === typeof instance.componentWillUnmount &&
		            safelyCallComponentWillUnmount(
		              finishedWork,
		              finishedWork.return,
		              instance
		            );
		          recursivelyTraverseDisappearLayoutEffects(finishedWork);
		          break;
		        case 27:
		          supportsSingletons &&
		            runWithFiberInDEV(
		              finishedWork,
		              releaseSingletonInstance,
		              finishedWork.stateNode
		            );
		        case 26:
		        case 5:
		          safelyDetachRef(finishedWork, finishedWork.return);
		          recursivelyTraverseDisappearLayoutEffects(finishedWork);
		          break;
		        case 22:
		          null === finishedWork.memoizedState &&
		            recursivelyTraverseDisappearLayoutEffects(finishedWork);
		          break;
		        case 30:
		          recursivelyTraverseDisappearLayoutEffects(finishedWork);
		          break;
		        default:
		          recursivelyTraverseDisappearLayoutEffects(finishedWork);
		      }
		      (finishedWork.mode & 2) !== NoMode &&
		        0 <= componentEffectStartTime &&
		        0 <= componentEffectEndTime &&
		        (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) &&
		        logComponentEffect(
		          finishedWork,
		          componentEffectStartTime,
		          componentEffectEndTime,
		          componentEffectDuration,
		          componentEffectErrors
		        );
		      popComponentEffectStart(prevEffectStart);
		      popComponentEffectDuration(prevEffectDuration);
		      componentEffectErrors = prevEffectErrors;
		      componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
		    }
		    function recursivelyTraverseDisappearLayoutEffects(parentFiber) {
		      for (parentFiber = parentFiber.child; null !== parentFiber; )
		        disappearLayoutEffects(parentFiber),
		          (parentFiber = parentFiber.sibling);
		    }
		    function reappearLayoutEffects(
		      finishedRoot,
		      current,
		      finishedWork,
		      includeWorkInProgressEffects
		    ) {
		      var prevEffectStart = pushComponentEffectStart(),
		        prevEffectDuration = pushComponentEffectDuration(),
		        prevEffectErrors = pushComponentEffectErrors(),
		        prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(),
		        flags = finishedWork.flags;
		      switch (finishedWork.tag) {
		        case 0:
		        case 11:
		        case 15:
		          recursivelyTraverseReappearLayoutEffects(
		            finishedRoot,
		            finishedWork,
		            includeWorkInProgressEffects
		          );
		          commitHookLayoutEffects(finishedWork, Layout);
		          break;
		        case 1:
		          recursivelyTraverseReappearLayoutEffects(
		            finishedRoot,
		            finishedWork,
		            includeWorkInProgressEffects
		          );
		          current = finishedWork.stateNode;
		          "function" === typeof current.componentDidMount &&
		            runWithFiberInDEV(
		              finishedWork,
		              callComponentDidMountInDEV,
		              finishedWork,
		              current
		            );
		          current = finishedWork.updateQueue;
		          if (null !== current) {
		            finishedRoot = finishedWork.stateNode;
		            try {
		              runWithFiberInDEV(
		                finishedWork,
		                commitHiddenCallbacks,
		                current,
		                finishedRoot
		              );
		            } catch (error) {
		              captureCommitPhaseError(finishedWork, finishedWork.return, error);
		            }
		          }
		          includeWorkInProgressEffects &&
		            flags & 64 &&
		            commitClassCallbacks(finishedWork);
		          safelyAttachRef(finishedWork, finishedWork.return);
		          break;
		        case 27:
		          supportsSingletons && commitHostSingletonAcquisition(finishedWork);
		        case 26:
		        case 5:
		          recursivelyTraverseReappearLayoutEffects(
		            finishedRoot,
		            finishedWork,
		            includeWorkInProgressEffects
		          );
		          includeWorkInProgressEffects &&
		            null === current &&
		            flags & 4 &&
		            commitHostMount(finishedWork);
		          safelyAttachRef(finishedWork, finishedWork.return);
		          break;
		        case 12:
		          if (includeWorkInProgressEffects && flags & 4) {
		            flags = pushNestedEffectDurations();
		            recursivelyTraverseReappearLayoutEffects(
		              finishedRoot,
		              finishedWork,
		              includeWorkInProgressEffects
		            );
		            includeWorkInProgressEffects = finishedWork.stateNode;
		            includeWorkInProgressEffects.effectDuration +=
		              bubbleNestedEffectDurations(flags);
		            try {
		              runWithFiberInDEV(
		                finishedWork,
		                commitProfiler,
		                finishedWork,
		                current,
		                commitStartTime,
		                includeWorkInProgressEffects.effectDuration
		              );
		            } catch (error) {
		              captureCommitPhaseError(finishedWork, finishedWork.return, error);
		            }
		          } else
		            recursivelyTraverseReappearLayoutEffects(
		              finishedRoot,
		              finishedWork,
		              includeWorkInProgressEffects
		            );
		          break;
		        case 31:
		          recursivelyTraverseReappearLayoutEffects(
		            finishedRoot,
		            finishedWork,
		            includeWorkInProgressEffects
		          );
		          includeWorkInProgressEffects &&
		            flags & 4 &&
		            commitActivityHydrationCallbacks(finishedRoot, finishedWork);
		          break;
		        case 13:
		          recursivelyTraverseReappearLayoutEffects(
		            finishedRoot,
		            finishedWork,
		            includeWorkInProgressEffects
		          );
		          includeWorkInProgressEffects &&
		            flags & 4 &&
		            commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
		          break;
		        case 22:
		          null === finishedWork.memoizedState &&
		            recursivelyTraverseReappearLayoutEffects(
		              finishedRoot,
		              finishedWork,
		              includeWorkInProgressEffects
		            );
		          safelyAttachRef(finishedWork, finishedWork.return);
		          break;
		        case 30:
		          break;
		        default:
		          recursivelyTraverseReappearLayoutEffects(
		            finishedRoot,
		            finishedWork,
		            includeWorkInProgressEffects
		          );
		      }
		      (finishedWork.mode & 2) !== NoMode &&
		        0 <= componentEffectStartTime &&
		        0 <= componentEffectEndTime &&
		        (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) &&
		        logComponentEffect(
		          finishedWork,
		          componentEffectStartTime,
		          componentEffectEndTime,
		          componentEffectDuration,
		          componentEffectErrors
		        );
		      popComponentEffectStart(prevEffectStart);
		      popComponentEffectDuration(prevEffectDuration);
		      componentEffectErrors = prevEffectErrors;
		      componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
		    }
		    function recursivelyTraverseReappearLayoutEffects(
		      finishedRoot,
		      parentFiber,
		      includeWorkInProgressEffects
		    ) {
		      includeWorkInProgressEffects =
		        includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
		      for (parentFiber = parentFiber.child; null !== parentFiber; )
		        reappearLayoutEffects(
		          finishedRoot,
		          parentFiber.alternate,
		          parentFiber,
		          includeWorkInProgressEffects
		        ),
		          (parentFiber = parentFiber.sibling);
		    }
		    function commitOffscreenPassiveMountEffects(current, finishedWork) {
		      var previousCache = null;
		      null !== current &&
		        null !== current.memoizedState &&
		        null !== current.memoizedState.cachePool &&
		        (previousCache = current.memoizedState.cachePool.pool);
		      current = null;
		      null !== finishedWork.memoizedState &&
		        null !== finishedWork.memoizedState.cachePool &&
		        (current = finishedWork.memoizedState.cachePool.pool);
		      current !== previousCache &&
		        (null != current && retainCache(current),
		        null != previousCache && releaseCache(previousCache));
		    }
		    function commitCachePassiveMountEffect(current, finishedWork) {
		      current = null;
		      null !== finishedWork.alternate &&
		        (current = finishedWork.alternate.memoizedState.cache);
		      finishedWork = finishedWork.memoizedState.cache;
		      finishedWork !== current &&
		        (retainCache(finishedWork), null != current && releaseCache(current));
		    }
		    function recursivelyTraversePassiveMountEffects(
		      root,
		      parentFiber,
		      committedLanes,
		      committedTransitions,
		      endTime
		    ) {
		      if (
		        parentFiber.subtreeFlags & 10256 ||
		        (0 !== parentFiber.actualDuration &&
		          (null === parentFiber.alternate ||
		            parentFiber.alternate.child !== parentFiber.child))
		      )
		        for (parentFiber = parentFiber.child; null !== parentFiber; ) {
		          var nextSibling = parentFiber.sibling;
		          commitPassiveMountOnFiber(
		            root,
		            parentFiber,
		            committedLanes,
		            committedTransitions,
		            null !== nextSibling ? nextSibling.actualStartTime : endTime
		          );
		          parentFiber = nextSibling;
		        }
		    }
		    function commitPassiveMountOnFiber(
		      finishedRoot,
		      finishedWork,
		      committedLanes,
		      committedTransitions,
		      endTime
		    ) {
		      var prevEffectStart = pushComponentEffectStart(),
		        prevEffectDuration = pushComponentEffectDuration(),
		        prevEffectErrors = pushComponentEffectErrors(),
		        prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(),
		        prevDeepEquality = alreadyWarnedForDeepEquality,
		        flags = finishedWork.flags;
		      switch (finishedWork.tag) {
		        case 0:
		        case 11:
		        case 15:
		          (finishedWork.mode & 2) !== NoMode &&
		            0 < finishedWork.actualStartTime &&
		            0 !== (finishedWork.flags & 1) &&
		            logComponentRender(
		              finishedWork,
		              finishedWork.actualStartTime,
		              endTime,
		              inHydratedSubtree,
		              committedLanes
		            );
		          recursivelyTraversePassiveMountEffects(
		            finishedRoot,
		            finishedWork,
		            committedLanes,
		            committedTransitions,
		            endTime
		          );
		          flags & 2048 &&
		            commitHookPassiveMountEffects(finishedWork, Passive | HasEffect);
		          break;
		        case 1:
		          (finishedWork.mode & 2) !== NoMode &&
		            0 < finishedWork.actualStartTime &&
		            (0 !== (finishedWork.flags & 128)
		              ? logComponentErrored(
		                  finishedWork,
		                  finishedWork.actualStartTime,
		                  endTime,
		                  []
		                )
		              : 0 !== (finishedWork.flags & 1) &&
		                logComponentRender(
		                  finishedWork,
		                  finishedWork.actualStartTime,
		                  endTime,
		                  inHydratedSubtree,
		                  committedLanes
		                ));
		          recursivelyTraversePassiveMountEffects(
		            finishedRoot,
		            finishedWork,
		            committedLanes,
		            committedTransitions,
		            endTime
		          );
		          break;
		        case 3:
		          var prevProfilerEffectDuration = pushNestedEffectDurations(),
		            wasInHydratedSubtree = inHydratedSubtree;
		          inHydratedSubtree =
		            null !== finishedWork.alternate &&
		            finishedWork.alternate.memoizedState.isDehydrated &&
		            0 === (finishedWork.flags & 256);
		          recursivelyTraversePassiveMountEffects(
		            finishedRoot,
		            finishedWork,
		            committedLanes,
		            committedTransitions,
		            endTime
		          );
		          inHydratedSubtree = wasInHydratedSubtree;
		          flags & 2048 &&
		            ((committedLanes = null),
		            null !== finishedWork.alternate &&
		              (committedLanes = finishedWork.alternate.memoizedState.cache),
		            (committedTransitions = finishedWork.memoizedState.cache),
		            committedTransitions !== committedLanes &&
		              (retainCache(committedTransitions),
		              null != committedLanes && releaseCache(committedLanes)));
		          finishedRoot.passiveEffectDuration += popNestedEffectDurations(
		            prevProfilerEffectDuration
		          );
		          break;
		        case 12:
		          if (flags & 2048) {
		            flags = pushNestedEffectDurations();
		            recursivelyTraversePassiveMountEffects(
		              finishedRoot,
		              finishedWork,
		              committedLanes,
		              committedTransitions,
		              endTime
		            );
		            finishedRoot = finishedWork.stateNode;
		            finishedRoot.passiveEffectDuration +=
		              bubbleNestedEffectDurations(flags);
		            try {
		              runWithFiberInDEV(
		                finishedWork,
		                commitProfilerPostCommitImpl,
		                finishedWork,
		                finishedWork.alternate,
		                commitStartTime,
		                finishedRoot.passiveEffectDuration
		              );
		            } catch (error) {
		              captureCommitPhaseError(finishedWork, finishedWork.return, error);
		            }
		          } else
		            recursivelyTraversePassiveMountEffects(
		              finishedRoot,
		              finishedWork,
		              committedLanes,
		              committedTransitions,
		              endTime
		            );
		          break;
		        case 31:
		          flags = inHydratedSubtree;
		          prevProfilerEffectDuration =
		            null !== finishedWork.alternate
		              ? finishedWork.alternate.memoizedState
		              : null;
		          wasInHydratedSubtree = finishedWork.memoizedState;
		          null !== prevProfilerEffectDuration && null === wasInHydratedSubtree
		            ? ((wasInHydratedSubtree = finishedWork.deletions),
		              null !== wasInHydratedSubtree &&
		              0 < wasInHydratedSubtree.length &&
		              18 === wasInHydratedSubtree[0].tag
		                ? ((inHydratedSubtree = false),
		                  (prevProfilerEffectDuration =
		                    prevProfilerEffectDuration.hydrationErrors),
		                  null !== prevProfilerEffectDuration &&
		                    logComponentErrored(
		                      finishedWork,
		                      finishedWork.actualStartTime,
		                      endTime,
		                      prevProfilerEffectDuration
		                    ))
		                : (inHydratedSubtree = true))
		            : (inHydratedSubtree = false);
		          recursivelyTraversePassiveMountEffects(
		            finishedRoot,
		            finishedWork,
		            committedLanes,
		            committedTransitions,
		            endTime
		          );
		          inHydratedSubtree = flags;
		          break;
		        case 13:
		          flags = inHydratedSubtree;
		          prevProfilerEffectDuration =
		            null !== finishedWork.alternate
		              ? finishedWork.alternate.memoizedState
		              : null;
		          wasInHydratedSubtree = finishedWork.memoizedState;
		          null === prevProfilerEffectDuration ||
		          null === prevProfilerEffectDuration.dehydrated ||
		          (null !== wasInHydratedSubtree &&
		            null !== wasInHydratedSubtree.dehydrated)
		            ? (inHydratedSubtree = false)
		            : ((wasInHydratedSubtree = finishedWork.deletions),
		              null !== wasInHydratedSubtree &&
		              0 < wasInHydratedSubtree.length &&
		              18 === wasInHydratedSubtree[0].tag
		                ? ((inHydratedSubtree = false),
		                  (prevProfilerEffectDuration =
		                    prevProfilerEffectDuration.hydrationErrors),
		                  null !== prevProfilerEffectDuration &&
		                    logComponentErrored(
		                      finishedWork,
		                      finishedWork.actualStartTime,
		                      endTime,
		                      prevProfilerEffectDuration
		                    ))
		                : (inHydratedSubtree = true));
		          recursivelyTraversePassiveMountEffects(
		            finishedRoot,
		            finishedWork,
		            committedLanes,
		            committedTransitions,
		            endTime
		          );
		          inHydratedSubtree = flags;
		          break;
		        case 23:
		          break;
		        case 22:
		          wasInHydratedSubtree = finishedWork.stateNode;
		          prevProfilerEffectDuration = finishedWork.alternate;
		          null !== finishedWork.memoizedState
		            ? wasInHydratedSubtree._visibility &
		              OffscreenPassiveEffectsConnected
		              ? recursivelyTraversePassiveMountEffects(
		                  finishedRoot,
		                  finishedWork,
		                  committedLanes,
		                  committedTransitions,
		                  endTime
		                )
		              : recursivelyTraverseAtomicPassiveEffects(
		                  finishedRoot,
		                  finishedWork,
		                  committedLanes,
		                  committedTransitions,
		                  endTime
		                )
		            : wasInHydratedSubtree._visibility &
		                OffscreenPassiveEffectsConnected
		              ? recursivelyTraversePassiveMountEffects(
		                  finishedRoot,
		                  finishedWork,
		                  committedLanes,
		                  committedTransitions,
		                  endTime
		                )
		              : ((wasInHydratedSubtree._visibility |=
		                  OffscreenPassiveEffectsConnected),
		                recursivelyTraverseReconnectPassiveEffects(
		                  finishedRoot,
		                  finishedWork,
		                  committedLanes,
		                  committedTransitions,
		                  0 !== (finishedWork.subtreeFlags & 10256) ||
		                    (0 !== finishedWork.actualDuration &&
		                      (null === finishedWork.alternate ||
		                        finishedWork.alternate.child !== finishedWork.child)),
		                  endTime
		                ),
		                (finishedWork.mode & 2) === NoMode ||
		                  inHydratedSubtree ||
		                  ((finishedRoot = finishedWork.actualStartTime),
		                  0 <= finishedRoot &&
		                    0.05 < endTime - finishedRoot &&
		                    logComponentReappeared(finishedWork, finishedRoot, endTime),
		                  0 <= componentEffectStartTime &&
		                    0 <= componentEffectEndTime &&
		                    0.05 < componentEffectEndTime - componentEffectStartTime &&
		                    logComponentReappeared(
		                      finishedWork,
		                      componentEffectStartTime,
		                      componentEffectEndTime
		                    )));
		          flags & 2048 &&
		            commitOffscreenPassiveMountEffects(
		              prevProfilerEffectDuration,
		              finishedWork
		            );
		          break;
		        case 24:
		          recursivelyTraversePassiveMountEffects(
		            finishedRoot,
		            finishedWork,
		            committedLanes,
		            committedTransitions,
		            endTime
		          );
		          flags & 2048 &&
		            commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
		          break;
		        default:
		          recursivelyTraversePassiveMountEffects(
		            finishedRoot,
		            finishedWork,
		            committedLanes,
		            committedTransitions,
		            endTime
		          );
		      }
		      if ((finishedWork.mode & 2) !== NoMode) {
		        if (
		          (finishedRoot =
		            !inHydratedSubtree &&
		            null === finishedWork.alternate &&
		            null !== finishedWork.return &&
		            null !== finishedWork.return.alternate)
		        )
		          (committedLanes = finishedWork.actualStartTime),
		            0 <= committedLanes &&
		              0.05 < endTime - committedLanes &&
		              logComponentTrigger(
		                finishedWork,
		                committedLanes,
		                endTime,
		                "Mount"
		              );
		        0 <= componentEffectStartTime &&
		          0 <= componentEffectEndTime &&
		          ((componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) &&
		            logComponentEffect(
		              finishedWork,
		              componentEffectStartTime,
		              componentEffectEndTime,
		              componentEffectDuration,
		              componentEffectErrors
		            ),
		          finishedRoot &&
		            0.05 < componentEffectEndTime - componentEffectStartTime &&
		            logComponentTrigger(
		              finishedWork,
		              componentEffectStartTime,
		              componentEffectEndTime,
		              "Mount"
		            ));
		      }
		      popComponentEffectStart(prevEffectStart);
		      popComponentEffectDuration(prevEffectDuration);
		      componentEffectErrors = prevEffectErrors;
		      componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
		      alreadyWarnedForDeepEquality = prevDeepEquality;
		    }
		    function recursivelyTraverseReconnectPassiveEffects(
		      finishedRoot,
		      parentFiber,
		      committedLanes,
		      committedTransitions,
		      includeWorkInProgressEffects,
		      endTime
		    ) {
		      includeWorkInProgressEffects =
		        includeWorkInProgressEffects &&
		        (0 !== (parentFiber.subtreeFlags & 10256) ||
		          (0 !== parentFiber.actualDuration &&
		            (null === parentFiber.alternate ||
		              parentFiber.alternate.child !== parentFiber.child)));
		      for (parentFiber = parentFiber.child; null !== parentFiber; ) {
		        var nextSibling = parentFiber.sibling;
		        reconnectPassiveEffects(
		          finishedRoot,
		          parentFiber,
		          committedLanes,
		          committedTransitions,
		          includeWorkInProgressEffects,
		          null !== nextSibling ? nextSibling.actualStartTime : endTime
		        );
		        parentFiber = nextSibling;
		      }
		    }
		    function reconnectPassiveEffects(
		      finishedRoot,
		      finishedWork,
		      committedLanes,
		      committedTransitions,
		      includeWorkInProgressEffects,
		      endTime
		    ) {
		      var prevEffectStart = pushComponentEffectStart(),
		        prevEffectDuration = pushComponentEffectDuration(),
		        prevEffectErrors = pushComponentEffectErrors(),
		        prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(),
		        prevDeepEquality = alreadyWarnedForDeepEquality;
		      includeWorkInProgressEffects &&
		        (finishedWork.mode & 2) !== NoMode &&
		        0 < finishedWork.actualStartTime &&
		        0 !== (finishedWork.flags & 1) &&
		        logComponentRender(
		          finishedWork,
		          finishedWork.actualStartTime,
		          endTime,
		          inHydratedSubtree,
		          committedLanes
		        );
		      var flags = finishedWork.flags;
		      switch (finishedWork.tag) {
		        case 0:
		        case 11:
		        case 15:
		          recursivelyTraverseReconnectPassiveEffects(
		            finishedRoot,
		            finishedWork,
		            committedLanes,
		            committedTransitions,
		            includeWorkInProgressEffects,
		            endTime
		          );
		          commitHookPassiveMountEffects(finishedWork, Passive);
		          break;
		        case 23:
		          break;
		        case 22:
		          var _instance2 = finishedWork.stateNode;
		          null !== finishedWork.memoizedState
		            ? _instance2._visibility & OffscreenPassiveEffectsConnected
		              ? recursivelyTraverseReconnectPassiveEffects(
		                  finishedRoot,
		                  finishedWork,
		                  committedLanes,
		                  committedTransitions,
		                  includeWorkInProgressEffects,
		                  endTime
		                )
		              : recursivelyTraverseAtomicPassiveEffects(
		                  finishedRoot,
		                  finishedWork,
		                  committedLanes,
		                  committedTransitions,
		                  endTime
		                )
		            : ((_instance2._visibility |= OffscreenPassiveEffectsConnected),
		              recursivelyTraverseReconnectPassiveEffects(
		                finishedRoot,
		                finishedWork,
		                committedLanes,
		                committedTransitions,
		                includeWorkInProgressEffects,
		                endTime
		              ));
		          includeWorkInProgressEffects &&
		            flags & 2048 &&
		            commitOffscreenPassiveMountEffects(
		              finishedWork.alternate,
		              finishedWork
		            );
		          break;
		        case 24:
		          recursivelyTraverseReconnectPassiveEffects(
		            finishedRoot,
		            finishedWork,
		            committedLanes,
		            committedTransitions,
		            includeWorkInProgressEffects,
		            endTime
		          );
		          includeWorkInProgressEffects &&
		            flags & 2048 &&
		            commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
		          break;
		        default:
		          recursivelyTraverseReconnectPassiveEffects(
		            finishedRoot,
		            finishedWork,
		            committedLanes,
		            committedTransitions,
		            includeWorkInProgressEffects,
		            endTime
		          );
		      }
		      (finishedWork.mode & 2) !== NoMode &&
		        0 <= componentEffectStartTime &&
		        0 <= componentEffectEndTime &&
		        (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) &&
		        logComponentEffect(
		          finishedWork,
		          componentEffectStartTime,
		          componentEffectEndTime,
		          componentEffectDuration,
		          componentEffectErrors
		        );
		      popComponentEffectStart(prevEffectStart);
		      popComponentEffectDuration(prevEffectDuration);
		      componentEffectErrors = prevEffectErrors;
		      componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
		      alreadyWarnedForDeepEquality = prevDeepEquality;
		    }
		    function recursivelyTraverseAtomicPassiveEffects(
		      finishedRoot$jscomp$0,
		      parentFiber,
		      committedLanes$jscomp$0,
		      committedTransitions$jscomp$0,
		      endTime$jscomp$0
		    ) {
		      if (
		        parentFiber.subtreeFlags & 10256 ||
		        (0 !== parentFiber.actualDuration &&
		          (null === parentFiber.alternate ||
		            parentFiber.alternate.child !== parentFiber.child))
		      )
		        for (var child = parentFiber.child; null !== child; ) {
		          parentFiber = child.sibling;
		          var finishedRoot = finishedRoot$jscomp$0,
		            committedLanes = committedLanes$jscomp$0,
		            committedTransitions = committedTransitions$jscomp$0,
		            endTime =
		              null !== parentFiber
		                ? parentFiber.actualStartTime
		                : endTime$jscomp$0,
		            prevDeepEquality = alreadyWarnedForDeepEquality;
		          (child.mode & 2) !== NoMode &&
		            0 < child.actualStartTime &&
		            0 !== (child.flags & 1) &&
		            logComponentRender(
		              child,
		              child.actualStartTime,
		              endTime,
		              inHydratedSubtree,
		              committedLanes
		            );
		          var flags = child.flags;
		          switch (child.tag) {
		            case 22:
		              recursivelyTraverseAtomicPassiveEffects(
		                finishedRoot,
		                child,
		                committedLanes,
		                committedTransitions,
		                endTime
		              );
		              flags & 2048 &&
		                commitOffscreenPassiveMountEffects(child.alternate, child);
		              break;
		            case 24:
		              recursivelyTraverseAtomicPassiveEffects(
		                finishedRoot,
		                child,
		                committedLanes,
		                committedTransitions,
		                endTime
		              );
		              flags & 2048 &&
		                commitCachePassiveMountEffect(child.alternate, child);
		              break;
		            default:
		              recursivelyTraverseAtomicPassiveEffects(
		                finishedRoot,
		                child,
		                committedLanes,
		                committedTransitions,
		                endTime
		              );
		          }
		          alreadyWarnedForDeepEquality = prevDeepEquality;
		          child = parentFiber;
		        }
		    }
		    function recursivelyAccumulateSuspenseyCommit(
		      parentFiber,
		      committedLanes,
		      suspendedState
		    ) {
		      if (parentFiber.subtreeFlags & suspenseyCommitFlag)
		        for (parentFiber = parentFiber.child; null !== parentFiber; )
		          accumulateSuspenseyCommitOnFiber(
		            parentFiber,
		            committedLanes,
		            suspendedState
		          ),
		            (parentFiber = parentFiber.sibling);
		    }
		    function accumulateSuspenseyCommitOnFiber(
		      fiber,
		      committedLanes,
		      suspendedState
		    ) {
		      switch (fiber.tag) {
		        case 26:
		          recursivelyAccumulateSuspenseyCommit(
		            fiber,
		            committedLanes,
		            suspendedState
		          );
		          if (fiber.flags & suspenseyCommitFlag)
		            if (null !== fiber.memoizedState)
		              suspendResource(
		                suspendedState,
		                currentHoistableRoot,
		                fiber.memoizedState,
		                fiber.memoizedProps
		              );
		            else {
		              var instance = fiber.stateNode,
		                type = fiber.type;
		              fiber = fiber.memoizedProps;
		              ((committedLanes & 335544128) === committedLanes ||
		                maySuspendCommitInSyncRender(type, fiber)) &&
		                suspendInstance(suspendedState, instance, type, fiber);
		            }
		          break;
		        case 5:
		          recursivelyAccumulateSuspenseyCommit(
		            fiber,
		            committedLanes,
		            suspendedState
		          );
		          fiber.flags & suspenseyCommitFlag &&
		            ((instance = fiber.stateNode),
		            (type = fiber.type),
		            (fiber = fiber.memoizedProps),
		            ((committedLanes & 335544128) === committedLanes ||
		              maySuspendCommitInSyncRender(type, fiber)) &&
		              suspendInstance(suspendedState, instance, type, fiber));
		          break;
		        case 3:
		        case 4:
		          supportsResources
		            ? ((instance = currentHoistableRoot),
		              (currentHoistableRoot = getHoistableRoot(
		                fiber.stateNode.containerInfo
		              )),
		              recursivelyAccumulateSuspenseyCommit(
		                fiber,
		                committedLanes,
		                suspendedState
		              ),
		              (currentHoistableRoot = instance))
		            : recursivelyAccumulateSuspenseyCommit(
		                fiber,
		                committedLanes,
		                suspendedState
		              );
		          break;
		        case 22:
		          null === fiber.memoizedState &&
		            ((instance = fiber.alternate),
		            null !== instance && null !== instance.memoizedState
		              ? ((instance = suspenseyCommitFlag),
		                (suspenseyCommitFlag = 16777216),
		                recursivelyAccumulateSuspenseyCommit(
		                  fiber,
		                  committedLanes,
		                  suspendedState
		                ),
		                (suspenseyCommitFlag = instance))
		              : recursivelyAccumulateSuspenseyCommit(
		                  fiber,
		                  committedLanes,
		                  suspendedState
		                ));
		          break;
		        default:
		          recursivelyAccumulateSuspenseyCommit(
		            fiber,
		            committedLanes,
		            suspendedState
		          );
		      }
		    }
		    function detachAlternateSiblings(parentFiber) {
		      var previousFiber = parentFiber.alternate;
		      if (
		        null !== previousFiber &&
		        ((parentFiber = previousFiber.child), null !== parentFiber)
		      ) {
		        previousFiber.child = null;
		        do
		          (previousFiber = parentFiber.sibling),
		            (parentFiber.sibling = null),
		            (parentFiber = previousFiber);
		        while (null !== parentFiber);
		      }
		    }
		    function recursivelyTraversePassiveUnmountEffects(parentFiber) {
		      var deletions = parentFiber.deletions;
		      if (0 !== (parentFiber.flags & 16)) {
		        if (null !== deletions)
		          for (var i = 0; i < deletions.length; i++) {
		            var childToDelete = deletions[i],
		              prevEffectStart = pushComponentEffectStart();
		            nextEffect = childToDelete;
		            commitPassiveUnmountEffectsInsideOfDeletedTree_begin(
		              childToDelete,
		              parentFiber
		            );
		            (childToDelete.mode & 2) !== NoMode &&
		              0 <= componentEffectStartTime &&
		              0 <= componentEffectEndTime &&
		              0.05 < componentEffectEndTime - componentEffectStartTime &&
		              logComponentTrigger(
		                childToDelete,
		                componentEffectStartTime,
		                componentEffectEndTime,
		                "Unmount"
		              );
		            popComponentEffectStart(prevEffectStart);
		          }
		        detachAlternateSiblings(parentFiber);
		      }
		      if (parentFiber.subtreeFlags & 10256)
		        for (parentFiber = parentFiber.child; null !== parentFiber; )
		          commitPassiveUnmountOnFiber(parentFiber),
		            (parentFiber = parentFiber.sibling);
		    }
		    function commitPassiveUnmountOnFiber(finishedWork) {
		      var prevEffectStart = pushComponentEffectStart(),
		        prevEffectDuration = pushComponentEffectDuration(),
		        prevEffectErrors = pushComponentEffectErrors(),
		        prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
		      switch (finishedWork.tag) {
		        case 0:
		        case 11:
		        case 15:
		          recursivelyTraversePassiveUnmountEffects(finishedWork);
		          finishedWork.flags & 2048 &&
		            commitHookPassiveUnmountEffects(
		              finishedWork,
		              finishedWork.return,
		              Passive | HasEffect
		            );
		          break;
		        case 3:
		          var prevProfilerEffectDuration = pushNestedEffectDurations();
		          recursivelyTraversePassiveUnmountEffects(finishedWork);
		          finishedWork.stateNode.passiveEffectDuration +=
		            popNestedEffectDurations(prevProfilerEffectDuration);
		          break;
		        case 12:
		          prevProfilerEffectDuration = pushNestedEffectDurations();
		          recursivelyTraversePassiveUnmountEffects(finishedWork);
		          finishedWork.stateNode.passiveEffectDuration +=
		            bubbleNestedEffectDurations(prevProfilerEffectDuration);
		          break;
		        case 22:
		          prevProfilerEffectDuration = finishedWork.stateNode;
		          null !== finishedWork.memoizedState &&
		          prevProfilerEffectDuration._visibility &
		            OffscreenPassiveEffectsConnected &&
		          (null === finishedWork.return || 13 !== finishedWork.return.tag)
		            ? ((prevProfilerEffectDuration._visibility &=
		                ~OffscreenPassiveEffectsConnected),
		              recursivelyTraverseDisconnectPassiveEffects(finishedWork),
		              (finishedWork.mode & 2) !== NoMode &&
		                0 <= componentEffectStartTime &&
		                0 <= componentEffectEndTime &&
		                0.05 < componentEffectEndTime - componentEffectStartTime &&
		                logComponentTrigger(
		                  finishedWork,
		                  componentEffectStartTime,
		                  componentEffectEndTime,
		                  "Disconnect"
		                ))
		            : recursivelyTraversePassiveUnmountEffects(finishedWork);
		          break;
		        default:
		          recursivelyTraversePassiveUnmountEffects(finishedWork);
		      }
		      (finishedWork.mode & 2) !== NoMode &&
		        0 <= componentEffectStartTime &&
		        0 <= componentEffectEndTime &&
		        (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) &&
		        logComponentEffect(
		          finishedWork,
		          componentEffectStartTime,
		          componentEffectEndTime,
		          componentEffectDuration,
		          componentEffectErrors
		        );
		      popComponentEffectStart(prevEffectStart);
		      popComponentEffectDuration(prevEffectDuration);
		      componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
		      componentEffectErrors = prevEffectErrors;
		    }
		    function recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
		      var deletions = parentFiber.deletions;
		      if (0 !== (parentFiber.flags & 16)) {
		        if (null !== deletions)
		          for (var i = 0; i < deletions.length; i++) {
		            var childToDelete = deletions[i],
		              prevEffectStart = pushComponentEffectStart();
		            nextEffect = childToDelete;
		            commitPassiveUnmountEffectsInsideOfDeletedTree_begin(
		              childToDelete,
		              parentFiber
		            );
		            (childToDelete.mode & 2) !== NoMode &&
		              0 <= componentEffectStartTime &&
		              0 <= componentEffectEndTime &&
		              0.05 < componentEffectEndTime - componentEffectStartTime &&
		              logComponentTrigger(
		                childToDelete,
		                componentEffectStartTime,
		                componentEffectEndTime,
		                "Unmount"
		              );
		            popComponentEffectStart(prevEffectStart);
		          }
		        detachAlternateSiblings(parentFiber);
		      }
		      for (parentFiber = parentFiber.child; null !== parentFiber; )
		        disconnectPassiveEffect(parentFiber),
		          (parentFiber = parentFiber.sibling);
		    }
		    function disconnectPassiveEffect(finishedWork) {
		      var prevEffectStart = pushComponentEffectStart(),
		        prevEffectDuration = pushComponentEffectDuration(),
		        prevEffectErrors = pushComponentEffectErrors(),
		        prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
		      switch (finishedWork.tag) {
		        case 0:
		        case 11:
		        case 15:
		          commitHookPassiveUnmountEffects(
		            finishedWork,
		            finishedWork.return,
		            Passive
		          );
		          recursivelyTraverseDisconnectPassiveEffects(finishedWork);
		          break;
		        case 22:
		          var instance = finishedWork.stateNode;
		          instance._visibility & OffscreenPassiveEffectsConnected &&
		            ((instance._visibility &= ~OffscreenPassiveEffectsConnected),
		            recursivelyTraverseDisconnectPassiveEffects(finishedWork));
		          break;
		        default:
		          recursivelyTraverseDisconnectPassiveEffects(finishedWork);
		      }
		      (finishedWork.mode & 2) !== NoMode &&
		        0 <= componentEffectStartTime &&
		        0 <= componentEffectEndTime &&
		        (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) &&
		        logComponentEffect(
		          finishedWork,
		          componentEffectStartTime,
		          componentEffectEndTime,
		          componentEffectDuration,
		          componentEffectErrors
		        );
		      popComponentEffectStart(prevEffectStart);
		      popComponentEffectDuration(prevEffectDuration);
		      componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
		      componentEffectErrors = prevEffectErrors;
		    }
		    function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(
		      deletedSubtreeRoot,
		      nearestMountedAncestor$jscomp$0
		    ) {
		      for (; null !== nextEffect; ) {
		        var fiber = nextEffect,
		          current = fiber,
		          nearestMountedAncestor = nearestMountedAncestor$jscomp$0,
		          prevEffectStart = pushComponentEffectStart(),
		          prevEffectDuration = pushComponentEffectDuration(),
		          prevEffectErrors = pushComponentEffectErrors(),
		          prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
		        switch (current.tag) {
		          case 0:
		          case 11:
		          case 15:
		            commitHookPassiveUnmountEffects(
		              current,
		              nearestMountedAncestor,
		              Passive
		            );
		            break;
		          case 23:
		          case 22:
		            null !== current.memoizedState &&
		              null !== current.memoizedState.cachePool &&
		              ((nearestMountedAncestor = current.memoizedState.cachePool.pool),
		              null != nearestMountedAncestor &&
		                retainCache(nearestMountedAncestor));
		            break;
		          case 24:
		            releaseCache(current.memoizedState.cache);
		        }
		        (current.mode & 2) !== NoMode &&
		          0 <= componentEffectStartTime &&
		          0 <= componentEffectEndTime &&
		          (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) &&
		          logComponentEffect(
		            current,
		            componentEffectStartTime,
		            componentEffectEndTime,
		            componentEffectDuration,
		            componentEffectErrors
		          );
		        popComponentEffectStart(prevEffectStart);
		        popComponentEffectDuration(prevEffectDuration);
		        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
		        componentEffectErrors = prevEffectErrors;
		        current = fiber.child;
		        if (null !== current) (current.return = fiber), (nextEffect = current);
		        else
		          a: for (fiber = deletedSubtreeRoot; null !== nextEffect; ) {
		            current = nextEffect;
		            prevEffectStart = current.sibling;
		            prevEffectDuration = current.return;
		            detachFiberAfterEffects(current);
		            if (current === fiber) {
		              nextEffect = null;
		              break a;
		            }
		            if (null !== prevEffectStart) {
		              prevEffectStart.return = prevEffectDuration;
		              nextEffect = prevEffectStart;
		              break a;
		            }
		            nextEffect = prevEffectDuration;
		          }
		      }
		    }
		    function findFiberRootForHostRoot(hostRoot) {
		      var maybeFiber = getInstanceFromNode(hostRoot);
		      if (null != maybeFiber) {
		        if ("string" !== typeof maybeFiber.memoizedProps["data-testname"])
		          throw Error(
		            "Invalid host root specified. Should be either a React container or a node with a testname attribute."
		          );
		        return maybeFiber;
		      }
		      hostRoot = findFiberRoot(hostRoot);
		      if (null === hostRoot)
		        throw Error(
		          "Could not find React container within specified host subtree."
		        );
		      return hostRoot.stateNode.current;
		    }
		    function matchSelector(fiber$jscomp$0, selector) {
		      var tag = fiber$jscomp$0.tag;
		      switch (selector.$$typeof) {
		        case COMPONENT_TYPE:
		          if (fiber$jscomp$0.type === selector.value) return true;
		          break;
		        case HAS_PSEUDO_CLASS_TYPE:
		          a: {
		            selector = selector.value;
		            fiber$jscomp$0 = [fiber$jscomp$0, 0];
		            for (tag = 0; tag < fiber$jscomp$0.length; ) {
		              var fiber = fiber$jscomp$0[tag++],
		                tag$jscomp$0 = fiber.tag,
		                selectorIndex = fiber$jscomp$0[tag++],
		                selector$jscomp$0 = selector[selectorIndex];
		              if (
		                (5 !== tag$jscomp$0 &&
		                  26 !== tag$jscomp$0 &&
		                  27 !== tag$jscomp$0) ||
		                !isHiddenSubtree(fiber)
		              ) {
		                for (
		                  ;
		                  null != selector$jscomp$0 &&
		                  matchSelector(fiber, selector$jscomp$0);

		                )
		                  selectorIndex++,
		                    (selector$jscomp$0 = selector[selectorIndex]);
		                if (selectorIndex === selector.length) {
		                  selector = true;
		                  break a;
		                } else
		                  for (fiber = fiber.child; null !== fiber; )
		                    fiber$jscomp$0.push(fiber, selectorIndex),
		                      (fiber = fiber.sibling);
		              }
		            }
		            selector = false;
		          }
		          return selector;
		        case ROLE_TYPE:
		          if (
		            (5 === tag || 26 === tag || 27 === tag) &&
		            matchAccessibilityRole(fiber$jscomp$0.stateNode, selector.value)
		          )
		            return true;
		          break;
		        case TEXT_TYPE:
		          if (5 === tag || 6 === tag || 26 === tag || 27 === tag)
		            if (
		              ((fiber$jscomp$0 = getTextContent(fiber$jscomp$0)),
		              null !== fiber$jscomp$0 &&
		                0 <= fiber$jscomp$0.indexOf(selector.value))
		            )
		              return true;
		          break;
		        case TEST_NAME_TYPE:
		          if (5 === tag || 26 === tag || 27 === tag)
		            if (
		              ((fiber$jscomp$0 = fiber$jscomp$0.memoizedProps["data-testname"]),
		              "string" === typeof fiber$jscomp$0 &&
		                fiber$jscomp$0.toLowerCase() === selector.value.toLowerCase())
		            )
		              return true;
		          break;
		        default:
		          throw Error("Invalid selector type specified.");
		      }
		      return false;
		    }
		    function selectorToString(selector) {
		      switch (selector.$$typeof) {
		        case COMPONENT_TYPE:
		          return (
		            "<" + (getComponentNameFromType(selector.value) || "Unknown") + ">"
		          );
		        case HAS_PSEUDO_CLASS_TYPE:
		          return ":has(" + (selectorToString(selector) || "") + ")";
		        case ROLE_TYPE:
		          return '[role="' + selector.value + '"]';
		        case TEXT_TYPE:
		          return '"' + selector.value + '"';
		        case TEST_NAME_TYPE:
		          return '[data-testname="' + selector.value + '"]';
		        default:
		          throw Error("Invalid selector type specified.");
		      }
		    }
		    function findPaths(root, selectors) {
		      var matchingFibers = [];
		      root = [root, 0];
		      for (var index = 0; index < root.length; ) {
		        var fiber = root[index++],
		          tag = fiber.tag,
		          selectorIndex = root[index++],
		          selector = selectors[selectorIndex];
		        if (
		          (5 !== tag && 26 !== tag && 27 !== tag) ||
		          !isHiddenSubtree(fiber)
		        ) {
		          for (; null != selector && matchSelector(fiber, selector); )
		            selectorIndex++, (selector = selectors[selectorIndex]);
		          if (selectorIndex === selectors.length) matchingFibers.push(fiber);
		          else
		            for (fiber = fiber.child; null !== fiber; )
		              root.push(fiber, selectorIndex), (fiber = fiber.sibling);
		        }
		      }
		      return matchingFibers;
		    }
		    function findAllNodes(hostRoot, selectors) {
		      if (!supportsTestSelectors)
		        throw Error("Test selector API is not supported by this renderer.");
		      hostRoot = findFiberRootForHostRoot(hostRoot);
		      hostRoot = findPaths(hostRoot, selectors);
		      selectors = [];
		      hostRoot = Array.from(hostRoot);
		      for (var index = 0; index < hostRoot.length; ) {
		        var node = hostRoot[index++],
		          tag = node.tag;
		        if (5 === tag || 26 === tag || 27 === tag)
		          isHiddenSubtree(node) || selectors.push(node.stateNode);
		        else
		          for (node = node.child; null !== node; )
		            hostRoot.push(node), (node = node.sibling);
		      }
		      return selectors;
		    }
		    function onCommitRoot() {
		      supportsTestSelectors &&
		        commitHooks.forEach(function (commitHook) {
		          return commitHook();
		        });
		    }
		    function isConcurrentActEnvironment() {
		      var isReactActEnvironmentGlobal =
		        "undefined" !== typeof IS_REACT_ACT_ENVIRONMENT
		          ? IS_REACT_ACT_ENVIRONMENT
		          : void 0;
		      isReactActEnvironmentGlobal ||
		        null === ReactSharedInternals.actQueue ||
		        console.error(
		          "The current testing environment is not configured to support act(...)"
		        );
		      return isReactActEnvironmentGlobal;
		    }
		    function requestUpdateLane(fiber) {
		      if (
		        (executionContext & RenderContext) !== NoContext &&
		        0 !== workInProgressRootRenderLanes
		      )
		        return workInProgressRootRenderLanes & -workInProgressRootRenderLanes;
		      var transition = ReactSharedInternals.T;
		      return null !== transition
		        ? (transition._updatedFibers || (transition._updatedFibers = new Set()),
		          transition._updatedFibers.add(fiber),
		          requestTransitionLane())
		        : resolveUpdatePriority();
		    }
		    function requestDeferredLane() {
		      if (0 === workInProgressDeferredLane)
		        if (0 === (workInProgressRootRenderLanes & 536870912) || isHydrating) {
		          var lane = nextTransitionDeferredLane;
		          nextTransitionDeferredLane <<= 1;
		          0 === (nextTransitionDeferredLane & 3932160) &&
		            (nextTransitionDeferredLane = 262144);
		          workInProgressDeferredLane = lane;
		        } else workInProgressDeferredLane = 536870912;
		      lane = suspenseHandlerStackCursor.current;
		      null !== lane && (lane.flags |= 32);
		      return workInProgressDeferredLane;
		    }
		    function scheduleUpdateOnFiber(root, fiber, lane) {
		      isRunningInsertionEffect &&
		        console.error("useInsertionEffect must not schedule updates.");
		      isFlushingPassiveEffects && (didScheduleUpdateDuringPassiveEffects = true);
		      if (
		        (root === workInProgressRoot &&
		          (workInProgressSuspendedReason === SuspendedOnData ||
		            workInProgressSuspendedReason === SuspendedOnAction)) ||
		        null !== root.cancelPendingCommit
		      )
		        prepareFreshStack(root, 0),
		          markRootSuspended(
		            root,
		            workInProgressRootRenderLanes,
		            workInProgressDeferredLane,
		            false
		          );
		      markRootUpdated$1(root, lane);
		      if (
		        (executionContext & RenderContext) !== NoContext &&
		        root === workInProgressRoot
		      ) {
		        if (isRendering)
		          switch (fiber.tag) {
		            case 0:
		            case 11:
		            case 15:
		              root =
		                (workInProgress && getComponentNameFromFiber(workInProgress)) ||
		                "Unknown";
		              didWarnAboutUpdateInRenderForAnotherComponent.has(root) ||
		                (didWarnAboutUpdateInRenderForAnotherComponent.add(root),
		                (fiber = getComponentNameFromFiber(fiber) || "Unknown"),
		                console.error(
		                  "Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://react.dev/link/setstate-in-render",
		                  fiber,
		                  root,
		                  root
		                ));
		              break;
		            case 1:
		              didWarnAboutUpdateInRender ||
		                (console.error(
		                  "Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."
		                ),
		                (didWarnAboutUpdateInRender = true));
		          }
		      } else
		        isDevToolsPresent && addFiberToLanesMap(root, fiber, lane),
		          warnIfUpdatesNotWrappedWithActDEV(fiber),
		          root === workInProgressRoot &&
		            ((executionContext & RenderContext) === NoContext &&
		              (workInProgressRootInterleavedUpdatedLanes |= lane),
		            workInProgressRootExitStatus === RootSuspendedWithDelay &&
		              markRootSuspended(
		                root,
		                workInProgressRootRenderLanes,
		                workInProgressDeferredLane,
		                false
		              )),
		          ensureRootIsScheduled(root);
		    }
		    function performWorkOnRoot(root, lanes, forceSync) {
		      if ((executionContext & (RenderContext | CommitContext)) !== NoContext)
		        throw Error("Should not already be working.");
		      if (0 !== workInProgressRootRenderLanes && null !== workInProgress) {
		        var yieldedFiber = workInProgress,
		          yieldEndTime = now$1();
		        switch (yieldReason) {
		          case SuspendedOnImmediate:
		          case SuspendedOnData:
		            var startTime = yieldStartTime;
		            supportsUserTiming &&
		              ((yieldedFiber = yieldedFiber._debugTask)
		                ? yieldedFiber.run(
		                    console.timeStamp.bind(
		                      console,
		                      "Suspended",
		                      startTime,
		                      yieldEndTime,
		                      "Components \u269b",
		                      void 0,
		                      "primary-light"
		                    )
		                  )
		                : console.timeStamp(
		                    "Suspended",
		                    startTime,
		                    yieldEndTime,
		                    "Components \u269b",
		                    void 0,
		                    "primary-light"
		                  ));
		            break;
		          case SuspendedOnAction:
		            startTime = yieldStartTime;
		            supportsUserTiming &&
		              ((yieldedFiber = yieldedFiber._debugTask)
		                ? yieldedFiber.run(
		                    console.timeStamp.bind(
		                      console,
		                      "Action",
		                      startTime,
		                      yieldEndTime,
		                      "Components \u269b",
		                      void 0,
		                      "primary-light"
		                    )
		                  )
		                : console.timeStamp(
		                    "Action",
		                    startTime,
		                    yieldEndTime,
		                    "Components \u269b",
		                    void 0,
		                    "primary-light"
		                  ));
		            break;
		          default:
		            supportsUserTiming &&
		              ((yieldedFiber = yieldEndTime - yieldStartTime),
		              3 > yieldedFiber ||
		                console.timeStamp(
		                  "Blocked",
		                  yieldStartTime,
		                  yieldEndTime,
		                  "Components \u269b",
		                  void 0,
		                  5 > yieldedFiber
		                    ? "primary-light"
		                    : 10 > yieldedFiber
		                      ? "primary"
		                      : 100 > yieldedFiber
		                        ? "primary-dark"
		                        : "error"
		                ));
		        }
		      }
		      startTime = (forceSync =
		        (!forceSync &&
		          0 === (lanes & 127) &&
		          0 === (lanes & root.expiredLanes)) ||
		        checkIfRootIsPrerendering(root, lanes))
		        ? renderRootConcurrent(root, lanes)
		        : renderRootSync(root, lanes, true);
		      var renderWasConcurrent = forceSync;
		      do {
		        if (startTime === RootInProgress) {
		          workInProgressRootIsPrerendering &&
		            !forceSync &&
		            markRootSuspended(root, lanes, 0, false);
		          lanes = workInProgressSuspendedReason;
		          yieldStartTime = now();
		          yieldReason = lanes;
		          break;
		        } else {
		          yieldedFiber = now$1();
		          yieldEndTime = root.current.alternate;
		          if (
		            renderWasConcurrent &&
		            !isRenderConsistentWithExternalStores(yieldEndTime)
		          ) {
		            setCurrentTrackFromLanes(lanes);
		            yieldEndTime = renderStartTime;
		            startTime = yieldedFiber;
		            !supportsUserTiming ||
		              startTime <= yieldEndTime ||
		              (workInProgressUpdateTask
		                ? workInProgressUpdateTask.run(
		                    console.timeStamp.bind(
		                      console,
		                      "Teared Render",
		                      yieldEndTime,
		                      startTime,
		                      currentTrack,
		                      "Scheduler \u269b",
		                      "error"
		                    )
		                  )
		                : console.timeStamp(
		                    "Teared Render",
		                    yieldEndTime,
		                    startTime,
		                    currentTrack,
		                    "Scheduler \u269b",
		                    "error"
		                  ));
		            finalizeRender(lanes, yieldedFiber);
		            startTime = renderRootSync(root, lanes, false);
		            renderWasConcurrent = false;
		            continue;
		          }
		          if (startTime === RootErrored) {
		            renderWasConcurrent = lanes;
		            if (root.errorRecoveryDisabledLanes & renderWasConcurrent)
		              var errorRetryLanes = 0;
		            else
		              (errorRetryLanes = root.pendingLanes & -536870913),
		                (errorRetryLanes =
		                  0 !== errorRetryLanes
		                    ? errorRetryLanes
		                    : errorRetryLanes & 536870912
		                      ? 536870912
		                      : 0);
		            if (0 !== errorRetryLanes) {
		              setCurrentTrackFromLanes(lanes);
		              logErroredRenderPhase(
		                renderStartTime,
		                yieldedFiber,
		                lanes,
		                workInProgressUpdateTask
		              );
		              finalizeRender(lanes, yieldedFiber);
		              lanes = errorRetryLanes;
		              a: {
		                yieldedFiber = root;
		                startTime = renderWasConcurrent;
		                renderWasConcurrent = workInProgressRootConcurrentErrors;
		                var wasRootDehydrated =
		                  supportsHydration &&
		                  yieldedFiber.current.memoizedState.isDehydrated;
		                wasRootDehydrated &&
		                  (prepareFreshStack(yieldedFiber, errorRetryLanes).flags |=
		                    256);
		                errorRetryLanes = renderRootSync(
		                  yieldedFiber,
		                  errorRetryLanes,
		                  false
		                );
		                if (errorRetryLanes !== RootErrored) {
		                  if (
		                    workInProgressRootDidAttachPingListener &&
		                    !wasRootDehydrated
		                  ) {
		                    yieldedFiber.errorRecoveryDisabledLanes |= startTime;
		                    workInProgressRootInterleavedUpdatedLanes |= startTime;
		                    startTime = RootSuspendedWithDelay;
		                    break a;
		                  }
		                  yieldedFiber = workInProgressRootRecoverableErrors;
		                  workInProgressRootRecoverableErrors = renderWasConcurrent;
		                  null !== yieldedFiber &&
		                    (null === workInProgressRootRecoverableErrors
		                      ? (workInProgressRootRecoverableErrors = yieldedFiber)
		                      : workInProgressRootRecoverableErrors.push.apply(
		                          workInProgressRootRecoverableErrors,
		                          yieldedFiber
		                        ));
		                }
		                startTime = errorRetryLanes;
		              }
		              renderWasConcurrent = false;
		              if (startTime !== RootErrored) continue;
		              else yieldedFiber = now$1();
		            }
		          }
		          if (startTime === RootFatalErrored) {
		            setCurrentTrackFromLanes(lanes);
		            logErroredRenderPhase(
		              renderStartTime,
		              yieldedFiber,
		              lanes,
		              workInProgressUpdateTask
		            );
		            finalizeRender(lanes, yieldedFiber);
		            prepareFreshStack(root, 0);
		            markRootSuspended(root, lanes, 0, true);
		            break;
		          }
		          a: {
		            forceSync = root;
		            switch (startTime) {
		              case RootInProgress:
		              case RootFatalErrored:
		                throw Error("Root did not complete. This is a bug in React.");
		              case RootSuspendedWithDelay:
		                if ((lanes & 4194048) !== lanes) break;
		              case RootSuspendedAtTheShell:
		                setCurrentTrackFromLanes(lanes);
		                logSuspendedRenderPhase(
		                  renderStartTime,
		                  yieldedFiber,
		                  lanes,
		                  workInProgressUpdateTask
		                );
		                finalizeRender(lanes, yieldedFiber);
		                yieldEndTime = lanes;
		                0 !== (yieldEndTime & 127)
		                  ? (blockingSuspendedTime = yieldedFiber)
		                  : 0 !== (yieldEndTime & 4194048) &&
		                    (transitionSuspendedTime = yieldedFiber);
		                markRootSuspended(
		                  forceSync,
		                  lanes,
		                  workInProgressDeferredLane,
		                  !workInProgressRootDidSkipSuspendedSiblings
		                );
		                break a;
		              case RootErrored:
		                workInProgressRootRecoverableErrors = null;
		                break;
		              case RootSuspended:
		              case RootCompleted:
		                break;
		              default:
		                throw Error("Unknown root exit status.");
		            }
		            if (null !== ReactSharedInternals.actQueue)
		              commitRoot(
		                forceSync,
		                yieldEndTime,
		                lanes,
		                workInProgressRootRecoverableErrors,
		                workInProgressTransitions,
		                workInProgressRootDidIncludeRecursiveRenderUpdate,
		                workInProgressDeferredLane,
		                workInProgressRootInterleavedUpdatedLanes,
		                workInProgressSuspendedRetryLanes,
		                startTime,
		                null,
		                null,
		                renderStartTime,
		                yieldedFiber
		              );
		            else {
		              if (
		                (lanes & 62914560) === lanes &&
		                ((renderWasConcurrent =
		                  globalMostRecentFallbackTime +
		                  FALLBACK_THROTTLE_MS -
		                  now$1()),
		                10 < renderWasConcurrent)
		              ) {
		                markRootSuspended(
		                  forceSync,
		                  lanes,
		                  workInProgressDeferredLane,
		                  !workInProgressRootDidSkipSuspendedSiblings
		                );
		                if (0 !== getNextLanes(forceSync, 0, true)) break a;
		                pendingEffectsLanes = lanes;
		                forceSync.timeoutHandle = scheduleTimeout(
		                  commitRootWhenReady.bind(
		                    null,
		                    forceSync,
		                    yieldEndTime,
		                    workInProgressRootRecoverableErrors,
		                    workInProgressTransitions,
		                    workInProgressRootDidIncludeRecursiveRenderUpdate,
		                    lanes,
		                    workInProgressDeferredLane,
		                    workInProgressRootInterleavedUpdatedLanes,
		                    workInProgressSuspendedRetryLanes,
		                    workInProgressRootDidSkipSuspendedSiblings,
		                    startTime,
		                    "Throttled",
		                    renderStartTime,
		                    yieldedFiber
		                  ),
		                  renderWasConcurrent
		                );
		                break a;
		              }
		              commitRootWhenReady(
		                forceSync,
		                yieldEndTime,
		                workInProgressRootRecoverableErrors,
		                workInProgressTransitions,
		                workInProgressRootDidIncludeRecursiveRenderUpdate,
		                lanes,
		                workInProgressDeferredLane,
		                workInProgressRootInterleavedUpdatedLanes,
		                workInProgressSuspendedRetryLanes,
		                workInProgressRootDidSkipSuspendedSiblings,
		                startTime,
		                null,
		                renderStartTime,
		                yieldedFiber
		              );
		            }
		          }
		        }
		        break;
		      } while (1);
		      ensureRootIsScheduled(root);
		    }
		    function commitRootWhenReady(
		      root,
		      finishedWork,
		      recoverableErrors,
		      transitions,
		      didIncludeRenderPhaseUpdate,
		      lanes,
		      spawnedLane,
		      updatedLanes,
		      suspendedRetryLanes,
		      didSkipSuspendedSiblings,
		      exitStatus,
		      suspendedCommitReason,
		      completedRenderStartTime,
		      completedRenderEndTime
		    ) {
		      root.timeoutHandle = noTimeout;
		      var subtreeFlags = finishedWork.subtreeFlags,
		        suspendedState = null;
		      if (subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408))
		        if (
		          ((suspendedState = startSuspendingCommit()),
		          accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedState),
		          (subtreeFlags =
		            (lanes & 62914560) === lanes
		              ? globalMostRecentFallbackTime - now$1()
		              : (lanes & 4194048) === lanes
		                ? globalMostRecentTransitionTime - now$1()
		                : 0),
		          (subtreeFlags = waitForCommitToBeReady(suspendedState, subtreeFlags)),
		          null !== subtreeFlags)
		        ) {
		          pendingEffectsLanes = lanes;
		          root.cancelPendingCommit = subtreeFlags(
		            commitRoot.bind(
		              null,
		              root,
		              finishedWork,
		              lanes,
		              recoverableErrors,
		              transitions,
		              didIncludeRenderPhaseUpdate,
		              spawnedLane,
		              updatedLanes,
		              suspendedRetryLanes,
		              exitStatus,
		              suspendedState,
		              getSuspendedCommitReason(suspendedState, root.containerInfo),
		              completedRenderStartTime,
		              completedRenderEndTime
		            )
		          );
		          markRootSuspended(
		            root,
		            lanes,
		            spawnedLane,
		            !didSkipSuspendedSiblings
		          );
		          return;
		        }
		      commitRoot(
		        root,
		        finishedWork,
		        lanes,
		        recoverableErrors,
		        transitions,
		        didIncludeRenderPhaseUpdate,
		        spawnedLane,
		        updatedLanes,
		        suspendedRetryLanes,
		        exitStatus,
		        suspendedState,
		        suspendedCommitReason,
		        completedRenderStartTime,
		        completedRenderEndTime
		      );
		    }
		    function isRenderConsistentWithExternalStores(finishedWork) {
		      for (var node = finishedWork; ; ) {
		        var tag = node.tag;
		        if (
		          (0 === tag || 11 === tag || 15 === tag) &&
		          node.flags & 16384 &&
		          ((tag = node.updateQueue),
		          null !== tag && ((tag = tag.stores), null !== tag))
		        )
		          for (var i = 0; i < tag.length; i++) {
		            var check = tag[i],
		              getSnapshot = check.getSnapshot;
		            check = check.value;
		            try {
		              if (!objectIs(getSnapshot(), check)) return !1;
		            } catch (error) {
		              return false;
		            }
		          }
		        tag = node.child;
		        if (node.subtreeFlags & 16384 && null !== tag)
		          (tag.return = node), (node = tag);
		        else {
		          if (node === finishedWork) break;
		          for (; null === node.sibling; ) {
		            if (null === node.return || node.return === finishedWork) return true;
		            node = node.return;
		          }
		          node.sibling.return = node.return;
		          node = node.sibling;
		        }
		      }
		      return true;
		    }
		    function markRootSuspended(
		      root,
		      suspendedLanes,
		      spawnedLane,
		      didAttemptEntireTree
		    ) {
		      suspendedLanes &= ~workInProgressRootPingedLanes;
		      suspendedLanes &= ~workInProgressRootInterleavedUpdatedLanes;
		      root.suspendedLanes |= suspendedLanes;
		      root.pingedLanes &= ~suspendedLanes;
		      didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
		      didAttemptEntireTree = root.expirationTimes;
		      for (var lanes = suspendedLanes; 0 < lanes; ) {
		        var index = 31 - clz32(lanes),
		          lane = 1 << index;
		        didAttemptEntireTree[index] = -1;
		        lanes &= ~lane;
		      }
		      0 !== spawnedLane &&
		        markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
		    }
		    function flushSyncWork() {
		      return (executionContext & (RenderContext | CommitContext)) === NoContext
		        ? (flushSyncWorkAcrossRoots_impl(0), false)
		        : true;
		    }
		    function isAlreadyRendering() {
		      return (executionContext & (RenderContext | CommitContext)) !== NoContext;
		    }
		    function resetWorkInProgressStack() {
		      if (null !== workInProgress) {
		        if (workInProgressSuspendedReason === NotSuspended)
		          var interruptedWork = workInProgress.return;
		        else
		          (interruptedWork = workInProgress),
		            resetContextDependencies(),
		            resetHooksOnUnwind(interruptedWork),
		            (thenableState$1 = null),
		            (thenableIndexCounter$1 = 0),
		            (interruptedWork = workInProgress);
		        for (; null !== interruptedWork; )
		          unwindInterruptedWork(interruptedWork.alternate, interruptedWork),
		            (interruptedWork = interruptedWork.return);
		        workInProgress = null;
		      }
		    }
		    function finalizeRender(lanes, finalizationTime) {
		      0 !== (lanes & 127) && (blockingClampTime = finalizationTime);
		      0 !== (lanes & 4194048) && (transitionClampTime = finalizationTime);
		    }
		    function prepareFreshStack(root, lanes) {
		      supportsUserTiming &&
		        (console.timeStamp(
		          "Blocking Track",
		          0.003,
		          0.003,
		          "Blocking",
		          "Scheduler \u269b",
		          "primary-light"
		        ),
		        console.timeStamp(
		          "Transition Track",
		          0.003,
		          0.003,
		          "Transition",
		          "Scheduler \u269b",
		          "primary-light"
		        ),
		        console.timeStamp(
		          "Suspense Track",
		          0.003,
		          0.003,
		          "Suspense",
		          "Scheduler \u269b",
		          "primary-light"
		        ),
		        console.timeStamp(
		          "Idle Track",
		          0.003,
		          0.003,
		          "Idle",
		          "Scheduler \u269b",
		          "primary-light"
		        ));
		      var previousRenderStartTime = renderStartTime;
		      renderStartTime = now();
		      if (0 !== workInProgressRootRenderLanes && 0 < previousRenderStartTime) {
		        setCurrentTrackFromLanes(workInProgressRootRenderLanes);
		        if (
		          workInProgressRootExitStatus === RootSuspended ||
		          workInProgressRootExitStatus === RootSuspendedWithDelay
		        )
		          logSuspendedRenderPhase(
		            previousRenderStartTime,
		            renderStartTime,
		            lanes,
		            workInProgressUpdateTask
		          );
		        else {
		          var endTime = renderStartTime,
		            debugTask = workInProgressUpdateTask;
		          if (supportsUserTiming && !(endTime <= previousRenderStartTime)) {
		            var color =
		                (lanes & 738197653) === lanes
		                  ? "tertiary-dark"
		                  : "primary-dark",
		              label =
		                (lanes & 536870912) === lanes
		                  ? "Prewarm"
		                  : (lanes & 201326741) === lanes
		                    ? "Interrupted Hydration"
		                    : "Interrupted Render";
		            debugTask
		              ? debugTask.run(
		                  console.timeStamp.bind(
		                    console,
		                    label,
		                    previousRenderStartTime,
		                    endTime,
		                    currentTrack,
		                    "Scheduler \u269b",
		                    color
		                  )
		                )
		              : console.timeStamp(
		                  label,
		                  previousRenderStartTime,
		                  endTime,
		                  currentTrack,
		                  "Scheduler \u269b",
		                  color
		                );
		          }
		        }
		        finalizeRender(workInProgressRootRenderLanes, renderStartTime);
		      }
		      previousRenderStartTime = workInProgressUpdateTask;
		      workInProgressUpdateTask = null;
		      if (0 !== (lanes & 127)) {
		        workInProgressUpdateTask = blockingUpdateTask;
		        debugTask =
		          0 <= blockingUpdateTime && blockingUpdateTime < blockingClampTime
		            ? blockingClampTime
		            : blockingUpdateTime;
		        endTime =
		          0 <= blockingEventTime && blockingEventTime < blockingClampTime
		            ? blockingClampTime
		            : blockingEventTime;
		        color =
		          0 <= endTime ? endTime : 0 <= debugTask ? debugTask : renderStartTime;
		        0 <= blockingSuspendedTime &&
		          (setCurrentTrackFromLanes(2),
		          logSuspendedWithDelayPhase(
		            blockingSuspendedTime,
		            color,
		            lanes,
		            previousRenderStartTime
		          ));
		        previousRenderStartTime = debugTask;
		        var eventTime = endTime,
		          eventType = blockingEventType,
		          eventIsRepeat = 0 < blockingEventRepeatTime,
		          isSpawnedUpdate = 1 === blockingUpdateType,
		          isPingedUpdate = 2 === blockingUpdateType;
		        debugTask = renderStartTime;
		        endTime = blockingUpdateTask;
		        color = blockingUpdateMethodName;
		        label = blockingUpdateComponentName;
		        if (supportsUserTiming) {
		          currentTrack = "Blocking";
		          0 < previousRenderStartTime
		            ? previousRenderStartTime > debugTask &&
		              (previousRenderStartTime = debugTask)
		            : (previousRenderStartTime = debugTask);
		          0 < eventTime
		            ? eventTime > previousRenderStartTime &&
		              (eventTime = previousRenderStartTime)
		            : (eventTime = previousRenderStartTime);
		          if (null !== eventType && previousRenderStartTime > eventTime) {
		            var color$jscomp$0 = eventIsRepeat ? "secondary-light" : "warning";
		            endTime
		              ? endTime.run(
		                  console.timeStamp.bind(
		                    console,
		                    eventIsRepeat ? "Consecutive" : "Event: " + eventType,
		                    eventTime,
		                    previousRenderStartTime,
		                    currentTrack,
		                    "Scheduler \u269b",
		                    color$jscomp$0
		                  )
		                )
		              : console.timeStamp(
		                  eventIsRepeat ? "Consecutive" : "Event: " + eventType,
		                  eventTime,
		                  previousRenderStartTime,
		                  currentTrack,
		                  "Scheduler \u269b",
		                  color$jscomp$0
		                );
		          }
		          debugTask > previousRenderStartTime &&
		            ((eventTime = isSpawnedUpdate
		              ? "error"
		              : (lanes & 738197653) === lanes
		                ? "tertiary-light"
		                : "primary-light"),
		            (isSpawnedUpdate = isPingedUpdate
		              ? "Promise Resolved"
		              : isSpawnedUpdate
		                ? "Cascading Update"
		                : 5 < debugTask - previousRenderStartTime
		                  ? "Update Blocked"
		                  : "Update"),
		            (isPingedUpdate = []),
		            null != label && isPingedUpdate.push(["Component name", label]),
		            null != color && isPingedUpdate.push(["Method name", color]),
		            (previousRenderStartTime = {
		              start: previousRenderStartTime,
		              end: debugTask,
		              detail: {
		                devtools: {
		                  properties: isPingedUpdate,
		                  track: currentTrack,
		                  trackGroup: "Scheduler \u269b",
		                  color: eventTime
		                }
		              }
		            }),
		            endTime
		              ? endTime.run(
		                  performance.measure.bind(
		                    performance,
		                    isSpawnedUpdate,
		                    previousRenderStartTime
		                  )
		                )
		              : performance.measure(isSpawnedUpdate, previousRenderStartTime));
		        }
		        blockingUpdateTime = -1.1;
		        blockingUpdateType = 0;
		        blockingUpdateComponentName = blockingUpdateMethodName = null;
		        blockingSuspendedTime = -1.1;
		        blockingEventRepeatTime = blockingEventTime;
		        blockingEventTime = -1.1;
		        blockingClampTime = now();
		      }
		      0 !== (lanes & 4194048) &&
		        ((workInProgressUpdateTask = transitionUpdateTask),
		        (debugTask =
		          0 <= transitionStartTime && transitionStartTime < transitionClampTime
		            ? transitionClampTime
		            : transitionStartTime),
		        (previousRenderStartTime =
		          0 <= transitionUpdateTime &&
		          transitionUpdateTime < transitionClampTime
		            ? transitionClampTime
		            : transitionUpdateTime),
		        (endTime =
		          0 <= transitionEventTime && transitionEventTime < transitionClampTime
		            ? transitionClampTime
		            : transitionEventTime),
		        (color =
		          0 <= endTime
		            ? endTime
		            : 0 <= previousRenderStartTime
		              ? previousRenderStartTime
		              : renderStartTime),
		        0 <= transitionSuspendedTime &&
		          (setCurrentTrackFromLanes(256),
		          logSuspendedWithDelayPhase(
		            transitionSuspendedTime,
		            color,
		            lanes,
		            workInProgressUpdateTask
		          )),
		        (isPingedUpdate = endTime),
		        (eventTime = transitionEventType),
		        (eventType = 0 < transitionEventRepeatTime),
		        (eventIsRepeat = 2 === transitionUpdateType),
		        (color = renderStartTime),
		        (endTime = transitionUpdateTask),
		        (label = transitionUpdateMethodName),
		        (isSpawnedUpdate = transitionUpdateComponentName),
		        supportsUserTiming &&
		          ((currentTrack = "Transition"),
		          0 < previousRenderStartTime
		            ? previousRenderStartTime > color &&
		              (previousRenderStartTime = color)
		            : (previousRenderStartTime = color),
		          0 < debugTask
		            ? debugTask > previousRenderStartTime &&
		              (debugTask = previousRenderStartTime)
		            : (debugTask = previousRenderStartTime),
		          0 < isPingedUpdate
		            ? isPingedUpdate > debugTask && (isPingedUpdate = debugTask)
		            : (isPingedUpdate = debugTask),
		          debugTask > isPingedUpdate &&
		            null !== eventTime &&
		            ((color$jscomp$0 = eventType ? "secondary-light" : "warning"),
		            endTime
		              ? endTime.run(
		                  console.timeStamp.bind(
		                    console,
		                    eventType ? "Consecutive" : "Event: " + eventTime,
		                    isPingedUpdate,
		                    debugTask,
		                    currentTrack,
		                    "Scheduler \u269b",
		                    color$jscomp$0
		                  )
		                )
		              : console.timeStamp(
		                  eventType ? "Consecutive" : "Event: " + eventTime,
		                  isPingedUpdate,
		                  debugTask,
		                  currentTrack,
		                  "Scheduler \u269b",
		                  color$jscomp$0
		                )),
		          previousRenderStartTime > debugTask &&
		            (endTime
		              ? endTime.run(
		                  console.timeStamp.bind(
		                    console,
		                    "Action",
		                    debugTask,
		                    previousRenderStartTime,
		                    currentTrack,
		                    "Scheduler \u269b",
		                    "primary-dark"
		                  )
		                )
		              : console.timeStamp(
		                  "Action",
		                  debugTask,
		                  previousRenderStartTime,
		                  currentTrack,
		                  "Scheduler \u269b",
		                  "primary-dark"
		                )),
		          color > previousRenderStartTime &&
		            ((debugTask = eventIsRepeat
		              ? "Promise Resolved"
		              : 5 < color - previousRenderStartTime
		                ? "Update Blocked"
		                : "Update"),
		            (isPingedUpdate = []),
		            null != isSpawnedUpdate &&
		              isPingedUpdate.push(["Component name", isSpawnedUpdate]),
		            null != label && isPingedUpdate.push(["Method name", label]),
		            (previousRenderStartTime = {
		              start: previousRenderStartTime,
		              end: color,
		              detail: {
		                devtools: {
		                  properties: isPingedUpdate,
		                  track: currentTrack,
		                  trackGroup: "Scheduler \u269b",
		                  color: "primary-light"
		                }
		              }
		            }),
		            endTime
		              ? endTime.run(
		                  performance.measure.bind(
		                    performance,
		                    debugTask,
		                    previousRenderStartTime
		                  )
		                )
		              : performance.measure(debugTask, previousRenderStartTime))),
		        (transitionUpdateTime = transitionStartTime = -1.1),
		        (transitionUpdateType = 0),
		        (transitionSuspendedTime = -1.1),
		        (transitionEventRepeatTime = transitionEventTime),
		        (transitionEventTime = -1.1),
		        (transitionClampTime = now()));
		      previousRenderStartTime = root.timeoutHandle;
		      previousRenderStartTime !== noTimeout &&
		        ((root.timeoutHandle = noTimeout),
		        cancelTimeout(previousRenderStartTime));
		      previousRenderStartTime = root.cancelPendingCommit;
		      null !== previousRenderStartTime &&
		        ((root.cancelPendingCommit = null), previousRenderStartTime());
		      pendingEffectsLanes = 0;
		      resetWorkInProgressStack();
		      workInProgressRoot = root;
		      workInProgress = previousRenderStartTime = createWorkInProgress(
		        root.current,
		        null
		      );
		      workInProgressRootRenderLanes = lanes;
		      workInProgressSuspendedReason = NotSuspended;
		      workInProgressThrownValue = null;
		      workInProgressRootDidSkipSuspendedSiblings = false;
		      workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
		      workInProgressRootDidAttachPingListener = false;
		      workInProgressRootExitStatus = RootInProgress;
		      workInProgressSuspendedRetryLanes =
		        workInProgressDeferredLane =
		        workInProgressRootPingedLanes =
		        workInProgressRootInterleavedUpdatedLanes =
		        workInProgressRootSkippedLanes =
		          0;
		      workInProgressRootRecoverableErrors = workInProgressRootConcurrentErrors =
		        null;
		      workInProgressRootDidIncludeRecursiveRenderUpdate = false;
		      0 !== (lanes & 8) && (lanes |= lanes & 32);
		      endTime = root.entangledLanes;
		      if (0 !== endTime)
		        for (root = root.entanglements, endTime &= lanes; 0 < endTime; )
		          (debugTask = 31 - clz32(endTime)),
		            (color = 1 << debugTask),
		            (lanes |= root[debugTask]),
		            (endTime &= ~color);
		      entangledRenderLanes = lanes;
		      finishQueueingConcurrentUpdates();
		      root = getCurrentTime();
		      1e3 < root - lastResetTime &&
		        ((ReactSharedInternals.recentlyCreatedOwnerStacks = 0),
		        (lastResetTime = root));
		      ReactStrictModeWarnings.discardPendingWarnings();
		      return previousRenderStartTime;
		    }
		    function handleThrow(root, thrownValue) {
		      currentlyRenderingFiber = null;
		      ReactSharedInternals.H = ContextOnlyDispatcher;
		      ReactSharedInternals.getCurrentStack = null;
		      isRendering = false;
		      current = null;
		      thrownValue === SuspenseException ||
		      thrownValue === SuspenseActionException
		        ? ((thrownValue = getSuspendedThenable()),
		          (workInProgressSuspendedReason = SuspendedOnImmediate))
		        : thrownValue === SuspenseyCommitException
		          ? ((thrownValue = getSuspendedThenable()),
		            (workInProgressSuspendedReason = SuspendedOnInstance))
		          : (workInProgressSuspendedReason =
		              thrownValue === SelectiveHydrationException
		                ? SuspendedOnHydration
		                : null !== thrownValue &&
		                    "object" === typeof thrownValue &&
		                    "function" === typeof thrownValue.then
		                  ? SuspendedOnDeprecatedThrowPromise
		                  : SuspendedOnError);
		      workInProgressThrownValue = thrownValue;
		      var erroredWork = workInProgress;
		      null === erroredWork
		        ? ((workInProgressRootExitStatus = RootFatalErrored),
		          logUncaughtError(
		            root,
		            createCapturedValueAtFiber(thrownValue, root.current)
		          ))
		        : erroredWork.mode & 2 &&
		          stopProfilerTimerIfRunningAndRecordDuration(erroredWork);
		    }
		    function shouldRemainOnPreviousScreen() {
		      var handler = suspenseHandlerStackCursor.current;
		      return null === handler
		        ? true
		        : (workInProgressRootRenderLanes & 4194048) ===
		            workInProgressRootRenderLanes
		          ? null === shellBoundary
		            ? true
		            : false
		          : (workInProgressRootRenderLanes & 62914560) ===
		                workInProgressRootRenderLanes ||
		              0 !== (workInProgressRootRenderLanes & 536870912)
		            ? handler === shellBoundary
		            : false;
		    }
		    function pushDispatcher() {
		      var prevDispatcher = ReactSharedInternals.H;
		      ReactSharedInternals.H = ContextOnlyDispatcher;
		      return null === prevDispatcher ? ContextOnlyDispatcher : prevDispatcher;
		    }
		    function pushAsyncDispatcher() {
		      var prevAsyncDispatcher = ReactSharedInternals.A;
		      ReactSharedInternals.A = DefaultAsyncDispatcher;
		      return prevAsyncDispatcher;
		    }
		    function markRenderDerivedCause(fiber) {
		      null === workInProgressUpdateTask &&
		        (workInProgressUpdateTask =
		          null == fiber._debugTask ? null : fiber._debugTask);
		    }
		    function renderDidSuspendDelayIfPossible() {
		      workInProgressRootExitStatus = RootSuspendedWithDelay;
		      workInProgressRootDidSkipSuspendedSiblings ||
		        ((workInProgressRootRenderLanes & 4194048) !==
		          workInProgressRootRenderLanes &&
		          null !== suspenseHandlerStackCursor.current) ||
		        (workInProgressRootIsPrerendering = true);
		      (0 === (workInProgressRootSkippedLanes & 134217727) &&
		        0 === (workInProgressRootInterleavedUpdatedLanes & 134217727)) ||
		        null === workInProgressRoot ||
		        markRootSuspended(
		          workInProgressRoot,
		          workInProgressRootRenderLanes,
		          workInProgressDeferredLane,
		          false
		        );
		    }
		    function renderRootSync(root, lanes, shouldYieldForPrerendering) {
		      var prevExecutionContext = executionContext;
		      executionContext |= RenderContext;
		      var prevDispatcher = pushDispatcher(),
		        prevAsyncDispatcher = pushAsyncDispatcher();
		      if (
		        workInProgressRoot !== root ||
		        workInProgressRootRenderLanes !== lanes
		      ) {
		        if (isDevToolsPresent) {
		          var memoizedUpdaters = root.memoizedUpdaters;
		          0 < memoizedUpdaters.size &&
		            (restorePendingUpdaters(root, workInProgressRootRenderLanes),
		            memoizedUpdaters.clear());
		          movePendingFibersToMemoized(root, lanes);
		        }
		        workInProgressTransitions = null;
		        prepareFreshStack(root, lanes);
		      }
		      lanes = false;
		      memoizedUpdaters = workInProgressRootExitStatus;
		      a: do
		        try {
		          if (
		            workInProgressSuspendedReason !== NotSuspended &&
		            null !== workInProgress
		          ) {
		            var unitOfWork = workInProgress,
		              thrownValue = workInProgressThrownValue;
		            switch (workInProgressSuspendedReason) {
		              case SuspendedOnHydration:
		                resetWorkInProgressStack();
		                memoizedUpdaters = RootSuspendedAtTheShell;
		                break a;
		              case SuspendedOnImmediate:
		              case SuspendedOnData:
		              case SuspendedOnAction:
		              case SuspendedOnDeprecatedThrowPromise:
		                null === suspenseHandlerStackCursor.current && (lanes = !0);
		                var reason = workInProgressSuspendedReason;
		                workInProgressSuspendedReason = NotSuspended;
		                workInProgressThrownValue = null;
		                throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
		                if (
		                  shouldYieldForPrerendering &&
		                  workInProgressRootIsPrerendering
		                ) {
		                  memoizedUpdaters = RootInProgress;
		                  break a;
		                }
		                break;
		              default:
		                (reason = workInProgressSuspendedReason),
		                  (workInProgressSuspendedReason = NotSuspended),
		                  (workInProgressThrownValue = null),
		                  throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
		            }
		          }
		          workLoopSync();
		          memoizedUpdaters = workInProgressRootExitStatus;
		          break;
		        } catch (thrownValue$4) {
		          handleThrow(root, thrownValue$4);
		        }
		      while (1);
		      lanes && root.shellSuspendCounter++;
		      resetContextDependencies();
		      executionContext = prevExecutionContext;
		      ReactSharedInternals.H = prevDispatcher;
		      ReactSharedInternals.A = prevAsyncDispatcher;
		      null === workInProgress &&
		        ((workInProgressRoot = null),
		        (workInProgressRootRenderLanes = 0),
		        finishQueueingConcurrentUpdates());
		      return memoizedUpdaters;
		    }
		    function workLoopSync() {
		      for (; null !== workInProgress; ) performUnitOfWork(workInProgress);
		    }
		    function renderRootConcurrent(root, lanes) {
		      var prevExecutionContext = executionContext;
		      executionContext |= RenderContext;
		      var prevDispatcher = pushDispatcher(),
		        prevAsyncDispatcher = pushAsyncDispatcher();
		      if (
		        workInProgressRoot !== root ||
		        workInProgressRootRenderLanes !== lanes
		      ) {
		        if (isDevToolsPresent) {
		          var memoizedUpdaters = root.memoizedUpdaters;
		          0 < memoizedUpdaters.size &&
		            (restorePendingUpdaters(root, workInProgressRootRenderLanes),
		            memoizedUpdaters.clear());
		          movePendingFibersToMemoized(root, lanes);
		        }
		        workInProgressTransitions = null;
		        workInProgressRootRenderTargetTime = now$1() + RENDER_TIMEOUT_MS;
		        prepareFreshStack(root, lanes);
		      } else
		        workInProgressRootIsPrerendering = checkIfRootIsPrerendering(
		          root,
		          lanes
		        );
		      a: do
		        try {
		          if (
		            workInProgressSuspendedReason !== NotSuspended &&
		            null !== workInProgress
		          )
		            b: switch (
		              ((lanes = workInProgress),
		              (memoizedUpdaters = workInProgressThrownValue),
		              workInProgressSuspendedReason)
		            ) {
		              case SuspendedOnError:
		                workInProgressSuspendedReason = NotSuspended;
		                workInProgressThrownValue = null;
		                throwAndUnwindWorkLoop(
		                  root,
		                  lanes,
		                  memoizedUpdaters,
		                  SuspendedOnError
		                );
		                break;
		              case SuspendedOnData:
		              case SuspendedOnAction:
		                if (isThenableResolved(memoizedUpdaters)) {
		                  workInProgressSuspendedReason = NotSuspended;
		                  workInProgressThrownValue = null;
		                  replaySuspendedUnitOfWork(lanes);
		                  break;
		                }
		                lanes = function () {
		                  (workInProgressSuspendedReason !== SuspendedOnData &&
		                    workInProgressSuspendedReason !== SuspendedOnAction) ||
		                    workInProgressRoot !== root ||
		                    (workInProgressSuspendedReason =
		                      SuspendedAndReadyToContinue);
		                  ensureRootIsScheduled(root);
		                };
		                memoizedUpdaters.then(lanes, lanes);
		                break a;
		              case SuspendedOnImmediate:
		                workInProgressSuspendedReason = SuspendedAndReadyToContinue;
		                break a;
		              case SuspendedOnInstance:
		                workInProgressSuspendedReason =
		                  SuspendedOnInstanceAndReadyToContinue;
		                break a;
		              case SuspendedAndReadyToContinue:
		                isThenableResolved(memoizedUpdaters)
		                  ? ((workInProgressSuspendedReason = NotSuspended),
		                    (workInProgressThrownValue = null),
		                    replaySuspendedUnitOfWork(lanes))
		                  : ((workInProgressSuspendedReason = NotSuspended),
		                    (workInProgressThrownValue = null),
		                    throwAndUnwindWorkLoop(
		                      root,
		                      lanes,
		                      memoizedUpdaters,
		                      SuspendedAndReadyToContinue
		                    ));
		                break;
		              case SuspendedOnInstanceAndReadyToContinue:
		                var resource = null;
		                switch (workInProgress.tag) {
		                  case 26:
		                    resource = workInProgress.memoizedState;
		                  case 5:
		                  case 27:
		                    var hostFiber = workInProgress,
		                      type = hostFiber.type,
		                      props = hostFiber.pendingProps;
		                    if (
		                      resource
		                        ? preloadResource(resource)
		                        : preloadInstance(hostFiber.stateNode, type, props)
		                    ) {
		                      workInProgressSuspendedReason = NotSuspended;
		                      workInProgressThrownValue = null;
		                      var sibling = hostFiber.sibling;
		                      if (null !== sibling) workInProgress = sibling;
		                      else {
		                        var returnFiber = hostFiber.return;
		                        null !== returnFiber
		                          ? ((workInProgress = returnFiber),
		                            completeUnitOfWork(returnFiber))
		                          : (workInProgress = null);
		                      }
		                      break b;
		                    }
		                    break;
		                  default:
		                    console.error(
		                      "Unexpected type of fiber triggered a suspensey commit. This is a bug in React."
		                    );
		                }
		                workInProgressSuspendedReason = NotSuspended;
		                workInProgressThrownValue = null;
		                throwAndUnwindWorkLoop(
		                  root,
		                  lanes,
		                  memoizedUpdaters,
		                  SuspendedOnInstanceAndReadyToContinue
		                );
		                break;
		              case SuspendedOnDeprecatedThrowPromise:
		                workInProgressSuspendedReason = NotSuspended;
		                workInProgressThrownValue = null;
		                throwAndUnwindWorkLoop(
		                  root,
		                  lanes,
		                  memoizedUpdaters,
		                  SuspendedOnDeprecatedThrowPromise
		                );
		                break;
		              case SuspendedOnHydration:
		                resetWorkInProgressStack();
		                workInProgressRootExitStatus = RootSuspendedAtTheShell;
		                break a;
		              default:
		                throw Error(
		                  "Unexpected SuspendedReason. This is a bug in React."
		                );
		            }
		          null !== ReactSharedInternals.actQueue
		            ? workLoopSync()
		            : workLoopConcurrentByScheduler();
		          break;
		        } catch (thrownValue$5) {
		          handleThrow(root, thrownValue$5);
		        }
		      while (1);
		      resetContextDependencies();
		      ReactSharedInternals.H = prevDispatcher;
		      ReactSharedInternals.A = prevAsyncDispatcher;
		      executionContext = prevExecutionContext;
		      if (null !== workInProgress) return RootInProgress;
		      workInProgressRoot = null;
		      workInProgressRootRenderLanes = 0;
		      finishQueueingConcurrentUpdates();
		      return workInProgressRootExitStatus;
		    }
		    function workLoopConcurrentByScheduler() {
		      for (; null !== workInProgress && !shouldYield(); )
		        performUnitOfWork(workInProgress);
		    }
		    function performUnitOfWork(unitOfWork) {
		      var current = unitOfWork.alternate;
		      (unitOfWork.mode & 2) !== NoMode
		        ? (startProfilerTimer(unitOfWork),
		          (current = runWithFiberInDEV(
		            unitOfWork,
		            beginWork,
		            current,
		            unitOfWork,
		            entangledRenderLanes
		          )),
		          stopProfilerTimerIfRunningAndRecordDuration(unitOfWork))
		        : (current = runWithFiberInDEV(
		            unitOfWork,
		            beginWork,
		            current,
		            unitOfWork,
		            entangledRenderLanes
		          ));
		      unitOfWork.memoizedProps = unitOfWork.pendingProps;
		      null === current
		        ? completeUnitOfWork(unitOfWork)
		        : (workInProgress = current);
		    }
		    function replaySuspendedUnitOfWork(unitOfWork) {
		      var next = runWithFiberInDEV(unitOfWork, replayBeginWork, unitOfWork);
		      unitOfWork.memoizedProps = unitOfWork.pendingProps;
		      null === next ? completeUnitOfWork(unitOfWork) : (workInProgress = next);
		    }
		    function replayBeginWork(unitOfWork) {
		      var current = unitOfWork.alternate,
		        isProfilingMode = (unitOfWork.mode & 2) !== NoMode;
		      isProfilingMode && startProfilerTimer(unitOfWork);
		      switch (unitOfWork.tag) {
		        case 15:
		        case 0:
		          current = replayFunctionComponent(
		            current,
		            unitOfWork,
		            unitOfWork.pendingProps,
		            unitOfWork.type,
		            void 0,
		            workInProgressRootRenderLanes
		          );
		          break;
		        case 11:
		          current = replayFunctionComponent(
		            current,
		            unitOfWork,
		            unitOfWork.pendingProps,
		            unitOfWork.type.render,
		            unitOfWork.ref,
		            workInProgressRootRenderLanes
		          );
		          break;
		        case 5:
		          resetHooksOnUnwind(unitOfWork);
		        default:
		          unwindInterruptedWork(current, unitOfWork),
		            (unitOfWork = workInProgress =
		              resetWorkInProgress(unitOfWork, entangledRenderLanes)),
		            (current = beginWork(current, unitOfWork, entangledRenderLanes));
		      }
		      isProfilingMode &&
		        stopProfilerTimerIfRunningAndRecordDuration(unitOfWork);
		      return current;
		    }
		    function throwAndUnwindWorkLoop(
		      root,
		      unitOfWork,
		      thrownValue,
		      suspendedReason
		    ) {
		      resetContextDependencies();
		      resetHooksOnUnwind(unitOfWork);
		      thenableState$1 = null;
		      thenableIndexCounter$1 = 0;
		      var returnFiber = unitOfWork.return;
		      try {
		        if (
		          throwException(
		            root,
		            returnFiber,
		            unitOfWork,
		            thrownValue,
		            workInProgressRootRenderLanes
		          )
		        ) {
		          workInProgressRootExitStatus = RootFatalErrored;
		          logUncaughtError(
		            root,
		            createCapturedValueAtFiber(thrownValue, root.current)
		          );
		          workInProgress = null;
		          return;
		        }
		      } catch (error) {
		        if (null !== returnFiber) throw ((workInProgress = returnFiber), error);
		        workInProgressRootExitStatus = RootFatalErrored;
		        logUncaughtError(
		          root,
		          createCapturedValueAtFiber(thrownValue, root.current)
		        );
		        workInProgress = null;
		        return;
		      }
		      if (unitOfWork.flags & 32768) {
		        if (isHydrating || suspendedReason === SuspendedOnError) root = true;
		        else if (
		          workInProgressRootIsPrerendering ||
		          0 !== (workInProgressRootRenderLanes & 536870912)
		        )
		          root = false;
		        else if (
		          ((workInProgressRootDidSkipSuspendedSiblings = root = true),
		          suspendedReason === SuspendedOnData ||
		            suspendedReason === SuspendedOnAction ||
		            suspendedReason === SuspendedOnImmediate ||
		            suspendedReason === SuspendedOnDeprecatedThrowPromise)
		        )
		          (suspendedReason = suspenseHandlerStackCursor.current),
		            null !== suspendedReason &&
		              13 === suspendedReason.tag &&
		              (suspendedReason.flags |= 16384);
		        unwindUnitOfWork(unitOfWork, root);
		      } else completeUnitOfWork(unitOfWork);
		    }
		    function completeUnitOfWork(unitOfWork) {
		      var completedWork = unitOfWork;
		      do {
		        if (0 !== (completedWork.flags & 32768)) {
		          unwindUnitOfWork(
		            completedWork,
		            workInProgressRootDidSkipSuspendedSiblings
		          );
		          return;
		        }
		        var current = completedWork.alternate;
		        unitOfWork = completedWork.return;
		        startProfilerTimer(completedWork);
		        current = runWithFiberInDEV(
		          completedWork,
		          completeWork,
		          current,
		          completedWork,
		          entangledRenderLanes
		        );
		        (completedWork.mode & 2) !== NoMode &&
		          stopProfilerTimerIfRunningAndRecordIncompleteDuration(completedWork);
		        if (null !== current) {
		          workInProgress = current;
		          return;
		        }
		        completedWork = completedWork.sibling;
		        if (null !== completedWork) {
		          workInProgress = completedWork;
		          return;
		        }
		        workInProgress = completedWork = unitOfWork;
		      } while (null !== completedWork);
		      workInProgressRootExitStatus === RootInProgress &&
		        (workInProgressRootExitStatus = RootCompleted);
		    }
		    function unwindUnitOfWork(unitOfWork, skipSiblings) {
		      do {
		        var next = unwindWork(unitOfWork.alternate, unitOfWork);
		        if (null !== next) {
		          next.flags &= 32767;
		          workInProgress = next;
		          return;
		        }
		        if ((unitOfWork.mode & 2) !== NoMode) {
		          stopProfilerTimerIfRunningAndRecordIncompleteDuration(unitOfWork);
		          next = unitOfWork.actualDuration;
		          for (var child = unitOfWork.child; null !== child; )
		            (next += child.actualDuration), (child = child.sibling);
		          unitOfWork.actualDuration = next;
		        }
		        next = unitOfWork.return;
		        null !== next &&
		          ((next.flags |= 32768),
		          (next.subtreeFlags = 0),
		          (next.deletions = null));
		        if (
		          !skipSiblings &&
		          ((unitOfWork = unitOfWork.sibling), null !== unitOfWork)
		        ) {
		          workInProgress = unitOfWork;
		          return;
		        }
		        workInProgress = unitOfWork = next;
		      } while (null !== unitOfWork);
		      workInProgressRootExitStatus = RootSuspendedAtTheShell;
		      workInProgress = null;
		    }
		    function commitRoot(
		      root,
		      finishedWork,
		      lanes,
		      recoverableErrors,
		      transitions,
		      didIncludeRenderPhaseUpdate,
		      spawnedLane,
		      updatedLanes,
		      suspendedRetryLanes,
		      exitStatus,
		      suspendedState,
		      suspendedCommitReason,
		      completedRenderStartTime,
		      completedRenderEndTime
		    ) {
		      root.cancelPendingCommit = null;
		      do flushPendingEffects();
		      while (pendingEffectsStatus !== NO_PENDING_EFFECTS);
		      ReactStrictModeWarnings.flushLegacyContextWarning();
		      ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
		      if ((executionContext & (RenderContext | CommitContext)) !== NoContext)
		        throw Error("Should not already be working.");
		      setCurrentTrackFromLanes(lanes);
		      exitStatus === RootErrored
		        ? logErroredRenderPhase(
		            completedRenderStartTime,
		            completedRenderEndTime,
		            lanes,
		            workInProgressUpdateTask
		          )
		        : null !== recoverableErrors
		          ? logRecoveredRenderPhase(
		              completedRenderStartTime,
		              completedRenderEndTime,
		              lanes,
		              recoverableErrors,
		              null !== finishedWork &&
		                null !== finishedWork.alternate &&
		                finishedWork.alternate.memoizedState.isDehydrated &&
		                0 !== (finishedWork.flags & 256),
		              workInProgressUpdateTask
		            )
		          : logRenderPhase(
		              completedRenderStartTime,
		              completedRenderEndTime,
		              lanes,
		              workInProgressUpdateTask
		            );
		      if (null !== finishedWork) {
		        0 === lanes &&
		          console.error(
		            "finishedLanes should not be empty during a commit. This is a bug in React."
		          );
		        if (finishedWork === root.current)
		          throw Error(
		            "Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue."
		          );
		        didIncludeRenderPhaseUpdate =
		          finishedWork.lanes | finishedWork.childLanes;
		        didIncludeRenderPhaseUpdate |= concurrentlyUpdatedLanes;
		        markRootFinished(
		          root,
		          lanes,
		          didIncludeRenderPhaseUpdate,
		          spawnedLane,
		          updatedLanes,
		          suspendedRetryLanes
		        );
		        root === workInProgressRoot &&
		          ((workInProgress = workInProgressRoot = null),
		          (workInProgressRootRenderLanes = 0));
		        pendingFinishedWork = finishedWork;
		        pendingEffectsRoot = root;
		        pendingEffectsLanes = lanes;
		        pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
		        pendingPassiveTransitions = transitions;
		        pendingRecoverableErrors = recoverableErrors;
		        pendingEffectsRenderEndTime = completedRenderEndTime;
		        pendingSuspendedCommitReason = suspendedCommitReason;
		        pendingDelayedCommitReason = IMMEDIATE_COMMIT;
		        pendingSuspendedViewTransitionReason = null;
		        0 !== finishedWork.actualDuration ||
		        0 !== (finishedWork.subtreeFlags & 10256) ||
		        0 !== (finishedWork.flags & 10256)
		          ? ((root.callbackNode = null),
		            (root.callbackPriority = 0),
		            scheduleCallback(NormalPriority$1, function () {
		              trackSchedulerEvent();
		              pendingDelayedCommitReason === IMMEDIATE_COMMIT &&
		                (pendingDelayedCommitReason = DELAYED_PASSIVE_COMMIT);
		              flushPassiveEffects();
		              return null;
		            }))
		          : ((root.callbackNode = null), (root.callbackPriority = 0));
		        commitErrors = null;
		        commitStartTime = now();
		        null !== suspendedCommitReason &&
		          logSuspendedCommitPhase(
		            completedRenderEndTime,
		            commitStartTime,
		            suspendedCommitReason,
		            workInProgressUpdateTask
		          );
		        recoverableErrors = 0 !== (finishedWork.flags & 13878);
		        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
		          recoverableErrors = ReactSharedInternals.T;
		          ReactSharedInternals.T = null;
		          transitions = getCurrentUpdatePriority();
		          setCurrentUpdatePriority(2);
		          spawnedLane = executionContext;
		          executionContext |= CommitContext;
		          try {
		            commitBeforeMutationEffects(root, finishedWork, lanes);
		          } finally {
		            (executionContext = spawnedLane),
		              setCurrentUpdatePriority(transitions),
		              (ReactSharedInternals.T = recoverableErrors);
		          }
		        }
		        pendingEffectsStatus = PENDING_MUTATION_PHASE;
		        flushMutationEffects();
		        flushLayoutEffects();
		        flushSpawnedWork();
		      }
		    }
		    function flushMutationEffects() {
		      if (pendingEffectsStatus === PENDING_MUTATION_PHASE) {
		        pendingEffectsStatus = NO_PENDING_EFFECTS;
		        var root = pendingEffectsRoot,
		          finishedWork = pendingFinishedWork,
		          lanes = pendingEffectsLanes,
		          rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
		        if (
		          0 !== (finishedWork.subtreeFlags & 13878) ||
		          rootMutationHasEffect
		        ) {
		          rootMutationHasEffect = ReactSharedInternals.T;
		          ReactSharedInternals.T = null;
		          var previousPriority = getCurrentUpdatePriority();
		          setCurrentUpdatePriority(2);
		          var prevExecutionContext = executionContext;
		          executionContext |= CommitContext;
		          try {
		            (inProgressLanes = lanes),
		              (inProgressRoot = root),
		              resetComponentEffectTimers(),
		              commitMutationEffectsOnFiber(finishedWork, root),
		              (inProgressRoot = inProgressLanes = null),
		              resetAfterCommit(root.containerInfo);
		          } finally {
		            (executionContext = prevExecutionContext),
		              setCurrentUpdatePriority(previousPriority),
		              (ReactSharedInternals.T = rootMutationHasEffect);
		          }
		        }
		        root.current = finishedWork;
		        pendingEffectsStatus = PENDING_LAYOUT_PHASE;
		      }
		    }
		    function flushLayoutEffects() {
		      if (pendingEffectsStatus === PENDING_LAYOUT_PHASE) {
		        pendingEffectsStatus = NO_PENDING_EFFECTS;
		        var suspendedViewTransitionReason =
		          pendingSuspendedViewTransitionReason;
		        if (null !== suspendedViewTransitionReason) {
		          commitStartTime = now();
		          var startTime = commitEndTime,
		            endTime = commitStartTime;
		          !supportsUserTiming ||
		            endTime <= startTime ||
		            (console.timeStamp(
		                  suspendedViewTransitionReason,
		                  startTime,
		                  endTime,
		                  currentTrack,
		                  "Scheduler \u269b",
		                  "secondary-light"
		                ));
		        }
		        suspendedViewTransitionReason = pendingEffectsRoot;
		        startTime = pendingFinishedWork;
		        endTime = pendingEffectsLanes;
		        var rootHasLayoutEffect = 0 !== (startTime.flags & 8772);
		        if (0 !== (startTime.subtreeFlags & 8772) || rootHasLayoutEffect) {
		          rootHasLayoutEffect = ReactSharedInternals.T;
		          ReactSharedInternals.T = null;
		          var _previousPriority = getCurrentUpdatePriority();
		          setCurrentUpdatePriority(2);
		          var _prevExecutionContext = executionContext;
		          executionContext |= CommitContext;
		          try {
		            (inProgressLanes = endTime),
		              (inProgressRoot = suspendedViewTransitionReason),
		              resetComponentEffectTimers(),
		              commitLayoutEffectOnFiber(
		                suspendedViewTransitionReason,
		                startTime.alternate,
		                startTime
		              ),
		              (inProgressRoot = inProgressLanes = null);
		          } finally {
		            (executionContext = _prevExecutionContext),
		              setCurrentUpdatePriority(_previousPriority),
		              (ReactSharedInternals.T = rootHasLayoutEffect);
		          }
		        }
		        suspendedViewTransitionReason = pendingEffectsRenderEndTime;
		        startTime = pendingSuspendedCommitReason;
		        commitEndTime = now();
		        suspendedViewTransitionReason =
		          null === startTime ? suspendedViewTransitionReason : commitStartTime;
		        startTime = commitEndTime;
		        endTime = pendingDelayedCommitReason === ABORTED_VIEW_TRANSITION_COMMIT;
		        rootHasLayoutEffect = workInProgressUpdateTask;
		        null !== commitErrors
		          ? logCommitErrored(
		              suspendedViewTransitionReason,
		              startTime,
		              commitErrors,
		              false,
		              rootHasLayoutEffect
		            )
		          : !supportsUserTiming ||
		            startTime <= suspendedViewTransitionReason ||
		            (rootHasLayoutEffect
		              ? rootHasLayoutEffect.run(
		                  console.timeStamp.bind(
		                    console,
		                    endTime ? "Commit Interrupted View Transition" : "Commit",
		                    suspendedViewTransitionReason,
		                    startTime,
		                    currentTrack,
		                    "Scheduler \u269b",
		                    endTime ? "error" : "secondary-dark"
		                  )
		                )
		              : console.timeStamp(
		                  endTime ? "Commit Interrupted View Transition" : "Commit",
		                  suspendedViewTransitionReason,
		                  startTime,
		                  currentTrack,
		                  "Scheduler \u269b",
		                  endTime ? "error" : "secondary-dark"
		                ));
		        pendingEffectsStatus = PENDING_AFTER_MUTATION_PHASE;
		      }
		    }
		    function flushSpawnedWork() {
		      if (
		        pendingEffectsStatus === PENDING_SPAWNED_WORK ||
		        pendingEffectsStatus === PENDING_AFTER_MUTATION_PHASE
		      ) {
		        if (pendingEffectsStatus === PENDING_SPAWNED_WORK) {
		          var startViewTransitionStartTime = commitEndTime;
		          commitEndTime = now();
		          var endTime = commitEndTime,
		            abortedViewTransition =
		              pendingDelayedCommitReason === ABORTED_VIEW_TRANSITION_COMMIT;
		          !supportsUserTiming ||
		            endTime <= startViewTransitionStartTime ||
		            (console.timeStamp(
		                  abortedViewTransition
		                    ? "Interrupted View Transition"
		                    : "Starting Animation",
		                  startViewTransitionStartTime,
		                  endTime,
		                  currentTrack,
		                  "Scheduler \u269b",
		                  abortedViewTransition ? " error" : "secondary-light"
		                ));
		          pendingDelayedCommitReason !== ABORTED_VIEW_TRANSITION_COMMIT &&
		            (pendingDelayedCommitReason = ANIMATION_STARTED_COMMIT);
		        }
		        pendingEffectsStatus = NO_PENDING_EFFECTS;
		        requestPaint();
		        startViewTransitionStartTime = pendingEffectsRoot;
		        var finishedWork = pendingFinishedWork;
		        endTime = pendingEffectsLanes;
		        abortedViewTransition = pendingRecoverableErrors;
		        var rootDidHavePassiveEffects =
		          0 !== finishedWork.actualDuration ||
		          0 !== (finishedWork.subtreeFlags & 10256) ||
		          0 !== (finishedWork.flags & 10256);
		        rootDidHavePassiveEffects
		          ? (pendingEffectsStatus = PENDING_PASSIVE_PHASE)
		          : ((pendingEffectsStatus = NO_PENDING_EFFECTS),
		            (pendingFinishedWork = pendingEffectsRoot = null),
		            releaseRootPooledCache(
		              startViewTransitionStartTime,
		              startViewTransitionStartTime.pendingLanes
		            ),
		            (nestedPassiveUpdateCount = 0),
		            (rootWithPassiveNestedUpdates = null));
		        var remainingLanes = startViewTransitionStartTime.pendingLanes;
		        0 === remainingLanes && (legacyErrorBoundariesThatAlreadyFailed = null);
		        rootDidHavePassiveEffects ||
		          commitDoubleInvokeEffectsInDEV(startViewTransitionStartTime);
		        remainingLanes = lanesToEventPriority(endTime);
		        finishedWork = finishedWork.stateNode;
		        if (
		          injectedHook &&
		          "function" === typeof injectedHook.onCommitFiberRoot
		        )
		          try {
		            var didError = 128 === (finishedWork.current.flags & 128);
		            switch (remainingLanes) {
		              case 2:
		                var schedulerPriority = ImmediatePriority;
		                break;
		              case 8:
		                schedulerPriority = UserBlockingPriority;
		                break;
		              case 32:
		                schedulerPriority = NormalPriority$1;
		                break;
		              case 268435456:
		                schedulerPriority = IdlePriority;
		                break;
		              default:
		                schedulerPriority = NormalPriority$1;
		            }
		            injectedHook.onCommitFiberRoot(
		              rendererID,
		              finishedWork,
		              schedulerPriority,
		              didError
		            );
		          } catch (err) {
		            hasLoggedError ||
		              ((hasLoggedError = true),
		              console.error(
		                "React instrumentation encountered an error: %o",
		                err
		              ));
		          }
		        isDevToolsPresent &&
		          startViewTransitionStartTime.memoizedUpdaters.clear();
		        onCommitRoot();
		        if (null !== abortedViewTransition) {
		          didError = ReactSharedInternals.T;
		          schedulerPriority = getCurrentUpdatePriority();
		          setCurrentUpdatePriority(2);
		          ReactSharedInternals.T = null;
		          try {
		            var onRecoverableError =
		              startViewTransitionStartTime.onRecoverableError;
		            for (
		              finishedWork = 0;
		              finishedWork < abortedViewTransition.length;
		              finishedWork++
		            ) {
		              var recoverableError = abortedViewTransition[finishedWork],
		                errorInfo = makeErrorInfo(recoverableError.stack);
		              runWithFiberInDEV(
		                recoverableError.source,
		                onRecoverableError,
		                recoverableError.value,
		                errorInfo
		              );
		            }
		          } finally {
		            (ReactSharedInternals.T = didError),
		              setCurrentUpdatePriority(schedulerPriority);
		          }
		        }
		        0 !== (pendingEffectsLanes & 3) && flushPendingEffects();
		        ensureRootIsScheduled(startViewTransitionStartTime);
		        remainingLanes = startViewTransitionStartTime.pendingLanes;
		        0 !== (endTime & 261930) && 0 !== (remainingLanes & 42)
		          ? ((nestedUpdateScheduled = true),
		            startViewTransitionStartTime === rootWithNestedUpdates
		              ? nestedUpdateCount++
		              : ((nestedUpdateCount = 0),
		                (rootWithNestedUpdates = startViewTransitionStartTime)))
		          : (nestedUpdateCount = 0);
		        rootDidHavePassiveEffects || finalizeRender(endTime, commitEndTime);
		        supportsHydration && flushHydrationEvents();
		        flushSyncWorkAcrossRoots_impl(0);
		      }
		    }
		    function makeErrorInfo(componentStack) {
		      componentStack = { componentStack: componentStack };
		      Object.defineProperty(componentStack, "digest", {
		        get: function () {
		          console.error(
		            'You are accessing "digest" from the errorInfo object passed to onRecoverableError. This property is no longer provided as part of errorInfo but can be accessed as a property of the Error instance itself.'
		          );
		        }
		      });
		      return componentStack;
		    }
		    function releaseRootPooledCache(root, remainingLanes) {
		      0 === (root.pooledCacheLanes &= remainingLanes) &&
		        ((remainingLanes = root.pooledCache),
		        null != remainingLanes &&
		          ((root.pooledCache = null), releaseCache(remainingLanes)));
		    }
		    function flushPendingEffects() {
		      flushMutationEffects();
		      flushLayoutEffects();
		      flushSpawnedWork();
		      return flushPassiveEffects();
		    }
		    function flushPassiveEffects() {
		      if (pendingEffectsStatus !== PENDING_PASSIVE_PHASE) return false;
		      var root = pendingEffectsRoot,
		        remainingLanes = pendingEffectsRemainingLanes;
		      pendingEffectsRemainingLanes = 0;
		      var renderPriority = lanesToEventPriority(pendingEffectsLanes),
		        priority = 32 > renderPriority ? 32 : renderPriority;
		      renderPriority = ReactSharedInternals.T;
		      var previousPriority = getCurrentUpdatePriority();
		      try {
		        setCurrentUpdatePriority(priority);
		        ReactSharedInternals.T = null;
		        var transitions = pendingPassiveTransitions;
		        pendingPassiveTransitions = null;
		        priority = pendingEffectsRoot;
		        var lanes = pendingEffectsLanes;
		        pendingEffectsStatus = NO_PENDING_EFFECTS;
		        pendingFinishedWork = pendingEffectsRoot = null;
		        pendingEffectsLanes = 0;
		        if ((executionContext & (RenderContext | CommitContext)) !== NoContext)
		          throw Error("Cannot flush passive effects while already rendering.");
		        setCurrentTrackFromLanes(lanes);
		        isFlushingPassiveEffects = !0;
		        didScheduleUpdateDuringPassiveEffects = !1;
		        var passiveEffectStartTime = 0;
		        commitErrors = null;
		        passiveEffectStartTime = now$1();
		        if (pendingDelayedCommitReason === ANIMATION_STARTED_COMMIT) {
		          var startTime = commitEndTime,
		            endTime = passiveEffectStartTime;
		          !supportsUserTiming ||
		            endTime <= startTime ||
		            (animatingTask
		              ? animatingTask.run(
		                  console.timeStamp.bind(
		                    console,
		                    "Animating",
		                    startTime,
		                    endTime,
		                    currentTrack,
		                    "Scheduler \u269b",
		                    "secondary-dark"
		                  )
		                )
		              : console.timeStamp(
		                  "Animating",
		                  startTime,
		                  endTime,
		                  currentTrack,
		                  "Scheduler \u269b",
		                  "secondary-dark"
		                ));
		        } else {
		          startTime = commitEndTime;
		          endTime = passiveEffectStartTime;
		          var delayedUntilPaint =
		            pendingDelayedCommitReason === DELAYED_PASSIVE_COMMIT;
		          !supportsUserTiming ||
		            endTime <= startTime ||
		            (workInProgressUpdateTask
		              ? workInProgressUpdateTask.run(
		                  console.timeStamp.bind(
		                    console,
		                    delayedUntilPaint ? "Waiting for Paint" : "Waiting",
		                    startTime,
		                    endTime,
		                    currentTrack,
		                    "Scheduler \u269b",
		                    "secondary-light"
		                  )
		                )
		              : console.timeStamp(
		                  delayedUntilPaint ? "Waiting for Paint" : "Waiting",
		                  startTime,
		                  endTime,
		                  currentTrack,
		                  "Scheduler \u269b",
		                  "secondary-light"
		                ));
		        }
		        startTime = executionContext;
		        executionContext |= CommitContext;
		        var finishedWork = priority.current;
		        resetComponentEffectTimers();
		        commitPassiveUnmountOnFiber(finishedWork);
		        var finishedWork$jscomp$0 = priority.current;
		        finishedWork = pendingEffectsRenderEndTime;
		        resetComponentEffectTimers();
		        commitPassiveMountOnFiber(
		          priority,
		          finishedWork$jscomp$0,
		          lanes,
		          transitions,
		          finishedWork
		        );
		        commitDoubleInvokeEffectsInDEV(priority);
		        executionContext = startTime;
		        var passiveEffectsEndTime = now$1();
		        finishedWork$jscomp$0 = passiveEffectStartTime;
		        finishedWork = workInProgressUpdateTask;
		        null !== commitErrors
		          ? logCommitErrored(
		              finishedWork$jscomp$0,
		              passiveEffectsEndTime,
		              commitErrors,
		              !0,
		              finishedWork
		            )
		          : !supportsUserTiming ||
		            passiveEffectsEndTime <= finishedWork$jscomp$0 ||
		            (finishedWork
		              ? finishedWork.run(
		                  console.timeStamp.bind(
		                    console,
		                    "Remaining Effects",
		                    finishedWork$jscomp$0,
		                    passiveEffectsEndTime,
		                    currentTrack,
		                    "Scheduler \u269b",
		                    "secondary-dark"
		                  )
		                )
		              : console.timeStamp(
		                  "Remaining Effects",
		                  finishedWork$jscomp$0,
		                  passiveEffectsEndTime,
		                  currentTrack,
		                  "Scheduler \u269b",
		                  "secondary-dark"
		                ));
		        finalizeRender(lanes, passiveEffectsEndTime);
		        flushSyncWorkAcrossRoots_impl(0, !1);
		        didScheduleUpdateDuringPassiveEffects
		          ? priority === rootWithPassiveNestedUpdates
		            ? nestedPassiveUpdateCount++
		            : ((nestedPassiveUpdateCount = 0),
		              (rootWithPassiveNestedUpdates = priority))
		          : (nestedPassiveUpdateCount = 0);
		        didScheduleUpdateDuringPassiveEffects = isFlushingPassiveEffects = !1;
		        if (
		          injectedHook &&
		          "function" === typeof injectedHook.onPostCommitFiberRoot
		        )
		          try {
		            injectedHook.onPostCommitFiberRoot(rendererID, priority);
		          } catch (err) {
		            hasLoggedError ||
		              ((hasLoggedError = !0),
		              console.error(
		                "React instrumentation encountered an error: %o",
		                err
		              ));
		          }
		        var stateNode = priority.current.stateNode;
		        stateNode.effectDuration = 0;
		        stateNode.passiveEffectDuration = 0;
		        return !0;
		      } finally {
		        setCurrentUpdatePriority(previousPriority),
		          (ReactSharedInternals.T = renderPriority),
		          releaseRootPooledCache(root, remainingLanes);
		      }
		    }
		    function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
		      sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
		      recordEffectError(sourceFiber);
		      sourceFiber = createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
		      rootFiber = enqueueUpdate(rootFiber, sourceFiber, 2);
		      null !== rootFiber &&
		        (markRootUpdated$1(rootFiber, 2), ensureRootIsScheduled(rootFiber));
		    }
		    function captureCommitPhaseError(
		      sourceFiber,
		      nearestMountedAncestor,
		      error
		    ) {
		      isRunningInsertionEffect = false;
		      if (3 === sourceFiber.tag)
		        captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
		      else {
		        for (; null !== nearestMountedAncestor; ) {
		          if (3 === nearestMountedAncestor.tag) {
		            captureCommitPhaseErrorOnRoot(
		              nearestMountedAncestor,
		              sourceFiber,
		              error
		            );
		            return;
		          }
		          if (1 === nearestMountedAncestor.tag) {
		            var instance = nearestMountedAncestor.stateNode;
		            if (
		              "function" ===
		                typeof nearestMountedAncestor.type.getDerivedStateFromError ||
		              ("function" === typeof instance.componentDidCatch &&
		                (null === legacyErrorBoundariesThatAlreadyFailed ||
		                  !legacyErrorBoundariesThatAlreadyFailed.has(instance)))
		            ) {
		              sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
		              recordEffectError(sourceFiber);
		              error = createClassErrorUpdate(2);
		              instance = enqueueUpdate(nearestMountedAncestor, error, 2);
		              null !== instance &&
		                (initializeClassErrorUpdate(
		                  error,
		                  instance,
		                  nearestMountedAncestor,
		                  sourceFiber
		                ),
		                markRootUpdated$1(instance, 2),
		                ensureRootIsScheduled(instance));
		              return;
		            }
		          }
		          nearestMountedAncestor = nearestMountedAncestor.return;
		        }
		        console.error(
		          "Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Potential causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.\n\nError message:\n\n%s",
		          error
		        );
		      }
		    }
		    function attachPingListener(root, wakeable, lanes) {
		      var pingCache = root.pingCache;
		      if (null === pingCache) {
		        pingCache = root.pingCache = new PossiblyWeakMap();
		        var threadIDs = new Set();
		        pingCache.set(wakeable, threadIDs);
		      } else
		        (threadIDs = pingCache.get(wakeable)),
		          void 0 === threadIDs &&
		            ((threadIDs = new Set()), pingCache.set(wakeable, threadIDs));
		      threadIDs.has(lanes) ||
		        ((workInProgressRootDidAttachPingListener = true),
		        threadIDs.add(lanes),
		        (pingCache = pingSuspendedRoot.bind(null, root, wakeable, lanes)),
		        isDevToolsPresent && restorePendingUpdaters(root, lanes),
		        wakeable.then(pingCache, pingCache));
		    }
		    function pingSuspendedRoot(root, wakeable, pingedLanes) {
		      var pingCache = root.pingCache;
		      null !== pingCache && pingCache.delete(wakeable);
		      root.pingedLanes |= root.suspendedLanes & pingedLanes;
		      root.warmLanes &= ~pingedLanes;
		      0 !== (pingedLanes & 127)
		        ? 0 > blockingUpdateTime &&
		          ((blockingClampTime = blockingUpdateTime = now()),
		          (blockingUpdateTask = createTask("Promise Resolved")),
		          (blockingUpdateType = 2))
		        : 0 !== (pingedLanes & 4194048) &&
		          0 > transitionUpdateTime &&
		          ((transitionClampTime = transitionUpdateTime = now()),
		          (transitionUpdateTask = createTask("Promise Resolved")),
		          (transitionUpdateType = 2));
		      isConcurrentActEnvironment() &&
		        null === ReactSharedInternals.actQueue &&
		        console.error(
		          "A suspended resource finished loading inside a test, but the event was not wrapped in act(...).\n\nWhen testing, code that resolves suspended data should be wrapped into act(...):\n\nact(() => {\n  /* finish loading suspended data */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act"
		        );
		      workInProgressRoot === root &&
		        (workInProgressRootRenderLanes & pingedLanes) === pingedLanes &&
		        (workInProgressRootExitStatus === RootSuspendedWithDelay ||
		        (workInProgressRootExitStatus === RootSuspended &&
		          (workInProgressRootRenderLanes & 62914560) ===
		            workInProgressRootRenderLanes &&
		          now$1() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS)
		          ? (executionContext & RenderContext) === NoContext &&
		            prepareFreshStack(root, 0)
		          : (workInProgressRootPingedLanes |= pingedLanes),
		        workInProgressSuspendedRetryLanes === workInProgressRootRenderLanes &&
		          (workInProgressSuspendedRetryLanes = 0));
		      ensureRootIsScheduled(root);
		    }
		    function retryTimedOutBoundary(boundaryFiber, retryLane) {
		      0 === retryLane && (retryLane = claimNextRetryLane());
		      boundaryFiber = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
		      null !== boundaryFiber &&
		        (markRootUpdated$1(boundaryFiber, retryLane),
		        ensureRootIsScheduled(boundaryFiber));
		    }
		    function retryDehydratedSuspenseBoundary(boundaryFiber) {
		      var suspenseState = boundaryFiber.memoizedState,
		        retryLane = 0;
		      null !== suspenseState && (retryLane = suspenseState.retryLane);
		      retryTimedOutBoundary(boundaryFiber, retryLane);
		    }
		    function resolveRetryWakeable(boundaryFiber, wakeable) {
		      var retryLane = 0;
		      switch (boundaryFiber.tag) {
		        case 31:
		        case 13:
		          var retryCache = boundaryFiber.stateNode;
		          var suspenseState = boundaryFiber.memoizedState;
		          null !== suspenseState && (retryLane = suspenseState.retryLane);
		          break;
		        case 19:
		          retryCache = boundaryFiber.stateNode;
		          break;
		        case 22:
		          retryCache = boundaryFiber.stateNode._retryCache;
		          break;
		        default:
		          throw Error(
		            "Pinged unknown suspense boundary type. This is probably a bug in React."
		          );
		      }
		      null !== retryCache && retryCache.delete(wakeable);
		      retryTimedOutBoundary(boundaryFiber, retryLane);
		    }
		    function recursivelyTraverseAndDoubleInvokeEffectsInDEV(
		      root$jscomp$0,
		      parentFiber,
		      isInStrictMode
		    ) {
		      if (0 !== (parentFiber.subtreeFlags & 67117056))
		        for (parentFiber = parentFiber.child; null !== parentFiber; ) {
		          var root = root$jscomp$0,
		            fiber = parentFiber,
		            isStrictModeFiber = fiber.type === REACT_STRICT_MODE_TYPE;
		          isStrictModeFiber = isInStrictMode || isStrictModeFiber;
		          22 !== fiber.tag
		            ? fiber.flags & 67108864
		              ? isStrictModeFiber &&
		                runWithFiberInDEV(
		                  fiber,
		                  doubleInvokeEffectsOnFiber,
		                  root,
		                  fiber
		                )
		              : recursivelyTraverseAndDoubleInvokeEffectsInDEV(
		                  root,
		                  fiber,
		                  isStrictModeFiber
		                )
		            : null === fiber.memoizedState &&
		              (isStrictModeFiber && fiber.flags & 8192
		                ? runWithFiberInDEV(
		                    fiber,
		                    doubleInvokeEffectsOnFiber,
		                    root,
		                    fiber
		                  )
		                : fiber.subtreeFlags & 67108864 &&
		                  runWithFiberInDEV(
		                    fiber,
		                    recursivelyTraverseAndDoubleInvokeEffectsInDEV,
		                    root,
		                    fiber,
		                    isStrictModeFiber
		                  ));
		          parentFiber = parentFiber.sibling;
		        }
		    }
		    function doubleInvokeEffectsOnFiber(root, fiber) {
		      setIsStrictModeForDevtools(true);
		      try {
		        disappearLayoutEffects(fiber),
		          disconnectPassiveEffect(fiber),
		          reappearLayoutEffects(root, fiber.alternate, fiber, !1),
		          reconnectPassiveEffects(root, fiber, 0, null, !1, 0);
		      } finally {
		        setIsStrictModeForDevtools(false);
		      }
		    }
		    function commitDoubleInvokeEffectsInDEV(root) {
		      var doubleInvokeEffects = true;
		      root.current.mode & 24 || (doubleInvokeEffects = false);
		      recursivelyTraverseAndDoubleInvokeEffectsInDEV(
		        root,
		        root.current,
		        doubleInvokeEffects
		      );
		    }
		    function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
		      if ((executionContext & RenderContext) === NoContext) {
		        var tag = fiber.tag;
		        if (
		          3 === tag ||
		          1 === tag ||
		          0 === tag ||
		          11 === tag ||
		          14 === tag ||
		          15 === tag
		        ) {
		          tag = getComponentNameFromFiber(fiber) || "ReactComponent";
		          if (null !== didWarnStateUpdateForNotYetMountedComponent) {
		            if (didWarnStateUpdateForNotYetMountedComponent.has(tag)) return;
		            didWarnStateUpdateForNotYetMountedComponent.add(tag);
		          } else didWarnStateUpdateForNotYetMountedComponent = new Set([tag]);
		          runWithFiberInDEV(fiber, function () {
		            console.error(
		              "Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously tries to update the component. Move this work to useEffect instead."
		            );
		          });
		        }
		      }
		    }
		    function restorePendingUpdaters(root, lanes) {
		      isDevToolsPresent &&
		        root.memoizedUpdaters.forEach(function (schedulingFiber) {
		          addFiberToLanesMap(root, schedulingFiber, lanes);
		        });
		    }
		    function scheduleCallback(priorityLevel, callback) {
		      var actQueue = ReactSharedInternals.actQueue;
		      return null !== actQueue
		        ? (actQueue.push(callback), fakeActCallbackNode)
		        : scheduleCallback$3(priorityLevel, callback);
		    }
		    function warnIfUpdatesNotWrappedWithActDEV(fiber) {
		      isConcurrentActEnvironment() &&
		        null === ReactSharedInternals.actQueue &&
		        runWithFiberInDEV(fiber, function () {
		          console.error(
		            "An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act",
		            getComponentNameFromFiber(fiber)
		          );
		        });
		    }
		    function resolveFunctionForHotReloading(type) {
		      if (null === resolveFamily) return type;
		      var family = resolveFamily(type);
		      return void 0 === family ? type : family.current;
		    }
		    function resolveForwardRefForHotReloading(type) {
		      if (null === resolveFamily) return type;
		      var family = resolveFamily(type);
		      return void 0 === family
		        ? null !== type &&
		          void 0 !== type &&
		          "function" === typeof type.render &&
		          ((family = resolveFunctionForHotReloading(type.render)),
		          type.render !== family)
		          ? ((family = { $$typeof: REACT_FORWARD_REF_TYPE, render: family }),
		            void 0 !== type.displayName &&
		              (family.displayName = type.displayName),
		            family)
		          : type
		        : family.current;
		    }
		    function isCompatibleFamilyForHotReloading(fiber, element) {
		      if (null === resolveFamily) return false;
		      var prevType = fiber.elementType;
		      element = element.type;
		      var needsCompareFamilies = false,
		        $$typeofNextType =
		          "object" === typeof element && null !== element
		            ? element.$$typeof
		            : null;
		      switch (fiber.tag) {
		        case 1:
		          "function" === typeof element && (needsCompareFamilies = true);
		          break;
		        case 0:
		          "function" === typeof element
		            ? (needsCompareFamilies = true)
		            : $$typeofNextType === REACT_LAZY_TYPE &&
		              (needsCompareFamilies = true);
		          break;
		        case 11:
		          $$typeofNextType === REACT_FORWARD_REF_TYPE
		            ? (needsCompareFamilies = true)
		            : $$typeofNextType === REACT_LAZY_TYPE &&
		              (needsCompareFamilies = true);
		          break;
		        case 14:
		        case 15:
		          $$typeofNextType === REACT_MEMO_TYPE
		            ? (needsCompareFamilies = true)
		            : $$typeofNextType === REACT_LAZY_TYPE &&
		              (needsCompareFamilies = true);
		          break;
		        default:
		          return false;
		      }
		      return needsCompareFamilies &&
		        ((fiber = resolveFamily(prevType)),
		        void 0 !== fiber && fiber === resolveFamily(element))
		        ? true
		        : false;
		    }
		    function markFailedErrorBoundaryForHotReloading(fiber) {
		      null !== resolveFamily &&
		        "function" === typeof WeakSet &&
		        (null === failedBoundaries && (failedBoundaries = new WeakSet()),
		        failedBoundaries.add(fiber));
		    }
		    function scheduleFibersWithFamiliesRecursively(
		      fiber,
		      updatedFamilies,
		      staleFamilies
		    ) {
		      do {
		        var _fiber = fiber,
		          alternate = _fiber.alternate,
		          child = _fiber.child,
		          sibling = _fiber.sibling,
		          tag = _fiber.tag;
		        _fiber = _fiber.type;
		        var candidateType = null;
		        switch (tag) {
		          case 0:
		          case 15:
		          case 1:
		            candidateType = _fiber;
		            break;
		          case 11:
		            candidateType = _fiber.render;
		        }
		        if (null === resolveFamily)
		          throw Error("Expected resolveFamily to be set during hot reload.");
		        var needsRender = false;
		        _fiber = false;
		        null !== candidateType &&
		          ((candidateType = resolveFamily(candidateType)),
		          void 0 !== candidateType &&
		            (staleFamilies.has(candidateType)
		              ? (_fiber = true)
		              : updatedFamilies.has(candidateType) &&
		                (1 === tag ? (_fiber = true) : (needsRender = true))));
		        null !== failedBoundaries &&
		          (failedBoundaries.has(fiber) ||
		            (null !== alternate && failedBoundaries.has(alternate))) &&
		          (_fiber = true);
		        _fiber && (fiber._debugNeedsRemount = true);
		        if (_fiber || needsRender)
		          (alternate = enqueueConcurrentRenderForLane(fiber, 2)),
		            null !== alternate && scheduleUpdateOnFiber(alternate, fiber, 2);
		        null === child ||
		          _fiber ||
		          scheduleFibersWithFamiliesRecursively(
		            child,
		            updatedFamilies,
		            staleFamilies
		          );
		        if (null === sibling) break;
		        fiber = sibling;
		      } while (1);
		    }
		    function FiberNode(tag, pendingProps, key, mode) {
		      this.tag = tag;
		      this.key = key;
		      this.sibling =
		        this.child =
		        this.return =
		        this.stateNode =
		        this.type =
		        this.elementType =
		          null;
		      this.index = 0;
		      this.refCleanup = this.ref = null;
		      this.pendingProps = pendingProps;
		      this.dependencies =
		        this.memoizedState =
		        this.updateQueue =
		        this.memoizedProps =
		          null;
		      this.mode = mode;
		      this.subtreeFlags = this.flags = 0;
		      this.deletions = null;
		      this.childLanes = this.lanes = 0;
		      this.alternate = null;
		      this.actualDuration = -0;
		      this.actualStartTime = -1.1;
		      this.treeBaseDuration = this.selfBaseDuration = -0;
		      this._debugTask =
		        this._debugStack =
		        this._debugOwner =
		        this._debugInfo =
		          null;
		      this._debugNeedsRemount = false;
		      this._debugHookTypes = null;
		      hasBadMapPolyfill ||
		        "function" !== typeof Object.preventExtensions ||
		        Object.preventExtensions(this);
		    }
		    function shouldConstruct(Component) {
		      Component = Component.prototype;
		      return !(!Component || !Component.isReactComponent);
		    }
		    function createWorkInProgress(current, pendingProps) {
		      var workInProgress = current.alternate;
		      null === workInProgress
		        ? ((workInProgress = createFiber(
		            current.tag,
		            pendingProps,
		            current.key,
		            current.mode
		          )),
		          (workInProgress.elementType = current.elementType),
		          (workInProgress.type = current.type),
		          (workInProgress.stateNode = current.stateNode),
		          (workInProgress._debugOwner = current._debugOwner),
		          (workInProgress._debugStack = current._debugStack),
		          (workInProgress._debugTask = current._debugTask),
		          (workInProgress._debugHookTypes = current._debugHookTypes),
		          (workInProgress.alternate = current),
		          (current.alternate = workInProgress))
		        : ((workInProgress.pendingProps = pendingProps),
		          (workInProgress.type = current.type),
		          (workInProgress.flags = 0),
		          (workInProgress.subtreeFlags = 0),
		          (workInProgress.deletions = null),
		          (workInProgress.actualDuration = -0),
		          (workInProgress.actualStartTime = -1.1));
		      workInProgress.flags = current.flags & 65011712;
		      workInProgress.childLanes = current.childLanes;
		      workInProgress.lanes = current.lanes;
		      workInProgress.child = current.child;
		      workInProgress.memoizedProps = current.memoizedProps;
		      workInProgress.memoizedState = current.memoizedState;
		      workInProgress.updateQueue = current.updateQueue;
		      pendingProps = current.dependencies;
		      workInProgress.dependencies =
		        null === pendingProps
		          ? null
		          : {
		              lanes: pendingProps.lanes,
		              firstContext: pendingProps.firstContext,
		              _debugThenableState: pendingProps._debugThenableState
		            };
		      workInProgress.sibling = current.sibling;
		      workInProgress.index = current.index;
		      workInProgress.ref = current.ref;
		      workInProgress.refCleanup = current.refCleanup;
		      workInProgress.selfBaseDuration = current.selfBaseDuration;
		      workInProgress.treeBaseDuration = current.treeBaseDuration;
		      workInProgress._debugInfo = current._debugInfo;
		      workInProgress._debugNeedsRemount = current._debugNeedsRemount;
		      switch (workInProgress.tag) {
		        case 0:
		        case 15:
		          workInProgress.type = resolveFunctionForHotReloading(current.type);
		          break;
		        case 1:
		          workInProgress.type = resolveFunctionForHotReloading(current.type);
		          break;
		        case 11:
		          workInProgress.type = resolveForwardRefForHotReloading(current.type);
		      }
		      return workInProgress;
		    }
		    function resetWorkInProgress(workInProgress, renderLanes) {
		      workInProgress.flags &= 65011714;
		      var current = workInProgress.alternate;
		      null === current
		        ? ((workInProgress.childLanes = 0),
		          (workInProgress.lanes = renderLanes),
		          (workInProgress.child = null),
		          (workInProgress.subtreeFlags = 0),
		          (workInProgress.memoizedProps = null),
		          (workInProgress.memoizedState = null),
		          (workInProgress.updateQueue = null),
		          (workInProgress.dependencies = null),
		          (workInProgress.stateNode = null),
		          (workInProgress.selfBaseDuration = 0),
		          (workInProgress.treeBaseDuration = 0))
		        : ((workInProgress.childLanes = current.childLanes),
		          (workInProgress.lanes = current.lanes),
		          (workInProgress.child = current.child),
		          (workInProgress.subtreeFlags = 0),
		          (workInProgress.deletions = null),
		          (workInProgress.memoizedProps = current.memoizedProps),
		          (workInProgress.memoizedState = current.memoizedState),
		          (workInProgress.updateQueue = current.updateQueue),
		          (workInProgress.type = current.type),
		          (renderLanes = current.dependencies),
		          (workInProgress.dependencies =
		            null === renderLanes
		              ? null
		              : {
		                  lanes: renderLanes.lanes,
		                  firstContext: renderLanes.firstContext,
		                  _debugThenableState: renderLanes._debugThenableState
		                }),
		          (workInProgress.selfBaseDuration = current.selfBaseDuration),
		          (workInProgress.treeBaseDuration = current.treeBaseDuration));
		      return workInProgress;
		    }
		    function createFiberFromTypeAndProps(
		      type,
		      key,
		      pendingProps,
		      owner,
		      mode,
		      lanes
		    ) {
		      var fiberTag = 0,
		        resolvedType = type;
		      if ("function" === typeof type)
		        shouldConstruct(type) && (fiberTag = 1),
		          (resolvedType = resolveFunctionForHotReloading(resolvedType));
		      else if ("string" === typeof type)
		        supportsResources && supportsSingletons
		          ? ((fiberTag = getHostContext()),
		            (fiberTag = isHostHoistableType(type, pendingProps, fiberTag)
		              ? 26
		              : isHostSingletonType(type)
		                ? 27
		                : 5))
		          : supportsResources
		            ? ((fiberTag = getHostContext()),
		              (fiberTag = isHostHoistableType(type, pendingProps, fiberTag)
		                ? 26
		                : 5))
		            : (fiberTag = supportsSingletons
		                ? isHostSingletonType(type)
		                  ? 27
		                  : 5
		                : 5);
		      else
		        a: switch (type) {
		          case REACT_ACTIVITY_TYPE:
		            return (
		              (key = createFiber(31, pendingProps, key, mode)),
		              (key.elementType = REACT_ACTIVITY_TYPE),
		              (key.lanes = lanes),
		              key
		            );
		          case REACT_FRAGMENT_TYPE:
		            return createFiberFromFragment(
		              pendingProps.children,
		              mode,
		              lanes,
		              key
		            );
		          case REACT_STRICT_MODE_TYPE:
		            fiberTag = 8;
		            mode |= 24;
		            break;
		          case REACT_PROFILER_TYPE:
		            return (
		              (type = pendingProps),
		              (owner = mode),
		              "string" !== typeof type.id &&
		                console.error(
		                  'Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.',
		                  typeof type.id
		                ),
		              (key = createFiber(12, type, key, owner | 2)),
		              (key.elementType = REACT_PROFILER_TYPE),
		              (key.lanes = lanes),
		              (key.stateNode = { effectDuration: 0, passiveEffectDuration: 0 }),
		              key
		            );
		          case REACT_SUSPENSE_TYPE:
		            return (
		              (key = createFiber(13, pendingProps, key, mode)),
		              (key.elementType = REACT_SUSPENSE_TYPE),
		              (key.lanes = lanes),
		              key
		            );
		          case REACT_SUSPENSE_LIST_TYPE:
		            return (
		              (key = createFiber(19, pendingProps, key, mode)),
		              (key.elementType = REACT_SUSPENSE_LIST_TYPE),
		              (key.lanes = lanes),
		              key
		            );
		          default:
		            if ("object" === typeof type && null !== type)
		              switch (type.$$typeof) {
		                case REACT_CONTEXT_TYPE:
		                  fiberTag = 10;
		                  break a;
		                case REACT_CONSUMER_TYPE:
		                  fiberTag = 9;
		                  break a;
		                case REACT_FORWARD_REF_TYPE:
		                  fiberTag = 11;
		                  resolvedType = resolveForwardRefForHotReloading(resolvedType);
		                  break a;
		                case REACT_MEMO_TYPE:
		                  fiberTag = 14;
		                  break a;
		                case REACT_LAZY_TYPE:
		                  fiberTag = 16;
		                  resolvedType = null;
		                  break a;
		              }
		            resolvedType = "";
		            if (
		              void 0 === type ||
		              ("object" === typeof type &&
		                null !== type &&
		                0 === Object.keys(type).length)
		            )
		              resolvedType +=
		                " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
		            null === type
		              ? (pendingProps = "null")
		              : isArrayImpl(type)
		                ? (pendingProps = "array")
		                : void 0 !== type && type.$$typeof === REACT_ELEMENT_TYPE
		                  ? ((pendingProps =
		                      "<" +
		                      (getComponentNameFromType(type.type) || "Unknown") +
		                      " />"),
		                    (resolvedType =
		                      " Did you accidentally export a JSX literal instead of a component?"))
		                  : (pendingProps = typeof type);
		            fiberTag = owner
		              ? "number" === typeof owner.tag
		                ? getComponentNameFromFiber(owner)
		                : "string" === typeof owner.name
		                  ? owner.name
		                  : null
		              : null;
		            fiberTag &&
		              (resolvedType +=
		                "\n\nCheck the render method of `" + fiberTag + "`.");
		            fiberTag = 29;
		            pendingProps = Error(
		              "Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " +
		                (pendingProps + "." + resolvedType)
		            );
		            resolvedType = null;
		        }
		      key = createFiber(fiberTag, pendingProps, key, mode);
		      key.elementType = type;
		      key.type = resolvedType;
		      key.lanes = lanes;
		      key._debugOwner = owner;
		      return key;
		    }
		    function createFiberFromElement(element, mode, lanes) {
		      mode = createFiberFromTypeAndProps(
		        element.type,
		        element.key,
		        element.props,
		        element._owner,
		        mode,
		        lanes
		      );
		      mode._debugOwner = element._owner;
		      mode._debugStack = element._debugStack;
		      mode._debugTask = element._debugTask;
		      return mode;
		    }
		    function createFiberFromFragment(elements, mode, lanes, key) {
		      elements = createFiber(7, elements, key, mode);
		      elements.lanes = lanes;
		      return elements;
		    }
		    function createFiberFromText(content, mode, lanes) {
		      content = createFiber(6, content, null, mode);
		      content.lanes = lanes;
		      return content;
		    }
		    function createFiberFromDehydratedFragment(dehydratedNode) {
		      var fiber = createFiber(18, null, null, NoMode);
		      fiber.stateNode = dehydratedNode;
		      return fiber;
		    }
		    function createFiberFromPortal(portal, mode, lanes) {
		      mode = createFiber(
		        4,
		        null !== portal.children ? portal.children : [],
		        portal.key,
		        mode
		      );
		      mode.lanes = lanes;
		      mode.stateNode = {
		        containerInfo: portal.containerInfo,
		        pendingChildren: null,
		        implementation: portal.implementation
		      };
		      return mode;
		    }
		    function FiberRootNode(
		      containerInfo,
		      tag,
		      hydrate,
		      identifierPrefix,
		      onUncaughtError,
		      onCaughtError,
		      onRecoverableError,
		      onDefaultTransitionIndicator,
		      formState
		    ) {
		      this.tag = 1;
		      this.containerInfo = containerInfo;
		      this.pingCache = this.current = this.pendingChildren = null;
		      this.timeoutHandle = noTimeout;
		      this.callbackNode =
		        this.next =
		        this.pendingContext =
		        this.context =
		        this.cancelPendingCommit =
		          null;
		      this.callbackPriority = 0;
		      this.expirationTimes = createLaneMap(-1);
		      this.entangledLanes =
		        this.shellSuspendCounter =
		        this.errorRecoveryDisabledLanes =
		        this.expiredLanes =
		        this.warmLanes =
		        this.pingedLanes =
		        this.suspendedLanes =
		        this.pendingLanes =
		          0;
		      this.entanglements = createLaneMap(0);
		      this.hiddenUpdates = createLaneMap(null);
		      this.identifierPrefix = identifierPrefix;
		      this.onUncaughtError = onUncaughtError;
		      this.onCaughtError = onCaughtError;
		      this.onRecoverableError = onRecoverableError;
		      this.pooledCache = null;
		      this.pooledCacheLanes = 0;
		      this.formState = formState;
		      this.incompleteTransitions = new Map();
		      this.passiveEffectDuration = this.effectDuration = -0;
		      this.memoizedUpdaters = new Set();
		      containerInfo = this.pendingUpdatersLaneMap = [];
		      for (tag = 0; 31 > tag; tag++) containerInfo.push(new Set());
		      this._debugRootType = hydrate ? "hydrateRoot()" : "createRoot()";
		    }
		    function createFiberRoot(
		      containerInfo,
		      tag,
		      hydrate,
		      initialChildren,
		      hydrationCallbacks,
		      isStrictMode,
		      identifierPrefix,
		      formState,
		      onUncaughtError,
		      onCaughtError,
		      onRecoverableError,
		      onDefaultTransitionIndicator
		    ) {
		      containerInfo = new FiberRootNode(
		        containerInfo,
		        tag,
		        hydrate,
		        identifierPrefix,
		        onUncaughtError,
		        onCaughtError,
		        onRecoverableError,
		        onDefaultTransitionIndicator,
		        formState
		      );
		      tag = 1;
		      true === isStrictMode && (tag |= 24);
		      isStrictMode = createFiber(3, null, null, tag | 2);
		      containerInfo.current = isStrictMode;
		      isStrictMode.stateNode = containerInfo;
		      tag = createCache();
		      retainCache(tag);
		      containerInfo.pooledCache = tag;
		      retainCache(tag);
		      isStrictMode.memoizedState = {
		        element: initialChildren,
		        isDehydrated: hydrate,
		        cache: tag
		      };
		      initializeUpdateQueue(isStrictMode);
		      return containerInfo;
		    }
		    function testStringCoercion(value) {
		      return "" + value;
		    }
		    function getContextForSubtree(parentComponent) {
		      if (!parentComponent) return emptyContextObject;
		      parentComponent = emptyContextObject;
		      return parentComponent;
		    }
		    function updateContainerSync(
		      element,
		      container,
		      parentComponent,
		      callback
		    ) {
		      updateContainerImpl(
		        container.current,
		        2,
		        element,
		        container,
		        parentComponent,
		        callback
		      );
		      return 2;
		    }
		    function updateContainerImpl(
		      rootFiber,
		      lane,
		      element,
		      container,
		      parentComponent,
		      callback
		    ) {
		      if (
		        injectedHook &&
		        "function" === typeof injectedHook.onScheduleFiberRoot
		      )
		        try {
		          injectedHook.onScheduleFiberRoot(rendererID, container, element);
		        } catch (err) {
		          hasLoggedError ||
		            ((hasLoggedError = true),
		            console.error(
		              "React instrumentation encountered an error: %o",
		              err
		            ));
		        }
		      parentComponent = getContextForSubtree(parentComponent);
		      null === container.context
		        ? (container.context = parentComponent)
		        : (container.pendingContext = parentComponent);
		      isRendering &&
		        null !== current &&
		        !didWarnAboutNestedUpdates &&
		        ((didWarnAboutNestedUpdates = true),
		        console.error(
		          "Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.",
		          getComponentNameFromFiber(current) || "Unknown"
		        ));
		      container = createUpdate(lane);
		      container.payload = { element: element };
		      callback = void 0 === callback ? null : callback;
		      null !== callback &&
		        ("function" !== typeof callback &&
		          console.error(
		            "Expected the last optional `callback` argument to be a function. Instead received: %s.",
		            callback
		          ),
		        (container.callback = callback));
		      element = enqueueUpdate(rootFiber, container, lane);
		      null !== element &&
		        (startUpdateTimerByLane(lane, "root.render()", null),
		        scheduleUpdateOnFiber(element, rootFiber, lane),
		        entangleTransitions(element, rootFiber, lane));
		    }
		    function markRetryLaneImpl(fiber, retryLane) {
		      fiber = fiber.memoizedState;
		      if (null !== fiber && null !== fiber.dehydrated) {
		        var a = fiber.retryLane;
		        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
		      }
		    }
		    function markRetryLaneIfNotHydrated(fiber, retryLane) {
		      markRetryLaneImpl(fiber, retryLane);
		      (fiber = fiber.alternate) && markRetryLaneImpl(fiber, retryLane);
		    }
		    function getCurrentFiberForDevTools() {
		      return current;
		    }
		    var exports$1 = {};
		    var React = React__default,
		      Scheduler = requireScheduler(),
		      assign = Object.assign,
		      REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"),
		      REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"),
		      REACT_PORTAL_TYPE = Symbol.for("react.portal"),
		      REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"),
		      REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"),
		      REACT_PROFILER_TYPE = Symbol.for("react.profiler"),
		      REACT_CONSUMER_TYPE = Symbol.for("react.consumer"),
		      REACT_CONTEXT_TYPE = Symbol.for("react.context"),
		      REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"),
		      REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"),
		      REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"),
		      REACT_MEMO_TYPE = Symbol.for("react.memo"),
		      REACT_LAZY_TYPE = Symbol.for("react.lazy");
		    var REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
		    var REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
		    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator,
		      REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference"),
		      isArrayImpl = Array.isArray,
		      ReactSharedInternals =
		        React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
		      rendererVersion = $$$config.rendererVersion,
		      rendererPackageName = $$$config.rendererPackageName,
		      extraDevToolsConfig = $$$config.extraDevToolsConfig,
		      getPublicInstance = $$$config.getPublicInstance,
		      getRootHostContext = $$$config.getRootHostContext,
		      getChildHostContext = $$$config.getChildHostContext,
		      prepareForCommit = $$$config.prepareForCommit,
		      resetAfterCommit = $$$config.resetAfterCommit,
		      createInstance = $$$config.createInstance;
		    $$$config.cloneMutableInstance;
		    var appendInitialChild = $$$config.appendInitialChild,
		      finalizeInitialChildren = $$$config.finalizeInitialChildren,
		      shouldSetTextContent = $$$config.shouldSetTextContent,
		      createTextInstance = $$$config.createTextInstance;
		    $$$config.cloneMutableTextInstance;
		    var scheduleTimeout = $$$config.scheduleTimeout,
		      cancelTimeout = $$$config.cancelTimeout,
		      noTimeout = $$$config.noTimeout,
		      isPrimaryRenderer = $$$config.isPrimaryRenderer;
		    $$$config.warnsIfNotActing;
		    var supportsMutation = $$$config.supportsMutation,
		      supportsPersistence = $$$config.supportsPersistence,
		      supportsHydration = $$$config.supportsHydration,
		      getInstanceFromNode = $$$config.getInstanceFromNode;
		    $$$config.beforeActiveInstanceBlur;
		    var preparePortalMount = $$$config.preparePortalMount;
		    $$$config.prepareScopeUpdate;
		    $$$config.getInstanceFromScope;
		    var setCurrentUpdatePriority = $$$config.setCurrentUpdatePriority,
		      getCurrentUpdatePriority = $$$config.getCurrentUpdatePriority,
		      resolveUpdatePriority = $$$config.resolveUpdatePriority,
		      trackSchedulerEvent = $$$config.trackSchedulerEvent,
		      resolveEventType = $$$config.resolveEventType,
		      resolveEventTimeStamp = $$$config.resolveEventTimeStamp,
		      shouldAttemptEagerTransition = $$$config.shouldAttemptEagerTransition,
		      detachDeletedInstance = $$$config.detachDeletedInstance;
		    $$$config.requestPostPaintCallback;
		    var maySuspendCommit = $$$config.maySuspendCommit,
		      maySuspendCommitOnUpdate = $$$config.maySuspendCommitOnUpdate,
		      maySuspendCommitInSyncRender = $$$config.maySuspendCommitInSyncRender,
		      preloadInstance = $$$config.preloadInstance,
		      startSuspendingCommit = $$$config.startSuspendingCommit,
		      suspendInstance = $$$config.suspendInstance;
		    $$$config.suspendOnActiveViewTransition;
		    var waitForCommitToBeReady = $$$config.waitForCommitToBeReady,
		      getSuspendedCommitReason = $$$config.getSuspendedCommitReason,
		      NotPendingTransition = $$$config.NotPendingTransition,
		      HostTransitionContext = $$$config.HostTransitionContext,
		      resetFormInstance = $$$config.resetFormInstance,
		      bindToConsole = $$$config.bindToConsole,
		      supportsMicrotasks = $$$config.supportsMicrotasks,
		      scheduleMicrotask = $$$config.scheduleMicrotask,
		      supportsTestSelectors = $$$config.supportsTestSelectors,
		      findFiberRoot = $$$config.findFiberRoot,
		      getBoundingRect = $$$config.getBoundingRect,
		      getTextContent = $$$config.getTextContent,
		      isHiddenSubtree = $$$config.isHiddenSubtree,
		      matchAccessibilityRole = $$$config.matchAccessibilityRole,
		      setFocusIfFocusable = $$$config.setFocusIfFocusable,
		      setupIntersectionObserver = $$$config.setupIntersectionObserver,
		      appendChild = $$$config.appendChild,
		      appendChildToContainer = $$$config.appendChildToContainer,
		      commitTextUpdate = $$$config.commitTextUpdate,
		      commitMount = $$$config.commitMount,
		      commitUpdate = $$$config.commitUpdate,
		      insertBefore = $$$config.insertBefore,
		      insertInContainerBefore = $$$config.insertInContainerBefore,
		      removeChild = $$$config.removeChild,
		      removeChildFromContainer = $$$config.removeChildFromContainer,
		      resetTextContent = $$$config.resetTextContent,
		      hideInstance = $$$config.hideInstance,
		      hideTextInstance = $$$config.hideTextInstance,
		      unhideInstance = $$$config.unhideInstance,
		      unhideTextInstance = $$$config.unhideTextInstance;
		    $$$config.cancelViewTransitionName;
		    $$$config.cancelRootViewTransitionName;
		    $$$config.restoreRootViewTransitionName;
		    $$$config.cloneRootViewTransitionContainer;
		    $$$config.removeRootViewTransitionClone;
		    $$$config.measureClonedInstance;
		    $$$config.hasInstanceChanged;
		    $$$config.hasInstanceAffectedParent;
		    $$$config.startViewTransition;
		    $$$config.startGestureTransition;
		    $$$config.stopViewTransition;
		    $$$config.getCurrentGestureOffset;
		    $$$config.createViewTransitionInstance;
		    var clearContainer = $$$config.clearContainer;
		    $$$config.createFragmentInstance;
		    $$$config.updateFragmentInstanceFiber;
		    $$$config.commitNewChildToFragmentInstance;
		    $$$config.deleteChildFromFragmentInstance;
		    var cloneInstance = $$$config.cloneInstance,
		      createContainerChildSet = $$$config.createContainerChildSet,
		      appendChildToContainerChildSet = $$$config.appendChildToContainerChildSet,
		      finalizeContainerChildren = $$$config.finalizeContainerChildren,
		      replaceContainerChildren = $$$config.replaceContainerChildren,
		      cloneHiddenInstance = $$$config.cloneHiddenInstance,
		      cloneHiddenTextInstance = $$$config.cloneHiddenTextInstance,
		      isSuspenseInstancePending = $$$config.isSuspenseInstancePending,
		      isSuspenseInstanceFallback = $$$config.isSuspenseInstanceFallback,
		      getSuspenseInstanceFallbackErrorDetails =
		        $$$config.getSuspenseInstanceFallbackErrorDetails,
		      registerSuspenseInstanceRetry = $$$config.registerSuspenseInstanceRetry,
		      canHydrateFormStateMarker = $$$config.canHydrateFormStateMarker,
		      isFormStateMarkerMatching = $$$config.isFormStateMarkerMatching,
		      getNextHydratableSibling = $$$config.getNextHydratableSibling,
		      getNextHydratableSiblingAfterSingleton =
		        $$$config.getNextHydratableSiblingAfterSingleton,
		      getFirstHydratableChild = $$$config.getFirstHydratableChild,
		      getFirstHydratableChildWithinContainer =
		        $$$config.getFirstHydratableChildWithinContainer,
		      getFirstHydratableChildWithinActivityInstance =
		        $$$config.getFirstHydratableChildWithinActivityInstance,
		      getFirstHydratableChildWithinSuspenseInstance =
		        $$$config.getFirstHydratableChildWithinSuspenseInstance,
		      getFirstHydratableChildWithinSingleton =
		        $$$config.getFirstHydratableChildWithinSingleton,
		      canHydrateInstance = $$$config.canHydrateInstance,
		      canHydrateTextInstance = $$$config.canHydrateTextInstance,
		      canHydrateActivityInstance = $$$config.canHydrateActivityInstance,
		      canHydrateSuspenseInstance = $$$config.canHydrateSuspenseInstance,
		      hydrateInstance = $$$config.hydrateInstance,
		      hydrateTextInstance = $$$config.hydrateTextInstance,
		      hydrateActivityInstance = $$$config.hydrateActivityInstance,
		      hydrateSuspenseInstance = $$$config.hydrateSuspenseInstance,
		      getNextHydratableInstanceAfterActivityInstance =
		        $$$config.getNextHydratableInstanceAfterActivityInstance,
		      getNextHydratableInstanceAfterSuspenseInstance =
		        $$$config.getNextHydratableInstanceAfterSuspenseInstance,
		      commitHydratedInstance = $$$config.commitHydratedInstance,
		      commitHydratedContainer = $$$config.commitHydratedContainer,
		      commitHydratedActivityInstance = $$$config.commitHydratedActivityInstance,
		      commitHydratedSuspenseInstance = $$$config.commitHydratedSuspenseInstance,
		      finalizeHydratedChildren = $$$config.finalizeHydratedChildren,
		      flushHydrationEvents = $$$config.flushHydrationEvents;
		    $$$config.clearActivityBoundary;
		    var clearSuspenseBoundary = $$$config.clearSuspenseBoundary;
		    $$$config.clearActivityBoundaryFromContainer;
		    var clearSuspenseBoundaryFromContainer =
		        $$$config.clearSuspenseBoundaryFromContainer,
		      hideDehydratedBoundary = $$$config.hideDehydratedBoundary,
		      unhideDehydratedBoundary = $$$config.unhideDehydratedBoundary,
		      shouldDeleteUnhydratedTailInstances =
		        $$$config.shouldDeleteUnhydratedTailInstances,
		      diffHydratedPropsForDevWarnings =
		        $$$config.diffHydratedPropsForDevWarnings,
		      diffHydratedTextForDevWarnings = $$$config.diffHydratedTextForDevWarnings,
		      describeHydratableInstanceForDevWarnings =
		        $$$config.describeHydratableInstanceForDevWarnings,
		      validateHydratableInstance = $$$config.validateHydratableInstance,
		      validateHydratableTextInstance = $$$config.validateHydratableTextInstance,
		      supportsResources = $$$config.supportsResources,
		      isHostHoistableType = $$$config.isHostHoistableType,
		      getHoistableRoot = $$$config.getHoistableRoot,
		      getResource = $$$config.getResource,
		      acquireResource = $$$config.acquireResource,
		      releaseResource = $$$config.releaseResource,
		      hydrateHoistable = $$$config.hydrateHoistable,
		      mountHoistable = $$$config.mountHoistable,
		      unmountHoistable = $$$config.unmountHoistable,
		      createHoistableInstance = $$$config.createHoistableInstance,
		      prepareToCommitHoistables = $$$config.prepareToCommitHoistables,
		      mayResourceSuspendCommit = $$$config.mayResourceSuspendCommit,
		      preloadResource = $$$config.preloadResource,
		      suspendResource = $$$config.suspendResource,
		      supportsSingletons = $$$config.supportsSingletons,
		      resolveSingletonInstance = $$$config.resolveSingletonInstance,
		      acquireSingletonInstance = $$$config.acquireSingletonInstance,
		      releaseSingletonInstance = $$$config.releaseSingletonInstance,
		      isHostSingletonType = $$$config.isHostSingletonType,
		      isSingletonScope = $$$config.isSingletonScope,
		      valueStack = [];
		    var fiberStack = [];
		    var index$jscomp$0 = -1,
		      emptyContextObject = {};
		    Object.freeze(emptyContextObject);
		    var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback,
		      log$1 = Math.log,
		      LN2 = Math.LN2,
		      nextTransitionUpdateLane = 256,
		      nextTransitionDeferredLane = 262144,
		      nextRetryLane = 4194304,
		      scheduleCallback$3 = Scheduler.unstable_scheduleCallback,
		      cancelCallback$1 = Scheduler.unstable_cancelCallback,
		      shouldYield = Scheduler.unstable_shouldYield,
		      requestPaint = Scheduler.unstable_requestPaint,
		      now$1 = Scheduler.unstable_now,
		      ImmediatePriority = Scheduler.unstable_ImmediatePriority,
		      UserBlockingPriority = Scheduler.unstable_UserBlockingPriority,
		      NormalPriority$1 = Scheduler.unstable_NormalPriority,
		      IdlePriority = Scheduler.unstable_IdlePriority,
		      log = Scheduler.log,
		      unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue,
		      rendererID = null,
		      injectedHook = null,
		      hasLoggedError = false,
		      isDevToolsPresent = "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__,
		      lastResetTime = 0;
		    if (
		      "object" === typeof performance &&
		      "function" === typeof performance.now
		    ) {
		      var localPerformance = performance;
		      var getCurrentTime = function () {
		        return localPerformance.now();
		      };
		    } else {
		      var localDate = Date;
		      getCurrentTime = function () {
		        return localDate.now();
		      };
		    }
		    var objectIs = "function" === typeof Object.is ? Object.is : is,
		      reportGlobalError =
		        "function" === typeof reportError
		          ? reportError
		          : function (error) {
		              if (
		                "object" === typeof window &&
		                "function" === typeof window.ErrorEvent
		              ) {
		                var event = new window.ErrorEvent("error", {
		                  bubbles: true,
		                  cancelable: true,
		                  message:
		                    "object" === typeof error &&
		                    null !== error &&
		                    "string" === typeof error.message
		                      ? String(error.message)
		                      : String(error),
		                  error: error
		                });
		                if (!window.dispatchEvent(event)) return;
		              } else if (
		                "object" === typeof process &&
		                "function" === typeof process.emit
		              ) {
		                process.emit("uncaughtException", error);
		                return;
		              }
		              console.error(error);
		            },
		      hasOwnProperty = Object.prototype.hasOwnProperty,
		      supportsUserTiming =
		        "undefined" !== typeof console &&
		        "function" === typeof console.timeStamp &&
		        "undefined" !== typeof performance &&
		        "function" === typeof performance.measure,
		      currentTrack = "Blocking",
		      alreadyWarnedForDeepEquality = false,
		      reusableComponentDevToolDetails = {
		        color: "primary",
		        properties: null,
		        tooltipText: "",
		        track: "Components \u269b"
		      },
		      reusableComponentOptions = {
		        start: -0,
		        end: -0,
		        detail: { devtools: reusableComponentDevToolDetails }
		      },
		      resuableChangedPropsEntry = ["Changed Props", ""],
		      reusableDeeplyEqualPropsEntry = [
		        "Changed Props",
		        "This component received deeply equal props. It might benefit from useMemo or the React Compiler in its owner."
		      ],
		      disabledDepth = 0,
		      prevLog,
		      prevInfo,
		      prevWarn,
		      prevError,
		      prevGroup,
		      prevGroupCollapsed,
		      prevGroupEnd;
		    disabledLog.__reactDisabledLog = true;
		    var prefix,
		      suffix,
		      reentry = false;
		    var componentFrameCache = new (
		      "function" === typeof WeakMap ? WeakMap : Map
		    )();
		    var CapturedStacks = new WeakMap(),
		      forkStack = [],
		      forkStackIndex = 0,
		      treeForkProvider = null,
		      treeForkCount = 0,
		      idStack = [],
		      idStackIndex = 0,
		      treeContextProvider = null,
		      treeContextId = 1,
		      treeContextOverflow = "",
		      contextStackCursor = createCursor(null),
		      contextFiberStackCursor = createCursor(null),
		      rootInstanceStackCursor = createCursor(null),
		      hostTransitionProviderCursor = createCursor(null),
		      needsEscaping = /["'&<>\n\t]|^\s|\s$/,
		      current = null,
		      isRendering = false,
		      hydrationParentFiber = null,
		      nextHydratableInstance = null,
		      isHydrating = false,
		      didSuspendOrErrorDEV = false,
		      hydrationDiffRootDEV = null,
		      hydrationErrors = null,
		      rootOrSingletonContext = false,
		      HydrationMismatchException = Error(
		        "Hydration Mismatch Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."
		      ),
		      NoMode = 0,
		      valueCursor = createCursor(null);
		    var rendererCursorDEV = createCursor(null);
		    var renderer2CursorDEV = createCursor(null);
		    var rendererSigil = {};
		    var currentlyRenderingFiber$1 = null,
		      lastContextDependency = null,
		      isDisallowedContextReadInDEV = false,
		      AbortControllerLocal =
		        "undefined" !== typeof AbortController
		          ? AbortController
		          : function () {
		              var listeners = [],
		                signal = (this.signal = {
		                  aborted: false,
		                  addEventListener: function (type, listener) {
		                    listeners.push(listener);
		                  }
		                });
		              this.abort = function () {
		                signal.aborted = true;
		                listeners.forEach(function (listener) {
		                  return listener();
		                });
		              };
		            },
		      scheduleCallback$2 = Scheduler.unstable_scheduleCallback,
		      NormalPriority = Scheduler.unstable_NormalPriority,
		      CacheContext = {
		        $$typeof: REACT_CONTEXT_TYPE,
		        Consumer: null,
		        Provider: null,
		        _currentValue: null,
		        _currentValue2: null,
		        _threadCount: 0,
		        _currentRenderer: null,
		        _currentRenderer2: null
		      },
		      now = Scheduler.unstable_now,
		      createTask = console.createTask
		        ? console.createTask
		        : function () {
		            return null;
		          },
		      renderStartTime = -0,
		      commitStartTime = -0,
		      commitEndTime = -0,
		      commitErrors = null,
		      profilerStartTime = -1.1,
		      profilerEffectDuration = -0,
		      componentEffectDuration = -0,
		      componentEffectStartTime = -1.1,
		      componentEffectEndTime = -1.1,
		      componentEffectErrors = null,
		      componentEffectSpawnedUpdate = false,
		      blockingClampTime = -0,
		      blockingUpdateTime = -1.1,
		      blockingUpdateTask = null,
		      blockingUpdateType = 0,
		      blockingUpdateMethodName = null,
		      blockingUpdateComponentName = null,
		      blockingEventTime = -1.1,
		      blockingEventType = null,
		      blockingEventRepeatTime = -1.1,
		      blockingSuspendedTime = -1.1,
		      transitionClampTime = -0,
		      transitionStartTime = -1.1,
		      transitionUpdateTime = -1.1,
		      transitionUpdateType = 0,
		      transitionUpdateTask = null,
		      transitionUpdateMethodName = null,
		      transitionUpdateComponentName = null,
		      transitionEventTime = -1.1,
		      transitionEventType = null,
		      transitionEventRepeatTime = -1.1,
		      transitionSuspendedTime = -1.1,
		      animatingTask = null,
		      yieldReason = 0,
		      yieldStartTime = -1.1,
		      currentUpdateIsNested = false,
		      nestedUpdateScheduled = false,
		      firstScheduledRoot = null,
		      lastScheduledRoot = null,
		      didScheduleMicrotask = false,
		      didScheduleMicrotask_act = false,
		      mightHavePendingSyncWork = false,
		      isFlushingWork = false,
		      currentEventTransitionLane = 0,
		      fakeActCallbackNode$1 = {},
		      currentEntangledListeners = null,
		      currentEntangledPendingCount = 0,
		      currentEntangledLane = 0,
		      currentEntangledActionThenable = null,
		      prevOnStartTransitionFinish = ReactSharedInternals.S;
		    ReactSharedInternals.S = function (transition, returnValue) {
		      globalMostRecentTransitionTime = now$1();
		      if (
		        "object" === typeof returnValue &&
		        null !== returnValue &&
		        "function" === typeof returnValue.then
		      ) {
		        if (0 > transitionStartTime && 0 > transitionUpdateTime) {
		          transitionStartTime = now();
		          var newEventTime = resolveEventTimeStamp(),
		            newEventType = resolveEventType();
		          if (
		            newEventTime !== transitionEventRepeatTime ||
		            newEventType !== transitionEventType
		          )
		            transitionEventRepeatTime = -1.1;
		          transitionEventTime = newEventTime;
		          transitionEventType = newEventType;
		        }
		        entangleAsyncAction(transition, returnValue);
		      }
		      null !== prevOnStartTransitionFinish &&
		        prevOnStartTransitionFinish(transition, returnValue);
		    };
		    var resumedCache = createCursor(null),
		      ReactStrictModeWarnings = {
		        recordUnsafeLifecycleWarnings: function () {},
		        flushPendingUnsafeLifecycleWarnings: function () {},
		        recordLegacyContextWarning: function () {},
		        flushLegacyContextWarning: function () {},
		        discardPendingWarnings: function () {}
		      },
		      pendingComponentWillMountWarnings = [],
		      pendingUNSAFE_ComponentWillMountWarnings = [],
		      pendingComponentWillReceivePropsWarnings = [],
		      pendingUNSAFE_ComponentWillReceivePropsWarnings = [],
		      pendingComponentWillUpdateWarnings = [],
		      pendingUNSAFE_ComponentWillUpdateWarnings = [],
		      didWarnAboutUnsafeLifecycles = new Set();
		    ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function (
		      fiber,
		      instance
		    ) {
		      didWarnAboutUnsafeLifecycles.has(fiber.type) ||
		        ("function" === typeof instance.componentWillMount &&
		          true !== instance.componentWillMount.__suppressDeprecationWarning &&
		          pendingComponentWillMountWarnings.push(fiber),
		        fiber.mode & 8 &&
		          "function" === typeof instance.UNSAFE_componentWillMount &&
		          pendingUNSAFE_ComponentWillMountWarnings.push(fiber),
		        "function" === typeof instance.componentWillReceiveProps &&
		          true !==
		            instance.componentWillReceiveProps.__suppressDeprecationWarning &&
		          pendingComponentWillReceivePropsWarnings.push(fiber),
		        fiber.mode & 8 &&
		          "function" === typeof instance.UNSAFE_componentWillReceiveProps &&
		          pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber),
		        "function" === typeof instance.componentWillUpdate &&
		          true !== instance.componentWillUpdate.__suppressDeprecationWarning &&
		          pendingComponentWillUpdateWarnings.push(fiber),
		        fiber.mode & 8 &&
		          "function" === typeof instance.UNSAFE_componentWillUpdate &&
		          pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber));
		    };
		    ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function () {
		      var componentWillMountUniqueNames = new Set();
		      0 < pendingComponentWillMountWarnings.length &&
		        (pendingComponentWillMountWarnings.forEach(function (fiber) {
		          componentWillMountUniqueNames.add(
		            getComponentNameFromFiber(fiber) || "Component"
		          );
		          didWarnAboutUnsafeLifecycles.add(fiber.type);
		        }),
		        (pendingComponentWillMountWarnings = []));
		      var UNSAFE_componentWillMountUniqueNames = new Set();
		      0 < pendingUNSAFE_ComponentWillMountWarnings.length &&
		        (pendingUNSAFE_ComponentWillMountWarnings.forEach(function (fiber) {
		          UNSAFE_componentWillMountUniqueNames.add(
		            getComponentNameFromFiber(fiber) || "Component"
		          );
		          didWarnAboutUnsafeLifecycles.add(fiber.type);
		        }),
		        (pendingUNSAFE_ComponentWillMountWarnings = []));
		      var componentWillReceivePropsUniqueNames = new Set();
		      0 < pendingComponentWillReceivePropsWarnings.length &&
		        (pendingComponentWillReceivePropsWarnings.forEach(function (fiber) {
		          componentWillReceivePropsUniqueNames.add(
		            getComponentNameFromFiber(fiber) || "Component"
		          );
		          didWarnAboutUnsafeLifecycles.add(fiber.type);
		        }),
		        (pendingComponentWillReceivePropsWarnings = []));
		      var UNSAFE_componentWillReceivePropsUniqueNames = new Set();
		      0 < pendingUNSAFE_ComponentWillReceivePropsWarnings.length &&
		        (pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(
		          function (fiber) {
		            UNSAFE_componentWillReceivePropsUniqueNames.add(
		              getComponentNameFromFiber(fiber) || "Component"
		            );
		            didWarnAboutUnsafeLifecycles.add(fiber.type);
		          }
		        ),
		        (pendingUNSAFE_ComponentWillReceivePropsWarnings = []));
		      var componentWillUpdateUniqueNames = new Set();
		      0 < pendingComponentWillUpdateWarnings.length &&
		        (pendingComponentWillUpdateWarnings.forEach(function (fiber) {
		          componentWillUpdateUniqueNames.add(
		            getComponentNameFromFiber(fiber) || "Component"
		          );
		          didWarnAboutUnsafeLifecycles.add(fiber.type);
		        }),
		        (pendingComponentWillUpdateWarnings = []));
		      var UNSAFE_componentWillUpdateUniqueNames = new Set();
		      0 < pendingUNSAFE_ComponentWillUpdateWarnings.length &&
		        (pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function (fiber) {
		          UNSAFE_componentWillUpdateUniqueNames.add(
		            getComponentNameFromFiber(fiber) || "Component"
		          );
		          didWarnAboutUnsafeLifecycles.add(fiber.type);
		        }),
		        (pendingUNSAFE_ComponentWillUpdateWarnings = []));
		      if (0 < UNSAFE_componentWillMountUniqueNames.size) {
		        var sortedNames = setToSortedString(
		          UNSAFE_componentWillMountUniqueNames
		        );
		        console.error(
		          "Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s",
		          sortedNames
		        );
		      }
		      0 < UNSAFE_componentWillReceivePropsUniqueNames.size &&
		        ((sortedNames = setToSortedString(
		          UNSAFE_componentWillReceivePropsUniqueNames
		        )),
		        console.error(
		          "Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state\n\nPlease update the following components: %s",
		          sortedNames
		        ));
		      0 < UNSAFE_componentWillUpdateUniqueNames.size &&
		        ((sortedNames = setToSortedString(
		          UNSAFE_componentWillUpdateUniqueNames
		        )),
		        console.error(
		          "Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s",
		          sortedNames
		        ));
		      0 < componentWillMountUniqueNames.size &&
		        ((sortedNames = setToSortedString(componentWillMountUniqueNames)),
		        console.warn(
		          "componentWillMount has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s",
		          sortedNames
		        ));
		      0 < componentWillReceivePropsUniqueNames.size &&
		        ((sortedNames = setToSortedString(
		          componentWillReceivePropsUniqueNames
		        )),
		        console.warn(
		          "componentWillReceiveProps has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s",
		          sortedNames
		        ));
		      0 < componentWillUpdateUniqueNames.size &&
		        ((sortedNames = setToSortedString(componentWillUpdateUniqueNames)),
		        console.warn(
		          "componentWillUpdate has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s",
		          sortedNames
		        ));
		    };
		    var pendingLegacyContextWarning = new Map(),
		      didWarnAboutLegacyContext = new Set();
		    ReactStrictModeWarnings.recordLegacyContextWarning = function (
		      fiber,
		      instance
		    ) {
		      var strictRoot = null;
		      for (var node = fiber; null !== node; )
		        node.mode & 8 && (strictRoot = node), (node = node.return);
		      null === strictRoot
		        ? console.error(
		            "Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue."
		          )
		        : !didWarnAboutLegacyContext.has(fiber.type) &&
		          ((node = pendingLegacyContextWarning.get(strictRoot)),
		          null != fiber.type.contextTypes ||
		            null != fiber.type.childContextTypes ||
		            (null !== instance &&
		              "function" === typeof instance.getChildContext)) &&
		          (void 0 === node &&
		            ((node = []), pendingLegacyContextWarning.set(strictRoot, node)),
		          node.push(fiber));
		    };
		    ReactStrictModeWarnings.flushLegacyContextWarning = function () {
		      pendingLegacyContextWarning.forEach(function (fiberArray) {
		        if (0 !== fiberArray.length) {
		          var firstFiber = fiberArray[0],
		            uniqueNames = new Set();
		          fiberArray.forEach(function (fiber) {
		            uniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
		            didWarnAboutLegacyContext.add(fiber.type);
		          });
		          var sortedNames = setToSortedString(uniqueNames);
		          runWithFiberInDEV(firstFiber, function () {
		            console.error(
		              "Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://react.dev/link/legacy-context",
		              sortedNames
		            );
		          });
		        }
		      });
		    };
		    ReactStrictModeWarnings.discardPendingWarnings = function () {
		      pendingComponentWillMountWarnings = [];
		      pendingUNSAFE_ComponentWillMountWarnings = [];
		      pendingComponentWillReceivePropsWarnings = [];
		      pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
		      pendingComponentWillUpdateWarnings = [];
		      pendingUNSAFE_ComponentWillUpdateWarnings = [];
		      pendingLegacyContextWarning = new Map();
		    };
		    var callComponent = {
		        react_stack_bottom_frame: function (Component, props, secondArg) {
		          var wasRendering = isRendering;
		          isRendering = true;
		          try {
		            return Component(props, secondArg);
		          } finally {
		            isRendering = wasRendering;
		          }
		        }
		      },
		      callComponentInDEV =
		        callComponent.react_stack_bottom_frame.bind(callComponent),
		      callRender = {
		        react_stack_bottom_frame: function (instance) {
		          var wasRendering = isRendering;
		          isRendering = true;
		          try {
		            return instance.render();
		          } finally {
		            isRendering = wasRendering;
		          }
		        }
		      },
		      callRenderInDEV = callRender.react_stack_bottom_frame.bind(callRender),
		      callComponentDidMount = {
		        react_stack_bottom_frame: function (finishedWork, instance) {
		          try {
		            instance.componentDidMount();
		          } catch (error) {
		            captureCommitPhaseError(finishedWork, finishedWork.return, error);
		          }
		        }
		      },
		      callComponentDidMountInDEV =
		        callComponentDidMount.react_stack_bottom_frame.bind(
		          callComponentDidMount
		        ),
		      callComponentDidUpdate = {
		        react_stack_bottom_frame: function (
		          finishedWork,
		          instance,
		          prevProps,
		          prevState,
		          snapshot
		        ) {
		          try {
		            instance.componentDidUpdate(prevProps, prevState, snapshot);
		          } catch (error) {
		            captureCommitPhaseError(finishedWork, finishedWork.return, error);
		          }
		        }
		      },
		      callComponentDidUpdateInDEV =
		        callComponentDidUpdate.react_stack_bottom_frame.bind(
		          callComponentDidUpdate
		        ),
		      callComponentDidCatch = {
		        react_stack_bottom_frame: function (instance, errorInfo) {
		          var stack = errorInfo.stack;
		          instance.componentDidCatch(errorInfo.value, {
		            componentStack: null !== stack ? stack : ""
		          });
		        }
		      },
		      callComponentDidCatchInDEV =
		        callComponentDidCatch.react_stack_bottom_frame.bind(
		          callComponentDidCatch
		        ),
		      callComponentWillUnmount = {
		        react_stack_bottom_frame: function (
		          current,
		          nearestMountedAncestor,
		          instance
		        ) {
		          try {
		            instance.componentWillUnmount();
		          } catch (error) {
		            captureCommitPhaseError(current, nearestMountedAncestor, error);
		          }
		        }
		      },
		      callComponentWillUnmountInDEV =
		        callComponentWillUnmount.react_stack_bottom_frame.bind(
		          callComponentWillUnmount
		        ),
		      callCreate = {
		        react_stack_bottom_frame: function (effect) {
		          var create = effect.create;
		          effect = effect.inst;
		          create = create();
		          return (effect.destroy = create);
		        }
		      },
		      callCreateInDEV = callCreate.react_stack_bottom_frame.bind(callCreate),
		      callDestroy = {
		        react_stack_bottom_frame: function (
		          current,
		          nearestMountedAncestor,
		          destroy
		        ) {
		          try {
		            destroy();
		          } catch (error) {
		            captureCommitPhaseError(current, nearestMountedAncestor, error);
		          }
		        }
		      },
		      callDestroyInDEV = callDestroy.react_stack_bottom_frame.bind(callDestroy),
		      callLazyInit = {
		        react_stack_bottom_frame: function (lazy) {
		          var init = lazy._init;
		          return init(lazy._payload);
		        }
		      },
		      callLazyInitInDEV =
		        callLazyInit.react_stack_bottom_frame.bind(callLazyInit),
		      SuspenseException = Error(
		        "Suspense Exception: This is not a real error! It's an implementation detail of `use` to interrupt the current render. You must either rethrow it immediately, or move the `use` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary, or call the promise's `.catch` method and pass the result to `use`."
		      ),
		      SuspenseyCommitException = Error(
		        "Suspense Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."
		      ),
		      SuspenseActionException = Error(
		        "Suspense Exception: This is not a real error! It's an implementation detail of `useActionState` to interrupt the current render. You must either rethrow it immediately, or move the `useActionState` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary."
		      ),
		      noopSuspenseyCommitThenable = {
		        then: function () {
		          console.error(
		            'Internal React error: A listener was unexpectedly attached to a "noop" thenable. This is a bug in React. Please file an issue.'
		          );
		        }
		      },
		      suspendedThenable = null,
		      needsToResetSuspendedThenableDEV = false,
		      thenableState$1 = null,
		      thenableIndexCounter$1 = 0,
		      currentDebugInfo = null,
		      didWarnAboutMaps;
		    var didWarnAboutGenerators = (didWarnAboutMaps = false);
		    var ownerHasKeyUseWarning = {};
		    var ownerHasFunctionTypeWarning = {};
		    var ownerHasSymbolTypeWarning = {};
		    warnForMissingKey = function (returnFiber, workInProgress, child) {
		      if (
		        null !== child &&
		        "object" === typeof child &&
		        child._store &&
		        ((!child._store.validated && null == child.key) ||
		          2 === child._store.validated)
		      ) {
		        if ("object" !== typeof child._store)
		          throw Error(
		            "React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue."
		          );
		        child._store.validated = 1;
		        var componentName = getComponentNameFromFiber(returnFiber),
		          componentKey = componentName || "null";
		        if (!ownerHasKeyUseWarning[componentKey]) {
		          ownerHasKeyUseWarning[componentKey] = true;
		          child = child._owner;
		          returnFiber = returnFiber._debugOwner;
		          var currentComponentErrorInfo = "";
		          returnFiber &&
		            "number" === typeof returnFiber.tag &&
		            (componentKey = getComponentNameFromFiber(returnFiber)) &&
		            (currentComponentErrorInfo =
		              "\n\nCheck the render method of `" + componentKey + "`.");
		          currentComponentErrorInfo ||
		            (componentName &&
		              (currentComponentErrorInfo =
		                "\n\nCheck the top-level render call using <" +
		                componentName +
		                ">."));
		          var childOwnerAppendix = "";
		          null != child &&
		            returnFiber !== child &&
		            ((componentName = null),
		            "number" === typeof child.tag
		              ? (componentName = getComponentNameFromFiber(child))
		              : "string" === typeof child.name && (componentName = child.name),
		            componentName &&
		              (childOwnerAppendix =
		                " It was passed a child from " + componentName + "."));
		          runWithFiberInDEV(workInProgress, function () {
		            console.error(
		              'Each child in a list should have a unique "key" prop.%s%s See https://react.dev/link/warning-keys for more information.',
		              currentComponentErrorInfo,
		              childOwnerAppendix
		            );
		          });
		        }
		      }
		    };
		    var reconcileChildFibers = createChildReconciler(true),
		      mountChildFibers = createChildReconciler(false),
		      OffscreenVisible = 1,
		      OffscreenPassiveEffectsConnected = 2,
		      concurrentQueues = [],
		      concurrentQueuesIndex = 0,
		      concurrentlyUpdatedLanes = 0,
		      UpdateState = 0,
		      ReplaceState = 1,
		      ForceUpdate = 2,
		      CaptureUpdate = 3,
		      hasForceUpdate = false;
		    var didWarnUpdateInsideUpdate = false;
		    var currentlyProcessingQueue = null;
		    var didReadFromEntangledAsyncAction = false,
		      currentTreeHiddenStackCursor = createCursor(null),
		      prevEntangledRenderLanesCursor = createCursor(0),
		      suspenseHandlerStackCursor = createCursor(null),
		      shellBoundary = null,
		      SubtreeSuspenseContextMask = 1,
		      ForceSuspenseFallback = 2,
		      suspenseStackCursor = createCursor(0),
		      NoFlags = 0,
		      HasEffect = 1,
		      Insertion = 2,
		      Layout = 4,
		      Passive = 8,
		      didWarnUncachedGetSnapshot;
		    var didWarnAboutMismatchedHooksForComponent = new Set();
		    var didWarnAboutUseWrappedInTryCatch = new Set();
		    var didWarnAboutAsyncClientComponent = new Set();
		    var didWarnAboutUseFormState = new Set();
		    var renderLanes = 0,
		      currentlyRenderingFiber = null,
		      currentHook = null,
		      workInProgressHook = null,
		      didScheduleRenderPhaseUpdate = false,
		      didScheduleRenderPhaseUpdateDuringThisPass = false,
		      shouldDoubleInvokeUserFnsInHooksDEV = false,
		      localIdCounter = 0,
		      thenableIndexCounter = 0,
		      thenableState = null,
		      globalClientIdCounter = 0,
		      RE_RENDER_LIMIT = 25,
		      currentHookNameInDev = null,
		      hookTypesDev = null,
		      hookTypesUpdateIndexDev = -1,
		      ignorePreviousDependencies = false,
		      ContextOnlyDispatcher = {
		        readContext: readContext,
		        use: use,
		        useCallback: throwInvalidHookError,
		        useContext: throwInvalidHookError,
		        useEffect: throwInvalidHookError,
		        useImperativeHandle: throwInvalidHookError,
		        useLayoutEffect: throwInvalidHookError,
		        useInsertionEffect: throwInvalidHookError,
		        useMemo: throwInvalidHookError,
		        useReducer: throwInvalidHookError,
		        useRef: throwInvalidHookError,
		        useState: throwInvalidHookError,
		        useDebugValue: throwInvalidHookError,
		        useDeferredValue: throwInvalidHookError,
		        useTransition: throwInvalidHookError,
		        useSyncExternalStore: throwInvalidHookError,
		        useId: throwInvalidHookError,
		        useHostTransitionStatus: throwInvalidHookError,
		        useFormState: throwInvalidHookError,
		        useActionState: throwInvalidHookError,
		        useOptimistic: throwInvalidHookError,
		        useMemoCache: throwInvalidHookError,
		        useCacheRefresh: throwInvalidHookError
		      };
		    ContextOnlyDispatcher.useEffectEvent = throwInvalidHookError;
		    var HooksDispatcherOnMountInDEV = null,
		      HooksDispatcherOnMountWithHookTypesInDEV = null,
		      HooksDispatcherOnUpdateInDEV = null,
		      HooksDispatcherOnRerenderInDEV = null,
		      InvalidNestedHooksDispatcherOnMountInDEV = null,
		      InvalidNestedHooksDispatcherOnUpdateInDEV = null,
		      InvalidNestedHooksDispatcherOnRerenderInDEV = null;
		    HooksDispatcherOnMountInDEV = {
		      readContext: function (context) {
		        return readContext(context);
		      },
		      use: use,
		      useCallback: function (callback, deps) {
		        currentHookNameInDev = "useCallback";
		        mountHookTypesDev();
		        checkDepsAreArrayDev(deps);
		        return mountCallback(callback, deps);
		      },
		      useContext: function (context) {
		        currentHookNameInDev = "useContext";
		        mountHookTypesDev();
		        return readContext(context);
		      },
		      useEffect: function (create, deps) {
		        currentHookNameInDev = "useEffect";
		        mountHookTypesDev();
		        checkDepsAreArrayDev(deps);
		        return mountEffect(create, deps);
		      },
		      useImperativeHandle: function (ref, create, deps) {
		        currentHookNameInDev = "useImperativeHandle";
		        mountHookTypesDev();
		        checkDepsAreArrayDev(deps);
		        return mountImperativeHandle(ref, create, deps);
		      },
		      useInsertionEffect: function (create, deps) {
		        currentHookNameInDev = "useInsertionEffect";
		        mountHookTypesDev();
		        checkDepsAreArrayDev(deps);
		        mountEffectImpl(4, Insertion, create, deps);
		      },
		      useLayoutEffect: function (create, deps) {
		        currentHookNameInDev = "useLayoutEffect";
		        mountHookTypesDev();
		        checkDepsAreArrayDev(deps);
		        return mountLayoutEffect(create, deps);
		      },
		      useMemo: function (create, deps) {
		        currentHookNameInDev = "useMemo";
		        mountHookTypesDev();
		        checkDepsAreArrayDev(deps);
		        var prevDispatcher = ReactSharedInternals.H;
		        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
		        try {
		          return mountMemo(create, deps);
		        } finally {
		          ReactSharedInternals.H = prevDispatcher;
		        }
		      },
		      useReducer: function (reducer, initialArg, init) {
		        currentHookNameInDev = "useReducer";
		        mountHookTypesDev();
		        var prevDispatcher = ReactSharedInternals.H;
		        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
		        try {
		          return mountReducer(reducer, initialArg, init);
		        } finally {
		          ReactSharedInternals.H = prevDispatcher;
		        }
		      },
		      useRef: function (initialValue) {
		        currentHookNameInDev = "useRef";
		        mountHookTypesDev();
		        return mountRef(initialValue);
		      },
		      useState: function (initialState) {
		        currentHookNameInDev = "useState";
		        mountHookTypesDev();
		        var prevDispatcher = ReactSharedInternals.H;
		        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
		        try {
		          return mountState(initialState);
		        } finally {
		          ReactSharedInternals.H = prevDispatcher;
		        }
		      },
		      useDebugValue: function () {
		        currentHookNameInDev = "useDebugValue";
		        mountHookTypesDev();
		      },
		      useDeferredValue: function (value, initialValue) {
		        currentHookNameInDev = "useDeferredValue";
		        mountHookTypesDev();
		        return mountDeferredValue(value, initialValue);
		      },
		      useTransition: function () {
		        currentHookNameInDev = "useTransition";
		        mountHookTypesDev();
		        return mountTransition();
		      },
		      useSyncExternalStore: function (
		        subscribe,
		        getSnapshot,
		        getServerSnapshot
		      ) {
		        currentHookNameInDev = "useSyncExternalStore";
		        mountHookTypesDev();
		        return mountSyncExternalStore(
		          subscribe,
		          getSnapshot,
		          getServerSnapshot
		        );
		      },
		      useId: function () {
		        currentHookNameInDev = "useId";
		        mountHookTypesDev();
		        return mountId();
		      },
		      useFormState: function (action, initialState) {
		        currentHookNameInDev = "useFormState";
		        mountHookTypesDev();
		        warnOnUseFormStateInDev();
		        return mountActionState(action, initialState);
		      },
		      useActionState: function (action, initialState) {
		        currentHookNameInDev = "useActionState";
		        mountHookTypesDev();
		        return mountActionState(action, initialState);
		      },
		      useOptimistic: function (passthrough) {
		        currentHookNameInDev = "useOptimistic";
		        mountHookTypesDev();
		        return mountOptimistic(passthrough);
		      },
		      useHostTransitionStatus: useHostTransitionStatus,
		      useMemoCache: useMemoCache,
		      useCacheRefresh: function () {
		        currentHookNameInDev = "useCacheRefresh";
		        mountHookTypesDev();
		        return mountRefresh();
		      },
		      useEffectEvent: function (callback) {
		        currentHookNameInDev = "useEffectEvent";
		        mountHookTypesDev();
		        return mountEvent(callback);
		      }
		    };
		    HooksDispatcherOnMountWithHookTypesInDEV = {
		      readContext: function (context) {
		        return readContext(context);
		      },
		      use: use,
		      useCallback: function (callback, deps) {
		        currentHookNameInDev = "useCallback";
		        updateHookTypesDev();
		        return mountCallback(callback, deps);
		      },
		      useContext: function (context) {
		        currentHookNameInDev = "useContext";
		        updateHookTypesDev();
		        return readContext(context);
		      },
		      useEffect: function (create, deps) {
		        currentHookNameInDev = "useEffect";
		        updateHookTypesDev();
		        return mountEffect(create, deps);
		      },
		      useImperativeHandle: function (ref, create, deps) {
		        currentHookNameInDev = "useImperativeHandle";
		        updateHookTypesDev();
		        return mountImperativeHandle(ref, create, deps);
		      },
		      useInsertionEffect: function (create, deps) {
		        currentHookNameInDev = "useInsertionEffect";
		        updateHookTypesDev();
		        mountEffectImpl(4, Insertion, create, deps);
		      },
		      useLayoutEffect: function (create, deps) {
		        currentHookNameInDev = "useLayoutEffect";
		        updateHookTypesDev();
		        return mountLayoutEffect(create, deps);
		      },
		      useMemo: function (create, deps) {
		        currentHookNameInDev = "useMemo";
		        updateHookTypesDev();
		        var prevDispatcher = ReactSharedInternals.H;
		        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
		        try {
		          return mountMemo(create, deps);
		        } finally {
		          ReactSharedInternals.H = prevDispatcher;
		        }
		      },
		      useReducer: function (reducer, initialArg, init) {
		        currentHookNameInDev = "useReducer";
		        updateHookTypesDev();
		        var prevDispatcher = ReactSharedInternals.H;
		        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
		        try {
		          return mountReducer(reducer, initialArg, init);
		        } finally {
		          ReactSharedInternals.H = prevDispatcher;
		        }
		      },
		      useRef: function (initialValue) {
		        currentHookNameInDev = "useRef";
		        updateHookTypesDev();
		        return mountRef(initialValue);
		      },
		      useState: function (initialState) {
		        currentHookNameInDev = "useState";
		        updateHookTypesDev();
		        var prevDispatcher = ReactSharedInternals.H;
		        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
		        try {
		          return mountState(initialState);
		        } finally {
		          ReactSharedInternals.H = prevDispatcher;
		        }
		      },
		      useDebugValue: function () {
		        currentHookNameInDev = "useDebugValue";
		        updateHookTypesDev();
		      },
		      useDeferredValue: function (value, initialValue) {
		        currentHookNameInDev = "useDeferredValue";
		        updateHookTypesDev();
		        return mountDeferredValue(value, initialValue);
		      },
		      useTransition: function () {
		        currentHookNameInDev = "useTransition";
		        updateHookTypesDev();
		        return mountTransition();
		      },
		      useSyncExternalStore: function (
		        subscribe,
		        getSnapshot,
		        getServerSnapshot
		      ) {
		        currentHookNameInDev = "useSyncExternalStore";
		        updateHookTypesDev();
		        return mountSyncExternalStore(
		          subscribe,
		          getSnapshot,
		          getServerSnapshot
		        );
		      },
		      useId: function () {
		        currentHookNameInDev = "useId";
		        updateHookTypesDev();
		        return mountId();
		      },
		      useActionState: function (action, initialState) {
		        currentHookNameInDev = "useActionState";
		        updateHookTypesDev();
		        return mountActionState(action, initialState);
		      },
		      useFormState: function (action, initialState) {
		        currentHookNameInDev = "useFormState";
		        updateHookTypesDev();
		        warnOnUseFormStateInDev();
		        return mountActionState(action, initialState);
		      },
		      useOptimistic: function (passthrough) {
		        currentHookNameInDev = "useOptimistic";
		        updateHookTypesDev();
		        return mountOptimistic(passthrough);
		      },
		      useHostTransitionStatus: useHostTransitionStatus,
		      useMemoCache: useMemoCache,
		      useCacheRefresh: function () {
		        currentHookNameInDev = "useCacheRefresh";
		        updateHookTypesDev();
		        return mountRefresh();
		      },
		      useEffectEvent: function (callback) {
		        currentHookNameInDev = "useEffectEvent";
		        updateHookTypesDev();
		        return mountEvent(callback);
		      }
		    };
		    HooksDispatcherOnUpdateInDEV = {
		      readContext: function (context) {
		        return readContext(context);
		      },
		      use: use,
		      useCallback: function (callback, deps) {
		        currentHookNameInDev = "useCallback";
		        updateHookTypesDev();
		        return updateCallback(callback, deps);
		      },
		      useContext: function (context) {
		        currentHookNameInDev = "useContext";
		        updateHookTypesDev();
		        return readContext(context);
		      },
		      useEffect: function (create, deps) {
		        currentHookNameInDev = "useEffect";
		        updateHookTypesDev();
		        updateEffectImpl(2048, Passive, create, deps);
		      },
		      useImperativeHandle: function (ref, create, deps) {
		        currentHookNameInDev = "useImperativeHandle";
		        updateHookTypesDev();
		        return updateImperativeHandle(ref, create, deps);
		      },
		      useInsertionEffect: function (create, deps) {
		        currentHookNameInDev = "useInsertionEffect";
		        updateHookTypesDev();
		        return updateEffectImpl(4, Insertion, create, deps);
		      },
		      useLayoutEffect: function (create, deps) {
		        currentHookNameInDev = "useLayoutEffect";
		        updateHookTypesDev();
		        return updateEffectImpl(4, Layout, create, deps);
		      },
		      useMemo: function (create, deps) {
		        currentHookNameInDev = "useMemo";
		        updateHookTypesDev();
		        var prevDispatcher = ReactSharedInternals.H;
		        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
		        try {
		          return updateMemo(create, deps);
		        } finally {
		          ReactSharedInternals.H = prevDispatcher;
		        }
		      },
		      useReducer: function (reducer, initialArg, init) {
		        currentHookNameInDev = "useReducer";
		        updateHookTypesDev();
		        var prevDispatcher = ReactSharedInternals.H;
		        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
		        try {
		          return updateReducer(reducer, initialArg, init);
		        } finally {
		          ReactSharedInternals.H = prevDispatcher;
		        }
		      },
		      useRef: function () {
		        currentHookNameInDev = "useRef";
		        updateHookTypesDev();
		        return updateWorkInProgressHook().memoizedState;
		      },
		      useState: function () {
		        currentHookNameInDev = "useState";
		        updateHookTypesDev();
		        var prevDispatcher = ReactSharedInternals.H;
		        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
		        try {
		          return updateReducer(basicStateReducer);
		        } finally {
		          ReactSharedInternals.H = prevDispatcher;
		        }
		      },
		      useDebugValue: function () {
		        currentHookNameInDev = "useDebugValue";
		        updateHookTypesDev();
		      },
		      useDeferredValue: function (value, initialValue) {
		        currentHookNameInDev = "useDeferredValue";
		        updateHookTypesDev();
		        return updateDeferredValue(value, initialValue);
		      },
		      useTransition: function () {
		        currentHookNameInDev = "useTransition";
		        updateHookTypesDev();
		        return updateTransition();
		      },
		      useSyncExternalStore: function (
		        subscribe,
		        getSnapshot,
		        getServerSnapshot
		      ) {
		        currentHookNameInDev = "useSyncExternalStore";
		        updateHookTypesDev();
		        return updateSyncExternalStore(
		          subscribe,
		          getSnapshot,
		          getServerSnapshot
		        );
		      },
		      useId: function () {
		        currentHookNameInDev = "useId";
		        updateHookTypesDev();
		        return updateWorkInProgressHook().memoizedState;
		      },
		      useFormState: function (action) {
		        currentHookNameInDev = "useFormState";
		        updateHookTypesDev();
		        warnOnUseFormStateInDev();
		        return updateActionState(action);
		      },
		      useActionState: function (action) {
		        currentHookNameInDev = "useActionState";
		        updateHookTypesDev();
		        return updateActionState(action);
		      },
		      useOptimistic: function (passthrough, reducer) {
		        currentHookNameInDev = "useOptimistic";
		        updateHookTypesDev();
		        return updateOptimistic(passthrough, reducer);
		      },
		      useHostTransitionStatus: useHostTransitionStatus,
		      useMemoCache: useMemoCache,
		      useCacheRefresh: function () {
		        currentHookNameInDev = "useCacheRefresh";
		        updateHookTypesDev();
		        return updateWorkInProgressHook().memoizedState;
		      },
		      useEffectEvent: function (callback) {
		        currentHookNameInDev = "useEffectEvent";
		        updateHookTypesDev();
		        return updateEvent(callback);
		      }
		    };
		    HooksDispatcherOnRerenderInDEV = {
		      readContext: function (context) {
		        return readContext(context);
		      },
		      use: use,
		      useCallback: function (callback, deps) {
		        currentHookNameInDev = "useCallback";
		        updateHookTypesDev();
		        return updateCallback(callback, deps);
		      },
		      useContext: function (context) {
		        currentHookNameInDev = "useContext";
		        updateHookTypesDev();
		        return readContext(context);
		      },
		      useEffect: function (create, deps) {
		        currentHookNameInDev = "useEffect";
		        updateHookTypesDev();
		        updateEffectImpl(2048, Passive, create, deps);
		      },
		      useImperativeHandle: function (ref, create, deps) {
		        currentHookNameInDev = "useImperativeHandle";
		        updateHookTypesDev();
		        return updateImperativeHandle(ref, create, deps);
		      },
		      useInsertionEffect: function (create, deps) {
		        currentHookNameInDev = "useInsertionEffect";
		        updateHookTypesDev();
		        return updateEffectImpl(4, Insertion, create, deps);
		      },
		      useLayoutEffect: function (create, deps) {
		        currentHookNameInDev = "useLayoutEffect";
		        updateHookTypesDev();
		        return updateEffectImpl(4, Layout, create, deps);
		      },
		      useMemo: function (create, deps) {
		        currentHookNameInDev = "useMemo";
		        updateHookTypesDev();
		        var prevDispatcher = ReactSharedInternals.H;
		        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnRerenderInDEV;
		        try {
		          return updateMemo(create, deps);
		        } finally {
		          ReactSharedInternals.H = prevDispatcher;
		        }
		      },
		      useReducer: function (reducer, initialArg, init) {
		        currentHookNameInDev = "useReducer";
		        updateHookTypesDev();
		        var prevDispatcher = ReactSharedInternals.H;
		        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnRerenderInDEV;
		        try {
		          return rerenderReducer(reducer, initialArg, init);
		        } finally {
		          ReactSharedInternals.H = prevDispatcher;
		        }
		      },
		      useRef: function () {
		        currentHookNameInDev = "useRef";
		        updateHookTypesDev();
		        return updateWorkInProgressHook().memoizedState;
		      },
		      useState: function () {
		        currentHookNameInDev = "useState";
		        updateHookTypesDev();
		        var prevDispatcher = ReactSharedInternals.H;
		        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnRerenderInDEV;
		        try {
		          return rerenderReducer(basicStateReducer);
		        } finally {
		          ReactSharedInternals.H = prevDispatcher;
		        }
		      },
		      useDebugValue: function () {
		        currentHookNameInDev = "useDebugValue";
		        updateHookTypesDev();
		      },
		      useDeferredValue: function (value, initialValue) {
		        currentHookNameInDev = "useDeferredValue";
		        updateHookTypesDev();
		        return rerenderDeferredValue(value, initialValue);
		      },
		      useTransition: function () {
		        currentHookNameInDev = "useTransition";
		        updateHookTypesDev();
		        return rerenderTransition();
		      },
		      useSyncExternalStore: function (
		        subscribe,
		        getSnapshot,
		        getServerSnapshot
		      ) {
		        currentHookNameInDev = "useSyncExternalStore";
		        updateHookTypesDev();
		        return updateSyncExternalStore(
		          subscribe,
		          getSnapshot,
		          getServerSnapshot
		        );
		      },
		      useId: function () {
		        currentHookNameInDev = "useId";
		        updateHookTypesDev();
		        return updateWorkInProgressHook().memoizedState;
		      },
		      useFormState: function (action) {
		        currentHookNameInDev = "useFormState";
		        updateHookTypesDev();
		        warnOnUseFormStateInDev();
		        return rerenderActionState(action);
		      },
		      useActionState: function (action) {
		        currentHookNameInDev = "useActionState";
		        updateHookTypesDev();
		        return rerenderActionState(action);
		      },
		      useOptimistic: function (passthrough, reducer) {
		        currentHookNameInDev = "useOptimistic";
		        updateHookTypesDev();
		        return rerenderOptimistic(passthrough, reducer);
		      },
		      useHostTransitionStatus: useHostTransitionStatus,
		      useMemoCache: useMemoCache,
		      useCacheRefresh: function () {
		        currentHookNameInDev = "useCacheRefresh";
		        updateHookTypesDev();
		        return updateWorkInProgressHook().memoizedState;
		      },
		      useEffectEvent: function (callback) {
		        currentHookNameInDev = "useEffectEvent";
		        updateHookTypesDev();
		        return updateEvent(callback);
		      }
		    };
		    InvalidNestedHooksDispatcherOnMountInDEV = {
		      readContext: function (context) {
		        warnInvalidContextAccess();
		        return readContext(context);
		      },
		      use: function (usable) {
		        warnInvalidHookAccess();
		        return use(usable);
		      },
		      useCallback: function (callback, deps) {
		        currentHookNameInDev = "useCallback";
		        warnInvalidHookAccess();
		        mountHookTypesDev();
		        return mountCallback(callback, deps);
		      },
		      useContext: function (context) {
		        currentHookNameInDev = "useContext";
		        warnInvalidHookAccess();
		        mountHookTypesDev();
		        return readContext(context);
		      },
		      useEffect: function (create, deps) {
		        currentHookNameInDev = "useEffect";
		        warnInvalidHookAccess();
		        mountHookTypesDev();
		        return mountEffect(create, deps);
		      },
		      useImperativeHandle: function (ref, create, deps) {
		        currentHookNameInDev = "useImperativeHandle";
		        warnInvalidHookAccess();
		        mountHookTypesDev();
		        return mountImperativeHandle(ref, create, deps);
		      },
		      useInsertionEffect: function (create, deps) {
		        currentHookNameInDev = "useInsertionEffect";
		        warnInvalidHookAccess();
		        mountHookTypesDev();
		        mountEffectImpl(4, Insertion, create, deps);
		      },
		      useLayoutEffect: function (create, deps) {
		        currentHookNameInDev = "useLayoutEffect";
		        warnInvalidHookAccess();
		        mountHookTypesDev();
		        return mountLayoutEffect(create, deps);
		      },
		      useMemo: function (create, deps) {
		        currentHookNameInDev = "useMemo";
		        warnInvalidHookAccess();
		        mountHookTypesDev();
		        var prevDispatcher = ReactSharedInternals.H;
		        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
		        try {
		          return mountMemo(create, deps);
		        } finally {
		          ReactSharedInternals.H = prevDispatcher;
		        }
		      },
		      useReducer: function (reducer, initialArg, init) {
		        currentHookNameInDev = "useReducer";
		        warnInvalidHookAccess();
		        mountHookTypesDev();
		        var prevDispatcher = ReactSharedInternals.H;
		        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
		        try {
		          return mountReducer(reducer, initialArg, init);
		        } finally {
		          ReactSharedInternals.H = prevDispatcher;
		        }
		      },
		      useRef: function (initialValue) {
		        currentHookNameInDev = "useRef";
		        warnInvalidHookAccess();
		        mountHookTypesDev();
		        return mountRef(initialValue);
		      },
		      useState: function (initialState) {
		        currentHookNameInDev = "useState";
		        warnInvalidHookAccess();
		        mountHookTypesDev();
		        var prevDispatcher = ReactSharedInternals.H;
		        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
		        try {
		          return mountState(initialState);
		        } finally {
		          ReactSharedInternals.H = prevDispatcher;
		        }
		      },
		      useDebugValue: function () {
		        currentHookNameInDev = "useDebugValue";
		        warnInvalidHookAccess();
		        mountHookTypesDev();
		      },
		      useDeferredValue: function (value, initialValue) {
		        currentHookNameInDev = "useDeferredValue";
		        warnInvalidHookAccess();
		        mountHookTypesDev();
		        return mountDeferredValue(value, initialValue);
		      },
		      useTransition: function () {
		        currentHookNameInDev = "useTransition";
		        warnInvalidHookAccess();
		        mountHookTypesDev();
		        return mountTransition();
		      },
		      useSyncExternalStore: function (
		        subscribe,
		        getSnapshot,
		        getServerSnapshot
		      ) {
		        currentHookNameInDev = "useSyncExternalStore";
		        warnInvalidHookAccess();
		        mountHookTypesDev();
		        return mountSyncExternalStore(
		          subscribe,
		          getSnapshot,
		          getServerSnapshot
		        );
		      },
		      useId: function () {
		        currentHookNameInDev = "useId";
		        warnInvalidHookAccess();
		        mountHookTypesDev();
		        return mountId();
		      },
		      useFormState: function (action, initialState) {
		        currentHookNameInDev = "useFormState";
		        warnInvalidHookAccess();
		        mountHookTypesDev();
		        return mountActionState(action, initialState);
		      },
		      useActionState: function (action, initialState) {
		        currentHookNameInDev = "useActionState";
		        warnInvalidHookAccess();
		        mountHookTypesDev();
		        return mountActionState(action, initialState);
		      },
		      useOptimistic: function (passthrough) {
		        currentHookNameInDev = "useOptimistic";
		        warnInvalidHookAccess();
		        mountHookTypesDev();
		        return mountOptimistic(passthrough);
		      },
		      useMemoCache: function (size) {
		        warnInvalidHookAccess();
		        return useMemoCache(size);
		      },
		      useHostTransitionStatus: useHostTransitionStatus,
		      useCacheRefresh: function () {
		        currentHookNameInDev = "useCacheRefresh";
		        mountHookTypesDev();
		        return mountRefresh();
		      },
		      useEffectEvent: function (callback) {
		        currentHookNameInDev = "useEffectEvent";
		        warnInvalidHookAccess();
		        mountHookTypesDev();
		        return mountEvent(callback);
		      }
		    };
		    InvalidNestedHooksDispatcherOnUpdateInDEV = {
		      readContext: function (context) {
		        warnInvalidContextAccess();
		        return readContext(context);
		      },
		      use: function (usable) {
		        warnInvalidHookAccess();
		        return use(usable);
		      },
		      useCallback: function (callback, deps) {
		        currentHookNameInDev = "useCallback";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        return updateCallback(callback, deps);
		      },
		      useContext: function (context) {
		        currentHookNameInDev = "useContext";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        return readContext(context);
		      },
		      useEffect: function (create, deps) {
		        currentHookNameInDev = "useEffect";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        updateEffectImpl(2048, Passive, create, deps);
		      },
		      useImperativeHandle: function (ref, create, deps) {
		        currentHookNameInDev = "useImperativeHandle";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        return updateImperativeHandle(ref, create, deps);
		      },
		      useInsertionEffect: function (create, deps) {
		        currentHookNameInDev = "useInsertionEffect";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        return updateEffectImpl(4, Insertion, create, deps);
		      },
		      useLayoutEffect: function (create, deps) {
		        currentHookNameInDev = "useLayoutEffect";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        return updateEffectImpl(4, Layout, create, deps);
		      },
		      useMemo: function (create, deps) {
		        currentHookNameInDev = "useMemo";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        var prevDispatcher = ReactSharedInternals.H;
		        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
		        try {
		          return updateMemo(create, deps);
		        } finally {
		          ReactSharedInternals.H = prevDispatcher;
		        }
		      },
		      useReducer: function (reducer, initialArg, init) {
		        currentHookNameInDev = "useReducer";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        var prevDispatcher = ReactSharedInternals.H;
		        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
		        try {
		          return updateReducer(reducer, initialArg, init);
		        } finally {
		          ReactSharedInternals.H = prevDispatcher;
		        }
		      },
		      useRef: function () {
		        currentHookNameInDev = "useRef";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        return updateWorkInProgressHook().memoizedState;
		      },
		      useState: function () {
		        currentHookNameInDev = "useState";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        var prevDispatcher = ReactSharedInternals.H;
		        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
		        try {
		          return updateReducer(basicStateReducer);
		        } finally {
		          ReactSharedInternals.H = prevDispatcher;
		        }
		      },
		      useDebugValue: function () {
		        currentHookNameInDev = "useDebugValue";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		      },
		      useDeferredValue: function (value, initialValue) {
		        currentHookNameInDev = "useDeferredValue";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        return updateDeferredValue(value, initialValue);
		      },
		      useTransition: function () {
		        currentHookNameInDev = "useTransition";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        return updateTransition();
		      },
		      useSyncExternalStore: function (
		        subscribe,
		        getSnapshot,
		        getServerSnapshot
		      ) {
		        currentHookNameInDev = "useSyncExternalStore";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        return updateSyncExternalStore(
		          subscribe,
		          getSnapshot,
		          getServerSnapshot
		        );
		      },
		      useId: function () {
		        currentHookNameInDev = "useId";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        return updateWorkInProgressHook().memoizedState;
		      },
		      useFormState: function (action) {
		        currentHookNameInDev = "useFormState";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        return updateActionState(action);
		      },
		      useActionState: function (action) {
		        currentHookNameInDev = "useActionState";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        return updateActionState(action);
		      },
		      useOptimistic: function (passthrough, reducer) {
		        currentHookNameInDev = "useOptimistic";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        return updateOptimistic(passthrough, reducer);
		      },
		      useMemoCache: function (size) {
		        warnInvalidHookAccess();
		        return useMemoCache(size);
		      },
		      useHostTransitionStatus: useHostTransitionStatus,
		      useCacheRefresh: function () {
		        currentHookNameInDev = "useCacheRefresh";
		        updateHookTypesDev();
		        return updateWorkInProgressHook().memoizedState;
		      },
		      useEffectEvent: function (callback) {
		        currentHookNameInDev = "useEffectEvent";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        return updateEvent(callback);
		      }
		    };
		    InvalidNestedHooksDispatcherOnRerenderInDEV = {
		      readContext: function (context) {
		        warnInvalidContextAccess();
		        return readContext(context);
		      },
		      use: function (usable) {
		        warnInvalidHookAccess();
		        return use(usable);
		      },
		      useCallback: function (callback, deps) {
		        currentHookNameInDev = "useCallback";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        return updateCallback(callback, deps);
		      },
		      useContext: function (context) {
		        currentHookNameInDev = "useContext";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        return readContext(context);
		      },
		      useEffect: function (create, deps) {
		        currentHookNameInDev = "useEffect";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        updateEffectImpl(2048, Passive, create, deps);
		      },
		      useImperativeHandle: function (ref, create, deps) {
		        currentHookNameInDev = "useImperativeHandle";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        return updateImperativeHandle(ref, create, deps);
		      },
		      useInsertionEffect: function (create, deps) {
		        currentHookNameInDev = "useInsertionEffect";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        return updateEffectImpl(4, Insertion, create, deps);
		      },
		      useLayoutEffect: function (create, deps) {
		        currentHookNameInDev = "useLayoutEffect";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        return updateEffectImpl(4, Layout, create, deps);
		      },
		      useMemo: function (create, deps) {
		        currentHookNameInDev = "useMemo";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        var prevDispatcher = ReactSharedInternals.H;
		        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
		        try {
		          return updateMemo(create, deps);
		        } finally {
		          ReactSharedInternals.H = prevDispatcher;
		        }
		      },
		      useReducer: function (reducer, initialArg, init) {
		        currentHookNameInDev = "useReducer";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        var prevDispatcher = ReactSharedInternals.H;
		        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
		        try {
		          return rerenderReducer(reducer, initialArg, init);
		        } finally {
		          ReactSharedInternals.H = prevDispatcher;
		        }
		      },
		      useRef: function () {
		        currentHookNameInDev = "useRef";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        return updateWorkInProgressHook().memoizedState;
		      },
		      useState: function () {
		        currentHookNameInDev = "useState";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        var prevDispatcher = ReactSharedInternals.H;
		        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
		        try {
		          return rerenderReducer(basicStateReducer);
		        } finally {
		          ReactSharedInternals.H = prevDispatcher;
		        }
		      },
		      useDebugValue: function () {
		        currentHookNameInDev = "useDebugValue";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		      },
		      useDeferredValue: function (value, initialValue) {
		        currentHookNameInDev = "useDeferredValue";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        return rerenderDeferredValue(value, initialValue);
		      },
		      useTransition: function () {
		        currentHookNameInDev = "useTransition";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        return rerenderTransition();
		      },
		      useSyncExternalStore: function (
		        subscribe,
		        getSnapshot,
		        getServerSnapshot
		      ) {
		        currentHookNameInDev = "useSyncExternalStore";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        return updateSyncExternalStore(
		          subscribe,
		          getSnapshot,
		          getServerSnapshot
		        );
		      },
		      useId: function () {
		        currentHookNameInDev = "useId";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        return updateWorkInProgressHook().memoizedState;
		      },
		      useFormState: function (action) {
		        currentHookNameInDev = "useFormState";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        return rerenderActionState(action);
		      },
		      useActionState: function (action) {
		        currentHookNameInDev = "useActionState";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        return rerenderActionState(action);
		      },
		      useOptimistic: function (passthrough, reducer) {
		        currentHookNameInDev = "useOptimistic";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        return rerenderOptimistic(passthrough, reducer);
		      },
		      useMemoCache: function (size) {
		        warnInvalidHookAccess();
		        return useMemoCache(size);
		      },
		      useHostTransitionStatus: useHostTransitionStatus,
		      useCacheRefresh: function () {
		        currentHookNameInDev = "useCacheRefresh";
		        updateHookTypesDev();
		        return updateWorkInProgressHook().memoizedState;
		      },
		      useEffectEvent: function (callback) {
		        currentHookNameInDev = "useEffectEvent";
		        warnInvalidHookAccess();
		        updateHookTypesDev();
		        return updateEvent(callback);
		      }
		    };
		    var fakeInternalInstance = {};
		    var didWarnAboutStateAssignmentForComponent = new Set();
		    var didWarnAboutUninitializedState = new Set();
		    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
		    var didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
		    var didWarnAboutDirectlyAssigningPropsToState = new Set();
		    var didWarnAboutUndefinedDerivedState = new Set();
		    var didWarnAboutContextTypes$1 = new Set();
		    var didWarnAboutChildContextTypes = new Set();
		    var didWarnAboutInvalidateContextType = new Set();
		    var didWarnOnInvalidCallback = new Set();
		    Object.freeze(fakeInternalInstance);
		    var classComponentUpdater = {
		        enqueueSetState: function (inst, payload, callback) {
		          inst = inst._reactInternals;
		          var lane = requestUpdateLane(inst),
		            update = createUpdate(lane);
		          update.payload = payload;
		          void 0 !== callback &&
		            null !== callback &&
		            (warnOnInvalidCallback(callback), (update.callback = callback));
		          payload = enqueueUpdate(inst, update, lane);
		          null !== payload &&
		            (startUpdateTimerByLane(lane, "this.setState()", inst),
		            scheduleUpdateOnFiber(payload, inst, lane),
		            entangleTransitions(payload, inst, lane));
		        },
		        enqueueReplaceState: function (inst, payload, callback) {
		          inst = inst._reactInternals;
		          var lane = requestUpdateLane(inst),
		            update = createUpdate(lane);
		          update.tag = ReplaceState;
		          update.payload = payload;
		          void 0 !== callback &&
		            null !== callback &&
		            (warnOnInvalidCallback(callback), (update.callback = callback));
		          payload = enqueueUpdate(inst, update, lane);
		          null !== payload &&
		            (startUpdateTimerByLane(lane, "this.replaceState()", inst),
		            scheduleUpdateOnFiber(payload, inst, lane),
		            entangleTransitions(payload, inst, lane));
		        },
		        enqueueForceUpdate: function (inst, callback) {
		          inst = inst._reactInternals;
		          var lane = requestUpdateLane(inst),
		            update = createUpdate(lane);
		          update.tag = ForceUpdate;
		          void 0 !== callback &&
		            null !== callback &&
		            (warnOnInvalidCallback(callback), (update.callback = callback));
		          callback = enqueueUpdate(inst, update, lane);
		          null !== callback &&
		            (startUpdateTimerByLane(lane, "this.forceUpdate()", inst),
		            scheduleUpdateOnFiber(callback, inst, lane),
		            entangleTransitions(callback, inst, lane));
		        }
		      },
		      componentName = null,
		      errorBoundaryName = null,
		      SelectiveHydrationException = Error(
		        "This is not a real error. It's an implementation detail of React's selective hydration feature. If this leaks into userspace, it's a bug in React. Please file an issue."
		      ),
		      didReceiveUpdate = false;
		    var didWarnAboutBadClass = {};
		    var didWarnAboutContextTypeOnFunctionComponent = {};
		    var didWarnAboutContextTypes = {};
		    var didWarnAboutGetDerivedStateOnFunctionComponent = {};
		    var didWarnAboutReassigningProps = false;
		    var didWarnAboutRevealOrder = {};
		    var didWarnAboutTailOptions = {};
		    var SUSPENDED_MARKER = {
		        dehydrated: null,
		        treeContext: null,
		        retryLane: 0,
		        hydrationErrors: null
		      },
		      hasWarnedAboutUsingNoValuePropOnContextProvider = false,
		      didWarnAboutUndefinedSnapshotBeforeUpdate = null;
		    didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
		    var offscreenSubtreeIsHidden = false,
		      offscreenSubtreeWasHidden = false,
		      needsFormReset = false,
		      PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set,
		      nextEffect = null,
		      inProgressLanes = null,
		      inProgressRoot = null,
		      hostParent = null,
		      hostParentIsContainer = false,
		      currentHoistableRoot = null,
		      inHydratedSubtree = false,
		      suspenseyCommitFlag = 8192,
		      DefaultAsyncDispatcher = {
		        getCacheForType: function (resourceType) {
		          var cache = readContext(CacheContext),
		            cacheForType = cache.data.get(resourceType);
		          void 0 === cacheForType &&
		            ((cacheForType = resourceType()),
		            cache.data.set(resourceType, cacheForType));
		          return cacheForType;
		        },
		        cacheSignal: function () {
		          return readContext(CacheContext).controller.signal;
		        },
		        getOwner: function () {
		          return current;
		        }
		      },
		      COMPONENT_TYPE = 0,
		      HAS_PSEUDO_CLASS_TYPE = 1,
		      ROLE_TYPE = 2,
		      TEST_NAME_TYPE = 3,
		      TEXT_TYPE = 4;
		    if ("function" === typeof Symbol && Symbol.for) {
		      var symbolFor = Symbol.for;
		      COMPONENT_TYPE = symbolFor("selector.component");
		      HAS_PSEUDO_CLASS_TYPE = symbolFor("selector.has_pseudo_class");
		      ROLE_TYPE = symbolFor("selector.role");
		      TEST_NAME_TYPE = symbolFor("selector.test_id");
		      TEXT_TYPE = symbolFor("selector.text");
		    }
		    var commitHooks = [],
		      PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map,
		      NoContext = 0,
		      RenderContext = 2,
		      CommitContext = 4,
		      RootInProgress = 0,
		      RootFatalErrored = 1,
		      RootErrored = 2,
		      RootSuspended = 3,
		      RootSuspendedWithDelay = 4,
		      RootSuspendedAtTheShell = 6,
		      RootCompleted = 5,
		      executionContext = NoContext,
		      workInProgressRoot = null,
		      workInProgress = null,
		      workInProgressRootRenderLanes = 0,
		      NotSuspended = 0,
		      SuspendedOnError = 1,
		      SuspendedOnData = 2,
		      SuspendedOnImmediate = 3,
		      SuspendedOnInstance = 4,
		      SuspendedOnInstanceAndReadyToContinue = 5,
		      SuspendedOnDeprecatedThrowPromise = 6,
		      SuspendedAndReadyToContinue = 7,
		      SuspendedOnHydration = 8,
		      SuspendedOnAction = 9,
		      workInProgressSuspendedReason = NotSuspended,
		      workInProgressThrownValue = null,
		      workInProgressRootDidSkipSuspendedSiblings = false,
		      workInProgressRootIsPrerendering = false,
		      workInProgressRootDidAttachPingListener = false,
		      entangledRenderLanes = 0,
		      workInProgressRootExitStatus = RootInProgress,
		      workInProgressRootSkippedLanes = 0,
		      workInProgressRootInterleavedUpdatedLanes = 0,
		      workInProgressRootPingedLanes = 0,
		      workInProgressDeferredLane = 0,
		      workInProgressSuspendedRetryLanes = 0,
		      workInProgressRootConcurrentErrors = null,
		      workInProgressRootRecoverableErrors = null,
		      workInProgressRootDidIncludeRecursiveRenderUpdate = false,
		      globalMostRecentFallbackTime = 0,
		      globalMostRecentTransitionTime = 0,
		      FALLBACK_THROTTLE_MS = 300,
		      workInProgressRootRenderTargetTime = Infinity,
		      RENDER_TIMEOUT_MS = 500,
		      workInProgressTransitions = null,
		      workInProgressUpdateTask = null,
		      legacyErrorBoundariesThatAlreadyFailed = null,
		      IMMEDIATE_COMMIT = 0,
		      ABORTED_VIEW_TRANSITION_COMMIT = 1,
		      DELAYED_PASSIVE_COMMIT = 2,
		      ANIMATION_STARTED_COMMIT = 3,
		      NO_PENDING_EFFECTS = 0,
		      PENDING_MUTATION_PHASE = 1,
		      PENDING_LAYOUT_PHASE = 2,
		      PENDING_AFTER_MUTATION_PHASE = 3,
		      PENDING_SPAWNED_WORK = 4,
		      PENDING_PASSIVE_PHASE = 5,
		      pendingEffectsStatus = 0,
		      pendingEffectsRoot = null,
		      pendingFinishedWork = null,
		      pendingEffectsLanes = 0,
		      pendingEffectsRemainingLanes = 0,
		      pendingEffectsRenderEndTime = -0,
		      pendingPassiveTransitions = null,
		      pendingRecoverableErrors = null,
		      pendingSuspendedCommitReason = null,
		      pendingDelayedCommitReason = IMMEDIATE_COMMIT,
		      pendingSuspendedViewTransitionReason = null,
		      NESTED_UPDATE_LIMIT = 50,
		      nestedUpdateCount = 0,
		      rootWithNestedUpdates = null,
		      isFlushingPassiveEffects = false,
		      didScheduleUpdateDuringPassiveEffects = false,
		      NESTED_PASSIVE_UPDATE_LIMIT = 50,
		      nestedPassiveUpdateCount = 0,
		      rootWithPassiveNestedUpdates = null,
		      isRunningInsertionEffect = false,
		      didWarnStateUpdateForNotYetMountedComponent = null,
		      didWarnAboutUpdateInRender = false;
		    var didWarnAboutUpdateInRenderForAnotherComponent = new Set();
		    var fakeActCallbackNode = {},
		      resolveFamily = null,
		      failedBoundaries = null;
		    var hasBadMapPolyfill = false;
		    try {
		      var nonExtensibleObject = Object.preventExtensions({});
		      new Map([[nonExtensibleObject, null]]);
		      new Set([nonExtensibleObject]);
		    } catch (e) {
		      hasBadMapPolyfill = true;
		    }
		    var didWarnAboutNestedUpdates = false;
		    var didWarnAboutFindNodeInStrictMode = {};
		    var overrideHookState = null,
		      overrideHookStateDeletePath = null,
		      overrideHookStateRenamePath = null,
		      overrideProps = null,
		      overridePropsDeletePath = null,
		      overridePropsRenamePath = null,
		      scheduleUpdate = null,
		      scheduleRetry = null,
		      setErrorHandler = null,
		      setSuspenseHandler = null;
		    overrideHookState = function (fiber, id, path, value) {
		      id = findHook(fiber, id);
		      null !== id &&
		        ((path = copyWithSetImpl(id.memoizedState, path, 0, value)),
		        (id.memoizedState = path),
		        (id.baseState = path),
		        (fiber.memoizedProps = assign({}, fiber.memoizedProps)),
		        (path = enqueueConcurrentRenderForLane(fiber, 2)),
		        null !== path && scheduleUpdateOnFiber(path, fiber, 2));
		    };
		    overrideHookStateDeletePath = function (fiber, id, path) {
		      id = findHook(fiber, id);
		      null !== id &&
		        ((path = copyWithDeleteImpl(id.memoizedState, path, 0)),
		        (id.memoizedState = path),
		        (id.baseState = path),
		        (fiber.memoizedProps = assign({}, fiber.memoizedProps)),
		        (path = enqueueConcurrentRenderForLane(fiber, 2)),
		        null !== path && scheduleUpdateOnFiber(path, fiber, 2));
		    };
		    overrideHookStateRenamePath = function (fiber, id, oldPath, newPath) {
		      id = findHook(fiber, id);
		      null !== id &&
		        ((oldPath = copyWithRename(id.memoizedState, oldPath, newPath)),
		        (id.memoizedState = oldPath),
		        (id.baseState = oldPath),
		        (fiber.memoizedProps = assign({}, fiber.memoizedProps)),
		        (oldPath = enqueueConcurrentRenderForLane(fiber, 2)),
		        null !== oldPath && scheduleUpdateOnFiber(oldPath, fiber, 2));
		    };
		    overrideProps = function (fiber, path, value) {
		      fiber.pendingProps = copyWithSetImpl(fiber.memoizedProps, path, 0, value);
		      fiber.alternate && (fiber.alternate.pendingProps = fiber.pendingProps);
		      path = enqueueConcurrentRenderForLane(fiber, 2);
		      null !== path && scheduleUpdateOnFiber(path, fiber, 2);
		    };
		    overridePropsDeletePath = function (fiber, path) {
		      fiber.pendingProps = copyWithDeleteImpl(fiber.memoizedProps, path, 0);
		      fiber.alternate && (fiber.alternate.pendingProps = fiber.pendingProps);
		      path = enqueueConcurrentRenderForLane(fiber, 2);
		      null !== path && scheduleUpdateOnFiber(path, fiber, 2);
		    };
		    overridePropsRenamePath = function (fiber, oldPath, newPath) {
		      fiber.pendingProps = copyWithRename(
		        fiber.memoizedProps,
		        oldPath,
		        newPath
		      );
		      fiber.alternate && (fiber.alternate.pendingProps = fiber.pendingProps);
		      oldPath = enqueueConcurrentRenderForLane(fiber, 2);
		      null !== oldPath && scheduleUpdateOnFiber(oldPath, fiber, 2);
		    };
		    scheduleUpdate = function (fiber) {
		      var root = enqueueConcurrentRenderForLane(fiber, 2);
		      null !== root && scheduleUpdateOnFiber(root, fiber, 2);
		    };
		    scheduleRetry = function (fiber) {
		      var lane = claimNextRetryLane(),
		        root = enqueueConcurrentRenderForLane(fiber, lane);
		      null !== root && scheduleUpdateOnFiber(root, fiber, lane);
		    };
		    setErrorHandler = function (newShouldErrorImpl) {
		      shouldErrorImpl = newShouldErrorImpl;
		    };
		    setSuspenseHandler = function (newShouldSuspendImpl) {
		      shouldSuspendImpl = newShouldSuspendImpl;
		    };
		    exports$1.attemptContinuousHydration = function (fiber) {
		      if (13 === fiber.tag || 31 === fiber.tag) {
		        var root = enqueueConcurrentRenderForLane(fiber, 67108864);
		        null !== root && scheduleUpdateOnFiber(root, fiber, 67108864);
		        markRetryLaneIfNotHydrated(fiber, 67108864);
		      }
		    };
		    exports$1.attemptHydrationAtCurrentPriority = function (fiber) {
		      if (13 === fiber.tag || 31 === fiber.tag) {
		        var lane = requestUpdateLane(fiber);
		        lane = getBumpedLaneForHydrationByLane(lane);
		        var root = enqueueConcurrentRenderForLane(fiber, lane);
		        null !== root && scheduleUpdateOnFiber(root, fiber, lane);
		        markRetryLaneIfNotHydrated(fiber, lane);
		      }
		    };
		    exports$1.attemptSynchronousHydration = function (fiber) {
		      switch (fiber.tag) {
		        case 3:
		          fiber = fiber.stateNode;
		          if (fiber.current.memoizedState.isDehydrated) {
		            var lanes = getHighestPriorityLanes(fiber.pendingLanes);
		            if (0 !== lanes) {
		              fiber.pendingLanes |= 2;
		              for (fiber.entangledLanes |= 2; lanes; ) {
		                var lane = 1 << (31 - clz32(lanes));
		                fiber.entanglements[1] |= lane;
		                lanes &= ~lane;
		              }
		              ensureRootIsScheduled(fiber);
		              (executionContext & (RenderContext | CommitContext)) ===
		                NoContext &&
		                ((workInProgressRootRenderTargetTime =
		                  now$1() + RENDER_TIMEOUT_MS),
		                flushSyncWorkAcrossRoots_impl(0));
		            }
		          }
		          break;
		        case 31:
		        case 13:
		          (lanes = enqueueConcurrentRenderForLane(fiber, 2)),
		            null !== lanes && scheduleUpdateOnFiber(lanes, fiber, 2),
		            flushSyncWork(),
		            markRetryLaneIfNotHydrated(fiber, 2);
		      }
		    };
		    exports$1.batchedUpdates = function (fn, a) {
		      return fn(a);
		    };
		    exports$1.createComponentSelector = function (component) {
		      return { $$typeof: COMPONENT_TYPE, value: component };
		    };
		    exports$1.createContainer = function (
		      containerInfo,
		      tag,
		      hydrationCallbacks,
		      isStrictMode,
		      concurrentUpdatesByDefaultOverride,
		      identifierPrefix,
		      onUncaughtError,
		      onCaughtError,
		      onRecoverableError,
		      onDefaultTransitionIndicator
		    ) {
		      return createFiberRoot(
		        containerInfo,
		        tag,
		        false,
		        null,
		        hydrationCallbacks,
		        isStrictMode,
		        identifierPrefix,
		        null,
		        onUncaughtError,
		        onCaughtError,
		        onRecoverableError,
		        onDefaultTransitionIndicator
		      );
		    };
		    exports$1.createHasPseudoClassSelector = function (selectors) {
		      return { $$typeof: HAS_PSEUDO_CLASS_TYPE, value: selectors };
		    };
		    exports$1.createHydrationContainer = function (
		      initialChildren,
		      callback,
		      containerInfo,
		      tag,
		      hydrationCallbacks,
		      isStrictMode,
		      concurrentUpdatesByDefaultOverride,
		      identifierPrefix,
		      onUncaughtError,
		      onCaughtError,
		      onRecoverableError,
		      onDefaultTransitionIndicator,
		      transitionCallbacks,
		      formState
		    ) {
		      initialChildren = createFiberRoot(
		        containerInfo,
		        tag,
		        true,
		        initialChildren,
		        hydrationCallbacks,
		        isStrictMode,
		        identifierPrefix,
		        formState,
		        onUncaughtError,
		        onCaughtError,
		        onRecoverableError,
		        onDefaultTransitionIndicator
		      );
		      initialChildren.context = getContextForSubtree(null);
		      containerInfo = initialChildren.current;
		      tag = requestUpdateLane(containerInfo);
		      tag = getBumpedLaneForHydrationByLane(tag);
		      hydrationCallbacks = createUpdate(tag);
		      hydrationCallbacks.callback =
		        void 0 !== callback && null !== callback ? callback : null;
		      enqueueUpdate(containerInfo, hydrationCallbacks, tag);
		      startUpdateTimerByLane(tag, "hydrateRoot()", null);
		      callback = tag;
		      initialChildren.current.lanes = callback;
		      markRootUpdated$1(initialChildren, callback);
		      ensureRootIsScheduled(initialChildren);
		      return initialChildren;
		    };
		    exports$1.createPortal = function (children, containerInfo, implementation) {
		      var key =
		        3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
		      try {
		        testStringCoercion(key);
		        var JSCompiler_inline_result = !1;
		      } catch (e$6) {
		        JSCompiler_inline_result = true;
		      }
		      JSCompiler_inline_result &&
		        (console.error(
		          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
		          ("function" === typeof Symbol &&
		            Symbol.toStringTag &&
		            key[Symbol.toStringTag]) ||
		            key.constructor.name ||
		            "Object"
		        ),
		        testStringCoercion(key));
		      return {
		        $$typeof: REACT_PORTAL_TYPE,
		        key: null == key ? null : "" + key,
		        children: children,
		        containerInfo: containerInfo,
		        implementation: implementation
		      };
		    };
		    exports$1.createRoleSelector = function (role) {
		      return { $$typeof: ROLE_TYPE, value: role };
		    };
		    exports$1.createTestNameSelector = function (id) {
		      return { $$typeof: TEST_NAME_TYPE, value: id };
		    };
		    exports$1.createTextSelector = function (text) {
		      return { $$typeof: TEXT_TYPE, value: text };
		    };
		    exports$1.defaultOnCaughtError = function (error) {
		      var componentNameMessage = componentName
		          ? "The above error occurred in the <" + componentName + "> component."
		          : "The above error occurred in one of your React components.",
		        recreateMessage =
		          "React will try to recreate this component tree from scratch using the error boundary you provided, " +
		          ((errorBoundaryName || "Anonymous") + ".");
		      "object" === typeof error &&
		      null !== error &&
		      "string" === typeof error.environmentName
		        ? bindToConsole(
		            "error",
		            ["%o\n\n%s\n\n%s\n", error, componentNameMessage, recreateMessage],
		            error.environmentName
		          )()
		        : console.error(
		            "%o\n\n%s\n\n%s\n",
		            error,
		            componentNameMessage,
		            recreateMessage
		          );
		    };
		    exports$1.defaultOnRecoverableError = function (error) {
		      reportGlobalError(error);
		    };
		    exports$1.defaultOnUncaughtError = function (error) {
		      reportGlobalError(error);
		      console.warn(
		        "%s\n\n%s\n",
		        componentName
		          ? "An error occurred in the <" + componentName + "> component."
		          : "An error occurred in one of your React components.",
		        "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://react.dev/link/error-boundaries to learn more about error boundaries."
		      );
		    };
		    exports$1.deferredUpdates = function (fn) {
		      var prevTransition = ReactSharedInternals.T,
		        previousPriority = getCurrentUpdatePriority();
		      try {
		        return (
		          setCurrentUpdatePriority(32), (ReactSharedInternals.T = null), fn()
		        );
		      } finally {
		        setCurrentUpdatePriority(previousPriority),
		          (ReactSharedInternals.T = prevTransition);
		      }
		    };
		    exports$1.discreteUpdates = function (fn, a, b, c, d) {
		      var prevTransition = ReactSharedInternals.T,
		        previousPriority = getCurrentUpdatePriority();
		      try {
		        return (
		          setCurrentUpdatePriority(2),
		          (ReactSharedInternals.T = null),
		          fn(a, b, c, d)
		        );
		      } finally {
		        setCurrentUpdatePriority(previousPriority),
		          (ReactSharedInternals.T = prevTransition),
		          executionContext === NoContext &&
		            (workInProgressRootRenderTargetTime = now$1() + RENDER_TIMEOUT_MS);
		      }
		    };
		    exports$1.findAllNodes = findAllNodes;
		    exports$1.findBoundingRects = function (hostRoot, selectors) {
		      if (!supportsTestSelectors)
		        throw Error("Test selector API is not supported by this renderer.");
		      selectors = findAllNodes(hostRoot, selectors);
		      hostRoot = [];
		      for (var i = 0; i < selectors.length; i++)
		        hostRoot.push(getBoundingRect(selectors[i]));
		      for (selectors = hostRoot.length - 1; 0 < selectors; selectors--) {
		        i = hostRoot[selectors];
		        for (
		          var targetLeft = i.x,
		            targetRight = targetLeft + i.width,
		            targetTop = i.y,
		            targetBottom = targetTop + i.height,
		            j = selectors - 1;
		          0 <= j;
		          j--
		        )
		          if (selectors !== j) {
		            var otherRect = hostRoot[j],
		              otherLeft = otherRect.x,
		              otherRight = otherLeft + otherRect.width,
		              otherTop = otherRect.y,
		              otherBottom = otherTop + otherRect.height;
		            if (
		              targetLeft >= otherLeft &&
		              targetTop >= otherTop &&
		              targetRight <= otherRight &&
		              targetBottom <= otherBottom
		            ) {
		              hostRoot.splice(selectors, 1);
		              break;
		            } else if (
		              !(
		                targetLeft !== otherLeft ||
		                i.width !== otherRect.width ||
		                otherBottom < targetTop ||
		                otherTop > targetBottom
		              )
		            ) {
		              otherTop > targetTop &&
		                ((otherRect.height += otherTop - targetTop),
		                (otherRect.y = targetTop));
		              otherBottom < targetBottom &&
		                (otherRect.height = targetBottom - otherTop);
		              hostRoot.splice(selectors, 1);
		              break;
		            } else if (
		              !(
		                targetTop !== otherTop ||
		                i.height !== otherRect.height ||
		                otherRight < targetLeft ||
		                otherLeft > targetRight
		              )
		            ) {
		              otherLeft > targetLeft &&
		                ((otherRect.width += otherLeft - targetLeft),
		                (otherRect.x = targetLeft));
		              otherRight < targetRight &&
		                (otherRect.width = targetRight - otherLeft);
		              hostRoot.splice(selectors, 1);
		              break;
		            }
		          }
		      }
		      return hostRoot;
		    };
		    exports$1.findHostInstance = function (component) {
		      var fiber = component._reactInternals;
		      if (void 0 === fiber) {
		        if ("function" === typeof component.render)
		          throw Error("Unable to find node on an unmounted component.");
		        component = Object.keys(component).join(",");
		        throw Error(
		          "Argument appears to not be a ReactComponent. Keys: " + component
		        );
		      }
		      component = findCurrentHostFiber(fiber);
		      return null === component ? null : getPublicInstance(component.stateNode);
		    };
		    exports$1.findHostInstanceWithNoPortals = function (fiber) {
		      fiber = findCurrentFiberUsingSlowPath(fiber);
		      fiber =
		        null !== fiber ? findCurrentHostFiberWithNoPortalsImpl(fiber) : null;
		      return null === fiber ? null : getPublicInstance(fiber.stateNode);
		    };
		    exports$1.findHostInstanceWithWarning = function (component, methodName) {
		      var fiber = component._reactInternals;
		      if (void 0 === fiber) {
		        if ("function" === typeof component.render)
		          throw Error("Unable to find node on an unmounted component.");
		        component = Object.keys(component).join(",");
		        throw Error(
		          "Argument appears to not be a ReactComponent. Keys: " + component
		        );
		      }
		      component = findCurrentHostFiber(fiber);
		      if (null === component) return null;
		      if (component.mode & 8) {
		        var componentName = getComponentNameFromFiber(fiber) || "Component";
		        didWarnAboutFindNodeInStrictMode[componentName] ||
		          ((didWarnAboutFindNodeInStrictMode[componentName] = true),
		          runWithFiberInDEV(component, function () {
		            fiber.mode & 8
		              ? console.error(
		                  "%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://react.dev/link/strict-mode-find-node",
		                  methodName,
		                  methodName,
		                  componentName
		                )
		              : console.error(
		                  "%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://react.dev/link/strict-mode-find-node",
		                  methodName,
		                  methodName,
		                  componentName
		                );
		          }));
		      }
		      return getPublicInstance(component.stateNode);
		    };
		    exports$1.flushPassiveEffects = flushPendingEffects;
		    exports$1.flushSyncFromReconciler = function (fn) {
		      var prevExecutionContext = executionContext;
		      executionContext |= 1;
		      var prevTransition = ReactSharedInternals.T,
		        previousPriority = getCurrentUpdatePriority();
		      try {
		        if ((setCurrentUpdatePriority(2), (ReactSharedInternals.T = null), fn))
		          return fn();
		      } finally {
		        setCurrentUpdatePriority(previousPriority),
		          (ReactSharedInternals.T = prevTransition),
		          (executionContext = prevExecutionContext),
		          (executionContext & (RenderContext | CommitContext)) === NoContext &&
		            flushSyncWorkAcrossRoots_impl(0);
		      }
		    };
		    exports$1.flushSyncWork = flushSyncWork;
		    exports$1.focusWithin = function (hostRoot, selectors) {
		      if (!supportsTestSelectors)
		        throw Error("Test selector API is not supported by this renderer.");
		      hostRoot = findFiberRootForHostRoot(hostRoot);
		      selectors = findPaths(hostRoot, selectors);
		      selectors = Array.from(selectors);
		      for (hostRoot = 0; hostRoot < selectors.length; ) {
		        var fiber = selectors[hostRoot++],
		          tag = fiber.tag;
		        if (!isHiddenSubtree(fiber)) {
		          if (
		            (5 === tag || 26 === tag || 27 === tag) &&
		            setFocusIfFocusable(fiber.stateNode)
		          )
		            return true;
		          for (fiber = fiber.child; null !== fiber; )
		            selectors.push(fiber), (fiber = fiber.sibling);
		        }
		      }
		      return false;
		    };
		    exports$1.getFindAllNodesFailureDescription = function (hostRoot, selectors) {
		      if (!supportsTestSelectors)
		        throw Error("Test selector API is not supported by this renderer.");
		      var maxSelectorIndex = 0,
		        matchedNames = [];
		      hostRoot = [findFiberRootForHostRoot(hostRoot), 0];
		      for (var index = 0; index < hostRoot.length; ) {
		        var fiber = hostRoot[index++],
		          tag = fiber.tag,
		          selectorIndex = hostRoot[index++],
		          selector = selectors[selectorIndex];
		        if ((5 !== tag && 26 !== tag && 27 !== tag) || !isHiddenSubtree(fiber))
		          if (
		            (matchSelector(fiber, selector) &&
		              (matchedNames.push(selectorToString(selector)),
		              selectorIndex++,
		              selectorIndex > maxSelectorIndex &&
		                (maxSelectorIndex = selectorIndex)),
		            selectorIndex < selectors.length)
		          )
		            for (fiber = fiber.child; null !== fiber; )
		              hostRoot.push(fiber, selectorIndex), (fiber = fiber.sibling);
		      }
		      if (maxSelectorIndex < selectors.length) {
		        for (
		          hostRoot = [];
		          maxSelectorIndex < selectors.length;
		          maxSelectorIndex++
		        )
		          hostRoot.push(selectorToString(selectors[maxSelectorIndex]));
		        return (
		          "findAllNodes was able to match part of the selector:\n  " +
		          (matchedNames.join(" > ") +
		            "\n\nNo matching component was found for:\n  ") +
		          hostRoot.join(" > ")
		        );
		      }
		      return null;
		    };
		    exports$1.getPublicRootInstance = function (container) {
		      container = container.current;
		      if (!container.child) return null;
		      switch (container.child.tag) {
		        case 27:
		        case 5:
		          return getPublicInstance(container.child.stateNode);
		        default:
		          return container.child.stateNode;
		      }
		    };
		    exports$1.injectIntoDevTools = function () {
		      var internals = {
		        bundleType: 1,
		        version: rendererVersion,
		        rendererPackageName: rendererPackageName,
		        currentDispatcherRef: ReactSharedInternals,
		        reconcilerVersion: "19.2.0"
		      };
		      null !== extraDevToolsConfig &&
		        (internals.rendererConfig = extraDevToolsConfig);
		      internals.overrideHookState = overrideHookState;
		      internals.overrideHookStateDeletePath = overrideHookStateDeletePath;
		      internals.overrideHookStateRenamePath = overrideHookStateRenamePath;
		      internals.overrideProps = overrideProps;
		      internals.overridePropsDeletePath = overridePropsDeletePath;
		      internals.overridePropsRenamePath = overridePropsRenamePath;
		      internals.scheduleUpdate = scheduleUpdate;
		      internals.scheduleRetry = scheduleRetry;
		      internals.setErrorHandler = setErrorHandler;
		      internals.setSuspenseHandler = setSuspenseHandler;
		      internals.scheduleRefresh = scheduleRefresh;
		      internals.scheduleRoot = scheduleRoot;
		      internals.setRefreshHandler = setRefreshHandler;
		      internals.getCurrentFiber = getCurrentFiberForDevTools;
		      return injectInternals(internals);
		    };
		    exports$1.isAlreadyRendering = isAlreadyRendering;
		    exports$1.observeVisibleRects = function (
		      hostRoot,
		      selectors,
		      callback,
		      options
		    ) {
		      function commitHook() {
		        var nextInstanceRoots = findAllNodes(hostRoot, selectors);
		        instanceRoots.forEach(function (target) {
		          0 > nextInstanceRoots.indexOf(target) && unobserve(target);
		        });
		        nextInstanceRoots.forEach(function (target) {
		          0 > instanceRoots.indexOf(target) && observe(target);
		        });
		      }
		      if (!supportsTestSelectors)
		        throw Error("Test selector API is not supported by this renderer.");
		      var instanceRoots = findAllNodes(hostRoot, selectors);
		      callback = setupIntersectionObserver(instanceRoots, callback, options);
		      var disconnect = callback.disconnect,
		        observe = callback.observe,
		        unobserve = callback.unobserve;
		      commitHooks.push(commitHook);
		      return {
		        disconnect: function () {
		          var index = commitHooks.indexOf(commitHook);
		          0 <= index && commitHooks.splice(index, 1);
		          disconnect();
		        }
		      };
		    };
		    exports$1.shouldError = function (fiber) {
		      return shouldErrorImpl(fiber);
		    };
		    exports$1.shouldSuspend = function (fiber) {
		      return shouldSuspendImpl(fiber);
		    };
		    exports$1.startHostTransition = function (
		      formFiber,
		      pendingState,
		      action,
		      formData
		    ) {
		      if (5 !== formFiber.tag)
		        throw Error(
		          "Expected the form instance to be a HostComponent. This is a bug in React."
		        );
		      var queue = ensureFormComponentIsStateful(formFiber).queue;
		      startHostActionTimer(formFiber);
		      startTransition(
		        formFiber,
		        queue,
		        pendingState,
		        NotPendingTransition,
		        null === action
		          ? noop
		          : function () {
		              null === ReactSharedInternals.T &&
		                console.error(
		                  "requestFormReset was called outside a transition or action. To fix, move to an action, or wrap with startTransition."
		                );
		              var stateHook = ensureFormComponentIsStateful(formFiber);
		              null === stateHook.next &&
		                (stateHook = formFiber.alternate.memoizedState);
		              dispatchSetStateInternal(
		                formFiber,
		                stateHook.next.queue,
		                {},
		                requestUpdateLane(formFiber)
		              );
		              return action(formData);
		            }
		      );
		    };
		    exports$1.updateContainer = function (
		      element,
		      container,
		      parentComponent,
		      callback
		    ) {
		      var current = container.current,
		        lane = requestUpdateLane(current);
		      updateContainerImpl(
		        current,
		        lane,
		        element,
		        container,
		        parentComponent,
		        callback
		      );
		      return lane;
		    };
		    exports$1.updateContainerSync = updateContainerSync;
		    return exports$1;
		  }),
		  (module.exports.default = module.exports),
		  Object.defineProperty(module.exports, "__esModule", { value: true })); 
	} (reactReconciler_development));
	return reactReconciler_development.exports;
}

var hasRequiredReactReconciler;

function requireReactReconciler () {
	if (hasRequiredReactReconciler) return reactReconciler.exports;
	hasRequiredReactReconciler = 1;

	if (process.env.NODE_ENV === 'production') {
	  reactReconciler.exports = requireReactReconciler_production();
	} else {
	  reactReconciler.exports = requireReactReconciler_development();
	}
	return reactReconciler.exports;
}

var reactReconcilerExports = requireReactReconciler();
var ReactFiberReconciler = /*@__PURE__*/getDefaultExportFromCjs(reactReconcilerExports);

var constants = {exports: {}};

var reactReconcilerConstants_production = {};

/**
 * @license React
 * react-reconciler-constants.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactReconcilerConstants_production;

function requireReactReconcilerConstants_production () {
	if (hasRequiredReactReconcilerConstants_production) return reactReconcilerConstants_production;
	hasRequiredReactReconcilerConstants_production = 1;
	reactReconcilerConstants_production.ConcurrentRoot = 1;
	reactReconcilerConstants_production.ContinuousEventPriority = 8;
	reactReconcilerConstants_production.DefaultEventPriority = 32;
	reactReconcilerConstants_production.DiscreteEventPriority = 2;
	reactReconcilerConstants_production.IdleEventPriority = 268435456;
	reactReconcilerConstants_production.LegacyRoot = 0;
	reactReconcilerConstants_production.NoEventPriority = 0;
	return reactReconcilerConstants_production;
}

var reactReconcilerConstants_development = {};

/**
 * @license React
 * react-reconciler-constants.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactReconcilerConstants_development;

function requireReactReconcilerConstants_development () {
	if (hasRequiredReactReconcilerConstants_development) return reactReconcilerConstants_development;
	hasRequiredReactReconcilerConstants_development = 1;
	"production" !== process.env.NODE_ENV &&
	  ((reactReconcilerConstants_development.ConcurrentRoot = 1),
	  (reactReconcilerConstants_development.ContinuousEventPriority = 8),
	  (reactReconcilerConstants_development.DefaultEventPriority = 32),
	  (reactReconcilerConstants_development.DiscreteEventPriority = 2),
	  (reactReconcilerConstants_development.IdleEventPriority = 268435456),
	  (reactReconcilerConstants_development.LegacyRoot = 0),
	  (reactReconcilerConstants_development.NoEventPriority = 0));
	return reactReconcilerConstants_development;
}

var hasRequiredConstants;

function requireConstants () {
	if (hasRequiredConstants) return constants.exports;
	hasRequiredConstants = 1;

	if (process.env.NODE_ENV === 'production') {
	  constants.exports = requireReactReconcilerConstants_production();
	} else {
	  constants.exports = requireReactReconcilerConstants_development();
	}
	return constants.exports;
}

var constantsExports = requireConstants();

const propsToSkip = {
    children: true,
    ref: true,
    key: true,
    style: true,
    forwardedRef: true,
    unstable_applyCache: true,
    unstable_applyDrawHitFromCache: true,
};
let zIndexWarningShowed = false;
let dragWarningShowed = false;
const EVENTS_NAMESPACE = '.react-konva-event';
const DRAGGABLE_WARNING = `ReactKonva: You have a Konva node with draggable = true and position defined but no onDragMove or onDragEnd events are handled.
Position of a node will be changed during drag&drop, so you should update state of the react app as well.
Consider to add onDragMove or onDragEnd events.
For more info see: https://github.com/konvajs/react-konva/issues/256
`;
const Z_INDEX_WARNING = `ReactKonva: You are using "zIndex" attribute for a Konva node.
react-konva may get confused with ordering. Just define correct order of elements in your render function of a component.
For more info see: https://github.com/konvajs/react-konva/issues/194
`;
const EMPTY_PROPS = {};
function applyNodeProps(instance, props, oldProps = EMPTY_PROPS) {
    // don't use zIndex in react-konva
    if (!zIndexWarningShowed && 'zIndex' in props) {
        console.warn(Z_INDEX_WARNING);
        zIndexWarningShowed = true;
    }
    // check correct draggable usage
    if (!dragWarningShowed && props.draggable) {
        var hasPosition = props.x !== undefined || props.y !== undefined;
        var hasEvents = props.onDragEnd || props.onDragMove;
        if (hasPosition && !hasEvents) {
            console.warn(DRAGGABLE_WARNING);
            dragWarningShowed = true;
        }
    }
    // check old props
    // we need to unset properties that are not in new props
    // and remove all events
    for (var key in oldProps) {
        if (propsToSkip[key]) {
            continue;
        }
        var isEvent = key.slice(0, 2) === 'on';
        var propChanged = oldProps[key] !== props[key];
        // if that is a changed event, we need to remove it
        if (isEvent && propChanged) {
            var eventName = key.substr(2).toLowerCase();
            if (eventName.substr(0, 7) === 'content') {
                eventName =
                    'content' +
                        eventName.substr(7, 1).toUpperCase() +
                        eventName.substr(8);
            }
            instance.off(eventName, oldProps[key]);
        }
        var toRemove = !props.hasOwnProperty(key);
        if (toRemove) {
            instance.setAttr(key, undefined);
        }
    }
    var strictUpdate = props._useStrictMode;
    var updatedProps = {};
    var hasUpdates = false;
    const newEvents = {};
    for (var key in props) {
        if (propsToSkip[key]) {
            continue;
        }
        var isEvent = key.slice(0, 2) === 'on';
        var toAdd = oldProps[key] !== props[key];
        if (isEvent && toAdd) {
            var eventName = key.substr(2).toLowerCase();
            if (eventName.substr(0, 7) === 'content') {
                eventName =
                    'content' +
                        eventName.substr(7, 1).toUpperCase() +
                        eventName.substr(8);
            }
            // check that event is not undefined
            if (props[key]) {
                newEvents[eventName] = props[key];
            }
        }
        if (!isEvent &&
            (props[key] !== oldProps[key] ||
                (strictUpdate && props[key] !== instance.getAttr(key)))) {
            hasUpdates = true;
            updatedProps[key] = props[key];
        }
    }
    if (hasUpdates) {
        instance.setAttrs(updatedProps);
        updatePicture(instance);
    }
    // subscribe to events AFTER we set attrs
    // we need it to fix https://github.com/konvajs/react-konva/issues/471
    // settings attrs may add events. Like "draggable: true" will add "mousedown" listener
    for (var eventName in newEvents) {
        // first clear any existing listeners, it is required for strict mode
        instance.off(eventName + EVENTS_NAMESPACE);
        // then attach new one
        instance.on(eventName + EVENTS_NAMESPACE, newEvents[eventName]);
    }
}
function updatePicture(node) {
    if (!Konva$1.autoDrawEnabled) {
        var drawingNode = node.getLayer() || node.getStage();
        drawingNode && drawingNode.batchDraw();
    }
}

var schedulerExports = requireScheduler();

const NO_CONTEXT = {};
const UPDATE_SIGNAL = {};
// for react-spring capability
Konva.Node.prototype._applyProps = applyNodeProps;
// let currentUpdatePriority: number = NoEventPriority;
let currentUpdatePriority = constantsExports.DefaultEventPriority;
function appendInitialChild(parentInstance, child) {
    if (typeof child === 'string') {
        // Noop for string children of Text (eg <Text>foo</Text>)
        console.error(`Do not use plain text as child of Konva.Node. You are using text: ${child}`);
        return;
    }
    parentInstance.add(child);
    updatePicture(parentInstance);
}
function createInstance(type, props, internalInstanceHandle) {
    let NodeClass = Konva[type];
    if (!NodeClass) {
        console.error(`Konva has no node with the type ${type}. Group will be used instead. If you use minimal version of react-konva, just import required nodes into Konva: "import "konva/lib/shapes/${type}"  If you want to render DOM elements as part of canvas tree take a look into this demo: https://konvajs.github.io/docs/react/DOM_Portal.html`);
        NodeClass = Konva.Group;
    }
    // we need to split props into events and non events
    // we we can pass non events into constructor directly
    // that way the performance should be better
    // we we apply change "applyNodeProps"
    // then it will trigger change events on first run
    // but we don't need them!
    const propsWithoutEvents = {};
    const propsWithOnlyEvents = {};
    for (var key in props) {
        // ignore ref
        if (key === 'ref') {
            continue;
        }
        var isEvent = key.slice(0, 2) === 'on';
        if (isEvent) {
            propsWithOnlyEvents[key] = props[key];
        }
        else {
            propsWithoutEvents[key] = props[key];
        }
    }
    const instance = new NodeClass(propsWithoutEvents);
    applyNodeProps(instance, propsWithOnlyEvents);
    return instance;
}
function createTextInstance(text, rootContainerInstance, internalInstanceHandle) {
    console.error(`Text components are not supported for now in ReactKonva. Your text is: "${text}"`);
}
function finalizeInitialChildren(domElement, type, props) {
    return false;
}
function getPublicInstance(instance) {
    return instance;
}
function prepareForCommit() {
    return null;
}
function preparePortalMount() {
    return null;
}
function prepareUpdate(domElement, type, oldProps, newProps) {
    return UPDATE_SIGNAL;
}
function resetAfterCommit() {
    // Noop
}
function resetTextContent(domElement) {
    // Noop
}
function shouldDeprioritizeSubtree(type, props) {
    return false;
}
function getRootHostContext() {
    return NO_CONTEXT;
}
function getChildHostContext() {
    return NO_CONTEXT;
}
const scheduleTimeout = setTimeout;
const cancelTimeout = clearTimeout;
const supportsMicrotasks = true;
// Async — fixes the mobx-react-lite snapshot race. Stage's useLayoutEffect
// then explicitly calls `flushSyncWork()` to keep parent useLayoutEffect able
// to read Konva nodes added by subscribing children (see ReactKonvaCore.tsx).
const scheduleMicrotask = typeof queueMicrotask === 'function'
    ? queueMicrotask
    : (fn) => Promise.resolve(null).then(fn);
const noTimeout = -1;
// export const schedulePassiveEffects = scheduleDeferredCallback;
// export const cancelPassiveEffects = cancelDeferredCallback;
function shouldSetTextContent(type, props) {
    return false;
}
// The Konva renderer is secondary to the React DOM renderer.
const isPrimaryRenderer = false;
const warnsIfNotActing = false;
const supportsMutation = true;
const supportsPersistence = false;
const supportsHydration = false;
function appendChild(parentInstance, child) {
    if (child.parent === parentInstance) {
        child.moveToTop();
    }
    else {
        parentInstance.add(child);
    }
    updatePicture(parentInstance);
}
function appendChildToContainer(parentInstance, child) {
    if (child.parent === parentInstance) {
        child.moveToTop();
    }
    else {
        parentInstance.add(child);
    }
    updatePicture(parentInstance);
}
function insertBefore(parentInstance, child, beforeChild) {
    // child._remove() will not stop dragging
    // but child.remove() will stop it, but we don't need it
    // removing will reset zIndexes
    child._remove();
    parentInstance.add(child);
    child.setZIndex(beforeChild.getZIndex());
    updatePicture(parentInstance);
}
function insertInContainerBefore(parentInstance, child, beforeChild) {
    insertBefore(parentInstance, child, beforeChild);
}
function removeChild(parentInstance, child) {
    child.destroy();
    child.off(EVENTS_NAMESPACE);
    updatePicture(parentInstance);
}
function removeChildFromContainer(parentInstance, child) {
    child.destroy();
    child.off(EVENTS_NAMESPACE);
    updatePicture(parentInstance);
}
function commitTextUpdate(textInstance, oldText, newText) {
    console.error(`Text components are not yet supported in ReactKonva. You text is: "${newText}"`);
}
function commitMount(instance, type, newProps) {
    // Noop
}
function commitUpdate(instance, type, oldProps, newProps) {
    applyNodeProps(instance, newProps, oldProps);
}
function hideInstance(instance) {
    instance.hide();
    updatePicture(instance);
}
function hideTextInstance(textInstance) {
    // Noop
}
function unhideInstance(instance, props) {
    if (props.visible == null || props.visible) {
        instance.show();
    }
}
function unhideTextInstance(textInstance, text) {
    // Noop
}
function clearContainer(container) {
    // Noop
}
function detachDeletedInstance() { }
function getInstanceFromNode() {
    return null;
}
function beforeActiveInstanceBlur() { }
function afterActiveInstanceBlur() { }
function getCurrentEventPriority() {
    return constantsExports.DefaultEventPriority;
}
function prepareScopeUpdate() { }
function getInstanceFromScope() {
    return null;
}
function setCurrentUpdatePriority(newPriority) {
    currentUpdatePriority = newPriority;
}
function getCurrentUpdatePriority() {
    return currentUpdatePriority;
}
// Load-bearing: pins secondary commits to React's sync lane so they land
// before the scheduler yields. Required for parent useLayoutEffect to read
// Konva nodes added by subscribing children. Changing to Default/Continuous/
// Idle breaks ~18 tests in test/01-mounting and test/16-scheduling-invariants.
function resolveUpdatePriority() {
    return constantsExports.DiscreteEventPriority;
}
function shouldAttemptEagerTransition() {
    return false;
}
function trackSchedulerEvent() { }
function resolveEventType() {
    return null;
}
function resolveEventTimeStamp() {
    return -1.1;
}
function requestPostPaintCallback() { }
function maySuspendCommit() {
    return false;
}
function preloadInstance() {
    return true;
}
function startSuspendingCommit() { }
function suspendInstance() { }
function waitForCommitToBeReady() {
    return null;
}
const NotPendingTransition = null;
// React 19 transition context - create as React context that can be cast by reconciler
const HostTransitionContext = /* @__PURE__ */ React__default.createContext(null);
function resetFormInstance() { }

var HostConfig = /*#__PURE__*/Object.freeze({
  __proto__: null,
  HostTransitionContext: HostTransitionContext,
  NotPendingTransition: NotPendingTransition,
  afterActiveInstanceBlur: afterActiveInstanceBlur,
  appendChild: appendChild,
  appendChildToContainer: appendChildToContainer,
  appendInitialChild: appendInitialChild,
  beforeActiveInstanceBlur: beforeActiveInstanceBlur,
  cancelTimeout: cancelTimeout,
  clearContainer: clearContainer,
  commitMount: commitMount,
  commitTextUpdate: commitTextUpdate,
  commitUpdate: commitUpdate,
  createInstance: createInstance,
  createTextInstance: createTextInstance,
  detachDeletedInstance: detachDeletedInstance,
  finalizeInitialChildren: finalizeInitialChildren,
  getChildHostContext: getChildHostContext,
  getCurrentEventPriority: getCurrentEventPriority,
  getCurrentUpdatePriority: getCurrentUpdatePriority,
  getInstanceFromNode: getInstanceFromNode,
  getInstanceFromScope: getInstanceFromScope,
  getPublicInstance: getPublicInstance,
  getRootHostContext: getRootHostContext,
  hideInstance: hideInstance,
  hideTextInstance: hideTextInstance,
  idlePriority: schedulerExports.unstable_IdlePriority,
  insertBefore: insertBefore,
  insertInContainerBefore: insertInContainerBefore,
  isPrimaryRenderer: isPrimaryRenderer,
  maySuspendCommit: maySuspendCommit,
  noTimeout: noTimeout,
  now: schedulerExports.unstable_now,
  preloadInstance: preloadInstance,
  prepareForCommit: prepareForCommit,
  preparePortalMount: preparePortalMount,
  prepareScopeUpdate: prepareScopeUpdate,
  prepareUpdate: prepareUpdate,
  removeChild: removeChild,
  removeChildFromContainer: removeChildFromContainer,
  requestPostPaintCallback: requestPostPaintCallback,
  resetAfterCommit: resetAfterCommit,
  resetFormInstance: resetFormInstance,
  resetTextContent: resetTextContent,
  resolveEventTimeStamp: resolveEventTimeStamp,
  resolveEventType: resolveEventType,
  resolveUpdatePriority: resolveUpdatePriority,
  run: schedulerExports.unstable_runWithPriority,
  scheduleMicrotask: scheduleMicrotask,
  scheduleTimeout: scheduleTimeout,
  setCurrentUpdatePriority: setCurrentUpdatePriority,
  shouldAttemptEagerTransition: shouldAttemptEagerTransition,
  shouldDeprioritizeSubtree: shouldDeprioritizeSubtree,
  shouldSetTextContent: shouldSetTextContent,
  startSuspendingCommit: startSuspendingCommit,
  supportsHydration: supportsHydration,
  supportsMicrotasks: supportsMicrotasks,
  supportsMutation: supportsMutation,
  supportsPersistence: supportsPersistence,
  suspendInstance: suspendInstance,
  trackSchedulerEvent: trackSchedulerEvent,
  unhideInstance: unhideInstance,
  unhideTextInstance: unhideTextInstance,
  waitForCommitToBeReady: waitForCommitToBeReady,
  warnsIfNotActing: warnsIfNotActing
});

function i(e, t, r) {
  if (!e) return;
  if (r(e) === true) return e;
  let n = e.child;
  for (; n; ) {
    const u = i(n, t, r);
    if (u) return u;
    n = n.sibling;
  }
}
function l(e) {
  try {
    return Object.defineProperties(e, {
      _currentRenderer: {
        get() {
          return null;
        },
        set() {
        }
      },
      _currentRenderer2: {
        get() {
          return null;
        },
        set() {
        }
      }
    });
  } catch (t) {
    return e;
  }
}
const a$1 = /* @__PURE__ */ l(/* @__PURE__ */ React.createContext(null));
class m extends React.Component {
  render() {
    return /* @__PURE__ */ React.createElement(a$1.Provider, { value: this._reactInternals }, this.props.children);
  }
}
function c$1() {
  const e = React.useContext(a$1);
  if (e === null) throw new Error("its-fine: useFiber must be called within a <FiberProvider />!");
  const t = React.useId();
  return React.useMemo(() => {
    for (const n of [e, e == null ? void 0 : e.alternate]) {
      if (!n) continue;
      const u = i(n, false, (d) => {
        let s = d.memoizedState;
        for (; s; ) {
          if (s.memoizedState === t) return true;
          s = s.next;
        }
      });
      if (u) return u;
    }
  }, [e, t]);
}
const p = Symbol.for("react.context"), b = (e) => e !== null && typeof e == "object" && "$$typeof" in e && e.$$typeof === p;
function h() {
  const e = c$1(), [t] = React.useState(() => /* @__PURE__ */ new Map());
  t.clear();
  let r = e;
  for (; r; ) {
    const n = r.type;
    b(n) && n !== a$1 && !t.has(n) && t.set(n, React.use(l(n))), r = r.return;
  }
  return t;
}
function x() {
  const e = h();
  return React.useMemo(
    () => Array.from(e.keys()).reduce(
      (t, r) => (n) => /* @__PURE__ */ React.createElement(t, null, /* @__PURE__ */ React.createElement(r.Provider, { ...n, value: e.get(r) })),
      (t) => /* @__PURE__ */ React.createElement(m, { ...t })
    ),
    [e]
  );
}

/**
 * Based on ReactArt.js
 * Copyright (c) 2017-present Lavrenov Anton.
 * All rights reserved.
 *
 * MIT
 */
if (React__default.version.indexOf('19') === -1) {
    throw new Error('react-konva version 19 is only compatible with React 19. Make sure to have the last version of react-konva and react or downgrade react-konva to version 18.');
}
function usePrevious(value) {
    const ref = React__default.useRef({});
    React__default.useLayoutEffect(() => {
        ref.current = value;
    });
    React__default.useLayoutEffect(() => {
        return () => {
            // when using suspense it is possible that stage is unmounted
            // but React still keep component ref
            // in that case we need to manually flush props
            // we have a special test for that
            ref.current = {};
        };
    }, []);
    return ref.current;
}
const useIsReactStrictMode = () => {
    const memoCount = React__default.useRef(0);
    // in strict mode, memo will be called twice
    React__default.useMemo(() => {
        memoCount.current++;
    }, []);
    return memoCount.current > 1;
};
const StageWrap = (props) => {
    const container = React__default.useRef(null);
    const stage = React__default.useRef(null);
    const fiberRef = React__default.useRef(null);
    const oldProps = usePrevious(props);
    const Bridge = x();
    const pendingDestroy = React__default.useRef(null);
    const _setRef = (stage) => {
        const { forwardedRef } = props;
        if (!forwardedRef) {
            return;
        }
        if (typeof forwardedRef === 'function') {
            forwardedRef(stage);
        }
        else {
            forwardedRef.current = stage;
        }
    };
    const isStrictMode = useIsReactStrictMode();
    const destroyStage = () => {
        _setRef(null);
        // CRITICAL: flushSyncFromReconciler is required here to ensure pending work
        // (e.g. stale MobX updates on child components) is flushed synchronously
        // before the tree is torn down. Without it, unmounting a Stage can leave
        // pending Konva work that runs after the stage is already destroyed.
        KonvaRenderer.flushSyncFromReconciler(() => {
            KonvaRenderer.updateContainer(null, fiberRef.current, null);
        });
        stage.current?.destroy();
        stage.current = null;
    };
    React__default.useLayoutEffect(() => {
        // Cancel any pending destruction (happens during re-ordering in strict mode)
        if (pendingDestroy.current) {
            clearTimeout(pendingDestroy.current);
            pendingDestroy.current = null;
        }
        // If stage already exists (re-ordering scenario), reuse it
        if (stage.current) {
            _setRef(stage.current);
        }
        else {
            stage.current = new Konva.Stage({
                width: props.width,
                height: props.height,
                container: container.current,
            });
            _setRef(stage.current);
            // @ts-ignore
            fiberRef.current = KonvaRenderer.createContainer(stage.current, constantsExports.ConcurrentRoot, null, false, null, '', console.error, console.error, console.error, null);
            KonvaRenderer.updateContainer(React__default.createElement(Bridge, {}, props.children), fiberRef.current, null, () => { });
        }
        return () => {
            if (isStrictMode) {
                // Delay destruction to allow cancellation on remount
                pendingDestroy.current = setTimeout(destroyStage, 0);
            }
            else {
                destroyStage();
            }
        };
    }, []);
    React__default.useLayoutEffect(() => {
        _setRef(stage.current);
        applyNodeProps(stage.current, props, oldProps);
        // updateContainer schedules sync-lane work; with async scheduleMicrotask
        // the work is queued, so flushSyncWork() drains it inline here so that
        // a parent useLayoutEffect can read Konva nodes added by subscribing
        // children. (Lighter than flushSyncFromReconciler — no callback wrapper.)
        KonvaRenderer.updateContainer(React__default.createElement(Bridge, {}, props.children), fiberRef.current, null);
        KonvaRenderer.flushSyncWork();
    });
    return React__default.createElement('div', {
        ref: container,
        id: props.id,
        accessKey: props.accessKey,
        className: props.className,
        role: props.role,
        style: props.style,
        tabIndex: props.tabIndex,
        title: props.title,
    });
};
const Layer = 'Layer';
const Group = 'Group';
const Rect = 'Rect';
const Circle = 'Circle';
const Line = 'Line';
const Image$1 = 'Image';
const Text = 'Text';
// @ts-ignore
const KonvaRenderer = ReactFiberReconciler(HostConfig);
// Update Stage component declaration
const Stage = React__default.forwardRef((props, ref) => {
    return React__default.createElement(m, {}, React__default.createElement(StageWrap, { ...props, forwardedRef: ref }));
});

const TwoCanvasContext = createContext({
    stageRef: { current: null },
    dimensions: { width: 0, height: 0 },
});
const useTwoCanvasContext = () => useContext(TwoCanvasContext);

/** Distance in pixels within which a click counts as hitting the close indicator. */
const SNAP_THRESHOLD_PX = 10;
const DEFAULT_DRAWING_STYLE = {
    stroke: '#0099ff',
    strokeWidth: 1.5,
    fill: 'rgba(0, 153, 255, 0.12)',
    closeIndicatorRadius: 8,
    closeIndicatorFill: 'rgba(0, 153, 255, 0.25)',
    closeIndicatorStroke: '#0099ff',
    tooltipFill: 'rgba(0, 0, 0, 0.72)',
    tooltipTextColor: '#ffffff',
};

/** Active drawing tool. Determines interaction behaviour inside TwoCanvas. */
var DrawingMode;
(function (DrawingMode) {
    DrawingMode[DrawingMode["Line"] = 0] = "Line";
    DrawingMode[DrawingMode["Rect"] = 1] = "Rect";
    DrawingMode[DrawingMode["Circle"] = 2] = "Circle";
    DrawingMode[DrawingMode["Polyline"] = 3] = "Polyline";
    DrawingMode[DrawingMode["Polygon"] = 4] = "Polygon";
})(DrawingMode || (DrawingMode = {}));
/** Discriminant used on the `DrawnShape` payload. */
var DrawnShapeType;
(function (DrawnShapeType) {
    DrawnShapeType["Rect"] = "rect";
    DrawnShapeType["Circle"] = "circle";
    DrawnShapeType["Line"] = "line";
    DrawnShapeType["Polyline"] = "polyline";
    DrawnShapeType["Polygon"] = "polygon";
})(DrawnShapeType || (DrawnShapeType = {}));

// ---------------------------------------------------------------------------
// Internal helpers
// ---------------------------------------------------------------------------
const flat = (pts) => pts.flatMap((p) => p);
/**
 * Small pill-shaped label rendered on the canvas — used for close indicator
 * tooltips ("Click to finish", "Click to close").
 */
const TooltipLabel = ({ x, y, text, bgColor, textColor, }) => {
    const fontSize = 11;
    const padX = 6;
    const padY = 3;
    const approxWidth = text.length * 6.2 + padX * 2;
    const height = fontSize + padY * 2;
    return (jsxs(Group, { x: x, y: y - height / 2, children: [jsx(Rect, { width: approxWidth, height: height, fill: bgColor, cornerRadius: 3, opacity: 0.85 }), jsx(Text, { x: padX, y: padY, text: text, fontSize: fontSize, fontFamily: "sans-serif", fill: textColor })] }));
};
/**
 * An overlay Konva Layer that handles all drawing interaction and renders
 * the live preview shapes. It sits above all content layers so drawing
 * clicks are never swallowed by existing canvas items.
 */
const DrawingLayer = ({ mode, placedPoints, mousePos, nearCloseIndicator, style, drawingBounds, onPointPlaced, zoom, pan, toContentCoords, }) => {
    const hasMouse = mousePos !== null;
    const mouse = mousePos ?? [0, 0];
    const first = placedPoints[0];
    const last = placedPoints[placedPoints.length - 1];
    const indicatorOffset = style.closeIndicatorRadius + 6;
    return (jsx(Layer, { children: jsxs(Group, { scaleX: zoom, scaleY: zoom, x: pan.x, y: pan.y, children: [jsx(Rect, { x: -1e6, y: -1e6, width: 2e6, height: 2e6, fill: "rgba(0,0,0,0.001)", onClick: (e) => {
                        const stagePos = e.target.getStage()?.getPointerPosition();
                        if (!stagePos)
                            return;
                        const [cx, cy] = toContentCoords(stagePos.x, stagePos.y);
                        if (drawingBounds) {
                            const inBounds = cx >= drawingBounds.x &&
                                cx <= drawingBounds.x + drawingBounds.width &&
                                cy >= drawingBounds.y &&
                                cy <= drawingBounds.y + drawingBounds.height;
                            if (!inBounds)
                                return;
                        }
                        onPointPlaced([cx, cy]);
                    } }), mode === DrawingMode.Line && placedPoints.length === 1 && hasMouse && (jsxs(Fragment, { children: [jsx(Circle, { listening: false, x: first[0], y: first[1], radius: 3, fill: style.stroke }), jsx(Line, { listening: false, points: flat([first, mouse]), stroke: style.stroke, strokeWidth: style.strokeWidth })] })), mode === DrawingMode.Rect && placedPoints.length === 1 && hasMouse && (jsxs(Fragment, { children: [jsx(Circle, { listening: false, x: first[0], y: first[1], radius: 3, fill: style.stroke }), jsx(Rect, { listening: false, x: Math.min(first[0], mouse[0]), y: Math.min(first[1], mouse[1]), width: Math.abs(mouse[0] - first[0]), height: Math.abs(mouse[1] - first[1]), stroke: style.stroke, strokeWidth: style.strokeWidth, fill: style.fill })] })), mode === DrawingMode.Circle && placedPoints.length === 1 && hasMouse && (jsxs(Fragment, { children: [jsx(Circle, { listening: false, x: first[0], y: first[1], radius: 3, fill: style.stroke }), jsx(Circle, { listening: false, x: first[0], y: first[1], radius: Math.sqrt((mouse[0] - first[0]) ** 2 + (mouse[1] - first[1]) ** 2), stroke: style.stroke, strokeWidth: style.strokeWidth, fill: style.fill })] })), mode === DrawingMode.Polyline && placedPoints.length >= 1 && (jsxs(Fragment, { children: [placedPoints.length >= 2 && (jsx(Line, { listening: false, points: flat(placedPoints), stroke: style.stroke, strokeWidth: style.strokeWidth })), placedPoints.map(([px, py], i) => (jsx(Circle, { listening: false, x: px, y: py, radius: 3, fill: style.stroke }, i))), hasMouse && (jsx(Line, { listening: false, points: flat([last, mouse]), stroke: style.stroke, strokeWidth: style.strokeWidth, dash: [6, 4] })), placedPoints.length >= 2 && (jsxs(Fragment, { children: [jsx(Circle, { x: last[0], y: last[1], radius: style.closeIndicatorRadius, fill: style.closeIndicatorFill, stroke: style.closeIndicatorStroke, strokeWidth: 1 }), nearCloseIndicator && (jsx(TooltipLabel, { x: last[0] + indicatorOffset, y: last[1], text: "Click to finish", bgColor: style.tooltipFill, textColor: style.tooltipTextColor }))] }))] })), mode === DrawingMode.Polygon && placedPoints.length >= 1 && (jsxs(Fragment, { children: [placedPoints.length >= 2 && (jsx(Line, { listening: false, points: flat(placedPoints), stroke: style.stroke, strokeWidth: style.strokeWidth })), placedPoints.map(([px, py], i) => (jsx(Circle, { listening: false, x: px, y: py, radius: 3, fill: style.stroke }, i))), hasMouse && (jsx(Line, { listening: false, points: flat([last, mouse]), stroke: style.stroke, strokeWidth: style.strokeWidth, dash: [6, 4] })), hasMouse && placedPoints.length >= 2 && (jsx(Line, { listening: false, points: flat([mouse, first]), stroke: style.stroke, strokeWidth: style.strokeWidth, dash: [6, 4] })), placedPoints.length >= 3 && (jsxs(Fragment, { children: [jsx(Circle, { x: first[0], y: first[1], radius: style.closeIndicatorRadius, fill: style.closeIndicatorFill, stroke: style.closeIndicatorStroke, strokeWidth: 1 }), nearCloseIndicator && (jsx(TooltipLabel, { x: first[0] + indicatorOffset, y: first[1], text: "Click to close", bgColor: style.tooltipFill, textColor: style.tooltipTextColor }))] }))] }))] }) }));
};

const dist = (a, b) => Math.sqrt((a[0] - b[0]) ** 2 + (a[1] - b[1]) ** 2);
/**
 * Core drawing state machine.
 *
 * Manages placed points and mouse position for the active drawing mode.
 * Completion logic per mode:
 *  - rect / circle / line : 2nd click finalises the shape
 *  - polyline             : click the last placed point to finalise (≥2 pts)
 *  - polygon              : click the first placed point to finalise (≥3 pts)
 */
function useDrawing$1(mode, onComplete) {
    const [placedPoints, setPlacedPoints] = useState([]);
    const [mousePos, setMousePos] = useState(null);
    // Stable ref so callbacks never need onComplete in their dep arrays.
    const onCompleteRef = useRef(onComplete);
    useLayoutEffect(() => {
        onCompleteRef.current = onComplete;
    });
    // Reset when the mode switches.
    useEffect(() => {
        setPlacedPoints([]);
        setMousePos(null);
    }, [mode]);
    // Derived: is the pointer hovering the snap area of the relevant close indicator?
    const nearCloseIndicator = (() => {
        if (!mousePos || mode == null)
            return false;
        if (mode === DrawingMode.Polyline && placedPoints.length >= 2)
            return dist(mousePos, placedPoints[placedPoints.length - 1]) <= SNAP_THRESHOLD_PX;
        if (mode === DrawingMode.Polygon && placedPoints.length >= 3)
            return dist(mousePos, placedPoints[0]) <= SNAP_THRESHOLD_PX;
        return false;
    })();
    const handleMouseMove = useCallback((pos) => {
        setMousePos(pos);
    }, []);
    const handlePointPlaced = useCallback((pos) => {
        if (mode == null)
            return;
        const currentMode = mode;
        // Two-click shapes: 1st click anchors, 2nd click finalises.
        if (currentMode === DrawingMode.Rect || currentMode === DrawingMode.Circle || currentMode === DrawingMode.Line) {
            setPlacedPoints((prev) => {
                if (prev.length === 0)
                    return [pos];
                const [p1] = prev;
                let shape;
                if (currentMode === DrawingMode.Rect) {
                    shape = {
                        type: DrawnShapeType.Rect,
                        x: Math.min(p1[0], pos[0]),
                        y: Math.min(p1[1], pos[1]),
                        width: Math.abs(pos[0] - p1[0]),
                        height: Math.abs(pos[1] - p1[1]),
                    };
                }
                else if (currentMode === DrawingMode.Circle) {
                    shape = { type: DrawnShapeType.Circle, x: p1[0], y: p1[1], radius: dist(p1, pos) };
                }
                else {
                    shape = { type: DrawnShapeType.Line, points: [p1, pos] };
                }
                // Defer the callback so it fires after the state update resolves.
                setTimeout(() => onCompleteRef.current?.(shape), 0);
                return [];
            });
            return;
        }
        // Polyline: click the last point to close.
        if (mode === DrawingMode.Polyline) {
            setPlacedPoints((prev) => {
                if (prev.length >= 2 && dist(pos, prev[prev.length - 1]) <= SNAP_THRESHOLD_PX) {
                    setTimeout(() => onCompleteRef.current?.({ type: DrawnShapeType.Polyline, points: prev }), 0);
                    return [];
                }
                return [...prev, pos];
            });
            return;
        }
        // Polygon: click the first point to close (requires ≥3 pts).
        if (mode === DrawingMode.Polygon) {
            setPlacedPoints((prev) => {
                if (prev.length >= 3 && dist(pos, prev[0]) <= SNAP_THRESHOLD_PX) {
                    setTimeout(() => onCompleteRef.current?.({ type: DrawnShapeType.Polygon, points: prev }), 0);
                    return [];
                }
                return [...prev, pos];
            });
        }
    }, [mode]);
    const closeDrawing = useCallback(() => {
        setPlacedPoints((prev) => {
            if (mode === DrawingMode.Polyline && prev.length >= 2) {
                setTimeout(() => onCompleteRef.current?.({ type: DrawnShapeType.Polyline, points: prev }), 0);
                return [];
            }
            if (mode === DrawingMode.Polygon && prev.length >= 3) {
                setTimeout(() => onCompleteRef.current?.({ type: DrawnShapeType.Polygon, points: prev }), 0);
                return [];
            }
            return prev;
        });
    }, [mode]);
    const cancelDrawing = useCallback(() => {
        setPlacedPoints([]);
        setMousePos(null);
    }, []);
    return { placedPoints, mousePos, nearCloseIndicator, handlePointPlaced, handleMouseMove, closeDrawing, cancelDrawing };
}

/**
 * Tracks hover state for a TwoCanvas shape and merges `_hover` style overrides
 * on top of the base props when the pointer is over the shape.
 *
 * Supports a `cursor` key in `_hover` — sets `document.body.style.cursor` while
 * the pointer is over the shape and restores the previous value on leave.
 *
 * Wraps the caller's `onMouseEnter`/`onMouseLeave` so both hover tracking and
 * user-supplied handlers fire together.
 */
function useHover(hoverStyle, onMouseEnter, onMouseLeave) {
    const [hovered, setHovered] = useState(false);
    const prevCursorRef = useRef('');
    const { cursor, ...restHoverStyle } = (hoverStyle ?? {});
    return {
        appliedHoverStyle: hovered && hoverStyle ? restHoverStyle : {},
        onMouseEnter: (e) => {
            setHovered(true);
            if (cursor) {
                prevCursorRef.current = document.body.style.cursor;
                document.body.style.cursor = cursor;
            }
            onMouseEnter?.(e);
        },
        onMouseLeave: (e) => {
            setHovered(false);
            if (cursor) {
                document.body.style.cursor = prevCursorRef.current;
            }
            onMouseLeave?.(e);
        },
    };
}

const CanvasCircle = ({ x, y, radius, fill, stroke, strokeWidth = 1, opacity, visible, draggable, onDragEnd, onClick, onDblClick, onMouseEnter, onMouseLeave, _hover, }) => {
    const hover = useHover(_hover, onMouseEnter, onMouseLeave);
    return (jsx(Circle, { x: x, y: y, radius: radius, fill: fill, stroke: stroke, strokeWidth: strokeWidth, opacity: opacity, visible: visible, draggable: draggable, onDragEnd: onDragEnd, onClick: onClick, onDblClick: onDblClick, ...hover.appliedHoverStyle, onMouseEnter: hover.onMouseEnter, onMouseLeave: hover.onMouseLeave }));
};

/**
 * An image drawn on the TwoCanvas. Loads `src` asynchronously; renders nothing
 * until the image is ready to avoid a blank flash.
 *
 * - `width`/`height` default to the image's natural dimensions.
 * - `x`/`y` default to centering the (fitted) image in the canvas.
 * - `objectFit` uses the explicit `width`/`height` box if given, otherwise the full canvas size.
 *
 * @example
 * <TwoCanvas>
 *   <TwoCanvas.Image src="https://example.com/photo.jpg" />
 * </TwoCanvas>
 */
function applyFit(natW, natH, boxW, boxH, mode) {
    if (mode === 'fill')
        return { width: boxW, height: boxH };
    let scale;
    if (mode === 'cover') {
        scale = Math.max(boxW / natW, boxH / natH);
    }
    else if (mode === 'natural') {
        scale = Math.min(1, boxW / natW, boxH / natH);
    }
    else {
        // contain
        scale = Math.min(boxW / natW, boxH / natH);
    }
    return { width: natW * scale, height: natH * scale };
}
const CanvasImage = ({ src, x, y, width, height, objectFit = 'contain', opacity, visible, draggable, onDragEnd, onClick, onDblClick, onMouseEnter, onMouseLeave, onLoad, _hover, }) => {
    const { dimensions } = useTwoCanvasContext();
    const hover = useHover(_hover, onMouseEnter, onMouseLeave);
    const [image, setImage] = useState(null);
    const imgRef = useRef(null);
    // Keep the latest onLoad in a ref so the loader effect can stay keyed on `src` alone.
    const onLoadRef = useRef(onLoad);
    onLoadRef.current = onLoad;
    useEffect(() => {
        const img = new window.Image();
        imgRef.current = img;
        img.onload = () => {
            setImage(img);
            onLoadRef.current?.(img.naturalWidth, img.naturalHeight);
        };
        img.onerror = () => console.error(`[TwoCanvas.Image] Failed to load: ${src}`);
        img.src = src;
        return () => {
            img.onload = null;
            img.onerror = null;
        };
    }, [src]);
    if (!image)
        return null;
    const natW = image.naturalWidth;
    const natH = image.naturalHeight;
    // Use the explicit box if given, otherwise fall back to the canvas dimensions.
    const boxW = width ?? dimensions.width;
    const boxH = height ?? dimensions.height;
    const { width: drawW, height: drawH } = applyFit(natW, natH, boxW, boxH, objectFit);
    // Center in the canvas when x/y are omitted.
    const drawX = x ?? (dimensions.width - drawW) / 2;
    const drawY = y ?? (dimensions.height - drawH) / 2;
    return (jsx(Image$1, { image: image, x: drawX, y: drawY, width: drawW, height: drawH, opacity: opacity, visible: visible, draggable: draggable, onDragEnd: onDragEnd, onClick: onClick, onDblClick: onDblClick, ...hover.appliedHoverStyle, onMouseEnter: hover.onMouseEnter, onMouseLeave: hover.onMouseLeave }));
};

const CanvasLine = ({ points, stroke = '#000000', strokeWidth = 1, opacity, visible, lineCap = 'round', lineJoin = 'round', closed, dash, onClick, onDblClick, onMouseEnter, onMouseLeave, _hover, }) => {
    const hover = useHover(_hover, onMouseEnter, onMouseLeave);
    return (jsx(Line, { points: points.flatMap((p) => p), stroke: stroke, strokeWidth: strokeWidth, opacity: opacity, visible: visible, lineCap: lineCap, lineJoin: lineJoin, closed: closed, dash: dash, onClick: onClick, onDblClick: onDblClick, ...hover.appliedHoverStyle, onMouseEnter: hover.onMouseEnter, onMouseLeave: hover.onMouseLeave }));
};

const CanvasPolygon = ({ points, fill, stroke, strokeWidth = 1, opacity, visible, draggable, onDragEnd, onClick, onDblClick, onMouseEnter, onMouseLeave, _hover, }) => {
    const hover = useHover(_hover, onMouseEnter, onMouseLeave);
    return (jsx(Line, { points: points.flatMap((p) => p), closed: true, fill: fill, stroke: stroke, strokeWidth: strokeWidth, opacity: opacity, visible: visible, draggable: draggable, onDragEnd: onDragEnd, onClick: onClick, onDblClick: onDblClick, ...hover.appliedHoverStyle, onMouseEnter: hover.onMouseEnter, onMouseLeave: hover.onMouseLeave }));
};

const CanvasRect = ({ x, y, width, height, fill, stroke, strokeWidth = 1, opacity, cornerRadius, visible, draggable, onDragEnd, onClick, onDblClick, onMouseEnter, onMouseLeave, _hover, }) => {
    const hover = useHover(_hover, onMouseEnter, onMouseLeave);
    return (jsx(Rect, { x: x, y: y, width: width, height: height, fill: fill, stroke: stroke, strokeWidth: strokeWidth, opacity: opacity, cornerRadius: cornerRadius, visible: visible, draggable: draggable, onDragEnd: onDragEnd, onClick: onClick, onDblClick: onDblClick, ...hover.appliedHoverStyle, onMouseEnter: hover.onMouseEnter, onMouseLeave: hover.onMouseLeave }));
};

const ZOOM_STEP = 1.25;
const MIN_ZOOM = 0.25;
const MAX_ZOOM = 8;
/**
 * Clamp pan so no corner of the content can cross the canvas center.
 * - Dragging left/up: the trailing edge (right/bottom) cannot pass the center.
 * - Dragging right/down: the leading edge (left/top) cannot pass the center.
 */
function constrainPan(desired, bounds, zoom, dims) {
    const cx = dims.width / 2;
    const cy = dims.height / 2;
    const x = Math.max(cx - (bounds.x + bounds.width) * zoom, // right edge at center
    Math.min(cx - bounds.x * zoom, desired.x));
    const y = Math.max(cy - (bounds.y + bounds.height) * zoom, // bottom edge at center
    Math.min(cy - bounds.y * zoom, desired.y));
    return { x, y };
}
/**
 * A 2D canvas backed by Konva/react-konva.
 *
 * Renders to a Stage that automatically tracks its container's size via a
 * ResizeObserver (same debounced approach as ThreeCanvas). All canvas items
 * are passed as children — the parent never needs to know about Konva.
 *
 * Built-in child components:
 *   TwoCanvas.Rect    — rectangle
 *   TwoCanvas.Circle  — circle
 *   TwoCanvas.Line    — line / polyline
 *   TwoCanvas.Polygon — closed filled polygon
 *   TwoCanvas.Image   — async-loaded image
 *
 * Drawing mode:
 *   Set `drawingMode` to activate a drawing tool. The canvas enters an
 *   interactive state: the cursor changes, an overlay intercepts all pointer
 *   events, and a live ghost preview tracks the mouse. When the user finishes
 *   drawing, `onShapeComplete` fires with a plain data payload — no Konva
 *   types — so the app can open a modal, persist data, etc.
 *
 * @example
 * <TwoCanvas
 *   backgroundColor="#1a1a2e"
 *   drawingMode={activeMode}
 *   onShapeComplete={(shape) => { setActiveMode(null); openModal(shape) }}
 * >
 *   <TwoCanvas.Image src={diagramUrl} x={0} y={0} />
 * </TwoCanvas>
 */
const TwoCanvas = ({ backgroundColor, className, style, children, drawingMode, drawingBounds, drawingRef, onShapeComplete, drawingStyle, zoomRef, enablePan, contentBounds, }) => {
    const containerRef = useRef(null);
    const stageRef = useRef(null);
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
    // Zoom / pan state
    const [zoom, setZoom] = useState(1);
    const [pan, setPan] = useState({ x: 0, y: 0 });
    const panDragRef = useRef(null);
    const prevBodyCursorRef = useRef('');
    // Always-fresh ref so RAF/animation callbacks never capture stale zoom/pan.
    const zoomStateRef = useRef({ zoom: 1, pan: { x: 0, y: 0 } });
    zoomStateRef.current = { zoom, pan };
    const animRafRef = useRef(null);
    const isAnimatingRef = useRef(false);
    // Konva group node for the zoomed/panned content. During pan drags and zoom animations we drive
    // it imperatively (set attrs + batchDraw) instead of through React state, so the interaction
    // never triggers a re-render per mousemove/frame. State is committed only when the gesture ends.
    const groupRef = useRef(null);
    const setGroupViewport = useCallback((nextZoom, nextPan) => {
        zoomStateRef.current = { zoom: nextZoom, pan: nextPan };
        const group = groupRef.current;
        if (!group)
            return;
        group.scale({ x: nextZoom, y: nextZoom });
        group.position(nextPan);
        group.getLayer()?.batchDraw();
    }, []);
    // Extract contentBounds as primitives so effects only re-run when values change.
    const cbX = contentBounds?.x;
    const cbY = contentBounds?.y;
    const cbW = contentBounds?.width;
    const cbH = contentBounds?.height;
    // Pan is enabled only when the content actually overflows the canvas in at least one axis.
    const canPan = useMemo(() => {
        if (!enablePan)
            return false;
        if (cbW == null || cbH == null)
            return zoom > 1;
        return cbW * zoom > dimensions.width || cbH * zoom > dimensions.height;
    }, [enablePan, zoom, dimensions.width, dimensions.height, cbW, cbH]);
    // Whenever zoom, canvas size, or content bounds change, re-constrain pan.
    // Skip during animations — the animation already targets a constrained position.
    useEffect(() => {
        if (isAnimatingRef.current)
            return;
        if (cbX == null || cbY == null || cbW == null || cbH == null)
            return;
        const bounds = { x: cbX, y: cbY, width: cbW, height: cbH };
        setPan((prev) => constrainPan(prev, bounds, zoom, dimensions));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [zoom, dimensions.width, dimensions.height, cbX, cbY, cbW, cbH]);
    useEffect(() => {
        const container = containerRef.current?.parentElement;
        if (!container)
            return;
        const resizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                const { width, height } = entry.contentRect;
                const roundedWidth = Math.round(width);
                const roundedHeight = Math.round(height);
                setDimensions({ width: roundedWidth, height: roundedHeight });
            }
        });
        resizeObserver.observe(container);
        return () => {
            resizeObserver.disconnect();
        };
    }, []);
    // Smoothly animate zoom+pan to a target using RAF + ease-out cubic.
    // Reads current values from zoomStateRef so chained calls (rapid button clicks)
    // always start from the latest rendered position.
    const animateToViewport = useCallback((targetZoom, targetPan, duration = 150) => {
        if (animRafRef.current != null)
            cancelAnimationFrame(animRafRef.current);
        const { zoom: fromZoom, pan: fromPan } = zoomStateRef.current;
        const startTime = performance.now();
        isAnimatingRef.current = true;
        const step = (now) => {
            const t = Math.min((now - startTime) / duration, 1);
            const ease = 1 - Math.pow(1 - t, 3); // ease-out cubic
            const z = fromZoom + (targetZoom - fromZoom) * ease;
            const p = { x: fromPan.x + (targetPan.x - fromPan.x) * ease, y: fromPan.y + (targetPan.y - fromPan.y) * ease };
            if (t < 1) {
                // Drive the canvas imperatively mid-flight — no React re-render per frame.
                setGroupViewport(z, p);
                animRafRef.current = requestAnimationFrame(step);
            }
            else {
                animRafRef.current = null;
                isAnimatingRef.current = false;
                // Commit the final viewport to React state once the animation settles.
                setZoom(targetZoom);
                setPan(targetPan);
            }
        };
        animRafRef.current = requestAnimationFrame(step);
    }, [setGroupViewport]);
    // Cancel any in-progress animation on unmount.
    useEffect(() => () => {
        if (animRafRef.current != null)
            cancelAnimationFrame(animRafRef.current);
    }, []);
    // Convert stage-absolute pointer coords → content coords (accounts for zoom/pan).
    const toContentCoords = useCallback((stageX, stageY) => [(stageX - pan.x) / zoom, (stageY - pan.y) / zoom], [pan, zoom]);
    // Zoom toward the canvas center, clamped to [MIN_ZOOM, MAX_ZOOM], with smooth animation.
    // Reads current zoom/pan from zoomStateRef so rapid calls chain correctly mid-animation.
    const applyZoom = useCallback((newZoom) => {
        const clamped = Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, newZoom));
        const { zoom: currentZoom, pan: currentPan } = zoomStateRef.current;
        const cx = dimensions.width / 2;
        const cy = dimensions.height / 2;
        const zoomed = {
            x: cx - ((cx - currentPan.x) / currentZoom) * clamped,
            y: cy - ((cy - currentPan.y) / currentZoom) * clamped,
        };
        const targetPan = cbX != null && cbY != null && cbW != null && cbH != null
            ? constrainPan(zoomed, { x: cbX, y: cbY, width: cbW, height: cbH }, clamped, dimensions)
            : zoomed;
        animateToViewport(clamped, targetPan);
    }, [dimensions, cbX, cbY, cbW, cbH, animateToViewport]);
    // Expose zoom controls imperatively.
    useImperativeHandle(zoomRef ?? null, () => ({
        zoomIn: () => applyZoom(zoomStateRef.current.zoom * ZOOM_STEP),
        zoomOut: () => applyZoom(zoomStateRef.current.zoom / ZOOM_STEP),
        reset: ({ animate = true } = {}) => {
            const targetZoom = 1;
            const targetPan = cbX != null && cbY != null && cbW != null && cbH != null
                ? constrainPan({ x: 0, y: 0 }, { x: cbX, y: cbY, width: cbW, height: cbH }, targetZoom, dimensions)
                : { x: 0, y: 0 };
            if (animate) {
                animateToViewport(targetZoom, targetPan);
            }
            else {
                if (animRafRef.current != null) {
                    cancelAnimationFrame(animRafRef.current);
                    animRafRef.current = null;
                    isAnimatingRef.current = false;
                }
                setZoom(targetZoom);
                setPan(targetPan);
            }
        },
    }), [applyZoom, animateToViewport, dimensions, cbX, cbY, cbW, cbH]);
    // Drawing state machine
    const mergedDrawingStyle = useMemo(() => ({ ...DEFAULT_DRAWING_STYLE, ...drawingStyle }), [drawingStyle]);
    const { placedPoints, mousePos, nearCloseIndicator, handlePointPlaced, handleMouseMove, closeDrawing, cancelDrawing, } = useDrawing$1(drawingMode, onShapeComplete);
    // Expose imperative controls for toolbar buttons and keyboard shortcuts.
    useImperativeHandle(drawingRef ?? null, () => ({ closeDrawing, cancelDrawing }), [closeDrawing, cancelDrawing]);
    // Listen for Escape at the document level while drawing mode is active.
    useEffect(() => {
        if (drawingMode == null)
            return;
        const handler = (e) => {
            if (e.key === 'Escape')
                cancelDrawing();
        };
        document.addEventListener('keydown', handler);
        return () => document.removeEventListener('keydown', handler);
    }, [drawingMode, cancelDrawing]);
    // Pan cursor: managed via document.body so shapes can still show 'pointer' on hover
    // (same mechanism as useHover — avoids the div inline style overriding shape cursors).
    useEffect(() => {
        if (!canPan || drawingMode != null)
            return;
        prevBodyCursorRef.current = document.body.style.cursor;
        document.body.style.cursor = 'grab';
        return () => {
            document.body.style.cursor = prevBodyCursorRef.current;
        };
    }, [canPan, drawingMode]);
    // Cursor on the div: only drawing mode. Pan cursor lives on document.body (above).
    const cursor = drawingMode ? (nearCloseIndicator ? 'pointer' : 'crosshair') : undefined;
    const contextValue = useMemo(() => ({ stageRef, dimensions }), [dimensions]);
    return (jsx(TwoCanvasContext.Provider, { value: contextValue, children: jsx("div", { ref: containerRef, className: className, style: { width: '100%', height: '100%', ...style, cursor }, children: jsxs(Stage, { ref: stageRef, width: dimensions.width, height: dimensions.height, onMouseDown: (e) => {
                    if (!canPan || drawingMode != null)
                        return;
                    const pos = e.target.getStage()?.getPointerPosition();
                    if (!pos)
                        return;
                    panDragRef.current = { mouseX: pos.x, mouseY: pos.y, panX: pan.x, panY: pan.y };
                    document.body.style.cursor = 'grabbing';
                }, onMouseMove: (e) => {
                    const pos = e.target.getStage()?.getPointerPosition();
                    if (!pos)
                        return;
                    if (drawingMode != null) {
                        const [cx, cy] = toContentCoords(pos.x, pos.y);
                        const bounds = drawingBounds;
                        const x = bounds ? Math.max(bounds.x, Math.min(bounds.x + bounds.width, cx)) : cx;
                        const y = bounds ? Math.max(bounds.y, Math.min(bounds.y + bounds.height, cy)) : cy;
                        handleMouseMove([x, y]);
                        return;
                    }
                    if (canPan && panDragRef.current) {
                        const { mouseX, mouseY, panX, panY } = panDragRef.current;
                        const desired = { x: panX + (pos.x - mouseX), y: panY + (pos.y - mouseY) };
                        const next = cbX != null && cbY != null && cbW != null && cbH != null
                            ? constrainPan(desired, { x: cbX, y: cbY, width: cbW, height: cbH }, zoom, dimensions)
                            : desired;
                        // Move imperatively while dragging; commit to state on mouse up.
                        setGroupViewport(zoom, next);
                    }
                }, onMouseUp: () => {
                    if (!panDragRef.current)
                        return;
                    panDragRef.current = null;
                    document.body.style.cursor = canPan ? 'grab' : prevBodyCursorRef.current;
                    setPan(zoomStateRef.current.pan);
                }, onMouseLeave: () => {
                    if (!panDragRef.current)
                        return;
                    panDragRef.current = null;
                    setPan(zoomStateRef.current.pan);
                }, children: [backgroundColor && (jsx(Layer, { listening: false, children: jsx(CanvasRect, { x: 0, y: 0, width: dimensions.width, height: dimensions.height, fill: backgroundColor }) })), jsx(Layer, { children: jsx(Group, { ref: groupRef, scaleX: zoom, scaleY: zoom, x: pan.x, y: pan.y, children: children }) }), drawingMode != null && (jsx(DrawingLayer, { mode: drawingMode, placedPoints: placedPoints, mousePos: mousePos, nearCloseIndicator: nearCloseIndicator, style: mergedDrawingStyle, drawingBounds: drawingBounds, onPointPlaced: handlePointPlaced, zoom: zoom, pan: pan, toContentCoords: toContentCoords }))] }) }) }));
};
TwoCanvas.Rect = CanvasRect;
TwoCanvas.Circle = CanvasCircle;
TwoCanvas.Line = CanvasLine;
TwoCanvas.Polygon = CanvasPolygon;
TwoCanvas.Image = CanvasImage;

const Tooltip = forwardRef(function Tooltip(props, ref) {
    const { showArrow, children, disabled, portalled = true, label, contentProps, portalRef, ...rest } = props;
    if (disabled || !label)
        return children;
    return (jsxs(Tooltip$1.Root, { ...rest, children: [jsx(Tooltip$1.Trigger, { asChild: true, children: jsx("div", { children: children }) }), jsx(Portal, { disabled: !portalled, container: portalRef, children: jsx(Tooltip$1.Positioner, { children: jsxs(Tooltip$1.Content, { ref: ref, ...contentProps, children: [showArrow && (jsx(Tooltip$1.Arrow, { children: jsx(Tooltip$1.ArrowTip, {}) })), jsx(Fragment, { children: label })] }) }) })] }));
});

const ZoomToolbar = ({ onZoomIn, onZoomOut, onZoomReset }) => {
    const { t } = useTranslation();
    return (jsxs(Box, { position: "absolute", bottom: 2, right: 2, zIndex: 1, display: "flex", flexDirection: "row", gap: 0.5, bg: "whiteAlpha.900", backdropFilter: "blur(4px)", borderRadius: "md", p: 0.5, border: "1px solid", borderColor: "gray.200", shadow: "sm", children: [jsx(Tooltip, { label: t('ui.zoomOut'), positioning: { placement: 'top' }, showArrow: true, children: jsx(IconButton, { size: "xs", variant: "ghost", colorPalette: "gray", "aria-label": t('ui.zoomOut'), onClick: onZoomOut, children: jsx(Icon, { as: LuZoomOut, boxSize: 3.5 }) }) }), jsx(Separator, { orientation: "vertical", h: "auto" }), jsx(Tooltip, { label: t('ui.zoomReset'), positioning: { placement: 'top' }, showArrow: true, children: jsx(IconButton, { size: "xs", variant: "ghost", colorPalette: "gray", "aria-label": t('ui.zoomReset'), onClick: onZoomReset, children: jsx(Icon, { as: LuRotateCcw, boxSize: 3.5 }) }) }), jsx(Separator, { orientation: "vertical", h: "auto" }), jsx(Tooltip, { label: t('ui.zoomIn'), positioning: { placement: 'top' }, showArrow: true, children: jsx(IconButton, { size: "xs", variant: "ghost", colorPalette: "gray", "aria-label": t('ui.zoomIn'), onClick: onZoomIn, children: jsx(Icon, { as: LuZoomIn, boxSize: 3.5 }) }) })] }));
};

const ImageViewer = ({ eventDamages, allDamagePhotos, damage, photo, setFocusingPhotoId }) => {
    const { t } = useTranslation();
    const boxRef = useRef(null);
    const zoomRef = useRef(null);
    const [boxSize, setBoxSize] = useState({ width: 0, height: 0 });
    const [imgNatSize, setImgNatSize] = useState(null);
    // Track container size to compute contentBounds
    useEffect(() => {
        const el = boxRef.current;
        if (!el)
            return;
        const ro = new ResizeObserver(([entry]) => {
            const { width, height } = entry.contentRect;
            setBoxSize({ width, height });
        });
        ro.observe(el);
        return () => ro.disconnect();
    }, []);
    // Reset bounds on photo change; the real natural size arrives via TwoCanvas.Image's onLoad below,
    // reusing the image it already decodes rather than loading the full-res file a second time.
    useEffect(() => {
        setImgNatSize(null);
    }, [photo?.url]);
    // Compute the contain-fit rect in canvas coordinates — used to constrain pan
    const contentBounds = useMemo(() => {
        if (!imgNatSize || !boxSize.width || !boxSize.height)
            return undefined;
        const scale = Math.min(1, boxSize.width / imgNatSize.width, boxSize.height / imgNatSize.height);
        const drawW = imgNatSize.width * scale;
        const drawH = imgNatSize.height * scale;
        return {
            x: (boxSize.width - drawW) / 2,
            y: (boxSize.height - drawH) / 2,
            width: drawW,
            height: drawH,
        };
    }, [imgNatSize, boxSize]);
    // Reset view when switching photos
    useEffect(() => {
        zoomRef.current?.reset({ animate: false });
    }, [photo?.photo_id]);
    // Sorted photos for prev/next navigation
    const spanPhotos = useMemo(() => {
        const spanDamages = eventDamages?.filter((d) => d.span_id === photo?.span_id).sort((a, b) => (a.order || 0) - (b.order || 0)) || [];
        return allDamagePhotos
            .filter((p) => p.span_id === photo?.span_id)
            .sort((a, b) => spanDamages.findIndex((d) => d.damage_id === a.damage_id) -
            spanDamages.findIndex((d) => d.damage_id === b.damage_id));
    }, [eventDamages, photo?.span_id, allDamagePhotos]);
    const { prevPhoto, nextPhoto } = useMemo(() => {
        const currentIndex = spanPhotos.findIndex((p) => p.photo_id === photo?.photo_id);
        return {
            prevPhoto: currentIndex > 0 ? spanPhotos[currentIndex - 1] : null,
            nextPhoto: currentIndex < spanPhotos.length - 1 ? spanPhotos[currentIndex + 1] : null,
        };
    }, [spanPhotos, photo?.photo_id]);
    // Warm the browser cache for the adjacent photos so prev/next navigation paints instantly.
    useEffect(() => {
        [prevPhoto, nextPhoto].forEach((neighbor) => {
            if (!neighbor?.url)
                return;
            const img = new window.Image();
            img.src = neighbor.url;
        });
    }, [prevPhoto, nextPhoto]);
    return (jsxs(Box, { ref: boxRef, flex: "1", borderRight: "1px solid", borderColor: "gray.200", position: "relative", overflow: "hidden", children: [!damage && photo?.caption ? (jsx(Box, { position: "absolute", w: "full", top: 2, left: 0, px: 2, py: 1, zIndex: 1, pointerEvents: "none", children: jsxs(Box, { borderRadius: "md", color: "gray.900", fontSize: "sm", bg: "whiteAlpha.700", px: 2, pt: 2, pb: 1, backdropFilter: "blur(4px)", children: [jsx(Text$2, { fontSize: "0.6rem", lineHeight: 1, color: "gray.500", textTransform: "uppercase", letterSpacing: "widest", children: t('object.defectPhotos.memo') }), jsx(Text$2, { fontSize: "sm", children: photo?.caption })] }) })) : null, jsx(TwoCanvas, { backgroundColor: "#111827", enablePan: true, zoomRef: zoomRef, contentBounds: contentBounds, children: photo?.url ? (jsx(TwoCanvas.Image, { src: photo.url, objectFit: "natural", onLoad: (width, height) => setImgNatSize({ width, height }) })) : null }), jsx(IconButton, { position: "absolute", left: 3, top: "50%", transform: "translateY(-50%)", title: t('section.deliverables.damagePhotos.lightbox.previousPhoto'), size: "md", borderRadius: "full", bg: "white/80", _hover: { bg: 'white' }, color: "gray.800", shadow: "md", disabled: !prevPhoto, onClick: (e) => {
                    e.stopPropagation();
                    setFocusingPhotoId(prevPhoto?.photo_id || null);
                }, children: jsx(Icon, { as: LuChevronLeft, boxSize: 6 }) }), jsx(IconButton, { position: "absolute", right: 3, top: "50%", transform: "translateY(-50%)", title: t('section.deliverables.damagePhotos.lightbox.nextPhoto'), size: "md", borderRadius: "full", bg: "white/80", _hover: { bg: 'white' }, color: "gray.800", shadow: "md", disabled: !nextPhoto, onClick: (e) => {
                    e.stopPropagation();
                    setFocusingPhotoId(nextPhoto?.photo_id || null);
                }, children: jsx(Icon, { as: LuChevronRight, boxSize: 6 }) }), jsx(ZoomToolbar, { onZoomIn: () => zoomRef.current?.zoomIn(), onZoomOut: () => zoomRef.current?.zoomOut(), onZoomReset: () => zoomRef.current?.reset() })] }));
};
var ImageViewer$1 = memo(ImageViewer);

/**
 * One label/value pair. The two cells are separate grid items rather than a nested flex row so the
 * label column sizes to the longest label in it — a fixed percentage clips the longer English labels
 * ("INSPECTION DATE") that the shorter Japanese ones fit inside.
 */
const Property = ({ label, value }) => (jsxs(Fragment, { children: [jsx(GridItem, { px: 2, py: 1.5, bg: "gray.50/80", color: "gray.500", fontWeight: "semibold", textTransform: "uppercase", letterSpacing: "wider", fontSize: "8.5px", borderRight: "1px solid {colors.gray.100}", borderBottom: "1px solid {colors.gray.100}", whiteSpace: "nowrap", display: "flex", alignItems: "center", children: label }), jsx(GridItem, { px: 2, py: 1.5, color: "gray.800", fontSize: "xs", fontWeight: "medium", borderRight: "1px solid {colors.gray.100}", borderBottom: "1px solid {colors.gray.100}", minW: 0, wordBreak: "break-word", display: "flex", alignItems: "center", children: jsx(Fragment, { children: value }) })] }));
const RightSidebar = ({ damage, previousDamage, photo }) => {
    // Hooks
    const { t } = useTranslation();
    if (!damage || !photo)
        return null;
    // Derived states. Every field mirrors the Deliverables photo card, so the pane and the card it
    // zooms into stay in step.
    const damageTypeLabel = t(`object.defectType.${damage.facility_type}.${camelCase(damage.damage_type)}`);
    return (jsxs(VStack, { flex: "0 0 400px", bg: "white", overflowY: "auto", align: "stretch", gap: 0, children: [jsx(HStack, { justify: "space-between", gap: 2, px: 4, py: 2, color: "gray.800", fontSize: "sm", fontWeight: "semibold", letterSpacing: "wide", flexShrink: 0, style: { backgroundColor: 'rgb(238, 242, 246)' }, children: jsxs(Box, { truncate: true, minW: 0, children: [jsx(Span, { color: "gray.900", children: damageTypeLabel }), jsx(Span, { color: "gray.400", mx: 1.5, children: "\u00B7" }), jsx(Span, { color: "gray.600", fontWeight: "medium", children: damage.damage_name })] }) }), jsxs(Grid, { w: "full", templateColumns: "auto minmax(0, 1fr) auto minmax(0, 1fr)", children: [jsx(Property, { label: t('section.deliverables.defectPhotos.photoNo'), value: jsx(Span, { color: "gray.900", fontWeight: "bold", fontVariantNumeric: "tabular-nums", children: photo.photo_number ?? '-' }) }), jsx(Property, { label: t('object.span.inspectionDate'), value: jsx(Box, { color: "gray.700", fontSize: "xs", fontVariantNumeric: "tabular-nums", children: damage.inspection_date ? new Date(damage.inspection_date).toLocaleDateString() : '-' }) }), jsx(Property, { label: t('section.deliverables.defectPhotos.memberName'), value: jsx(Box, { color: "gray.800", fontSize: "xs", fontWeight: "medium", children: damage.damage_name || '-' }) }), jsx(Property, { label: t('section.deliverables.defectPhotos.elementNo'), value: jsx(Box, { color: "gray.700", fontSize: "xs", fontVariantNumeric: "tabular-nums", children: damage.element_number || '-' }) }), jsx(Property, { label: t('object.defectType._single'), value: jsx(Box, { color: "gray.800", fontSize: "xs", fontWeight: "medium", children: damageTypeLabel }) }), jsx(Property, { label: t('object.severity._single'), value: jsx(Box, { display: "flex", alignItems: "center", justifyContent: "center", w: "full", children: jsx(SeverityBadge, { grade: damage.severity, size: "sm" }) }) })] }), jsxs(VStack, { flex: 1, minH: 0, overflowY: "auto", align: "stretch", gap: 0, children: [jsx(Box, { px: 3, py: 1.5, bg: "gray.50/80", color: "gray.500", fontWeight: "semibold", textTransform: "uppercase", letterSpacing: "wider", fontSize: "8.5px", borderY: "1px solid {colors.gray.100}", children: t('section.inspectionItem.detail.previousSeverity') }), jsx(Box, { display: "flex", alignItems: "center", justifyContent: "center", py: 3, borderBottom: "1px solid {colors.gray.100}", children: jsx(Box, { opacity: 0.7, children: previousDamage ? jsx(SeverityBadge, { grade: previousDamage.severity, size: "sm" }) : '-' }) }), jsx(Box, { px: 3, py: 1.5, bg: "gray.50/80", color: "gray.500", fontWeight: "semibold", textTransform: "uppercase", letterSpacing: "wider", fontSize: "8.5px", borderBottom: "1px solid {colors.gray.100}", children: t('object.defectPhotos.memo') }), jsx(Box, { px: 3, py: 2.5, color: "gray.700", fontSize: "xs", whiteSpace: "pre-line", lineHeight: "relaxed", wordBreak: "break-word", flex: 1, children: jsx(Text$2, { as: "span", color: "gray.600", children: photo.caption || '-' }) })] })] }));
};
var RightSidebar$1 = memo(RightSidebar);

const dividerRecipe = defineSlotRecipe({
    className: 'divider',
    slots: ['root', 'line', 'label'],
    base: {
        root: {
            display: 'flex',
            justifyContent: 'center',
            position: 'relative',
        },
        line: {
            borderWidth: 0,
            position: 'absolute',
        },
        label: {
            w: 'fit-content',
            bg: 'white',
            border: '1px solid {colors.gray.300}',
            borderRadius: 'full',
            px: 3,
            py: 1,
            fontSize: 'xs',
            fontWeight: 'semibold',
            color: 'gray.500',
            zIndex: 1,
        },
    },
    variants: {
        variant: {
            horizontal: {
                root: {
                    flexDirection: 'row',
                    alignItems: 'center',
                    w: 'full',
                },
                line: {
                    borderBottom: '1px solid {colors.gray.200}',
                    w: 'full',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                },
            },
            vertical: {
                root: {
                    flexDirection: 'column',
                    alignItems: 'center',
                    h: 'full',
                },
                line: {
                    borderRight: '1px solid {colors.gray.200}',
                    h: 'full',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                },
            },
        },
    },
    defaultVariants: {
        variant: 'horizontal',
    },
});
const { withProvider: withProvider$2, withContext: withContext$2 } = createSlotRecipeContext({ recipe: dividerRecipe });
const DividerRoot = withProvider$2('div', 'root');
const DividerLine = withContext$2('hr', 'line');
const DividerLabel = withContext$2('span', 'label');

/**
 * Divider - A thin rule styled with the design system's gray border.
 *
 * Renders as a full-width `<hr>` with a 1px border. Can be oriented horizontally (default) or vertically.
 *
 * @example
 * <VStack>
 *   <Text>Section A</Text>
 *   <Divider />
 *   <Text>Section B</Text>
 * </VStack>
 *
 * @example
 * // With label
 * <Divider label="OR" />
 *
 * @example
 * // Vertical divider
 * <HStack h="100px">
 *   <Text>Left</Text>
 *   <Divider orientation="vertical" />
 *   <Text>Right</Text>
 * </HStack>
 */
const Divider = ({ label, children, ...props }) => (jsx(DividerRoot, { ...props, children: children ?? jsx(DividerLine, {}) }));

const Thumbnails = ({ eventDamages, allDamagePhotos, photo, setFocusingPhotoId }) => {
    // Derived states
    const spanDamages = useMemo(() => eventDamages?.filter((d) => d.span_id === photo?.span_id).sort((a, b) => (a.order || 0) - (b.order || 0)) || [], [eventDamages, photo?.span_id]);
    const damagePhotosByDamageId = useMemo(() => {
        const photosByDamage = {};
        spanDamages.forEach((damage) => {
            photosByDamage[damage.damage_id] = allDamagePhotos.filter((p) => p.damage_id === damage.damage_id && p.photo_category === 'damage' && p.project_id === damage.project_id);
        });
        return photosByDamage;
    }, [spanDamages, allDamagePhotos]);
    return (jsx(Flex, { bg: "gray.100", borderTop: "1px solid", borderColor: "gray.200", overflowX: "auto", overflowY: "hidden", borderBottomRadius: "md", alignItems: "center", py: 2, pb: 4, children: jsx(HStack, { h: 24, gap: 2.5, px: 5, flexWrap: "nowrap", children: spanDamages.map((damage, index) => {
                const photos = damagePhotosByDamageId[damage.damage_id] || [];
                const previousDamage = spanDamages[index - 1];
                const isNewDamage = previousDamage?.damage_id !== damage.damage_id && index < spanDamages.length - 1;
                if (photos.length === 0)
                    return null;
                return (jsxs(Fragment$1, { children: [jsxs(VStack, { alignItems: "flex-start", gap: 0, children: [jsx(Text$2, { px: 1.5, fontSize: "xs", lineHeight: "1.25", h: "2.5em", lineClamp: 2, children: damage.damage_name }), jsx(HStack, { gap: 1.5, children: photos.map((thumb) => (jsx(Box, { w: 20, h: 14, rounded: "md", flexShrink: 0, flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 0.5, cursor: "pointer", transition: "all 0.2s", overflow: "hidden", border: "1px solid transparent", shadow: thumb.photo_id === photo?.photo_id ? '0 0 0 2px {colors.blue.500}' : 'none', borderColor: thumb.photo_id === photo?.photo_id ? 'whiteAlpha.100' : 'transparent', _hover: { ringColor: 'gray.300', scale: 1.1 }, onClick: (e) => {
                                            e.stopPropagation();
                                            setFocusingPhotoId(thumb.photo_id, true);
                                        }, children: jsx(Image$3, { borderRadius: "md", alt: thumb.original_filename, w: "full", h: "full", objectFit: "cover", src: thumb.thumbnail_url }) }, `lightbox-thumbnail-${thumb.photo_id}`))) })] }), isNewDamage && (jsx(Divider, { h: "80%", variant: "vertical", mx: 1, children: jsx(DividerLine, { borderColor: "gray.400" }) }))] }, `lightbox-damage-${damage.damage_id}`));
            }) }) }));
};
var Thumbnails$1 = memo(Thumbnails);

const Body = (props) => {
    return (jsxs(Flex, { h: "full", w: "full", align: "stretch", direction: "column", position: "relative", children: [jsxs(HStack, { flex: 1, minH: 0, align: "stretch", gap: 0, children: [jsx(ImageViewer$1, { ...props }), jsx(RightSidebar$1, { ...props })] }), jsx(Thumbnails$1, { ...props })] }));
};

const Lightbox = (props) => {
    const { focusingPhotoId, setFocusingPhotoId, facility, event, isLoadingDamagePhotos, allDamagePhotos, eventDamages } = props;
    // Hooks
    const { t } = useTranslation$1();
    const isLoading = isLoadingDamagePhotos || !facility || !event;
    // Derived states
    const photo = allDamagePhotos?.find((d) => d.photo_id === focusingPhotoId);
    const damage = eventDamages?.find((d) => d.damage_id === photo?.damage_id && d.span_id === photo?.span_id);
    // Only "missing" once everything has settled — otherwise the error flashes while data is still loading.
    const missingData = !isLoading && (!event?.event_type || !damage || !photo);
    return (jsx(Dialog.Root, { lazyMount: true, size: "cover", open: !!focusingPhotoId, onOpenChange: ({ open }) => {
            if (open)
                return;
            setFocusingPhotoId(null);
        }, children: jsxs(Portal, { children: [jsx(Dialog.Backdrop, {}), jsx(Dialog.Positioner, { children: jsxs(Dialog.Content, { display: "flex", flexDirection: "column", maxH: "100dvh", children: [!isLoading && facility && event?.event_type ? (jsxs(Dialog.Header, { borderBottom: "1px solid", borderColor: "gray.200", justifyContent: "space-between", children: [jsxs(HStack, { gap: 2, minW: 0, fontSize: "sm", children: [jsx(Text$2, { fontWeight: "semibold", fontSize: "xl", color: "gray.800", truncate: true, children: t('section.deliverables.damagePhotos.lightbox.title') }), jsx(Text$2, { color: "gray.300", children: "\u00B7" }), jsx(Text$2, { color: "gray.600", truncate: true, children: facility.facility_name }), jsx(Text$2, { color: "gray.300", children: "\u00B7" }), jsxs(Text$2, { color: "gray.600", truncate: true, children: [event.project_name, " (", t(`object.eventType.${camelCase(event.event_type)}`), ")"] })] }), jsx(DialogCloser, {})] })) : null, jsxs(Dialog.Body, { display: "flex", alignItems: "center", justifyContent: "center", p: 0, flex: 1, minH: 0, children: [isLoading ? jsx(Spinner, { size: "lg" }) : null, missingData ? jsx(Text$2, { children: t('section.deliverables.damagePhotos.lightbox.loadingError') }) : null, !isLoading && !missingData && damage && photo ? jsx(Body, { ...props }) : null] })] }) })] }) }));
};

const SectionTitle = ({ children, fontSize = 'lg', ...props }) => (jsxs(HStack, { position: "relative", mx: 0, ...props, children: [jsx(Text$2, { display: "inline-block", position: "relative", zIndex: 5, pe: 2, fontWeight: "bold", whiteSpace: "nowrap", overflow: "visible", mx: 0, fontSize: fontSize, children: children }), jsx(Divider, {})] }));

const ToggleField$1 = ({ id, label, value, disabled = false, tooltip, onChange }) => {
    const ref = useRef(null);
    return (jsxs(HStack, { w: "100%", ref: ref, children: [jsx(Tooltip, { label: tooltip, showArrow: true, positioning: { placement: 'top-start' }, portalRef: ref, children: jsx(Box, { children: jsxs(Switch.Root, { w: "50px", colorPalette: "blue", checked: value, onCheckedChange: (e) => onChange(e.checked), disabled: disabled, children: [jsx(Switch.HiddenInput, {}), jsx(Switch.Control, {})] }) }) }), jsx(Text$2, { flex: 1, children: label })] }, `toggle-props-${id}`));
};

const TOLERANCE_FIELD_CLOSED_HEIGHT = '52px';
const ToleranceTypeLabel = {
    [ProjectSheetToleranceType.WithinTolerance]: '設計値±規格値',
    [ProjectSheetToleranceType.GteDesignedValue]: '設計値以上',
    [ProjectSheetToleranceType.LteDesignedValue]: '設計値以下',
    [ProjectSheetToleranceType.AsymmetricTolerance]: '設計値±規格値(非対称)',
};
const ToleranceField = ({ icon, title, enabled, additionalFields = [], expanded = false, expandable = true, toleranceType, extraContent, onToggle, onChangeToleranceType, }) => {
    const [isExpanded, setIsExpanded] = useState(expanded);
    useEffect(() => {
        setIsExpanded(expanded);
    }, [expanded]);
    return (jsxs(Box, { borderWidth: "1px", borderColor: enabled ? 'blue.500' : 'gray.300', borderRadius: 6, overflow: "hidden", maxHeight: isExpanded ? '300px' : TOLERANCE_FIELD_CLOSED_HEIGHT, transition: "max-height 0.3s ease", mb: 2.5, children: [jsxs(Flex, { p: 2, alignItems: "center", height: TOLERANCE_FIELD_CLOSED_HEIGHT, cursor: expandable ? 'pointer' : 'default', _hover: expandable ? { bg: 'gray.100' } : undefined, onClick: expandable ? () => setIsExpanded(!isExpanded) : undefined, gap: 2, children: [icon, jsx(Text$2, { flex: 1, fontSize: "xl", children: title }), jsxs(Switch.Root, { colorPalette: "blue", checked: enabled, onCheckedChange: (e) => onToggle(Boolean(e.checked)), onClick: (e) => e.stopPropagation(), children: [jsx(Switch.HiddenInput, {}), jsx(Switch.Control, {})] })] }), jsxs(Box, { bg: "gray.50", px: 4, py: 2, borderBottomRadius: 6, children: [extraContent, toleranceType !== undefined && (jsxs(HStack, { children: [jsx(Text$2, { children: "\u8A31\u5BB9\u8A2D\u5B9A" }), jsx(Spacer, {}), jsxs(Menu.Root, { lazyMount: true, positioning: { placement: 'bottom-end' }, children: [jsx(Menu.Trigger, { asChild: true, children: jsxs(Button, { fontWeight: "normal", variant: "outline", size: "sm", bg: "white", justifyContent: "space-between", children: [ToleranceTypeLabel[toleranceType], jsx(ChevronDownIcon, {})] }) }), jsx(Portal, { children: jsx(Menu.Positioner, { children: jsxs(Menu.Content, { children: [jsx(Menu.Item, { value: ProjectSheetToleranceType.WithinTolerance, onSelect: onChangeToleranceType
                                                            ? () => onChangeToleranceType(ProjectSheetToleranceType.WithinTolerance)
                                                            : undefined, children: ToleranceTypeLabel.within_tolerance }), jsx(Menu.Item, { value: ProjectSheetToleranceType.AsymmetricTolerance, onSelect: onChangeToleranceType
                                                            ? () => onChangeToleranceType(ProjectSheetToleranceType.AsymmetricTolerance)
                                                            : undefined, children: ToleranceTypeLabel.asymmetric_tolerance }), jsx(Menu.Item, { value: ProjectSheetToleranceType.GteDesignedValue, onSelect: onChangeToleranceType
                                                            ? () => onChangeToleranceType(ProjectSheetToleranceType.GteDesignedValue)
                                                            : undefined, children: ToleranceTypeLabel.gte_designed_value }), jsx(Menu.Item, { value: ProjectSheetToleranceType.LteDesignedValue, onSelect: onChangeToleranceType
                                                            ? () => onChangeToleranceType(ProjectSheetToleranceType.LteDesignedValue)
                                                            : undefined, children: ToleranceTypeLabel.lte_designed_value })] }) }) })] })] })), additionalFields.length > 0 && (jsxs(Fragment, { children: [jsx(Text$2, { my: 2, children: "\u8FFD\u52A0\u306E\u30C7\u30FC\u30BF\u30DD\u30A4\u30F3\u30C8" }), jsx(VStack, { bg: "white", py: 3, px: 5, borderColor: "gray.300", borderWidth: 1, borderRadius: 6, children: additionalFields.map((field) => (jsx(ToggleField$1, { ...field, disabled: !enabled }, field.id))) })] }))] })] }));
};

const CoverThicknessAggregateLabel = {
    [CoverThicknessAggregate.Min]: '最小',
    [CoverThicknessAggregate.Max]: '最大',
    [CoverThicknessAggregate.Avg]: '平均',
};
const COVER_THICKNESS_AGGREGATES = [
    CoverThicknessAggregate.Min,
    CoverThicknessAggregate.Max,
    CoverThicknessAggregate.Avg,
];
/**
 * Single-select for which aggregate (最小 / 最大 / 平均) a cover-thickness row uses.
 */
const CoverThicknessValueSelect = ({ value, onChange }) => (jsxs(HStack, { mb: 2, children: [jsx(Text$2, { children: "\u8A08\u6E2C\u5024" }), jsx(Spacer, {}), jsxs(Menu.Root, { lazyMount: true, positioning: { placement: 'bottom-end' }, children: [jsx(Menu.Trigger, { asChild: true, children: jsxs(Button, { fontWeight: "normal", variant: "outline", size: "sm", bg: "white", justifyContent: "space-between", children: [CoverThicknessAggregateLabel[value], jsx(ChevronDownIcon, {})] }) }), jsx(Portal, { children: jsx(Menu.Positioner, { children: jsx(Menu.Content, { children: COVER_THICKNESS_AGGREGATES.map((type) => (jsx(Menu.Item, { value: type, onSelect: () => onChange(type), children: CoverThicknessAggregateLabel[type] }, type))) }) }) })] })] }));

const ToggleField = ({ id, label, value, disabled = false, tooltip, onChange }) => {
    const ref = useRef(null);
    return (jsxs(HStack, { w: "100%", ref: ref, children: [jsx(Tooltip, { label: tooltip, showArrow: true, positioning: { placement: 'top-start' }, portalRef: ref, children: jsx(Box, { children: jsxs(Switch.Root, { w: "50px", colorPalette: "blue", checked: value, onCheckedChange: (e) => onChange(e.checked), disabled: disabled, children: [jsx(Switch.HiddenInput, {}), jsx(Switch.Control, {})] }) }) }), jsx(Text$2, { flex: 1, children: label })] }, `toggle-props-${id}`));
};

const ProjectSheetItemsOrderText = {
    [ProjectSheetItemsOrder.Name]: '要素名',
    [ProjectSheetItemsOrder.CreatedAt]: '作成日時順',
    [ProjectSheetItemsOrder.CustomOrder]: '3D画面で設定したカスタム順',
};
const InspectionSheetSettings = ({ settings, onChange }) => {
    /**
     * Predefined data points for depth.
     */
    const depthDataPoints = [
        {
            id: 'min_grid_depth',
            label: '最小',
            value: settings.sheet_rows_visibility?.min_grid_depth || false,
            onChange: () => {
                onChange({
                    sheet_rows_visibility: { min_grid_depth: !settings.sheet_rows_visibility?.min_grid_depth },
                });
            },
        },
        {
            id: 'max_grid_depth',
            label: '最大',
            value: settings.sheet_rows_visibility?.max_grid_depth || false,
            onChange: () => {
                onChange({
                    sheet_rows_visibility: { max_grid_depth: !settings.sheet_rows_visibility?.max_grid_depth },
                });
            },
        },
    ];
    /**
     * Sub-option for 頂点間の長さ: also show the edge length value next to its index label (L1=123).
     */
    const edgeLengthDataPoints = [
        {
            id: 'edge_length_with_value',
            label: '値も表示 (L1=123)',
            value: settings.sheet_rows_visibility?.edge_length_with_value || false,
            onChange: () => {
                onChange({
                    sheet_rows_visibility: {
                        edge_length_with_value: !settings.sheet_rows_visibility?.edge_length_with_value,
                    },
                });
            },
        },
    ];
    /**
     * Determines the order type for items in the inspection sheet.
     */
    const orderType = useMemo(() => {
        // If the order type is somehow set to InspectionGroup, even through grouping is off, fallback to CreatedAt
        if (!settings.sheet_use_inspection_group_order &&
            settings.sheet_order_type_of_items === ProjectSheetItemsOrder.CustomOrder) {
            return ProjectSheetItemsOrder.CreatedAt;
        }
        // Otherwise, return the order type set in settings or default to CreatedAt
        return settings.sheet_order_type_of_items || ProjectSheetItemsOrder.CreatedAt;
    }, [settings]);
    return (jsxs(Fragment, { children: [jsx(SectionTitle, { children: "\u691C\u51FA\u3057\u305F\u8981\u7D20\u306E\u8868\u793A/\u975E\u8868\u793A" }), jsx(Text$2, { mt: 2, fontSize: "md", children: "\u8868\u793A\u8A2D\u5B9A\u306F\u51FA\u529B\u3055\u308C\u308B\u30D5\u30A1\u30A4\u30EB\u306B\u3082\u9069\u7528\u3055\u308C\u307E\u3059\u3002" }), jsxs(Box, { mt: 3, className: "setting-group", children: [jsx(ToleranceField, { icon: jsx(Icon, { as: SvgToolbarVolumeEstimationPolygon, boxSize: 5, className: "icon-black" }), expandable: false, title: "\u4F53\u7A4D\u30E2\u30C7\u30EB", enabled: settings.sheet_models_visibility?.volume || false, onToggle: () => onChange({
                            sheet_models_visibility: { volume: !settings.sheet_models_visibility?.volume },
                        }) }), jsx(ToleranceField, { icon: jsx(Icon, { as: SvgToolbarPlane, boxSize: 5, className: "icon-black" }), expandable: false, title: "\u9762\u7A4D\u30E2\u30C7\u30EB", enabled: settings.sheet_models_visibility?.plane || false, onToggle: () => onChange({
                            sheet_models_visibility: { plane: !settings.sheet_models_visibility?.plane },
                        }) }), jsx(ToleranceField, { icon: jsx(Icon, { as: SvgToolbarDistance, boxSize: 5, className: "icon-black" }), expandable: false, title: "\u624B\u52D5\u8A08\u6E2C\u3057\u305F\u8DDD\u96E2", enabled: settings.sheet_models_visibility?.length_with_distance_tool || false, expanded: settings.sheet_models_visibility?.length_with_distance_tool || false, toleranceType: settings.sheet_rows_tolerance_type?.length_with_distance_tool, onToggle: () => onChange({
                            sheet_models_visibility: {
                                length_with_distance_tool: !settings.sheet_models_visibility?.length_with_distance_tool,
                            },
                        }), onChangeToleranceType: (type) => {
                            onChange({
                                sheet_rows_tolerance_type: {
                                    length_with_distance_tool: type,
                                },
                            });
                        } }), jsx(ToleranceField, { icon: jsx(Icon, { as: SvgToolbarPolyline, boxSize: 5, className: "icon-black" }), expandable: false, title: "\u5EF6\u9577", enabled: settings.sheet_models_visibility?.polyline || false, expanded: settings.sheet_models_visibility?.polyline || false, toleranceType: settings.sheet_rows_tolerance_type?.polyline_length, onToggle: () => onChange({
                            sheet_models_visibility: {
                                polyline: !settings.sheet_models_visibility?.polyline,
                            },
                        }), onChangeToleranceType: (type) => {
                            onChange({
                                sheet_rows_tolerance_type: {
                                    polyline_length: type,
                                },
                            });
                        } })] }), jsx(Spacer, { my: 8 }), jsx(SectionTitle, { children: "\u691C\u51FA\u8981\u7D20\u306E\u9806\u5E8F" }), jsx(Text$2, { my: 2, fontSize: "md", children: "\u691C\u67FB\u5E33\u7968\u3067\u306E\u8981\u7D20\u306E\u4E26\u3073\u9806\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044" }), jsxs(Box, { className: "setting-group", children: [jsx(ToleranceField, { icon: jsx(InspectionGroupIcon, { className: "icon-black", fontSize: "1.5em" }), expandable: false, title: "\u691C\u67FB\u30B0\u30EB\u30FC\u30D7\u306E\u9806\u5E8F\u3092\u4F7F\u7528", enabled: settings.sheet_use_inspection_group_order || false, onToggle: () => onChange({
                            sheet_use_inspection_group_order: !settings.sheet_use_inspection_group_order,
                        }) }), jsxs(Menu.Root, { positioning: { sameWidth: true }, children: [jsx(Menu.Trigger, { asChild: true, children: jsxs(Button, { fontWeight: "normal", variant: "outline", size: "sm", bg: "white", w: "100%", mt: 2, textAlign: "left", justifyContent: "space-between", children: [ProjectSheetItemsOrderText[orderType], jsx(ChevronDownIcon, {})] }) }), jsx(Portal, { children: jsx(Menu.Positioner, { children: jsxs(Menu.Content, { children: [jsx(Menu.Item, { value: ProjectSheetItemsOrder.CustomOrder, onSelect: () => onChange({
                                                    sheet_order_type_of_items: ProjectSheetItemsOrder.CustomOrder,
                                                }), disabled: !settings.sheet_use_inspection_group_order, children: ProjectSheetItemsOrderText[ProjectSheetItemsOrder.CustomOrder] }), jsx(Menu.Item, { value: ProjectSheetItemsOrder.Name, onSelect: () => onChange({
                                                    sheet_order_type_of_items: ProjectSheetItemsOrder.Name,
                                                }), children: ProjectSheetItemsOrderText[ProjectSheetItemsOrder.Name] }), jsx(Menu.Item, { value: ProjectSheetItemsOrder.CreatedAt, onSelect: () => onChange({
                                                    sheet_order_type_of_items: ProjectSheetItemsOrder.CreatedAt,
                                                }), children: ProjectSheetItemsOrderText[ProjectSheetItemsOrder.CreatedAt] })] }) }) })] })] }), jsx(Spacer, { my: 8 }), jsx(SectionTitle, { children: "\u5217\u306E\u8868\u793A/\u975E\u8868\u793A" }), jsx(Text$2, { mt: 2, fontSize: "md", children: "\u8868\u793A\u8A2D\u5B9A\u306F\u51FA\u529B\u3055\u308C\u308B\u30D5\u30A1\u30A4\u30EB\u306B\u3082\u9069\u7528\u3055\u308C\u307E\u3059\u3002" }), jsxs(VStack, { borderColor: "gray.300", borderWidth: 1, borderRadius: 6, mt: 3, py: 3, px: 4, className: "setting-group", children: [jsx(ToggleField, { id: "estimated_value", label: "\u5B9F\u6E2C\u5024", value: settings.sheet_cols_visibility?.estimated_value || false, onChange: () => onChange({
                            sheet_cols_visibility: { estimated_value: !settings.sheet_cols_visibility?.estimated_value },
                        }), tooltip: "\u5B9F\u6E2C\u5024\u306F\u975E\u8868\u793A\u306B\u3067\u304D\u307E\u305B\u3093", disabled: true }), jsx(ToggleField, { id: "tolerance", label: "\u898F\u683C\u5024", value: settings.sheet_cols_visibility?.tolerance || false, onChange: () => onChange({
                            sheet_cols_visibility: { tolerance: !settings.sheet_cols_visibility?.tolerance },
                        }) }), jsx(ToggleField, { id: "designed_value", label: "\u8A2D\u8A08\u5024\u30FB\u5DEE", value: settings.sheet_cols_visibility?.designed_value || false, onChange: () => onChange({
                            sheet_cols_visibility: { designed_value: !settings.sheet_cols_visibility?.designed_value },
                        }) }), jsx(ToggleField, { id: "plane_diagram", label: "\u5E73\u9762\u56F3", value: settings.sheet_diagram_visibility?.plane_diagram || false, onChange: () => onChange({
                            sheet_diagram_visibility: { plane_diagram: !settings.sheet_diagram_visibility?.plane_diagram },
                        }) }), jsx(ToggleField, { id: "grid_diagram", label: "\u6DF1\u3055\u30B0\u30EA\u30C3\u30C9", value: settings.sheet_diagram_visibility?.grid_diagram || false, onChange: () => onChange({
                            sheet_diagram_visibility: { grid_diagram: !settings.sheet_diagram_visibility?.grid_diagram },
                        }) }), jsx(ToggleField, { id: "polyline_diagram", label: "\u5EF6\u9577\u56F3", value: settings.sheet_diagram_visibility?.polyline_diagram || false, onChange: () => onChange({
                            sheet_diagram_visibility: {
                                polyline_diagram: !settings.sheet_diagram_visibility?.polyline_diagram,
                            },
                        }) })] }), jsx(Spacer, { my: 8 }), jsx(SectionTitle, { children: "\u884C\u306E\u8868\u793A/\u975E\u8868\u793A" }), jsx(Text$2, { mt: 2, fontSize: "md", children: "\u8868\u793A\u8A2D\u5B9A\u306F\u51FA\u529B\u3055\u308C\u308B\u30D5\u30A1\u30A4\u30EB\u306B\u3082\u9069\u7528\u3055\u308C\u307E\u3059\u3002" }), jsxs(Box, { mt: 3, className: "setting-group", children: [jsx(ToleranceField, { expandable: false, title: "\u8FBA\u306E\u9577\u30551", enabled: settings.sheet_rows_visibility?.polygon_length_1 || false, expanded: settings.sheet_rows_visibility?.polygon_length_1 || false, toleranceType: settings.sheet_rows_tolerance_type?.polygon_length_1, onToggle: () => onChange({
                            sheet_rows_visibility: { polygon_length_1: !settings.sheet_rows_visibility?.polygon_length_1 },
                        }), onChangeToleranceType: (type) => {
                            onChange({
                                sheet_rows_tolerance_type: {
                                    polygon_length_1: type,
                                },
                            });
                        } }), jsx(ToleranceField, { expandable: false, title: "\u8FBA\u306E\u9577\u30552", enabled: settings.sheet_rows_visibility?.polygon_length_2 || false, expanded: settings.sheet_rows_visibility?.polygon_length_2 || false, toleranceType: settings.sheet_rows_tolerance_type?.polygon_length_2, onToggle: () => onChange({
                            sheet_rows_visibility: { polygon_length_2: !settings.sheet_rows_visibility?.polygon_length_2 },
                        }), onChangeToleranceType: (type) => {
                            onChange({
                                sheet_rows_tolerance_type: {
                                    polygon_length_2: type,
                                },
                            });
                        } }), jsx(ToleranceField, { expandable: false, additionalFields: edgeLengthDataPoints, title: "\u9802\u70B9\u9593\u306E\u9577\u3055", enabled: settings.sheet_rows_visibility?.edge_length || false, expanded: settings.sheet_rows_visibility?.edge_length || false, toleranceType: settings.sheet_rows_tolerance_type?.edge_length, onToggle: () => onChange({
                            sheet_rows_visibility: {
                                edge_length: !settings.sheet_rows_visibility?.edge_length,
                            },
                        }), onChangeToleranceType: (type) => {
                            onChange({
                                sheet_rows_tolerance_type: {
                                    edge_length: type,
                                },
                            });
                        } }), jsx(ToleranceField, { expandable: false, title: "\u5916\u5468\u9577", enabled: settings.sheet_rows_visibility?.polygon_perimeter || false, expanded: settings.sheet_rows_visibility?.polygon_perimeter || false, toleranceType: settings.sheet_rows_tolerance_type?.polygon_perimeter, onToggle: () => onChange({
                            sheet_rows_visibility: {
                                polygon_perimeter: !settings.sheet_rows_visibility?.polygon_perimeter,
                            },
                        }), onChangeToleranceType: (type) => {
                            onChange({
                                sheet_rows_tolerance_type: {
                                    polygon_perimeter: type,
                                },
                            });
                        } }), jsx(ToleranceField, { expandable: false, title: "\u9762\u7A4D\u5024", enabled: settings.sheet_rows_visibility?.polygon_area || false, expanded: settings.sheet_rows_visibility?.polygon_area || false, toleranceType: settings.sheet_rows_tolerance_type?.polygon_area, onToggle: () => onChange({
                            sheet_rows_visibility: { polygon_area: !settings.sheet_rows_visibility?.polygon_area },
                        }), onChangeToleranceType: (type) => {
                            onChange({
                                sheet_rows_tolerance_type: {
                                    polygon_area: type,
                                },
                            });
                        } }), jsx(ToleranceField, { expandable: false, title: "\u4F53\u7A4D\u5024", enabled: settings.sheet_rows_visibility?.volume || false, expanded: settings.sheet_rows_visibility?.volume || false, toleranceType: settings.sheet_rows_tolerance_type?.volume, onToggle: () => onChange({
                            sheet_rows_visibility: { volume: !settings.sheet_rows_visibility?.volume },
                        }), onChangeToleranceType: (type) => {
                            onChange({
                                sheet_rows_tolerance_type: {
                                    volume: type,
                                },
                            });
                        } }), jsx(ToleranceField, { expandable: false, additionalFields: depthDataPoints, title: "\u6DF1\u3055", enabled: settings.sheet_rows_visibility?.grid || false, expanded: settings.sheet_rows_visibility?.grid || false, toleranceType: settings.sheet_rows_tolerance_type?.grid, onToggle: () => onChange({
                            sheet_rows_visibility: { grid: !settings.sheet_rows_visibility?.grid },
                        }), onChangeToleranceType: (type) => {
                            onChange({
                                sheet_rows_tolerance_type: {
                                    grid: type,
                                },
                            });
                        } }), jsx(ToleranceField, { expandable: false, title: "\u8868\u304B\u3076\u308A\u539A", enabled: settings.sheet_rows_visibility?.upper_plane_to_cylinders_distance || false, expanded: settings.sheet_rows_visibility?.upper_plane_to_cylinders_distance || false, toleranceType: settings.sheet_rows_tolerance_type?.upper_plane_to_cylinders_distance, extraContent: jsx(CoverThicknessValueSelect, { value: settings.cover_thickness_value_type?.upper ?? CoverThicknessAggregate.Min, onChange: (type) => onChange({
                                cover_thickness_value_type: {
                                    upper: type,
                                    lower: settings.cover_thickness_value_type?.lower ?? CoverThicknessAggregate.Min,
                                },
                            }) }), onToggle: () => onChange({
                            sheet_rows_visibility: {
                                upper_plane_to_cylinders_distance: !settings.sheet_rows_visibility?.upper_plane_to_cylinders_distance,
                            },
                        }), onChangeToleranceType: (type) => {
                            onChange({
                                sheet_rows_tolerance_type: {
                                    upper_plane_to_cylinders_distance: type,
                                },
                            });
                        } }), jsx(ToleranceField, { expandable: false, title: "\u88CF\u304B\u3076\u308A\u539A", enabled: settings.sheet_rows_visibility?.lower_plane_to_cylinders_distance || false, expanded: settings.sheet_rows_visibility?.lower_plane_to_cylinders_distance || false, toleranceType: settings.sheet_rows_tolerance_type?.lower_plane_to_cylinders_distance, extraContent: jsx(CoverThicknessValueSelect, { value: settings.cover_thickness_value_type?.lower ?? CoverThicknessAggregate.Min, onChange: (type) => onChange({
                                cover_thickness_value_type: {
                                    upper: settings.cover_thickness_value_type?.upper ?? CoverThicknessAggregate.Min,
                                    lower: type,
                                },
                            }) }), onToggle: () => onChange({
                            sheet_rows_visibility: {
                                lower_plane_to_cylinders_distance: !settings.sheet_rows_visibility?.lower_plane_to_cylinders_distance,
                            },
                        }), onChangeToleranceType: (type) => {
                            onChange({
                                sheet_rows_tolerance_type: {
                                    lower_plane_to_cylinders_distance: type,
                                },
                            });
                        } })] })] }));
};

var _extends$1 = {exports: {}};

var hasRequired_extends;

function require_extends () {
	if (hasRequired_extends) return _extends$1.exports;
	hasRequired_extends = 1;
	(function (module) {
		function _extends() {
		  return module.exports = _extends = Object.assign ? Object.assign.bind() : function (n) {
		    for (var e = 1; e < arguments.length; e++) {
		      var t = arguments[e];
		      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		    }
		    return n;
		  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _extends.apply(null, arguments);
		}
		module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports; 
	} (_extends$1));
	return _extends$1.exports;
}

var _extendsExports = require_extends();
var _extends = /*@__PURE__*/getDefaultExportFromCjs(_extendsExports);

var objectWithoutPropertiesLoose = {exports: {}};

var hasRequiredObjectWithoutPropertiesLoose;

function requireObjectWithoutPropertiesLoose () {
	if (hasRequiredObjectWithoutPropertiesLoose) return objectWithoutPropertiesLoose.exports;
	hasRequiredObjectWithoutPropertiesLoose = 1;
	(function (module) {
		function _objectWithoutPropertiesLoose(r, e) {
		  if (null == r) return {};
		  var t = {};
		  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
		    if (-1 !== e.indexOf(n)) continue;
		    t[n] = r[n];
		  }
		  return t;
		}
		module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports; 
	} (objectWithoutPropertiesLoose));
	return objectWithoutPropertiesLoose.exports;
}

var objectWithoutPropertiesLooseExports = requireObjectWithoutPropertiesLoose();
var _objectWithoutPropertiesLoose = /*@__PURE__*/getDefaultExportFromCjs(objectWithoutPropertiesLooseExports);

var RGB_MAX = 255;
var SV_MAX = 100;
/**
 * ```js
 * rgbaToHsva({ r: 255, g: 255, b: 255, a: 1 }) //=> { h: 0, s: 0, v: 100, a: 1 }
 * ```
 */
var rgbaToHsva = _ref => {
  var {
    r,
    g,
    b,
    a
  } = _ref;
  var max = Math.max(r, g, b);
  var delta = max - Math.min(r, g, b);

  // prettier-ignore
  var hh = delta ? max === r ? (g - b) / delta : max === g ? 2 + (b - r) / delta : 4 + (r - g) / delta : 0;
  return {
    h: 60 * (hh < 0 ? hh + 6 : hh),
    s: max ? delta / max * SV_MAX : 0,
    v: max / RGB_MAX * SV_MAX,
    a
  };
};
var hsvaToHslaString = hsva => {
  var {
    h,
    s,
    l,
    a
  } = hsvaToHsla(hsva);
  return "hsla(" + h + ", " + s + "%, " + l + "%, " + a + ")";
};
var hslaToHsva = _ref4 => {
  var {
    h,
    s,
    l,
    a
  } = _ref4;
  s *= (l < 50 ? l : SV_MAX - l) / SV_MAX;
  return {
    h: h,
    s: s > 0 ? 2 * s / (l + s) * SV_MAX : 0,
    v: l + s,
    a
  };
};
var hsvaToHsla = _ref5 => {
  var {
    h,
    s,
    v,
    a
  } = _ref5;
  var hh = (200 - s) * v / SV_MAX;
  return {
    h,
    s: hh > 0 && hh < 200 ? s * v / SV_MAX / (hh <= SV_MAX ? hh : 200 - hh) * SV_MAX : 0,
    l: hh / 2,
    a
  };
};
var rgbToHex = _ref7 => {
  var {
    r,
    g,
    b
  } = _ref7;
  var bin = r << 16 | g << 8 | b;
  return "#" + (h => new Array(7 - h.length).join('0') + h)(bin.toString(16));
};
var rgbaToHexa = _ref8 => {
  var {
    r,
    g,
    b,
    a
  } = _ref8;
  var alpha = typeof a === 'number' && (a * 255 | 1 << 8).toString(16).slice(1);
  return "" + rgbToHex({
    r,
    g,
    b
  }) + (alpha ? alpha : '');
};
var hexToHsva = hex => rgbaToHsva(hexToRgba(hex));
var hexToRgba = hex => {
  var htemp = hex.replace('#', '');
  if (/^#?/.test(hex) && htemp.length === 3) {
    hex = "#" + htemp.charAt(0) + htemp.charAt(0) + htemp.charAt(1) + htemp.charAt(1) + htemp.charAt(2) + htemp.charAt(2);
  }
  var reg = new RegExp("[A-Za-z0-9]{2}", 'g');
  var [r, g, b = 0, a] = hex.match(reg).map(v => parseInt(v, 16));
  return {
    r,
    g,
    b,
    a: (a != null ? a : 255) / RGB_MAX
  };
};

/**
 * Converts HSVA to RGBA. Based on formula from https://en.wikipedia.org/wiki/HSL_and_HSV
 * @param color HSVA color as an array [0-360, 0-1, 0-1, 0-1]
 */
var hsvaToRgba = _ref9 => {
  var {
    h,
    s,
    v,
    a
  } = _ref9;
  var _h = h / 60,
    _s = s / SV_MAX,
    _v = v / SV_MAX,
    hi = Math.floor(_h) % 6;
  var f = _h - Math.floor(_h),
    _p = RGB_MAX * _v * (1 - _s),
    _q = RGB_MAX * _v * (1 - _s * f),
    _t = RGB_MAX * _v * (1 - _s * (1 - f));
  _v *= RGB_MAX;
  var rgba = {};
  switch (hi) {
    case 0:
      rgba.r = _v;
      rgba.g = _t;
      rgba.b = _p;
      break;
    case 1:
      rgba.r = _q;
      rgba.g = _v;
      rgba.b = _p;
      break;
    case 2:
      rgba.r = _p;
      rgba.g = _v;
      rgba.b = _t;
      break;
    case 3:
      rgba.r = _p;
      rgba.g = _q;
      rgba.b = _v;
      break;
    case 4:
      rgba.r = _t;
      rgba.g = _p;
      rgba.b = _v;
      break;
    case 5:
      rgba.r = _v;
      rgba.g = _p;
      rgba.b = _q;
      break;
  }
  rgba.r = Math.round(rgba.r);
  rgba.g = Math.round(rgba.g);
  rgba.b = Math.round(rgba.b);
  return _extends({}, rgba, {
    a
  });
};
var hsvaToRgbaString = hsva => {
  var {
    r,
    g,
    b,
    a
  } = hsvaToRgba(hsva);
  return "rgba(" + r + ", " + g + ", " + b + ", " + a + ")";
};
var rgbaToRgb = _ref0 => {
  var {
    r,
    g,
    b
  } = _ref0;
  return {
    r,
    g,
    b
  };
};
var hslaToHsl = _ref1 => {
  var {
    h,
    s,
    l
  } = _ref1;
  return {
    h,
    s,
    l
  };
};
var hsvaToHex = hsva => rgbToHex(hsvaToRgba(hsva));
var hsvaToHexa = hsva => rgbaToHexa(hsvaToRgba(hsva));
var hsvaToHsv = _ref10 => {
  var {
    h,
    s,
    v
  } = _ref10;
  return {
    h,
    s,
    v
  };
};

/**
 * Converts RGB to XY. Based on formula from https://developers.meethue.com/develop/application-design-guidance/color-conversion-formulas-rgb-to-xy-and-back/
 * @param color RGB color as an array [0-255, 0-255, 0-255]
 */
var rgbToXY = _ref12 => {
  var {
    r,
    g,
    b
  } = _ref12;
  var translateColor = function translateColor(color) {
    return color <= 0.04045 ? color / 12.92 : Math.pow((color + 0.055) / 1.055, 2.4);
  };
  var red = translateColor(r / 255);
  var green = translateColor(g / 255);
  var blue = translateColor(b / 255);
  var xyz = {};
  xyz.x = red * 0.4124 + green * 0.3576 + blue * 0.1805;
  xyz.y = red * 0.2126 + green * 0.7152 + blue * 0.0722;
  xyz.bri = red * 0.0193 + green * 0.1192 + blue * 0.9505;
  return xyz;
};
var color = str => {
  var rgb;
  var hsl;
  var hsv;
  var rgba;
  var hsla;
  var hsva;
  var xy;
  var hex;
  var hexa;
  if (typeof str === 'string' && validHex$1(str)) {
    hsva = hexToHsva(str);
    hex = str;
  } else if (typeof str !== 'string') {
    hsva = str;
  }
  if (hsva) {
    hsv = hsvaToHsv(hsva);
    hsla = hsvaToHsla(hsva);
    rgba = hsvaToRgba(hsva);
    hexa = rgbaToHexa(rgba);
    hex = hsvaToHex(hsva);
    hsl = hslaToHsl(hsla);
    rgb = rgbaToRgb(rgba);
    xy = rgbToXY(rgb);
  }
  return {
    rgb,
    hsl,
    hsv,
    rgba,
    hsla,
    hsva,
    hex,
    hexa,
    xy
  };
};
var validHex$1 = hex => /^#?([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);

var objectDestructuringEmpty = {exports: {}};

var hasRequiredObjectDestructuringEmpty;

function requireObjectDestructuringEmpty () {
	if (hasRequiredObjectDestructuringEmpty) return objectDestructuringEmpty.exports;
	hasRequiredObjectDestructuringEmpty = 1;
	(function (module) {
		function _objectDestructuringEmpty(t) {
		  if (null == t) throw new TypeError("Cannot destructure " + t);
		}
		module.exports = _objectDestructuringEmpty, module.exports.__esModule = true, module.exports["default"] = module.exports; 
	} (objectDestructuringEmpty));
	return objectDestructuringEmpty.exports;
}

var objectDestructuringEmptyExports = requireObjectDestructuringEmpty();
var _objectDestructuringEmpty = /*@__PURE__*/getDefaultExportFromCjs(objectDestructuringEmptyExports);

var _excluded$b = ["prefixCls", "className", "color", "colors", "style", "rectProps", "onChange", "addonAfter", "addonBefore", "rectRender"];
var Swatch = /*#__PURE__*/React__default.forwardRef((props, ref) => {
  var {
      prefixCls = 'w-color-swatch',
      className,
      color: color$1,
      colors = [],
      style,
      rectProps = {},
      onChange,
      addonAfter,
      addonBefore,
      rectRender
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$b);
  var rectStyle = _extends({
    '--swatch-background-color': 'rgb(144, 19, 254)',
    background: 'var(--swatch-background-color)',
    height: 15,
    width: 15,
    marginRight: 5,
    marginBottom: 5,
    cursor: 'pointer',
    position: 'relative',
    outline: 'none',
    borderRadius: 2
  }, rectProps.style);
  var handleClick = (hex, evn) => {
    onChange && onChange(hexToHsva(hex), color(hexToHsva(hex)), evn);
  };
  return /*#__PURE__*/jsxs("div", _extends({
    ref: ref
  }, other, {
    className: [prefixCls, className || ''].filter(Boolean).join(' '),
    style: _extends({
      display: 'flex',
      flexWrap: 'wrap',
      position: 'relative'
    }, style),
    children: [addonBefore && /*#__PURE__*/React__default.isValidElement(addonBefore) && addonBefore, colors && Array.isArray(colors) && colors.map((item, idx) => {
      var title = '';
      var background = '';
      if (typeof item === 'string') {
        title = item;
        background = item;
      }
      if (typeof item === 'object' && item.color) {
        title = item.title || item.color;
        background = item.color;
      }
      var checked = color$1 && color$1.toLocaleLowerCase() === background.toLocaleLowerCase();
      var render = rectRender && rectRender({
        title,
        color: background,
        checked: !!checked,
        style: _extends({}, rectStyle, {
          background
        }),
        onClick: evn => handleClick(background, evn)
      });
      if (render) {
        return /*#__PURE__*/jsx(Fragment$1, {
          children: render
        }, idx);
      }
      var child = rectProps.children && /*#__PURE__*/React__default.isValidElement(rectProps.children) ? /*#__PURE__*/React__default.cloneElement(rectProps.children, {
        color: background,
        checked
      }) : null;
      return /*#__PURE__*/jsx("div", _extends({
        tabIndex: 0,
        title: title,
        onClick: evn => handleClick(background, evn)
      }, rectProps, {
        children: child,
        style: _extends({}, rectStyle, {
          background
        })
      }), idx);
    }), addonAfter && /*#__PURE__*/React__default.isValidElement(addonAfter) && addonAfter]
  }));
});
Swatch.displayName = 'Swatch';

var defalutStyle = {
  marginRight: 0,
  marginBottom: 0,
  borderRadius: 0,
  boxSizing: 'border-box',
  height: 25,
  width: 25
};
function Point(_ref) {
  var {
    style,
    title,
    checked,
    color,
    onClick,
    rectProps
  } = _ref;
  var btn = useRef(null);
  var handleMouseEnter = useCallback(() => {
    btn.current.style['zIndex'] = '2';
    btn.current.style['outline'] = '#fff solid 2px';
    btn.current.style['boxShadow'] = 'rgb(0 0 0 / 25%) 0 0 5px 2px';
  }, []);
  var handleMouseLeave = useCallback(() => {
    if (!checked) {
      btn.current.style['zIndex'] = '0';
      btn.current.style['outline'] = 'initial';
      btn.current.style['boxShadow'] = 'initial';
    }
  }, [checked]);
  var rectStyle = checked ? {
    zIndex: 1,
    outline: '#fff solid 2px',
    boxShadow: 'rgb(0 0 0 / 25%) 0 0 5px 2px'
  } : {
    zIndex: 0
  };
  return /*#__PURE__*/jsx("div", _extends({
    ref: btn,
    title: title
  }, rectProps, {
    onClick: onClick,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    style: _extends({}, style, {
      marginRight: 0,
      marginBottom: 0,
      borderRadius: 0,
      boxSizing: 'border-box',
      height: 25,
      width: 25
    }, defalutStyle, rectStyle, rectProps == null ? void 0 : rectProps.style)
  }));
}

var _excluded$a = ["prefixCls", "placement", "className", "style", "color", "colors", "showTriangle", "rectProps", "onChange", "rectRender"];
var CORLER_HEX = ['#B80000', '#DB3E00', '#FCCB00', '#008B02', '#006B76', '#1273DE', '#004DCF', '#5300EB', '#EB9694', '#FAD0C3', '#FEF3BD', '#C1E1C5', '#BEDADC', '#C4DEF6', '#BED3F3', '#D4C4FB'];
var GithubPlacement = /*#__PURE__*/function (GithubPlacement) {
  GithubPlacement["Left"] = "L";
  GithubPlacement["LeftTop"] = "LT";
  GithubPlacement["LeftBottom"] = "LB";
  GithubPlacement["Right"] = "R";
  GithubPlacement["RightTop"] = "RT";
  GithubPlacement["RightBottom"] = "RB";
  GithubPlacement["Top"] = "T";
  GithubPlacement["TopRight"] = "TR";
  GithubPlacement["TopLeft"] = "TL";
  GithubPlacement["Bottom"] = "B";
  GithubPlacement["BottomLeft"] = "BL";
  GithubPlacement["BottomRight"] = "BR";
  return GithubPlacement;
}({});
var Github = /*#__PURE__*/React__default.forwardRef((props, ref) => {
  var {
      prefixCls = 'w-color-github',
      placement = GithubPlacement.TopRight,
      className,
      style,
      color: color$1,
      colors = CORLER_HEX,
      showTriangle = true,
      rectProps = {},
      onChange,
      rectRender
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$a);
  var hsva = typeof color$1 === 'string' && validHex$1(color$1) ? hexToHsva(color$1) : color$1;
  var hex = color$1 ? hsvaToHex(hsva) : '';
  var handleChange = hsv => onChange && onChange(color(hsv));
  var styleWrapper = _extends({
    '--github-border': '1px solid rgba(0, 0, 0, 0.2)',
    '--github-background-color': '#fff',
    '--github-box-shadow': 'rgb(0 0 0 / 15%) 0px 3px 12px',
    '--github-arrow-border-color': 'rgba(0, 0, 0, 0.15)',
    width: 200,
    borderRadius: 4,
    background: 'var(--github-background-color)',
    boxShadow: 'var(--github-box-shadow)',
    border: 'var(--github-border)',
    position: 'relative',
    padding: 5
  }, style);
  var rStyle = {
    borderStyle: 'solid',
    position: 'absolute'
  };
  var arrBrStyl = _extends({}, rStyle);
  var arrStyl = _extends({}, rStyle);
  if (/^T/.test(placement)) {
    arrBrStyl.borderWidth = '0 8px 8px';
    arrBrStyl.borderColor = 'transparent transparent var(--github-arrow-border-color)';
    arrStyl.borderWidth = '0 7px 7px';
    arrStyl.borderColor = 'transparent transparent var(--github-background-color)';
  }
  if (placement === GithubPlacement.TopRight) {
    arrBrStyl.top = -8;
    arrStyl.top = -7;
  }
  if (placement === GithubPlacement.Top) {
    arrBrStyl.top = -8;
    arrStyl.top = -7;
  }
  if (placement === GithubPlacement.TopLeft) {
    arrBrStyl.top = -8;
    arrStyl.top = -7;
  }
  if (/^B/.test(placement)) {
    arrBrStyl.borderWidth = '8px 8px 0';
    arrBrStyl.borderColor = 'var(--github-arrow-border-color) transparent transparent';
    arrStyl.borderWidth = '7px 7px 0';
    arrStyl.borderColor = 'var(--github-background-color) transparent transparent';
    if (placement === GithubPlacement.BottomRight) {
      arrBrStyl.top = '100%';
      arrStyl.top = '100%';
    }
    if (placement === GithubPlacement.Bottom) {
      arrBrStyl.top = '100%';
      arrStyl.top = '100%';
    }
    if (placement === GithubPlacement.BottomLeft) {
      arrBrStyl.top = '100%';
      arrStyl.top = '100%';
    }
  }
  if (/^(B|T)/.test(placement)) {
    if (placement === GithubPlacement.Top || placement === GithubPlacement.Bottom) {
      arrBrStyl.left = '50%';
      arrBrStyl.marginLeft = -8;
      arrStyl.left = '50%';
      arrStyl.marginLeft = -7;
    }
    if (placement === GithubPlacement.TopRight || placement === GithubPlacement.BottomRight) {
      arrBrStyl.right = 10;
      arrStyl.right = 11;
    }
    if (placement === GithubPlacement.TopLeft || placement === GithubPlacement.BottomLeft) {
      arrBrStyl.left = 7;
      arrStyl.left = 8;
    }
  }
  if (/^L/.test(placement)) {
    arrBrStyl.borderWidth = '8px 8px 8px 0';
    arrBrStyl.borderColor = 'transparent var(--github-arrow-border-color) transparent transparent';
    arrStyl.borderWidth = '7px 7px 7px 0';
    arrStyl.borderColor = 'transparent var(--github-background-color) transparent transparent';
    arrBrStyl.left = -8;
    arrStyl.left = -7;
  }
  if (/^R/.test(placement)) {
    arrBrStyl.borderWidth = '8px 0 8px 8px';
    arrBrStyl.borderColor = 'transparent transparent transparent var(--github-arrow-border-color)';
    arrStyl.borderWidth = '7px 0 7px 7px';
    arrStyl.borderColor = 'transparent transparent transparent var(--github-background-color)';
    arrBrStyl.right = -8;
    arrStyl.right = -7;
  }
  if (/^(L|R)/.test(placement)) {
    if (placement === GithubPlacement.RightTop || placement === GithubPlacement.LeftTop) {
      arrBrStyl.top = 5;
      arrStyl.top = 6;
    }
    if (placement === GithubPlacement.Left || placement === GithubPlacement.Right) {
      arrBrStyl.top = '50%';
      arrStyl.top = '50%';
      arrBrStyl.marginTop = -8;
      arrStyl.marginTop = -7;
    }
    if (placement === GithubPlacement.LeftBottom || placement === GithubPlacement.RightBottom) {
      arrBrStyl.top = '100%';
      arrStyl.top = '100%';
      arrBrStyl.marginTop = -21;
      arrStyl.marginTop = -20;
    }
  }
  var render = _ref => {
    var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
    var handle = rectRender && rectRender(_extends({}, props));
    if (handle) return handle;
    return /*#__PURE__*/jsx(Point, _extends({}, props, {
      rectProps: rectProps
    }));
  };
  return /*#__PURE__*/jsx(Swatch, _extends({
    ref: ref,
    className: [prefixCls, className].filter(Boolean).join(' '),
    colors: colors,
    color: hex,
    rectRender: render
  }, other, {
    onChange: handleChange,
    style: styleWrapper,
    rectProps: {
      style: {
        marginRight: 0,
        marginBottom: 0,
        borderRadius: 0,
        height: 25,
        width: 25
      }
    },
    addonBefore: /*#__PURE__*/jsx(Fragment$1, {
      children: showTriangle && /*#__PURE__*/jsxs(Fragment$1, {
        children: [/*#__PURE__*/jsx("div", {
          style: arrBrStyl
        }), /*#__PURE__*/jsx("div", {
          style: arrStyl
        })]
      })
    })
  }));
});
Github.displayName = 'Github';

// Saves incoming handler to the ref in order to avoid "useCallback hell"
function useEventCallback(handler) {
  var callbackRef = useRef(handler);
  useEffect(() => {
    callbackRef.current = handler;
  });
  return useCallback((value, event) => callbackRef.current && callbackRef.current(value, event), []);
}

// Check if an event was triggered by touch
var isTouch = event => 'touches' in event;

// Browsers introduced an intervention, making touch events passive by default.
// This workaround removes `preventDefault` call from the touch handlers.
// https://github.com/facebook/react/issues/19651
var preventDefaultMove = event => {
  !isTouch(event) && event.preventDefault && event.preventDefault();
};
// Clamps a value between an upper and lower bound.
// We use ternary operators because it makes the minified code
// 2 times shorter then `Math.min(Math.max(a,b),c)`
var clamp = function clamp(number, min, max) {
  if (min === void 0) {
    min = 0;
  }
  if (max === void 0) {
    max = 1;
  }
  return number > max ? max : number < min ? min : number;
};
// Returns a relative position of the pointer inside the node's bounding box
var getRelativePosition = (node, event) => {
  var rect = node.getBoundingClientRect();

  // Get user's pointer position from `touches` array if it's a `TouchEvent`
  var pointer = isTouch(event) ? event.touches[0] : event;
  return {
    left: clamp((pointer.pageX - (rect.left + window.pageXOffset)) / rect.width),
    top: clamp((pointer.pageY - (rect.top + window.pageYOffset)) / rect.height),
    width: rect.width,
    height: rect.height,
    x: pointer.pageX - (rect.left + window.pageXOffset),
    y: pointer.pageY - (rect.top + window.pageYOffset)
  };
};

var _excluded$9 = ["prefixCls", "className", "onMove", "onDown"];
var Interactive = /*#__PURE__*/React__default.forwardRef((props, ref) => {
  var {
      prefixCls = 'w-color-interactive',
      className,
      onMove,
      onDown
    } = props,
    reset = _objectWithoutPropertiesLoose(props, _excluded$9);
  var container = useRef(null);
  var hasTouched = useRef(false);
  var [isDragging, setDragging] = useState(false);
  var onMoveCallback = useEventCallback(onMove);
  var onKeyCallback = useEventCallback(onDown);

  // Prevent mobile browsers from handling mouse events (conflicting with touch ones).
  // If we detected a touch interaction before, we prefer reacting to touch events only.
  var isValid = event => {
    if (hasTouched.current && !isTouch(event)) return false;
    hasTouched.current = isTouch(event);
    return true;
  };
  var handleMove = useCallback(event => {
    preventDefaultMove(event);
    if (!container.current) return;
    var isDown = isTouch(event) ? event.touches.length > 0 : event.buttons > 0;
    if (!isDown) {
      setDragging(false);
      return;
    }
    onMoveCallback == null || onMoveCallback(getRelativePosition(container.current, event), event);
  }, [onMoveCallback]);
  var handleMoveEnd = useCallback(() => setDragging(false), []);
  var toggleDocumentEvents = useCallback(state => {
    if (state) {
      window.addEventListener(hasTouched.current ? 'touchmove' : 'mousemove', handleMove);
      window.addEventListener(hasTouched.current ? 'touchend' : 'mouseup', handleMoveEnd);
    } else {
      window.removeEventListener('mousemove', handleMove);
      window.removeEventListener('mouseup', handleMoveEnd);
      window.removeEventListener('touchmove', handleMove);
      window.removeEventListener('touchend', handleMoveEnd);
    }
  }, [handleMove, handleMoveEnd]);
  useEffect(() => {
    toggleDocumentEvents(isDragging);
    return () => {
      toggleDocumentEvents(false);
    };
  }, [isDragging, handleMove, handleMoveEnd, toggleDocumentEvents]);
  var handleMoveStart = useCallback(event => {
    var activeEl = document.activeElement;
    activeEl == null || activeEl.blur();
    preventDefaultMove(event.nativeEvent);
    if (!isValid(event.nativeEvent)) return;
    if (!container.current) return;
    onKeyCallback == null || onKeyCallback(getRelativePosition(container.current, event.nativeEvent), event.nativeEvent);
    setDragging(true);
  }, [onKeyCallback]);
  return /*#__PURE__*/jsx("div", _extends({}, reset, {
    className: [prefixCls, className || ''].filter(Boolean).join(' '),
    style: _extends({}, reset.style, {
      touchAction: 'none'
    }),
    ref: container,
    tabIndex: 0,
    onMouseDown: handleMoveStart,
    onTouchStart: handleMoveStart
  }));
});
Interactive.displayName = 'Interactive';

var Pointer$1 = _ref => {
  var {
    className,
    color,
    left,
    top,
    prefixCls
  } = _ref;
  var style = {
    position: 'absolute',
    top,
    left
  };
  var stylePointer = {
    '--saturation-pointer-box-shadow': 'rgb(255 255 255) 0px 0px 0px 1.5px, rgb(0 0 0 / 30%) 0px 0px 1px 1px inset, rgb(0 0 0 / 40%) 0px 0px 1px 2px',
    width: 6,
    height: 6,
    transform: 'translate(-3px, -3px)',
    boxShadow: 'var(--saturation-pointer-box-shadow)',
    borderRadius: '50%',
    backgroundColor: color
  };
  return useMemo(() => /*#__PURE__*/jsx("div", {
    className: prefixCls + "-pointer " + (className || ''),
    style: style,
    children: /*#__PURE__*/jsx("div", {
      className: prefixCls + "-fill",
      style: stylePointer
    })
  }), [top, left, color, className, prefixCls]);
};

var _excluded$8 = ["prefixCls", "radius", "pointer", "className", "hue", "style", "hsva", "onChange"];
var Saturation = /*#__PURE__*/React__default.forwardRef((props, ref) => {
  var _hsva$h;
  var {
      prefixCls = 'w-color-saturation',
      radius = 0,
      pointer,
      className,
      hue = 0,
      style,
      hsva,
      onChange
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$8);
  var containerStyle = _extends({
    width: 200,
    height: 200,
    borderRadius: radius
  }, style, {
    position: 'relative'
  });
  var containerRef = useRef(null);

  // Combine external ref with internal ref
  var combinedRef = useCallback(node => {
    containerRef.current = node;
    if (typeof ref === 'function') {
      ref(node);
    } else if (ref && 'current' in ref) {
      ref.current = node;
    }
  }, [ref]);
  var handleChange = useCallback((interaction, event) => {
    onChange && hsva && onChange({
      h: hsva.h,
      s: interaction.left * 100,
      v: (1 - interaction.top) * 100,
      a: hsva.a
      // source: 'hsv',
    });
    // Ensure the component maintains focus after drag interaction
    var element = containerRef.current;
    if (element) {
      element.focus();
    }
  }, [hsva, onChange]);
  var handleKeyDown = useCallback(event => {
    if (!hsva || !onChange) return;
    var step = 1; // 1% step for saturation and value
    var newS = hsva.s;
    var newV = hsva.v;
    var changed = false;
    switch (event.key) {
      case 'ArrowLeft':
        newS = Math.max(0, hsva.s - step);
        changed = true;
        event.preventDefault();
        break;
      case 'ArrowRight':
        newS = Math.min(100, hsva.s + step);
        changed = true;
        event.preventDefault();
        break;
      case 'ArrowUp':
        newV = Math.min(100, hsva.v + step);
        changed = true;
        event.preventDefault();
        break;
      case 'ArrowDown':
        newV = Math.max(0, hsva.v - step);
        changed = true;
        event.preventDefault();
        break;
      default:
        return;
    }
    if (changed) {
      onChange({
        h: hsva.h,
        s: newS,
        v: newV,
        a: hsva.a
      });
    }
  }, [hsva, onChange]);
  var pointerElement = useMemo(() => {
    if (!hsva) return null;
    var comProps = {
      top: 100 - hsva.v + "%",
      left: hsva.s + "%",
      color: hsvaToHslaString(hsva)
    };
    if (pointer && typeof pointer === 'function') {
      return pointer(_extends({
        prefixCls
      }, comProps));
    }
    return /*#__PURE__*/jsx(Pointer$1, _extends({
      prefixCls: prefixCls
    }, comProps));
  }, [hsva, pointer, prefixCls]);
  var handleClick = useCallback(event => {
    event.target.focus();
  }, []);
  return /*#__PURE__*/jsx(Interactive, _extends({
    className: [prefixCls, className || ''].filter(Boolean).join(' ')
  }, other, {
    style: _extends({
      position: 'absolute',
      inset: 0,
      cursor: 'crosshair',
      backgroundImage: "linear-gradient(0deg, #000, transparent), linear-gradient(90deg, #fff, hsl(" + ((_hsva$h = hsva == null ? void 0 : hsva.h) != null ? _hsva$h : hue) + ", 100%, 50%))"
    }, containerStyle, {
      outline: 'none'
    }),
    ref: combinedRef,
    onMove: handleChange,
    onDown: handleChange,
    onKeyDown: handleKeyDown,
    onClick: handleClick,
    children: pointerElement
  }));
});
Saturation.displayName = 'Saturation';

var _excluded$7 = ["className", "prefixCls", "left", "top", "style", "fillProps"];
var Pointer = _ref => {
  var {
      className,
      prefixCls,
      left,
      top,
      style,
      fillProps
    } = _ref,
    reset = _objectWithoutPropertiesLoose(_ref, _excluded$7);
  var styleWrapper = _extends({}, style, {
    position: 'absolute',
    left,
    top
  });
  var stylePointer = _extends({
    width: 18,
    height: 18,
    boxShadow: 'var(--alpha-pointer-box-shadow)',
    borderRadius: '50%',
    backgroundColor: 'var(--alpha-pointer-background-color)'
  }, fillProps == null ? void 0 : fillProps.style, {
    transform: left ? 'translate(-9px, -1px)' : 'translate(-1px, -9px)'
  });
  return /*#__PURE__*/jsx("div", _extends({
    className: prefixCls + "-pointer " + (className || ''),
    style: styleWrapper
  }, reset, {
    children: /*#__PURE__*/jsx("div", _extends({
      className: prefixCls + "-fill"
    }, fillProps, {
      style: stylePointer
    }))
  }));
};

var _excluded$6 = ["prefixCls", "className", "hsva", "background", "bgProps", "innerProps", "pointerProps", "radius", "width", "height", "direction", "style", "onChange", "pointer"];
var BACKGROUND_IMG = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAMUlEQVQ4T2NkYGAQYcAP3uCTZhw1gGGYhAGBZIA/nYDCgBDAm9BGDWAAJyRCgLaBCAAgXwixzAS0pgAAAABJRU5ErkJggg==';
var Alpha = /*#__PURE__*/React__default.forwardRef((props, ref) => {
  var {
      prefixCls = 'w-color-alpha',
      className,
      hsva,
      background,
      bgProps = {},
      innerProps = {},
      pointerProps = {},
      radius = 0,
      width,
      height = 16,
      direction = 'horizontal',
      style,
      onChange,
      pointer
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$6);
  var handleChange = offset => {
    onChange && onChange(_extends({}, hsva, {
      a: direction === 'horizontal' ? offset.left : offset.top
    }), offset);
  };
  var colorTo = hsvaToHslaString(Object.assign({}, hsva, {
    a: 1
  }));
  var innerBackground = "linear-gradient(to " + (direction === 'horizontal' ? 'right' : 'bottom') + ", rgba(244, 67, 54, 0) 0%, " + colorTo + " 100%)";
  var comProps = {};
  if (direction === 'horizontal') {
    comProps.left = hsva.a * 100 + "%";
  } else {
    comProps.top = hsva.a * 100 + "%";
  }
  var styleWrapper = _extends({
    '--alpha-background-color': '#fff',
    '--alpha-pointer-background-color': 'rgb(248, 248, 248)',
    '--alpha-pointer-box-shadow': 'rgb(0 0 0 / 37%) 0px 1px 4px 0px',
    borderRadius: radius,
    background: "url(" + BACKGROUND_IMG + ") left center",
    backgroundColor: 'var(--alpha-background-color)'
  }, {
    width,
    height
  }, style, {
    position: 'relative'
  });
  var handleKeyDown = useCallback(event => {
    var step = 0.01; // 1% step
    var currentAlpha = hsva.a;
    var newAlpha = currentAlpha;
    switch (event.key) {
      case 'ArrowLeft':
        if (direction === 'horizontal') {
          newAlpha = Math.max(0, currentAlpha - step);
          event.preventDefault();
        }
        break;
      case 'ArrowRight':
        if (direction === 'horizontal') {
          newAlpha = Math.min(1, currentAlpha + step);
          event.preventDefault();
        }
        break;
      case 'ArrowUp':
        if (direction === 'vertical') {
          newAlpha = Math.max(0, currentAlpha - step);
          event.preventDefault();
        }
        break;
      case 'ArrowDown':
        if (direction === 'vertical') {
          newAlpha = Math.min(1, currentAlpha + step);
          event.preventDefault();
        }
        break;
      default:
        return;
    }
    if (newAlpha !== currentAlpha) {
      var syntheticOffset = {
        left: direction === 'horizontal' ? newAlpha : hsva.a,
        top: direction === 'vertical' ? newAlpha : hsva.a,
        width: 0,
        height: 0,
        x: 0,
        y: 0
      };
      onChange && onChange(_extends({}, hsva, {
        a: newAlpha
      }), syntheticOffset);
    }
  }, [hsva, direction, onChange]);
  var handleClick = useCallback(event => {
    event.target.focus();
  }, []);
  var pointerElement = pointer && typeof pointer === 'function' ? pointer(_extends({
    prefixCls
  }, pointerProps, comProps)) : /*#__PURE__*/jsx(Pointer, _extends({}, pointerProps, {
    prefixCls: prefixCls
  }, comProps));
  return /*#__PURE__*/jsxs("div", _extends({}, other, {
    className: [prefixCls, prefixCls + "-" + direction, className || ''].filter(Boolean).join(' '),
    style: styleWrapper,
    ref: ref,
    children: [/*#__PURE__*/jsx("div", _extends({}, bgProps, {
      style: _extends({
        inset: 0,
        position: 'absolute',
        background: background || innerBackground,
        borderRadius: radius
      }, bgProps.style)
    })), /*#__PURE__*/jsx(Interactive, _extends({}, innerProps, {
      style: _extends({}, innerProps.style, {
        inset: 0,
        zIndex: 1,
        position: 'absolute',
        outline: 'none'
      }),
      onMove: handleChange,
      onDown: handleChange,
      onClick: handleClick,
      onKeyDown: handleKeyDown,
      children: pointerElement
    }))]
  }));
});
Alpha.displayName = 'Alpha';

var _excluded$5 = ["prefixCls", "className", "hue", "onChange", "direction"];
var Hue = /*#__PURE__*/React__default.forwardRef((props, ref) => {
  var {
      prefixCls = 'w-color-hue',
      className,
      hue = 0,
      onChange: _onChange,
      direction = 'horizontal'
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$5);
  return /*#__PURE__*/jsx(Alpha, _extends({
    ref: ref,
    className: prefixCls + " " + (className || '')
  }, other, {
    direction: direction,
    background: "linear-gradient(to " + (direction === 'horizontal' ? 'right' : 'bottom') + ", rgb(255, 0, 0) 0%, rgb(255, 255, 0) 17%, rgb(0, 255, 0) 33%, rgb(0, 255, 255) 50%, rgb(0, 0, 255) 67%, rgb(255, 0, 255) 83%, rgb(255, 0, 0) 100%)",
    hsva: {
      h: hue,
      s: 100,
      v: 100,
      a: hue / 360
    },
    onChange: (_, interaction) => {
      _onChange && _onChange({
        h: direction === 'horizontal' ? 360 * interaction.left : 360 * interaction.top
      });
    }
  }));
});
Hue.displayName = 'Hue';

var _excluded$4 = ["prefixCls", "placement", "label", "value", "className", "style", "labelStyle", "inputStyle", "onChange", "onBlur", "renderInput"];
var validHex = hex => /^#?([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
var getNumberValue = value => Number(String(value).replace(/%/g, ''));
var EditableInput = /*#__PURE__*/React__default.forwardRef((props, ref) => {
  var {
      prefixCls = 'w-color-editable-input',
      placement = 'bottom',
      label,
      value: initValue,
      className,
      style,
      labelStyle,
      inputStyle,
      onChange,
      onBlur,
      renderInput
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$4);
  var [value, setValue] = useState(initValue);
  var isFocus = useRef(false);
  var inputIdRef = useRef(other.id || prefixCls + "-" + Math.random().toString(36).slice(2, 11));
  var inputId = other.id || inputIdRef.current;
  useEffect(() => {
    if (props.value !== value) {
      if (!isFocus.current) {
        setValue(props.value);
      }
    }
  }, [props.value]);
  function handleChange(evn, valInit) {
    var value = (valInit || evn.target.value).trim().replace(/^#/, '');
    if (validHex(value)) {
      onChange && onChange(evn, value);
    }
    var val = getNumberValue(value);
    if (!isNaN(val)) {
      onChange && onChange(evn, val);
    }
    setValue(value);
  }
  function handleBlur(evn) {
    isFocus.current = false;
    setValue(props.value);
    onBlur && onBlur(evn);
  }
  var placementStyle = {};
  if (placement === 'bottom') {
    placementStyle['flexDirection'] = 'column';
  }
  if (placement === 'top') {
    placementStyle['flexDirection'] = 'column-reverse';
  }
  if (placement === 'left') {
    placementStyle['flexDirection'] = 'row-reverse';
  }
  var wrapperStyle = _extends({
    '--editable-input-label-color': 'rgb(153, 153, 153)',
    '--editable-input-box-shadow': 'rgb(204 204 204) 0px 0px 0px 1px inset',
    '--editable-input-color': '#666',
    position: 'relative',
    alignItems: 'center',
    display: 'flex',
    fontSize: 11
  }, placementStyle, style);
  var editableStyle = _extends({
    width: '100%',
    paddingTop: 2,
    paddingBottom: 2,
    paddingLeft: 3,
    paddingRight: 3,
    fontSize: 11,
    background: 'transparent',
    boxSizing: 'border-box',
    border: 'none',
    color: 'var(--editable-input-color)',
    boxShadow: 'var(--editable-input-box-shadow)'
  }, inputStyle);
  var inputProps = _extends({
    value,
    onChange: handleChange,
    onBlur: handleBlur,
    autoComplete: 'off',
    onFocus: () => isFocus.current = true
  }, other, {
    id: inputId,
    style: editableStyle,
    onFocusCapture: e => {
      var elm = e.target;
      elm.setSelectionRange(elm.value.length, elm.value.length);
    }
  });
  return /*#__PURE__*/jsxs("div", {
    className: [prefixCls, className || ''].filter(Boolean).join(' '),
    style: wrapperStyle,
    children: [renderInput ? renderInput(inputProps, ref) : /*#__PURE__*/jsx("input", _extends({
      ref: ref
    }, inputProps)), label && /*#__PURE__*/jsx("label", {
      htmlFor: inputId,
      style: _extends({
        color: 'var(--editable-input-label-color)',
        textTransform: 'capitalize'
      }, labelStyle),
      children: label
    })]
  });
});
EditableInput.displayName = 'EditableInput';

var _excluded$3 = ["prefixCls", "hsva", "placement", "rProps", "gProps", "bProps", "aProps", "className", "style", "onChange"];
var EditableInputRGBA = /*#__PURE__*/React__default.forwardRef((props, ref) => {
  var {
      prefixCls = 'w-color-editable-input-rgba',
      hsva,
      placement = 'bottom',
      rProps = {},
      gProps = {},
      bProps = {},
      aProps = {},
      className,
      style,
      onChange
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$3);
  var rgba = hsva ? hsvaToRgba(hsva) : {};
  function handleBlur(evn) {
    var value = Number(evn.target.value);
    if (value && value > 255) {
      evn.target.value = '255';
    }
    if (value && value < 0) {
      evn.target.value = '0';
    }
  }
  var handleAlphaBlur = evn => {
    var value = Number(evn.target.value);
    if (value && value > 100) {
      evn.target.value = '100';
    }
    if (value && value < 0) {
      evn.target.value = '0';
    }
  };
  var handleChange = (value, type, evn) => {
    if (typeof value === 'number') {
      if (type === 'a') {
        if (value < 0) value = 0;
        if (value > 100) value = 100;
        onChange && onChange(color(rgbaToHsva(_extends({}, rgba, {
          a: value / 100
        }))));
      }
      if (value > 255) {
        value = 255;
        evn.target.value = '255';
      }
      if (value < 0) {
        value = 0;
        evn.target.value = '0';
      }
      if (type === 'r') {
        onChange && onChange(color(rgbaToHsva(_extends({}, rgba, {
          r: value
        }))));
      }
      if (type === 'g') {
        onChange && onChange(color(rgbaToHsva(_extends({}, rgba, {
          g: value
        }))));
      }
      if (type === 'b') {
        onChange && onChange(color(rgbaToHsva(_extends({}, rgba, {
          b: value
        }))));
      }
    }
  };
  var roundedAlpha = rgba.a ? Math.round(rgba.a * 100) / 100 : 0;
  return /*#__PURE__*/jsxs("div", _extends({
    ref: ref,
    className: [prefixCls, className || ''].filter(Boolean).join(' ')
  }, other, {
    style: _extends({
      fontSize: 11,
      display: 'flex'
    }, style),
    children: [/*#__PURE__*/jsx(EditableInput, _extends({
      label: "R",
      value: rgba.r || 0,
      onBlur: handleBlur,
      placement: placement,
      onChange: (evn, val) => handleChange(val, 'r', evn)
    }, rProps, {
      style: _extends({}, rProps.style)
    })), /*#__PURE__*/jsx(EditableInput, _extends({
      label: "G",
      value: rgba.g || 0,
      onBlur: handleBlur,
      placement: placement,
      onChange: (evn, val) => handleChange(val, 'g', evn)
    }, gProps, {
      style: _extends({
        marginLeft: 5
      }, gProps.style)
    })), /*#__PURE__*/jsx(EditableInput, _extends({
      label: "B",
      value: rgba.b || 0,
      onBlur: handleBlur,
      placement: placement,
      onChange: (evn, val) => handleChange(val, 'b', evn)
    }, bProps, {
      style: _extends({
        marginLeft: 5
      }, bProps.style)
    })), aProps && /*#__PURE__*/jsx(EditableInput, _extends({
      label: "A",
      value: parseInt(String(roundedAlpha * 100), 10),
      onBlur: handleAlphaBlur,
      placement: placement,
      onChange: (evn, val) => handleChange(val, 'a', evn)
    }, aProps, {
      style: _extends({
        marginLeft: 5
      }, aProps.style)
    }))]
  }));
});
EditableInputRGBA.displayName = 'EditableInputRGBA';

var _excluded$2 = ["prefixCls", "hsva", "hProps", "sProps", "lProps", "aProps", "className", "onChange"];
var EditableInputHSLA = /*#__PURE__*/React__default.forwardRef((props, ref) => {
  var {
      prefixCls = 'w-color-editable-input-hsla',
      hsva,
      hProps = {},
      sProps = {},
      lProps = {},
      aProps = {},
      className,
      onChange
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$2);
  var hsla = hsva ? hsvaToHsla(hsva) : {
    h: 0,
    s: 0,
    l: 0,
    a: 0
  };
  var handleChange = (value, type, evn) => {
    if (typeof value === 'number') {
      if (type === 'h') {
        if (value < 0) value = 0;
        if (value > 360) value = 360;
        onChange && onChange(color(hslaToHsva(_extends({}, hsla, {
          h: value
        }))));
      }
      if (type === 's') {
        if (value < 0) value = 0;
        if (value > 100) value = 100;
        onChange && onChange(color(hslaToHsva(_extends({}, hsla, {
          s: value
        }))));
      }
      if (type === 'l') {
        if (value < 0) value = 0;
        if (value > 100) value = 100;
        onChange && onChange(color(hslaToHsva(_extends({}, hsla, {
          l: value
        }))));
      }
      if (type === 'a') {
        if (value < 0) value = 0;
        if (value > 1) value = 1;
        onChange && onChange(color(hslaToHsva(_extends({}, hsla, {
          a: value
        }))));
      }
    }
  };
  var aPropsObj = aProps == false ? false : _extends({
    label: 'A',
    value: Math.round(hsla.a * 100) / 100
  }, aProps, {
    onChange: (evn, val) => handleChange(val, 'a')
  });
  return /*#__PURE__*/jsx(EditableInputRGBA, _extends({
    ref: ref,
    hsva: hsva,
    rProps: _extends({
      label: 'H',
      value: Math.round(hsla.h)
    }, hProps, {
      onChange: (evn, val) => handleChange(val, 'h')
    }),
    gProps: _extends({
      label: 'S',
      value: Math.round(hsla.s) + "%"
    }, sProps, {
      onChange: (evn, val) => handleChange(val, 's')
    }),
    bProps: _extends({
      label: 'L',
      value: Math.round(hsla.l) + "%"
    }, lProps, {
      onChange: (evn, val) => handleChange(val, 'l')
    }),
    aProps: aPropsObj,
    className: [prefixCls, className || ''].filter(Boolean).join(' ')
  }, other));
});
EditableInputHSLA.displayName = 'EditableInputHSLA';

var _excluded$1 = ["style"];
function Arrow(props) {
  var {
      style
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$1);
  var btn = useRef(null);
  var handleMouseEnter = useCallback(() => {
    btn.current.style['backgroundColor'] = 'var(--chrome-arrow-background-color)';
  }, []);
  var handleMouseLeave = useCallback(() => {
    btn.current.style['backgroundColor'] = 'transparent';
  }, []);
  return /*#__PURE__*/jsx("div", _extends({
    ref: btn,
    style: _extends({
      marginLeft: 5,
      cursor: 'pointer',
      transition: 'background-color .3s',
      borderRadius: 2
    }, style)
  }, other, {
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    children: /*#__PURE__*/jsx("svg", {
      viewBox: "0 0 1024 1024",
      width: "24",
      height: "24",
      style: {
        display: 'block'
      },
      children: /*#__PURE__*/jsx("path", {
        d: "M373.888 576h276.224c9.322667 0 14.293333 11.178667 9.173333 18.773333l-1.258666 1.557334-138.112 146.858666a10.709333 10.709333 0 0 1-14.293334 1.365334l-1.536-1.365334-138.112-146.858666c-6.592-6.997333-2.666667-18.645333 5.973334-20.16l1.941333-0.170667h276.224-276.224z m146.026667-295.189333l138.112 146.858666c7.04 7.509333 2.069333 20.330667-7.914667 20.330667H373.888c-9.984 0-14.976-12.821333-7.914667-20.330667l138.112-146.858666a10.730667 10.730667 0 0 1 15.829334 0z",
        fill: "var(--chrome-arrow-fill)"
      })
    })
  }));
}

function getIsEyeDropperSupported() {
  return 'EyeDropper' in window;
}
function EyeDropper(props) {
  var click = () => {
    if ('EyeDropper' in window) {
      var eyeDropper = new window.EyeDropper();
      eyeDropper.open().then(result => {
        props.onPickColor == null || props.onPickColor(result.sRGBHex);
      }).catch(err => {
        if (err.name === 'AbortError') ;
      });
    }
  };
  return /*#__PURE__*/jsx("svg", {
    viewBox: "0 0 512 512",
    height: "1em",
    width: "1em",
    onClick: click,
    children: /*#__PURE__*/jsx("path", {
      fill: "currentColor",
      d: "M482.8 29.23c38.9 38.98 38.9 102.17 0 141.17L381.2 271.9l9.4 9.5c12.5 12.5 12.5 32.7 0 45.2s-32.7 12.5-45.2 0l-160-160c-12.5-12.5-12.5-32.7 0-45.2s32.7-12.5 45.2 0l9.5 9.4L341.6 29.23c39-38.974 102.2-38.974 141.2 0zM55.43 323.3 176.1 202.6l45.3 45.3-120.7 120.7c-3.01 3-4.7 7-4.7 11.3V416h36.1c4.3 0 8.3-1.7 11.3-4.7l120.7-120.7 45.3 45.3-120.7 120.7c-15 15-35.4 23.4-56.6 23.4H89.69l-39.94 26.6c-12.69 8.5-29.59 6.8-40.377-4-10.786-10.8-12.459-27.7-3.998-40.4L32 422.3v-42.4c0-21.2 8.43-41.6 23.43-56.6z"
    })
  });
}

var _excluded = ["prefixCls", "className", "style", "color", "showEditableInput", "showEyeDropper", "showColorPreview", "showHue", "showAlpha", "inputType", "rectProps", "onChange"];
var ChromeInputType = /*#__PURE__*/function (ChromeInputType) {
  ChromeInputType["HEXA"] = "hexa";
  ChromeInputType["RGBA"] = "rgba";
  ChromeInputType["HSLA"] = "hsla";
  return ChromeInputType;
}({});
var Chrome = /*#__PURE__*/React__default.forwardRef((props, ref) => {
  var {
      prefixCls = 'w-color-chrome',
      className,
      style,
      color: color$1,
      showEditableInput = true,
      showEyeDropper = true,
      showColorPreview = true,
      showHue = true,
      showAlpha = true,
      inputType = ChromeInputType.RGBA,
      rectProps = {},
      onChange
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  var hsva = typeof color$1 === 'string' && validHex$1(color$1) ? hexToHsva(color$1) : color$1 || {
    h: 0,
    s: 0,
    l: 0,
    a: 0
  };
  var handleChange = hsv => onChange && onChange(color(hsv));
  var [type, setType] = useState(inputType);
  var handleClick = () => {
    if (type === ChromeInputType.RGBA) {
      setType(ChromeInputType.HSLA);
    }
    if (type === ChromeInputType.HSLA) {
      setType(ChromeInputType.HEXA);
    }
    if (type === ChromeInputType.HEXA) {
      setType(ChromeInputType.RGBA);
    }
  };
  var labelStyle = {
    paddingTop: 6
  };
  var inputStyle = {
    textAlign: 'center',
    paddingTop: 4,
    paddingBottom: 4
  };
  var wrapperStyle = _extends({
    '--chrome-arrow-fill': '#333',
    '--chrome-arrow-background-color': '#e8e8e8',
    borderRadius: 0,
    flexDirection: 'column',
    width: 230,
    padding: 0
  }, style);
  var alphaStyle = {
    '--chrome-alpha-box-shadow': 'rgb(0 0 0 / 25%) 0px 0px 1px inset',
    borderRadius: '50%',
    background: hsvaToRgbaString(hsva),
    boxShadow: 'var(--chrome-alpha-box-shadow)'
  };
  var handleClickColor = hex => {
    var result = hexToHsva(hex);
    handleChange(_extends({}, result));
  };
  var styleSize = {
    height: 14,
    width: 14
  };
  var pointerProps = {
    style: _extends({}, styleSize),
    fillProps: {
      style: styleSize
    }
  };
  return /*#__PURE__*/jsx(Github, _extends({
    ref: ref,
    color: hsva,
    style: wrapperStyle,
    colors: undefined,
    className: [prefixCls, className].filter(Boolean).join(' '),
    placement: GithubPlacement.TopLeft
  }, other, {
    addonAfter: /*#__PURE__*/jsxs(Fragment$1, {
      children: [/*#__PURE__*/jsx(Saturation, {
        hsva: hsva,
        style: {
          width: '100%',
          height: 130
        },
        onChange: newColor => {
          handleChange(_extends({}, hsva, newColor, {
            a: hsva.a
          }));
        }
      }), /*#__PURE__*/jsxs("div", {
        style: {
          padding: 15,
          display: 'flex',
          alignItems: 'center',
          gap: 10
        },
        children: [getIsEyeDropperSupported() && showEyeDropper && /*#__PURE__*/jsx(EyeDropper, {
          onPickColor: handleClickColor
        }), showColorPreview && /*#__PURE__*/jsx(Alpha, {
          width: 28,
          height: 28,
          hsva: hsva,
          radius: 2,
          style: {
            borderRadius: '50%'
          },
          bgProps: {
            style: {
              background: 'transparent'
            }
          },
          innerProps: {
            style: alphaStyle
          },
          pointer: () => /*#__PURE__*/jsx(Fragment$1, {})
        }), /*#__PURE__*/jsxs("div", {
          style: {
            flex: 1
          },
          children: [showHue == true && /*#__PURE__*/jsx(Hue, {
            hue: hsva.h,
            style: {
              width: '100%',
              height: 12,
              borderRadius: 2
            },
            pointerProps: pointerProps,
            bgProps: {
              style: {
                borderRadius: 2
              }
            },
            onChange: newHue => {
              handleChange(_extends({}, hsva, newHue));
            }
          }), showAlpha == true && /*#__PURE__*/jsx(Alpha, {
            hsva: hsva,
            style: {
              marginTop: 6,
              height: 12,
              borderRadius: 2
            },
            pointerProps: pointerProps,
            bgProps: {
              style: {
                borderRadius: 2
              }
            },
            onChange: newAlpha => {
              handleChange(_extends({}, hsva, newAlpha));
            }
          })]
        })]
      }), showEditableInput && /*#__PURE__*/jsxs("div", {
        style: {
          display: 'flex',
          alignItems: 'flex-start',
          padding: '0 15px 15px 15px',
          userSelect: 'none'
        },
        children: [/*#__PURE__*/jsxs("div", {
          style: {
            flex: 1
          },
          children: [type == ChromeInputType.RGBA && /*#__PURE__*/jsx(EditableInputRGBA, {
            hsva: hsva,
            rProps: {
              labelStyle,
              inputStyle
            },
            gProps: {
              labelStyle,
              inputStyle
            },
            bProps: {
              labelStyle,
              inputStyle
            },
            aProps: showAlpha == false ? false : {
              labelStyle,
              inputStyle
            },
            onChange: reColor => handleChange(reColor.hsva)
          }), type === ChromeInputType.HEXA && /*#__PURE__*/jsx(EditableInput, {
            label: "HEX",
            labelStyle: labelStyle,
            inputStyle: inputStyle,
            value: hsva.a > 0 && hsva.a < 1 ? hsvaToHexa(hsva).toLocaleUpperCase() : hsvaToHex(hsva).toLocaleUpperCase(),
            onChange: (_, value) => {
              if (typeof value === 'string') {
                handleChange(hexToHsva(/^#/.test(value) ? value : "#" + value));
              }
            }
          }), type === ChromeInputType.HSLA && /*#__PURE__*/jsx(EditableInputHSLA, {
            hsva: hsva,
            hProps: {
              labelStyle,
              inputStyle
            },
            sProps: {
              labelStyle,
              inputStyle
            },
            lProps: {
              labelStyle,
              inputStyle
            },
            aProps: showAlpha == false ? false : {
              labelStyle,
              inputStyle
            },
            onChange: reColor => handleChange(reColor.hsva)
          })]
        }), /*#__PURE__*/jsx(Arrow, {
          onClick: handleClick
        })]
      })]
    }),
    rectRender: () => /*#__PURE__*/jsx(Fragment$1, {})
  }));
});
Chrome.displayName = 'Chrome';

// Simple replacement for useOutsideClick for Chakra v3
function useOutsideClick({ ref, handler, }) {
    useEffect(() => {
        const listener = (event) => {
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            handler();
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        return () => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [ref, handler]);
}

const rangeInputRecipe = defineSlotRecipe({
    className: 'range-input',
    slots: ['root', 'group', 'input', 'increment', 'decrement', 'reset', 'valueDisplay'],
    base: {
        root: {
            display: 'flex',
            alignItems: 'center',
            overflow: 'hidden',
            gap: 1,
            height: 'var(--range-input-height)',
            width: '100px',
        },
        group: {
            borderRadius: 'md',
            borderWidth: '1px',
            display: 'flex',
            alignItems: 'center',
            overflow: 'hidden',
            flex: 1,
        },
        input: {
            width: '100%',
            height: '100%',
            display: 'none',
            fontSize: 'sm',
            borderWidth: 0,
            borderRadius: 'md',
            px: 2,
            _focus: {
                display: 'block',
            },
            '&::selection': {
                backgroundColor: 'blue.500',
            },
        },
        increment: {
            fontSize: 'sm',
            minWidth: 6,
            height: '100%',
            borderLeftRadius: 0,
            _disabled: {
                opacity: 0.4,
                cursor: 'not-allowed',
            },
            '& > svg': {
                color: 'gray.400',
            },
        },
        decrement: {
            fontSize: 'sm',
            minWidth: 6,
            height: '100%',
            borderEndRadius: 0,
            _disabled: {
                opacity: 0.4,
                cursor: 'not-allowed',
            },
            '& > svg': {
                color: 'gray.400',
            },
        },
        reset: {
            width: 'var(--range-input-height)',
            height: 'var(--range-input-height)',
            minWidth: 0,
            _disabled: {
                opacity: 0.4,
                cursor: 'not-allowed',
            },
            '& > svg': {
                width: '16px',
                height: '16px',
                color: 'gray.400',
            },
        },
        valueDisplay: {
            flex: 1,
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            fontSize: 'sm',
        },
    },
    variants: {
        colorPalette: {
            black: {
                root: {},
                group: {
                    backgroundColor: 'gray.900',
                    borderColor: 'whiteAlpha.200',
                    color: 'white',
                },
                increment: {
                    color: 'white',
                    bg: 'gray.900',
                    _hover: {
                        bg: 'gray.600',
                    },
                },
                decrement: {
                    color: 'white',
                    bg: 'gray.900',
                    _hover: {
                        bg: 'gray.600',
                    },
                },
                reset: {
                    bg: 'transparent',
                    color: 'white',
                    _hover: {
                        bg: 'gray.500',
                    },
                },
            },
            gray2Light: {
                root: {},
                group: {
                    backgroundColor: 'gray2.700',
                    borderColor: 'whiteAlpha.200',
                    color: 'white',
                },
                increment: {
                    color: 'white',
                    bg: 'transparent',
                    _hover: {
                        bg: 'gray2.700',
                    },
                },
                decrement: {
                    color: 'white',
                    bg: 'transparent',
                    _hover: {
                        bg: 'gray2.700',
                    },
                },
                reset: {
                    bg: 'transparent',
                    color: 'white',
                    _hover: {
                        bg: 'gray2.600',
                    },
                },
            },
            white: {
                root: {},
                group: {
                    backgroundColor: 'white',
                    borderColor: 'gray.300',
                    color: 'gray.600',
                },
                increment: {
                    color: 'gray.600',
                    bg: 'white',
                    _hover: {
                        bg: 'gray.200',
                    },
                },
                decrement: {
                    color: 'gray.600',
                    bg: 'white',
                    _hover: {
                        bg: 'gray.200',
                    },
                },
                reset: {
                    bg: 'transparent',
                    color: 'gray.600',
                    _hover: {
                        bg: 'gray.400',
                    },
                    '& > svg': {
                        color: 'gray.800',
                    },
                },
            },
        },
        size: {
            sm: {
                root: {
                    '--range-input-height': '20px',
                },
                increment: {
                    minWidth: 4,
                },
                decrement: {
                    minWidth: 4,
                },
                valueDisplay: {
                    fontSize: 'xs',
                },
            },
            md: {
                root: {
                    '--range-input-height': '24px',
                },
                increment: {
                    minWidth: 6,
                },
                decrement: {
                    minWidth: 6,
                },
            },
        },
    },
    defaultVariants: {
        colorPalette: 'white',
        size: 'md',
    },
});
const { withProvider: withProvider$1, withContext: withContext$1 } = createSlotRecipeContext({ recipe: rangeInputRecipe });
const RangeInputRoot = withProvider$1('div', 'root');
const RangeInputGroup = withContext$1('div', 'group');
const RangeInputInput = withContext$1('input', 'input');
const RangeInputIncrement = withContext$1('button', 'increment');
const RangeInputDecrement = withContext$1('button', 'decrement');
const RangeInputReset = withContext$1('button', 'reset');
const RangeInputValueDisplay = withContext$1('div', 'valueDisplay');

const RangeInput = ({ max, min, precision, step, unit, onDown, onClose, updateValue, onManualEdit, onReset, value, defaultValue, displayValue, disabled, size, testId = '', ...variantProps }) => {
    // Refs
    const inputRef = useRef(null);
    const [isManual, setIsManual] = useState(false);
    const handleManualToggle = useCallback((newState) => {
        onManualEdit?.(newState);
        setIsManual(newState);
        if (!newState)
            onClose?.();
    }, [onManualEdit, onClose]);
    useEffect(() => {
        if (isManual && inputRef.current) {
            inputRef.current.focus();
            inputRef.current.select();
        }
    }, [isManual]);
    const outsideClickHandler = useCallback(() => {
        if (isManual) {
            handleManualToggle(false);
        }
    }, [isManual, handleManualToggle]);
    useOutsideClick({
        ref: inputRef,
        handler: outsideClickHandler,
    });
    const onKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === 'Escape') {
            handleManualToggle(false);
        }
    };
    /**
     * Reset the input value to the default value.
     * A bit of hacky way by manually triggering an input change event directly to input/React
     * since there doesn't seem to be a way to update the internal value of useNumberInput.
     */
    const handleReset = useCallback((e) => {
        if (!inputRef.current || defaultValue === undefined)
            return;
        e.stopPropagation();
        // Change to a value different from the default so that it can see the change
        Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value')?.set?.call(inputRef.current, defaultValue - step);
        inputRef.current.dispatchEvent(new Event('input', { bubbles: true }));
        // Now set the default value
        Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value')?.set?.call(inputRef.current, defaultValue);
        inputRef.current.dispatchEvent(new Event('input', { bubbles: true }));
        // Call the callback if provided
        if (onReset)
            onReset();
    }, [defaultValue, step, onReset]);
    return (jsx(NumberInput.Root, { step: step, min: min, max: max, value: value?.toString() || '0', onValueChange: (details) => {
            if (details.valueAsNumber !== null && !Number.isNaN(details.valueAsNumber)) {
                updateValue(details.valueAsNumber);
            }
        }, children: jsxs(RangeInputRoot, { onMouseDown: onDown, className: "range-input-container", size: size, ...variantProps, children: [jsxs(RangeInputGroup, { children: [jsx(RangeInputInput, { as: NumberInput.Input, "data-testid": `range-input-${testId}`, onKeyDown: onKeyDown, autoFocus: true, ref: inputRef, display: isManual ? 'block' : 'none' }), !isManual && (jsxs(Fragment, { children: [jsx(NumberInput.DecrementTrigger, { asChild: true, unstyled: true, children: jsx(RangeInputDecrement, { as: IconButton, disabled: value === null, className: "range-input-decrement", "aria-label": "decrease", "data-testid": `range-input-${testId}-decrement`, children: jsx(Icon, { as: CaretLeftIcon, boxSize: 4 }) }) }), jsx(RangeInputValueDisplay, { onClick: () => handleManualToggle(!disabled), children: jsx(NumberInput.ValueText, { asChild: true, children: jsxs(Text$2, { flex: "1", textAlign: "right", children: [value === null ? '-' : displayValue || value, value !== null && unit ? unit : ''] }) }) }), jsx(NumberInput.IncrementTrigger, { asChild: true, unstyled: true, children: jsx(RangeInputIncrement, { as: IconButton, disabled: value === null, className: "range-input-increment", "aria-label": "increase", "data-testid": `range-input-${testId}-increment`, children: jsx(Icon, { as: CaretRightIcon, boxSize: 4 }) }) })] }))] }), onReset && (jsx(RangeInputReset, { as: IconButton, "aria-label": "reset", onClick: handleReset, "data-testid": `range-input-${testId}-reset`, children: jsx(ResetIcon, {}) }))] }) }));
};

const Field$1 = ({ id, name, bgColor, textColor, visible, containerRef, onChange, onUpdated, }) => {
    // States
    const [tempBgColor, setTempBgColor] = useState(bgColor);
    const [tempTextColor, setTempTextColor] = useState(textColor);
    /**
     * Handle close color selection.
     * - Executes callback
     * - Resets temporary color
     */
    const handleCloseColorSelection = useCallback(() => {
        onUpdated?.({
            text_color: tempTextColor,
            bg_color: tempBgColor,
        });
    }, [tempTextColor, tempBgColor, onUpdated]);
    /**
     * Update temp colors when value changes from outside.
     */
    useEffect(() => {
        setTempBgColor(bgColor);
        setTempTextColor(textColor);
    }, [bgColor, textColor]);
    return (jsxs(Fragment$1, { children: [jsx(Box, { ml: 4, children: jsxs(Switch.Root, { colorPalette: "blue", checked: visible, onCheckedChange: () => onUpdated?.({ visible: !visible }), children: [jsx(Switch.HiddenInput, {}), jsx(Switch.Control, {})] }) }), jsx(Box, { children: name }), jsx(Flex, { justifyContent: "center", alignItems: "center", children: jsxs(Popover.Root, { onOpenChange: (e) => !e.open && handleCloseColorSelection(), children: [jsx(Popover.Trigger, { asChild: true, children: jsx(Button, { variant: "outline", maxWidth: 6, minWidth: 6, width: 6, height: 6, p: 0, backgroundColor: tempBgColor, borderColor: "secondary.200", _hover: { bg: tempBgColor }, _focus: { bg: tempBgColor }, _active: { bg: tempBgColor } }) }), jsx(Portal, { container: containerRef, children: jsx(Popover.Positioner, { children: jsx(Popover.Content, { w: "auto", children: jsx(Chrome, { inputType: ChromeInputType.HEXA, showAlpha: false, showEyeDropper: false, color: tempBgColor, onChange: (color) => {
                                            setTempBgColor(color.hex);
                                            onChange?.({ bg_color: color.hex });
                                        } }) }) }) })] }) }), jsx(Flex, { justifyContent: "center", alignItems: "center", children: jsxs(Popover.Root, { onOpenChange: (e) => !e.open && handleCloseColorSelection(), children: [jsx(Popover.Trigger, { asChild: true, children: jsx(Button, { variant: "outline", maxWidth: 6, minWidth: 6, width: 6, height: 6, p: 0, backgroundColor: tempTextColor, borderColor: "secondary.200", _hover: { bg: tempTextColor }, _focus: { bg: tempTextColor }, _active: { bg: tempTextColor } }) }), jsx(Portal, { container: containerRef, children: jsx(Popover.Positioner, { children: jsx(Popover.Content, { w: "auto", children: jsx(Chrome, { inputType: ChromeInputType.HEXA, showAlpha: false, showEyeDropper: false, color: tempTextColor, onChange: (color) => {
                                            setTempTextColor(color.hex);
                                            onChange?.({ text_color: color.hex });
                                        } }) }) }) })] }) })] }, id));
};

const LabelColorFields = ({ labels }) => {
    // Refs
    const containerRef = useRef(null);
    return (jsxs(Grid, { ref: containerRef, templateColumns: "55px 1fr 56px 56px", columnGap: 2, rowGap: 2, width: "100%", children: [jsx(Box, { gridColumn: "1 / span 2", fontSize: "lg", fontWeight: "bold", children: "\u30E9\u30D9\u30EB" }), jsx(Box, { textAlign: "center", pt: 1, fontSize: "sm", color: "gray.500", children: "\u80CC\u666F" }), jsx(Box, { textAlign: "center", pt: 1, fontSize: "sm", color: "gray.500", children: "\u30C6\u30AD\u30B9\u30C8" }), labels.map((label) => (createElement(Field$1, { ...label, key: label.id, containerRef: containerRef })))] }));
};

var FieldType;
(function (FieldType) {
    FieldType[FieldType["Range"] = 0] = "Range";
    FieldType[FieldType["Color"] = 1] = "Color";
    FieldType[FieldType["Toggle"] = 2] = "Toggle";
    FieldType[FieldType["Dropdown"] = 3] = "Dropdown";
    FieldType[FieldType["LabelColors"] = 4] = "LabelColors";
})(FieldType || (FieldType = {}));

/**
 * Render label with optional help tooltip
 */
const FieldLabel = ({ label, helpText }) => {
    const containerRef = useRef(null);
    if (!helpText) {
        return (jsx(Text$2, { fontSize: "md", color: "gray.600", children: label }));
    }
    return (jsx(Tooltip, { label: jsx(Text$2, { whiteSpace: "pre-line", children: helpText }), positioning: { placement: 'top' }, showArrow: true, 
        // gutter={12}
        portalRef: containerRef, children: jsxs(HStack, { gap: 1, ref: containerRef, children: [jsx(Text$2, { fontSize: "md", color: "gray.600", children: label }), jsx(Icon, { as: HelpOutlineIcon, color: "gray.500", boxSize: 3, cursor: "help" })] }) }));
};

const Field = ({ id, label, type, value, onChange, onUpdated, min, max, step, unit, options, labels, helpText, containerRef, }) => {
    // States
    const [tempColor, setTempColor] = useState(value);
    /**
     * Handle close color selection.
     * - Executes callback
     * - Resets temporary color
     */
    const handleCloseColorSelection = useCallback((callback) => {
        if (!tempColor)
            return;
        callback?.(tempColor);
    }, [tempColor]);
    /**
     * Update tempColor when value changes from outside.
     */
    useEffect(() => {
        if (type === FieldType.Color && typeof value === 'string') {
            setTempColor(value);
        }
    }, [type, value]);
    return (jsxs(HStack, { w: "100%", children: [type === FieldType.Range && typeof value === 'number' && (jsxs(Fragment, { children: [jsx(FieldLabel, { label: label, helpText: helpText }), jsx(Spacer, {}), jsx(RangeInput, { testId: `test-${id}`, min: min, max: max, step: step || 1, precision: getPrecision(step || 1), unit: unit, value: value, displayValue: `${value}`, updateValue: (newValue) => onUpdated?.(newValue), onReset: () => null }, id)] })), type === FieldType.Color && typeof value === 'string' && (jsxs(Fragment, { children: [jsx(FieldLabel, { label: label, helpText: helpText }), jsx(Spacer, {}), jsxs(Popover.Root, { onOpenChange: (e) => !e.open && handleCloseColorSelection(onUpdated), children: [jsx(Popover.Trigger, { asChild: true, children: jsx(Button, { variant: "outline", maxWidth: 8, minWidth: 8, width: 8, height: 8, p: 0, backgroundColor: tempColor, borderColor: "secondary.200", _hover: { bg: tempColor }, _focus: { bg: tempColor }, _active: { bg: tempColor } }) }), jsx(Portal, { container: containerRef, children: jsx(Popover.Positioner, { children: jsx(Popover.Content, { w: "auto", children: jsx(Chrome, { inputType: ChromeInputType.HEXA, showAlpha: false, showEyeDropper: false, color: tempColor, onChange: (color) => {
                                                setTempColor(color.hex);
                                                onChange?.(color.hex);
                                            } }) }) }) })] })] })), type === FieldType.Toggle && typeof value === 'boolean' && (jsxs(Fragment, { children: [jsx(FieldLabel, { label: label, helpText: helpText }), jsx(Spacer, {}), jsxs(Switch.Root, { colorPalette: "blue", checked: value, onCheckedChange: (e) => onUpdated?.(e.checked), children: [jsx(Switch.HiddenInput, {}), jsx(Switch.Control, {})] })] })), type === FieldType.Dropdown && typeof value === 'string' && options && (jsxs(Fragment, { children: [jsx(FieldLabel, { label: label, helpText: helpText }), jsx(Spacer, {}), jsxs(Menu.Root, { lazyMount: true, positioning: { placement: 'bottom-end' }, children: [jsx(Menu.Trigger, { asChild: true, children: jsxs(Button, { fontWeight: "normal", variant: "outline", size: "sm", bg: "white", color: "gray.600", children: [options[value], " ", jsx(LuChevronDown, {})] }) }), jsx(Portal, { children: jsx(Menu.Positioner, { children: jsx(Menu.Content, { children: Object.entries(options).map(([optionValue, optionLabel]) => (jsx(Menu.Item, { value: optionValue, onClick: () => onUpdated?.(optionValue), color: "gray.600", children: optionLabel }, optionValue))) }) }) })] })] })), type === FieldType.LabelColors && labels && jsx(LabelColorFields, { labels: labels })] }, id));
};

const CUSTOMIZABLE_FIELD_CLOSED_HEIGHT = '52px';
const customizableFieldRecipe = defineSlotRecipe({
    className: 'customizableField',
    slots: ['root', 'label', 'toggle', 'fields'],
    base: {
        root: {
            borderWidth: '1px',
            borderRadius: 6,
            overflow: 'hidden',
            transition: 'max-height 0.3s ease, border-color 0.2s',
            mb: 2.5,
        },
        label: {
            display: 'flex',
            p: 2,
            alignItems: 'center',
            height: CUSTOMIZABLE_FIELD_CLOSED_HEIGHT,
            gap: 2,
        },
        toggle: {
        // Styles for Switch will be handled by Switch component itself
        },
        fields: {
            bg: 'gray.50',
            px: 4,
            py: 2,
            borderBottomRadius: 6,
        },
    },
    variants: {
        enabled: {
            true: {
                root: {
                    borderColor: 'blue.500',
                },
            },
            false: {
                root: {
                    borderColor: 'gray.300',
                },
            },
        },
        expandable: {
            true: {
                label: {
                    cursor: 'pointer',
                    _hover: {
                        bg: 'gray.100',
                    },
                },
            },
            false: {
                label: {
                    cursor: 'default',
                },
            },
        },
        expanded: {
            true: {
                root: {
                    maxHeight: '550px',
                },
            },
            false: {
                root: {
                    maxHeight: CUSTOMIZABLE_FIELD_CLOSED_HEIGHT,
                },
            },
        },
    },
    defaultVariants: {
        enabled: true,
        expandable: true,
        expanded: false,
    },
});
const { withProvider, withContext } = createSlotRecipeContext({ recipe: customizableFieldRecipe });
const CustomizableFieldRoot = withProvider('div', 'root');
const CustomizableFieldLabel = withContext('div', 'label');
const CustomizableFieldToggle = withContext('div', 'toggle');
const CustomizableFieldFields = withContext('div', 'fields');

/**
 * A customizable field component with better customization options.
 * In ToleranceField, it is locked to tolerance type and additional toggle fields only.
 * In this component, every option row can be of any type.
 */
const CustomizableField = ({ icon, title, enabled = true, expanded, expandable = true, onToggle, fields = [], }) => {
    // States
    const [isExpanded, setIsExpanded] = useState(expandable ? (expanded ?? enabled ?? false) : false);
    // Refs
    const containerRef = useRef(null);
    useEffect(() => {
        setIsExpanded(expanded ?? enabled ?? false);
    }, [expanded, enabled]);
    return (jsxs(CustomizableFieldRoot, { ref: containerRef, enabled: enabled, expandable: expandable, expanded: isExpanded, children: [jsxs(CustomizableFieldLabel, { onClick: expandable ? () => setIsExpanded((prev) => !prev) : undefined, children: [icon, jsx(Text$2, { flex: 1, fontSize: "xl", children: title }), onToggle && (jsx(CustomizableFieldToggle, { children: jsxs(Switch.Root, { colorPalette: "blue", checked: enabled, onCheckedChange: (e) => onToggle(e.checked), onClick: (e) => e.stopPropagation(), children: [jsx(Switch.HiddenInput, {}), jsx(Switch.Control, {})] }) }))] }), jsx(CustomizableFieldFields, { children: jsx(VStack, { children: fields
                        .filter((field) => field.visible !== false)
                        .map((field) => (createElement(Field, { ...field, key: field.id, containerRef: containerRef }))) }) })] }));
};

const ELEMENT_TOGGLES = [
    { key: 'min', label: '最小' },
    { key: 'max', label: '最大' },
    { key: 'avg', label: '平均' },
];
const SIDES = [
    { key: 'upper', title: '表' },
    { key: 'lower', title: '裏' },
];
/**
 * かぶり厚-specific display settings.
 *
 * One section per side (表 / 裏). Each section holds the label config (moved from
 * 体積) and the per-element visibility toggles (最小 / 最大 / 平均).
 *
 * This intentionally does not reuse CustomizableField — its expand/collapse
 * max-height would clip the two stacked sections — but mirrors its look.
 */
const CoverThicknessSettings = ({ depth, onUpdated, onChange, }) => {
    // Refs (shared anchor for the color popovers)
    const containerRef = useRef(null);
    const patchSide = (side, value) => side === 'upper' ? { depth: { upper: value } } : { depth: { lower: value } };
    const updateLabel = (side, label) => onUpdated(patchSide(side, { label }));
    const changeLabel = (side, label) => onChange(patchSide(side, { label }));
    const updateShow = (side, key, value) => {
        // Always send the complete { min, max, avg } block — the BE schema requires
        // all three whenever `show` is present, so a partial patch (which merges into
        // a config that may not have `show` yet) would fail validation.
        const current = depth[side].show;
        const next = {
            min: current?.min ?? true,
            max: current?.max ?? true,
            avg: current?.avg ?? true,
        };
        next[key] = value;
        onUpdated(patchSide(side, { show: next }));
    };
    return (jsxs(Box, { ref: containerRef, border: "1px solid", borderColor: "blue.500", borderRadius: 6, overflow: "hidden", mb: "10px", children: [jsxs(Flex, { p: 2, align: "center", gap: 2, children: [jsx(SvgToolbarCoverThickness, { className: "icon-black", height: "1.3em", width: "1.3em" }), jsx(Text$2, { flex: 1, fontSize: "xl", children: "\u304B\u3076\u308A\u539A" })] }), jsx(Box, { bg: "gray.50", px: 4, py: 2, borderBottomRadius: 6, children: jsx(VStack, { align: "stretch", gap: 3, children: SIDES.map(({ key, title }, index) => {
                        const config = depth[key];
                        return (jsxs(Box, { children: [index > 0 && jsx(Separator, { mb: 3, borderColor: "gray.300" }), jsxs(Grid, { templateColumns: "50px 1fr 56px 56px", columnGap: 2, rowGap: 2, width: "100%", my: 3, children: [jsx(Box, { gridColumn: "1 / span 2", fontSize: "xl", fontWeight: "bold", color: "gray.600", children: title }), jsx(Box, { textAlign: "center", pt: 1, fontSize: "sm", color: "gray.600", children: "\u80CC\u666F" }), jsx(Box, { textAlign: "center", pt: 1, fontSize: "sm", color: "gray.600", children: "\u30C6\u30AD\u30B9\u30C8" }), jsx(Field$1, { id: `depth-${key}-label`, name: "\u30E9\u30D9\u30EB", bgColor: config.label.bg_color, textColor: config.label.text_color, visible: config.label.visible ?? true, containerRef: containerRef, onUpdated: (label) => updateLabel(key, label), onChange: (label) => changeLabel(key, label) })] }), jsx(Text$2, { fontSize: "md", fontWeight: "bold", color: "gray.600", mb: 1, children: "\u8981\u7D20\u8868\u793A" }), jsx(VStack, { align: "stretch", gap: 2, pl: 4, children: ELEMENT_TOGGLES.map(({ key: showKey, label }) => (jsxs(HStack, { w: "100%", children: [jsx(Text$2, { children: label }), jsx(Spacer, {}), jsxs(Switch.Root, { colorPalette: "blue", checked: config.show?.[showKey] ?? true, onCheckedChange: (e) => updateShow(key, showKey, Boolean(e.checked)), children: [jsx(Switch.HiddenInput, {}), jsx(Switch.Control, {})] })] }, showKey))) })] }, key));
                    }) }) })] }));
};

/**
 * The per-element-type sections of the 要素 block. A host that doesn't render every element type
 * (the Platform's 3D view) passes the subset it does; the 一般 section is not one of them and is
 * always shown, since the coloring mode it holds applies whatever a host renders.
 */
var EditorDisplaySettingsSection;
(function (EditorDisplaySettingsSection) {
    EditorDisplaySettingsSection["Polyline"] = "POLYLINE";
    EditorDisplaySettingsSection["Plane"] = "PLANE";
    EditorDisplaySettingsSection["Volume"] = "VOLUME";
    EditorDisplaySettingsSection["CoverThickness"] = "COVER_THICKNESS";
    EditorDisplaySettingsSection["Rebar"] = "REBAR";
    EditorDisplaySettingsSection["CustomMeasurement"] = "CUSTOM_MEASUREMENT";
})(EditorDisplaySettingsSection || (EditorDisplaySettingsSection = {}));
const EditorDisplaySettings = ({ settings, sections, onUpdated, onChange, }) => {
    // Derived
    const isGroupColoring = settings.general.display_type === EditorColoringType.Group;
    const isElementColoring = settings.general.display_type === EditorColoringType.Element;
    const showsSection = (section) => !sections || sections.includes(section);
    return (jsxs(Fragment, { children: [jsx(SectionTitle, { children: "3D\u753B\u9762" }), jsxs(Box, { mt: 3, className: "setting-group", children: [jsx(CustomizableField, { icon: jsx(SettingIcon, { className: "icon-black", size: "1.3em" }), expandable: false, title: "\u4E00\u822C", fields: [
                            {
                                id: 'canvas-bg-color',
                                type: FieldType.Color,
                                label: '背景色',
                                value: settings.general.bg_color,
                                onUpdated: (value) => onUpdated({ general: { bg_color: value } }),
                                onChange: (value) => onChange({ general: { bg_color: value } }),
                            },
                            {
                                id: 'label-size',
                                type: FieldType.Range,
                                label: 'ラベルサイズ',
                                value: settings.general.label_size,
                                min: 1,
                                max: 5,
                                step: 0.1,
                                onUpdated: (value) => onUpdated({ general: { label_size: value } }),
                            },
                        ] }), jsx(CustomizableField, { icon: jsx(SvgPcd, { className: "icon-black", width: "1.5em", height: "1.5em" }), expandable: false, title: "\u70B9\u7FA4", fields: [
                            {
                                id: 'pcd-visible',
                                type: FieldType.Toggle,
                                label: '表示・非表示',
                                value: settings.pcd.visible,
                                onUpdated: (value) => onUpdated({ pcd: { visible: value } }),
                            },
                            {
                                id: 'pcd-opacity',
                                type: FieldType.Range,
                                label: '不透明度',
                                value: settings.pcd.opacity * 100,
                                min: 0,
                                max: 100,
                                step: 10,
                                unit: '%',
                                onUpdated: (value) => onUpdated({ pcd: { opacity: value / 100 } }),
                            },
                            {
                                id: 'pcd-point-size',
                                type: FieldType.Range,
                                label: '点のサイズ',
                                value: settings.pcd.point_size,
                                min: 0.1,
                                max: 5,
                                step: 0.1,
                                onUpdated: (value) => onUpdated({ pcd: { point_size: value } }),
                            },
                        ] }), jsx(CustomizableField, { icon: jsx(CubeIcon, { className: "icon-black", size: "1.3em" }), expandable: false, title: "3D\u30E1\u30C3\u30B7\u30E5", fields: [
                            {
                                id: 'mesh-visible',
                                type: FieldType.Toggle,
                                label: '表示・非表示',
                                value: settings.mesh.visible,
                                onUpdated: (value) => onUpdated({ mesh: { visible: value } }),
                            },
                            {
                                id: 'mesh-opacity',
                                type: FieldType.Range,
                                label: '不透明度',
                                value: settings.mesh.opacity * 100,
                                min: 0,
                                max: 100,
                                step: 10,
                                unit: '%',
                                onUpdated: (value) => onUpdated({ mesh: { opacity: value / 100 } }),
                            },
                        ] })] }), jsx(Spacer, { my: 8 }), jsx(SectionTitle, { children: "\u8981\u7D20" }), jsxs(Box, { mt: 3, className: "setting-group", children: [jsx(CustomizableField, { icon: jsx(SettingIcon, { className: "icon-black", size: "1.3em" }), expandable: false, title: "\u4E00\u822C", fields: [
                            {
                                id: 'coloring-type',
                                type: FieldType.Dropdown,
                                label: '要素の色',
                                value: settings.general.display_type,
                                options: {
                                    auto: '自動',
                                    group: '検査グループ',
                                    element: '要素の種類',
                                },
                                helpText: '3D画面上の要素の色を設定します。\n\n' +
                                    '自動：検査グループがあれば検査グループの色、なければ要素の種類に応じた色\n' +
                                    '検査グループ：検査グループに応じた色\n' +
                                    '要素の種類：要素の種類に応じた色',
                                onUpdated: (value) => onUpdated({ general: { display_type: value } }),
                            },
                            {
                                id: 'unlabeled-color',
                                type: FieldType.Color,
                                label: '未分類要素の色',
                                value: settings.general.unlabeled_color,
                                visible: !isElementColoring,
                                onUpdated: (value) => onUpdated({ general: { unlabeled_color: value } }),
                                onChange: (value) => onChange({ general: { unlabeled_color: value } }),
                            },
                        ] }), showsSection(EditorDisplaySettingsSection.Polyline) && (jsx(CustomizableField, { icon: jsx(SvgToolbarPolyline, { className: "icon-black", height: "1.3em", width: "1.3em" }), expandable: false, title: "\u5EF6\u9577", fields: [
                            {
                                id: 'polyline-color',
                                type: FieldType.Color,
                                label: '色',
                                value: settings.polyline.color,
                                visible: !isGroupColoring,
                                onUpdated: (value) => onUpdated({ polyline: { color: value } }),
                                onChange: (value) => onChange({ polyline: { color: value } }),
                            },
                            {
                                id: 'polyline-labels',
                                type: FieldType.LabelColors,
                                label: '',
                                value: '',
                                labels: [
                                    {
                                        id: 'polyline-label-total',
                                        name: '合計',
                                        bgColor: settings.polyline.primary.label.bg_color,
                                        textColor: settings.polyline.primary.label.text_color,
                                        visible: settings.polyline.primary.label.visible ?? true,
                                        onUpdated: (updatedLabel) => onUpdated({
                                            polyline: {
                                                primary: { label: updatedLabel },
                                            },
                                        }),
                                        onChange: (updatedLabel) => onChange({
                                            polyline: {
                                                primary: { label: updatedLabel },
                                            },
                                        }),
                                    },
                                    {
                                        id: 'polyline-label-edge',
                                        name: '各辺',
                                        bgColor: settings.polyline.edge.label.bg_color,
                                        textColor: settings.polyline.edge.label.text_color,
                                        visible: settings.polyline.edge.label.visible ?? false,
                                        onUpdated: (updatedLabel) => onUpdated({
                                            polyline: {
                                                edge: { label: updatedLabel },
                                            },
                                        }),
                                        onChange: (updatedLabel) => onChange({
                                            polyline: {
                                                edge: { label: updatedLabel },
                                            },
                                        }),
                                    },
                                ],
                            },
                        ] })), showsSection(EditorDisplaySettingsSection.Plane) && (jsx(CustomizableField, { icon: jsx(SvgToolbarPlane, { className: "icon-black", height: "1.3em", width: "1.3em" }), expandable: false, title: "\u9762\u7A4D", fields: [
                            {
                                id: 'plane-color',
                                type: FieldType.Color,
                                label: '色',
                                value: settings.plane.color,
                                visible: !isGroupColoring,
                                onUpdated: (value) => onUpdated({ plane: { color: value } }),
                                onChange: (value) => onChange({ plane: { color: value } }),
                            },
                            {
                                id: 'plane-opacity',
                                type: FieldType.Range,
                                label: '不透明度',
                                value: (settings.plane.opacity || 1) * 100,
                                min: 0,
                                max: 100,
                                step: 10,
                                unit: '%',
                                onUpdated: (value) => onUpdated({ plane: { opacity: value / 100 } }),
                            },
                            {
                                id: 'plane-labels',
                                type: FieldType.LabelColors,
                                label: '',
                                value: '',
                                labels: [
                                    {
                                        id: 'plane-label-total',
                                        name: '合計',
                                        bgColor: settings.plane.primary.label.bg_color,
                                        textColor: settings.plane.primary.label.text_color,
                                        visible: settings.plane.primary.label.visible ?? true,
                                        onUpdated: (updatedLabel) => onUpdated({
                                            plane: {
                                                primary: { label: updatedLabel },
                                            },
                                        }),
                                        onChange: (updatedLabel) => onChange({
                                            plane: {
                                                primary: { label: updatedLabel },
                                            },
                                        }),
                                    },
                                    {
                                        id: 'plane-label-edge',
                                        name: '各辺',
                                        bgColor: settings.plane.edge.label.bg_color,
                                        textColor: settings.plane.edge.label.text_color,
                                        visible: settings.plane.edge.label.visible ?? false,
                                        onUpdated: (updatedLabel) => onUpdated({
                                            plane: {
                                                edge: { label: updatedLabel },
                                            },
                                        }),
                                        onChange: (updatedLabel) => onChange({
                                            plane: {
                                                edge: { label: updatedLabel },
                                            },
                                        }),
                                    },
                                ],
                            },
                        ] })), showsSection(EditorDisplaySettingsSection.Volume) && (jsx(CustomizableField, { icon: jsx(SvgToolbarVolumeEstimationPolygon, { className: "icon-black", height: "1.3em", width: "1.3em" }), expandable: false, title: "\u4F53\u7A4D", fields: [
                            {
                                id: 'volume-upper-color',
                                type: FieldType.Color,
                                label: '仕上がり面の色',
                                value: settings.volume.upper.color,
                                visible: !isGroupColoring,
                                onUpdated: (value) => onUpdated({ volume: { upper: { color: value } } }),
                                onChange: (value) => onChange({ volume: { upper: { color: value } } }),
                            },
                            {
                                id: 'volume-lower-color',
                                type: FieldType.Color,
                                label: '斫り面の色',
                                value: settings.volume.lower.color,
                                visible: !isGroupColoring,
                                onUpdated: (value) => onUpdated({ volume: { lower: { color: value } } }),
                                onChange: (value) => onChange({ volume: { lower: { color: value } } }),
                            },
                            {
                                id: 'volume-opacity',
                                type: FieldType.Range,
                                label: '不透明度',
                                value: (settings.volume.upper.opacity || 1) * 100,
                                min: 0,
                                max: 100,
                                step: 10,
                                unit: '%',
                                onUpdated: (value) => onUpdated({
                                    volume: {
                                        upper: { opacity: value / 100 },
                                        lower: { opacity: value / 100 },
                                    },
                                }),
                            },
                            {
                                id: 'volume-labels',
                                type: FieldType.LabelColors,
                                label: '',
                                value: '',
                                labels: [
                                    {
                                        id: 'volume-label-total',
                                        name: '体積',
                                        bgColor: settings.volume.upper.primary.label.bg_color,
                                        textColor: settings.volume.upper.primary.label.text_color,
                                        visible: settings.volume.upper.primary.label.visible ?? true,
                                        onUpdated: (updatedLabel) => onUpdated({
                                            volume: {
                                                upper: { primary: { label: updatedLabel } },
                                            },
                                        }),
                                        onChange: (updatedLabel) => onChange({
                                            volume: {
                                                upper: { primary: { label: updatedLabel } },
                                            },
                                        }),
                                    },
                                    {
                                        id: 'volume-label-upper-edge',
                                        name: '仕上がり面の辺長',
                                        bgColor: settings.volume.upper.edge.label.bg_color,
                                        textColor: settings.volume.upper.edge.label.text_color,
                                        visible: settings.volume.upper.edge.label.visible ?? true,
                                        onUpdated: (updatedLabel) => onUpdated({
                                            volume: {
                                                upper: { edge: { label: updatedLabel } },
                                            },
                                        }),
                                        onChange: (updatedLabel) => onChange({
                                            volume: {
                                                upper: { edge: { label: updatedLabel } },
                                            },
                                        }),
                                    },
                                    {
                                        id: 'volume-label-lower-edge',
                                        name: '斫り面の辺長',
                                        bgColor: settings.volume.lower.edge.label.bg_color,
                                        textColor: settings.volume.lower.edge.label.text_color,
                                        visible: settings.volume.lower.edge.label.visible ?? true,
                                        onUpdated: (updatedLabel) => onUpdated({
                                            volume: {
                                                lower: { edge: { label: updatedLabel } },
                                            },
                                        }),
                                        onChange: (updatedLabel) => onChange({
                                            volume: {
                                                lower: { edge: { label: updatedLabel } },
                                            },
                                        }),
                                    },
                                    {
                                        id: 'volume-label-grid-point',
                                        name: 'グリッド点',
                                        bgColor: settings.grid.label.bg_color,
                                        textColor: settings.grid.label.text_color,
                                        visible: settings.grid.label.visible ?? true,
                                        onUpdated: (updatedLabel) => onUpdated({
                                            grid: {
                                                label: updatedLabel,
                                            },
                                        }),
                                        onChange: (updatedLabel) => onChange({
                                            grid: {
                                                label: updatedLabel,
                                            },
                                        }),
                                    },
                                    {
                                        id: 'volume-label-grid-point-error',
                                        name: 'グリッドの深さ欠損点',
                                        bgColor: settings.grid.error.label.bg_color,
                                        textColor: settings.grid.error.label.text_color,
                                        visible: settings.grid.error.label.visible ?? true,
                                        onUpdated: (updatedLabel) => onUpdated({
                                            grid: {
                                                error: { label: updatedLabel },
                                            },
                                        }),
                                        onChange: (updatedLabel) => onChange({
                                            grid: {
                                                error: { label: updatedLabel },
                                            },
                                        }),
                                    },
                                ],
                            },
                        ] })), showsSection(EditorDisplaySettingsSection.CoverThickness) && (jsx(CoverThicknessSettings, { depth: settings.depth, onUpdated: onUpdated, onChange: onChange })), showsSection(EditorDisplaySettingsSection.Rebar) && (jsx(CustomizableField, { icon: jsx(SvgToolbarCylinder, { className: "icon-black", height: "1.3em", width: "1.3em" }), expandable: false, title: "\u9244\u7B4B", fields: [
                            {
                                id: 'rebar-color',
                                type: FieldType.Color,
                                label: '色',
                                value: settings.rebar.color,
                                visible: !isGroupColoring,
                                onUpdated: (value) => onUpdated({ rebar: { color: value } }),
                                onChange: (value) => onChange({ rebar: { color: value } }),
                            },
                            {
                                id: 'rebar-labels',
                                type: FieldType.LabelColors,
                                label: '',
                                value: '',
                                labels: [
                                    {
                                        id: 'rebar-label-surface-area',
                                        name: '面積',
                                        bgColor: settings.rebar.primary.label.bg_color,
                                        textColor: settings.rebar.primary.label.text_color,
                                        visible: settings.rebar.primary.label.visible ?? true,
                                        onUpdated: (updatedLabel) => onUpdated({ rebar: { primary: { label: updatedLabel } } }),
                                        onChange: (updatedLabel) => onChange({ rebar: { primary: { label: updatedLabel } } }),
                                    },
                                ],
                            },
                        ] })), showsSection(EditorDisplaySettingsSection.CustomMeasurement) && (jsx(CustomizableField, { icon: jsx(SvgToolbarDistance, { className: "icon-black", height: "1.3em", width: "1.3em" }), expandable: false, title: "\u8DDD\u96E2\u306E\u8A08\u7B97", fields: [
                            {
                                id: 'custom-measurement-color',
                                type: FieldType.Color,
                                label: '色',
                                value: settings.custom_measurement.color,
                                visible: !isGroupColoring,
                                onUpdated: (value) => onUpdated({ custom_measurement: { color: value } }),
                                onChange: (value) => onChange({ custom_measurement: { color: value } }),
                            },
                            {
                                id: 'custom-measurement-labels',
                                type: FieldType.LabelColors,
                                label: '',
                                value: '',
                                labels: [
                                    {
                                        id: 'custom-measurement-label-distance',
                                        name: '合計',
                                        bgColor: settings.custom_measurement.primary.label.bg_color,
                                        textColor: settings.custom_measurement.primary.label.text_color,
                                        visible: settings.custom_measurement.primary.label.visible ?? true,
                                        onUpdated: (updatedLabel) => onUpdated({ custom_measurement: { primary: { label: updatedLabel } } }),
                                        onChange: (updatedLabel) => onChange({ custom_measurement: { primary: { label: updatedLabel } } }),
                                    },
                                ],
                            },
                        ] }))] })] }));
};

const TABS = [{ value: 'display', title: '表示設定' }];
/**
 * The 3D display-settings slide-out drawer, shared by the Editor page and the Platform's 3D view.
 *
 * The component owns the chrome and the interaction contract only — edits **preview immediately**
 * through `onUpdated`, **saving is explicit** via 保存, and cancel/close **reverts** the preview.
 * Reading and persisting the area's `display_config` is the host's job, injected here.
 */
const EditorSettingsDrawer = ({ open, settings, sections, isSaving = false, onChange, onUpdated, onSave, onCancel, onResetToAccountSettings, }) => (jsx(Drawer.Root, { closeOnInteractOutside: false, open: open, onOpenChange: (e) => {
        if (!e.open)
            onCancel();
    }, size: "md", children: jsxs(Portal, { children: [jsx(Drawer.Backdrop, { bg: "blackAlpha.400" }), jsx(Drawer.Positioner, { children: jsxs(Drawer.Content, { children: [jsxs(Drawer.Header, { textAlign: "center", flexDirection: "column", p: 0, children: [jsx(Box, { fontSize: "xl", fontWeight: "semibold", color: "gray2.700", borderBottomColor: "gray2.300", borderBottomWidth: "1px", p: 6, w: "full", children: "3D\u753B\u9762\u306E\u8A2D\u5B9A" }), jsx(Tabs.Root, { value: "display", w: "full", justifyContent: "start", mt: 2, px: 4, children: jsx(Tabs.List, { children: TABS.map((tab) => (jsx(Tabs.Trigger, { value: tab.value, children: tab.title }, tab.value))) }) })] }), jsxs(Drawer.Body, { py: 6, children: [jsxs(Box, { borderLeft: "4px solid {colors.blue.400}", pl: 2, children: ["\u8A2D\u5B9A\u306F\u30A8\u30EA\u30A2\u306B\u9069\u7528\u3055\u308C\u307E\u3059\u3002 ", jsx("br", {}), "\u521D\u671F\u8A2D\u5B9A\u3092\u5909\u66F4\u3059\u308B\u306B\u306F", ' ', jsx(Link, { color: "blue.400", href: `${MARKLY_URL}/user#editor`, target: "_blank", children: "\u30A2\u30AB\u30A6\u30F3\u30C8\u8A2D\u5B9A" }), "\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002"] }), jsx(Spacer, { my: 6 }), jsx(EditorDisplaySettings, { settings: settings, sections: sections, onUpdated: onUpdated, onChange: onChange })] }), jsxs(Drawer.Footer, { borderTopColor: "gray2.300", borderTopWidth: 1, pt: 4, children: [onResetToAccountSettings ? (jsxs(Button, { "aria-label": "\u30A2\u30AB\u30A6\u30F3\u30C8\u8A2D\u5B9A\u306B\u623B\u3059", variant: "ghost", color: "blue.500", disabled: isSaving, onClick: onResetToAccountSettings, children: [jsx(ResetIcon, { size: "1.3em" }), "\u30A2\u30AB\u30A6\u30F3\u30C8\u8A2D\u5B9A\u306B\u623B\u3059"] })) : null, jsx(Spacer, {}), jsx(Button, { variant: "outline", mr: 3, onClick: onCancel, disabled: isSaving, children: "\u30AD\u30E3\u30F3\u30BB\u30EB" }), jsx(Button, { colorPalette: "blue", onClick: onSave, disabled: isSaving, loading: isSaving, loadingText: "\u4FDD\u5B58\u4E2D...", children: "\u4FDD\u5B58" })] })] }) })] }) }));

/**
 * Non-negative decimal input with stepper buttons (revealed on hover/focus) and an optional unit
 * suffix. The draft is kept internally as a string so in-progress input like "12." or ".5" survives
 * the round-trip through `onValueChange` → `value`; consumers only ever see the parsed number
 * (`undefined` while the field is empty / not yet a number).
 */
const StepperNumberInput = ({ value, onValueChange, min = 0, step = 1, unit, placeholder, testId }) => {
    const [draft, setDraft] = useState(value?.toString() ?? '');
    // Re-sync the draft only when `value` diverges from what the draft already parses to, so an echo
    // of the user's own keystroke (e.g. "12." parsing to 12) doesn't rewrite — and truncate — it.
    useEffect(() => {
        setDraft((prev) => {
            const parsed = parseFloat(prev);
            const current = Number.isNaN(parsed) ? undefined : parsed;
            return current === value ? prev : (value?.toString() ?? '');
        });
    }, [value]);
    const handleChange = (event) => {
        // Digits with at most one decimal point (empty allowed); anything else is dropped.
        const raw = event.target.value;
        if (!/^\d*\.?\d*$/.test(raw))
            return;
        setDraft(raw);
        const parsed = parseFloat(raw);
        onValueChange(Number.isNaN(parsed) ? undefined : parsed);
    };
    const stepBy = (delta) => {
        const current = parseFloat(draft);
        const next = Math.max((Number.isNaN(current) ? 0 : current) + delta, min);
        // toFixed rounds away float artifacts; Number() strips the trailing zeros it adds.
        const rounded = Number(next.toFixed(3));
        setDraft(String(rounded));
        onValueChange(rounded);
    };
    return (jsxs(HStack, { border: "1px solid", borderColor: "gray.200", rounded: "sm", css: {
            '&:has(input:focus)': {
                borderColor: 'blue.500',
                boxShadow: '0 0 0 1px {colors.blue.500}',
            },
            '&:has(input:focus) .show-on-focus, &:hover .show-on-focus': {
                display: 'flex',
            },
            '& .show-on-focus': {
                display: 'none',
            },
        }, children: [jsx(Input, { type: "text", inputMode: "decimal", pattern: "[0-9]*[.]?[0-9]*", size: "xs", value: draft, onChange: handleChange, placeholder: placeholder, borderWidth: 0, _focus: { '--focus-color': 'transparent' }, "data-testid": testId }), jsxs(VStack, { gap: 0, className: "show-on-focus", onMouseDown: (e) => e.preventDefault(), children: [jsx(IconButton, { variant: "ghost", "aria-label": "Increase value", size: "xs", height: "auto", color: "whiteAlpha.700", _hover: { bg: 'blackAlpha.700', color: 'white' }, onClick: () => stepBy(step), children: jsx(Icon, { as: BsCaretUpFill, boxSize: 3, scale: 1.3 }) }), jsx(IconButton, { variant: "ghost", "aria-label": "Decrease value", size: "xs", height: "auto", color: "whiteAlpha.700", _hover: { bg: 'blackAlpha.700', color: 'white' }, onClick: () => stepBy(-step), children: jsx(Icon, { as: BsCaretDownFill, boxSize: 3, scale: 1.3 }) })] }), unit ? (jsx(Text$2, { fontSize: "xs", color: "gray2.300", pr: 2, children: unit })) : null] }));
};

const Restricted = ({ children, permitted, alterVisual = false, hideOnDenied = false, }) => {
    const { t } = useTranslation();
    if (hideOnDenied && !permitted)
        return null;
    return (jsx(Tooltip, { label: !permitted ? t('ui.noPermission') : undefined, showArrow: true, children: jsx(Box, { asChild: true, opacity: !permitted && alterVisual ? 0.5 : undefined, pointerEvents: !permitted && alterVisual ? 'none' : undefined, cursor: !permitted && alterVisual ? 'not-allowed' : undefined, children: children }) }));
};

function c(e,u,c,i){var l=this,a=useRef(null),o=useRef(0),f=useRef(0),v=useRef(null),d=useRef([]),s=useRef(),m=useRef(),h=useRef(e),g=useRef(true),x=useRef(),E=useRef();h.current=e;var b="undefined"!=typeof window,p=!u&&0!==u&&b;if("function"!=typeof e)throw new TypeError("Expected a function");u=+u||0;var y=!!(c=c||{}).leading,w=!("trailing"in c)||!!c.trailing,T=!!c.flushOnExit&&w,O="maxWait"in c,F="debounceOnServer"in c&&!!c.debounceOnServer,L=O?Math.max(+c.maxWait||0,u):null,A=useMemo(function(){var r=function(r){var n=d.current,t=s.current;return d.current=s.current=null,o.current=r,f.current=f.current||r,m.current=h.current.apply(t,n)},n=function(r,n){p&&cancelAnimationFrame(v.current),v.current=p?requestAnimationFrame(r):setTimeout(r,n);},t=function(r){if(!g.current)return  false;var n=r-a.current;return !a.current||n>=u||n<0||O&&r-o.current>=L},e=function(n){return v.current=null,w&&d.current?r(n):(d.current=s.current=null,m.current)},c=function r(){var c=Date.now();if(y&&f.current===o.current&&A(),t(c))return e(c);if(g.current){var i=u-(c-a.current),l=O?Math.min(i,L-(c-o.current)):i;n(r,l);}},A=function(){},D=function(){if(b||F){var e,i=Date.now(),f=t(i);if(d.current=[].slice.call(arguments),s.current=l,a.current=i,T&&!x.current&&(x.current=function(){var r;"hidden"===(null==(r=globalThis.document)?void 0:r.visibilityState)&&E.current.flush();},null==(e=globalThis.document)||null==e.addEventListener||e.addEventListener("visibilitychange",x.current)),f){if(!v.current&&g.current)return o.current=a.current,n(c,u),y?r(a.current):m.current;if(O)return n(c,u),r(a.current)}return v.current||n(c,u),m.current}};return D.cancel=function(){var r=v.current;r&&(p?cancelAnimationFrame(v.current):clearTimeout(v.current)),o.current=0,d.current=a.current=s.current=v.current=null;},D.isPending=function(){return !!v.current},D.flush=function(){return v.current?e(Date.now()):m.current},D},[y,O,u,L,w,T,p,b,F,i]);return E.current=A,useEffect(function(){return g.current=true,function(){var r;T&&E.current.flush(),x.current&&(null==(r=globalThis.document)||null==r.removeEventListener||r.removeEventListener("visibilitychange",x.current),x.current=null),g.current=false;}},[T]),A}function a(r,n,t){var e=void 0===t?{}:t,u=e.leading,i=e.trailing,l=e.flushOnExit;return c(r,n,{maxWait:n,leading:void 0===u||u,trailing:void 0===i||i,flushOnExit:void 0!==l&&l})}

const AutoComplete = ({ defaultValue, items, autoFocus, validate, onChange, onCancel }) => {
    const { open, onOpen, onClose } = useDisclosure();
    // Refs
    const containerRef = useRef(null);
    const inputRef = useRef(null);
    // States
    const [value, setValue] = useState(defaultValue || '');
    const [error, setError] = useState(null);
    const handleItemClick = (e, item) => {
        if (!inputRef.current)
            return;
        e.stopPropagation();
        if (validate) {
            const result = validate(item.name);
            if (typeof result === 'string') {
                setError(result);
                return;
            }
        }
        setValue(item.name);
        inputRef.current.value = item.name;
        if (onChange)
            onChange(item);
        onClose();
    };
    // Replace useOutsideClick with custom implementation
    useEffect(() => {
        if (!open)
            return undefined;
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                if (validate) {
                    const result = validate(value);
                    if (typeof result === 'string') {
                        setError(result);
                        return;
                    }
                }
                if (onChange) {
                    onChange({
                        id: crypto.randomUUID(),
                        name: value,
                    });
                }
                onClose();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [open, value, validate, onChange, onClose]);
    useEffect(() => {
        if (inputRef.current && autoFocus) {
            inputRef.current.focus();
        }
    }, [inputRef, autoFocus]);
    return (jsxs(Box, { position: "relative", color: "gray2.300", ref: containerRef, children: [jsx(Tooltip, { label: jsx(Text$2, { color: "orange", children: error }), showArrow: true, open: !!error, positioning: {
                    placement: 'top',
                }, children: jsx(Input, { ref: inputRef, "data-autocomplete-input": true, defaultValue: defaultValue, size: "xs", placeholder: "\u30B0\u30EB\u30FC\u30D7\u540D", onFocus: (e) => {
                        e.stopPropagation();
                        onOpen();
                    }, onKeyDown: (e) => {
                        setError(null);
                        if (e.key === 'Enter') {
                            e.stopPropagation();
                            if (validate) {
                                const result = validate(e.currentTarget.value);
                                if (typeof result === 'string') {
                                    setError(result);
                                    return;
                                }
                            }
                            if (onChange) {
                                onChange({
                                    id: crypto.randomUUID(),
                                    name: e.currentTarget.value,
                                });
                            }
                            onClose();
                        }
                        else if (e.key === 'Escape') {
                            e.stopPropagation();
                            if (onCancel)
                                onCancel();
                            onClose();
                        }
                    }, onInput: (e) => {
                        onOpen();
                        setValue(e.currentTarget.value);
                    } }) }), jsx(Box, { visibility: open ? 'visible' : 'hidden', position: "absolute", top: "100%", left: 0, zIndex: 20, width: "100%", maxHeight: "210px", overflowY: "auto", backgroundColor: "gray2.700", children: items
                    .filter((item) => item.name.toLowerCase().includes(value.toLowerCase()))
                    .map((item) => (jsx(Box, { px: 4, py: 1, cursor: "pointer", _hover: { backgroundColor: 'gray2.600' }, onClick: (e) => handleItemClick(e, item), children: item.name }, item.id))) })] }));
};

/** Where a dropped layer lands relative to the layer it was dropped on. */
var PanelDropPosition;
(function (PanelDropPosition) {
    PanelDropPosition["Above"] = "ABOVE";
    PanelDropPosition["Below"] = "BELOW";
})(PanelDropPosition || (PanelDropPosition = {}));
/** The drag payload's MIME type — the dragged layer's id travels in it. */
const LAYER_DRAG_TYPE = 'application/x-panel-layer-id';
/**
 * A second payload type naming what kind of layer is moving. The id itself is unreadable during
 * `dragover` (browsers only expose the *types*), so the kind rides in the type name — which is how
 * a drop target can tell, while the drag is still in the air, whether it would accept this one.
 */
const layerKindType = (kind) => `application/x-panel-layer-kind-${kind.toLowerCase()}`;
const PanelLayer = ({ id, depth, color, label, labelProps, labelPostfix, layerProps, containerProps, tooltip, children = [], endElement, isCountable = false, isSelected = false, isDisabled = false, isWorking = false, isProcessing = false, isDeleting = false, isMarkedForDeletion = false, isSuccess = false, isError = false, isHidden = false, isFocusPinned = false, isVirtualContainer = false, onColorChanged, onHover, onSelect, onToggleVisibility, onDelete, onReset, onLabelChanged, validateLabel, startsEditingLabel = false, labelPlaceholder, labelSuggestions, onLabelEditCancelled, isDraggable = false, dragKind, acceptsDragKinds, isSubtreeDropTarget = false, onDropLayer, onOrderChange, onFocusItem,
// item: current,
// depth,
// isParentWorking = false,
// isShadowClone = false,
// forGroup = false,
// collapsible = true,
// editMode = false,
// onUpdated,
// onColorChanged,
// onCheckToggled,
// onSelect: onSelectLayer,
// onVisibilityToggled,
// validateName,
// forceLayerFullOpacity = false,
 }) => {
    // isDeleting || (isElementDeleting && deletingElementIds.includes(layerId)) || savingElementIds.includes(layerId)
    // Hook
    // const {
    //   collapsed,
    //   isInvisible,
    //   isSelected,
    //   isShapeSelectable,
    //   isSelectable,
    //   isChecked,
    //   isFocused,
    //   canBeChecked,
    //   handleToggleVisibility,
    //   handleDelete,
    //   handleHover,
    //   handleCheck,
    //   handleClick,
    //   handleFocusItem,
    //   setCollapsed,
    // } = useElementPanel(current, onUpdated, onSelectLayer, onCheckToggled, onVisibilityToggled, forGroup)
    // States
    const [isExpanded, setIsExpanded] = useState(true);
    const [isEditingLabel, setIsEditingLabel] = useState(startsEditingLabel);
    const [layerColor, setLayerColor] = useState(color);
    const [nameInputError, setNameInputError] = useState(null);
    // Which edge of this row a dragged layer would land on — drives the insertion line.
    const [dropPosition, setDropPosition] = useState(null);
    const isHoverable = (!!onHover || !!onSelect) && !isDisabled;
    const isSelectable = !!onSelect && !isDisabled;
    const isToggleable = !!onToggleVisibility;
    const isOrderable = !!onOrderChange && !isDisabled;
    const isDeletable = !!onDelete && !isDisabled;
    const isResettable = !!onReset && !isDisabled;
    const isRenamable = !!onLabelChanged && !isDisabled;
    const isFocusable = !!onFocusItem;
    const isCollapsible = children.length > 0;
    const isGrabbable = isDraggable && !isDisabled;
    const isDropTarget = !!onDropLayer && !isDisabled;
    const isShadowClone = false;
    const hasWorkingAnscOrDesc = false; // isParentWorking || checkIsWorking(current)
    // const hasSpacer = !dropdown && !editMode
    // const hasCollapseToggle = (collapsible && children && children.length > 0) || isCollapsible
    const hasBeenGrabbed = false; // useMemo(() => draggingItemKey === key, [draggingItemKey, key])
    // const hasOrderButton = isOrderable
    // Derived states. If it's a flag, prefix with `canBeXX`. Leave `isXX` for config value for easier figuring out where it comes from.
    // !!((item && onDelete !== false) || onDelete) && !isElementDeleting && !dropdown && !hasBeenGrabbed && !isShadowClone
    // Check if layer is currently being edited or saved (disable delete during these states)
    // Note: editedElementIds uses inspection_item_id, but getId() may return shape_id, so check both
    // const inspectionItemId = current.inspectionItem?.inspection_item_id
    const isDirty = false;
    // useMemo(() => {
    //   const idsToCheck = inspectionItemId ? [layerId, inspectionItemId] : [layerId]
    //   return (
    //     isBatchSaving ||
    //     editedGroupKeys.includes(key) ||
    //     idsToCheck.some((ids) => editedElementIds.includes(ids) || savingElementIds.includes(ids))
    //   )
    // }, [isBatchSaving, editedGroupKeys, editedElementIds, savingElementIds, key, layerId, inspectionItemId])
    // Derived states for styling
    const ids = useMemo(() => (isVirtualContainer ? children.map((child) => child.id) : [id]), [isVirtualContainer, id, children]);
    // Row colour driven by the layer's state props (the Editor styled these via its local
    // `.elist-layer-item.working/.success/.error` CSS, which never shipped with this shared
    // component — the state props are the source of truth here). Errors trump success trumps
    // in-progress (own or via a working ancestor/descendant, mirroring the `.working` class
    // condition); the label, action buttons and icons all follow it.
    const stateColor = useMemo(() => {
        if (isError)
            return 'red.300';
        if (isSuccess)
            return 'green.400';
        if (isWorking || isProcessing || hasWorkingAnscOrDesc)
            return 'yellow.400';
        return undefined;
    }, [isError, isSuccess, isWorking, isProcessing, hasWorkingAnscOrDesc]);
    /**
     * Handle color change event
     *
     * @param color
     */
    const handleChangeColor = a((clr) => {
        if (onColorChanged) {
            onColorChanged(clr);
        }
    }, 1000 / 30);
    /**
     * Start dragging this layer — the id travels on the drag itself, so a drop target needs no
     * shared "currently dragging" state to read it back.
     * @param e Drag event.
     */
    const handleDragStart = useCallback((e) => {
        e.stopPropagation();
        e.dataTransfer.setData(LAYER_DRAG_TYPE, id);
        if (dragKind)
            e.dataTransfer.setData(layerKindType(dragKind), '');
        e.dataTransfer.effectAllowed = 'move';
    }, [id, dragKind]);
    /**
     * Track which edge of this row the pointer is over so the insertion line shows there. Stopped
     * from bubbling so the innermost row under the pointer is the one that answers.
     * @param e Drag event.
     */
    const handleDragOver = useCallback((e) => {
        if (!isDropTarget || !e.dataTransfer.types.includes(LAYER_DRAG_TYPE))
            return;
        // Something this target doesn't take: leave it to whatever is underneath, and show nothing.
        const isAccepted = !acceptsDragKinds || acceptsDragKinds.some((kind) => e.dataTransfer.types.includes(layerKindType(kind)));
        if (!isAccepted)
            return;
        e.preventDefault();
        e.stopPropagation();
        e.dataTransfer.dropEffect = 'move';
        if (isSubtreeDropTarget) {
            setDropPosition(PanelDropPosition.Below);
            return;
        }
        const rect = e.currentTarget.getBoundingClientRect();
        setDropPosition(e.clientY < rect.top + rect.height / 2 ? PanelDropPosition.Above : PanelDropPosition.Below);
    }, [isDropTarget, acceptsDragKinds, isSubtreeDropTarget]);
    /**
     * Clear the insertion line once the pointer genuinely leaves the row (moving across the row's
     * own buttons fires a leave too).
     * @param e Drag event.
     */
    const handleDragLeave = useCallback((e) => {
        if (e.currentTarget.contains(e.relatedTarget))
            return;
        setDropPosition(null);
    }, []);
    /**
     * Hand the dropped layer to the consumer, which decides what landing here means.
     * @param e Drag event.
     */
    const handleDrop = useCallback((e) => {
        const draggedId = e.dataTransfer.getData(LAYER_DRAG_TYPE);
        const position = dropPosition;
        setDropPosition(null);
        if (!isDropTarget || !draggedId || draggedId === id || !position)
            return;
        e.preventDefault();
        e.stopPropagation();
        onDropLayer?.(draggedId, position);
    }, [isDropTarget, dropPosition, id, onDropLayer]);
    /**
     * Confirm a label edit, keeping the row in edit mode while the new label is invalid.
     * @param newLabel The label typed in.
     */
    const commitLabel = useCallback((newLabel) => {
        const validation = validateLabel?.(newLabel);
        if (typeof validation === 'string') {
            setNameInputError(validation);
            return;
        }
        setNameInputError(null);
        setIsEditingLabel(false);
        if (newLabel !== label)
            onLabelChanged?.([id], newLabel);
    }, [validateLabel, label, onLabelChanged, id]);
    /**
     * Generate the class name for the layer item based on its state.
     */
    const layerClass = useMemo(() => {
        const classes = ['elist-layer-item'];
        if (isWorking || hasWorkingAnscOrDesc) {
            classes.push('working');
        }
        if (isSuccess) {
            classes.push('success');
        }
        if (isError) {
            classes.push('error');
        }
        // if (isGrouped) {
        //   classes.push('grouped')
        // }
        // if (isInspectionGroup(item)) {
        //   classes.push('inspection-group')
        // }
        return classes.join(' ');
    }, [isWorking, isSuccess, isShadowClone, hasBeenGrabbed, hasWorkingAnscOrDesc, isError]);
    const containerClass = useMemo(() => {
        const classes = ['elist-layer-container'];
        // if (isInspectionGroup(item)) {
        //   classes.push('inspection-group')
        // }
        return classes.join(' ');
    }, []);
    const childrenCount = useMemo(
    // () => (children || []).filter((child) => (!child.isGrouped && !forGroup) || forGroup).length,
    () => children.length, [children]);
    /**
     * Update layerColor when color prop changes
     */
    useEffect(() => {
        setLayerColor(color);
    }, [color]);
    // if ((isGrouped && !forGroup && !isShadowClone) || (isVirtualContainer && !childrenCount)) {
    //   return null
    // }
    return (jsx(Tooltip, { label: tooltip, showArrow: true, disabled: !tooltip, positioning: {
            placement: 'left',
        }, children: jsxs(Box, { width: "100%", className: containerClass, ...containerProps, onDragOver: isDropTarget && isSubtreeDropTarget ? handleDragOver : undefined, onDragLeave: isDropTarget && isSubtreeDropTarget ? handleDragLeave : undefined, onDrop: isDropTarget && isSubtreeDropTarget ? handleDrop : undefined, children: [jsxs(HStack, { width: "100%", gap: 0, px: 2, color: stateColor, borderTop: "1px solid transparent", borderBottom: "1px solid transparent", cursor: isSelectable ? 'pointer' : 'default', backgroundColor: isSelected ? '#3F444E' : undefined, _hover: isHoverable
                        ? {
                            borderTop: '1px solid {colors.gray2.600}',
                            borderBottom: '1px solid {colors.gray2.600}',
                            backgroundColor: isSelected ? 'whiteAlpha.50' : 'gray2.900',
                        }
                        : undefined, onClick: isSelectable ? () => onSelect(ids) : undefined, onMouseEnter: isHoverable ? () => onHover?.(true) : undefined, onMouseLeave: isHoverable ? () => onHover?.(false) : undefined, position: "relative", className: layerClass, "data-id": id, "data-element-key": id, w: undefined, draggable: isGrabbable && !isProcessing, onDragStart: isGrabbable ? handleDragStart : undefined, onDragEnd: isGrabbable ? () => setDropPosition(null) : undefined, onDragOver: isDropTarget && !isSubtreeDropTarget ? handleDragOver : undefined, onDragLeave: isDropTarget && !isSubtreeDropTarget ? handleDragLeave : undefined, onDrop: isDropTarget && !isSubtreeDropTarget ? handleDrop : undefined, ...layerProps, children: [isSelected ? (jsx(Box, { width: "5px", backgroundColor: "#3F444E", height: "100%", position: "absolute", top: 0, left: 0 })) : null, dropPosition && !isSubtreeDropTarget ? (jsx(Box, { height: "2px", width: "100%", backgroundColor: "blue.400", position: "absolute", left: 0, top: dropPosition === PanelDropPosition.Above ? 0 : undefined, bottom: dropPosition === PanelDropPosition.Below ? 0 : undefined })) : null, jsx(Box, { width: `${depth * 12}px`, id: "depth-indent" }), isGrabbable || isOrderable ? (jsx(IconButton, { minW: {
                                base: 7,
                                lg: 6,
                            }, "aria-label": "reorder", variant: "panel-icon", className: "grabber", disabled: isProcessing, cursor: isProcessing ? 'not-allowed' : 'grab', children: jsx(OrderGrabIcon, {}) })) : null, isCollapsible ? (jsx(IconButton, { minW: {
                                base: 7,
                                lg: 6,
                            }, "aria-label": isExpanded ? 'collapse' : 'expand', onClick: (e) => {
                                e.stopPropagation();
                                setIsExpanded(!isExpanded);
                            }, variant: "panel-icon", disabled: !isCollapsible, children: isExpanded ? jsx(CollapseIcon, {}) : jsx(ExpandIcon, {}) })) : (jsx(Square, { size: 6, id: "collapse-indent" })), isToggleable ? (jsx(IconButton, { minW: {
                                base: 7,
                                lg: 6,
                            }, "aria-label": isHidden ? 'hidden' : 'shown', variant: "panel-icon", onClick: onToggleVisibility ? () => onToggleVisibility(ids) : undefined, children: isHidden ? jsx(Icon, { as: HideIcon, boxSize: 4 }) : jsx(Icon, { as: ShowIcon, boxSize: 4 }) })) : (jsx(Square, { size: 6 })), isFocusable ? (jsx(IconButton, { minW: {
                                lgDown: 7,
                                xl: 6,
                            }, "aria-label": "focus to item", variant: "panel-icon", onClick: onFocusItem ? () => onFocusItem([id]) : undefined, children: jsx(Icon, { as: FocusItemIcon, color: isFocusPinned ? '{colors.orange.400}' : '', boxSize: 4.5 }) })) : null, color ? (jsxs(Popover.Root, { onOpenChange: (e) => {
                                if (!e.open) {
                                    onColorChanged?.(layerColor || color);
                                    // onUpdated?.({ ...current, color: layerColor, isEditing: false })
                                }
                            }, children: [jsx(Popover.Trigger, { asChild: true, children: jsx(Button, { variant: "outline", maxWidth: 4, minWidth: 4, width: 4, height: 4, p: 0, ml: 1, backgroundColor: layerColor, borderColor: "whiteAlpha.200", borderRadius: 4, _hover: { bg: layerColor }, _focus: { bg: layerColor }, _active: { bg: layerColor }, _disabled: { bg: layerColor }, onClick: (e) => {
                                            e.stopPropagation();
                                        }, disabled: isDisabled || isProcessing }) }), jsx(Portal, { children: jsx(Popover.Positioner, { children: jsx(Popover.Content, { w: "auto", onClick: (e) => e.stopPropagation(), children: jsx(Chrome, { inputType: ChromeInputType.HEXA, showAlpha: false, showEyeDropper: false, color: layerColor, onChange: (clr) => {
                                                    setLayerColor(clr.hex);
                                                    handleChangeColor(clr.hex);
                                                } }) }) }) })] })) : null, jsxs(HStack, { gap: 0.5, flex: 1, children: [isEditingLabel ? (jsx(Box, { pl: 1, onClick: (e) => e.stopPropagation(), children: labelSuggestions ? (
                                    // A row being named offers the names to choose from — typing is optional.
                                    // Confirming (Enter or clicking away) saves; Escape abandons the row.
                                    jsx(AutoComplete, { defaultValue: label, items: labelSuggestions.map((name) => ({ id: name, name })), validate: validateLabel, onChange: (item) => commitLabel(item.name), onCancel: () => {
                                            setIsEditingLabel(false);
                                            onLabelEditCancelled?.();
                                        }, autoFocus: true })) : (jsx(Tooltip, { label: jsx(Text$2, { color: "orange", children: nameInputError }), showArrow: true, open: !!nameInputError, positioning: {
                                            placement: 'top',
                                        }, children: jsx(Input, { defaultValue: label, size: "xs", placeholder: labelPlaceholder, onBlur: (e) => commitLabel(e.currentTarget.value), onKeyDown: (e) => {
                                                e.stopPropagation();
                                                setNameInputError(null);
                                                if (e.key === 'Enter') {
                                                    commitLabel(e.currentTarget.value);
                                                }
                                                else if (e.key === 'Escape') {
                                                    setIsEditingLabel(false);
                                                    onLabelEditCancelled?.();
                                                }
                                            }, autoFocus: true }) })) })) : null, !isEditingLabel ? (jsxs(HStack, { gap: 0, children: [jsxs(Text$2, { mx: 1, textDecoration: isMarkedForDeletion ? 'line-through' : undefined, opacity: isDisabled ? 0.5 : undefined, cursor: isRenamable ? 'text' : undefined, onDoubleClick: isRenamable
                                                ? (e) => {
                                                    e.stopPropagation();
                                                    setIsEditingLabel(true);
                                                }
                                                : undefined, ...labelProps, 
                                            // The state colour wins over a consumer-set label colour while a state is active.
                                            color: stateColor ?? labelProps?.color, children: [label, " ", labelPostfix, " ", isCountable && childrenCount ? `(${childrenCount})` : ''] }), isSuccess ? (jsx(Flex, { w: "28px", justifyContent: "center", children: jsx(SuccessIcon, {}) })) : null] })) : null, isWorking && !isProcessing && !isEditingLabel ? jsx(UnsavedIcon, { size: "1.2em" }) : '', isError ? jsx(WarningIcon, { color: "red.400" }) : ''] }), null, isProcessing ? (jsx(Flex, { w: "28px", justifyContent: "center", children: jsx(Spinner, { size: "xs" }) })) : null, 
                        // ## Reset button
                        isResettable ? (jsx(IconButton, { "aria-label": "reset", variant: "panel-icon", color: stateColor, onClick: (e) => {
                                e.stopPropagation();
                                return onReset?.(ids);
                            }, children: jsx(ResetIcon, {}) })) : null, 
                        // ## Delete button
                        isDeletable ? (jsx(IconButton, { "aria-label": "delete", variant: "panel-icon", color: stateColor, disabled: isProcessing || isDirty, 
                            // A press here must not read as "clicked away" to an editor open on the same row —
                            // that would commit the very label the press is about to discard.
                            onMouseDown: (e) => e.stopPropagation(), onClick: (e) => {
                                e.stopPropagation();
                                return onDelete?.(ids);
                            }, children: jsx(TrashIcon, {}) })) : null, endElement] }), dropPosition && isSubtreeDropTarget ? jsx(Box, { height: "2px", width: "100%", backgroundColor: "blue.400" }) : null, isExpanded && children?.map((child) => jsx(PanelLayer, { ...child }, child.id))] }) }));
};

const initialDrawingConfig = {};
const initialContextDrawingState = {
    phase: 'idle',
    tool: null,
    placedCount: 0,
};
const initialCompletion = {
    completable: false,
};

const threeCanvasContextInitialState = {
    sceneRef: { current: null },
    cameraRef: { current: null },
    arcballControlsRef: { current: null },
    setSceneDetails: () => { },
    activeTool: null,
    setActiveTool: () => { },
    drawingState: initialContextDrawingState,
    setDrawingState: () => { },
    completion: initialCompletion,
    setCompletion: () => { },
    previewStyle: null,
    setPreviewStyle: () => { },
    drawingConfig: initialDrawingConfig,
    setDrawingConfig: () => { },
    editingAnchor: null,
    setEditingAnchor: () => { },
    currentAnchorPosition: null,
    setCurrentAnchorPosition: () => { },
    cursor: CursorState.NONE,
    setCursor: () => { },
    defaultCursor: CursorState.NONE,
    setDefaultCursor: () => { },
    closingTooltip: undefined,
    setClosingTooltip: () => { },
    previewPrimaryLabelVisible: true,
    setPreviewPrimaryLabelVisible: () => { },
    previewEdgeLabelVisible: true,
    setPreviewEdgeLabelVisible: () => { },
    editingPlane: null,
    setEditingPlane: () => { },
};
const ThreeCanvasContext = createContext(threeCanvasContextInitialState);
const useThreeCanvasContext = () => useContext(ThreeCanvasContext);
const ThreeCanvasProvider = ({ children }) => {
    // Refs
    const sceneRef = useRef(null);
    const cameraRef = useRef(null);
    const arcballControlsRef = useRef(null);
    // States
    const [sceneDetails, setSceneDetails] = useState(undefined);
    const [activeTool, setActiveTool] = useState(null);
    const [drawingState, setDrawingState] = useState(initialContextDrawingState);
    const [completion, setCompletion] = useState(initialCompletion);
    const [previewStyle, setPreviewStyle] = useState(null);
    const [drawingConfig, setDrawingConfig] = useState(initialDrawingConfig);
    const [editingAnchor, setEditingAnchor] = useState(null);
    const [currentAnchorPosition, setCurrentAnchorPosition] = useState(null);
    const [cursor, setCursor] = useState(CursorState.NONE);
    const [defaultCursor, setDefaultCursor] = useState(CursorState.NONE);
    const [closingTooltip, setClosingTooltip] = useState(undefined);
    const [previewPrimaryLabelVisible, setPreviewPrimaryLabelVisible] = useState(true);
    const [previewEdgeLabelVisible, setPreviewEdgeLabelVisible] = useState(true);
    const [editingPlane, setEditingPlane] = useState(null);
    // Derived State
    const threeCanvasContextValue = useMemo(() => ({
        sceneRef,
        cameraRef,
        arcballControlsRef,
        sceneDetails,
        setSceneDetails,
        activeTool,
        setActiveTool,
        drawingState,
        setDrawingState,
        completion,
        setCompletion,
        previewStyle,
        setPreviewStyle,
        drawingConfig,
        setDrawingConfig,
        editingAnchor,
        setEditingAnchor,
        currentAnchorPosition,
        setCurrentAnchorPosition,
        cursor,
        setCursor,
        defaultCursor,
        setDefaultCursor,
        closingTooltip,
        setClosingTooltip,
        previewPrimaryLabelVisible,
        setPreviewPrimaryLabelVisible,
        previewEdgeLabelVisible,
        setPreviewEdgeLabelVisible,
        editingPlane,
        setEditingPlane,
    }), [
        sceneDetails,
        activeTool,
        drawingState,
        completion,
        previewStyle,
        drawingConfig,
        editingAnchor,
        currentAnchorPosition,
        cursor,
        closingTooltip,
        previewPrimaryLabelVisible,
        previewEdgeLabelVisible,
        editingPlane,
        defaultCursor,
    ]);
    return jsx(ThreeCanvasContext.Provider, { value: threeCanvasContextValue, children: children });
};

/**
 * Calculate the midpoint of a polyline defined by an array of points.
 *
 * @param allPoints - An array of points representing the polyline.
 * @returns An object containing the total distance of the polyline and the coordinates of the midpoint.
 */
const calculatePolylineMidpoint = (allPoints) => {
    const allPointsV3 = allPoints.map((p) => (p instanceof Vector3 ? p.clone() : new Vector3().fromArray(p)));
    // Go through each section of the polyline and calculate the distance between them, then the total distance.
    const totalDistance = allPointsV3.reduce((collection, point, index) => {
        const pointsPair = [point, allPointsV3[index + 1]];
        if (!pointsPair[1])
            return collection;
        return collection + pointsPair[0].distanceTo(pointsPair[1]);
    }, 0);
    // Handle case where all points are duplicates (zero total distance)
    if (totalDistance === 0) {
        return {
            totalDistance: 0,
            point: allPointsV3[0].toArray(),
        };
    }
    // Figure out the mid-point of the polyline.
    const midPointDistance = totalDistance / 2;
    return {
        totalDistance,
        point: allPointsV3.reduce((collection, point, index) => {
            if (collection.totalDistance >= midPointDistance)
                return collection;
            const pointsPair = [point, allPointsV3[index + 1]];
            if (!pointsPair[1])
                return collection;
            // Skip duplicate points (zero distance)
            const distance = pointsPair[0].distanceTo(pointsPair[1]);
            if (distance === 0)
                return collection;
            if (collection.totalDistance + distance < midPointDistance) {
                collection.totalDistance += distance;
                return collection;
            }
            const remainingDistance = midPointDistance - collection.totalDistance;
            const result = pointsPair[0].lerp(pointsPair[1], remainingDistance / distance).toArray();
            return { point: result, totalDistance: midPointDistance };
        }, {
            point: [0, 0, 0],
            totalDistance: 0,
        }).point,
    };
};
/**
 * Get offset matrix from transformation.
 *
 * @param transformation Transformation matrix or Matrix4
 */
const toMatrix4 = (transformation) => {
    const offsetMatrix = new Matrix4().identity();
    if (transformation) {
        if (transformation instanceof Matrix4) {
            offsetMatrix.copy(transformation);
        }
        else {
            offsetMatrix.fromArray(transformation);
        }
    }
    return offsetMatrix;
};
/**
 * Find the center of a set of points.
 * @param points Set of Vector3 points
 * @returns
 */
const findCenter = (points) => {
    if (points.length === 0) {
        return null;
    }
    const sumX = points.reduce((acc, point) => acc + point.x, 0);
    const sumY = points.reduce((acc, point) => acc + point.y, 0);
    const sumZ = points.reduce((acc, point) => acc + point.z, 0);
    const centerX = sumX / points.length;
    const centerY = sumY / points.length;
    const centerZ = sumZ / points.length;
    return new Vector3(centerX, centerY, centerZ);
};
/**
 * Calculate the edge index in a polyline given a point on the line.
 *
 * @param allPoints - An array of points representing the polyline.
 * @param point - The position on the polyline to calculate the index for.
 */
const calculateIndexInPolyline = (allPoints, point) => {
    const allPointsV3 = allPoints.map((p) => (p instanceof Vector3 ? p.clone() : new Vector3().fromArray(p)));
    const pointV3 = point instanceof Vector3 ? point.clone() : new Vector3().fromArray(point);
    let closestIndex = -1;
    let closestDistance = Infinity;
    // Go through each segment of the polyline to find the closest point on the polyline to the given point
    allPointsV3.forEach((startPoint, index) => {
        const endPoint = allPointsV3[index + 1];
        if (!endPoint)
            return;
        // Project the point onto the line segment
        const lineVec = endPoint.clone().sub(startPoint);
        const pointVec = pointV3.clone().sub(startPoint);
        const lineLenSq = lineVec.lengthSq();
        const t = Math.max(0, Math.min(1, pointVec.dot(lineVec) / lineLenSq));
        const projection = startPoint.clone().add(lineVec.multiplyScalar(t));
        const distance = projection.distanceTo(pointV3);
        if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index + 1; // after the startPoint
        }
    });
    return closestIndex;
};
/**
 * Split a polyline's points into two parts at the given index (typically from
 * `calculateIndexInPolyline`). The point at `index` starts the second part, so a split of
 * `[a, b, c, d]` at `2` yields `[[a, b], [c, d]]`. Returns `null` when the index is at (or past)
 * either end, where there is nothing to cut. Generic over the point representation.
 */
const splitPolylineAtIndex = (allPoints, index) => {
    if (index <= 0 || index >= allPoints.length)
        return null;
    return [allPoints.slice(0, index), allPoints.slice(index)];
};
/**
 * Computes the radius of the bounding sphere that encloses a given bounding box.
 * @param bbox - The bounding box (Box3) to compute the sphere radius from.
 * @returns The radius of the bounding sphere.
 */
function computeBoundingSphereRadius(bbox) {
    // Compute the diagonal length of the bounding box
    const diagonal = bbox.max.clone().sub(bbox.min).length();
    // The radius is half of the diagonal length
    return diagonal * 0.5;
}
/**
 * Computes the center and radius of a point cloud.
 *
 * @param pointCloud The point cloud to compute the center and radius for.
 * @returns An object containing the center (Vector3) and radius (number) of the point cloud.
 */
const getCenterAndRadius = (pointClouds) => {
    const pcds = Array.isArray(pointClouds) ? pointClouds : [pointClouds];
    const bbox = pcds.reduce((acc, pcd) => {
        if (pcd instanceof Points) {
            pcd.geometry.computeBoundingBox();
            if (pcd.geometry.boundingBox)
                acc.union(pcd.geometry.boundingBox);
        }
        else if (pcd instanceof PointCloudOctree) {
            acc.union(pcd.getBoundingBoxWorld());
        }
        return acc;
    }, new Box3());
    const center = bbox.getCenter(new Vector3());
    const radius = computeBoundingSphereRadius(bbox);
    return { bbox, center, radius };
};
/**
 * Aligns a a set of coordinates to the z-axis.
 * The coordinates must be coplanar.
 *
 * @param points The points.
 * @param offsetBeforeRotate Whether to offset the points by the first point before rotation.
 *
 * @returns The aligned points. If the points have less than 3 points, the original points are returned.
 */
const alignToZAxis = (points, offsetBeforeRotate) => {
    if (points.length < 3)
        return { points, matrix: new Matrix4().identity(), inverseMatrix: new Matrix4().identity(), offset: new Vector3() };
    // Calculate two vectors from three points
    const vector1 = new Vector3().subVectors(points[1], points[0]);
    const vector2 = new Vector3().subVectors(points[2], points[0]);
    // Calculate the normal of the plane
    const normal = new Vector3().crossVectors(vector1, vector2).normalize();
    // Define the z-axis as the target normal
    const zAxis = new Vector3(0, 0, 1);
    // Create a quaternion that rotates the normal to align with the z-axis
    const quaternion = new Quaternion().setFromUnitVectors(normal, zAxis);
    // Rotate each point to align with the z-axis
    const offset = offsetBeforeRotate ? points[0].clone() : new Vector3(0, 0, 0);
    const alignedPoints = points.map((point) => point.clone().sub(offset).applyQuaternion(quaternion));
    return {
        points: alignedPoints,
        matrix: new Matrix4().makeRotationFromQuaternion(quaternion),
        inverseMatrix: new Matrix4().makeRotationFromQuaternion(quaternion.invert()),
        offset,
    };
};
/**
 * Direction of the turn formed by three points (XY only): positive for a counter-clockwise turn,
 * negative for clockwise, zero for collinear.
 */
const direction = (pi, pj, pk) => (pj.x - pi.x) * (pk.y - pi.y) - (pk.x - pi.x) * (pj.y - pi.y);
/** Whether two line segments (p1→p2 and p3→p4) properly intersect, in the XY plane. */
const linesIntersect = (p1, p2, p3, p4) => {
    const d1 = direction(p3, p4, p1);
    const d2 = direction(p3, p4, p2);
    const d3 = direction(p1, p2, p3);
    const d4 = direction(p1, p2, p4);
    return ((d1 > 0 && d2 < 0) || (d1 < 0 && d2 > 0)) && ((d3 > 0 && d4 < 0) || (d3 < 0 && d4 > 0));
};
/**
 * Whether a closed polygon self-intersects (any two non-adjacent edges cross), in the XY plane.
 * Ported from the Editor's `services/Polygon.ts`. Considers only x/y — for a 3D polygon on an
 * arbitrary plane, align it to the XY plane with `alignToZAxis()` first.
 *
 * @param points Vertices of the polygon (open loop — the closing edge back to the first is implied)
 * @returns True if any two non-adjacent edges intersect
 */
const checkForLineIntersections = (points) => {
    const numPoints = points.length;
    for (let i = 0; i < numPoints; i += 1) {
        const a1 = points[i];
        const a2 = points[(i + 1) % numPoints];
        for (let j = i + 1; j < numPoints; j += 1) {
            // Check non-adjacent segments only (skip shared endpoints and the wrap-around neighbour).
            if (!(j === i || j === (i + 1) % numPoints || (i === 0 && j === numPoints - 1))) {
                const b1 = points[j];
                const b2 = points[(j + 1) % numPoints];
                if (linesIntersect(a1, a2, b1, b2)) {
                    return true;
                }
            }
        }
    }
    return false;
};
/**
 * Checks if a polygon is convex in the XY plane.
 * Note: This function only considers the x and y coordinates of the points.
 * For 3D polygons on arbitrary planes, first align them to the XY plane using alignToZAxis().
 * @param points Array of Vector3 points representing the vertices of the polygon
 * @returns True if the polygon is convex in the XY plane, false otherwise
 */
const isConvexPolygon = (points) => {
    const numPoints = points.length;
    if (numPoints < 4)
        return true; // Triangles are always convex
    let sign = 0;
    for (let i = 0; i < numPoints; i += 1) {
        const dx1 = points[(i + 2) % numPoints].x - points[(i + 1) % numPoints].x;
        const dy1 = points[(i + 2) % numPoints].y - points[(i + 1) % numPoints].y;
        const dx2 = points[i].x - points[(i + 1) % numPoints].x;
        const dy2 = points[i].y - points[(i + 1) % numPoints].y;
        const zCrossProduct = dx1 * dy2 - dy1 * dx2;
        if (zCrossProduct !== 0) {
            if (sign === 0) {
                sign = zCrossProduct > 0 ? 1 : -1;
            }
            else if ((zCrossProduct > 0 && sign < 0) || (zCrossProduct < 0 && sign > 0)) {
                return false;
            }
        }
    }
    return true;
};
// ---- Cuboid placement geometry (ported from the Editor's `services/Points.ts`) ----
// https://docs.google.com/presentation/d/1-_qYSQdIpZ6SeF9G_5n0scfgPz6bTrJhJIVS4wJttcY/edit#slide=id.g1a91a669376_0_0
// Fix the third point (C -> D) to make it place on the normal vector of the line between point 1 (A) and point 2 (B)
const fixVertexOnNormal = (points) => {
    if (points.length !== 3) {
        return points;
    }
    const directionAB = points[1].clone().sub(points[0]).normalize();
    const directionNormal = points[2].clone().sub(points[1]).cross(directionAB).normalize();
    const directionAD = directionAB.cross(directionNormal).normalize();
    const distance = new Line3(points[0], points[1])
        .closestPointToPoint(points[2], false, new Vector3())
        .distanceTo(points[2]);
    const newPoint = points[1].clone().add(directionAD.multiplyScalar(distance));
    return [points[0], points[1], newPoint];
};
// Find the last point of a Parallelogram from previous 3 points
const findMissingVertexParallelogram = (points) => {
    if (points.length !== 3) {
        return new Vector3();
    }
    // Find the center point between point1 and point3
    const centerPoint = new Line3(points[0].clone(), points[2].clone()).getCenter(new Vector3());
    // Missing point is the point go from point2 across the center point,
    // with 2 times distance from point2 to the center point
    const missingCrossVector = centerPoint.sub(points[1]);
    const missingCrossLength = missingCrossVector.length();
    const missingCenterVector = missingCrossVector.normalize().multiplyScalar(missingCrossLength * 2);
    const missingCenterPoint = points[1].clone().add(missingCenterVector);
    return missingCenterPoint;
};
const movePointUp = (target, planeNormal, distance) => new Vector3().addVectors(target.clone(), planeNormal.clone().multiplyScalar(distance));
/**
 * Derive an oriented box from 4 anchor points: the first 3 span the base plane (assumed already
 * orthogonalized via `fixVertexOnNormal`), the 4th sets the (signed) height above/below it. Each
 * extent is floored at `minSize`. Ported from the Editor's `getCuboidFromPoints`, minus the unused
 * virtual-axis points.
 */
const getCuboidFromPoints = (points, minSize) => {
    const bottomPlane = new Plane().setFromCoplanarPoints(points[0], points[1], points[2]);
    const bottomPlaneNormal = bottomPlane.normal.normalize();
    // Collinear/duplicate base anchors give a zero normal (three.js normalize is zero-safe), which
    // would degenerate the basis below into a NaN rotation (`extractRotation` divides by column
    // length). Fall back to a world axis not parallel to the anchor line — and rebuild the plane
    // from it so the height stays consistent — instead of persisting NaN geometry.
    if (bottomPlaneNormal.lengthSq() < 1e-12) {
        const anchorDirection = points[1].clone().sub(points[0]).normalize();
        bottomPlaneNormal.set(0, 1, 0);
        if (Math.abs(anchorDirection.dot(bottomPlaneNormal)) > 0.9)
            bottomPlaneNormal.set(1, 0, 0);
        bottomPlane.setFromNormalAndCoplanarPoint(bottomPlaneNormal, points[0]);
    }
    const width = Math.max(minSize, Math.abs(points[0].distanceTo(points[1])));
    const depth = Math.max(minSize, Math.abs(points[1].distanceTo(points[2])));
    const height = bottomPlane.distanceToPoint(points[3]);
    const absHeight = Math.max(minSize, Math.abs(height));
    const center = new Line3(points[0], points[2]).getCenter(new Vector3());
    const position = movePointUp(center, bottomPlaneNormal, height / 2);
    // Create orthogonal basis vectors for rotation matrix
    const xAxis = points[0].clone().sub(points[1]).normalize();
    const yAxis = bottomPlaneNormal.clone(); // Already normalized
    const zAxis = new Vector3().crossVectors(xAxis, yAxis).normalize();
    // Ensure right-handed coordinate system by recomputing xAxis using a temporary variable
    const newXAxis = new Vector3().crossVectors(yAxis, zAxis).normalize();
    const rotationMatrix = new Matrix4().makeBasis(newXAxis, yAxis, zAxis);
    const quaternion = new Quaternion().setFromRotationMatrix(rotationMatrix);
    // use for drawing bounding box
    const edgesGeometry = new EdgesGeometry(new BoxGeometry(width, absHeight, depth));
    return {
        width,
        depth,
        height: absHeight,
        position,
        quaternion,
        edgesGeometry,
        rotationMatrix,
    };
};
/** Plain `Cuboid` (center / rotation / extent) derived from 4 placed cuboid anchors. */
const generateCuboidFromAnchors = (points, minSize) => {
    const { width, depth, height, position, rotationMatrix } = getCuboidFromPoints(points, minSize);
    return {
        center: position.toArray(),
        rotation: new Matrix3().setFromMatrix4(new Matrix4().extractRotation(rotationMatrix)).toArray(),
        extent: [width, height, depth],
    };
};
/**
 * The 4 anchor points of the fixed-size quick box around a triple-clicked point (half-size
 * `CUBOID_QUICK_SIZE`) — an axis-aligned box, verbatim from the Editor's quick-box corners.
 * @param point The triple-clicked scene point (the box center).
 * @param size Half-size of the box on every axis (world units).
 */
const getQuickCuboidAnchors = (point, size) => [
    new Vector3(point.x - size, point.y - size, point.z - size),
    new Vector3(point.x + size, point.y - size, point.z - size),
    new Vector3(point.x + size, point.y - size, point.z + size),
    new Vector3(point.x + size, point.y + size, point.z + size),
];

/**
 * Calculates the required camera distance so that all given points
 * fit within the camera's view, with some padding.
 *
 * Assumptions:
 * - Points lie on a plane perpendicular to camera direction
 * - Camera looks straight at the plane center
 * - FOV is vertical FOV in degrees
 *
 * @param points Array of 3D coordinates
 * @param fovDeg Vertical field of view in degrees
 * @param aspect Aspect ratio (width / height)
 * @returns Required camera distance. Returns 1 if points array is empty or target cannot be determined.
 */
function fitCameraDistance(points, normal, cameraUp, fovDeg, aspect, padding = 1.0) {
    if (points.length === 0)
        return 1;
    const pointsv3 = points.map((p) => (p instanceof Vector3 ? p : new Vector3(...p)));
    const target = findCenter(pointsv3);
    if (!target)
        return 1;
    // Calculate required camera distance to fit the whole plane in view, with some padding
    // Transform 3D points to camera-aligned coordinate system for accurate distance calculation
    const forward = normal.clone().normalize();
    const right = new Vector3().crossVectors(cameraUp, forward).normalize();
    const up = new Vector3().crossVectors(forward, right).normalize();
    // Project points to 2D in camera's viewing plane
    const points2D = pointsv3.map((pos) => {
        const p = pos.clone().sub(target);
        return new Vector3(p.dot(right), p.dot(up), 0);
    });
    let minX = Infinity;
    let maxX = -Infinity;
    let minY = Infinity;
    let maxY = -Infinity;
    points2D.forEach((p) => {
        minX = Math.min(minX, p.x);
        maxX = Math.max(maxX, p.x);
        minY = Math.min(minY, p.y);
        maxY = Math.max(maxY, p.y);
    });
    const width = maxX - minX;
    const height = maxY - minY;
    const fovRad = (fovDeg * Math.PI) / 180;
    const tanHalfFov = Math.tan(fovRad / 2);
    const distanceHeight = height / (2 * tanHalfFov);
    const distanceWidth = width / (2 * tanHalfFov * aspect);
    return Math.max(distanceHeight, distanceWidth) * padding;
}

/* eslint-disable no-underscore-dangle */
/**
 * Similarity threshold for determining if the calculated plane of provided points
 * is nearly parallel to camera view direction.
 *
 * angleInRadians = Math.acos(threshold)
 */
const SIMILARITY_THRESHOLD = 0.9; // ~25 degrees tolerance
class ArcballControls extends ArcballControls$1 {
    constructor() {
        super(...arguments);
        /** Indicates whether the ArcballControls is currently animating the camera. */
        this.isAnimating = false;
    }
    get gizmoMatrixState() {
        return this._gizmoMatrixState;
    }
    get cameraMatrixState() {
        return this._cameraMatrixState;
    }
    get gizmos() {
        return this._gizmos;
    }
    set currentTarget(target) {
        this._currentTarget.copy(target);
    }
    /**
     * Export all the information required to restore the ArcballControls state later.
     * This includes the camera's position, quaternion, and up vector,
     */
    exportState() {
        if (!(this.object instanceof PerspectiveCamera))
            return null;
        const camera = this.object;
        return {
            cameraPosition: camera.position.clone(),
            cameraQuaternion: camera.quaternion.clone(),
            cameraUp: camera.up.clone(),
            target: this.target.clone(),
        };
    }
    /**
     * Import the ArcballControls state from a previously exported state object.
     * This will restore the camera's position, quaternion, up vector, and the ArcballControls target.
     * @param state The state object containing the camera's position, quaternion, up vector, and target.
     * @returns
     */
    importState(state) {
        if (!(this.object instanceof PerspectiveCamera))
            return;
        const camera = this.object;
        camera.position.copy(state.cameraPosition);
        camera.quaternion.copy(state.cameraQuaternion);
        camera.up.copy(state.cameraUp);
        this.updateTarget(state.target);
    }
    /**
     * Update the ArcballControls target and related gizmo positions and states
     * without performing a camera transformation. This is useful for cases where we want to
     * instantly update the target (e.g., after camera animation) without causing an additional camera movement.
     *
     * @param target The new target position for the ArcballControls.
     */
    updateTarget(target) {
        this.target.copy(target);
        this.currentTarget = target;
        this._gizmos.position.copy(target);
        this._tbRadius = this.calculateTbRadius(this.object);
        this.makeGizmos(target, this._tbRadius);
        this.updateMatrixState();
    }
    /**
     * Animates a Three.js camera from its current transform to a target transform
     * using cubic ease-in-out interpolation.
     *
     * Position uses linear interpolation (LERP).
     * Rotation uses quaternion spherical interpolation (SLERP).
     *
     * @param targetPosition Target camera position
     * @param targetQuaternion Target camera quaternion
     * @param duration Duration in milliseconds
     */
    async animateCamera(targetPosition, targetQuaternion, duration) {
        if (!(this.object instanceof PerspectiveCamera))
            return Promise.reject(new Error('animateCamera only supports PerspectiveCamera'));
        const camera = this.object;
        const startPosition = camera.position.clone();
        const startQuaternion = camera.quaternion.clone();
        // If duration is zero or negative, immediately apply the target transform
        if (duration <= 0) {
            camera.position.copy(targetPosition);
            camera.quaternion.copy(targetQuaternion);
            camera.updateMatrixWorld();
            return Promise.resolve();
        }
        function easeInOutCubic(t) {
            return t < 0.5 ? 4 * t * t * t : 1 - (-2 * t + 2) ** 3 / 2;
        }
        function lerp(a, b, t) {
            return a + (b - a) * t;
        }
        const isPanEnabled = this.enablePan;
        const isRotateEnabled = this.enableRotate;
        const isZoomEnabled = this.enableZoom;
        this.enablePan = false;
        this.enableRotate = false;
        this.enableZoom = false;
        this.isAnimating = true;
        await new Promise((resolve) => {
            const startTime = performance.now();
            function frame(now) {
                const elapsed = now - startTime;
                const t_2 = Math.min(Math.max(elapsed / duration, 0), 1);
                const eased = easeInOutCubic(t_2);
                camera.position.set(lerp(startPosition.x, targetPosition.x, eased), lerp(startPosition.y, targetPosition.y, eased), lerp(startPosition.z, targetPosition.z, eased));
                camera.quaternion.copy(startQuaternion).slerp(targetQuaternion, eased);
                if (t_2 < 1) {
                    requestAnimationFrame(frame);
                }
                else {
                    resolve();
                }
            }
            requestAnimationFrame(frame);
        });
        this.enablePan = isPanEnabled;
        this.enableRotate = isRotateEnabled;
        this.enableZoom = isZoomEnabled;
        this.isAnimating = false;
    }
    /**
     * Animate the ArcballControls to a new position.
     *
     * @param target The new target position for the ArcballControls.
     * @param newCameraPosition The new camera position to animate to.
     * @param newCameraQuaternion The new camera orientation (quaternion) to animate to.
     * @param duration The duration of the animation in milliseconds.
     * @returns A promise that resolves when the animation is complete.
     */
    async animateToTarget(target, newCameraPosition, newCameraQuaternion, duration = 800) {
        // Prevent overlapping animations
        if (this.isAnimating)
            return;
        // Animate camera to the new position and orientation
        await this.animateCamera(newCameraPosition, newCameraQuaternion, duration);
        // Update ArcballControls target to the new target
        this.updateTarget(target);
    }
    /**
     * Animate the ArcballControls to a new camera profile.
     *
     * @param profile The camera profile to animate to.
     * @param orientation The camera view orientation to use from the profile.
     * @param duration The duration of the animation in milliseconds. If not provided, a default duration will be used.
     *                 If set to 0, the camera will jump to the new profile without animation.
     * @returns A promise that resolves when the animation is complete.
     */
    async animateToProfile(
    // Accepts a front-only profile too (per-item profiles store `positions.front` only). Only the
    // requested orientation's position is read, so a `FrontCameraProfile` is safe with the default
    // FRONT orientation; the TOP/BOTTOM branches below are guarded on the positions they need.
    profile, orientation = CameraViewOrientation.FRONT, duration = 800) {
        const positions = profile.positions;
        const orientationPosition = positions[orientation];
        if (!orientationPosition)
            return;
        const target = new Vector3(...profile.target);
        const newCameraPosition = new Vector3(...orientationPosition);
        const newCameraQuaternion = new Quaternion();
        const cameraUp = new Vector3(profile.state.arcballState.cameraUp.x, profile.state.arcballState.cameraUp.y, profile.state.arcballState.cameraUp.z);
        if (orientation === CameraViewOrientation.TOP && positions.back) {
            cameraUp.fromArray(positions.back).sub(target).normalize();
        }
        else if (orientation === CameraViewOrientation.BOTTOM && positions.front) {
            cameraUp.fromArray(positions.front).sub(target).normalize();
        }
        newCameraQuaternion.setFromRotationMatrix(new Matrix4().lookAt(newCameraPosition, target, cameraUp));
        if (duration) {
            await this.animateToTarget(target, newCameraPosition, newCameraQuaternion, duration);
        }
        else {
            this.focusToTarget(target, newCameraPosition, newCameraQuaternion);
        }
    }
    /**
     * Focus the camera on a specific target point at a given distance.
     *
     * @param target The target point to focus on (Vector3)
     */
    focus(target) {
        if (!(this.object instanceof PerspectiveCamera) || !(this instanceof ArcballControls))
            return false;
        // Disable zoom temporarily to prevent zooming in when focusing
        const zoomEnabled = this.enableZoom;
        this.enableZoom = false;
        super.focus(target, 1);
        this.enableZoom = zoomEnabled;
    }
    /**
     * Focus the ArcballControls to a specific target position. This method can be used to instantly move the camera
     * to focus on a new target without animation. It updates the ArcballControls target and related gizmo positions and states.
     *
     * @param target The new target position for the ArcballControls.
     * @param cameraPosition The new camera position to focus on the target.
     * @param cameraQuaternion The new camera orientation (quaternion) to focus on the target.
     */
    focusToTarget(target, cameraPosition, cameraQuaternion) {
        if (!(this.object instanceof PerspectiveCamera))
            return;
        this.object.position.copy(cameraPosition);
        this.object.quaternion.copy(cameraQuaternion);
        this.object.updateMatrixWorld();
        this.updateTarget(target);
    }
    /**
     * Focuses the camera on the given points, adjusting the camera position and orientation to ensure all points are visible.
     *
     * @param input Array of 3D points to focus on.
     * @param options Optional parameters to customize the focusing behavior.
     * @returns A promise that resolves when the focusing operation is complete.
     */
    async focusItem(input, { cameraProfile, distance, shouldAnimate = true } = {}) {
        if (!(this.object instanceof PerspectiveCamera) || !(this instanceof ArcballControls) || input.length < 2)
            return false;
        // If there are only 2 points, we will add using midpoint as an additional point.
        // This generally only applied for polylines as there's no way a plane can be formed with only 2 points.
        const positions = [];
        if (input.length === 2) {
            const midpoint = new Vector3((input[0].x + input[1].x) / 2, (input[0].y + input[1].y) / 2, (input[0].z + input[1].z) / 2);
            positions.push(input[0].clone(), midpoint, input[1].clone());
        }
        else {
            input.forEach((point) => positions.push(point.clone()));
        }
        // Calculate target as the center of the plane
        const target = findCenter(positions);
        if (!target)
            throw new Error('Failed to calculate center of the plane');
        // Create the plane
        const plane = new Plane().setFromCoplanarPoints(positions[0], positions[1], positions[2]);
        // Determine which side of the plane to place the camera
        // based on camera profile or current camera position
        const cameraUp = new Vector3();
        const cameraForward = new Vector3(0, 0, -1);
        const referencePosition = new Vector3();
        if (cameraProfile) {
            const { state: { arcballState: { cameraUp: up }, }, target: cameraTarget, positions: { front }, } = cameraProfile;
            referencePosition.fromArray(front);
            cameraUp.set(up.x, up.y, up.z);
            cameraForward.fromArray(cameraTarget).sub(referencePosition).normalize();
        }
        else {
            cameraUp.setFromMatrixColumn(this.object.matrix, 1);
            cameraForward.applyQuaternion(this.object.quaternion).normalize();
            referencePosition.copy(this.object.position);
        }
        // Check if plane is nearly parallel to camera's view direction
        // If so, use camera's direction for more stable focusing
        const targetNormal = new Vector3();
        const planeNormal = plane.normal.clone().normalize();
        const similarity = Math.abs(planeNormal.dot(cameraForward));
        // Plane is nearly parallel to camera view, use camera direction as normal
        // cameraForward points FROM camera TO scene, so negate it to point FROM plane TO camera
        // Only do this for camera profile as it provides a more stable reference direction.
        // For polyline with only 2 points, we will always use camera direction as normal since
        // the calculated plane is not useful anyway.
        if ((similarity > SIMILARITY_THRESHOLD && cameraProfile) || input.length === 2) {
            targetNormal.copy(cameraForward.clone().negate());
        }
        else {
            // Determine which side of the plane the reference position is on
            // If distance >= 0, camera is on the side the normal points to
            const distanceToPlane = plane.distanceToPoint(referencePosition);
            targetNormal.copy(distanceToPlane >= 0 ? plane.normal.clone() : plane.normal.clone().negate());
        }
        // Calculate new parameters for the camera to focus on the target
        const cameraDistance = distance ?? fitCameraDistance(positions, targetNormal, cameraUp, this.object.fov, this.object.aspect, 3);
        const newCameraPosition = new Vector3().copy(target).add(targetNormal.multiplyScalar(cameraDistance));
        const newCameraQuaternion = new Quaternion().setFromRotationMatrix(new Matrix4().lookAt(newCameraPosition, target, cameraUp));
        // Update ArcballControls target to the new target
        if (shouldAnimate) {
            await this.animateToTarget(target, newCameraPosition, newCameraQuaternion);
        }
        else {
            this.focusToTarget(target, newCameraPosition, newCameraQuaternion);
        }
        return true;
    }
}

const CameraManager = ({ windowSize, sceneDetails, fov = 90, near = 0.1, far = 2000, areas, skipInitialCameraProfile = false, }) => {
    const { set, scene, camera, gl } = useThree();
    const { arcballControlsRef, editingAnchor } = useThreeCanvasContext();
    // Refs
    const isInitialzedControlsAreaIdRef = useRef('');
    // TODO: to be moved into Context whenever the tool that uses it is implemented
    const disablePanning = false;
    const disableRotation = false;
    // Derived states
    const isDragging = editingAnchor !== null; // Suspend orbit/pan while an anchor is being dragged so the camera doesn't move with it.
    const area = areas?.[0];
    const isAreaLoaded = Boolean(area?.inspection_area_id && sceneDetails);
    const isControlsInitialized = Boolean(isAreaLoaded && isInitialzedControlsAreaIdRef.current === area?.inspection_area_id);
    /**
     * Update controls based on state changes.
     */
    useEffect(() => {
        if (!arcballControlsRef.current)
            return;
        arcballControlsRef.current.enabled = !isDragging;
        arcballControlsRef.current.enablePan = !disablePanning;
        arcballControlsRef.current.enableRotate = !disableRotation;
    }, [disablePanning, disableRotation, isDragging, arcballControlsRef]);
    /**
     * Initialize the scene camera.
     * This runs only once when the component mounts.
     */
    useEffect(() => {
        if (!sceneDetails || !isAreaLoaded)
            return;
        // Initialize camera
        if (camera instanceof PerspectiveCamera) {
            camera.aspect = windowSize.width / windowSize.height;
            camera.fov = fov;
            camera.near = near;
            camera.far = far;
            camera.position.set(sceneDetails.center.x, sceneDetails.center.y - sceneDetails.radius, sceneDetails.center.z);
            camera.up.set(0, 0, 1);
            camera.updateMatrixWorld();
            camera.updateProjectionMatrix();
        }
        // dispatch(setInitCameraCompleted(true))
    }, [sceneDetails, windowSize, fov, near, far, camera, isAreaLoaded]);
    /**
     * Initialize ArcballControls for the scene.
     */
    const initControls = useCallback(() => {
        if (!sceneDetails || !isAreaLoaded)
            return;
        arcballControlsRef.current = new ArcballControls(camera, gl.domElement, scene);
        arcballControlsRef.current.enableFocus = false; // We want finer control over focus. It'll be handled by the CameraFocus tool.
        arcballControlsRef.current.activateGizmos(false);
        arcballControlsRef.current.setGizmosVisible(false);
        set({
            controls: arcballControlsRef.current,
        });
        // Skip the saved profile when the app owns the initial camera (e.g. framing a linked damage's
        // item): its load animation would otherwise block that focus. Fall back to centring so there's
        // no in-flight animation for the app's focus to fight.
        if (area?.camera_profile && !skipInitialCameraProfile) {
            arcballControlsRef.current.animateToProfile(area.camera_profile, undefined, isControlsInitialized ? 0 : undefined);
        }
        else {
            arcballControlsRef.current.target.set(sceneDetails.center.x, sceneDetails.center.y, sceneDetails.center.z);
            arcballControlsRef.current.update();
        }
        isInitialzedControlsAreaIdRef.current = area?.inspection_area_id || '';
    }, [
        arcballControlsRef,
        camera,
        gl,
        scene,
        area?.camera_profile,
        skipInitialCameraProfile,
        isAreaLoaded,
        isControlsInitialized,
        sceneDetails,
        set,
    ]);
    /**
     * Initialize the scene with controls.
     * This runs only once when the component mounts.
     */
    useEffect(() => {
        // Set controls
        initControls();
        return () => {
            if (arcballControlsRef.current) {
                arcballControlsRef.current.dispose();
                arcballControlsRef.current = null;
            }
        };
    }, [arcballControlsRef, initControls]);
    return null;
};

var DrawingTool;
(function (DrawingTool) {
    DrawingTool["Polyline"] = "POLYLINE";
    DrawingTool["Polygon"] = "POLYGON";
    DrawingTool["Cuboid"] = "CUBOID";
})(DrawingTool || (DrawingTool = {}));

var CircleAnchorIcon;
(function (CircleAnchorIcon) {
    CircleAnchorIcon[CircleAnchorIcon["CHECK"] = 0] = "CHECK";
    CircleAnchorIcon[CircleAnchorIcon["MOVE"] = 1] = "MOVE";
    CircleAnchorIcon[CircleAnchorIcon["REMOVE"] = 2] = "REMOVE";
    CircleAnchorIcon[CircleAnchorIcon["CHAIN"] = 3] = "CHAIN";
    CircleAnchorIcon[CircleAnchorIcon["WARNING"] = 4] = "WARNING";
})(CircleAnchorIcon || (CircleAnchorIcon = {}));
var AnchorColors;
(function (AnchorColors) {
    AnchorColors["Normal"] = "#333";
    AnchorColors["Drawing"] = "red";
    AnchorColors["Selected"] = "orange";
    AnchorColors["Movable"] = "#248CE4";
})(AnchorColors || (AnchorColors = {}));

const raycaster$1 = new Raycaster();
// PCD points are sparse; increase threshold so nearby points register
raycaster$1.params.Points = { threshold: 0.0075 };
function getRaycastHits(event, canvas, camera, scene, isPointPickable) {
    const rect = canvas.getBoundingClientRect();
    const { coords } = getClickCoords({ x: event.clientX, y: event.clientY }, { x: rect.left, y: rect.top, width: rect.width, height: rect.height });
    raycaster$1.setFromCamera(coords, camera);
    const allObjects = [];
    scene.children.forEach((child) => allObjects.push(...child.children, child));
    const pcdHits = raycaster$1.intersectObjects(allObjects.filter((o) => o instanceof Points), false);
    // Solid mesh is a separate "scene surface" channel. Its meshes are tagged `userData.isSolidMesh`
    // when tiles load, so we raycast the scene recursively and keep only those hits — distinguishing
    // our solid mesh from any other meshes in the scene (anchors, previews, drawn geometry).
    const meshHits = raycaster$1.intersectObjects(scene.children, true);
    // Hits are sorted by distance, so within each channel the first hit passing the consumer's
    // picking filter (all of them, when no filter is set) is the closest pickable point.
    const pcdHit = isPointPickable ? pcdHits.find((hit) => isPointPickable(hit.point)) : pcdHits[0];
    const solidMeshHit = meshHits.find((hit) => hit.object.userData.isSolidMesh === true && (!isPointPickable || isPointPickable(hit.point)));
    return {
        pcdPoint: pcdHit?.point,
        solidMeshPoint: solidMeshHit?.point,
    };
}
const isRenderableObject3D = (object) => {
    return object instanceof Object3D;
};
const warnInvalidObject3D = (type, object) => {
    console.warn(`[ThreeCanvas] ${type} item is not an instance of Object3D`, object);
};
const warnEmptyObjectName = (type, object) => {
    if (!object.name.trim()) {
        console.warn(`[ThreeCanvas] ${type} Object3D.name is empty`, object);
    }
};
/**
 * Get the (x, y) relative position in the range -1 to 1, with the canvas center as (0, 0), from click coordinates
 * @param {{x: number, y: number}} clickPosition x, y coordinates of the click position from the top-left of the screen
 * @param {{x: number, y: number, width: number, height: number}} clickElement x, y coordinates of the top-left of the clicked element, plus its width and height
 * @return {{coords: {x: number, y:number}}} {coords: {x: number, y:number}}
 */
const getClickCoords = (clickPosition, clickElement) => {
    //* Get the relative position of the click from the canvas
    const relativeX = clickPosition.x - clickElement.x;
    const relativeY = clickPosition.y - clickElement.y;
    //* Convert to relative position in the range -1 to 1 with the canvas center as (0, 0)
    return {
        coords: new Vector2((relativeX / clickElement.width) * 2 - 1, -(relativeY / clickElement.height) * 2 + 1),
    };
};
/**
 * Recursively find objects of a specific type within an Object3D, defined by userData.type.
 *
 * @param object The Object3D to search within.
 * @param type The type to search for, defined in userData.type.
 */
const findObjectsOfType = (object, type) => {
    const objects = [];
    // Check if current object matches the type
    if (object.userData.type === type) {
        objects.push(object);
    }
    // Recursively check all children
    object.children.forEach((child) => {
        objects.push(...findObjectsOfType(child, type));
    });
    return objects;
};

new Raycaster();
const useProjectionPlane = (camera, gl) => {
    // Store
    const selectedBlueprint = undefined;
    /**
     * Calculate the projection matrix based on the selected blueprint's camera profile.
     */
    const projectionMatrix = useMemo(() => {
        return new Matrix4();
    }, [selectedBlueprint?.camera_profile]);
    /**
     * Calculate the projection directions based on the selected blueprint's camera profile.
     * This includes the up, left, and normal vectors of the projection plane.
     */
    const projectionDirections = useMemo(() => {
        return null;
    }, [selectedBlueprint]);
    /**
     * Calculate the projection plane based on the selected blueprint and mode.
     */
    const projectionPlane = useMemo(() => {
        {
            return null;
        }
    }, [selectedBlueprint, projectionDirections]);
    /**
     * Calculate an offset matrix to slightly offset objects from the projection plane to avoid z-fighting.
     *
     * @param offset Distance to offset along the projection normal. Default is 0.001 units.
     */
    const calculateOffsetMatrix = useCallback((offset = 1) => {
        if (!projectionDirections)
            return new Matrix4();
        const translation = projectionDirections.normal
            .clone()
            .negate()
            .multiplyScalar((offset * 2) / 1000); // Convert m to mm
        const offsetMatrix = new Matrix4().makeTranslation(translation.x, translation.y, translation.z);
        return offsetMatrix;
    }, [projectionDirections]);
    /**
     * Raycast to the projection plane from a screen position.
     * @param screenPos - The screen position to raycast from.
     * @param result - The Vector3 to store the intersection result
     * @returns The intersection point or null if projection plane is not set
     */
    const raycastToPlane = useCallback((screenPos, result) => {
        return null;
    }, [camera, gl?.domElement, projectionPlane]);
    /**
     * Projects a 3D world position to 2D screen coordinates.
     *
     * @param pos World position to project.
     * @param camera Camera used for projection.
     * @param width Viewport width in pixels.
     * @param height Viewport height in pixels.
     * @returns Screen space coordinates in pixels.
     */
    const worldToScreen = (pos) => {
        return null;
    };
    /**
     * Converts 2D screen coordinates into a 3D world position on a given plane.
     *
     * @param screenPos The position in screen space (pixels).
     * @param camera The camera used for unprojection.
     * @param width The viewport width in pixels.
     * @param height The viewport height in pixels.
     * @param plane The plane in world space to intersect with.
     * @returns The intersection point in world space, or null if no intersection exists.
     */
    const screenToWorld = (screenPos) => {
        return null;
    };
    return {
        projectionMatrix,
        projectionPlane,
        projectionDirections,
        worldToScreen,
        screenToWorld,
        raycastToPlane,
        calculateOffsetMatrix,
    };
};

/**
 * Available icons for the circle anchor.
 */
const Icons = {
    [CircleAnchorIcon.CHECK]: jsx(FaCheck, { pointerEvents: "none" }),
    [CircleAnchorIcon.MOVE]: jsx(FiMove, { pointerEvents: "none" }),
    [CircleAnchorIcon.REMOVE]: jsx(DeleteIcon, { pointerEvents: "none" }),
    [CircleAnchorIcon.CHAIN]: jsx(FaLink, { pointerEvents: "none" }),
    [CircleAnchorIcon.WARNING]: jsx(MdOutlineWarning, { pointerEvents: "none" }),
};
/**
 * Constants for anchor sizing and geometry
 */
const ANCHOR_PIXEL_RADIUS = 7;
const DEFAULT_ICON_SIZE = 16;
const ICON_TO_ANCHOR_RATIO = 1;
const BASE_GEOMETRY_SIZE = 0.002;
const GEOMETRY_SEGMENTS = 32;

/**
 * Create circle geometry for anchors
 */
const createAnchorGeometry = (scale = 1) => new CircleGeometry(BASE_GEOMETRY_SIZE * scale, GEOMETRY_SEGMENTS);
/**
 * Convert pixel radius to world space units for consistent anchor sizing
 * @param camera - The camera (perspective or orthographic)
 * @param pixelRadius - Desired radius in screen pixels
 * @param canvasSize - Canvas dimensions
 * @param anchorPosition - Position of the anchor in world space
 * @returns World space size to achieve the desired pixel radius
 */
const getWorldSizeForPixelRadius = (camera, pixelRadius, canvasSize, anchorPosition) => {
    if (camera instanceof OrthographicCamera) {
        // For orthographic cameras, the view is a box defined by left/right/top/bottom.
        // The world width is (right - left), and camera.zoom scales the view.
        // To convert a pixel radius to world units:
        //   (pixelRadius / canvas width) gives the fraction of the view in pixels,
        //   multiply by worldWidth to get world units,
        //   divide by camera.zoom to account for zoom scaling.
        const worldWidth = camera.right - camera.left;
        return ((pixelRadius / canvasSize.width) * worldWidth) / camera.zoom;
    }
    if (camera instanceof PerspectiveCamera) {
        // For perspective cameras, the size of an object in screen space depends on its perpendicular distance from the camera plane and the field of view (fov).
        // Calculate perpendicular distance to camera plane for consistent sizing regardless of position relative to camera axis.
        // The world height at a given distance is: 2 * distance * tan(fov / 2)
        //   - distance: perpendicular distance to camera viewing plane
        //   - fov: vertical field of view in radians
        // (pixelRadius / canvas height) gives the fraction of the view in pixels,
        // multiply by worldHeight to get world units at the anchor's depth.
        const cameraDirection = new Vector3(0, 0, -1).applyQuaternion(camera.quaternion);
        const cameraToAnchor = anchorPosition.clone().sub(camera.position);
        const distance = Math.abs(cameraToAnchor.dot(cameraDirection));
        const fov = (camera.fov * Math.PI) / 180; // Convert to radians
        const worldHeight = 2 * distance * Math.tan(fov / 2);
        return (pixelRadius / canvasSize.height) * worldHeight;
    }
    return BASE_GEOMETRY_SIZE; // Fallback to default size
};

const ANCHOR_GLYPHS = {
    [CircleAnchorIcon.CHECK]: {
        viewBox: 512,
        stroke: false,
        paths: [
            'M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z',
        ],
    },
    [CircleAnchorIcon.MOVE]: {
        viewBox: 24,
        stroke: true,
        strokeWidth: 2,
        paths: ['M5 9L2 12L5 15', 'M9 5L12 2L15 5', 'M15 19L12 22L9 19', 'M19 9L22 12L19 15', 'M2 12L22 12', 'M12 2L12 22'],
    },
    [CircleAnchorIcon.REMOVE]: {
        viewBox: 24,
        // Thicker than the source LuX (2): two bare strokes read too thin at anchor size.
        stroke: true,
        strokeWidth: 4,
        paths: ['M18 6 6 18', 'm6 6 12 12'],
    },
    [CircleAnchorIcon.CHAIN]: {
        viewBox: 512,
        stroke: false,
        paths: [
            'M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z',
        ],
    },
    [CircleAnchorIcon.WARNING]: {
        viewBox: 24,
        stroke: false,
        paths: ['M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z'],
    },
};
/** Ordered icon list; each glyph's atlas column index equals its position here. */
const ANCHOR_GLYPH_ORDER = [
    CircleAnchorIcon.CHECK,
    CircleAnchorIcon.MOVE,
    CircleAnchorIcon.REMOVE,
    CircleAnchorIcon.CHAIN,
    CircleAnchorIcon.WARNING,
];
/** Pixels per glyph cell in the shared SDF atlas texture. */
const ATLAS_CELL_PX = 128;
/**
 * Fraction of a cell the glyph's viewBox is drawn into, centred. The margin (1 − inset)
 * gives the distance field room to fall off around the glyph and keeps a glyph from
 * bleeding into its neighbour in the strip. The shader maps the icon box onto this same
 * central region, so the on-screen icon size is unchanged.
 */
const ATLAS_GLYPH_INSET = 0.72;
/**
 * Distance (in cell pixels) mapped onto the [0,1] alpha range either side of a glyph
 * edge (edge == 0.5). Wide enough to survive minification, narrow enough to keep thin
 * strokes above 0.5 so they don't drop out on tiny anchors.
 */
const SDF_SPREAD_PX = 8;
/** Supersample factor for rasterising glyph coverage before the distance transform. */
const SDF_SUPERSAMPLE = 4;

/**
 * The single shared glyph atlas for every anchor in the app.
 *
 * A horizontal strip of {@link ATLAS_CELL_PX}-wide cells, one per icon in
 * {@link ANCHOR_GLYPH_ORDER}. Each cell stores a **signed distance field** of the glyph
 * in its alpha channel (0.5 == edge, >0.5 inside), not raw coverage — anchors are tiny
 * on screen, and an SDF re-thresholded with `fwidth` in the shader stays crisp at any
 * size instead of shimmering (no mips) or blurring (coverage mips). Built lazily once;
 * mounting an anchor never touches the DOM or React, only samples this texture.
 */
let atlasTexture = null;
/** Column index of an icon within the atlas, or -1 when it has no glyph. */
const getGlyphIndex = (icon) => ANCHOR_GLYPH_ORDER.indexOf(icon);
/** Number of glyph cells in the atlas. */
const GLYPH_COUNT = ANCHOR_GLYPH_ORDER.length;
const INF = 1e20;
/** Draw one glyph white and centred into a `size`×`size` context (cleared first). */
const drawGlyphCoverage = (ctx, glyph, size) => {
    const drawSize = size * ATLAS_GLYPH_INSET;
    const margin = (size - drawSize) / 2;
    const scale = drawSize / glyph.viewBox;
    ctx.clearRect(0, 0, size, size);
    ctx.save();
    ctx.translate(margin, margin);
    ctx.scale(scale, scale);
    ctx.fillStyle = '#ffffff';
    ctx.strokeStyle = '#ffffff';
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    if (glyph.strokeWidth)
        ctx.lineWidth = glyph.strokeWidth;
    glyph.paths.forEach((d) => {
        const path = new Path2D(d);
        if (glyph.stroke)
            ctx.stroke(path);
        else
            ctx.fill(path);
    });
    ctx.restore();
};
/**
 * 1-D squared Euclidean distance transform (Felzenszwalb & Huttenlocher, 2012).
 * `f` holds the input cost per index; results are written into `d`.
 */
const edt1d = (f, d, v, z, n) => {
    v[0] = 0;
    z[0] = -INF;
    z[1] = INF;
    let k = 0;
    for (let q = 1; q < n; q++) {
        let s = (f[q] + q * q - (f[v[k]] + v[k] * v[k])) / (2 * q - 2 * v[k]);
        while (s <= z[k]) {
            k -= 1;
            s = (f[q] + q * q - (f[v[k]] + v[k] * v[k])) / (2 * q - 2 * v[k]);
        }
        k += 1;
        v[k] = q;
        z[k] = s;
        z[k + 1] = INF;
    }
    k = 0;
    for (let q = 0; q < n; q++) {
        while (z[k + 1] < q)
            k += 1;
        d[q] = (q - v[k]) * (q - v[k]) + f[v[k]];
    }
};
/** In-place 2-D squared EDT of a `w`×`h` grid (0 at seeds, INF elsewhere). */
const edt2d = (grid, w, h) => {
    const size = Math.max(w, h);
    const f = new Float64Array(size);
    const d = new Float64Array(size);
    const v = new Int32Array(size);
    const z = new Float64Array(size + 1);
    for (let x = 0; x < w; x++) {
        for (let y = 0; y < h; y++)
            f[y] = grid[y * w + x];
        edt1d(f, d, v, z, h);
        for (let y = 0; y < h; y++)
            grid[y * w + x] = d[y];
    }
    for (let y = 0; y < h; y++) {
        for (let x = 0; x < w; x++)
            f[x] = grid[y * w + x];
        edt1d(f, d, v, z, w);
        for (let x = 0; x < w; x++)
            grid[y * w + x] = d[x];
    }
};
/** Signed distance (in pixels, positive inside the glyph) from RGBA coverage. */
const signedDistanceField = (rgba, size) => {
    const n = size * size;
    const gIn = new Float64Array(n);
    const gOut = new Float64Array(n);
    for (let i = 0; i < n; i++) {
        const inside = rgba[i * 4 + 3] > 127;
        gIn[i] = inside ? 0 : INF;
        gOut[i] = inside ? INF : 0;
    }
    edt2d(gIn, size, size); // squared distance to nearest inside (used for outside pixels)
    edt2d(gOut, size, size); // squared distance to nearest outside (used for inside pixels)
    const sdf = new Float64Array(n);
    for (let i = 0; i < n; i++)
        sdf[i] = Math.sqrt(gOut[i]) - Math.sqrt(gIn[i]);
    return sdf;
};
const buildAtlas = () => {
    const cell = ATLAS_CELL_PX;
    const ss = SDF_SUPERSAMPLE;
    const hires = cell * ss;
    const width = cell * GLYPH_COUNT;
    const height = cell;
    const glyphCanvas = document.createElement('canvas');
    glyphCanvas.width = hires;
    glyphCanvas.height = hires;
    const glyphCtx = glyphCanvas.getContext('2d', { willReadFrequently: true });
    const atlasCanvas = document.createElement('canvas');
    atlasCanvas.width = width;
    atlasCanvas.height = height;
    const atlasCtx = atlasCanvas.getContext('2d');
    if (glyphCtx && atlasCtx) {
        const image = atlasCtx.createImageData(width, height);
        ANCHOR_GLYPH_ORDER.forEach((icon, index) => {
            drawGlyphCoverage(glyphCtx, ANCHOR_GLYPHS[icon], hires);
            const { data } = glyphCtx.getImageData(0, 0, hires, hires);
            const sdf = signedDistanceField(data, hires);
            const cellX = index * cell;
            for (let y = 0; y < cell; y++) {
                for (let x = 0; x < cell; x++) {
                    // Average the supersampled block, then convert hires px → cell px.
                    let sum = 0;
                    for (let dy = 0; dy < ss; dy++) {
                        for (let dx = 0; dx < ss; dx++) {
                            sum += sdf[(y * ss + dy) * hires + (x * ss + dx)];
                        }
                    }
                    const distCell = sum / (ss * ss) / ss;
                    const value = Math.max(0, Math.min(1, 0.5 + distCell / (2 * SDF_SPREAD_PX)));
                    const di = (y * width + cellX + x) * 4;
                    image.data[di] = 255;
                    image.data[di + 1] = 255;
                    image.data[di + 2] = 255;
                    image.data[di + 3] = Math.round(value * 255);
                }
            }
        });
        atlasCtx.putImageData(image, 0, 0);
    }
    const texture = new CanvasTexture(atlasCanvas);
    // Mips keep the SDF alias-free under heavy minification; averaging a distance field
    // preserves edges (unlike coverage). The shader re-sharpens with fwidth either way.
    texture.generateMipmaps = true;
    texture.minFilter = LinearMipmapLinearFilter;
    texture.magFilter = LinearFilter;
    texture.anisotropy = 16; // clamped to the GPU max at upload
    texture.needsUpdate = true;
    return texture;
};
/**
 * Returns the shared glyph atlas, building it on first use. Returns a blank
 * {@link Texture} in non-DOM environments (SSR/tests) so callers never crash.
 */
const getIconAtlas = () => {
    if (atlasTexture)
        return atlasTexture;
    atlasTexture = typeof document === 'undefined' ? new Texture() : buildAtlas();
    return atlasTexture;
};

/**
 * A single GLSL program shared by every anchor. Per-anchor `ShaderMaterial`
 * instances differ only in the values of the per-anchor uniform block below — the
 * program compiles once. This is deliberately structured so the per-anchor block can
 * later be promoted to `InstancedBufferAttribute`s (approach B) with no shader rewrite.
 *
 * Uniform groups:
 * - **Global** (identical for all anchors — camera/viewport/atlas): `uViewport`,
 *   `uPixelRadius`, `uAtlas`, `uAtlasCount`. These stay uniforms even under instancing.
 * - **Per-anchor** (would become instanced attributes): `uColor`, `uOutlineColor`,
 *   `uIconColor`, `uOpacity`, `uOutlineOpacity`, `uInnerScale`, `uIconIndex`,
 *   `uIconHalf`, `uScale`, `uTouchMult`, `uProjectionBias`.
 */
const vertexShader = /* glsl */ `
  // -- Global uniforms --
  uniform vec2 uViewport;      // canvas size in px
  uniform float uPixelRadius;  // target on-screen radius in px

  // -- Per-anchor uniforms --
  uniform float uScale;          // scale, or hoverScale while hovered
  uniform float uTouchMult;      // touch-area multiplier (quad extent vs visible radius)
  uniform float uProjectionBias; // view-space z nudge toward camera on a projection plane

  varying vec2 vRUv; // fragment coords in radius units: visible circle edge at length()==1

  void main() {
    // Anchor centre in view space.
    vec4 mvCenter = modelViewMatrix * vec4(0.0, 0.0, 0.0, 1.0);

    // World distance that maps to one screen pixel at this depth. Derived on the GPU
    // for both perspective (clip.w == -z) and orthographic (clip.w == 1) cameras — the
    // shader port of getWorldSizeForPixelRadius. Height-based (P[1][1]/uViewport.y), like
    // that CPU function and the raycast that reuses it: split-screen viewports (editor
    // PCD alignment) span the full canvas height but half its width, so the width-based
    // form under-sizes anchors there while the height-based form holds everywhere.
    vec4 clip = projectionMatrix * mvCenter;
    float worldPerPixel = (2.0 * clip.w) / (projectionMatrix[1][1] * uViewport.y);
    float radiusWorld = uPixelRadius * worldPerPixel * uScale;

    // Billboard: offset the quad corner in view space so it always faces the camera,
    // sized to cover the enlarged touch area. No quaternion, no per-frame CPU work.
    float halfEdge = radiusWorld * uTouchMult;
    mvCenter.xy += position.xy * (halfEdge * 2.0);
    mvCenter.z += uProjectionBias;

    vRUv = position.xy * (2.0 * uTouchMult);

    gl_Position = projectionMatrix * mvCenter;
  }
`;
const fragmentShader = /* glsl */ `
  // -- Global uniforms --
  uniform sampler2D uAtlas;
  uniform float uAtlasCount;
  uniform float uIconInset; // fraction of each atlas cell the glyph occupies

  // -- Per-anchor uniforms --
  uniform vec3 uColor;
  uniform vec3 uOutlineColor;
  uniform vec3 uIconColor;
  uniform float uOpacity;
  uniform float uOutlineOpacity;
  uniform float uInnerScale;
  uniform float uIconIndex; // < 0 renders no icon
  uniform float uIconHalf;  // icon half-extent in radius units

  varying vec2 vRUv;

  // Straight-alpha "source over destination" compositing.
  vec4 over(vec4 src, vec4 dst) {
    float a = src.a + dst.a * (1.0 - src.a);
    if (a <= 0.0) return vec4(0.0);
    vec3 rgb = (src.rgb * src.a + dst.rgb * dst.a * (1.0 - src.a)) / a;
    return vec4(rgb, a);
  }

  void main() {
    float r = length(vRUv);
    float aa = fwidth(r);

    // Outline ring fills the disk up to radius 1; the inner colour fills up to uInnerScale.
    float ringMask = 1.0 - smoothstep(1.0 - aa, 1.0 + aa, r);
    float fillMask = 1.0 - smoothstep(uInnerScale - aa, uInnerScale + aa, r);

    vec4 color = vec4(0.0);
    color = over(vec4(uOutlineColor, uOutlineOpacity * ringMask), color);
    color = over(vec4(uColor, uOpacity * fillMask), color);

    // Icon glyph from the shared SDF atlas, tinted by uIconColor. The alpha channel is a
    // signed distance (0.5 == edge), re-thresholded here with fwidth for a crisp ~1px
    // antialiased edge at any on-screen size. uIconIndex is a uniform, so this branch is
    // uniform across the draw and texture2D's mip derivatives stay well-defined; the
    // per-fragment box test uses step()/clamp() so we never sample under non-uniform flow.
    if (uIconIndex >= 0.0) {
      vec2 iconUv = vRUv / (2.0 * uIconHalf) + 0.5;
      // Map the icon box onto the glyph's padded central region within its cell.
      vec2 cellUv = (clamp(iconUv, 0.0, 1.0) - 0.5) * uIconInset + 0.5;
      vec2 atlasUv = vec2((cellUv.x + uIconIndex) / uAtlasCount, cellUv.y);
      float dist = texture2D(uAtlas, atlasUv).a;
      float aa = max(fwidth(dist), 1e-4);
      float glyphAlpha = smoothstep(0.5 - aa, 0.5 + aa, dist);
      // Zero outside the icon box so the glyph never spills onto the ring/fill.
      vec2 inBox = step(vec2(0.0), iconUv) * step(iconUv, vec2(1.0));
      glyphAlpha *= inBox.x * inBox.y;
      color = over(vec4(uIconColor, glyphAlpha), color);
    }

    if (color.a <= 0.0) discard;

    gl_FragColor = color;
    #include <colorspace_fragment>
  }
`;

/**
 * Shared unit quad for every anchor — never mutated (billboarding/sizing happens in the
 * shader), so one geometry serves the whole app. Not disposed with any single anchor.
 */
const QUAD_GEOMETRY = new PlaneGeometry(1, 1);
/**
 * View-space nudge toward the camera applied while a projection plane is active, so the
 * anchor sits just in front of the plane (mirrors V1's 0.005 world-space offset).
 */
const PROJECTION_Z_BIAS = 0.005;
// Scratch objects reused inside the synchronous custom raycast (safe to share).
const rayWorldPos = new Vector3();
const raySphere = new Sphere();
const rayHitPoint = new Vector3();
/**
 * Drop-in replacement for {@link CircleAnchor} that draws the whole anchor — circle,
 * outline and icon — as a single billboarded quad with one shader material. No
 * per-anchor DOM, no per-anchor `useFrame`: mounting an anchor is as cheap as mounting a
 * plain mesh, which removes the ~1s freeze when many anchors appear at once (#193).
 */
const CircleAnchorV2 = ({ id, point, scale = 1, innerScale = 0.75, hoverScale = 1.1, icon, iconColor, iconScale = 0.8, color = 'red', outlineColor = 'white', outlineOpacity = 1, opacity = 1, tooltipText, showTooltip = 'hover', depthTest = false, depthWrite = false, renderOrder = 1, visible = true, customCamera, touchAreaMultiplier = 1.5, isInteractable = true, labelFontSize = 1, onDown, onUp, onEnter, onLeave, onMove, }) => {
    const { camera: threeCamera, size } = useThree();
    const { projectionDirections } = useProjectionPlane();
    const camera = (customCamera || threeCamera);
    // Refs
    const meshRef = useRef(null);
    // Latest camera/canvas size for the custom raycast (which runs outside React render).
    const cameraRef = useRef(camera);
    cameraRef.current = camera;
    const sizeRef = useRef(size);
    sizeRef.current = size;
    const [isHovered, setIsHovered] = useState(false);
    const atlas = useMemo(() => getIconAtlas(), []);
    /**
     * One shader material per anchor. Every instance runs the same compiled program;
     * only the per-anchor uniform block differs — structured so it can later be promoted
     * to instanced attributes (approach B) without touching the shader.
     */
    const material = useMemo(() => new ShaderMaterial({
        vertexShader,
        fragmentShader,
        transparent: true,
        side: DoubleSide,
        uniforms: {
            // Global (shared across anchors under a future instanced pool)
            uViewport: { value: new Vector2(1, 1) },
            uPixelRadius: { value: ANCHOR_PIXEL_RADIUS * labelFontSize },
            uAtlas: { value: atlas },
            uAtlasCount: { value: GLYPH_COUNT },
            uIconInset: { value: ATLAS_GLYPH_INSET },
            // Per-anchor
            uColor: { value: new Color() },
            uOutlineColor: { value: new Color() },
            uIconColor: { value: new Color() },
            uOpacity: { value: 1 },
            uOutlineOpacity: { value: 1 },
            uInnerScale: { value: 0.75 },
            uIconIndex: { value: -1 },
            uIconHalf: { value: 0.4 },
            uScale: { value: 1 },
            uTouchMult: { value: 1.5 },
            uProjectionBias: { value: 0 },
        },
    }), [atlas, labelFontSize]);
    // Dispose the material on unmount (the shared geometry/atlas are never disposed).
    useEffect(() => () => material.dispose(), [material]);
    // Depth behaviour mirrors V1: depth test/write off by default, drawn on top.
    useEffect(() => {
        material.depthTest = depthTest;
        material.depthWrite = depthWrite;
    }, [material, depthTest, depthWrite]);
    // Viewport size feeds the shader's pixel→world sizing (updates only on resize).
    useEffect(() => {
        material.uniforms.uViewport.value.set(size.width, size.height);
    }, [material, size.width, size.height]);
    // All per-anchor appearance uniforms. Runs on prop or hover change — never per frame.
    useEffect(() => {
        const u = material.uniforms;
        const activeScale = isHovered ? hoverScale : scale;
        u.uColor.value.set(color);
        u.uOutlineColor.value.set(outlineColor);
        u.uIconColor.value.set(iconColor ?? color);
        u.uOpacity.value = opacity;
        u.uOutlineOpacity.value = outlineOpacity;
        u.uInnerScale.value = innerScale;
        u.uIconIndex.value = icon === undefined ? -1 : getGlyphIndex(icon);
        // Keep the icon's on-screen size independent of the anchor scale (as in V1), by
        // dividing out the quad's scale — icon size then depends only on iconScale.
        u.uIconHalf.value = (iconScale * ICON_TO_ANCHOR_RATIO) / (2 * activeScale);
        u.uScale.value = activeScale;
        u.uTouchMult.value = touchAreaMultiplier;
        u.uProjectionBias.value = projectionDirections ? PROJECTION_Z_BIAS : 0;
    }, [
        material,
        color,
        outlineColor,
        iconColor,
        opacity,
        outlineOpacity,
        innerScale,
        icon,
        iconScale,
        scale,
        hoverScale,
        isHovered,
        touchAreaMultiplier,
        projectionDirections,
    ]);
    /**
     * Custom ray–sphere pick. A shader-billboarded quad can't be raycast through its
     * (never-transformed) CPU geometry, so we hit-test a sphere of the touch radius —
     * identical forgiveness to V1's invisible enlarged hitbox mesh.
     */
    const raycast = useCallback((raycaster, intersects) => {
        const mesh = meshRef.current;
        const cam = cameraRef.current;
        if (!mesh || !mesh.visible || !cam)
            return;
        const center = mesh.getWorldPosition(rayWorldPos);
        const pixelRadius = ANCHOR_PIXEL_RADIUS * labelFontSize;
        const worldRadius = getWorldSizeForPixelRadius(cam, pixelRadius, sizeRef.current, center) * touchAreaMultiplier;
        raySphere.set(center, worldRadius);
        const hit = raycaster.ray.intersectSphere(raySphere, rayHitPoint);
        if (!hit)
            return;
        const distance = raycaster.ray.origin.distanceTo(hit);
        if (distance < raycaster.near || distance > raycaster.far)
            return;
        intersects.push({ distance, point: hit.clone(), object: mesh });
    }, [touchAreaMultiplier, labelFontSize]);
    const onPointerEnter = useCallback((e) => {
        e.stopPropagation();
        if (onEnter && visible)
            onEnter(e);
        setIsHovered(true);
    }, [onEnter, visible]);
    const onPointerLeave = useCallback((e) => {
        e.stopPropagation();
        if (onLeave && visible)
            onLeave(e);
        setIsHovered(false);
    }, [onLeave, visible]);
    const onPointerDown = useCallback((e) => {
        e.stopPropagation();
        if (e.nativeEvent.button !== 0)
            return;
        if (onDown && visible)
            onDown(e);
    }, [onDown, visible]);
    const onPointerMove = useCallback((e) => {
        if (onMove && visible)
            onMove(e);
    }, [onMove, visible]);
    const onPointerUp = useCallback((e) => {
        if (onUp && visible)
            onUp(e);
    }, [onUp, visible]);
    return (jsxs("mesh", { ref: meshRef, name: `circle-anchor-${id}`, position: point, visible: visible, renderOrder: renderOrder, frustumCulled: false, geometry: QUAD_GEOMETRY, userData: { type: 'CircleAnchor' }, raycast: raycast, onPointerDown: isInteractable ? onPointerDown : undefined, onPointerEnter: isInteractable ? onPointerEnter : undefined, onPointerLeave: onPointerLeave, onPointerMove: isInteractable ? onPointerMove : undefined, onPointerUp: isInteractable ? onPointerUp : undefined, children: [jsx("primitive", { object: material, attach: "material" }), !!tooltipText && (showTooltip === 'always' || (showTooltip === 'hover' && isHovered)) && (jsx(Html, { style: { transform: 'translateX(-50%) translateY(-200%)', pointerEvents: 'none' }, zIndexRange: [1, 9], children: jsx(StylesProvider, { children: jsx(Box, { backgroundColor: "yellow", py: 0, px: 4, opacity: opacity, fontSize: `${80 * labelFontSize}%`, fontWeight: "bold", color: "black", whiteSpace: "nowrap", children: tooltipText }) }) }))] }));
};

var SubtoolVertex;
(function (SubtoolVertex) {
    SubtoolVertex["None"] = "none";
    SubtoolVertex["AddVertex"] = "add-vertex";
    /** Vertex-only removal: click a vertex to delete it; the line stays a single polyline. */
    SubtoolVertex["RemoveVertex"] = "remove-vertex";
    /**
     * Vertex removal **and** edge cutting: clicking an edge splits the line into two polylines.
     * Kept for parity with the Editor but hidden on Platform, where a single line links to a damage
     * record and a split would create an ambiguous second line (see the polyline tool's subtoolbar).
     */
    SubtoolVertex["Remove"] = "remove";
    SubtoolVertex["MoveVertex"] = "move-vertex";
    SubtoolVertex["ConnectVertex"] = "connect-vertex";
})(SubtoolVertex || (SubtoolVertex = {}));
var AnchorStates;
(function (AnchorStates) {
    AnchorStates["Base"] = "base";
    AnchorStates["Highlighted"] = "highlighted";
})(AnchorStates || (AnchorStates = {}));
/**
 * Default styles for anchors.
 */
const DefaultStyles = {
    color: 'red',
};
/**
 * Default styles for when vertex subtool is active.
 */
const DefaultAnchorStyles = {
    color: AnchorColors.Movable,
    icon: CircleAnchorIcon.MOVE,
    iconColor: 'white',
    outlineOpacity: 0,
    iconScale: 1.6,
    scale: 1.3,
    hoverScale: 1.5,
};
/**
 * Styles when no action is possible on the anchor.
 */
const NoActionStyles = {
    ...DefaultAnchorStyles,
    color: AnchorColors.Normal,
    outlineOpacity: 1,
    icon: undefined,
};
/**
 * Styles for each vertex subtool.
 */
const VertexSubtoolStyles = {
    [SubtoolVertex.AddVertex]: { [AnchorStates.Base]: DefaultAnchorStyles },
    [SubtoolVertex.MoveVertex]: { [AnchorStates.Base]: DefaultAnchorStyles },
    [SubtoolVertex.RemoveVertex]: {
        [AnchorStates.Base]: {
            ...DefaultAnchorStyles,
            icon: CircleAnchorIcon.REMOVE,
            color: 'red',
        },
    },
    // Both remove sub-modes delete a vertex, so they share the removable-anchor styling.
    [SubtoolVertex.Remove]: {
        [AnchorStates.Base]: {
            ...DefaultAnchorStyles,
            icon: CircleAnchorIcon.REMOVE,
            color: 'red',
        },
    },
    [SubtoolVertex.ConnectVertex]: {
        [AnchorStates.Base]: {
            ...DefaultAnchorStyles,
            color: '#63b3ed', // blue.200
            icon: CircleAnchorIcon.CHAIN,
        },
        [AnchorStates.Highlighted]: {
            iconScale: (DefaultAnchorStyles.iconScale) * 1.2,
            scale: (DefaultAnchorStyles.scale) * 1.2,
            hoverScale: (DefaultAnchorStyles.hoverScale) * 1.2,
            color: '#68D391', // green.300
            icon: CircleAnchorIcon.CHECK,
        },
    },
};
/**
 * Different cursor states for each vertex subtool.
 * This defines what cursor to show when hovering over anchors.
 */
({
    [SubtoolVertex.RemoveVertex]: CursorState.POINTER,
    [SubtoolVertex.Remove]: CursorState.POINTER,
});
var TransformTypes;
(function (TransformTypes) {
    TransformTypes["TRANSLATE"] = "translate";
    TransformTypes["ROTATE"] = "rotate";
    TransformTypes["SCALE"] = "scale";
})(TransformTypes || (TransformTypes = {}));
/**
 * Anchors required to place a cuboid: the first 3 define the base plane (the 3rd is
 * orthogonalized onto it — `fixVertexOnNormal`), the 4th sets the depth.
 * The Editor's `EDITOR_REQUIRED_ANCHORS.cuboid`.
 */
const CUBOID_REQUIRED_ANCHORS = 4;
/**
 * Half-size (world units, m) of the quick box placed around a triple-clicked point.
 * The Editor's `EDITOR_CUBOID_QUICK_SIZE`.
 */
const CUBOID_QUICK_SIZE = 3;
/**
 * Minimum cuboid extent per axis (m) — the Editor's 10 mm floor
 * (`millimeterToMeter(MIN_DIAMETER_SCALE)` in its `CuboidFrame`).
 */
const CUBOID_MIN_SIZE = 0.01;

/**
 * The working (in-placement, not-yet-persisted) cuboid: a wireframe box derived from 4 anchor
 * points, transformable with a `TransformControls` gizmo (translate / scale / rotate via `mode`).
 * Ported from the Editor's `objects/CuboidFrame`, with the gizmo mode and colour as props instead
 * of Redux state. Strictly geometric — what the box *means* is the consumer's business.
 *
 * Like `PolygonPlaneMeshTransformable`, only one instance may render at a time (the gizmo's
 * flags/events carry no identity).
 */
const CuboidFrame = ({ anchors, mode = TransformTypes.SCALE, minSize = CUBOID_MIN_SIZE, maxSize, color = 'white', onChange, onChanged, }) => {
    // Refs
    const lineRef = useRef(null);
    const groupRef = useRef(null);
    const transformRef = useRef(null);
    const prevAnchorsRef = useRef(undefined);
    // States
    const [cuboidInfo, setCuboidInfo] = useState();
    // Detect if user is on mobile for transform control sizing (same check as `Transformable`).
    const isMobile = useMemo(() => /Mobi|Android/i.test(navigator.userAgent), []);
    /**
     * Generate cuboid data from the controlled object's current transform, clamping the scale so
     * every extent stays within [minSize, maxSize]; re-attaches the gizmo when a clamp corrected it.
     */
    const generateCuboid = useCallback(() => {
        if (!lineRef.current || !transformRef.current || !cuboidInfo) {
            return {
                center: [0, 0, 0],
                rotation: new Matrix3().setFromMatrix4(new Matrix4()).toArray(),
                extent: [0, 0, 0],
            };
        }
        const minScaleX = minSize / (cuboidInfo.width || 1);
        const minScaleY = minSize / (cuboidInfo.height || 1);
        const minScaleZ = minSize / (cuboidInfo.depth || 1);
        const maxScaleX = maxSize / (cuboidInfo.width || 1);
        const maxScaleY = maxSize / (cuboidInfo.height || 1);
        const maxScaleZ = maxSize / (cuboidInfo.depth || 1);
        const { scale } = lineRef.current;
        let { width, depth, height } = cuboidInfo;
        width *= scale.x;
        height *= scale.y;
        depth *= scale.z;
        let needReset = false;
        if (minScaleX > scale.x) {
            needReset = true;
            lineRef.current.scale.x = minScaleX;
            width = minSize;
        }
        if (minScaleY > scale.y) {
            needReset = true;
            lineRef.current.scale.y = minScaleY;
            height = minSize;
        }
        if (minScaleZ > scale.z) {
            needReset = true;
            lineRef.current.scale.z = minScaleZ;
            depth = minSize;
        }
        if (maxScaleX < scale.x) {
            needReset = true;
            lineRef.current.scale.x = maxScaleX;
            width = maxSize;
        }
        if (maxScaleY < scale.y) {
            needReset = true;
            lineRef.current.scale.y = maxScaleY;
            height = maxSize;
        }
        if (maxScaleZ < scale.z) {
            needReset = true;
            lineRef.current.scale.z = maxScaleZ;
            depth = maxSize;
        }
        if (needReset) {
            transformRef.current.detach();
            transformRef.current.attach(lineRef.current);
        }
        return {
            center: lineRef.current.getWorldPosition(new Vector3()).toArray(),
            rotation: new Matrix3().setFromMatrix4(new Matrix4().extractRotation(lineRef.current.matrixWorld)).toArray(),
            extent: [width, height, depth],
        };
    }, [minSize, maxSize, cuboidInfo]);
    /**
     * Report the box's live value while the gizmo transforms it.
     */
    const updateCuboid = useCallback(() => {
        onChange?.(generateCuboid());
    }, [onChange, generateCuboid]);
    /**
     * Derive the box geometry once when the 4 anchors arrive (identity-guarded, like the Editor —
     * gizmo transforms move the rendered group, never the anchors).
     */
    useEffect(() => {
        if (anchors?.length !== CUBOID_REQUIRED_ANCHORS) {
            prevAnchorsRef.current = undefined;
            return;
        }
        // if cuboid has been initialized, no need to recalculate
        if (prevAnchorsRef.current) {
            return;
        }
        prevAnchorsRef.current = anchors;
        const info = getCuboidFromPoints(anchors, minSize);
        onChange?.({
            center: info.position.toArray(),
            rotation: new Matrix3().setFromMatrix4(new Matrix4().extractRotation(info.rotationMatrix)).toArray(),
            extent: [info.width, info.height, info.depth],
        });
        setCuboidInfo(info);
    }, [minSize, anchors, onChange]);
    /**
     * Free a replaced derived geometry (one per box placement; the mounted one is auto-disposed by
     * R3F on unmount, and `dispose()` is safe to call twice).
     */
    useEffect(() => () => cuboidInfo?.edgesGeometry.dispose(), [cuboidInfo]);
    /**
     * Re-report the box whenever the derived geometry (or a clamp bound) changes.
     */
    useEffect(() => {
        // if cuboid has not been initialized, no need to recalculate
        if (!cuboidInfo) {
            return;
        }
        updateCuboid();
    }, [minSize, cuboidInfo, updateCuboid]);
    useFrame(() => {
        if (lineRef.current && transformRef.current && anchors) {
            transformRef.current.visible = true;
            lineRef.current.visible = true;
            transformRef.current.attach(lineRef.current);
        }
        // reset the values when cuboid destroyed
        if (lineRef.current && transformRef.current && !anchors) {
            transformRef.current.visible = false;
            transformRef.current.position.set(0, 0, 0);
            transformRef.current.setRotationFromMatrix(new Matrix4());
            transformRef.current.clear();
            lineRef.current.visible = false;
            lineRef.current.position.set(0, 0, 0);
            lineRef.current.scale.set(1, 1, 1);
        }
    });
    if (anchors?.length !== CUBOID_REQUIRED_ANCHORS || !cuboidInfo) {
        return null;
    }
    return (jsxs(Fragment, { children: [jsx(TransformControls, { ref: transformRef, size: isMobile ? 1 : 0.5, onObjectChange: updateCuboid, mode: mode, onMouseUp: () => {
                    onChanged?.(generateCuboid());
                }, space: "local" }), jsx("group", { ref: groupRef, position: cuboidInfo.position, quaternion: cuboidInfo.quaternion, children: jsx("group", { ref: lineRef, children: jsx("lineSegments", { geometry: cuboidInfo.edgesGeometry, children: jsx("lineBasicMaterial", { color: color }) }) }) })] }));
};

/**
 * Dashed guide line through the given points; with 3 points the parallelogram's missing 4th vertex
 * is filled in and the loop closed, previewing the cuboid's base face. Ported from the Editor's
 * `AnchorFrames` `Frame` (minus its label/tooltip, which the mask flow never used).
 */
const GuideFrame = ({ points, color }) => {
    const ref = useRef(null);
    const framePoints = [...points];
    if (framePoints.length === 3) {
        framePoints.push(findMissingVertexParallelogram(framePoints));
        framePoints.push(framePoints[0].clone());
    }
    useFrame(() => {
        if (ref.current) {
            ref.current.geometry.setFromPoints(framePoints);
            ref.current.computeLineDistances();
        }
    });
    return (
    // R3F's `line` ref type clashes with three's `Line`; the Editor casts the same way.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    jsxs("line", { ref: ref, children: [jsx("bufferGeometry", {}), jsx("lineDashedMaterial", { transparent: true, depthTest: false, depthWrite: false, color: color, dashSize: 0.005, gapSize: 0.005 })] }));
};
/**
 * Dashed box preview once all 4 anchor points exist (3 placed + the cursor as the prospective
 * depth anchor). Ported from the Editor's passive `AnchorFrames` `CuboidFrame`.
 */
const BoxFrame = ({ points, color }) => {
    const ref = useRef(null);
    const { position, quaternion, edgesGeometry } = useMemo(() => {
        const fixedPoints = [...fixVertexOnNormal([points[0], points[1], points[2]]), points[3]];
        return getCuboidFromPoints(fixedPoints, CUBOID_MIN_SIZE);
    }, [points]);
    /**
     * Free the derived geometry when it's replaced (a new one is derived per cursor move — without
     * this each intermediate `EdgesGeometry` would leak until page unload) or the frame unmounts.
     */
    useEffect(() => () => edgesGeometry.dispose(), [edgesGeometry]);
    useFrame(() => {
        if (ref.current) {
            ref.current.computeLineDistances();
        }
    });
    return (jsx("lineSegments", { ref: ref, quaternion: quaternion, position: position, geometry: edgesGeometry, children: jsx("lineDashedMaterial", { depthTest: false, depthWrite: false, color: color, dashSize: 0.005, gapSize: 0.005 }) }));
};
/**
 * In-placement preview for the cuboid drawing tool: a dashed guide through the placed anchors +
 * cursor (the base face, parallelogram-filled at 3 points), becoming a dashed box once the cursor
 * supplies the prospective 4th (depth) anchor. Ported from the Editor's `CuboidAnchorFrames`, with
 * the cursor passed in as a prop instead of read from a store.
 */
const CuboidPlacementFrame = ({ placedVertices, cursorVertex, color = 'white', }) => {
    const points = cursorVertex ? [...placedVertices, cursorVertex] : [...placedVertices];
    if (!points.length) {
        return null;
    }
    return (jsxs("group", { renderOrder: 1, children: [points.length <= 3 && jsx(GuideFrame, { points: fixVertexOnNormal(points), color: color }), points.length === CUBOID_REQUIRED_ANCHORS && jsx(BoxFrame, { points: points, color: color })] }));
};

/**
 * Passive wireframe of an already-defined cuboid (center / rotation / extent) — e.g. a saved
 * region shown as a frame while a consumer's tool is active. Display only: no gizmo, no events.
 */
const CuboidRegionFrame = ({ cuboid, color = 'white', }) => {
    const { position, quaternion, edgesGeometry } = useMemo(() => {
        const rotation = new Matrix4().setFromMatrix3(new Matrix3().fromArray(cuboid.rotation));
        return {
            position: new Vector3(...cuboid.center),
            quaternion: new Quaternion().setFromRotationMatrix(rotation),
            edgesGeometry: new EdgesGeometry(new BoxGeometry(...cuboid.extent)),
        };
    }, [cuboid]);
    /**
     * Free the derived geometry when it's replaced or the frame unmounts.
     */
    useEffect(() => () => edgesGeometry.dispose(), [edgesGeometry]);
    return (jsx("lineSegments", { position: position, quaternion: quaternion, geometry: edgesGeometry, children: jsx("lineBasicMaterial", { color: color }) }));
};

/**
 * Scale multiplier for the text labels the canvas draws on shapes, provided by `ThreeCanvas` from
 * its `labelSize` prop. `1` is the baseline size, and the default outside a canvas.
 *
 * Deliberately its own context rather than a field on `ThreeCanvasContext`: the labels are drei
 * `Html` (the 3D view's known render cost) and this value only changes when the user moves the
 * control, whereas the canvas context churns on every pointer-move of an anchor drag. Kept separate,
 * a label only re-renders for the knob itself. The provider lives inside the R3F tree, so — unlike
 * the canvas context — it needs no `useContextBridge`.
 */
const LabelSizeContext = createContext(1);
const useLabelSize = () => useContext(LabelSizeContext);

const PI_4 = Math.PI / 4;
const PI_3_4 = (3 * Math.PI) / 4;
/**
 * Label for warnings, complete with Tooltip!
 */
const Label = (props) => {
    const { point, label, labelPrefix = '⚠️ ', message, offset = [0, 0], styles: styleOps, backgroundColor = 'yellow', color = 'black', opacity, padding = ['8px', '2px'], visible = true, isAdjustingColors, autoAdjustAwayFromAngle, onEnter, onLeave, onDown, onUp, onClick, } = props;
    // Context — the canvas's label-scale knob (`labelSize` prop), 1 outside a ThreeCanvas.
    const labelSize = useLabelSize();
    // Store
    const currentLabelBackgroundColor = '#ffffff'; // useToolUtilSelector((state) => state.currentLabelBackgroundColor)
    const currentLabelTextColor = '#000000'; // useToolUtilSelector((state) => state.currentLabelTextColor)
    // States
    const [translateX, setTranslateX] = useState(() => `calc(-50% + ${offset[0]}px)`);
    const [translateY, setTranslateY] = useState(() => `calc(-50% + ${offset[1]}px)`);
    const [arrowClass, setArrowClass] = useState('');
    // Refs
    const containerRef = useRef(null);
    // Vars
    const isInteractive = !!(onEnter || onLeave || onDown || onUp || onClick);
    const canBeSeen = visible && (opacity === undefined || opacity > 0 || (typeof styleOps?.opacity === 'number' && styleOps.opacity > 0));
    /**
     * Combine styles with defaults.
     * Deprecated props (outlineColor, outlineWidth, fontSize, padding) are merged into styles for backward compatibility.
     */
    const styles = useMemo(() => ({
        ...{
            backgroundColor,
            color,
            padding,
            opacity,
            fontWeight: 'bold',
            whiteSpace: 'nowrap',
            borderRadius: 4,
        },
        ...styleOps,
        // Handle real-time color adjustments
        ...(isAdjustingColors
            ? {
                color: currentLabelTextColor,
                backgroundColor: currentLabelBackgroundColor,
            }
            : {}),
    }), [
        backgroundColor,
        color,
        padding,
        opacity,
        styleOps,
        isAdjustingColors,
        currentLabelBackgroundColor,
        currentLabelTextColor,
    ]);
    /**
     * Calculate padding for Box component based on styles.padding prop.
     */
    const boxPadding = useMemo(() => {
        let pad = {
            padding: '2px 4px',
        };
        if (typeof styles.padding === 'number') {
            pad = { padding: styles.padding };
        }
        else if (Array.isArray(styles.padding) && styles.padding.length === 2) {
            pad = { paddingInline: styles.padding[0], paddingBlock: styles.padding[1] };
        }
        else if (Array.isArray(styles.padding) && styles.padding.length === 4) {
            pad = {
                paddingTop: styles.padding[0],
                paddingRight: styles.padding[1],
                paddingBottom: styles.padding[2],
                paddingLeft: styles.padding[3],
            };
        }
        return pad;
    }, [styles.padding]);
    /**
     * Update translate styles on offset change.
     */
    useEffect(() => {
        let x = '-50%';
        let y = '-50%';
        // padding for angle adjustment
        let px = 0;
        let py = 0;
        if (autoAdjustAwayFromAngle !== undefined) {
            if (autoAdjustAwayFromAngle >= -PI_4 && autoAdjustAwayFromAngle < PI_4) {
                // Right
                x = '-100%';
                px = -10;
                setArrowClass('label-arrow-right');
            }
            else if (autoAdjustAwayFromAngle >= PI_4 && autoAdjustAwayFromAngle < PI_3_4) {
                // Top
                y = '-0%';
                py = 10;
                setArrowClass('label-arrow-top');
            }
            else if (autoAdjustAwayFromAngle >= PI_3_4 || autoAdjustAwayFromAngle < -PI_3_4) {
                // Left
                x = '0%';
                px = 10;
                setArrowClass('label-arrow-left');
            }
            else {
                // Bottom
                y = '-100%';
                py = -10;
                setArrowClass('label-arrow-bottom');
            }
        }
        else {
            setArrowClass('');
        }
        setTranslateX(`calc(${x} + ${offset[0] + px}px)`);
        setTranslateY(`calc(${y} + ${offset[1] + py}px)`);
    }, [offset, autoAdjustAwayFromAngle]);
    if (message !== undefined) {
        return (jsx("group", { children: jsx(Html, { ref: containerRef, position: point, zIndexRange: [5, 10], style: {
                    transform: `translateX(${translateX}) translateY(${translateY})`,
                    top: `${autoAdjustAwayFromAngle}px`,
                    pointerEvents: isInteractive ? 'auto' : 'none',
                    transition: 'transform 0.2s ease-out',
                    '--label-background-color': styles.backgroundColor,
                }, className: canBeSeen ? arrowClass : '', children: jsx(StylesProvider, { children: jsx(Tooltip, { showArrow: true, positioning: { placement: 'top' }, label: message, contentProps: { className: 'canvas-tooltip', p: '8px', fontWeight: 'normal' }, children: jsxs(Box, { display: canBeSeen ? 'block' : 'none', fontSize: `${80 * labelSize}%`, onMouseEnter: onEnter, onMouseLeave: onLeave, onMouseDown: onDown, onMouseUp: onUp, onClick: onClick, css: omit(styles, 'padding'), ...boxPadding, children: [labelPrefix, label] }) }) }) }) }));
    }
    return (jsx(Html, { ref: containerRef, position: point, zIndexRange: [5, 10], children: jsxs("div", { onMouseEnter: onEnter, onMouseLeave: onLeave, onMouseDown: onDown, onMouseUp: onUp, onClick: onClick, style: {
                display: canBeSeen ? 'block' : 'none',
                fontSize: `${80 * labelSize}%`,
                ...omit(styles, 'padding'),
                ...boxPadding,
            }, children: [labelPrefix, label] }) }));
};

const Anchor = (props) => {
    const { parentId, id, point, visible = true, opacity, color, outlineColor, icon, iconColor, outlineOpacity, iconScale, scale, hoverScale, anchorIndex, showOnHover, isInteractable, isDraggable = true, isNoAction, isParentHoverSelected, isHighlighted, vertexSubtool = SubtoolVertex.None, availableVertexSubtools = [], onEnter, onLeave, onDown, onUp, onUpdate, onUpdated, onComplete, } = props;
    // Context — live drag position fed by the canvas while this anchor is being dragged.
    const { currentAnchorPosition, setCurrentAnchorPosition, setEditingAnchor, setCursor } = useThreeCanvasContext();
    // The active sub-mode + offered sub-modes are injected by the parent `<Polyline>` (Layer 2/3 owns them).
    const currentVertexSubtool = vertexSubtool;
    // States
    const [isHovered, setIsHovered] = useState(false);
    // Refs
    const isEditing = useRef(false);
    /**
     * Get opacity based on visibility and hover state.
     *
     * @param value - The base opacity value.
     * @returns The calculated opacity.
     */
    const getOpacity = useCallback((value) => {
        if (showOnHover && !isParentHoverSelected && !isHovered)
            return 0;
        if (isHovered || isHighlighted)
            return 1;
        return visible || isParentHoverSelected ? value : 0;
    }, [visible, isParentHoverSelected, showOnHover, isHovered, isHighlighted]);
    /**
     * Set styles based on current vertex subtoolbar.
     * In terms of priority where former will be overridden by latter:
     * - default styles
     * - subtool base styles
     * - state-based subtool styles (e.g. no action, highlighted, etc)
     * - specific props
     * - opacity state
     */
    const newAnchorProps = useMemo(() => {
        const priorityStyles = {
            color,
            outlineColor,
            icon,
            iconColor,
            outlineOpacity: getOpacity(outlineOpacity),
            iconScale,
            scale,
            hoverScale,
        };
        if (!availableVertexSubtools.length || currentVertexSubtool === SubtoolVertex.None || !isInteractable) {
            return priorityStyles;
        }
        // Apply subtool styles
        const subtoolStyles = {
            ...(VertexSubtoolStyles[currentVertexSubtool]
                ? VertexSubtoolStyles[currentVertexSubtool]?.[AnchorStates.Base]
                : {}),
            ...(isHighlighted ? VertexSubtoolStyles[currentVertexSubtool]?.[AnchorStates.Highlighted] : {}),
        };
        // If no action is possible, use no action styles
        const actionStyles = isNoAction ? NoActionStyles : subtoolStyles;
        // Merge all styles together
        const merged = merge({}, DefaultStyles, actionStyles, priorityStyles);
        return merged;
    }, [
        color,
        outlineColor,
        icon,
        iconColor,
        outlineOpacity,
        iconScale,
        scale,
        hoverScale,
        currentVertexSubtool,
        availableVertexSubtools.length,
        isInteractable,
        isNoAction,
        isHighlighted,
        getOpacity,
    ]);
    /**
     * Handle mouse enter event on the anchor.
     *
     * @param ev - The mouse event.
     */
    const handleMouseEnter = (ev) => {
        ev.stopPropagation();
        // Declare the desired cursor — the consumer applies it to the canvas container. Keep
        // `grabbing` if we re-enter mid-drag; otherwise the affordance is `grab`.
        setCursor(isEditing.current ? CursorState.GRABBING : CursorState.GRAB);
        setIsHovered(true);
        onEnter?.(anchorIndex, ev);
    };
    /**
     * Handle mouse leave event on the anchor.
     *
     * @param ev - The mouse event.
     */
    const handleMouseLeave = (ev) => {
        ev.stopPropagation();
        // Don't drop the cursor while dragging — the pointer can leave the anchor mid-drag; the
        // window-up handler clears it on release.
        if (!isEditing.current)
            setCursor(CursorState.NONE);
        setIsHovered(false);
        onLeave?.(anchorIndex, ev);
    };
    /**
     * Handle mouse down event on the anchor.
     *
     * @param ev - The mouse event.
     */
    const handleMouseDown = (ev) => {
        ev.stopPropagation();
        onDown?.(anchorIndex, ev);
        if (!onUpdated || !isDraggable)
            return;
        // Begin drag: clear any stale position and flag this anchor as the active one so the
        // canvas feeds it positions and orbit controls suspend.
        setCurrentAnchorPosition(null);
        setEditingAnchor({ parentId, anchorIndex });
        isEditing.current = true;
        setCursor(CursorState.GRABBING);
    };
    /**
     * Handle mouse up event on the anchor.
     * @param ev - The mouse event.
     */
    const handleMouseUp = (ev) => {
        ev.stopPropagation();
        if (!onUpdated)
            return;
        onUp?.(anchorIndex, ev);
    };
    /**
     * When current anchor position changes, and is in editing mode, call onUpdate.
     */
    useEffect(() => {
        if (!currentAnchorPosition || !isEditing.current || !onUpdated)
            return;
        onUpdate?.(anchorIndex, currentAnchorPosition);
    }, [currentAnchorPosition, isEditing, anchorIndex, onUpdate, onUpdated]);
    /**
     * Handle mouse up event on window.
     * This is to capture events outside the anchor and canvas
     * if user's mouse goes out of bounds while dragging.
     */
    useEffect(() => {
        const handleUp = (ev) => {
            if (!isEditing.current)
                return;
            ev.stopPropagation();
            onComplete?.();
            isEditing.current = false;
            // End drag: release the active-anchor flag, clear the live position, and drop the cursor.
            setEditingAnchor(null);
            setCurrentAnchorPosition(null);
            setIsHovered(false);
            setCursor(CursorState.NONE);
        };
        window.addEventListener('mouseup', handleUp);
        window.addEventListener('touchend', handleUp);
        return () => {
            window.removeEventListener('mouseup', handleUp);
            window.removeEventListener('touchend', handleUp);
        };
    }, [id, parentId, isEditing, onComplete, setEditingAnchor, setCurrentAnchorPosition, setCursor]);
    return (jsx(CircleAnchorV2, { ...props, ...newAnchorProps, id: id, point: point, opacity: getOpacity(opacity), onEnter: onUpdated ? handleMouseEnter : undefined, onLeave: onUpdated ? handleMouseLeave : undefined, onUp: handleMouseUp, onDown: handleMouseDown, renderOrder: 999, touchAreaMultiplier: 2, visible: visible }));
};

const DEFAULT_POLYLINE_CONFIG = {
    label: {
        visible: false,
        styles: {
            color: '#000',
            backgroundColor: '#88DF41',
            opacity: 1,
        },
    },
    line: { style: LineStyle.Solid, color: '#FFFFFF', thickness: 0.0025 },
    lineOutline: {
        visible: false,
        color: '#ffffff',
        style: LineStyle.Solid,
        thickness: 0.0025,
    },
};
const HOVERED_POLYLINE_CONFIG = {
    ...DEFAULT_POLYLINE_CONFIG,
    lineOutline: {
        ...DEFAULT_POLYLINE_CONFIG.lineOutline,
        visible: true,
        color: '#FFFF00',
    },
};
const SELECTED_POLYLINE_CONFIG = {
    ...DEFAULT_POLYLINE_CONFIG,
    lineOutline: {
        ...DEFAULT_POLYLINE_CONFIG.lineOutline,
        visible: true,
    },
};
const DEFAULT_LINE_MATERIAL = new LineMaterial({
    transparent: true,
    alphaToCoverage: true,
    worldUnits: true,
    depthTest: false,
    depthWrite: false,
    // default dash styles
    dashed: true,
    dashScale: 400,
    dashSize: 2,
    gapSize: 1.5,
});

// Ratio used to determine the gap size for dashed lines based on the line width.
// A value of 800 was chosen empirically to produce visually balanced dashed lines
// across a range of line widths in the blueprint editor.
const LINE_WIDTH_TO_GAP_RATIO = 800;
const DRAG_DETECTION_THRESHOLD = 10; // in pixels

const DEFAULT_PLANES_STYLES = {
    guideLine: {
        visible: false,
        style: LineStyle.Solid,
        color: 'yellow',
        thickness: 0.0075,
        renderOrder: 999,
    }};
const HOVERED_PLANE_STYLES = {
    guideLine: {
        ...DEFAULT_PLANES_STYLES.guideLine,
        color: '#FFFF00',
        visible: true,
    }};
const SELECTED_PLANE_STYLES = {
    guideLine: {
        ...HOVERED_PLANE_STYLES.guideLine,
        color: 'white',
    }};

const Outline = (props) => {
    const { id, positions, isWorking, isEditing, renderOrder, selected, config } = props;
    const { guideLineConfig } = config;
    // Hooks
    const { camera } = useThree();
    // Store
    const currentStrokeColor = '#ff0000'; // useSelector((state: RootState) => state.toolUtil.core.currentStrokeColor)
    // Center point of the polygon for line width scaling
    const center = useMemo(() => findCenter(positions.map((p) => new Vector3(...p))), [positions]);
    const [outline] = useState(() => {
        const geometry = new LineGeometry();
        geometry.setPositions([...positions, positions[0]].flatMap((p) => p));
        const outlineMat = DEFAULT_LINE_MATERIAL.clone();
        outlineMat.dashed = guideLineConfig?.style === LineStyle.Dashed;
        outlineMat.color.set(guideLineConfig?.color || DEFAULT_PLANES_STYLES.guideLine?.color || 'black'); // Use white when set as transparent since 'transparent' is not a valid color
        outlineMat.linewidth = guideLineConfig?.thickness || 0;
        outlineMat.dashSize = outlineMat.linewidth * LINE_WIDTH_TO_GAP_RATIO;
        outlineMat.gapSize = outlineMat.linewidth * LINE_WIDTH_TO_GAP_RATIO;
        const outlineLn = new Line2(geometry, outlineMat);
        if (renderOrder)
            outlineLn.renderOrder = renderOrder;
        outlineLn.computeLineDistances();
        return outlineLn;
    });
    /**
     * Update mesh and outline on points change
     */
    useEffect(() => {
        if (!outline || positions.length < 2)
            return;
        const pts = [...positions, positions[0]];
        const geometry = new LineGeometry();
        geometry.setPositions(pts.map((p) => p).flat());
        outline.geometry.dispose();
        outline.geometry = geometry;
        outline.computeLineDistances();
    }, [positions, outline, isWorking, isEditing]);
    /**
     * Update the material color when the current stroke color changes.
     * This is used for real-time updates of the stroke color while the user is selecting it to
     * avoid unnecessary re-renders.
     *
     * The color set here _should not_ be the final color. It still must come from the line config prop.
     */
    useEffect(() => {
        if (!outline || !(outline.material instanceof LineMaterial) || !guideLineConfig || (!selected && !isWorking))
            return;
        outline.material.color.set(currentStrokeColor);
    }, [outline, guideLineConfig, currentStrokeColor, selected, isWorking, id]);
    useEffect(() => {
        if (!outline || !(outline.material instanceof LineMaterial) || !guideLineConfig)
            return;
        outline.material.linewidth = guideLineConfig.thickness || 0;
        outline.material.dashed = guideLineConfig.style === LineStyle.Dashed;
        outline.material.color.set(guideLineConfig.color || DEFAULT_PLANES_STYLES.guideLine?.color || 'black');
        outline.material.dashSize = outline.material.linewidth * LINE_WIDTH_TO_GAP_RATIO;
        outline.material.gapSize = outline.material.linewidth * LINE_WIDTH_TO_GAP_RATIO;
    }, [outline, guideLineConfig, id]);
    /**
     *  To keep the line thickness constant when zooming in/out.
     */
    useFrame(() => {
        if (camera instanceof PerspectiveCamera && center) {
            // distance from the camera to the anchor point
            const cameraToAnchor = center.clone().sub(camera.position.clone());
            // angle between the camera's forward vector and the vector from the camera to the anchor point
            const angle = cameraToAnchor.angleTo(new Vector3(0, 0, -1).applyQuaternion(camera.quaternion.clone()));
            // center position of viewing plane calculated from the camera's position and the distance to the anchor point
            const centerOfTheAnchorViewingPlane = camera.position
                .clone()
                .sub(new Vector3(0, 0, cameraToAnchor.length() * Math.cos(angle)).applyQuaternion(camera.quaternion.clone()));
            const scaleFactor = clamp$1(camera.position.distanceTo(centerOfTheAnchorViewingPlane) * 6, 1, 10) / 10;
            // gradually increase line width by scaleFactor, thinner line at low scaleFactor, thicker line at high scaleFactor
            if (outline && guideLineConfig) {
                const lineWidth = (guideLineConfig.thickness || 0.001) + scaleFactor ** 2 * 0.005;
                outline.material.linewidth = lineWidth;
                outline.material.dashSize = outline.material.linewidth * LINE_WIDTH_TO_GAP_RATIO;
                outline.material.gapSize = outline.material.linewidth * LINE_WIDTH_TO_GAP_RATIO;
            }
        }
    });
    return (jsx("group", { children: jsx("primitive", { object: outline, renderOrder: guideLineConfig?.renderOrder, visible: (guideLineConfig?.visible ?? true) && positions.length >= 2 }) }));
};

const useConfigs$1 = ({ id, label, guideLine, guideLabel, selected, }) => {
    // States
    const [hovered, setHovered] = useState(false);
    // Label Configs
    const labelConfig = useMemo(() => label
        ? merge({}, {
            color: 'black',
            backgroundColor: 'yellow',
        }, label)
        : undefined, [label]);
    // Guide Configs
    // For as long as any of guideLabel, guideLine, or guideOutline is defined, guides will be shown.
    const guideLineConfig = useMemo(() => {
        if (hovered)
            return merge({}, HOVERED_PLANE_STYLES.guideLine, guideLine);
        if (selected)
            return merge({}, SELECTED_PLANE_STYLES.guideLine, guideLine);
        if (guideLine)
            return merge({}, DEFAULT_PLANES_STYLES.guideLine, guideLine);
        return DEFAULT_PLANES_STYLES.guideLine;
    }, [guideLine, selected, hovered]);
    const guideLabelConfig = useMemo(() => guideLabel
        ? merge({}, {
            color: '#000',
            backgroundColor: '#fff',
        }, guideLabel)
        : undefined, [guideLabel]);
    return {
        hovered,
        setHovered,
        isHoverSelected: (hovered || selected) ?? false,
        labelConfig,
        guideLineConfig,
        guideLabelConfig,
    };
};

const useEventHandlers$1 = ({ id, polygon: shape, vertexAnchors, movable, selectable, onSelect, onHover }, { setHovered }) => {
    // const isEditorPage = matches.some((row) => row.id === 'project-editor')
    // const isBlueprintPage = matches.some((row) => row.id === 'project-blueprint-editor')
    // An anchor being dragged anywhere in the scene is the global "editing" signal — while it's set,
    // hover is suppressed on every object (mirrors the Editor's `editingElementId` gate) so other
    // shapes don't light up as the dragging cursor passes over them.
    const { editingAnchor } = useThreeCanvasContext();
    // Refs
    const isMouseInsideRef = useRef(false);
    const isDraggingRef = useRef(false);
    const dragStartPosRef = useRef(null);
    const currentPositionsRef = useRef(null);
    const movingStartLocalPointRef = useRef(null);
    useRef(new Vector2());
    /**
     * Handle mouse enter event on the polygon plane mesh.
     *
     * @param ev - The mouse event.
     */
    const handleMouseEnter = useCallback((ev) => {
        // don't allow hovering while any anchor is being dragged
        if (editingAnchor)
            return;
        isMouseInsideRef.current = true;
        ev.stopPropagation();
        if (selectable)
            setHovered(true);
        onHover?.(true);
        // if (movable) dispatch(setCursor(CursorState.MOVE))
        // else if (selectable) dispatch(setCursor(CursorState.POINTER))
        // if (selectable) dispatch(setHoveredElementId(id))
    }, [editingAnchor, selectable, setHovered, onHover]);
    /**
     * Handle mouse leave event on the polygon plane mesh.
     *
     * @param ev - The mouse event.
     */
    const handleMouseLeave = useCallback((ev) => {
        ev.stopPropagation();
        isMouseInsideRef.current = false;
        setHovered(false);
        onHover?.(false);
        // if (movable && !isDraggingRef.current) dispatch(setCursor(CursorState.DEFAULT))
        // else if (selectable) dispatch(setCursor(CursorState.DEFAULT))
        // if (selectable) dispatch(setHoveredElementId(''))
    }, [setHovered, onHover]);
    /**
     * Handle mouse down event on the polygon plane mesh.
     *
     * @param ev - The mouse event.
     */
    const handleMouseDown = useCallback((ev) => {
        ev.stopPropagation();
        movingStartLocalPointRef.current = new Vector2(ev.clientX, ev.clientY);
    }, []);
    const doSelection = useCallback(() => {
        onSelect?.();
        // if (!isEditorPage) {
        //   dispatch(setSelectedElementIds([id]))
        //   return
        // }
        // try {
        //   validateSelectedShape(shape, ShapeKeyType.POLYGON, getVolumeEstimationItems(inspectionItems), currentEditorTool)
        // } catch (e) {
        //   if (!toaster.isVisible(TOAST_ID)) {
        //     toaster.create({
        //       ...TOAST_CONFIG,
        //       id: TOAST_ID,
        //       type: 'error',
        //       title: e instanceof Error ? e.message : 'エラー',
        //     })
        //   }
        //   return
        // }
        // let newShapeIds = [...selectedElementIds]
        // // If only 1 volume can be selected, deselect all other volumes
        // if (currentEditorTool && currentEditorTool.config?.volume?.onlyOneSelectable) {
        //   newShapeIds = newShapeIds
        //     .filter((i) => !shapes.polygons.find((poly) => poly.shape_id === i))
        //     .filter((i) => !shapes.cylinders.find((cylinder) => cylinder.shape_id === i))
        // }
        // const idIndex = newShapeIds.indexOf(shape.shape_id)
        // if (idIndex >= 0) {
        //   newShapeIds.splice(idIndex, 1)
        // } else {
        //   newShapeIds.push(shape.shape_id)
        // }
        // changeSelectedShapeIds(newShapeIds)
    }, [
        onSelect,
        // isEditorPage,
        // id,
        // shape,
        // selectedElementIds,
        // shapes,
        // inspectionItems,
        // currentEditorTool,
        // dispatch,
        // changeSelectedShapeIds,
    ]);
    /**
     * Handle click event on the polygon plane mesh.
     *
     * @param ev - The mouse event.
     */
    const handleClick = useCallback((ev) => {
        if (isDraggingRef.current)
            return;
        ev.stopPropagation();
        doSelection();
    }, [doSelection]);
    /**
     * Handle mouse up event on the polygon plane mesh.
     * This is registered on window to capture events outside the polygon and canvas
     * if user's mouse goes out of bounds while dragging.
     */
    useEffect(() => {
        // const handleMouseUp = (ev: MouseEvent) => {
        //   movingStartLocalPointRef.current = null
        //   if (!isDraggingRef.current) return
        //   ev.stopPropagation()
        //   if (currentPositionsRef.current) vertexAnchors?.onUpdated?.(currentPositionsRef.current)
        //   dispatch(setEditingElementId(undefined))
        //   if (!isMouseInsideRef.current) dispatch(setCursor(CursorState.DEFAULT))
        //   if (isBlueprintPage) doSelection()
        //   isDraggingRef.current = false
        //   dragStartPosRef.current = null
        //   currentPositionsRef.current = null
        // }
        // const handleMouseMove = (ev: MouseEvent) => {
        //   if (movingStartLocalPointRef.current) {
        //     const distance = movingStartLocalPointRef.current.distanceTo(tempV2Ref.current.set(ev.clientX, ev.clientY))
        //     if (distance > EDITOR_DRAG_DETECTION_THRESHOLD && !isDraggingRef.current) {
        //       isDraggingRef.current = true
        //       dispatch(setEditingElementId(id))
        //       dispatch(setHoveredElementId(''))
        //     }
        //   }
        // }
        // window.addEventListener('mouseup', handleMouseUp)
        // window.addEventListener('mousemove', handleMouseMove)
        // return () => {
        //   window.removeEventListener('mouseup', handleMouseUp)
        //   window.removeEventListener('mousemove', handleMouseMove)
        // }
    }, [
    // dispatch, doSelection, isBlueprintPage, vertexAnchors, id
    ]);
    return {
        dragStartPosRef,
        currentPositionsRef,
        isDraggingRef,
        handleMouseEnter,
        handleMouseLeave,
        handleMouseDown,
        handleClick,
    };
};

class TinyQueue {
    constructor(data = [], compare = (a, b) => (a < b ? -1 : a > b ? 1 : 0)) {
        this.data = data;
        this.length = this.data.length;
        this.compare = compare;

        if (this.length > 0) {
            for (let i = (this.length >> 1) - 1; i >= 0; i--) this._down(i);
        }
    }

    push(item) {
        this.data.push(item);
        this._up(this.length++);
    }

    pop() {
        if (this.length === 0) return undefined;

        const top = this.data[0];
        const bottom = this.data.pop();

        if (--this.length > 0) {
            this.data[0] = bottom;
            this._down(0);
        }

        return top;
    }

    peek() {
        return this.data[0];
    }

    _up(pos) {
        const {data, compare} = this;
        const item = data[pos];

        while (pos > 0) {
            const parent = (pos - 1) >> 1;
            const current = data[parent];
            if (compare(item, current) >= 0) break;
            data[pos] = current;
            pos = parent;
        }

        data[pos] = item;
    }

    _down(pos) {
        const {data, compare} = this;
        const halfLength = this.length >> 1;
        const item = data[pos];

        while (pos < halfLength) {
            let bestChild = (pos << 1) + 1; // initially it is the left child
            const right = bestChild + 1;

            if (right < this.length && compare(data[right], data[bestChild]) < 0) {
                bestChild = right;
            }
            if (compare(data[bestChild], item) >= 0) break;

            data[pos] = data[bestChild];
            pos = bestChild;
        }

        data[pos] = item;
    }
}

function polylabel(polygon, precision = 1.0, debug = false) {
    // find the bounding box of the outer ring
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;

    for (const [x, y] of polygon[0]) {
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
    }

    const width = maxX - minX;
    const height = maxY - minY;
    const cellSize = Math.max(precision, Math.min(width, height));

    if (cellSize === precision) {
        const result = [minX, minY];
        result.distance = 0;
        return result;
    }

    // a priority queue of cells in order of their "potential" (max distance to polygon)
    const cellQueue = new TinyQueue([], (a, b) => b.max - a.max);

    // take centroid as the first best guess
    let bestCell = getCentroidCell(polygon);

    // second guess: bounding box centroid
    const bboxCell = new Cell(minX + width / 2, minY + height / 2, 0, polygon);
    if (bboxCell.d > bestCell.d) bestCell = bboxCell;

    let numProbes = 2;

    function potentiallyQueue(x, y, h) {
        const cell = new Cell(x, y, h, polygon);
        numProbes++;
        if (cell.max > bestCell.d + precision) cellQueue.push(cell);

        // update the best cell if we found a better one
        if (cell.d > bestCell.d) {
            bestCell = cell;
            if (debug) console.log(`found best ${Math.round(1e4 * cell.d) / 1e4} after ${numProbes} probes`);
        }
    }

    // cover polygon with initial cells
    let h = cellSize / 2;
    for (let x = minX; x < maxX; x += cellSize) {
        for (let y = minY; y < maxY; y += cellSize) {
            potentiallyQueue(x + h, y + h, h);
        }
    }

    while (cellQueue.length) {
        // pick the most promising cell from the queue
        const {max, x, y, h: ch} = cellQueue.pop();

        // do not drill down further if there's no chance of a better solution
        if (max - bestCell.d <= precision) break;

        // split the cell into four cells
        h = ch / 2;
        potentiallyQueue(x - h, y - h, h);
        potentiallyQueue(x + h, y - h, h);
        potentiallyQueue(x - h, y + h, h);
        potentiallyQueue(x + h, y + h, h);
    }

    if (debug) {
        console.log(`num probes: ${numProbes}\nbest distance: ${bestCell.d}`);
    }

    const result = [bestCell.x, bestCell.y];
    result.distance = bestCell.d;
    return result;
}

function Cell(x, y, h, polygon) {
    this.x = x; // cell center x
    this.y = y; // cell center y
    this.h = h; // half the cell size
    this.d = pointToPolygonDist(x, y, polygon); // distance from cell center to polygon
    this.max = this.d + this.h * Math.SQRT2; // max distance to polygon within a cell
}

// signed distance from point to polygon outline (negative if point is outside)
function pointToPolygonDist(x, y, polygon) {
    let inside = false;
    let minDistSq = Infinity;

    for (const ring of polygon) {
        for (let i = 0, len = ring.length, j = len - 1; i < len; j = i++) {
            const a = ring[i];
            const b = ring[j];

            if ((a[1] > y !== b[1] > y) &&
                (x < (b[0] - a[0]) * (y - a[1]) / (b[1] - a[1]) + a[0])) inside = !inside;

            minDistSq = Math.min(minDistSq, getSegDistSq(x, y, a, b));
        }
    }

    return minDistSq === 0 ? 0 : (inside ? 1 : -1) * Math.sqrt(minDistSq);
}

// get polygon centroid
function getCentroidCell(polygon) {
    let area = 0;
    let x = 0;
    let y = 0;
    const points = polygon[0];

    for (let i = 0, len = points.length, j = len - 1; i < len; j = i++) {
        const a = points[i];
        const b = points[j];
        const f = a[0] * b[1] - b[0] * a[1];
        x += (a[0] + b[0]) * f;
        y += (a[1] + b[1]) * f;
        area += f * 3;
    }
    const centroid = new Cell(x / area, y / area, 0, polygon);
    if (area === 0 || centroid.d < 0) return new Cell(points[0][0], points[0][1], 0, polygon);
    return centroid;
}

// get squared distance from a point to a segment
function getSegDistSq(px, py, a, b) {
    let x = a[0];
    let y = a[1];
    let dx = b[0] - x;
    let dy = b[1] - y;

    if (dx !== 0 || dy !== 0) {
        const t = ((px - x) * dx + (py - y) * dy) / (dx * dx + dy * dy);

        if (t > 1) {
            x = b[0];
            y = b[1];

        } else if (t > 0) {
            x += dx * t;
            y += dy * t;
        }
    }

    dx = px - x;
    dy = py - y;

    return dx * dx + dy * dy;
}

/**
 * Minimum allowed squared distance between two points.
 * Used to determine if two points are considered "distinct" in geometric operations.
 * Units: squared scene units (e.g., if positions are in meters, this is in m^2).
 * The value 0.001 was chosen to avoid floating-point precision issues and to ignore negligible differences.
 */
const MIN_DISTANCE_SQUARED = 0.001;
const useObjects$1 = (props, config, currentPositionsRef, dragStartPosRef, isDraggingRef) => {
    const { id, polygon, workingVertices, workingCursor, offsetTransformation, transformControls, isOpenLoop, isEditing, isWorking, isAdjustingColors = false, visible = true, opacity = 0.7, disableEditingRef, onUpdate, getPoints, } = props;
    const { guideLabelConfig, labelConfig } = config;
    /**
     * Resolve the polygon the mesh works against. When no domain `polygon` is supplied
     * (drawing preview / pre-domain shapes) build a minimal one from `workingVertices`,
     * so the rest of the hook reads a single shape regardless of source.
     */
    const resolvedPolygon = useMemo(() => {
        if (polygon)
            return polygon;
        const positions = workingVertices ?? [];
        const center = findCenter(positions.map((p) => new Vector3(...p)))?.toArray() ?? [0, 0, 0];
        return {
            shape_id: id,
            positions,
            vertices: [],
            center,
            transformation: new Matrix4().toArray(),
        };
    }, [polygon, workingVertices, id]);
    // Store
    // Live cursor candidate appended while drawing/editing; null when there is no cursor.
    const currentAnchorPosition = workingCursor ?? null;
    // TODO: To be replaced once color editing is implemented.
    const currentFillColor = '#ff0000'; // useToolUtilSelector((state) => state.currentFillColor)
    // States
    const [labelText, setLabelText] = useState('');
    // Refs
    const editingAnchorRef = useRef(null);
    const meshRef = useRef(null);
    /**
     * Setup offset matrix.
     * Use whatever is provided, or identity if none.
     */
    const offsetMatrix = useMemo(() => {
        if (offsetTransformation instanceof Matrix4)
            return offsetTransformation;
        return offsetTransformation ? new Matrix4().fromArray(offsetTransformation) : new Matrix4().identity();
    }, [offsetTransformation]);
    const polygonMatrixInverse = useMemo(() => resolvedPolygon.transformation && transformControls
        ? new Matrix4().fromArray(resolvedPolygon.transformation).invert()
        : new Matrix4().identity(), [resolvedPolygon.transformation, transformControls]);
    /**
     * Get position from offset matrix.
     */
    const { position: offsetPosition, quaternion: offsetQuaternion } = useMemo(() => {
        if (!offsetTransformation)
            return { position: new Vector3(), quaternion: new Quaternion(), matrix: new Matrix4() };
        const pos = new Vector3();
        const quat = new Quaternion();
        offsetMatrix.decompose(pos, quat, new Vector3());
        return {
            position: pos,
            quaternion: quat,
            matrix: offsetMatrix,
        };
    }, [offsetTransformation, offsetMatrix]);
    // Vars
    const isVisible = useMemo(() => visible && opacity > 0, [visible, opacity]);
    const planeCenter = useMemo(() => new Vector3(...resolvedPolygon.center), [resolvedPolygon.center]);
    /**
     * Use states for points for ID stability.
     */
    const [planePoints, setPlanePoints] = useState(() => resolvedPolygon.positions.map((p) => ({
        id: crypto.randomUUID(),
        point: new Vector3(...p),
    })));
    const planePointsArr = useMemo(() => planePoints.map((p) => p.point.toArray()), [planePoints]);
    /**
     * Calculate label position at the centroid of the polygon.
     * We're using polylabel to ensure the label is within the polygon
     * if the shape is concave.
     */
    const calculateLabelPosition = useCallback((positions) => {
        const posV3 = positions.map((v) => new Vector3(...v));
        // If the polygon is convex, we can use simple center calculation
        const { points: zAlignedPosV3 } = alignToZAxis(posV3);
        if (isConvexPolygon(zAlignedPosV3)) {
            const center = findCenter(posV3);
            return center || planeCenter;
        }
        const { points, inverseMatrix, offset } = alignToZAxis(posV3, true);
        const centered = polylabel([points.map((pos) => [pos.x, pos.y])], 0.001);
        return new Vector3(centered[0], centered[1], points[0].z).applyMatrix4(inverseMatrix).add(offset);
    }, [planeCenter]);
    const [labelPosition, setLabelPosition] = useState(() => calculateLabelPosition(resolvedPolygon.positions));
    // Update label position when polygon positions change
    useEffect(() => {
        setLabelPosition(calculateLabelPosition(resolvedPolygon.positions));
    }, [resolvedPolygon.positions, calculateLabelPosition]);
    /**
     * Generate plane vertices.
     */
    const planeVertices = useMemo(() => {
        // Non-working polygon use provided vertices as-is.
        if (!isWorking)
            return resolvedPolygon.vertices.map((v) => new Vector2(...v));
        // If working, we need to add the current anchor and recalculate the vertices.
        // Generate vertices once we actually have a triangle.
        const { points: verticesV3 } = alignToZAxis(planePoints.map((p) => p.point));
        return verticesV3.map((v) => new Vector2(...v));
    }, [resolvedPolygon.vertices, planePoints, isWorking]);
    /**
     * Generate plane points.
     */
    const getPlanePoints = useCallback((currentPos, anchorIndex) => {
        const pts = cloneDeep(resolvedPolygon.positions);
        // new polygon
        if (isWorking && currentPos) {
            if (getPoints) {
                return getPoints(currentPos, null);
            }
            // Need to do a bit of clean up for points that are too close to each other
            const lastPoint = pts[pts.length - 1];
            if (lastPoint) {
                const newPoint = currentPos;
                const distanceSquared = (lastPoint[0] - newPoint[0]) ** 2 + (lastPoint[1] - newPoint[1]) ** 2 + (lastPoint[2] - newPoint[2]) ** 2;
                // Points are too close; ignore the new point
                if (distanceSquared < MIN_DISTANCE_SQUARED) {
                    return pts;
                }
            }
            pts.push(currentPos);
        }
        // adjusting a single vertex
        if (anchorIndex !== null && currentPos) {
            pts[anchorIndex] = currentPos;
        }
        // dragging the entire polygon
        if (isEditing && anchorIndex === null) {
            if (getPoints) {
                return getPoints(currentPos, anchorIndex);
            }
            if (!dragStartPosRef.current) {
                dragStartPosRef.current = currentPos;
            }
            else {
                const dragOffset = [
                    currentPos[0] - dragStartPosRef.current[0],
                    currentPos[1] - dragStartPosRef.current[1],
                    currentPos[2] - dragStartPosRef.current[2],
                ];
                pts.forEach((p) => {
                    p[0] += dragOffset[0];
                    p[1] += dragOffset[1];
                    p[2] += dragOffset[2];
                });
            }
        }
        return pts;
    }, [resolvedPolygon.positions, isWorking, isEditing, dragStartPosRef, getPoints]);
    /**
     * Generate guide line labels.
     */
    const guideLabels = useMemo(() => {
        if (!guideLabelConfig || planePoints.length < 2)
            return [];
        // Calculate the positions and label for the labels on midpoints of the edges.
        const pts = planePoints.map((p) => p.point.toArray());
        const points = isOpenLoop ? pts : pts.slice(0, -1);
        let positions = points.map((point, index) => {
            const nextPoint = new Vector3(...points[(index + 1) % points.length]);
            return {
                point: new Vector3(...point).clone().add(nextPoint).multiplyScalar(0.5).toArray(),
                label: `${Math.round(meterToMillimeter(new Vector3(...point).distanceTo(nextPoint)))}mm`,
            };
        });
        // Hide the last label if hideLastLabel is true
        if (guideLabelConfig.hideLastLabel && positions.length > 0) {
            positions = positions.slice(0, -1);
        }
        return positions.map(({ point, label: lbl }, index) => ({
            ...guideLabelConfig,
            id: `${resolvedPolygon.shape_id}-label-${index}`,
            point,
            label: lbl,
            labelPrefix: '',
        }));
    }, [planePoints, guideLabelConfig, isOpenLoop, resolvedPolygon.shape_id]);
    /**
     * Create geometry in a state for optimization.
     * It'll be created once, and updated when the points change.
     */
    const [geometry] = useState(() => {
        const buffer = new BufferGeometry();
        const positions = new Float32Array(planePoints.length * 3);
        planePoints.forEach(({ point: vertex }, index) => {
            vertex.toArray(positions, index * 3);
        });
        const indi = ShapeUtils.triangulateShape(planeVertices, []);
        buffer.setAttribute('position', new BufferAttribute(positions, 3));
        buffer.setIndex(indi.flat());
        buffer.computeVertexNormals();
        return buffer;
    });
    /**
     * Update mesh function
     */
    const updateMesh = useCallback((points) => {
        // Set new positions
        const positions = new Float32Array(points.length * 3);
        points.forEach((point, index) => {
            positions.set(point, index * 3);
        });
        geometry.setAttribute('position', new BufferAttribute(positions, 3));
        // Generate z-aligned vertices since triangulation depends on the points to be on a plane.
        const alignedPoints = alignToZAxis(points.map((v) => new Vector3(...v)));
        const indi = ShapeUtils.triangulateShape(alignedPoints.points, []);
        geometry.setIndex(indi.flat());
        geometry.computeBoundingBox();
        geometry.computeBoundingSphere();
        meshRef.current?.updateMatrixWorld();
    }, [geometry]);
    /**
     * Update the geometry when the plane points change.
     */
    useEffect(() => {
        if (!planeCenter ||
            !currentAnchorPosition ||
            !isVisible ||
            (!isEditing && !isWorking) ||
            (isEditing && editingAnchorRef.current === null && isDraggingRef.current === false) ||
            disableEditingRef?.current)
            return;
        const point = new Vector3(...currentAnchorPosition);
        // If offsetTransformation is set, apply the transformation to currentPoint
        if (polygonMatrixInverse) {
            point.applyMatrix4(polygonMatrixInverse);
        }
        const points = getPlanePoints(point.toArray(), editingAnchorRef.current);
        currentPositionsRef.current = points;
        // -- Update mesh
        updateMesh(points);
        if (labelConfig)
            setLabelPosition(calculateLabelPosition(points));
        if (labelConfig?.generateLabel)
            setLabelText(labelConfig.generateLabel(points));
        // -- Update line / anchor
        setPlanePoints((prev) => points.map((p, i) => prev[i] ? { ...prev[i], point: new Vector3(...p) } : { id: crypto.randomUUID(), point: new Vector3(...p) }));
        // Callbacks
        onUpdate?.(points);
    }, [
        meshRef,
        disableEditingRef,
        planeCenter,
        currentAnchorPosition,
        geometry,
        isWorking,
        isEditing,
        isVisible,
        isDraggingRef,
        editingAnchorRef,
        currentPositionsRef,
        labelConfig,
        polygonMatrixInverse,
        calculateLabelPosition,
        updateMesh,
        getPlanePoints,
        onUpdate,
    ]);
    /**
     * Update plane points when polygon positions change.
     */
    useEffect(() => {
        updateMesh(resolvedPolygon.positions);
        setPlanePoints((prev) => resolvedPolygon.positions.map((p, i) => prev[i] ? { ...prev[i], point: new Vector3(...p) } : { id: crypto.randomUUID(), point: new Vector3(...p) }));
    }, [id, resolvedPolygon.positions, updateMesh]);
    /**
     * Update the mesh material color when the current fill color changes.
     * This is used for real-time updates of the fill color while the user is selecting it to
     * avoid unnecessary re-renders.
     *
     * The color set here _should not_ be the final color. It still must come from the `color` prop.
     */
    useEffect(() => {
        if (!meshRef.current ||
            !(meshRef.current.material instanceof MeshBasicMaterial) ||
            !currentFillColor ||
            !isAdjustingColors)
            return;
        meshRef.current.visible = currentFillColor !== 'transparent';
        meshRef.current.material.color.set(currentFillColor);
    }, [currentFillColor, id, isWorking, isAdjustingColors]);
    /**
     * Clean up geometry on unmount
     */
    useEffect(() => () => geometry && geometry.dispose(), [geometry]);
    return {
        offsetPosition,
        offsetQuaternion,
        planePoints,
        planePointsArr,
        geometry,
        guideLabels,
        labelPosition,
        labelText,
        meshRef,
        editingAnchorRef,
        isVisible,
    };
};

const PolygonPlaneMesh = (props) => {
    const { id, name, polygon, transparent = true, color, opacity = 0.7, label, selectable = false, depthTest = true, depthWrite = true, renderOrder, vertexAnchors, anchorProps, } = props;
    // -- Hooks
    const config = useConfigs$1(props);
    const { isHoverSelected, labelConfig, guideLabelConfig } = config;
    const { dragStartPosRef, currentPositionsRef, isDraggingRef, handleMouseEnter, handleMouseLeave, handleMouseDown, handleClick, } = useEventHandlers$1(props, config);
    const { offsetPosition, offsetQuaternion, planePoints, planePointsArr, geometry, guideLabels, labelPosition, labelText, meshRef, editingAnchorRef, isVisible, } = useObjects$1(props, config, currentPositionsRef, dragStartPosRef, isDraggingRef);
    return (jsxs("group", { visible: isVisible, position: offsetPosition, quaternion: offsetQuaternion, children: [jsx(Outline, { ...props, config: config, renderOrder: renderOrder ? renderOrder + 10 : undefined, positions: planePointsArr }), vertexAnchors && planePoints
                ? planePoints.map(({ id: anchorId, point }, anchorIndex) => (createElement(Anchor, { ...vertexAnchors, ...anchorProps, key: anchorId, id: anchorId, parentId: id, point: point.toArray(), anchorIndex: anchorIndex, visible: vertexAnchors.visible, depthTest: vertexAnchors.depthTest, depthWrite: vertexAnchors.depthWrite, isParentHoverSelected: isHoverSelected, renderOrder: renderOrder ? renderOrder + 20 : undefined, onDown: (anchorIdx, event) => {
                        if (editingAnchorRef.current === null) {
                            editingAnchorRef.current = anchorIdx;
                        }
                        vertexAnchors.onDown?.(anchorIdx, event);
                    }, onUpdate: (idx, pt) => {
                        const pts = currentPositionsRef.current?.slice() || planePoints.map(({ point: p }) => p.toArray());
                        pts[idx] = pt;
                        vertexAnchors.onUpdate?.(pts);
                    }, onComplete: () => {
                        if (currentPositionsRef.current) {
                            vertexAnchors.onUpdated?.(currentPositionsRef.current);
                        }
                        editingAnchorRef.current = null;
                        currentPositionsRef.current = null;
                    } })))
                : null, jsx("mesh", { ref: meshRef, onPointerOver: selectable && isVisible ? handleMouseEnter : undefined, onPointerOut: handleMouseLeave, onPointerDown: selectable && isVisible ? handleMouseDown : undefined, onClick: selectable && isVisible ? handleClick : undefined, geometry: geometry, visible: !color || color !== 'transparent', renderOrder: renderOrder, name: name ?? id, userData: { shapeId: polygon?.shape_id ?? id }, children: jsx("meshBasicMaterial", { side: DoubleSide, transparent: transparent, color: !color || color === 'transparent' ? 'white' : color, opacity: opacity, depthTest: depthTest, depthWrite: depthWrite }) }), guideLabelConfig && guideLabels.length
                ? guideLabels.map((labelProps) => (jsx(Label, { ...labelProps, visible: (labelProps.visible ?? true) && isVisible, labelPrefix: "" }, labelProps.id)))
                : null, !!label && labelConfig ? (jsx(Label, { id: `${id}-distance-label`, point: labelPosition.toArray(), label: labelText || label.label || labelConfig.label, labelPrefix: "", visible: labelConfig.visible && isVisible, styles: labelConfig.styles, isAdjustingColors: labelConfig.isAdjustingColors })) : null] }));
};

const useConfigs = ({ id, points, label, segmentLabels, line, lineOutline, visible = true, opacity = 1, vertexAnchors, vertexSubtool = SubtoolVertex.None, selected = false, selectable = true, }) => {
    // Store
    const hoveredElementId = ''; // useToolUtilSelector((state) => state.hoveredElementId)
    // The active vertex-edit sub-mode is injected by the consuming tool (see `PolylineProps.vertexSubtool`).
    const currentVertexSubtool = vertexSubtool;
    // States
    const [hovered, setHovered] = useState(false);
    const [isDraggable, setIsDraggable] = useState(true);
    const [isEndsOnly, setIsEndsOnly] = useState(vertexAnchors?.endsOnly ?? false);
    const [pointOnLine, setPointOnLine] = useState();
    const [pointIndexForMerge, setPointIndexForMerge] = useState(null); // Index of point selected for merging polylines
    // Refs
    const dragStartPosRef = useRef(null);
    const currentPositionsRef = useRef(null);
    const isDraggingRef = useRef(false);
    const isDraggingVertexRef = useRef(false);
    const isHoveringAnchorRef = useRef(false);
    const editingAnchorRef = useRef(null);
    // Derived
    // Both remove sub-modes delete a vertex; only the `Remove` sub-mode also cuts an edge (split).
    const isRemovingVertex = currentVertexSubtool === SubtoolVertex.RemoveVertex || currentVertexSubtool === SubtoolVertex.Remove;
    const isSplittingEdge = currentVertexSubtool === SubtoolVertex.Remove;
    const isMergingPolyline = currentVertexSubtool === SubtoolVertex.ConnectVertex;
    const isVertexRemovable = isRemovingVertex && points.length > 2;
    const isAddingVertex = currentVertexSubtool === SubtoolVertex.AddVertex;
    const isNoVertexActions = !isVertexRemovable && !isDraggable && !isMergingPolyline;
    // Configurations for the label, line, and outline
    const labelConfig = useMemo(() => {
        if (label) {
            if (hovered)
                return merge({}, HOVERED_POLYLINE_CONFIG.label, label);
            if (selected)
                return merge({}, SELECTED_POLYLINE_CONFIG.label, label);
            return label;
        }
        return DEFAULT_POLYLINE_CONFIG.label || null;
    }, [label, selected, hovered]);
    const segmentLabelsConfig = useMemo(() => {
        if (segmentLabels) {
            if (hovered)
                return merge({}, HOVERED_POLYLINE_CONFIG.segmentLabels, segmentLabels);
            if (selected)
                return merge({}, SELECTED_POLYLINE_CONFIG.segmentLabels, segmentLabels);
            return segmentLabels;
        }
        return DEFAULT_POLYLINE_CONFIG.segmentLabels || null;
    }, [segmentLabels, selected, hovered]);
    const lineConfig = useMemo(() => {
        if (hovered)
            return merge({}, HOVERED_POLYLINE_CONFIG.line, line);
        if (selected)
            return merge({}, SELECTED_POLYLINE_CONFIG.line, line);
        if (line)
            return merge({}, DEFAULT_POLYLINE_CONFIG.line, line);
        return DEFAULT_POLYLINE_CONFIG.line;
    }, [line, selected, hovered]);
    const lineOutlineConfig = useMemo(() => {
        if (hovered)
            return merge({}, HOVERED_POLYLINE_CONFIG.lineOutline, lineOutline);
        if (selected)
            return merge({}, SELECTED_POLYLINE_CONFIG.lineOutline, lineOutline);
        if (lineOutline)
            return merge({}, DEFAULT_POLYLINE_CONFIG.lineOutline, lineOutline);
        return DEFAULT_POLYLINE_CONFIG.lineOutline;
    }, [lineOutline, selected, hovered]);
    // If it can be seen, it can be interacted with
    const canBeSeen = (visible === undefined || visible) && (opacity === undefined || opacity > 0);
    const canBeInteracted = canBeSeen && selectable && !isDraggingRef.current && !editingAnchorRef.current;
    const canLineBeInteracted = canBeInteracted && !isHoveringAnchorRef.current;
    /**
     * Disable dragging if current vertex subtool is not none and there are available subtools.
     * Alo disables pointForMerge when no longer in merging mode.
     */
    useEffect(() => {
        setIsDraggable(!isRemovingVertex && !isMergingPolyline);
        if (!isMergingPolyline)
            setPointIndexForMerge(null);
    }, [isRemovingVertex, isMergingPolyline]);
    /**
     * Update endsOnly state when vertexAnchors prop changes.
     */
    useEffect(() => {
        setIsEndsOnly((vertexAnchors?.endsOnly ?? false) || isMergingPolyline);
    }, [vertexAnchors?.endsOnly, isMergingPolyline]);
    return {
        labelConfig,
        segmentLabelsConfig,
        lineConfig,
        lineOutlineConfig,
        hovered,
        setHovered,
        isHoverSelected: hoveredElementId === id || selected,
        isNoVertexActions,
        isHoveringAnchorRef,
        isEndsOnly,
        isAddingVertex,
        isRemovingVertex,
        isSplittingEdge,
        isVertexRemovable,
        isMergingPolyline,
        isDraggable,
        isDraggingRef,
        isDraggingVertexRef,
        dragStartPosRef,
        currentPositionsRef,
        editingAnchorRef,
        pointOnLine,
        setPointOnLine,
        pointIndexForMerge,
        setPointIndexForMerge,
        canBeSeen,
        canBeInteracted,
        canLineBeInteracted,
    };
};

const useEventHandlers = (props, configs) => {
    const { id, points, vertexAnchors, isWorking, onEnter, onLeave, onDown, onSelect, onHover } = props;
    const { currentPositionsRef, isAddingVertex, isRemovingVertex, isSplittingEdge, isDraggingRef, dragStartPosRef, isDraggingVertexRef, pointOnLine, setPointOnLine, setHovered, } = configs;
    // An anchor being dragged anywhere in the scene is the global "editing" signal — while it's set,
    // hover is suppressed on every object (mirrors the Editor's `editingElementId` gate) so other
    // shapes don't light up as the dragging cursor passes over them.
    const { editingAnchor } = useThreeCanvasContext();
    // Refs
    const movingStartLocalPointRef = useRef(null);
    const tempV2Ref = useRef(new Vector2());
    /**
     * Handle mouse enter event on the distance label.
     * 1. Sets the cursor to move.
     * 2. Sets the hovered element state.
     *
     * @param ev - The mouse event.
     */
    const handleMouseEnter = (ev) => {
        // don't allow hovering while any anchor is being dragged
        if (editingAnchor)
            return;
        ev.stopPropagation();
        onHover?.(true);
        onEnter?.(ev);
        setHovered(true);
    };
    /**
     * Handle mouse leave event on the distance label.
     * 1. Sets the cursor back to default.
     * 2. Clears any hovered element state.
     *
     * @param ev - The mouse event.
     */
    const handleMouseLeave = (ev) => {
        ev.stopPropagation();
        setPointOnLine(undefined);
        onLeave?.(ev);
        onHover?.(false);
        setHovered(false);
    };
    /**
     * Handle mouse move event on the polyline.
     * Active when Add Vertex or Remove Vertex (for edge cutting) subtool is selected.
     *
     * @param ev - The mouse event.
     */
    const handleMouseMove = (ev) => {
        ev.stopPropagation();
        if ((isAddingVertex || isSplittingEdge) && !isDraggingVertexRef.current) {
            setPointOnLine(ev.pointOnLine?.toArray());
        }
    };
    /**
     * Handle mouse down event on the distance label.
     *
     * @param ev - The mouse event.
     */
    const handleMouseDown = (ev) => {
        ev.stopPropagation();
        currentPositionsRef.current = points;
        movingStartLocalPointRef.current = new Vector2(ev.clientX, ev.clientY);
        dragStartPosRef.current = null;
        onDown?.(ev);
    };
    /**
     * Handle click event on the distance label.
     * Selects the distance label if not dragging and if selector tool is active.
     * When the `Remove` tool is active, clicking on an edge will trigger a split (handled in parent).
     * (Vertex-only `RemoveVertex` does not split — only anchor clicks remove.)
     *
     * @param ev - The mouse event.
     */
    const handleClick = (ev) => {
        if (isDraggingRef.current || false || isWorking)
            return;
        ev.stopPropagation();
        if (isAddingVertex && pointOnLine) {
            // Figure out where to add the vertex
            const newIndex = calculateIndexInPolyline(points, pointOnLine);
            // Add a vertex in within the points collection
            const newPoints = [...points];
            newPoints.splice(newIndex, 0, pointOnLine);
            // Notify the parent about the updated points
            currentPositionsRef.current = newPoints;
            vertexAnchors?.onUpdated?.(newPoints);
        }
        else if (isSplittingEdge && pointOnLine) {
            // Clicking the line body (an edge, not an anchor) in the `Remove` sub-mode cuts the line here.
            // The engine only reports where; the consumer performs the actual split.
            vertexAnchors?.onSplit?.(calculateIndexInPolyline(points, pointOnLine));
        }
        else if (!isRemovingVertex) {
            onSelect?.();
        }
    };
    /**
     * Handle mouse up and mouse move events on window.
     * This is to capture events outside the distance label and canvas
     * if user's mouse goes out of bounds while dragging.
     */
    useEffect(() => {
        const handleUp = (ev) => {
            movingStartLocalPointRef.current = null;
            if (!isDraggingRef.current)
                return;
            ev.stopPropagation();
            if (currentPositionsRef.current)
                vertexAnchors?.onUpdated?.(currentPositionsRef.current);
            isDraggingRef.current = false;
            dragStartPosRef.current = null;
            currentPositionsRef.current = null;
            // dispatch(setEditingElementId(undefined))
            // dispatch(toggleSelectedElementIds({ ids: [id], selected: true }))
        };
        const handleMove = (ev) => {
            if (movingStartLocalPointRef.current) {
                const distance = movingStartLocalPointRef.current.distanceTo(tempV2Ref.current.set(ev.clientX, ev.clientY));
                if (distance > DRAG_DETECTION_THRESHOLD && !isDraggingRef.current) {
                    isDraggingRef.current = true;
                    // dispatch(setEditingElementId(id))
                    // dispatch(setHoveredElementId(''))
                }
            }
        };
        window.addEventListener('mouseup', handleUp);
        window.addEventListener('mousemove', handleMove);
        return () => {
            window.removeEventListener('mouseup', handleUp);
            window.removeEventListener('mousemove', handleMove);
        };
    }, [isDraggingRef, movingStartLocalPointRef, dragStartPosRef, currentPositionsRef, vertexAnchors, id]);
    return {
        movingStartLocalPointRef,
        pointOnLine,
        handleMouseEnter,
        handleMouseLeave,
        handleMouseMove,
        handleMouseDown,
        handleClick,
    };
};

const useEdgeHighlight = ({ points }, { pointOnLine, isSplittingEdge }) => {
    // States
    const [isEdgeHighlightVisible, setIsEdgeHighlightVisible] = useState(false);
    const [edgeGeometry] = useState(() => {
        const geom = new LineGeometry();
        geom.setPositions([0, 1, 0, 0, 0, 0]); // edge highlight can only ever be 2 points so we set it once here
        return geom;
    });
    // Refs
    const edgeHighlightRef = useRef(null);
    /**
     * Update the edge highlight positions based on the current edge index.
     * This highlights edges when hovering over them in Remove Vertex mode for edge cutting.
     */
    useEffect(() => {
        if (!pointOnLine || !isSplittingEdge) {
            setIsEdgeHighlightVisible(false);
            return;
        }
        const index = calculateIndexInPolyline(points, pointOnLine);
        const startPoint = points[index - 1];
        const endPoint = points[index];
        if (!startPoint || !endPoint) {
            setIsEdgeHighlightVisible(false);
            return;
        }
        edgeGeometry.setPositions([...startPoint, ...endPoint]);
        setIsEdgeHighlightVisible(true);
    }, [edgeGeometry, points, pointOnLine, isSplittingEdge]);
    return {
        edgeHighlightRef,
        edgeGeometry,
        isEdgeHighlightVisible,
    };
};

const getContrastingColor = (hexColor) => {
    // Remove the hash if it's there
    const color = hexColor.replace('#', '');
    // Convert to RGB
    const r = parseInt(color.substring(0, 2), 16);
    const g = parseInt(color.substring(2, 4), 16);
    const b = parseInt(color.substring(4, 6), 16);
    // Calculate the brightness using the YIQ formula
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    // Return black for light colors and white for dark colors
    return yiq >= 128 ? '#000000' : '#FFFFFF';
};
const useObjects = (props, configs) => {
    const { id, parentId, points, offsetTransformation, label, vertexAnchors, customCamera, isWorking, isEditing, isAdjustingColors, isOutlineContrastingColor, } = props;
    const { camera: threeCamera } = useThree();
    const { labelConfig, segmentLabelsConfig, lineConfig, lineOutlineConfig, canBeSeen, canLineBeInteracted, isEndsOnly, isDraggingRef, dragStartPosRef, currentPositionsRef, editingAnchorRef, setPointIndexForMerge, } = configs;
    const isMobile = /Mobi|Android/i.test(window.navigator.userAgent);
    const edgeHighlight = useEdgeHighlight(props, configs);
    const { edgeHighlightRef } = edgeHighlight;
    // Refs
    const tempV3 = useRef(new Vector3());
    const groupRef = useRef(null);
    const hitboxLineRef = useRef(undefined);
    const lineRef = useRef(undefined);
    const outlineRef = useRef(undefined);
    const labelMessage = useRef(null);
    const currentAnchorPositionRef = useRef(undefined);
    const lastObjectCountRef = useRef(points.length);
    // Live world position of the anchor currently being dragged, fed by the canvas via context (null
    // when nothing is being dragged). Previously hard-coded to the origin during the editor→common
    // migration, which wrote every dragged vertex to [0,0,0]; reading it here restores vertex moves.
    const { currentAnchorPosition } = useThreeCanvasContext();
    const currentStrokeColor = '#ff0000'; // useAppSelector((state) => state.toolUtil.core.currentStrokeColor)
    const currentFillColor = '#00ff00'; // useAppSelector((state) => state.toolUtil.core.currentFillColor)
    const selectedElementIds = []; // useAppSelector((state) => state.toolUtil.core.selectedElementIds)
    // States
    const [labelAdjustmentAngle, setLabelAdjustmentAngle] = useState();
    // Derived values
    const offsetMatrix = useMemo(() => toMatrix4(offsetTransformation), [offsetTransformation]);
    const offsettedPoints = useMemo(() => points.map((p) => tempV3.current
        .set(...p)
        .applyMatrix4(offsetMatrix)
        .toArray()), [points, offsetMatrix]);
    /**
     * Get polyline points based on current anchor position and editing state.
     */
    const getPolylinePoints = useCallback((currentPos, anchorIndex) => {
        if (vertexAnchors?.getPoints) {
            return vertexAnchors.getPoints(currentPos, anchorIndex);
        }
        const pts = cloneDeep(offsettedPoints);
        // new polygon
        if (isWorking && currentPos && !isMobile) {
            pts.push(currentPos);
        }
        // adjusting a single vertex
        else if (anchorIndex !== null && currentPos) {
            pts[anchorIndex] = currentPos;
        }
        // dragging the entire polygon
        else if (isEditing && anchorIndex === null) {
            if (!dragStartPosRef.current) {
                dragStartPosRef.current = currentPos;
            }
            else {
                const dragOffset = [
                    currentPos[0] - dragStartPosRef.current[0],
                    currentPos[1] - dragStartPosRef.current[1],
                    currentPos[2] - dragStartPosRef.current[2],
                ];
                pts.forEach((p) => {
                    p[0] += dragOffset[0];
                    p[1] += dragOffset[1];
                    p[2] += dragOffset[2];
                });
            }
        }
        return pts;
    }, [offsettedPoints, isWorking, isMobile, dragStartPosRef, isEditing, vertexAnchors]);
    /**
     * Use states for polyline points for ID stability.
     */
    const [polylinePoints, setPolylinePoints] = useState(() => offsettedPoints.map((p) => ({
        id: crypto.randomUUID(),
        point: new Vector3(...p),
    })));
    /**
     * Checks if a vertex should be visible.
     */
    const isVertexVisible = useCallback((anchorIndex) => {
        if (vertexAnchors === undefined || vertexAnchors.visible === false || !canBeSeen)
            return false;
        if (isEndsOnly) {
            return anchorIndex === 0 || anchorIndex === polylinePoints.length - 1;
        }
        return true;
    }, [isEndsOnly, polylinePoints.length, vertexAnchors, canBeSeen]);
    const center = useMemo(() => (offsettedPoints.length ? findCenter(offsettedPoints.map((p) => new Vector3(...p))) : null), [offsettedPoints]);
    const camera = customCamera || threeCamera;
    /**
     * Calculate the label adjustment angle based on the first segment of the polyline.
     */
    const calculateLabelAdjustmentAngle = useCallback((pts) => {
        if (!camera || pts.length < 2)
            return;
        // -- Figure out direction vector of first to second point
        const p1 = new Vector3().fromArray(pts[0]);
        const p2 = new Vector3().fromArray(pts[1]);
        const dir = p2.clone().sub(p1).normalize();
        // -- Get the direction relative to the camera
        const cameraMatrix = camera.matrix.toArray();
        const right = new Vector3().setFromMatrixColumn(camera.matrixWorld, 0).normalize();
        const x = dir.dot(right);
        const y = dir.dot(new Vector3(cameraMatrix[4], cameraMatrix[5], cameraMatrix[6]).normalize());
        // -- Set angle in radians
        setLabelAdjustmentAngle(Math.atan2(y, x));
    }, [camera]);
    /**
     * Throttled update of label adjustment angle for real-time calls.
     */
    const updateLabelAdjustmentAngle = a(calculateLabelAdjustmentAngle, 1000 / 15);
    /**
     * Calculate label data (position and total distance).
     */
    const calculateLabelData = useCallback((pts) => {
        // If there are segment labels, place the primary label at the start to show total distance
        if (segmentLabelsConfig) {
            // -- Total distance
            const allPointsV3 = pts.map((p) => (p instanceof Vector3 ? p.clone() : new Vector3().fromArray(p)));
            const totalDistance = allPointsV3.reduce((collection, point, index) => {
                const pointsPair = [point, allPointsV3[index + 1]];
                if (!pointsPair[1])
                    return collection;
                return collection + pointsPair[0].distanceTo(pointsPair[1]);
            }, 0);
            // -- Calculate adjustment angle
            calculateLabelAdjustmentAngle(pts);
            return {
                point: pts[0],
                totalDistance,
            };
        }
        return calculatePolylineMidpoint(pts);
    }, [segmentLabelsConfig, calculateLabelAdjustmentAngle]);
    /**
     * Calculate segment label data.
     */
    const calculateSegmentLabelData = useCallback((pts, ids) => pts.reduce((acc, _, i) => {
        if (i === 0)
            return acc;
        const segment = {
            id: ids?.[i - 1] || crypto.randomUUID(),
            label: segmentLabelsConfig?.generateLabel?.([pts[i - 1], pts[i]]) || '',
            ...calculatePolylineMidpoint([pts[i - 1], pts[i]]),
        };
        acc.push(segment);
        return acc;
    }, []), [segmentLabelsConfig]);
    /**
     * Throttled update of segment label data for real-time calls.
     */
    const updateSegmentLabelData = a((pts) => {
        // we need to retain the IDs for existing segments for stability
        setSegmentLabelData((prev) => calculateSegmentLabelData(pts, prev.map((p) => p.id)));
    }, 1000 / 30);
    // Label states
    const [labelData, setLabelData] = useState(() => label && offsettedPoints.length > 1 ? calculateLabelData(offsettedPoints) : null);
    const [segmentLabelData, setSegmentLabelData] = useState(calculateSegmentLabelData(offsettedPoints));
    /**
     * Update current anchor position ref
     */
    useEffect(() => {
        currentAnchorPositionRef.current = currentAnchorPosition ?? undefined;
    }, [currentAnchorPosition]);
    const [lineGeometry, setLineGeometry] = useState(() => {
        const len = polylinePoints.length;
        const pts = polylinePoints
            .concat({ id: crypto.randomUUID(), point: new Vector3().fromArray(offsettedPoints[0] || [0, 0, 0]) }, {
            id: crypto.randomUUID(),
            point: new Vector3().fromArray(offsettedPoints[1] || offsettedPoints[0] || [0, 0, 0]),
        })
            .slice(0, Math.max(2, len)); // LineGeometry needs at least 2 points
        const geometry = new LineGeometry();
        geometry.setPositions(pts.map((p) => p.point.toArray()).flat());
        return geometry;
    });
    /**
     * Update label position and message.
     * Throttled for performance.
     */
    const updateLabel = a((pts) => {
        if (label && pts.length > 1) {
            const midpoint = calculateLabelData(pts);
            // Don't update if the distance has not exceeded 1mm to prevent overlapping
            if (midpoint.totalDistance < 0.001)
                return;
            setLabelData(midpoint);
            if (labelConfig?.generateLabel) {
                labelMessage.current = labelConfig.generateLabel(pts);
            }
        }
    }, 1000 / 30, { leading: true, trailing: true });
    /**
     * Update line geometry when it changes.
     */
    useEffect(() => {
        if (lineRef.current) {
            lineRef.current.geometry = lineGeometry;
            lineRef.current.computeLineDistances();
            if (outlineRef.current) {
                outlineRef.current.geometry = lineRef.current.geometry.clone();
                outlineRef.current.computeLineDistances();
            }
            if (hitboxLineRef.current) {
                hitboxLineRef.current.geometry = lineRef.current.geometry.clone();
                hitboxLineRef.current.computeLineDistances();
            }
        }
    }, [lineGeometry]);
    /**
     * Update polyline object geometry.
     *
     * @param pts - New points for the polyline
     */
    const updateObject = useCallback((pts) => {
        // Update geometry if the number of points has increased
        if (pts.length !== lastObjectCountRef.current) {
            setLineGeometry((prev) => {
                if (prev)
                    prev.dispose();
                const geometry = new LineGeometry();
                geometry.setPositions(pts.map((p) => p).flat());
                return geometry;
            });
            lastObjectCountRef.current = pts.length;
        }
        else {
            if (hitboxLineRef.current) {
                hitboxLineRef.current.geometry.setPositions(pts.map((p) => p).flat());
                hitboxLineRef.current.geometry.computeVertexNormals();
                hitboxLineRef.current.computeLineDistances();
            }
            if (lineRef.current) {
                lineRef.current.geometry.setPositions(pts.map((p) => p).flat());
                lineRef.current.geometry.computeVertexNormals();
                lineRef.current.computeLineDistances();
            }
            if (outlineRef.current) {
                outlineRef.current.geometry.setPositions(pts.map((p) => p).flat());
                outlineRef.current.geometry.computeVertexNormals();
                outlineRef.current.computeLineDistances();
            }
        }
    }, []);
    /**
     * Update main line
     */
    useEffect(() => {
        if ((!lineRef.current && !outlineRef.current) ||
            !currentAnchorPosition ||
            !canBeSeen ||
            (!isEditing && !isWorking) ||
            (isEditing && editingAnchorRef.current === null && isDraggingRef.current === false))
            return;
        const pts = getPolylinePoints(currentAnchorPosition, editingAnchorRef.current);
        if (!pts)
            return;
        // -- Update mesh
        currentPositionsRef.current = pts;
        updateObject(pts);
        // -- Update line / anchor
        setPolylinePoints((prev) => pts.map((p, i) => prev[i] ? { ...prev[i], point: new Vector3(...p) } : { id: crypto.randomUUID(), point: new Vector3(...p) }));
        updateLabel(pts);
        updateSegmentLabelData(pts);
        // -- Callbacks
        if (vertexAnchors?.onUpdate) {
            vertexAnchors.onUpdate(pts.map((p) => p));
        }
    }, [
        currentAnchorPosition,
        editingAnchorRef,
        isEditing,
        isWorking,
        canBeSeen,
        vertexAnchors,
        isDraggingRef,
        currentPositionsRef,
        updateLabel,
        updateSegmentLabelData,
        updateObject,
        getPolylinePoints,
    ]);
    /**
     * Update polyline when points prop changes.
     */
    useEffect(() => {
        // While a vertex / line drag is in progress the drag effect above owns the geometry — don't let
        // a prop change clobber it. At any other time, sync — even while the tool keeps the line in
        // `isEditing`. This is essential for edits that don't come from an in-canvas drag: add / remove
        // / split committed via the canvas click (the orbit controls capture the pointer, so those go
        // through the app and flow back in through `points`, not through the drag path). Without this,
        // those edits mutate state but never render.
        const isActivelyDragging = editingAnchorRef.current !== null || isDraggingRef.current;
        if (isEditing && isActivelyDragging)
            return;
        // Desktop drawing preview augments the committed points with the live cursor position; for a
        // plain sync (editing but not dragging) always use the committed points, so a stale drag
        // position can't be mistaken for a whole-line drag by `getPolylinePoints`.
        const pts = !isEditing && !isMobile && currentAnchorPositionRef.current
            ? getPolylinePoints(currentAnchorPositionRef.current, null)
            : offsettedPoints;
        if (!pts?.length)
            return;
        // -- Reset point index for merging if the object count has changed
        if (offsettedPoints.length !== lastObjectCountRef.current) {
            setPointIndexForMerge(null);
        }
        /// -- Update points
        setPolylinePoints((prev) => pts.map((p, i) => prev[i] ? { ...prev[i], point: new Vector3(...p) } : { id: crypto.randomUUID(), point: new Vector3(...p) }));
        // -- Update mesh and labels
        updateObject(pts);
        if (segmentLabelsConfig)
            updateSegmentLabelData(pts);
        if (label)
            updateLabel(pts);
    }, [
        offsettedPoints,
        isEditing,
        isMobile,
        segmentLabelsConfig,
        label,
        updateLabel,
        getPolylinePoints,
        setPointIndexForMerge,
        updateObject,
        updateSegmentLabelData,
        editingAnchorRef,
        isDraggingRef,
    ]);
    /**
     * Update the mesh material color when the current fill color changes.
     * This is used for real-time updates of the fill color while the user is selecting it to
     * avoid unnecessary re-renders.
     *
     * The color set here _should not_ be the final color. It still must come from the `color` prop.
     */
    useEffect(() => {
        if (!lineRef.current ||
            !(lineRef.current.material instanceof LineMaterial) ||
            !currentStrokeColor ||
            (!parentId && !selectedElementIds.includes(id) && !isWorking) ||
            (parentId && !selectedElementIds.includes(parentId) && !isWorking))
            return;
        lineRef.current.material.color.set(currentStrokeColor);
    }, [lineRef, currentStrokeColor, selectedElementIds, id, parentId, isWorking]);
    useEffect(() => {
        if (!lineRef.current ||
            !(lineRef.current.material instanceof LineMaterial) ||
            !currentFillColor ||
            !isAdjustingColors)
            return;
        lineRef.current.material.color.set(currentFillColor);
        if (isOutlineContrastingColor && outlineRef.current) {
            const lineBgColor = getContrastingColor(currentFillColor);
            const outlineColor = lineBgColor === '#000000' ? '#888' : '#eee';
            outlineRef.current.material.color.set(outlineColor);
        }
    }, [currentFillColor, isAdjustingColors, isOutlineContrastingColor]);
    useEffect(() => {
        if (!lineRef.current ||
            !(lineRef.current.material instanceof LineMaterial) ||
            (!parentId && !selectedElementIds.includes(id) && !isWorking) ||
            (parentId && !selectedElementIds.includes(parentId) && !isWorking))
            return;
        lineRef.current.material.dashed = lineConfig?.style === LineStyle.Dashed;
    }, [lineRef, lineConfig, selectedElementIds, id, parentId, isWorking]);
    /**
     *  To keep the anchor size constant when zooming in/out.
     *  Use the camera's directional distance to prevent the anchor from appearing larger as it goes to the edge of the screen.
     *  NOTE: If this is heavy, consider using a distance from the camera to the ABControls' gizmo point for all anchors.
     *        The results will vary, but they look good.
     */
    useFrame(() => {
        if (camera instanceof PerspectiveCamera && center) {
            // distance from the camera to the anchor point
            const cameraToAnchor = center.clone().sub(camera.position.clone());
            // angle between the camera's forward vector and the vector from the camera to the anchor point
            const angle = cameraToAnchor.angleTo(new Vector3(0, 0, -1).applyQuaternion(camera.quaternion.clone()));
            // center position of viewing plane calculated from the camera's position and the distance to the anchor point
            const centerOfTheAnchorViewingPlane = camera.position
                .clone()
                .sub(new Vector3(0, 0, cameraToAnchor.length() * Math.cos(angle)).applyQuaternion(camera.quaternion.clone()));
            const scaleFactor = clamp$1(camera.position.distanceTo(centerOfTheAnchorViewingPlane) * 6, 1, 10) / 10;
            // gradually increase line width by scaleFactor, thinner line at low scaleFactor, thicker line at high scaleFactor
            if (lineRef.current && lineConfig) {
                const baseThickness = lineConfig.thickness ?? DEFAULT_POLYLINE_CONFIG.line?.thickness ?? 0.0025;
                const lineWidth = baseThickness + scaleFactor ** 2 * 0.005;
                lineRef.current.material.linewidth = lineWidth;
                lineRef.current.material.dashSize = lineRef.current.material.linewidth * LINE_WIDTH_TO_GAP_RATIO;
                lineRef.current.material.gapSize = lineRef.current.material.linewidth * LINE_WIDTH_TO_GAP_RATIO;
            }
            if (outlineRef.current && lineOutlineConfig) {
                const baseThickness = lineOutlineConfig.thickness ?? DEFAULT_POLYLINE_CONFIG.lineOutline?.thickness ?? 0.0025;
                outlineRef.current.material.linewidth =
                    baseThickness + Math.max(0.0025, baseThickness * 0.5) + scaleFactor ** 2 * 0.01;
                outlineRef.current.material.dashSize = outlineRef.current.material.linewidth * LINE_WIDTH_TO_GAP_RATIO;
                outlineRef.current.material.gapSize = outlineRef.current.material.linewidth * LINE_WIDTH_TO_GAP_RATIO;
                if (edgeHighlightRef.current) {
                    edgeHighlightRef.current.material.linewidth = outlineRef.current.material.linewidth;
                }
            }
            if (hitboxLineRef.current && (lineConfig || lineOutlineConfig)) {
                if (canLineBeInteracted) {
                    hitboxLineRef.current.material.linewidth =
                        (lineOutlineConfig?.thickness || lineConfig?.thickness || 0) +
                            Math.max(0.0025, Math.max(lineRef.current?.material.linewidth || 0, outlineRef.current?.material.linewidth || 0) * 0.5) +
                            scaleFactor ** 2 * 0.02;
                    hitboxLineRef.current.material.dashSize = hitboxLineRef.current.material.linewidth * LINE_WIDTH_TO_GAP_RATIO;
                    hitboxLineRef.current.material.gapSize = hitboxLineRef.current.material.linewidth * LINE_WIDTH_TO_GAP_RATIO;
                }
                else {
                    // A hacky workaround to make the hitbox line not interfere with vertex/anchor mouse events
                    hitboxLineRef.current.material.linewidth = 0.00001;
                }
            }
            if (segmentLabelsConfig && !isEditing)
                updateLabelAdjustmentAngle(offsettedPoints);
        }
    });
    return {
        ...edgeHighlight,
        groupRef,
        hitboxLineRef,
        lineRef,
        outlineRef,
        editingAnchorRef,
        currentAnchorPosition,
        polylinePoints,
        isVertexVisible,
        labelData,
        labelMessage,
        segmentLabelData,
        labelAdjustmentAngle,
    };
};

/**
 * Polyline object with ability to add labels and anchors.
 * Labels will be displayed at the midpoint of the polyline.
 * Anchor will be displayed at the start and end of the polyline.
 */
const Polyline = (props) => {
    const { id, vertexAnchors, vertexSubtool, anchorProps, topAnchorProps, bottomAnchorProps, hideBottomAnchor, } = props;
    // Offer the active sub-mode's styling to the anchors (empty keeps the plain look when none is active).
    const availableVertexSubtools = vertexSubtool && vertexSubtool !== SubtoolVertex.None ? [vertexSubtool] : [];
    const configs = useConfigs(props);
    const { labelConfig, segmentLabelsConfig, lineConfig, lineOutlineConfig, isSplittingEdge, isDraggable, isHoverSelected, isAddingVertex, isVertexRemovable, isMergingPolyline, isNoVertexActions, isDraggingVertexRef, isHoveringAnchorRef, currentPositionsRef, pointOnLine, pointIndexForMerge, setPointIndexForMerge, canBeSeen, canBeInteracted, canLineBeInteracted, } = configs;
    const { handleMouseEnter, handleMouseLeave, handleMouseMove, handleMouseDown, handleClick } = useEventHandlers(props, configs);
    const { groupRef, hitboxLineRef, lineRef, outlineRef, editingAnchorRef, edgeHighlightRef, edgeGeometry, isEdgeHighlightVisible, polylinePoints, isVertexVisible, labelData, labelMessage, segmentLabelData, labelAdjustmentAngle, } = useObjects(props, configs);
    return (jsxs("group", { ref: groupRef, name: `distance-label-${id}-group`, visible: canBeSeen, children: [jsx("line2", { ref: hitboxLineRef, renderOrder: 10, name: `distance-label-${id}-hitbox`, onPointerEnter: canLineBeInteracted ? handleMouseEnter : undefined, onPointerLeave: handleMouseLeave, onPointerDown: canLineBeInteracted ? handleMouseDown : undefined, onPointerMove: canLineBeInteracted ? handleMouseMove : undefined, onClick: canLineBeInteracted ? handleClick : undefined, children: jsx("lineMaterial", { transparent: true, alphaToCoverage: true, worldUnits: true, color: "pink", linewidth: (lineOutlineConfig?.thickness || lineConfig?.thickness || 0.002) * 3, 
                    // dashed={LineStyle.Solid} // hitbox is always solid
                    depthTest: false, depthWrite: false, visible: false }) }), jsx("line2", { ref: edgeHighlightRef, renderOrder: 20, name: `distance-label-${id}-edge-highlight`, geometry: edgeGeometry, raycast: () => null, children: jsx("lineMaterial", { transparent: true, alphaToCoverage: true, worldUnits: true, color: "yellow", linewidth: lineOutlineConfig?.thickness || 0.002, dashed: false, depthTest: false, depthWrite: false, visible: isSplittingEdge && isEdgeHighlightVisible }) }), jsx("line2", { ref: outlineRef, renderOrder: 10, name: `distance-label-${id}-outline`, raycast: () => null, children: jsx("lineMaterial", { transparent: true, alphaToCoverage: true, worldUnits: true, color: lineOutlineConfig?.color === 'transparent' ? 'white' : lineOutlineConfig?.color || 'white', linewidth: lineOutlineConfig?.thickness || 0.002, dashed: lineOutlineConfig?.style === LineStyle.Dashed, dashScale: 2, dashSize: 2, gapSize: 1.5, depthTest: false, depthWrite: false, visible: lineOutlineConfig?.visible ?? lineOutlineConfig?.color !== 'transparent' }) }), jsx("line2", { ref: lineRef, name: `distance-label-${id}-line`, renderOrder: 15, raycast: () => null, children: jsx("lineMaterial", { transparent: true, alphaToCoverage: true, worldUnits: true, color: lineConfig?.color === 'transparent' ? 'white' : lineConfig?.color || 'white', dashed: lineConfig?.style === LineStyle.Dashed, linewidth: lineConfig?.thickness || 0.001, dashScale: DEFAULT_LINE_MATERIAL.dashScale, dashSize: (lineConfig?.thickness || 0.001) * LINE_WIDTH_TO_GAP_RATIO, gapSize: (lineConfig?.thickness || 0.001) * LINE_WIDTH_TO_GAP_RATIO, depthTest: false, depthWrite: false, visible: lineConfig?.visible ?? true }) }), isAddingVertex && pointOnLine ? (jsx(CircleAnchorV2, { id: `${id}-current-anchor`, point: pointOnLine, tooltipText: "\u9802\u70B9\u3092\u8FFD\u52A0", showTooltip: "always", isInteractable: false, renderOrder: 20 })) : null, vertexAnchors &&
                polylinePoints.slice(0, hideBottomAnchor ? -1 : undefined).map(({ id: anchorId, point }, anchorIndex) => (createElement(Anchor, { ...vertexAnchors, ...anchorProps, ...(anchorIndex === 0 ? topAnchorProps : undefined), ...(anchorIndex === polylinePoints.length - 1 ? bottomAnchorProps : undefined), key: anchorId, id: anchorId, visible: isVertexVisible(anchorIndex), parentId: id, anchorIndex: anchorIndex, point: point.toArray(), vertexSubtool: vertexSubtool, availableVertexSubtools: availableVertexSubtools, isNoAction: isNoVertexActions, isDraggable: isDraggable, isParentHoverSelected: isHoverSelected, isHighlighted: pointIndexForMerge === anchorIndex, onEnter: (idx, ev) => {
                        isHoveringAnchorRef.current = true;
                        vertexAnchors.onEnter?.(idx, ev);
                    }, onLeave: (idx, ev) => {
                        isHoveringAnchorRef.current = false;
                        vertexAnchors.onLeave?.(idx, ev);
                    }, onUpdate: canBeInteracted || vertexAnchors.isInteractable || isDraggable
                        ? (idx, pt) => {
                            const pts = currentPositionsRef.current?.slice() || polylinePoints.map(({ point: p }) => p.toArray());
                            pts[idx] = pt;
                            vertexAnchors.onUpdate?.(pts);
                            isDraggingVertexRef.current = true;
                        }
                        : undefined, onUp: (aidx, ev) => {
                        if (isVertexRemovable) {
                            vertexAnchors.onUpdated?.(polylinePoints.filter((_, i) => i !== aidx).map(({ point: p }) => p.toArray()));
                        }
                        else if (isMergingPolyline) {
                            setPointIndexForMerge((prev) => (prev === aidx ? null : aidx));
                        }
                        vertexAnchors.onUp?.(aidx, ev);
                    }, onDown: (aidx, ev) => {
                        if (isDraggable)
                            editingAnchorRef.current = aidx;
                        vertexAnchors.onDown?.(aidx, ev);
                    }, onComplete: () => {
                        if (currentPositionsRef.current) {
                            vertexAnchors.onUpdated?.(currentPositionsRef.current);
                        }
                        editingAnchorRef.current = null;
                        currentPositionsRef.current = null;
                        labelMessage.current = null;
                        isHoveringAnchorRef.current = false;
                        isDraggingVertexRef.current = false;
                    } }))), labelData && labelConfig ? (jsx(Label, { id: `${id}-distance-label`, point: labelData.point, label: labelMessage.current || labelConfig.label, labelPrefix: "", visible: labelConfig.visible && canBeSeen, styles: labelConfig.styles, isAdjustingColors: labelConfig.isAdjustingColors, autoAdjustAwayFromAngle: labelAdjustmentAngle })) : null, segmentLabelsConfig && segmentLabelData.length > 0
                ? segmentLabelData.map(({ id: segmentId, point, label }) => (jsx(Label, { id: `${id}-segment-distance-label-${segmentId}`, point: point, label: label, labelPrefix: "", visible: segmentLabelsConfig.visible && canBeSeen, styles: segmentLabelsConfig.styles, isAdjustingColors: segmentLabelsConfig.isAdjustingColors }, `${id}-segment-distance-label-${segmentId}`)))
                : null] }));
};

/**
 * Get the distance label with unit and optional width
 * @param distance in meters
 * @param width in millimeters (optional)
 * @returns label with unit and width if provided
 */
const getDistanceLabel = (distance, width) => {
    const roundedDistance = roundNumber(distance, '0.001');
    const distanceInMillimeter = meterToMillimeter(roundedDistance);
    let lengthLabel;
    if (distanceInMillimeter < 10000) {
        lengthLabel = `${distanceInMillimeter}mm`;
    }
    else {
        lengthLabel = `${roundedDistance}m`;
    }
    // Only add width if it's explicitly set (excluding 0)
    if (width !== undefined && width !== null && width !== 0) {
        return `${lengthLabel} × ${width}mm`;
    }
    return lengthLabel;
};

/**
 * Calculate the total length of a polyline defined by an array of points.
 *
 * @param allPoints - An array of points representing the polyline.
 */
const calculatePolylineLength = (allPoints) => {
    const allPointsV3 = allPoints.map((p) => (p instanceof Vector3 ? p.clone() : new Vector3().fromArray(p)));
    // Go through each section of the polyline and calculate the distance between them, then the total distance.
    const totalDistance = allPointsV3.reduce((collection, point, index) => {
        const pointsPair = [point, allPointsV3[index + 1]];
        if (!pointsPair[1])
            return collection;
        return collection + pointsPair[0].distanceTo(pointsPair[1]);
    }, 0);
    return totalDistance;
};

/** Render order for the in-progress fill — above the PCD, below edges and vertex markers. */
const FILL_RENDER_ORDER$1 = 18;
/** Thin dashed white outline shown while drawing (`previewStyle` can override). */
const PREVIEW_GUIDE_LINE = { visible: true, style: LineStyle.Dashed, color: '#ffffff', thickness: 0.0015 };
/** Outline turns red while the closing anchor is hovered (paired with the red anchor). */
const HOVER_GUIDE_LINE = { visible: true, style: LineStyle.Dashed, color: '#ff3b30', thickness: 0.0015 };
/** Fill opacity while drawing — a touch more opaque than the package default so it reads clearly. */
const PREVIEW_FILL_OPACITY = 0.85;
/** Closing-anchor colours by state: dark grey (not yet closable) → blue (closable) → red (hover). */
const CLOSING_IDLE_COLOR = '#4b5563';
const CLOSING_READY_COLOR = AnchorColors.Movable;
const CLOSING_HOVER_COLOR = '#ff3b30';
/** Cuboid placement dots — the Editor's grey anchor colour. */
const CUBOID_ANCHOR_COLOR = '#777';
const DrawingPreview = ({ tool, placedVertices, cursorVertex, complete, suppressClickRef }) => {
    // Consumer-supplied look-and-feel + the closing-anchor tooltip; merged over the package defaults.
    const { previewStyle, drawingConfig, completion, closingTooltip, previewPrimaryLabelVisible, previewEdgeLabelVisible, } = useThreeCanvasContext();
    // Whether the closing anchor is hovered (drives its red state + the red outline).
    const [isClosingHovered, setIsClosingHovered] = useState(false);
    // Manual-close tools (no `maxVertices`) show a single closing anchor. A **polygon** closes back to
    // its **first** vertex, so the anchor sits there; an open **polyline** closes at its **last-placed**
    // vertex, so the anchor sits there instead. It's dark grey until the shape is completable
    // (≥ minVertices, not self-intersecting), then blue with a ✓; hovering it (and clicking to close)
    // is enabled only then. Auto-complete tools (Camera Profile) instead show a plain marker at every vertex.
    const isManualClose = !drawingConfig.maxVertices;
    const isPolyline = tool === DrawingTool.Polyline;
    const isCuboid = tool === DrawingTool.Cuboid;
    const canClose = completion.completable;
    const closingColor = !canClose ? CLOSING_IDLE_COLOR : isClosingHovered ? CLOSING_HOVER_COLOR : CLOSING_READY_COLOR;
    // The vertex the closing anchor sits on: last-placed for a polyline, first for a polygon.
    const closingIndex = isPolyline ? placedVertices.length - 1 : 0;
    const closingVertex = placedVertices[closingIndex];
    // Placed vertices + the live cursor candidate.
    const previewVertices = useMemo(() => {
        if (!cursorVertex || placedVertices.length === 0)
            return placedVertices;
        return [...placedVertices, cursorVertex];
    }, [placedVertices, cursorVertex]);
    /**
     * Points fed to PolygonPlaneMesh (polygon only). Memoised so the reference stays stable
     * across the mesh's internal re-renders — otherwise its positions effect would re-run
     * every frame. Built from placed + cursor so edges/fill/anchors all follow the cursor.
     */
    const workingVertices = useMemo(() => previewVertices.map((v) => [v.x, v.y, v.z]), [previewVertices]);
    // Outline turns red while the closing anchor is hovered; otherwise the consumer's `previewStyle`
    // guide line (or the package default) applies. Passed once, after the `previewStyle` spread.
    const guideLine = isManualClose && canClose && isClosingHovered ? HOVER_GUIDE_LINE : (previewStyle?.guideLine ?? PREVIEW_GUIDE_LINE);
    return (jsxs("group", { name: "drawing-preview", children: [previewVertices.length > 0 ? (isCuboid ? (
            // Cuboid — dashed base-face guide, becoming a dashed box preview once the cursor
            // supplies the prospective depth anchor (Editor parity; no fill, no closing anchor).
            jsx(CuboidPlacementFrame, { placedVertices: placedVertices, cursorVertex: cursorVertex })) : isPolyline ? (
            // Open line — the L1 Polyline renderer (line + outline, no fill), following the cursor.
            jsx(Polyline, { id: "drawing-preview-polyline", points: workingVertices, selectable: false, hideAnchors: true, line: {
                    visible: true,
                    // A polyline draws as a solid line (the plane tool keeps its dashed guide); the
                    // hover-aware colour still flows through from `guideLine`.
                    style: LineStyle.Solid,
                    color: guideLine.color,
                    thickness: guideLine.thickness,
                    depthTest: false,
                    depthWrite: false,
                    renderOrder: FILL_RENDER_ORDER$1,
                }, 
                // Live total-length readout while drawing (same 全長 label the draft shows once closed),
                // recomputed as the cursor moves. Honours the tool's primary-label display toggle
                // (mirrored into the canvas context), so it hides when 全長 is turned off.
                label: {
                    label: getDistanceLabel(calculatePolylineLength(workingVertices)),
                    generateLabel: (pts) => getDistanceLabel(calculatePolylineLength(pts)),
                    visible: previewPrimaryLabelVisible,
                }, 
                // Per-segment (各辺) lengths, likewise honouring the tool's edge-label toggle. Omitted
                // entirely when off so no hidden per-segment labels are mounted.
                segmentLabels: previewEdgeLabelVisible
                    ? {
                        generateLabel: (pts) => getDistanceLabel(calculatePolylineLength(pts)),
                        visible: true,
                    }
                    : undefined })) : (jsx(PolygonPlaneMesh, { id: "drawing-preview-polygon", isWorking: true, color: "white", opacity: PREVIEW_FILL_OPACITY, ...(previewStyle ?? {}), workingVertices: workingVertices, guideLine: guideLine, depthTest: false, depthWrite: false, renderOrder: FILL_RENDER_ORDER$1 }))) : null, isManualClose && isPolyline && placedVertices[0] ? (jsx(CircleAnchorV2, { id: "drawing-preview-first-anchor", point: [placedVertices[0].x, placedVertices[0].y, placedVertices[0].z], isInteractable: false, color: AnchorColors.Normal, outlineColor: "white", outlineOpacity: 1, scale: 1.3, renderOrder: FILL_RENDER_ORDER$1 + 20 })) : null, isCuboid
                ? // Cuboid: a plain grey dot per placed anchor + the live cursor candidate (the Editor's
                    // `circleAnchors`); no closing anchor — placement auto-completes at the 4th anchor.
                    previewVertices.map((vertex, index) => (jsx(CircleAnchorV2, { id: `drawing-preview-cuboid-anchor-${index}`, point: [vertex.x, vertex.y, vertex.z], isInteractable: false, color: CUBOID_ANCHOR_COLOR, renderOrder: FILL_RENDER_ORDER$1 + 20 }, `drawing-preview-cuboid-anchor-${index}`)))
                : isManualClose
                    ? // Manual close: a single closing anchor on the closing vertex (first for a polygon, last-
                        // placed for a polyline; states above). For a polyline it appears only once there are ≥2
                        // points, so it never sits on top of the first-vertex marker. Clicking it (when closable)
                        // completes the drawing; `onDown` sets the suppression ref first so the same click doesn't
                        // also place a vertex.
                        closingVertex &&
                            (isPolyline ? placedVertices.length >= 2 : placedVertices.length > 0) && (jsx(CircleAnchorV2, { id: "drawing-preview-closing-anchor", point: [closingVertex.x, closingVertex.y, closingVertex.z], isInteractable: canClose, color: closingColor, icon: canClose ? CircleAnchorIcon.CHECK : undefined, iconColor: "white", iconScale: 1.6, scale: 1.6, tooltipText: canClose ? closingTooltip : undefined, showTooltip: "hover", renderOrder: FILL_RENDER_ORDER$1 + 30, onEnter: () => setIsClosingHovered(true), onLeave: () => setIsClosingHovered(false), onDown: () => {
                                suppressClickRef.current = true;
                                complete();
                            } }))
                    : // Auto-complete tools: a plain, non-interactable marker per placed vertex.
                        placedVertices.map((vertex, index) => (jsx(Anchor, { id: `drawing-preview-anchor-${index}`, parentId: "drawing-preview-polygon", point: [vertex.x, vertex.y, vertex.z], anchorIndex: index, isParentHoverSelected: true, isInteractable: false, color: AnchorColors.Movable, outlineOpacity: 0, scale: 1.5, icon: CircleAnchorIcon.MOVE, iconColor: "white", iconScale: 1.3, renderOrder: FILL_RENDER_ORDER$1 + 20 }, `drawing-preview-anchor-${index}`)))] }));
};

class PotreeCache {
    constructor(getAccessToken) {
        /**
         * Default expiration time for the cache.
         * This will be overridden by the actual expiration time when the URLs are fetched.
         * Value is in seconds.
         */
        this.ttl = 60; // 1 minute
        /**
         * Buffer time to avoid expiration.
         * This is used to expire the URLs earlier than the actual expiration time to avoid issues with time differences.
         * Value is in seconds.
         */
        this.ttlBuffer = 10;
        /**
         * Cached access token for Auth0.
         * This is used to avoid fetching a new token every time.
         */
        this.auth0AccessToken = null;
        this.cache = new Map();
        this.getAccessToken = getAccessToken;
    }
    /**
     * Type guard to check if the Potree file exists in the signed URLs.
     *
     * @param fileName File name to check
     * @param urls Signed URLs for Potree files
     * @returns Whether the file exists
     */
    static hasFile(fileName, urls) {
        return (urls && fileName in urls) || false;
    }
    /**
     * Checks the cached access token for Potree, and if it is not available, fetches a new one.
     *
     * @param getAccessToken Function to get the access token
     * @returns Auth0 access token
     */
    async getAuth0AccessToken() {
        // Check the expiration of existing token, if exists
        if (this.auth0AccessToken) {
            const token = JSON.parse(atob(this.auth0AccessToken.split('.')[1]));
            if ((token.exp + this.ttlBuffer) * 1000 > Date.now()) {
                return this.auth0AccessToken;
            }
        }
        // Fetch new token
        this.auth0AccessToken = await this.getAccessToken();
        return this.auth0AccessToken;
    }
    /**
     * Given the signed URLs returned from blueprint's get-potree-files API,
     * extract the blueprint-specific area URLs from it.
     *
     * @returns Signed URLs for the blueprint area files, or null if not available.
     */
    static getBlueprintAreaUrls(signedURLs, blueprintAreaId) {
        const urls = signedURLs?.aligned_pcds?.[blueprintAreaId];
        if (!urls) {
            return null;
        }
        return {
            ...signedURLs,
            metadata: urls.metadata,
            hierarchy: urls.hierarchy,
            octree: urls.octree,
        };
    }
    /**
     * Generate signed URLs for Potree files and cache them for a minute.
     *
     * @param token Auth0 access token
     * @param projectId Project ID
     * @param inspectionAreaId Inspection Area ID
     * @param showErrorModal Function to show error modal
     * @returns Signed URLs for Potree files
     */
    async getPotreeSignedURLs(projectId, { inspectionArea, blueprint, blueprintAreaId }, showErrorModal) {
        if (!this.auth0AccessToken) {
            this.auth0AccessToken = await this.getAuth0AccessToken();
        }
        const cacheId = [projectId, inspectionArea.inspection_area_id, blueprint?.blueprint_id].filter(Boolean).join('-');
        let potreeSignedUrls = this.cache.get(cacheId) || null;
        if (potreeSignedUrls && potreeSignedUrls.expiry.getTime() > Date.now()) {
            if (blueprintAreaId) {
                return PotreeCache.getBlueprintAreaUrls(potreeSignedUrls, blueprintAreaId);
            }
            return potreeSignedUrls;
        }
        const urls = await getSignedUrlForPotreeFiles(this.auth0AccessToken, projectId, inspectionArea.inspection_area_id, blueprint?.blueprint_id || null).catch((err) => {
            showErrorModal?.('Failed to load point cloud data. Please try again.');
            return null;
        });
        if (!urls)
            return null;
        const url = new URL(urls.metadata);
        const expiry = parseInt(url.searchParams.get('X-Amz-Expires') || '', 10) || this.ttl;
        // expire earlier to avoid the time difference between fetching this URL and using it
        potreeSignedUrls = {
            ...urls,
            expiry: new Date(Date.now() + 1000 * (expiry - this.ttlBuffer)),
            inspectionAreaId: inspectionArea.inspection_area_id,
            blueprintId: blueprint?.blueprint_id,
        };
        this.cache.set(cacheId, potreeSignedUrls);
        if (blueprintAreaId)
            return PotreeCache.getBlueprintAreaUrls(potreeSignedUrls, blueprintAreaId);
        return potreeSignedUrls;
    }
}

const usePCDLoader = (customPotree, onError) => {
    // URL Params
    // const { project_id } = useParams<{ project_id: string }>()
    // Context
    const { getAccessTokenSilently } = useAuth0();
    // const { showErrorModal } = useGlobalModalContext()
    // Potree stuff
    const [potree] = useState(new Potree('v2'));
    const [potreeCache] = useState(new PotreeCache(getAccessTokenSilently));
    /**
     * Load a Potree point cloud.
     *
     * @param loaderParams Parameters for loading. Must include inspection area.
     * @param blueprint Optional blueprint, if loading from a blueprint area.
     */
    const loadPotree = useCallback(async (loaderParams) => {
        if (!loaderParams.inspectionArea.down_sampled_file) {
            return null;
        }
        // Get access token
        const pcd = await potree
            .loadPointCloud(
        // The name of the point cloud which is to be loaded.
        'metadata.json', 
        // Given the relative URL of a file, should return a full URL (e.g. signed).
        async (fileName) => {
            const urls = await potreeCache.getPotreeSignedURLs(loaderParams.inspectionArea.project_id, loaderParams, onError);
            const fileNameWithoutExt = fileName.split('.')[0];
            let url = '';
            if (urls && PotreeCache.hasFile(fileNameWithoutExt, urls) && typeof urls[fileNameWithoutExt] === 'string') {
                url = urls[fileNameWithoutExt];
            }
            return url;
        })
            .catch((err) => {
            // Sentry.captureException(err)
            return null;
        });
        if (pcd)
            pcd.name = [
                loaderParams.inspectionArea.inspection_area_id,
                loaderParams.blueprint?.blueprint_id,
                loaderParams.blueprintAreaId,
            ]
                .filter(Boolean)
                .join('-');
        return pcd;
    }, [potree, potreeCache, onError]);
    /**
     * Load a PCD file.
     *
     * @deprecated Hatsuly no longer supports PCD files.
     * @param loaderParams Parameters for loading. Must include inspection area.
     * @param onProgress Progress callback. Only used for PCDLoader, Potree has no progress.
     */
    const loadPCD = useCallback(async (loaderParams, onProgress) => {
        const { inspectionArea, blueprint } = loaderParams;
        if (!inspectionArea.down_sampled_file) {
            return null;
        }
        // Potree-based files.
        // Blueprint will only load through Potree.
        const po3dir = inspectionArea.down_sampled_file.potree_dir;
        if (po3dir || blueprint) {
            return loadPotree(loaderParams);
        }
        if (Cache.get(inspectionArea.inspection_area_id)) {
            const loadPoints = Cache.get(inspectionArea.inspection_area_id);
            loadPoints.material.transparent = true;
            return loadPoints;
        }
        // Get access token
        const token = await getAccessTokenSilently();
        if (!token) {
            return null;
        }
        const url = await getSignedUrlForGetDownSampledFile(token, inspectionArea.project_id, inspectionArea.inspection_area_id).catch((err) => {
            return null;
        });
        if (!url) {
            return null;
        }
        // 点群データのダウンロード
        try {
            const loader = new PCDLoader();
            let loadPoints;
            try {
                loadPoints = await loader.loadAsync(url, (e) => {
                    onProgress?.((e.loaded / e.total) * 100);
                });
            }
            catch (err) {
                if (err instanceof RangeError) {
                    onError?.('読み込み可能な点群サイズの上限を超過しました。小さい範囲で点群を取り直すか、点群密度を間引いてお試しください。\nこの上限はお使いの端末の性能等により変動することがあります。');
                    return null;
                }
                throw err;
            }
            loadPoints.name = inspectionArea.inspection_area_id;
            // 点群データをキャッシュに保存（どこかのタイミングでキャッシュを消したい、ログアウトとか？）
            Cache.add(inspectionArea.inspection_area_id, loadPoints);
            loadPoints.material.transparent = true;
            return loadPoints;
        }
        catch (err) {
            // Sentry.captureException(err)
            return null;
        }
    }, [loadPotree, getAccessTokenSilently, onError]);
    return {
        potree,
        loadPCD,
        loadPotree,
    };
};

const useValidateRenderableObjects = (type, objects) => {
    useEffect(() => {
        objects.forEach((object) => {
            if (!isRenderableObject3D(object)) {
                warnInvalidObject3D(type, object);
                return;
            }
            warnEmptyObjectName(type, object);
        });
    }, [type, objects]);
};

const PointCloudRenderer = ({ objects }) => {
    useValidateRenderableObjects('pointCloud', objects);
    return (jsx(Fragment, { children: objects.map((object) => {
            if (!isRenderableObject3D(object)) {
                return null;
            }
            return jsx("primitive", { object: object }, object.name);
        }) }));
};

const PointCloudManager = ({ areas, setSceneDetails, onLoading, onLoaded, pointSize, pcdOpacity, pcdVisible = true, meshPresent = false, maskRegions, maskOutsideOpacity, }) => {
    // Hooks & Context
    const { camera, gl } = useThree();
    const { potree, loadPotree } = usePCDLoader();
    // States
    const [pcds, setPCDs] = useState([]);
    // Refs
    const loadingAreasRef = useRef(new Set()); // To keep track of which areas are currently loading to avoid duplicate loads
    const areasRef = useRef(areas);
    // Derived State
    const isPointCloudInvisible = !pcdVisible;
    // Whether a mask config has ever been written to this potree instance — a consumer dropping the
    // prop back to `undefined` afterwards still needs the active mask cleared, not left dangling.
    const maskEngagedRef = useRef(false);
    /**
     * Generate a stable string of all area IDs to use as a dependency for effects.
     * This ensures that effects only re-run when the actual set of areas changes, not just when the reference changes.
     */
    const areaIdsString = useMemo(() => {
        areasRef.current = areas;
        if (!areas?.length)
            return '';
        return areas
            ?.map((area) => area.inspection_area_id)
            .sort()
            .join('::');
    }, [areas]);
    /**
     * Effect to load point clouds for the given areas.
     */
    useEffect(() => {
        if (!areas?.length)
            return;
        const loadAllPointClouds = async () => {
            const loadedPCDs = [];
            setPCDs([]); // Clear local PCDs to trigger re-render and show loading state for new areas
            onLoading?.();
            const areaIds = areaIdsString.split('::');
            for (const areaId of areaIds) {
                if (loadingAreasRef.current.has(areaId)) {
                    continue;
                }
                loadingAreasRef.current.add(areaId);
                const pcd = await loadPotree({
                    inspectionArea: areasRef.current?.find((a) => a.inspection_area_id === areaId),
                });
                if (pcd) {
                    pcd.name = `area-${areaId}`;
                    loadedPCDs.push(pcd);
                }
                loadingAreasRef.current.delete(areaId);
            }
            // Only set based on current areas.
            setPCDs((prev) => {
                const areaIds = new Set(areas.map((a) => a.inspection_area_id));
                const filteredPrev = prev.filter((pcd) => {
                    const pcdAreaId = pcd.name?.split('area-')[1];
                    return pcdAreaId && areaIds.has(pcdAreaId);
                });
                return [...filteredPrev, ...loadedPCDs];
            });
            // When it's all done, figure out PCD dimensions to center the camera.
            if (!loadingAreasRef.current.size) {
                if (loadedPCDs.length) {
                    const { bbox, center, radius } = getCenterAndRadius(loadedPCDs);
                    setSceneDetails({
                        center,
                        radius,
                        bbox,
                    });
                }
                // Update states
                // setInitCompleted(true)
                //
                onLoaded?.();
            }
        };
        loadAllPointClouds();
    }, [areaIdsString, loadPotree, setSceneDetails]);
    /**
     * Apply the display knobs (point size, opacity, visibility) to every loaded point cloud's
     * material. Re-runs when a new set of PCDs loads so freshly-loaded clouds pick up the current
     * settings too. Rendering only — persistence and UI live in the app layer.
     *
     * When mask regions are given they take over the opacity story (the Editor's `PotreePCD`
     * behaviour): the material's base opacity becomes the shader's outside-the-masks default — 0
     * while any mask exists, else `pcdOpacity` — and each mask cuboid renders its inside at
     * `pcdOpacity`. An undefined `maskRegions` never touches the mask config, so consumers that
     * don't mask keep the plain material path.
     */
    useEffect(() => {
        // `undefined` after a config was written means "stop masking" — clear with an empty config
        // rather than leaving the previous cuboids dangling on the potree instance.
        const effectiveMaskRegions = maskRegions ?? (maskEngagedRef.current ? [] : undefined);
        // Outside-the-masks base opacity: normally 0 while any mask exists (hide outside), but a
        // consumer-set `maskOutsideOpacity` overrides it whenever masking is engaged — the Editor's
        // in-mask-tool dim (0.1), which applies even with no boxes yet so the working box previews
        // bright against a dim cloud.
        let defaultOpacity = effectiveMaskRegions?.length ? 0 : pcdOpacity;
        if (effectiveMaskRegions !== undefined && maskOutsideOpacity !== undefined)
            defaultOpacity = maskOutsideOpacity;
        pcds.forEach((pcd) => {
            if (pointSize !== undefined)
                pcd.material.size = pointSize;
            if (defaultOpacity !== undefined) {
                pcd.material.opacity = defaultOpacity;
                pcd.material.enableTransparency();
                pcd.material.blending = NormalBlending;
                pcd.material.depthTest = !meshPresent;
            }
            pcd.visible = pcdVisible;
        });
        if (effectiveMaskRegions !== undefined) {
            maskEngagedRef.current = true;
            potree.setMaskConfig({
                cuboids: effectiveMaskRegions.map((region) => ({
                    id: region.region_id,
                    center: new Vector3(...region.center),
                    rotation: region.rotation,
                    extent: new Vector3(...region.extent),
                    opacity: pcdOpacity ?? 1,
                })),
                defaultOpacity: defaultOpacity ?? 1,
            });
            // Apply the new config now, in the same turn as the opacity write above. The mask uniforms
            // only reach the shader inside `updatePointClouds`, and the render loop below is throttled
            // to 10 FPS — waiting for it leaves frames where the new base opacity renders against the
            // old mask state (the whole cloud blinks out when masks turn on: opacity is already 0 but
            // no cuboid is compiled in yet).
            if (pcds.length)
                potree.updatePointClouds(pcds, camera, gl);
        }
    }, [pcds, pointSize, pcdOpacity, pcdVisible, meshPresent, maskRegions, maskOutsideOpacity, potree, camera, gl]);
    /**
     * Render loop to trigger Potree's update function.
     * This is necessary to process Potree's LOD and masking updates.
     * Throttled to 10 FPS to balance performance and responsiveness.
     */
    const render = a(() => {
        if (isPointCloudInvisible)
            return;
        potree.updatePointClouds(pcds, camera, gl);
    }, 1000 / 10);
    useFrame(render);
    return jsx(Fragment, { children: pcds.length ? jsx(PointCloudRenderer, { objects: pcds }) : null });
};

const planeRaycaster = new Raycaster();
/** §2 polygon plane-fallback: hit the derived plane when scene surface misses */
function getPlaneHit(event, canvas, plane, camera) {
    const rect = canvas.getBoundingClientRect();
    const { coords } = getClickCoords({ x: event.clientX, y: event.clientY }, { x: rect.left, y: rect.top, width: rect.width, height: rect.height });
    planeRaycaster.setFromCamera(coords, camera);
    const target = new Vector3();
    const hit = planeRaycaster.ray.intersectPlane(plane, target);
    return hit ?? undefined;
}
/** Pixels the cursor must move between down and up to be considered a drag (orbit). */
const DRAG_THRESHOLD_PX = 10;
/** Max ms / px between two left clicks to count as a double-click. */
const DOUBLE_CLICK_MS = 300;
const DOUBLE_CLICK_DIST_PX = 10;
function useCanvasEventHandlers({ activeTool, canvasRef, derivedPlane, onSurfaceClick, onCursorMove, onMiddleClick, onPointClick, complete, onCuboidQuickPlace, suppressClickRef, isPointPickable, }) {
    // Hooks
    const { sceneRef, cameraRef, editingAnchor, setCurrentAnchorPosition, drawingConfig, drawingState, completion, editingPlane, } = useThreeCanvasContext();
    // Track mouse-down position to distinguish click from drag (left = vertex/focus, middle = pan)
    const mouseDownPosRef = useRef(null);
    const middleDownPosRef = useRef(null);
    // Track the last left click to detect a double-click (time + position).
    const lastClickRef = useRef(null);
    // Consecutive same-spot clicks (1 = single, 2 = double, 3 = triple …), tracked separately from
    // the pairwise double-click ref above — that one is consumed when a pair fires, so it can never
    // count to three. Drives the cuboid quick box.
    const clickChainRef = useRef(null);
    /**
     * Forget the click chain when the drawing tool changes, so clicks made under another tool can't
     * count toward a cuboid triple-click.
     */
    useEffect(() => {
        clickChainRef.current = null;
    }, [activeTool]);
    /** Scene-surface hit only (PCD / solid mesh), no plane fallback — for focus-style events. */
    const resolveSurfaceHit = (e) => {
        if (!sceneRef.current || !cameraRef.current || !canvasRef.current)
            return undefined;
        const { pcdPoint, solidMeshPoint } = getRaycastHits(e, canvasRef.current, cameraRef.current, sceneRef.current, isPointPickable);
        return pcdPoint ?? solidMeshPoint;
    };
    const resolveHit = (e) => {
        // Constrain to a plane when one applies, so points/edits stay coplanar (the click ray is
        // intersected with the plane, mirroring the Editor's `pointSelectionPlane`):
        //  · `editingPlane` — a vertex drag on an existing polygon is locked to that polygon's plane.
        //  · `derivedPlane` — once the in-progress polygon has ≥3 points, further points snap to it.
        // Before any plane exists, pick the real surface point so the first three define it from the scan.
        const constraintPlane = editingPlane ?? derivedPlane;
        if (constraintPlane && cameraRef.current && canvasRef.current) {
            const planeHit = getPlaneHit(e, canvasRef.current, constraintPlane, cameraRef.current);
            if (planeHit)
                return planeHit;
        }
        return resolveSurfaceHit(e);
    };
    /** True when the pointer moved far enough between `downPos` and the event to be a drag. */
    const isDrag = (e, downPos) => {
        if (!downPos)
            return false;
        return Math.hypot(e.clientX - downPos.x, e.clientY - downPos.y) > DRAG_THRESHOLD_PX;
    };
    return {
        onMouseDown: (e) => {
            if (e.button === 0)
                mouseDownPosRef.current = { x: e.clientX, y: e.clientY };
            if (e.button === 1)
                middleDownPosRef.current = { x: e.clientX, y: e.clientY };
            return null;
        },
        onMouseMove: (e) => {
            // Edit mode runs independently of `activeTool`: while an anchor is being dragged,
            // feed it the live scene-surface position (package-internal, no consumer round-trip).
            if (editingAnchor) {
                const hit = resolveHit(e);
                if (hit)
                    setCurrentAnchorPosition(hit.toArray());
                return;
            }
            if (!activeTool)
                return;
            onCursorMove(resolveHit(e));
        },
        onMouseUp: (e) => {
            // Releasing an anchor drag must not place a vertex or focus; the anchor's own window-level
            // mouseup finalizes it.
            if (editingAnchor)
                return;
            // A closing-anchor click already completed the drawing this gesture — swallow the click so it
            // doesn't also place a stray vertex.
            if (suppressClickRef.current) {
                suppressClickRef.current = false;
                mouseDownPosRef.current = null;
                return;
            }
            // Middle-click → raw middle-click event (business layer decides — e.g. focus). Skip if it
            // was a middle-drag (pan).
            if (e.button === 1) {
                const downPos = middleDownPosRef.current;
                middleDownPosRef.current = null;
                if (!onMiddleClick || isDrag(e, downPos))
                    return;
                const hit = resolveSurfaceHit(e);
                if (hit)
                    onMiddleClick(hit);
                return;
            }
            if (e.button !== 0)
                return;
            const downPos = mouseDownPosRef.current;
            mouseDownPosRef.current = null;
            // A drag is an orbit, not a click — no vertex placement, no focus.
            if (isDrag(e, downPos))
                return;
            // Double-click detection (shared by manual-close completion + the raw `onPointClick`).
            const now = e.timeStamp;
            const prev = lastClickRef.current;
            const isDoubleClicked = !!prev &&
                now - prev.time < DOUBLE_CLICK_MS &&
                Math.hypot(e.clientX - prev.x, e.clientY - prev.y) < DOUBLE_CLICK_DIST_PX;
            lastClickRef.current = { time: now, x: e.clientX, y: e.clientY };
            // Extend (or restart) the consecutive-click chain with this click.
            const chain = clickChainRef.current;
            const isChained = !!chain &&
                now - chain.time < DOUBLE_CLICK_MS &&
                Math.hypot(e.clientX - chain.x, e.clientY - chain.y) < DOUBLE_CLICK_DIST_PX;
            const chainCount = isChained ? chain.count + 1 : 1;
            clickChainRef.current = { time: now, x: e.clientX, y: e.clientY, count: chainCount };
            // Manual-close drawing tools (no `maxVertices`): a double-click closes the shape when it's
            // completable, instead of placing another vertex. (Tools that auto-complete at a fixed count
            // — Camera Profile — never take this path.)
            const isManualClose = !!activeTool && !drawingConfig.maxVertices;
            if (isManualClose && isDoubleClicked && completion.completable) {
                complete();
                lastClickRef.current = null;
                return;
            }
            // Raw left-click on a scene point, with a double-click flag — fired regardless of the active
            // drawing tool so tools that draw nothing (Focus) or edit existing geometry (Polyline: add /
            // remove / split a vertex on a hovered line) can react. The business layer gates it. Runs
            // *before* placement so a tool that **consumes** the click (returns true) preempts placing a
            // drawing vertex for that same click — e.g. clicking an existing line to insert a vertex must
            // not also start a new line.
            if (onPointClick) {
                const surfaceHit = resolveSurfaceHit(e);
                if (surfaceHit) {
                    const consumed = onPointClick(surfaceHit, { isDoubleClicked });
                    // Consume the gesture: once a click is paired into a double-click, or the handler acts on
                    // it (e.g. Focus fires + reverts the tool), forget it so the *next* click can't re-pair
                    // with it and fire a second time (double-focus / triple-click double-fire).
                    if (isDoubleClicked || consumed)
                        lastClickRef.current = null;
                    if (consumed)
                        return;
                }
            }
            // Cuboid quick box: a triple-click before the base triangle exists (fewer than 3 placed
            // anchors — the first two clicks of the gesture placed anchors, discarded here) replaces the
            // whole placement with a fixed-size box around the clicked point (Editor parity).
            if (activeTool === DrawingTool.Cuboid && onCuboidQuickPlace && chainCount >= 3 && drawingState.placedCount < 3) {
                const hit = resolveSurfaceHit(e);
                if (hit) {
                    onCuboidQuickPlace(hit);
                    clickChainRef.current = null;
                    lastClickRef.current = null;
                    return;
                }
            }
            // Left-click vertex placement while a drawing tool is live (unchanged path).
            if (activeTool) {
                const hit = resolveHit(e);
                if (hit)
                    onSurfaceClick(hit);
            }
        },
        onTouchMove: () => null,
        onTouchStart: () => null,
        onTouchEnd: () => null,
        onTouchMoveCapture: () => null,
    };
}

const initialDrawingState = {
    placedVertices: [],
    cursorVertex: null,
};
/**
 * Vertices a drawing needs before it can complete: a polyline is an open chain (2), a polygon a
 * closed loop (3), a cuboid a base triangle + a depth anchor (4).
 */
const getMinVertices = (tool) => {
    switch (tool) {
        case DrawingTool.Polyline:
            return 2;
        case DrawingTool.Cuboid:
            return CUBOID_REQUIRED_ANCHORS;
        default:
            return 3;
    }
};
/**
 * Whether the drawn polygon self-intersects. Only possible for a Polygon with ≥4 vertices (a
 * triangle can't cross itself); the points are projected onto their plane (`alignToZAxis`) before
 * the XY edge-cross test. Polylines are never checked (they're open).
 */
const isSelfIntersecting = (tool, vertices) => {
    if (tool !== DrawingTool.Polygon || vertices.length < 4)
        return false;
    const { points } = alignToZAxis(vertices);
    return checkForLineIntersections(points);
};
function useDrawing({ activeTool, onComplete, onCancel }) {
    // Context
    const { setCompletion, setDrawingState: setContextDrawingState, drawingConfig } = useThreeCanvasContext();
    // States
    const [drawingState, setDrawingState] = useState(initialDrawingState);
    // Hooks
    const prevToolRef = useRef(activeTool);
    const placedVerticesRef = useRef([]);
    // Set by `restore()` so the tool-change reset below doesn't wipe a just-seeded drawing when
    // re-entering DRAW (e.g. a tool stepping a committed shape back into placement).
    const restoreGuardRef = useRef(false);
    // Derived state
    const placedCount = drawingState.placedVertices.length;
    // Reset only on a genuine switch to a *different* drawing primitive. A transition to/from `null`
    // is a suspend/resume, not an end: a tool can be momentarily deselected (e.g. a transient Focus
    // detour nulls `activeTool`, then restores the same tool) and the in-progress placement must
    // survive it. Genuine ends clear the placement explicitly via `complete()` / `cancel()` (the
    // latter is what a tool's real exit calls), and a pending `restore()` re-seed is preserved.
    useEffect(() => {
        const prevTool = prevToolRef.current;
        if (prevTool === activeTool)
            return;
        prevToolRef.current = activeTool;
        if (restoreGuardRef.current) {
            restoreGuardRef.current = false;
            return;
        }
        const switchedPrimitive = activeTool !== null && prevTool !== null;
        if (switchedPrimitive)
            setDrawingState(initialDrawingState);
    }, [activeTool]);
    /**
     * Handle a click on the surface to place a vertex.
     */
    const onSurfaceClick = useCallback((point) => {
        if (!activeTool)
            return;
        setDrawingState((prev) => {
            let placedVertices = [...prev.placedVertices, point.clone()];
            if (activeTool === DrawingTool.Cuboid) {
                // A cuboid takes exactly 4 anchors; ignore further clicks (the Editor's guard).
                if (prev.placedVertices.length >= CUBOID_REQUIRED_ANCHORS)
                    return prev;
                // Placing the 4th (depth) anchor orthogonalizes the base triangle (C → D onto the
                // normal of A–B), so the stored anchors are the ones the box is derived from.
                if (placedVertices.length === CUBOID_REQUIRED_ANCHORS) {
                    placedVertices = [...fixVertexOnNormal(placedVertices.slice(0, 3)), placedVertices[3]];
                }
            }
            return { ...prev, placedVertices };
        });
    }, [activeTool]);
    /**
     * Update the cursor vertex when the mouse moves over the canvas.
     *  This is used to show a preview of the next vertex to be placed.
     */
    const onCursorMove = useCallback((point) => {
        if (!activeTool)
            return;
        setDrawingState((prev) => ({
            ...prev,
            cursorVertex: point ? point.clone() : null,
        }));
    }, [activeTool]);
    /**
     * Keep a stable ref to placed vertices so complete/cancel can read latest without
     * needing drawingState in their dependency arrays (avoids stale-closure issues)
     */
    useEffect(() => {
        placedVerticesRef.current = drawingState.placedVertices;
    }, [drawingState.placedVertices]);
    /**
     * Plane derived from the first 3 placed vertices (Polygon tool only).
     * Stable reference — only recomputed when the relevant vertices change.
     */
    const derivedPlane = useMemo(() => {
        if (activeTool !== DrawingTool.Polygon)
            return null;
        const verts = drawingState.placedVertices;
        if (verts.length < 3)
            return null;
        return new Plane().setFromCoplanarPoints(verts[0], verts[1], verts[2]);
    }, [activeTool, drawingState.placedVertices]);
    // Keep a stable ref so complete() always reads the latest plane without closure staleness
    const derivedPlaneRef = useRef(null);
    useEffect(() => {
        derivedPlaneRef.current = derivedPlane;
    }, [derivedPlane]);
    /**
     * Complete the drawing and fire the onComplete callback with a copy of the vertices
     */
    const complete = useCallback(() => {
        const vertices = placedVerticesRef.current;
        const minVertices = getMinVertices(activeTool);
        // No-op unless completable (enough vertices, not self-intersecting), so every trigger
        // (maxVertices auto-complete, double-click, closing anchor, imperative complete) is safe.
        if (vertices.length < minVertices || isSelfIntersecting(activeTool, vertices))
            return;
        const plane = derivedPlaneRef.current ?? undefined;
        onComplete?.({ vertices: vertices.map((v) => v.clone()), plane });
        setDrawingState(initialDrawingState);
    }, [onComplete, activeTool]);
    /**
     * Auto-complete once the configured vertex count is reached (P2; CameraProfile = 3).
     * Declared after the ref-sync effects above so complete() reads the latest vertices and
     * derived plane. complete() resets placedVertices, so this won't re-fire in a loop.
     */
    const { maxVertices } = drawingConfig;
    useEffect(() => {
        if (!activeTool || !maxVertices)
            return;
        if (placedCount >= maxVertices)
            complete();
    }, [activeTool, maxVertices, placedCount, complete]);
    /**
     * Cancel the drawing and fire the onCancel callback
     */
    const cancel = useCallback(() => {
        onCancel?.();
        setDrawingState(initialDrawingState);
    }, [onCancel]);
    /**
     * Undo the last placed vertex
     */
    const undo = useCallback(() => {
        setDrawingState((prev) => ({
            ...prev,
            placedVertices: prev.placedVertices.slice(0, -1),
        }));
    }, []);
    /**
     * Seed the placement state with existing vertices (re-enter an in-progress drawing). Guards
     * the tool-change reset so switching back into the drawing tool doesn't wipe the seed.
     */
    const restore = useCallback((vertices) => {
        const cloned = vertices.map((v) => v.clone());
        restoreGuardRef.current = true;
        placedVerticesRef.current = cloned;
        setDrawingState({ placedVertices: cloned, cursorVertex: null });
    }, []);
    /**
     * Cancel drawing on Escape key press. This is a global listener because the canvas may not have
     * focus when the user presses Escape. Only cancels while a tool is actually live (`activeTool`
     * set): when the drawing is merely suspended (e.g. a transient Focus detour nulls `activeTool`),
     * ESC must not wipe the preserved in-progress placement.
     */
    useEffect(() => {
        if (!activeTool)
            return undefined;
        const handleKeyDown = (e) => {
            if (e.key === 'Escape')
                cancel();
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [activeTool, cancel]);
    /**
     * Push derived drawing state into context so consumers can read it
     */
    useEffect(() => {
        setContextDrawingState(activeTool ? { phase: 'drawing', tool: activeTool, placedCount } : initialContextDrawingState);
    }, [activeTool, placedCount, setContextDrawingState]);
    /**
     * Push completion eligibility into context whenever the inputs change
     */
    const minVertices = getMinVertices(activeTool);
    const selfIntersecting = isSelfIntersecting(activeTool, drawingState.placedVertices);
    const isCompletable = activeTool !== null && placedCount >= minVertices && !selfIntersecting;
    useEffect(() => {
        if (isCompletable) {
            setCompletion({ completable: true });
        }
        else {
            let reason = 'No active tool';
            if (activeTool)
                reason = selfIntersecting ? 'Polygon edges must not cross' : `Need at least ${minVertices} points`;
            setCompletion({ completable: false, reason });
        }
    }, [isCompletable, activeTool, minVertices, selfIntersecting, setCompletion]);
    return { drawingState, derivedPlane, onSurfaceClick, onCursorMove, complete, cancel, undo, restore };
}

/** Stable empty default so the bridge's hook count never changes when no extra contexts are given. */
const NO_BRIDGE_CONTEXTS = [];
const ThreeCanvas = forwardRef(function ThreeCanvas({ areas, skipInitialCameraProfile = false, activeTool = null, className, style, fov = 90, near = 0.1, far = 5000, pointSize, pcdOpacity, pcdVisible = true, meshPresent = false, backgroundColor = '#000000', labelSize = 1, maskRegions, maskOutsideOpacity, isPointPickable, children, bridgeContexts = NO_BRIDGE_CONTEXTS, onLoading, onLoaded, onComplete, onCancel, onMiddleClick, onPointClick, }, ref) {
    // Hooks
    const { sceneRef, cameraRef, sceneDetails, setSceneDetails, setActiveTool } = useThreeCanvasContext();
    // Forward the canvas context + query client, plus any app contexts the consumer hands in, so
    // in-canvas objects can read app state (e.g. tool state) by context across the R3F boundary.
    const ContextBridge = useContextBridge(ThreeCanvasContext, QueryClientContext, ...bridgeContexts);
    // States
    const [dimensions, setDimensions] = useState({ width: window.innerWidth, height: window.innerHeight });
    // Refs
    const canvasRef = useRef(null);
    const stabilizeTimerRef = useRef(null);
    // Set by the closing anchor when it completes a drawing, so the canvas's own mouse-up handler
    // skips placing a stray vertex for that same click (the R3F anchor event can't stop the outer
    // div's DOM handler). Read-and-reset in `useCanvasEventHandlers`.
    const suppressClickRef = useRef(false);
    // Last live drawing primitive, so the preview can still render while the tool is momentarily
    // suspended (`activeTool` null) but placement isn't finished — e.g. a Focus detour mid-draw.
    const lastDrawingToolRef = useRef(activeTool);
    if (activeTool)
        lastDrawingToolRef.current = activeTool;
    // Sync prop → context so hooks inside the canvas can read activeTool
    useEffect(() => {
        setActiveTool(activeTool ?? null);
    }, [activeTool, setActiveTool]);
    // Drawing state machine
    const { drawingState, derivedPlane, onSurfaceClick, onCursorMove, ...exposedHandlers } = useDrawing({
        activeTool: activeTool ?? null,
        onComplete,
        onCancel,
    });
    // Expose imperative handle
    useImperativeHandle(ref, () => exposedHandlers);
    const { restore } = exposedHandlers;
    /**
     * Cuboid quick box: replace the placement with the fixed-size box's 4 anchors. Seeding all 4
     * trips the cuboid's `maxVertices` auto-complete, so the box completes immediately.
     * @param point The triple-clicked scene point (the box center).
     */
    const handleCuboidQuickPlace = useCallback((point) => {
        restore(getQuickCuboidAnchors(point, CUBOID_QUICK_SIZE));
    }, [restore]);
    // Canvas event handlers
    const canvasEventHandlers = useCanvasEventHandlers({
        activeTool,
        canvasRef,
        derivedPlane,
        onSurfaceClick,
        onCursorMove,
        onMiddleClick,
        onPointClick,
        complete: exposedHandlers.complete,
        onCuboidQuickPlace: handleCuboidQuickPlace,
        suppressClickRef,
        isPointPickable,
    });
    // Observe the parent element — not the canvas — because the canvas's fixed width/height
    // attributes prevent it from ever reporting a smaller contentRect on shrink.
    useEffect(() => {
        const container = canvasRef.current?.parentElement;
        if (!container)
            return;
        let lastUpdateDimensions = { width: 0, height: 0 };
        const resizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                const { width, height } = entry.contentRect;
                const roundedWidth = Math.round(width);
                const roundedHeight = Math.round(height);
                if (stabilizeTimerRef.current) {
                    clearTimeout(stabilizeTimerRef.current);
                }
                stabilizeTimerRef.current = setTimeout(() => {
                    if (lastUpdateDimensions.width !== roundedWidth || lastUpdateDimensions.height !== roundedHeight) {
                        lastUpdateDimensions = { width: roundedWidth, height: roundedHeight };
                        setDimensions({ width: roundedWidth, height: roundedHeight });
                    }
                }, 200);
            }
        });
        resizeObserver.observe(container);
        return () => {
            resizeObserver.disconnect();
            if (stabilizeTimerRef.current) {
                clearTimeout(stabilizeTimerRef.current);
            }
        };
    }, []);
    return (jsx(Canvas$1, { ref: canvasRef, className: className, style: style, tabIndex: -1, gl: {
            preserveDrawingBuffer: true,
            localClippingEnabled: false,
            toneMapping: NoToneMapping,
            outputColorSpace: LinearSRGBColorSpace,
        }, onCreated: ({ scene, camera }) => {
            sceneRef.current = scene;
            if (camera instanceof PerspectiveCamera)
                cameraRef.current = camera;
        }, ...canvasEventHandlers, children: jsx(ContextBridge, { children: jsxs(LabelSizeContext.Provider, { value: labelSize, children: [jsx("ambientLight", { intensity: Math.PI }), jsx("color", { attach: "background", args: [backgroundColor] }), children, (activeTool ?? lastDrawingToolRef.current) &&
                        (activeTool !== null || drawingState.placedVertices.length > 0) && (jsx(DrawingPreview, { tool: (activeTool ?? lastDrawingToolRef.current), placedVertices: drawingState.placedVertices, cursorVertex: activeTool ? drawingState.cursorVertex : null, complete: exposedHandlers.complete, suppressClickRef: suppressClickRef })), jsx(PointCloudManager, { areas: areas, setSceneDetails: setSceneDetails, onLoading: onLoading, onLoaded: onLoaded, pointSize: pointSize, pcdOpacity: pcdOpacity, pcdVisible: pcdVisible, meshPresent: meshPresent, maskRegions: maskRegions, maskOutsideOpacity: maskOutsideOpacity }), jsx(CameraManager, { windowSize: dimensions, sceneDetails: sceneDetails, fov: fov, near: near, far: far, areas: areas, skipInitialCameraProfile: skipInitialCameraProfile })] }) }) }));
});

/**
 * Go through an Object3D and tag all Meshes as solid mesh.
 * The Object3D can be the mesh itself or a Group containing multiple meshes.
 *
 * @param object Object to tag
 */
const tagAsSolidMesh = (object) => {
    if (object instanceof Mesh) {
        object.userData.isSolidMesh = true;
        return;
    }
    object.traverse((child) => {
        if (child instanceof Mesh) {
            child.userData.isSolidMesh = true;
        }
    });
};
/**
 * A mesh tile's bounding box in world space.
 *
 * `MeshTilesManager.setOffsetPosition` folds the mesh offset into the manager's own transform
 * *and* into every tile's `boundingBox`, so the box already sits where the manager puts its
 * children — applying the manager's own `matrixWorld` would add that offset a second time and
 * leave the box twice as far out as the geometry it describes. Only whatever transform sits
 * above the manager is still to be applied.
 *
 * Takes the tile structurally rather than as a `MeshTile`, which would make this module and
 * `MeshTile` import each other.
 *
 * @param tile Tile whose bounding box is wanted.
 * @param manager The tiles manager the tile belongs to.
 * @returns The box in world space, or null for a tile that has none.
 */
const getTileWorldBoundingBox = (tile, manager) => {
    if (!tile.boundingBox)
        return null;
    const bbox = tile.boundingBox.clone();
    if (manager.parent)
        bbox.applyMatrix4(manager.parent.matrixWorld);
    return bbox;
};
/**
 * Transform an Oriented Bounding Box (OBB) defined by an axis-aligned bounding box (AABB)
 * and a transformation matrix into a new AABB that fully contains the OBB.
 * @param aabb Axis-aligned bounding box defined by Box3
 * @param m Transformation matrix
 * @returns New axis-aligned bounding box that fully contains the transformed OBB
 */
const transformOBBToAABB = (aabb, m) => {
    const points = [
        new Vector3(aabb.min.x, aabb.min.y, aabb.min.z),
        new Vector3(aabb.min.x, aabb.min.y, aabb.max.z),
        new Vector3(aabb.min.x, aabb.max.y, aabb.min.z),
        new Vector3(aabb.min.x, aabb.max.y, aabb.max.z),
        new Vector3(aabb.max.x, aabb.min.y, aabb.min.z),
        new Vector3(aabb.max.x, aabb.min.y, aabb.max.z),
        new Vector3(aabb.max.x, aabb.max.y, aabb.min.z),
        new Vector3(aabb.max.x, aabb.max.y, aabb.max.z),
    ];
    const localAABB = new Box3();
    points.forEach((p) => {
        p.applyMatrix4(m);
        localAABB.expandByPoint(p);
    });
    return localAABB;
};
/**
 * Add (or replace) a named Box3 helper under a parent object, for debugging bounding boxes.
 *
 * @param parent Object to attach the helper to
 * @param name Unique name for the helper (a previous helper with the same name is removed first)
 * @param box Bounding box to visualize
 * @param color Line color
 */
const addBox3Helper = (parent, name, box, color = 0x00ff00) => {
    const existing = parent.getObjectByName(name);
    if (existing)
        parent.remove(existing);
    const boxHelper = new Box3Helper(box, color);
    boxHelper.name = name;
    boxHelper.userData.type = 'debug';
    parent.add(boxHelper);
    return boxHelper;
};

const dummyA = new Vector3();
const dummyB = new Vector3();
/**
 * MeshTilesManager class extending Three.js Object3D to manage Tile-based meshes.
 */
class MeshTilesManager extends Object3D {
    constructor() {
        super();
        /**
         * Reference to the active camera for LOD calculations.
         */
        this.camera = null;
        /**
         * Current mask regions used for toggling tile visibility based on intersection.
         * Part of the mask-cube seam — left empty here; each app's mask wiring fills this in.
         */
        this.masks = [];
        /**
         * A map of mesh IDs currently loading LODs
         * with their percentage progress.
         */
        this.loadingLODs = {};
        /**
         * Previous overall loading progress to control update frequency of progress callback.
         */
        this.previousProgress = 0;
        /**
         * Metadata about the MeshTilesManager.
         */
        this.userData = {};
        this.children = [];
    }
    /**
     * Constraint the add method to only accept MeshTile instances.
     *
     * @param tiles MeshTile instances to add
     */
    add(...tiles) {
        super.add(...tiles);
        return this;
    }
    /**
     * Preload all LODs for all MeshTile.
     */
    async preload() {
        if (!this.camera)
            return;
        // Toggle visibility of tiles based on masks first before loading to
        // save resources by not loading invisible tiles
        this.toggleTileBasedOnMasks();
        const intersectedTiles = [];
        const otherTiles = [];
        // Sort tiles into intersected vs non-intersected based on camera distance for prioritized loading
        // Exclude invisible tiles since they won't be seen anyway and don't need to be loaded immediately
        this.children.forEach((tile) => {
            if (!tile.visible)
                return;
            // Prioritize tiles with LOD0 first
            const lodLevel = tile.getLODLevel(this.camera);
            if (lodLevel === 0) {
                intersectedTiles.push(tile);
            }
            else {
                otherTiles.push(tile);
            }
            // initialize loading progress for all tiles
            this.loadingLODs[tile.userData.id] = 0;
        });
        // -- Prioritize intersected tiles
        await Promise.allSettled(intersectedTiles.map((tile) => tile.tick(this.camera)));
        // -- Sort tiles from closest to farthest from camera
        otherTiles.sort((a, b) => {
            if (!this.camera)
                return 0;
            const aCenter = a.center || dummyA;
            const bCenter = b.center || dummyB;
            const aDist = aCenter.distanceToSquared(this.camera.position);
            const bDist = bCenter.distanceToSquared(this.camera.position);
            return aDist - bDist;
        });
        // Safeguard
        if (!this.camera)
            return;
        await Promise.allSettled(otherTiles.map((tile) => tile.tick(this.camera)));
    }
    /**
     * Toggle visibility of MeshTile based on current masks. Tiles with bounding boxes that do not intersect
     * with any mask regions will be hidden, while those that intersect will be shown.
     * If there are no masks, all tiles will be shown.
     */
    toggleTileBasedOnMasks() {
        this.children.forEach((tile) => {
            if (tile.boundingBox) {
                tile.visible =
                    this.masks.length === 0
                        ? true
                        : this.masks.some((region) => transformOBBToAABB(tile.boundingBox, region.modelMatrix).intersectsBox(new Box3(region.min, region.max)));
            }
        });
    }
    /**
     * Run tick for the manager and all of its MeshTile.
     */
    tick() {
        if (!this.camera)
            return;
        this.children.forEach((tile) => {
            void tile.tick(this.camera);
        });
        this.checkLoadingProgress();
    }
    /**
     * Set offset position to the manager and for all LOD tiles.
     * @param offset Vector3 offset to apply
     */
    setOffsetPosition(offset) {
        this.position.copy(offset);
        this.children.forEach((tile) => {
            tile.setOffsetPosition(offset);
        });
    }
    /**
     * Set opacity for all LOD tiles.
     * @param opacity Opacity value between 0 and 1 to apply to all tiles
     */
    setOpacity(opacity) {
        this.children.forEach((tile) => {
            tile.setOpacity(opacity);
        });
    }
    /**
     * Check loading progress of LODs and clean up completed ones.
     */
    checkLoadingProgress() {
        // Clean up loading LODs map
        Object.entries(this.loadingLODs).forEach(([meshId, percentage]) => {
            if (percentage >= 100) {
                delete this.loadingLODs[meshId];
            }
        });
        if (Object.keys(this.loadingLODs).length === 0) {
            this.previousProgress = 0;
        }
    }
    /**
     * Event to be called by MeshTile when they start loading an LOD.
     *
     * @param tile MeshTile instance loading the LOD
     * @param percentage Loading percentage (0-100)
     */
    onLoadingLOD(tile, percentage) {
        const meshId = tile.userData.id;
        this.loadingLODs[meshId] = percentage;
        const totalTiles = Object.keys(this.loadingLODs).length;
        const overallProgress = Object.values(this.loadingLODs).reduce((sum, val) => sum + val, 0) / totalTiles / 100;
        // Slow down progress updates to every 1% since that's enough for UI purposes
        if (overallProgress - this.previousProgress >= 0.01 || overallProgress >= 1) {
            this.onLoadingProgress?.(overallProgress);
            this.previousProgress = overallProgress;
        }
    }
    /**
     * Clear all MeshTile and their resources.
     */
    clear() {
        this.children.forEach((tile) => {
            tile.clear();
        });
        super.clear();
        return this;
    }
    /**
     * Reset the manager.
     */
    reset() {
        this.abort();
        this.clear();
        return this;
    }
    /**
     * Abort any ongoing LOD loading for all MeshTile.
     */
    abort() {
        this.children.forEach((tile) => {
            tile.abort();
        });
        return this;
    }
}

const CAMERA_BOUNDING_SPHERE_RADIUS = 15;
const ORTHO_LOD_ZOOM_THRESHOLD = 2;
const HEADER_TEXELS = 1;
const TEXELS_PER_REGION = 7; // 1 region header + 4 modelMatrix + 1 min + 1 max
const MAX_REGIONS = 256;
var MeshState;
(function (MeshState) {
    MeshState[MeshState["None"] = 0] = "None";
    MeshState[MeshState["Loading"] = 1] = "Loading";
    MeshState[MeshState["Processing"] = 2] = "Processing";
    MeshState[MeshState["Rendered"] = 3] = "Rendered";
})(MeshState || (MeshState = {}));

/**
 * Apply a custom shader to the material to implement masking based on the provided mask data texture.
 *
 * This is part of the mask-cube seam — it is only wired up when a `maskDataTexture` is supplied.
 * Both apps consume it: the Editor's mask feature and the Platform's mask display layer each build
 * the texture app-side and hand it to the tiles.
 *
 * @param material The material to which the masking shader will be applied.
 * @param maskDataTexture The data texture containing mask information.
 */
const applyMaskingShaderToMaterial = (material, maskDataTexture) => {
    material.onBeforeCompile = (shader) => {
        shader.uniforms = {
            ...shader.uniforms,
            uRegionTex: { value: maskDataTexture },
        };
        // Get the position of the fragment in world space by appending it to the beginning of the shader.
        // We still need the original shader for other parts of the rendering.
        shader.vertexShader = shader.vertexShader.replace(`void main() {`, `
        varying vec4 fragPosition;

        void main() {
            fragPosition = modelMatrix * vec4(position, 1.0);
      `);
        // Add a check if the fragment is outside the masks and if so, set a lower opacity
        // or discard it altogether.
        // Replace the original diffuseColor to use the new opacity.
        // The original shader is retained as we still need it to render it as-is,
        // just with lower opacity or none as necessary.
        shader.fragmentShader = shader.fragmentShader
            .replace(`void main() {`, `
        precision highp float;

        uniform sampler2D uRegionTex;

        in vec4 fragPosition;

        const int HEADER_TEXELS = ${HEADER_TEXELS};
        const int TEXELS_PER_REGION = ${TEXELS_PER_REGION};
        const int MAX_REGIONS = ${MAX_REGIONS};

        /* Fetch a texel by absolute texel index */
        vec4 fetchTexel(int texelIndex) {
          return texelFetch(uRegionTex, ivec2(texelIndex, 0), 0);
        }

        /* Load region data */
        float getOpacity(int regionIndex) {
          int base = HEADER_TEXELS + regionIndex * TEXELS_PER_REGION;

          vec4 regionHeader = fetchTexel(base + 0);
          float opacity = regionHeader.x;

          mat4 regionModelMatrix = mat4(
            fetchTexel(base + 1),
            fetchTexel(base + 2),
            fetchTexel(base + 3),
            fetchTexel(base + 4)
          );

          vec3 minV = fetchTexel(base + 5).xyz;
          vec3 maxV = fetchTexel(base + 6).xyz;

          vec4 localPos = regionModelMatrix * fragPosition;

          return (all(greaterThanEqual(localPos.xyz, minV)) &&
                all(lessThanEqual(localPos.xyz, maxV))) ? opacity : 0.0;
        }

        void main() {
          vec4 header = fetchTexel(0);
          int regionCount = int(header.x);
          bool forceShowOutside = int(header.y) == 1;
          bool inside = false;
          float updatedOpacity = opacity;

          if (regionCount > 0) {
            for (int i = 0; i < MAX_REGIONS; i++) {
              if (i >= regionCount) break;

              float regionOpacity = getOpacity(i);
              if (regionOpacity > 0.0) {
                updatedOpacity = regionOpacity; // Use the opacity from the region data
                inside = true;
                break;
              }
            }

            if (!inside && !forceShowOutside) {
              discard;
            }
          }
        `)
            .replace(
        // prettier-ignore
        'vec4 diffuseColor = vec4( diffuse, opacity );', 'vec4 diffuseColor = vec4( diffuse, updatedOpacity );');
    };
};

/**
 * Dispose material and its textures to free up memory.
 *
 * @param mat Material or array of materials to dispose
 */
const disposeMaterial = (mat) => {
    if (Array.isArray(mat)) {
        mat.forEach((m) => (m instanceof Material ? disposeMaterial(m) : null));
    }
    else if (mat instanceof Material) {
        if (mat instanceof MeshPhongMaterial && mat.map)
            mat.map.dispose();
        mat.dispose();
    }
};

const lodRaycaster = new Raycaster();
/**
 * LODGroup class extending Three.js Group to manage individual mesh with LODs.
 * This class does not mean a speciific LOD, but rather a container for LOD meshes to
 * be swapped based on camera distance.
 */
class MeshTile extends Group$2 {
    /**
     * Create a LODGroup instance.
     *
     * @param meshEntry Mesh bundle entry from manifest
     */
    constructor(meshEntry) {
        super();
        /**
         * Center point of the LOD group mesh.
         */
        this.center = null;
        /**
         * Bounding box of the LOD group mesh.
         */
        this.boundingBox = null;
        /**
         * Whether to enable depth test when rendering this tile.
         */
        this.depthTest = true;
        /**
         * Whether to enable depth write when rendering this tile.
         */
        this.depthWrite = true;
        /**
         * Original OBJ file path for later use.
         */
        this.objFilePath = null;
        /**
         * Mask regions to apply to the tile, if any.
         * Formated in DataTexture for shader use.
         */
        this.maskDataTexture = null;
        /**
         * Opacity of the tile.
         */
        this.opacity = 1;
        /**
         * Current LOD being used.
         */
        this.currentLOD = -1;
        /**
         * Highest LOD index available.
         */
        this.highestLOD = -1;
        /**
         * LOD indices to remove on cleanup.
         * Adding LOD indices here will remove them at the next cleanup call.
         *
         * Holds map of LOD index to timestamp when it can be removed.
         */
        this.lodCleanupBin = {};
        /**
         * Offset positioning of the LOD tile, if any.
         * This is not applied to the tile itself, but will be used when loading LODs.
         */
        this.offsetPosition = null;
        /**
         * Abort controller for ongoing LOD loads.
         */
        this.abortController = null;
        this.center = meshEntry.center ? new Vector3(...meshEntry.center) : null;
        this.boundingBox = meshEntry.bbox
            ? new Box3(new Vector3(...meshEntry.bbox.min), new Vector3(...meshEntry.bbox.max))
            : null;
        this.userData = meshEntry;
        this.highestLOD = meshEntry.lods.length - 1;
        tagAsSolidMesh(this);
        this.urlGenerator = (path) => Promise.resolve(path);
    }
    /**
     * Override add function to modify the mesh or materials for metadata or shaders
     * that is a standard for all tiles.
     *
     * @param object Object3D(s) to add to the group
     * @returns
     */
    add(...object) {
        super.add(...object);
        object.forEach((obj) => {
            tagAsSolidMesh(obj);
        });
        this.applyMaterialParams();
        return this;
    }
    /**
     * Override raycast function to first check for bounding box intersection before doing detailed raycast on the mesh.
     * @param raycaster Raycaster object from Three.js
     * @param intersects Array to store raycast intersection results
     */
    raycast(raycaster, intersects) {
        // Only raycast if the tile is visible and has a bounding box for intersection
        if (!this.visible || !this.boundingBox)
            return;
        const intersection = raycaster.ray.intersectBox(this.boundingBox, new Vector3());
        if (intersection) {
            super.raycast(raycaster, intersects);
        }
    }
    /**
     * Set URL generator function.
     * @param urlGenerator
     */
    setURLGenerator(urlGenerator) {
        this.urlGenerator = urlGenerator;
    }
    /**
     * Runs the tick for this tile.
     */
    async tick(camera) {
        // Clean up flags/caches
        this.cleanup();
        // Load appropriate LOD based on camera position, but only if the tile is visible
        if (this.visible) {
            await this.loadLOD(this.getLODLevel(camera));
        }
    }
    /**
     * Determine appropriate LOD level based on camera position.
     *
     * @param camera Active camera
     * @returns LOD index to load
     */
    getLODLevel(camera) {
        const highestLOD = this.userData.lods.length - 1;
        if (!camera || !this.boundingBox)
            return highestLOD;
        // -- Perspective Camera will be based on bounding sphere intersection of camera to
        //    tile's bounding box
        if (camera instanceof PerspectiveCamera) {
            // Generate camera's bounding sphere for LOD calculations
            // Note the check will be bounding box intersection, so the mesh may end up
            // being loaded even if the actual mesh is still a distance away from the camera.
            const cameraSphere = new Sphere(camera.position, CAMERA_BOUNDING_SPHERE_RADIUS);
            // Only supporting 2 LOD levels for now
            return cameraSphere.intersectsBox(this.boundingBox) ? 0 : highestLOD;
        }
        // -- Orthographic Camera will be based on zoom level as well as what the camera is looking at
        if (camera instanceof OrthographicCamera) {
            // Figure out what we're looking at by casting a ray from the camera center
            lodRaycaster.ray.origin.copy(camera.position);
            lodRaycaster.ray.direction.set(0, 0, -1).applyQuaternion(camera.quaternion);
            const intersected = lodRaycaster.ray.intersectBox(this.boundingBox, new Vector3());
            const zoom = camera.zoom || 1;
            // Within zoom level threshold and looking at the tile, load highest LOD
            // (as we're still only supporting 2 LOD levels for now)
            if (zoom >= ORTHO_LOD_ZOOM_THRESHOLD && !!intersected) {
                return 0;
            }
        }
        return highestLOD;
    }
    /**
     * Cleanly remove all loaded LODs and reset current LOD.
     */
    clear() {
        if (!this?.traverse)
            return this;
        this.traverse((child) => {
            if (child instanceof Mesh && child.geometry instanceof BufferGeometry) {
                // Dispose geometry
                child.geometry.dispose();
                // Dispose material and textures
                if (child.material instanceof Material || Array.isArray(child.material)) {
                    disposeMaterial(child.material);
                }
            }
            this.remove(child);
        });
        super.clear();
        return this;
    }
    /**
     * Clean up non-active LODs to save memory.
     * Should only be used to unload higher-res LODs when a lower-res LOD is loaded
     * to prevent unnecessary stuttering.
     */
    cleanup() {
        // Remove high-res LODs from scene to save memory
        this.children.forEach((child) => {
            // ignore anything other than Group
            if (!(child instanceof Group$2))
                return;
            if (child.userData.lod in this.lodCleanupBin &&
                new Date().getTime() >= this.lodCleanupBin[child.userData.lod] &&
                child.userData.lod !== this.currentLOD) {
                child.traverse((grandChild) => {
                    if (grandChild instanceof Mesh && grandChild.geometry instanceof BufferGeometry) {
                        // Dispose geometry
                        grandChild.geometry.dispose();
                        // Dispose material and textures
                        if (grandChild.material instanceof Material || Array.isArray(grandChild.material)) {
                            disposeMaterial(grandChild.material);
                        }
                    }
                });
                this.remove(child);
            }
        });
    }
    /**
     * Abort any ongoing LOD loading.
     */
    abort() {
        if (this.abortController) {
            this.abortController.abort();
            this.abortController = null;
        }
    }
    /**
     * Mark non-active LODs for removal.
     *
     * @param object Object3D to keep active
     */
    removeInactiveLODs(object) {
        // Remove high-res LODs from scene to save memory
        this.children.forEach((child) => {
            // ignore anything other than Group
            if (!(child instanceof Group$2))
                return;
            if (child !== object) {
                child.visible = false;
                // Keep highest LOD and queue for removal after delay
                if (this.highestLOD !== child.userData.lod) {
                    this.lodCleanupBin[child.userData.lod] = new Date().getTime() + 15000; // 15 seconds delay
                }
            }
        });
    }
    /**
     * Set offset position to the LOD tile.
     * Will also recalculate bounding box position if applicable.
     * @param offset Vector3 offset to apply
     */
    setOffsetPosition(offset) {
        this.offsetPosition = offset;
        if (this.boundingBox) {
            const size = new Vector3();
            this.boundingBox.getSize(size);
            const newMin = this.center ? this.center.clone().sub(size.clone().multiplyScalar(0.5)).add(offset) : null;
            const newMax = this.center ? this.center.clone().add(size.clone().multiplyScalar(0.5)).add(offset) : null;
            if (newMin && newMax) {
                this.boundingBox.set(newMin, newMax);
            }
        }
    }
    /**
     * Apply masking shader to material
     */
    applyMaterialParams() {
        if (!this.maskDataTexture)
            return;
        this.traverse((child) => {
            if (!(child instanceof Mesh) || !this.maskDataTexture)
                return;
            if (child.material instanceof Material) {
                applyMaskingShaderToMaterial(child.material, this.maskDataTexture);
                child.material.depthTest = this.depthTest;
                child.material.depthWrite = this.depthWrite;
                child.material.opacity = this.opacity;
                child.material.transparent = this.opacity < 1;
                child.material.needsUpdate = true;
            }
            else if (Array.isArray(child.material)) {
                child.material.forEach((mat) => {
                    applyMaskingShaderToMaterial(mat, this.maskDataTexture);
                    mat.depthTest = this.depthTest;
                    mat.depthWrite = this.depthWrite;
                    mat.opacity = this.opacity;
                    mat.transparent = this.opacity < 1;
                    mat.needsUpdate = true;
                });
            }
            child.renderOrder = this.depthTest || this.depthWrite ? 0 : -1;
        });
    }
    /**
     * Set opacity for the tile and update materials accordingly.
     *
     * @param opacity Opacity value between 0 and 1
     */
    setOpacity(opacity) {
        this.opacity = opacity;
        this.traverse((child) => {
            if (!(child instanceof Mesh))
                return;
            if (child.material instanceof Material) {
                child.material.opacity = opacity;
                child.material.transparent = opacity < 1;
                child.material.needsUpdate = true;
            }
            else if (Array.isArray(child.material)) {
                child.material.forEach((mat) => {
                    mat.opacity = opacity;
                    mat.transparent = opacity < 1;
                    mat.needsUpdate = true;
                });
            }
        });
    }
}

class MeshTileDebug extends MeshTile {
    constructor() {
        super(...arguments);
        /**
         * Bounding box helper for debugging purposes.
         */
        this.boundingBoxHelper = null;
        /**
         * Disable LOD intersect highlight effect.
         */
        this.disableLodIntersectHighlight = false;
    }
    /**
     * Enable debugging visuals for the mesh tile.
     */
    debug() {
        this.showBoundingBoxHelper();
    }
    /**
     * Show bounding box helper for debugging.
     */
    showBoundingBoxHelper() {
        if (this.boundingBox && !this.boundingBoxHelper) {
            this.boundingBoxHelper = addBox3Helper(this, `solid-mesh-bbox-helper-${this.userData.id}`, this.boundingBox.clone(), 0xffff00);
        }
    }
    /**
     * Set bounding box helper color.
     *
     * @param color Color to set for the bounding box helper
     * @param force Whether to force the color regardless of LOD intersect state
     */
    setBoundingBoxColor(color, force = false) {
        if (!this.boundingBoxHelper || !(this.boundingBoxHelper.material instanceof LineBasicMaterial))
            return;
        this.boundingBoxHelper.material.color.set(color);
        this.disableLodIntersectHighlight = force;
    }
    /**
     * Runs the tick for this tile.
     *
     * @param camera The camera to check for LOD intersection
     */
    async tick(camera) {
        // Check if camera sphere intersects with bounding box
        if (this.boundingBoxHelper && !this.disableLodIntersectHighlight) {
            if (this.getLODLevel(camera) === 0) {
                this.setBoundingBoxColor(0x0000ff);
            }
            else {
                this.setBoundingBoxColor(0xffff00);
            }
        }
        return super.tick(camera);
    }
}

/**
 * Fetch a file into an ArrayBuffer with progress + abort support (via XHR).
 *
 * @param url URL to fetch
 * @param signal Optional AbortSignal to cancel the request
 * @param onProgress Optional progress callback (0 to 1)
 */
const fetchBufferWithProgress = async (url, signal, onProgress) => new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'arraybuffer';
    if (onProgress) {
        xhr.onprogress = (event) => {
            if (event.lengthComputable) {
                onProgress(event.loaded / event.total);
            }
        };
    }
    xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
            resolve(xhr.response);
        }
        else {
            reject(new Error(xhr.statusText || `HTTP ${xhr.status}`));
        }
    };
    xhr.onerror = () => reject(new Error('Network error'));
    xhr.onabort = () => reject(new AbortError('Request aborted', url));
    if (signal) {
        signal.addEventListener('abort', () => {
            xhr.abort();
        });
    }
    xhr.send();
});
/**
 * Load materials from MTL files and apply to OBJ file.
 * @param objFile URL of the OBJ file
 * @param mtlFiles Array of MTL file URLs and their corresponding texture overrides
 * @param onProgress Optional progress callback.
 */
const loadObjMtl = async (objFile, mtlFiles, onProgress) => {
    if (mtlFiles?.length === 0)
        return null;
    const objLoader = new OBJLoader();
    const mtlLoader = new MTLLoader();
    // 1. Load all MTL files in parallel
    const creators = await Promise.all(mtlFiles.map(({ mtl_file }) => new Promise((resolve, reject) => {
        mtlLoader.load(mtl_file, resolve, (progressEvent) => {
            if (onProgress && progressEvent.total) {
                const progress = (progressEvent.loaded / progressEvent.total) * 100;
                onProgress(mtl_file, progress);
            }
        }, reject);
    })));
    if (creators.length === 0)
        return null;
    // 2. Push all materials into a single MaterialCreator
    const merged = creators[0];
    // merged.baseUrl = ''
    creators.slice(1).forEach((creator) => {
        merged.materialsInfo = { ...merged.materialsInfo, ...creator.materialsInfo };
        merged.materials = { ...merged.materials, ...creator.materials };
    });
    // Go through each material info and update URL in materialsInfo
    mtlFiles.forEach(({ textures }) => {
        // If there's only 1 texture mapping, use as fallback for missing mappings
        const txts = Object.values(textures);
        const urls = txts.length === 1 ? Object.fromEntries(Object.entries(txts[0]).map(([k, v]) => [k.toLowerCase(), v])) : null;
        Object.entries(textures).forEach(([texMatName, texMatInfo]) => {
            const texMatNameLower = texMatName.toLowerCase();
            Object.entries(merged.materialsInfo).forEach(([matName, info]) => {
                const matNameLower = matName.toLowerCase();
                Object.entries(texMatInfo).forEach(([texAttrName]) => {
                    const texAttrNameLower = texAttrName.toLowerCase();
                    if (texAttrNameLower in info && texAttrName in texMatInfo && matNameLower === texMatNameLower) {
                        // @ts-expect-error TS would complain about dynamic key assignment
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                        info[texAttrNameLower] = texMatInfo[texAttrName];
                    }
                    else if (urls && texAttrNameLower in urls) {
                        // @ts-expect-error TS would complain about dynamic key assignment
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                        info[texAttrNameLower] = urls[texAttrNameLower];
                    }
                });
            });
        });
    });
    // Preload and adjust material settings
    merged.preload();
    Object.values(merged.materials).forEach((mat) => {
        mat.side = DoubleSide;
        mat.alphaTest = 0.01;
    });
    // 5. Load the OBJ with the materials
    return new Promise((resolve, reject) => {
        objLoader.setMaterials(merged);
        objLoader.load(objFile, resolve, (progressEvent) => {
            if (onProgress && progressEvent.total) {
                const progress = (progressEvent.loaded / progressEvent.total) * 100;
                onProgress(objFile, progress);
            }
        }, reject);
    });
};
/**
 * Fetches an image pack, parses it, and returns a map of MeshPhongMaterials keyed by filename.
 *
 * @param url URL of the packed material file
 * @param abortSignal Optional AbortSignal to cancel the fetch request
 * @param onProgress Optional progress callback (0 to 1).
 * @returns A promise that resolves to a record mapping material names to MeshPhongMaterial instances.
 */
const loadMaterialsFromImagePack = async (url, abortSignal, onProgress) => {
    let buffer = Cache.get(url);
    if (!buffer) {
        buffer = await fetchBufferWithProgress(url, abortSignal, onProgress ? (progress) => onProgress(url, progress) : undefined);
        // # FIXME: revisit after implement integration with S3 signed URL with expiry
        Cache.add(url, buffer);
    }
    const view = new DataView(buffer);
    const decoder = new TextDecoder('utf-8');
    const materials = {};
    let offset = 0;
    const tasks = [];
    // --- Header: magic + version + .mtl content length + .mtl content ---
    // 4 bytes: magic "MTLP"
    const magicBytes = new Uint8Array(buffer, offset, 4);
    const magic = decoder.decode(magicBytes);
    offset += 4;
    if (magic !== 'MTLP') {
        throw new Error(`Unsupported texture pack format (magic=${magic})`);
    }
    // 2 bytes: version
    const version = view.getUint16(offset, false);
    offset += 2;
    if (version !== 1) {
        throw new Error(`Unsupported texture pack version: ${version}`);
    }
    // 4 bytes: mtl_length
    const mtlLength = view.getUint32(offset, false);
    offset += 4;
    // mtl_length bytes: .mtl content (currently unused, but parsed to
    // keep the reader aligned with the packer format)
    if (mtlLength > 0) {
        offset += mtlLength;
    }
    while (offset < buffer.byteLength) {
        // filename length
        const nameLen = view.getUint16(offset, false);
        offset += 2;
        // filename
        const nameBytes = new Uint8Array(buffer, offset, nameLen);
        const name = decoder.decode(nameBytes);
        offset += nameLen;
        // image size
        const imageSize = view.getUint32(offset, false);
        offset += 4;
        // image bytes
        const imageBytes = new Uint8Array(buffer, offset, imageSize);
        offset += imageSize;
        // Create a blob URL for the image
        const blob = new Blob([imageBytes], { type: 'image/jpeg' });
        const imageUrl = URL.createObjectURL(blob);
        // Load the texture asynchronously
        const task = new Promise((resolve, reject) => {
            // Look in DOM first
            const existingImg = document.querySelector(`img[data-src="${imageUrl}"]`);
            const textureLoader = new Texture();
            textureLoader.needsUpdate = true;
            const material = new MeshPhongMaterial({
                name,
                map: textureLoader,
                side: DoubleSide,
                alphaTest: 0.01,
            });
            if (existingImg) {
                textureLoader.image = existingImg;
                resolve({ name, material });
                return;
            }
            const img = new Image();
            img.onload = () => {
                textureLoader.image = img;
                textureLoader.needsUpdate = true;
                // set to DOM for caching
                img.setAttribute('data-src', imageUrl);
                img.style.display = 'none';
                document.body.appendChild(img);
                // Revoke the blob URL after loading
                URL.revokeObjectURL(imageUrl);
                resolve({ name, material });
            };
            img.onerror = (err) => {
                // eslint-disable-next-line no-console
                console.error('Failed to load texture image from pack', { imageUrl, name, err });
                // Revoke the blob URL on error as well
                URL.revokeObjectURL(imageUrl);
                reject(new Error(`Failed to load texture image: ${name}`));
            };
            img.src = imageUrl;
        });
        tasks.push(task);
    }
    const results = await Promise.all(tasks);
    results.forEach(({ name, material }) => {
        materials[name] = material;
    });
    return materials;
};
const objLoader = new OBJLoader();
/**
 * Load an OBJ file with a packed materials.
 *
 * @param objFile URL of the OBJ file
 * @param packFile URL of the packed material file
 * @param abortSignal Optional AbortSignal to cancel the fetch request
 * @param onProgress Optional progress callback (0 to 100).
 */
const loadObjPacked = async (objFile, packFile, abortSignal, onProgress) => {
    // 1. Fetch texture pack and parse into materials
    const materials = await loadMaterialsFromImagePack(packFile, abortSignal, (fileName, progress) => {
        onProgress?.(fileName, progress * 100 * 0.5);
    });
    // 5. Load the OBJ with the materials
    return new Promise((resolve, reject) => {
        objLoader.load(objFile, resolve, (progressEvent) => {
            if (onProgress && progressEvent.total) {
                const progress = (progressEvent.loaded / progressEvent.total) * 100 * 0.5 + 50;
                onProgress(objFile, progress);
            }
        }, reject);
    }).then((object) => {
        // Apply loaded materials to meshes based on material name
        object.traverse((child) => {
            if (child instanceof Mesh) {
                // If there's only 1 material, assign it directly
                const allMaterials = Object.values(materials);
                if (allMaterials.length === 1) {
                    [child.material] = allMaterials;
                }
                else {
                    child.material = allMaterials;
                }
            }
        });
        return object;
    });
};
/**
 * Load an OBJ file with either multiple MTL files or a packed material file.
 *
 * @param objFile URL of the OBJ file
 * @param mtlFiles Array of MTL files with texture mappings
 * @param mtlPack URL of the packed material file
 * @param abortSignal Optional AbortSignal to cancel the fetch request
 * @param onProgress Optional progress callback (0 to 100)
 */
const loadObjV2 = async (objFile, mtlFiles, mtlPack, abortSignal, onProgress) => {
    // Prioritize packed materials if available
    if (mtlPack) {
        return loadObjPacked(objFile, mtlPack, abortSignal, onProgress);
    }
    if (mtlFiles && mtlFiles.length > 0) {
        return loadObjMtl(objFile, mtlFiles, onProgress);
    }
    return Promise.resolve(null);
};

/**
 * MeshTileObj class extending MeshTile to manage obj tiles.
 * This class does not mean a speciific Mesh, but rather a container to manage
 * meshes within the tile for optimized rendering.
 */
class MeshTileObj extends MeshTileDebug {
    constructor() {
        super(...arguments);
        /**
         * Currently loading LOD flags to prevent duplicate loads.
         */
        this.loadingLOD = [];
    }
    /**
     * Load specific LOD index
     *
     * @param lodIndex LOD index to load
     */
    async loadLOD(lodIndex) {
        if (lodIndex < 0 || lodIndex >= this.userData.lods.length || lodIndex === this.currentLOD)
            return;
        const localAreaId = this.parent instanceof MeshTilesManager ? this.parent.userData.inspectionAreaId : null;
        // Find and show the child with the desired LOD if already loaded
        for (let i = 0; i < this.children.length; i += 1) {
            const child = this.children[i];
            if (lodIndex === child.userData.lod) {
                child.visible = true;
                this.currentLOD = lodIndex;
                this.removeInactiveLODs(child);
                return;
            }
        }
        const lodEntry = this.userData.lods[lodIndex];
        const { obj_file, mtl_files, mtl_pack } = lodEntry;
        if (!obj_file || (!mtl_files?.length && !mtl_pack)) {
            // Inform manager we're done with this Tile even if there's no file to load, to prevent hanging loading state
            // Then removing it completely to stop the manager from ticking it again.
            if (this.parent instanceof MeshTilesManager) {
                this.parent.onLoadingLOD(this, 100);
            }
            this.parent?.remove(this);
            return;
        }
        // Replace OBJ and MTL file paths with full URL
        const objFile = await this.urlGenerator(obj_file);
        const mtlFiles = mtl_files
            ? await Promise.all(mtl_files.map(async (mtl) => ({
                mtl_file: await this.urlGenerator(mtl.mtl_file),
                textures: Object.fromEntries(await Promise.all(Object.entries(mtl.textures).map(async ([key, mapSlots]) => [
                    key,
                    Object.fromEntries(await Promise.all(Object.entries(mapSlots).map(async ([slot, path]) => typeof path === 'string' ? [slot, await this.urlGenerator(path)] : [slot, path]))),
                ]))),
            })))
            : undefined;
        const mtlPack = mtl_pack ? await this.urlGenerator(mtl_pack) : undefined;
        // Prevent multiple loads for the same LOD
        if (this.loadingLOD[lodIndex])
            return;
        this.loadingLOD[lodIndex] = true;
        // Abort previous loading if any, and create new abort controller
        if (this.abortController)
            this.abortController.abort();
        this.abortController = new AbortController();
        await loadObjV2(objFile, mtlFiles, mtlPack, this.abortController.signal, (fileName, progress) => {
            if (this.parent instanceof MeshTilesManager) {
                this.parent.onLoadingLOD(this, progress);
            }
        })
            .then((object) => {
            let hasMaterial = false;
            object?.traverse((child) => {
                if (child instanceof Mesh) {
                    hasMaterial = child.material !== undefined;
                }
            });
            // Safeguard against OBJ files without material, threeJS will error out mesh without material
            if (!hasMaterial) {
                // eslint-disable-next-line no-console
                console.warn(`Loaded tile (${this.userData.id}) does not contain material, skipping:`, objFile);
                return;
            }
            // Check if we're still within the same area before adding the loaded object
            if (!this.parent ||
                (this.parent instanceof MeshTilesManager && this.parent.userData.inspectionAreaId !== localAreaId)) {
                // Clear cache if any to not waste memory
                Cache.remove(objFile);
                if (mtlPack)
                    Cache.remove(mtlPack);
                this.loadingLOD[lodIndex] = false;
                return;
            }
            if (object) {
                this.loadingLOD[lodIndex] = false;
                this.objFilePath = obj_file;
                this.currentLOD = lodIndex;
                object.userData = {
                    meshId: this.userData.id,
                    lod: lodIndex,
                };
                this.add(object);
                this.removeInactiveLODs(object);
            }
        })
            .catch((err) => {
            this.loadingLOD[lodIndex] = false;
            // Don't report abort errors
            if (!(err instanceof AbortError)) {
                // eslint-disable-next-line no-console
                console.error('Failed to load solid mesh LOD', { lodIndex, userData: this.userData, err });
            }
        });
    }
}

const useLODManager = (tilesManager) => {
    // Hooks
    const { camera } = useThree();
    // Refs
    const lastPosition = useRef(undefined);
    /**
     * Track camera position changes to update LODs.
     * Throttled since we don't need to update LODs every frame.
     */
    const updateLod = a(() => {
        if (!tilesManager || !camera)
            return;
        // Check if camera has moved significantly
        if (lastPosition.current) {
            const dist = lastPosition.current.distanceTo(camera.position);
            if (dist < 0.5)
                return;
        }
        // Tick Tiles Manager to update LODs
        tilesManager.tick();
        if (!lastPosition.current)
            lastPosition.current = camera.position.clone();
        else
            lastPosition.current.copy(camera.position);
    }, 500);
    useFrame(updateLod);
};

/**
 * Get the points of the convex polygon formed by intersecting a box with a plane.
 * Used by extend-to-bbox: a drawn plane is extended to the edges of the scene bounding
 * box. Returns up to 4 sorted points, or `null` when the plane misses the box.
 *
 * Ported from Editor `@/services/Plane`.
 *
 * @param box Bounding box (e.g. `sceneDetails.bbox`).
 * @param plane Intersection plane derived from the placed points.
 */
const getPlaneQuadInBox = (box, plane) => {
    const corners = [
        new Vector3(box.min.x, box.min.y, box.min.z),
        new Vector3(box.max.x, box.min.y, box.min.z),
        new Vector3(box.max.x, box.max.y, box.min.z),
        new Vector3(box.min.x, box.max.y, box.min.z),
        new Vector3(box.min.x, box.min.y, box.max.z),
        new Vector3(box.max.x, box.min.y, box.max.z),
        new Vector3(box.max.x, box.max.y, box.max.z),
        new Vector3(box.min.x, box.max.y, box.max.z),
    ];
    // prettier-ignore
    const edgePairs = [
        [0, 1], [1, 2], [2, 3], [3, 0],
        [4, 5], [5, 6], [6, 7], [7, 4],
        [0, 4], [1, 5], [2, 6], [3, 7],
    ];
    const intersections = [];
    const a = new Vector3();
    const b = new Vector3();
    const hit = new Vector3();
    // edge-plane intersections
    for (let i = 0; i < edgePairs.length; i += 1) {
        a.copy(corners[edgePairs[i][0]]);
        b.copy(corners[edgePairs[i][1]]);
        const da = plane.distanceToPoint(a);
        const db = plane.distanceToPoint(b);
        if (da * db < 0) {
            const t = da / (da - db);
            hit.copy(a).lerp(b, t);
            intersections.push(hit.clone());
        }
    }
    if (intersections.length < 3)
        return null;
    // -------------------------
    // Sort points on the plane
    // -------------------------
    // centroid
    const center = new Vector3();
    for (let i = 0; i < intersections.length; i += 1) {
        center.add(intersections[i]);
    }
    center.multiplyScalar(1 / intersections.length);
    // build orthonormal basis
    const normal = plane.normal.clone().normalize();
    const tangent = new Vector3();
    // pick a vector not parallel to normal
    if (Math.abs(normal.x) > 0.9) {
        tangent.set(0, 1, 0); // use Y if X is dominant
    }
    else {
        tangent.set(1, 0, 0); // otherwise use X
    }
    // project tangent onto plane: T = T - (T·N)N
    tangent.sub(normal.clone().multiplyScalar(tangent.dot(normal))).normalize();
    // B = N × T
    const bitangent = new Vector3().crossVectors(normal, tangent);
    // sort by angle
    intersections.sort((p1, p2) => {
        const v1 = p1.clone().sub(center);
        const v2 = p2.clone().sub(center);
        const a1 = Math.atan2(v1.dot(bitangent), v1.dot(tangent));
        const a2 = Math.atan2(v2.dot(bitangent), v2.dot(tangent));
        return a1 - a2;
    });
    // -------------------------
    // Ensure exactly 4 points
    // -------------------------
    if (intersections.length === 4)
        return intersections;
    // If more than 4 (usually 5 or 6), pick farthest 4 from center
    intersections.sort((p1, p2) => center.distanceTo(p2) - center.distanceTo(p1));
    return intersections.slice(0, 4);
};
/**
 * Sort rectangle corner points into a consistent winding order by angle around their
 * centroid (projected onto the XY plane). Used after {@link getPlaneQuadInBox} so the
 * extended rectangle triangulates / renders without crossed edges.
 *
 * Ported from Editor `@/services/Shape`.
 *
 * @param points The (unordered) rectangle corner points.
 */
const sortRectanglePoints3D = (points) => {
    // Calculate the centroid of the rectangle
    const centroid = points.reduce((acc, point) => acc.add(point), new Vector3()).divideScalar(points.length);
    // Project the points onto the XY plane
    const points2D = points.map((point) => new Vector2(point.x, point.y));
    const centroid2D = new Vector2(centroid.x, centroid.y);
    // Sort the points based on their angle relative to the centroid in the 2D plane
    const sortedPoints2D = points2D.sort((p1, p2) => {
        const angleA = Math.atan2(p1.y - centroid2D.y, p1.x - centroid2D.x);
        const angleB = Math.atan2(p2.y - centroid2D.y, p2.x - centroid2D.x);
        return angleA - angleB;
    });
    // Map the sorted 2D points back to the original 3D points
    const sortedPoints = sortedPoints2D.map((sortedPoint2D) => points.find((point) => point.x === sortedPoint2D.x && point.y === sortedPoint2D.y));
    return sortedPoints;
};

/** Above the PCD; matches the in-progress preview's ordering. */
const FILL_RENDER_ORDER = 18;
/**
 * Stable noop. The `Anchor` only enables dragging when an `onUpdated` is present (it never
 * calls it); a module-level constant keeps its identity stable so the anchor's drag effect
 * doesn't re-fire every render — emission happens in `onComplete` instead.
 */
const NOOP = () => { };
/**
 * Renders a plane derived from `vertices`, extended to the scene bounding box
 * (`sceneDetails.bbox`). The derivation is package-internal — the consumer passes only the
 * committed points, never per-move geometry. Used for the CameraProfile committed shape.
 *
 * When `editable`, anchors on the placed points are draggable: a drag re-derives the
 * rectangle live (decoupled-anchor model) and emits the updated points on release via
 * `onAdjusted`.
 */
const ExtendedPlane = ({ id = 'extended-plane', vertices, style, editable = false, showAnchors = editable, onAdjusted, }) => {
    const { sceneDetails } = useThreeCanvasContext();
    /**
     * Live copy of the placed points. Dragging an anchor mutates this so the rectangle
     * re-derives without a consumer round-trip; it resyncs whenever the committed `vertices`
     * prop changes. The ref mirrors it so the release handler reads the latest without stale
     * closures.
     */
    const [liveVertices, setLiveVertices] = useState(vertices);
    const liveVerticesRef = useRef(vertices);
    // Resync by VALUE, not array identity: consumers often rebuild this array each render (e.g. from
    // a mapped `Vector3[]`), and an identity-based effect would re-fire on every re-render — wiping an
    // in-progress anchor drag on each pointer-move. Keying on the serialised points only resyncs when
    // the committed geometry actually changes.
    const verticesKey = JSON.stringify(vertices);
    useEffect(() => {
        liveVerticesRef.current = vertices;
        setLiveVertices(vertices);
        // eslint-disable-next-line react-hooks/exhaustive-deps -- `verticesKey` is the value-based proxy for `vertices`
    }, [verticesKey]);
    /**
     * Live anchor move: replace the dragged point and re-derive. Stable identity (reads the
     * ref, not state) so the anchor's drag effect only re-fires on actual position changes.
     */
    const handleAnchorUpdate = useCallback((anchorIndex, point) => {
        const next = liveVerticesRef.current.slice();
        next[anchorIndex] = point;
        liveVerticesRef.current = next;
        setLiveVertices(next);
    }, []);
    /** Anchor released: emit the committed points (perf guardrail — release only). */
    const handleAnchorComplete = useCallback(() => {
        onAdjusted?.(liveVerticesRef.current.map((p) => new Vector3(...p)));
    }, [onAdjusted]);
    /**
     * Derive the bbox-extended rectangle from the (live) placed points + scene bbox.
     */
    const rectangle = useMemo(() => {
        const bbox = sceneDetails?.bbox;
        if (liveVertices.length < 3 || !bbox)
            return null;
        const verts = liveVertices.map((p) => new Vector3(...p));
        const plane = new Plane().setFromCoplanarPoints(verts[0], verts[1], verts[2]);
        const quad = getPlaneQuadInBox(bbox, plane);
        if (!quad)
            return null;
        return sortRectanglePoints3D(quad).map((p) => p.toArray());
    }, [liveVertices, sceneDetails?.bbox]);
    if (!rectangle)
        return null;
    return (jsxs(Fragment, { children: [jsx(PolygonPlaneMesh, { id: id, isWorking: true, workingVertices: rectangle, ...style, depthTest: false, depthWrite: false, renderOrder: FILL_RENDER_ORDER }), showAnchors
                ? liveVertices.map((point, anchorIndex) => (jsx(Anchor, { id: `${id}-anchor-${anchorIndex}`, parentId: id, point: point, anchorIndex: anchorIndex, isInteractable: editable, isDraggable: editable, isParentHoverSelected: true, color: AnchorColors.Movable, outlineOpacity: 0, scale: 1.5, icon: CircleAnchorIcon.MOVE, iconColor: "white", iconScale: 1.3, onUpdate: editable ? handleAnchorUpdate : undefined, 
                    // Presence of `onUpdated` is what enables dragging on the Anchor; the actual
                    // emit happens on release in `onComplete` (Anchor never calls `onUpdated`).
                    onUpdated: editable ? NOOP : undefined, onComplete: editable ? handleAnchorComplete : undefined }, `${id}-anchor-${anchorIndex}`)))
                : null] }));
};

function useTransforms({ polygon, transformControls, onUpdated, onReset }) {
    // Store
    const currentTransformType = TransformTypes.SCALE; // useAppSelector((state) => state.editor.currentTransformType)
    const isAdjustingVertex = false; // useAppSelector((state) => state.toolUtil.core.isAdjustingVertex)
    // TODO: Transformation pivot point. [0,0,0] should never happen as polygon always comes with center defined
    // const pivot: PointArray = useMemo(() => polygon.center || [0, 0, 0], [polygon.center])
    // Refs
    const transformControlsRef = useRef(null);
    const controlledGroupRef = useRef(null);
    const isAnchorDown = useRef(false);
    // The actual controlled object, one that is controlled by TransformControls
    // is something it added itself that we can't add a ref to, but what it does is
    // adding our own defined children (controlledGroupRef) as a child to that object,
    // so we just reference the parent to get it.
    const controlledObject = controlledGroupRef.current?.parent;
    const anchors = useMemo(() => (controlledObject ? findObjectsOfType(controlledObject, 'CircleAnchor') : []), [controlledObject]);
    /**
     * Setup allowed transform types
     */
    useEffect(() => {
        // if (!transformControls?.allowedTransforms) return () => null
        // dispatch(setAllowedTransformControls(transformControls.allowedTransforms))
        // dispatch(setCurrentTransformType(transformControls.allowedTransforms[0]))
        // return () => {
        //   dispatch(resetTransformControls())
        // }
    }, [
    // transformControls?.allowedTransforms, dispatch
    ]);
    /**
     * Disable transform controls when it cannot be used.
     *
     * The flag will be used in other components to sync with transform controls state.
     */
    useEffect(() => {
        // dispatch(setDisableTransformControls(transformControls?.enabled !== undefined ? !transformControls.enabled : false))
    }, [
    // transformControls, dispatch
    ]);
    /**
     * Change transform mode when currentTransformType changes.
     */
    useEffect(() => {
        if (!transformControlsRef.current)
            return;
        transformControlsRef.current.setMode(currentTransformType);
    }, [currentTransformType]);
    /**
     * Hides transform controls when a vertex is being adjusted.
     */
    useEffect(() => {
        if (!transformControlsRef.current)
            return;
        transformControlsRef.current.visible = !isAdjustingVertex;
    }, [isAdjustingVertex]);
    const toggleAnchors = useCallback((visible) => {
        anchors.forEach((anchor) => {
            anchor.visible = visible;
        });
    }, [anchors]);
    /**
     * Handle mouse down on transform controls.
     *
     * We want to hide/disable any other possible interactions with the plane
     * to avoid conflicts while transforming.
     */
    const handleMouseDown = useCallback(() => {
        if (isAnchorDown.current)
            return;
        toggleAnchors(false);
    }, [toggleAnchors]);
    /**
     * Handle mouse up on transform controls.
     *
     * Restore whatever we hide/disabled on mouse down.
     * Also trigger onUpdated callback with latest positions and matrix.
     */
    const handleMouseUp = useCallback(() => {
        if (!controlledObject)
            return;
        toggleAnchors(true);
        if (onUpdated) {
            onUpdated(polygon?.positions ?? [], controlledObject.matrix);
        }
    }, [controlledObject, polygon?.positions, toggleAnchors, onUpdated]);
    /**
     * Handle reset transforms event.
     */
    useEffect(() => {
        const handleReset = () => {
            onReset?.();
        };
        document.addEventListener('transform-controls:reset', handleReset);
        return () => {
            document.removeEventListener('transform-controls:reset', handleReset);
        };
    }, [onReset]);
    return {
        transformControlsRef,
        controlledGroupRef,
        isAnchorDown,
        toggleAnchors,
        handleMouseUp,
        handleMouseDown,
    };
}

/**
 * Wrapper around PolygonPlaneMesh to make it transformable with TransformControls.
 *
 * Only one can be used/rendered at the same time as various flags and events does not
 * have any identifications to differentiate multiple instances.
 *
 * @param props Same as Polygon plane mesh props.
 */
const PolygonPlaneMeshTransformable = (props) => {
    const { vertexAnchors } = props;
    const { transformControlsRef, controlledGroupRef, isAnchorDown, handleMouseUp, handleMouseDown } = useTransforms(props);
    // Desctructure props
    const { polygon, offsetTransformation, transformControls } = props;
    // Detect if user is on mobile for transform control sizing
    const isMobile = useMemo(() => /Mobi|Android/i.test(navigator.userAgent), []);
    // Store
    const currentTransformType = TransformTypes.SCALE; // useAppSelector((state) => state.editor.currentTransformType)
    // Transformation pivot point. [0,0,0] should never happen as polygon always comes with center defined
    const pivot = useMemo(() => transformControls?.pivotPoint || polygon?.center || [0, 0, 0], [transformControls?.pivotPoint, polygon?.center]);
    /**
     * Setup offset matrix.
     * Use whatever is provided, or identity if none.
     */
    const offsetMatrix = useMemo(() => {
        if (offsetTransformation instanceof Matrix4)
            return offsetTransformation;
        return offsetTransformation ? new Matrix4().fromArray(offsetTransformation) : new Matrix4().identity();
    }, [offsetTransformation]);
    /**
     * Get position from offset matrix.
     */
    const { position: offsetPosition, quaternion: offsetQuaternion } = useMemo(() => {
        if (!offsetTransformation)
            return { position: new Vector3(), quaternion: new Quaternion(), matrix: new Matrix4() };
        const pos = new Vector3();
        const quat = new Quaternion();
        offsetMatrix.decompose(pos, quat, new Vector3());
        return {
            position: pos,
            quaternion: quat,
            matrix: offsetMatrix,
        };
    }, [offsetTransformation, offsetMatrix]);
    return (jsx(TransformControls, { ref: transformControlsRef, size: isMobile ? 1 : 0.75, space: "local", mode: currentTransformType, enabled: (transformControls?.enabled ?? true) && true && !!currentTransformType, position: offsetPosition, quaternion: offsetQuaternion, onMouseUp: handleMouseUp, onMouseDown: handleMouseDown, children: jsx("group", { ref: controlledGroupRef, name: "PolygonPlaneMeshTransformableGroup", children: jsx(PolygonPlaneMesh, { ...props, origin: pivot, offsetTransformation: new Matrix4().identity(), vertexAnchors: vertexAnchors
                    ? {
                        ...vertexAnchors,
                        onDown: (anchorIndex, event) => {
                            // If vertex was modified while user is hovering over transform controls,
                            // transform controll will think the mouse operation is on itself
                            // but since this is fired first, we set the flag to indicate anchor is
                            // being pressed down so transform controls can ignore the mouse events.
                            isAnchorDown.current = true;
                            vertexAnchors.onDown?.(anchorIndex, event);
                        },
                        onUpdated(points) {
                            isAnchorDown.current = false;
                            vertexAnchors.onUpdated?.(points);
                        },
                    }
                    : undefined }) }) }));
};

/**
 * Adds a circle to the canvas, generally used for interactable anchors.
 */
const CircleAnchor = ({ id, point, scale = 1, innerScale = 0.75, hoverScale = 1.1, icon, iconColor, iconScale = 0.8, color = 'red', outlineColor = 'white', outlineOpacity = 1, opacity = 1, tooltipText, showTooltip = 'hover', depthTest = false, depthWrite = false, renderOrder = 1, visible = true, customCamera, touchAreaMultiplier = 1.5, isInteractable = true, onDown, onUp, onEnter, onLeave, onMove, }) => {
    const { camera: threeCamera } = useThree();
    const { projectionDirections } = useProjectionPlane();
    // Context
    // const { selectedTool } = useContext(EditorContext)
    const selectedTool = null;
    const camera = customCamera || threeCamera;
    // Store
    const labelFontSize = 1; // useSelector((state: RootState) => state.toolUtil.core.labelFontSize)
    // Refs
    const groupRef = useRef(null);
    const outerRef = useRef(null);
    const innerRef = useRef(null);
    const hitBoxRef = useRef(null);
    const iconRef = useRef(null);
    // States
    const [isHovered, setIsHovered] = useState(false);
    const [outerGeometry] = useState(createAnchorGeometry());
    const [innerGeometry] = useState(createAnchorGeometry(innerScale));
    const [hitAreaGeometry] = useState(createAnchorGeometry(scale * touchAreaMultiplier));
    /**
     * Set the position of the anchor.
     */
    const position = useRef(new Vector3().fromArray(point || [0, 0, 0]));
    const tempPosition = useRef(new Vector3());
    useEffect(() => {
        if (!point || tempPosition.current.fromArray(point).equals(position.current))
            return;
        position.current.fromArray(point);
        if (groupRef.current) {
            groupRef.current.position.copy(position.current);
        }
    }, [position, point]);
    /**
     * Keep the anchor at a fixed pixel radius regardless of camera zoom or position.
     */
    useFrame(({ gl }) => {
        if (!camera || !groupRef.current)
            return;
        // Make anchor always face camera
        groupRef.current.quaternion.copy(camera.quaternion);
        // Calculate consistent world scale, factoring in labelFontSize
        const canvasSize = { width: gl.domElement.clientWidth, height: gl.domElement.clientHeight };
        const scaledPixelRadius = ANCHOR_PIXEL_RADIUS * labelFontSize;
        const worldPos = groupRef.current.getWorldPosition(tempPosition.current);
        const worldSize = getWorldSizeForPixelRadius(camera, scaledPixelRadius, canvasSize, worldPos);
        const baseScale = (isHovered ? hoverScale : scale) * (worldSize / BASE_GEOMETRY_SIZE);
        // Apply scaling to both meshes
        outerRef.current?.scale.set(baseScale, baseScale, baseScale);
        innerRef.current?.scale.set(baseScale, baseScale, baseScale);
        // Apply scaling to hit area mesh (larger touch target)
        hitBoxRef.current?.scale.set(baseScale, baseScale, baseScale);
        // Scale icon proportionally, factoring in labelFontSize
        if (iconRef.current) {
            const targetIconPixelSize = scaledPixelRadius * ICON_TO_ANCHOR_RATIO;
            const iconScaleFactor = iconScale * (targetIconPixelSize / DEFAULT_ICON_SIZE) * (isHovered ? iconScale : 1);
            iconRef.current.style.transform = `scale(${iconScaleFactor})`;
            iconRef.current.style.color = iconColor || color;
        }
        if (projectionDirections) {
            const offsetToCamera = projectionDirections.normal.clone().negate().multiplyScalar(0.005);
            groupRef.current.position.copy(position.current).add(offsetToCamera);
        }
    });
    /**
     * Event Handlers (pointer enter/hover)
     */
    const onPointerEnter = useCallback((e) => {
        e.stopPropagation();
        if (onEnter && groupRef.current?.visible)
            onEnter(e);
        setIsHovered(true);
    }, [groupRef, onEnter]);
    /**
     * Event Handlers (pointer leave)
     */
    const onPointerLeave = useCallback((e) => {
        e.stopPropagation();
        if (onLeave && groupRef.current?.visible)
            onLeave(e);
        setIsHovered(false);
    }, [groupRef, onLeave]);
    /**
     * Event Handlers (pointer down)
     */
    const onPointerDown = useCallback((e) => {
        e.stopPropagation();
        // if (selectedTool === EDITOR_TOOLS.FOCUS || e.nativeEvent.button !== 0) return
        if (e.nativeEvent.button !== 0)
            return;
        if (onDown && groupRef.current?.visible)
            onDown(e);
    }, [onDown, selectedTool, groupRef]);
    return (jsxs("group", { name: `circle-anchor-${id}`, renderOrder: renderOrder, position: point, ref: groupRef, visible: visible, userData: { type: 'CircleAnchor' }, children: [jsx("mesh", { ref: hitBoxRef, name: `circle-anchor-${id}-hitarea`, onPointerDown: isInteractable ? onPointerDown : undefined, onPointerEnter: isInteractable ? onPointerEnter : undefined, onPointerLeave: onPointerLeave, onPointerMove: isInteractable
                    ? (e) => {
                        if (onMove && groupRef.current?.visible)
                            onMove(e);
                    }
                    : undefined, onPointerUp: isInteractable
                    ? (e) => {
                        if (onUp && groupRef.current?.visible)
                            onUp(e);
                    }
                    : undefined, geometry: hitAreaGeometry, renderOrder: renderOrder + 2, children: jsx("meshStandardMaterial", { color: "lightgreen", depthTest: depthTest, depthWrite: depthWrite, transparent: true, visible: false, opacity: 0 }) }), jsx("mesh", { ref: outerRef, name: `circle-anchor-${id}-outer`, geometry: outerGeometry, renderOrder: renderOrder, raycast: () => null, children: jsx("meshStandardMaterial", { color: outlineColor, opacity: outlineOpacity, depthTest: depthTest, depthWrite: depthWrite, transparent: true }) }), jsx("mesh", { ref: innerRef, name: `circle-anchor-${id}-inner`, geometry: innerGeometry, renderOrder: renderOrder + 1, raycast: () => null, children: jsx("meshStandardMaterial", { color: color, depthTest: depthTest, depthWrite: depthWrite, opacity: opacity, transparent: true }) }), jsx(Html, { style: {
                    transform: 'translateX(-50%) translateY(-50%)',
                    pointerEvents: 'none',
                    display: visible ? 'block' : 'none',
                }, zIndexRange: [1, 9], children: jsx(StylesProvider, { children: icon && (jsx(Box, { ref: iconRef, color: iconColor, transform: `scale(${iconScale})`, pointerEvents: "none", opacity: !groupRef.current || groupRef.current?.visible ? 1 : 0, children: Icons[icon] })) }) }), !!tooltipText && (showTooltip === 'always' || (showTooltip === 'hover' && isHovered)) && (jsx(Html, { style: { transform: 'translateX(-50%) translateY(-200%)', pointerEvents: 'none' }, zIndexRange: [1, 9], children: jsx(StylesProvider, { children: jsx(Box, { backgroundColor: "yellow", py: 0, px: 4, opacity: opacity, fontSize: `${80 * labelFontSize}%`, fontWeight: "bold", color: "black", whiteSpace: "nowrap", children: tooltipText }) }) }))] }));
};

/**
 * The business tools — a capability in the product's language (what a toolbar button selects),
 * as opposed to `DrawingTool` (the geometric primitive the canvas draws). A business tool may
 * activate a `DrawingTool` (e.g. Plane/Volume → Polygon) or draw nothing (Focus). The base tool
 * is the plain selector (`Move`, pending a `Selector` rename).
 *
 * This is the canonical home; see 3D_EDITOR_ARCHITECTURE.md. The copy in `ThreeCanvas/definitions`
 * is deprecated and kept only until its remaining in-package consumers migrate here.
 */
var EditorTools;
(function (EditorTools) {
    EditorTools["Move"] = "MOVE";
    EditorTools["Focus"] = "FOCUS";
    EditorTools["Comment"] = "COMMENT";
    EditorTools["Cylinder"] = "CYLINDER";
    EditorTools["CylinderCuboid"] = "CYLINDER_CUBOID";
    EditorTools["Distance"] = "DISTANCE";
    EditorTools["CustomMeasurement"] = "CUSTOM_MEASUREMENT";
    EditorTools["Polyline"] = "POLYLINE";
    EditorTools["Clipping"] = "CLIPPING";
    EditorTools["Plane"] = "PLANE";
    EditorTools["Torus"] = "TORUS";
    EditorTools["TorusCuboid"] = "TORUS_CUBOID";
    EditorTools["Volume"] = "VOLUME";
    EditorTools["VolumeRectangle"] = "VOLUME_RECTANGLE";
    EditorTools["VolumePolygon"] = "VOLUME_POLYGON";
    EditorTools["Depth"] = "DEPTH";
    EditorTools["PcdTrimCuboid"] = "PCD_TRIM_CUBOID";
    EditorTools["Grid"] = "GRID";
    EditorTools["CameraProfile"] = "CAMERA_PROFILE";
    EditorTools["ItemCameraProfile"] = "ITEM_CAMERA_PROFILE";
    EditorTools["PcdAlignment"] = "PCD_ALIGNMENT";
    EditorTools["PlaneDetection"] = "PLANE_DETECTION";
    /** Mask (注目領域) — the Editor's `PcdTrimCuboid`, ported without the "PCD trim" naming. */
    EditorTools["Mask"] = "MASK";
})(EditorTools || (EditorTools = {}));
/**
 * The standard tool actions, each with a locked look (label, color, icon — see
 * `TOOL_BUTTON_PRESETS`). A tool picks the preset for a common action; it cannot restyle it, so the
 * same action reads the same in every tool (the old Editor's button-preset rule). The set mirrors
 * the old Editor's presets one-to-one — its blue `apply` ("apply without closing the tool") is
 * `Save` here; a separate `Apply` was skipped as it would duplicate `Save`.
 */
var ToolButtonPreset;
(function (ToolButtonPreset) {
    /** Blue — persist the pending changes, staying in the tool (the old Editor's `apply`). */
    ToolButtonPreset["Save"] = "SAVE";
    /** Green — persist / submit, then leave the tool (the old Editor's `submit`). */
    ToolButtonPreset["SaveAndExit"] = "SAVE_AND_EXIT";
    /** Grey — clear the tool's uncommitted work (the old Editor's `reset`). */
    ToolButtonPreset["Reset"] = "RESET";
    /** Discard the in-progress drawing (subtoolbar). */
    ToolButtonPreset["Cancel"] = "CANCEL";
    /** Step back one action/vertex (subtoolbar). */
    ToolButtonPreset["Undo"] = "UNDO";
    /** Close/complete the in-progress drawing (subtoolbar). */
    ToolButtonPreset["Complete"] = "COMPLETE";
})(ToolButtonPreset || (ToolButtonPreset = {}));
/**
 * The preset → locked-look table, taken from the old Editor's button set (`ToolsPanel` /
 * `ToolActions` in hatsuly-app): apply/save = blue + SaveIcon, submit/save-and-exit = green +
 * CheckCircleIcon, reset = grey + ResetIcon, and the subtoolbar trio's icons. Tools never read
 * this directly — the render surfaces resolve a `ToolButton` through `resolveToolButton`.
 *
 * A `colorPalette` here applies where the surface colours by palette (the side-panel stage
 * buttons). Slots with their own fixed chrome — the reset slot's grey and the subtoolbar's ghost /
 * complete treatments — own their colours at the surface; Reset's `gray` records the canonical
 * colour for such a surface to realise.
 */
const TOOL_BUTTON_PRESETS = {
    [ToolButtonPreset.Save]: { labelKey: '3d.buttons.save', colorPalette: 'blue', icon: SaveIcon },
    [ToolButtonPreset.SaveAndExit]: { labelKey: '3d.buttons.saveAndExit', colorPalette: 'green', icon: CheckCircleIcon },
    [ToolButtonPreset.Reset]: { labelKey: '3d.buttons.reset', colorPalette: 'gray', icon: ResetIcon },
    [ToolButtonPreset.Cancel]: { labelKey: '3d.buttons.cancel', icon: ResetIcon },
    [ToolButtonPreset.Undo]: { labelKey: '3d.buttons.undo', icon: UndoIcon },
    [ToolButtonPreset.Complete]: { labelKey: '3d.buttons.complete', icon: ConfirmIcon },
};
/**
 * Resolve a `ToolButton` to its render props — the single place a preset's locked look is applied.
 * Render surfaces call this and style from the result; tools never resolve their own presets.
 * @param button The preset or custom button to resolve.
 * @param t Translation function for the preset's default label key.
 */
const resolveToolButton = (button, t) => {
    if (button.preset) {
        const look = TOOL_BUTTON_PRESETS[button.preset];
        return {
            label: button.label ?? t(look.labelKey),
            onClick: button.onClick,
            disabled: button.disabled,
            loading: button.loading ?? false,
            loadingText: button.loadingText,
            icon: look.icon,
            colorPalette: look.colorPalette,
        };
    }
    return {
        label: button.label,
        onClick: button.onClick,
        disabled: button.disabled,
        loading: button.loading ?? false,
        loadingText: button.loadingText,
        icon: button.icon,
        colorPalette: button.colorPalette,
    };
};

/**
 * CameraProfile draws a 3-point polygon, auto-completed and extended to the scene bbox.
 */
const CAMERA_PROFILE_CONFIG = { maxVertices: 3, extendToBbox: true };
/** Stable empty config used while the tool is inactive (keeps the reference stable). */
const INACTIVE_DRAWING_CONFIG$4 = {};

/**
 * CameraProfile creation/editing workflow stages.
 * DRAW (place 3 points) → ROTATE (adjust the plane) → FOCUS (rotate camera parallel) → SAVING.
 */
var CameraProfileStage;
(function (CameraProfileStage) {
    CameraProfileStage["Draw"] = "DRAW";
    CameraProfileStage["Rotate"] = "ROTATE";
    CameraProfileStage["Focus"] = "FOCUS";
    CameraProfileStage["Saving"] = "SAVING";
})(CameraProfileStage || (CameraProfileStage = {}));

/** How fast the FOCUS drag rotates the camera around the plane normal (ported from Editor). */
const ROTATION_SENSITIVITY = 0.0025;
/**
 * Project a world position to canvas-local screen pixels (top-left origin, Y down).
 */
const projectToScreen = (world, camera, width, height) => {
    const ndc = world.clone().project(camera);
    return new Vector2((ndc.x + 1) * 0.5 * width, (1 - ndc.y) * 0.5 * height);
};
/**
 * Rotation direction of a drag around a center point: `1` clockwise, `-1` counter-clockwise.
 * (Sign of the cross product of center→start and center→current.)
 */
const getRotationDirection = (center, start, current) => {
    const vs = { x: start.x - center.x, y: start.y - center.y };
    const vc = { x: current.x - center.x, y: current.y - center.y };
    const cross = vs.x * vc.y - vs.y * vc.x;
    return cross > 0 ? -1 : 1;
};

const raycaster = new Raycaster();
/** Plane derived from the first three placed points, or null if fewer than 3. */
const planeFromPoints = (points) => {
    if (points.length < 3)
        return null;
    const [a, b, c] = points;
    return new Plane().setFromCoplanarPoints(a, b, c);
};
/**
 * Headless CameraProfile tool (Layer 2 — shared, app-agnostic). Owns the workflow state
 * machine, geometry orchestration and the FOCUS-stage camera manipulation; apps render UI
 * from the returned API and wire the canvas-driving props. Camera/controls come in by
 * injection so the same logic serves Platform (ThreeCanvasContext) and Editor (EditorContext).
 */
function useCameraProfile({ cameraRef, arcballControlsRef, canvasHandleRef, placedCount, persistProfile, selectedTool, setSelectedTool, tool = EditorTools.CameraProfile, }) {
    // Hooks
    const { t } = useTranslation();
    // The tool is active when it's the selected business tool (single source of truth, L2).
    const isActive = selectedTool === tool;
    // States
    const [stage, setStage] = useState(CameraProfileStage.Draw);
    const [drawnPlanePoints, setDrawnPlanePoints] = useState([]);
    const [target, setTarget] = useState(undefined);
    // Bumped by every reset so an in-flight save's continuation can tell the state it captured was
    // thrown away — without this, a failed save could resurrect a non-DRAW stage (with no points)
    // on a tool that was just reset/discarded, stranding it permanently "dirty".
    const saveEpochRef = useRef(0);
    /** Reset the working state to a fresh DRAW (does not touch any loaded/saved profile). */
    const reset = useCallback(() => {
        saveEpochRef.current += 1;
        setStage(CameraProfileStage.Draw);
        setDrawnPlanePoints([]);
        setTarget(undefined);
        // Also clear any in-progress placement owned by the drawing engine (L1).
        canvasHandleRef.current?.cancel();
    }, [canvasHandleRef]);
    // Selecting another tool resets this one's working state — the normal rule, so tools always
    // start fresh and don't bleed state into one another. The single exception is Focus: it's a
    // transient one-shot that returns here, so its detour must leave this tool's work intact.
    // Reset fires only when *this* tool is the one being left: `reset()` cancels the shared canvas
    // placement, so an unconditional run would wipe another tool's in-progress drawing on its
    // Focus-return leg.
    const wasActiveRef = useRef(false);
    useEffect(() => {
        if (isActive) {
            wasActiveRef.current = true;
            return;
        }
        if (selectedTool === EditorTools.Focus)
            return;
        if (wasActiveRef.current)
            reset();
        wasActiveRef.current = false;
    }, [isActive, selectedTool, reset]);
    /** Enter the tool, or leave it back to the base Selector if it's already active. */
    const toggle = useCallback(() => {
        setSelectedTool((prev) => (prev === tool ? EditorTools.Move : tool));
    }, [setSelectedTool, tool]);
    /** Store the plane points and set the target to their centroid (via `findCenter`). */
    const commitGeometry = useCallback((vertices) => {
        setDrawnPlanePoints(vertices);
        setTarget(findCenter(vertices) ?? undefined);
    }, []);
    /** Drawing finished (3rd point auto-completes): store geometry and advance to ROTATE. */
    const onComplete = useCallback((result) => {
        commitGeometry(result.vertices);
        setStage(CameraProfileStage.Rotate);
    }, [commitGeometry]);
    /** Anchor released during ROTATE: re-store geometry + target (stays in ROTATE). */
    const onAdjusted = useCallback((vertices) => {
        commitGeometry(vertices);
    }, [commitGeometry]);
    /**
     * Enter FOCUS: move the camera to look perpendicular at the plane (target centroid) from
     * the same side at the current distance, then advance the stage. The fine-tune effect
     * (below) then locks orbit rotation and drives parallel rotation. Ported from Editor's
     * `useFocusItem` (skipProfile path) + `useEditor` submit handler.
     */
    const advanceToFocus = useCallback(() => {
        const camera = cameraRef.current;
        const controls = arcballControlsRef.current;
        if (!camera || !controls)
            return;
        setStage(CameraProfileStage.Focus);
        // Lock only free-orbit rotation (pan + zoom stay). Set it BEFORE the animation so
        // `animateCamera`'s save/restore captures `false` and preserves the lock on arrival —
        // otherwise it would restore the pre-animation `true` and re-enable orbit.
        controls.enableRotate = false;
        controls.focusItem(drawnPlanePoints.map((p) => new Vector3(...p)));
    }, [cameraRef, arcballControlsRef, drawnPlanePoints]);
    /**
     * Save the profile: generate it from the live camera + controls (pure shared service), then
     * persist via the injected `persistProfile`. On success, leave editing (the saved profile now
     * drives the toolbar's view-orientation buttons); on failure, fall back to FOCUS to retry.
     */
    const save = useCallback(async () => {
        const camera = cameraRef.current;
        const controls = arcballControlsRef.current;
        if (!camera || !controls)
            return;
        const epoch = saveEpochRef.current;
        setStage(CameraProfileStage.Saving);
        const profile = generateCameraProfile(camera, controls);
        const success = await persistProfile(profile);
        // The state was reset/discarded while the write was in flight: leave it alone — especially
        // the failure fallback, which would otherwise re-enter FOCUS with no points. (The write
        // itself can't be recalled; its outcome still surfaces through the host's toasts.)
        if (saveEpochRef.current !== epoch)
            return;
        if (success) {
            // Saved: leave the tool back to the base Selector; the deactivation effect clears the state.
            setSelectedTool(EditorTools.Move);
        }
        else {
            setStage(CameraProfileStage.Focus);
        }
    }, [cameraRef, arcballControlsRef, persistProfile, setSelectedTool]);
    /**
     * FOCUS interaction: while in FOCUS, suspend arcball rotation and rotate the camera around
     * the plane normal from the drag (port of Editor `onFocusFineTune`). Listeners attach to the
     * canvas DOM (the arcball control's element); cleanup restores rotation on leaving FOCUS.
     */
    useEffect(() => {
        if (stage !== CameraProfileStage.Focus)
            return;
        const camera = cameraRef.current;
        const controls = arcballControlsRef.current;
        const dom = controls?.domElement;
        const plane = planeFromPoints(drawnPlanePoints);
        if (!camera || !controls || !dom || !plane)
            return;
        // Lock free-orbit rotation only; pan + zoom remain. The manual roll below replaces it.
        controls.enableRotate = false;
        let isPointerDown = false;
        let previous = null;
        const fineTune = (current) => {
            if (!previous)
                return;
            // Target = where the camera looks, on the plane.
            const direction = camera.getWorldDirection(new Vector3());
            raycaster.ray.set(camera.position, direction);
            const planeTarget = new Vector3();
            if (!raycaster.ray.intersectPlane(plane, planeTarget))
                return;
            const rect = dom.getBoundingClientRect();
            const toLocal = (p) => new Vector2(p.x - rect.left, p.y - rect.top);
            const targetScreen = projectToScreen(planeTarget, camera, rect.width, rect.height);
            const prevLocal = toLocal(previous);
            const currLocal = toLocal(current);
            // Negative: opposite of what the camera roll needs vs. the on-screen drag direction.
            const sign = -getRotationDirection(targetScreen, prevLocal, currLocal);
            const angle = currLocal.distanceTo(prevLocal) * sign * ROTATION_SENSITIVITY;
            camera.rotateZ(angle);
            camera.matrix.compose(camera.position, camera.quaternion, camera.scale);
        };
        const onPointerDown = (e) => {
            if (e.button !== 0)
                return;
            isPointerDown = true;
            previous = { x: e.clientX, y: e.clientY };
        };
        const onPointerMove = (e) => {
            if (!isPointerDown)
                return;
            fineTune({ x: e.clientX, y: e.clientY });
            previous = { x: e.clientX, y: e.clientY };
        };
        const onPointerUp = () => {
            isPointerDown = false;
            previous = null;
        };
        dom.addEventListener('pointerdown', onPointerDown);
        window.addEventListener('pointermove', onPointerMove);
        window.addEventListener('pointerup', onPointerUp);
        return () => {
            controls.enableRotate = true; // restore free-orbit rotation on leaving FOCUS
            dom.removeEventListener('pointerdown', onPointerDown);
            window.removeEventListener('pointermove', onPointerMove);
            window.removeEventListener('pointerup', onPointerUp);
        };
    }, [stage, drawnPlanePoints, cameraRef, arcballControlsRef]);
    // Polygon placement is only live during DRAW; later stages stop drawing.
    const activeTool = isActive && stage === CameraProfileStage.Draw ? DrawingTool.Polygon : null;
    const editable = isActive && stage === CameraProfileStage.Rotate;
    const drawingConfig = isActive ? CAMERA_PROFILE_CONFIG : INACTIVE_DRAWING_CONFIG$4;
    const canvas = useMemo(() => ({ activeTool, onComplete }), [activeTool, onComplete]);
    // Stage baseline cursor: DRAW shows a crosshair for placing points; no baseline afterwards
    // (in ROTATE the anchors set their own cursor transiently via the context's `cursor`).
    const defaultCursor = isActive && stage === CameraProfileStage.Draw ? CursorState.CROSSHAIR : CursorState.NONE;
    /**
     * Single, stage-aware "step back" (one thing per press): FOCUS→ROTATE, then pop one placed
     * vertex per press through DRAW until empty. Committed points live here (L2); in-progress
     * ones in the drawing engine (L1) — popping a committed point re-enters DRAW with the
     * remainder seeded back into L1 so they stay visible/editable.
     */
    const undo = useCallback(() => {
        if (stage === CameraProfileStage.Focus) {
            setStage(CameraProfileStage.Rotate);
            return;
        }
        if (stage === CameraProfileStage.Rotate) {
            const remaining = drawnPlanePoints.slice(0, -1);
            setDrawnPlanePoints([]);
            setTarget(undefined);
            setStage(CameraProfileStage.Draw);
            canvasHandleRef.current?.restore(remaining);
            return;
        }
        // DRAW: pop the last in-progress vertex (owned by the drawing engine).
        canvasHandleRef.current?.undo();
    }, [stage, drawnPlanePoints, canvasHandleRef]);
    /** There's something to undo unless we're at an empty DRAW (or mid-save). */
    const canUndo = isActive && stage !== CameraProfileStage.Saving && (stage !== CameraProfileStage.Draw || placedCount > 0);
    /**
     * Dirty = any working geometry exists (committed or in-progress) or we're past DRAW — except
     * while SAVING: a save in flight is committed work, and the write can't be cancelled, so guards
     * must not offer to "discard" it (its outcome surfaces through the host's toasts either way).
     */
    const isDirty = stage !== CameraProfileStage.Saving &&
        (stage !== CameraProfileStage.Draw || drawnPlanePoints.length > 0 || placedCount > 0);
    /**
     * Stage-driven action button: DRAW/ROTATE → 正面を指定 (→FOCUS); FOCUS/SAVING → 保存. A custom
     * button (not a preset): the stage-dependent label/icon pair is this workflow's own, not a
     * standard action.
     */
    const stageButton = useMemo(() => {
        if (stage === CameraProfileStage.Focus || stage === CameraProfileStage.Saving) {
            return {
                label: t('ui.save'),
                loadingText: t('ui.saving'),
                onClick: save,
                disabled: stage === CameraProfileStage.Saving,
                loading: stage === CameraProfileStage.Saving,
                icon: SaveIcon,
            };
        }
        return {
            label: t('3d.cameraProfile.specifyFront'),
            onClick: advanceToFocus,
            disabled: stage === CameraProfileStage.Draw,
            loading: false,
            icon: FaForwardStep,
        };
    }, [t, stage, advanceToFocus, save]);
    /** "Reset all" (`Reset` preset) — side panel, next to the stage button. Disabled when nothing's
     *  drawn (which includes mid-save: `isDirty` is false while SAVING). */
    const resetButton = useMemo(() => ({
        preset: ToolButtonPreset.Reset,
        onClick: reset,
        disabled: !isDirty,
    }), [reset, isDirty]);
    /**
     * Bottom-center "step back" (`Undo` preset). In FOCUS the next press returns to ROTATE, so the
     * label overrides the preset default to say what it does; otherwise the default (one point back).
     */
    const undoButton = useMemo(() => ({
        preset: ToolButtonPreset.Undo,
        label: stage === CameraProfileStage.Focus ? t('3d.cameraProfile.backToFront') : undefined,
        onClick: undo,
        disabled: !canUndo,
    }), [t, stage, undo, canUndo]);
    // Memoised on its actual inputs so consumers (and the app's ToolApi built on top) get a stable
    // reference — the API's identity only changes when tool state actually does.
    return useMemo(() => ({
        isActive,
        stage,
        drawnPlanePoints,
        target,
        editable,
        drawingConfig,
        canvas,
        defaultCursor,
        toggle,
        reset,
        isDirty,
        onAdjusted,
        stageButton,
        resetButton,
        undoButton,
    }), [
        isActive,
        stage,
        drawnPlanePoints,
        target,
        editable,
        drawingConfig,
        canvas,
        defaultCursor,
        toggle,
        reset,
        isDirty,
        onAdjusted,
        stageButton,
        resetButton,
        undoButton,
    ]);
}

/**
 * Drawing config for Plane Detection: no `maxVertices`, so the polygon does **not** auto-complete
 * — the user closes it manually (unlike Camera Profile's fixed 3-vertex triangle). `extendToBbox`
 * is off: the measured surface is the drawn outline itself, not a plane extended to the scene box.
 */
const PLANE_DETECTION_CONFIG = { extendToBbox: false };
/** Config synced into the canvas while the tool is inactive (matches the shared inactive baseline). */
const INACTIVE_DRAWING_CONFIG$3 = {};
/**
 * Default cap on how many outlines can be drawn before submitting — the Editor's multi-polygon
 * limit (`MAXIMUM_NUMBER_OF_SHAPE_DETECTION_POLYGON`). Consumers override it: the Platform passes
 * `maxPolygons: 1` so each measured area maps unambiguously to one defect record.
 */
const DEFAULT_MAX_DETECTION_POLYGONS = 20;

/**
 * Headless Plane Detection tool (Layer 2 — shared, app-agnostic). Owns the working polygon, the
 * list of completed-but-unsent polygons and the draw/edit/undo/reset rules, and fires detection
 * via the injected `detectAreas`. It carries no notion of "damage"/defect records, persistence or
 * the in-flight "saving" set — those live entirely in the L3 consumer. Mirrors the CameraProfile
 * hook's shape (declarative state + button configs; canvas-driving props injected).
 */
function usePlaneDetection({ canvasHandleRef, placedCount, completable = false, detectAreas, maxPolygons = DEFAULT_MAX_DETECTION_POLYGONS, submitGate, selectedTool, setSelectedTool, tool = EditorTools.PlaneDetection, }) {
    // Hooks
    const { t } = useTranslation();
    // The tool is active when it's the selected business tool (single source of truth, L2).
    const isActive = selectedTool === tool;
    // States — the drawn-but-unsent polygons (the working polygon lives in the L1 drawing engine).
    const [completedPolygons, setCompletedPolygons] = useState([]);
    // Whether the in-progress placement on the *shared* canvas is this tool's. `placedCount` is the
    // one canvas's count, so it must only count as this tool's work while this tool owns the drawing
    // (active, or suspended under a Focus detour) — another tool placing points is not our drawing.
    const [ownsPlacement, setOwnsPlacement] = useState(false);
    const isAtMaxPolygons = completedPolygons.length >= maxPolygons;
    /** Clear the not-yet-submitted drawing (working polygon + completed polygons). Never touches
     *  in-flight detections — those have left `completedPolygons` and are tracked in L3. */
    const reset = useCallback(() => {
        setCompletedPolygons([]);
        canvasHandleRef.current?.cancel();
    }, [canvasHandleRef]);
    // Selecting another tool clears the not-yet-submitted drawing — the normal rule. The single
    // exception is Focus: a transient detour that returns here, so its work must survive intact.
    // In-flight detections are unaffected either way (they're no longer in `completedPolygons`).
    // Reset fires only when *this* tool is the one being left: `reset()` cancels the shared canvas
    // placement, so an unconditional run would wipe another tool's in-progress drawing on its
    // Focus-return leg.
    const wasActiveRef = useRef(false);
    useEffect(() => {
        if (isActive) {
            wasActiveRef.current = true;
            setOwnsPlacement(true);
            return;
        }
        // A Focus detour keeps both the work and the claim on the shared placement.
        if (selectedTool === EditorTools.Focus)
            return;
        if (wasActiveRef.current)
            reset();
        wasActiveRef.current = false;
        setOwnsPlacement(false);
    }, [isActive, selectedTool, reset]);
    /** Enter the tool, or leave it back to the base Selector if it's already active. */
    const toggle = useCallback(() => {
        setSelectedTool((prev) => (prev === tool ? EditorTools.Move : tool));
    }, [setSelectedTool, tool]);
    /** Drawing finished: push the outline into `completedPolygons` unless the cap is reached. */
    const onComplete = useCallback((result) => {
        setCompletedPolygons((prev) => (prev.length >= maxPolygons ? prev : [...prev, result.vertices]));
    }, [maxPolygons]);
    /** Anchor released while editing a completed (unsubmitted) polygon: replace its vertices. */
    const onAdjusted = useCallback((polygonIndex, vertices) => {
        setCompletedPolygons((prev) => prev.map((polygon, index) => (index === polygonIndex ? vertices : polygon)));
    }, []);
    /**
     * Submit the completed polygons as one batch and leave the tool (back to Move) **immediately** —
     * fire-and-forget, matching the Editor's UX. The outlines are handed to `detectAreas` (whose host
     * owns the in-flight visuals and every outcome, including a failed submit) and dropped from
     * `completedPolygons` without waiting on the API.
     */
    const submit = useCallback(() => {
        if (!completedPolygons.length)
            return;
        void detectAreas(completedPolygons);
        setCompletedPolygons([]);
        setSelectedTool(EditorTools.Move);
    }, [completedPolygons, detectAreas, setSelectedTool]);
    /**
     * Single "step back" (one vertex per press): pop the last in-progress vertex, else re-open the
     * last completed polygon **without its last vertex** — so undoing a just-closed polygon removes
     * the last placed point (matching CameraProfile's ROTATE→DRAW step-back).
     */
    const undo = useCallback(() => {
        if (placedCount > 0) {
            canvasHandleRef.current?.undo();
            return;
        }
        if (completedPolygons.length > 0) {
            const last = completedPolygons[completedPolygons.length - 1];
            setCompletedPolygons((prev) => prev.slice(0, -1));
            canvasHandleRef.current?.restore(last.slice(0, -1));
        }
    }, [placedCount, completedPolygons, canvasHandleRef]);
    /** Close the working polygon (manual close — there is no `maxVertices` auto-complete). */
    const complete = useCallback(() => {
        canvasHandleRef.current?.complete();
    }, [canvasHandleRef]);
    // Placement is live only while active and under the polygon cap; at the cap the user must submit
    // the outline(s) before drawing another (on the Platform's `maxPolygons: 1`, one at a time).
    const activeTool = isActive && !isAtMaxPolygons ? DrawingTool.Polygon : null;
    const drawingConfig = isActive ? PLANE_DETECTION_CONFIG : INACTIVE_DRAWING_CONFIG$3;
    const canvas = useMemo(() => ({ activeTool, onComplete }), [activeTool, onComplete]);
    const defaultCursor = isActive ? CursorState.CROSSHAIR : CursorState.NONE;
    // The submit button enables whenever there's ≥1 completed polygon and the gate is open.
    const canSubmit = completedPolygons.length > 0 && !submitGate?.disabled;
    // 計算してリンク submits and leaves the tool — the standard save-and-exit action wearing this
    // tool's domain wording, so it keeps the preset's locked look with a `label` override.
    const detectAndLinkButton = useMemo(() => ({
        preset: ToolButtonPreset.SaveAndExit,
        label: t('3d.planeDetection.detectAndLink'),
        onClick: submit,
        disabled: !canSubmit,
        loading: false,
    }), [t, submit, canSubmit]);
    // Subtoolbar draw actions (undo · cancel · complete). Each is `null` when it doesn't apply, so
    // the subtoolbar hides it.
    const isDirty = (ownsPlacement && placedCount > 0) || completedPolygons.length > 0;
    const undoButton = useMemo(() => (isActive && isDirty ? { preset: ToolButtonPreset.Undo, onClick: undo, disabled: false } : null), [isActive, isDirty, undo]);
    const cancelButton = useMemo(() => (isActive && isDirty ? { preset: ToolButtonPreset.Cancel, onClick: reset, disabled: false } : null), [isActive, isDirty, reset]);
    // Complete closes the *working* polygon, so it shows only while one is in progress (placed
    // vertices) and enables once that polygon is completable (≥3 vertices, not self-intersecting).
    const completeButton = useMemo(() => isActive && placedCount > 0
        ? { preset: ToolButtonPreset.Complete, onClick: complete, disabled: !completable }
        : null, [isActive, placedCount, completable, complete]);
    // Memoised on its actual inputs so consumers (and the app's ToolApi built on top) get a stable
    // reference — the API's identity only changes when tool state actually does.
    return useMemo(() => ({
        isActive,
        activeTool,
        drawingConfig,
        canvas,
        defaultCursor,
        toggle,
        reset,
        isDirty,
        completedPolygons,
        isAtMaxPolygons,
        onAdjusted,
        detectAndLinkButton,
        undoButton,
        cancelButton,
        completeButton,
    }), [
        isActive,
        activeTool,
        drawingConfig,
        canvas,
        defaultCursor,
        toggle,
        reset,
        isDirty,
        completedPolygons,
        isAtMaxPolygons,
        onAdjusted,
        detectAndLinkButton,
        undoButton,
        cancelButton,
        completeButton,
    ]);
}

/**
 * Drawing config for the Polyline tool: an **open line**, so there is no `maxVertices` (the user
 * ends the line manually via double-click / closing-anchor / Complete) and no derived plane
 * (`extendToBbox` off — a polyline never derives a plane, unlike the polygon tools). `minVertices`
 * comes from the L1 engine (2 for Polyline).
 */
const POLYLINE_CONFIG = {};
/** Config synced into the canvas while the tool is inactive (matches the shared inactive baseline). */
const INACTIVE_DRAWING_CONFIG$2 = {};

const newId$1 = () => crypto.randomUUID();
const toPointArray$1 = (v) => v.toArray();
/** Only one line may be drawn at a time (mirrors Plane Detection's single-outline rule). */
const MAX_UNSAVED_LINES = 1;
/**
 * Headless Polyline tool (Layer 2 — shared, app-agnostic). Owns the working line, the drawn-but-
 * unsaved lines, the accumulated edits to saved lines, the vertex-edit sub-mode (draw / move / add
 * / remove / connect / split), per-line width and firing save. It carries no notion of "damage" /
 * defect records or persistence — those live entirely in the L3 consumer. This is the first tool
 * that **edits already-saved items** and saves **without a background job** (a direct flush).
 */
function usePolyline({ canvasHandleRef, placedCount, completable = false, savePolylines, savedPolylines, submitGate, selectedTool, setSelectedTool, tool = EditorTools.Polyline, }) {
    // Hooks
    const { t } = useTranslation();
    // The tool is active when it's the selected business tool (single source of truth, L2).
    const isActive = selectedTool === tool;
    // States — the working line lives in the L1 drawing engine; these are everything else.
    const [completedPolylines, setCompletedPolylines] = useState([]);
    const [editedById, setEditedById] = useState({});
    const [editSubtool, setEditSubtoolState] = useState(SubtoolVertex.AddVertex);
    const [workingWidth, setWorkingWidthState] = useState(undefined);
    const [labelVisibility, setLabelVisibilityState] = useState({ primary: true, edge: false });
    const [mergeAnchor, setMergeAnchor] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    // Whether the in-progress placement on the *shared* canvas is this tool's. `placedCount` is the
    // one canvas's count, so it must only count as this tool's work while this tool owns the drawing
    // (active, or suspended under a Focus detour) — another tool placing points is not our line.
    const [ownsPlacement, setOwnsPlacement] = useState(false);
    /** Upsert one entry in the edited-saved-lines accumulator (full replace by id). */
    const upsertEdited = useCallback((edit) => {
        setEditedById((prev) => ({ ...prev, [edit.id]: edit }));
    }, []);
    /** Resolve a line's current points + width (draft, or saved with any queued edit overlaid). */
    const resolveLine = useCallback((ref) => {
        if (!ref.isSaved) {
            const draft = completedPolylines.find((p) => p.id === ref.id);
            return draft ? { points: draft.points, width: draft.width } : null;
        }
        const edited = editedById[ref.id];
        const saved = savedPolylines.find((s) => s.id === ref.id);
        if (!edited && !saved)
            return null;
        return { points: edited?.points ?? saved?.points ?? [], width: edited?.width ?? saved?.width };
    }, [completedPolylines, editedById, savedPolylines]);
    /** Clear the not-yet-saved work (drawing + drafts + queued edits). Never touches saved lines. */
    const reset = useCallback(() => {
        setCompletedPolylines([]);
        setEditedById({});
        setWorkingWidthState(undefined);
        setMergeAnchor(null);
        setEditSubtoolState(SubtoolVertex.AddVertex);
        canvasHandleRef.current?.cancel();
    }, [canvasHandleRef]);
    /**
     * Clear what isn't saved yet — the placement and every draft — leaving the queued edits to saved
     * lines alone: the scoped counterpart to `reset()`, for a host offering a delete on the unsaved
     * line itself (exact under the one-unsaved-line cap the Platform runs). Frozen mid-save like the
     * other edits: the flush already carries the drafts, so dropping them here would lose the work a
     * failed flush is meant to keep.
     */
    const discardWorkingLine = useCallback(() => {
        if (submitting)
            return;
        setCompletedPolylines([]);
        setMergeAnchor(null);
        canvasHandleRef.current?.cancel();
    }, [canvasHandleRef, submitting]);
    // Selecting another tool clears the not-yet-saved work — the normal rule. The single exception
    // is Focus: a transient detour that returns here, so its work must survive intact. There are no
    // in-flight jobs to protect (the direct save is atomic from the tool's view). Reset fires only
    // when *this* tool is the one being left: `reset()` cancels the shared canvas placement, so an
    // unconditional run would wipe another tool's in-progress drawing on its Focus-return leg.
    const wasActiveRef = useRef(false);
    useEffect(() => {
        if (isActive) {
            wasActiveRef.current = true;
            setOwnsPlacement(true);
            return;
        }
        // A Focus detour keeps both the work and the claim on the shared placement.
        if (selectedTool === EditorTools.Focus)
            return;
        if (wasActiveRef.current)
            reset();
        wasActiveRef.current = false;
        setOwnsPlacement(false);
    }, [isActive, selectedTool, reset]);
    /** Enter the tool, or leave it back to the base Selector if it's already active. */
    const toggle = useCallback(() => {
        setSelectedTool((prev) => (prev === tool ? EditorTools.Move : tool));
    }, [setSelectedTool, tool]);
    /** Switch the vertex-edit sub-mode. Leaving AddVertex discards the in-progress line (like the Editor). */
    const setEditSubtool = useCallback((subtool) => {
        setEditSubtoolState(subtool);
        if (subtool !== SubtoolVertex.AddVertex)
            canvasHandleRef.current?.cancel();
        if (subtool !== SubtoolVertex.ConnectVertex)
            setMergeAnchor(null);
    }, [canvasHandleRef]);
    /**
     * Drawing finished: push the vertices into the drawn-but-unsaved list (require ≥2, like the
     * Editor). Capped at one unsaved line at a time (mirrors Plane Detection's single-outline rule),
     * so the user saves the current line before drawing another.
     */
    const onComplete = useCallback((result) => {
        if (submitting)
            return; // frozen while a save is in flight (see doSave)
        if (result.vertices.length < 2)
            return;
        setCompletedPolylines((prev) => prev.length >= MAX_UNSAVED_LINES
            ? prev
            : [...prev, { id: newId$1(), points: result.vertices.map(toPointArray$1), width: workingWidth }]);
    }, [workingWidth, submitting]);
    /** A vertex move / add / remove committed on a line; route it to the right collection. */
    const onEditPoints = useCallback((ref, points) => {
        if (submitting)
            return; // frozen while a save is in flight
        if (!ref.isSaved) {
            setCompletedPolylines((prev) => prev.flatMap((p) => {
                if (p.id !== ref.id)
                    return [p];
                return points.length >= 2 ? [{ ...p, points }] : []; // a vertex removal below 2 drops it
            }));
            return;
        }
        const existing = resolveLine(ref);
        upsertEdited({ id: ref.id, points, width: existing?.width });
    }, [resolveLine, upsertEdited, submitting]);
    /** Cut a line at an edge index. Segments with <2 points are dropped (mirrors the Editor's split). */
    const onSplit = useCallback((ref, edgeIndex) => {
        if (submitting)
            return; // frozen while a save is in flight
        const line = resolveLine(ref);
        if (!line || edgeIndex <= 0 || edgeIndex >= line.points.length)
            return;
        const first = line.points.slice(0, edgeIndex);
        const second = line.points.slice(edgeIndex);
        const valid = [first, second].filter((part) => part.length >= 2);
        if (!ref.isSaved) {
            setCompletedPolylines((prev) => {
                const kept = prev.flatMap((p) => {
                    if (p.id !== ref.id)
                        return [p];
                    return first.length >= 2 ? [{ ...p, points: first }] : [];
                });
                return second.length >= 2
                    ? [...kept, { id: newId$1(), points: second, width: line.width, inspectionItemId: ref.id }]
                    : kept;
            });
            return;
        }
        // Saved line: the first valid part stays on the item; a second valid part becomes a new line.
        if (valid.length === 0) {
            upsertEdited({ id: ref.id, points: [], width: line.width, isDeleted: true });
            return;
        }
        upsertEdited({ id: ref.id, points: valid[0], width: line.width });
        if (valid.length > 1) {
            setCompletedPolylines((prev) => [
                ...prev,
                { id: newId$1(), points: valid[1], width: line.width, inspectionItemId: ref.id },
            ]);
        }
    }, [resolveLine, upsertEdited, submitting]);
    /** Merge two lines end-to-end, preserving the width-bearing line's width (mirrors `useMergingPolyline`). */
    const performMerge = useCallback((first, second) => {
        // The line that already carries a width wins, so the merged line keeps it.
        let a = first;
        let b = second;
        if (a.width === undefined && b.width !== undefined) {
            a = second;
            b = first;
        }
        const aAtEnd = a.anchorIndex === a.points.length - 1;
        const bAtStart = b.anchorIndex === 0;
        const bAtEnd = b.anchorIndex === b.points.length - 1;
        const aAtStart = a.anchorIndex === 0;
        let points;
        if (aAtEnd && bAtStart)
            points = [...a.points, ...b.points];
        else if (aAtEnd && bAtEnd)
            points = [...a.points, ...[...b.points].reverse()];
        else if (aAtStart && bAtStart)
            points = [...[...a.points].reverse(), ...b.points];
        else
            points = [...b.points, ...a.points];
        const width = a.width ?? b.width;
        if (!a.ref.isSaved && !b.ref.isSaved) {
            setCompletedPolylines((prev) => [
                ...prev.filter((p) => p.id !== a.ref.id && p.id !== b.ref.id),
                { id: newId$1(), points, width },
            ]);
            return;
        }
        // At least one saved line: the saved one keeps the merged points; the other is removed.
        const keep = a.ref.isSaved ? a : b;
        const other = a.ref.isSaved ? b : a;
        upsertEdited({ id: keep.ref.id, points, width });
        if (other.ref.isSaved) {
            upsertEdited({ id: other.ref.id, points: [], width: other.width, isDeleted: true });
        }
        else {
            setCompletedPolylines((prev) => prev.filter((p) => p.id !== other.ref.id));
        }
    }, [upsertEdited]);
    /** ConnectVertex anchor click — first click selects, second (different) merges. */
    const onMergeAnchor = useCallback((ref, anchorIndex) => {
        if (submitting)
            return; // frozen while a save is in flight
        const line = resolveLine(ref);
        if (!line)
            return;
        if (!mergeAnchor) {
            setMergeAnchor({ ref, anchorIndex });
            return;
        }
        if (mergeAnchor.ref.id === ref.id && mergeAnchor.anchorIndex === anchorIndex) {
            setMergeAnchor(null);
            return;
        }
        const first = resolveLine(mergeAnchor.ref);
        if (!first) {
            setMergeAnchor({ ref, anchorIndex });
            return;
        }
        performMerge({ ref: mergeAnchor.ref, anchorIndex: mergeAnchor.anchorIndex, points: first.points, width: first.width }, { ref, anchorIndex, points: line.points, width: line.width });
        setMergeAnchor(null);
    }, [mergeAnchor, resolveLine, performMerge, submitting]);
    /** Mark a saved line for deletion (flushed as a batch-delete on save). */
    const deleteSaved = useCallback((id) => {
        if (submitting)
            return; // frozen while a save is in flight
        const existing = resolveLine({ id, isSaved: true });
        upsertEdited({ id, points: existing?.points ?? [], width: existing?.width, isDeleted: true });
    }, [resolveLine, upsertEdited, submitting]);
    // Which line / vertex the cursor is over, tracked from the L1 object's hover callbacks. Kept in
    // refs (not state) so `handleCanvasClick` reads the latest without re-subscribing.
    const hoveredLineRef = useRef(null);
    const hoveredVertexRef = useRef(null);
    /** Track line-body hover (the L1 `<Polyline>` `onHover`), so a click knows which line it's on. */
    const onLineHover = useCallback((ref, hovering) => {
        if (hovering)
            hoveredLineRef.current = ref;
        else if (hoveredLineRef.current?.id === ref.id)
            hoveredLineRef.current = null;
    }, []);
    /** Track vertex-anchor hover (the L1 `vertexAnchors.onEnter/onLeave`), for click-to-remove. */
    const onVertexHover = useCallback((ref, index) => {
        if (index !== null)
            hoveredVertexRef.current = { ref, index };
        else if (hoveredVertexRef.current?.ref.id === ref.id)
            hoveredVertexRef.current = null;
    }, []);
    /**
     * Perform the active sub-tool's click action at `point`, driven off the tracked hover state.
     * Wired to the canvas's raw left-click (reliable) rather than the L1 object's own click handlers,
     * which don't fire here because the orbit controls capture the pointer on down (only the drag
     * path, which uses a window `mouseup`, survives that). Returns whether the click was consumed —
     * the canvas then skips placing a drawing vertex for it.
     */
    const handleCanvasClick = useCallback((point) => {
        if (!isActive || submitting)
            return false; // frozen while a save is in flight
        // Both remove sub-modes delete a hovered vertex (keeping ≥2 points). Only `Remove` also cuts
        // an edge into two lines. `Remove` is hidden on Platform (a split would create an ambiguous
        // second line that can't be linked to the damage), so `RemoveVertex` is a no-op on an edge.
        if (editSubtool === SubtoolVertex.RemoveVertex || editSubtool === SubtoolVertex.Remove) {
            const vertex = hoveredVertexRef.current;
            if (vertex) {
                const line = resolveLine(vertex.ref);
                if (line && line.points.length > 2) {
                    onEditPoints(vertex.ref, line.points.filter((_, index) => index !== vertex.index));
                }
                return true;
            }
            if (editSubtool === SubtoolVertex.Remove) {
                const hoveredLine = hoveredLineRef.current;
                if (hoveredLine) {
                    const line = resolveLine(hoveredLine);
                    if (line)
                        onSplit(hoveredLine, calculateIndexInPolyline(line.points, point));
                    return true;
                }
            }
            return false;
        }
        if (editSubtool === SubtoolVertex.AddVertex) {
            const hoveredLine = hoveredLineRef.current;
            if (hoveredLine) {
                const line = resolveLine(hoveredLine);
                if (line) {
                    const index = calculateIndexInPolyline(line.points, point);
                    const next = [...line.points];
                    next.splice(index, 0, point);
                    onEditPoints(hoveredLine, next);
                }
                return true;
            }
            return false;
        }
        return false;
    }, [isActive, editSubtool, resolveLine, onEditPoints, onSplit, submitting]);
    /** Set the width for new lines + all unsaved drafts, and optionally the given saved lines. */
    const setWorkingWidth = useCallback((width, targetSavedIds) => {
        if (submitting)
            return; // frozen while a save is in flight
        setWorkingWidthState(width);
        setCompletedPolylines((prev) => prev.map((p) => ({ ...p, width })));
        targetSavedIds?.forEach((id) => {
            const existing = editedById[id] ?? savedPolylines.find((s) => s.id === id);
            if (existing)
                upsertEdited({ id, points: existing.points, width, isDeleted: editedById[id]?.isDeleted });
        });
    }, [editedById, savedPolylines, upsertEdited, submitting]);
    const setLabelVisibility = useCallback((visibility) => {
        setLabelVisibilityState((prev) => ({ ...prev, ...visibility }));
    }, []);
    // ---- save ----
    const editedList = useMemo(() => Object.values(editedById), [editedById]);
    const hasChanges = completedPolylines.length > 0 || editedList.length > 0;
    const doSave = useCallback(async (finish) => {
        if (!hasChanges || submitting)
            return;
        const created = completedPolylines
            .filter((p) => p.points.length >= 2)
            .map((p) => ({ points: p.points, width: p.width }));
        const edited = editedList
            .filter((e) => !e.isDeleted && e.points.length >= 2)
            .map((e) => ({ id: e.id, points: e.points, width: e.width }));
        const deleted = editedList.filter((e) => e.isDeleted || e.points.length < 2).map((e) => e.id);
        if (!created.length && !edited.length && !deleted.length)
            return;
        setSubmitting(true);
        try {
            await savePolylines({ created, edited, deleted });
            // Success: the writes are settled and re-fetched by L3; drop the local work.
            setCompletedPolylines([]);
            setEditedById({});
            setMergeAnchor(null);
            canvasHandleRef.current?.cancel();
            if (finish)
                setSelectedTool(EditorTools.Move);
        }
        catch {
            // Failure: keep the unsaved work so the user can retry (mirrors the Editor's allSettled flush).
        }
        finally {
            setSubmitting(false);
        }
    }, [hasChanges, submitting, completedPolylines, editedList, savePolylines, canvasHandleRef, setSelectedTool]);
    // ---- undo (step back a vertex, or re-open the last drawn line) ----
    const undo = useCallback(() => {
        if (placedCount > 0) {
            canvasHandleRef.current?.undo();
            return;
        }
        if (completedPolylines.length > 0) {
            const last = completedPolylines[completedPolylines.length - 1];
            setCompletedPolylines((prev) => prev.slice(0, -1));
            canvasHandleRef.current?.restore(last.points.slice(0, -1).map((p) => new Vector3().fromArray(p)));
        }
    }, [placedCount, completedPolylines, canvasHandleRef]);
    const complete = useCallback(() => {
        canvasHandleRef.current?.complete();
    }, [canvasHandleRef]);
    const cancelWorking = useCallback(() => {
        canvasHandleRef.current?.cancel();
    }, [canvasHandleRef]);
    // ---- derived / canvas ----
    // At most one unsaved line at a time: once one is drawn, placement is suspended until it's saved.
    const isAtMaxLines = completedPolylines.length >= MAX_UNSAVED_LINES;
    // New placement is live only while active, in the AddVertex (draw) sub-mode, under the cap, and
    // not mid-save (edits are frozen while a save is in flight so `doSave` can't clear newer work).
    const isDrawing = isActive && editSubtool === SubtoolVertex.AddVertex;
    const activeTool = isDrawing && !isAtMaxLines && !submitting ? DrawingTool.Polyline : null;
    const drawingConfig = isActive ? POLYLINE_CONFIG : INACTIVE_DRAWING_CONFIG$2;
    const canvas = useMemo(() => ({ activeTool, onComplete }), [activeTool, onComplete]);
    const defaultCursor = useMemo(() => {
        if (!isActive)
            return CursorState.NONE;
        if (editSubtool === SubtoolVertex.AddVertex)
            return CursorState.CROSSHAIR;
        if (editSubtool === SubtoolVertex.RemoveVertex ||
            editSubtool === SubtoolVertex.Remove ||
            editSubtool === SubtoolVertex.ConnectVertex)
            return CursorState.POINTER;
        return CursorState.NONE;
    }, [isActive, editSubtool]);
    // ---- buttons ----
    const saveDisabled = !hasChanges || submitting || Boolean(submitGate?.disabled);
    const saveButton = useMemo(() => ({
        preset: ToolButtonPreset.Save,
        loadingText: t('ui.saving'),
        onClick: () => void doSave(false),
        disabled: saveDisabled,
        loading: submitting,
    }), [t, doSave, saveDisabled, submitting]);
    const saveAndFinishButton = useMemo(() => ({
        preset: ToolButtonPreset.SaveAndExit,
        loadingText: t('ui.saving'),
        onClick: () => void doSave(true),
        disabled: saveDisabled,
        loading: submitting,
    }), [t, doSave, saveDisabled, submitting]);
    // Not dirty while a save is in flight: the flush is committed work and can't be cancelled, so
    // guards must not offer to "discard" it. A failed flush re-reports dirty (the work is kept).
    const isDirty = (hasChanges || (ownsPlacement && placedCount > 0)) && !submitting;
    // The new line that has no item yet — being placed, or drawn and awaiting its save. Survives the
    // flush (so a host listing it can spin the entry rather than drop it) and ignores edits to saved
    // lines. Only ever one at a time: placement is suspended while an unsaved draft is outstanding.
    const hasWorkingLine = completedPolylines.length > 0 || (ownsPlacement && placedCount > 0);
    // Shown for the whole tool session (not just once dirty); disabled until there's unsaved work.
    const resetButton = useMemo(() => (isActive ? { preset: ToolButtonPreset.Reset, onClick: reset, disabled: !isDirty || submitting } : null), [isActive, isDirty, submitting, reset]);
    // Draw actions apply only while a working line is being drawn (AddVertex + placed vertices).
    const undoButton = useMemo(() => isDrawing && (placedCount > 0 || completedPolylines.length > 0)
        ? { preset: ToolButtonPreset.Undo, onClick: undo, disabled: submitting }
        : null, [isDrawing, placedCount, completedPolylines.length, submitting, undo]);
    const cancelButton = useMemo(() => isDrawing && placedCount > 0
        ? { preset: ToolButtonPreset.Cancel, onClick: cancelWorking, disabled: submitting }
        : null, [isDrawing, placedCount, submitting, cancelWorking]);
    const completeButton = useMemo(() => isDrawing && placedCount > 0
        ? { preset: ToolButtonPreset.Complete, onClick: complete, disabled: !completable || submitting }
        : null, [isDrawing, placedCount, completable, submitting, complete]);
    // Vertex sub-tool toggles for the bottom-center subtoolbar (shown whenever the tool is active).
    const vertexButtons = useMemo(() => {
        if (!isActive)
            return [];
        const make = (subtool, label, icon) => ({
            key: subtool,
            label,
            icon,
            active: editSubtool === subtool,
            onClick: () => setEditSubtool(subtool),
        });
        return [
            make(SubtoolVertex.AddVertex, t('3d.polyline.vertex.add'), SvgVertexAdd),
            make(SubtoolVertex.RemoveVertex, t('3d.polyline.vertex.remove'), SvgVertexRemove),
            // TODO: `Remove` (delete vertex + cut an edge into two lines) is hidden on Platform: a split
            // would create a second polyline, but a line must stay 1:1 with its damage record. Kept in
            // the enum + click handling so it can be brought back later.
            // make(SubtoolVertex.Remove, t('3d.polyline.vertex.removeSplit'), VertexRemoveIcon),
            make(SubtoolVertex.MoveVertex, t('3d.polyline.vertex.move'), SvgVertexMove),
            // TODO: Connect (merge two lines) does not apply to the current single-polyline-per-save
            // Platform flow (there's only ever one unsaved line to merge). To be brought back later.
            // make(SubtoolVertex.ConnectVertex, t('3d.polyline.vertex.connect'), VertexConnectIcon),
        ];
    }, [isActive, editSubtool, t, setEditSubtool]);
    // Memoised on its actual inputs so consumers (and the app's ToolApi built on top) get a stable
    // reference — the API's identity only changes when tool state actually does.
    return useMemo(() => ({
        isActive,
        activeTool,
        drawingConfig,
        canvas,
        defaultCursor,
        toggle,
        reset,
        discardWorkingLine,
        isDirty,
        hasWorkingLine,
        isSaving: submitting,
        editSubtool,
        completedPolylines,
        editedById,
        workingWidth,
        labelVisibility,
        onComplete,
        onEditPoints,
        onSplit,
        onMergeAnchor,
        mergeAnchor,
        deleteSaved,
        onLineHover,
        onVertexHover,
        handleCanvasClick,
        setEditSubtool,
        setWorkingWidth,
        setLabelVisibility,
        saveButton,
        saveAndFinishButton,
        resetButton,
        undoButton,
        cancelButton,
        completeButton,
        vertexButtons,
    }), [
        isActive,
        activeTool,
        drawingConfig,
        canvas,
        defaultCursor,
        toggle,
        reset,
        discardWorkingLine,
        isDirty,
        hasWorkingLine,
        submitting,
        editSubtool,
        completedPolylines,
        editedById,
        workingWidth,
        labelVisibility,
        onComplete,
        onEditPoints,
        onSplit,
        onMergeAnchor,
        mergeAnchor,
        deleteSaved,
        onLineHover,
        onVertexHover,
        handleCanvasClick,
        setEditSubtool,
        setWorkingWidth,
        setLabelVisibility,
        saveButton,
        saveAndFinishButton,
        resetButton,
        undoButton,
        cancelButton,
        completeButton,
        vertexButtons,
    ]);
}

/** A measurement is always exactly two points — a distance, not an open N-vertex line. */
const MEASUREMENT_VERTEX_COUNT = 2;
/**
 * Drawing config for the CustomMeasurement tool: the **Polyline** primitive capped at two vertices,
 * so the engine auto-completes the line as the second point lands (`maxVertices`, no closing anchor
 * and no manual finish). No derived plane (`extendToBbox` off — a line never derives one).
 */
const CUSTOM_MEASUREMENT_CONFIG = { maxVertices: MEASUREMENT_VERTEX_COUNT };
/** Config synced into the canvas while the tool is inactive (matches the shared inactive baseline). */
const INACTIVE_DRAWING_CONFIG$1 = {};

const newId = () => crypto.randomUUID();
const toPointArray = (v) => v.toArray();
/** Tolerance (in metres) under which a queued endpoint edit counts as already saved. */
const POINT_MATCH_TOLERANCE = 0.0001;
/** Whether two point lists describe the same measurement (within the write round-trip's tolerance). */
const arePointsEqual = (a, b) => a.length === b.length &&
    a.every((point, index) => point.every((coord, axis) => Math.abs(coord - b[index][axis]) <= POINT_MATCH_TOLERANCE));
/**
 * Headless CustomMeasurement tool (Layer 2 — shared, app-agnostic). Draws a **two-point distance**
 * on the L1 Polyline primitive capped at `maxVertices: 2`, so the line auto-completes as the second
 * point lands. It is the first tool that **auto-saves**: there is no Save button, no submit gate and
 * no blocking save stage — completing a measurement fires the injected write, and so does dragging a
 * saved measurement's endpoint. The hook holds the not-yet-written work only so the canvas can keep
 * showing it; persistence, item types and defect records all live in the L3 consumer.
 */
function useCustomMeasurement({ canvasHandleRef, placedCount, saveMeasurements, savedMeasurements, selectedTool, setSelectedTool, tool = EditorTools.CustomMeasurement, }) {
    // The tool is active when it's the selected business tool (single source of truth, L2).
    const isActive = selectedTool === tool;
    // States — the in-progress point lives in the L1 drawing engine; these are the finished work
    // waiting on its write.
    const [pendingMeasurements, setPendingMeasurements] = useState([]);
    const [editedById, setEditedById] = useState({});
    // Whether the in-progress placement on the *shared* canvas is this tool's. `placedCount` is the
    // one canvas's count, so it only counts as this tool's half-drawn measurement while this tool owns
    // the drawing (active, or suspended under a Focus detour) — another tool's placement is not ours.
    const [ownsPlacement, setOwnsPlacement] = useState(false);
    // Refs — the callbacks below fire from canvas events, so they read the latest work from refs
    // rather than a stale closure.
    const pendingRef = useRef(pendingMeasurements);
    const editedRef = useRef(editedById);
    useEffect(() => {
        pendingRef.current = pendingMeasurements;
    }, [pendingMeasurements]);
    useEffect(() => {
        editedRef.current = editedById;
    }, [editedById]);
    /**
     * Fire the auto-save with the tool's **whole** current change set: the consumer coalesces a burst
     * into one flush that keeps only the newest call's payload, so every call has to carry everything
     * still unwritten. Created measurements travel with their client id — the consumer de-duplicates
     * on it, since one may ride along in several calls before a flush actually sends it.
     * @param created Completed measurements whose write hasn't landed yet.
     * @param edited Queued endpoint edits to saved measurements.
     */
    const flush = useCallback((created, edited) => {
        if (!created.length && !edited.length)
            return;
        saveMeasurements({
            created: created.map(({ id, points }) => ({ id, points })),
            edited: edited.map(({ id, points }) => ({ id, points })),
        })
            .then(() => {
            // The writes landed and the consumer refreshed its cache, so the saved items take over
            // from the local copies. An edit superseded while in flight is kept (its own flush is
            // still pending) — hence the identity check rather than a blanket delete.
            setPendingMeasurements((prev) => prev.filter((draft) => !created.some((sent) => sent.id === draft.id)));
            setEditedById((prev) => {
                const next = { ...prev };
                edited.forEach((edit) => {
                    if (next[edit.id] === edit)
                        delete next[edit.id];
                });
                return next;
            });
        })
            .catch(() => {
            // Keep the work: the next completion / endpoint drag sends it again (L3 toasts the error).
        });
    }, [saveMeasurements]);
    /** Drop the unfinished (single-point) measurement; finished ones are already committed. */
    const reset = useCallback(() => {
        canvasHandleRef.current?.cancel();
    }, [canvasHandleRef]);
    /**
     * Drop everything not yet written, for a consumer whose target changed under the tool (an area
     * switch): unwritten work is in the *old* target's world coordinates, and a retry would write it
     * against the new one — so it can only be thrown away, never kept.
     */
    const discardUnwritten = useCallback(() => {
        setPendingMeasurements([]);
        setEditedById({});
        canvasHandleRef.current?.cancel();
    }, [canvasHandleRef]);
    // Selecting another tool drops the unfinished measurement — the normal rule. The single exception
    // is Focus: a transient detour that returns here, so the placed point must survive it. Reset fires
    // only when *this* tool is the one being left: `reset()` cancels the shared canvas placement, so
    // an unconditional run would wipe another tool's in-progress drawing on its Focus-return leg.
    const wasActiveRef = useRef(false);
    useEffect(() => {
        if (isActive) {
            wasActiveRef.current = true;
            setOwnsPlacement(true);
            return;
        }
        // A Focus detour keeps both the placed point and the claim on the shared placement.
        if (selectedTool === EditorTools.Focus)
            return;
        if (wasActiveRef.current)
            reset();
        wasActiveRef.current = false;
        setOwnsPlacement(false);
    }, [isActive, selectedTool, reset]);
    // Work that has arrived in the saved data is done — drop the local copy. Normally the flush's
    // success does this; keeping it self-healing means a partially-failed flush (one whose create did
    // land) can't leave a saved measurement drawn twice, or a moved endpoint overlaid for good.
    useEffect(() => {
        setPendingMeasurements((prev) => {
            const settled = prev.filter((draft) => savedMeasurements.some((measurement) => arePointsEqual(measurement.points, draft.points)));
            if (!settled.length)
                return prev;
            return prev.filter((draft) => !settled.includes(draft));
        });
        setEditedById((prev) => {
            const settled = Object.values(prev).filter((edit) => {
                const saved = savedMeasurements.find((measurement) => measurement.id === edit.id);
                // Gone from the saved data (deleted from the item list, or the area changed) — there is
                // nothing left to patch, and keeping it would fail the write again on every later change.
                if (!saved)
                    return true;
                return arePointsEqual(saved.points, edit.points);
            });
            if (!settled.length)
                return prev;
            const next = { ...prev };
            settled.forEach((edit) => delete next[edit.id]);
            return next;
        });
    }, [savedMeasurements]);
    /** Enter the tool, or leave it back to the base Selector if it's already active. */
    const toggle = useCallback(() => {
        setSelectedTool((prev) => (prev === tool ? EditorTools.Move : tool));
    }, [setSelectedTool, tool]);
    /**
     * The second point landed (the engine auto-completed at `maxVertices`): keep the finished line so
     * it stays visible, fire its write, and stay in draw mode for the next measurement.
     * @param result The completed drawing's vertices.
     */
    const onComplete = useCallback((result) => {
        if (result.vertices.length < MEASUREMENT_VERTEX_COUNT)
            return;
        const points = result.vertices.slice(0, MEASUREMENT_VERTEX_COUNT).map(toPointArray);
        // A double-click places both points at once (the primitive auto-completes at two, so nothing
        // else consumes the second click): that measures nothing, and auto-saving it would leave junk
        // the user can only delete from the item list. Drop it instead.
        if (arePointsEqual([points[0]], [points[1]]))
            return;
        const draft = { id: newId(), points };
        setPendingMeasurements((prev) => [...prev, draft]);
        flush([...pendingRef.current, draft], Object.values(editedRef.current));
    }, [flush]);
    /**
     * An endpoint of a saved measurement was dragged to a new position: queue the edit (so the line
     * keeps the moved endpoint) and fire its write. A measurement is always two points, so a list of
     * any other length is not a measurement and is ignored.
     * @param id Inspection item id of the saved measurement.
     * @param points The measurement's two points after the drag.
     */
    const onEditPoints = useCallback((id, points) => {
        if (points.length !== MEASUREMENT_VERTEX_COUNT)
            return;
        const edit = { id, points };
        setEditedById((prev) => ({ ...prev, [id]: edit }));
        flush(pendingRef.current, [...Object.values(editedRef.current).filter((queued) => queued.id !== id), edit]);
    }, [flush]);
    /** Step the single placed point back out of the in-progress measurement. */
    const undo = useCallback(() => {
        canvasHandleRef.current?.undo();
    }, [canvasHandleRef]);
    // ---- derived / canvas ----
    const activeTool = isActive ? DrawingTool.Polyline : null;
    const drawingConfig = isActive ? CUSTOM_MEASUREMENT_CONFIG : INACTIVE_DRAWING_CONFIG$1;
    const canvas = useMemo(() => ({ activeTool, onComplete }), [activeTool, onComplete]);
    const defaultCursor = isActive ? CursorState.CROSSHAIR : CursorState.NONE;
    // A measurement is half drawn: its first point is placed and the second hasn't landed. Consumers
    // list it as a temporary in-progress entry, the way the other drawing tools' do. The upper bound
    // matters: the engine reports the full count for the render that completes the measurement, and
    // without it that render would show both the half-drawn entry and the completed one's saving entry.
    const hasWorkingMeasurement = ownsPlacement && placedCount > 0 && placedCount < MEASUREMENT_VERTEX_COUNT;
    // ---- buttons ----
    // The only draw action: shown for the whole tool session, enabled while the first point is placed
    // and the second isn't. A completed measurement is never undone — it is deleted from the item list
    // — so once nothing is placed there is nothing to step back.
    const undoButton = useMemo(() => (isActive ? { preset: ToolButtonPreset.Undo, onClick: undo, disabled: placedCount === 0 } : null), [isActive, placedCount, undo]);
    // Memoised on its actual inputs so consumers (and the app's ToolApi built on top) get a stable
    // reference — the API's identity only changes when tool state actually does.
    return useMemo(() => ({
        isActive,
        activeTool,
        drawingConfig,
        canvas,
        defaultCursor,
        toggle,
        reset,
        discardUnwritten,
        hasWorkingMeasurement,
        pendingMeasurements,
        editedById,
        onComplete,
        onEditPoints,
        undoButton,
    }), [
        isActive,
        activeTool,
        drawingConfig,
        canvas,
        defaultCursor,
        toggle,
        reset,
        discardUnwritten,
        hasWorkingMeasurement,
        pendingMeasurements,
        editedById,
        onComplete,
        onEditPoints,
        undoButton,
    ]);
}

/**
 * Drawing config for the Mask tool: the cuboid auto-completes at its 4th anchor (3 define the base
 * plane, the 4th the depth), so there is no closing anchor and no manual close.
 */
const MASK_CONFIG = { maxVertices: CUBOID_REQUIRED_ANCHORS };
/** Config synced into the canvas while the tool is inactive (matches the shared inactive baseline). */
const INACTIVE_DRAWING_CONFIG = {};
/**
 * Synthetic `region_id` of the working (unsaved) box — the saved region gets its real id from the
 * create response. The Editor used the same literal for its live-preview extra mask.
 */
const MASK_WORKING_REGION_ID = 'working-mask';
/** Throttle (ms) for pushing live gizmo transforms into state — the renderers' preview rate. */
const MASK_LIVE_PREVIEW_THROTTLE = 1000 / 30;
/**
 * Opacity of everything *outside* the masks while the in-tool view holds (`isViewAllPoints`) —
 * the whole scene stays visible, dimmed, on both renderers. The Editor's `showAsDim` /
 * `forceShowOutside` value (0.1 in `PotreePCD` and the mesh manager alike).
 */
const MASK_VIEW_ALL_POINTS_OPACITY = 0.1;

/**
 * The gizmo mode the working box is transformed with — the Editor's
 * `EDITOR_SUB_TOOLS.CUBOID.{TRANSLATE,SCALE,ROTATE}`. Values match the L1 `TransformTypes` (and
 * drei's `TransformControls` modes) so they map straight onto the gizmo.
 */
var MaskTransformMode;
(function (MaskTransformMode) {
    MaskTransformMode["Translate"] = "translate";
    MaskTransformMode["Scale"] = "scale";
    MaskTransformMode["Rotate"] = "rotate";
})(MaskTransformMode || (MaskTransformMode = {}));

/**
 * Headless Mask tool (Layer 2 — shared, app-agnostic). Owns the working (unsaved) cuboid — placed
 * via 4 anchors or the triple-click quick box, then transformed with the translate / scale /
 * rotate gizmo — and firing save. It carries no notion of "damage"/defect records (masks are
 * area-wide) and no persistence — those live entirely in the L3 consumer. Saves are **direct**
 * (no background job): the save buttons block only for the POST round-trip.
 */
function useMask({ canvasHandleRef, placedCount, saveMask, savedRegions, selectedTool, setSelectedTool, tool = EditorTools.Mask, }) {
    // Hooks
    const { t } = useTranslation();
    // The tool is active when it's the selected business tool (single source of truth, L2).
    const isActive = selectedTool === tool;
    // States — in-progress anchor placement lives in the L1 drawing engine; these are everything else.
    const [workingAnchors, setWorkingAnchors] = useState(null);
    const [workingRegion, setWorkingRegion] = useState(null);
    const [transformMode, setTransformMode] = useState(MaskTransformMode.Scale);
    const [isSuspendedByFocus, setIsSuspendedByFocus] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    // Refs
    const wasActiveRef = useRef(false);
    /** Clear the working (unsaved) box. Never touches saved regions. */
    const reset = useCallback(() => {
        setWorkingAnchors(null);
        setWorkingRegion(null);
        setTransformMode(MaskTransformMode.Scale);
        canvasHandleRef.current?.cancel();
    }, [canvasHandleRef]);
    /**
     * Selecting another tool clears the working box — the normal rule. The single exception is
     * Focus: a transient detour that returns here, so the box must survive it; while suspended under
     * one, the in-tool view mode also holds (`isViewAllPoints`).
     */
    useEffect(() => {
        if (isActive) {
            wasActiveRef.current = true;
            setIsSuspendedByFocus(false);
            return;
        }
        if (selectedTool === EditorTools.Focus) {
            setIsSuspendedByFocus(wasActiveRef.current);
            return;
        }
        // Reset only when *this* tool is the one being left: `reset()` cancels the shared canvas
        // placement, so an unconditional run would wipe another tool's in-progress drawing on its
        // Focus-return leg (same guard as the sibling hooks).
        if (wasActiveRef.current)
            reset();
        wasActiveRef.current = false;
        setIsSuspendedByFocus(false);
    }, [isActive, selectedTool, reset]);
    /** Enter the tool, or leave it back to the base Selector if it's already active. */
    const toggle = useCallback(() => {
        setSelectedTool((prev) => (prev === tool ? EditorTools.Move : tool));
    }, [setSelectedTool, tool]);
    /**
     * Placement finished (4 anchors, already orthogonalized by the engine): keep them and derive the
     * working box immediately, so save is possible without ever touching the gizmo.
     */
    const onComplete = useCallback((result) => {
        if (isSaving)
            return; // frozen while a save is in flight (see doSave)
        if (result.vertices.length !== CUBOID_REQUIRED_ANCHORS)
            return;
        setWorkingAnchors(result.vertices);
        setWorkingRegion({
            region_id: MASK_WORKING_REGION_ID,
            ...generateCuboidFromAnchors(result.vertices, CUBOID_MIN_SIZE),
        });
    }, [isSaving]);
    /**
     * Commit a gizmo-reported box into the working region.
     * @param cuboid The box as currently transformed.
     */
    const commitWorkingRegion = useCallback((cuboid) => {
        setWorkingRegion({ region_id: MASK_WORKING_REGION_ID, ...cuboid });
    }, []);
    // Live gizmo updates land throttled (the renderers preview from `workingRegion`, so an
    // unthrottled 60 Hz drag would re-render every mask consumer per frame)…
    const onWorkingChange = a(commitWorkingRegion, MASK_LIVE_PREVIEW_THROTTLE);
    /**
     * …and a drag end commits immediately, superseding any pending throttled value.
     * @param cuboid The box as released.
     */
    const onWorkingChanged = useCallback((cuboid) => {
        onWorkingChange.cancel();
        commitWorkingRegion(cuboid);
    }, [onWorkingChange, commitWorkingRegion]);
    // ---- save ----
    const doSave = useCallback(async (finish) => {
        if (!workingRegion || isSaving)
            return;
        setIsSaving(true);
        try {
            await saveMask(workingRegion);
            // Success: the region is persisted and re-read by L3; drop the working box.
            setWorkingAnchors(null);
            setWorkingRegion(null);
            canvasHandleRef.current?.cancel();
            if (finish)
                setSelectedTool(EditorTools.Move);
        }
        catch {
            // Failure: keep the working box in place so the user can retry (L3 surfaced the error).
        }
        finally {
            setIsSaving(false);
        }
    }, [workingRegion, isSaving, saveMask, canvasHandleRef, setSelectedTool]);
    // ---- undo (step back an anchor, or re-open the completed box's depth anchor) ----
    const undo = useCallback(() => {
        if (placedCount > 0) {
            canvasHandleRef.current?.undo();
            return;
        }
        if (workingAnchors) {
            const anchors = workingAnchors.slice(0, -1);
            setWorkingAnchors(null);
            setWorkingRegion(null);
            canvasHandleRef.current?.restore(anchors);
        }
    }, [placedCount, workingAnchors, canvasHandleRef]);
    // ---- derived / canvas ----
    // One box at a time: once placed, anchor placement is suspended until it's saved or discarded
    // (the gizmo owns the box from here), and not mid-save.
    const activeTool = isActive && !workingAnchors && !isSaving ? DrawingTool.Cuboid : null;
    const drawingConfig = isActive ? MASK_CONFIG : INACTIVE_DRAWING_CONFIG;
    const canvas = useMemo(() => ({ activeTool, onComplete }), [activeTool, onComplete]);
    const defaultCursor = isActive ? CursorState.CROSSHAIR : CursorState.NONE;
    const isViewAllPoints = isActive || isSuspendedByFocus;
    // Not dirty while a save is in flight: the write is committed work and can't be cancelled, so
    // guards must not offer to "discard" it. A failed save keeps the box and re-reports dirty.
    // `placedCount` is the *shared* canvas's count, so it only counts as this tool's work while this
    // tool owns the drawing (active, or suspended under a Focus detour — i.e. `isViewAllPoints`);
    // another tool placing points is not our box.
    const isDirty = ((isViewAllPoints && placedCount > 0) || workingAnchors !== null) && !isSaving;
    // ---- buttons ----
    const saveDisabled = !workingRegion || isSaving;
    const saveButton = useMemo(() => ({
        preset: ToolButtonPreset.Save,
        loadingText: t('ui.saving'),
        onClick: () => void doSave(false),
        disabled: saveDisabled,
        loading: isSaving,
    }), [t, doSave, saveDisabled, isSaving]);
    const saveAndFinishButton = useMemo(() => ({
        preset: ToolButtonPreset.SaveAndExit,
        loadingText: t('ui.saving'),
        onClick: () => void doSave(true),
        disabled: saveDisabled,
        loading: isSaving,
    }), [t, doSave, saveDisabled, isSaving]);
    // Shown for the whole tool session (not just once dirty); disabled until there's a working box.
    const resetButton = useMemo(() => (isActive ? { preset: ToolButtonPreset.Reset, onClick: reset, disabled: !isDirty || isSaving } : null), [isActive, isDirty, isSaving, reset]);
    const undoButton = useMemo(() => (isActive && isDirty ? { preset: ToolButtonPreset.Undo, onClick: undo, disabled: isSaving } : null), [isActive, isDirty, isSaving, undo]);
    // Gizmo mode toggles for the bottom-center subtoolbar — shown once the box exists (the Editor
    // mounted its CuboidToolbar the same way).
    const transformToggles = useMemo(() => {
        if (!isActive || !workingAnchors)
            return [];
        const make = (mode, label, icon) => ({
            key: mode,
            label,
            icon,
            active: transformMode === mode,
            disabled: isSaving,
            onClick: () => setTransformMode(mode),
        });
        return [
            make(MaskTransformMode.Translate, t('3d.mask.transform.translate'), SvgToolbarTranslate),
            make(MaskTransformMode.Scale, t('3d.mask.transform.scale'), SvgToolbarScale),
            make(MaskTransformMode.Rotate, t('3d.mask.transform.rotate'), SvgToolbarRotate),
        ];
    }, [isActive, workingAnchors, transformMode, isSaving, t]);
    // Memoised on its actual inputs so consumers (and the app's ToolApi built on top) get a stable
    // reference — the API's identity only changes when tool state actually does.
    return useMemo(() => ({
        isActive,
        isViewAllPoints,
        activeTool,
        drawingConfig,
        canvas,
        defaultCursor,
        toggle,
        reset,
        isDirty,
        transformMode,
        workingAnchors,
        workingRegion,
        isSaving,
        savedRegions,
        onComplete,
        onWorkingChange,
        onWorkingChanged,
        saveButton,
        saveAndFinishButton,
        resetButton,
        undoButton,
        transformToggles,
    }), [
        isActive,
        isViewAllPoints,
        activeTool,
        drawingConfig,
        canvas,
        defaultCursor,
        toggle,
        reset,
        isDirty,
        transformMode,
        workingAnchors,
        workingRegion,
        isSaving,
        savedRegions,
        onComplete,
        onWorkingChange,
        onWorkingChanged,
        saveButton,
        saveAndFinishButton,
        resetButton,
        undoButton,
        transformToggles,
    ]);
}

/**
 * How a camera focus was triggered. The string values are carried verbatim into analytics as the
 * `Trigger` property of the `Camera Focus` event.
 */
var FocusTrigger;
(function (FocusTrigger) {
    FocusTrigger["MiddleClick"] = "Middle Click";
    FocusTrigger["DoubleClickSelector"] = "Double Click (Selector)";
    FocusTrigger["SingleClickFocusTool"] = "Single Click (Focus Tool)";
})(FocusTrigger || (FocusTrigger = {}));

/**
 * Headless Focus tool (Layer 2 — shared, app-agnostic). Focus draws nothing; it re-centres the
 * camera on a clicked scene point via the arcball controls, preserving distance/orientation. The
 * app forwards the canvas's raw click events to `onMiddleClick`/`onPointClick`; this hook reads the
 * business `selectedTool` and decides whether to focus.
 */
function useCameraFocus({ arcballControlsRef, selectedTool, setSelectedTool, onFocus, }) {
    const isActive = selectedTool === EditorTools.Focus;
    // The tool that was active when Focus was armed. Focus is a transient one-shot: arming it does
    // not reset the previous tool, and leaving Focus (one-shot fire or disarm) returns to it rather
    // than to the base Selector — so e.g. focusing mid-CameraProfile drops you back into it.
    const toolBeforeFocusRef = useRef(null);
    /** Re-target the camera on the point (modern equivalent of the Editor's `focusCamera`). */
    const focus = useCallback((point, trigger) => {
        const controls = arcballControlsRef.current;
        if (!controls)
            return;
        controls.focus(point);
        onFocus?.(trigger);
    }, [arcballControlsRef, onFocus]);
    const toggle = useCallback(() => {
        if (selectedTool === EditorTools.Focus) {
            // Disarm → return to the tool we came from.
            setSelectedTool(toolBeforeFocusRef.current ?? EditorTools.Move);
        }
        else {
            // Arm → remember the current tool so leaving Focus can restore it.
            toolBeforeFocusRef.current = selectedTool;
            setSelectedTool(EditorTools.Focus);
        }
    }, [selectedTool, setSelectedTool]);
    // ESC disarms Focus (tool-exit gesture), returning to the tool it was armed from without firing.
    // While armed, `activeTool` is null, so the drawing engine's own ESC-cancel is dormant — this is
    // the only ESC handler in play, and it leaves the suspended tool's work intact.
    useEffect(() => {
        if (!isActive)
            return undefined;
        const onKeyDown = (e) => {
            if (e.key === 'Escape')
                setSelectedTool(toolBeforeFocusRef.current ?? EditorTools.Move);
        };
        document.addEventListener('keydown', onKeyDown);
        return () => document.removeEventListener('keydown', onKeyDown);
    }, [isActive, setSelectedTool]);
    // Middle-click focuses under any tool.
    const onMiddleClick = useCallback((point) => {
        focus(point, FocusTrigger.MiddleClick);
    }, [focus]);
    const onPointClick = useCallback((point, { isDoubleClicked }) => {
        if (selectedTool === EditorTools.Focus) {
            // One-shot: single-click focuses, then returns to the tool Focus was armed from.
            focus(point, FocusTrigger.SingleClickFocusTool);
            setSelectedTool(toolBeforeFocusRef.current ?? EditorTools.Move);
            return true;
        }
        // Double-click focuses only under the base Selector.
        if (isDoubleClicked && selectedTool === EditorTools.Move) {
            focus(point, FocusTrigger.DoubleClickSelector);
            return true;
        }
        return false;
    }, [selectedTool, setSelectedTool, focus]);
    // Memoised on its actual inputs so consumers (and the app's ToolApi built on top) get a stable
    // reference — the API's identity only changes when tool state actually does.
    return useMemo(() => ({ isActive, toggle, onMiddleClick, onPointClick }), [isActive, toggle, onMiddleClick, onPointClick]);
}

/**
 * Tool-global keyboard shortcuts (Layer 2 — shared, app-agnostic). Generic over tools: the app
 * feeds it whatever action buttons the active tool exposes, so shortcuts are wired once instead of
 * per tool. Today it binds:
 *
 * - **Ctrl+Z / Cmd+Z → undo** (skipped when the button is absent/disabled, and while typing in a
 *   field so it doesn't hijack native text undo).
 *
 * Listens globally because the canvas may not hold focus. Extend with more actions (redo, etc.) by
 * adding fields to {@link ToolShortcuts}.
 */
function useToolShortcuts({ undo }) {
    const undoDisabled = !undo || undo.disabled;
    const onUndo = undo?.onClick;
    useEffect(() => {
        if (undoDisabled || !onUndo)
            return;
        const handleKeyDown = (e) => {
            const isUndoCombo = (e.metaKey || e.ctrlKey) && !e.shiftKey && !e.altKey && e.key.toLowerCase() === 'z';
            if (!isUndoCombo)
                return;
            const target = e.target;
            const isTyping = !!target && (target.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName));
            if (isTyping)
                return;
            e.preventDefault();
            onUndo();
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [undoDisabled, onUndo]);
}

const editorToolsContextInitialState = {
    selectedTool: EditorTools.Move,
    setSelectedTool: () => { },
};
const EditorToolsContext = createContext(editorToolsContextInitialState);
const useEditorToolsContext = () => useContext(EditorToolsContext);
/**
 * Owns the business-tool selection for a 3D editing surface. Wrap the app's tools layer in this so
 * every tool (and the toolbar UI) reads/writes one shared selection — selecting one tool
 * deactivates the others.
 */
const EditorToolsProvider = ({ children }) => {
    const [selectedTool, setSelectedTool] = useState(EditorTools.Move);
    const value = useMemo(() => ({ selectedTool, setSelectedTool }), [selectedTool]);
    return jsx(EditorToolsContext.Provider, { value: value, children: children });
};

// https://stackoverflow.com/a/66089276
function preventDefault(e) {
    if (!isTouchEvent(e))
        return;
    if (e.touches.length < 2 && e.preventDefault) {
        e.preventDefault();
    }
}
function isTouchEvent(e) {
    return e && 'touches' in e;
}
function useLongPress({ onLongPress, onClick }, { delay = 300, shouldPreventDefault = true } = {}) {
    const [longPressTriggered, setLongPressTriggered] = useState(false);
    const timeout = useRef(null);
    const target = useRef(null);
    const start = useCallback((e) => {
        e.persist();
        const clonedEvent = { ...e };
        if (shouldPreventDefault && e.target) {
            e.target.addEventListener('touchend', preventDefault, { passive: false });
            target.current = e.target;
        }
        timeout.current = setTimeout(() => {
            onLongPress(clonedEvent);
            setLongPressTriggered(true);
        }, delay);
    }, [onLongPress, delay, shouldPreventDefault]);
    const clear = useCallback((e, shouldTriggerClick = true) => {
        if (timeout.current)
            clearTimeout(timeout.current);
        if (shouldTriggerClick && !longPressTriggered)
            onClick?.(e);
        setLongPressTriggered(false);
        if (shouldPreventDefault && target.current) {
            target.current.removeEventListener('touchend', preventDefault);
        }
    }, [shouldPreventDefault, onClick, longPressTriggered]);
    return {
        onMouseDown: (e) => start(e),
        onTouchStart: (e) => start(e),
        onMouseUp: (e) => clear(e),
        onMouseLeave: (e) => clear(e, false),
        onTouchEnd: (e) => clear(e),
    };
}

const ToolbarButton = ({ icon, label, warningLabel, toolType, variants, buttonSize, toolTipPlacement, disabled = false, onMouseEnter, onMouseLeave, }) => {
    const { open, onToggle, onClose } = useDisclosure();
    const { selectedTool, setSelectedTool } = useEditorToolsContext();
    // Refs
    const buttonRef = useRef(null);
    // States
    const [selectedVariant, setSelectedVariant] = useState(toolType);
    // store
    // const dispatch = useAppDispatch()
    // const videos = useAppSelector((root) => root.videos.videos)
    // const workingTools = useAppSelector((root) => root.toolUtil.core.workingTools)
    // const successTools = useAppSelector((root) => root.toolUtil.core.successTools)
    const videos = [];
    const workingTools = [];
    const successTools = [];
    // Get the selected video configuration
    // The tool change modal is only displayed if it has a videoUrl or description.
    // Otherwise, it is displayed when the help icon is pressed.
    const vc = useMemo(() => videos.find((video) => video.toolType === selectedVariant && !video.variant), [videos, selectedVariant]);
    const defaultVc = useMemo(() => ({
        toolType: selectedVariant,
        version: 0,
        title: variants?.find((v) => v.toolType === selectedVariant)?.label
            ? `${label} - ${variants.find((v) => v.toolType === selectedVariant).label}`
            : label,
        helpCenterUrl: HELP_CENTER_URL,
    }), [selectedVariant, label, variants]);
    // The modal display when a tool is changed is not shown if there is no setting in AppConfig.
    const videoConfig = useMemo(() => vc
        ? {
            ...defaultVc,
            ...vc,
        }
        : undefined, [vc, defaultVc]);
    // The modal display when the ? icon is clicked is displayed
    // with the default setting even if there is no setting in AppConfig.
    // useEffect(() => {
    //   if (selectedTool === selectedVariant) {
    //     dispatch(setSelectedVideoConfig(videoConfig || defaultVc))
    //   }
    // }, [videoConfig, selectedTool, selectedVariant, dispatch, defaultVc])
    const onLongPress = () => {
        if (!disabled)
            onToggle();
    };
    const useDisclosureProps = useDisclosure();
    const onClick = (e) => {
        e.stopPropagation();
        if (disabled)
            return;
        // Get the version of the watched video from localStorage
        const watchedVersion = localStorage.getItem(selectedVariant);
        const isVideoWatched = videoConfig && watchedVersion ? Number(watchedVersion) >= videoConfig.version : false;
        if (!isVideoWatched && videoConfig) {
            useDisclosureProps.onOpen();
            localStorage.setItem(selectedVariant, videoConfig.version.toString());
            // Tracking
            // mixpanel.track('Show Help Modal', {
            //   'Selected Tool': selectedVariant,
            //   'Video URL': videoConfig.videoUrl,
            //   'External URL': videoConfig.helpCenterUrl,
            //   'Triggered By': 'Auto',
            //   'Help Config Version': videoConfig.version,
            // })
        }
        setSelectedTool(selectedVariant);
    };
    const mouseLongPress = useLongPress({ onLongPress, onClick }, { delay: 1200, shouldPreventDefault: true });
    return (jsxs(Fragment, { children: [jsx(Tooltip, { positioning: { placement: toolTipPlacement || 'right' }, showArrow: true, label: label ? (jsxs(Fragment, { children: [jsx(Text$2, { fontSize: "sm", children: label }), warningLabel ? (jsx(Text$2, { fontSize: "xs", color: "orange.400", mt: 2, children: warningLabel })) : null] })) : null, children: jsx(Flex, { userSelect: "none", className: "toolbar-button", onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, children: jsxs(Square, { "data-testid": `${label}ToolbarButton`, ref: buttonRef, ...mouseLongPress, position: "relative", backgroundColor: selectedTool === selectedVariant ? 'gray2.600' : 'transparent', color: "white", opacity: disabled ? 0.2 : 1, fontSize: "xl", size: buttonSize, className: [
                            selectedTool === selectedVariant ? 'selected' : null,
                            successTools.includes(toolType) ? 'success' : null,
                        ]
                            .filter(Boolean)
                            .join(' '), children: [variants?.find((v) => v.toolType === selectedVariant)?.icon || icon, variants && (jsx(Square, { position: "absolute", bottom: 0, right: 0, size: 2, borderBottomColor: "secondary.400", borderRightColor: "secondary.400", borderTopColor: "transparent", borderLeftColor: "transparent", borderWidth: 4 })), successTools.includes(toolType) && (jsx(Circle$2, { size: 3, position: "absolute", bgColor: "green.400", top: 1, right: 1 })), workingTools.includes(toolType) && (jsx(Spinner, { size: "xs", position: "absolute", color: "orange", css: { '--spinner-track-color': 'colors.whiteAlpha.300' }, top: 1, right: 1 }))] }) }) }), variants && (jsx(Portal, { children: jsxs(Popover.Root, { open: open, onOpenChange: (e) => (e.open ? null : onClose()), closeOnInteractOutside: true, children: [jsx(Popover.Trigger, { asChild: true, children: jsx(Square, { position: "absolute", size: buttonSize, pointerEvents: "none", backgroundColor: "transparent", top: (buttonRef.current?.offsetTop || 0) + 35, zIndex: 0 }) }), jsx(Popover.Positioner, { children: jsxs(Popover.Content, { w: buttonSize, borderWidth: 0, backgroundColor: "transparent", children: [jsx(Popover.Body, { p: 0, backgroundColor: "secondary.800", borderColor: "secondary.700", borderWidth: 1, overflow: "hidden", borderRadius: "md", children: jsx(VStack, { gap: 0, separator: jsx(StackSeparator, { borderColor: "whiteAlpha.200" }), children: variants.map((variant) => (jsx(Tooltip, { showArrow: true, positioning: { placement: 'right' }, label: variant.label, children: jsx(Square, { "data-testid": `${variant.label}ToolbarButton`, position: "relative", backgroundColor: selectedVariant === variant.toolType ? 'secondary.600' : 'transparent', color: "white", fontSize: "xl", size: buttonSize, onClick: (e) => {
                                                        e.stopPropagation();
                                                        setSelectedVariant(variant.toolType);
                                                        // Get the version of the watched video from localStorage
                                                        const variantVc = videos.find((video) => video.toolType === variant.toolType);
                                                        const watchedVersion = localStorage.getItem(variant.toolType);
                                                        const isVideoWatched = variantVc && watchedVersion ? Number(watchedVersion) >= variantVc.version : false;
                                                        if (!isVideoWatched && variantVc) {
                                                            useDisclosureProps.onOpen();
                                                            localStorage.setItem(variant.toolType, variantVc.version.toString());
                                                        }
                                                        setSelectedTool(variant.toolType);
                                                        onToggle();
                                                    }, children: variant.icon }) }, variant.toolType))) }) }), jsx(Popover.Arrow, { left: 12, backgroundColor: "secondary.800", borderColor: "secondary.700", boxShadow: "-1px 1px 1px 0 {colors.gray2.600} !important" })] }) })] }) }))] }));
};

/**
 * @deprecated Use controls directly instead of this hook.
 */
const useFocus = ({ cameraProfile } = {}) => {
    // Hooks
    const { cameraRef: { current: camera }, arcballControlsRef: { current: controls }, } = useThreeCanvasContext();
    /**
     * Focuses the camera on the given points, adjusting the camera position and orientation to ensure all points are visible.
     *
     * @param input Array of 3D points to focus on.
     * @param options Optional parameters to customize the focusing behavior.
     * @returns A promise that resolves when the focusing operation is complete.
     */
    const focusItem = async (input, { cameraProfile: customProfile, skipProfile = false, distance, shouldAnimate = true } = {}) => {
        if (!(camera instanceof PerspectiveCamera) || !(controls instanceof ArcballControls) || input.length < 2)
            return false;
        // If there's a custom profile, use that directly instead of calculating everything.
        if (customProfile) {
            await controls.animateToProfile(customProfile, undefined, shouldAnimate ? undefined : 0);
            return true;
        }
        await controls.focusItem(input, {
            cameraProfile: skipProfile ? undefined : (cameraProfile ?? undefined),
            distance,
            shouldAnimate,
        });
        return true;
    };
    return { focusItem };
};

var SECONDS_A_MINUTE = 60;
var SECONDS_A_HOUR = SECONDS_A_MINUTE * 60;
var SECONDS_A_DAY = SECONDS_A_HOUR * 24;
var SECONDS_A_WEEK = SECONDS_A_DAY * 7;
var MILLISECONDS_A_SECOND = 1e3;
var MILLISECONDS_A_MINUTE = SECONDS_A_MINUTE * MILLISECONDS_A_SECOND;
var MILLISECONDS_A_HOUR = SECONDS_A_HOUR * MILLISECONDS_A_SECOND;
var MILLISECONDS_A_DAY = SECONDS_A_DAY * MILLISECONDS_A_SECOND;
var MILLISECONDS_A_WEEK = SECONDS_A_WEEK * MILLISECONDS_A_SECOND; // English locales

var MS = 'millisecond';
var S = 'second';
var MIN = 'minute';
var H = 'hour';
var D = 'day';
var W = 'week';
var M = 'month';
var Q = 'quarter';
var Y = 'year';
var DATE = 'date';
var FORMAT_DEFAULT = 'YYYY-MM-DDTHH:mm:ssZ';
var INVALID_DATE_STRING = 'Invalid Date'; // regex

var REGEX_PARSE = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/;
var REGEX_FORMAT = /\[([^\]]+)]|YYYY|YY|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g;

// English [en]
// We don't need weekdaysShort, weekdaysMin, monthsShort in en.js locale
var en = {
  name: 'en',
  weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
  months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
  ordinal: function ordinal(n) {
    var s = ['th', 'st', 'nd', 'rd'];
    var v = n % 100;
    return "[" + n + (s[(v - 20) % 10] || s[v] || s[0]) + "]";
  }
};

var padStart = function padStart(string, length, pad) {
  var s = String(string);
  if (!s || s.length >= length) return string;
  return "" + Array(length + 1 - s.length).join(pad) + string;
};

var padZoneStr = function padZoneStr(instance) {
  var negMinutes = -instance.utcOffset();
  var minutes = Math.abs(negMinutes);
  var hourOffset = Math.floor(minutes / 60);
  var minuteOffset = minutes % 60;
  return "" + (negMinutes <= 0 ? '+' : '-') + padStart(hourOffset, 2, '0') + ":" + padStart(minuteOffset, 2, '0');
};

var monthDiff = function monthDiff(a, b) {
  // function from moment.js in order to keep the same result
  if (a.date() < b.date()) return -monthDiff(b, a);
  var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month());
  var anchor = a.clone().add(wholeMonthDiff, M);
  var c = b - anchor < 0;
  var anchor2 = a.clone().add(wholeMonthDiff + (c ? -1 : 1), M);
  return +(-(wholeMonthDiff + (b - anchor) / (c ? anchor - anchor2 : anchor2 - anchor)) || 0);
};

var absFloor = function absFloor(n) {
  return n < 0 ? Math.ceil(n) || 0 : Math.floor(n);
};

var prettyUnit = function prettyUnit(u) {
  var special = {
    M: M,
    y: Y,
    w: W,
    d: D,
    D: DATE,
    h: H,
    m: MIN,
    s: S,
    ms: MS,
    Q: Q
  };
  return special[u] || String(u || '').toLowerCase().replace(/s$/, '');
};

var isUndefined = function isUndefined(s) {
  return s === undefined;
};

var U = {
  s: padStart,
  z: padZoneStr,
  m: monthDiff,
  a: absFloor,
  p: prettyUnit,
  u: isUndefined
};

var L = 'en'; // global locale

var Ls = {}; // global loaded locale

Ls[L] = en;
var IS_DAYJS = '$isDayjsObject'; // eslint-disable-next-line no-use-before-define

var isDayjs = function isDayjs(d) {
  return d instanceof Dayjs || !!(d && d[IS_DAYJS]);
};

var parseLocale = function parseLocale(preset, object, isLocal) {
  var l;
  if (!preset) return L;

  if (typeof preset === 'string') {
    var presetLower = preset.toLowerCase();

    if (Ls[presetLower]) {
      l = presetLower;
    }

    if (object) {
      Ls[presetLower] = object;
      l = presetLower;
    }

    var presetSplit = preset.split('-');

    if (!l && presetSplit.length > 1) {
      return parseLocale(presetSplit[0]);
    }
  } else {
    var name = preset.name;
    Ls[name] = preset;
    l = name;
  }

  if (!isLocal && l) L = l;
  return l || !isLocal && L;
};

var dayjs = function dayjs(date, c) {
  if (isDayjs(date)) {
    return date.clone();
  } // eslint-disable-next-line no-nested-ternary


  var cfg = typeof c === 'object' ? c : {};
  cfg.date = date;
  cfg.args = arguments; // eslint-disable-line prefer-rest-params

  return new Dayjs(cfg); // eslint-disable-line no-use-before-define
};

var wrapper = function wrapper(date, instance) {
  return dayjs(date, {
    locale: instance.$L,
    utc: instance.$u,
    x: instance.$x,
    $offset: instance.$offset // todo: refactor; do not use this.$offset in you code

  });
};

var Utils = U; // for plugin use

Utils.l = parseLocale;
Utils.i = isDayjs;
Utils.w = wrapper;

var parseDate = function parseDate(cfg) {
  var date = cfg.date,
      utc = cfg.utc;
  if (date === null) return new Date(NaN); // null is invalid

  if (Utils.u(date)) return new Date(); // today

  if (date instanceof Date) return new Date(date);

  if (typeof date === 'string' && !/Z$/i.test(date)) {
    var d = date.match(REGEX_PARSE);

    if (d) {
      var m = d[2] - 1 || 0;
      var ms = (d[7] || '0').substring(0, 3);

      if (utc) {
        return new Date(Date.UTC(d[1], m, d[3] || 1, d[4] || 0, d[5] || 0, d[6] || 0, ms));
      }

      return new Date(d[1], m, d[3] || 1, d[4] || 0, d[5] || 0, d[6] || 0, ms);
    }
  }

  return new Date(date); // everything else
};

var Dayjs = /*#__PURE__*/function () {
  function Dayjs(cfg) {
    this.$L = parseLocale(cfg.locale, null, true);
    this.parse(cfg); // for plugin

    this.$x = this.$x || cfg.x || {};
    this[IS_DAYJS] = true;
  }

  var _proto = Dayjs.prototype;

  _proto.parse = function parse(cfg) {
    this.$d = parseDate(cfg);
    this.init();
  };

  _proto.init = function init() {
    var $d = this.$d;
    this.$y = $d.getFullYear();
    this.$M = $d.getMonth();
    this.$D = $d.getDate();
    this.$W = $d.getDay();
    this.$H = $d.getHours();
    this.$m = $d.getMinutes();
    this.$s = $d.getSeconds();
    this.$ms = $d.getMilliseconds();
  } // eslint-disable-next-line class-methods-use-this
  ;

  _proto.$utils = function $utils() {
    return Utils;
  };

  _proto.isValid = function isValid() {
    return !(this.$d.toString() === INVALID_DATE_STRING);
  };

  _proto.isSame = function isSame(that, units) {
    var other = dayjs(that);
    return this.startOf(units) <= other && other <= this.endOf(units);
  };

  _proto.isAfter = function isAfter(that, units) {
    return dayjs(that) < this.startOf(units);
  };

  _proto.isBefore = function isBefore(that, units) {
    return this.endOf(units) < dayjs(that);
  };

  _proto.$g = function $g(input, get, set) {
    if (Utils.u(input)) return this[get];
    return this.set(set, input);
  };

  _proto.unix = function unix() {
    return Math.floor(this.valueOf() / 1000);
  };

  _proto.valueOf = function valueOf() {
    // timezone(hour) * 60 * 60 * 1000 => ms
    return this.$d.getTime();
  };

  _proto.startOf = function startOf(units, _startOf) {
    var _this = this;

    // startOf -> endOf
    var isStartOf = !Utils.u(_startOf) ? _startOf : true;
    var unit = Utils.p(units);

    var instanceFactory = function instanceFactory(d, m) {
      var ins = Utils.w(_this.$u ? Date.UTC(_this.$y, m, d) : new Date(_this.$y, m, d), _this);
      return isStartOf ? ins : ins.endOf(D);
    };

    var instanceFactorySet = function instanceFactorySet(method, slice) {
      var argumentStart = [0, 0, 0, 0];
      var argumentEnd = [23, 59, 59, 999];
      return Utils.w(_this.toDate()[method].apply( // eslint-disable-line prefer-spread
      _this.toDate('s'), (isStartOf ? argumentStart : argumentEnd).slice(slice)), _this);
    };

    var $W = this.$W,
        $M = this.$M,
        $D = this.$D;
    var utcPad = "set" + (this.$u ? 'UTC' : '');

    switch (unit) {
      case Y:
        return isStartOf ? instanceFactory(1, 0) : instanceFactory(31, 11);

      case M:
        return isStartOf ? instanceFactory(1, $M) : instanceFactory(0, $M + 1);

      case W:
        {
          var weekStart = this.$locale().weekStart || 0;
          var gap = ($W < weekStart ? $W + 7 : $W) - weekStart;
          return instanceFactory(isStartOf ? $D - gap : $D + (6 - gap), $M);
        }

      case D:
      case DATE:
        return instanceFactorySet(utcPad + "Hours", 0);

      case H:
        return instanceFactorySet(utcPad + "Minutes", 1);

      case MIN:
        return instanceFactorySet(utcPad + "Seconds", 2);

      case S:
        return instanceFactorySet(utcPad + "Milliseconds", 3);

      default:
        return this.clone();
    }
  };

  _proto.endOf = function endOf(arg) {
    return this.startOf(arg, false);
  };

  _proto.$set = function $set(units, _int) {
    var _C$D$C$DATE$C$M$C$Y$C;

    // private set
    var unit = Utils.p(units);
    var utcPad = "set" + (this.$u ? 'UTC' : '');
    var name = (_C$D$C$DATE$C$M$C$Y$C = {}, _C$D$C$DATE$C$M$C$Y$C[D] = utcPad + "Date", _C$D$C$DATE$C$M$C$Y$C[DATE] = utcPad + "Date", _C$D$C$DATE$C$M$C$Y$C[M] = utcPad + "Month", _C$D$C$DATE$C$M$C$Y$C[Y] = utcPad + "FullYear", _C$D$C$DATE$C$M$C$Y$C[H] = utcPad + "Hours", _C$D$C$DATE$C$M$C$Y$C[MIN] = utcPad + "Minutes", _C$D$C$DATE$C$M$C$Y$C[S] = utcPad + "Seconds", _C$D$C$DATE$C$M$C$Y$C[MS] = utcPad + "Milliseconds", _C$D$C$DATE$C$M$C$Y$C)[unit];
    var arg = unit === D ? this.$D + (_int - this.$W) : _int;

    if (unit === M || unit === Y) {
      // clone is for badMutable plugin
      var date = this.clone().set(DATE, 1);
      date.$d[name](arg);
      date.init();
      this.$d = date.set(DATE, Math.min(this.$D, date.daysInMonth())).$d;
    } else if (name) this.$d[name](arg);

    this.init();
    return this;
  };

  _proto.set = function set(string, _int2) {
    return this.clone().$set(string, _int2);
  };

  _proto.get = function get(unit) {
    return this[Utils.p(unit)]();
  };

  _proto.add = function add(number, units) {
    var _this2 = this,
        _C$MIN$C$H$C$S$unit;

    number = Number(number); // eslint-disable-line no-param-reassign

    var unit = Utils.p(units);

    var instanceFactorySet = function instanceFactorySet(n) {
      var d = dayjs(_this2);
      return Utils.w(d.date(d.date() + Math.round(n * number)), _this2);
    };

    if (unit === M) {
      return this.set(M, this.$M + number);
    }

    if (unit === Y) {
      return this.set(Y, this.$y + number);
    }

    if (unit === D) {
      return instanceFactorySet(1);
    }

    if (unit === W) {
      return instanceFactorySet(7);
    }

    var step = (_C$MIN$C$H$C$S$unit = {}, _C$MIN$C$H$C$S$unit[MIN] = MILLISECONDS_A_MINUTE, _C$MIN$C$H$C$S$unit[H] = MILLISECONDS_A_HOUR, _C$MIN$C$H$C$S$unit[S] = MILLISECONDS_A_SECOND, _C$MIN$C$H$C$S$unit)[unit] || 1; // ms

    var nextTimeStamp = this.$d.getTime() + number * step;
    return Utils.w(nextTimeStamp, this);
  };

  _proto.subtract = function subtract(number, string) {
    return this.add(number * -1, string);
  };

  _proto.format = function format(formatStr) {
    var _this3 = this;

    var locale = this.$locale();
    if (!this.isValid()) return locale.invalidDate || INVALID_DATE_STRING;
    var str = formatStr || FORMAT_DEFAULT;
    var zoneStr = Utils.z(this);
    var $H = this.$H,
        $m = this.$m,
        $M = this.$M;
    var weekdays = locale.weekdays,
        months = locale.months,
        meridiem = locale.meridiem;

    var getShort = function getShort(arr, index, full, length) {
      return arr && (arr[index] || arr(_this3, str)) || full[index].slice(0, length);
    };

    var get$H = function get$H(num) {
      return Utils.s($H % 12 || 12, num, '0');
    };

    var meridiemFunc = meridiem || function (hour, minute, isLowercase) {
      var m = hour < 12 ? 'AM' : 'PM';
      return isLowercase ? m.toLowerCase() : m;
    };

    var matches = function matches(match) {
      switch (match) {
        case 'YY':
          return String(_this3.$y).slice(-2);

        case 'YYYY':
          return Utils.s(_this3.$y, 4, '0');

        case 'M':
          return $M + 1;

        case 'MM':
          return Utils.s($M + 1, 2, '0');

        case 'MMM':
          return getShort(locale.monthsShort, $M, months, 3);

        case 'MMMM':
          return getShort(months, $M);

        case 'D':
          return _this3.$D;

        case 'DD':
          return Utils.s(_this3.$D, 2, '0');

        case 'd':
          return String(_this3.$W);

        case 'dd':
          return getShort(locale.weekdaysMin, _this3.$W, weekdays, 2);

        case 'ddd':
          return getShort(locale.weekdaysShort, _this3.$W, weekdays, 3);

        case 'dddd':
          return weekdays[_this3.$W];

        case 'H':
          return String($H);

        case 'HH':
          return Utils.s($H, 2, '0');

        case 'h':
          return get$H(1);

        case 'hh':
          return get$H(2);

        case 'a':
          return meridiemFunc($H, $m, true);

        case 'A':
          return meridiemFunc($H, $m, false);

        case 'm':
          return String($m);

        case 'mm':
          return Utils.s($m, 2, '0');

        case 's':
          return String(_this3.$s);

        case 'ss':
          return Utils.s(_this3.$s, 2, '0');

        case 'SSS':
          return Utils.s(_this3.$ms, 3, '0');

        case 'Z':
          return zoneStr;
      }

      return null;
    };

    return str.replace(REGEX_FORMAT, function (match, $1) {
      return $1 || matches(match) || zoneStr.replace(':', '');
    }); // 'ZZ'
  };

  _proto.utcOffset = function utcOffset() {
    // Because a bug at FF24, we're rounding the timezone offset around 15 minutes
    // https://github.com/moment/moment/pull/1871
    return -Math.round(this.$d.getTimezoneOffset() / 15) * 15;
  };

  _proto.diff = function diff(input, units, _float) {
    var _this4 = this;

    var unit = Utils.p(units);
    var that = dayjs(input);
    var zoneDelta = (that.utcOffset() - this.utcOffset()) * MILLISECONDS_A_MINUTE;
    var diff = this - that;

    var getMonth = function getMonth() {
      return Utils.m(_this4, that);
    };

    var result;

    switch (unit) {
      case Y:
        result = getMonth() / 12;
        break;

      case M:
        result = getMonth();
        break;

      case Q:
        result = getMonth() / 3;
        break;

      case W:
        result = (diff - zoneDelta) / MILLISECONDS_A_WEEK;
        break;

      case D:
        result = (diff - zoneDelta) / MILLISECONDS_A_DAY;
        break;

      case H:
        result = diff / MILLISECONDS_A_HOUR;
        break;

      case MIN:
        result = diff / MILLISECONDS_A_MINUTE;
        break;

      case S:
        result = diff / MILLISECONDS_A_SECOND;
        break;

      default:
        result = diff; // milliseconds

        break;
    }

    return _float ? result : Utils.a(result);
  };

  _proto.daysInMonth = function daysInMonth() {
    return this.endOf(M).$D;
  };

  _proto.$locale = function $locale() {
    // get locale object
    return Ls[this.$L];
  };

  _proto.locale = function locale(preset, object) {
    if (!preset) return this.$L;
    var that = this.clone();
    var nextLocaleName = parseLocale(preset, object, true);
    if (nextLocaleName) that.$L = nextLocaleName;
    return that;
  };

  _proto.clone = function clone() {
    return Utils.w(this.$d, this);
  };

  _proto.toDate = function toDate() {
    return new Date(this.valueOf());
  };

  _proto.toJSON = function toJSON() {
    return this.isValid() ? this.toISOString() : null;
  };

  _proto.toISOString = function toISOString() {
    // ie 8 return
    // new Dayjs(this.valueOf() + this.$d.getTimezoneOffset() * 60000)
    // .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
    return this.$d.toISOString();
  };

  _proto.toString = function toString() {
    return this.$d.toUTCString();
  };

  return Dayjs;
}();

var proto = Dayjs.prototype;
dayjs.prototype = proto;
[['$ms', MS], ['$s', S], ['$m', MIN], ['$H', H], ['$W', D], ['$M', M], ['$y', Y], ['$D', DATE]].forEach(function (g) {
  proto[g[1]] = function (input) {
    return this.$g(input, g[0], g[1]);
  };
});

dayjs.extend = function (plugin, option) {
  if (!plugin.$i) {
    // install plugin only once
    plugin(option, Dayjs, dayjs);
    plugin.$i = true;
  }

  return dayjs;
};

dayjs.locale = parseLocale;
dayjs.isDayjs = isDayjs;

dayjs.unix = function (timestamp) {
  return dayjs(timestamp * 1e3);
};

dayjs.en = Ls[L];
dayjs.Ls = Ls;
dayjs.p = {};

var typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
}; // Cache time-zone lookups from Intl.DateTimeFormat,
// as it is a *very* slow method.

var dtfCache = {};

var getDateTimeFormat = function getDateTimeFormat(timezone, options) {
  if (options === void 0) {
    options = {};
  }

  var timeZoneName = options.timeZoneName || 'short';
  var key = timezone + "|" + timeZoneName;
  var dtf = dtfCache[key];

  if (!dtf) {
    dtf = new Intl.DateTimeFormat('en-US', {
      hour12: false,
      timeZone: timezone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZoneName: timeZoneName
    });
    dtfCache[key] = dtf;
  }

  return dtf;
};

var tz = (function (o, c, d) {
  var defaultTimezone;

  var makeFormatParts = function makeFormatParts(timestamp, timezone, options) {
    if (options === void 0) {
      options = {};
    }

    var date = new Date(timestamp);
    var dtf = getDateTimeFormat(timezone, options);
    return dtf.formatToParts(date);
  };

  var tzOffset = function tzOffset(timestamp, timezone) {
    var formatResult = makeFormatParts(timestamp, timezone);
    var filled = [];

    for (var i = 0; i < formatResult.length; i += 1) {
      var _formatResult$i = formatResult[i],
          type = _formatResult$i.type,
          value = _formatResult$i.value;
      var pos = typeToPos[type];

      if (pos >= 0) {
        filled[pos] = parseInt(value, 10);
      }
    }

    var hour = filled[3]; // Workaround for the same behavior in different node version
    // https://github.com/nodejs/node/issues/33027

    /* istanbul ignore next */

    var fixedHour = hour === 24 ? 0 : hour;
    var utcString = filled[0] + "-" + filled[1] + "-" + filled[2] + " " + fixedHour + ":" + filled[4] + ":" + filled[5] + ":000";
    var utcTs = d.utc(utcString).valueOf();
    var asTS = +timestamp;
    var over = asTS % 1000;
    asTS -= over;
    return (utcTs - asTS) / (60 * 1000);
  }; // find the right offset a given local time. The o input is our guess, which determines which
  // offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
  // https://github.com/moment/luxon/blob/master/src/datetime.js#L76


  var fixOffset = function fixOffset(localTS, o0, tz) {
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - o0 * 60 * 1000; // Test whether the zone matches the offset for this ts

    var o2 = tzOffset(utcGuess, tz); // If so, offset didn't change and we're done

    if (o0 === o2) {
      return [utcGuess, o0];
    } // If not, change the ts by the difference in the offset


    utcGuess -= (o2 - o0) * 60 * 1000; // If that gives us the local time we want, we're done

    var o3 = tzOffset(utcGuess, tz);

    if (o2 === o3) {
      return [utcGuess, o2];
    } // If it's different, we're in a hole time.
    // The offset has changed, but the we don't adjust the time


    return [localTS - Math.min(o2, o3) * 60 * 1000, Math.max(o2, o3)];
  };

  var proto = c.prototype;

  proto.tz = function (timezone, keepLocalTime) {
    if (timezone === void 0) {
      timezone = defaultTimezone;
    }

    var oldOffset = this.utcOffset();
    var date = this.toDate();
    var target = date.toLocaleString('en-US', {
      timeZone: timezone
    });
    var diff = Math.round((date - new Date(target)) / 1000 / 60);
    var offset = -Math.round(date.getTimezoneOffset() / 15) * 15 - diff;
    var isUTC = !Number(offset);
    var ins;

    if (isUTC) {
      // if utcOffset is 0, turn it to UTC mode
      ins = this.utcOffset(0, keepLocalTime);
    } else {
      ins = d(target, {
        locale: this.$L
      }).$set(MS, this.$ms).utcOffset(offset, true);

      if (keepLocalTime) {
        var newOffset = ins.utcOffset();
        ins = ins.add(oldOffset - newOffset, MIN);
      }
    }

    ins.$x.$timezone = timezone;
    return ins;
  };

  proto.offsetName = function (type) {
    // type: short(default) / long
    var zone = this.$x.$timezone || d.tz.guess();
    var result = makeFormatParts(this.valueOf(), zone, {
      timeZoneName: type
    }).find(function (m) {
      return m.type.toLowerCase() === 'timezonename';
    });
    return result && result.value;
  };

  var oldStartOf = proto.startOf;

  proto.startOf = function (units, startOf) {
    if (!this.$x || !this.$x.$timezone) {
      return oldStartOf.call(this, units, startOf);
    }

    var withoutTz = d(this.format('YYYY-MM-DD HH:mm:ss:SSS'), {
      locale: this.$L
    });
    var startOfWithoutTz = oldStartOf.call(withoutTz, units, startOf);
    return startOfWithoutTz.tz(this.$x.$timezone, true);
  };

  d.tz = function (input, arg1, arg2) {
    var parseFormat = arg2 && arg1;
    var timezone = arg2 || arg1 || defaultTimezone;
    var previousOffset = tzOffset(+d(), timezone);

    if (typeof input !== 'string') {
      // timestamp number || js Date || Day.js
      return d(input).tz(timezone);
    }

    var localTs = d.utc(input, parseFormat).valueOf();

    var _fixOffset = fixOffset(localTs, previousOffset, timezone),
        targetTs = _fixOffset[0],
        targetOffset = _fixOffset[1];

    var ins = d(targetTs).utcOffset(targetOffset);
    ins.$x.$timezone = timezone;
    return ins;
  };

  d.tz.guess = function () {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  };

  d.tz.setDefault = function (timezone) {
    defaultTimezone = timezone;
  };
});

dayjs.extend(tz);
/**
 * Custom hook to get the current time in a specific timezone.
 * @param {string} timezone - The timezone to get the current time for.
 * @param {number} updateInterval - The interval in milliseconds to update the time. Default is 10000ms (10 seconds).
 */
function useCurrentTime(timezone, updateInterval = 10000) {
    // const [currentTime, setCurrentTime] = useState(dayjs().tz(timezone))
    const [currentTime, setCurrentTime] = useState(dayjs());
    // useEffect(() => {
    //   const interval = setInterval(() => {
    //     setCurrentTime(dayjs().tz(timezone))
    //   }, updateInterval)
    //   return () => clearInterval(interval)
    // }, [timezone, updateInterval])
    return currentTime;
}

/** Default quiet period before a batch goes out — the Editor's element/group batch-save delay. */
const DEFAULT_BATCH_SAVE_DELAY = 3 * 1000; // ms
/**
 * One buffer, one timer, one save.
 *
 * Surfaces that edit the same records queue their changes here instead of each running their own
 * debounced write, so edits made inside the quiet period **coalesce into a single flush** carrying
 * all of them — never two staggered saves racing each other. The buffer is emptied before the save
 * starts, so anything queued while it is in flight lands in the next flush rather than being lost.
 *
 * @param params The buffer's shape (empty/merge/has-changes), the save itself and the delay.
 */
const useBatchedSave = ({ createEmpty, merge, hasChanges, save, delay = DEFAULT_BATCH_SAVE_DELAY, }) => {
    // Refs — the buffer and the callbacks are read at flush time, outside render.
    const pendingRef = useRef(createEmpty());
    const paramsRef = useRef({ createEmpty, merge, hasChanges, save });
    paramsRef.current = { createEmpty, merge, hasChanges, save };
    // States
    const [isSaving, setIsSaving] = useState(false);
    /**
     * Take everything buffered and save it as one batch.
     */
    const flushPending = useCallback(async () => {
        const { createEmpty: empty, hasChanges: has, save: persist } = paramsRef.current;
        const pending = pendingRef.current;
        if (!has(pending))
            return;
        // Emptied first so edits made during the save accumulate for the next flush.
        pendingRef.current = empty();
        setIsSaving(true);
        try {
            await persist(pending);
        }
        finally {
            setIsSaving(false);
        }
    }, []);
    // The timed flush has nobody to report to, so a failure is left to the save's own error
    // handling; an explicit `flush()` propagates it instead, so its caller can react.
    const debouncedFlush = c(() => {
        flushPending().catch(() => { });
    }, delay);
    /**
     * Accumulate a change into the buffer and restart the quiet period.
     * @param change The change to merge in.
     */
    const queue = useCallback((change) => {
        pendingRef.current = paramsRef.current.merge(pendingRef.current, change);
        debouncedFlush();
    }, [debouncedFlush]);
    /**
     * Flush now instead of waiting out the quiet period.
     */
    const flush = useCallback(async () => {
        debouncedFlush.cancel();
        await flushPending();
    }, [debouncedFlush, flushPending]);
    /**
     * Don't drop a buffered edit when the surface goes away — flush it on unmount.
     */
    useEffect(() => () => {
        debouncedFlush.cancel();
        flushPending().catch(() => { });
    }, [debouncedFlush, flushPending]);
    return { queue, flush, isSaving };
};

export { Anchor, AnchorColors, ArcballControls, CAMERA_BOUNDING_SPHERE_RADIUS, CAMERA_PROFILE_CONFIG, CUBOID_MIN_SIZE, CUBOID_QUICK_SIZE, CUBOID_REQUIRED_ANCHORS, CUSTOM_MEASUREMENT_CONFIG, CameraProfileStage, CaretLeftIcon, CaretRightIcon, CauseBadge, CheckCircleIcon, ChevronDownIcon, ChevronRightIcon, CircleAnchor, CircleAnchorIcon, CircleAnchorV2, CollapseIcon, ConfirmIcon, CountermeasureBadge, CountermeasureColorMap, SvgToolbarCoverThickness as CoverThicknessIcon, CubeIcon, CuboidFrame, CuboidRegionFrame, DEFAULT_MAX_DETECTION_POLYGONS, DeleteIcon, DialogCloser, Divider, DividerLabel, DividerLine, DividerRoot, DrawingMode, DrawingTool, DrawnShapeType, EditorDisplaySettings, EditorDisplaySettingsSection, EditorSettingsDrawer, EditorTools, EditorToolsProvider, ErrorPage, EventInspectionDateRange, ExpandIcon, ExtendedPlane, FacilityKP, FocusItemIcon, FocusTrigger, GlobalModalProvider, HEADER_TEXELS, HelpOutlineIcon, HideIcon, InspectionGroupIcon, InspectionSheetSettings, JobStatusProvider, Label, Lightbox, LoadingPage, LoadingPageContainer, LoadingPageImage, LoadingPageRoot, LoadingPageText, LogoutIcon, MASK_CONFIG, MASK_VIEW_ALL_POINTS_OPACITY, MASK_WORKING_REGION_ID, MAX_REGIONS, MEASUREMENT_VERTEX_COUNT, MaintenancePage, MaskTransformMode, MeshState, MeshTile, MeshTileDebug, MeshTileObj, MeshTilesManager, ModalType, NotFound, ORTHO_LOD_ZOOM_THRESHOLD, OrderGrabIcon, SvgPcd as PCDIcon, PLANE_DETECTION_CONFIG, POLYLINE_CONFIG, PanelDropPosition, PanelLayer, PaymentIcon, PolygonPlaneMesh, Polyline, PopoverCloser, ProgressionBadge, RangeInput, RatingBadgeColors, RequiredFieldMark, ResetIcon, Restricted, SaveIcon, SectionTitle, SettingIcon, SeverityBadge, SeverityChangeBadge, SeverityChangeColorMap, SeverityColorMap, ShowIcon, SoundnessBadge, SoundnessRatingColorMap, StepperNumberInput, StylesProvider, SubtoolVertex, SuccessIcon, TEXELS_PER_REGION, TOOL_BUTTON_PRESETS, ThreeCanvas, ThreeCanvasProvider, ToolButtonPreset, ToolbarButton, ToolbarCameraCubeBackIcon, ToolbarCameraCubeDownIcon, ToolbarCameraCubeFrontIcon, ToolbarCameraCubeLeftIcon, ToolbarCameraCubeRightIcon, ToolbarCameraCubeUpIcon, ToolbarCameraIcon, SvgToolbarComment as ToolbarCommentIcon, SvgToolbarCylinder as ToolbarCylinderIcon, SvgToolbarDepth as ToolbarDepthIcon, SvgToolbarDistance as ToolbarDistanceIcon, ToolbarFocusButton, ToolbarGridIcon, ToolbarMaskRegion, SvgToolbarMove as ToolbarMoveIcon, SvgToolbarPlane as ToolbarPlaneIcon, SvgToolbarPolyline as ToolbarPolylineIcon, SvgToolbarVolumeEstimationPolygon as ToolbarVolumePolygonIcon, Tooltip, SvgToolbarRotate as TransformRotateIcon, SvgToolbarScale as TransformScaleIcon, SvgToolbarTranslate as TransformTranslateIcon, TransformTypes, PolygonPlaneMeshTransformable as TransformablePolygonPlaneMesh, TrashIcon, TwoCanvas, UndoIcon, UnsavedIcon, SvgVertexAdd as VertexAddIcon, SvgVertexConnect as VertexConnectIcon, SvgVertexMove as VertexMoveIcon, SvgVertexRemove as VertexRemoveIcon, WarningIcon, WarningIconCircle, addBox3Helper, alignToZAxis, applyMaskingShaderToMaterial, calculateIndexInPolyline, calculatePolylineLength, calculatePolylineMidpoint, checkForLineIntersections, computeBoundingSphereRadius, createDefaultModalProps, createErrorModalProps, disposeMaterial, dividerRecipe, findCenter, findMissingVertexParallelogram, fixVertexOnNormal, generateCuboidFromAnchors, getCenterAndRadius, getCuboidFromPoints, getDistanceLabel, getQuickCuboidAnchors, getSeverityChange, getTileWorldBoundingBox, isConvexPolygon, loadObjV2, loadingPageRecipe, resolveToolButton, splitPolylineAtIndex, tagAsSolidMesh, toMatrix4, transformOBBToAABB, useBatchedSave, useCameraFocus, useCameraProfile, useCurrentTime, useCustomMeasurement, useDrawing$1 as useDrawing, useEditorToolsContext, useFocus, useGlobalModal, useJobStatus, useLODManager, useLongPress, useMask, useOutsideClick, usePlaneDetection, usePolyline, useThreeCanvasContext, useToolShortcuts, useTwoCanvasContext };
//# sourceMappingURL=index.js.map
